// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./themes/default/assets/images/flags.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./themes/default/assets/fonts/icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./themes/default/assets/fonts/icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./themes/default/assets/fonts/icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./themes/default/assets/fonts/icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./themes/default/assets/fonts/icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./themes/default/assets/fonts/outline-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./themes/default/assets/fonts/outline-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./themes/default/assets/fonts/outline-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./themes/default/assets/fonts/outline-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./themes/default/assets/fonts/outline-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./themes/default/assets/fonts/brand-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./themes/default/assets/fonts/brand-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./themes/default/assets/fonts/brand-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./themes/default/assets/fonts/brand-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./themes/default/assets/fonts/brand-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAVgAA8AAAAACFAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABWAAAABwAAAAchGgaq0dERUYAAAF0AAAAHAAAAB4AJwAPT1MvMgAAAZAAAABDAAAAVnW4TJdjbWFwAAAB1AAAAEsAAAFS8CcaqmN2dCAAAAIgAAAABAAAAAQAEQFEZ2FzcAAAAiQAAAAIAAAACP//AANnbHlmAAACLAAAAQoAAAGkrRHP9WhlYWQAAAM4AAAAMAAAADYPK8YyaGhlYQAAA2gAAAAdAAAAJANCAb1obXR4AAADiAAAACIAAAAiCBkAOGxvY2EAAAOsAAAAFAAAABQBnAIybWF4cAAAA8AAAAAfAAAAIAEVAF5uYW1lAAAD4AAAATAAAAKMFGlj5HBvc3QAAAUQAAAARgAAAHJoedjqd2ViZgAABVgAAAAGAAAABrO7W5UAAAABAAAAANXulPUAAAAA1r4hgAAAAADXu2Q1eNpjYGRgYOABYjEgZmJgBEIOIGYB8xgAA/YAN3jaY2BktGOcwMDKwMI4jTGNgYHBHUp/ZZBkaGFgYGJgZWbACgLSXFMYHFT/fLjFeOD/AQY9xjMMbkBhRpAcAN48DQYAeNpjYGBgZoBgGQZGBhDwAfIYwXwWBgMgzQGETAwMqn8+8H649f8/lHX9//9b7Pzf+fWgusCAkY0BzmUE6gHpQwGMDMMeAACbxg7SAAARAUQAAAAB//8AAnjadZBPSsNAGMXfS+yMqYgOhpSuSlKadmUhiVEhEMQzFF22m17BbbvzCh5BXCUn6EG8gjeQ4DepwYo4i+/ffL95j4EDA+CFC7jQuKyIeVHrI3wkleq9F7XrSInKteOeHdda8bOoaeepSc00NWPz/LRec9G8GabyGtEdF7h19z033GAMTK7zbM42xNEZpzYof0RtQ5CUHAQJ73OtVyutc+3b7Ou//b8XNlsPx3jgjUifABdhEohKJJL5iM5p39uqc7X1+sRQSqmGrUVhlsJ4lpmEUVwyT8SUYtg0P9DyNzPADDs+tjrGV6KRCRfsui3eHcL4/p8ZXvfMlcnEU+CLv7hDykOP+AKTPTxbAAB42mNgZGBgAGKuf5KP4vltvjLIMzGAwLV9ig0g+vruFFMQzdjACOJzMIClARh0CTJ42mNgZGBgPPD/AJD8wgAEjA0MjAyogAMAbOQEAQAAAAC7ABEAAAAAAKoAAAH0AAABgAAAAUAACAFAAAgAwAAXAAAAAAAAACoAKgAqADIAbACGAKAAugDSeNpjYGRgYOBkUGFgYgABEMkFhAwM/xn0QAIADdUBdAB42qWQvUoDQRSFv3GjaISUQaymSmGxJoGAsRC0iPYLsU50Y6IxrvlRtPCJJKUPIBb+PIHv4EN4djKuKAqCDHfmu+feOdwZoMCUAJNbAlYUMzaUlM14jjxbngOq7HnOia89z1Pk1vMCa9x7ztPkzfMyJbPj+ZGi6Xp+omxuPD+zaD7meaFg7mb8GrBqHmhwxoAxlm0uiRkpP9X5m26pKRoMxTGR1D49Dv/Yb/91o6l8qL6eu5n2hZQzn68utR9m3FU2cB4t9cdSLG2utI+44Eh/P9bqKO+oJ/WxmXssj77YkrjasZQD6SFddythk3Wtzrf+UF2p076Udla1VNzsERP3kkjVRKel7mp1udXYcHtZSlV7RfmJe1GiFWveluaeKD5/MuJcSk8Tpm/vvwPIbmJleNpjYGKAAFYG7ICTgYGRiZGZkYWRlZGNkZ2Rg5GTLT2nsiDDEEIZsZfmZRqZujmDaDcDAxcI7WIOpS2gtCWUdgQAZkcSmQAAAAFblbO6AAA=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjCBsAAAC8AAAAYGNtYXCj2pm8AAABHAAAAKRnYXNwAAAAEAAAAcAAAAAIZ2x5ZlJbXMYAAAHIAAARnGhlYWQBGAe5AAATZAAAADZoaGVhA+IB/QAAE5wAAAAkaG10eCzgAEMAABPAAAAAcGxvY2EwXCxOAAAUMAAAADptYXhwACIAnAAAFGwAAAAgbmFtZfC1n04AABSMAAABPHBvc3QAAwAAAAAVyAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADxZQHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEAJAAAAAgACAABAAAAAEAIOYF8AbwDfAj8C7wbvBw8Irwl/Cc8SPxZf/9//8AAAAAACDmAPAE8AzwI/Au8G7wcPCH8JfwnPEj8WT//f//AAH/4xoEEAYQAQ/sD+IPow+iD4wPgA98DvYOtgADAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAH//wAPAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAIAAP/tAgAB0wAKABUAAAEvAQ8BFwc3Fyc3BQc3Jz8BHwEHFycCALFPT7GAHp6eHoD/AHAWW304OH1bFnABGRqgoBp8sFNTsHyyOnxYEnFxElh8OgAAAAACAAD/7QIAAdMACgASAAABLwEPARcHNxcnNwUxER8BBxcnAgCxT0+xgB6enh6A/wA4fVsWcAEZGqCgGnywU1OwfLIBHXESWHw6AAAAAQAA/+0CAAHTAAoAAAEvAQ8BFwc3Fyc3AgCxT0+xgB6enh6AARkaoKAafLBTU7B8AAAAAAEAAAAAAgABwAArAAABFA4CBzEHDgMjIi4CLwEuAzU0PgIzMh4CFz4DMzIeAhUCAAcMEgugBgwMDAYGDAwMBqALEgwHFyg2HhAfGxkKChkbHxAeNigXAS0QHxsZCqAGCwkGBQkLBqAKGRsfEB42KBcHDBILCxIMBxcoNh4AAAAAAgAAAAACAAHAACsAWAAAATQuAiMiDgIHLgMjIg4CFRQeAhcxFx4DMzI+Aj8BPgM1DwEiFCIGMTAmIjQjJy4DNTQ+AjMyHgIfATc+AzMyHgIVFA4CBwIAFyg2HhAfGxkKChkbHxAeNigXBwwSC6AGDAwMBgYMDAwGoAsSDAdbogEBAQEBAaIGCgcEDRceEQkREA4GLy8GDhARCREeFw0EBwoGAS0eNigXBwwSCwsSDAcXKDYeEB8bGQqgBgsJBgUJCwagChkbHxA+ogEBAQGiBg4QEQkRHhcNBAcKBjQ0BgoHBA0XHhEJERAOBgABAAAAAAIAAcAAMQAAARQOAgcxBw4DIyIuAi8BLgM1ND4CMzIeAhcHFwc3Jzc+AzMyHgIVAgAHDBILoAYMDAwGBgwMDAagCxIMBxcoNh4KFRMSCC9wQLBwJwUJCgkFHjYoFwEtEB8bGQqgBgsJBgUJCwagChkbHxAeNigXAwUIBUtAoMBAOwECAQEXKDYeAAABAAAAAAIAAbcAKgAAEzQ3NjMyFxYXFhcWFzY3Njc2NzYzMhcWFRQPAQYjIi8BJicmJyYnJicmNQAkJUARExIQEAsMCgoMCxAQEhMRQCUkQbIGBwcGsgMFBQsKCQkGBwExPyMkBgYLCgkKCgoKCQoLBgYkIz8/QawFBawCBgUNDg4OFRQTAAAAAQAAAA0B2wHSACYAABM0PwI2FzYfAhYVFA8BFxQVFAcGByYvAQcGByYnJjU0PwEnJjUAEI9BBQkIBkCPEAdoGQMDBgUGgIEGBQYDAwEYaAcBIwsCFoEMAQEMgRYCCwYIZJABBQUFAwEBAkVFAgEBAwUFAwOQZAkFAAAAAAIAAAANAdsB0gAkAC4AABM0PwI2FzYfAhYVFA8BFxQVFAcmLwEHBgcmJyY1ND8BJyY1HwEHNxcnNy8BBwAQj0EFCQgGQI8QB2gZDAUGgIEGBQYDAwEYaAc/WBVsaxRXeDY2ASMLAhaBDAEBDIEWAgsGCGSQAQUNAQECRUUCAQEDBQUDA5BkCQURVXg4OHhVEW5uAAABACMAKQHdAXwAGgAANzQ/ATYXNh8BNzYXNh8BFhUUDwEGByYvASY1IwgmCAwLCFS8CAsMCCYICPUIDAsIjgjSCwkmCQEBCVS7CQEBCSYJCg0H9gcBAQePBwwAAAEAHwAfAXMBcwAsAAA3ND8BJyY1ND8BNjMyHwE3NjMyHwEWFRQPARcWFRQPAQYjIi8BBwYjIi8BJjUfCFRUCAgnCAwLCFRUCAwLCCcICFRUCAgnCAsMCFRUCAsMCCcIYgsIVFQIDAsIJwgIVFQICCcICwwIVFQICwwIJwgIVFQICCcIDAAAAAACAAAAJQFJAbcAHwArAAA3NTQ3NjsBNTQ3NjMyFxYdATMyFxYdARQHBiMhIicmNTczNTQnJiMiBwYdAQAICAsKJSY1NCYmCQsICAgIC/7tCwgIW5MWFR4fFRZApQsICDc0JiYmJjQ3CAgLpQsICAgIC8A3HhYVFRYeNwAAAQAAAAcBbgG3ACEAADcRNDc2NzYzITIXFhcWFREUBwYHBiMiLwEHBiMiJyYnJjUABgUKBgYBLAYGCgUGBgUKBQcOCn5+Cg4GBgoFBicBcAoICAMDAwMICAr+kAoICAQCCXl5CQIECAgKAAAAAwAAACUCAAFuABgAMQBKAAA3NDc2NzYzMhcWFxYVFAcGBwYjIicmJyY1MxYXFjMyNzY3JicWFRQHBiMiJyY1NDcGBzcUFxYzMjc2NTQ3NjMyNzY1NCcmIyIHBhUABihDREtLREMoBgYoQ0RLS0RDKAYlJjk5Q0M5OSYrQREmJTU1JSYRQSuEBAQGBgQEEREZBgQEBAQGJBkayQoKQSgoKChBCgoKCkEoJycoQQoKOiMjIyM6RCEeIjUmJSUmNSIeIUQlBgQEBAQGGBIRBAQGBgQEGhojAAAABQAAAAkCAAGJACwAOABRAGgAcAAANzQ3Njc2MzIXNzYzMhcWFxYXFhcWFxYVFDEGBwYPAQYjIicmNTQ3JicmJyY1MxYXNyYnJjU0NwYHNxQXFjMyNzY1NDc2MzI3NjU0JyYjIgcGFRc3Njc2NyYnNxYXFhcWFRQHBgcGBwYjPwEWFRQHBgcABitBQU0ZGhADBQEEBAUFBAUEBQEEHjw8Hg4DBQQiBQ0pIyIZBiUvSxYZDg4RQSuEBAQGBgQEEREZBgQEBAQGJBkaVxU9MzQiIDASGxkZEAYGCxQrODk/LlACFxYlyQsJQycnBRwEAgEDAwIDAwIBAwUCNmxsNhkFFAMFBBUTHh8nCQtKISgSHBsfIh4hRCUGBAQEBAYYEhEEBAYGBAQaGiPJJQUiIjYzISASGhkbCgoKChIXMRsbUZANCyghIA8AAAMAAAAAAbcB2wA5AEoAlAAANzU0NzY7ATY3Njc2NzY3Njc2MzIXFhcWFRQHMzIXFhUUBxYVFAcUFRQHFgcGKwEiJyYnJisBIicmNTcUFxYzMjc2NTQnJiMiBwYVFzMyFxYXFhcWFxYXFhcWOwEyNTQnNjc2NTQnNjU0JyYnNjc2NTQnJisBNDc2NTQnJiMGBwYHBgcGBwYHBgcGBwYHBgcGBwYrARUACwoQTgodEQ4GBAMFBgwLDxgTEwoKDjMdFhYOAgoRARkZKCUbGxsjIQZSEAoLJQUFCAcGBQUGBwgFBUkJBAUFBAQHBwMDBwcCPCUjNwIJBQUFDwMDBAkGBgsLDmUODgoJGwgDAwYFDAYQAQUGAwQGBgYFBgUGBgQJSbcPCwsGJhUPCBERExMMCgkJFBQhGxwWFR4ZFQoKFhMGBh0WKBcXBgcMDAoLDxIHBQYGBQcIBQYGBQgSAQEBAQICAQEDAgEULwgIBQoLCgsJDhQHCQkEAQ0NCg8LCxAdHREcDQ4IEBETEw0GFAEHBwUECAgFBQUFAgO3AAADAAD/2wG3AbcAPABNAJkAADc1NDc2OwEyNzY3NjsBMhcWBxUWFRQVFhUUBxYVFAcGKwEWFRQHBgcGIyInJicmJyYnJicmJyYnIyInJjU3FBcWMzI3NjU0JyYjIgcGFRczMhcWFxYXFhcWFxYXFhcWFxYXFhcWFzI3NjU0JyY1MzI3NjU0JyYjNjc2NTQnNjU0JyYnNjU0JyYrASIHIgcGBwYHBgcGIwYrARUACwoQUgYhJRsbHiAoGRkBEQoCDhYWHTMOCgoTExgPCwoFBgIBBAMFDhEdCk4QCgslBQUIBwYFBQYHCAUFSQkEBgYFBgUGBgYEAwYFARAGDAUGAwMIGwkKDg5lDgsLBgYJBAMDDwUFBQkCDg4ZJSU8AgcHAwMHBwQEBQUECbe3DwsKDAwHBhcWJwIWHQYGExYKChUZHhYVHRoiExQJCgsJDg4MDAwNBg4WJQcLCw+kBwUGBgUHCAUGBgUIpAMCBQYFBQcIBAUHBwITBwwTExERBw0OHBEdHRALCw8KDQ0FCQkHFA4JCwoLCgUICBgMCxUDAgEBAgMBAQG3AAAAAQAAAA0A7gHSABQAABM0PwI2FxEHBgcmJyY1ND8BJyY1ABCPQQUJgQYFBgMDARhoBwEjCwIWgQwB/oNFAgEBAwUFAwOQZAkFAAAAAAIAAAAAAgABtwAqAFkAABM0NzYzMhcWFxYXFhc2NzY3Njc2MzIXFhUUDwEGIyIvASYnJicmJyYnJjUzFB8BNzY1NCcmJyYnJicmIyIHBgcGBwYHBiMiJyYnJicmJyYjIgcGBwYHBgcGFQAkJUARExIQEAsMCgoMCxAQEhMRQCUkQbIGBwcGsgMFBQsKCQkGByU1pqY1BgYJCg4NDg0PDhIRDg8KCgcFCQkFBwoKDw4REg4PDQ4NDgoJBgYBMT8jJAYGCwoJCgoKCgkKCwYGJCM/P0GsBQWsAgYFDQ4ODhUUEzA1oJ82MBcSEgoLBgcCAgcHCwsKCQgHBwgJCgsLBwcCAgcGCwoSEhcAAAACAAAABwFuAbcAIQAoAAA3ETQ3Njc2MyEyFxYXFhURFAcGBwYjIi8BBwYjIicmJyY1PwEfAREhEQAGBQoGBgEsBgYKBQYGBQoFBw4Kfn4KDgYGCgUGJZIZef7cJwFwCggIAwMDAwgICv6QCggIBAIJeXkJAgQICAoIjRl0AWP+nQAAAAABAAAAJQHbAbcAMgAANzU0NzY7ATU0NzYzMhcWHQEUBwYrASInJj0BNCcmIyIHBh0BMzIXFh0BFAcGIyEiJyY1AAgIC8AmJjQ1JiUFBQgSCAUFFhUfHhUWHAsICAgIC/7tCwgIQKULCAg3NSUmJiU1SQgFBgYFCEkeFhUVFh43CAgLpQsICAgICwAAAAIAAQANAdsB0gAiAC0AABM2PwI2MzIfAhYXFg8BFxYHBiMiLwEHBiMiJyY/AScmNx8CLwE/AS8CEwEDDJBABggJBUGODgIDCmcYAgQCCAMIf4IFBgYEAgEZaQgC7hBbEgINSnkILgEBJggCFYILC4IVAggICWWPCgUFA0REAwUFCo9lCQipCTBmEw1HEhFc/u0AAAADAAAAAAHJAbcAFAAlAHkAADc1NDc2OwEyFxYdARQHBisBIicmNTcUFxYzMjc2NTQnJiMiBwYVFzU0NzYzNjc2NzY3Njc2NzY3Njc2NzY3NjMyFxYXFhcWFxYXFhUUFRQHBgcGBxQHBgcGBzMyFxYVFAcWFRYHFgcGBxYHBgcjIicmJyYnJiciJyY1AAUGB1MHBQYGBQdTBwYFJQUFCAcGBQUGBwgFBWQFBQgGDw8OFAkFBAQBAQMCAQIEBAYFBw4KCgcHBQQCAwEBAgMDAgYCAgIBAU8XEBAQBQEOBQUECwMREiYlExYXDAwWJAoHBQY3twcGBQUGB7cIBQUFBQgkBwYFBQYHCAUGBgUIJLcHBQYBEBATGQkFCQgGBQwLBgcICQUGAwMFBAcHBgYICQQEBwsLCwYGCgIDBAMCBBEQFhkSDAoVEhAREAsgFBUBBAUEBAcMAQUFCAAAAAADAAD/2wHJAZIAFAAlAHkAADcUFxYXNxY3Nj0BNCcmBycGBwYdATc0NzY3FhcWFRQHBicGJyY1FzU0NzY3Fjc2NzY3NjcXNhcWBxYXFgcWBxQHFhUUBwYHJxYXFhcWFRYXFhcWFRQVFAcGBwYHBgcGBwYnBicmJyYnJicmJyYnJicmJyYnJiciJyY1AAUGB1MHBQYGBQdTBwYFJQUFCAcGBQUGBwgFBWQGBQcKJBYMDBcWEyUmEhEDCwQFBQ4BBRAQEBdPAQECAgIGAgMDAgEBAwIEBQcHCgoOBwUGBAQCAQIDAQEEBAUJFA4PDwYIBQWlBwYFAQEBBwQJtQkEBwEBAQUGB7eTBwYEAQEEBgcJBAYBAQYECZS4BwYEAgENBwUCBgMBAQEXEyEJEhAREBcIDhAaFhEPAQEFAgQCBQELBQcKDAkIBAUHCgUGBwgDBgIEAQEHBQkIBwUMCwcECgcGCRoREQ8CBgQIAAAAAQAAAAEAAJth57dfDzz1AAsCAAAAAADP/GODAAAAAM/8Y4MAAP/bAgAB2wAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAACAAABAAAAAAAAAAAAAAAAAAAAHAAAAAAAAAAAAAAAAAEAAAACAAAAAgAAAAIAAAACAAAAAgAAAAIAAAACAAAAAdwAAAHcAAACAAAjAZMAHwFJAAABbgAAAgAAAAIAAAACAAAAAgAAAAEAAAACAAAAAW4AAAHcAAAB3AABAdwAAAHcAAAAAAAAAAoAFAAeAEoAcACKAMoBQAGIAcwCCgJUAoICxgMEAzoDpgRKBRgF7AYSBpgG2gcgB2oIGAjOAAAAAQAAABwAmgAFAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAwAAAABAAAAAAACAA4AQAABAAAAAAADAAwAIgABAAAAAAAEAAwATgABAAAAAAAFABYADAABAAAAAAAGAAYALgABAAAAAAAKADQAWgADAAEECQABAAwAAAADAAEECQACAA4AQAADAAEECQADAAwAIgADAAEECQAEAAwATgADAAEECQAFABYADAADAAEECQAGAAwANAADAAEECQAKADQAWgByAGEAdABpAG4AZwBWAGUAcgBzAGkAbwBuACAAMQAuADAAcgBhAHQAaQBuAGdyYXRpbmcAcgBhAHQAaQBuAGcAUgBlAGcAdQBsAGEAcgByAGEAdABpAG4AZwBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic&subset=latin);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

███████╗███████╗███╗   ███╗ █████╗ ███╗   ██╗████████╗██╗ ██████╗    ██╗   ██╗██╗
██╔════╝██╔════╝████╗ ████║██╔══██╗████╗  ██║╚══██╔══╝██║██╔════╝    ██║   ██║██║
███████╗█████╗  ██╔████╔██║███████║██╔██╗ ██║   ██║   ██║██║         ██║   ██║██║
╚════██║██╔══╝  ██║╚██╔╝██║██╔══██║██║╚██╗██║   ██║   ██║██║         ██║   ██║██║
███████║███████╗██║ ╚═╝ ██║██║  ██║██║ ╚████║   ██║   ██║╚██████╗    ╚██████╔╝██║
╚══════╝╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚═╝ ╚═════╝     ╚═════╝ ╚═╝

  Import this file into your LESS project to use Semantic UI without build tools
*/
/* Global */
/*!
 * # Semantic UI - Reset
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Reset
*******************************/
/* Packaged Theme */
/*******************************
             Reset
*******************************/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Reset
*******************************/
/* Border-Box */
*,
*:before,
*:after {
  box-sizing: inherit;
}
html {
  box-sizing: border-box;
}
/* iPad Input Shadows */
input[type="text"],
input[type="email"],
input[type="search"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  /* mobile firefox too! */
}
/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in
 *    IE on Windows Phone and in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -ms-text-size-adjust: 100%;
  /* 2 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}
/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers (opinionated).
 */
body {
  margin: 0;
}
/**
 * Add the correct display in IE 9-.
 */
article,
aside,
footer,
header,
nav,
section {
  display: block;
}
/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
/* Grouping content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in IE.
 */
figcaption,
figure,
main {
  /* 1 */
  display: block;
}
/**
 * Add the correct margin in IE 8.
 */
figure {
  margin: 1em 40px;
}
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}
/* Text-level semantics
   ========================================================================== */
/**
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */
a {
  background-color: transparent;
  /* 1 */
  -webkit-text-decoration-skip: objects;
  /* 2 */
}
/**
 * 1. Remove the bottom border in Chrome 57- and Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}
/**
 * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
 */
b,
strong {
  font-weight: inherit;
}
/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}
/**
 * Add the correct font style in Android 4.3-.
 */
dfn {
  font-style: italic;
}
/**
 * Add the correct background and color in IE 9-.
 */
mark {
  background-color: #ff0;
  color: #000;
}
/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}
/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/* Embedded content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
audio,
video {
  display: inline-block;
}
/**
 * Add the correct display in iOS 4-7.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}
/**
 * Remove the border on images inside links in IE 10-.
 */
img {
  border-style: none;
}
/**
 * Hide the overflow in IE.
 */
svg:not(:root) {
  overflow: hidden;
}
/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers (opinionated).
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}
/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}
/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}
/**
 * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
}
/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}
/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}
/**
 * 1. Add the correct display in IE 9-.
 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  display: inline-block;
  /* 1 */
  vertical-align: baseline;
  /* 2 */
}
/**
 * Remove the default vertical scrollbar in IE.
 */
textarea {
  overflow: auto;
}
/**
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}
/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}
/**
 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
 */
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}
/* Interactive
   ========================================================================== */
/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 */
details,
menu {
  display: block;
}
/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}
/* Scripting
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
canvas {
  display: inline-block;
}
/**
 * Add the correct display in IE.
 */
template {
  display: none;
}
/* Hidden
   ========================================================================== */
/**
 * Add the correct display in IE 10-.
 */
[hidden] {
  display: none;
}
/*!
 * # Semantic UI - Site
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged Theme */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Page
*******************************/
html,
body {
  height: 100%;
}
html {
  font-size: 14px;
}
body {
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  min-width: 320px;
  background: #FFFFFF;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.4285em;
  color: rgba(255, 255, 255, 0.87);
  font-smoothing: antialiased;
}
/*******************************
             Headers
*******************************/
h1,
h2,
h3,
h4,
h5 {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  line-height: 1.28571429em;
  margin: calc(2rem -  0.14285714em ) 0em 1rem;
  font-weight: bold;
  padding: 0em;
}
h1 {
  min-height: 1rem;
  font-size: 2rem;
}
h2 {
  font-size: 1.71428571rem;
}
h3 {
  font-size: 1.28571429rem;
}
h4 {
  font-size: 1.07142857rem;
}
h5 {
  font-size: 1rem;
}
h1:first-child,
h2:first-child,
h3:first-child,
h4:first-child,
h5:first-child {
  margin-top: 0em;
}
h1:last-child,
h2:last-child,
h3:last-child,
h4:last-child,
h5:last-child {
  margin-bottom: 0em;
}
/*******************************
             Text
*******************************/
p {
  margin: 0em 0em 1em;
  line-height: 1.4285em;
}
p:first-child {
  margin-top: 0em;
}
p:last-child {
  margin-bottom: 0em;
}
/*-------------------
        Links
--------------------*/
a {
  color: #4183C4;
  text-decoration: none;
}
a:hover {
  color: #1e70bf;
  text-decoration: none;
}
/*******************************
         Scrollbars
*******************************/
/*******************************
          Highlighting
*******************************/
/* Site */
::-webkit-selection {
  background-color: #CCE2FF;
  color: rgba(255, 255, 255, 0.87);
}
::-moz-selection {
  background-color: #CCE2FF;
  color: rgba(255, 255, 255, 0.87);
}
::selection {
  background-color: #CCE2FF;
  color: rgba(255, 255, 255, 0.87);
}
/* Form */
textarea::-webkit-selection,
input::-webkit-selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(255, 255, 255, 0.87);
}
textarea::-moz-selection,
input::-moz-selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(255, 255, 255, 0.87);
}
textarea::selection,
input::selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(255, 255, 255, 0.87);
}
/* Force Simple Scrollbars */
body ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}
body ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0px;
}
body ::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.25);
  transition: color 0.2s ease;
}
body ::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.15);
}
body ::-webkit-scrollbar-thumb:hover {
  background: rgba(128, 135, 139, 0.8);
}
/* Inverted UI */
body .ui.inverted::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
body .ui.inverted::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
body .ui.inverted::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.15);
}
body .ui.inverted::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
/*******************************
        Global Overrides
*******************************/
/* Elements */
/*!
 * # Semantic UI - Button
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Button
*******************************/
/*-------------------
       Element
--------------------*/
/* Button */
/* Button defaults to using same height as input globally */
/* Text */
/* Internal Shadow */
/* Box Shadow */
/* Icon */
/* Loader */
/*
@willChange: box-shadow, transform, opacity, color, background;
*/
/*-------------------
        Group
--------------------*/
/*-------------------
        States
--------------------*/
/* Hovered */
/* Focused */
/* Disabled */
/* Pressed Down */
/* Active */
/* Active + Hovered */
/* Loading */
/*-------------------
        Types
--------------------*/
/* Or */
/* Icon */
/* Labeled */
/* hypotenuse of triangle */
/* Labeled Icon */
/* Inverted */
/* Basic */
/* Basic Hover */
/* Basic Focus */
/* Basic Down */
/* Basic Active */
/* Basic Inverted */
/* Basic Group */
/*-------------------
      Variations
--------------------*/
/* Colors */
/* Colored */
/* Inverted */
/* Ordinality */
/* Compact */
/* Attached */
/* Floated */
/* Animated */
/* Packaged Theme */
/*******************************
            Button
*******************************/
/*-------------------
       Element
--------------------*/
/* Button */
/* Button defaults to using same height as input globally */
/* Text */
/* Internal Shadow */
/* Box Shadow */
/* Icon */
/* Loader */
/*
@willChange: box-shadow, transform, opacity, color, background;
*/
/*-------------------
        Group
--------------------*/
/*-------------------
        States
--------------------*/
/* Hovered */
/* Focused */
/* Disabled */
/* Pressed Down */
/* Active */
/* Active + Hovered */
/* Loading */
/*-------------------
        Types
--------------------*/
/* Or */
/* Icon */
/* Labeled */
/* hypotenuse of triangle */
/* Labeled Icon */
/* Inverted */
/* Basic */
/* Basic Hover */
/* Basic Focus */
/* Basic Down */
/* Basic Active */
/* Basic Inverted */
/* Basic Group */
/*-------------------
      Variations
--------------------*/
/* Colors */
/* Colored */
/* Inverted */
/* Ordinality */
/* Compact */
/* Attached */
/* Floated */
/* Animated */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Button
*******************************/
.ui.button {
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  outline: none;
  border: none;
  vertical-align: baseline;
  background: #5855f4 none;
  color: #eceff8;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  margin: 0em 0.25em 0em 0em;
  padding: 0.78571429em 1.5em 0.78571429em;
  text-transform: none;
  text-shadow: none;
  font-weight: bold;
  line-height: 1em;
  font-style: normal;
  text-align: center;
  text-decoration: none;
  border-radius: 0.28571429rem;
  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
  user-select: none;
  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
  will-change: '';
  -webkit-tap-highlight-color: transparent;
}
/*******************************
            States
*******************************/
/*--------------
      Hover
---------------*/
.ui.button:hover {
  background-color: #CACBCD;
  background-image: none;
  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
  color: rgba(255, 255, 255, 0.8);
}
.ui.button:hover .icon {
  opacity: 0.85;
}
/*--------------
      Focus
---------------*/
.ui.button:focus {
  background-color: #CACBCD;
  color: rgba(255, 255, 255, 0.8);
  background-image: '' !important;
  box-shadow: '' !important;
}
.ui.button:focus .icon {
  opacity: 0.85;
}
/*--------------
      Down
---------------*/
.ui.button:active,
.ui.active.button:active {
  background-color: #BABBBC;
  background-image: '';
  color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 0px 1px transparent inset, none;
}
/*--------------
     Active
---------------*/
.ui.active.button {
  background-color: #C0C1C2;
  background-image: none;
  box-shadow: 0px 0px 0px 1px transparent inset;
  color: rgba(255, 255, 255, 0.95);
}
.ui.active.button:hover {
  background-color: #C0C1C2;
  background-image: none;
  color: rgba(255, 255, 255, 0.95);
}
.ui.active.button:active {
  background-color: #C0C1C2;
  background-image: none;
}
/*--------------
    Loading
---------------*/
/* Specificity hack */
.ui.loading.loading.loading.loading.loading.loading.button {
  position: relative;
  cursor: default;
  text-shadow: none !important;
  color: transparent !important;
  opacity: 1;
  pointer-events: auto;
  transition: all 0s linear, opacity 0.1s ease;
}
.ui.loading.button:before {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.15);
}
.ui.loading.button:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  animation: button-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #FFFFFF transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
.ui.labeled.icon.loading.button .icon {
  background-color: transparent;
  box-shadow: none;
}
@keyframes button-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ui.basic.loading.button:not(.inverted):before {
  border-color: rgba(0, 0, 0, 0.1);
}
.ui.basic.loading.button:not(.inverted):after {
  border-top-color: #767676;
}
/*-------------------
      Disabled
--------------------*/
.ui.buttons .disabled.button,
.ui.disabled.button,
.ui.button:disabled,
.ui.disabled.button:hover,
.ui.disabled.active.button {
  cursor: default;
  opacity: 0.45 !important;
  background-image: none !important;
  box-shadow: none !important;
  pointer-events: none !important;
}
/* Basic Group With Disabled */
.ui.basic.buttons .ui.disabled.button {
  border-color: rgba(255, 255, 255, 0.5);
}
/*******************************
             Types
*******************************/
/*-------------------
       Animated
--------------------*/
.ui.animated.button {
  position: relative;
  overflow: hidden;
  padding-right: 0em !important;
  vertical-align: middle;
  z-index: 1;
}
.ui.animated.button .content {
  will-change: transform, opacity;
}
.ui.animated.button .visible.content {
  position: relative;
  margin-right: 1.5em;
}
.ui.animated.button .hidden.content {
  position: absolute;
  width: 100%;
}
/* Horizontal */
.ui.animated.button .visible.content,
.ui.animated.button .hidden.content {
  transition: right 0.3s ease 0s;
}
.ui.animated.button .visible.content {
  left: auto;
  right: 0%;
}
.ui.animated.button .hidden.content {
  top: 50%;
  left: auto;
  right: -100%;
  margin-top: -0.5em;
}
.ui.animated.button:focus .visible.content,
.ui.animated.button:hover .visible.content {
  left: auto;
  right: 200%;
}
.ui.animated.button:focus .hidden.content,
.ui.animated.button:hover .hidden.content {
  left: auto;
  right: 0%;
}
/* Vertical */
.ui.vertical.animated.button .visible.content,
.ui.vertical.animated.button .hidden.content {
  transition: top 0.3s ease, transform 0.3s ease;
}
.ui.vertical.animated.button .visible.content {
  transform: translateY(0%);
  right: auto;
}
.ui.vertical.animated.button .hidden.content {
  top: -50%;
  left: 0%;
  right: auto;
}
.ui.vertical.animated.button:focus .visible.content,
.ui.vertical.animated.button:hover .visible.content {
  transform: translateY(200%);
  right: auto;
}
.ui.vertical.animated.button:focus .hidden.content,
.ui.vertical.animated.button:hover .hidden.content {
  top: 50%;
  right: auto;
}
/* Fade */
.ui.fade.animated.button .visible.content,
.ui.fade.animated.button .hidden.content {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.ui.fade.animated.button .visible.content {
  left: auto;
  right: auto;
  opacity: 1;
  transform: scale(1);
}
.ui.fade.animated.button .hidden.content {
  opacity: 0;
  left: 0%;
  right: auto;
  transform: scale(1.5);
}
.ui.fade.animated.button:focus .visible.content,
.ui.fade.animated.button:hover .visible.content {
  left: auto;
  right: auto;
  opacity: 0;
  transform: scale(0.75);
}
.ui.fade.animated.button:focus .hidden.content,
.ui.fade.animated.button:hover .hidden.content {
  left: 0%;
  right: auto;
  opacity: 1;
  transform: scale(1);
}
/*-------------------
       Inverted
--------------------*/
.ui.inverted.button {
  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
  background: transparent none;
  color: #FFFFFF;
  text-shadow: none !important;
}
/* Group */
.ui.inverted.buttons .button {
  margin: 0px 0px 0px -2px;
}
.ui.inverted.buttons .button:first-child {
  margin-left: 0em;
}
.ui.inverted.vertical.buttons .button {
  margin: 0px 0px -2px 0px;
}
.ui.inverted.vertical.buttons .button:first-child {
  margin-top: 0em;
}
/* States */
/* Hover */
.ui.inverted.button:hover {
  background: #FFFFFF;
  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
  color: rgba(255, 255, 255, 0.8);
}
/* Active / Focus */
.ui.inverted.button:focus,
.ui.inverted.button.active {
  background: #FFFFFF;
  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
  color: rgba(255, 255, 255, 0.8);
}
/* Active Focus */
.ui.inverted.button.active:focus {
  background: #DCDDDE;
  box-shadow: 0px 0px 0px 2px #DCDDDE inset !important;
  color: rgba(255, 255, 255, 0.8);
}
/*-------------------
    Labeled Button
--------------------*/
.ui.labeled.button:not(.icon) {
  display: inline-flex;
  flex-direction: row;
  background: none !important;
  padding: 0px !important;
  border: none !important;
  box-shadow: none !important;
}
.ui.labeled.button > .button {
  margin: 0px;
}
.ui.labeled.button > .label {
  display: flex;
  align-items: center;
  margin: 0px 0px 0px -1px !important;
  padding: '';
  font-size: 1em;
  border-color: rgba(255, 255, 255, 0.15);
}
/* Tag */
.ui.labeled.button > .tag.label:before {
  width: 1.85em;
  height: 1.85em;
}
/* Right */
.ui.labeled.button:not([class*="left labeled"]) > .button {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.ui.labeled.button:not([class*="left labeled"]) > .label {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
/* Left Side */
.ui[class*="left labeled"].button > .button {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.ui[class*="left labeled"].button > .label {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/*-------------------
       Social
--------------------*/
/* Facebook */
.ui.facebook.button {
  background-color: #3B5998;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.facebook.button:hover {
  background-color: #304d8a;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.facebook.button:active {
  background-color: #2d4373;
  color: #FFFFFF;
  text-shadow: none;
}
/* Twitter */
.ui.twitter.button {
  background-color: #55ACEE;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.twitter.button:hover {
  background-color: #35a2f4;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.twitter.button:active {
  background-color: #2795e9;
  color: #FFFFFF;
  text-shadow: none;
}
/* Google Plus */
.ui.google.plus.button {
  background-color: #DD4B39;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.google.plus.button:hover {
  background-color: #e0321c;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.google.plus.button:active {
  background-color: #c23321;
  color: #FFFFFF;
  text-shadow: none;
}
/* Linked In */
.ui.linkedin.button {
  background-color: #1F88BE;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.linkedin.button:hover {
  background-color: #147baf;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.linkedin.button:active {
  background-color: #186992;
  color: #FFFFFF;
  text-shadow: none;
}
/* YouTube */
.ui.youtube.button {
  background-color: #FF0000;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.youtube.button:hover {
  background-color: #e60000;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.youtube.button:active {
  background-color: #cc0000;
  color: #FFFFFF;
  text-shadow: none;
}
/* Instagram */
.ui.instagram.button {
  background-color: #49769C;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.instagram.button:hover {
  background-color: #3d698e;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.instagram.button:active {
  background-color: #395c79;
  color: #FFFFFF;
  text-shadow: none;
}
/* Pinterest */
.ui.pinterest.button {
  background-color: #BD081C;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.pinterest.button:hover {
  background-color: #ac0013;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.pinterest.button:active {
  background-color: #8c0615;
  color: #FFFFFF;
  text-shadow: none;
}
/* VK */
.ui.vk.button {
  background-color: #4D7198;
  color: #FFFFFF;
  background-image: none;
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.vk.button:hover {
  background-color: #41648a;
  color: #FFFFFF;
}
.ui.vk.button:active {
  background-color: #3c5876;
  color: #FFFFFF;
}
/*--------------
     Icon
---------------*/
.ui.button > .icon:not(.button) {
  height: 0.85714286em;
  opacity: 0.8;
  margin: 0em 0.42857143em 0em -0.21428571em;
  transition: opacity 0.1s ease;
  vertical-align: '';
  color: '';
}
.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {
  margin: 0em 0.42857143em 0em -0.21428571em;
}
.ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {
  margin: 0em -0.21428571em 0em 0.42857143em;
}
/*******************************
           Variations
*******************************/
/*-------------------
       Floated
--------------------*/
.ui[class*="left floated"].buttons,
.ui[class*="left floated"].button {
  float: left;
  margin-left: 0em;
  margin-right: 0.25em;
}
.ui[class*="right floated"].buttons,
.ui[class*="right floated"].button {
  float: right;
  margin-right: 0em;
  margin-left: 0.25em;
}
/*-------------------
       Compact
--------------------*/
.ui.compact.buttons .button,
.ui.compact.button {
  padding: 0.58928571em 1.125em 0.58928571em;
}
.ui.compact.icon.buttons .button,
.ui.compact.icon.button {
  padding: 0.58928571em 0.58928571em 0.58928571em;
}
.ui.compact.labeled.icon.buttons .button,
.ui.compact.labeled.icon.button {
  padding: 0.58928571em 3.69642857em 0.58928571em;
}
/*-------------------
        Sizes
--------------------*/
.ui.mini.buttons .button,
.ui.mini.buttons .or,
.ui.mini.button {
  font-size: 0.78571429rem;
}
.ui.tiny.buttons .button,
.ui.tiny.buttons .or,
.ui.tiny.button {
  font-size: 0.85714286rem;
}
.ui.small.buttons .button,
.ui.small.buttons .or,
.ui.small.button {
  font-size: 0.92857143rem;
}
.ui.buttons .button,
.ui.buttons .or,
.ui.button {
  font-size: 1rem;
}
.ui.large.buttons .button,
.ui.large.buttons .or,
.ui.large.button {
  font-size: 1.14285714rem;
}
.ui.big.buttons .button,
.ui.big.buttons .or,
.ui.big.button {
  font-size: 1.28571429rem;
}
.ui.huge.buttons .button,
.ui.huge.buttons .or,
.ui.huge.button {
  font-size: 1.42857143rem;
}
.ui.massive.buttons .button,
.ui.massive.buttons .or,
.ui.massive.button {
  font-size: 1.71428571rem;
}
/*--------------
    Icon Only
---------------*/
.ui.icon.buttons .button,
.ui.icon.button {
  padding: 0.78571429em 0.78571429em 0.78571429em;
}
.ui.icon.buttons .button > .icon,
.ui.icon.button > .icon {
  opacity: 0.9;
  margin: 0em !important;
  vertical-align: top;
}
/*-------------------
        Basic
--------------------*/
.ui.basic.buttons .button,
.ui.basic.button {
  background: transparent none !important;
  color: #eceff8 !important;
  font-weight: normal;
  border-radius: 0.28571429rem;
  text-transform: none;
  text-shadow: none !important;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
}
.ui.basic.buttons {
  box-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
}
.ui.basic.buttons .button {
  border-radius: 0em;
}
.ui.basic.buttons .button:hover,
.ui.basic.button:hover {
  background: #FFFFFF !important;
  color: rgba(255, 255, 255, 0.8) !important;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.basic.buttons .button:focus,
.ui.basic.button:focus {
  background: #FFFFFF !important;
  color: rgba(255, 255, 255, 0.8) !important;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.basic.buttons .button:active,
.ui.basic.button:active {
  background: #F8F8F8 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.basic.buttons .active.button,
.ui.basic.active.button {
  background: rgba(0, 0, 0, 0.05) !important;
  box-shadow: '' !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.basic.buttons .active.button:hover,
.ui.basic.active.button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
/* Vertical */
.ui.basic.buttons .button:hover {
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset inset;
}
.ui.basic.buttons .button:active {
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(255, 255, 255, 0.15) inset inset;
}
.ui.basic.buttons .active.button {
  box-shadow: '' !important;
}
/* Standard Basic Inverted */
.ui.basic.inverted.buttons .button,
.ui.basic.inverted.button {
  background-color: transparent !important;
  color: #F9FAFB !important;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
}
.ui.basic.inverted.buttons .button:hover,
.ui.basic.inverted.button:hover {
  color: #FFFFFF !important;
  box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}
.ui.basic.inverted.buttons .button:focus,
.ui.basic.inverted.button:focus {
  color: #FFFFFF !important;
  box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}
.ui.basic.inverted.buttons .button:active,
.ui.basic.inverted.button:active {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #FFFFFF !important;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.9) inset !important;
}
.ui.basic.inverted.buttons .active.button,
.ui.basic.inverted.active.button {
  background-color: rgba(255, 255, 255, 0.08);
  color: #FFFFFF;
  text-shadow: none;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7) inset;
}
.ui.basic.inverted.buttons .active.button:hover,
.ui.basic.inverted.active.button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}
/* Basic Group */
.ui.basic.buttons .button {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: none;
}
.ui.basic.vertical.buttons .button {
  border-left: none;
}
.ui.basic.vertical.buttons .button {
  border-left-width: 0px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.basic.vertical.buttons .button:first-child {
  border-top-width: 0px;
}
/*--------------
  Labeled Icon
---------------*/
.ui.labeled.icon.buttons .button,
.ui.labeled.icon.button {
  position: relative;
  padding-left: 4.07142857em !important;
  padding-right: 1.5em !important;
}
/* Left Labeled */
.ui.labeled.icon.buttons > .button > .icon,
.ui.labeled.icon.button > .icon {
  position: absolute;
  height: 100%;
  line-height: 1;
  border-radius: 0px;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  text-align: center;
  margin: 0em;
  width: 2.57142857em;
  background-color: rgba(0, 0, 0, 0.05);
  color: '';
  box-shadow: -1px 0px 0px 0px transparent inset;
}
/* Left Labeled */
.ui.labeled.icon.buttons > .button > .icon,
.ui.labeled.icon.button > .icon {
  top: 0em;
  left: 0em;
}
/* Right Labeled */
.ui[class*="right labeled"].icon.button {
  padding-right: 4.07142857em !important;
  padding-left: 1.5em !important;
}
.ui[class*="right labeled"].icon.button > .icon {
  left: auto;
  right: 0em;
  border-radius: 0px;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  box-shadow: 1px 0px 0px 0px transparent inset;
}
.ui.labeled.icon.buttons > .button > .icon:before,
.ui.labeled.icon.button > .icon:before,
.ui.labeled.icon.buttons > .button > .icon:after,
.ui.labeled.icon.button > .icon:after {
  display: block;
  position: absolute;
  width: 100%;
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}
/* Loading */
.ui.labeled.icon.button > .icon.loading {
  animation: none;
}
.ui.labeled.icon.button > .icon.loading:before {
  animation: labeled-button-icon-loading 2s linear infinite;
}
@keyframes labeled-button-icon-loading {
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}
.ui.labeled.icon.buttons .button > .icon {
  border-radius: 0em;
}
.ui.labeled.icon.buttons .button:first-child > .icon {
  border-top-left-radius: 0.28571429rem;
  border-bottom-left-radius: 0.28571429rem;
}
.ui.labeled.icon.buttons .button:last-child > .icon {
  border-top-right-radius: 0.28571429rem;
  border-bottom-right-radius: 0.28571429rem;
}
.ui.vertical.labeled.icon.buttons .button:first-child > .icon {
  border-radius: 0em;
  border-top-left-radius: 0.28571429rem;
}
.ui.vertical.labeled.icon.buttons .button:last-child > .icon {
  border-radius: 0em;
  border-bottom-left-radius: 0.28571429rem;
}
/* Fluid Labeled */
.ui.fluid[class*="left labeled"].icon.button,
.ui.fluid[class*="right labeled"].icon.button {
  padding-left: 1.5em !important;
  padding-right: 1.5em !important;
}
/*--------------
     Toggle
---------------*/
/* Toggle (Modifies active state to give affordances) */
.ui.toggle.buttons .active.button,
.ui.buttons .button.toggle.active,
.ui.button.toggle.active {
  background-color: #21BA45 !important;
  box-shadow: none !important;
  text-shadow: none;
  color: #FFFFFF !important;
}
.ui.button.toggle.active:hover {
  background-color: #16ab39 !important;
  text-shadow: none;
  color: #FFFFFF !important;
}
/*--------------
    Circular
---------------*/
.ui.circular.button {
  border-radius: 10em;
}
.ui.circular.button > .icon {
  width: 1em;
  vertical-align: baseline;
}
/*-------------------
      Or Buttons
--------------------*/
.ui.buttons .or {
  position: relative;
  width: 0.3em;
  height: 2.57142857em;
  z-index: 3;
}
.ui.buttons .or:before {
  position: absolute;
  text-align: center;
  border-radius: 500rem;
  content: 'or';
  top: 50%;
  left: 50%;
  background-color: #FFFFFF;
  text-shadow: none;
  margin-top: -0.89285714em;
  margin-left: -0.89285714em;
  width: 1.78571429em;
  height: 1.78571429em;
  line-height: 1.78571429em;
  color: rgba(255, 255, 255, 0.4);
  font-style: normal;
  font-weight: bold;
  box-shadow: 0px 0px 0px 1px transparent inset;
}
.ui.buttons .or[data-text]:before {
  content: attr(data-text);
}
/* Fluid Or */
.ui.fluid.buttons .or {
  width: 0em !important;
}
.ui.fluid.buttons .or:after {
  display: none;
}
/*-------------------
       Attached
--------------------*/
/* Singular */
.ui.attached.button {
  position: relative;
  display: block;
  margin: 0em;
  border-radius: 0em;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) !important;
}
/* Top / Bottom */
.ui.attached.top.button {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.attached.bottom.button {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
/* Left / Right */
.ui.left.attached.button {
  display: inline-block;
  border-left: none;
  text-align: right;
  padding-right: 0.75em;
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui.right.attached.button {
  display: inline-block;
  text-align: left;
  padding-left: 0.75em;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
/* Plural */
.ui.attached.buttons {
  position: relative;
  display: flex;
  border-radius: 0em;
  width: auto !important;
  z-index: 2;
  margin-left: -1px;
  margin-right: -1px;
}
.ui.attached.buttons .button {
  margin: 0em;
}
.ui.attached.buttons .button:first-child {
  border-radius: 0em;
}
.ui.attached.buttons .button:last-child {
  border-radius: 0em;
}
/* Top / Bottom */
.ui[class*="top attached"].buttons {
  margin-bottom: -1px;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui[class*="top attached"].buttons .button:first-child {
  border-radius: 0.28571429rem 0em 0em 0em;
}
.ui[class*="top attached"].buttons .button:last-child {
  border-radius: 0em 0.28571429rem 0em 0em;
}
.ui[class*="bottom attached"].buttons {
  margin-top: -1px;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui[class*="bottom attached"].buttons .button:first-child {
  border-radius: 0em 0em 0em 0.28571429rem;
}
.ui[class*="bottom attached"].buttons .button:last-child {
  border-radius: 0em 0em 0.28571429rem 0em;
}
/* Left / Right */
.ui[class*="left attached"].buttons {
  display: inline-flex;
  margin-right: 0em;
  margin-left: -1px;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui[class*="left attached"].buttons .button:first-child {
  margin-left: -1px;
  border-radius: 0em 0.28571429rem 0em 0em;
}
.ui[class*="left attached"].buttons .button:last-child {
  margin-left: -1px;
  border-radius: 0em 0em 0.28571429rem 0em;
}
.ui[class*="right attached"].buttons {
  display: inline-flex;
  margin-left: 0em;
  margin-right: -1px;
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui[class*="right attached"].buttons .button:first-child {
  margin-left: -1px;
  border-radius: 0.28571429rem 0em 0em 0em;
}
.ui[class*="right attached"].buttons .button:last-child {
  margin-left: -1px;
  border-radius: 0em 0em 0em 0.28571429rem;
}
/*-------------------
        Fluid
--------------------*/
.ui.fluid.buttons,
.ui.fluid.button {
  width: 100%;
}
.ui.fluid.button {
  display: block;
}
.ui.two.buttons {
  width: 100%;
}
.ui.two.buttons > .button {
  width: 50%;
}
.ui.three.buttons {
  width: 100%;
}
.ui.three.buttons > .button {
  width: 33.333%;
}
.ui.four.buttons {
  width: 100%;
}
.ui.four.buttons > .button {
  width: 25%;
}
.ui.five.buttons {
  width: 100%;
}
.ui.five.buttons > .button {
  width: 20%;
}
.ui.six.buttons {
  width: 100%;
}
.ui.six.buttons > .button {
  width: 16.666%;
}
.ui.seven.buttons {
  width: 100%;
}
.ui.seven.buttons > .button {
  width: 14.285%;
}
.ui.eight.buttons {
  width: 100%;
}
.ui.eight.buttons > .button {
  width: 12.5%;
}
.ui.nine.buttons {
  width: 100%;
}
.ui.nine.buttons > .button {
  width: 11.11%;
}
.ui.ten.buttons {
  width: 100%;
}
.ui.ten.buttons > .button {
  width: 10%;
}
.ui.eleven.buttons {
  width: 100%;
}
.ui.eleven.buttons > .button {
  width: 9.09%;
}
.ui.twelve.buttons {
  width: 100%;
}
.ui.twelve.buttons > .button {
  width: 8.3333%;
}
/* Fluid Vertical Buttons */
.ui.fluid.vertical.buttons,
.ui.fluid.vertical.buttons > .button {
  display: flex;
  width: auto;
}
.ui.two.vertical.buttons > .button {
  height: 50%;
}
.ui.three.vertical.buttons > .button {
  height: 33.333%;
}
.ui.four.vertical.buttons > .button {
  height: 25%;
}
.ui.five.vertical.buttons > .button {
  height: 20%;
}
.ui.six.vertical.buttons > .button {
  height: 16.666%;
}
.ui.seven.vertical.buttons > .button {
  height: 14.285%;
}
.ui.eight.vertical.buttons > .button {
  height: 12.5%;
}
.ui.nine.vertical.buttons > .button {
  height: 11.11%;
}
.ui.ten.vertical.buttons > .button {
  height: 10%;
}
.ui.eleven.vertical.buttons > .button {
  height: 9.09%;
}
.ui.twelve.vertical.buttons > .button {
  height: 8.3333%;
}
/*-------------------
       Colors
--------------------*/
/*--- Black ---*/
.ui.black.buttons .button,
.ui.black.button {
  background-color: #1B1C1D;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.black.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.black.buttons .button:hover,
.ui.black.button:hover {
  background-color: #27292a;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.black.buttons .button:focus,
.ui.black.button:focus {
  background-color: #2f3032;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.black.buttons .button:active,
.ui.black.button:active {
  background-color: #343637;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.black.buttons .active.button,
.ui.black.buttons .active.button:active,
.ui.black.active.button,
.ui.black.button .active.button:active {
  background-color: #0f0f10;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.black.buttons .button,
.ui.basic.black.button {
  box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
  color: #1B1C1D !important;
}
.ui.basic.black.buttons .button:hover,
.ui.basic.black.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #27292a inset !important;
  color: #27292a !important;
}
.ui.basic.black.buttons .button:focus,
.ui.basic.black.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #2f3032 inset !important;
  color: #27292a !important;
}
.ui.basic.black.buttons .active.button,
.ui.basic.black.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #0f0f10 inset !important;
  color: #343637 !important;
}
.ui.basic.black.buttons .button:active,
.ui.basic.black.button:active {
  box-shadow: 0px 0px 0px 1px #343637 inset !important;
  color: #343637 !important;
}
.ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.black.buttons .button,
.ui.inverted.black.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
  color: #FFFFFF;
}
.ui.inverted.black.buttons .button:hover,
.ui.inverted.black.button:hover,
.ui.inverted.black.buttons .button:focus,
.ui.inverted.black.button:focus,
.ui.inverted.black.buttons .button.active,
.ui.inverted.black.button.active,
.ui.inverted.black.buttons .button:active,
.ui.inverted.black.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.black.buttons .button:hover,
.ui.inverted.black.button:hover {
  background-color: #000000;
}
.ui.inverted.black.buttons .button:focus,
.ui.inverted.black.button:focus {
  background-color: #000000;
}
.ui.inverted.black.buttons .active.button,
.ui.inverted.black.active.button {
  background-color: #000000;
}
.ui.inverted.black.buttons .button:active,
.ui.inverted.black.button:active {
  background-color: #000000;
}
/* Inverted Basic */
.ui.inverted.black.basic.buttons .button,
.ui.inverted.black.buttons .basic.button,
.ui.inverted.black.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:hover,
.ui.inverted.black.buttons .basic.button:hover,
.ui.inverted.black.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #000000 inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:focus,
.ui.inverted.black.basic.buttons .button:focus,
.ui.inverted.black.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #000000 inset !important;
  color: #545454 !important;
}
.ui.inverted.black.basic.buttons .active.button,
.ui.inverted.black.buttons .basic.active.button,
.ui.inverted.black.basic.active.button {
  box-shadow: 0px 0px 0px 2px #000000 inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:active,
.ui.inverted.black.buttons .basic.button:active,
.ui.inverted.black.basic.button:active {
  box-shadow: 0px 0px 0px 2px #000000 inset !important;
  color: #FFFFFF !important;
}
/*--- Grey ---*/
.ui.grey.buttons .button,
.ui.grey.button {
  background-color: #767676;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.grey.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.grey.buttons .button:hover,
.ui.grey.button:hover {
  background-color: #838383;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.grey.buttons .button:focus,
.ui.grey.button:focus {
  background-color: #8a8a8a;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.grey.buttons .button:active,
.ui.grey.button:active {
  background-color: #909090;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.grey.buttons .active.button,
.ui.grey.buttons .active.button:active,
.ui.grey.active.button,
.ui.grey.button .active.button:active {
  background-color: #696969;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.grey.buttons .button,
.ui.basic.grey.button {
  box-shadow: 0px 0px 0px 1px #767676 inset !important;
  color: #767676 !important;
}
.ui.basic.grey.buttons .button:hover,
.ui.basic.grey.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #838383 inset !important;
  color: #838383 !important;
}
.ui.basic.grey.buttons .button:focus,
.ui.basic.grey.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #8a8a8a inset !important;
  color: #838383 !important;
}
.ui.basic.grey.buttons .active.button,
.ui.basic.grey.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #696969 inset !important;
  color: #909090 !important;
}
.ui.basic.grey.buttons .button:active,
.ui.basic.grey.button:active {
  box-shadow: 0px 0px 0px 1px #909090 inset !important;
  color: #909090 !important;
}
.ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.grey.buttons .button,
.ui.inverted.grey.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
  color: #FFFFFF;
}
.ui.inverted.grey.buttons .button:hover,
.ui.inverted.grey.button:hover,
.ui.inverted.grey.buttons .button:focus,
.ui.inverted.grey.button:focus,
.ui.inverted.grey.buttons .button.active,
.ui.inverted.grey.button.active,
.ui.inverted.grey.buttons .button:active,
.ui.inverted.grey.button:active {
  box-shadow: none !important;
  color: #eceff8;
}
.ui.inverted.grey.buttons .button:hover,
.ui.inverted.grey.button:hover {
  background-color: #cfd0d2;
}
.ui.inverted.grey.buttons .button:focus,
.ui.inverted.grey.button:focus {
  background-color: #c7c9cb;
}
.ui.inverted.grey.buttons .active.button,
.ui.inverted.grey.active.button {
  background-color: #cfd0d2;
}
.ui.inverted.grey.buttons .button:active,
.ui.inverted.grey.button:active {
  background-color: #c2c4c5;
}
/* Inverted Basic */
.ui.inverted.grey.basic.buttons .button,
.ui.inverted.grey.buttons .basic.button,
.ui.inverted.grey.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:hover,
.ui.inverted.grey.buttons .basic.button:hover,
.ui.inverted.grey.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:focus,
.ui.inverted.grey.basic.buttons .button:focus,
.ui.inverted.grey.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #c7c9cb inset !important;
  color: #DCDDDE !important;
}
.ui.inverted.grey.basic.buttons .active.button,
.ui.inverted.grey.buttons .basic.active.button,
.ui.inverted.grey.basic.active.button {
  box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:active,
.ui.inverted.grey.buttons .basic.button:active,
.ui.inverted.grey.basic.button:active {
  box-shadow: 0px 0px 0px 2px #c2c4c5 inset !important;
  color: #FFFFFF !important;
}
/*--- Brown ---*/
.ui.brown.buttons .button,
.ui.brown.button {
  background-color: #A5673F;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.brown.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.brown.buttons .button:hover,
.ui.brown.button:hover {
  background-color: #975b33;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.brown.buttons .button:focus,
.ui.brown.button:focus {
  background-color: #90532b;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.brown.buttons .button:active,
.ui.brown.button:active {
  background-color: #805031;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.brown.buttons .active.button,
.ui.brown.buttons .active.button:active,
.ui.brown.active.button,
.ui.brown.button .active.button:active {
  background-color: #995a31;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.brown.buttons .button,
.ui.basic.brown.button {
  box-shadow: 0px 0px 0px 1px #A5673F inset !important;
  color: #A5673F !important;
}
.ui.basic.brown.buttons .button:hover,
.ui.basic.brown.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #975b33 inset !important;
  color: #975b33 !important;
}
.ui.basic.brown.buttons .button:focus,
.ui.basic.brown.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #90532b inset !important;
  color: #975b33 !important;
}
.ui.basic.brown.buttons .active.button,
.ui.basic.brown.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #995a31 inset !important;
  color: #805031 !important;
}
.ui.basic.brown.buttons .button:active,
.ui.basic.brown.button:active {
  box-shadow: 0px 0px 0px 1px #805031 inset !important;
  color: #805031 !important;
}
.ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.brown.buttons .button,
.ui.inverted.brown.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #D67C1C inset !important;
  color: #D67C1C;
}
.ui.inverted.brown.buttons .button:hover,
.ui.inverted.brown.button:hover,
.ui.inverted.brown.buttons .button:focus,
.ui.inverted.brown.button:focus,
.ui.inverted.brown.buttons .button.active,
.ui.inverted.brown.button.active,
.ui.inverted.brown.buttons .button:active,
.ui.inverted.brown.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.brown.buttons .button:hover,
.ui.inverted.brown.button:hover {
  background-color: #c86f11;
}
.ui.inverted.brown.buttons .button:focus,
.ui.inverted.brown.button:focus {
  background-color: #c16808;
}
.ui.inverted.brown.buttons .active.button,
.ui.inverted.brown.active.button {
  background-color: #cc6f0d;
}
.ui.inverted.brown.buttons .button:active,
.ui.inverted.brown.button:active {
  background-color: #a96216;
}
/* Inverted Basic */
.ui.inverted.brown.basic.buttons .button,
.ui.inverted.brown.buttons .basic.button,
.ui.inverted.brown.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.brown.basic.buttons .button:hover,
.ui.inverted.brown.buttons .basic.button:hover,
.ui.inverted.brown.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #c86f11 inset !important;
  color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .button:focus,
.ui.inverted.brown.basic.buttons .button:focus,
.ui.inverted.brown.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #c16808 inset !important;
  color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .active.button,
.ui.inverted.brown.buttons .basic.active.button,
.ui.inverted.brown.basic.active.button {
  box-shadow: 0px 0px 0px 2px #cc6f0d inset !important;
  color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .button:active,
.ui.inverted.brown.buttons .basic.button:active,
.ui.inverted.brown.basic.button:active {
  box-shadow: 0px 0px 0px 2px #a96216 inset !important;
  color: #D67C1C !important;
}
/*--- Blue ---*/
.ui.blue.buttons .button,
.ui.blue.button {
  background-color: #2185D0;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.blue.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.blue.buttons .button:hover,
.ui.blue.button:hover {
  background-color: #1678c2;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.blue.buttons .button:focus,
.ui.blue.button:focus {
  background-color: #0d71bb;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.blue.buttons .button:active,
.ui.blue.button:active {
  background-color: #1a69a4;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.blue.buttons .active.button,
.ui.blue.buttons .active.button:active,
.ui.blue.active.button,
.ui.blue.button .active.button:active {
  background-color: #1279c6;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.blue.buttons .button,
.ui.basic.blue.button {
  box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
  color: #2185D0 !important;
}
.ui.basic.blue.buttons .button:hover,
.ui.basic.blue.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
  color: #1678c2 !important;
}
.ui.basic.blue.buttons .button:focus,
.ui.basic.blue.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
  color: #1678c2 !important;
}
.ui.basic.blue.buttons .active.button,
.ui.basic.blue.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
  color: #1a69a4 !important;
}
.ui.basic.blue.buttons .button:active,
.ui.basic.blue.button:active {
  box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
  color: #1a69a4 !important;
}
.ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.blue.buttons .button,
.ui.inverted.blue.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
  color: #54C8FF;
}
.ui.inverted.blue.buttons .button:hover,
.ui.inverted.blue.button:hover,
.ui.inverted.blue.buttons .button:focus,
.ui.inverted.blue.button:focus,
.ui.inverted.blue.buttons .button.active,
.ui.inverted.blue.button.active,
.ui.inverted.blue.buttons .button:active,
.ui.inverted.blue.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.blue.buttons .button:hover,
.ui.inverted.blue.button:hover {
  background-color: #3ac0ff;
}
.ui.inverted.blue.buttons .button:focus,
.ui.inverted.blue.button:focus {
  background-color: #2bbbff;
}
.ui.inverted.blue.buttons .active.button,
.ui.inverted.blue.active.button {
  background-color: #3ac0ff;
}
.ui.inverted.blue.buttons .button:active,
.ui.inverted.blue.button:active {
  background-color: #21b8ff;
}
/* Inverted Basic */
.ui.inverted.blue.basic.buttons .button,
.ui.inverted.blue.buttons .basic.button,
.ui.inverted.blue.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.blue.basic.buttons .button:hover,
.ui.inverted.blue.buttons .basic.button:hover,
.ui.inverted.blue.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .button:focus,
.ui.inverted.blue.basic.buttons .button:focus,
.ui.inverted.blue.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .active.button,
.ui.inverted.blue.buttons .basic.active.button,
.ui.inverted.blue.basic.active.button {
  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .button:active,
.ui.inverted.blue.buttons .basic.button:active,
.ui.inverted.blue.basic.button:active {
  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
  color: #54C8FF !important;
}
/*--- Green ---*/
.ui.green.buttons .button,
.ui.green.button {
  background-color: #21BA45;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.green.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.green.buttons .button:hover,
.ui.green.button:hover {
  background-color: #16ab39;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.green.buttons .button:focus,
.ui.green.button:focus {
  background-color: #0ea432;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.green.buttons .button:active,
.ui.green.button:active {
  background-color: #198f35;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.green.buttons .active.button,
.ui.green.buttons .active.button:active,
.ui.green.active.button,
.ui.green.button .active.button:active {
  background-color: #13ae38;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.green.buttons .button,
.ui.basic.green.button {
  box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
  color: #21BA45 !important;
}
.ui.basic.green.buttons .button:hover,
.ui.basic.green.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
  color: #16ab39 !important;
}
.ui.basic.green.buttons .button:focus,
.ui.basic.green.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
  color: #16ab39 !important;
}
.ui.basic.green.buttons .active.button,
.ui.basic.green.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
  color: #198f35 !important;
}
.ui.basic.green.buttons .button:active,
.ui.basic.green.button:active {
  box-shadow: 0px 0px 0px 1px #198f35 inset !important;
  color: #198f35 !important;
}
.ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.green.buttons .button,
.ui.inverted.green.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #2ECC40 inset !important;
  color: #2ECC40;
}
.ui.inverted.green.buttons .button:hover,
.ui.inverted.green.button:hover,
.ui.inverted.green.buttons .button:focus,
.ui.inverted.green.button:focus,
.ui.inverted.green.buttons .button.active,
.ui.inverted.green.button.active,
.ui.inverted.green.buttons .button:active,
.ui.inverted.green.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.green.buttons .button:hover,
.ui.inverted.green.button:hover {
  background-color: #22be34;
}
.ui.inverted.green.buttons .button:focus,
.ui.inverted.green.button:focus {
  background-color: #19b82b;
}
.ui.inverted.green.buttons .active.button,
.ui.inverted.green.active.button {
  background-color: #1fc231;
}
.ui.inverted.green.buttons .button:active,
.ui.inverted.green.button:active {
  background-color: #25a233;
}
/* Inverted Basic */
.ui.inverted.green.basic.buttons .button,
.ui.inverted.green.buttons .basic.button,
.ui.inverted.green.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.green.basic.buttons .button:hover,
.ui.inverted.green.buttons .basic.button:hover,
.ui.inverted.green.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #22be34 inset !important;
  color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .button:focus,
.ui.inverted.green.basic.buttons .button:focus,
.ui.inverted.green.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #19b82b inset !important;
  color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .active.button,
.ui.inverted.green.buttons .basic.active.button,
.ui.inverted.green.basic.active.button {
  box-shadow: 0px 0px 0px 2px #1fc231 inset !important;
  color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .button:active,
.ui.inverted.green.buttons .basic.button:active,
.ui.inverted.green.basic.button:active {
  box-shadow: 0px 0px 0px 2px #25a233 inset !important;
  color: #2ECC40 !important;
}
/*--- Orange ---*/
.ui.orange.buttons .button,
.ui.orange.button {
  background-color: #F2711C;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.orange.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.orange.buttons .button:hover,
.ui.orange.button:hover {
  background-color: #f26202;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.orange.buttons .button:focus,
.ui.orange.button:focus {
  background-color: #e55b00;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.orange.buttons .button:active,
.ui.orange.button:active {
  background-color: #cf590c;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.orange.buttons .active.button,
.ui.orange.buttons .active.button:active,
.ui.orange.active.button,
.ui.orange.button .active.button:active {
  background-color: #f56100;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.orange.buttons .button,
.ui.basic.orange.button {
  box-shadow: 0px 0px 0px 1px #F2711C inset !important;
  color: #F2711C !important;
}
.ui.basic.orange.buttons .button:hover,
.ui.basic.orange.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #f26202 inset !important;
  color: #f26202 !important;
}
.ui.basic.orange.buttons .button:focus,
.ui.basic.orange.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #e55b00 inset !important;
  color: #f26202 !important;
}
.ui.basic.orange.buttons .active.button,
.ui.basic.orange.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #f56100 inset !important;
  color: #cf590c !important;
}
.ui.basic.orange.buttons .button:active,
.ui.basic.orange.button:active {
  box-shadow: 0px 0px 0px 1px #cf590c inset !important;
  color: #cf590c !important;
}
.ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.orange.buttons .button,
.ui.inverted.orange.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #FF851B inset !important;
  color: #FF851B;
}
.ui.inverted.orange.buttons .button:hover,
.ui.inverted.orange.button:hover,
.ui.inverted.orange.buttons .button:focus,
.ui.inverted.orange.button:focus,
.ui.inverted.orange.buttons .button.active,
.ui.inverted.orange.button.active,
.ui.inverted.orange.buttons .button:active,
.ui.inverted.orange.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.orange.buttons .button:hover,
.ui.inverted.orange.button:hover {
  background-color: #ff7701;
}
.ui.inverted.orange.buttons .button:focus,
.ui.inverted.orange.button:focus {
  background-color: #f17000;
}
.ui.inverted.orange.buttons .active.button,
.ui.inverted.orange.active.button {
  background-color: #ff7701;
}
.ui.inverted.orange.buttons .button:active,
.ui.inverted.orange.button:active {
  background-color: #e76b00;
}
/* Inverted Basic */
.ui.inverted.orange.basic.buttons .button,
.ui.inverted.orange.buttons .basic.button,
.ui.inverted.orange.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.orange.basic.buttons .button:hover,
.ui.inverted.orange.buttons .basic.button:hover,
.ui.inverted.orange.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
  color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .button:focus,
.ui.inverted.orange.basic.buttons .button:focus,
.ui.inverted.orange.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #f17000 inset !important;
  color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .active.button,
.ui.inverted.orange.buttons .basic.active.button,
.ui.inverted.orange.basic.active.button {
  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
  color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .button:active,
.ui.inverted.orange.buttons .basic.button:active,
.ui.inverted.orange.basic.button:active {
  box-shadow: 0px 0px 0px 2px #e76b00 inset !important;
  color: #FF851B !important;
}
/*--- Pink ---*/
.ui.pink.buttons .button,
.ui.pink.button {
  background-color: #E03997;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.pink.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.pink.buttons .button:hover,
.ui.pink.button:hover {
  background-color: #e61a8d;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.pink.buttons .button:focus,
.ui.pink.button:focus {
  background-color: #e10f85;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.pink.buttons .button:active,
.ui.pink.button:active {
  background-color: #c71f7e;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.pink.buttons .active.button,
.ui.pink.buttons .active.button:active,
.ui.pink.active.button,
.ui.pink.button .active.button:active {
  background-color: #ea158d;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.pink.buttons .button,
.ui.basic.pink.button {
  box-shadow: 0px 0px 0px 1px #E03997 inset !important;
  color: #E03997 !important;
}
.ui.basic.pink.buttons .button:hover,
.ui.basic.pink.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #e61a8d inset !important;
  color: #e61a8d !important;
}
.ui.basic.pink.buttons .button:focus,
.ui.basic.pink.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #e10f85 inset !important;
  color: #e61a8d !important;
}
.ui.basic.pink.buttons .active.button,
.ui.basic.pink.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #ea158d inset !important;
  color: #c71f7e !important;
}
.ui.basic.pink.buttons .button:active,
.ui.basic.pink.button:active {
  box-shadow: 0px 0px 0px 1px #c71f7e inset !important;
  color: #c71f7e !important;
}
.ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.pink.buttons .button,
.ui.inverted.pink.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #FF8EDF inset !important;
  color: #FF8EDF;
}
.ui.inverted.pink.buttons .button:hover,
.ui.inverted.pink.button:hover,
.ui.inverted.pink.buttons .button:focus,
.ui.inverted.pink.button:focus,
.ui.inverted.pink.buttons .button.active,
.ui.inverted.pink.button.active,
.ui.inverted.pink.buttons .button:active,
.ui.inverted.pink.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.pink.buttons .button:hover,
.ui.inverted.pink.button:hover {
  background-color: #ff74d8;
}
.ui.inverted.pink.buttons .button:focus,
.ui.inverted.pink.button:focus {
  background-color: #ff65d3;
}
.ui.inverted.pink.buttons .active.button,
.ui.inverted.pink.active.button {
  background-color: #ff74d8;
}
.ui.inverted.pink.buttons .button:active,
.ui.inverted.pink.button:active {
  background-color: #ff5bd1;
}
/* Inverted Basic */
.ui.inverted.pink.basic.buttons .button,
.ui.inverted.pink.buttons .basic.button,
.ui.inverted.pink.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.pink.basic.buttons .button:hover,
.ui.inverted.pink.buttons .basic.button:hover,
.ui.inverted.pink.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
  color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .button:focus,
.ui.inverted.pink.basic.buttons .button:focus,
.ui.inverted.pink.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #ff65d3 inset !important;
  color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .active.button,
.ui.inverted.pink.buttons .basic.active.button,
.ui.inverted.pink.basic.active.button {
  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
  color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .button:active,
.ui.inverted.pink.buttons .basic.button:active,
.ui.inverted.pink.basic.button:active {
  box-shadow: 0px 0px 0px 2px #ff5bd1 inset !important;
  color: #FF8EDF !important;
}
/*--- Violet ---*/
.ui.violet.buttons .button,
.ui.violet.button {
  background-color: #6435C9;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.violet.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.violet.buttons .button:hover,
.ui.violet.button:hover {
  background-color: #5829bb;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.violet.buttons .button:focus,
.ui.violet.button:focus {
  background-color: #4f20b5;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.violet.buttons .button:active,
.ui.violet.button:active {
  background-color: #502aa1;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.violet.buttons .active.button,
.ui.violet.buttons .active.button:active,
.ui.violet.active.button,
.ui.violet.button .active.button:active {
  background-color: #5626bf;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.violet.buttons .button,
.ui.basic.violet.button {
  box-shadow: 0px 0px 0px 1px #6435C9 inset !important;
  color: #6435C9 !important;
}
.ui.basic.violet.buttons .button:hover,
.ui.basic.violet.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #5829bb inset !important;
  color: #5829bb !important;
}
.ui.basic.violet.buttons .button:focus,
.ui.basic.violet.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #4f20b5 inset !important;
  color: #5829bb !important;
}
.ui.basic.violet.buttons .active.button,
.ui.basic.violet.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #5626bf inset !important;
  color: #502aa1 !important;
}
.ui.basic.violet.buttons .button:active,
.ui.basic.violet.button:active {
  box-shadow: 0px 0px 0px 1px #502aa1 inset !important;
  color: #502aa1 !important;
}
.ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.violet.buttons .button,
.ui.inverted.violet.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #A291FB inset !important;
  color: #A291FB;
}
.ui.inverted.violet.buttons .button:hover,
.ui.inverted.violet.button:hover,
.ui.inverted.violet.buttons .button:focus,
.ui.inverted.violet.button:focus,
.ui.inverted.violet.buttons .button.active,
.ui.inverted.violet.button.active,
.ui.inverted.violet.buttons .button:active,
.ui.inverted.violet.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.violet.buttons .button:hover,
.ui.inverted.violet.button:hover {
  background-color: #8a73ff;
}
.ui.inverted.violet.buttons .button:focus,
.ui.inverted.violet.button:focus {
  background-color: #7d64ff;
}
.ui.inverted.violet.buttons .active.button,
.ui.inverted.violet.active.button {
  background-color: #8a73ff;
}
.ui.inverted.violet.buttons .button:active,
.ui.inverted.violet.button:active {
  background-color: #7860f9;
}
/* Inverted Basic */
.ui.inverted.violet.basic.buttons .button,
.ui.inverted.violet.buttons .basic.button,
.ui.inverted.violet.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.violet.basic.buttons .button:hover,
.ui.inverted.violet.buttons .basic.button:hover,
.ui.inverted.violet.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
  color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .button:focus,
.ui.inverted.violet.basic.buttons .button:focus,
.ui.inverted.violet.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #7d64ff inset !important;
  color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .active.button,
.ui.inverted.violet.buttons .basic.active.button,
.ui.inverted.violet.basic.active.button {
  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
  color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .button:active,
.ui.inverted.violet.buttons .basic.button:active,
.ui.inverted.violet.basic.button:active {
  box-shadow: 0px 0px 0px 2px #7860f9 inset !important;
  color: #A291FB !important;
}
/*--- Purple ---*/
.ui.purple.buttons .button,
.ui.purple.button {
  background-color: #A333C8;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.purple.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.purple.buttons .button:hover,
.ui.purple.button:hover {
  background-color: #9627ba;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.purple.buttons .button:focus,
.ui.purple.button:focus {
  background-color: #8f1eb4;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.purple.buttons .button:active,
.ui.purple.button:active {
  background-color: #82299f;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.purple.buttons .active.button,
.ui.purple.buttons .active.button:active,
.ui.purple.active.button,
.ui.purple.button .active.button:active {
  background-color: #9724be;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.purple.buttons .button,
.ui.basic.purple.button {
  box-shadow: 0px 0px 0px 1px #A333C8 inset !important;
  color: #A333C8 !important;
}
.ui.basic.purple.buttons .button:hover,
.ui.basic.purple.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #9627ba inset !important;
  color: #9627ba !important;
}
.ui.basic.purple.buttons .button:focus,
.ui.basic.purple.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #8f1eb4 inset !important;
  color: #9627ba !important;
}
.ui.basic.purple.buttons .active.button,
.ui.basic.purple.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #9724be inset !important;
  color: #82299f !important;
}
.ui.basic.purple.buttons .button:active,
.ui.basic.purple.button:active {
  box-shadow: 0px 0px 0px 1px #82299f inset !important;
  color: #82299f !important;
}
.ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.purple.buttons .button,
.ui.inverted.purple.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #DC73FF inset !important;
  color: #DC73FF;
}
.ui.inverted.purple.buttons .button:hover,
.ui.inverted.purple.button:hover,
.ui.inverted.purple.buttons .button:focus,
.ui.inverted.purple.button:focus,
.ui.inverted.purple.buttons .button.active,
.ui.inverted.purple.button.active,
.ui.inverted.purple.buttons .button:active,
.ui.inverted.purple.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.purple.buttons .button:hover,
.ui.inverted.purple.button:hover {
  background-color: #d65aff;
}
.ui.inverted.purple.buttons .button:focus,
.ui.inverted.purple.button:focus {
  background-color: #d24aff;
}
.ui.inverted.purple.buttons .active.button,
.ui.inverted.purple.active.button {
  background-color: #d65aff;
}
.ui.inverted.purple.buttons .button:active,
.ui.inverted.purple.button:active {
  background-color: #cf40ff;
}
/* Inverted Basic */
.ui.inverted.purple.basic.buttons .button,
.ui.inverted.purple.buttons .basic.button,
.ui.inverted.purple.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.purple.basic.buttons .button:hover,
.ui.inverted.purple.buttons .basic.button:hover,
.ui.inverted.purple.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #d65aff inset !important;
  color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .button:focus,
.ui.inverted.purple.basic.buttons .button:focus,
.ui.inverted.purple.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #d24aff inset !important;
  color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .active.button,
.ui.inverted.purple.buttons .basic.active.button,
.ui.inverted.purple.basic.active.button {
  box-shadow: 0px 0px 0px 2px #d65aff inset !important;
  color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .button:active,
.ui.inverted.purple.buttons .basic.button:active,
.ui.inverted.purple.basic.button:active {
  box-shadow: 0px 0px 0px 2px #cf40ff inset !important;
  color: #DC73FF !important;
}
/*--- Red ---*/
.ui.red.buttons .button,
.ui.red.button {
  background-color: #DB2828;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.red.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.red.buttons .button:hover,
.ui.red.button:hover {
  background-color: #d01919;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.red.buttons .button:focus,
.ui.red.button:focus {
  background-color: #ca1010;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.red.buttons .button:active,
.ui.red.button:active {
  background-color: #b21e1e;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.red.buttons .active.button,
.ui.red.buttons .active.button:active,
.ui.red.active.button,
.ui.red.button .active.button:active {
  background-color: #d41515;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.red.buttons .button,
.ui.basic.red.button {
  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
  color: #DB2828 !important;
}
.ui.basic.red.buttons .button:hover,
.ui.basic.red.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #d01919 inset !important;
  color: #d01919 !important;
}
.ui.basic.red.buttons .button:focus,
.ui.basic.red.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
  color: #d01919 !important;
}
.ui.basic.red.buttons .active.button,
.ui.basic.red.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #d41515 inset !important;
  color: #b21e1e !important;
}
.ui.basic.red.buttons .button:active,
.ui.basic.red.button:active {
  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
  color: #b21e1e !important;
}
.ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.red.buttons .button,
.ui.inverted.red.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #FF695E inset !important;
  color: #FF695E;
}
.ui.inverted.red.buttons .button:hover,
.ui.inverted.red.button:hover,
.ui.inverted.red.buttons .button:focus,
.ui.inverted.red.button:focus,
.ui.inverted.red.buttons .button.active,
.ui.inverted.red.button.active,
.ui.inverted.red.buttons .button:active,
.ui.inverted.red.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.red.buttons .button:hover,
.ui.inverted.red.button:hover {
  background-color: #ff5144;
}
.ui.inverted.red.buttons .button:focus,
.ui.inverted.red.button:focus {
  background-color: #ff4335;
}
.ui.inverted.red.buttons .active.button,
.ui.inverted.red.active.button {
  background-color: #ff5144;
}
.ui.inverted.red.buttons .button:active,
.ui.inverted.red.button:active {
  background-color: #ff392b;
}
/* Inverted Basic */
.ui.inverted.red.basic.buttons .button,
.ui.inverted.red.buttons .basic.button,
.ui.inverted.red.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.red.basic.buttons .button:hover,
.ui.inverted.red.buttons .basic.button:hover,
.ui.inverted.red.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
  color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .button:focus,
.ui.inverted.red.basic.buttons .button:focus,
.ui.inverted.red.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #ff4335 inset !important;
  color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .active.button,
.ui.inverted.red.buttons .basic.active.button,
.ui.inverted.red.basic.active.button {
  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
  color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .button:active,
.ui.inverted.red.buttons .basic.button:active,
.ui.inverted.red.basic.button:active {
  box-shadow: 0px 0px 0px 2px #ff392b inset !important;
  color: #FF695E !important;
}
/*--- Teal ---*/
.ui.teal.buttons .button,
.ui.teal.button {
  background-color: #00B5AD;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.teal.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.teal.buttons .button:hover,
.ui.teal.button:hover {
  background-color: #009c95;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.teal.buttons .button:focus,
.ui.teal.button:focus {
  background-color: #008c86;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.teal.buttons .button:active,
.ui.teal.button:active {
  background-color: #00827c;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.teal.buttons .active.button,
.ui.teal.buttons .active.button:active,
.ui.teal.active.button,
.ui.teal.button .active.button:active {
  background-color: #009c95;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.teal.buttons .button,
.ui.basic.teal.button {
  box-shadow: 0px 0px 0px 1px #00B5AD inset !important;
  color: #00B5AD !important;
}
.ui.basic.teal.buttons .button:hover,
.ui.basic.teal.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #009c95 inset !important;
  color: #009c95 !important;
}
.ui.basic.teal.buttons .button:focus,
.ui.basic.teal.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #008c86 inset !important;
  color: #009c95 !important;
}
.ui.basic.teal.buttons .active.button,
.ui.basic.teal.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #009c95 inset !important;
  color: #00827c !important;
}
.ui.basic.teal.buttons .button:active,
.ui.basic.teal.button:active {
  box-shadow: 0px 0px 0px 1px #00827c inset !important;
  color: #00827c !important;
}
.ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.teal.buttons .button,
.ui.inverted.teal.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #6DFFFF inset !important;
  color: #6DFFFF;
}
.ui.inverted.teal.buttons .button:hover,
.ui.inverted.teal.button:hover,
.ui.inverted.teal.buttons .button:focus,
.ui.inverted.teal.button:focus,
.ui.inverted.teal.buttons .button.active,
.ui.inverted.teal.button.active,
.ui.inverted.teal.buttons .button:active,
.ui.inverted.teal.button:active {
  box-shadow: none !important;
  color: #eceff8;
}
.ui.inverted.teal.buttons .button:hover,
.ui.inverted.teal.button:hover {
  background-color: #54ffff;
}
.ui.inverted.teal.buttons .button:focus,
.ui.inverted.teal.button:focus {
  background-color: #44ffff;
}
.ui.inverted.teal.buttons .active.button,
.ui.inverted.teal.active.button {
  background-color: #54ffff;
}
.ui.inverted.teal.buttons .button:active,
.ui.inverted.teal.button:active {
  background-color: #3affff;
}
/* Inverted Basic */
.ui.inverted.teal.basic.buttons .button,
.ui.inverted.teal.buttons .basic.button,
.ui.inverted.teal.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:hover,
.ui.inverted.teal.buttons .basic.button:hover,
.ui.inverted.teal.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #54ffff inset !important;
  color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:focus,
.ui.inverted.teal.basic.buttons .button:focus,
.ui.inverted.teal.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #44ffff inset !important;
  color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .active.button,
.ui.inverted.teal.buttons .basic.active.button,
.ui.inverted.teal.basic.active.button {
  box-shadow: 0px 0px 0px 2px #54ffff inset !important;
  color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:active,
.ui.inverted.teal.buttons .basic.button:active,
.ui.inverted.teal.basic.button:active {
  box-shadow: 0px 0px 0px 2px #3affff inset !important;
  color: #6DFFFF !important;
}
/*--- Olive ---*/
.ui.olive.buttons .button,
.ui.olive.button {
  background-color: #B5CC18;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.olive.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.olive.buttons .button:hover,
.ui.olive.button:hover {
  background-color: #a7bd0d;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.olive.buttons .button:focus,
.ui.olive.button:focus {
  background-color: #a0b605;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.olive.buttons .button:active,
.ui.olive.button:active {
  background-color: #8d9e13;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.olive.buttons .active.button,
.ui.olive.buttons .active.button:active,
.ui.olive.active.button,
.ui.olive.button .active.button:active {
  background-color: #aac109;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.olive.buttons .button,
.ui.basic.olive.button {
  box-shadow: 0px 0px 0px 1px #B5CC18 inset !important;
  color: #B5CC18 !important;
}
.ui.basic.olive.buttons .button:hover,
.ui.basic.olive.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #a7bd0d inset !important;
  color: #a7bd0d !important;
}
.ui.basic.olive.buttons .button:focus,
.ui.basic.olive.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #a0b605 inset !important;
  color: #a7bd0d !important;
}
.ui.basic.olive.buttons .active.button,
.ui.basic.olive.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #aac109 inset !important;
  color: #8d9e13 !important;
}
.ui.basic.olive.buttons .button:active,
.ui.basic.olive.button:active {
  box-shadow: 0px 0px 0px 1px #8d9e13 inset !important;
  color: #8d9e13 !important;
}
.ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.olive.buttons .button,
.ui.inverted.olive.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #D9E778 inset !important;
  color: #D9E778;
}
.ui.inverted.olive.buttons .button:hover,
.ui.inverted.olive.button:hover,
.ui.inverted.olive.buttons .button:focus,
.ui.inverted.olive.button:focus,
.ui.inverted.olive.buttons .button.active,
.ui.inverted.olive.button.active,
.ui.inverted.olive.buttons .button:active,
.ui.inverted.olive.button:active {
  box-shadow: none !important;
  color: #eceff8;
}
.ui.inverted.olive.buttons .button:hover,
.ui.inverted.olive.button:hover {
  background-color: #d8ea5c;
}
.ui.inverted.olive.buttons .button:focus,
.ui.inverted.olive.button:focus {
  background-color: #daef47;
}
.ui.inverted.olive.buttons .active.button,
.ui.inverted.olive.active.button {
  background-color: #daed59;
}
.ui.inverted.olive.buttons .button:active,
.ui.inverted.olive.button:active {
  background-color: #cddf4d;
}
/* Inverted Basic */
.ui.inverted.olive.basic.buttons .button,
.ui.inverted.olive.buttons .basic.button,
.ui.inverted.olive.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.olive.basic.buttons .button:hover,
.ui.inverted.olive.buttons .basic.button:hover,
.ui.inverted.olive.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #d8ea5c inset !important;
  color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .button:focus,
.ui.inverted.olive.basic.buttons .button:focus,
.ui.inverted.olive.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #daef47 inset !important;
  color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .active.button,
.ui.inverted.olive.buttons .basic.active.button,
.ui.inverted.olive.basic.active.button {
  box-shadow: 0px 0px 0px 2px #daed59 inset !important;
  color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .button:active,
.ui.inverted.olive.buttons .basic.button:active,
.ui.inverted.olive.basic.button:active {
  box-shadow: 0px 0px 0px 2px #cddf4d inset !important;
  color: #D9E778 !important;
}
/*--- Yellow ---*/
.ui.yellow.buttons .button,
.ui.yellow.button {
  background-color: #FBBD08;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.yellow.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.yellow.buttons .button:hover,
.ui.yellow.button:hover {
  background-color: #eaae00;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.yellow.buttons .button:focus,
.ui.yellow.button:focus {
  background-color: #daa300;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.yellow.buttons .button:active,
.ui.yellow.button:active {
  background-color: #cd9903;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.yellow.buttons .active.button,
.ui.yellow.buttons .active.button:active,
.ui.yellow.active.button,
.ui.yellow.button .active.button:active {
  background-color: #eaae00;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.yellow.buttons .button,
.ui.basic.yellow.button {
  box-shadow: 0px 0px 0px 1px #FBBD08 inset !important;
  color: #FBBD08 !important;
}
.ui.basic.yellow.buttons .button:hover,
.ui.basic.yellow.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
  color: #eaae00 !important;
}
.ui.basic.yellow.buttons .button:focus,
.ui.basic.yellow.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #daa300 inset !important;
  color: #eaae00 !important;
}
.ui.basic.yellow.buttons .active.button,
.ui.basic.yellow.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
  color: #cd9903 !important;
}
.ui.basic.yellow.buttons .button:active,
.ui.basic.yellow.button:active {
  box-shadow: 0px 0px 0px 1px #cd9903 inset !important;
  color: #cd9903 !important;
}
.ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.yellow.buttons .button,
.ui.inverted.yellow.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #FFE21F inset !important;
  color: #FFE21F;
}
.ui.inverted.yellow.buttons .button:hover,
.ui.inverted.yellow.button:hover,
.ui.inverted.yellow.buttons .button:focus,
.ui.inverted.yellow.button:focus,
.ui.inverted.yellow.buttons .button.active,
.ui.inverted.yellow.button.active,
.ui.inverted.yellow.buttons .button:active,
.ui.inverted.yellow.button:active {
  box-shadow: none !important;
  color: #eceff8;
}
.ui.inverted.yellow.buttons .button:hover,
.ui.inverted.yellow.button:hover {
  background-color: #ffdf05;
}
.ui.inverted.yellow.buttons .button:focus,
.ui.inverted.yellow.button:focus {
  background-color: #f5d500;
}
.ui.inverted.yellow.buttons .active.button,
.ui.inverted.yellow.active.button {
  background-color: #ffdf05;
}
.ui.inverted.yellow.buttons .button:active,
.ui.inverted.yellow.button:active {
  background-color: #ebcd00;
}
/* Inverted Basic */
.ui.inverted.yellow.basic.buttons .button,
.ui.inverted.yellow.buttons .basic.button,
.ui.inverted.yellow.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.yellow.basic.buttons .button:hover,
.ui.inverted.yellow.buttons .basic.button:hover,
.ui.inverted.yellow.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
  color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .button:focus,
.ui.inverted.yellow.basic.buttons .button:focus,
.ui.inverted.yellow.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #f5d500 inset !important;
  color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .active.button,
.ui.inverted.yellow.buttons .basic.active.button,
.ui.inverted.yellow.basic.active.button {
  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
  color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .button:active,
.ui.inverted.yellow.buttons .basic.button:active,
.ui.inverted.yellow.basic.button:active {
  box-shadow: 0px 0px 0px 2px #ebcd00 inset !important;
  color: #FFE21F !important;
}
/*-------------------
       Primary
--------------------*/
/*--- Standard ---*/
.ui.primary.buttons .button,
.ui.primary.button {
  background-color: #2185D0;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.primary.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.primary.buttons .button:hover,
.ui.primary.button:hover {
  background-color: #1678c2;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.primary.buttons .button:focus,
.ui.primary.button:focus {
  background-color: #0d71bb;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.primary.buttons .button:active,
.ui.primary.button:active {
  background-color: #1a69a4;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.primary.buttons .active.button,
.ui.primary.buttons .active.button:active,
.ui.primary.active.button,
.ui.primary.button .active.button:active {
  background-color: #1279c6;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.primary.buttons .button,
.ui.basic.primary.button {
  box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
  color: #2185D0 !important;
}
.ui.basic.primary.buttons .button:hover,
.ui.basic.primary.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
  color: #1678c2 !important;
}
.ui.basic.primary.buttons .button:focus,
.ui.basic.primary.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
  color: #1678c2 !important;
}
.ui.basic.primary.buttons .active.button,
.ui.basic.primary.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
  color: #1a69a4 !important;
}
.ui.basic.primary.buttons .button:active,
.ui.basic.primary.button:active {
  box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
  color: #1a69a4 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.primary.buttons .button,
.ui.inverted.primary.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
  color: #54C8FF;
}
.ui.inverted.primary.buttons .button:hover,
.ui.inverted.primary.button:hover,
.ui.inverted.primary.buttons .button:focus,
.ui.inverted.primary.button:focus,
.ui.inverted.primary.buttons .button.active,
.ui.inverted.primary.button.active,
.ui.inverted.primary.buttons .button:active,
.ui.inverted.primary.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.primary.buttons .button:hover,
.ui.inverted.primary.button:hover {
  background-color: #3ac0ff;
}
.ui.inverted.primary.buttons .button:focus,
.ui.inverted.primary.button:focus {
  background-color: #2bbbff;
}
.ui.inverted.primary.buttons .active.button,
.ui.inverted.primary.active.button {
  background-color: #3ac0ff;
}
.ui.inverted.primary.buttons .button:active,
.ui.inverted.primary.button:active {
  background-color: #21b8ff;
}
/* Inverted Basic */
.ui.inverted.primary.basic.buttons .button,
.ui.inverted.primary.buttons .basic.button,
.ui.inverted.primary.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.primary.basic.buttons .button:hover,
.ui.inverted.primary.buttons .basic.button:hover,
.ui.inverted.primary.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .button:focus,
.ui.inverted.primary.basic.buttons .button:focus,
.ui.inverted.primary.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .active.button,
.ui.inverted.primary.buttons .basic.active.button,
.ui.inverted.primary.basic.active.button {
  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
  color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .button:active,
.ui.inverted.primary.buttons .basic.button:active,
.ui.inverted.primary.basic.button:active {
  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
  color: #54C8FF !important;
}
/*-------------------
      Secondary
--------------------*/
/* Standard */
.ui.secondary.buttons .button,
.ui.secondary.button {
  background-color: #1B1C1D;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.secondary.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.secondary.buttons .button:hover,
.ui.secondary.button:hover {
  background-color: #27292a;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.secondary.buttons .button:focus,
.ui.secondary.button:focus {
  background-color: #2e3032;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.secondary.buttons .button:active,
.ui.secondary.button:active {
  background-color: #343637;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.secondary.buttons .active.button,
.ui.secondary.buttons .active.button:active,
.ui.secondary.active.button,
.ui.secondary.button .active.button:active {
  background-color: #27292a;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.secondary.buttons .button,
.ui.basic.secondary.button {
  box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
  color: #1B1C1D !important;
}
.ui.basic.secondary.buttons .button:hover,
.ui.basic.secondary.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #27292a inset !important;
  color: #27292a !important;
}
.ui.basic.secondary.buttons .button:focus,
.ui.basic.secondary.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #2e3032 inset !important;
  color: #27292a !important;
}
.ui.basic.secondary.buttons .active.button,
.ui.basic.secondary.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #27292a inset !important;
  color: #343637 !important;
}
.ui.basic.secondary.buttons .button:active,
.ui.basic.secondary.button:active {
  box-shadow: 0px 0px 0px 1px #343637 inset !important;
  color: #343637 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
  margin-left: -1px;
}
/* Inverted */
.ui.inverted.secondary.buttons .button,
.ui.inverted.secondary.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px #545454 inset !important;
  color: #545454;
}
.ui.inverted.secondary.buttons .button:hover,
.ui.inverted.secondary.button:hover,
.ui.inverted.secondary.buttons .button:focus,
.ui.inverted.secondary.button:focus,
.ui.inverted.secondary.buttons .button.active,
.ui.inverted.secondary.button.active,
.ui.inverted.secondary.buttons .button:active,
.ui.inverted.secondary.button:active {
  box-shadow: none !important;
  color: #FFFFFF;
}
.ui.inverted.secondary.buttons .button:hover,
.ui.inverted.secondary.button:hover {
  background-color: #616161;
}
.ui.inverted.secondary.buttons .button:focus,
.ui.inverted.secondary.button:focus {
  background-color: #686868;
}
.ui.inverted.secondary.buttons .active.button,
.ui.inverted.secondary.active.button {
  background-color: #616161;
}
.ui.inverted.secondary.buttons .button:active,
.ui.inverted.secondary.button:active {
  background-color: #6e6e6e;
}
/* Inverted Basic */
.ui.inverted.secondary.basic.buttons .button,
.ui.inverted.secondary.buttons .basic.button,
.ui.inverted.secondary.basic.button {
  background-color: transparent;
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
  color: #FFFFFF !important;
}
.ui.inverted.secondary.basic.buttons .button:hover,
.ui.inverted.secondary.buttons .basic.button:hover,
.ui.inverted.secondary.basic.button:hover {
  box-shadow: 0px 0px 0px 2px #616161 inset !important;
  color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .button:focus,
.ui.inverted.secondary.basic.buttons .button:focus,
.ui.inverted.secondary.basic.button:focus {
  box-shadow: 0px 0px 0px 2px #686868 inset !important;
  color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .active.button,
.ui.inverted.secondary.buttons .basic.active.button,
.ui.inverted.secondary.basic.active.button {
  box-shadow: 0px 0px 0px 2px #616161 inset !important;
  color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .button:active,
.ui.inverted.secondary.buttons .basic.button:active,
.ui.inverted.secondary.basic.button:active {
  box-shadow: 0px 0px 0px 2px #6e6e6e inset !important;
  color: #545454 !important;
}
/*---------------
    Positive
----------------*/
/* Standard */
.ui.positive.buttons .button,
.ui.positive.button {
  background-color: #21BA45;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.positive.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.positive.buttons .button:hover,
.ui.positive.button:hover {
  background-color: #16ab39;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.positive.buttons .button:focus,
.ui.positive.button:focus {
  background-color: #0ea432;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.positive.buttons .button:active,
.ui.positive.button:active {
  background-color: #198f35;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.positive.buttons .active.button,
.ui.positive.buttons .active.button:active,
.ui.positive.active.button,
.ui.positive.button .active.button:active {
  background-color: #13ae38;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.positive.buttons .button,
.ui.basic.positive.button {
  box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
  color: #21BA45 !important;
}
.ui.basic.positive.buttons .button:hover,
.ui.basic.positive.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
  color: #16ab39 !important;
}
.ui.basic.positive.buttons .button:focus,
.ui.basic.positive.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
  color: #16ab39 !important;
}
.ui.basic.positive.buttons .active.button,
.ui.basic.positive.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
  color: #198f35 !important;
}
.ui.basic.positive.buttons .button:active,
.ui.basic.positive.button:active {
  box-shadow: 0px 0px 0px 1px #198f35 inset !important;
  color: #198f35 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
  margin-left: -1px;
}
/*---------------
     Negative
----------------*/
/* Standard */
.ui.negative.buttons .button,
.ui.negative.button {
  background-color: #DB2828;
  color: #FFFFFF;
  text-shadow: none;
  background-image: none;
}
.ui.negative.button {
  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.negative.buttons .button:hover,
.ui.negative.button:hover {
  background-color: #d01919;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.negative.buttons .button:focus,
.ui.negative.button:focus {
  background-color: #ca1010;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.negative.buttons .button:active,
.ui.negative.button:active {
  background-color: #b21e1e;
  color: #FFFFFF;
  text-shadow: none;
}
.ui.negative.buttons .active.button,
.ui.negative.buttons .active.button:active,
.ui.negative.active.button,
.ui.negative.button .active.button:active {
  background-color: #d41515;
  color: #FFFFFF;
  text-shadow: none;
}
/* Basic */
.ui.basic.negative.buttons .button,
.ui.basic.negative.button {
  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
  color: #DB2828 !important;
}
.ui.basic.negative.buttons .button:hover,
.ui.basic.negative.button:hover {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #d01919 inset !important;
  color: #d01919 !important;
}
.ui.basic.negative.buttons .button:focus,
.ui.basic.negative.button:focus {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
  color: #d01919 !important;
}
.ui.basic.negative.buttons .active.button,
.ui.basic.negative.active.button {
  background: transparent !important;
  box-shadow: 0px 0px 0px 1px #d41515 inset !important;
  color: #b21e1e !important;
}
.ui.basic.negative.buttons .button:active,
.ui.basic.negative.button:active {
  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
  color: #b21e1e !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
  margin-left: -1px;
}
/*******************************
            Groups
*******************************/
.ui.buttons {
  display: inline-flex;
  flex-direction: row;
  font-size: 0em;
  vertical-align: baseline;
  margin: 0em 0.25em 0em 0em;
}
.ui.buttons:not(.basic):not(.inverted) {
  box-shadow: none;
}
/* Clearfix */
.ui.buttons:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
/* Standard Group */
.ui.buttons .button {
  flex: 1 0 auto;
  margin: 0em;
  border-radius: 0em;
  margin: 0px 0px 0px 0px;
}
.ui.buttons > .ui.button:not(.basic):not(.inverted),
.ui.buttons:not(.basic):not(.inverted) > .button {
  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;
}
.ui.buttons .button:first-child {
  border-left: none;
  margin-left: 0em;
  border-top-left-radius: 0.28571429rem;
  border-bottom-left-radius: 0.28571429rem;
}
.ui.buttons .button:last-child {
  border-top-right-radius: 0.28571429rem;
  border-bottom-right-radius: 0.28571429rem;
}
/* Vertical  Style */
.ui.vertical.buttons {
  display: inline-flex;
  flex-direction: column;
}
.ui.vertical.buttons .button {
  display: block;
  float: none;
  width: 100%;
  margin: 0px 0px 0px 0px;
  box-shadow: none;
  border-radius: 0em;
}
.ui.vertical.buttons .button:first-child {
  border-top-left-radius: 0.28571429rem;
  border-top-right-radius: 0.28571429rem;
}
.ui.vertical.buttons .button:last-child {
  margin-bottom: 0px;
  border-bottom-left-radius: 0.28571429rem;
  border-bottom-right-radius: 0.28571429rem;
}
.ui.vertical.buttons .button:only-child {
  border-radius: 0.28571429rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Container
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Container
*******************************/
/*-------------------
       Element
--------------------*/
/* Minimum Gutter is used to determine  the maximum container width for a given device */
/* Devices */
/* Coupling (Add Negative Margin to container size) */
/*-------------------
       Types
--------------------*/
/* Text */
/* Packaged Theme */
/*******************************
            Container
*******************************/
/*-------------------
       Element
--------------------*/
/* Minimum Gutter is used to determine  the maximum container width for a given device */
/* Devices */
/* Coupling (Add Negative Margin to container size) */
/*-------------------
       Types
--------------------*/
/* Text */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Container
*******************************/
/* All Sizes */
.ui.container {
  display: block;
  max-width: 100% !important;
}
/* Mobile */
@media only screen and (max-width: 767px) {
  .ui.container {
    width: auto !important;
    margin-left: 1em !important;
    margin-right: 1em !important;
  }
  .ui.grid.container {
    width: auto !important;
  }
  .ui.relaxed.grid.container {
    width: auto !important;
  }
  .ui.very.relaxed.grid.container {
    width: auto !important;
  }
}
/* Tablet */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.container {
    width: 723px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .ui.grid.container {
    width: calc( 723px  +  2rem ) !important;
  }
  .ui.relaxed.grid.container {
    width: calc( 723px  +  3rem ) !important;
  }
  .ui.very.relaxed.grid.container {
    width: calc( 723px  +  5rem ) !important;
  }
}
/* Small Monitor */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .ui.container {
    width: 933px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .ui.grid.container {
    width: calc( 933px  +  2rem ) !important;
  }
  .ui.relaxed.grid.container {
    width: calc( 933px  +  3rem ) !important;
  }
  .ui.very.relaxed.grid.container {
    width: calc( 933px  +  5rem ) !important;
  }
}
/* Large Monitor */
@media only screen and (min-width: 1200px) {
  .ui.container {
    width: 1127px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .ui.grid.container {
    width: calc( 1127px  +  2rem ) !important;
  }
  .ui.relaxed.grid.container {
    width: calc( 1127px  +  3rem ) !important;
  }
  .ui.very.relaxed.grid.container {
    width: calc( 1127px  +  5rem ) !important;
  }
}
/*******************************
             Types
*******************************/
/* Text Container */
.ui.text.container {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  max-width: 700px !important;
  line-height: 1.5;
}
.ui.text.container {
  font-size: 1.14285714rem;
}
/* Fluid */
.ui.fluid.container {
  width: 100%;
}
/*******************************
           Variations
*******************************/
.ui[class*="left aligned"].container {
  text-align: left;
}
.ui[class*="center aligned"].container {
  text-align: center;
}
.ui[class*="right aligned"].container {
  text-align: right;
}
.ui.justified.container {
  text-align: justify;
  hyphens: auto;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Divider
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Divider
*******************************/
/*-------------------
       Element
--------------------*/
/* Text */
/*-------------------
       Coupling
--------------------*/
/* Icon */
/*******************************
         Variations
*******************************/
/* Horizontal / Vertical */
/* Inverted */
/* Section */
/* Sizes */
/* Packaged Theme */
/*******************************
            Divider
*******************************/
/*-------------------
       Element
--------------------*/
/* Text */
/*-------------------
       Coupling
--------------------*/
/* Icon */
/*******************************
         Variations
*******************************/
/* Horizontal / Vertical */
/* Inverted */
/* Section */
/* Sizes */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Divider
*******************************/
.ui.divider {
  margin: 1rem 0rem;
  line-height: 1;
  height: 0em;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(255, 255, 255, 0.85);
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
/*--------------
      Basic
---------------*/
.ui.divider:not(.vertical):not(.horizontal) {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
/*--------------
    Coupling
---------------*/
/* Allow divider between each column row */
.ui.grid > .column + .divider,
.ui.grid > .row > .column + .divider {
  left: auto;
}
/*--------------
   Horizontal
---------------*/
.ui.horizontal.divider {
  display: table;
  white-space: nowrap;
  height: auto;
  margin: '';
  line-height: 1;
  text-align: center;
}
.ui.horizontal.divider:before,
.ui.horizontal.divider:after {
  content: '';
  display: table-cell;
  position: relative;
  top: 50%;
  width: 50%;
  background-repeat: no-repeat;
}
.ui.horizontal.divider:before {
  background-position: right 1em top 50%;
}
.ui.horizontal.divider:after {
  background-position: left 1em top 50%;
}
/*--------------
    Vertical
---------------*/
.ui.vertical.divider {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  margin: 0rem;
  padding: 0em;
  width: auto;
  height: 50%;
  line-height: 0em;
  text-align: center;
  transform: translateX(-50%);
}
.ui.vertical.divider:before,
.ui.vertical.divider:after {
  position: absolute;
  left: 50%;
  content: '';
  z-index: 3;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  width: 0%;
  height: calc(100% -  1rem );
}
.ui.vertical.divider:before {
  top: -100%;
}
.ui.vertical.divider:after {
  top: auto;
  bottom: 0px;
}
/* Inside grid */
@media only screen and (max-width: 767px) {
  .ui.stackable.grid .ui.vertical.divider,
  .ui.grid .stackable.row .ui.vertical.divider {
    display: table;
    white-space: nowrap;
    height: auto;
    margin: '';
    overflow: hidden;
    line-height: 1;
    text-align: center;
    position: static;
    top: 0;
    left: 0;
    transform: none;
  }
  .ui.stackable.grid .ui.vertical.divider:before,
  .ui.grid .stackable.row .ui.vertical.divider:before,
  .ui.stackable.grid .ui.vertical.divider:after,
  .ui.grid .stackable.row .ui.vertical.divider:after {
    position: static;
    left: 0;
    border-left: none;
    border-right: none;
    content: '';
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    background-repeat: no-repeat;
  }
  .ui.stackable.grid .ui.vertical.divider:before,
  .ui.grid .stackable.row .ui.vertical.divider:before {
    background-position: right 1em top 50%;
  }
  .ui.stackable.grid .ui.vertical.divider:after,
  .ui.grid .stackable.row .ui.vertical.divider:after {
    background-position: left 1em top 50%;
  }
}
/*--------------
      Icon
---------------*/
.ui.divider > .icon {
  margin: 0rem;
  font-size: 1rem;
  height: 1em;
  vertical-align: middle;
}
/*******************************
          Variations
*******************************/
/*--------------
    Hidden
---------------*/
.ui.hidden.divider {
  border-color: transparent !important;
}
.ui.hidden.divider:before,
.ui.hidden.divider:after {
  display: none;
}
/*--------------
    Inverted
---------------*/
.ui.divider.inverted,
.ui.vertical.inverted.divider,
.ui.horizontal.inverted.divider {
  color: #FFFFFF;
}
.ui.divider.inverted,
.ui.divider.inverted:after,
.ui.divider.inverted:before {
  border-top-color: rgba(255, 255, 255, 0.15) !important;
  border-left-color: rgba(255, 255, 255, 0.15) !important;
  border-bottom-color: rgba(255, 255, 255, 0.15) !important;
  border-right-color: rgba(255, 255, 255, 0.15) !important;
}
/*--------------
    Fitted
---------------*/
.ui.fitted.divider {
  margin: 0em;
}
/*--------------
    Clearing
---------------*/
.ui.clearing.divider {
  clear: both;
}
/*--------------
    Section
---------------*/
.ui.section.divider {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
/*--------------
     Sizes
---------------*/
.ui.divider {
  font-size: 1rem;
}
/*******************************
         Theme Overrides
*******************************/
.ui.horizontal.divider:before,
.ui.horizontal.divider:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media only screen and (max-width: 767px) {
  .ui.stackable.grid .ui.vertical.divider:before,
  .ui.grid .stackable.row .ui.vertical.divider:before,
  .ui.stackable.grid .ui.vertical.divider:after,
  .ui.grid .stackable.row .ui.vertical.divider:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}
/*!
 * # Semantic UI - Flag
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Flag
*******************************/
/*-------------------
       Element
--------------------*/
/* Packaged Theme */
/*******************************
            Flag
*******************************/
/*-------------------
       Element
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Flag
*******************************/
i.flag:not(.icon) {
  display: inline-block;
  width: 16px;
  height: 11px;
  line-height: 11px;
  vertical-align: baseline;
  margin: 0em 0.5em 0em 0em;
  text-decoration: inherit;
  speak: none;
  font-smoothing: antialiased;
  backface-visibility: hidden;
}
/* Sprite */
i.flag:not(.icon):before {
  display: inline-block;
  content: '';
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat -108px -1976px;
  width: 16px;
  height: 11px;
}
/* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */
/*******************************
         Theme Overrides
*******************************/
i.flag.ad:before,
i.flag.andorra:before {
  background-position: 0px 0px;
}
i.flag.ae:before,
i.flag.united.arab.emirates:before,
i.flag.uae:before {
  background-position: 0px -26px;
}
i.flag.af:before,
i.flag.afghanistan:before {
  background-position: 0px -52px;
}
i.flag.ag:before,
i.flag.antigua:before {
  background-position: 0px -78px;
}
i.flag.ai:before,
i.flag.anguilla:before {
  background-position: 0px -104px;
}
i.flag.al:before,
i.flag.albania:before {
  background-position: 0px -130px;
}
i.flag.am:before,
i.flag.armenia:before {
  background-position: 0px -156px;
}
i.flag.an:before,
i.flag.netherlands.antilles:before {
  background-position: 0px -182px;
}
i.flag.ao:before,
i.flag.angola:before {
  background-position: 0px -208px;
}
i.flag.ar:before,
i.flag.argentina:before {
  background-position: 0px -234px;
}
i.flag.as:before,
i.flag.american.samoa:before {
  background-position: 0px -260px;
}
i.flag.at:before,
i.flag.austria:before {
  background-position: 0px -286px;
}
i.flag.au:before,
i.flag.australia:before {
  background-position: 0px -312px;
}
i.flag.aw:before,
i.flag.aruba:before {
  background-position: 0px -338px;
}
i.flag.ax:before,
i.flag.aland.islands:before {
  background-position: 0px -364px;
}
i.flag.az:before,
i.flag.azerbaijan:before {
  background-position: 0px -390px;
}
i.flag.ba:before,
i.flag.bosnia:before {
  background-position: 0px -416px;
}
i.flag.bb:before,
i.flag.barbados:before {
  background-position: 0px -442px;
}
i.flag.bd:before,
i.flag.bangladesh:before {
  background-position: 0px -468px;
}
i.flag.be:before,
i.flag.belgium:before {
  background-position: 0px -494px;
}
i.flag.bf:before,
i.flag.burkina.faso:before {
  background-position: 0px -520px;
}
i.flag.bg:before,
i.flag.bulgaria:before {
  background-position: 0px -546px;
}
i.flag.bh:before,
i.flag.bahrain:before {
  background-position: 0px -572px;
}
i.flag.bi:before,
i.flag.burundi:before {
  background-position: 0px -598px;
}
i.flag.bj:before,
i.flag.benin:before {
  background-position: 0px -624px;
}
i.flag.bm:before,
i.flag.bermuda:before {
  background-position: 0px -650px;
}
i.flag.bn:before,
i.flag.brunei:before {
  background-position: 0px -676px;
}
i.flag.bo:before,
i.flag.bolivia:before {
  background-position: 0px -702px;
}
i.flag.br:before,
i.flag.brazil:before {
  background-position: 0px -728px;
}
i.flag.bs:before,
i.flag.bahamas:before {
  background-position: 0px -754px;
}
i.flag.bt:before,
i.flag.bhutan:before {
  background-position: 0px -780px;
}
i.flag.bv:before,
i.flag.bouvet.island:before {
  background-position: 0px -806px;
}
i.flag.bw:before,
i.flag.botswana:before {
  background-position: 0px -832px;
}
i.flag.by:before,
i.flag.belarus:before {
  background-position: 0px -858px;
}
i.flag.bz:before,
i.flag.belize:before {
  background-position: 0px -884px;
}
i.flag.ca:before,
i.flag.canada:before {
  background-position: 0px -910px;
}
i.flag.cc:before,
i.flag.cocos.islands:before {
  background-position: 0px -962px;
}
i.flag.cd:before,
i.flag.congo:before {
  background-position: 0px -988px;
}
i.flag.cf:before,
i.flag.central.african.republic:before {
  background-position: 0px -1014px;
}
i.flag.cg:before,
i.flag.congo.brazzaville:before {
  background-position: 0px -1040px;
}
i.flag.ch:before,
i.flag.switzerland:before {
  background-position: 0px -1066px;
}
i.flag.ci:before,
i.flag.cote.divoire:before {
  background-position: 0px -1092px;
}
i.flag.ck:before,
i.flag.cook.islands:before {
  background-position: 0px -1118px;
}
i.flag.cl:before,
i.flag.chile:before {
  background-position: 0px -1144px;
}
i.flag.cm:before,
i.flag.cameroon:before {
  background-position: 0px -1170px;
}
i.flag.cn:before,
i.flag.china:before {
  background-position: 0px -1196px;
}
i.flag.co:before,
i.flag.colombia:before {
  background-position: 0px -1222px;
}
i.flag.cr:before,
i.flag.costa.rica:before {
  background-position: 0px -1248px;
}
i.flag.cs:before,
i.flag.serbia:before {
  background-position: 0px -1274px;
}
i.flag.cu:before,
i.flag.cuba:before {
  background-position: 0px -1300px;
}
i.flag.cv:before,
i.flag.cape.verde:before {
  background-position: 0px -1326px;
}
i.flag.cx:before,
i.flag.christmas.island:before {
  background-position: 0px -1352px;
}
i.flag.cy:before,
i.flag.cyprus:before {
  background-position: 0px -1378px;
}
i.flag.cz:before,
i.flag.czech.republic:before {
  background-position: 0px -1404px;
}
i.flag.de:before,
i.flag.germany:before {
  background-position: 0px -1430px;
}
i.flag.dj:before,
i.flag.djibouti:before {
  background-position: 0px -1456px;
}
i.flag.dk:before,
i.flag.denmark:before {
  background-position: 0px -1482px;
}
i.flag.dm:before,
i.flag.dominica:before {
  background-position: 0px -1508px;
}
i.flag.do:before,
i.flag.dominican.republic:before {
  background-position: 0px -1534px;
}
i.flag.dz:before,
i.flag.algeria:before {
  background-position: 0px -1560px;
}
i.flag.ec:before,
i.flag.ecuador:before {
  background-position: 0px -1586px;
}
i.flag.ee:before,
i.flag.estonia:before {
  background-position: 0px -1612px;
}
i.flag.eg:before,
i.flag.egypt:before {
  background-position: 0px -1638px;
}
i.flag.eh:before,
i.flag.western.sahara:before {
  background-position: 0px -1664px;
}
i.flag.gb.eng:before,
i.flag.england:before {
  background-position: 0px -1690px;
}
i.flag.er:before,
i.flag.eritrea:before {
  background-position: 0px -1716px;
}
i.flag.es:before,
i.flag.spain:before {
  background-position: 0px -1742px;
}
i.flag.et:before,
i.flag.ethiopia:before {
  background-position: 0px -1768px;
}
i.flag.eu:before,
i.flag.european.union:before {
  background-position: 0px -1794px;
}
i.flag.fi:before,
i.flag.finland:before {
  background-position: 0px -1846px;
}
i.flag.fj:before,
i.flag.fiji:before {
  background-position: 0px -1872px;
}
i.flag.fk:before,
i.flag.falkland.islands:before {
  background-position: 0px -1898px;
}
i.flag.fm:before,
i.flag.micronesia:before {
  background-position: 0px -1924px;
}
i.flag.fo:before,
i.flag.faroe.islands:before {
  background-position: 0px -1950px;
}
i.flag.fr:before,
i.flag.france:before {
  background-position: 0px -1976px;
}
i.flag.ga:before,
i.flag.gabon:before {
  background-position: -36px 0px;
}
i.flag.gb:before,
i.flag.uk:before,
i.flag.united.kingdom:before {
  background-position: -36px -26px;
}
i.flag.gd:before,
i.flag.grenada:before {
  background-position: -36px -52px;
}
i.flag.ge:before,
i.flag.georgia:before {
  background-position: -36px -78px;
}
i.flag.gf:before,
i.flag.french.guiana:before {
  background-position: -36px -104px;
}
i.flag.gh:before,
i.flag.ghana:before {
  background-position: -36px -130px;
}
i.flag.gi:before,
i.flag.gibraltar:before {
  background-position: -36px -156px;
}
i.flag.gl:before,
i.flag.greenland:before {
  background-position: -36px -182px;
}
i.flag.gm:before,
i.flag.gambia:before {
  background-position: -36px -208px;
}
i.flag.gn:before,
i.flag.guinea:before {
  background-position: -36px -234px;
}
i.flag.gp:before,
i.flag.guadeloupe:before {
  background-position: -36px -260px;
}
i.flag.gq:before,
i.flag.equatorial.guinea:before {
  background-position: -36px -286px;
}
i.flag.gr:before,
i.flag.greece:before {
  background-position: -36px -312px;
}
i.flag.gs:before,
i.flag.sandwich.islands:before {
  background-position: -36px -338px;
}
i.flag.gt:before,
i.flag.guatemala:before {
  background-position: -36px -364px;
}
i.flag.gu:before,
i.flag.guam:before {
  background-position: -36px -390px;
}
i.flag.gw:before,
i.flag.guinea-bissau:before {
  background-position: -36px -416px;
}
i.flag.gy:before,
i.flag.guyana:before {
  background-position: -36px -442px;
}
i.flag.hk:before,
i.flag.hong.kong:before {
  background-position: -36px -468px;
}
i.flag.hm:before,
i.flag.heard.island:before {
  background-position: -36px -494px;
}
i.flag.hn:before,
i.flag.honduras:before {
  background-position: -36px -520px;
}
i.flag.hr:before,
i.flag.croatia:before {
  background-position: -36px -546px;
}
i.flag.ht:before,
i.flag.haiti:before {
  background-position: -36px -572px;
}
i.flag.hu:before,
i.flag.hungary:before {
  background-position: -36px -598px;
}
i.flag.id:before,
i.flag.indonesia:before {
  background-position: -36px -624px;
}
i.flag.ie:before,
i.flag.ireland:before {
  background-position: -36px -650px;
}
i.flag.il:before,
i.flag.israel:before {
  background-position: -36px -676px;
}
i.flag.in:before,
i.flag.india:before {
  background-position: -36px -702px;
}
i.flag.io:before,
i.flag.indian.ocean.territory:before {
  background-position: -36px -728px;
}
i.flag.iq:before,
i.flag.iraq:before {
  background-position: -36px -754px;
}
i.flag.ir:before,
i.flag.iran:before {
  background-position: -36px -780px;
}
i.flag.is:before,
i.flag.iceland:before {
  background-position: -36px -806px;
}
i.flag.it:before,
i.flag.italy:before {
  background-position: -36px -832px;
}
i.flag.jm:before,
i.flag.jamaica:before {
  background-position: -36px -858px;
}
i.flag.jo:before,
i.flag.jordan:before {
  background-position: -36px -884px;
}
i.flag.jp:before,
i.flag.japan:before {
  background-position: -36px -910px;
}
i.flag.ke:before,
i.flag.kenya:before {
  background-position: -36px -936px;
}
i.flag.kg:before,
i.flag.kyrgyzstan:before {
  background-position: -36px -962px;
}
i.flag.kh:before,
i.flag.cambodia:before {
  background-position: -36px -988px;
}
i.flag.ki:before,
i.flag.kiribati:before {
  background-position: -36px -1014px;
}
i.flag.km:before,
i.flag.comoros:before {
  background-position: -36px -1040px;
}
i.flag.kn:before,
i.flag.saint.kitts.and.nevis:before {
  background-position: -36px -1066px;
}
i.flag.kp:before,
i.flag.north.korea:before {
  background-position: -36px -1092px;
}
i.flag.kr:before,
i.flag.south.korea:before {
  background-position: -36px -1118px;
}
i.flag.kw:before,
i.flag.kuwait:before {
  background-position: -36px -1144px;
}
i.flag.ky:before,
i.flag.cayman.islands:before {
  background-position: -36px -1170px;
}
i.flag.kz:before,
i.flag.kazakhstan:before {
  background-position: -36px -1196px;
}
i.flag.la:before,
i.flag.laos:before {
  background-position: -36px -1222px;
}
i.flag.lb:before,
i.flag.lebanon:before {
  background-position: -36px -1248px;
}
i.flag.lc:before,
i.flag.saint.lucia:before {
  background-position: -36px -1274px;
}
i.flag.li:before,
i.flag.liechtenstein:before {
  background-position: -36px -1300px;
}
i.flag.lk:before,
i.flag.sri.lanka:before {
  background-position: -36px -1326px;
}
i.flag.lr:before,
i.flag.liberia:before {
  background-position: -36px -1352px;
}
i.flag.ls:before,
i.flag.lesotho:before {
  background-position: -36px -1378px;
}
i.flag.lt:before,
i.flag.lithuania:before {
  background-position: -36px -1404px;
}
i.flag.lu:before,
i.flag.luxembourg:before {
  background-position: -36px -1430px;
}
i.flag.lv:before,
i.flag.latvia:before {
  background-position: -36px -1456px;
}
i.flag.ly:before,
i.flag.libya:before {
  background-position: -36px -1482px;
}
i.flag.ma:before,
i.flag.morocco:before {
  background-position: -36px -1508px;
}
i.flag.mc:before,
i.flag.monaco:before {
  background-position: -36px -1534px;
}
i.flag.md:before,
i.flag.moldova:before {
  background-position: -36px -1560px;
}
i.flag.me:before,
i.flag.montenegro:before {
  background-position: -36px -1586px;
}
i.flag.mg:before,
i.flag.madagascar:before {
  background-position: -36px -1613px;
}
i.flag.mh:before,
i.flag.marshall.islands:before {
  background-position: -36px -1639px;
}
i.flag.mk:before,
i.flag.macedonia:before {
  background-position: -36px -1665px;
}
i.flag.ml:before,
i.flag.mali:before {
  background-position: -36px -1691px;
}
i.flag.mm:before,
i.flag.myanmar:before,
i.flag.burma:before {
  background-position: -73px -1821px;
}
i.flag.mn:before,
i.flag.mongolia:before {
  background-position: -36px -1743px;
}
i.flag.mo:before,
i.flag.macau:before {
  background-position: -36px -1769px;
}
i.flag.mp:before,
i.flag.northern.mariana.islands:before {
  background-position: -36px -1795px;
}
i.flag.mq:before,
i.flag.martinique:before {
  background-position: -36px -1821px;
}
i.flag.mr:before,
i.flag.mauritania:before {
  background-position: -36px -1847px;
}
i.flag.ms:before,
i.flag.montserrat:before {
  background-position: -36px -1873px;
}
i.flag.mt:before,
i.flag.malta:before {
  background-position: -36px -1899px;
}
i.flag.mu:before,
i.flag.mauritius:before {
  background-position: -36px -1925px;
}
i.flag.mv:before,
i.flag.maldives:before {
  background-position: -36px -1951px;
}
i.flag.mw:before,
i.flag.malawi:before {
  background-position: -36px -1977px;
}
i.flag.mx:before,
i.flag.mexico:before {
  background-position: -72px 0px;
}
i.flag.my:before,
i.flag.malaysia:before {
  background-position: -72px -26px;
}
i.flag.mz:before,
i.flag.mozambique:before {
  background-position: -72px -52px;
}
i.flag.na:before,
i.flag.namibia:before {
  background-position: -72px -78px;
}
i.flag.nc:before,
i.flag.new.caledonia:before {
  background-position: -72px -104px;
}
i.flag.ne:before,
i.flag.niger:before {
  background-position: -72px -130px;
}
i.flag.nf:before,
i.flag.norfolk.island:before {
  background-position: -72px -156px;
}
i.flag.ng:before,
i.flag.nigeria:before {
  background-position: -72px -182px;
}
i.flag.ni:before,
i.flag.nicaragua:before {
  background-position: -72px -208px;
}
i.flag.nl:before,
i.flag.netherlands:before {
  background-position: -72px -234px;
}
i.flag.no:before,
i.flag.norway:before {
  background-position: -72px -260px;
}
i.flag.np:before,
i.flag.nepal:before {
  background-position: -72px -286px;
}
i.flag.nr:before,
i.flag.nauru:before {
  background-position: -72px -312px;
}
i.flag.nu:before,
i.flag.niue:before {
  background-position: -72px -338px;
}
i.flag.nz:before,
i.flag.new.zealand:before {
  background-position: -72px -364px;
}
i.flag.om:before,
i.flag.oman:before {
  background-position: -72px -390px;
}
i.flag.pa:before,
i.flag.panama:before {
  background-position: -72px -416px;
}
i.flag.pe:before,
i.flag.peru:before {
  background-position: -72px -442px;
}
i.flag.pf:before,
i.flag.french.polynesia:before {
  background-position: -72px -468px;
}
i.flag.pg:before,
i.flag.new.guinea:before {
  background-position: -72px -494px;
}
i.flag.ph:before,
i.flag.philippines:before {
  background-position: -72px -520px;
}
i.flag.pk:before,
i.flag.pakistan:before {
  background-position: -72px -546px;
}
i.flag.pl:before,
i.flag.poland:before {
  background-position: -72px -572px;
}
i.flag.pm:before,
i.flag.saint.pierre:before {
  background-position: -72px -598px;
}
i.flag.pn:before,
i.flag.pitcairn.islands:before {
  background-position: -72px -624px;
}
i.flag.pr:before,
i.flag.puerto.rico:before {
  background-position: -72px -650px;
}
i.flag.ps:before,
i.flag.palestine:before {
  background-position: -72px -676px;
}
i.flag.pt:before,
i.flag.portugal:before {
  background-position: -72px -702px;
}
i.flag.pw:before,
i.flag.palau:before {
  background-position: -72px -728px;
}
i.flag.py:before,
i.flag.paraguay:before {
  background-position: -72px -754px;
}
i.flag.qa:before,
i.flag.qatar:before {
  background-position: -72px -780px;
}
i.flag.re:before,
i.flag.reunion:before {
  background-position: -72px -806px;
}
i.flag.ro:before,
i.flag.romania:before {
  background-position: -72px -832px;
}
i.flag.rs:before,
i.flag.serbia:before {
  background-position: -72px -858px;
}
i.flag.ru:before,
i.flag.russia:before {
  background-position: -72px -884px;
}
i.flag.rw:before,
i.flag.rwanda:before {
  background-position: -72px -910px;
}
i.flag.sa:before,
i.flag.saudi.arabia:before {
  background-position: -72px -936px;
}
i.flag.sb:before,
i.flag.solomon.islands:before {
  background-position: -72px -962px;
}
i.flag.sc:before,
i.flag.seychelles:before {
  background-position: -72px -988px;
}
i.flag.gb.sct:before,
i.flag.scotland:before {
  background-position: -72px -1014px;
}
i.flag.sd:before,
i.flag.sudan:before {
  background-position: -72px -1040px;
}
i.flag.se:before,
i.flag.sweden:before {
  background-position: -72px -1066px;
}
i.flag.sg:before,
i.flag.singapore:before {
  background-position: -72px -1092px;
}
i.flag.sh:before,
i.flag.saint.helena:before {
  background-position: -72px -1118px;
}
i.flag.si:before,
i.flag.slovenia:before {
  background-position: -72px -1144px;
}
i.flag.sj:before,
i.flag.svalbard:before,
i.flag.jan.mayen:before {
  background-position: -72px -1170px;
}
i.flag.sk:before,
i.flag.slovakia:before {
  background-position: -72px -1196px;
}
i.flag.sl:before,
i.flag.sierra.leone:before {
  background-position: -72px -1222px;
}
i.flag.sm:before,
i.flag.san.marino:before {
  background-position: -72px -1248px;
}
i.flag.sn:before,
i.flag.senegal:before {
  background-position: -72px -1274px;
}
i.flag.so:before,
i.flag.somalia:before {
  background-position: -72px -1300px;
}
i.flag.sr:before,
i.flag.suriname:before {
  background-position: -72px -1326px;
}
i.flag.st:before,
i.flag.sao.tome:before {
  background-position: -72px -1352px;
}
i.flag.sv:before,
i.flag.el.salvador:before {
  background-position: -72px -1378px;
}
i.flag.sy:before,
i.flag.syria:before {
  background-position: -72px -1404px;
}
i.flag.sz:before,
i.flag.swaziland:before {
  background-position: -72px -1430px;
}
i.flag.tc:before,
i.flag.caicos.islands:before {
  background-position: -72px -1456px;
}
i.flag.td:before,
i.flag.chad:before {
  background-position: -72px -1482px;
}
i.flag.tf:before,
i.flag.french.territories:before {
  background-position: -72px -1508px;
}
i.flag.tg:before,
i.flag.togo:before {
  background-position: -72px -1534px;
}
i.flag.th:before,
i.flag.thailand:before {
  background-position: -72px -1560px;
}
i.flag.tj:before,
i.flag.tajikistan:before {
  background-position: -72px -1586px;
}
i.flag.tk:before,
i.flag.tokelau:before {
  background-position: -72px -1612px;
}
i.flag.tl:before,
i.flag.timorleste:before {
  background-position: -72px -1638px;
}
i.flag.tm:before,
i.flag.turkmenistan:before {
  background-position: -72px -1664px;
}
i.flag.tn:before,
i.flag.tunisia:before {
  background-position: -72px -1690px;
}
i.flag.to:before,
i.flag.tonga:before {
  background-position: -72px -1716px;
}
i.flag.tr:before,
i.flag.turkey:before {
  background-position: -72px -1742px;
}
i.flag.tt:before,
i.flag.trinidad:before {
  background-position: -72px -1768px;
}
i.flag.tv:before,
i.flag.tuvalu:before {
  background-position: -72px -1794px;
}
i.flag.tw:before,
i.flag.taiwan:before {
  background-position: -72px -1820px;
}
i.flag.tz:before,
i.flag.tanzania:before {
  background-position: -72px -1846px;
}
i.flag.ua:before,
i.flag.ukraine:before {
  background-position: -72px -1872px;
}
i.flag.ug:before,
i.flag.uganda:before {
  background-position: -72px -1898px;
}
i.flag.um:before,
i.flag.us.minor.islands:before {
  background-position: -72px -1924px;
}
i.flag.us:before,
i.flag.america:before,
i.flag.united.states:before {
  background-position: -72px -1950px;
}
i.flag.uy:before,
i.flag.uruguay:before {
  background-position: -72px -1976px;
}
i.flag.uz:before,
i.flag.uzbekistan:before {
  background-position: -108px 0px;
}
i.flag.va:before,
i.flag.vatican.city:before {
  background-position: -108px -26px;
}
i.flag.vc:before,
i.flag.saint.vincent:before {
  background-position: -108px -52px;
}
i.flag.ve:before,
i.flag.venezuela:before {
  background-position: -108px -78px;
}
i.flag.vg:before,
i.flag.british.virgin.islands:before {
  background-position: -108px -104px;
}
i.flag.vi:before,
i.flag.us.virgin.islands:before {
  background-position: -108px -130px;
}
i.flag.vn:before,
i.flag.vietnam:before {
  background-position: -108px -156px;
}
i.flag.vu:before,
i.flag.vanuatu:before {
  background-position: -108px -182px;
}
i.flag.gb.wls:before,
i.flag.wales:before {
  background-position: -108px -208px;
}
i.flag.wf:before,
i.flag.wallis.and.futuna:before {
  background-position: -108px -234px;
}
i.flag.ws:before,
i.flag.samoa:before {
  background-position: -108px -260px;
}
i.flag.ye:before,
i.flag.yemen:before {
  background-position: -108px -286px;
}
i.flag.yt:before,
i.flag.mayotte:before {
  background-position: -108px -312px;
}
i.flag.za:before,
i.flag.south.africa:before {
  background-position: -108px -338px;
}
i.flag.zm:before,
i.flag.zambia:before {
  background-position: -108px -364px;
}
i.flag.zw:before,
i.flag.zimbabwe:before {
  background-position: -108px -390px;
}
/*!
 * # Semantic UI - Header
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Header
*******************************/
/*-------------------
       Element
--------------------*/
/* Sub Heading */
/* Sub Header */
/* Icon */
/* Image */
/* Label */
/* Content */
/* Paragraph after Header */
/*-------------------
      Variations
--------------------*/
/* Sizing */
/* Sub Header */
/* Icon Header */
/* No Line Height Offset */
/* Divided */
/* Block */
/* Attached */
/* Inverted */
/* Floated */
/* Packaged Theme */
/*******************************
            Header
*******************************/
/*-------------------
       Element
--------------------*/
/* Sub Heading */
/* Sub Header */
/* Icon */
/* Image */
/* Label */
/* Content */
/* Paragraph after Header */
/*-------------------
      Variations
--------------------*/
/* Sizing */
/* Sub Header */
/* Icon Header */
/* No Line Height Offset */
/* Divided */
/* Block */
/* Attached */
/* Inverted */
/* Floated */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Header
*******************************/
/* Standard */
.ui.header {
  border: none;
  margin: calc(2rem -  0.14285714em ) 0em 1rem;
  padding: 0em 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: bold;
  line-height: 1.28571429em;
  text-transform: none;
  color: rgba(255, 255, 255, 0.87);
}
.ui.header:first-child {
  margin-top: -0.14285714em;
}
.ui.header:last-child {
  margin-bottom: 0em;
}
/*--------------
   Sub Header
---------------*/
.ui.header .sub.header {
  display: block;
  font-weight: normal;
  padding: 0em;
  margin: 0em;
  font-size: 1rem;
  line-height: 1.2em;
  color: rgba(255, 255, 255, 0.6);
}
/*--------------
      Icon
---------------*/
.ui.header > .icon {
  display: table-cell;
  opacity: 1;
  font-size: 1.5em;
  padding-top: 0em;
  vertical-align: middle;
}
/* With Text Node */
.ui.header .icon:only-child {
  display: inline-block;
  padding: 0em;
  margin-right: 0.75rem;
}
/*-------------------
        Image
--------------------*/
.ui.header > .image:not(.icon),
.ui.header > img {
  display: inline-block;
  margin-top: 0.14285714em;
  width: 2.5em;
  height: auto;
  vertical-align: middle;
}
.ui.header > .image:not(.icon):only-child,
.ui.header > img:only-child {
  margin-right: 0.75rem;
}
/*--------------
     Content
---------------*/
.ui.header .content {
  display: inline-block;
  vertical-align: top;
}
/* After Image */
.ui.header > img + .content,
.ui.header > .image + .content {
  padding-left: 0.75rem;
  vertical-align: middle;
}
/* After Icon */
.ui.header > .icon + .content {
  padding-left: 0.75rem;
  display: table-cell;
  vertical-align: middle;
}
/*--------------
 Loose Coupling
---------------*/
.ui.header .ui.label {
  font-size: '';
  margin-left: 0.5rem;
  vertical-align: middle;
}
/* Positioning */
.ui.header + p {
  margin-top: 0em;
}
/*******************************
            Types
*******************************/
/*--------------
     Page
---------------*/
h1.ui.header {
  font-size: 2rem;
}
h2.ui.header {
  font-size: 1.71428571rem;
}
h3.ui.header {
  font-size: 1.28571429rem;
}
h4.ui.header {
  font-size: 1.07142857rem;
}
h5.ui.header {
  font-size: 1rem;
}
/* Sub Header */
h1.ui.header .sub.header {
  font-size: 1.14285714rem;
}
h2.ui.header .sub.header {
  font-size: 1.14285714rem;
}
h3.ui.header .sub.header {
  font-size: 1rem;
}
h4.ui.header .sub.header {
  font-size: 1rem;
}
h5.ui.header .sub.header {
  font-size: 0.92857143rem;
}
/*--------------
 Content Heading
---------------*/
.ui.huge.header {
  min-height: 1em;
  font-size: 2em;
}
.ui.large.header {
  font-size: 1.71428571em;
}
.ui.medium.header {
  font-size: 1.28571429em;
}
.ui.small.header {
  font-size: 1.07142857em;
}
.ui.tiny.header {
  font-size: 1em;
}
/* Sub Header */
.ui.huge.header .sub.header {
  font-size: 1.14285714rem;
}
.ui.large.header .sub.header {
  font-size: 1.14285714rem;
}
.ui.header .sub.header {
  font-size: 1rem;
}
.ui.small.header .sub.header {
  font-size: 1rem;
}
.ui.tiny.header .sub.header {
  font-size: 0.92857143rem;
}
/*--------------
   Sub Heading
---------------*/
.ui.sub.header {
  padding: 0em;
  margin-bottom: 0.14285714rem;
  font-weight: bold;
  font-size: 0.85714286em;
  text-transform: uppercase;
  color: '';
}
.ui.small.sub.header {
  font-size: 0.78571429em;
}
.ui.sub.header {
  font-size: 0.85714286em;
}
.ui.large.sub.header {
  font-size: 0.92857143em;
}
.ui.huge.sub.header {
  font-size: 1em;
}
/*-------------------
        Icon
--------------------*/
.ui.icon.header {
  display: inline-block;
  text-align: center;
  margin: 2rem 0em 1rem;
}
.ui.icon.header:after {
  content: '';
  display: block;
  height: 0px;
  clear: both;
  visibility: hidden;
}
.ui.icon.header:first-child {
  margin-top: 0em;
}
.ui.icon.header .icon {
  float: none;
  display: block;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 0em;
  font-size: 3em;
  margin: 0em auto 0.5rem;
  opacity: 1;
}
.ui.icon.header .content {
  display: block;
  padding: 0em;
}
.ui.icon.header .circular.icon {
  font-size: 2em;
}
.ui.icon.header .square.icon {
  font-size: 2em;
}
.ui.block.icon.header .icon {
  margin-bottom: 0em;
}
.ui.icon.header.aligned {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
/*******************************
            States
*******************************/
.ui.disabled.header {
  opacity: 0.45;
}
/*******************************
           Variations
*******************************/
/*-------------------
      Inverted
--------------------*/
.ui.inverted.header {
  color: #FFFFFF;
}
.ui.inverted.header .sub.header {
  color: rgba(255, 255, 255, 0.8);
}
.ui.inverted.attached.header {
  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  box-shadow: none;
  border-color: transparent;
}
.ui.inverted.block.header {
  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  box-shadow: none;
}
.ui.inverted.block.header {
  border-bottom: none;
}
/*-------------------
       Colors
--------------------*/
/*--- Red ---*/
.ui.red.header {
  color: #DB2828 !important;
}
a.ui.red.header:hover {
  color: #d01919 !important;
}
.ui.red.dividing.header {
  border-bottom: 2px solid #DB2828;
}
/* Inverted */
.ui.inverted.red.header {
  color: #FF695E !important;
}
a.ui.inverted.red.header:hover {
  color: #ff5144 !important;
}
/*--- Orange ---*/
.ui.orange.header {
  color: #F2711C !important;
}
a.ui.orange.header:hover {
  color: #f26202 !important;
}
.ui.orange.dividing.header {
  border-bottom: 2px solid #F2711C;
}
/* Inverted */
.ui.inverted.orange.header {
  color: #FF851B !important;
}
a.ui.inverted.orange.header:hover {
  color: #ff7701 !important;
}
/*--- Olive ---*/
.ui.olive.header {
  color: #B5CC18 !important;
}
a.ui.olive.header:hover {
  color: #a7bd0d !important;
}
.ui.olive.dividing.header {
  border-bottom: 2px solid #B5CC18;
}
/* Inverted */
.ui.inverted.olive.header {
  color: #D9E778 !important;
}
a.ui.inverted.olive.header:hover {
  color: #d8ea5c !important;
}
/*--- Yellow ---*/
.ui.yellow.header {
  color: #FBBD08 !important;
}
a.ui.yellow.header:hover {
  color: #eaae00 !important;
}
.ui.yellow.dividing.header {
  border-bottom: 2px solid #FBBD08;
}
/* Inverted */
.ui.inverted.yellow.header {
  color: #FFE21F !important;
}
a.ui.inverted.yellow.header:hover {
  color: #ffdf05 !important;
}
/*--- Green ---*/
.ui.green.header {
  color: #21BA45 !important;
}
a.ui.green.header:hover {
  color: #16ab39 !important;
}
.ui.green.dividing.header {
  border-bottom: 2px solid #21BA45;
}
/* Inverted */
.ui.inverted.green.header {
  color: #2ECC40 !important;
}
a.ui.inverted.green.header:hover {
  color: #22be34 !important;
}
/*--- Teal ---*/
.ui.teal.header {
  color: #00B5AD !important;
}
a.ui.teal.header:hover {
  color: #009c95 !important;
}
.ui.teal.dividing.header {
  border-bottom: 2px solid #00B5AD;
}
/* Inverted */
.ui.inverted.teal.header {
  color: #6DFFFF !important;
}
a.ui.inverted.teal.header:hover {
  color: #54ffff !important;
}
/*--- Blue ---*/
.ui.blue.header {
  color: #2185D0 !important;
}
a.ui.blue.header:hover {
  color: #1678c2 !important;
}
.ui.blue.dividing.header {
  border-bottom: 2px solid #2185D0;
}
/* Inverted */
.ui.inverted.blue.header {
  color: #54C8FF !important;
}
a.ui.inverted.blue.header:hover {
  color: #3ac0ff !important;
}
/*--- Violet ---*/
.ui.violet.header {
  color: #6435C9 !important;
}
a.ui.violet.header:hover {
  color: #5829bb !important;
}
.ui.violet.dividing.header {
  border-bottom: 2px solid #6435C9;
}
/* Inverted */
.ui.inverted.violet.header {
  color: #A291FB !important;
}
a.ui.inverted.violet.header:hover {
  color: #8a73ff !important;
}
/*--- Purple ---*/
.ui.purple.header {
  color: #A333C8 !important;
}
a.ui.purple.header:hover {
  color: #9627ba !important;
}
.ui.purple.dividing.header {
  border-bottom: 2px solid #A333C8;
}
/* Inverted */
.ui.inverted.purple.header {
  color: #DC73FF !important;
}
a.ui.inverted.purple.header:hover {
  color: #d65aff !important;
}
/*--- Pink ---*/
.ui.pink.header {
  color: #E03997 !important;
}
a.ui.pink.header:hover {
  color: #e61a8d !important;
}
.ui.pink.dividing.header {
  border-bottom: 2px solid #E03997;
}
/* Inverted */
.ui.inverted.pink.header {
  color: #FF8EDF !important;
}
a.ui.inverted.pink.header:hover {
  color: #ff74d8 !important;
}
/*--- Brown ---*/
.ui.brown.header {
  color: #A5673F !important;
}
a.ui.brown.header:hover {
  color: #975b33 !important;
}
.ui.brown.dividing.header {
  border-bottom: 2px solid #A5673F;
}
/* Inverted */
.ui.inverted.brown.header {
  color: #D67C1C !important;
}
a.ui.inverted.brown.header:hover {
  color: #c86f11 !important;
}
/*--- Grey ---*/
.ui.grey.header {
  color: #767676 !important;
}
a.ui.grey.header:hover {
  color: #838383 !important;
}
.ui.grey.dividing.header {
  border-bottom: 2px solid #767676;
}
/* Inverted */
.ui.inverted.grey.header {
  color: #DCDDDE !important;
}
a.ui.inverted.grey.header:hover {
  color: #cfd0d2 !important;
}
/*-------------------
       Aligned
--------------------*/
.ui.left.aligned.header {
  text-align: left;
}
.ui.right.aligned.header {
  text-align: right;
}
.ui.centered.header,
.ui.center.aligned.header {
  text-align: center;
}
.ui.justified.header {
  text-align: justify;
}
.ui.justified.header:after {
  display: inline-block;
  content: '';
  width: 100%;
}
/*-------------------
       Floated
--------------------*/
.ui.floated.header,
.ui[class*="left floated"].header {
  float: left;
  margin-top: 0em;
  margin-right: 0.5em;
}
.ui[class*="right floated"].header {
  float: right;
  margin-top: 0em;
  margin-left: 0.5em;
}
/*-------------------
       Fitted
--------------------*/
.ui.fitted.header {
  padding: 0em;
}
/*-------------------
      Dividing
--------------------*/
.ui.dividing.header {
  padding-bottom: 0.21428571rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.dividing.header .sub.header {
  padding-bottom: 0.21428571rem;
}
.ui.dividing.header .icon {
  margin-bottom: 0em;
}
.ui.inverted.dividing.header {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}
/*-------------------
        Block
--------------------*/
.ui.block.header {
  background: #F3F4F5;
  padding: 0.78571429rem 1rem;
  box-shadow: none;
  border: 1px solid #D4D4D5;
  border-radius: 0.28571429rem;
}
.ui.tiny.block.header {
  font-size: 0.85714286rem;
}
.ui.small.block.header {
  font-size: 0.92857143rem;
}
.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1rem;
}
.ui.large.block.header {
  font-size: 1.14285714rem;
}
.ui.huge.block.header {
  font-size: 1.42857143rem;
}
/*-------------------
       Attached
--------------------*/
.ui.attached.header {
  background: #FFFFFF;
  padding: 0.78571429rem 1rem;
  margin-left: -1px;
  margin-right: -1px;
  box-shadow: none;
  border: 1px solid #D4D4D5;
}
.ui.attached.block.header {
  background: #F3F4F5;
}
.ui.attached:not(.top):not(.bottom).header {
  margin-top: 0em;
  margin-bottom: 0em;
  border-top: none;
  border-radius: 0em;
}
.ui.top.attached.header {
  margin-bottom: 0em;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.bottom.attached.header {
  margin-top: 0em;
  border-top: none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
/* Attached Sizes */
.ui.tiny.attached.header {
  font-size: 0.85714286em;
}
.ui.small.attached.header {
  font-size: 0.92857143em;
}
.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1em;
}
.ui.large.attached.header {
  font-size: 1.14285714em;
}
.ui.huge.attached.header {
  font-size: 1.42857143em;
}
/*-------------------
        Sizing
--------------------*/
.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1.28571429em;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Icon
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Icon
*******************************/
/*--------------
   Font Files
---------------*/
/*--------------
 Optional Files
---------------*/
/* Outline Icons */
/* Brand Icons */
/*--------------
   Definition
---------------*/
/* Icon Variables */
/* Variations */
/* Packaged Theme */
/*******************************
             Icon
*******************************/
/*--------------
   Font Files
---------------*/
/*--------------
 Optional Files
---------------*/
/* Outline Icons */
/* Brand Icons */
/*--------------
   Definition
---------------*/
/* Icon Variables */
/* Variations */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Icon
*******************************/
@font-face {
  font-family: 'Icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('svg');
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
i.icon {
  display: inline-block;
  opacity: 1;
  margin: 0em 0.25rem 0em 0em;
  width: 1.18em;
  height: 1em;
  font-family: 'Icons';
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  text-align: center;
  speak: none;
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
}
i.icon:before {
  background: none !important;
}
/*******************************
             Types
*******************************/
/*--------------
    Loading
---------------*/
i.icon.loading {
  height: 1em;
  line-height: 1;
}
i.icon.loading {
  animation: icon-loading 2s linear infinite;
}
@keyframes icon-loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*******************************
             States
*******************************/
i.icon.hover {
  opacity: 1 !important;
}
i.icon.active {
  opacity: 1 !important;
}
i.emphasized.icon {
  opacity: 1 !important;
}
i.disabled.icon {
  opacity: 0.45 !important;
}
/*******************************
           Variations
*******************************/
/*-------------------
        Fitted
--------------------*/
i.fitted.icon {
  width: auto;
  margin: 0em !important;
}
/*-------------------
         Link
--------------------*/
i.link.icon,
i.link.icons {
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
i.link.icon:hover,
i.link.icons:hover {
  opacity: 1 !important;
}
/*-------------------
      Circular
--------------------*/
i.circular.icon {
  border-radius: 500em !important;
  line-height: 1 !important;
  padding: 0.5em 0em !important;
  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;
  width: 2em !important;
  height: 2em !important;
}
i.circular.inverted.icon {
  border: none;
  box-shadow: none;
}
/*-------------------
      Flipped
--------------------*/
i.flipped.icon,
i.horizontally.flipped.icon {
  transform: scale(-1, 1);
}
i.vertically.flipped.icon {
  transform: scale(1, -1);
}
/*-------------------
      Rotated
--------------------*/
i.rotated.icon,
i.right.rotated.icon,
i.clockwise.rotated.icon {
  transform: rotate(90deg);
}
i.left.rotated.icon,
i.counterclockwise.rotated.icon {
  transform: rotate(-90deg);
}
/*-------------------
      Bordered
--------------------*/
i.bordered.icon {
  line-height: 1;
  vertical-align: baseline;
  width: 2em;
  height: 2em;
  padding: 0.5em 0em !important;
  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;
}
i.bordered.inverted.icon {
  border: none;
  box-shadow: none;
}
/*-------------------
      Inverted
--------------------*/
/* Inverted Shapes */
i.inverted.bordered.icon,
i.inverted.circular.icon {
  background-color: #1B1C1D !important;
  color: #FFFFFF !important;
}
i.inverted.icon {
  color: #FFFFFF;
}
/*-------------------
       Colors
--------------------*/
/* Red */
i.red.icon {
  color: #DB2828 !important;
}
i.inverted.red.icon {
  color: #FF695E !important;
}
i.inverted.bordered.red.icon,
i.inverted.circular.red.icon {
  background-color: #DB2828 !important;
  color: #FFFFFF !important;
}
/* Orange */
i.orange.icon {
  color: #F2711C !important;
}
i.inverted.orange.icon {
  color: #FF851B !important;
}
i.inverted.bordered.orange.icon,
i.inverted.circular.orange.icon {
  background-color: #F2711C !important;
  color: #FFFFFF !important;
}
/* Yellow */
i.yellow.icon {
  color: #FBBD08 !important;
}
i.inverted.yellow.icon {
  color: #FFE21F !important;
}
i.inverted.bordered.yellow.icon,
i.inverted.circular.yellow.icon {
  background-color: #FBBD08 !important;
  color: #FFFFFF !important;
}
/* Olive */
i.olive.icon {
  color: #B5CC18 !important;
}
i.inverted.olive.icon {
  color: #D9E778 !important;
}
i.inverted.bordered.olive.icon,
i.inverted.circular.olive.icon {
  background-color: #B5CC18 !important;
  color: #FFFFFF !important;
}
/* Green */
i.green.icon {
  color: #21BA45 !important;
}
i.inverted.green.icon {
  color: #2ECC40 !important;
}
i.inverted.bordered.green.icon,
i.inverted.circular.green.icon {
  background-color: #21BA45 !important;
  color: #FFFFFF !important;
}
/* Teal */
i.teal.icon {
  color: #00B5AD !important;
}
i.inverted.teal.icon {
  color: #6DFFFF !important;
}
i.inverted.bordered.teal.icon,
i.inverted.circular.teal.icon {
  background-color: #00B5AD !important;
  color: #FFFFFF !important;
}
/* Blue */
i.blue.icon {
  color: #2185D0 !important;
}
i.inverted.blue.icon {
  color: #54C8FF !important;
}
i.inverted.bordered.blue.icon,
i.inverted.circular.blue.icon {
  background-color: #2185D0 !important;
  color: #FFFFFF !important;
}
/* Violet */
i.violet.icon {
  color: #6435C9 !important;
}
i.inverted.violet.icon {
  color: #A291FB !important;
}
i.inverted.bordered.violet.icon,
i.inverted.circular.violet.icon {
  background-color: #6435C9 !important;
  color: #FFFFFF !important;
}
/* Purple */
i.purple.icon {
  color: #A333C8 !important;
}
i.inverted.purple.icon {
  color: #DC73FF !important;
}
i.inverted.bordered.purple.icon,
i.inverted.circular.purple.icon {
  background-color: #A333C8 !important;
  color: #FFFFFF !important;
}
/* Pink */
i.pink.icon {
  color: #E03997 !important;
}
i.inverted.pink.icon {
  color: #FF8EDF !important;
}
i.inverted.bordered.pink.icon,
i.inverted.circular.pink.icon {
  background-color: #E03997 !important;
  color: #FFFFFF !important;
}
/* Brown */
i.brown.icon {
  color: #A5673F !important;
}
i.inverted.brown.icon {
  color: #D67C1C !important;
}
i.inverted.bordered.brown.icon,
i.inverted.circular.brown.icon {
  background-color: #A5673F !important;
  color: #FFFFFF !important;
}
/* Grey */
i.grey.icon {
  color: #767676 !important;
}
i.inverted.grey.icon {
  color: #DCDDDE !important;
}
i.inverted.bordered.grey.icon,
i.inverted.circular.grey.icon {
  background-color: #767676 !important;
  color: #FFFFFF !important;
}
/* Black */
i.black.icon {
  color: #1B1C1D !important;
}
i.inverted.black.icon {
  color: #545454 !important;
}
i.inverted.bordered.black.icon,
i.inverted.circular.black.icon {
  background-color: #1B1C1D !important;
  color: #FFFFFF !important;
}
/*-------------------
        Sizes
--------------------*/
i.mini.icon,
i.mini.icons {
  line-height: 1;
  font-size: 0.4em;
}
i.tiny.icon,
i.tiny.icons {
  line-height: 1;
  font-size: 0.5em;
}
i.small.icon,
i.small.icons {
  line-height: 1;
  font-size: 0.75em;
}
i.icon,
i.icons {
  font-size: 1em;
}
i.large.icon,
i.large.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 1.5em;
}
i.big.icon,
i.big.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 2em;
}
i.huge.icon,
i.huge.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 4em;
}
i.massive.icon,
i.massive.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 8em;
}
/*******************************
            Groups
*******************************/
i.icons {
  display: inline-block;
  position: relative;
  line-height: 1;
}
i.icons .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin: 0em;
  margin: 0;
}
i.icons .icon:first-child {
  position: static;
  width: auto;
  height: auto;
  vertical-align: top;
  transform: none;
  margin-right: 0.25rem;
}
/* Corner Icon */
i.icons .corner.icon {
  top: auto;
  left: auto;
  right: 0;
  bottom: 0;
  transform: none;
  font-size: 0.45em;
  text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF;
}
i.icons .top.right.corner.icon {
  top: 0;
  left: auto;
  right: 0;
  bottom: auto;
}
i.icons .top.left.corner.icon {
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
}
i.icons .bottom.left.corner.icon {
  top: auto;
  left: 0;
  right: auto;
  bottom: 0;
}
i.icons .bottom.right.corner.icon {
  top: auto;
  left: auto;
  right: 0;
  bottom: 0;
}
i.icons .inverted.corner.icon {
  text-shadow: -1px -1px 0 #1B1C1D, 1px -1px 0 #1B1C1D, -1px 1px 0 #1B1C1D, 1px 1px 0 #1B1C1D;
}
/*
 * Font Awesome 5.0.8 by @fontawesome - http://fontawesome.io - @fontawesome
 * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)
 */
/*******************************

Semantic-UI integration of font-awesome :

///class names are separated
i.icon.circle => i.icon.circle
i.icon.circle-o => i.icon.circle.outline

//abbreviation are replaced by full letters:
i.icon.ellipsis-h => i.icon.ellipsis.horizontal
i.icon.ellipsis-v => i.icon.ellipsis.vertical
.alpha => .i.icon.alphabet
.asc => .i.icon.ascending
.desc => .i.icon.descending
.alt =>.alternate

ASCII order is conserved for easier maintenance.

Icons that only have one style 'outline', 'square' etc do not require this class
for instance \`lemon icon\` not \`lemon outline icon\` since there is only one lemon

*******************************/
/*******************************
            Icons
*******************************/
/* Deprecated *In/Out Naming Conflict) */
i.icon.linkedin.in:before {
  content: "\\f0e1";
}
i.icon.zoom.in:before {
  content: "\\f00e";
}
i.icon.zoom.out:before {
  content: "\\f010";
}
i.icon.sign.in:before {
  content: "\\f2f6";
}
i.icon.in.cart:before {
  content: "\\f218";
}
i.icon.log.out:before {
  content: "\\f2f5";
}
i.icon.sign.out:before {
  content: "\\f2f5";
}
/* Icons */
i.icon.\\35 00px:before {
  content: "\\f26e";
}
i.icon.accessible.icon:before {
  content: "\\f368";
}
i.icon.accusoft:before {
  content: "\\f369";
}
i.icon.address.book:before {
  content: "\\f2b9";
}
i.icon.address.card:before {
  content: "\\f2bb";
}
i.icon.adjust:before {
  content: "\\f042";
}
i.icon.adn:before {
  content: "\\f170";
}
i.icon.adversal:before {
  content: "\\f36a";
}
i.icon.affiliatetheme:before {
  content: "\\f36b";
}
i.icon.algolia:before {
  content: "\\f36c";
}
i.icon.align.center:before {
  content: "\\f037";
}
i.icon.align.justify:before {
  content: "\\f039";
}
i.icon.align.left:before {
  content: "\\f036";
}
i.icon.align.right:before {
  content: "\\f038";
}
i.icon.amazon:before {
  content: "\\f270";
}
i.icon.amazon.pay:before {
  content: "\\f42c";
}
i.icon.ambulance:before {
  content: "\\f0f9";
}
i.icon.american.sign.language.interpreting:before {
  content: "\\f2a3";
}
i.icon.amilia:before {
  content: "\\f36d";
}
i.icon.anchor:before {
  content: "\\f13d";
}
i.icon.android:before {
  content: "\\f17b";
}
i.icon.angellist:before {
  content: "\\f209";
}
i.icon.angle.double.down:before {
  content: "\\f103";
}
i.icon.angle.double.left:before {
  content: "\\f100";
}
i.icon.angle.double.right:before {
  content: "\\f101";
}
i.icon.angle.double.up:before {
  content: "\\f102";
}
i.icon.angle.down:before {
  content: "\\f107";
}
i.icon.angle.left:before {
  content: "\\f104";
}
i.icon.angle.right:before {
  content: "\\f105";
}
i.icon.angle.up:before {
  content: "\\f106";
}
i.icon.angrycreative:before {
  content: "\\f36e";
}
i.icon.angular:before {
  content: "\\f420";
}
i.icon.app.store:before {
  content: "\\f36f";
}
i.icon.app.store.ios:before {
  content: "\\f370";
}
i.icon.apper:before {
  content: "\\f371";
}
i.icon.apple:before {
  content: "\\f179";
}
i.icon.apple.pay:before {
  content: "\\f415";
}
i.icon.archive:before {
  content: "\\f187";
}
i.icon.arrow.alternate.circle.down:before {
  content: "\\f358";
}
i.icon.arrow.alternate.circle.left:before {
  content: "\\f359";
}
i.icon.arrow.alternate.circle.right:before {
  content: "\\f35a";
}
i.icon.arrow.alternate.circle.up:before {
  content: "\\f35b";
}
i.icon.arrow.circle.down:before {
  content: "\\f0ab";
}
i.icon.arrow.circle.left:before {
  content: "\\f0a8";
}
i.icon.arrow.circle.right:before {
  content: "\\f0a9";
}
i.icon.arrow.circle.up:before {
  content: "\\f0aa";
}
i.icon.arrow.down:before {
  content: "\\f063";
}
i.icon.arrow.left:before {
  content: "\\f060";
}
i.icon.arrow.right:before {
  content: "\\f061";
}
i.icon.arrow.up:before {
  content: "\\f062";
}
i.icon.arrows.alternate:before {
  content: "\\f0b2";
}
i.icon.arrows.alternate.horizontal:before {
  content: "\\f337";
}
i.icon.arrows.alternate.vertical:before {
  content: "\\f338";
}
i.icon.assistive.listening.systems:before {
  content: "\\f2a2";
}
i.icon.asterisk:before {
  content: "\\f069";
}
i.icon.asymmetrik:before {
  content: "\\f372";
}
i.icon.at:before {
  content: "\\f1fa";
}
i.icon.audible:before {
  content: "\\f373";
}
i.icon.audio.description:before {
  content: "\\f29e";
}
i.icon.autoprefixer:before {
  content: "\\f41c";
}
i.icon.avianex:before {
  content: "\\f374";
}
i.icon.aviato:before {
  content: "\\f421";
}
i.icon.aws:before {
  content: "\\f375";
}
i.icon.backward:before {
  content: "\\f04a";
}
i.icon.balance.scale:before {
  content: "\\f24e";
}
i.icon.ban:before {
  content: "\\f05e";
}
i.icon.band.aid:before {
  content: "\\f462";
}
i.icon.bandcamp:before {
  content: "\\f2d5";
}
i.icon.barcode:before {
  content: "\\f02a";
}
i.icon.bars:before {
  content: "\\f0c9";
}
i.icon.baseball.ball:before {
  content: "\\f433";
}
i.icon.basketball.ball:before {
  content: "\\f434";
}
i.icon.bath:before {
  content: "\\f2cd";
}
i.icon.battery.empty:before {
  content: "\\f244";
}
i.icon.battery.full:before {
  content: "\\f240";
}
i.icon.battery.half:before {
  content: "\\f242";
}
i.icon.battery.quarter:before {
  content: "\\f243";
}
i.icon.battery.three.quarters:before {
  content: "\\f241";
}
i.icon.bed:before {
  content: "\\f236";
}
i.icon.beer:before {
  content: "\\f0fc";
}
i.icon.behance:before {
  content: "\\f1b4";
}
i.icon.behance.square:before {
  content: "\\f1b5";
}
i.icon.bell:before {
  content: "\\f0f3";
}
i.icon.bell.slash:before {
  content: "\\f1f6";
}
i.icon.bicycle:before {
  content: "\\f206";
}
i.icon.bimobject:before {
  content: "\\f378";
}
i.icon.binoculars:before {
  content: "\\f1e5";
}
i.icon.birthday.cake:before {
  content: "\\f1fd";
}
i.icon.bitbucket:before {
  content: "\\f171";
}
i.icon.bitcoin:before {
  content: "\\f379";
}
i.icon.bity:before {
  content: "\\f37a";
}
i.icon.black.tie:before {
  content: "\\f27e";
}
i.icon.blackberry:before {
  content: "\\f37b";
}
i.icon.blind:before {
  content: "\\f29d";
}
i.icon.blogger:before {
  content: "\\f37c";
}
i.icon.blogger.b:before {
  content: "\\f37d";
}
i.icon.bluetooth:before {
  content: "\\f293";
}
i.icon.bluetooth.b:before {
  content: "\\f294";
}
i.icon.bold:before {
  content: "\\f032";
}
i.icon.bolt:before {
  content: "\\f0e7";
}
i.icon.bomb:before {
  content: "\\f1e2";
}
i.icon.book:before {
  content: "\\f02d";
}
i.icon.bookmark:before {
  content: "\\f02e";
}
i.icon.bowling.ball:before {
  content: "\\f436";
}
i.icon.box:before {
  content: "\\f466";
}
i.icon.boxes:before {
  content: "\\f468";
}
i.icon.braille:before {
  content: "\\f2a1";
}
i.icon.briefcase:before {
  content: "\\f0b1";
}
i.icon.btc:before {
  content: "\\f15a";
}
i.icon.bug:before {
  content: "\\f188";
}
i.icon.building:before {
  content: "\\f1ad";
}
i.icon.bullhorn:before {
  content: "\\f0a1";
}
i.icon.bullseye:before {
  content: "\\f140";
}
i.icon.buromobelexperte:before {
  content: "\\f37f";
}
i.icon.bus:before {
  content: "\\f207";
}
i.icon.buysellads:before {
  content: "\\f20d";
}
i.icon.calculator:before {
  content: "\\f1ec";
}
i.icon.calendar:before {
  content: "\\f133";
}
i.icon.calendar.alternate:before {
  content: "\\f073";
}
i.icon.calendar.check:before {
  content: "\\f274";
}
i.icon.calendar.minus:before {
  content: "\\f272";
}
i.icon.calendar.plus:before {
  content: "\\f271";
}
i.icon.calendar.times:before {
  content: "\\f273";
}
i.icon.camera:before {
  content: "\\f030";
}
i.icon.camera.retro:before {
  content: "\\f083";
}
i.icon.car:before {
  content: "\\f1b9";
}
i.icon.caret.down:before {
  content: "\\f0d7";
}
i.icon.caret.left:before {
  content: "\\f0d9";
}
i.icon.caret.right:before {
  content: "\\f0da";
}
i.icon.caret.square.down:before {
  content: "\\f150";
}
i.icon.caret.square.left:before {
  content: "\\f191";
}
i.icon.caret.square.right:before {
  content: "\\f152";
}
i.icon.caret.square.up:before {
  content: "\\f151";
}
i.icon.caret.up:before {
  content: "\\f0d8";
}
i.icon.cart.arrow.down:before {
  content: "\\f218";
}
i.icon.cart.plus:before {
  content: "\\f217";
}
i.icon.cc.amazon.pay:before {
  content: "\\f42d";
}
i.icon.cc.amex:before {
  content: "\\f1f3";
}
i.icon.cc.apple.pay:before {
  content: "\\f416";
}
i.icon.cc.diners.club:before {
  content: "\\f24c";
}
i.icon.cc.discover:before {
  content: "\\f1f2";
}
i.icon.cc.jcb:before {
  content: "\\f24b";
}
i.icon.cc.mastercard:before {
  content: "\\f1f1";
}
i.icon.cc.paypal:before {
  content: "\\f1f4";
}
i.icon.cc.stripe:before {
  content: "\\f1f5";
}
i.icon.cc.visa:before {
  content: "\\f1f0";
}
i.icon.centercode:before {
  content: "\\f380";
}
i.icon.certificate:before {
  content: "\\f0a3";
}
i.icon.chart.area:before {
  content: "\\f1fe";
}
i.icon.chart.bar:before {
  content: "\\f080";
}
i.icon.chart.line:before {
  content: "\\f201";
}
i.icon.chart.pie:before {
  content: "\\f200";
}
i.icon.check:before {
  content: "\\f00c";
}
i.icon.check.circle:before {
  content: "\\f058";
}
i.icon.check.square:before {
  content: "\\f14a";
}
i.icon.chess:before {
  content: "\\f439";
}
i.icon.chess.bishop:before {
  content: "\\f43a";
}
i.icon.chess.board:before {
  content: "\\f43c";
}
i.icon.chess.king:before {
  content: "\\f43f";
}
i.icon.chess.knight:before {
  content: "\\f441";
}
i.icon.chess.pawn:before {
  content: "\\f443";
}
i.icon.chess.queen:before {
  content: "\\f445";
}
i.icon.chess.rook:before {
  content: "\\f447";
}
i.icon.chevron.circle.down:before {
  content: "\\f13a";
}
i.icon.chevron.circle.left:before {
  content: "\\f137";
}
i.icon.chevron.circle.right:before {
  content: "\\f138";
}
i.icon.chevron.circle.up:before {
  content: "\\f139";
}
i.icon.chevron.down:before {
  content: "\\f078";
}
i.icon.chevron.left:before {
  content: "\\f053";
}
i.icon.chevron.right:before {
  content: "\\f054";
}
i.icon.chevron.up:before {
  content: "\\f077";
}
i.icon.child:before {
  content: "\\f1ae";
}
i.icon.chrome:before {
  content: "\\f268";
}
i.icon.circle:before {
  content: "\\f111";
}
i.icon.circle.notch:before {
  content: "\\f1ce";
}
i.icon.clipboard:before {
  content: "\\f328";
}
i.icon.clipboard.check:before {
  content: "\\f46c";
}
i.icon.clipboard.list:before {
  content: "\\f46d";
}
i.icon.clock:before {
  content: "\\f017";
}
i.icon.clone:before {
  content: "\\f24d";
}
i.icon.closed.captioning:before {
  content: "\\f20a";
}
i.icon.cloud:before {
  content: "\\f0c2";
}
i.icon.cloudscale:before {
  content: "\\f383";
}
i.icon.cloudsmith:before {
  content: "\\f384";
}
i.icon.cloudversify:before {
  content: "\\f385";
}
i.icon.code:before {
  content: "\\f121";
}
i.icon.code.branch:before {
  content: "\\f126";
}
i.icon.codepen:before {
  content: "\\f1cb";
}
i.icon.codiepie:before {
  content: "\\f284";
}
i.icon.coffee:before {
  content: "\\f0f4";
}
i.icon.cog:before {
  content: "\\f013";
}
i.icon.cogs:before {
  content: "\\f085";
}
i.icon.columns:before {
  content: "\\f0db";
}
i.icon.comment:before {
  content: "\\f075";
}
i.icon.comment.alternate:before {
  content: "\\f27a";
}
i.icon.comments:before {
  content: "\\f086";
}
i.icon.compass:before {
  content: "\\f14e";
}
i.icon.compress:before {
  content: "\\f066";
}
i.icon.connectdevelop:before {
  content: "\\f20e";
}
i.icon.contao:before {
  content: "\\f26d";
}
i.icon.copy:before {
  content: "\\f0c5";
}
i.icon.copyright:before {
  content: "\\f1f9";
}
i.icon.cpanel:before {
  content: "\\f388";
}
i.icon.creative.commons:before {
  content: "\\f25e";
}
i.icon.credit.card:before {
  content: "\\f09d";
}
i.icon.crop:before {
  content: "\\f125";
}
i.icon.crosshairs:before {
  content: "\\f05b";
}
i.icon.css3:before {
  content: "\\f13c";
}
i.icon.css3.alternate:before {
  content: "\\f38b";
}
i.icon.cube:before {
  content: "\\f1b2";
}
i.icon.cubes:before {
  content: "\\f1b3";
}
i.icon.cut:before {
  content: "\\f0c4";
}
i.icon.cuttlefish:before {
  content: "\\f38c";
}
i.icon.d.and.d:before {
  content: "\\f38d";
}
i.icon.dashcube:before {
  content: "\\f210";
}
i.icon.database:before {
  content: "\\f1c0";
}
i.icon.deaf:before {
  content: "\\f2a4";
}
i.icon.delicious:before {
  content: "\\f1a5";
}
i.icon.deploydog:before {
  content: "\\f38e";
}
i.icon.deskpro:before {
  content: "\\f38f";
}
i.icon.desktop:before {
  content: "\\f108";
}
i.icon.deviantart:before {
  content: "\\f1bd";
}
i.icon.digg:before {
  content: "\\f1a6";
}
i.icon.digital.ocean:before {
  content: "\\f391";
}
i.icon.discord:before {
  content: "\\f392";
}
i.icon.discourse:before {
  content: "\\f393";
}
i.icon.dna:before {
  content: "\\f471";
}
i.icon.dochub:before {
  content: "\\f394";
}
i.icon.docker:before {
  content: "\\f395";
}
i.icon.dollar.sign:before {
  content: "\\f155";
}
i.icon.dolly:before {
  content: "\\f472";
}
i.icon.dolly.flatbed:before {
  content: "\\f474";
}
i.icon.dot.circle:before {
  content: "\\f192";
}
i.icon.download:before {
  content: "\\f019";
}
i.icon.draft2digital:before {
  content: "\\f396";
}
i.icon.dribbble:before {
  content: "\\f17d";
}
i.icon.dribbble.square:before {
  content: "\\f397";
}
i.icon.dropbox:before {
  content: "\\f16b";
}
i.icon.drupal:before {
  content: "\\f1a9";
}
i.icon.dyalog:before {
  content: "\\f399";
}
i.icon.earlybirds:before {
  content: "\\f39a";
}
i.icon.edge:before {
  content: "\\f282";
}
i.icon.edit:before {
  content: "\\f044";
}
i.icon.eject:before {
  content: "\\f052";
}
i.icon.elementor:before {
  content: "\\f430";
}
i.icon.ellipsis.horizontal:before {
  content: "\\f141";
}
i.icon.ellipsis.vertical:before {
  content: "\\f142";
}
i.icon.ember:before {
  content: "\\f423";
}
i.icon.empire:before {
  content: "\\f1d1";
}
i.icon.envelope:before {
  content: "\\f0e0";
}
i.icon.envelope.open:before {
  content: "\\f2b6";
}
i.icon.envelope.square:before {
  content: "\\f199";
}
i.icon.envira:before {
  content: "\\f299";
}
i.icon.eraser:before {
  content: "\\f12d";
}
i.icon.erlang:before {
  content: "\\f39d";
}
i.icon.ethereum:before {
  content: "\\f42e";
}
i.icon.etsy:before {
  content: "\\f2d7";
}
i.icon.euro.sign:before {
  content: "\\f153";
}
i.icon.exchange.alternate:before {
  content: "\\f362";
}
i.icon.exclamation:before {
  content: "\\f12a";
}
i.icon.exclamation.circle:before {
  content: "\\f06a";
}
i.icon.exclamation.triangle:before {
  content: "\\f071";
}
i.icon.expand:before {
  content: "\\f065";
}
i.icon.expand.arrows.alternate:before {
  content: "\\f31e";
}
i.icon.expeditedssl:before {
  content: "\\f23e";
}
i.icon.external.alternate:before {
  content: "\\f35d";
}
i.icon.external.square.alternate:before {
  content: "\\f360";
}
i.icon.eye:before {
  content: "\\f06e";
}
i.icon.eye.dropper:before {
  content: "\\f1fb";
}
i.icon.eye.slash:before {
  content: "\\f070";
}
i.icon.facebook:before {
  content: "\\f09a";
}
i.icon.facebook.f:before {
  content: "\\f39e";
}
i.icon.facebook.messenger:before {
  content: "\\f39f";
}
i.icon.facebook.square:before {
  content: "\\f082";
}
i.icon.fast.backward:before {
  content: "\\f049";
}
i.icon.fast.forward:before {
  content: "\\f050";
}
i.icon.fax:before {
  content: "\\f1ac";
}
i.icon.female:before {
  content: "\\f182";
}
i.icon.fighter.jet:before {
  content: "\\f0fb";
}
i.icon.file:before {
  content: "\\f15b";
}
i.icon.file.alternate:before {
  content: "\\f15c";
}
i.icon.file.archive:before {
  content: "\\f1c6";
}
i.icon.file.audio:before {
  content: "\\f1c7";
}
i.icon.file.code:before {
  content: "\\f1c9";
}
i.icon.file.excel:before {
  content: "\\f1c3";
}
i.icon.file.image:before {
  content: "\\f1c5";
}
i.icon.file.pdf:before {
  content: "\\f1c1";
}
i.icon.file.powerpoint:before {
  content: "\\f1c4";
}
i.icon.file.video:before {
  content: "\\f1c8";
}
i.icon.file.word:before {
  content: "\\f1c2";
}
i.icon.film:before {
  content: "\\f008";
}
i.icon.filter:before {
  content: "\\f0b0";
}
i.icon.fire:before {
  content: "\\f06d";
}
i.icon.fire.extinguisher:before {
  content: "\\f134";
}
i.icon.firefox:before {
  content: "\\f269";
}
i.icon.first.aid:before {
  content: "\\f479";
}
i.icon.first.order:before {
  content: "\\f2b0";
}
i.icon.firstdraft:before {
  content: "\\f3a1";
}
i.icon.flag:before {
  content: "\\f024";
}
i.icon.flag.checkered:before {
  content: "\\f11e";
}
i.icon.flask:before {
  content: "\\f0c3";
}
i.icon.flickr:before {
  content: "\\f16e";
}
i.icon.flipboard:before {
  content: "\\f44d";
}
i.icon.fly:before {
  content: "\\f417";
}
i.icon.folder:before {
  content: "\\f07b";
}
i.icon.folder.open:before {
  content: "\\f07c";
}
i.icon.font:before {
  content: "\\f031";
}
i.icon.font.awesome:before {
  content: "\\f2b4";
}
i.icon.font.awesome.alternate:before {
  content: "\\f35c";
}
i.icon.font.awesome.flag:before {
  content: "\\f425";
}
i.icon.fonticons:before {
  content: "\\f280";
}
i.icon.fonticons.fi:before {
  content: "\\f3a2";
}
i.icon.football.ball:before {
  content: "\\f44e";
}
i.icon.fort.awesome:before {
  content: "\\f286";
}
i.icon.fort.awesome.alternate:before {
  content: "\\f3a3";
}
i.icon.forumbee:before {
  content: "\\f211";
}
i.icon.forward:before {
  content: "\\f04e";
}
i.icon.foursquare:before {
  content: "\\f180";
}
i.icon.free.code.camp:before {
  content: "\\f2c5";
}
i.icon.freebsd:before {
  content: "\\f3a4";
}
i.icon.frown:before {
  content: "\\f119";
}
i.icon.futbol:before {
  content: "\\f1e3";
}
i.icon.gamepad:before {
  content: "\\f11b";
}
i.icon.gavel:before {
  content: "\\f0e3";
}
i.icon.gem:before {
  content: "\\f3a5";
}
i.icon.genderless:before {
  content: "\\f22d";
}
i.icon.get.pocket:before {
  content: "\\f265";
}
i.icon.gg:before {
  content: "\\f260";
}
i.icon.gg.circle:before {
  content: "\\f261";
}
i.icon.gift:before {
  content: "\\f06b";
}
i.icon.git:before {
  content: "\\f1d3";
}
i.icon.git.square:before {
  content: "\\f1d2";
}
i.icon.github:before {
  content: "\\f09b";
}
i.icon.github.alternate:before {
  content: "\\f113";
}
i.icon.github.square:before {
  content: "\\f092";
}
i.icon.gitkraken:before {
  content: "\\f3a6";
}
i.icon.gitlab:before {
  content: "\\f296";
}
i.icon.gitter:before {
  content: "\\f426";
}
i.icon.glass.martini:before {
  content: "\\f000";
}
i.icon.glide:before {
  content: "\\f2a5";
}
i.icon.glide.g:before {
  content: "\\f2a6";
}
i.icon.globe:before {
  content: "\\f0ac";
}
i.icon.gofore:before {
  content: "\\f3a7";
}
i.icon.golf.ball:before {
  content: "\\f450";
}
i.icon.goodreads:before {
  content: "\\f3a8";
}
i.icon.goodreads.g:before {
  content: "\\f3a9";
}
i.icon.google:before {
  content: "\\f1a0";
}
i.icon.google.drive:before {
  content: "\\f3aa";
}
i.icon.google.play:before {
  content: "\\f3ab";
}
i.icon.google.plus:before {
  content: "\\f2b3";
}
i.icon.google.plus.g:before {
  content: "\\f0d5";
}
i.icon.google.plus.square:before {
  content: "\\f0d4";
}
i.icon.google.wallet:before {
  content: "\\f1ee";
}
i.icon.graduation.cap:before {
  content: "\\f19d";
}
i.icon.gratipay:before {
  content: "\\f184";
}
i.icon.grav:before {
  content: "\\f2d6";
}
i.icon.gripfire:before {
  content: "\\f3ac";
}
i.icon.grunt:before {
  content: "\\f3ad";
}
i.icon.gulp:before {
  content: "\\f3ae";
}
i.icon.h.square:before {
  content: "\\f0fd";
}
i.icon.hacker.news:before {
  content: "\\f1d4";
}
i.icon.hacker.news.square:before {
  content: "\\f3af";
}
i.icon.hand.lizard:before {
  content: "\\f258";
}
i.icon.hand.paper:before {
  content: "\\f256";
}
i.icon.hand.peace:before {
  content: "\\f25b";
}
i.icon.hand.point.down:before {
  content: "\\f0a7";
}
i.icon.hand.point.left:before {
  content: "\\f0a5";
}
i.icon.hand.point.right:before {
  content: "\\f0a4";
}
i.icon.hand.point.up:before {
  content: "\\f0a6";
}
i.icon.hand.pointer:before {
  content: "\\f25a";
}
i.icon.hand.rock:before {
  content: "\\f255";
}
i.icon.hand.scissors:before {
  content: "\\f257";
}
i.icon.hand.spock:before {
  content: "\\f259";
}
i.icon.handshake:before {
  content: "\\f2b5";
}
i.icon.hashtag:before {
  content: "\\f292";
}
i.icon.hdd:before {
  content: "\\f0a0";
}
i.icon.heading:before {
  content: "\\f1dc";
}
i.icon.headphones:before {
  content: "\\f025";
}
i.icon.heart:before {
  content: "\\f004";
}
i.icon.heartbeat:before {
  content: "\\f21e";
}
i.icon.hips:before {
  content: "\\f452";
}
i.icon.hire.a.helper:before {
  content: "\\f3b0";
}
i.icon.history:before {
  content: "\\f1da";
}
i.icon.hockey.puck:before {
  content: "\\f453";
}
i.icon.home:before {
  content: "\\f015";
}
i.icon.hooli:before {
  content: "\\f427";
}
i.icon.hospital:before {
  content: "\\f0f8";
}
i.icon.hospital.symbol:before {
  content: "\\f47e";
}
i.icon.hotjar:before {
  content: "\\f3b1";
}
i.icon.hourglass:before {
  content: "\\f254";
}
i.icon.hourglass.end:before {
  content: "\\f253";
}
i.icon.hourglass.half:before {
  content: "\\f252";
}
i.icon.hourglass.start:before {
  content: "\\f251";
}
i.icon.houzz:before {
  content: "\\f27c";
}
i.icon.html5:before {
  content: "\\f13b";
}
i.icon.hubspot:before {
  content: "\\f3b2";
}
i.icon.i.cursor:before {
  content: "\\f246";
}
i.icon.id.badge:before {
  content: "\\f2c1";
}
i.icon.id.card:before {
  content: "\\f2c2";
}
i.icon.image:before {
  content: "\\f03e";
}
i.icon.images:before {
  content: "\\f302";
}
i.icon.imdb:before {
  content: "\\f2d8";
}
i.icon.inbox:before {
  content: "\\f01c";
}
i.icon.indent:before {
  content: "\\f03c";
}
i.icon.industry:before {
  content: "\\f275";
}
i.icon.info:before {
  content: "\\f129";
}
i.icon.info.circle:before {
  content: "\\f05a";
}
i.icon.instagram:before {
  content: "\\f16d";
}
i.icon.internet.explorer:before {
  content: "\\f26b";
}
i.icon.ioxhost:before {
  content: "\\f208";
}
i.icon.italic:before {
  content: "\\f033";
}
i.icon.itunes:before {
  content: "\\f3b4";
}
i.icon.itunes.note:before {
  content: "\\f3b5";
}
i.icon.jenkins:before {
  content: "\\f3b6";
}
i.icon.joget:before {
  content: "\\f3b7";
}
i.icon.joomla:before {
  content: "\\f1aa";
}
i.icon.js:before {
  content: "\\f3b8";
}
i.icon.js.square:before {
  content: "\\f3b9";
}
i.icon.jsfiddle:before {
  content: "\\f1cc";
}
i.icon.key:before {
  content: "\\f084";
}
i.icon.keyboard:before {
  content: "\\f11c";
}
i.icon.keycdn:before {
  content: "\\f3ba";
}
i.icon.kickstarter:before {
  content: "\\f3bb";
}
i.icon.kickstarter.k:before {
  content: "\\f3bc";
}
i.icon.korvue:before {
  content: "\\f42f";
}
i.icon.language:before {
  content: "\\f1ab";
}
i.icon.laptop:before {
  content: "\\f109";
}
i.icon.laravel:before {
  content: "\\f3bd";
}
i.icon.lastfm:before {
  content: "\\f202";
}
i.icon.lastfm.square:before {
  content: "\\f203";
}
i.icon.leaf:before {
  content: "\\f06c";
}
i.icon.leanpub:before {
  content: "\\f212";
}
i.icon.lemon:before {
  content: "\\f094";
}
i.icon.less:before {
  content: "\\f41d";
}
i.icon.level.down.alternate:before {
  content: "\\f3be";
}
i.icon.level.up.alternate:before {
  content: "\\f3bf";
}
i.icon.life.ring:before {
  content: "\\f1cd";
}
i.icon.lightbulb:before {
  content: "\\f0eb";
}
i.icon.linechat:before {
  content: "\\f3c0";
}
i.icon.linkify:before {
  content: "\\f0c1";
}
i.icon.linkedin:before {
  content: "\\f08c";
}
i.icon.linkedin.alt:before {
  content: "\\f0e1";
}
i.icon.linode:before {
  content: "\\f2b8";
}
i.icon.linux:before {
  content: "\\f17c";
}
i.icon.lira.sign:before {
  content: "\\f195";
}
i.icon.list:before {
  content: "\\f03a";
}
i.icon.list.alternate:before {
  content: "\\f022";
}
i.icon.list.ol:before {
  content: "\\f0cb";
}
i.icon.list.ul:before {
  content: "\\f0ca";
}
i.icon.location.arrow:before {
  content: "\\f124";
}
i.icon.lock:before {
  content: "\\f023";
}
i.icon.lock.open:before {
  content: "\\f3c1";
}
i.icon.long.arrow.alternate.down:before {
  content: "\\f309";
}
i.icon.long.arrow.alternate.left:before {
  content: "\\f30a";
}
i.icon.long.arrow.alternate.right:before {
  content: "\\f30b";
}
i.icon.long.arrow.alternate.up:before {
  content: "\\f30c";
}
i.icon.low.vision:before {
  content: "\\f2a8";
}
i.icon.lyft:before {
  content: "\\f3c3";
}
i.icon.magento:before {
  content: "\\f3c4";
}
i.icon.magic:before {
  content: "\\f0d0";
}
i.icon.magnet:before {
  content: "\\f076";
}
i.icon.male:before {
  content: "\\f183";
}
i.icon.map:before {
  content: "\\f279";
}
i.icon.map.marker:before {
  content: "\\f041";
}
i.icon.map.marker.alternate:before {
  content: "\\f3c5";
}
i.icon.map.pin:before {
  content: "\\f276";
}
i.icon.map.signs:before {
  content: "\\f277";
}
i.icon.mars:before {
  content: "\\f222";
}
i.icon.mars.double:before {
  content: "\\f227";
}
i.icon.mars.stroke:before {
  content: "\\f229";
}
i.icon.mars.stroke.horizontal:before {
  content: "\\f22b";
}
i.icon.mars.stroke.vertical:before {
  content: "\\f22a";
}
i.icon.maxcdn:before {
  content: "\\f136";
}
i.icon.medapps:before {
  content: "\\f3c6";
}
i.icon.medium:before {
  content: "\\f23a";
}
i.icon.medium.m:before {
  content: "\\f3c7";
}
i.icon.medkit:before {
  content: "\\f0fa";
}
i.icon.medrt:before {
  content: "\\f3c8";
}
i.icon.meetup:before {
  content: "\\f2e0";
}
i.icon.meh:before {
  content: "\\f11a";
}
i.icon.mercury:before {
  content: "\\f223";
}
i.icon.microchip:before {
  content: "\\f2db";
}
i.icon.microphone:before {
  content: "\\f130";
}
i.icon.microphone.slash:before {
  content: "\\f131";
}
i.icon.microsoft:before {
  content: "\\f3ca";
}
i.icon.minus:before {
  content: "\\f068";
}
i.icon.minus.circle:before {
  content: "\\f056";
}
i.icon.minus.square:before {
  content: "\\f146";
}
i.icon.mix:before {
  content: "\\f3cb";
}
i.icon.mixcloud:before {
  content: "\\f289";
}
i.icon.mizuni:before {
  content: "\\f3cc";
}
i.icon.mobile:before {
  content: "\\f10b";
}
i.icon.mobile.alternate:before {
  content: "\\f3cd";
}
i.icon.modx:before {
  content: "\\f285";
}
i.icon.monero:before {
  content: "\\f3d0";
}
i.icon.money.bill.alternate:before {
  content: "\\f3d1";
}
i.icon.moon:before {
  content: "\\f186";
}
i.icon.motorcycle:before {
  content: "\\f21c";
}
i.icon.mouse.pointer:before {
  content: "\\f245";
}
i.icon.music:before {
  content: "\\f001";
}
i.icon.napster:before {
  content: "\\f3d2";
}
i.icon.neuter:before {
  content: "\\f22c";
}
i.icon.newspaper:before {
  content: "\\f1ea";
}
i.icon.nintendo.switch:before {
  content: "\\f418";
}
i.icon.node:before {
  content: "\\f419";
}
i.icon.node.js:before {
  content: "\\f3d3";
}
i.icon.npm:before {
  content: "\\f3d4";
}
i.icon.ns8:before {
  content: "\\f3d5";
}
i.icon.nutritionix:before {
  content: "\\f3d6";
}
i.icon.object.group:before {
  content: "\\f247";
}
i.icon.object.ungroup:before {
  content: "\\f248";
}
i.icon.odnoklassniki:before {
  content: "\\f263";
}
i.icon.odnoklassniki.square:before {
  content: "\\f264";
}
i.icon.opencart:before {
  content: "\\f23d";
}
i.icon.openid:before {
  content: "\\f19b";
}
i.icon.opera:before {
  content: "\\f26a";
}
i.icon.optin.monster:before {
  content: "\\f23c";
}
i.icon.osi:before {
  content: "\\f41a";
}
i.icon.outdent:before {
  content: "\\f03b";
}
i.icon.page4:before {
  content: "\\f3d7";
}
i.icon.pagelines:before {
  content: "\\f18c";
}
i.icon.paint.brush:before {
  content: "\\f1fc";
}
i.icon.palfed:before {
  content: "\\f3d8";
}
i.icon.pallet:before {
  content: "\\f482";
}
i.icon.paper.plane:before {
  content: "\\f1d8";
}
i.icon.paperclip:before {
  content: "\\f0c6";
}
i.icon.paragraph:before {
  content: "\\f1dd";
}
i.icon.paste:before {
  content: "\\f0ea";
}
i.icon.patreon:before {
  content: "\\f3d9";
}
i.icon.pause:before {
  content: "\\f04c";
}
i.icon.pause.circle:before {
  content: "\\f28b";
}
i.icon.paw:before {
  content: "\\f1b0";
}
i.icon.paypal:before {
  content: "\\f1ed";
}
i.icon.pen.square:before {
  content: "\\f14b";
}
i.icon.pencil.alternate:before {
  content: "\\f303";
}
i.icon.percent:before {
  content: "\\f295";
}
i.icon.periscope:before {
  content: "\\f3da";
}
i.icon.phabricator:before {
  content: "\\f3db";
}
i.icon.phoenix.framework:before {
  content: "\\f3dc";
}
i.icon.phone:before {
  content: "\\f095";
}
i.icon.phone.square:before {
  content: "\\f098";
}
i.icon.phone.volume:before {
  content: "\\f2a0";
}
i.icon.php:before {
  content: "\\f457";
}
i.icon.pied.piper:before {
  content: "\\f2ae";
}
i.icon.pied.piper.alternate:before {
  content: "\\f1a8";
}
i.icon.pied.piper.pp:before {
  content: "\\f1a7";
}
i.icon.pills:before {
  content: "\\f484";
}
i.icon.pinterest:before {
  content: "\\f0d2";
}
i.icon.pinterest.p:before {
  content: "\\f231";
}
i.icon.pinterest.square:before {
  content: "\\f0d3";
}
i.icon.plane:before {
  content: "\\f072";
}
i.icon.play:before {
  content: "\\f04b";
}
i.icon.play.circle:before {
  content: "\\f144";
}
i.icon.playstation:before {
  content: "\\f3df";
}
i.icon.plug:before {
  content: "\\f1e6";
}
i.icon.plus:before {
  content: "\\f067";
}
i.icon.plus.circle:before {
  content: "\\f055";
}
i.icon.plus.square:before {
  content: "\\f0fe";
}
i.icon.podcast:before {
  content: "\\f2ce";
}
i.icon.pound.sign:before {
  content: "\\f154";
}
i.icon.power.off:before {
  content: "\\f011";
}
i.icon.print:before {
  content: "\\f02f";
}
i.icon.product.hunt:before {
  content: "\\f288";
}
i.icon.pushed:before {
  content: "\\f3e1";
}
i.icon.puzzle.piece:before {
  content: "\\f12e";
}
i.icon.python:before {
  content: "\\f3e2";
}
i.icon.qq:before {
  content: "\\f1d6";
}
i.icon.qrcode:before {
  content: "\\f029";
}
i.icon.question:before {
  content: "\\f128";
}
i.icon.question.circle:before {
  content: "\\f059";
}
i.icon.quidditch:before {
  content: "\\f458";
}
i.icon.quinscape:before {
  content: "\\f459";
}
i.icon.quora:before {
  content: "\\f2c4";
}
i.icon.quote.left:before {
  content: "\\f10d";
}
i.icon.quote.right:before {
  content: "\\f10e";
}
i.icon.random:before {
  content: "\\f074";
}
i.icon.ravelry:before {
  content: "\\f2d9";
}
i.icon.react:before {
  content: "\\f41b";
}
i.icon.rebel:before {
  content: "\\f1d0";
}
i.icon.recycle:before {
  content: "\\f1b8";
}
i.icon.redriver:before {
  content: "\\f3e3";
}
i.icon.reddit:before {
  content: "\\f1a1";
}
i.icon.reddit.alien:before {
  content: "\\f281";
}
i.icon.reddit.square:before {
  content: "\\f1a2";
}
i.icon.redo:before {
  content: "\\f01e";
}
i.icon.redo.alternate:before {
  content: "\\f2f9";
}
i.icon.registered:before {
  content: "\\f25d";
}
i.icon.rendact:before {
  content: "\\f3e4";
}
i.icon.renren:before {
  content: "\\f18b";
}
i.icon.reply:before {
  content: "\\f3e5";
}
i.icon.reply.all:before {
  content: "\\f122";
}
i.icon.replyd:before {
  content: "\\f3e6";
}
i.icon.resolving:before {
  content: "\\f3e7";
}
i.icon.retweet:before {
  content: "\\f079";
}
i.icon.road:before {
  content: "\\f018";
}
i.icon.rocket:before {
  content: "\\f135";
}
i.icon.rocketchat:before {
  content: "\\f3e8";
}
i.icon.rockrms:before {
  content: "\\f3e9";
}
i.icon.rss:before {
  content: "\\f09e";
}
i.icon.rss.square:before {
  content: "\\f143";
}
i.icon.ruble.sign:before {
  content: "\\f158";
}
i.icon.rupee.sign:before {
  content: "\\f156";
}
i.icon.safari:before {
  content: "\\f267";
}
i.icon.sass:before {
  content: "\\f41e";
}
i.icon.save:before {
  content: "\\f0c7";
}
i.icon.schlix:before {
  content: "\\f3ea";
}
i.icon.scribd:before {
  content: "\\f28a";
}
i.icon.search:before {
  content: "\\f002";
}
i.icon.search.minus:before {
  content: "\\f010";
}
i.icon.search.plus:before {
  content: "\\f00e";
}
i.icon.searchengin:before {
  content: "\\f3eb";
}
i.icon.sellcast:before {
  content: "\\f2da";
}
i.icon.sellsy:before {
  content: "\\f213";
}
i.icon.server:before {
  content: "\\f233";
}
i.icon.servicestack:before {
  content: "\\f3ec";
}
i.icon.share:before {
  content: "\\f064";
}
i.icon.share.alternate:before {
  content: "\\f1e0";
}
i.icon.share.alternate.square:before {
  content: "\\f1e1";
}
i.icon.share.square:before {
  content: "\\f14d";
}
i.icon.shekel.sign:before {
  content: "\\f20b";
}
i.icon.shield.alternate:before {
  content: "\\f3ed";
}
i.icon.ship:before {
  content: "\\f21a";
}
i.icon.shipping.fast:before {
  content: "\\f48b";
}
i.icon.shirtsinbulk:before {
  content: "\\f214";
}
i.icon.shopping.bag:before {
  content: "\\f290";
}
i.icon.shopping.basket:before {
  content: "\\f291";
}
i.icon.shopping.cart:before {
  content: "\\f07a";
}
i.icon.shower:before {
  content: "\\f2cc";
}
i.icon.sign.language:before {
  content: "\\f2a7";
}
i.icon.signal:before {
  content: "\\f012";
}
i.icon.simplybuilt:before {
  content: "\\f215";
}
i.icon.sistrix:before {
  content: "\\f3ee";
}
i.icon.sitemap:before {
  content: "\\f0e8";
}
i.icon.skyatlas:before {
  content: "\\f216";
}
i.icon.skype:before {
  content: "\\f17e";
}
i.icon.slack:before {
  content: "\\f198";
}
i.icon.slack.hash:before {
  content: "\\f3ef";
}
i.icon.sliders.horizontal:before {
  content: "\\f1de";
}
i.icon.slideshare:before {
  content: "\\f1e7";
}
i.icon.smile:before {
  content: "\\f118";
}
i.icon.snapchat:before {
  content: "\\f2ab";
}
i.icon.snapchat.ghost:before {
  content: "\\f2ac";
}
i.icon.snapchat.square:before {
  content: "\\f2ad";
}
i.icon.snowflake:before {
  content: "\\f2dc";
}
i.icon.sort:before {
  content: "\\f0dc";
}
i.icon.sort.alphabet.down:before {
  content: "\\f15d";
}
i.icon.sort.alphabet.up:before {
  content: "\\f15e";
}
i.icon.sort.amount.down:before {
  content: "\\f160";
}
i.icon.sort.amount.up:before {
  content: "\\f161";
}
i.icon.sort.down:before {
  content: "\\f0dd";
}
i.icon.sort.numeric.down:before {
  content: "\\f162";
}
i.icon.sort.numeric.up:before {
  content: "\\f163";
}
i.icon.sort.up:before {
  content: "\\f0de";
}
i.icon.soundcloud:before {
  content: "\\f1be";
}
i.icon.space.shuttle:before {
  content: "\\f197";
}
i.icon.speakap:before {
  content: "\\f3f3";
}
i.icon.spinner:before {
  content: "\\f110";
}
i.icon.spotify:before {
  content: "\\f1bc";
}
i.icon.square:before {
  content: "\\f0c8";
}
i.icon.square.full:before {
  content: "\\f45c";
}
i.icon.stack.exchange:before {
  content: "\\f18d";
}
i.icon.stack.overflow:before {
  content: "\\f16c";
}
i.icon.star:before {
  content: "\\f005";
}
i.icon.star.half:before {
  content: "\\f089";
}
i.icon.staylinked:before {
  content: "\\f3f5";
}
i.icon.steam:before {
  content: "\\f1b6";
}
i.icon.steam.square:before {
  content: "\\f1b7";
}
i.icon.steam.symbol:before {
  content: "\\f3f6";
}
i.icon.step.backward:before {
  content: "\\f048";
}
i.icon.step.forward:before {
  content: "\\f051";
}
i.icon.stethoscope:before {
  content: "\\f0f1";
}
i.icon.sticker.mule:before {
  content: "\\f3f7";
}
i.icon.sticky.note:before {
  content: "\\f249";
}
i.icon.stop:before {
  content: "\\f04d";
}
i.icon.stop.circle:before {
  content: "\\f28d";
}
i.icon.stopwatch:before {
  content: "\\f2f2";
}
i.icon.strava:before {
  content: "\\f428";
}
i.icon.street.view:before {
  content: "\\f21d";
}
i.icon.strikethrough:before {
  content: "\\f0cc";
}
i.icon.stripe:before {
  content: "\\f429";
}
i.icon.stripe.s:before {
  content: "\\f42a";
}
i.icon.studiovinari:before {
  content: "\\f3f8";
}
i.icon.stumbleupon:before {
  content: "\\f1a4";
}
i.icon.stumbleupon.circle:before {
  content: "\\f1a3";
}
i.icon.subscript:before {
  content: "\\f12c";
}
i.icon.subway:before {
  content: "\\f239";
}
i.icon.suitcase:before {
  content: "\\f0f2";
}
i.icon.sun:before {
  content: "\\f185";
}
i.icon.superpowers:before {
  content: "\\f2dd";
}
i.icon.superscript:before {
  content: "\\f12b";
}
i.icon.supple:before {
  content: "\\f3f9";
}
i.icon.sync:before {
  content: "\\f021";
}
i.icon.sync.alternate:before {
  content: "\\f2f1";
}
i.icon.syringe:before {
  content: "\\f48e";
}
i.icon.table:before {
  content: "\\f0ce";
}
i.icon.table.tennis:before {
  content: "\\f45d";
}
i.icon.tablet:before {
  content: "\\f10a";
}
i.icon.tablet.alternate:before {
  content: "\\f3fa";
}
i.icon.tachometer.alternate:before {
  content: "\\f3fd";
}
i.icon.tag:before {
  content: "\\f02b";
}
i.icon.tags:before {
  content: "\\f02c";
}
i.icon.tasks:before {
  content: "\\f0ae";
}
i.icon.taxi:before {
  content: "\\f1ba";
}
i.icon.telegram:before {
  content: "\\f2c6";
}
i.icon.telegram.plane:before {
  content: "\\f3fe";
}
i.icon.tencent.weibo:before {
  content: "\\f1d5";
}
i.icon.terminal:before {
  content: "\\f120";
}
i.icon.text.height:before {
  content: "\\f034";
}
i.icon.text.width:before {
  content: "\\f035";
}
i.icon.th:before {
  content: "\\f00a";
}
i.icon.th.large:before {
  content: "\\f009";
}
i.icon.th.list:before {
  content: "\\f00b";
}
i.icon.themeisle:before {
  content: "\\f2b2";
}
i.icon.thermometer:before {
  content: "\\f491";
}
i.icon.thermometer.empty:before {
  content: "\\f2cb";
}
i.icon.thermometer.full:before {
  content: "\\f2c7";
}
i.icon.thermometer.half:before {
  content: "\\f2c9";
}
i.icon.thermometer.quarter:before {
  content: "\\f2ca";
}
i.icon.thermometer.three.quarters:before {
  content: "\\f2c8";
}
i.icon.thumbs.down:before {
  content: "\\f165";
}
i.icon.thumbs.up:before {
  content: "\\f164";
}
i.icon.thumbtack:before {
  content: "\\f08d";
}
i.icon.ticket.alternate:before {
  content: "\\f3ff";
}
i.icon.times:before {
  content: "\\f00d";
}
i.icon.times.circle:before {
  content: "\\f057";
}
i.icon.tint:before {
  content: "\\f043";
}
i.icon.toggle.off:before {
  content: "\\f204";
}
i.icon.toggle.on:before {
  content: "\\f205";
}
i.icon.trademark:before {
  content: "\\f25c";
}
i.icon.train:before {
  content: "\\f238";
}
i.icon.transgender:before {
  content: "\\f224";
}
i.icon.transgender.alternate:before {
  content: "\\f225";
}
i.icon.trash:before {
  content: "\\f1f8";
}
i.icon.trash.alternate:before {
  content: "\\f2ed";
}
i.icon.tree:before {
  content: "\\f1bb";
}
i.icon.trello:before {
  content: "\\f181";
}
i.icon.tripadvisor:before {
  content: "\\f262";
}
i.icon.trophy:before {
  content: "\\f091";
}
i.icon.truck:before {
  content: "\\f0d1";
}
i.icon.tty:before {
  content: "\\f1e4";
}
i.icon.tumblr:before {
  content: "\\f173";
}
i.icon.tumblr.square:before {
  content: "\\f174";
}
i.icon.tv:before {
  content: "\\f26c";
}
i.icon.twitch:before {
  content: "\\f1e8";
}
i.icon.twitter:before {
  content: "\\f099";
}
i.icon.twitter.square:before {
  content: "\\f081";
}
i.icon.typo3:before {
  content: "\\f42b";
}
i.icon.uber:before {
  content: "\\f402";
}
i.icon.uikit:before {
  content: "\\f403";
}
i.icon.umbrella:before {
  content: "\\f0e9";
}
i.icon.underline:before {
  content: "\\f0cd";
}
i.icon.undo:before {
  content: "\\f0e2";
}
i.icon.undo.alternate:before {
  content: "\\f2ea";
}
i.icon.uniregistry:before {
  content: "\\f404";
}
i.icon.universal.access:before {
  content: "\\f29a";
}
i.icon.university:before {
  content: "\\f19c";
}
i.icon.unlink:before {
  content: "\\f127";
}
i.icon.unlock:before {
  content: "\\f09c";
}
i.icon.unlock.alternate:before {
  content: "\\f13e";
}
i.icon.untappd:before {
  content: "\\f405";
}
i.icon.upload:before {
  content: "\\f093";
}
i.icon.usb:before {
  content: "\\f287";
}
i.icon.user:before {
  content: "\\f007";
}
i.icon.user.circle:before {
  content: "\\f2bd";
}
i.icon.user.md:before {
  content: "\\f0f0";
}
i.icon.user.plus:before {
  content: "\\f234";
}
i.icon.user.secret:before {
  content: "\\f21b";
}
i.icon.user.times:before {
  content: "\\f235";
}
i.icon.users:before {
  content: "\\f0c0";
}
i.icon.ussunnah:before {
  content: "\\f407";
}
i.icon.utensil.spoon:before {
  content: "\\f2e5";
}
i.icon.utensils:before {
  content: "\\f2e7";
}
i.icon.vaadin:before {
  content: "\\f408";
}
i.icon.venus:before {
  content: "\\f221";
}
i.icon.venus.double:before {
  content: "\\f226";
}
i.icon.venus.mars:before {
  content: "\\f228";
}
i.icon.viacoin:before {
  content: "\\f237";
}
i.icon.viadeo:before {
  content: "\\f2a9";
}
i.icon.viadeo.square:before {
  content: "\\f2aa";
}
i.icon.viber:before {
  content: "\\f409";
}
i.icon.video:before {
  content: "\\f03d";
}
i.icon.vimeo:before {
  content: "\\f40a";
}
i.icon.vimeo.square:before {
  content: "\\f194";
}
i.icon.vimeo.v:before {
  content: "\\f27d";
}
i.icon.vine:before {
  content: "\\f1ca";
}
i.icon.vk:before {
  content: "\\f189";
}
i.icon.vnv:before {
  content: "\\f40b";
}
i.icon.volleyball.ball:before {
  content: "\\f45f";
}
i.icon.volume.down:before {
  content: "\\f027";
}
i.icon.volume.off:before {
  content: "\\f026";
}
i.icon.volume.up:before {
  content: "\\f028";
}
i.icon.vuejs:before {
  content: "\\f41f";
}
i.icon.warehouse:before {
  content: "\\f494";
}
i.icon.weibo:before {
  content: "\\f18a";
}
i.icon.weight:before {
  content: "\\f496";
}
i.icon.weixin:before {
  content: "\\f1d7";
}
i.icon.whatsapp:before {
  content: "\\f232";
}
i.icon.whatsapp.square:before {
  content: "\\f40c";
}
i.icon.wheelchair:before {
  content: "\\f193";
}
i.icon.whmcs:before {
  content: "\\f40d";
}
i.icon.wifi:before {
  content: "\\f1eb";
}
i.icon.wikipedia.w:before {
  content: "\\f266";
}
i.icon.window.close:before {
  content: "\\f410";
}
i.icon.window.maximize:before {
  content: "\\f2d0";
}
i.icon.window.minimize:before {
  content: "\\f2d1";
}
i.icon.window.restore:before {
  content: "\\f2d2";
}
i.icon.windows:before {
  content: "\\f17a";
}
i.icon.won.sign:before {
  content: "\\f159";
}
i.icon.wordpress:before {
  content: "\\f19a";
}
i.icon.wordpress.simple:before {
  content: "\\f411";
}
i.icon.wpbeginner:before {
  content: "\\f297";
}
i.icon.wpexplorer:before {
  content: "\\f2de";
}
i.icon.wpforms:before {
  content: "\\f298";
}
i.icon.wrench:before {
  content: "\\f0ad";
}
i.icon.xbox:before {
  content: "\\f412";
}
i.icon.xing:before {
  content: "\\f168";
}
i.icon.xing.square:before {
  content: "\\f169";
}
i.icon.y.combinator:before {
  content: "\\f23b";
}
i.icon.yahoo:before {
  content: "\\f19e";
}
i.icon.yandex:before {
  content: "\\f413";
}
i.icon.yandex.international:before {
  content: "\\f414";
}
i.icon.yelp:before {
  content: "\\f1e9";
}
i.icon.yen.sign:before {
  content: "\\f157";
}
i.icon.yoast:before {
  content: "\\f2b1";
}
i.icon.youtube:before {
  content: "\\f167";
}
i.icon.youtube.square:before {
  content: "\\f431";
}
/* Aliases */
i.icon.chess.rock:before {
  content: "\\f447";
}
i.icon.ordered.list:before {
  content: "\\f0cb";
}
i.icon.unordered.list:before {
  content: "\\f0ca";
}
i.icon.user.doctor:before {
  content: "\\f0f0";
}
i.icon.shield:before {
  content: "\\f3ed";
}
i.icon.puzzle:before {
  content: "\\f12e";
}
i.icon.credit.card.amazon.pay:before {
  content: "\\f42d";
}
i.icon.credit.card.american.express:before {
  content: "\\f1f3";
}
i.icon.credit.card.diners.club:before {
  content: "\\f24c";
}
i.icon.credit.card.discover:before {
  content: "\\f1f2";
}
i.icon.credit.card.jcb:before {
  content: "\\f24b";
}
i.icon.credit.card.mastercard:before {
  content: "\\f1f1";
}
i.icon.credit.card.paypal:before {
  content: "\\f1f4";
}
i.icon.credit.card.stripe:before {
  content: "\\f1f5";
}
i.icon.credit.card.visa:before {
  content: "\\f1f0";
}
i.icon.add.circle:before {
  content: "\\f055";
}
i.icon.add.square:before {
  content: "\\f0fe";
}
i.icon.add.to.calendar:before {
  content: "\\f271";
}
i.icon.add.to.cart:before {
  content: "\\f217";
}
i.icon.add.user:before {
  content: "\\f234";
}
i.icon.add:before {
  content: "\\f067";
}
i.icon.alarm.mute:before {
  content: "\\f1f6";
}
i.icon.alarm:before {
  content: "\\f0f3";
}
i.icon.ald:before {
  content: "\\f2a2";
}
i.icon.als:before {
  content: "\\f2a2";
}
i.icon.american.express.card:before {
  content: "\\f1f3";
}
i.icon.american.express:before {
  content: "\\f1f3";
}
i.icon.amex:before {
  content: "\\f1f3";
}
i.icon.announcement:before {
  content: "\\f0a1";
}
i.icon.area.chart:before {
  content: "\\f1fe";
}
i.icon.area.graph:before {
  content: "\\f1fe";
}
i.icon.arrow.down.cart:before {
  content: "\\f218";
}
i.icon.asexual:before {
  content: "\\f22d";
}
i.icon.asl.interpreting:before {
  content: "\\f2a3";
}
i.icon.asl:before {
  content: "\\f2a3";
}
i.icon.assistive.listening.devices:before {
  content: "\\f2a2";
}
i.icon.attach:before {
  content: "\\f0c6";
}
i.icon.attention:before {
  content: "\\f06a";
}
i.icon.balance:before {
  content: "\\f24e";
}
i.icon.bar:before {
  content: "\\f0fc";
}
i.icon.bathtub:before {
  content: "\\f2cd";
}
i.icon.battery.four:before {
  content: "\\f240";
}
i.icon.battery.high:before {
  content: "\\f241";
}
i.icon.battery.low:before {
  content: "\\f243";
}
i.icon.battery.medium:before {
  content: "\\f242";
}
i.icon.battery.one:before {
  content: "\\f243";
}
i.icon.battery.three:before {
  content: "\\f241";
}
i.icon.battery.two:before {
  content: "\\f242";
}
i.icon.battery.zero:before {
  content: "\\f244";
}
i.icon.birthday:before {
  content: "\\f1fd";
}
i.icon.block.layout:before {
  content: "\\f009";
}
i.icon.bluetooth.alternative:before {
  content: "\\f294";
}
i.icon.broken.chain:before {
  content: "\\f127";
}
i.icon.browser:before {
  content: "\\f022";
}
i.icon.call.square:before {
  content: "\\f098";
}
i.icon.call:before {
  content: "\\f095";
}
i.icon.cancel:before {
  content: "\\f00d";
}
i.icon.cart:before {
  content: "\\f07a";
}
i.icon.cc:before {
  content: "\\f20a";
}
i.icon.chain:before {
  content: "\\f0c1";
}
i.icon.chat:before {
  content: "\\f075";
}
i.icon.checked.calendar:before {
  content: "\\f274";
}
i.icon.checkmark:before {
  content: "\\f00c";
}
i.icon.circle.notched:before {
  content: "\\f1ce";
}
i.icon.close:before {
  content: "\\f00d";
}
i.icon.cny:before {
  content: "\\f157";
}
i.icon.cocktail:before {
  content: "\\f000";
}
i.icon.commenting:before {
  content: "\\f27a";
}
i.icon.computer:before {
  content: "\\f108";
}
i.icon.configure:before {
  content: "\\f0ad";
}
i.icon.content:before {
  content: "\\f0c9";
}
i.icon.deafness:before {
  content: "\\f2a4";
}
i.icon.delete.calendar:before {
  content: "\\f273";
}
i.icon.delete:before {
  content: "\\f00d";
}
i.icon.detective:before {
  content: "\\f21b";
}
i.icon.diners.club.card:before {
  content: "\\f24c";
}
i.icon.diners.club:before {
  content: "\\f24c";
}
i.icon.discover.card:before {
  content: "\\f1f2";
}
i.icon.discover:before {
  content: "\\f1f2";
}
i.icon.discussions:before {
  content: "\\f086";
}
i.icon.doctor:before {
  content: "\\f0f0";
}
i.icon.dollar:before {
  content: "\\f155";
}
i.icon.dont:before {
  content: "\\f05e";
}
i.icon.dribble:before {
  content: "\\f17d";
}
i.icon.drivers.license:before {
  content: "\\f2c2";
}
i.icon.dropdown:before {
  content: "\\f0d7";
}
i.icon.eercast:before {
  content: "\\f2da";
}
i.icon.emergency:before {
  content: "\\f0f9";
}
i.icon.envira.gallery:before {
  content: "\\f299";
}
i.icon.erase:before {
  content: "\\f12d";
}
i.icon.eur:before {
  content: "\\f153";
}
i.icon.euro:before {
  content: "\\f153";
}
i.icon.eyedropper:before {
  content: "\\f1fb";
}
i.icon.fa:before {
  content: "\\f2b4";
}
i.icon.factory:before {
  content: "\\f275";
}
i.icon.favorite:before {
  content: "\\f005";
}
i.icon.feed:before {
  content: "\\f09e";
}
i.icon.female.homosexual:before {
  content: "\\f226";
}
i.icon.file.text:before {
  content: "\\f15c";
}
i.icon.find:before {
  content: "\\f1e5";
}
i.icon.first.aid:before {
  content: "\\f0fa";
}
i.icon.five.hundred.pixels:before {
  content: "\\f26e";
}
i.icon.fork:before {
  content: "\\f126";
}
i.icon.game:before {
  content: "\\f11b";
}
i.icon.gay:before {
  content: "\\f227";
}
i.icon.gbp:before {
  content: "\\f154";
}
i.icon.gittip:before {
  content: "\\f184";
}
i.icon.google.plus.circle:before {
  content: "\\f2b3";
}
i.icon.google.plus.official:before {
  content: "\\f2b3";
}
i.icon.grab:before {
  content: "\\f255";
}
i.icon.graduation:before {
  content: "\\f19d";
}
i.icon.grid.layout:before {
  content: "\\f00a";
}
i.icon.group:before {
  content: "\\f0c0";
}
i.icon.h:before {
  content: "\\f0fd";
}
i.icon.hand.victory:before {
  content: "\\f25b";
}
i.icon.handicap:before {
  content: "\\f193";
}
i.icon.hard.of.hearing:before {
  content: "\\f2a4";
}
i.icon.header:before {
  content: "\\f1dc";
}
i.icon.help.circle:before {
  content: "\\f059";
}
i.icon.help:before {
  content: "\\f128";
}
i.icon.heterosexual:before {
  content: "\\f228";
}
i.icon.hide:before {
  content: "\\f070";
}
i.icon.hotel:before {
  content: "\\f236";
}
i.icon.hourglass.four:before {
  content: "\\f254";
}
i.icon.hourglass.full:before {
  content: "\\f254";
}
i.icon.hourglass.one:before {
  content: "\\f251";
}
i.icon.hourglass.three:before {
  content: "\\f253";
}
i.icon.hourglass.two:before {
  content: "\\f252";
}
i.icon.idea:before {
  content: "\\f0eb";
}
i.icon.ils:before {
  content: "\\f20b";
}
i.icon.in-cart:before {
  content: "\\f218";
}
i.icon.inr:before {
  content: "\\f156";
}
i.icon.intergender:before {
  content: "\\f224";
}
i.icon.intersex:before {
  content: "\\f224";
}
i.icon.japan.credit.bureau.card:before {
  content: "\\f24b";
}
i.icon.japan.credit.bureau:before {
  content: "\\f24b";
}
i.icon.jcb:before {
  content: "\\f24b";
}
i.icon.jpy:before {
  content: "\\f157";
}
i.icon.krw:before {
  content: "\\f159";
}
i.icon.lab:before {
  content: "\\f0c3";
}
i.icon.law:before {
  content: "\\f24e";
}
i.icon.legal:before {
  content: "\\f0e3";
}
i.icon.lesbian:before {
  content: "\\f226";
}
i.icon.lightning:before {
  content: "\\f0e7";
}
i.icon.like:before {
  content: "\\f004";
}
i.icon.line.graph:before {
  content: "\\f201";
}
i.icon.linkedin.square:before {
  content: "\\f08c";
}
i.icon.linkify:before {
  content: "\\f0c1";
}
i.icon.lira:before {
  content: "\\f195";
}
i.icon.list.layout:before {
  content: "\\f00b";
}
i.icon.magnify:before {
  content: "\\f00e";
}
i.icon.mail.forward:before {
  content: "\\f064";
}
i.icon.mail.square:before {
  content: "\\f199";
}
i.icon.mail:before {
  content: "\\f0e0";
}
i.icon.male.homosexual:before {
  content: "\\f227";
}
i.icon.man:before {
  content: "\\f222";
}
i.icon.marker:before {
  content: "\\f041";
}
i.icon.mars.alternate:before {
  content: "\\f229";
}
i.icon.mars.horizontal:before {
  content: "\\f22b";
}
i.icon.mars.vertical:before {
  content: "\\f22a";
}
i.icon.mastercard.card:before {
  content: "\\f1f1";
}
i.icon.mastercard:before {
  content: "\\f1f1";
}
i.icon.microsoft.edge:before {
  content: "\\f282";
}
i.icon.military:before {
  content: "\\f0fb";
}
i.icon.ms.edge:before {
  content: "\\f282";
}
i.icon.mute:before {
  content: "\\f131";
}
i.icon.new.pied.piper:before {
  content: "\\f2ae";
}
i.icon.non.binary.transgender:before {
  content: "\\f223";
}
i.icon.numbered.list:before {
  content: "\\f0cb";
}
i.icon.optinmonster:before {
  content: "\\f23c";
}
i.icon.options:before {
  content: "\\f1de";
}
i.icon.other.gender.horizontal:before {
  content: "\\f22b";
}
i.icon.other.gender.vertical:before {
  content: "\\f22a";
}
i.icon.other.gender:before {
  content: "\\f229";
}
i.icon.payment:before {
  content: "\\f09d";
}
i.icon.paypal.card:before {
  content: "\\f1f4";
}
i.icon.pencil.square:before {
  content: "\\f14b";
}
i.icon.photo:before {
  content: "\\f030";
}
i.icon.picture:before {
  content: "\\f03e";
}
i.icon.pie.chart:before {
  content: "\\f200";
}
i.icon.pie.graph:before {
  content: "\\f200";
}
i.icon.pied.piper.hat:before {
  content: "\\f2ae";
}
i.icon.pin:before {
  content: "\\f08d";
}
i.icon.plus.cart:before {
  content: "\\f217";
}
i.icon.pocket:before {
  content: "\\f265";
}
i.icon.point:before {
  content: "\\f041";
}
i.icon.pointing.down:before {
  content: "\\f0a7";
}
i.icon.pointing.left:before {
  content: "\\f0a5";
}
i.icon.pointing.right:before {
  content: "\\f0a4";
}
i.icon.pointing.up:before {
  content: "\\f0a6";
}
i.icon.pound:before {
  content: "\\f154";
}
i.icon.power.cord:before {
  content: "\\f1e6";
}
i.icon.power:before {
  content: "\\f011";
}
i.icon.privacy:before {
  content: "\\f084";
}
i.icon.r.circle:before {
  content: "\\f25d";
}
i.icon.rain:before {
  content: "\\f0e9";
}
i.icon.record:before {
  content: "\\f03d";
}
i.icon.refresh:before {
  content: "\\f021";
}
i.icon.remove.circle:before {
  content: "\\f057";
}
i.icon.remove.from.calendar:before {
  content: "\\f272";
}
i.icon.remove.user:before {
  content: "\\f235";
}
i.icon.remove:before {
  content: "\\f00d";
}
i.icon.repeat:before {
  content: "\\f01e";
}
i.icon.rmb:before {
  content: "\\f157";
}
i.icon.rouble:before {
  content: "\\f158";
}
i.icon.rub:before {
  content: "\\f158";
}
i.icon.ruble:before {
  content: "\\f158";
}
i.icon.rupee:before {
  content: "\\f156";
}
i.icon.s15:before {
  content: "\\f2cd";
}
i.icon.selected.radio:before {
  content: "\\f192";
}
i.icon.send:before {
  content: "\\f1d8";
}
i.icon.setting:before {
  content: "\\f013";
}
i.icon.settings:before {
  content: "\\f085";
}
i.icon.shekel:before {
  content: "\\f20b";
}
i.icon.sheqel:before {
  content: "\\f20b";
}
i.icon.shipping:before {
  content: "\\f0d1";
}
i.icon.shop:before {
  content: "\\f07a";
}
i.icon.shuffle:before {
  content: "\\f074";
}
i.icon.shutdown:before {
  content: "\\f011";
}
i.icon.sidebar:before {
  content: "\\f0c9";
}
i.icon.signing:before {
  content: "\\f2a7";
}
i.icon.signup:before {
  content: "\\f044";
}
i.icon.sliders:before {
  content: "\\f1de";
}
i.icon.soccer:before {
  content: "\\f1e3";
}
i.icon.sort.alphabet.ascending:before {
  content: "\\f15d";
}
i.icon.sort.alphabet.descending:before {
  content: "\\f15e";
}
i.icon.sort.ascending:before {
  content: "\\f0de";
}
i.icon.sort.content.ascending:before {
  content: "\\f160";
}
i.icon.sort.content.descending:before {
  content: "\\f161";
}
i.icon.sort.descending:before {
  content: "\\f0dd";
}
i.icon.sort.numeric.ascending:before {
  content: "\\f162";
}
i.icon.sort.numeric.descending:before {
  content: "\\f163";
}
i.icon.sound:before {
  content: "\\f025";
}
i.icon.spy:before {
  content: "\\f21b";
}
i.icon.stripe.card:before {
  content: "\\f1f5";
}
i.icon.student:before {
  content: "\\f19d";
}
i.icon.talk:before {
  content: "\\f27a";
}
i.icon.target:before {
  content: "\\f140";
}
i.icon.teletype:before {
  content: "\\f1e4";
}
i.icon.television:before {
  content: "\\f26c";
}
i.icon.text.cursor:before {
  content: "\\f246";
}
i.icon.text.telephone:before {
  content: "\\f1e4";
}
i.icon.theme.isle:before {
  content: "\\f2b2";
}
i.icon.theme:before {
  content: "\\f043";
}
i.icon.thermometer:before {
  content: "\\f2c7";
}
i.icon.thumb.tack:before {
  content: "\\f08d";
}
i.icon.time:before {
  content: "\\f017";
}
i.icon.tm:before {
  content: "\\f25c";
}
i.icon.toggle.down:before {
  content: "\\f150";
}
i.icon.toggle.left:before {
  content: "\\f191";
}
i.icon.toggle.right:before {
  content: "\\f152";
}
i.icon.toggle.up:before {
  content: "\\f151";
}
i.icon.translate:before {
  content: "\\f1ab";
}
i.icon.travel:before {
  content: "\\f0b1";
}
i.icon.treatment:before {
  content: "\\f0f1";
}
i.icon.triangle.down:before {
  content: "\\f0d7";
}
i.icon.triangle.left:before {
  content: "\\f0d9";
}
i.icon.triangle.right:before {
  content: "\\f0da";
}
i.icon.triangle.up:before {
  content: "\\f0d8";
}
i.icon.try:before {
  content: "\\f195";
}
i.icon.unhide:before {
  content: "\\f06e";
}
i.icon.unlinkify:before {
  content: "\\f127";
}
i.icon.unmute:before {
  content: "\\f130";
}
i.icon.usd:before {
  content: "\\f155";
}
i.icon.user.cancel:before {
  content: "\\f235";
}
i.icon.user.close:before {
  content: "\\f235";
}
i.icon.user.delete:before {
  content: "\\f235";
}
i.icon.user.x:before {
  content: "\\f235";
}
i.icon.vcard:before {
  content: "\\f2bb";
}
i.icon.video.camera:before {
  content: "\\f03d";
}
i.icon.video.play:before {
  content: "\\f144";
}
i.icon.visa.card:before {
  content: "\\f1f0";
}
i.icon.visa:before {
  content: "\\f1f0";
}
i.icon.volume.control.phone:before {
  content: "\\f2a0";
}
i.icon.wait:before {
  content: "\\f017";
}
i.icon.warning.circle:before {
  content: "\\f06a";
}
i.icon.warning.sign:before {
  content: "\\f071";
}
i.icon.warning:before {
  content: "\\f12a";
}
i.icon.wechat:before {
  content: "\\f1d7";
}
i.icon.wi-fi:before {
  content: "\\f1eb";
}
i.icon.wikipedia:before {
  content: "\\f266";
}
i.icon.winner:before {
  content: "\\f091";
}
i.icon.wizard:before {
  content: "\\f0d0";
}
i.icon.woman:before {
  content: "\\f221";
}
i.icon.won:before {
  content: "\\f159";
}
i.icon.wordpress.beginner:before {
  content: "\\f297";
}
i.icon.wordpress.forms:before {
  content: "\\f298";
}
i.icon.world:before {
  content: "\\f0ac";
}
i.icon.write.square:before {
  content: "\\f14b";
}
i.icon.x:before {
  content: "\\f00d";
}
i.icon.yc:before {
  content: "\\f23b";
}
i.icon.ycombinator:before {
  content: "\\f23b";
}
i.icon.yen:before {
  content: "\\f157";
}
i.icon.zip:before {
  content: "\\f187";
}
i.icon.zoom-in:before {
  content: "\\f00e";
}
i.icon.zoom-out:before {
  content: "\\f010";
}
i.icon.zoom:before {
  content: "\\f00e";
}
i.icon.bitbucket.square:before {
  content: "\\f171";
}
i.icon.checkmark.box:before {
  content: "\\f14a";
}
i.icon.circle.thin:before {
  content: "\\f111";
}
i.icon.cloud.download:before {
  content: "\\f381";
}
i.icon.cloud.upload:before {
  content: "\\f382";
}
i.icon.compose:before {
  content: "\\f303";
}
i.icon.conversation:before {
  content: "\\f086";
}
i.icon.credit.card.alternative:before {
  content: "\\f09d";
}
i.icon.currency:before {
  content: "\\f3d1";
}
i.icon.dashboard:before {
  content: "\\f3fd";
}
i.icon.diamond:before {
  content: "\\f3a5";
}
i.icon.disk:before {
  content: "\\f0a0";
}
i.icon.exchange:before {
  content: "\\f362";
}
i.icon.external.share:before {
  content: "\\f14d";
}
i.icon.external.square:before {
  content: "\\f360";
}
i.icon.external:before {
  content: "\\f35d";
}
i.icon.facebook.official:before {
  content: "\\f082";
}
i.icon.food:before {
  content: "\\f2e7";
}
i.icon.hourglass.zero:before {
  content: "\\f253";
}
i.icon.level.down:before {
  content: "\\f3be";
}
i.icon.level.up:before {
  content: "\\f3bf";
}
i.icon.logout:before {
  content: "\\f2f5";
}
i.icon.meanpath:before {
  content: "\\f0c8";
}
i.icon.money:before {
  content: "\\f3d1";
}
i.icon.move:before {
  content: "\\f0b2";
}
i.icon.pencil:before {
  content: "\\f303";
}
i.icon.protect:before {
  content: "\\f023";
}
i.icon.radio:before {
  content: "\\f192";
}
i.icon.remove.bookmark:before {
  content: "\\f02e";
}
i.icon.resize.horizontal:before {
  content: "\\f337";
}
i.icon.resize.vertical:before {
  content: "\\f338";
}
i.icon.sign-in:before {
  content: "\\f2f6";
}
i.icon.sign-out:before {
  content: "\\f2f5";
}
i.icon.spoon:before {
  content: "\\f2e5";
}
i.icon.star.half.empty:before {
  content: "\\f089";
}
i.icon.star.half.full:before {
  content: "\\f089";
}
i.icon.ticket:before {
  content: "\\f3ff";
}
i.icon.times.rectangle:before {
  content: "\\f410";
}
i.icon.write:before {
  content: "\\f303";
}
i.icon.youtube.play:before {
  content: "\\f167";
}
/*******************************
        Outline Icons
*******************************/
/* Outline Icon */
/* Load & Define Icon Font */
@font-face {
  font-family: 'outline-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('svg');
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
i.icon.outline {
  font-family: 'outline-icons';
}
/* Icon Definitions */
i.icon.address.book.outline:before {
  content: "\\f2b9";
}
i.icon.address.card.outline:before {
  content: "\\f2bb";
}
i.icon.arrow.alternate.circle.down.outline:before {
  content: "\\f358";
}
i.icon.arrow.alternate.circle.left.outline:before {
  content: "\\f359";
}
i.icon.arrow.alternate.circle.right.outline:before {
  content: "\\f35a";
}
i.icon.arrow.alternate.circle.up.outline:before {
  content: "\\f35b";
}
i.icon.bell.outline:before {
  content: "\\f0f3";
}
i.icon.bell.slash.outline:before {
  content: "\\f1f6";
}
i.icon.bookmark.outline:before {
  content: "\\f02e";
}
i.icon.building.outline:before {
  content: "\\f1ad";
}
i.icon.calendar.outline:before {
  content: "\\f133";
}
i.icon.calendar.alternate.outline:before {
  content: "\\f073";
}
i.icon.calendar.check.outline:before {
  content: "\\f274";
}
i.icon.calendar.minus.outline:before {
  content: "\\f272";
}
i.icon.calendar.plus.outline:before {
  content: "\\f271";
}
i.icon.calendar.times.outline:before {
  content: "\\f273";
}
i.icon.caret.square.down.outline:before {
  content: "\\f150";
}
i.icon.caret.square.left.outline:before {
  content: "\\f191";
}
i.icon.caret.square.right.outline:before {
  content: "\\f152";
}
i.icon.caret.square.up.outline:before {
  content: "\\f151";
}
i.icon.chart.bar.outline:before {
  content: "\\f080";
}
i.icon.check.circle.outline:before {
  content: "\\f058";
}
i.icon.check.square.outline:before {
  content: "\\f14a";
}
i.icon.circle.outline:before {
  content: "\\f111";
}
i.icon.clipboard.outline:before {
  content: "\\f328";
}
i.icon.clock.outline:before {
  content: "\\f017";
}
i.icon.clone.outline:before {
  content: "\\f24d";
}
i.icon.closed.captioning.outline:before {
  content: "\\f20a";
}
i.icon.comment.outline:before {
  content: "\\f075";
}
i.icon.comment.alternate.outline:before {
  content: "\\f27a";
}
i.icon.comments.outline:before {
  content: "\\f086";
}
i.icon.compass.outline:before {
  content: "\\f14e";
}
i.icon.copy.outline:before {
  content: "\\f0c5";
}
i.icon.copyright.outline:before {
  content: "\\f1f9";
}
i.icon.credit.card.outline:before {
  content: "\\f09d";
}
i.icon.dot.circle.outline:before {
  content: "\\f192";
}
i.icon.edit.outline:before {
  content: "\\f044";
}
i.icon.envelope.outline:before {
  content: "\\f0e0";
}
i.icon.envelope.open.outline:before {
  content: "\\f2b6";
}
i.icon.eye.slash.outline:before {
  content: "\\f070";
}
i.icon.file.outline:before {
  content: "\\f15b";
}
i.icon.file.alternate.outline:before {
  content: "\\f15c";
}
i.icon.file.archive.outline:before {
  content: "\\f1c6";
}
i.icon.file.audio.outline:before {
  content: "\\f1c7";
}
i.icon.file.code.outline:before {
  content: "\\f1c9";
}
i.icon.file.excel.outline:before {
  content: "\\f1c3";
}
i.icon.file.image.outline:before {
  content: "\\f1c5";
}
i.icon.file.pdf.outline:before {
  content: "\\f1c1";
}
i.icon.file.powerpoint.outline:before {
  content: "\\f1c4";
}
i.icon.file.video.outline:before {
  content: "\\f1c8";
}
i.icon.file.word.outline:before {
  content: "\\f1c2";
}
i.icon.flag.outline:before {
  content: "\\f024";
}
i.icon.folder.outline:before {
  content: "\\f07b";
}
i.icon.folder.open.outline:before {
  content: "\\f07c";
}
i.icon.frown.outline:before {
  content: "\\f119";
}
i.icon.futbol.outline:before {
  content: "\\f1e3";
}
i.icon.gem.outline:before {
  content: "\\f3a5";
}
i.icon.hand.lizard.outline:before {
  content: "\\f258";
}
i.icon.hand.paper.outline:before {
  content: "\\f256";
}
i.icon.hand.peace.outline:before {
  content: "\\f25b";
}
i.icon.hand.point.down.outline:before {
  content: "\\f0a7";
}
i.icon.hand.point.left.outline:before {
  content: "\\f0a5";
}
i.icon.hand.point.right.outline:before {
  content: "\\f0a4";
}
i.icon.hand.point.up.outline:before {
  content: "\\f0a6";
}
i.icon.hand.pointer.outline:before {
  content: "\\f25a";
}
i.icon.hand.rock.outline:before {
  content: "\\f255";
}
i.icon.hand.scissors.outline:before {
  content: "\\f257";
}
i.icon.hand.spock.outline:before {
  content: "\\f259";
}
i.icon.handshake.outline:before {
  content: "\\f2b5";
}
i.icon.hdd.outline:before {
  content: "\\f0a0";
}
i.icon.heart.outline:before {
  content: "\\f004";
}
i.icon.hospital.outline:before {
  content: "\\f0f8";
}
i.icon.hourglass.outline:before {
  content: "\\f254";
}
i.icon.id.badge.outline:before {
  content: "\\f2c1";
}
i.icon.id.card.outline:before {
  content: "\\f2c2";
}
i.icon.image.outline:before {
  content: "\\f03e";
}
i.icon.images.outline:before {
  content: "\\f302";
}
i.icon.keyboard.outline:before {
  content: "\\f11c";
}
i.icon.lemon.outline:before {
  content: "\\f094";
}
i.icon.life.ring.outline:before {
  content: "\\f1cd";
}
i.icon.lightbulb.outline:before {
  content: "\\f0eb";
}
i.icon.list.alternate.outline:before {
  content: "\\f022";
}
i.icon.map.outline:before {
  content: "\\f279";
}
i.icon.meh.outline:before {
  content: "\\f11a";
}
i.icon.minus.square.outline:before {
  content: "\\f146";
}
i.icon.money.bill.alternate.outline:before {
  content: "\\f3d1";
}
i.icon.moon.outline:before {
  content: "\\f186";
}
i.icon.newspaper.outline:before {
  content: "\\f1ea";
}
i.icon.object.group.outline:before {
  content: "\\f247";
}
i.icon.object.ungroup.outline:before {
  content: "\\f248";
}
i.icon.paper.plane.outline:before {
  content: "\\f1d8";
}
i.icon.pause.circle.outline:before {
  content: "\\f28b";
}
i.icon.play.circle.outline:before {
  content: "\\f144";
}
i.icon.plus.square.outline:before {
  content: "\\f0fe";
}
i.icon.question.circle.outline:before {
  content: "\\f059";
}
i.icon.registered.outline:before {
  content: "\\f25d";
}
i.icon.save.outline:before {
  content: "\\f0c7";
}
i.icon.share.square.outline:before {
  content: "\\f14d";
}
i.icon.smile.outline:before {
  content: "\\f118";
}
i.icon.snowflake.outline:before {
  content: "\\f2dc";
}
i.icon.square.outline:before {
  content: "\\f0c8";
}
i.icon.star.outline:before {
  content: "\\f005";
}
i.icon.star.half.outline:before {
  content: "\\f089";
}
i.icon.sticky.note.outline:before {
  content: "\\f249";
}
i.icon.stop.circle.outline:before {
  content: "\\f28d";
}
i.icon.sun.outline:before {
  content: "\\f185";
}
i.icon.thumbs.down.outline:before {
  content: "\\f165";
}
i.icon.thumbs.up.outline:before {
  content: "\\f164";
}
i.icon.times.circle.outline:before {
  content: "\\f057";
}
i.icon.trash.alternate.outline:before {
  content: "\\f2ed";
}
i.icon.user.outline:before {
  content: "\\f007";
}
i.icon.user.circle.outline:before {
  content: "\\f2bd";
}
i.icon.window.close.outline:before {
  content: "\\f410";
}
i.icon.window.maximize.outline:before {
  content: "\\f2d0";
}
i.icon.window.minimize.outline:before {
  content: "\\f2d1";
}
i.icon.window.restore.outline:before {
  content: "\\f2d2";
}
/* Outline Aliases */
i.icon.disk.outline:before {
  content: "\\f0a0";
}
i.icon.heart.empty,
i.icon.star.empty {
  font-family: 'outline-icons';
}
i.icon.heart.empty:before {
  content: "\\f004";
}
i.icon.star.empty:before {
  content: "\\f089";
}
/*******************************
           Brand Icons
*******************************/
/* Load & Define Brand Font */
@font-face {
  font-family: 'brand-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('svg');
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
/* Brand Icon Font Family */
i.icon.\\35 00px,
i.icon.accessible.icon,
i.icon.accusoft,
i.icon.adn,
i.icon.adversal,
i.icon.affiliatetheme,
i.icon.algolia,
i.icon.amazon,
i.icon.amazon.pay,
i.icon.amilia,
i.icon.android,
i.icon.angellist,
i.icon.angrycreative,
i.icon.angular,
i.icon.app.store,
i.icon.app.store.ios,
i.icon.apper,
i.icon.apple,
i.icon.apple.pay,
i.icon.asymmetrik,
i.icon.audible,
i.icon.autoprefixer,
i.icon.avianex,
i.icon.aviato,
i.icon.aws,
i.icon.bandcamp,
i.icon.behance,
i.icon.behance.square,
i.icon.bimobject,
i.icon.bitbucket,
i.icon.bitcoin,
i.icon.bity,
i.icon.black.tie,
i.icon.blackberry,
i.icon.blogger,
i.icon.blogger.b,
i.icon.bluetooth,
i.icon.bluetooth.b,
i.icon.btc,
i.icon.buromobelexperte,
i.icon.buysellads,
i.icon.cc.amazon.pay,
i.icon.cc.amex,
i.icon.cc.apple.pay,
i.icon.cc.diners.club,
i.icon.cc.discover,
i.icon.cc.jcb,
i.icon.cc.mastercard,
i.icon.cc.paypal,
i.icon.cc.stripe,
i.icon.cc.visa,
i.icon.centercode,
i.icon.chrome,
i.icon.cloudscale,
i.icon.cloudsmith,
i.icon.cloudversify,
i.icon.codepen,
i.icon.codiepie,
i.icon.connectdevelop,
i.icon.contao,
i.icon.cpanel,
i.icon.creative.commons,
i.icon.css3,
i.icon.css3.alternate,
i.icon.cuttlefish,
i.icon.d.and.d,
i.icon.dashcube,
i.icon.delicious,
i.icon.deploydog,
i.icon.deskpro,
i.icon.deviantart,
i.icon.digg,
i.icon.digital.ocean,
i.icon.discord,
i.icon.discourse,
i.icon.dochub,
i.icon.docker,
i.icon.draft2digital,
i.icon.dribbble,
i.icon.dribbble.square,
i.icon.dropbox,
i.icon.drupal,
i.icon.dyalog,
i.icon.earlybirds,
i.icon.edge,
i.icon.elementor,
i.icon.ember,
i.icon.empire,
i.icon.envira,
i.icon.erlang,
i.icon.ethereum,
i.icon.etsy,
i.icon.expeditedssl,
i.icon.facebook,
i.icon.facebook.f,
i.icon.facebook.messenger,
i.icon.facebook.square,
i.icon.firefox,
i.icon.first.order,
i.icon.firstdraft,
i.icon.flickr,
i.icon.flipboard,
i.icon.fly,
i.icon.font.awesome,
i.icon.font.awesome.alternate,
i.icon.font.awesome.flag,
i.icon.fonticons,
i.icon.fonticons.fi,
i.icon.fort.awesome,
i.icon.fort.awesome.alternate,
i.icon.forumbee,
i.icon.foursquare,
i.icon.free.code.camp,
i.icon.freebsd,
i.icon.get.pocket,
i.icon.gg,
i.icon.gg.circle,
i.icon.git,
i.icon.git.square,
i.icon.github,
i.icon.github.alternate,
i.icon.github.square,
i.icon.gitkraken,
i.icon.gitlab,
i.icon.gitter,
i.icon.glide,
i.icon.glide.g,
i.icon.gofore,
i.icon.goodreads,
i.icon.goodreads.g,
i.icon.google,
i.icon.google.drive,
i.icon.google.play,
i.icon.google.plus,
i.icon.google.plus.g,
i.icon.google.plus.square,
i.icon.google.wallet,
i.icon.gratipay,
i.icon.grav,
i.icon.gripfire,
i.icon.grunt,
i.icon.gulp,
i.icon.hacker.news,
i.icon.hacker.news.square,
i.icon.hips,
i.icon.hire.a.helper,
i.icon.hooli,
i.icon.hotjar,
i.icon.houzz,
i.icon.html5,
i.icon.hubspot,
i.icon.imdb,
i.icon.instagram,
i.icon.internet.explorer,
i.icon.ioxhost,
i.icon.itunes,
i.icon.itunes.note,
i.icon.jenkins,
i.icon.joget,
i.icon.joomla,
i.icon.js,
i.icon.js.square,
i.icon.jsfiddle,
i.icon.keycdn,
i.icon.kickstarter,
i.icon.kickstarter.k,
i.icon.korvue,
i.icon.laravel,
i.icon.lastfm,
i.icon.lastfm.square,
i.icon.leanpub,
i.icon.less,
i.icon.linechat,
i.icon.linkedin,
i.icon.linkedin.alternate,
i.icon.linkedin.in,
i.icon.linode,
i.icon.linux,
i.icon.lyft,
i.icon.magento,
i.icon.maxcdn,
i.icon.medapps,
i.icon.medium,
i.icon.medium.m,
i.icon.medrt,
i.icon.meetup,
i.icon.microsoft,
i.icon.mix,
i.icon.mixcloud,
i.icon.mizuni,
i.icon.modx,
i.icon.monero,
i.icon.napster,
i.icon.nintendo.switch,
i.icon.node,
i.icon.node.js,
i.icon.npm,
i.icon.ns8,
i.icon.nutritionix,
i.icon.odnoklassniki,
i.icon.odnoklassniki.square,
i.icon.opencart,
i.icon.openid,
i.icon.opera,
i.icon.optin.monster,
i.icon.osi,
i.icon.page4,
i.icon.pagelines,
i.icon.palfed,
i.icon.patreon,
i.icon.paypal,
i.icon.periscope,
i.icon.phabricator,
i.icon.phoenix.framework,
i.icon.php,
i.icon.pied.piper,
i.icon.pied.piper.alternate,
i.icon.pied.piper.pp,
i.icon.pinterest,
i.icon.pinterest.p,
i.icon.pinterest.square,
i.icon.playstation,
i.icon.product.hunt,
i.icon.pushed,
i.icon.python,
i.icon.qq,
i.icon.quinscape,
i.icon.quora,
i.icon.ravelry,
i.icon.react,
i.icon.rebel,
i.icon.redriver,
i.icon.reddit,
i.icon.reddit.alien,
i.icon.reddit.square,
i.icon.rendact,
i.icon.renren,
i.icon.replyd,
i.icon.resolving,
i.icon.rocketchat,
i.icon.rockrms,
i.icon.safari,
i.icon.sass,
i.icon.schlix,
i.icon.scribd,
i.icon.searchengin,
i.icon.sellcast,
i.icon.sellsy,
i.icon.servicestack,
i.icon.shirtsinbulk,
i.icon.simplybuilt,
i.icon.sistrix,
i.icon.skyatlas,
i.icon.skype,
i.icon.slack,
i.icon.slack.hash,
i.icon.slideshare,
i.icon.snapchat,
i.icon.snapchat.ghost,
i.icon.snapchat.square,
i.icon.soundcloud,
i.icon.speakap,
i.icon.spotify,
i.icon.stack.exchange,
i.icon.stack.overflow,
i.icon.staylinked,
i.icon.steam,
i.icon.steam.square,
i.icon.steam.symbol,
i.icon.sticker.mule,
i.icon.strava,
i.icon.stripe,
i.icon.stripe.s,
i.icon.studiovinari,
i.icon.stumbleupon,
i.icon.stumbleupon.circle,
i.icon.superpowers,
i.icon.supple,
i.icon.telegram,
i.icon.telegram.plane,
i.icon.tencent.weibo,
i.icon.themeisle,
i.icon.trello,
i.icon.tripadvisor,
i.icon.tumblr,
i.icon.tumblr.square,
i.icon.twitch,
i.icon.twitter,
i.icon.twitter.square,
i.icon.typo3,
i.icon.uber,
i.icon.uikit,
i.icon.uniregistry,
i.icon.untappd,
i.icon.usb,
i.icon.ussunnah,
i.icon.vaadin,
i.icon.viacoin,
i.icon.viadeo,
i.icon.viadeo.square,
i.icon.viber,
i.icon.vimeo,
i.icon.vimeo.square,
i.icon.vimeo.v,
i.icon.vine,
i.icon.vk,
i.icon.vnv,
i.icon.vuejs,
i.icon.wechat,
i.icon.weibo,
i.icon.weixin,
i.icon.whatsapp,
i.icon.whatsapp.square,
i.icon.whmcs,
i.icon.wikipedia.w,
i.icon.windows,
i.icon.wordpress,
i.icon.wordpress.simple,
i.icon.wpbeginner,
i.icon.wpexplorer,
i.icon.wpforms,
i.icon.xbox,
i.icon.xing,
i.icon.xing.square,
i.icon.y.combinator,
i.icon.yahoo,
i.icon.yandex,
i.icon.yandex.international,
i.icon.yelp,
i.icon.yoast,
i.icon.youtube,
i.icon.youtube.square {
  font-family: 'brand-icons';
}
/* Brand Icons Ideally Would Be Defined Here */
/*!
 * # Semantic UI - Image
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Image
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Types
--------------------*/
/* Avatar */
/*-------------------
       Variations
--------------------*/
/* Spaced */
/* Floated */
/* Size */
/* Packaged Theme */
/*******************************
            Image
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Types
--------------------*/
/* Avatar */
/*-------------------
       Variations
--------------------*/
/* Spaced */
/* Floated */
/* Size */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Image
*******************************/
.ui.image {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  background-color: transparent;
}
img.ui.image {
  display: block;
}
.ui.image svg,
.ui.image img {
  display: block;
  max-width: 100%;
  height: auto;
}
/*******************************
            States
*******************************/
.ui.hidden.images,
.ui.hidden.image {
  display: none;
}
.ui.hidden.transition.images,
.ui.hidden.transition.image {
  display: block;
  visibility: hidden;
}
.ui.images > .hidden.transition {
  display: inline-block;
  visibility: hidden;
}
.ui.disabled.images,
.ui.disabled.image {
  cursor: default;
  opacity: 0.45;
}
/*******************************
          Variations
*******************************/
/*--------------
     Inline
---------------*/
.ui.inline.image,
.ui.inline.image svg,
.ui.inline.image img {
  display: inline-block;
}
/*------------------
  Vertical Aligned
-------------------*/
.ui.top.aligned.images .image,
.ui.top.aligned.image,
.ui.top.aligned.image svg,
.ui.top.aligned.image img {
  display: inline-block;
  vertical-align: top;
}
.ui.middle.aligned.images .image,
.ui.middle.aligned.image,
.ui.middle.aligned.image svg,
.ui.middle.aligned.image img {
  display: inline-block;
  vertical-align: middle;
}
.ui.bottom.aligned.images .image,
.ui.bottom.aligned.image,
.ui.bottom.aligned.image svg,
.ui.bottom.aligned.image img {
  display: inline-block;
  vertical-align: bottom;
}
/*--------------
     Rounded
---------------*/
.ui.rounded.images .image,
.ui.rounded.image,
.ui.rounded.images .image > *,
.ui.rounded.image > * {
  border-radius: 0.3125em;
}
/*--------------
    Bordered
---------------*/
.ui.bordered.images .image,
.ui.bordered.images img,
.ui.bordered.images svg,
.ui.bordered.image img,
.ui.bordered.image svg,
img.ui.bordered.image {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
/*--------------
    Circular
---------------*/
.ui.circular.images,
.ui.circular.image {
  overflow: hidden;
}
.ui.circular.images .image,
.ui.circular.image,
.ui.circular.images .image > *,
.ui.circular.image > * {
  -webkit-border-radius: 500rem;
  -moz-border-radius: 500rem;
  border-radius: 500rem;
}
/*--------------
     Fluid
---------------*/
.ui.fluid.images,
.ui.fluid.image,
.ui.fluid.images img,
.ui.fluid.images svg,
.ui.fluid.image svg,
.ui.fluid.image img {
  display: block;
  width: 100%;
  height: auto;
}
/*--------------
     Avatar
---------------*/
.ui.avatar.images .image,
.ui.avatar.images img,
.ui.avatar.images svg,
.ui.avatar.image img,
.ui.avatar.image svg,
.ui.avatar.image {
  margin-right: 0.25em;
  display: inline-block;
  width: 2em;
  height: 2em;
  -webkit-border-radius: 500rem;
  -moz-border-radius: 500rem;
  border-radius: 500rem;
}
/*-------------------
       Spaced
--------------------*/
.ui.spaced.image {
  display: inline-block !important;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.ui[class*="left spaced"].image {
  margin-left: 0.5em;
  margin-right: 0em;
}
.ui[class*="right spaced"].image {
  margin-left: 0em;
  margin-right: 0.5em;
}
/*-------------------
       Floated
--------------------*/
.ui.floated.image,
.ui.floated.images {
  float: left;
  margin-right: 1em;
  margin-bottom: 1em;
}
.ui.right.floated.images,
.ui.right.floated.image {
  float: right;
  margin-right: 0em;
  margin-bottom: 1em;
  margin-left: 1em;
}
.ui.floated.images:last-child,
.ui.floated.image:last-child {
  margin-bottom: 0em;
}
.ui.centered.images,
.ui.centered.image {
  margin-left: auto;
  margin-right: auto;
}
/*--------------
     Sizes
---------------*/
.ui.mini.images .image,
.ui.mini.images img,
.ui.mini.images svg,
.ui.mini.image {
  width: 35px;
  height: auto;
  font-size: 0.78571429rem;
}
.ui.tiny.images .image,
.ui.tiny.images img,
.ui.tiny.images svg,
.ui.tiny.image {
  width: 80px;
  height: auto;
  font-size: 0.85714286rem;
}
.ui.small.images .image,
.ui.small.images img,
.ui.small.images svg,
.ui.small.image {
  width: 150px;
  height: auto;
  font-size: 0.92857143rem;
}
.ui.medium.images .image,
.ui.medium.images img,
.ui.medium.images svg,
.ui.medium.image {
  width: 300px;
  height: auto;
  font-size: 1rem;
}
.ui.large.images .image,
.ui.large.images img,
.ui.large.images svg,
.ui.large.image {
  width: 450px;
  height: auto;
  font-size: 1.14285714rem;
}
.ui.big.images .image,
.ui.big.images img,
.ui.big.images svg,
.ui.big.image {
  width: 600px;
  height: auto;
  font-size: 1.28571429rem;
}
.ui.huge.images .image,
.ui.huge.images img,
.ui.huge.images svg,
.ui.huge.image {
  width: 800px;
  height: auto;
  font-size: 1.42857143rem;
}
.ui.massive.images .image,
.ui.massive.images img,
.ui.massive.images svg,
.ui.massive.image {
  width: 960px;
  height: auto;
  font-size: 1.71428571rem;
}
/*******************************
              Groups
*******************************/
.ui.images {
  font-size: 0em;
  margin: 0em -0.25rem 0rem;
}
.ui.images .image,
.ui.images > img,
.ui.images > svg {
  display: inline-block;
  margin: 0em 0.25rem 0.5rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Input
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Input
*******************************/
/*-------------------
      Element
--------------------*/
/*-------------------
        Types
--------------------*/
/* Icon Input */
/* Circular Icon Input */
/* Labeled Input */
/*-------------------
        States
--------------------*/
/* Placeholder */
/* Down */
/* Focus */
/* Error */
/* Loader */
/*-------------------
      Variations
--------------------*/
/* Inverted */
/* Packaged Theme */
/*******************************
            Input
*******************************/
/*-------------------
      Element
--------------------*/
/*-------------------
        Types
--------------------*/
/* Icon Input */
/* Circular Icon Input */
/* Labeled Input */
/*-------------------
        States
--------------------*/
/* Placeholder */
/* Down */
/* Focus */
/* Error */
/* Loader */
/*-------------------
      Variations
--------------------*/
/* Inverted */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           Standard
*******************************/
/*--------------------
        Inputs
---------------------*/
.ui.input {
  position: relative;
  font-weight: normal;
  font-style: normal;
  display: inline-flex;
  color: #ffffff;
}
.ui.input > input {
  margin: 0em;
  max-width: 100%;
  flex: 1 0 auto;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-align: left;
  line-height: 1.21428571em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  padding: 0.67857143em 1em;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  border-radius: 0.28571429rem;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;
  box-shadow: none;
}
/*--------------------
      Placeholder
---------------------*/
/* browsers require these rules separate */
.ui.input > input::-webkit-input-placeholder {
  color: #404040;
}
.ui.input > input::-moz-placeholder {
  color: #404040;
}
.ui.input > input:-ms-input-placeholder {
  color: #404040;
}
/*******************************
            States
*******************************/
/*--------------------
        Disabled
---------------------*/
.ui.disabled.input,
.ui.input:not(.disabled) input[disabled] {
  opacity: 0.45;
}
.ui.disabled.input > input,
.ui.input:not(.disabled) input[disabled] {
  pointer-events: none;
}
/*--------------------
        Active
---------------------*/
.ui.input > input:active,
.ui.input.down input {
  border-color: rgba(0, 0, 0, 0.3);
  background: #FAFAFA;
  color: rgba(255, 255, 255, 0.87);
  box-shadow: none;
}
/*--------------------
       Loading
---------------------*/
.ui.loading.loading.input > i.icon:before {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.ui.loading.loading.input > i.icon:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  animation: button-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
/*--------------------
        Focus
---------------------*/
.ui.input.focus > input,
.ui.input > input:focus {
  border-color: #85B7D9;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.8);
  box-shadow: none;
}
.ui.input.focus > input::-webkit-input-placeholder,
.ui.input > input:focus::-webkit-input-placeholder {
  color: #8c8c8c;
}
.ui.input.focus > input::-moz-placeholder,
.ui.input > input:focus::-moz-placeholder {
  color: #8c8c8c;
}
.ui.input.focus > input:-ms-input-placeholder,
.ui.input > input:focus:-ms-input-placeholder {
  color: #8c8c8c;
}
/*--------------------
        Error
---------------------*/
.ui.input.error > input {
  background-color: rgba(200, 3, 3, 0.15);
  border-color: #E0B4B4;
  color: #FFFFFF;
  box-shadow: none;
}
/* Error Placeholder */
.ui.input.error > input::-webkit-input-placeholder {
  color: #ffffff;
}
.ui.input.error > input::-moz-placeholder {
  color: #ffffff;
}
.ui.input.error > input:-ms-input-placeholder {
  color: #ffffff !important;
}
/* Focused Error Placeholder */
.ui.input.error > input:focus::-webkit-input-placeholder {
  color: #ffffff;
}
.ui.input.error > input:focus::-moz-placeholder {
  color: #ffffff;
}
.ui.input.error > input:focus:-ms-input-placeholder {
  color: #ffffff !important;
}
/*******************************
           Variations
*******************************/
/*--------------------
      Transparent
---------------------*/
.ui.transparent.input > input {
  border-color: transparent !important;
  background-color: transparent !important;
  padding: 0em !important;
  box-shadow: none !important;
  border-radius: 0px !important;
}
/* Transparent Icon */
.ui.transparent.icon.input > i.icon {
  width: 1.1em;
}
.ui.transparent.icon.input > input {
  padding-left: 0em !important;
  padding-right: 2em !important;
}
.ui.transparent[class*="left icon"].input > input {
  padding-left: 2em !important;
  padding-right: 0em !important;
}
/* Transparent Inverted */
.ui.transparent.inverted.input {
  color: #FFFFFF;
}
.ui.transparent.inverted.input > input {
  color: inherit;
}
.ui.transparent.inverted.input > input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.ui.transparent.inverted.input > input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.ui.transparent.inverted.input > input:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
/*--------------------
         Icon
---------------------*/
.ui.icon.input > i.icon {
  cursor: default;
  position: absolute;
  line-height: 1;
  text-align: center;
  top: 0px;
  right: 0px;
  margin: 0em;
  height: 100%;
  width: 2.67142857em;
  opacity: 0.5;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
  transition: opacity 0.3s ease;
}
.ui.icon.input > i.icon:not(.link) {
  pointer-events: none;
}
.ui.icon.input > input {
  padding-right: 2.67142857em !important;
}
.ui.icon.input > i.icon:before,
.ui.icon.input > i.icon:after {
  left: 0;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  margin-top: -0.5em;
}
.ui.icon.input > i.link.icon {
  cursor: pointer;
}
.ui.icon.input > i.circular.icon {
  top: 0.35em;
  right: 0.5em;
}
/* Left Icon Input */
.ui[class*="left icon"].input > i.icon {
  right: auto;
  left: 1px;
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui[class*="left icon"].input > i.circular.icon {
  right: auto;
  left: 0.5em;
}
.ui[class*="left icon"].input > input {
  padding-left: 2.67142857em !important;
  padding-right: 1em !important;
}
/* Focus */
.ui.icon.input > input:focus ~ i.icon {
  opacity: 1;
}
/*--------------------
        Labeled
---------------------*/
/* Adjacent Label */
.ui.labeled.input > .label {
  flex: 0 0 auto;
  margin: 0;
  font-size: 1em;
}
.ui.labeled.input > .label:not(.corner) {
  padding-top: 0.78571429em;
  padding-bottom: 0.78571429em;
}
/* Regular Label on Left */
.ui.labeled.input:not([class*="corner labeled"]) .label:first-child {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.ui.labeled.input:not([class*="corner labeled"]) .label:first-child + input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left-color: transparent;
}
.ui.labeled.input:not([class*="corner labeled"]) .label:first-child + input:focus {
  border-left-color: #85B7D9;
}
/* Regular Label on Right */
.ui[class*="right labeled"].input > input {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-right-color: transparent !important;
}
.ui[class*="right labeled"].input > input + .label {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.ui[class*="right labeled"].input > input:focus {
  border-right-color: #85B7D9 !important;
}
/* Corner Label */
.ui.labeled.input .corner.label {
  top: 1px;
  right: 1px;
  font-size: 0.64285714em;
  border-radius: 0em 0.28571429rem 0em 0em;
}
/* Spacing with corner label */
.ui[class*="corner labeled"]:not([class*="left corner labeled"]).labeled.input > input {
  padding-right: 2.5em !important;
}
.ui[class*="corner labeled"].icon.input:not([class*="left corner labeled"]) > input {
  padding-right: 3.25em !important;
}
.ui[class*="corner labeled"].icon.input:not([class*="left corner labeled"]) > .icon {
  margin-right: 1.25em;
}
/* Left Labeled */
.ui[class*="left corner labeled"].labeled.input > input {
  padding-left: 2.5em !important;
}
.ui[class*="left corner labeled"].icon.input > input {
  padding-left: 3.25em !important;
}
.ui[class*="left corner labeled"].icon.input > .icon {
  margin-left: 1.25em;
}
/* Corner Label Position  */
.ui.input > .ui.corner.label {
  top: 1px;
  right: 1px;
}
.ui.input > .ui.left.corner.label {
  right: auto;
  left: 1px;
}
/*--------------------
        Action
---------------------*/
.ui.action.input > .button,
.ui.action.input > .buttons {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
.ui.action.input > .button,
.ui.action.input > .buttons > .button {
  padding-top: 0.78571429em;
  padding-bottom: 0.78571429em;
  margin: 0;
}
/* Button on Right */
.ui.action.input:not([class*="left action"]) > input {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-right-color: transparent !important;
}
.ui.action.input:not([class*="left action"]) > .dropdown:not(:first-child),
.ui.action.input:not([class*="left action"]) > .button:not(:first-child),
.ui.action.input:not([class*="left action"]) > .buttons:not(:first-child) > .button {
  border-radius: 0px;
}
.ui.action.input:not([class*="left action"]) > .dropdown:last-child,
.ui.action.input:not([class*="left action"]) > .button:last-child,
.ui.action.input:not([class*="left action"]) > .buttons:last-child > .button {
  border-radius: 0px 0.28571429rem 0.28571429rem 0px;
}
/* Input Focus */
.ui.action.input:not([class*="left action"]) > input:focus {
  border-right-color: #85B7D9 !important;
}
/* Button on Left */
.ui[class*="left action"].input > input {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-left-color: transparent !important;
}
.ui[class*="left action"].input > .dropdown,
.ui[class*="left action"].input > .button,
.ui[class*="left action"].input > .buttons > .button {
  border-radius: 0px;
}
.ui[class*="left action"].input > .dropdown:first-child,
.ui[class*="left action"].input > .button:first-child,
.ui[class*="left action"].input > .buttons:first-child > .button {
  border-radius: 0.28571429rem 0px 0px 0.28571429rem;
}
/* Input Focus */
.ui[class*="left action"].input > input:focus {
  border-left-color: #85B7D9 !important;
}
/*--------------------
       Inverted
---------------------*/
/* Standard */
.ui.inverted.input > input {
  border: none;
}
/*--------------------
        Fluid
---------------------*/
.ui.fluid.input {
  display: flex;
}
.ui.fluid.input > input {
  width: 0px !important;
}
/*--------------------
        Size
---------------------*/
.ui.mini.input {
  font-size: 0.78571429em;
}
.ui.small.input {
  font-size: 0.92857143em;
}
.ui.input {
  font-size: 1em;
}
.ui.large.input {
  font-size: 1.14285714em;
}
.ui.big.input {
  font-size: 1.28571429em;
}
.ui.huge.input {
  font-size: 1.42857143em;
}
.ui.massive.input {
  font-size: 1.71428571em;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Label
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Label
*******************************/
/*-------------------
       Element
--------------------*/
/* medium is not @emSize custom value required */
/* Group */
/*-------------------
        Parts
--------------------*/
/* Link */
/* Icon */
/* Image */
/* Detail */
/* Delete */
/*-------------------
        Types
--------------------*/
/* Image Label */
/*-------------------
        States
--------------------*/
/* Hover */
/* Active */
/* Active Hover */
/*-------------------
      Variations
--------------------*/
/* Basic */
/* Tag */
/* Avoids error with background: inherit; on animation */
/* Ribbon */
/* Rounding Offset on Triangle */
/* Rounding Offset on Triangle */
/* Colors */
/* Attached */
/* Corner */
/* Corner Text */
/* Horizontal */
/* Circular Padding */
/* Pointing */
/* Basic Pointing */
/* Floating */
/*-------------------
        Group
--------------------*/
/* Sizing */
/* Packaged Theme */
/*******************************
             Label
*******************************/
/*-------------------
       Element
--------------------*/
/* medium is not @emSize custom value required */
/* Group */
/*-------------------
        Parts
--------------------*/
/* Link */
/* Icon */
/* Image */
/* Detail */
/* Delete */
/*-------------------
        Types
--------------------*/
/* Image Label */
/*-------------------
        States
--------------------*/
/* Hover */
/* Active */
/* Active Hover */
/*-------------------
      Variations
--------------------*/
/* Basic */
/* Tag */
/* Avoids error with background: inherit; on animation */
/* Ribbon */
/* Rounding Offset on Triangle */
/* Rounding Offset on Triangle */
/* Colors */
/* Attached */
/* Corner */
/* Corner Text */
/* Horizontal */
/* Circular Padding */
/* Pointing */
/* Basic Pointing */
/* Floating */
/*-------------------
        Group
--------------------*/
/* Sizing */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Label
*******************************/
.ui.label {
  display: inline-block;
  line-height: 1;
  vertical-align: baseline;
  margin: 0em 0.14285714em;
  background-color: rgba(0, 0, 0, 0);
  background-image: none;
  padding: 0.5833em 0.833em;
  color: rgba(255, 255, 255, 0.3);
  text-transform: none;
  font-weight: bold;
  border: 0px solid transparent;
  border-radius: 0.28571429rem;
  transition: background 0.1s ease;
}
.ui.label:first-child {
  margin-left: 0em;
}
.ui.label:last-child {
  margin-right: 0em;
}
/* Link */
a.ui.label {
  cursor: pointer;
}
/* Inside Link */
.ui.label > a {
  cursor: pointer;
  color: inherit;
  opacity: 0.5;
  transition: 0.1s opacity ease;
}
.ui.label > a:hover {
  opacity: 1;
}
/* Image */
.ui.label > img {
  width: auto !important;
  vertical-align: middle;
  height: 2.1666em !important;
}
/* Icon */
.ui.label > .icon {
  width: auto;
  margin: 0em 0.75em 0em 0em;
}
/* Detail */
.ui.label > .detail {
  display: inline-block;
  vertical-align: top;
  font-weight: bold;
  margin-left: 1em;
  opacity: 0.8;
}
.ui.label > .detail .icon {
  margin: 0em 0.25em 0em 0em;
}
/* Removable label */
.ui.label > .close.icon,
.ui.label > .delete.icon {
  cursor: pointer;
  margin-right: 0em;
  margin-left: 0.5em;
  font-size: 0.92857143em;
  opacity: 0.5;
  transition: background 0.1s ease;
}
.ui.label > .delete.icon:hover {
  opacity: 1;
}
/*-------------------
       Group
--------------------*/
.ui.labels > .label {
  margin: 0em 0.5em 0.5em 0em;
}
/*-------------------
       Coupling
--------------------*/
.ui.header > .ui.label {
  margin-top: -0.29165em;
}
/* Remove border radius on attached segment */
.ui.attached.segment > .ui.top.left.attached.label,
.ui.bottom.attached.segment > .ui.top.left.attached.label {
  border-top-left-radius: 0;
}
.ui.attached.segment > .ui.top.right.attached.label,
.ui.bottom.attached.segment > .ui.top.right.attached.label {
  border-top-right-radius: 0;
}
.ui.top.attached.segment > .ui.bottom.left.attached.label {
  border-bottom-left-radius: 0;
}
.ui.top.attached.segment > .ui.bottom.right.attached.label {
  border-bottom-right-radius: 0;
}
/* Padding on next content after a label */
.ui.top.attached.label:first-child + :not(.attached),
.ui.top.attached.label + [class*="right floated"] + * {
  margin-top: 2rem !important;
}
.ui.bottom.attached.label:first-child ~ :last-child:not(.attached) {
  margin-top: 0em;
  margin-bottom: 2rem !important;
}
/*******************************
             Types
*******************************/
.ui.image.label {
  width: auto !important;
  margin-top: 0em;
  margin-bottom: 0em;
  max-width: 9999px;
  vertical-align: baseline;
  text-transform: none;
  background: rgba(0, 0, 0, 0);
  padding: 0.5833em 0.833em 0.5833em 0.5em;
  border-radius: 0.28571429rem;
  box-shadow: none;
}
.ui.image.label img {
  display: inline-block;
  vertical-align: top;
  height: 2.1666em;
  margin: -0.5833em 0.5em -0.5833em -0.5em;
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui.image.label .detail {
  background: rgba(0, 0, 0, 0.1);
  margin: -0.5833em -0.833em -0.5833em 0.5em;
  padding: 0.5833em 0.833em;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
/*-------------------
         Tag
--------------------*/
.ui.tag.labels .label,
.ui.tag.label {
  margin-left: 1em;
  position: relative;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
  transition: none;
}
.ui.tag.labels .label:before,
.ui.tag.label:before {
  position: absolute;
  transform: translateY(-50%) translateX(50%) rotate(-45deg);
  top: 50%;
  right: 100%;
  content: '';
  background-color: inherit;
  background-image: none;
  width: 1.56em;
  height: 1.56em;
  transition: none;
}
.ui.tag.labels .label:after,
.ui.tag.label:after {
  position: absolute;
  content: '';
  top: 50%;
  left: -0.25em;
  margin-top: -0.25em;
  background-color: #FFFFFF !important;
  width: 0.5em;
  height: 0.5em;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.3);
  border-radius: 500rem;
}
/*-------------------
    Corner Label
--------------------*/
.ui.corner.label {
  position: absolute;
  top: 0em;
  right: 0em;
  margin: 0em;
  padding: 0em;
  text-align: center;
  border-color: rgba(0, 0, 0, 0);
  width: 4em;
  height: 4em;
  z-index: 1;
  transition: border-color 0.1s ease;
}
/* Icon Label */
.ui.corner.label {
  background-color: transparent !important;
}
.ui.corner.label:after {
  position: absolute;
  content: "";
  right: 0em;
  top: 0em;
  z-index: -1;
  width: 0em;
  height: 0em;
  background-color: transparent !important;
  border-top: 0em solid transparent;
  border-right: 4em solid transparent;
  border-bottom: 4em solid transparent;
  border-left: 0em solid transparent;
  border-right-color: inherit;
  transition: border-color 0.1s ease;
}
.ui.corner.label .icon {
  cursor: default;
  position: relative;
  top: 0.64285714em;
  left: 0.78571429em;
  font-size: 1.14285714em;
  margin: 0em;
}
/* Left Corner */
.ui.left.corner.label,
.ui.left.corner.label:after {
  right: auto;
  left: 0em;
}
.ui.left.corner.label:after {
  border-top: 4em solid transparent;
  border-right: 4em solid transparent;
  border-bottom: 0em solid transparent;
  border-left: 0em solid transparent;
  border-top-color: inherit;
}
.ui.left.corner.label .icon {
  left: -0.78571429em;
}
/* Segment */
.ui.segment > .ui.corner.label {
  top: -1px;
  right: -1px;
}
.ui.segment > .ui.left.corner.label {
  right: auto;
  left: -1px;
}
/*-------------------
       Ribbon
--------------------*/
.ui.ribbon.label {
  position: relative;
  margin: 0em;
  min-width: max-content;
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
  border-color: rgba(0, 0, 0, 0.15);
}
.ui.ribbon.label:after {
  position: absolute;
  content: '';
  top: 100%;
  left: 0%;
  background-color: transparent !important;
  border-style: solid;
  border-width: 0em 1.2em 1.2em 0em;
  border-color: transparent;
  border-right-color: inherit;
  width: 0em;
  height: 0em;
}
/* Positioning */
.ui.ribbon.label {
  left: calc(-1rem - 1.2em);
  margin-right: -1.2em;
  padding-left: calc(1rem + 1.2em);
  padding-right: 1.2em;
}
.ui[class*="right ribbon"].label {
  left: calc(100% + 1rem + 1.2em);
  padding-left: 1.2em;
  padding-right: calc(1rem + 1.2em);
}
/* Right Ribbon */
.ui[class*="right ribbon"].label {
  text-align: left;
  transform: translateX(-100%);
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui[class*="right ribbon"].label:after {
  left: auto;
  right: 0%;
  border-style: solid;
  border-width: 1.2em 1.2em 0em 0em;
  border-color: transparent;
  border-top-color: inherit;
}
/* Inside Table */
.ui.image > .ribbon.label,
.ui.card .image > .ribbon.label {
  position: absolute;
  top: 1rem;
}
.ui.card .image > .ui.ribbon.label,
.ui.image > .ui.ribbon.label {
  left: calc(--0.05rem - 1.2em);
}
.ui.card .image > .ui[class*="right ribbon"].label,
.ui.image > .ui[class*="right ribbon"].label {
  left: calc(100% + -0.05rem + 1.2em);
  padding-left: 0.833em;
}
/* Inside Table */
.ui.table td > .ui.ribbon.label {
  left: calc(-0.78571429em - 1.2em);
}
.ui.table td > .ui[class*="right ribbon"].label {
  left: calc(100% + 0.78571429em + 1.2em);
  padding-left: 0.833em;
}
/*-------------------
      Attached
--------------------*/
.ui[class*="top attached"].label,
.ui.attached.label {
  width: 100%;
  position: absolute;
  margin: 0em;
  top: 0em;
  left: 0em;
  padding: 0.75em 1em;
  border-radius: 0.21428571rem 0.21428571rem 0em 0em;
}
.ui[class*="bottom attached"].label {
  top: auto;
  bottom: 0em;
  border-radius: 0em 0em 0.21428571rem 0.21428571rem;
}
.ui[class*="top left attached"].label {
  width: auto;
  margin-top: 0em !important;
  border-radius: 0.21428571rem 0em 0.28571429rem 0em;
}
.ui[class*="top right attached"].label {
  width: auto;
  left: auto;
  right: 0em;
  border-radius: 0em 0.21428571rem 0em 0.28571429rem;
}
.ui[class*="bottom left attached"].label {
  width: auto;
  top: auto;
  bottom: 0em;
  border-radius: 0em 0.28571429rem 0em 0.21428571rem;
}
.ui[class*="bottom right attached"].label {
  top: auto;
  bottom: 0em;
  left: auto;
  right: 0em;
  width: auto;
  border-radius: 0.28571429rem 0em 0.21428571rem 0em;
}
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
.ui.label.disabled {
  opacity: 0.5;
}
/*-------------------
        Hover
--------------------*/
a.ui.labels .label:hover,
a.ui.label:hover {
  background-color: #E0E0E0;
  border-color: #E0E0E0;
  background-image: none;
  color: rgba(255, 255, 255, 0.8);
}
.ui.labels a.label:hover:before,
a.ui.label:hover:before {
  color: rgba(255, 255, 255, 0.8);
}
/*-------------------
        Active
--------------------*/
.ui.active.label {
  background-color: #D0D0D0;
  border-color: #D0D0D0;
  background-image: none;
  color: rgba(255, 255, 255, 0.95);
}
.ui.active.label:before {
  background-color: #D0D0D0;
  background-image: none;
  color: rgba(255, 255, 255, 0.95);
}
/*-------------------
     Active Hover
--------------------*/
a.ui.labels .active.label:hover,
a.ui.active.label:hover {
  background-color: #C8C8C8;
  border-color: #C8C8C8;
  background-image: none;
  color: rgba(255, 255, 255, 0.95);
}
.ui.labels a.active.label:ActiveHover:before,
a.ui.active.label:ActiveHover:before {
  background-color: #C8C8C8;
  background-image: none;
  color: rgba(255, 255, 255, 0.95);
}
/*-------------------
      Visible
--------------------*/
.ui.labels.visible .label,
.ui.label.visible:not(.dropdown) {
  display: inline-block !important;
}
/*-------------------
      Hidden
--------------------*/
.ui.labels.hidden .label,
.ui.label.hidden {
  display: none !important;
}
/*******************************
           Variations
*******************************/
/*-------------------
       Colors
--------------------*/
/*--- Red ---*/
.ui.red.labels .label,
.ui.red.label {
  background-color: #DB2828 !important;
  border-color: #DB2828 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.red.labels .label:hover,
a.ui.red.label:hover {
  background-color: #d01919 !important;
  border-color: #d01919 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.red.corner.label,
.ui.red.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.red.ribbon.label {
  border-color: #b21e1e !important;
}
/* Basic */
.ui.basic.red.label {
  background: none #FFFFFF !important;
  color: #DB2828 !important;
  border-color: #DB2828 !important;
}
.ui.basic.red.labels a.label:hover,
a.ui.basic.red.label:hover {
  background-color: #FFFFFF !important;
  color: #d01919 !important;
  border-color: #d01919 !important;
}
/*--- Orange ---*/
.ui.orange.labels .label,
.ui.orange.label {
  background-color: #F2711C !important;
  border-color: #F2711C !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.orange.labels .label:hover,
a.ui.orange.label:hover {
  background-color: #f26202 !important;
  border-color: #f26202 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.orange.corner.label,
.ui.orange.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.orange.ribbon.label {
  border-color: #cf590c !important;
}
/* Basic */
.ui.basic.orange.label {
  background: none #FFFFFF !important;
  color: #F2711C !important;
  border-color: #F2711C !important;
}
.ui.basic.orange.labels a.label:hover,
a.ui.basic.orange.label:hover {
  background-color: #FFFFFF !important;
  color: #f26202 !important;
  border-color: #f26202 !important;
}
/*--- Yellow ---*/
.ui.yellow.labels .label,
.ui.yellow.label {
  background-color: #FBBD08 !important;
  border-color: #FBBD08 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.yellow.labels .label:hover,
a.ui.yellow.label:hover {
  background-color: #eaae00 !important;
  border-color: #eaae00 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.yellow.corner.label,
.ui.yellow.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.yellow.ribbon.label {
  border-color: #cd9903 !important;
}
/* Basic */
.ui.basic.yellow.label {
  background: none #FFFFFF !important;
  color: #FBBD08 !important;
  border-color: #FBBD08 !important;
}
.ui.basic.yellow.labels a.label:hover,
a.ui.basic.yellow.label:hover {
  background-color: #FFFFFF !important;
  color: #eaae00 !important;
  border-color: #eaae00 !important;
}
/*--- Olive ---*/
.ui.olive.labels .label,
.ui.olive.label {
  background-color: #B5CC18 !important;
  border-color: #B5CC18 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.olive.labels .label:hover,
a.ui.olive.label:hover {
  background-color: #a7bd0d !important;
  border-color: #a7bd0d !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.olive.corner.label,
.ui.olive.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.olive.ribbon.label {
  border-color: #198f35 !important;
}
/* Basic */
.ui.basic.olive.label {
  background: none #FFFFFF !important;
  color: #B5CC18 !important;
  border-color: #B5CC18 !important;
}
.ui.basic.olive.labels a.label:hover,
a.ui.basic.olive.label:hover {
  background-color: #FFFFFF !important;
  color: #a7bd0d !important;
  border-color: #a7bd0d !important;
}
/*--- Green ---*/
.ui.green.labels .label,
.ui.green.label {
  background-color: #21BA45 !important;
  border-color: #21BA45 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.green.labels .label:hover,
a.ui.green.label:hover {
  background-color: #16ab39 !important;
  border-color: #16ab39 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.green.corner.label,
.ui.green.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.green.ribbon.label {
  border-color: #198f35 !important;
}
/* Basic */
.ui.basic.green.label {
  background: none #FFFFFF !important;
  color: #21BA45 !important;
  border-color: #21BA45 !important;
}
.ui.basic.green.labels a.label:hover,
a.ui.basic.green.label:hover {
  background-color: #FFFFFF !important;
  color: #16ab39 !important;
  border-color: #16ab39 !important;
}
/*--- Teal ---*/
.ui.teal.labels .label,
.ui.teal.label {
  background-color: #00B5AD !important;
  border-color: #00B5AD !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.teal.labels .label:hover,
a.ui.teal.label:hover {
  background-color: #009c95 !important;
  border-color: #009c95 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.teal.corner.label,
.ui.teal.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.teal.ribbon.label {
  border-color: #00827c !important;
}
/* Basic */
.ui.basic.teal.label {
  background: none #FFFFFF !important;
  color: #00B5AD !important;
  border-color: #00B5AD !important;
}
.ui.basic.teal.labels a.label:hover,
a.ui.basic.teal.label:hover {
  background-color: #FFFFFF !important;
  color: #009c95 !important;
  border-color: #009c95 !important;
}
/*--- Blue ---*/
.ui.blue.labels .label,
.ui.blue.label {
  background-color: #2185D0 !important;
  border-color: #2185D0 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.blue.labels .label:hover,
a.ui.blue.label:hover {
  background-color: #1678c2 !important;
  border-color: #1678c2 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.blue.corner.label,
.ui.blue.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.blue.ribbon.label {
  border-color: #1a69a4 !important;
}
/* Basic */
.ui.basic.blue.label {
  background: none #FFFFFF !important;
  color: #2185D0 !important;
  border-color: #2185D0 !important;
}
.ui.basic.blue.labels a.label:hover,
a.ui.basic.blue.label:hover {
  background-color: #FFFFFF !important;
  color: #1678c2 !important;
  border-color: #1678c2 !important;
}
/*--- Violet ---*/
.ui.violet.labels .label,
.ui.violet.label {
  background-color: #6435C9 !important;
  border-color: #6435C9 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.violet.labels .label:hover,
a.ui.violet.label:hover {
  background-color: #5829bb !important;
  border-color: #5829bb !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.violet.corner.label,
.ui.violet.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.violet.ribbon.label {
  border-color: #502aa1 !important;
}
/* Basic */
.ui.basic.violet.label {
  background: none #FFFFFF !important;
  color: #6435C9 !important;
  border-color: #6435C9 !important;
}
.ui.basic.violet.labels a.label:hover,
a.ui.basic.violet.label:hover {
  background-color: #FFFFFF !important;
  color: #5829bb !important;
  border-color: #5829bb !important;
}
/*--- Purple ---*/
.ui.purple.labels .label,
.ui.purple.label {
  background-color: #A333C8 !important;
  border-color: #A333C8 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.purple.labels .label:hover,
a.ui.purple.label:hover {
  background-color: #9627ba !important;
  border-color: #9627ba !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.purple.corner.label,
.ui.purple.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.purple.ribbon.label {
  border-color: #82299f !important;
}
/* Basic */
.ui.basic.purple.label {
  background: none #FFFFFF !important;
  color: #A333C8 !important;
  border-color: #A333C8 !important;
}
.ui.basic.purple.labels a.label:hover,
a.ui.basic.purple.label:hover {
  background-color: #FFFFFF !important;
  color: #9627ba !important;
  border-color: #9627ba !important;
}
/*--- Pink ---*/
.ui.pink.labels .label,
.ui.pink.label {
  background-color: #E03997 !important;
  border-color: #E03997 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.pink.labels .label:hover,
a.ui.pink.label:hover {
  background-color: #e61a8d !important;
  border-color: #e61a8d !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.pink.corner.label,
.ui.pink.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.pink.ribbon.label {
  border-color: #c71f7e !important;
}
/* Basic */
.ui.basic.pink.label {
  background: none #FFFFFF !important;
  color: #E03997 !important;
  border-color: #E03997 !important;
}
.ui.basic.pink.labels a.label:hover,
a.ui.basic.pink.label:hover {
  background-color: #FFFFFF !important;
  color: #e61a8d !important;
  border-color: #e61a8d !important;
}
/*--- Brown ---*/
.ui.brown.labels .label,
.ui.brown.label {
  background-color: #A5673F !important;
  border-color: #A5673F !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.brown.labels .label:hover,
a.ui.brown.label:hover {
  background-color: #975b33 !important;
  border-color: #975b33 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.brown.corner.label,
.ui.brown.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.brown.ribbon.label {
  border-color: #805031 !important;
}
/* Basic */
.ui.basic.brown.label {
  background: none #FFFFFF !important;
  color: #A5673F !important;
  border-color: #A5673F !important;
}
.ui.basic.brown.labels a.label:hover,
a.ui.basic.brown.label:hover {
  background-color: #FFFFFF !important;
  color: #975b33 !important;
  border-color: #975b33 !important;
}
/*--- Grey ---*/
.ui.grey.labels .label,
.ui.grey.label {
  background-color: #767676 !important;
  border-color: #767676 !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.grey.labels .label:hover,
a.ui.grey.label:hover {
  background-color: #838383 !important;
  border-color: #838383 !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.grey.corner.label,
.ui.grey.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.grey.ribbon.label {
  border-color: #805031 !important;
}
/* Basic */
.ui.basic.grey.label {
  background: none #FFFFFF !important;
  color: #767676 !important;
  border-color: #767676 !important;
}
.ui.basic.grey.labels a.label:hover,
a.ui.basic.grey.label:hover {
  background-color: #FFFFFF !important;
  color: #838383 !important;
  border-color: #838383 !important;
}
/*--- Black ---*/
.ui.black.labels .label,
.ui.black.label {
  background-color: #1B1C1D !important;
  border-color: #1B1C1D !important;
  color: #FFFFFF !important;
}
/* Link */
.ui.black.labels .label:hover,
a.ui.black.label:hover {
  background-color: #27292a !important;
  border-color: #27292a !important;
  color: #FFFFFF !important;
}
/* Corner */
.ui.black.corner.label,
.ui.black.corner.label:hover {
  background-color: transparent !important;
}
/* Ribbon */
.ui.black.ribbon.label {
  border-color: #805031 !important;
}
/* Basic */
.ui.basic.black.label {
  background: none #FFFFFF !important;
  color: #1B1C1D !important;
  border-color: #1B1C1D !important;
}
.ui.basic.black.labels a.label:hover,
a.ui.basic.black.label:hover {
  background-color: #FFFFFF !important;
  color: #27292a !important;
  border-color: #27292a !important;
}
/*-------------------
        Basic
--------------------*/
.ui.basic.label {
  background: none #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.87);
  box-shadow: none;
}
/* Link */
a.ui.basic.label:hover {
  text-decoration: none;
  background: none #FFFFFF;
  color: #1e70bf;
  box-shadow: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: none;
}
/* Pointing */
.ui.basic.pointing.label:before {
  border-color: inherit;
}
/*-------------------
       Fluid
--------------------*/
.ui.label.fluid,
.ui.fluid.labels > .label {
  width: 100%;
  box-sizing: border-box;
}
/*-------------------
       Inverted
--------------------*/
.ui.inverted.labels .label,
.ui.inverted.label {
  color: rgba(255, 255, 255, 0.9) !important;
}
/*-------------------
     Horizontal
--------------------*/
.ui.horizontal.labels .label,
.ui.horizontal.label {
  margin: 0em 0.5em 0em 0em;
  padding: 0.4em 0.833em;
  min-width: 3em;
  text-align: center;
}
/*-------------------
       Circular
--------------------*/
.ui.circular.labels .label,
.ui.circular.label {
  min-width: 2em;
  min-height: 2em;
  padding: 0.5em !important;
  line-height: 1em;
  text-align: center;
  border-radius: 500rem;
}
.ui.empty.circular.labels .label,
.ui.empty.circular.label {
  min-width: 0em;
  min-height: 0em;
  overflow: hidden;
  width: 0.5em;
  height: 0.5em;
  vertical-align: baseline;
}
/*-------------------
       Pointing
--------------------*/
.ui.pointing.label {
  position: relative;
}
.ui.attached.pointing.label {
  position: absolute;
}
.ui.pointing.label:before {
  background-color: inherit;
  background-image: inherit;
  border-width: none;
  border-style: solid;
  border-color: inherit;
}
/* Arrow */
.ui.pointing.label:before {
  position: absolute;
  content: '';
  transform: rotate(45deg);
  background-image: none;
  z-index: 2;
  width: 0.6666em;
  height: 0.6666em;
  transition: background 0.1s ease;
}
/*--- Above ---*/
.ui.pointing.label,
.ui[class*="pointing above"].label {
  margin-top: 1em;
}
.ui.pointing.label:before,
.ui[class*="pointing above"].label:before {
  border-width: 1px 0px 0px 1px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 0%;
  left: 50%;
}
/*--- Below ---*/
.ui[class*="bottom pointing"].label,
.ui[class*="pointing below"].label {
  margin-top: 0em;
  margin-bottom: 1em;
}
.ui[class*="bottom pointing"].label:before,
.ui[class*="pointing below"].label:before {
  border-width: 0px 1px 1px 0px;
  top: auto;
  right: auto;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 100%;
  left: 50%;
}
/*--- Left ---*/
.ui[class*="left pointing"].label {
  margin-top: 0em;
  margin-left: 0.6666em;
}
.ui[class*="left pointing"].label:before {
  border-width: 0px 0px 1px 1px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  bottom: auto;
  right: auto;
  top: 50%;
  left: 0em;
}
/*--- Right ---*/
.ui[class*="right pointing"].label {
  margin-top: 0em;
  margin-right: 0.6666em;
}
.ui[class*="right pointing"].label:before {
  border-width: 1px 1px 0px 0px;
  transform: translateX(50%) translateY(-50%) rotate(45deg);
  top: 50%;
  right: 0%;
  bottom: auto;
  left: auto;
}
/* Basic Pointing */
/*--- Above ---*/
.ui.basic.pointing.label:before,
.ui.basic[class*="pointing above"].label:before {
  margin-top: -1px;
}
/*--- Below ---*/
.ui.basic[class*="bottom pointing"].label:before,
.ui.basic[class*="pointing below"].label:before {
  bottom: auto;
  top: 100%;
  margin-top: 1px;
}
/*--- Left ---*/
.ui.basic[class*="left pointing"].label:before {
  top: 50%;
  left: -1px;
}
/*--- Right ---*/
.ui.basic[class*="right pointing"].label:before {
  top: 50%;
  right: -1px;
}
/*------------------
   Floating Label
-------------------*/
.ui.floating.label {
  position: absolute;
  z-index: 100;
  top: -1em;
  left: 100%;
  margin: 0em 0em 0em -1.5em !important;
}
/*-------------------
        Sizes
--------------------*/
.ui.mini.labels .label,
.ui.mini.label {
  font-size: 0.64285714rem;
}
.ui.tiny.labels .label,
.ui.tiny.label {
  font-size: 0.71428571rem;
}
.ui.small.labels .label,
.ui.small.label {
  font-size: 0.78571429rem;
}
.ui.labels .label,
.ui.label {
  font-size: 0.85714286rem;
}
.ui.large.labels .label,
.ui.large.label {
  font-size: 1rem;
}
.ui.big.labels .label,
.ui.big.label {
  font-size: 1.28571429rem;
}
.ui.huge.labels .label,
.ui.huge.label {
  font-size: 1.42857143rem;
}
.ui.massive.labels .label,
.ui.massive.label {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - List
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             List
*******************************/
/*-------------------
         View
--------------------*/
/* List */
/* List Item */
/* Sub List */
/* Sub List Item */
/*-------------------
      Elements
--------------------*/
/* Icon */
/* Image */
/* Content */
/* Header */
/* Description */
/* Link */
/* Header Link */
/* Linked Icon */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Float */
/* Horizontal */
/* Inverted */
/* Link List */
/* Inverted Link List */
/* Selection List */
/* Selection List States */
/* Inverted Selection List */
/* Animated List */
/* Bulleted */
/* Horizontal Bullets */
/* Ordered List */
/* Horizontal Ordered */
/* Divided */
/* Divided Horizontal */
/* Divided */
/* Divided Horizontal */
/* Relaxed */
/* Very Relaxed */
/* Packaged Theme */
/*******************************
             List
*******************************/
/*-------------------
         View
--------------------*/
/* List */
/* List Item */
/* Sub List */
/* Sub List Item */
/*-------------------
      Elements
--------------------*/
/* Icon */
/* Image */
/* Content */
/* Header */
/* Description */
/* Link */
/* Header Link */
/* Linked Icon */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Float */
/* Horizontal */
/* Inverted */
/* Link List */
/* Inverted Link List */
/* Selection List */
/* Selection List States */
/* Inverted Selection List */
/* Animated List */
/* Bulleted */
/* Horizontal Bullets */
/* Ordered List */
/* Horizontal Ordered */
/* Divided */
/* Divided Horizontal */
/* Divided */
/* Divided Horizontal */
/* Relaxed */
/* Very Relaxed */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            List
*******************************/
ul.ui.list,
ol.ui.list,
.ui.list {
  list-style-type: none;
  margin: 1em 0em;
  padding: 0em 0em;
}
ul.ui.list:first-child,
ol.ui.list:first-child,
.ui.list:first-child {
  margin-top: 0em;
  padding-top: 0em;
}
ul.ui.list:last-child,
ol.ui.list:last-child,
.ui.list:last-child {
  margin-bottom: 0em;
  padding-bottom: 0em;
}
/*******************************
            Content
*******************************/
/* List Item */
ul.ui.list li,
ol.ui.list li,
.ui.list > .item,
.ui.list .list > .item {
  display: list-item;
  table-layout: fixed;
  list-style-type: none;
  list-style-position: outside;
  padding: 0.21428571em 0em;
  line-height: 1.14285714em;
}
ul.ui.list > li:first-child:after,
ol.ui.list > li:first-child:after,
.ui.list > .list > .item,
.ui.list > .item:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
ul.ui.list li:first-child,
ol.ui.list li:first-child,
.ui.list .list > .item:first-child,
.ui.list > .item:first-child {
  padding-top: 0em;
}
ul.ui.list li:last-child,
ol.ui.list li:last-child,
.ui.list .list > .item:last-child,
.ui.list > .item:last-child {
  padding-bottom: 0em;
}
/* Child List */
ul.ui.list ul,
ol.ui.list ol,
.ui.list .list {
  clear: both;
  margin: 0em;
  padding: 0.75em 0em 0.25em 0.5em;
}
/* Child Item */
ul.ui.list ul li,
ol.ui.list ol li,
.ui.list .list > .item {
  padding: 0.14285714em 0em;
  line-height: inherit;
}
/* Icon */
.ui.list .list > .item > i.icon,
.ui.list > .item > i.icon {
  display: table-cell;
  margin: 0em;
  padding-top: 0em;
  padding-right: 0.28571429em;
  vertical-align: top;
  transition: color 0.1s ease;
}
.ui.list .list > .item > i.icon:only-child,
.ui.list > .item > i.icon:only-child {
  display: inline-block;
  vertical-align: top;
}
/* Image */
.ui.list .list > .item > .image,
.ui.list > .item > .image {
  display: table-cell;
  background-color: transparent;
  margin: 0em;
  vertical-align: top;
}
.ui.list .list > .item > .image:not(:only-child):not(img),
.ui.list > .item > .image:not(:only-child):not(img) {
  padding-right: 0.5em;
}
.ui.list .list > .item > .image img,
.ui.list > .item > .image img {
  vertical-align: top;
}
.ui.list .list > .item > img.image,
.ui.list .list > .item > .image:only-child,
.ui.list > .item > img.image,
.ui.list > .item > .image:only-child {
  display: inline-block;
}
/* Content */
.ui.list .list > .item > .content,
.ui.list > .item > .content {
  line-height: 1.14285714em;
}
.ui.list .list > .item > .image + .content,
.ui.list .list > .item > .icon + .content,
.ui.list > .item > .image + .content,
.ui.list > .item > .icon + .content {
  display: table-cell;
  width: 100%;
  padding: 0em 0em 0em 0.5em;
  vertical-align: top;
}
.ui.list .list > .item > img.image + .content,
.ui.list > .item > img.image + .content {
  display: inline-block;
  width: auto;
}
.ui.list .list > .item > .content > .list,
.ui.list > .item > .content > .list {
  margin-left: 0em;
  padding-left: 0em;
}
/* Header */
.ui.list .list > .item .header,
.ui.list > .item .header {
  display: block;
  margin: 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.87);
}
/* Description */
.ui.list .list > .item .description,
.ui.list > .item .description {
  display: block;
  color: rgba(0, 0, 0, 0.7);
}
/* Child Link */
.ui.list > .item a,
.ui.list .list > .item a {
  cursor: pointer;
}
/* Linking Item */
.ui.list .list > a.item,
.ui.list > a.item {
  cursor: pointer;
  color: #4183C4;
}
.ui.list .list > a.item:hover,
.ui.list > a.item:hover {
  color: #1e70bf;
}
/* Linked Item Icons */
.ui.list .list > a.item i.icon,
.ui.list > a.item i.icon {
  color: rgba(255, 255, 255, 0.4);
}
/* Header Link */
.ui.list .list > .item a.header,
.ui.list > .item a.header {
  cursor: pointer;
  color: #4183C4 !important;
}
.ui.list .list > .item a.header:hover,
.ui.list > .item a.header:hover {
  color: #1e70bf !important;
}
/* Floated Content */
.ui[class*="left floated"].list {
  float: left;
}
.ui[class*="right floated"].list {
  float: right;
}
.ui.list .list > .item [class*="left floated"],
.ui.list > .item [class*="left floated"] {
  float: left;
  margin: 0em 1em 0em 0em;
}
.ui.list .list > .item [class*="right floated"],
.ui.list > .item [class*="right floated"] {
  float: right;
  margin: 0em 0em 0em 1em;
}
/*******************************
            Coupling
*******************************/
.ui.menu .ui.list > .item,
.ui.menu .ui.list .list > .item {
  display: list-item;
  table-layout: fixed;
  background-color: transparent;
  list-style-type: none;
  list-style-position: outside;
  padding: 0.21428571em 0em;
  line-height: 1.14285714em;
}
.ui.menu .ui.list .list > .item:before,
.ui.menu .ui.list > .item:before {
  border: none;
  background: none;
}
.ui.menu .ui.list .list > .item:first-child,
.ui.menu .ui.list > .item:first-child {
  padding-top: 0em;
}
.ui.menu .ui.list .list > .item:last-child,
.ui.menu .ui.list > .item:last-child {
  padding-bottom: 0em;
}
/*******************************
            Types
*******************************/
/*-------------------
      Horizontal
--------------------*/
.ui.horizontal.list {
  display: inline-block;
  font-size: 0em;
}
.ui.horizontal.list > .item {
  display: inline-block;
  margin-left: 1em;
  font-size: 1rem;
}
.ui.horizontal.list:not(.celled) > .item:first-child {
  margin-left: 0em !important;
  padding-left: 0em !important;
}
.ui.horizontal.list .list {
  padding-left: 0em;
  padding-bottom: 0em;
}
.ui.horizontal.list > .item > .image,
.ui.horizontal.list .list > .item > .image,
.ui.horizontal.list > .item > .icon,
.ui.horizontal.list .list > .item > .icon,
.ui.horizontal.list > .item > .content,
.ui.horizontal.list .list > .item > .content {
  vertical-align: middle;
}
/* Padding on all elements */
.ui.horizontal.list > .item:first-child,
.ui.horizontal.list > .item:last-child {
  padding-top: 0.21428571em;
  padding-bottom: 0.21428571em;
}
/* Horizontal List */
.ui.horizontal.list > .item > i.icon {
  margin: 0em;
  padding: 0em 0.25em 0em 0em;
}
.ui.horizontal.list > .item > .icon,
.ui.horizontal.list > .item > .icon + .content {
  float: none;
  display: inline-block;
}
/*******************************
             States
*******************************/
/*-------------------
       Disabled
--------------------*/
.ui.list .list > .disabled.item,
.ui.list > .disabled.item {
  pointer-events: none;
  color: rgba(40, 40, 40, 0.3) !important;
}
.ui.inverted.list .list > .disabled.item,
.ui.inverted.list > .disabled.item {
  color: rgba(225, 225, 225, 0.3) !important;
}
/*-------------------
        Hover
--------------------*/
.ui.list .list > a.item:hover .icon,
.ui.list > a.item:hover .icon {
  color: rgba(255, 255, 255, 0.87);
}
/*******************************
           Variations
*******************************/
/*-------------------
       Inverted
--------------------*/
.ui.inverted.list .list > a.item > .icon,
.ui.inverted.list > a.item > .icon {
  color: rgba(255, 255, 255, 0.7);
}
.ui.inverted.list .list > .item .header,
.ui.inverted.list > .item .header {
  color: rgba(255, 255, 255, 0.9);
}
.ui.inverted.list .list > .item .description,
.ui.inverted.list > .item .description {
  color: rgba(255, 255, 255, 0.7);
}
/* Item Link */
.ui.inverted.list .list > a.item,
.ui.inverted.list > a.item {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
}
.ui.inverted.list .list > a.item:hover,
.ui.inverted.list > a.item:hover {
  color: #1e70bf;
}
/* Linking Content */
.ui.inverted.list .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.9) !important;
}
.ui.inverted.list .item a:not(.ui):hover {
  color: #1e70bf !important;
}
/*-------------------
       Aligned
--------------------*/
.ui.list[class*="top aligned"] .image,
.ui.list[class*="top aligned"] .content,
.ui.list [class*="top aligned"] {
  vertical-align: top !important;
}
.ui.list[class*="middle aligned"] .image,
.ui.list[class*="middle aligned"] .content,
.ui.list [class*="middle aligned"] {
  vertical-align: middle !important;
}
.ui.list[class*="bottom aligned"] .image,
.ui.list[class*="bottom aligned"] .content,
.ui.list [class*="bottom aligned"] {
  vertical-align: bottom !important;
}
/*-------------------
       Link
--------------------*/
.ui.link.list .item,
.ui.link.list a.item,
.ui.link.list .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.4);
  transition: 0.1s color ease;
}
.ui.link.list.list a.item:hover,
.ui.link.list.list .item a:not(.ui):hover {
  color: rgba(255, 255, 255, 0.8);
}
.ui.link.list.list a.item:active,
.ui.link.list.list .item a:not(.ui):active {
  color: rgba(255, 255, 255, 0.9);
}
.ui.link.list.list .active.item,
.ui.link.list.list .active.item a:not(.ui) {
  color: rgba(255, 255, 255, 0.95);
}
/* Inverted */
.ui.inverted.link.list .item,
.ui.inverted.link.list a.item,
.ui.inverted.link.list .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
.ui.inverted.link.list.list a.item:hover,
.ui.inverted.link.list.list .item a:not(.ui):hover {
  color: #ffffff;
}
.ui.inverted.link.list.list a.item:active,
.ui.inverted.link.list.list .item a:not(.ui):active {
  color: #ffffff;
}
.ui.inverted.link.list.list a.active.item,
.ui.inverted.link.list.list .active.item a:not(.ui) {
  color: #ffffff;
}
/*-------------------
      Selection
--------------------*/
.ui.selection.list .list > .item,
.ui.selection.list > .item {
  cursor: pointer;
  background: transparent;
  padding: 0.5em 0.5em;
  margin: 0em;
  color: rgba(255, 255, 255, 0.4);
  border-radius: 0.5em;
  transition: 0.1s color ease, 0.1s padding-left ease, 0.1s background-color ease;
}
.ui.selection.list .list > .item:last-child,
.ui.selection.list > .item:last-child {
  margin-bottom: 0em;
}
.ui.selection.list.list > .item:hover,
.ui.selection.list > .item:hover {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(255, 255, 255, 0.8);
}
.ui.selection.list .list > .item:active,
.ui.selection.list > .item:active {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.9);
}
.ui.selection.list .list > .item.active,
.ui.selection.list > .item.active {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
/* Inverted */
.ui.inverted.selection.list > .item,
.ui.inverted.selection.list > .item {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
}
.ui.inverted.selection.list > .item:hover,
.ui.inverted.selection.list > .item:hover {
  background: rgba(255, 255, 255, 0.02);
  color: #ffffff;
}
.ui.inverted.selection.list > .item:active,
.ui.inverted.selection.list > .item:active {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.ui.inverted.selection.list > .item.active,
.ui.inverted.selection.list > .item.active {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
/* Celled / Divided Selection List */
.ui.celled.selection.list .list > .item,
.ui.divided.selection.list .list > .item,
.ui.celled.selection.list > .item,
.ui.divided.selection.list > .item {
  border-radius: 0em;
}
/*-------------------
       Animated
--------------------*/
.ui.animated.list > .item {
  transition: 0.25s color ease 0.1s, 0.25s padding-left ease 0.1s, 0.25s background-color ease 0.1s;
}
.ui.animated.list:not(.horizontal) > .item:hover {
  padding-left: 1em;
}
/*-------------------
       Fitted
--------------------*/
.ui.fitted.list:not(.selection) .list > .item,
.ui.fitted.list:not(.selection) > .item {
  padding-left: 0em;
  padding-right: 0em;
}
.ui.fitted.selection.list .list > .item,
.ui.fitted.selection.list > .item {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
/*-------------------
      Bulleted
--------------------*/
ul.ui.list,
.ui.bulleted.list {
  margin-left: 1.25rem;
}
ul.ui.list li,
.ui.bulleted.list .list > .item,
.ui.bulleted.list > .item {
  position: relative;
}
ul.ui.list li:before,
.ui.bulleted.list .list > .item:before,
.ui.bulleted.list > .item:before {
  user-select: none;
  pointer-events: none;
  position: absolute;
  top: auto;
  left: auto;
  font-weight: normal;
  margin-left: -1.25rem;
  content: '•';
  opacity: 1;
  color: inherit;
  vertical-align: top;
}
ul.ui.list li:before,
.ui.bulleted.list .list > a.item:before,
.ui.bulleted.list > a.item:before {
  color: rgba(255, 255, 255, 0.87);
}
ul.ui.list ul,
.ui.bulleted.list .list {
  padding-left: 1.25rem;
}
/* Horizontal Bulleted */
ul.ui.horizontal.bulleted.list,
.ui.horizontal.bulleted.list {
  margin-left: 0em;
}
ul.ui.horizontal.bulleted.list li,
.ui.horizontal.bulleted.list > .item {
  margin-left: 1.75rem;
}
ul.ui.horizontal.bulleted.list li:first-child,
.ui.horizontal.bulleted.list > .item:first-child {
  margin-left: 0em;
}
ul.ui.horizontal.bulleted.list li::before,
.ui.horizontal.bulleted.list > .item::before {
  color: rgba(255, 255, 255, 0.87);
}
ul.ui.horizontal.bulleted.list li:first-child::before,
.ui.horizontal.bulleted.list > .item:first-child::before {
  display: none;
}
/*-------------------
       Ordered
--------------------*/
ol.ui.list,
.ui.ordered.list,
.ui.ordered.list .list,
ol.ui.list ol {
  counter-reset: ordered;
  margin-left: 1.25rem;
  list-style-type: none;
}
ol.ui.list li,
.ui.ordered.list .list > .item,
.ui.ordered.list > .item {
  list-style-type: none;
  position: relative;
}
ol.ui.list li:before,
.ui.ordered.list .list > .item:before,
.ui.ordered.list > .item:before {
  position: absolute;
  top: auto;
  left: auto;
  user-select: none;
  pointer-events: none;
  margin-left: -1.25rem;
  counter-increment: ordered;
  content: counters(ordered, ".") " ";
  text-align: right;
  color: rgba(255, 255, 255, 0.87);
  vertical-align: middle;
  opacity: 0.8;
}
ol.ui.inverted.list li:before,
.ui.ordered.inverted.list .list > .item:before,
.ui.ordered.inverted.list > .item:before {
  color: rgba(255, 255, 255, 0.7);
}
/* Value */
.ui.ordered.list > .list > .item[data-value],
.ui.ordered.list > .item[data-value] {
  content: attr(data-value);
}
ol.ui.list li[value]:before {
  content: attr(value);
}
/* Child Lists */
ol.ui.list ol,
.ui.ordered.list .list {
  margin-left: 1em;
}
ol.ui.list ol li:before,
.ui.ordered.list .list > .item:before {
  margin-left: -2em;
}
/* Horizontal Ordered */
ol.ui.horizontal.list,
.ui.ordered.horizontal.list {
  margin-left: 0em;
}
ol.ui.horizontal.list li:before,
.ui.ordered.horizontal.list .list > .item:before,
.ui.ordered.horizontal.list > .item:before {
  position: static;
  margin: 0em 0.5em 0em 0em;
}
/*-------------------
       Divided
--------------------*/
.ui.divided.list > .item {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.divided.list .list > .item {
  border-top: none;
}
.ui.divided.list .item .list > .item {
  border-top: none;
}
.ui.divided.list .list > .item:first-child,
.ui.divided.list > .item:first-child {
  border-top: none;
}
/* Sub Menu */
.ui.divided.list:not(.horizontal) .list > .item:first-child {
  border-top-width: 1px;
}
/* Divided bulleted */
.ui.divided.bulleted.list:not(.horizontal),
.ui.divided.bulleted.list .list {
  margin-left: 0em;
  padding-left: 0em;
}
.ui.divided.bulleted.list > .item:not(.horizontal) {
  padding-left: 1.25rem;
}
/* Divided Ordered */
.ui.divided.ordered.list {
  margin-left: 0em;
}
.ui.divided.ordered.list .list > .item,
.ui.divided.ordered.list > .item {
  padding-left: 1.25rem;
}
.ui.divided.ordered.list .item .list {
  margin-left: 0em;
  margin-right: 0em;
  padding-bottom: 0.21428571em;
}
.ui.divided.ordered.list .item .list > .item {
  padding-left: 1em;
}
/* Divided Selection */
.ui.divided.selection.list .list > .item,
.ui.divided.selection.list > .item {
  margin: 0em;
  border-radius: 0em;
}
/* Divided horizontal */
.ui.divided.horizontal.list {
  margin-left: 0em;
}
.ui.divided.horizontal.list > .item:not(:first-child) {
  padding-left: 0.5em;
}
.ui.divided.horizontal.list > .item:not(:last-child) {
  padding-right: 0.5em;
}
.ui.divided.horizontal.list > .item {
  border-top: none;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  margin: 0em;
  line-height: 0.6;
}
.ui.horizontal.divided.list > .item:first-child {
  border-left: none;
}
/* Inverted */
.ui.divided.inverted.list > .item,
.ui.divided.inverted.list > .list,
.ui.divided.inverted.horizontal.list > .item {
  border-color: rgba(255, 255, 255, 0.1);
}
/*-------------------
        Celled
--------------------*/
.ui.celled.list > .item,
.ui.celled.list > .list {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.ui.celled.list > .item:last-child {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
/* Padding on all elements */
.ui.celled.list > .item:first-child,
.ui.celled.list > .item:last-child {
  padding-top: 0.21428571em;
  padding-bottom: 0.21428571em;
}
/* Sub Menu */
.ui.celled.list .item .list > .item {
  border-width: 0px;
}
.ui.celled.list .list > .item:first-child {
  border-top-width: 0px;
}
/* Celled Bulleted */
.ui.celled.bulleted.list {
  margin-left: 0em;
}
.ui.celled.bulleted.list .list > .item,
.ui.celled.bulleted.list > .item {
  padding-left: 1.25rem;
}
.ui.celled.bulleted.list .item .list {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding-bottom: 0.21428571em;
}
/* Celled Ordered */
.ui.celled.ordered.list {
  margin-left: 0em;
}
.ui.celled.ordered.list .list > .item,
.ui.celled.ordered.list > .item {
  padding-left: 1.25rem;
}
.ui.celled.ordered.list .item .list {
  margin-left: 0em;
  margin-right: 0em;
  padding-bottom: 0.21428571em;
}
.ui.celled.ordered.list .list > .item {
  padding-left: 1em;
}
/* Celled Horizontal */
.ui.horizontal.celled.list {
  margin-left: 0em;
}
.ui.horizontal.celled.list .list > .item,
.ui.horizontal.celled.list > .item {
  border-top: none;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  margin: 0em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  line-height: 0.6;
}
.ui.horizontal.celled.list .list > .item:last-child,
.ui.horizontal.celled.list > .item:last-child {
  border-bottom: none;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
}
/* Inverted */
.ui.celled.inverted.list > .item,
.ui.celled.inverted.list > .list {
  border-color: 1px solid rgba(255, 255, 255, 0.1);
}
.ui.celled.inverted.horizontal.list .list > .item,
.ui.celled.inverted.horizontal.list > .item {
  border-color: 1px solid rgba(255, 255, 255, 0.1);
}
/*-------------------
       Relaxed
--------------------*/
.ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {
  padding-top: 0.42857143em;
}
.ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {
  padding-bottom: 0.42857143em;
}
.ui.horizontal.relaxed.list .list > .item:not(:first-child),
.ui.horizontal.relaxed.list > .item:not(:first-child) {
  padding-left: 1rem;
}
.ui.horizontal.relaxed.list .list > .item:not(:last-child),
.ui.horizontal.relaxed.list > .item:not(:last-child) {
  padding-right: 1rem;
}
/* Very Relaxed */
.ui[class*="very relaxed"].list:not(.horizontal) > .item:not(:first-child) {
  padding-top: 0.85714286em;
}
.ui[class*="very relaxed"].list:not(.horizontal) > .item:not(:last-child) {
  padding-bottom: 0.85714286em;
}
.ui.horizontal[class*="very relaxed"].list .list > .item:not(:first-child),
.ui.horizontal[class*="very relaxed"].list > .item:not(:first-child) {
  padding-left: 1.5rem;
}
.ui.horizontal[class*="very relaxed"].list .list > .item:not(:last-child),
.ui.horizontal[class*="very relaxed"].list > .item:not(:last-child) {
  padding-right: 1.5rem;
}
/*-------------------
      Sizes
--------------------*/
.ui.mini.list {
  font-size: 0.78571429em;
}
.ui.tiny.list {
  font-size: 0.85714286em;
}
.ui.small.list {
  font-size: 0.92857143em;
}
.ui.list {
  font-size: 1em;
}
.ui.large.list {
  font-size: 1.14285714em;
}
.ui.big.list {
  font-size: 1.28571429em;
}
.ui.huge.list {
  font-size: 1.42857143em;
}
.ui.massive.list {
  font-size: 1.71428571em;
}
.ui.mini.horizontal.list .list > .item,
.ui.mini.horizontal.list > .item {
  font-size: 0.78571429rem;
}
.ui.tiny.horizontal.list .list > .item,
.ui.tiny.horizontal.list > .item {
  font-size: 0.85714286rem;
}
.ui.small.horizontal.list .list > .item,
.ui.small.horizontal.list > .item {
  font-size: 0.92857143rem;
}
.ui.horizontal.list .list > .item,
.ui.horizontal.list > .item {
  font-size: 1rem;
}
.ui.large.horizontal.list .list > .item,
.ui.large.horizontal.list > .item {
  font-size: 1.14285714rem;
}
.ui.big.horizontal.list .list > .item,
.ui.big.horizontal.list > .item {
  font-size: 1.28571429rem;
}
.ui.huge.horizontal.list .list > .item,
.ui.huge.horizontal.list > .item {
  font-size: 1.42857143rem;
}
.ui.massive.horizontal.list .list > .item,
.ui.massive.horizontal.list > .item {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Loader
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Loader
*******************************/
/* Some global loader styles defined in site.variables */
/*-------------------
      Standard
--------------------*/
/*-------------------
        Types
--------------------*/
/* Text */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Exact Sizes (Avoids Rounding Errors) */
/* Packaged Theme */
/*******************************
             Loader
*******************************/
/* Some global loader styles defined in site.variables */
/*-------------------
      Standard
--------------------*/
/*-------------------
        Types
--------------------*/
/* Text */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Exact Sizes (Avoids Rounding Errors) */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Loader
*******************************/
/* Standard Size */
.ui.loader {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0px;
  text-align: center;
  z-index: 1000;
  transform: translateX(-50%) translateY(-50%);
}
/* Static Shape */
.ui.loader:before {
  position: absolute;
  content: '';
  top: 0%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
/* Active Shape */
.ui.loader:after {
  position: absolute;
  content: '';
  top: 0%;
  left: 50%;
  width: 100%;
  height: 100%;
  animation: loader 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
/* Active Animation */
@keyframes loader {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Sizes */
.ui.mini.loader:before,
.ui.mini.loader:after {
  width: 1rem;
  height: 1rem;
  margin: 0em 0em 0em -0.5rem;
}
.ui.tiny.loader:before,
.ui.tiny.loader:after {
  width: 1.14285714rem;
  height: 1.14285714rem;
  margin: 0em 0em 0em -0.57142857rem;
}
.ui.small.loader:before,
.ui.small.loader:after {
  width: 1.71428571rem;
  height: 1.71428571rem;
  margin: 0em 0em 0em -0.85714286rem;
}
.ui.loader:before,
.ui.loader:after {
  width: 2.28571429rem;
  height: 2.28571429rem;
  margin: 0em 0em 0em -1.14285714rem;
}
.ui.large.loader:before,
.ui.large.loader:after {
  width: 3.42857143rem;
  height: 3.42857143rem;
  margin: 0em 0em 0em -1.71428571rem;
}
.ui.big.loader:before,
.ui.big.loader:after {
  width: 3.71428571rem;
  height: 3.71428571rem;
  margin: 0em 0em 0em -1.85714286rem;
}
.ui.huge.loader:before,
.ui.huge.loader:after {
  width: 4.14285714rem;
  height: 4.14285714rem;
  margin: 0em 0em 0em -2.07142857rem;
}
.ui.massive.loader:before,
.ui.massive.loader:after {
  width: 4.57142857rem;
  height: 4.57142857rem;
  margin: 0em 0em 0em -2.28571429rem;
}
/*-------------------
      Coupling
--------------------*/
/* Show inside active dimmer */
.ui.dimmer .loader {
  display: block;
}
/* Black Dimmer */
.ui.dimmer .ui.loader {
  color: rgba(255, 255, 255, 0.9);
}
.ui.dimmer .ui.loader:before {
  border-color: rgba(255, 255, 255, 0.15);
}
.ui.dimmer .ui.loader:after {
  border-color: #FFFFFF transparent transparent;
}
/* White Dimmer (Inverted) */
.ui.inverted.dimmer .ui.loader {
  color: rgba(255, 255, 255, 0.87);
}
.ui.inverted.dimmer .ui.loader:before {
  border-color: rgba(0, 0, 0, 0.1);
}
.ui.inverted.dimmer .ui.loader:after {
  border-color: #767676 transparent transparent;
}
/*******************************
             Types
*******************************/
/*-------------------
        Text
--------------------*/
.ui.text.loader {
  width: auto !important;
  height: auto !important;
  text-align: center;
  font-style: normal;
}
/*******************************
            States
*******************************/
.ui.indeterminate.loader:after {
  animation-direction: reverse;
  animation-duration: 1.2s;
}
.ui.loader.active,
.ui.loader.visible {
  display: block;
}
.ui.loader.disabled,
.ui.loader.hidden {
  display: none;
}
/*******************************
            Variations
*******************************/
/*-------------------
        Sizes
--------------------*/
/* Loader */
.ui.inverted.dimmer .ui.mini.loader,
.ui.mini.loader {
  width: 1rem;
  height: 1rem;
  font-size: 0.78571429em;
}
.ui.inverted.dimmer .ui.tiny.loader,
.ui.tiny.loader {
  width: 1.14285714rem;
  height: 1.14285714rem;
  font-size: 0.85714286em;
}
.ui.inverted.dimmer .ui.small.loader,
.ui.small.loader {
  width: 1.71428571rem;
  height: 1.71428571rem;
  font-size: 0.92857143em;
}
.ui.inverted.dimmer .ui.loader,
.ui.loader {
  width: 2.28571429rem;
  height: 2.28571429rem;
  font-size: 1em;
}
.ui.inverted.dimmer .ui.large.loader,
.ui.large.loader {
  width: 3.42857143rem;
  height: 3.42857143rem;
  font-size: 1.14285714em;
}
.ui.inverted.dimmer .ui.big.loader,
.ui.big.loader {
  width: 3.71428571rem;
  height: 3.71428571rem;
  font-size: 1.28571429em;
}
.ui.inverted.dimmer .ui.huge.loader,
.ui.huge.loader {
  width: 4.14285714rem;
  height: 4.14285714rem;
  font-size: 1.42857143em;
}
.ui.inverted.dimmer .ui.massive.loader,
.ui.massive.loader {
  width: 4.57142857rem;
  height: 4.57142857rem;
  font-size: 1.71428571em;
}
/* Text Loader */
.ui.mini.text.loader {
  min-width: 1rem;
  padding-top: 1.78571429rem;
}
.ui.tiny.text.loader {
  min-width: 1.14285714rem;
  padding-top: 1.92857143rem;
}
.ui.small.text.loader {
  min-width: 1.71428571rem;
  padding-top: 2.5rem;
}
.ui.text.loader {
  min-width: 2.28571429rem;
  padding-top: 3.07142857rem;
}
.ui.large.text.loader {
  min-width: 3.42857143rem;
  padding-top: 4.21428571rem;
}
.ui.big.text.loader {
  min-width: 3.71428571rem;
  padding-top: 4.5rem;
}
.ui.huge.text.loader {
  min-width: 4.14285714rem;
  padding-top: 4.92857143rem;
}
.ui.massive.text.loader {
  min-width: 4.57142857rem;
  padding-top: 5.35714286rem;
}
/*-------------------
       Inverted
--------------------*/
.ui.inverted.loader {
  color: rgba(255, 255, 255, 0.9);
}
.ui.inverted.loader:before {
  border-color: rgba(255, 255, 255, 0.15);
}
.ui.inverted.loader:after {
  border-top-color: #FFFFFF;
}
/*-------------------
       Inline
--------------------*/
.ui.inline.loader {
  position: relative;
  vertical-align: middle;
  margin: 0em;
  left: 0em;
  top: 0em;
  transform: none;
}
.ui.inline.loader.active,
.ui.inline.loader.visible {
  display: inline-block;
}
/* Centered Inline */
.ui.centered.inline.loader.active,
.ui.centered.inline.loader.visible {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Loader
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/* Key Content Sizing */
/* Interval between consecutive placeholders */
/* Repeated Placeholder */
/* Image */
/* Header Image */
/* Paragraph */
/* Glow Gradient */
/* Variations */
/* Packaged Theme */
/* Key Content Sizing */
/* Interval between consecutive placeholders */
/* Repeated Placeholder */
/* Image */
/* Header Image */
/* Paragraph */
/* Glow Gradient */
/* Variations */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*-------------------
      Content
--------------------*/
.ui.placeholder {
  position: static;
  overflow: hidden;
  animation: placeholderShimmer 2s linear;
  animation-iteration-count: infinite;
  background-color: #FFFFFF;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.15) 15%, rgba(0, 0, 0, 0.08) 30%);
  background-size: 1200px 100%;
  max-width: 30rem;
}
@keyframes placeholderShimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
.ui.placeholder + .ui.placeholder {
  margin-top: 2rem;
}
.ui.placeholder + .ui.placeholder {
  animation-delay: 0.15s;
}
.ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.3s;
}
.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.45s;
}
.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.6s;
}
.ui.placeholder,
.ui.placeholder > :before,
.ui.placeholder .image.header:after,
.ui.placeholder .line,
.ui.placeholder .line:after {
  background-color: #FFFFFF;
}
/* Image */
.ui.placeholder .image:not(.header):not(.ui) {
  height: 100px;
}
.ui.placeholder .square.image:not(.header) {
  height: 0px;
  overflow: hidden;
  /* 1/1 aspect ratio */
  padding-top: 100%;
}
.ui.placeholder .rectangular.image:not(.header) {
  height: 0px;
  overflow: hidden;
  /* 4/3 aspect ratio */
  padding-top: 75%;
}
/* Lines */
.ui.placeholder .line {
  position: relative;
  height: 0.85714286em;
}
.ui.placeholder .line:before,
.ui.placeholder .line:after {
  top: 100%;
  position: absolute;
  content: '';
  background-color: inherit;
}
.ui.placeholder .line:before {
  left: 0px;
}
.ui.placeholder .line:after {
  right: 0px;
}
/* Any Lines */
.ui.placeholder .line {
  margin-bottom: 0.5em;
}
.ui.placeholder .line:before,
.ui.placeholder .line:after {
  height: 0.5em;
}
.ui.placeholder .line:not(:first-child) {
  margin-top: 0.5em;
}
/* Header Image + 2 Lines */
.ui.placeholder .header {
  position: relative;
  overflow: hidden;
}
/* Line Outdent */
.ui.placeholder .line:nth-child(1):after {
  width: 0%;
}
.ui.placeholder .line:nth-child(2):after {
  width: 50%;
}
.ui.placeholder .line:nth-child(3):after {
  width: 10%;
}
.ui.placeholder .line:nth-child(4):after {
  width: 35%;
}
.ui.placeholder .line:nth-child(5):after {
  width: 65%;
}
/* Header Line 1 & 2*/
.ui.placeholder .header .line {
  margin-bottom: 0.64285714em;
}
.ui.placeholder .header .line:before,
.ui.placeholder .header .line:after {
  height: 0.64285714em;
}
.ui.placeholder .header .line:not(:first-child) {
  margin-top: 0.64285714em;
}
.ui.placeholder .header .line:after {
  width: 20%;
}
.ui.placeholder .header .line:nth-child(2):after {
  width: 60%;
}
/* Image Header */
.ui.placeholder .image.header .line {
  margin-left: 3em;
}
.ui.placeholder .image.header .line:before {
  width: 0.71428571rem;
}
.ui.placeholder .image.header:after {
  display: block;
  height: 0.85714286em;
  content: '';
  margin-left: 3em;
}
/* Spacing */
.ui.placeholder .image .line:first-child,
.ui.placeholder .paragraph .line:first-child,
.ui.placeholder .header .line:first-child {
  height: 0.01px;
}
.ui.placeholder .image:not(:first-child):before,
.ui.placeholder .paragraph:not(:first-child):before,
.ui.placeholder .header:not(:first-child):before {
  height: 1.42857143em;
  content: '';
  display: block;
}
/* Inverted Content Loader */
.ui.inverted.placeholder {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.14) 15%, rgba(255, 255, 255, 0.08) 30%);
}
.ui.inverted.placeholder,
.ui.inverted.placeholder > :before,
.ui.inverted.placeholder .image.header:after,
.ui.inverted.placeholder .line,
.ui.inverted.placeholder .line:after {
  background-color: #1B1C1D;
}
/*******************************
            Variations
*******************************/
/*-------------------
        Sizes
--------------------*/
.ui.placeholder .full.line.line.line:after {
  width: 0%;
}
.ui.placeholder .very.long.line.line.line:after {
  width: 10%;
}
.ui.placeholder .long.line.line.line:after {
  width: 35%;
}
.ui.placeholder .medium.line.line.line:after {
  width: 50%;
}
.ui.placeholder .short.line.line.line:after {
  width: 65%;
}
.ui.placeholder .very.short.line.line.line:after {
  width: 80%;
}
/*-------------------
        Fluid
--------------------*/
.ui.fluid.placeholder {
  max-width: none;
}
/*!
 * # Semantic UI - Rail
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Rail
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Close */
/* Dividing */
/* Packaged Theme */
/*******************************
            Rail
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Close */
/* Dividing */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Rails
*******************************/
.ui.rail {
  position: absolute;
  top: 0%;
  width: 300px;
  height: 100%;
}
.ui.left.rail {
  left: auto;
  right: 100%;
  padding: 0em 2rem 0em 0em;
  margin: 0em 2rem 0em 0em;
}
.ui.right.rail {
  left: 100%;
  right: auto;
  padding: 0em 0em 0em 2rem;
  margin: 0em 0em 0em 2rem;
}
/*******************************
           Variations
*******************************/
/*--------------
     Internal
---------------*/
.ui.left.internal.rail {
  left: 0%;
  right: auto;
  padding: 0em 0em 0em 2rem;
  margin: 0em 0em 0em 2rem;
}
.ui.right.internal.rail {
  left: auto;
  right: 0%;
  padding: 0em 2rem 0em 0em;
  margin: 0em 2rem 0em 0em;
}
/*--------------
    Dividing
---------------*/
.ui.dividing.rail {
  width: 302.5px;
}
.ui.left.dividing.rail {
  padding: 0em 2.5rem 0em 0em;
  margin: 0em 2.5rem 0em 0em;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.right.dividing.rail {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  padding: 0em 0em 0em 2.5rem;
  margin: 0em 0em 0em 2.5rem;
}
/*--------------
    Distance
---------------*/
.ui.close.rail {
  width: calc( 300px  +  1em );
}
.ui.close.left.rail {
  padding: 0em 1em 0em 0em;
  margin: 0em 1em 0em 0em;
}
.ui.close.right.rail {
  padding: 0em 0em 0em 1em;
  margin: 0em 0em 0em 1em;
}
.ui.very.close.rail {
  width: calc( 300px  +  0.5em );
}
.ui.very.close.left.rail {
  padding: 0em 0.5em 0em 0em;
  margin: 0em 0.5em 0em 0em;
}
.ui.very.close.right.rail {
  padding: 0em 0em 0em 0.5em;
  margin: 0em 0em 0em 0.5em;
}
/*--------------
    Attached
---------------*/
.ui.attached.left.rail,
.ui.attached.right.rail {
  padding: 0em;
  margin: 0em;
}
/*--------------
     Sizing
---------------*/
.ui.mini.rail {
  font-size: 0.78571429rem;
}
.ui.tiny.rail {
  font-size: 0.85714286rem;
}
.ui.small.rail {
  font-size: 0.92857143rem;
}
.ui.rail {
  font-size: 1rem;
}
.ui.large.rail {
  font-size: 1.14285714rem;
}
.ui.big.rail {
  font-size: 1.28571429rem;
}
.ui.huge.rail {
  font-size: 1.42857143rem;
}
.ui.massive.rail {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Reveal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Reveal
*******************************/
/* Types */
/* Packaged Theme */
/*******************************
            Reveal
*******************************/
/* Types */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Reveal
*******************************/
.ui.reveal {
  display: inherit;
  position: relative !important;
  font-size: 0em !important;
}
.ui.reveal > .visible.content {
  position: absolute !important;
  top: 0em !important;
  left: 0em !important;
  z-index: 3 !important;
  transition: all 0.5s ease 0.1s;
}
.ui.reveal > .hidden.content {
  position: relative !important;
  z-index: 2 !important;
}
/* Make sure hovered element is on top of other reveal */
.ui.active.reveal .visible.content,
.ui.reveal:hover .visible.content {
  z-index: 4 !important;
}
/*******************************
              Types
*******************************/
/*--------------
      Slide
---------------*/
.ui.slide.reveal {
  position: relative !important;
  overflow: hidden !important;
  white-space: nowrap;
}
.ui.slide.reveal > .content {
  display: block;
  width: 100%;
  white-space: normal;
  float: left;
  margin: 0em;
  transition: transform 0.5s ease 0.1s;
}
.ui.slide.reveal > .visible.content {
  position: relative !important;
}
.ui.slide.reveal > .hidden.content {
  position: absolute !important;
  left: 0% !important;
  width: 100% !important;
  transform: translateX(100%) !important;
}
.ui.slide.active.reveal > .visible.content,
.ui.slide.reveal:hover > .visible.content {
  transform: translateX(-100%) !important;
}
.ui.slide.active.reveal > .hidden.content,
.ui.slide.reveal:hover > .hidden.content {
  transform: translateX(0%) !important;
}
.ui.slide.right.reveal > .visible.content {
  transform: translateX(0%) !important;
}
.ui.slide.right.reveal > .hidden.content {
  transform: translateX(-100%) !important;
}
.ui.slide.right.active.reveal > .visible.content,
.ui.slide.right.reveal:hover > .visible.content {
  transform: translateX(100%) !important;
}
.ui.slide.right.active.reveal > .hidden.content,
.ui.slide.right.reveal:hover > .hidden.content {
  transform: translateX(0%) !important;
}
.ui.slide.up.reveal > .hidden.content {
  transform: translateY(100%) !important;
}
.ui.slide.up.active.reveal > .visible.content,
.ui.slide.up.reveal:hover > .visible.content {
  transform: translateY(-100%) !important;
}
.ui.slide.up.active.reveal > .hidden.content,
.ui.slide.up.reveal:hover > .hidden.content {
  transform: translateY(0%) !important;
}
.ui.slide.down.reveal > .hidden.content {
  transform: translateY(-100%) !important;
}
.ui.slide.down.active.reveal > .visible.content,
.ui.slide.down.reveal:hover > .visible.content {
  transform: translateY(100%) !important;
}
.ui.slide.down.active.reveal > .hidden.content,
.ui.slide.down.reveal:hover > .hidden.content {
  transform: translateY(0%) !important;
}
/*--------------
      Fade
---------------*/
.ui.fade.reveal > .visible.content {
  opacity: 1;
}
.ui.fade.active.reveal > .visible.content,
.ui.fade.reveal:hover > .visible.content {
  opacity: 0;
}
/*--------------
      Move
---------------*/
.ui.move.reveal {
  position: relative !important;
  overflow: hidden !important;
  white-space: nowrap;
}
.ui.move.reveal > .content {
  display: block;
  float: left;
  white-space: normal;
  margin: 0em;
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;
}
.ui.move.reveal > .visible.content {
  position: relative !important;
}
.ui.move.reveal > .hidden.content {
  position: absolute !important;
  left: 0% !important;
  width: 100% !important;
}
.ui.move.active.reveal > .visible.content,
.ui.move.reveal:hover > .visible.content {
  transform: translateX(-100%) !important;
}
.ui.move.right.active.reveal > .visible.content,
.ui.move.right.reveal:hover > .visible.content {
  transform: translateX(100%) !important;
}
.ui.move.up.active.reveal > .visible.content,
.ui.move.up.reveal:hover > .visible.content {
  transform: translateY(-100%) !important;
}
.ui.move.down.active.reveal > .visible.content,
.ui.move.down.reveal:hover > .visible.content {
  transform: translateY(100%) !important;
}
/*--------------
     Rotate
---------------*/
.ui.rotate.reveal > .visible.content {
  transition-duration: 0.5s;
  transform: rotate(0deg);
}
.ui.rotate.reveal > .visible.content,
.ui.rotate.right.reveal > .visible.content {
  transform-origin: bottom right;
}
.ui.rotate.active.reveal > .visible.content,
.ui.rotate.reveal:hover > .visible.content,
.ui.rotate.right.active.reveal > .visible.content,
.ui.rotate.right.reveal:hover > .visible.content {
  transform: rotate(110deg);
}
.ui.rotate.left.reveal > .visible.content {
  transform-origin: bottom left;
}
.ui.rotate.left.active.reveal > .visible.content,
.ui.rotate.left.reveal:hover > .visible.content {
  transform: rotate(-110deg);
}
/*******************************
              States
*******************************/
.ui.disabled.reveal:hover > .visible.visible.content {
  position: static !important;
  display: block !important;
  opacity: 1 !important;
  top: 0 !important;
  left: 0 !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
}
.ui.disabled.reveal:hover > .hidden.hidden.content {
  display: none !important;
}
/*******************************
           Coupling
*******************************/
.ui.reveal > .ui.ribbon.label {
  z-index: 5;
}
/*******************************
           Variations
*******************************/
/*--------------
     Visible
---------------*/
.ui.visible.reveal {
  overflow: visible;
}
/*--------------
     Instant
---------------*/
.ui.instant.reveal > .content {
  transition-delay: 0s !important;
}
/*--------------
     Sizing
---------------*/
.ui.reveal > .content {
  font-size: 1rem !important;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Segment
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Segment
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Group
--------------------*/
/*-------------------
       Coupling
--------------------*/
/* Page Grid Segment */
/*******************************
            Types
*******************************/
/* Placeholder */
/* Piled */
/* Circular */
/* Stacked */
/*******************************
            States
*******************************/
/* Loading Dimmer */
/* Loading Spinner */
/*******************************
            Variations
*******************************/
/* Raised */
/* Padded */
/* Attached */
/* Inverted */
/* Floated */
/* Basic */
/* Colors */
/* Ordinality */
/* Packaged Theme */
/*******************************
            Segment
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Group
--------------------*/
/*-------------------
       Coupling
--------------------*/
/* Page Grid Segment */
/*******************************
            Types
*******************************/
/* Placeholder */
/* Piled */
/* Circular */
/* Stacked */
/*******************************
            States
*******************************/
/* Loading Dimmer */
/* Loading Spinner */
/*******************************
            Variations
*******************************/
/* Raised */
/* Padded */
/* Attached */
/* Inverted */
/* Floated */
/* Basic */
/* Colors */
/* Ordinality */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Segment
*******************************/
.ui.segment {
  position: relative;
  background: rgba(0, 0, 0, 0);
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
  margin: 1rem 0em;
  padding: 1em 1em;
  border-radius: 0.28571429rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.segment:first-child {
  margin-top: 0em;
}
.ui.segment:last-child {
  margin-bottom: 0em;
}
/* Vertical */
.ui.vertical.segment {
  margin: 0em;
  padding-left: 0em;
  padding-right: 0em;
  background: none transparent;
  border-radius: 0px;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.vertical.segment:last-child {
  border-bottom: none;
}
/*-------------------
    Loose Coupling
--------------------*/
/* Header */
.ui.inverted.segment > .ui.header {
  color: #FFFFFF;
}
/* Label */
.ui[class*="bottom attached"].segment > [class*="top attached"].label {
  border-top-left-radius: 0em;
  border-top-right-radius: 0em;
}
.ui[class*="top attached"].segment > [class*="bottom attached"].label {
  border-bottom-left-radius: 0em;
  border-bottom-right-radius: 0em;
}
.ui.attached.segment:not(.top):not(.bottom) > [class*="top attached"].label {
  border-top-left-radius: 0em;
  border-top-right-radius: 0em;
}
.ui.attached.segment:not(.top):not(.bottom) > [class*="bottom attached"].label {
  border-bottom-left-radius: 0em;
  border-bottom-right-radius: 0em;
}
/* Grid */
.ui.page.grid.segment,
.ui.grid > .row > .ui.segment.column,
.ui.grid > .ui.segment.column {
  padding-top: 2em;
  padding-bottom: 2em;
}
.ui.grid.segment {
  margin: 1rem 0em;
  border-radius: 0.28571429rem;
}
/* Table */
.ui.basic.table.segment {
  background: rgba(0, 0, 0, 0);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
}
.ui[class*="very basic"].table.segment {
  padding: 1em 1em;
}
/*******************************
             Types
*******************************/
/*-------------------
     Placeholder
--------------------*/
.ui.placeholder.segment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  max-width: initial;
  animation: none;
  overflow: visible;
  padding: 1em 1em;
  min-height: 18rem;
  background: #F9FAFB;
  border-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0px 2px 25px 0 rgba(34, 36, 38, 0.05) inset;
}
.ui.placeholder.segment .button,
.ui.placeholder.segment textarea {
  display: block;
}
.ui.placeholder.segment .field,
.ui.placeholder.segment textarea,
.ui.placeholder.segment > .ui.input,
.ui.placeholder.segment .button {
  max-width: 15rem;
  margin-left: auto;
  margin-right: auto;
}
.ui.placeholder.segment .column .button,
.ui.placeholder.segment .column .field,
.ui.placeholder.segment .column textarea,
.ui.placeholder.segment .column > .ui.input {
  max-width: 15rem;
  margin-left: auto;
  margin-right: auto;
}
.ui.placeholder.segment > .inline {
  align-self: center;
}
.ui.placeholder.segment > .inline > .button {
  display: inline-block;
  width: auto;
  margin: 0px 0.35714286rem 0px 0px;
}
.ui.placeholder.segment > .inline > .button:last-child {
  margin-right: 0px;
}
/*-------------------
        Piled
--------------------*/
.ui.piled.segments,
.ui.piled.segment {
  margin: 3em 0em;
  box-shadow: '';
  z-index: auto;
}
.ui.piled.segment:first-child {
  margin-top: 0em;
}
.ui.piled.segment:last-child {
  margin-bottom: 0em;
}
.ui.piled.segments:after,
.ui.piled.segments:before,
.ui.piled.segment:after,
.ui.piled.segment:before {
  background-color: #CCE2FF;
  visibility: visible;
  content: '';
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: '';
}
.ui.piled.segments:before,
.ui.piled.segment:before {
  transform: rotate(-1.2deg);
  top: 0;
  z-index: -2;
}
.ui.piled.segments:after,
.ui.piled.segment:after {
  transform: rotate(1.2deg);
  top: 0;
  z-index: -1;
}
/* Piled Attached */
.ui[class*="top attached"].piled.segment {
  margin-top: 3em;
  margin-bottom: 0em;
}
.ui.piled.segment[class*="top attached"]:first-child {
  margin-top: 0em;
}
.ui.piled.segment[class*="bottom attached"] {
  margin-top: 0em;
  margin-bottom: 3em;
}
.ui.piled.segment[class*="bottom attached"]:last-child {
  margin-bottom: 0em;
}
/*-------------------
       Stacked
--------------------*/
.ui.stacked.segment {
  padding-bottom: 1.4em;
}
.ui.stacked.segments:before,
.ui.stacked.segments:after,
.ui.stacked.segment:before,
.ui.stacked.segment:after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0%;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 0, 0, 0.03);
  width: 100%;
  height: 6px;
  visibility: visible;
}
.ui.stacked.segments:before,
.ui.stacked.segment:before {
  display: none;
}
/* Add additional page */
.ui.tall.stacked.segments:before,
.ui.tall.stacked.segment:before {
  display: block;
  bottom: 0px;
}
/* Inverted */
.ui.stacked.inverted.segments:before,
.ui.stacked.inverted.segments:after,
.ui.stacked.inverted.segment:before,
.ui.stacked.inverted.segment:after {
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(255, 255, 255, 0.35);
}
/*-------------------
       Padded
--------------------*/
.ui.padded.segment {
  padding: 1.5em;
}
.ui[class*="very padded"].segment {
  padding: 3em;
}
/* Padded vertical */
.ui.padded.segment.vertical.segment,
.ui[class*="very padded"].vertical.segment {
  padding-left: 0px;
  padding-right: 0px;
}
/*-------------------
       Compact
--------------------*/
.ui.compact.segment {
  display: table;
}
/* Compact Group */
.ui.compact.segments {
  display: inline-flex;
}
.ui.compact.segments .segment,
.ui.segments .compact.segment {
  display: block;
  flex: 0 1 auto;
}
/*-------------------
       Circular
--------------------*/
.ui.circular.segment {
  display: table-cell;
  padding: 2em;
  text-align: center;
  vertical-align: middle;
  border-radius: 500em;
}
/*-------------------
       Raised
--------------------*/
.ui.raised.segments,
.ui.raised.segment {
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}
/*******************************
            Groups
*******************************/
/* Group */
.ui.segments {
  flex-direction: column;
  position: relative;
  margin: 1rem 0em;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
}
.ui.segments:first-child {
  margin-top: 0em;
}
.ui.segments:last-child {
  margin-bottom: 0em;
}
/* Nested Segment */
.ui.segments > .segment {
  top: 0px;
  bottom: 0px;
  border-radius: 0px;
  margin: 0em;
  width: auto;
  box-shadow: none;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.segments:not(.horizontal) > .segment:first-child {
  border-top: none;
  margin-top: 0em;
  bottom: 0px;
  margin-bottom: 0em;
  top: 0px;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
/* Bottom */
.ui.segments:not(.horizontal) > .segment:last-child {
  top: 0px;
  bottom: 0px;
  margin-top: 0em;
  margin-bottom: 0em;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
/* Only */
.ui.segments:not(.horizontal) > .segment:only-child {
  border-radius: 0.28571429rem;
}
/* Nested Group */
.ui.segments > .ui.segments {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  margin: 1rem 1rem;
}
.ui.segments > .segments:first-child {
  border-top: none;
}
.ui.segments > .segment + .segments:not(.horizontal) {
  margin-top: 0em;
}
/* Horizontal Group */
.ui.horizontal.segments {
  display: flex;
  flex-direction: row;
  background-color: transparent;
  border-radius: 0px;
  padding: 0em;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
  margin: 1rem 0em;
  border-radius: 0.28571429rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
/* Nested Horizontal Group */
.ui.segments > .horizontal.segments {
  margin: 0em;
  background-color: transparent;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
/* Horizontal Segment */
.ui.horizontal.segments > .segment {
  flex: 1 1 auto;
  -ms-flex: 1 1 0px;
  /* Solves #2550 MS Flex */
  margin: 0em;
  min-width: 0px;
  background-color: transparent;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}
/* Border Fixes */
.ui.segments > .horizontal.segments:first-child {
  border-top: none;
}
.ui.horizontal.segments > .segment:first-child {
  border-left: none;
}
/*******************************
            States
*******************************/
/*--------------
    Disabled
---------------*/
.ui.disabled.segment {
  opacity: 0.45;
  color: rgba(40, 40, 40, 0.3);
}
/*--------------
    Loading
---------------*/
.ui.loading.segment {
  position: relative;
  cursor: default;
  pointer-events: none;
  text-shadow: none !important;
  color: transparent !important;
  transition: all 0s linear;
}
.ui.loading.segment:before {
  position: absolute;
  content: '';
  top: 0%;
  left: 0%;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  border-radius: 0.28571429rem;
  z-index: 100;
}
.ui.loading.segment:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -1.5em 0em 0em -1.5em;
  width: 3em;
  height: 3em;
  animation: segment-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
  visibility: visible;
  z-index: 101;
}
@keyframes segment-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*******************************
           Variations
*******************************/
/*-------------------
       Basic
--------------------*/
.ui.basic.segment {
  background: none transparent;
  box-shadow: none;
  border: none;
  border-radius: 0px;
}
/*-------------------
       Clearing
--------------------*/
.ui.clearing.segment:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
/*-------------------
       Colors
--------------------*/
/* Red */
.ui.red.segment:not(.inverted) {
  border-top: 2px solid #DB2828 !important;
}
.ui.inverted.red.segment {
  background-color: #DB2828 !important;
  color: #FFFFFF !important;
}
/* Orange */
.ui.orange.segment:not(.inverted) {
  border-top: 2px solid #F2711C !important;
}
.ui.inverted.orange.segment {
  background-color: #F2711C !important;
  color: #FFFFFF !important;
}
/* Yellow */
.ui.yellow.segment:not(.inverted) {
  border-top: 2px solid #FBBD08 !important;
}
.ui.inverted.yellow.segment {
  background-color: #FBBD08 !important;
  color: #FFFFFF !important;
}
/* Olive */
.ui.olive.segment:not(.inverted) {
  border-top: 2px solid #B5CC18 !important;
}
.ui.inverted.olive.segment {
  background-color: #B5CC18 !important;
  color: #FFFFFF !important;
}
/* Green */
.ui.green.segment:not(.inverted) {
  border-top: 2px solid #21BA45 !important;
}
.ui.inverted.green.segment {
  background-color: #21BA45 !important;
  color: #FFFFFF !important;
}
/* Teal */
.ui.teal.segment:not(.inverted) {
  border-top: 2px solid #00B5AD !important;
}
.ui.inverted.teal.segment {
  background-color: #00B5AD !important;
  color: #FFFFFF !important;
}
/* Blue */
.ui.blue.segment:not(.inverted) {
  border-top: 2px solid #2185D0 !important;
}
.ui.inverted.blue.segment {
  background-color: #2185D0 !important;
  color: #FFFFFF !important;
}
/* Violet */
.ui.violet.segment:not(.inverted) {
  border-top: 2px solid #6435C9 !important;
}
.ui.inverted.violet.segment {
  background-color: #6435C9 !important;
  color: #FFFFFF !important;
}
/* Purple */
.ui.purple.segment:not(.inverted) {
  border-top: 2px solid #A333C8 !important;
}
.ui.inverted.purple.segment {
  background-color: #A333C8 !important;
  color: #FFFFFF !important;
}
/* Pink */
.ui.pink.segment:not(.inverted) {
  border-top: 2px solid #E03997 !important;
}
.ui.inverted.pink.segment {
  background-color: #E03997 !important;
  color: #FFFFFF !important;
}
/* Brown */
.ui.brown.segment:not(.inverted) {
  border-top: 2px solid #A5673F !important;
}
.ui.inverted.brown.segment {
  background-color: #A5673F !important;
  color: #FFFFFF !important;
}
/* Grey */
.ui.grey.segment:not(.inverted) {
  border-top: 2px solid #767676 !important;
}
.ui.inverted.grey.segment {
  background-color: #767676 !important;
  color: #FFFFFF !important;
}
/* Black */
.ui.black.segment:not(.inverted) {
  border-top: 2px solid #1B1C1D !important;
}
.ui.inverted.black.segment {
  background-color: #1B1C1D !important;
  color: #FFFFFF !important;
}
/*-------------------
       Aligned
--------------------*/
.ui[class*="left aligned"].segment {
  text-align: left;
}
.ui[class*="right aligned"].segment {
  text-align: right;
}
.ui[class*="center aligned"].segment {
  text-align: center;
}
/*-------------------
       Floated
--------------------*/
.ui.floated.segment,
.ui[class*="left floated"].segment {
  float: left;
  margin-right: 1em;
}
.ui[class*="right floated"].segment {
  float: right;
  margin-left: 1em;
}
/*-------------------
      Inverted
--------------------*/
.ui.inverted.segment {
  border: none;
  box-shadow: none;
}
.ui.inverted.segment,
.ui.primary.inverted.segment {
  background: #1B1C1D;
  color: rgba(255, 255, 255, 0.9);
}
/* Nested */
.ui.inverted.segment .segment {
  color: rgba(255, 255, 255, 0.87);
}
.ui.inverted.segment .inverted.segment {
  color: rgba(255, 255, 255, 0.9);
}
/* Attached */
.ui.inverted.attached.segment {
  border-color: #555555;
}
/*-------------------
     Emphasis
--------------------*/
/* Secondary */
.ui.secondary.segment {
  background: #F3F4F5;
  color: rgba(255, 255, 255, 0.6);
}
.ui.secondary.inverted.segment {
  background: #4c4f52 linear-gradient(rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);
  color: rgba(255, 255, 255, 0.8);
}
/* Tertiary */
.ui.tertiary.segment {
  background: #DCDDDE;
  color: rgba(255, 255, 255, 0.6);
}
.ui.tertiary.inverted.segment {
  background: #717579 linear-gradient(rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.35) 100%);
  color: rgba(255, 255, 255, 0.8);
}
/*-------------------
      Attached
--------------------*/
/* Middle */
.ui.attached.segment {
  top: 0px;
  bottom: 0px;
  border-radius: 0px;
  margin: 0em -1px;
  width: calc(100% - (-1px * 2));
  max-width: calc(100% - (-1px * 2));
  box-shadow: none;
  border: 1px solid #D4D4D5;
}
.ui.attached:not(.message) + .ui.attached.segment:not(.top) {
  border-top: none;
}
/* Top */
.ui[class*="top attached"].segment {
  bottom: 0px;
  margin-bottom: 0em;
  top: 0px;
  margin-top: 1rem;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.segment[class*="top attached"]:first-child {
  margin-top: 0em;
}
/* Bottom */
.ui.segment[class*="bottom attached"] {
  bottom: 0px;
  margin-top: 0em;
  top: 0px;
  margin-bottom: 1rem;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.segment[class*="bottom attached"]:last-child {
  margin-bottom: 0em;
}
/*-------------------
        Size
--------------------*/
.ui.mini.segments .segment,
.ui.mini.segment {
  font-size: 0.78571429rem;
}
.ui.tiny.segments .segment,
.ui.tiny.segment {
  font-size: 0.85714286rem;
}
.ui.small.segments .segment,
.ui.small.segment {
  font-size: 0.92857143rem;
}
.ui.segments .segment,
.ui.segment {
  font-size: 1rem;
}
.ui.large.segments .segment,
.ui.large.segment {
  font-size: 1.14285714rem;
}
.ui.big.segments .segment,
.ui.big.segment {
  font-size: 1.28571429rem;
}
.ui.huge.segments .segment,
.ui.huge.segment {
  font-size: 1.42857143rem;
}
.ui.massive.segments .segment,
.ui.massive.segment {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Step
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
             Step
*******************************/
/*--------------
   Load Theme
---------------*/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Step
*******************************/
/*-------------------
       Group
--------------------*/
/*-------------------
      Element
--------------------*/
/* Icon */
/* Title */
/* Description */
/* Arrow */
/* Mobile */
/*-------------------
       Types
--------------------*/
/* Vertical */
/*-------------------
      Variations
--------------------*/
/*-------------------
       States
--------------------*/
/* Completed */
/* Hover */
/* Down */
/* Active */
/* Active + Hover */
/* Disabled */
/* Packaged Theme */
/*******************************
             Step
*******************************/
/*-------------------
       Group
--------------------*/
/*-------------------
      Element
--------------------*/
/* Icon */
/* Title */
/* Description */
/* Arrow */
/* Mobile */
/*-------------------
       Types
--------------------*/
/* Vertical */
/*-------------------
      Variations
--------------------*/
/*-------------------
       States
--------------------*/
/* Completed */
/* Hover */
/* Down */
/* Active */
/* Active + Hover */
/* Disabled */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Plural
*******************************/
.ui.steps {
  display: inline-flex;
  flex-direction: row;
  align-items: stretch;
  margin: 1em 0em;
  background: '';
  box-shadow: none;
  line-height: 1.14285714em;
  border-radius: 0.28571429rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
/* First Steps */
.ui.steps:first-child {
  margin-top: 0em;
}
/* Last Steps */
.ui.steps:last-child {
  margin-bottom: 0em;
}
/*******************************
           Singular
*******************************/
.ui.steps .step {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  flex-wrap: wrap;
  flex-direction: row;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  margin: 0em 0em;
  padding: 1.14285714em 2em;
  background: #FFFFFF;
  color: rgba(255, 255, 255, 0.87);
  box-shadow: none;
  border-radius: 0em;
  border: none;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;
}
/* Arrow */
.ui.steps .step:after {
  display: none;
  position: absolute;
  z-index: 2;
  content: '';
  top: 50%;
  right: 0%;
  border: medium none;
  background-color: #FFFFFF;
  width: 1.14285714em;
  height: 1.14285714em;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.15);
  border-width: 0px 1px 1px 0px;
  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;
  transform: translateY(-50%) translateX(50%) rotate(-45deg);
}
/* First Step */
.ui.steps .step:first-child {
  padding-left: 2em;
  border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
/* Last Step */
.ui.steps .step:last-child {
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui.steps .step:last-child {
  border-right: none;
  margin-right: 0em;
}
/* Only Step */
.ui.steps .step:only-child {
  border-radius: 0.28571429rem;
}
/*******************************
            Content
*******************************/
/* Title */
.ui.steps .step .title {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1.14285714em;
  font-weight: bold;
}
.ui.steps .step > .title {
  width: 100%;
}
/* Description */
.ui.steps .step .description {
  font-weight: normal;
  font-size: 0.92857143em;
  color: rgba(255, 255, 255, 0.87);
}
.ui.steps .step > .description {
  width: 100%;
}
.ui.steps .step .title ~ .description {
  margin-top: 0.25em;
}
/* Icon */
.ui.steps .step > .icon {
  line-height: 1;
  font-size: 2.5em;
  margin: 0em 1rem 0em 0em;
}
.ui.steps .step > .icon,
.ui.steps .step > .icon ~ .content {
  display: block;
  flex: 0 1 auto;
  align-self: middle;
}
.ui.steps .step > .icon ~ .content {
  flex-grow: 1 0 auto;
}
/* Horizontal Icon */
.ui.steps:not(.vertical) .step > .icon {
  width: auto;
}
/* Link */
.ui.steps .link.step,
.ui.steps a.step {
  cursor: pointer;
}
/*******************************
            Types
*******************************/
/*--------------
     Ordered
---------------*/
.ui.ordered.steps {
  counter-reset: ordered;
}
.ui.ordered.steps .step:before {
  display: block;
  position: static;
  text-align: center;
  content: counters(ordered, ".");
  align-self: middle;
  margin-right: 1rem;
  font-size: 2.5em;
  counter-increment: ordered;
  font-family: inherit;
  font-weight: bold;
}
.ui.ordered.steps .step > * {
  display: block;
  align-self: middle;
}
/*--------------
    Vertical
---------------*/
.ui.vertical.steps {
  display: inline-flex;
  flex-direction: column;
  overflow: visible;
}
.ui.vertical.steps .step {
  justify-content: flex-start;
  border-radius: 0em;
  padding: 1.14285714em 2em;
  border-right: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.vertical.steps .step:first-child {
  padding: 1.14285714em 2em;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.vertical.steps .step:last-child {
  border-bottom: none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.vertical.steps .step:only-child {
  border-radius: 0.28571429rem;
}
/* Arrow */
.ui.vertical.steps .step:after {
  display: none;
}
.ui.vertical.steps .step:after {
  top: 50%;
  right: 0%;
  border-width: 0px 1px 1px 0px;
}
.ui.vertical.steps .step:after {
  display: none;
}
.ui.vertical.steps .active.step:after {
  display: block;
}
.ui.vertical.steps .step:last-child:after {
  display: none;
}
.ui.vertical.steps .active.step:last-child:after {
  display: block;
}
/*---------------
    Responsive
----------------*/
/* Mobile (Default) */
@media only screen and (max-width: 767px) {
  .ui.steps:not(.unstackable) {
    display: inline-flex;
    overflow: visible;
    flex-direction: column;
  }
  .ui.steps:not(.unstackable) .step {
    width: 100% !important;
    flex-direction: column;
    border-radius: 0em;
    padding: 1.14285714em 2em;
  }
  .ui.steps:not(.unstackable) .step:first-child {
    padding: 1.14285714em 2em;
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
  }
  .ui.steps:not(.unstackable) .step:last-child {
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  }
  /* Arrow */
  .ui.steps:not(.unstackable) .step:after {
    display: none !important;
  }
  /* Content */
  .ui.steps:not(.unstackable) .step .content {
    text-align: center;
  }
  /* Icon */
  .ui.steps:not(.unstackable) .step > .icon,
  .ui.ordered.steps:not(.unstackable) .step:before {
    margin: 0em 0em 1rem 0em;
  }
}
/*******************************
             States
*******************************/
/* Link Hover */
.ui.steps .link.step:hover::after,
.ui.steps .link.step:hover,
.ui.steps a.step:hover::after,
.ui.steps a.step:hover {
  background: #F9FAFB;
  color: rgba(255, 255, 255, 0.8);
}
/* Link Down */
.ui.steps .link.step:active::after,
.ui.steps .link.step:active,
.ui.steps a.step:active::after,
.ui.steps a.step:active {
  background: #F3F4F5;
  color: rgba(255, 255, 255, 0.9);
}
/* Active */
.ui.steps .step.active {
  cursor: auto;
  background: #F3F4F5;
}
.ui.steps .step.active:after {
  background: #F3F4F5;
}
.ui.steps .step.active .title {
  color: #4183C4;
}
.ui.ordered.steps .step.active:before,
.ui.steps .active.step .icon {
  color: rgba(255, 255, 255, 0.85);
}
/* Active Arrow */
.ui.steps .step:after {
  display: block;
}
.ui.steps .active.step:after {
  display: block;
}
.ui.steps .step:last-child:after {
  display: none;
}
.ui.steps .active.step:last-child:after {
  display: none;
}
/* Active Hover */
.ui.steps .link.active.step:hover::after,
.ui.steps .link.active.step:hover,
.ui.steps a.active.step:hover::after,
.ui.steps a.active.step:hover {
  cursor: pointer;
  background: #DCDDDE;
  color: rgba(255, 255, 255, 0.87);
}
/* Completed */
.ui.steps .step.completed > .icon:before,
.ui.ordered.steps .step.completed:before {
  color: #21BA45;
}
/* Disabled */
.ui.steps .disabled.step {
  cursor: auto;
  background: #FFFFFF;
  pointer-events: none;
}
.ui.steps .disabled.step,
.ui.steps .disabled.step .title,
.ui.steps .disabled.step .description {
  color: rgba(40, 40, 40, 0.3);
}
.ui.steps .disabled.step:after {
  background: #FFFFFF;
}
/*******************************
           Variations
*******************************/
/*--------------
   Stackable
---------------*/
/* Tablet Or Below */
@media only screen and (max-width: 991px) {
  .ui[class*="tablet stackable"].steps {
    display: inline-flex;
    overflow: visible;
    flex-direction: column;
  }
  /* Steps */
  .ui[class*="tablet stackable"].steps .step {
    flex-direction: column;
    border-radius: 0em;
    padding: 1.14285714em 2em;
  }
  .ui[class*="tablet stackable"].steps .step:first-child {
    padding: 1.14285714em 2em;
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
  }
  .ui[class*="tablet stackable"].steps .step:last-child {
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  }
  /* Arrow */
  .ui[class*="tablet stackable"].steps .step:after {
    display: none !important;
  }
  /* Content */
  .ui[class*="tablet stackable"].steps .step .content {
    text-align: center;
  }
  /* Icon */
  .ui[class*="tablet stackable"].steps .step > .icon,
  .ui[class*="tablet stackable"].ordered.steps .step:before {
    margin: 0em 0em 1rem 0em;
  }
}
/*--------------
      Fluid
---------------*/
/* Fluid */
.ui.fluid.steps {
  display: flex;
  width: 100%;
}
/*--------------
    Attached
---------------*/
/* Top */
.ui.attached.steps {
  width: calc(100% + (--1px * 2)) !important;
  margin: 0em -1px 0;
  max-width: calc(100% + (--1px * 2));
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.attached.steps .step:first-child {
  border-radius: 0.28571429rem 0em 0em 0em;
}
.ui.attached.steps .step:last-child {
  border-radius: 0em 0.28571429rem 0em 0em;
}
/* Bottom */
.ui.bottom.attached.steps {
  margin: 0 -1px 0em;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.bottom.attached.steps .step:first-child {
  border-radius: 0em 0em 0em 0.28571429rem;
}
.ui.bottom.attached.steps .step:last-child {
  border-radius: 0em 0em 0.28571429rem 0em;
}
/*-------------------
    Evenly Divided
--------------------*/
.ui.one.steps,
.ui.two.steps,
.ui.three.steps,
.ui.four.steps,
.ui.five.steps,
.ui.six.steps,
.ui.seven.steps,
.ui.eight.steps {
  width: 100%;
}
.ui.one.steps > .step,
.ui.two.steps > .step,
.ui.three.steps > .step,
.ui.four.steps > .step,
.ui.five.steps > .step,
.ui.six.steps > .step,
.ui.seven.steps > .step,
.ui.eight.steps > .step {
  flex-wrap: nowrap;
}
.ui.one.steps > .step {
  width: 100%;
}
.ui.two.steps > .step {
  width: 50%;
}
.ui.three.steps > .step {
  width: 33.333%;
}
.ui.four.steps > .step {
  width: 25%;
}
.ui.five.steps > .step {
  width: 20%;
}
.ui.six.steps > .step {
  width: 16.666%;
}
.ui.seven.steps > .step {
  width: 14.285%;
}
.ui.eight.steps > .step {
  width: 12.5%;
}
/*-------------------
       Sizes
--------------------*/
.ui.mini.steps .step,
.ui.mini.step {
  font-size: 0.78571429rem;
}
.ui.tiny.steps .step,
.ui.tiny.step {
  font-size: 0.85714286rem;
}
.ui.small.steps .step,
.ui.small.step {
  font-size: 0.92857143rem;
}
.ui.steps .step,
.ui.step {
  font-size: 1rem;
}
.ui.large.steps .step,
.ui.large.step {
  font-size: 1.14285714rem;
}
.ui.big.steps .step,
.ui.big.step {
  font-size: 1.28571429rem;
}
.ui.huge.steps .step,
.ui.huge.step {
  font-size: 1.42857143rem;
}
.ui.massive.steps .step,
.ui.massive.step {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
@font-face {
  font-family: 'Step';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff');
}
.ui.steps .step.completed > .icon:before,
.ui.ordered.steps .step.completed:before {
  font-family: 'Step';
  content: '\\e800';
  /* '' */
}
/* Collections */
/*!
 * # Semantic UI - Breadcrumb
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
          Breadcrumb
*******************************/
/*-------------------
     Breadcrumb
--------------------*/
/* Coupling */
/*-------------------
       States
--------------------*/
/* Packaged Theme */
/*******************************
          Breadcrumb
*******************************/
/*-------------------
     Breadcrumb
--------------------*/
/* Coupling */
/*-------------------
       States
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           Breadcrumb
*******************************/
.ui.breadcrumb {
  line-height: 1;
  display: inline-block;
  margin: 0em 0em;
  vertical-align: middle;
}
.ui.breadcrumb:first-child {
  margin-top: 0em;
}
.ui.breadcrumb:last-child {
  margin-bottom: 0em;
}
/*******************************
          Content
*******************************/
/* Divider */
.ui.breadcrumb .divider {
  display: inline-block;
  opacity: 0.7;
  margin: 0em 0.21428571rem 0em;
  font-size: 0.92857143em;
  color: rgba(255, 255, 255, 0.4);
  vertical-align: baseline;
}
/* Link */
.ui.breadcrumb a {
  color: #4183C4;
}
.ui.breadcrumb a:hover {
  color: #1e70bf;
}
/* Icon Divider */
.ui.breadcrumb .icon.divider {
  font-size: 0.85714286em;
  vertical-align: baseline;
}
/* Section */
.ui.breadcrumb a.section {
  cursor: pointer;
}
.ui.breadcrumb .section {
  display: inline-block;
  margin: 0em;
  padding: 0em;
}
/* Loose Coupling */
.ui.breadcrumb.segment {
  display: inline-block;
  padding: 0.78571429em 1em;
}
/*******************************
            States
*******************************/
.ui.breadcrumb .active.section {
  font-weight: bold;
}
/*******************************
           Variations
*******************************/
.ui.mini.breadcrumb {
  font-size: 0.78571429rem;
}
.ui.tiny.breadcrumb {
  font-size: 0.85714286rem;
}
.ui.small.breadcrumb {
  font-size: 0.92857143rem;
}
.ui.breadcrumb {
  font-size: 1rem;
}
.ui.large.breadcrumb {
  font-size: 1.14285714rem;
}
.ui.big.breadcrumb {
  font-size: 1.28571429rem;
}
.ui.huge.breadcrumb {
  font-size: 1.42857143rem;
}
.ui.massive.breadcrumb {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Form
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Form
*******************************/
/*-------------------
       Elements
--------------------*/
/* Form */
/* Text */
/* Field */
/* Fields */
/* Form Label */
/* Input */
/* Select */
/* Text Area */
/* Checkbox */
/* Inline Validation Prompt */
/*-------------------
        States
--------------------*/
/* Focus */
/* Input Focus */
/* Text Area Focus */
/* Disabled */
/* Errored Input */
/* AutoFill */
/* Input Error */
/* Dropdown Error */
/* Focused Error */
/* Placeholder Error */
/* Loading Dimmer */
/* Loading Spinner */
/*-------------------
        Types
--------------------*/
/* Required */
/* Inverted */
/*-------------------
      Variations
--------------------*/
/* Grouped Fields */
/* Inline */
/*-------------------
       Groups
--------------------*/
/* Packaged Theme */
/*******************************
             Form
*******************************/
/*-------------------
       Elements
--------------------*/
/* Form */
/* Text */
/* Field */
/* Fields */
/* Form Label */
/* Input */
/* Select */
/* Text Area */
/* Checkbox */
/* Inline Validation Prompt */
/*-------------------
        States
--------------------*/
/* Focus */
/* Input Focus */
/* Text Area Focus */
/* Disabled */
/* Errored Input */
/* AutoFill */
/* Input Error */
/* Dropdown Error */
/* Focused Error */
/* Placeholder Error */
/* Loading Dimmer */
/* Loading Spinner */
/*-------------------
        Types
--------------------*/
/* Required */
/* Inverted */
/*-------------------
      Variations
--------------------*/
/* Grouped Fields */
/* Inline */
/*-------------------
       Groups
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Elements
*******************************/
/*--------------------
        Form
---------------------*/
.ui.form {
  position: relative;
  max-width: 100%;
}
/*--------------------
        Content
---------------------*/
.ui.form > p {
  margin: 1em 0em;
}
/*--------------------
        Field
---------------------*/
.ui.form .field {
  clear: both;
  margin: 0em 0em 1em;
}
.ui.form .field:last-child,
.ui.form .fields:last-child .field {
  margin-bottom: 0em;
}
.ui.form .fields .field {
  clear: both;
  margin: 0em;
}
/*--------------------
        Labels
---------------------*/
.ui.form .field > label {
  display: block;
  margin: 0em 0em 0.28571429rem 0em;
  color: rgba(255, 255, 255, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
  text-transform: none;
}
/*--------------------
    Standard Inputs
---------------------*/
.ui.form textarea,
.ui.form input:not([type]),
.ui.form input[type="date"],
.ui.form input[type="datetime-local"],
.ui.form input[type="email"],
.ui.form input[type="number"],
.ui.form input[type="password"],
.ui.form input[type="search"],
.ui.form input[type="tel"],
.ui.form input[type="time"],
.ui.form input[type="text"],
.ui.form input[type="file"],
.ui.form input[type="url"] {
  width: 100%;
  vertical-align: top;
}
/* Set max height on unusual input */
.ui.form ::-webkit-datetime-edit,
.ui.form ::-webkit-inner-spin-button {
  height: 1.21428571em;
}
.ui.form input:not([type]),
.ui.form input[type="date"],
.ui.form input[type="datetime-local"],
.ui.form input[type="email"],
.ui.form input[type="number"],
.ui.form input[type="password"],
.ui.form input[type="search"],
.ui.form input[type="tel"],
.ui.form input[type="time"],
.ui.form input[type="text"],
.ui.form input[type="file"],
.ui.form input[type="url"] {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  margin: 0em;
  outline: none;
  -webkit-appearance: none;
  tap-highlight-color: rgba(255, 255, 255, 0);
  line-height: 1.21428571em;
  padding: 0.67857143em 1em;
  font-size: 1em;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0em 0em 0em 0em transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
}
/* Text Area */
.ui.form textarea {
  margin: 0em;
  -webkit-appearance: none;
  tap-highlight-color: rgba(255, 255, 255, 0);
  padding: 0.78571429em 1em;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  outline: none;
  color: rgba(255, 255, 255, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0em 0em 0em 0em transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
  font-size: 1em;
  line-height: 1.2857;
  resize: vertical;
}
.ui.form textarea:not([rows]) {
  height: 12em;
  min-height: 8em;
  max-height: 24em;
}
.ui.form textarea,
.ui.form input[type="checkbox"] {
  vertical-align: top;
}
/*--------------------------
  Input w/ attached Button
---------------------------*/
.ui.form input.attached {
  width: auto;
}
/*--------------------
     Basic Select
---------------------*/
.ui.form select {
  display: block;
  height: auto;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
  box-shadow: 0em 0em 0em 0em transparent inset;
  padding: 0.62em 1em;
  color: rgba(255, 255, 255, 0.87);
  transition: color 0.1s ease, border-color 0.1s ease;
}
/*--------------------
       Dropdown
---------------------*/
/* Block */
.ui.form .field > .selection.dropdown {
  width: 100%;
}
.ui.form .field > .selection.dropdown > .dropdown.icon {
  float: right;
}
/* Inline */
.ui.form .inline.fields .field > .selection.dropdown,
.ui.form .inline.field > .selection.dropdown {
  width: auto;
}
.ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon,
.ui.form .inline.field > .selection.dropdown > .dropdown.icon {
  float: none;
}
/*--------------------
       UI Input
---------------------*/
/* Block */
.ui.form .field .ui.input,
.ui.form .fields .field .ui.input,
.ui.form .wide.field .ui.input {
  width: 100%;
}
/* Inline  */
.ui.form .inline.fields .field:not(.wide) .ui.input,
.ui.form .inline.field:not(.wide) .ui.input {
  width: auto;
  vertical-align: middle;
}
/* Auto Input */
.ui.form .fields .field .ui.input input,
.ui.form .field .ui.input input {
  width: auto;
}
/* Full Width Input */
.ui.form .ten.fields .ui.input input,
.ui.form .nine.fields .ui.input input,
.ui.form .eight.fields .ui.input input,
.ui.form .seven.fields .ui.input input,
.ui.form .six.fields .ui.input input,
.ui.form .five.fields .ui.input input,
.ui.form .four.fields .ui.input input,
.ui.form .three.fields .ui.input input,
.ui.form .two.fields .ui.input input,
.ui.form .wide.field .ui.input input {
  flex: 1 0 auto;
  width: 0px;
}
/*--------------------
   Types of Messages
---------------------*/
.ui.form .success.message,
.ui.form .warning.message,
.ui.form .error.message {
  display: none;
}
/* Assumptions */
.ui.form .message:first-child {
  margin-top: 0px;
}
/*--------------------
   Validation Prompt
---------------------*/
.ui.form .field .prompt.label {
  white-space: normal;
  background: #FFFFFF !important;
  border: 1px solid #E0B4B4 !important;
  color: #FFFFFF !important;
}
.ui.form .inline.fields .field .prompt,
.ui.form .inline.field .prompt {
  vertical-align: top;
  margin: -0.25em 0em -0.5em 0.5em;
}
.ui.form .inline.fields .field .prompt:before,
.ui.form .inline.field .prompt:before {
  border-width: 0px 0px 1px 1px;
  bottom: auto;
  right: auto;
  top: 50%;
  left: 0em;
}
/*******************************
            States
*******************************/
/*--------------------
      Autofilled
---------------------*/
.ui.form .field.field input:-webkit-autofill {
  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;
  border-color: #E5DFA1 !important;
}
/* Focus */
.ui.form .field.field input:-webkit-autofill:focus {
  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;
  border-color: #D5C315 !important;
}
/* Error */
.ui.form .error.error input:-webkit-autofill {
  box-shadow: 0px 0px 0px 100px #FFFAF0 inset !important;
  border-color: #E0B4B4 !important;
}
/*--------------------
      Placeholder
---------------------*/
/* browsers require these rules separate */
.ui.form ::-webkit-input-placeholder {
  color: rgba(64, 64, 64, 0.87);
}
.ui.form :-ms-input-placeholder {
  color: rgba(64, 64, 64, 0.87) !important;
}
.ui.form ::-moz-placeholder {
  color: rgba(64, 64, 64, 0.87);
}
.ui.form :focus::-webkit-input-placeholder {
  color: rgba(140, 140, 140, 0.87);
}
.ui.form :focus:-ms-input-placeholder {
  color: rgba(140, 140, 140, 0.87) !important;
}
.ui.form :focus::-moz-placeholder {
  color: rgba(140, 140, 140, 0.87);
}
/* Error Placeholder */
.ui.form .error ::-webkit-input-placeholder {
  color: #ffffff;
}
.ui.form .error :-ms-input-placeholder {
  color: #ffffff !important;
}
.ui.form .error ::-moz-placeholder {
  color: #ffffff;
}
.ui.form .error :focus::-webkit-input-placeholder {
  color: #ffffff;
}
.ui.form .error :focus:-ms-input-placeholder {
  color: #ffffff !important;
}
.ui.form .error :focus::-moz-placeholder {
  color: #ffffff;
}
/*--------------------
        Focus
---------------------*/
.ui.form input:not([type]):focus,
.ui.form input[type="date"]:focus,
.ui.form input[type="datetime-local"]:focus,
.ui.form input[type="email"]:focus,
.ui.form input[type="number"]:focus,
.ui.form input[type="password"]:focus,
.ui.form input[type="search"]:focus,
.ui.form input[type="tel"]:focus,
.ui.form input[type="time"]:focus,
.ui.form input[type="text"]:focus,
.ui.form input[type="file"]:focus,
.ui.form input[type="url"]:focus {
  color: rgba(255, 255, 255, 0.95);
  border-color: #85B7D9;
  border-radius: 0.28571429rem;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0px 0em 0em 0em rgba(255, 255, 255, 0.35) inset;
}
.ui.form textarea:focus {
  color: rgba(255, 255, 255, 0.95);
  border-color: #85B7D9;
  border-radius: 0.28571429rem;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0px 0em 0em 0em rgba(255, 255, 255, 0.35) inset;
  -webkit-appearance: none;
}
/*--------------------
        Success
---------------------*/
/* On Form */
.ui.form.success .success.message:not(:empty) {
  display: block;
}
.ui.form.success .compact.success.message:not(:empty) {
  display: inline-block;
}
.ui.form.success .icon.success.message:not(:empty) {
  display: flex;
}
/*--------------------
        Warning
---------------------*/
/* On Form */
.ui.form.warning .warning.message:not(:empty) {
  display: block;
}
.ui.form.warning .compact.warning.message:not(:empty) {
  display: inline-block;
}
.ui.form.warning .icon.warning.message:not(:empty) {
  display: flex;
}
/*--------------------
        Error
---------------------*/
/* On Form */
.ui.form.error .error.message:not(:empty) {
  display: block;
}
.ui.form.error .compact.error.message:not(:empty) {
  display: inline-block;
}
.ui.form.error .icon.error.message:not(:empty) {
  display: flex;
}
/* On Field(s) */
.ui.form .fields.error .field label,
.ui.form .field.error label,
.ui.form .fields.error .field .input,
.ui.form .field.error .input {
  color: #FFFFFF;
}
.ui.form .fields.error .field .corner.label,
.ui.form .field.error .corner.label {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.ui.form .fields.error .field textarea,
.ui.form .fields.error .field select,
.ui.form .fields.error .field input:not([type]),
.ui.form .fields.error .field input[type="date"],
.ui.form .fields.error .field input[type="datetime-local"],
.ui.form .fields.error .field input[type="email"],
.ui.form .fields.error .field input[type="number"],
.ui.form .fields.error .field input[type="password"],
.ui.form .fields.error .field input[type="search"],
.ui.form .fields.error .field input[type="tel"],
.ui.form .fields.error .field input[type="time"],
.ui.form .fields.error .field input[type="text"],
.ui.form .fields.error .field input[type="file"],
.ui.form .fields.error .field input[type="url"],
.ui.form .field.error textarea,
.ui.form .field.error select,
.ui.form .field.error input:not([type]),
.ui.form .field.error input[type="date"],
.ui.form .field.error input[type="datetime-local"],
.ui.form .field.error input[type="email"],
.ui.form .field.error input[type="number"],
.ui.form .field.error input[type="password"],
.ui.form .field.error input[type="search"],
.ui.form .field.error input[type="tel"],
.ui.form .field.error input[type="time"],
.ui.form .field.error input[type="text"],
.ui.form .field.error input[type="file"],
.ui.form .field.error input[type="url"] {
  background: rgba(200, 3, 3, 0.15);
  border-color: #E0B4B4;
  color: #FFFFFF;
  border-radius: '';
  box-shadow: none;
}
.ui.form .field.error textarea:focus,
.ui.form .field.error select:focus,
.ui.form .field.error input:not([type]):focus,
.ui.form .field.error input[type="date"]:focus,
.ui.form .field.error input[type="datetime-local"]:focus,
.ui.form .field.error input[type="email"]:focus,
.ui.form .field.error input[type="number"]:focus,
.ui.form .field.error input[type="password"]:focus,
.ui.form .field.error input[type="search"]:focus,
.ui.form .field.error input[type="tel"]:focus,
.ui.form .field.error input[type="time"]:focus,
.ui.form .field.error input[type="text"]:focus,
.ui.form .field.error input[type="file"]:focus,
.ui.form .field.error input[type="url"]:focus {
  background: rgba(200, 3, 3, 0.15);
  border-color: #E0B4B4;
  color: #FFFFFF;
  -webkit-appearance: none;
  box-shadow: none;
}
/* Preserve Native Select Stylings */
.ui.form .field.error select {
  -webkit-appearance: menulist-button;
}
/*------------------
    Dropdown Error
--------------------*/
.ui.form .fields.error .field .ui.dropdown,
.ui.form .fields.error .field .ui.dropdown .item,
.ui.form .field.error .ui.dropdown,
.ui.form .field.error .ui.dropdown .text,
.ui.form .field.error .ui.dropdown .item {
  background: rgba(200, 3, 3, 0.15);
  color: #FFFFFF;
}
.ui.form .fields.error .field .ui.dropdown,
.ui.form .field.error .ui.dropdown {
  border-color: #E0B4B4 !important;
}
.ui.form .fields.error .field .ui.dropdown:hover,
.ui.form .field.error .ui.dropdown:hover {
  border-color: #E0B4B4 !important;
}
.ui.form .fields.error .field .ui.dropdown:hover .menu,
.ui.form .field.error .ui.dropdown:hover .menu {
  border-color: #E0B4B4;
}
.ui.form .fields.error .field .ui.multiple.selection.dropdown > .label,
.ui.form .field.error .ui.multiple.selection.dropdown > .label {
  background-color: #EACBCB;
  color: #FFFFFF;
}
/* Hover */
.ui.form .fields.error .field .ui.dropdown .menu .item:hover,
.ui.form .field.error .ui.dropdown .menu .item:hover {
  background-color: #FBE7E7;
}
/* Selected */
.ui.form .fields.error .field .ui.dropdown .menu .selected.item,
.ui.form .field.error .ui.dropdown .menu .selected.item {
  background-color: #FBE7E7;
}
/* Active */
.ui.form .fields.error .field .ui.dropdown .menu .active.item,
.ui.form .field.error .ui.dropdown .menu .active.item {
  background-color: #FDCFCF !important;
}
/*--------------------
    Checkbox Error
---------------------*/
.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label,
.ui.form .field.error .checkbox:not(.toggle):not(.slider) label,
.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box,
.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {
  color: #FFFFFF;
}
.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before,
.ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before,
.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before,
.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {
  background: rgba(200, 3, 3, 0.15);
  border-color: #E0B4B4;
}
.ui.form .fields.error .field .checkbox label:after,
.ui.form .field.error .checkbox label:after,
.ui.form .fields.error .field .checkbox .box:after,
.ui.form .field.error .checkbox .box:after {
  color: #FFFFFF;
}
/*--------------------
       Disabled
---------------------*/
.ui.form .disabled.fields .field,
.ui.form .disabled.field,
.ui.form .field :disabled {
  pointer-events: none;
  opacity: 0.45;
}
.ui.form .field.disabled > label,
.ui.form .fields.disabled > label {
  opacity: 0.45;
}
.ui.form .field.disabled :disabled {
  opacity: 1;
}
/*--------------
    Loading
---------------*/
.ui.loading.form {
  position: relative;
  cursor: default;
  pointer-events: none;
}
.ui.loading.form:before {
  position: absolute;
  content: '';
  top: 0%;
  left: 0%;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 100;
}
.ui.loading.form:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -1.5em 0em 0em -1.5em;
  width: 3em;
  height: 3em;
  animation: form-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
  visibility: visible;
  z-index: 101;
}
@keyframes form-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*******************************
         Element Types
*******************************/
/*--------------------
     Required Field
---------------------*/
.ui.form .required.fields:not(.grouped) > .field > label:after,
.ui.form .required.fields.grouped > label:after,
.ui.form .required.field > label:after,
.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,
.ui.form .required.field > .checkbox:after {
  margin: -0.2em 0em 0em 0.2em;
  content: '*';
  color: #DB2828;
}
.ui.form .required.fields:not(.grouped) > .field > label:after,
.ui.form .required.fields.grouped > label:after,
.ui.form .required.field > label:after {
  display: inline-block;
  vertical-align: top;
}
.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,
.ui.form .required.field > .checkbox:after {
  position: absolute;
  top: 0%;
  left: 100%;
}
/*******************************
           Variations
*******************************/
/*--------------------
    Inverted Colors
---------------------*/
.ui.inverted.form label,
.ui.form .inverted.segment label,
.ui.form .inverted.segment .ui.checkbox label,
.ui.form .inverted.segment .ui.checkbox .box,
.ui.inverted.form .ui.checkbox label,
.ui.inverted.form .ui.checkbox .box,
.ui.inverted.form .inline.fields > label,
.ui.inverted.form .inline.fields .field > label,
.ui.inverted.form .inline.fields .field > p,
.ui.inverted.form .inline.field > label,
.ui.inverted.form .inline.field > p {
  color: rgba(255, 255, 255, 0.9);
}
/* Inverted Field */
.ui.inverted.form input:not([type]),
.ui.inverted.form input[type="date"],
.ui.inverted.form input[type="datetime-local"],
.ui.inverted.form input[type="email"],
.ui.inverted.form input[type="number"],
.ui.inverted.form input[type="password"],
.ui.inverted.form input[type="search"],
.ui.inverted.form input[type="tel"],
.ui.inverted.form input[type="time"],
.ui.inverted.form input[type="text"],
.ui.inverted.form input[type="file"],
.ui.inverted.form input[type="url"] {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.87);
  box-shadow: none;
}
/*--------------------
     Field Groups
---------------------*/
/* Grouped Vertically */
.ui.form .grouped.fields {
  display: block;
  margin: 0em 0em 1em;
}
.ui.form .grouped.fields:last-child {
  margin-bottom: 0em;
}
.ui.form .grouped.fields > label {
  margin: 0em 0em 0.28571429rem 0em;
  color: rgba(255, 255, 255, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
  text-transform: none;
}
.ui.form .grouped.fields .field,
.ui.form .grouped.inline.fields .field {
  display: block;
  margin: 0.5em 0em;
  padding: 0em;
}
/*--------------------
        Fields
---------------------*/
/* Split fields */
.ui.form .fields {
  display: flex;
  flex-direction: row;
  margin: 0em -0.5em 1em;
}
.ui.form .fields > .field {
  flex: 0 1 auto;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.ui.form .fields > .field:first-child {
  border-left: none;
  box-shadow: none;
}
/* Other Combinations */
.ui.form .two.fields > .fields,
.ui.form .two.fields > .field {
  width: 50%;
}
.ui.form .three.fields > .fields,
.ui.form .three.fields > .field {
  width: 33.33333333%;
}
.ui.form .four.fields > .fields,
.ui.form .four.fields > .field {
  width: 25%;
}
.ui.form .five.fields > .fields,
.ui.form .five.fields > .field {
  width: 20%;
}
.ui.form .six.fields > .fields,
.ui.form .six.fields > .field {
  width: 16.66666667%;
}
.ui.form .seven.fields > .fields,
.ui.form .seven.fields > .field {
  width: 14.28571429%;
}
.ui.form .eight.fields > .fields,
.ui.form .eight.fields > .field {
  width: 12.5%;
}
.ui.form .nine.fields > .fields,
.ui.form .nine.fields > .field {
  width: 11.11111111%;
}
.ui.form .ten.fields > .fields,
.ui.form .ten.fields > .field {
  width: 10%;
}
/* Swap to full width on mobile */
@media only screen and (max-width: 767px) {
  .ui.form .fields {
    flex-wrap: wrap;
  }
  .ui[class*="equal width"].form:not(.unstackable) .fields > .field,
  .ui.form:not(.unstackable) [class*="equal width"].fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {
    width: 100% !important;
    margin: 0em 0em 1em;
  }
}
/* Sizing Combinations */
.ui.form .fields .wide.field {
  width: 6.25%;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.ui.form .one.wide.field {
  width: 6.25% !important;
}
.ui.form .two.wide.field {
  width: 12.5% !important;
}
.ui.form .three.wide.field {
  width: 18.75% !important;
}
.ui.form .four.wide.field {
  width: 25% !important;
}
.ui.form .five.wide.field {
  width: 31.25% !important;
}
.ui.form .six.wide.field {
  width: 37.5% !important;
}
.ui.form .seven.wide.field {
  width: 43.75% !important;
}
.ui.form .eight.wide.field {
  width: 50% !important;
}
.ui.form .nine.wide.field {
  width: 56.25% !important;
}
.ui.form .ten.wide.field {
  width: 62.5% !important;
}
.ui.form .eleven.wide.field {
  width: 68.75% !important;
}
.ui.form .twelve.wide.field {
  width: 75% !important;
}
.ui.form .thirteen.wide.field {
  width: 81.25% !important;
}
.ui.form .fourteen.wide.field {
  width: 87.5% !important;
}
.ui.form .fifteen.wide.field {
  width: 93.75% !important;
}
.ui.form .sixteen.wide.field {
  width: 100% !important;
}
/* Swap to full width on mobile */
@media only screen and (max-width: 767px) {
  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,
  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field,
  .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {
    width: 100% !important;
  }
  .ui.form .fields {
    margin-bottom: 0em;
  }
}
/*--------------------
     Equal Width
---------------------*/
.ui[class*="equal width"].form .fields > .field,
.ui.form [class*="equal width"].fields > .field {
  width: 100%;
  flex: 1 1 auto;
}
/*--------------------
    Inline Fields
---------------------*/
.ui.form .inline.fields {
  margin: 0em 0em 1em;
  align-items: center;
}
.ui.form .inline.fields .field {
  margin: 0em;
  padding: 0em 1em 0em 0em;
}
/* Inline Label */
.ui.form .inline.fields > label,
.ui.form .inline.fields .field > label,
.ui.form .inline.fields .field > p,
.ui.form .inline.field > label,
.ui.form .inline.field > p {
  display: inline-block;
  width: auto;
  margin-top: 0em;
  margin-bottom: 0em;
  vertical-align: baseline;
  font-size: 0.92857143em;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.87);
  text-transform: none;
}
/* Grouped Inline Label */
.ui.form .inline.fields > label {
  margin: 0.035714em 1em 0em 0em;
}
/* Inline Input */
.ui.form .inline.fields .field > input,
.ui.form .inline.fields .field > select,
.ui.form .inline.field > input,
.ui.form .inline.field > select {
  display: inline-block;
  width: auto;
  margin-top: 0em;
  margin-bottom: 0em;
  vertical-align: middle;
  font-size: 1em;
}
/* Label */
.ui.form .inline.fields .field > :first-child,
.ui.form .inline.field > :first-child {
  margin: 0em 0.85714286em 0em 0em;
}
.ui.form .inline.fields .field > :only-child,
.ui.form .inline.field > :only-child {
  margin: 0em;
}
/* Wide */
.ui.form .inline.fields .wide.field {
  display: flex;
  align-items: center;
}
.ui.form .inline.fields .wide.field > input,
.ui.form .inline.fields .wide.field > select {
  width: 100%;
}
/*--------------------
        Sizes
---------------------*/
.ui.mini.form {
  font-size: 0.78571429rem;
}
.ui.tiny.form {
  font-size: 0.85714286rem;
}
.ui.small.form {
  font-size: 0.92857143rem;
}
.ui.form {
  font-size: 1rem;
}
.ui.large.form {
  font-size: 1.14285714rem;
}
.ui.big.form {
  font-size: 1.28571429rem;
}
.ui.huge.form {
  font-size: 1.42857143rem;
}
.ui.massive.form {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Grid
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Grid
*******************************/
/* Inherited From Site */
/*******************************
            Grid
*******************************/
/*******************************
           Variations
*******************************/
/*--------------
     Relaxed
---------------*/
/*--------------
     Divided
---------------*/
/*--------------
    Celled
---------------*/
/*--------------
    Stackable
---------------*/
/*******************************
             Legacy
*******************************/
/*--------------
     Page
---------------*/
/* Legacy (DO NOT USE)
 */
/* Packaged Theme */
/*******************************
             Grid
*******************************/
/* Inherited From Site */
/*******************************
            Grid
*******************************/
/*******************************
           Variations
*******************************/
/*--------------
     Relaxed
---------------*/
/*--------------
     Divided
---------------*/
/*--------------
    Celled
---------------*/
/*--------------
    Stackable
---------------*/
/*******************************
             Legacy
*******************************/
/*--------------
     Page
---------------*/
/* Legacy (DO NOT USE)
 */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Standard
*******************************/
.ui.grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 0em;
}
/*----------------------
      Remove Gutters
-----------------------*/
.ui.grid {
  margin-top: -1rem;
  margin-bottom: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}
.ui.relaxed.grid {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.ui[class*="very relaxed"].grid {
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}
/* Preserve Rows Spacing on Consecutive Grids */
.ui.grid + .grid {
  margin-top: 1rem;
}
/*-------------------
       Columns
--------------------*/
/* Standard 16 column */
.ui.grid > .column:not(.row),
.ui.grid > .row > .column {
  position: relative;
  display: inline-block;
  width: 6.25%;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
}
.ui.grid > * {
  padding-left: 1rem;
  padding-right: 1rem;
}
/*-------------------
        Rows
--------------------*/
.ui.grid > .row {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: inherit;
  align-items: stretch;
  width: 100% !important;
  padding: 0rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
/*-------------------
       Columns
--------------------*/
/* Vertical padding when no rows */
.ui.grid > .column:not(.row) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.ui.grid > .row > .column {
  margin-top: 0em;
  margin-bottom: 0em;
}
/*-------------------
      Content
--------------------*/
.ui.grid > .row > img,
.ui.grid > .row > .column > img {
  max-width: 100%;
}
/*-------------------
    Loose Coupling
--------------------*/
/* Collapse Margin on Consecutive Grid */
.ui.grid > .ui.grid:first-child {
  margin-top: 0em;
}
.ui.grid > .ui.grid:last-child {
  margin-bottom: 0em;
}
/* Segment inside Aligned Grid */
.ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached),
.ui.aligned.grid .column > .segment:not(.compact):not(.attached) {
  width: 100%;
}
/* Align Dividers with Gutter */
.ui.grid .row + .ui.divider {
  flex-grow: 1;
  margin: 1rem 1rem;
}
.ui.grid .column + .ui.vertical.divider {
  height: calc(50% - (2rem / 2));
}
/* Remove Border on Last Horizontal Segment */
.ui.grid > .row > .column:last-child > .horizontal.segment,
.ui.grid > .column:last-child > .horizontal.segment {
  box-shadow: none;
}
/*******************************
           Variations
*******************************/
/*-----------------------
       Page Grid
-------------------------*/
@media only screen and (max-width: 767px) {
  .ui.page.grid {
    width: auto;
    padding-left: 0em;
    padding-right: 0em;
    margin-left: 0em;
    margin-right: 0em;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.page.grid {
    width: auto;
    margin-left: 0em;
    margin-right: 0em;
    padding-left: 2em;
    padding-right: 2em;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .ui.page.grid {
    width: auto;
    margin-left: 0em;
    margin-right: 0em;
    padding-left: 3%;
    padding-right: 3%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919px) {
  .ui.page.grid {
    width: auto;
    margin-left: 0em;
    margin-right: 0em;
    padding-left: 15%;
    padding-right: 15%;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.page.grid {
    width: auto;
    margin-left: 0em;
    margin-right: 0em;
    padding-left: 23%;
    padding-right: 23%;
  }
}
/*-------------------
     Column Count
--------------------*/
/* Assume full width with one column */
.ui.grid > .column:only-child,
.ui.grid > .row > .column:only-child {
  width: 100%;
}
/* Grid Based */
.ui[class*="one column"].grid > .row > .column,
.ui[class*="one column"].grid > .column:not(.row) {
  width: 100%;
}
.ui[class*="two column"].grid > .row > .column,
.ui[class*="two column"].grid > .column:not(.row) {
  width: 50%;
}
.ui[class*="three column"].grid > .row > .column,
.ui[class*="three column"].grid > .column:not(.row) {
  width: 33.33333333%;
}
.ui[class*="four column"].grid > .row > .column,
.ui[class*="four column"].grid > .column:not(.row) {
  width: 25%;
}
.ui[class*="five column"].grid > .row > .column,
.ui[class*="five column"].grid > .column:not(.row) {
  width: 20%;
}
.ui[class*="six column"].grid > .row > .column,
.ui[class*="six column"].grid > .column:not(.row) {
  width: 16.66666667%;
}
.ui[class*="seven column"].grid > .row > .column,
.ui[class*="seven column"].grid > .column:not(.row) {
  width: 14.28571429%;
}
.ui[class*="eight column"].grid > .row > .column,
.ui[class*="eight column"].grid > .column:not(.row) {
  width: 12.5%;
}
.ui[class*="nine column"].grid > .row > .column,
.ui[class*="nine column"].grid > .column:not(.row) {
  width: 11.11111111%;
}
.ui[class*="ten column"].grid > .row > .column,
.ui[class*="ten column"].grid > .column:not(.row) {
  width: 10%;
}
.ui[class*="eleven column"].grid > .row > .column,
.ui[class*="eleven column"].grid > .column:not(.row) {
  width: 9.09090909%;
}
.ui[class*="twelve column"].grid > .row > .column,
.ui[class*="twelve column"].grid > .column:not(.row) {
  width: 8.33333333%;
}
.ui[class*="thirteen column"].grid > .row > .column,
.ui[class*="thirteen column"].grid > .column:not(.row) {
  width: 7.69230769%;
}
.ui[class*="fourteen column"].grid > .row > .column,
.ui[class*="fourteen column"].grid > .column:not(.row) {
  width: 7.14285714%;
}
.ui[class*="fifteen column"].grid > .row > .column,
.ui[class*="fifteen column"].grid > .column:not(.row) {
  width: 6.66666667%;
}
.ui[class*="sixteen column"].grid > .row > .column,
.ui[class*="sixteen column"].grid > .column:not(.row) {
  width: 6.25%;
}
/* Row Based Overrides */
.ui.grid > [class*="one column"].row > .column {
  width: 100% !important;
}
.ui.grid > [class*="two column"].row > .column {
  width: 50% !important;
}
.ui.grid > [class*="three column"].row > .column {
  width: 33.33333333% !important;
}
.ui.grid > [class*="four column"].row > .column {
  width: 25% !important;
}
.ui.grid > [class*="five column"].row > .column {
  width: 20% !important;
}
.ui.grid > [class*="six column"].row > .column {
  width: 16.66666667% !important;
}
.ui.grid > [class*="seven column"].row > .column {
  width: 14.28571429% !important;
}
.ui.grid > [class*="eight column"].row > .column {
  width: 12.5% !important;
}
.ui.grid > [class*="nine column"].row > .column {
  width: 11.11111111% !important;
}
.ui.grid > [class*="ten column"].row > .column {
  width: 10% !important;
}
.ui.grid > [class*="eleven column"].row > .column {
  width: 9.09090909% !important;
}
.ui.grid > [class*="twelve column"].row > .column {
  width: 8.33333333% !important;
}
.ui.grid > [class*="thirteen column"].row > .column {
  width: 7.69230769% !important;
}
.ui.grid > [class*="fourteen column"].row > .column {
  width: 7.14285714% !important;
}
.ui.grid > [class*="fifteen column"].row > .column {
  width: 6.66666667% !important;
}
.ui.grid > [class*="sixteen column"].row > .column {
  width: 6.25% !important;
}
/* Celled Page */
.ui.celled.page.grid {
  box-shadow: none;
}
/*-------------------
    Column Width
--------------------*/
/* Sizing Combinations */
.ui.grid > .row > [class*="one wide"].column,
.ui.grid > .column.row > [class*="one wide"].column,
.ui.grid > [class*="one wide"].column,
.ui.column.grid > [class*="one wide"].column {
  width: 6.25% !important;
}
.ui.grid > .row > [class*="two wide"].column,
.ui.grid > .column.row > [class*="two wide"].column,
.ui.grid > [class*="two wide"].column,
.ui.column.grid > [class*="two wide"].column {
  width: 12.5% !important;
}
.ui.grid > .row > [class*="three wide"].column,
.ui.grid > .column.row > [class*="three wide"].column,
.ui.grid > [class*="three wide"].column,
.ui.column.grid > [class*="three wide"].column {
  width: 18.75% !important;
}
.ui.grid > .row > [class*="four wide"].column,
.ui.grid > .column.row > [class*="four wide"].column,
.ui.grid > [class*="four wide"].column,
.ui.column.grid > [class*="four wide"].column {
  width: 25% !important;
}
.ui.grid > .row > [class*="five wide"].column,
.ui.grid > .column.row > [class*="five wide"].column,
.ui.grid > [class*="five wide"].column,
.ui.column.grid > [class*="five wide"].column {
  width: 31.25% !important;
}
.ui.grid > .row > [class*="six wide"].column,
.ui.grid > .column.row > [class*="six wide"].column,
.ui.grid > [class*="six wide"].column,
.ui.column.grid > [class*="six wide"].column {
  width: 37.5% !important;
}
.ui.grid > .row > [class*="seven wide"].column,
.ui.grid > .column.row > [class*="seven wide"].column,
.ui.grid > [class*="seven wide"].column,
.ui.column.grid > [class*="seven wide"].column {
  width: 43.75% !important;
}
.ui.grid > .row > [class*="eight wide"].column,
.ui.grid > .column.row > [class*="eight wide"].column,
.ui.grid > [class*="eight wide"].column,
.ui.column.grid > [class*="eight wide"].column {
  width: 50% !important;
}
.ui.grid > .row > [class*="nine wide"].column,
.ui.grid > .column.row > [class*="nine wide"].column,
.ui.grid > [class*="nine wide"].column,
.ui.column.grid > [class*="nine wide"].column {
  width: 56.25% !important;
}
.ui.grid > .row > [class*="ten wide"].column,
.ui.grid > .column.row > [class*="ten wide"].column,
.ui.grid > [class*="ten wide"].column,
.ui.column.grid > [class*="ten wide"].column {
  width: 62.5% !important;
}
.ui.grid > .row > [class*="eleven wide"].column,
.ui.grid > .column.row > [class*="eleven wide"].column,
.ui.grid > [class*="eleven wide"].column,
.ui.column.grid > [class*="eleven wide"].column {
  width: 68.75% !important;
}
.ui.grid > .row > [class*="twelve wide"].column,
.ui.grid > .column.row > [class*="twelve wide"].column,
.ui.grid > [class*="twelve wide"].column,
.ui.column.grid > [class*="twelve wide"].column {
  width: 75% !important;
}
.ui.grid > .row > [class*="thirteen wide"].column,
.ui.grid > .column.row > [class*="thirteen wide"].column,
.ui.grid > [class*="thirteen wide"].column,
.ui.column.grid > [class*="thirteen wide"].column {
  width: 81.25% !important;
}
.ui.grid > .row > [class*="fourteen wide"].column,
.ui.grid > .column.row > [class*="fourteen wide"].column,
.ui.grid > [class*="fourteen wide"].column,
.ui.column.grid > [class*="fourteen wide"].column {
  width: 87.5% !important;
}
.ui.grid > .row > [class*="fifteen wide"].column,
.ui.grid > .column.row > [class*="fifteen wide"].column,
.ui.grid > [class*="fifteen wide"].column,
.ui.column.grid > [class*="fifteen wide"].column {
  width: 93.75% !important;
}
.ui.grid > .row > [class*="sixteen wide"].column,
.ui.grid > .column.row > [class*="sixteen wide"].column,
.ui.grid > [class*="sixteen wide"].column,
.ui.column.grid > [class*="sixteen wide"].column {
  width: 100% !important;
}
/*----------------------
    Width per Device
-----------------------*/
/* Mobile Sizing Combinations */
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .ui.grid > .row > [class*="one wide mobile"].column,
  .ui.grid > .column.row > [class*="one wide mobile"].column,
  .ui.grid > [class*="one wide mobile"].column,
  .ui.column.grid > [class*="one wide mobile"].column {
    width: 6.25% !important;
  }
  .ui.grid > .row > [class*="two wide mobile"].column,
  .ui.grid > .column.row > [class*="two wide mobile"].column,
  .ui.grid > [class*="two wide mobile"].column,
  .ui.column.grid > [class*="two wide mobile"].column {
    width: 12.5% !important;
  }
  .ui.grid > .row > [class*="three wide mobile"].column,
  .ui.grid > .column.row > [class*="three wide mobile"].column,
  .ui.grid > [class*="three wide mobile"].column,
  .ui.column.grid > [class*="three wide mobile"].column {
    width: 18.75% !important;
  }
  .ui.grid > .row > [class*="four wide mobile"].column,
  .ui.grid > .column.row > [class*="four wide mobile"].column,
  .ui.grid > [class*="four wide mobile"].column,
  .ui.column.grid > [class*="four wide mobile"].column {
    width: 25% !important;
  }
  .ui.grid > .row > [class*="five wide mobile"].column,
  .ui.grid > .column.row > [class*="five wide mobile"].column,
  .ui.grid > [class*="five wide mobile"].column,
  .ui.column.grid > [class*="five wide mobile"].column {
    width: 31.25% !important;
  }
  .ui.grid > .row > [class*="six wide mobile"].column,
  .ui.grid > .column.row > [class*="six wide mobile"].column,
  .ui.grid > [class*="six wide mobile"].column,
  .ui.column.grid > [class*="six wide mobile"].column {
    width: 37.5% !important;
  }
  .ui.grid > .row > [class*="seven wide mobile"].column,
  .ui.grid > .column.row > [class*="seven wide mobile"].column,
  .ui.grid > [class*="seven wide mobile"].column,
  .ui.column.grid > [class*="seven wide mobile"].column {
    width: 43.75% !important;
  }
  .ui.grid > .row > [class*="eight wide mobile"].column,
  .ui.grid > .column.row > [class*="eight wide mobile"].column,
  .ui.grid > [class*="eight wide mobile"].column,
  .ui.column.grid > [class*="eight wide mobile"].column {
    width: 50% !important;
  }
  .ui.grid > .row > [class*="nine wide mobile"].column,
  .ui.grid > .column.row > [class*="nine wide mobile"].column,
  .ui.grid > [class*="nine wide mobile"].column,
  .ui.column.grid > [class*="nine wide mobile"].column {
    width: 56.25% !important;
  }
  .ui.grid > .row > [class*="ten wide mobile"].column,
  .ui.grid > .column.row > [class*="ten wide mobile"].column,
  .ui.grid > [class*="ten wide mobile"].column,
  .ui.column.grid > [class*="ten wide mobile"].column {
    width: 62.5% !important;
  }
  .ui.grid > .row > [class*="eleven wide mobile"].column,
  .ui.grid > .column.row > [class*="eleven wide mobile"].column,
  .ui.grid > [class*="eleven wide mobile"].column,
  .ui.column.grid > [class*="eleven wide mobile"].column {
    width: 68.75% !important;
  }
  .ui.grid > .row > [class*="twelve wide mobile"].column,
  .ui.grid > .column.row > [class*="twelve wide mobile"].column,
  .ui.grid > [class*="twelve wide mobile"].column,
  .ui.column.grid > [class*="twelve wide mobile"].column {
    width: 75% !important;
  }
  .ui.grid > .row > [class*="thirteen wide mobile"].column,
  .ui.grid > .column.row > [class*="thirteen wide mobile"].column,
  .ui.grid > [class*="thirteen wide mobile"].column,
  .ui.column.grid > [class*="thirteen wide mobile"].column {
    width: 81.25% !important;
  }
  .ui.grid > .row > [class*="fourteen wide mobile"].column,
  .ui.grid > .column.row > [class*="fourteen wide mobile"].column,
  .ui.grid > [class*="fourteen wide mobile"].column,
  .ui.column.grid > [class*="fourteen wide mobile"].column {
    width: 87.5% !important;
  }
  .ui.grid > .row > [class*="fifteen wide mobile"].column,
  .ui.grid > .column.row > [class*="fifteen wide mobile"].column,
  .ui.grid > [class*="fifteen wide mobile"].column,
  .ui.column.grid > [class*="fifteen wide mobile"].column {
    width: 93.75% !important;
  }
  .ui.grid > .row > [class*="sixteen wide mobile"].column,
  .ui.grid > .column.row > [class*="sixteen wide mobile"].column,
  .ui.grid > [class*="sixteen wide mobile"].column,
  .ui.column.grid > [class*="sixteen wide mobile"].column {
    width: 100% !important;
  }
}
/* Tablet Sizing Combinations */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.grid > .row > [class*="one wide tablet"].column,
  .ui.grid > .column.row > [class*="one wide tablet"].column,
  .ui.grid > [class*="one wide tablet"].column,
  .ui.column.grid > [class*="one wide tablet"].column {
    width: 6.25% !important;
  }
  .ui.grid > .row > [class*="two wide tablet"].column,
  .ui.grid > .column.row > [class*="two wide tablet"].column,
  .ui.grid > [class*="two wide tablet"].column,
  .ui.column.grid > [class*="two wide tablet"].column {
    width: 12.5% !important;
  }
  .ui.grid > .row > [class*="three wide tablet"].column,
  .ui.grid > .column.row > [class*="three wide tablet"].column,
  .ui.grid > [class*="three wide tablet"].column,
  .ui.column.grid > [class*="three wide tablet"].column {
    width: 18.75% !important;
  }
  .ui.grid > .row > [class*="four wide tablet"].column,
  .ui.grid > .column.row > [class*="four wide tablet"].column,
  .ui.grid > [class*="four wide tablet"].column,
  .ui.column.grid > [class*="four wide tablet"].column {
    width: 25% !important;
  }
  .ui.grid > .row > [class*="five wide tablet"].column,
  .ui.grid > .column.row > [class*="five wide tablet"].column,
  .ui.grid > [class*="five wide tablet"].column,
  .ui.column.grid > [class*="five wide tablet"].column {
    width: 31.25% !important;
  }
  .ui.grid > .row > [class*="six wide tablet"].column,
  .ui.grid > .column.row > [class*="six wide tablet"].column,
  .ui.grid > [class*="six wide tablet"].column,
  .ui.column.grid > [class*="six wide tablet"].column {
    width: 37.5% !important;
  }
  .ui.grid > .row > [class*="seven wide tablet"].column,
  .ui.grid > .column.row > [class*="seven wide tablet"].column,
  .ui.grid > [class*="seven wide tablet"].column,
  .ui.column.grid > [class*="seven wide tablet"].column {
    width: 43.75% !important;
  }
  .ui.grid > .row > [class*="eight wide tablet"].column,
  .ui.grid > .column.row > [class*="eight wide tablet"].column,
  .ui.grid > [class*="eight wide tablet"].column,
  .ui.column.grid > [class*="eight wide tablet"].column {
    width: 50% !important;
  }
  .ui.grid > .row > [class*="nine wide tablet"].column,
  .ui.grid > .column.row > [class*="nine wide tablet"].column,
  .ui.grid > [class*="nine wide tablet"].column,
  .ui.column.grid > [class*="nine wide tablet"].column {
    width: 56.25% !important;
  }
  .ui.grid > .row > [class*="ten wide tablet"].column,
  .ui.grid > .column.row > [class*="ten wide tablet"].column,
  .ui.grid > [class*="ten wide tablet"].column,
  .ui.column.grid > [class*="ten wide tablet"].column {
    width: 62.5% !important;
  }
  .ui.grid > .row > [class*="eleven wide tablet"].column,
  .ui.grid > .column.row > [class*="eleven wide tablet"].column,
  .ui.grid > [class*="eleven wide tablet"].column,
  .ui.column.grid > [class*="eleven wide tablet"].column {
    width: 68.75% !important;
  }
  .ui.grid > .row > [class*="twelve wide tablet"].column,
  .ui.grid > .column.row > [class*="twelve wide tablet"].column,
  .ui.grid > [class*="twelve wide tablet"].column,
  .ui.column.grid > [class*="twelve wide tablet"].column {
    width: 75% !important;
  }
  .ui.grid > .row > [class*="thirteen wide tablet"].column,
  .ui.grid > .column.row > [class*="thirteen wide tablet"].column,
  .ui.grid > [class*="thirteen wide tablet"].column,
  .ui.column.grid > [class*="thirteen wide tablet"].column {
    width: 81.25% !important;
  }
  .ui.grid > .row > [class*="fourteen wide tablet"].column,
  .ui.grid > .column.row > [class*="fourteen wide tablet"].column,
  .ui.grid > [class*="fourteen wide tablet"].column,
  .ui.column.grid > [class*="fourteen wide tablet"].column {
    width: 87.5% !important;
  }
  .ui.grid > .row > [class*="fifteen wide tablet"].column,
  .ui.grid > .column.row > [class*="fifteen wide tablet"].column,
  .ui.grid > [class*="fifteen wide tablet"].column,
  .ui.column.grid > [class*="fifteen wide tablet"].column {
    width: 93.75% !important;
  }
  .ui.grid > .row > [class*="sixteen wide tablet"].column,
  .ui.grid > .column.row > [class*="sixteen wide tablet"].column,
  .ui.grid > [class*="sixteen wide tablet"].column,
  .ui.column.grid > [class*="sixteen wide tablet"].column {
    width: 100% !important;
  }
}
/* Computer/Desktop Sizing Combinations */
@media only screen and (min-width: 992px) {
  .ui.grid > .row > [class*="one wide computer"].column,
  .ui.grid > .column.row > [class*="one wide computer"].column,
  .ui.grid > [class*="one wide computer"].column,
  .ui.column.grid > [class*="one wide computer"].column {
    width: 6.25% !important;
  }
  .ui.grid > .row > [class*="two wide computer"].column,
  .ui.grid > .column.row > [class*="two wide computer"].column,
  .ui.grid > [class*="two wide computer"].column,
  .ui.column.grid > [class*="two wide computer"].column {
    width: 12.5% !important;
  }
  .ui.grid > .row > [class*="three wide computer"].column,
  .ui.grid > .column.row > [class*="three wide computer"].column,
  .ui.grid > [class*="three wide computer"].column,
  .ui.column.grid > [class*="three wide computer"].column {
    width: 18.75% !important;
  }
  .ui.grid > .row > [class*="four wide computer"].column,
  .ui.grid > .column.row > [class*="four wide computer"].column,
  .ui.grid > [class*="four wide computer"].column,
  .ui.column.grid > [class*="four wide computer"].column {
    width: 25% !important;
  }
  .ui.grid > .row > [class*="five wide computer"].column,
  .ui.grid > .column.row > [class*="five wide computer"].column,
  .ui.grid > [class*="five wide computer"].column,
  .ui.column.grid > [class*="five wide computer"].column {
    width: 31.25% !important;
  }
  .ui.grid > .row > [class*="six wide computer"].column,
  .ui.grid > .column.row > [class*="six wide computer"].column,
  .ui.grid > [class*="six wide computer"].column,
  .ui.column.grid > [class*="six wide computer"].column {
    width: 37.5% !important;
  }
  .ui.grid > .row > [class*="seven wide computer"].column,
  .ui.grid > .column.row > [class*="seven wide computer"].column,
  .ui.grid > [class*="seven wide computer"].column,
  .ui.column.grid > [class*="seven wide computer"].column {
    width: 43.75% !important;
  }
  .ui.grid > .row > [class*="eight wide computer"].column,
  .ui.grid > .column.row > [class*="eight wide computer"].column,
  .ui.grid > [class*="eight wide computer"].column,
  .ui.column.grid > [class*="eight wide computer"].column {
    width: 50% !important;
  }
  .ui.grid > .row > [class*="nine wide computer"].column,
  .ui.grid > .column.row > [class*="nine wide computer"].column,
  .ui.grid > [class*="nine wide computer"].column,
  .ui.column.grid > [class*="nine wide computer"].column {
    width: 56.25% !important;
  }
  .ui.grid > .row > [class*="ten wide computer"].column,
  .ui.grid > .column.row > [class*="ten wide computer"].column,
  .ui.grid > [class*="ten wide computer"].column,
  .ui.column.grid > [class*="ten wide computer"].column {
    width: 62.5% !important;
  }
  .ui.grid > .row > [class*="eleven wide computer"].column,
  .ui.grid > .column.row > [class*="eleven wide computer"].column,
  .ui.grid > [class*="eleven wide computer"].column,
  .ui.column.grid > [class*="eleven wide computer"].column {
    width: 68.75% !important;
  }
  .ui.grid > .row > [class*="twelve wide computer"].column,
  .ui.grid > .column.row > [class*="twelve wide computer"].column,
  .ui.grid > [class*="twelve wide computer"].column,
  .ui.column.grid > [class*="twelve wide computer"].column {
    width: 75% !important;
  }
  .ui.grid > .row > [class*="thirteen wide computer"].column,
  .ui.grid > .column.row > [class*="thirteen wide computer"].column,
  .ui.grid > [class*="thirteen wide computer"].column,
  .ui.column.grid > [class*="thirteen wide computer"].column {
    width: 81.25% !important;
  }
  .ui.grid > .row > [class*="fourteen wide computer"].column,
  .ui.grid > .column.row > [class*="fourteen wide computer"].column,
  .ui.grid > [class*="fourteen wide computer"].column,
  .ui.column.grid > [class*="fourteen wide computer"].column {
    width: 87.5% !important;
  }
  .ui.grid > .row > [class*="fifteen wide computer"].column,
  .ui.grid > .column.row > [class*="fifteen wide computer"].column,
  .ui.grid > [class*="fifteen wide computer"].column,
  .ui.column.grid > [class*="fifteen wide computer"].column {
    width: 93.75% !important;
  }
  .ui.grid > .row > [class*="sixteen wide computer"].column,
  .ui.grid > .column.row > [class*="sixteen wide computer"].column,
  .ui.grid > [class*="sixteen wide computer"].column,
  .ui.column.grid > [class*="sixteen wide computer"].column {
    width: 100% !important;
  }
}
/* Large Monitor Sizing Combinations */
@media only screen and (min-width: 1200px) and (max-width: 1919px) {
  .ui.grid > .row > [class*="one wide large screen"].column,
  .ui.grid > .column.row > [class*="one wide large screen"].column,
  .ui.grid > [class*="one wide large screen"].column,
  .ui.column.grid > [class*="one wide large screen"].column {
    width: 6.25% !important;
  }
  .ui.grid > .row > [class*="two wide large screen"].column,
  .ui.grid > .column.row > [class*="two wide large screen"].column,
  .ui.grid > [class*="two wide large screen"].column,
  .ui.column.grid > [class*="two wide large screen"].column {
    width: 12.5% !important;
  }
  .ui.grid > .row > [class*="three wide large screen"].column,
  .ui.grid > .column.row > [class*="three wide large screen"].column,
  .ui.grid > [class*="three wide large screen"].column,
  .ui.column.grid > [class*="three wide large screen"].column {
    width: 18.75% !important;
  }
  .ui.grid > .row > [class*="four wide large screen"].column,
  .ui.grid > .column.row > [class*="four wide large screen"].column,
  .ui.grid > [class*="four wide large screen"].column,
  .ui.column.grid > [class*="four wide large screen"].column {
    width: 25% !important;
  }
  .ui.grid > .row > [class*="five wide large screen"].column,
  .ui.grid > .column.row > [class*="five wide large screen"].column,
  .ui.grid > [class*="five wide large screen"].column,
  .ui.column.grid > [class*="five wide large screen"].column {
    width: 31.25% !important;
  }
  .ui.grid > .row > [class*="six wide large screen"].column,
  .ui.grid > .column.row > [class*="six wide large screen"].column,
  .ui.grid > [class*="six wide large screen"].column,
  .ui.column.grid > [class*="six wide large screen"].column {
    width: 37.5% !important;
  }
  .ui.grid > .row > [class*="seven wide large screen"].column,
  .ui.grid > .column.row > [class*="seven wide large screen"].column,
  .ui.grid > [class*="seven wide large screen"].column,
  .ui.column.grid > [class*="seven wide large screen"].column {
    width: 43.75% !important;
  }
  .ui.grid > .row > [class*="eight wide large screen"].column,
  .ui.grid > .column.row > [class*="eight wide large screen"].column,
  .ui.grid > [class*="eight wide large screen"].column,
  .ui.column.grid > [class*="eight wide large screen"].column {
    width: 50% !important;
  }
  .ui.grid > .row > [class*="nine wide large screen"].column,
  .ui.grid > .column.row > [class*="nine wide large screen"].column,
  .ui.grid > [class*="nine wide large screen"].column,
  .ui.column.grid > [class*="nine wide large screen"].column {
    width: 56.25% !important;
  }
  .ui.grid > .row > [class*="ten wide large screen"].column,
  .ui.grid > .column.row > [class*="ten wide large screen"].column,
  .ui.grid > [class*="ten wide large screen"].column,
  .ui.column.grid > [class*="ten wide large screen"].column {
    width: 62.5% !important;
  }
  .ui.grid > .row > [class*="eleven wide large screen"].column,
  .ui.grid > .column.row > [class*="eleven wide large screen"].column,
  .ui.grid > [class*="eleven wide large screen"].column,
  .ui.column.grid > [class*="eleven wide large screen"].column {
    width: 68.75% !important;
  }
  .ui.grid > .row > [class*="twelve wide large screen"].column,
  .ui.grid > .column.row > [class*="twelve wide large screen"].column,
  .ui.grid > [class*="twelve wide large screen"].column,
  .ui.column.grid > [class*="twelve wide large screen"].column {
    width: 75% !important;
  }
  .ui.grid > .row > [class*="thirteen wide large screen"].column,
  .ui.grid > .column.row > [class*="thirteen wide large screen"].column,
  .ui.grid > [class*="thirteen wide large screen"].column,
  .ui.column.grid > [class*="thirteen wide large screen"].column {
    width: 81.25% !important;
  }
  .ui.grid > .row > [class*="fourteen wide large screen"].column,
  .ui.grid > .column.row > [class*="fourteen wide large screen"].column,
  .ui.grid > [class*="fourteen wide large screen"].column,
  .ui.column.grid > [class*="fourteen wide large screen"].column {
    width: 87.5% !important;
  }
  .ui.grid > .row > [class*="fifteen wide large screen"].column,
  .ui.grid > .column.row > [class*="fifteen wide large screen"].column,
  .ui.grid > [class*="fifteen wide large screen"].column,
  .ui.column.grid > [class*="fifteen wide large screen"].column {
    width: 93.75% !important;
  }
  .ui.grid > .row > [class*="sixteen wide large screen"].column,
  .ui.grid > .column.row > [class*="sixteen wide large screen"].column,
  .ui.grid > [class*="sixteen wide large screen"].column,
  .ui.column.grid > [class*="sixteen wide large screen"].column {
    width: 100% !important;
  }
}
/* Widescreen Sizing Combinations */
@media only screen and (min-width: 1920px) {
  .ui.grid > .row > [class*="one wide widescreen"].column,
  .ui.grid > .column.row > [class*="one wide widescreen"].column,
  .ui.grid > [class*="one wide widescreen"].column,
  .ui.column.grid > [class*="one wide widescreen"].column {
    width: 6.25% !important;
  }
  .ui.grid > .row > [class*="two wide widescreen"].column,
  .ui.grid > .column.row > [class*="two wide widescreen"].column,
  .ui.grid > [class*="two wide widescreen"].column,
  .ui.column.grid > [class*="two wide widescreen"].column {
    width: 12.5% !important;
  }
  .ui.grid > .row > [class*="three wide widescreen"].column,
  .ui.grid > .column.row > [class*="three wide widescreen"].column,
  .ui.grid > [class*="three wide widescreen"].column,
  .ui.column.grid > [class*="three wide widescreen"].column {
    width: 18.75% !important;
  }
  .ui.grid > .row > [class*="four wide widescreen"].column,
  .ui.grid > .column.row > [class*="four wide widescreen"].column,
  .ui.grid > [class*="four wide widescreen"].column,
  .ui.column.grid > [class*="four wide widescreen"].column {
    width: 25% !important;
  }
  .ui.grid > .row > [class*="five wide widescreen"].column,
  .ui.grid > .column.row > [class*="five wide widescreen"].column,
  .ui.grid > [class*="five wide widescreen"].column,
  .ui.column.grid > [class*="five wide widescreen"].column {
    width: 31.25% !important;
  }
  .ui.grid > .row > [class*="six wide widescreen"].column,
  .ui.grid > .column.row > [class*="six wide widescreen"].column,
  .ui.grid > [class*="six wide widescreen"].column,
  .ui.column.grid > [class*="six wide widescreen"].column {
    width: 37.5% !important;
  }
  .ui.grid > .row > [class*="seven wide widescreen"].column,
  .ui.grid > .column.row > [class*="seven wide widescreen"].column,
  .ui.grid > [class*="seven wide widescreen"].column,
  .ui.column.grid > [class*="seven wide widescreen"].column {
    width: 43.75% !important;
  }
  .ui.grid > .row > [class*="eight wide widescreen"].column,
  .ui.grid > .column.row > [class*="eight wide widescreen"].column,
  .ui.grid > [class*="eight wide widescreen"].column,
  .ui.column.grid > [class*="eight wide widescreen"].column {
    width: 50% !important;
  }
  .ui.grid > .row > [class*="nine wide widescreen"].column,
  .ui.grid > .column.row > [class*="nine wide widescreen"].column,
  .ui.grid > [class*="nine wide widescreen"].column,
  .ui.column.grid > [class*="nine wide widescreen"].column {
    width: 56.25% !important;
  }
  .ui.grid > .row > [class*="ten wide widescreen"].column,
  .ui.grid > .column.row > [class*="ten wide widescreen"].column,
  .ui.grid > [class*="ten wide widescreen"].column,
  .ui.column.grid > [class*="ten wide widescreen"].column {
    width: 62.5% !important;
  }
  .ui.grid > .row > [class*="eleven wide widescreen"].column,
  .ui.grid > .column.row > [class*="eleven wide widescreen"].column,
  .ui.grid > [class*="eleven wide widescreen"].column,
  .ui.column.grid > [class*="eleven wide widescreen"].column {
    width: 68.75% !important;
  }
  .ui.grid > .row > [class*="twelve wide widescreen"].column,
  .ui.grid > .column.row > [class*="twelve wide widescreen"].column,
  .ui.grid > [class*="twelve wide widescreen"].column,
  .ui.column.grid > [class*="twelve wide widescreen"].column {
    width: 75% !important;
  }
  .ui.grid > .row > [class*="thirteen wide widescreen"].column,
  .ui.grid > .column.row > [class*="thirteen wide widescreen"].column,
  .ui.grid > [class*="thirteen wide widescreen"].column,
  .ui.column.grid > [class*="thirteen wide widescreen"].column {
    width: 81.25% !important;
  }
  .ui.grid > .row > [class*="fourteen wide widescreen"].column,
  .ui.grid > .column.row > [class*="fourteen wide widescreen"].column,
  .ui.grid > [class*="fourteen wide widescreen"].column,
  .ui.column.grid > [class*="fourteen wide widescreen"].column {
    width: 87.5% !important;
  }
  .ui.grid > .row > [class*="fifteen wide widescreen"].column,
  .ui.grid > .column.row > [class*="fifteen wide widescreen"].column,
  .ui.grid > [class*="fifteen wide widescreen"].column,
  .ui.column.grid > [class*="fifteen wide widescreen"].column {
    width: 93.75% !important;
  }
  .ui.grid > .row > [class*="sixteen wide widescreen"].column,
  .ui.grid > .column.row > [class*="sixteen wide widescreen"].column,
  .ui.grid > [class*="sixteen wide widescreen"].column,
  .ui.column.grid > [class*="sixteen wide widescreen"].column {
    width: 100% !important;
  }
}
/*----------------------
        Centered
-----------------------*/
.ui.centered.grid,
.ui.centered.grid > .row,
.ui.grid > .centered.row {
  text-align: center;
  justify-content: center;
}
.ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),
.ui.centered.grid > .row > .column:not(.aligned):not(.justified),
.ui.grid .centered.row > .column:not(.aligned):not(.justified) {
  text-align: left;
}
.ui.grid > .centered.column,
.ui.grid > .row > .centered.column {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
/*----------------------
        Relaxed
-----------------------*/
.ui.relaxed.grid > .column:not(.row),
.ui.relaxed.grid > .row > .column,
.ui.grid > .relaxed.row > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.ui[class*="very relaxed"].grid > .column:not(.row),
.ui[class*="very relaxed"].grid > .row > .column,
.ui.grid > [class*="very relaxed"].row > .column {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
/* Coupling with UI Divider */
.ui.relaxed.grid .row + .ui.divider,
.ui.grid .relaxed.row + .ui.divider {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.ui[class*="very relaxed"].grid .row + .ui.divider,
.ui.grid [class*="very relaxed"].row + .ui.divider {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
/*----------------------
        Padded
-----------------------*/
.ui.padded.grid:not(.vertically):not(.horizontally) {
  margin: 0em !important;
}
[class*="horizontally padded"].ui.grid {
  margin-left: 0em !important;
  margin-right: 0em !important;
}
[class*="vertically padded"].ui.grid {
  margin-top: 0em !important;
  margin-bottom: 0em !important;
}
/*----------------------
       "Floated"
-----------------------*/
.ui.grid [class*="left floated"].column {
  margin-right: auto;
}
.ui.grid [class*="right floated"].column {
  margin-left: auto;
}
/*----------------------
        Divided
-----------------------*/
.ui.divided.grid:not([class*="vertically divided"]) > .column:not(.row),
.ui.divided.grid:not([class*="vertically divided"]) > .row > .column {
  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);
}
/* Swap from padding to margin on columns to have dividers align */
.ui[class*="vertically divided"].grid > .column:not(.row),
.ui[class*="vertically divided"].grid > .row > .column {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 0rem;
  padding-bottom: 0rem;
}
.ui[class*="vertically divided"].grid > .row {
  margin-top: 0em;
  margin-bottom: 0em;
}
/* No divider on first column on row */
.ui.divided.grid:not([class*="vertically divided"]) > .column:first-child,
.ui.divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
  box-shadow: none;
}
/* No space on top of first row */
.ui[class*="vertically divided"].grid > .row:first-child > .column {
  margin-top: 0em;
}
/* Divided Row */
.ui.grid > .divided.row > .column {
  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);
}
.ui.grid > .divided.row > .column:first-child {
  box-shadow: none;
}
/* Vertically Divided */
.ui[class*="vertically divided"].grid > .row {
  position: relative;
}
.ui[class*="vertically divided"].grid > .row:before {
  position: absolute;
  content: "";
  top: 0em;
  left: 0px;
  width: calc(100% - 2rem);
  height: 1px;
  margin: 0% 1rem;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
}
/* Padded Horizontally Divided */
[class*="horizontally padded"].ui.divided.grid,
.ui.padded.divided.grid:not(.vertically):not(.horizontally) {
  width: 100%;
}
/* First Row Vertically Divided */
.ui[class*="vertically divided"].grid > .row:first-child:before {
  box-shadow: none;
}
/* Inverted Divided */
.ui.inverted.divided.grid:not([class*="vertically divided"]) > .column:not(.row),
.ui.inverted.divided.grid:not([class*="vertically divided"]) > .row > .column {
  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.1);
}
.ui.inverted.divided.grid:not([class*="vertically divided"]) > .column:not(.row):first-child,
.ui.inverted.divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
  box-shadow: none;
}
.ui.inverted[class*="vertically divided"].grid > .row:before {
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1);
}
/* Relaxed */
.ui.relaxed[class*="vertically divided"].grid > .row:before {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  width: calc(100% - 3rem);
}
.ui[class*="very relaxed"][class*="vertically divided"].grid > .row:before {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  width: calc(100% - 5rem);
}
/*----------------------
         Celled
-----------------------*/
.ui.celled.grid {
  width: 100%;
  margin: 1em 0em;
  box-shadow: 0px 0px 0px 1px #D4D4D5;
}
.ui.celled.grid > .row {
  width: 100% !important;
  margin: 0em;
  padding: 0em;
  box-shadow: 0px -1px 0px 0px #D4D4D5;
}
.ui.celled.grid > .column:not(.row),
.ui.celled.grid > .row > .column {
  box-shadow: -1px 0px 0px 0px #D4D4D5;
}
.ui.celled.grid > .column:first-child,
.ui.celled.grid > .row > .column:first-child {
  box-shadow: none;
}
.ui.celled.grid > .column:not(.row),
.ui.celled.grid > .row > .column {
  padding: 1em;
}
.ui.relaxed.celled.grid > .column:not(.row),
.ui.relaxed.celled.grid > .row > .column {
  padding: 1.5em;
}
.ui[class*="very relaxed"].celled.grid > .column:not(.row),
.ui[class*="very relaxed"].celled.grid > .row > .column {
  padding: 2em;
}
/* Internally Celled */
.ui[class*="internally celled"].grid {
  box-shadow: none;
  margin: 0em;
}
.ui[class*="internally celled"].grid > .row:first-child {
  box-shadow: none;
}
.ui[class*="internally celled"].grid > .row > .column:first-child {
  box-shadow: none;
}
/*----------------------
   Vertically Aligned
-----------------------*/
/* Top Aligned */
.ui[class*="top aligned"].grid > .column:not(.row),
.ui[class*="top aligned"].grid > .row > .column,
.ui.grid > [class*="top aligned"].row > .column,
.ui.grid > [class*="top aligned"].column:not(.row),
.ui.grid > .row > [class*="top aligned"].column {
  flex-direction: column;
  vertical-align: top;
  align-self: flex-start !important;
}
/* Middle Aligned */
.ui[class*="middle aligned"].grid > .column:not(.row),
.ui[class*="middle aligned"].grid > .row > .column,
.ui.grid > [class*="middle aligned"].row > .column,
.ui.grid > [class*="middle aligned"].column:not(.row),
.ui.grid > .row > [class*="middle aligned"].column {
  flex-direction: column;
  vertical-align: middle;
  align-self: center !important;
}
/* Bottom Aligned */
.ui[class*="bottom aligned"].grid > .column:not(.row),
.ui[class*="bottom aligned"].grid > .row > .column,
.ui.grid > [class*="bottom aligned"].row > .column,
.ui.grid > [class*="bottom aligned"].column:not(.row),
.ui.grid > .row > [class*="bottom aligned"].column {
  flex-direction: column;
  vertical-align: bottom;
  align-self: flex-end !important;
}
/* Stretched */
.ui.stretched.grid > .row > .column,
.ui.stretched.grid > .column,
.ui.grid > .stretched.row > .column,
.ui.grid > .stretched.column:not(.row),
.ui.grid > .row > .stretched.column {
  display: inline-flex !important;
  align-self: stretch;
  flex-direction: column;
}
.ui.stretched.grid > .row > .column > *,
.ui.stretched.grid > .column > *,
.ui.grid > .stretched.row > .column > *,
.ui.grid > .stretched.column:not(.row) > *,
.ui.grid > .row > .stretched.column > * {
  flex-grow: 1;
}
/*----------------------
  Horizontally Centered
-----------------------*/
/* Left Aligned */
.ui[class*="left aligned"].grid > .column,
.ui[class*="left aligned"].grid > .row > .column,
.ui.grid > [class*="left aligned"].row > .column,
.ui.grid > [class*="left aligned"].column.column,
.ui.grid > .row > [class*="left aligned"].column.column {
  text-align: left;
  align-self: inherit;
}
/* Center Aligned */
.ui[class*="center aligned"].grid > .column,
.ui[class*="center aligned"].grid > .row > .column,
.ui.grid > [class*="center aligned"].row > .column,
.ui.grid > [class*="center aligned"].column.column,
.ui.grid > .row > [class*="center aligned"].column.column {
  text-align: center;
  align-self: inherit;
}
.ui[class*="center aligned"].grid {
  justify-content: center;
}
/* Right Aligned */
.ui[class*="right aligned"].grid > .column,
.ui[class*="right aligned"].grid > .row > .column,
.ui.grid > [class*="right aligned"].row > .column,
.ui.grid > [class*="right aligned"].column.column,
.ui.grid > .row > [class*="right aligned"].column.column {
  text-align: right;
  align-self: inherit;
}
/* Justified */
.ui.justified.grid > .column,
.ui.justified.grid > .row > .column,
.ui.grid > .justified.row > .column,
.ui.grid > .justified.column.column,
.ui.grid > .row > .justified.column.column {
  text-align: justify;
  hyphens: auto;
}
/*----------------------
         Colored
-----------------------*/
.ui.grid > .row > .red.column,
.ui.grid > .row > .orange.column,
.ui.grid > .row > .yellow.column,
.ui.grid > .row > .olive.column,
.ui.grid > .row > .green.column,
.ui.grid > .row > .teal.column,
.ui.grid > .row > .blue.column,
.ui.grid > .row > .violet.column,
.ui.grid > .row > .purple.column,
.ui.grid > .row > .pink.column,
.ui.grid > .row > .brown.column,
.ui.grid > .row > .grey.column,
.ui.grid > .row > .black.column {
  margin-top: -1rem;
  margin-bottom: -1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
/* Red */
.ui.grid > .red.row,
.ui.grid > .red.column,
.ui.grid > .row > .red.column {
  background-color: #DB2828 !important;
  color: #FFFFFF;
}
/* Orange */
.ui.grid > .orange.row,
.ui.grid > .orange.column,
.ui.grid > .row > .orange.column {
  background-color: #F2711C !important;
  color: #FFFFFF;
}
/* Yellow */
.ui.grid > .yellow.row,
.ui.grid > .yellow.column,
.ui.grid > .row > .yellow.column {
  background-color: #FBBD08 !important;
  color: #FFFFFF;
}
/* Olive */
.ui.grid > .olive.row,
.ui.grid > .olive.column,
.ui.grid > .row > .olive.column {
  background-color: #B5CC18 !important;
  color: #FFFFFF;
}
/* Green */
.ui.grid > .green.row,
.ui.grid > .green.column,
.ui.grid > .row > .green.column {
  background-color: #21BA45 !important;
  color: #FFFFFF;
}
/* Teal */
.ui.grid > .teal.row,
.ui.grid > .teal.column,
.ui.grid > .row > .teal.column {
  background-color: #00B5AD !important;
  color: #FFFFFF;
}
/* Blue */
.ui.grid > .blue.row,
.ui.grid > .blue.column,
.ui.grid > .row > .blue.column {
  background-color: #2185D0 !important;
  color: #FFFFFF;
}
/* Violet */
.ui.grid > .violet.row,
.ui.grid > .violet.column,
.ui.grid > .row > .violet.column {
  background-color: #6435C9 !important;
  color: #FFFFFF;
}
/* Purple */
.ui.grid > .purple.row,
.ui.grid > .purple.column,
.ui.grid > .row > .purple.column {
  background-color: #A333C8 !important;
  color: #FFFFFF;
}
/* Pink */
.ui.grid > .pink.row,
.ui.grid > .pink.column,
.ui.grid > .row > .pink.column {
  background-color: #E03997 !important;
  color: #FFFFFF;
}
/* Brown */
.ui.grid > .brown.row,
.ui.grid > .brown.column,
.ui.grid > .row > .brown.column {
  background-color: #A5673F !important;
  color: #FFFFFF;
}
/* Grey */
.ui.grid > .grey.row,
.ui.grid > .grey.column,
.ui.grid > .row > .grey.column {
  background-color: #767676 !important;
  color: #FFFFFF;
}
/* Black */
.ui.grid > .black.row,
.ui.grid > .black.column,
.ui.grid > .row > .black.column {
  background-color: #1B1C1D !important;
  color: #FFFFFF;
}
/*----------------------
      Equal Width
-----------------------*/
.ui[class*="equal width"].grid > .column:not(.row),
.ui[class*="equal width"].grid > .row > .column,
.ui.grid > [class*="equal width"].row > .column {
  display: inline-block;
  flex-grow: 1;
}
.ui[class*="equal width"].grid > .wide.column,
.ui[class*="equal width"].grid > .row > .wide.column,
.ui.grid > [class*="equal width"].row > .wide.column {
  flex-grow: 0;
}
/*----------------------
        Reverse
-----------------------*/
/* Mobile */
@media only screen and (max-width: 767px) {
  .ui[class*="mobile reversed"].grid,
  .ui[class*="mobile reversed"].grid > .row,
  .ui.grid > [class*="mobile reversed"].row {
    flex-direction: row-reverse;
  }
  .ui[class*="mobile vertically reversed"].grid,
  .ui.stackable[class*="mobile reversed"] {
    flex-direction: column-reverse;
  }
  /* Divided Reversed */
  .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  /* Vertically Divided Reversed */
  .ui.grid[class*="vertically divided"][class*="mobile vertically reversed"] > .row:first-child:before {
    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui.grid[class*="vertically divided"][class*="mobile vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  /* Celled Reversed */
  .ui[class*="mobile reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px #D4D4D5;
  }
  .ui[class*="mobile reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
/* Tablet */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui[class*="tablet reversed"].grid,
  .ui[class*="tablet reversed"].grid > .row,
  .ui.grid > [class*="tablet reversed"].row {
    flex-direction: row-reverse;
  }
  .ui[class*="tablet vertically reversed"].grid {
    flex-direction: column-reverse;
  }
  /* Divided Reversed */
  .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  /* Vertically Divided Reversed */
  .ui.grid[class*="vertically divided"][class*="tablet vertically reversed"] > .row:first-child:before {
    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui.grid[class*="vertically divided"][class*="tablet vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  /* Celled Reversed */
  .ui[class*="tablet reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px #D4D4D5;
  }
  .ui[class*="tablet reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
/* Computer */
@media only screen and (min-width: 992px) {
  .ui[class*="computer reversed"].grid,
  .ui[class*="computer reversed"].grid > .row,
  .ui.grid > [class*="computer reversed"].row {
    flex-direction: row-reverse;
  }
  .ui[class*="computer vertically reversed"].grid {
    flex-direction: column-reverse;
  }
  /* Divided Reversed */
  .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  /* Vertically Divided Reversed */
  .ui.grid[class*="vertically divided"][class*="computer vertically reversed"] > .row:first-child:before {
    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
  }
  .ui.grid[class*="vertically divided"][class*="computer vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  /* Celled Reversed */
  .ui[class*="computer reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0px 0px 0px #D4D4D5;
  }
  .ui[class*="computer reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
/*-------------------
      Doubling
--------------------*/
/* Tablet Only */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.doubling.grid {
    width: auto;
  }
  .ui.grid > .doubling.row,
  .ui.doubling.grid > .row {
    margin: 0em !important;
    padding: 0em !important;
  }
  .ui.grid > .doubling.row > .column,
  .ui.doubling.grid > .row > .column {
    display: inline-block !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    box-shadow: none !important;
    margin: 0em;
  }
  .ui[class*="two column"].doubling.grid > .row > .column,
  .ui[class*="two column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="two column"].doubling.row.row > .column {
    width: 100% !important;
  }
  .ui[class*="three column"].doubling.grid > .row > .column,
  .ui[class*="three column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="three column"].doubling.row.row > .column {
    width: 50% !important;
  }
  .ui[class*="four column"].doubling.grid > .row > .column,
  .ui[class*="four column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="four column"].doubling.row.row > .column {
    width: 50% !important;
  }
  .ui[class*="five column"].doubling.grid > .row > .column,
  .ui[class*="five column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="five column"].doubling.row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="six column"].doubling.grid > .row > .column,
  .ui[class*="six column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="six column"].doubling.row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="seven column"].doubling.grid > .row > .column,
  .ui[class*="seven column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="seven column"].doubling.row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="eight column"].doubling.grid > .row > .column,
  .ui[class*="eight column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="eight column"].doubling.row.row > .column {
    width: 25% !important;
  }
  .ui[class*="nine column"].doubling.grid > .row > .column,
  .ui[class*="nine column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="nine column"].doubling.row.row > .column {
    width: 25% !important;
  }
  .ui[class*="ten column"].doubling.grid > .row > .column,
  .ui[class*="ten column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="ten column"].doubling.row.row > .column {
    width: 20% !important;
  }
  .ui[class*="eleven column"].doubling.grid > .row > .column,
  .ui[class*="eleven column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="eleven column"].doubling.row.row > .column {
    width: 20% !important;
  }
  .ui[class*="twelve column"].doubling.grid > .row > .column,
  .ui[class*="twelve column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="twelve column"].doubling.row.row > .column {
    width: 16.66666667% !important;
  }
  .ui[class*="thirteen column"].doubling.grid > .row > .column,
  .ui[class*="thirteen column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="thirteen column"].doubling.row.row > .column {
    width: 16.66666667% !important;
  }
  .ui[class*="fourteen column"].doubling.grid > .row > .column,
  .ui[class*="fourteen column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="fourteen column"].doubling.row.row > .column {
    width: 14.28571429% !important;
  }
  .ui[class*="fifteen column"].doubling.grid > .row > .column,
  .ui[class*="fifteen column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="fifteen column"].doubling.row.row > .column {
    width: 14.28571429% !important;
  }
  .ui[class*="sixteen column"].doubling.grid > .row > .column,
  .ui[class*="sixteen column"].doubling.grid > .column:not(.row),
  .ui.grid > [class*="sixteen column"].doubling.row.row > .column {
    width: 12.5% !important;
  }
}
/* Mobile Only */
@media only screen and (max-width: 767px) {
  .ui.grid > .doubling.row,
  .ui.doubling.grid > .row {
    margin: 0em !important;
    padding: 0em !important;
  }
  .ui.grid > .doubling.row > .column,
  .ui.doubling.grid > .row > .column {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    margin: 0em !important;
    box-shadow: none !important;
  }
  .ui[class*="two column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="two column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="two column"].doubling:not(.stackable).row.row > .column {
    width: 100% !important;
  }
  .ui[class*="three column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="three column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="three column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="four column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="four column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="four column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="five column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="five column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="five column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="six column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="six column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="six column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="seven column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="seven column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="seven column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="eight column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="eight column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="eight column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .ui[class*="nine column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="nine column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="nine column"].doubling:not(.stackable).row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="ten column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="ten column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="ten column"].doubling:not(.stackable).row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="eleven column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="eleven column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="eleven column"].doubling:not(.stackable).row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="twelve column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="twelve column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="twelve column"].doubling:not(.stackable).row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="thirteen column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="thirteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="thirteen column"].doubling:not(.stackable).row.row > .column {
    width: 33.33333333% !important;
  }
  .ui[class*="fourteen column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="fourteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="fourteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
  .ui[class*="fifteen column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="fifteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="fifteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
  .ui[class*="sixteen column"].doubling:not(.stackable).grid > .row > .column,
  .ui[class*="sixteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .ui.grid > [class*="sixteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
}
/*-------------------
      Stackable
--------------------*/
@media only screen and (max-width: 767px) {
  .ui.stackable.grid {
    width: auto;
    margin-left: 0em !important;
    margin-right: 0em !important;
  }
  .ui.stackable.grid > .row > .wide.column,
  .ui.stackable.grid > .wide.column,
  .ui.stackable.grid > .column.grid > .column,
  .ui.stackable.grid > .column.row > .column,
  .ui.stackable.grid > .row > .column,
  .ui.stackable.grid > .column:not(.row),
  .ui.grid > .stackable.stackable.row > .column {
    width: 100% !important;
    margin: 0em 0em !important;
    box-shadow: none !important;
    padding: 1rem 1rem !important;
  }
  .ui.stackable.grid:not(.vertically) > .row {
    margin: 0em;
    padding: 0em;
  }
  /* Coupling */
  .ui.container > .ui.stackable.grid > .column,
  .ui.container > .ui.stackable.grid > .row > .column {
    padding-left: 0em !important;
    padding-right: 0em !important;
  }
  /* Don't pad inside segment or nested grid */
  .ui.grid .ui.stackable.grid,
  .ui.segment:not(.vertical) .ui.stackable.page.grid {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  /* Divided Stackable */
  .ui.stackable.divided.grid > .row:first-child > .column:first-child,
  .ui.stackable.celled.grid > .row:first-child > .column:first-child,
  .ui.stackable.divided.grid > .column:not(.row):first-child,
  .ui.stackable.celled.grid > .column:not(.row):first-child {
    border-top: none !important;
  }
  .ui.inverted.stackable.celled.grid > .column:not(.row),
  .ui.inverted.stackable.divided.grid > .column:not(.row),
  .ui.inverted.stackable.celled.grid > .row > .column,
  .ui.inverted.stackable.divided.grid > .row > .column {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  .ui.stackable.celled.grid > .column:not(.row),
  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),
  .ui.stackable.celled.grid > .row > .column,
  .ui.stackable.divided:not(.vertically).grid > .row > .column {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: none !important;
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .ui.stackable.celled.grid > .row {
    box-shadow: none !important;
  }
  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),
  .ui.stackable.divided:not(.vertically).grid > .row > .column {
    padding-left: 0em !important;
    padding-right: 0em !important;
  }
}
/*----------------------
     Only (Device)
-----------------------*/
/* These include arbitrary class repetitions for forced specificity */
/* Mobile Only Hide */
@media only screen and (max-width: 767px) {
  .ui[class*="tablet only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="tablet only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="tablet only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.mobile) {
    display: none !important;
  }
  .ui[class*="computer only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="computer only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="computer only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="computer only"].column:not(.mobile) {
    display: none !important;
  }
  .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
/* Tablet Only Hide */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui[class*="mobile only"].grid.grid.grid:not(.tablet),
  .ui.grid.grid.grid > [class*="mobile only"].row:not(.tablet),
  .ui.grid.grid.grid > [class*="mobile only"].column:not(.tablet),
  .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.tablet) {
    display: none !important;
  }
  .ui[class*="computer only"].grid.grid.grid:not(.tablet),
  .ui.grid.grid.grid > [class*="computer only"].row:not(.tablet),
  .ui.grid.grid.grid > [class*="computer only"].column:not(.tablet),
  .ui.grid.grid.grid > .row > [class*="computer only"].column:not(.tablet) {
    display: none !important;
  }
  .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
/* Computer Only Hide */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
  .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
/* Large Screen Only Hide */
@media only screen and (min-width: 1200px) and (max-width: 1919px) {
  .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
  .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
/* Widescreen Only Hide */
@media only screen and (min-width: 1920px) {
  .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
}
/*******************************
         Theme Overrides
*******************************/
/*
 * # Semantic - Menu
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2015 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Menu
*******************************/
/*-------------------
      Collection
--------------------*/
/* Menu */
/* Menu Item */
/* Divider */
/* Sub Menu */
/* Text Item */
/*--------------
    Elements
---------------*/
/* Icon */
/* Dropdown Icon */
/* Header */
/* Vertical Icon */
/* Vertical Header */
/* Pointing Arrow */
/*--------------
    Couplings
---------------*/
/* Button */
/* Input */
/* Image */
/* Label */
/* Dropdown in Menu */
/* Dropdown Variations */
/*--------------
     States
---------------*/
/* Hovered Item */
/* Pressed Item */
/* Active Item */
/* Active Hovered Item */
/* Selected Dropdown */
/* Active Dropdown */
/* Active Sub Menu */
/*--------------
     Types
---------------*/
/* Vertical */
/* Secondary */
/* Pointing */
/* Inverted Secondary */
/* Inverted Pointing */
/* Tiered */
/* Icon */
/* Tabular */
/* Pagination */
/* Labeled Icon */
/* Text */
/*--------------
   Variations
---------------*/
/* Inverted */
/* Inverted Sub Menu */
/* Inverted Hover */
/* Pressed */
/* Inverted Active */
/* Inverted Active Hover  */
/* Inverted Menu Divider */
/* Inverted Colored */
/* Fixed */
/* Floated */
/* Attached */
/* Resize large sizes */
/* Sizes */
/* Packaged Theme */
/*******************************
             Menu
*******************************/
/*-------------------
      Collection
--------------------*/
/* Menu */
/* Menu Item */
/* Divider */
/* Sub Menu */
/* Text Item */
/*--------------
    Elements
---------------*/
/* Icon */
/* Dropdown Icon */
/* Header */
/* Vertical Icon */
/* Vertical Header */
/* Pointing Arrow */
/*--------------
    Couplings
---------------*/
/* Button */
/* Input */
/* Image */
/* Label */
/* Dropdown in Menu */
/* Dropdown Variations */
/*--------------
     States
---------------*/
/* Hovered Item */
/* Pressed Item */
/* Active Item */
/* Active Hovered Item */
/* Selected Dropdown */
/* Active Dropdown */
/* Active Sub Menu */
/*--------------
     Types
---------------*/
/* Vertical */
/* Secondary */
/* Pointing */
/* Inverted Secondary */
/* Inverted Pointing */
/* Tiered */
/* Icon */
/* Tabular */
/* Pagination */
/* Labeled Icon */
/* Text */
/*--------------
   Variations
---------------*/
/* Inverted */
/* Inverted Sub Menu */
/* Inverted Hover */
/* Pressed */
/* Inverted Active */
/* Inverted Active Hover  */
/* Inverted Menu Divider */
/* Inverted Colored */
/* Fixed */
/* Floated */
/* Attached */
/* Resize large sizes */
/* Sizes */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Standard
*******************************/
/*--------------
      Menu
---------------*/
.ui.menu {
  display: flex;
  margin: 1rem 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  background: rgba(0, 0, 0, 0.15);
  font-weight: normal;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
  min-height: 2.85714286em;
}
.ui.menu:after {
  content: '';
  display: block;
  height: 0px;
  clear: both;
  visibility: hidden;
}
.ui.menu:first-child {
  margin-top: 0rem;
}
.ui.menu:last-child {
  margin-bottom: 0rem;
}
/*--------------
    Sub-Menu
---------------*/
.ui.menu .menu {
  margin: 0em;
}
.ui.menu:not(.vertical) > .menu {
  display: flex;
}
/*--------------
      Item
---------------*/
.ui.menu:not(.vertical) .item {
  display: flex;
  align-items: center;
}
.ui.menu .item {
  position: relative;
  vertical-align: middle;
  line-height: 1;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  flex: 0 0 auto;
  user-select: none;
  background: none;
  padding: 0.92857143em 1.14285714em;
  text-transform: none;
  color: rgba(255, 255, 255, 0.87);
  font-weight: normal;
  transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;
}
.ui.menu > .item:first-child {
  border-radius: 0.28571429rem 0px 0px 0.28571429rem;
}
/* Border */
.ui.menu .item:before {
  position: absolute;
  content: '';
  top: 0%;
  right: 0px;
  height: 100%;
  width: 1px;
  background: rgba(255, 255, 255, 0.1);
}
/*--------------
  Text Content
---------------*/
.ui.menu .text.item > *,
.ui.menu .item > a:not(.ui),
.ui.menu .item > p:only-child {
  user-select: text;
  line-height: 1.3;
}
.ui.menu .item > p:first-child {
  margin-top: 0;
}
.ui.menu .item > p:last-child {
  margin-bottom: 0;
}
/*--------------
      Icons
---------------*/
.ui.menu .item > i.icon {
  opacity: 0.9;
  float: none;
  margin: 0em 0.35714286em 0em 0em;
}
/*--------------
     Button
---------------*/
.ui.menu:not(.vertical) .item > .button {
  position: relative;
  top: 0em;
  margin: -0.5em 0em;
  padding-bottom: 0.78571429em;
  padding-top: 0.78571429em;
  font-size: 1em;
}
/*----------------
 Grid / Container
-----------------*/
.ui.menu > .grid,
.ui.menu > .container {
  display: flex;
  align-items: inherit;
  flex-direction: inherit;
}
/*--------------
     Inputs
---------------*/
.ui.menu .item > .input {
  width: 100%;
}
.ui.menu:not(.vertical) .item > .input {
  position: relative;
  top: 0em;
  margin: -0.5em 0em;
}
.ui.menu .item > .input input {
  font-size: 1em;
  padding-top: 0.57142857em;
  padding-bottom: 0.57142857em;
}
/*--------------
     Header
---------------*/
.ui.menu .header.item,
.ui.vertical.menu .header.item {
  margin: 0em;
  background: '';
  text-transform: normal;
  font-weight: bold;
}
.ui.vertical.menu .item > .header:not(.ui) {
  margin: 0em 0em 0.5em;
  font-size: 1em;
  font-weight: bold;
}
/*--------------
    Dropdowns
---------------*/
/* Dropdown Icon */
.ui.menu .item > i.dropdown.icon {
  padding: 0em;
  float: right;
  margin: 0em 0em 0em 1em;
}
/* Menu */
.ui.menu .dropdown.item .menu {
  min-width: calc(100% - 1px);
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  background: #FFFFFF;
  margin: 0em 0px 0px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  flex-direction: column !important;
}
/* Menu Items */
.ui.menu .ui.dropdown .menu > .item {
  margin: 0;
  text-align: left;
  font-size: 1em !important;
  padding: 0.78571429em 1.14285714em !important;
  background: transparent !important;
  color: rgba(255, 255, 255, 0.87) !important;
  text-transform: none !important;
  font-weight: normal !important;
  box-shadow: none !important;
  transition: none !important;
}
.ui.menu .ui.dropdown .menu > .item:hover {
  background: rgba(0, 0, 0, 0.05) !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.menu .ui.dropdown .menu > .selected.item {
  background: rgba(0, 0, 0, 0.05) !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.menu .ui.dropdown .menu > .active.item {
  background: rgba(0, 0, 0, 0.03) !important;
  font-weight: bold !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.menu .ui.dropdown.item .menu .item:not(.filtered) {
  display: block;
}
.ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {
  display: inline-block;
  font-size: 1em !important;
  float: none;
  margin: 0em 0.75em 0em 0em !important;
}
/* Secondary */
.ui.secondary.menu .dropdown.item > .menu,
.ui.text.menu .dropdown.item > .menu {
  border-radius: 0.28571429rem;
  margin-top: 0.35714286em;
}
/* Pointing */
.ui.menu .pointing.dropdown.item .menu {
  margin-top: 0.75em;
}
/* Inverted */
.ui.inverted.menu .search.dropdown.item > .search,
.ui.inverted.menu .search.dropdown.item > .text {
  color: rgba(255, 255, 255, 0.9);
}
/* Vertical */
.ui.vertical.menu .dropdown.item > .icon {
  float: right;
  content: "\\f0da";
  margin-left: 1em;
}
.ui.vertical.menu .dropdown.item .menu {
  left: 100%;
  min-width: 0;
  margin: 0em 0em 0em 0em;
  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0em 0.28571429rem 0.28571429rem 0.28571429rem;
}
.ui.vertical.menu .dropdown.item.upward .menu {
  bottom: 0;
}
.ui.vertical.menu .dropdown.item:not(.upward) .menu {
  top: 0;
}
.ui.vertical.menu .active.dropdown.item {
  border-top-right-radius: 0em;
  border-bottom-right-radius: 0em;
}
.ui.vertical.menu .dropdown.active.item {
  box-shadow: none;
}
/* Evenly Divided */
.ui.item.menu .dropdown .menu .item {
  width: 100%;
}
/*--------------
     Labels
---------------*/
.ui.menu .item > .label {
  background: #999999;
  color: #FFFFFF;
  margin-left: 1em;
  padding: 0.3em 0.78571429em;
}
.ui.vertical.menu .item > .label {
  background: #999999;
  color: #FFFFFF;
  margin-top: -0.15em;
  margin-bottom: -0.15em;
  padding: 0.3em 0.78571429em;
}
.ui.menu .item > .floating.label {
  padding: 0.3em 0.78571429em;
}
/*--------------
     Images
---------------*/
.ui.menu .item > img:not(.ui) {
  display: inline-block;
  vertical-align: middle;
  margin: -0.3em 0em;
  width: 2.5em;
}
.ui.vertical.menu .item > img:not(.ui):only-child {
  display: block;
  max-width: 100%;
  width: auto;
}
/*******************************
          Coupling
*******************************/
/*--------------
     List
---------------*/
/* Menu divider shouldnt apply */
.ui.menu .list .item:before {
  background: none !important;
}
/*--------------
     Sidebar
---------------*/
/* Show vertical dividers below last */
.ui.vertical.sidebar.menu > .item:first-child:before {
  display: block !important;
}
.ui.vertical.sidebar.menu > .item::before {
  top: auto;
  bottom: 0px;
}
/*--------------
    Container
---------------*/
@media only screen and (max-width: 767px) {
  .ui.menu > .ui.container {
    width: 100% !important;
    margin-left: 0em !important;
    margin-right: 0em !important;
  }
}
@media only screen and (min-width: 768px) {
  .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
}
/*******************************
             States
*******************************/
/*--------------
      Hover
---------------*/
.ui.link.menu .item:hover,
.ui.menu .dropdown.item:hover,
.ui.menu .link.item:hover,
.ui.menu a.item:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.03);
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Pressed
---------------*/
.ui.link.menu .item:active,
.ui.menu .link.item:active,
.ui.menu a.item:active {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Active
---------------*/
.ui.menu .active.item {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
  font-weight: normal;
  box-shadow: none;
}
.ui.menu .active.item > i.icon {
  opacity: 1;
}
/*--------------
  Active Hover
---------------*/
.ui.menu .active.item:hover,
.ui.vertical.menu .active.item:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Disabled
---------------*/
.ui.menu .item.disabled,
.ui.menu .item.disabled:hover {
  cursor: default !important;
  background-color: transparent !important;
  color: rgba(40, 40, 40, 0.3) !important;
}
/*******************************
             Types
*******************************/
/*------------------
Floated Menu / Item
-------------------*/
/* Left Floated */
.ui.menu:not(.vertical) .left.item,
.ui.menu:not(.vertical) :not(.dropdown) > .left.menu {
  display: flex;
  margin-right: auto !important;
}
/* Right Floated */
.ui.menu:not(.vertical) .right.item,
.ui.menu:not(.vertical) .right.menu {
  display: flex;
  margin-left: auto !important;
}
/* Swapped Borders */
.ui.menu .right.item::before,
.ui.menu .right.menu > .item::before {
  right: auto;
  left: 0;
}
/*--------------
    Vertical
---------------*/
.ui.vertical.menu {
  display: block;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
}
/*--- Item ---*/
.ui.vertical.menu .item {
  display: block;
  background: none;
  border-top: none;
  border-right: none;
}
.ui.vertical.menu > .item:first-child {
  border-radius: 0.28571429rem 0.28571429rem 0px 0px;
}
.ui.vertical.menu > .item:last-child {
  border-radius: 0px 0px 0.28571429rem 0.28571429rem;
}
/*--- Label ---*/
.ui.vertical.menu .item > .label {
  float: right;
  text-align: center;
}
/*--- Icon ---*/
.ui.vertical.menu .item > i.icon {
  width: 1.18em;
  float: right;
  margin: 0em 0em 0em 0.5em;
}
.ui.vertical.menu .item > .label + i.icon {
  float: none;
  margin: 0em 0.5em 0em 0em;
}
/*--- Border ---*/
.ui.vertical.menu .item:before {
  position: absolute;
  content: '';
  top: 0%;
  left: 0px;
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}
.ui.vertical.menu .item:first-child:before {
  display: none !important;
}
/*--- Sub Menu ---*/
.ui.vertical.menu .item > .menu {
  margin: 0.5em -1.14285714em 0em;
}
.ui.vertical.menu .menu .item {
  background: none;
  padding: 0.5em 1.33333333em;
  font-size: 0.85714286em;
  color: rgba(0, 0, 0, 0.5);
}
.ui.vertical.menu .item .menu a.item:hover,
.ui.vertical.menu .item .menu .link.item:hover {
  color: rgba(255, 255, 255, 0.85);
}
.ui.vertical.menu .menu .item:before {
  display: none;
}
/* Vertical Active */
.ui.vertical.menu .active.item {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 0em;
  box-shadow: none;
}
.ui.vertical.menu > .active.item:first-child {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.vertical.menu > .active.item:last-child {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.vertical.menu > .active.item:only-child {
  border-radius: 0.28571429rem;
}
.ui.vertical.menu .active.item .menu .active.item {
  border-left: none;
}
.ui.vertical.menu .item .menu .active.item {
  background-color: transparent;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Tabular
---------------*/
.ui.tabular.menu {
  border-radius: 0em;
  box-shadow: none !important;
  border: none;
  background: none transparent;
  border-bottom: 1px solid #D4D4D5;
}
.ui.tabular.fluid.menu {
  width: calc(100% + (1px * 2)) !important;
}
.ui.tabular.menu .item {
  background: transparent;
  border-bottom: none;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-top: 2px solid transparent;
  padding: 0.92857143em 1.42857143em;
  color: rgba(255, 255, 255, 0.87);
}
.ui.tabular.menu .item:before {
  display: none;
}
/* Hover */
.ui.tabular.menu .item:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.8);
}
/* Active */
.ui.tabular.menu .active.item {
  background: none #FFFFFF;
  color: rgba(255, 255, 255, 0.95);
  border-top-width: 1px;
  border-color: #D4D4D5;
  font-weight: bold;
  margin-bottom: -1px;
  box-shadow: none;
  border-radius: 0.28571429rem 0.28571429rem 0px 0px !important;
}
/* Coupling with segment for attachment */
.ui.tabular.menu + .attached:not(.top).segment,
.ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {
  border-top: none;
  margin-left: 0px;
  margin-top: 0px;
  margin-right: 0px;
  width: 100%;
}
.top.attached.segment + .ui.bottom.tabular.menu {
  position: relative;
  width: calc(100% + (1px * 2));
  left: -1px;
}
/* Bottom Vertical Tabular */
.ui.bottom.tabular.menu {
  background: none transparent;
  border-radius: 0em;
  box-shadow: none !important;
  border-bottom: none;
  border-top: 1px solid #D4D4D5;
}
.ui.bottom.tabular.menu .item {
  background: none;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: none;
}
.ui.bottom.tabular.menu .active.item {
  background: none #FFFFFF;
  color: rgba(255, 255, 255, 0.95);
  border-color: #D4D4D5;
  margin: -1px 0px 0px 0px;
  border-radius: 0px 0px 0.28571429rem 0.28571429rem !important;
}
/* Vertical Tabular (Left) */
.ui.vertical.tabular.menu {
  background: none transparent;
  border-radius: 0em;
  box-shadow: none !important;
  border-bottom: none;
  border-right: 1px solid #D4D4D5;
}
.ui.vertical.tabular.menu .item {
  background: none;
  border-left: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  border-right: none;
}
.ui.vertical.tabular.menu .active.item {
  background: none #FFFFFF;
  color: rgba(255, 255, 255, 0.95);
  border-color: #D4D4D5;
  margin: 0px -1px 0px 0px;
  border-radius: 0.28571429rem 0px 0px 0.28571429rem !important;
}
/* Vertical Right Tabular */
.ui.vertical.right.tabular.menu {
  background: none transparent;
  border-radius: 0em;
  box-shadow: none !important;
  border-bottom: none;
  border-right: none;
  border-left: 1px solid #D4D4D5;
}
.ui.vertical.right.tabular.menu .item {
  background: none;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  border-left: none;
}
.ui.vertical.right.tabular.menu .active.item {
  background: none #FFFFFF;
  color: rgba(255, 255, 255, 0.95);
  border-color: #D4D4D5;
  margin: 0px 0px 0px -1px;
  border-radius: 0px 0.28571429rem 0.28571429rem 0px !important;
}
/* Dropdown */
.ui.tabular.menu .active.dropdown.item {
  margin-bottom: 0px;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-top: 2px solid transparent;
  border-bottom: none;
}
/*--------------
   Pagination
---------------*/
.ui.pagination.menu {
  margin: 0em;
  display: inline-flex;
  vertical-align: middle;
}
.ui.pagination.menu .item:last-child {
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui.compact.menu .item:last-child {
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui.pagination.menu .item:last-child:before {
  display: none;
}
.ui.pagination.menu .item {
  min-width: 3em;
  text-align: center;
}
.ui.pagination.menu .icon.item i.icon {
  vertical-align: top;
}
/* Active */
.ui.pagination.menu .active.item {
  border-top: none;
  padding-top: 0.92857143em;
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
  box-shadow: none;
}
/*--------------
   Secondary
---------------*/
.ui.secondary.menu {
  background: none;
  margin-left: -0.35714286em;
  margin-right: -0.35714286em;
  border-radius: 0em;
  border: none;
  box-shadow: none;
}
/* Item */
.ui.secondary.menu .item {
  align-self: center;
  box-shadow: none;
  border: none;
  padding: 0.78571429em 0.92857143em;
  margin: 0em 0.35714286em;
  background: none;
  transition: color 0.1s ease;
  border-radius: 0.28571429rem;
}
/* No Divider */
.ui.secondary.menu .item:before {
  display: none !important;
}
/* Header */
.ui.secondary.menu .header.item {
  border-radius: 0em;
  border-right: none;
  background: none transparent;
}
/* Image */
.ui.secondary.menu .item > img:not(.ui) {
  margin: 0em;
}
/* Hover */
.ui.secondary.menu .dropdown.item:hover,
.ui.secondary.menu .link.item:hover,
.ui.secondary.menu a.item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
/* Active */
.ui.secondary.menu .active.item {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
  border-radius: 0.28571429rem;
}
/* Active Hover */
.ui.secondary.menu .active.item:hover {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
/* Inverted */
.ui.secondary.inverted.menu .link.item,
.ui.secondary.inverted.menu a.item {
  color: rgba(255, 255, 255, 0.7) !important;
}
.ui.secondary.inverted.menu .dropdown.item:hover,
.ui.secondary.inverted.menu .link.item:hover,
.ui.secondary.inverted.menu a.item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff !important;
}
.ui.secondary.inverted.menu .active.item {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff !important;
}
/* Fix item margins */
.ui.secondary.item.menu {
  margin-left: 0em;
  margin-right: 0em;
}
.ui.secondary.item.menu .item:last-child {
  margin-right: 0em;
}
.ui.secondary.attached.menu {
  box-shadow: none;
}
/* Sub Menu */
.ui.vertical.secondary.menu .item:not(.dropdown) > .menu {
  margin: 0em -0.92857143em;
}
.ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {
  margin: 0em;
  padding: 0.5em 1.33333333em;
}
/*---------------------
   Secondary Vertical
-----------------------*/
.ui.secondary.vertical.menu > .item {
  border: none;
  margin: 0em 0em 0.35714286em;
  border-radius: 0.28571429rem !important;
}
.ui.secondary.vertical.menu > .header.item {
  border-radius: 0em;
}
/* Sub Menu */
.ui.vertical.secondary.menu .item > .menu .item {
  background-color: transparent;
}
/* Inverted */
.ui.secondary.inverted.menu {
  background-color: transparent;
}
/*---------------------
   Secondary Pointing
-----------------------*/
.ui.secondary.pointing.menu {
  margin-left: 0em;
  margin-right: 0em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.15);
}
.ui.secondary.pointing.menu .item {
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-radius: 0em;
  align-self: flex-end;
  margin: 0em 0em -2px;
  padding: 0.85714286em 1.14285714em;
  border-bottom-width: 2px;
  transition: color 0.1s ease;
}
/* Item Types */
.ui.secondary.pointing.menu .header.item {
  color: rgba(255, 255, 255, 0.85) !important;
}
.ui.secondary.pointing.menu .text.item {
  box-shadow: none !important;
}
.ui.secondary.pointing.menu .item:after {
  display: none;
}
/* Hover */
.ui.secondary.pointing.menu .dropdown.item:hover,
.ui.secondary.pointing.menu .link.item:hover,
.ui.secondary.pointing.menu a.item:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.87);
}
/* Pressed */
.ui.secondary.pointing.menu .dropdown.item:active,
.ui.secondary.pointing.menu .link.item:active,
.ui.secondary.pointing.menu a.item:active {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.15);
}
/* Active */
.ui.secondary.pointing.menu .active.item {
  background-color: transparent;
  box-shadow: none;
  border-color: #1B1C1D;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.95);
}
/* Active Hover */
.ui.secondary.pointing.menu .active.item:hover {
  border-color: #1B1C1D;
  color: rgba(255, 255, 255, 0.95);
}
/* Active Dropdown */
.ui.secondary.pointing.menu .active.dropdown.item {
  border-color: transparent;
}
/* Vertical Pointing */
.ui.secondary.vertical.pointing.menu {
  border-bottom-width: 0px;
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: rgba(255, 255, 255, 0.15);
}
.ui.secondary.vertical.pointing.menu .item {
  border-bottom: none;
  border-right-style: solid;
  border-right-color: transparent;
  border-radius: 0em !important;
  margin: 0em -2px 0em 0em;
  border-right-width: 2px;
}
/* Vertical Active */
.ui.secondary.vertical.pointing.menu .active.item {
  border-color: #1B1C1D;
}
/* Inverted */
.ui.secondary.inverted.pointing.menu {
  border-color: rgba(255, 255, 255, 0.1);
}
.ui.secondary.inverted.pointing.menu {
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.15);
}
.ui.secondary.inverted.pointing.menu .item {
  color: rgba(255, 255, 255, 0.9);
}
.ui.secondary.inverted.pointing.menu .header.item {
  color: #FFFFFF !important;
}
/* Hover */
.ui.secondary.inverted.pointing.menu .link.item:hover,
.ui.secondary.inverted.pointing.menu a.item:hover {
  color: rgba(255, 255, 255, 0.95);
}
/* Active */
.ui.secondary.inverted.pointing.menu .active.item {
  border-color: #FFFFFF;
  color: #ffffff;
}
/*--------------
    Text Menu
---------------*/
.ui.text.menu {
  background: none transparent;
  border-radius: 0px;
  box-shadow: none;
  border: none;
  margin: 1em -0.5em;
}
.ui.text.menu .item {
  border-radius: 0px;
  box-shadow: none;
  align-self: center;
  margin: 0em 0em;
  padding: 0.35714286em 0.5em;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.6);
  transition: opacity 0.1s ease;
}
/* Border */
.ui.text.menu .item:before,
.ui.text.menu .menu .item:before {
  display: none !important;
}
/* Header */
.ui.text.menu .header.item {
  background-color: transparent;
  opacity: 1;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.92857143em;
  text-transform: uppercase;
  font-weight: bold;
}
/* Image */
.ui.text.menu .item > img:not(.ui) {
  margin: 0em;
}
/*--- fluid text ---*/
.ui.text.item.menu .item {
  margin: 0em;
}
/*--- vertical text ---*/
.ui.vertical.text.menu {
  margin: 1em 0em;
}
.ui.vertical.text.menu:first-child {
  margin-top: 0rem;
}
.ui.vertical.text.menu:last-child {
  margin-bottom: 0rem;
}
.ui.vertical.text.menu .item {
  margin: 0.57142857em 0em;
  padding-left: 0em;
  padding-right: 0em;
}
.ui.vertical.text.menu .item > i.icon {
  float: none;
  margin: 0em 0.35714286em 0em 0em;
}
.ui.vertical.text.menu .header.item {
  margin: 0.57142857em 0em 0.71428571em;
}
/* Vertical Sub Menu */
.ui.vertical.text.menu .item:not(.dropdown) > .menu {
  margin: 0em;
}
.ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {
  margin: 0em;
  padding: 0.5em 0em;
}
/*--- hover ---*/
.ui.text.menu .item:hover {
  opacity: 1;
  background-color: transparent;
}
/*--- active ---*/
.ui.text.menu .active.item {
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.95);
}
/*--- active hover ---*/
.ui.text.menu .active.item:hover {
  background-color: transparent;
}
/* Disable Bariations */
.ui.text.pointing.menu .active.item:after {
  box-shadow: none;
}
.ui.text.attached.menu {
  box-shadow: none;
}
/* Inverted */
.ui.inverted.text.menu,
.ui.inverted.text.menu .item,
.ui.inverted.text.menu .item:hover,
.ui.inverted.text.menu .active.item {
  background-color: transparent !important;
}
/* Fluid */
.ui.fluid.text.menu {
  margin-left: 0em;
  margin-right: 0em;
}
/*--------------
    Icon Only
---------------*/
/* Vertical Menu */
.ui.vertical.icon.menu {
  display: inline-block;
  width: auto;
}
/* Item */
.ui.icon.menu .item {
  height: auto;
  text-align: center;
  color: #1B1C1D;
}
/* Icon */
.ui.icon.menu .item > .icon:not(.dropdown) {
  margin: 0;
  opacity: 1;
}
/* Icon Gylph */
.ui.icon.menu .icon:before {
  opacity: 1;
}
/* (x) Item Icon */
.ui.menu .icon.item > .icon {
  width: auto;
  margin: 0em auto;
}
/* Vertical Icon */
.ui.vertical.icon.menu .item > .icon:not(.dropdown) {
  display: block;
  opacity: 1;
  margin: 0em auto;
  float: none;
}
/* Inverted */
.ui.inverted.icon.menu .item {
  color: #FFFFFF;
}
/*--------------
   Labeled Icon
---------------*/
/* Menu */
.ui.labeled.icon.menu {
  text-align: center;
}
/* Item */
.ui.labeled.icon.menu .item {
  min-width: 6em;
  flex-direction: column;
}
/* Icon */
.ui.labeled.icon.menu .item > .icon:not(.dropdown) {
  height: 1em;
  display: block;
  font-size: 1.71428571em !important;
  margin: 0em auto 0.5rem !important;
}
/* Fluid */
.ui.fluid.labeled.icon.menu > .item {
  min-width: 0em;
}
/*******************************
           Variations
*******************************/
/*--------------
    Stackable
---------------*/
@media only screen and (max-width: 767px) {
  .ui.stackable.menu {
    flex-direction: column;
  }
  .ui.stackable.menu .item {
    width: 100% !important;
  }
  .ui.stackable.menu .item:before {
    position: absolute;
    content: '';
    top: auto;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }
  .ui.stackable.menu .left.menu,
  .ui.stackable.menu .left.item {
    margin-right: 0 !important;
  }
  .ui.stackable.menu .right.menu,
  .ui.stackable.menu .right.item {
    margin-left: 0 !important;
  }
  .ui.stackable.menu .right.menu,
  .ui.stackable.menu .left.menu {
    flex-direction: column;
  }
}
/*--------------
     Colors
---------------*/
/*--- Standard Colors  ---*/
.ui.menu .red.active.item,
.ui.red.menu .active.item {
  border-color: #DB2828 !important;
  color: #DB2828 !important;
}
.ui.menu .orange.active.item,
.ui.orange.menu .active.item {
  border-color: #F2711C !important;
  color: #F2711C !important;
}
.ui.menu .yellow.active.item,
.ui.yellow.menu .active.item {
  border-color: #FBBD08 !important;
  color: #FBBD08 !important;
}
.ui.menu .olive.active.item,
.ui.olive.menu .active.item {
  border-color: #B5CC18 !important;
  color: #B5CC18 !important;
}
.ui.menu .green.active.item,
.ui.green.menu .active.item {
  border-color: #21BA45 !important;
  color: #21BA45 !important;
}
.ui.menu .teal.active.item,
.ui.teal.menu .active.item {
  border-color: #00B5AD !important;
  color: #00B5AD !important;
}
.ui.menu .blue.active.item,
.ui.blue.menu .active.item {
  border-color: #2185D0 !important;
  color: #2185D0 !important;
}
.ui.menu .violet.active.item,
.ui.violet.menu .active.item {
  border-color: #6435C9 !important;
  color: #6435C9 !important;
}
.ui.menu .purple.active.item,
.ui.purple.menu .active.item {
  border-color: #A333C8 !important;
  color: #A333C8 !important;
}
.ui.menu .pink.active.item,
.ui.pink.menu .active.item {
  border-color: #E03997 !important;
  color: #E03997 !important;
}
.ui.menu .brown.active.item,
.ui.brown.menu .active.item {
  border-color: #A5673F !important;
  color: #A5673F !important;
}
.ui.menu .grey.active.item,
.ui.grey.menu .active.item {
  border-color: #767676 !important;
  color: #767676 !important;
}
/*--------------
    Inverted
---------------*/
.ui.inverted.menu {
  border: 0px solid transparent;
  background: #1B1C1D;
  box-shadow: none;
}
/* Menu Item */
.ui.inverted.menu .item,
.ui.inverted.menu .item > a:not(.ui) {
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
}
.ui.inverted.menu .item.menu {
  background: transparent;
}
/*--- Border ---*/
.ui.inverted.menu .item:before {
  background: rgba(255, 255, 255, 0.08);
}
.ui.vertical.inverted.menu .item:before {
  background: rgba(255, 255, 255, 0.08);
}
/* Sub Menu */
.ui.vertical.inverted.menu .menu .item,
.ui.vertical.inverted.menu .menu .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
/* Header */
.ui.inverted.menu .header.item {
  margin: 0em;
  background: transparent;
  box-shadow: none;
}
/* Disabled */
.ui.inverted.menu .item.disabled,
.ui.inverted.menu .item.disabled:hover {
  color: rgba(225, 225, 225, 0.3);
}
/*--- Hover ---*/
.ui.link.inverted.menu .item:hover,
.ui.inverted.menu .dropdown.item:hover,
.ui.inverted.menu .link.item:hover,
.ui.inverted.menu a.item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.ui.vertical.inverted.menu .item .menu a.item:hover,
.ui.vertical.inverted.menu .item .menu .link.item:hover {
  background: transparent;
  color: #ffffff;
}
/*--- Pressed ---*/
.ui.inverted.menu a.item:active,
.ui.inverted.menu .link.item:active {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
/*--- Active ---*/
.ui.inverted.menu .active.item {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff !important;
}
.ui.inverted.vertical.menu .item .menu .active.item {
  background: transparent;
  color: #FFFFFF;
}
.ui.inverted.pointing.menu .active.item:after {
  background: #3D3E3F !important;
  margin: 0em !important;
  box-shadow: none !important;
  border: none !important;
}
/*--- Active Hover ---*/
.ui.inverted.menu .active.item:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #FFFFFF !important;
}
.ui.inverted.pointing.menu .active.item:hover:after {
  background: #3D3E3F !important;
}
/*--------------
     Floated
---------------*/
.ui.floated.menu {
  float: left;
  margin: 0rem 0.5rem 0rem 0rem;
}
.ui.floated.menu .item:last-child:before {
  display: none;
}
.ui.right.floated.menu {
  float: right;
  margin: 0rem 0rem 0rem 0.5rem;
}
/*--------------
    Inverted
---------------*/
/* Red */
.ui.inverted.menu .red.active.item,
.ui.inverted.red.menu {
  background-color: #DB2828;
}
.ui.inverted.red.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.red.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Orange */
.ui.inverted.menu .orange.active.item,
.ui.inverted.orange.menu {
  background-color: #F2711C;
}
.ui.inverted.orange.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.orange.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Yellow */
.ui.inverted.menu .yellow.active.item,
.ui.inverted.yellow.menu {
  background-color: #FBBD08;
}
.ui.inverted.yellow.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.yellow.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Olive */
.ui.inverted.menu .olive.active.item,
.ui.inverted.olive.menu {
  background-color: #B5CC18;
}
.ui.inverted.olive.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.olive.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Green */
.ui.inverted.menu .green.active.item,
.ui.inverted.green.menu {
  background-color: #21BA45;
}
.ui.inverted.green.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.green.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Teal */
.ui.inverted.menu .teal.active.item,
.ui.inverted.teal.menu {
  background-color: #00B5AD;
}
.ui.inverted.teal.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.teal.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Blue */
.ui.inverted.menu .blue.active.item,
.ui.inverted.blue.menu {
  background-color: #2185D0;
}
.ui.inverted.blue.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.blue.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Violet */
.ui.inverted.menu .violet.active.item,
.ui.inverted.violet.menu {
  background-color: #6435C9;
}
.ui.inverted.violet.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.violet.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Purple */
.ui.inverted.menu .purple.active.item,
.ui.inverted.purple.menu {
  background-color: #A333C8;
}
.ui.inverted.purple.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.purple.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Pink */
.ui.inverted.menu .pink.active.item,
.ui.inverted.pink.menu {
  background-color: #E03997;
}
.ui.inverted.pink.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.pink.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Brown */
.ui.inverted.menu .brown.active.item,
.ui.inverted.brown.menu {
  background-color: #A5673F;
}
.ui.inverted.brown.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.brown.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/* Grey */
.ui.inverted.menu .grey.active.item,
.ui.inverted.grey.menu {
  background-color: #767676;
}
.ui.inverted.grey.menu .item:before {
  background-color: rgba(255, 255, 255, 0.1);
}
.ui.inverted.grey.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
/*--------------
     Fitted
---------------*/
.ui.fitted.menu .item,
.ui.fitted.menu .item .menu .item,
.ui.menu .fitted.item {
  padding: 0em;
}
.ui.horizontally.fitted.menu .item,
.ui.horizontally.fitted.menu .item .menu .item,
.ui.menu .horizontally.fitted.item {
  padding-top: 0.92857143em;
  padding-bottom: 0.92857143em;
}
.ui.vertically.fitted.menu .item,
.ui.vertically.fitted.menu .item .menu .item,
.ui.menu .vertically.fitted.item {
  padding-left: 1.14285714em;
  padding-right: 1.14285714em;
}
/*--------------
   Borderless
---------------*/
.ui.borderless.menu .item:before,
.ui.borderless.menu .item .menu .item:before,
.ui.menu .borderless.item:before {
  background: none !important;
}
/*-------------------
       Compact
--------------------*/
.ui.compact.menu {
  display: inline-flex;
  margin: 0em;
  vertical-align: middle;
}
.ui.compact.vertical.menu {
  display: inline-block;
}
.ui.compact.menu .item:last-child {
  border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui.compact.menu .item:last-child:before {
  display: none;
}
.ui.compact.vertical.menu {
  width: auto !important;
}
.ui.compact.vertical.menu .item:last-child::before {
  display: block;
}
/*-------------------
        Fluid
--------------------*/
.ui.menu.fluid,
.ui.vertical.menu.fluid {
  width: 100% !important;
}
/*-------------------
      Evenly Sized
--------------------*/
.ui.item.menu,
.ui.item.menu .item {
  width: 100%;
  padding-left: 0em !important;
  padding-right: 0em !important;
  margin-left: 0em !important;
  margin-right: 0em !important;
  text-align: center;
  justify-content: center;
}
.ui.attached.item.menu {
  margin: 0em -1px !important;
}
.ui.item.menu .item:last-child:before {
  display: none;
}
.ui.menu.two.item .item {
  width: 50%;
}
.ui.menu.three.item .item {
  width: 33.333%;
}
.ui.menu.four.item .item {
  width: 25%;
}
.ui.menu.five.item .item {
  width: 20%;
}
.ui.menu.six.item .item {
  width: 16.666%;
}
.ui.menu.seven.item .item {
  width: 14.285%;
}
.ui.menu.eight.item .item {
  width: 12.5%;
}
.ui.menu.nine.item .item {
  width: 11.11%;
}
.ui.menu.ten.item .item {
  width: 10%;
}
.ui.menu.eleven.item .item {
  width: 9.09%;
}
.ui.menu.twelve.item .item {
  width: 8.333%;
}
/*--------------
     Fixed
---------------*/
.ui.menu.fixed {
  position: fixed;
  z-index: 101;
  margin: 0em;
  width: 100%;
}
.ui.menu.fixed,
.ui.menu.fixed .item:first-child,
.ui.menu.fixed .item:last-child {
  border-radius: 0px !important;
}
.ui.fixed.menu,
.ui[class*="top fixed"].menu {
  top: 0px;
  left: 0px;
  right: auto;
  bottom: auto;
}
.ui[class*="top fixed"].menu {
  border-top: none;
  border-left: none;
  border-right: none;
}
.ui[class*="right fixed"].menu {
  border-top: none;
  border-bottom: none;
  border-right: none;
  top: 0px;
  right: 0px;
  left: auto;
  bottom: auto;
  width: auto;
  height: 100%;
}
.ui[class*="bottom fixed"].menu {
  border-bottom: none;
  border-left: none;
  border-right: none;
  bottom: 0px;
  left: 0px;
  top: auto;
  right: auto;
}
.ui[class*="left fixed"].menu {
  border-top: none;
  border-bottom: none;
  border-left: none;
  top: 0px;
  left: 0px;
  right: auto;
  bottom: auto;
  width: auto;
  height: 100%;
}
/* Coupling with Grid */
.ui.fixed.menu + .ui.grid {
  padding-top: 2.75rem;
}
/*-------------------
       Pointing
--------------------*/
.ui.pointing.menu .item:after {
  visibility: hidden;
  position: absolute;
  content: '';
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  background: none;
  margin: 0.5px 0em 0em;
  width: 0.57142857em;
  height: 0.57142857em;
  border: none;
  border-bottom: 1px solid #D4D4D5;
  border-right: 1px solid #D4D4D5;
  z-index: 2;
  transition: background 0.1s ease;
}
.ui.vertical.pointing.menu .item:after {
  position: absolute;
  top: 50%;
  right: 0%;
  bottom: auto;
  left: auto;
  transform: translateX(50%) translateY(-50%) rotate(45deg);
  margin: 0em -0.5px 0em 0em;
  border: none;
  border-top: 1px solid #D4D4D5;
  border-right: 1px solid #D4D4D5;
}
/* Active */
.ui.pointing.menu .active.item:after {
  visibility: visible;
}
.ui.pointing.menu .active.dropdown.item:after {
  visibility: hidden;
}
/* Don't double up pointers */
.ui.pointing.menu .dropdown.active.item:after,
.ui.pointing.menu .active.item .menu .active.item:after {
  display: none;
}
/* Colors */
.ui.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.ui.pointing.menu .active.item:after {
  background-color: #F2F2F2;
}
.ui.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.ui.vertical.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.ui.vertical.pointing.menu .active.item:after {
  background-color: #F2F2F2;
}
.ui.vertical.pointing.menu .menu .active.item:after {
  background-color: #FFFFFF;
}
/*--------------
    Attached
---------------*/
/* Middle */
.ui.attached.menu {
  top: 0px;
  bottom: 0px;
  border-radius: 0px;
  margin: 0em -1px;
  width: calc(100% - (-1px * 2));
  max-width: calc(100% - (-1px * 2));
  box-shadow: none;
}
.ui.attached + .ui.attached.menu:not(.top) {
  border-top: none;
}
/* Top */
.ui[class*="top attached"].menu {
  bottom: 0px;
  margin-bottom: 0em;
  top: 0px;
  margin-top: 1rem;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.menu[class*="top attached"]:first-child {
  margin-top: 0em;
}
/* Bottom */
.ui[class*="bottom attached"].menu {
  bottom: 0px;
  margin-top: 0em;
  top: 0px;
  margin-bottom: 1rem;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui[class*="bottom attached"].menu:last-child {
  margin-bottom: 0em;
}
/* Attached Menu Item */
.ui.top.attached.menu > .item:first-child {
  border-radius: 0.28571429rem 0em 0em 0em;
}
.ui.bottom.attached.menu > .item:first-child {
  border-radius: 0em 0em 0em 0.28571429rem;
}
/* Tabular Attached */
.ui.attached.menu:not(.tabular) {
  border: 1px solid #D4D4D5;
}
.ui.attached.inverted.menu {
  border: none;
}
.ui.attached.tabular.menu {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}
/*--------------
     Sizes
---------------*/
/* Mini */
.ui.mini.menu {
  font-size: 0.78571429rem;
}
.ui.mini.vertical.menu {
  width: 9rem;
}
/* Tiny */
.ui.tiny.menu {
  font-size: 0.85714286rem;
}
.ui.tiny.vertical.menu {
  width: 11rem;
}
/* Small */
.ui.small.menu {
  font-size: 0.92857143rem;
}
.ui.small.vertical.menu {
  width: 13rem;
}
/* Medium */
.ui.menu {
  font-size: 1rem;
}
.ui.vertical.menu {
  width: 15rem;
}
/* Large */
.ui.large.menu {
  font-size: 1.07142857rem;
}
.ui.large.vertical.menu {
  width: 18rem;
}
/* Huge */
.ui.huge.menu {
  font-size: 1.21428571rem;
}
.ui.huge.vertical.menu {
  width: 22rem;
}
/* Big */
.ui.big.menu {
  font-size: 1.14285714rem;
}
.ui.big.vertical.menu {
  width: 20rem;
}
/* Massive */
.ui.massive.menu {
  font-size: 1.28571429rem;
}
.ui.massive.vertical.menu {
  width: 25rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Message
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Message
*******************************/
/*-------------------
       Elements
--------------------*/
/* Header */
/* Paragraph */
/* List */
/* Icon */
/* Close Icon */
/*-------------------
        Types
--------------------*/
/* Icon Message */
/* Attached */
/* Floating */
/* Colors */
/* Warning / Positive / Negative / Info */
/* Packaged Theme */
/*******************************
            Message
*******************************/
/*-------------------
       Elements
--------------------*/
/* Header */
/* Paragraph */
/* List */
/* Icon */
/* Close Icon */
/*-------------------
        Types
--------------------*/
/* Icon Message */
/* Attached */
/* Floating */
/* Colors */
/* Warning / Positive / Negative / Info */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Message
*******************************/
.ui.message {
  position: relative;
  min-height: 1em;
  margin: 1em 0em;
  background: rgba(0, 0, 0, 0.1);
  padding: 1em 1.5em;
  line-height: 1.4285em;
  color: rgba(255, 255, 255, 0.87);
  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;
  border-radius: 0.28571429rem;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.22) inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.message:first-child {
  margin-top: 0em;
}
.ui.message:last-child {
  margin-bottom: 0em;
}
/*--------------
     Content
---------------*/
/* Header */
.ui.message .header {
  display: block;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: bold;
  margin: -0.14285714em 0em 0rem 0em;
}
/* Default font size */
.ui.message .header:not(.ui) {
  font-size: 1.14285714em;
}
/* Paragraph */
.ui.message p {
  opacity: 0.85;
  margin: 0.75em 0em;
}
.ui.message p:first-child {
  margin-top: 0em;
}
.ui.message p:last-child {
  margin-bottom: 0em;
}
.ui.message .header + p {
  margin-top: 0.25em;
}
/* List */
.ui.message .list:not(.ui) {
  text-align: left;
  padding: 0em;
  opacity: 0.85;
  list-style-position: inside;
  margin: 0.5em 0em 0em;
}
.ui.message .list:not(.ui):first-child {
  margin-top: 0em;
}
.ui.message .list:not(.ui):last-child {
  margin-bottom: 0em;
}
.ui.message .list:not(.ui) li {
  position: relative;
  list-style-type: none;
  margin: 0em 0em 0.3em 1em;
  padding: 0em;
}
.ui.message .list:not(.ui) li:before {
  position: absolute;
  content: '•';
  left: -1em;
  height: 100%;
  vertical-align: baseline;
}
.ui.message .list:not(.ui) li:last-child {
  margin-bottom: 0em;
}
/* Icon */
.ui.message > .icon {
  margin-right: 0.6em;
}
/* Close Icon */
.ui.message > .close.icon {
  cursor: pointer;
  position: absolute;
  margin: 0em;
  top: 0.78575em;
  right: 0.5em;
  opacity: 0.7;
  transition: opacity 0.1s ease;
}
.ui.message > .close.icon:hover {
  opacity: 1;
}
/* First / Last Element */
.ui.message > :first-child {
  margin-top: 0em;
}
.ui.message > :last-child {
  margin-bottom: 0em;
}
/*******************************
            Coupling
*******************************/
.ui.dropdown .menu > .message {
  margin: 0px -1px;
}
/*******************************
            States
*******************************/
/*--------------
    Visible
---------------*/
.ui.visible.visible.visible.visible.message {
  display: block;
}
.ui.icon.visible.visible.visible.visible.message {
  display: flex;
}
/*--------------
     Hidden
---------------*/
.ui.hidden.hidden.hidden.hidden.message {
  display: none;
}
/*******************************
            Variations
*******************************/
/*--------------
    Compact
---------------*/
.ui.compact.message {
  display: inline-block;
}
.ui.compact.icon.message {
  display: inline-flex;
}
/*--------------
    Attached
---------------*/
.ui.attached.message {
  margin-bottom: -1px;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
  box-shadow: 0em 0em 0em 1px rgba(255, 255, 255, 0.15) inset;
  margin-left: -1px;
  margin-right: -1px;
}
.ui.attached + .ui.attached.message:not(.top):not(.bottom) {
  margin-top: -1px;
  border-radius: 0em;
}
.ui.bottom.attached.message {
  margin-top: -1px;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  box-shadow: 0em 0em 0em 1px rgba(255, 255, 255, 0.15) inset, 0px 1px 2px 0 rgba(255, 255, 255, 0.15);
}
.ui.bottom.attached.message:not(:last-child) {
  margin-bottom: 1em;
}
.ui.attached.icon.message {
  width: auto;
}
/*--------------
      Icon
---------------*/
.ui.icon.message {
  display: flex;
  width: 100%;
  align-items: center;
}
.ui.icon.message > .icon:not(.close) {
  display: block;
  flex: 0 0 auto;
  width: auto;
  line-height: 1;
  vertical-align: middle;
  font-size: 3em;
  opacity: 0.8;
}
.ui.icon.message > .content {
  display: block;
  flex: 1 1 auto;
  vertical-align: middle;
}
.ui.icon.message .icon:not(.close) + .content {
  padding-left: 0rem;
}
.ui.icon.message .circular.icon {
  width: 1em;
}
/*--------------
    Floating
---------------*/
.ui.floating.message {
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.22) inset, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}
/*--------------
     Colors
---------------*/
.ui.black.message {
  background-color: #1B1C1D;
  color: rgba(255, 255, 255, 0.9);
}
/*--------------
     Types
---------------*/
/* Positive */
.ui.positive.message {
  background-color: #FCFFF5;
  color: #2C662D;
}
.ui.positive.message,
.ui.attached.positive.message {
  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.positive.message .header {
  color: #1A531B;
}
/* Negative */
.ui.negative.message {
  background-color: rgba(200, 3, 3, 0.15);
  color: #FFFFFF;
}
.ui.negative.message,
.ui.attached.negative.message {
  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.negative.message .header {
  color: #912D2B;
}
/* Info */
.ui.info.message {
  background-color: #F8FFFF;
  color: #276F86;
}
.ui.info.message,
.ui.attached.info.message {
  box-shadow: 0px 0px 0px 1px #A9D5DE inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.info.message .header {
  color: #0E566C;
}
/* Warning */
.ui.warning.message {
  background-color: #FFFAF3;
  color: #573A08;
}
.ui.warning.message,
.ui.attached.warning.message {
  box-shadow: 0px 0px 0px 1px #C9BA9B inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.warning.message .header {
  color: #794B02;
}
/* Error */
.ui.error.message {
  background-color: rgba(200, 3, 3, 0.15);
  color: #FFFFFF;
}
.ui.error.message,
.ui.attached.error.message {
  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.error.message .header {
  color: #912D2B;
}
/* Success */
.ui.success.message {
  background-color: #FCFFF5;
  color: #2C662D;
}
.ui.success.message,
.ui.attached.success.message {
  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.success.message .header {
  color: #1A531B;
}
/* Colors */
.ui.inverted.message,
.ui.black.message {
  background-color: #1B1C1D;
  color: rgba(255, 255, 255, 0.9);
}
.ui.red.message {
  background-color: #FFE8E6;
  color: #DB2828;
  box-shadow: 0px 0px 0px 1px #DB2828 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.red.message .header {
  color: #c82121;
}
.ui.orange.message {
  background-color: #FFEDDE;
  color: #F2711C;
  box-shadow: 0px 0px 0px 1px #F2711C inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.orange.message .header {
  color: #e7640d;
}
.ui.yellow.message {
  background-color: #FFF8DB;
  color: #B58105;
  box-shadow: 0px 0px 0px 1px #B58105 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.yellow.message .header {
  color: #9c6f04;
}
.ui.olive.message {
  background-color: #FBFDEF;
  color: #8ABC1E;
  box-shadow: 0px 0px 0px 1px #8ABC1E inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.olive.message .header {
  color: #7aa61a;
}
.ui.green.message {
  background-color: #E5F9E7;
  color: #1EBC30;
  box-shadow: 0px 0px 0px 1px #1EBC30 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.green.message .header {
  color: #1aa62a;
}
.ui.teal.message {
  background-color: #E1F7F7;
  color: #10A3A3;
  box-shadow: 0px 0px 0px 1px #10A3A3 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.teal.message .header {
  color: #0e8c8c;
}
.ui.blue.message {
  background-color: #DFF0FF;
  color: #2185D0;
  box-shadow: 0px 0px 0px 1px #2185D0 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.blue.message .header {
  color: #1e77ba;
}
.ui.violet.message {
  background-color: #EAE7FF;
  color: #6435C9;
  box-shadow: 0px 0px 0px 1px #6435C9 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.violet.message .header {
  color: #5a30b5;
}
.ui.purple.message {
  background-color: #F6E7FF;
  color: #A333C8;
  box-shadow: 0px 0px 0px 1px #A333C8 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.purple.message .header {
  color: #922eb4;
}
.ui.pink.message {
  background-color: #FFE3FB;
  color: #E03997;
  box-shadow: 0px 0px 0px 1px #E03997 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.pink.message .header {
  color: #dd238b;
}
.ui.brown.message {
  background-color: #F1E2D3;
  color: #A5673F;
  box-shadow: 0px 0px 0px 1px #A5673F inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
.ui.brown.message .header {
  color: #935b38;
}
/*--------------
     Sizes
---------------*/
.ui.mini.message {
  font-size: 0.78571429em;
}
.ui.tiny.message {
  font-size: 0.85714286em;
}
.ui.small.message {
  font-size: 0.92857143em;
}
.ui.message {
  font-size: 1em;
}
.ui.large.message {
  font-size: 1.14285714em;
}
.ui.big.message {
  font-size: 1.28571429em;
}
.ui.huge.message {
  font-size: 1.42857143em;
}
.ui.massive.message {
  font-size: 1.71428571em;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Table
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Table
*******************************/
/*-------------------
       Element
--------------------*/
/*--------------
     Parts
---------------*/
/* Table Row */
/* Table Cell */
/* Table Header */
/* Table Footer */
/* Responsive Size */
/*-------------------
       Types
--------------------*/
/* Definition */
/*--------------
    Couplings
---------------*/
/*--------------
     States
---------------*/
/* Positive */
/* Negative */
/* Error */
/* Warning */
/* Active */
/*--------------
     Types
---------------*/
/* Attached */
/* Striped */
/* Selectable */
/* Sortable */
/* Colors */
/* Inverted */
/* Basic */
/* Padded */
/* Compact */
/* Sizes */
/* Packaged Theme */
/*******************************
             Table
*******************************/
/*-------------------
       Element
--------------------*/
/*--------------
     Parts
---------------*/
/* Table Row */
/* Table Cell */
/* Table Header */
/* Table Footer */
/* Responsive Size */
/*-------------------
       Types
--------------------*/
/* Definition */
/*--------------
    Couplings
---------------*/
/*--------------
     States
---------------*/
/* Positive */
/* Negative */
/* Error */
/* Warning */
/* Active */
/*--------------
     Types
---------------*/
/* Attached */
/* Striped */
/* Selectable */
/* Sortable */
/* Colors */
/* Inverted */
/* Basic */
/* Padded */
/* Compact */
/* Sizes */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Table
*******************************/
/* Prototype */
.ui.table {
  width: 100%;
  background: rgba(0, 0, 0, 0.15);
  margin: 1em 0em;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: none;
  border-radius: 0.28571429rem;
  text-align: left;
  color: rgba(255, 255, 255, 0.87);
  border-collapse: separate;
  border-spacing: 0px;
}
.ui.table:first-child {
  margin-top: 0em;
}
.ui.table:last-child {
  margin-bottom: 0em;
}
/*******************************
             Parts
*******************************/
/* Table Content */
.ui.table th,
.ui.table td {
  transition: background 0.1s ease, color 0.1s ease;
}
/* Headers */
.ui.table thead {
  box-shadow: none;
}
.ui.table thead th {
  cursor: auto;
  background: rgba(255, 255, 255, 0.15);
  text-align: inherit;
  color: rgba(255, 255, 255, 0.87);
  padding: 0.92857143em 0.78571429em;
  vertical-align: inherit;
  font-style: none;
  font-weight: bold;
  text-transform: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  border-left: none;
}
.ui.table thead tr > th:first-child {
  border-left: none;
}
.ui.table thead tr:first-child > th:first-child {
  border-radius: 0.28571429rem 0em 0em 0em;
}
.ui.table thead tr:first-child > th:last-child {
  border-radius: 0em 0.28571429rem 0em 0em;
}
.ui.table thead tr:first-child > th:only-child {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
/* Footer */
.ui.table tfoot {
  box-shadow: none;
}
.ui.table tfoot th {
  cursor: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.15);
  text-align: inherit;
  color: rgba(255, 255, 255, 0.87);
  padding: 0.78571429em 0.78571429em;
  vertical-align: middle;
  font-style: normal;
  font-weight: normal;
  text-transform: none;
}
.ui.table tfoot tr > th:first-child {
  border-left: none;
}
.ui.table tfoot tr:first-child > th:first-child {
  border-radius: 0em 0em 0em 0.28571429rem;
}
.ui.table tfoot tr:first-child > th:last-child {
  border-radius: 0em 0em 0.28571429rem 0em;
}
.ui.table tfoot tr:first-child > th:only-child {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
/* Table Row */
.ui.table tr td {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.ui.table tr:first-child td {
  border-top: none;
}
/* Repeated tbody */
.ui.table tbody + tbody tr:first-child td {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
/* Table Cells */
.ui.table td {
  padding: 0.78571429em 0.78571429em;
  text-align: inherit;
}
/* Icons */
.ui.table > .icon {
  vertical-align: baseline;
}
.ui.table > .icon:only-child {
  margin: 0em;
}
/* Table Segment */
.ui.table.segment {
  padding: 0em;
}
.ui.table.segment:after {
  display: none;
}
.ui.table.segment.stacked:after {
  display: block;
}
/* Responsive */
@media only screen and (max-width: 767px) {
  .ui.table:not(.unstackable) {
    width: 100%;
  }
  .ui.table:not(.unstackable) tbody,
  .ui.table:not(.unstackable) tr,
  .ui.table:not(.unstackable) tr > th,
  .ui.table:not(.unstackable) tr > td {
    width: auto !important;
    display: block !important;
  }
  .ui.table:not(.unstackable) {
    padding: 0em;
  }
  .ui.table:not(.unstackable) thead {
    display: block;
  }
  .ui.table:not(.unstackable) tfoot {
    display: block;
  }
  .ui.table:not(.unstackable) tr {
    padding-top: 1em;
    padding-bottom: 1em;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
  }
  .ui.table:not(.unstackable) tr > th,
  .ui.table:not(.unstackable) tr > td {
    background: none;
    border: none !important;
    padding: 0.25em 0.75em !important;
    box-shadow: none !important;
  }
  .ui.table:not(.unstackable) th:first-child,
  .ui.table:not(.unstackable) td:first-child {
    font-weight: bold;
  }
  /* Definition Table */
  .ui.definition.table:not(.unstackable) thead th:first-child {
    box-shadow: none !important;
  }
}
/*******************************
            Coupling
*******************************/
/* UI Image */
.ui.table th .image,
.ui.table th .image img,
.ui.table td .image,
.ui.table td .image img {
  max-width: none;
}
/*******************************
             Types
*******************************/
/*--------------
    Complex
---------------*/
.ui.structured.table {
  border-collapse: collapse;
}
.ui.structured.table thead th {
  border-left: none;
  border-right: none;
}
.ui.structured.sortable.table thead th {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  border-right: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.structured.basic.table th {
  border-left: none;
  border-right: none;
}
.ui.structured.celled.table tr th,
.ui.structured.celled.table tr td {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}
/*--------------
   Definition
---------------*/
.ui.definition.table thead:not(.full-width) th:first-child {
  pointer-events: none;
  background: transparent;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.4);
  box-shadow: -1px -1px 0px 1px #FFFFFF;
}
.ui.definition.table tfoot:not(.full-width) th:first-child {
  pointer-events: none;
  background: transparent;
  font-weight: rgba(255, 255, 255, 0.4);
  color: normal;
  box-shadow: 1px 1px 0px 1px #FFFFFF;
}
/* Remove Border */
.ui.celled.definition.table thead:not(.full-width) th:first-child {
  box-shadow: 0px -1px 0px 1px #FFFFFF;
}
.ui.celled.definition.table tfoot:not(.full-width) th:first-child {
  box-shadow: 0px 1px 0px 1px #FFFFFF;
}
/* Highlight Defining Column */
.ui.definition.table tr td:first-child:not(.ignored),
.ui.definition.table tr td.definition {
  background: rgba(0, 0, 0, 0.03);
  font-weight: bold;
  color: rgba(255, 255, 255, 0.95);
  text-transform: '';
  box-shadow: '';
  text-align: '';
  font-size: 1em;
  padding-left: '';
  padding-right: '';
}
/* Fix 2nd Column */
.ui.definition.table thead:not(.full-width) th:nth-child(2) {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.definition.table tfoot:not(.full-width) th:nth-child(2) {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.definition.table td:nth-child(2) {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}
/*******************************
             States
*******************************/
/*--------------
    Positive
---------------*/
.ui.table tr.positive,
.ui.table td.positive {
  box-shadow: 0px 0px 0px #A3C293 inset;
}
.ui.table tr.positive,
.ui.table td.positive {
  background: #FCFFF5 !important;
  color: #2C662D !important;
}
/*--------------
     Negative
---------------*/
.ui.table tr.negative,
.ui.table td.negative {
  box-shadow: 0px 0px 0px #E0B4B4 inset;
}
.ui.table tr.negative,
.ui.table td.negative,
.ui.table th.negative {
  background: rgba(200, 3, 3, 0.15) !important;
  color: #FFFFFF !important;
}
/*--------------
      Error
---------------*/
.ui.table tr.error,
.ui.table td.error {
  box-shadow: 0px 0px 0px #E0B4B4 inset;
}
.ui.table tr.error,
.ui.table td.error {
  background: rgba(200, 3, 3, 0.15) !important;
  color: #FFFFFF !important;
}
/*--------------
     Warning
---------------*/
.ui.table tr.warning,
.ui.table td.warning {
  box-shadow: 0px 0px 0px #C9BA9B inset;
}
.ui.table tr.warning,
.ui.table td.warning {
  background: #FFFAF3 !important;
  color: #573A08 !important;
}
/*--------------
     Active
---------------*/
.ui.table tr.active,
.ui.table td.active {
  box-shadow: 0px 0px 0px rgba(255, 255, 255, 0.87) inset;
}
.ui.table tr.active,
.ui.table td.active {
  background: #E0E0E0 !important;
  color: rgba(255, 255, 255, 0.87) !important;
}
/*--------------
     Disabled
---------------*/
.ui.table tr.disabled td,
.ui.table tr td.disabled,
.ui.table tr.disabled:hover,
.ui.table tr:hover td.disabled {
  pointer-events: none;
  color: rgba(40, 40, 40, 0.3);
}
/*******************************
          Variations
*******************************/
/*--------------
    Stackable
---------------*/
@media only screen and (max-width: 991px) {
  .ui[class*="tablet stackable"].table,
  .ui[class*="tablet stackable"].table tbody,
  .ui[class*="tablet stackable"].table tr,
  .ui[class*="tablet stackable"].table tr > th,
  .ui[class*="tablet stackable"].table tr > td {
    width: 100% !important;
    display: block !important;
  }
  .ui[class*="tablet stackable"].table {
    padding: 0em;
  }
  .ui[class*="tablet stackable"].table thead {
    display: block;
  }
  .ui[class*="tablet stackable"].table tfoot {
    display: block;
  }
  .ui[class*="tablet stackable"].table tr {
    padding-top: 1em;
    padding-bottom: 1em;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
  }
  .ui[class*="tablet stackable"].table tr > th,
  .ui[class*="tablet stackable"].table tr > td {
    background: none;
    border: none !important;
    padding: 0.25em 0.75em;
    box-shadow: none !important;
  }
  /* Definition Table */
  .ui.definition[class*="tablet stackable"].table thead th:first-child {
    box-shadow: none !important;
  }
}
/*--------------
 Text Alignment
---------------*/
.ui.table[class*="left aligned"],
.ui.table [class*="left aligned"] {
  text-align: left;
}
.ui.table[class*="center aligned"],
.ui.table [class*="center aligned"] {
  text-align: center;
}
.ui.table[class*="right aligned"],
.ui.table [class*="right aligned"] {
  text-align: right;
}
/*------------------
 Vertical Alignment
------------------*/
.ui.table[class*="top aligned"],
.ui.table [class*="top aligned"] {
  vertical-align: top;
}
.ui.table[class*="middle aligned"],
.ui.table [class*="middle aligned"] {
  vertical-align: middle;
}
.ui.table[class*="bottom aligned"],
.ui.table [class*="bottom aligned"] {
  vertical-align: bottom;
}
/*--------------
    Collapsing
---------------*/
.ui.table th.collapsing,
.ui.table td.collapsing {
  width: 1px;
  white-space: nowrap;
}
/*--------------
     Fixed
---------------*/
.ui.fixed.table {
  table-layout: fixed;
}
.ui.fixed.table th,
.ui.fixed.table td {
  overflow: hidden;
  text-overflow: ellipsis;
}
/*--------------
   Selectable
---------------*/
.ui.selectable.table tbody tr:hover,
.ui.table tbody tr td.selectable:hover {
  background: rgba(0, 0, 0, 0.05) !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.selectable.inverted.table tbody tr:hover,
.ui.inverted.table tbody tr td.selectable:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
}
/* Selectable Cell Link */
.ui.table tbody tr td.selectable {
  padding: 0em;
}
.ui.table tbody tr td.selectable > a:not(.ui) {
  display: block;
  color: inherit;
  padding: 0.78571429em 0.78571429em;
}
/* Other States */
.ui.selectable.table tr.error:hover,
.ui.table tr td.selectable.error:hover,
.ui.selectable.table tr:hover td.error {
  background: rgba(185, 3, 3, 0.15) !important;
  color: #f7f7f7 !important;
}
.ui.selectable.table tr.warning:hover,
.ui.table tr td.selectable.warning:hover,
.ui.selectable.table tr:hover td.warning {
  background: #fff4e4 !important;
  color: #493107 !important;
}
.ui.selectable.table tr.active:hover,
.ui.table tr td.selectable.active:hover,
.ui.selectable.table tr:hover td.active {
  background: #E0E0E0 !important;
  color: rgba(255, 255, 255, 0.87) !important;
}
.ui.selectable.table tr.positive:hover,
.ui.table tr td.selectable.positive:hover,
.ui.selectable.table tr:hover td.positive {
  background: #f7ffe6 !important;
  color: #275b28 !important;
}
.ui.selectable.table tr.negative:hover,
.ui.table tr td.selectable.negative:hover,
.ui.selectable.table tr:hover td.negative {
  background: rgba(185, 3, 3, 0.15) !important;
  color: #f7f7f7 !important;
}
/*-------------------
      Attached
--------------------*/
/* Middle */
.ui.attached.table {
  top: 0px;
  bottom: 0px;
  border-radius: 0px;
  margin: 0em -1px;
  width: calc(100% - (-1px * 2));
  max-width: calc(100% - (-1px * 2));
  box-shadow: none;
  border: 1px solid #D4D4D5;
}
.ui.attached + .ui.attached.table:not(.top) {
  border-top: none;
}
/* Top */
.ui[class*="top attached"].table {
  bottom: 0px;
  margin-bottom: 0em;
  top: 0px;
  margin-top: 1em;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.table[class*="top attached"]:first-child {
  margin-top: 0em;
}
/* Bottom */
.ui[class*="bottom attached"].table {
  bottom: 0px;
  margin-top: 0em;
  top: 0px;
  margin-bottom: 1em;
  box-shadow: none, none;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui[class*="bottom attached"].table:last-child {
  margin-bottom: 0em;
}
/*--------------
     Striped
---------------*/
/* Table Striping */
.ui.striped.table > tr:nth-child(2n),
.ui.striped.table tbody tr:nth-child(2n) {
  background-color: rgba(0, 0, 50, 0.02);
}
/* Stripes */
.ui.inverted.striped.table > tr:nth-child(2n),
.ui.inverted.striped.table tbody tr:nth-child(2n) {
  background-color: rgba(255, 255, 255, 0.05);
}
/* Allow striped active hover */
.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {
  background: #EFEFEF !important;
  color: rgba(255, 255, 255, 0.95) !important;
}
/*--------------
   Single Line
---------------*/
.ui.table[class*="single line"],
.ui.table [class*="single line"] {
  white-space: nowrap;
}
.ui.table[class*="single line"],
.ui.table [class*="single line"] {
  white-space: nowrap;
}
/*-------------------
       Colors
--------------------*/
/* Red */
.ui.red.table {
  border-top: 0.2em solid #DB2828;
}
.ui.inverted.red.table {
  background-color: #DB2828 !important;
  color: #FFFFFF !important;
}
/* Orange */
.ui.orange.table {
  border-top: 0.2em solid #F2711C;
}
.ui.inverted.orange.table {
  background-color: #F2711C !important;
  color: #FFFFFF !important;
}
/* Yellow */
.ui.yellow.table {
  border-top: 0.2em solid #FBBD08;
}
.ui.inverted.yellow.table {
  background-color: #FBBD08 !important;
  color: #FFFFFF !important;
}
/* Olive */
.ui.olive.table {
  border-top: 0.2em solid #B5CC18;
}
.ui.inverted.olive.table {
  background-color: #B5CC18 !important;
  color: #FFFFFF !important;
}
/* Green */
.ui.green.table {
  border-top: 0.2em solid #21BA45;
}
.ui.inverted.green.table {
  background-color: #21BA45 !important;
  color: #FFFFFF !important;
}
/* Teal */
.ui.teal.table {
  border-top: 0.2em solid #00B5AD;
}
.ui.inverted.teal.table {
  background-color: #00B5AD !important;
  color: #FFFFFF !important;
}
/* Blue */
.ui.blue.table {
  border-top: 0.2em solid #2185D0;
}
.ui.inverted.blue.table {
  background-color: #2185D0 !important;
  color: #FFFFFF !important;
}
/* Violet */
.ui.violet.table {
  border-top: 0.2em solid #6435C9;
}
.ui.inverted.violet.table {
  background-color: #6435C9 !important;
  color: #FFFFFF !important;
}
/* Purple */
.ui.purple.table {
  border-top: 0.2em solid #A333C8;
}
.ui.inverted.purple.table {
  background-color: #A333C8 !important;
  color: #FFFFFF !important;
}
/* Pink */
.ui.pink.table {
  border-top: 0.2em solid #E03997;
}
.ui.inverted.pink.table {
  background-color: #E03997 !important;
  color: #FFFFFF !important;
}
/* Brown */
.ui.brown.table {
  border-top: 0.2em solid #A5673F;
}
.ui.inverted.brown.table {
  background-color: #A5673F !important;
  color: #FFFFFF !important;
}
/* Grey */
.ui.grey.table {
  border-top: 0.2em solid #767676;
}
.ui.inverted.grey.table {
  background-color: #767676 !important;
  color: #FFFFFF !important;
}
/* Black */
.ui.black.table {
  border-top: 0.2em solid #1B1C1D;
}
.ui.inverted.black.table {
  background-color: #1B1C1D !important;
  color: #FFFFFF !important;
}
/*--------------
  Column Count
---------------*/
/* Grid Based */
.ui.one.column.table td {
  width: 100%;
}
.ui.two.column.table td {
  width: 50%;
}
.ui.three.column.table td {
  width: 33.33333333%;
}
.ui.four.column.table td {
  width: 25%;
}
.ui.five.column.table td {
  width: 20%;
}
.ui.six.column.table td {
  width: 16.66666667%;
}
.ui.seven.column.table td {
  width: 14.28571429%;
}
.ui.eight.column.table td {
  width: 12.5%;
}
.ui.nine.column.table td {
  width: 11.11111111%;
}
.ui.ten.column.table td {
  width: 10%;
}
.ui.eleven.column.table td {
  width: 9.09090909%;
}
.ui.twelve.column.table td {
  width: 8.33333333%;
}
.ui.thirteen.column.table td {
  width: 7.69230769%;
}
.ui.fourteen.column.table td {
  width: 7.14285714%;
}
.ui.fifteen.column.table td {
  width: 6.66666667%;
}
.ui.sixteen.column.table td {
  width: 6.25%;
}
/* Column Width */
.ui.table th.one.wide,
.ui.table td.one.wide {
  width: 6.25%;
}
.ui.table th.two.wide,
.ui.table td.two.wide {
  width: 12.5%;
}
.ui.table th.three.wide,
.ui.table td.three.wide {
  width: 18.75%;
}
.ui.table th.four.wide,
.ui.table td.four.wide {
  width: 25%;
}
.ui.table th.five.wide,
.ui.table td.five.wide {
  width: 31.25%;
}
.ui.table th.six.wide,
.ui.table td.six.wide {
  width: 37.5%;
}
.ui.table th.seven.wide,
.ui.table td.seven.wide {
  width: 43.75%;
}
.ui.table th.eight.wide,
.ui.table td.eight.wide {
  width: 50%;
}
.ui.table th.nine.wide,
.ui.table td.nine.wide {
  width: 56.25%;
}
.ui.table th.ten.wide,
.ui.table td.ten.wide {
  width: 62.5%;
}
.ui.table th.eleven.wide,
.ui.table td.eleven.wide {
  width: 68.75%;
}
.ui.table th.twelve.wide,
.ui.table td.twelve.wide {
  width: 75%;
}
.ui.table th.thirteen.wide,
.ui.table td.thirteen.wide {
  width: 81.25%;
}
.ui.table th.fourteen.wide,
.ui.table td.fourteen.wide {
  width: 87.5%;
}
.ui.table th.fifteen.wide,
.ui.table td.fifteen.wide {
  width: 93.75%;
}
.ui.table th.sixteen.wide,
.ui.table td.sixteen.wide {
  width: 100%;
}
/*--------------
    Sortable
---------------*/
.ui.sortable.table thead th {
  cursor: pointer;
  white-space: nowrap;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.87);
}
.ui.sortable.table thead th:first-child {
  border-left: none;
}
.ui.sortable.table thead th.sorted,
.ui.sortable.table thead th.sorted:hover {
  user-select: none;
}
.ui.sortable.table thead th:after {
  display: none;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  content: '';
  height: 1em;
  width: auto;
  opacity: 0.8;
  margin: 0em 0em 0em 0.5em;
  font-family: 'Icons';
}
.ui.sortable.table thead th.ascending:after {
  content: '\\f0d8';
}
.ui.sortable.table thead th.descending:after {
  content: '\\f0d7';
}
/* Hover */
.ui.sortable.table th.disabled:hover {
  cursor: auto;
  color: rgba(40, 40, 40, 0.3);
}
.ui.sortable.table thead th:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.8);
}
/* Sorted */
.ui.sortable.table thead th.sorted {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
.ui.sortable.table thead th.sorted:after {
  display: inline-block;
}
/* Sorted Hover */
.ui.sortable.table thead th.sorted:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
}
/* Inverted */
.ui.inverted.sortable.table thead th.sorted {
  background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  color: #ffffff;
}
.ui.inverted.sortable.table thead th:hover {
  background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  color: #ffffff;
}
.ui.inverted.sortable.table thead th {
  border-left-color: transparent;
  border-right-color: transparent;
}
/*--------------
    Inverted
---------------*/
/* Text Color */
.ui.inverted.table {
  background: #333333;
  color: rgba(255, 255, 255, 0.9);
  border: none;
}
.ui.inverted.table th {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.ui.inverted.table tr td {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.ui.inverted.table tr.disabled td,
.ui.inverted.table tr td.disabled,
.ui.inverted.table tr.disabled:hover td,
.ui.inverted.table tr:hover td.disabled {
  pointer-events: none;
  color: rgba(225, 225, 225, 0.3);
}
/* Definition */
.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,
.ui.inverted.definition.table thead:not(.full-width) th:first-child {
  background: #FFFFFF;
}
.ui.inverted.definition.table tr td:first-child {
  background: rgba(255, 255, 255, 0.02);
  color: #ffffff;
}
/*--------------
   Collapsing
---------------*/
.ui.collapsing.table {
  width: auto;
}
/*--------------
      Basic
---------------*/
.ui.basic.table {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: none;
}
.ui.basic.table thead,
.ui.basic.table tfoot {
  box-shadow: none;
}
.ui.basic.table th {
  background: #d9d9e2;
  border-left: none;
}
.ui.basic.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.ui.basic.table td {
  background: transparent;
}
.ui.basic.striped.table tbody tr:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.05) !important;
}
/* Very Basic */
.ui[class*="very basic"].table {
  border: none;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td {
  padding: '';
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th:first-child,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td:first-child {
  padding-left: 0em;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th:last-child,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td:last-child {
  padding-right: 0em;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) thead tr:first-child th {
  padding-top: 0em;
}
/*--------------
     Celled
---------------*/
.ui.celled.table tr th,
.ui.celled.table tr td {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.ui.celled.table tr th:first-child,
.ui.celled.table tr td:first-child {
  border-left: none;
}
/*--------------
     Padded
---------------*/
.ui.padded.table th {
  padding-left: 1em;
  padding-right: 1em;
}
.ui.padded.table th,
.ui.padded.table td {
  padding: 1em 1em;
}
/* Very */
.ui[class*="very padded"].table th {
  padding-left: 1.5em;
  padding-right: 1.5em;
}
.ui[class*="very padded"].table td {
  padding: 1.5em 1.5em;
}
/*--------------
     Compact
---------------*/
.ui.compact.table th {
  padding-left: 0.7em;
  padding-right: 0.7em;
}
.ui.compact.table td {
  padding: 0.5em 0.7em;
}
/* Very */
.ui[class*="very compact"].table th {
  padding-left: 0.6em;
  padding-right: 0.6em;
}
.ui[class*="very compact"].table td {
  padding: 0.4em 0.6em;
}
/*--------------
      Sizes
---------------*/
/* Small */
.ui.small.table {
  font-size: 0.9em;
}
/* Standard */
.ui.table {
  font-size: 1em;
}
/* Large */
.ui.large.table {
  font-size: 1.1em;
}
/* Views */
/*!
 * # Semantic UI - Ad
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
          Advertisement
*******************************/
/* Packaged Theme */
/*******************************
          Advertisement
*******************************/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
         Advertisement
*******************************/
.ui.ad {
  display: block;
  overflow: hidden;
  margin: 1em 0em;
}
.ui.ad:first-child {
  margin: 0em;
}
.ui.ad:last-child {
  margin: 0em;
}
.ui.ad iframe {
  margin: 0em;
  padding: 0em;
  border: none;
  overflow: hidden;
}
/*--------------
     Common
---------------*/
/* Leaderboard */
.ui.leaderboard.ad {
  width: 728px;
  height: 90px;
}
/* Medium Rectangle */
.ui[class*="medium rectangle"].ad {
  width: 300px;
  height: 250px;
}
/* Large Rectangle */
.ui[class*="large rectangle"].ad {
  width: 336px;
  height: 280px;
}
/* Half Page */
.ui[class*="half page"].ad {
  width: 300px;
  height: 600px;
}
/*--------------
     Square
---------------*/
/* Square */
.ui.square.ad {
  width: 250px;
  height: 250px;
}
/* Small Square */
.ui[class*="small square"].ad {
  width: 200px;
  height: 200px;
}
/*--------------
    Rectangle
---------------*/
/* Small Rectangle */
.ui[class*="small rectangle"].ad {
  width: 180px;
  height: 150px;
}
/* Vertical Rectangle */
.ui[class*="vertical rectangle"].ad {
  width: 240px;
  height: 400px;
}
/*--------------
     Button
---------------*/
.ui.button.ad {
  width: 120px;
  height: 90px;
}
.ui[class*="square button"].ad {
  width: 125px;
  height: 125px;
}
.ui[class*="small button"].ad {
  width: 120px;
  height: 60px;
}
/*--------------
   Skyscrapers
---------------*/
/* Skyscraper */
.ui.skyscraper.ad {
  width: 120px;
  height: 600px;
}
/* Wide Skyscraper */
.ui[class*="wide skyscraper"].ad {
  width: 160px;
}
/*--------------
     Banners
---------------*/
/* Banner */
.ui.banner.ad {
  width: 468px;
  height: 60px;
}
/* Vertical Banner */
.ui[class*="vertical banner"].ad {
  width: 120px;
  height: 240px;
}
/* Top Banner */
.ui[class*="top banner"].ad {
  width: 930px;
  height: 180px;
}
/* Half Banner */
.ui[class*="half banner"].ad {
  width: 234px;
  height: 60px;
}
/*--------------
    Boards
---------------*/
/* Leaderboard */
.ui[class*="large leaderboard"].ad {
  width: 970px;
  height: 90px;
}
/* Billboard */
.ui.billboard.ad {
  width: 970px;
  height: 250px;
}
/*--------------
    Panorama
---------------*/
/* Panorama */
.ui.panorama.ad {
  width: 980px;
  height: 120px;
}
/*--------------
     Netboard
---------------*/
/* Netboard */
.ui.netboard.ad {
  width: 580px;
  height: 400px;
}
/*--------------
     Mobile
---------------*/
/* Large Mobile Banner */
.ui[class*="large mobile banner"].ad {
  width: 320px;
  height: 100px;
}
/* Mobile Leaderboard */
.ui[class*="mobile leaderboard"].ad {
  width: 320px;
  height: 50px;
}
/*******************************
             Types
*******************************/
/* Mobile Sizes */
.ui.mobile.ad {
  display: none;
}
@media only screen and (max-width: 767px) {
  .ui.mobile.ad {
    display: block;
  }
}
/*******************************
           Variations
*******************************/
.ui.centered.ad {
  margin-left: auto;
  margin-right: auto;
}
.ui.test.ad {
  position: relative;
  background: #545454;
}
.ui.test.ad:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
  content: 'Ad';
  color: #FFFFFF;
  font-size: 1em;
  font-weight: bold;
}
.ui.mobile.test.ad:after {
  font-size: 0.85714286em;
}
.ui.test.ad[data-text]:after {
  content: attr(data-text);
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Item
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Card
*******************************/
/*-------------------
         View
--------------------*/
/* Shadow */
/* Card */
/* Card Group */
/* Consecutive Cards */
/*-------------------
       Content
--------------------*/
/* Image */
/* Content */
/* Header */
/* Metadata */
/* Icons */
/* Links */
/* Description */
/* Content Image */
/* Avatar Image */
/* Paragraph */
/* Dimmer */
/* Additional Content */
/* Extra Links */
/* Buttons */
/*-------------------
      Variations
--------------------*/
/* Link */
/* Raised */
/* Card Count */
/* Stackable */
/* Sizes */
/* Colored */
/* Packaged Theme */
/*******************************
             Card
*******************************/
/*-------------------
         View
--------------------*/
/* Shadow */
/* Card */
/* Card Group */
/* Consecutive Cards */
/*-------------------
       Content
--------------------*/
/* Image */
/* Content */
/* Header */
/* Metadata */
/* Icons */
/* Links */
/* Description */
/* Content Image */
/* Avatar Image */
/* Paragraph */
/* Dimmer */
/* Additional Content */
/* Extra Links */
/* Buttons */
/*-------------------
      Variations
--------------------*/
/* Link */
/* Raised */
/* Card Count */
/* Stackable */
/* Sizes */
/* Colored */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Standard
*******************************/
/*--------------
      Card
---------------*/
.ui.cards > .card,
.ui.card {
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 290px;
  min-height: 0px;
  background: #1e1f33;
  padding: 0em;
  border: none;
  border-radius: 0.28571429rem;
  box-shadow: 0px 1px 3px 0px #D4D4D5, 0px 0px 0px 0px #D4D4D5;
  transition: box-shadow 0.1s ease, transform 0.1s ease;
  z-index: '';
}
.ui.card {
  margin: 1em 0em;
}
.ui.cards > .card a,
.ui.card a {
  cursor: pointer;
}
.ui.card:first-child {
  margin-top: 0em;
}
.ui.card:last-child {
  margin-bottom: 0em;
}
/*--------------
      Cards
---------------*/
.ui.cards {
  display: flex;
  margin: -0.875em -0.5em;
  flex-wrap: wrap;
}
.ui.cards > .card {
  display: flex;
  margin: 0.875em 0.5em;
  float: none;
}
/* Clearing */
.ui.cards:after,
.ui.card:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
/* Consecutive Card Groups Preserve Row Spacing */
.ui.cards ~ .ui.cards {
  margin-top: 0.875em;
}
/*--------------
  Rounded Edges
---------------*/
.ui.cards > .card > :first-child,
.ui.card > :first-child {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em !important;
  border-top: none !important;
}
.ui.cards > .card > :last-child,
.ui.card > :last-child {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;
}
.ui.cards > .card > :only-child,
.ui.card > :only-child {
  border-radius: 0.28571429rem !important;
}
/*--------------
     Images
---------------*/
.ui.cards > .card > .image,
.ui.card > .image {
  position: relative;
  display: block;
  flex: 0 0 auto;
  padding: 0em;
  background: rgba(0, 0, 0, 0.05);
}
.ui.cards > .card > .image > img,
.ui.card > .image > img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: inherit;
}
.ui.cards > .card > .image:not(.ui) > img,
.ui.card > .image:not(.ui) > img {
  border: none;
}
/*--------------
     Content
---------------*/
.ui.cards > .card > .content,
.ui.card > .content {
  flex-grow: 1;
  border: none;
  border-top: 0px solid rgba(255, 255, 255, 0.1);
  background: none;
  margin: 0em;
  padding: 1em 1em;
  box-shadow: none;
  font-size: 1em;
  border-radius: 0em;
}
.ui.cards > .card > .content:after,
.ui.card > .content:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.ui.cards > .card > .content > .header,
.ui.card > .content > .header {
  display: block;
  margin: '';
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  color: rgba(255, 255, 255, 0.85);
}
/* Default Header Size */
.ui.cards > .card > .content > .header:not(.ui),
.ui.card > .content > .header:not(.ui) {
  font-weight: bold;
  font-size: 1.28571429em;
  margin-top: -0.21425em;
  line-height: 1.28571429em;
}
.ui.cards > .card > .content > .meta + .description,
.ui.cards > .card > .content > .header + .description,
.ui.card > .content > .meta + .description,
.ui.card > .content > .header + .description {
  margin-top: 0.5em;
}
/*----------------
 Floated Content
-----------------*/
.ui.cards > .card [class*="left floated"],
.ui.card [class*="left floated"] {
  float: left;
}
.ui.cards > .card [class*="right floated"],
.ui.card [class*="right floated"] {
  float: right;
}
/*--------------
     Aligned
---------------*/
.ui.cards > .card [class*="left aligned"],
.ui.card [class*="left aligned"] {
  text-align: left;
}
.ui.cards > .card [class*="center aligned"],
.ui.card [class*="center aligned"] {
  text-align: center;
}
.ui.cards > .card [class*="right aligned"],
.ui.card [class*="right aligned"] {
  text-align: right;
}
/*--------------
  Content Image
---------------*/
.ui.cards > .card .content img,
.ui.card .content img {
  display: inline-block;
  vertical-align: middle;
  width: '';
}
.ui.cards > .card img.avatar,
.ui.cards > .card .avatar img,
.ui.card img.avatar,
.ui.card .avatar img {
  width: 2em;
  height: 2em;
  border-radius: 500rem;
}
/*--------------
   Description
---------------*/
.ui.cards > .card > .content > .description,
.ui.card > .content > .description {
  clear: both;
  color: #eceff8;
}
/*--------------
    Paragraph
---------------*/
.ui.cards > .card > .content p,
.ui.card > .content p {
  margin: 0em 0em 0.5em;
}
.ui.cards > .card > .content p:last-child,
.ui.card > .content p:last-child {
  margin-bottom: 0em;
}
/*--------------
      Meta
---------------*/
.ui.cards > .card .meta,
.ui.card .meta {
  font-size: 1em;
  color: rgba(255, 255, 255, 0.4);
}
.ui.cards > .card .meta *,
.ui.card .meta * {
  margin-right: 0.3em;
}
.ui.cards > .card .meta :last-child,
.ui.card .meta :last-child {
  margin-right: 0em;
}
.ui.cards > .card .meta [class*="right floated"],
.ui.card .meta [class*="right floated"] {
  margin-right: 0em;
  margin-left: 0.3em;
}
/*--------------
      Links
---------------*/
/* Generic */
.ui.cards > .card > .content a:not(.ui),
.ui.card > .content a:not(.ui) {
  color: '';
  transition: color 0.1s ease;
}
.ui.cards > .card > .content a:not(.ui):hover,
.ui.card > .content a:not(.ui):hover {
  color: '';
}
/* Header */
.ui.cards > .card > .content > a.header,
.ui.card > .content > a.header {
  color: rgba(255, 255, 255, 0.85);
}
.ui.cards > .card > .content > a.header:hover,
.ui.card > .content > a.header:hover {
  color: #1e70bf;
}
/* Meta */
.ui.cards > .card .meta > a:not(.ui),
.ui.card .meta > a:not(.ui) {
  color: rgba(255, 255, 255, 0.4);
}
.ui.cards > .card .meta > a:not(.ui):hover,
.ui.card .meta > a:not(.ui):hover {
  color: rgba(255, 255, 255, 0.87);
}
/*--------------
     Buttons
---------------*/
.ui.cards > .card > .buttons,
.ui.card > .buttons,
.ui.cards > .card > .button,
.ui.card > .button {
  margin: 0px 0px;
  width: calc(100% +  0px );
}
/*--------------
      Dimmer
---------------*/
.ui.cards > .card .dimmer,
.ui.card .dimmer {
  background-color: '';
  z-index: 10;
}
/*--------------
     Labels
---------------*/
/*-----Star----- */
/* Icon */
.ui.cards > .card > .content .star.icon,
.ui.card > .content .star.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.ui.cards > .card > .content .star.icon:hover,
.ui.card > .content .star.icon:hover {
  opacity: 1;
  color: #FFB70A;
}
.ui.cards > .card > .content .active.star.icon,
.ui.card > .content .active.star.icon {
  color: #FFE623;
}
/*-----Like----- */
/* Icon */
.ui.cards > .card > .content .like.icon,
.ui.card > .content .like.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.ui.cards > .card > .content .like.icon:hover,
.ui.card > .content .like.icon:hover {
  opacity: 1;
  color: #FF2733;
}
.ui.cards > .card > .content .active.like.icon,
.ui.card > .content .active.like.icon {
  color: #FF2733;
}
/*----------------
  Extra Content
-----------------*/
.ui.cards > .card > .extra,
.ui.card > .extra {
  max-width: 100%;
  min-height: 0em !important;
  flex-grow: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
  position: static;
  background: none;
  width: auto;
  margin: 0em 0em;
  padding: 0.75em 1em;
  top: 0em;
  left: 0em;
  color: rgba(255, 255, 255, 0.4);
  box-shadow: none;
  transition: color 0.1s ease;
}
.ui.cards > .card > .extra a:not(.ui),
.ui.card > .extra a:not(.ui) {
  color: rgba(255, 255, 255, 0.4);
}
.ui.cards > .card > .extra a:not(.ui):hover,
.ui.card > .extra a:not(.ui):hover {
  color: #1e70bf;
}
/*******************************
           Variations
*******************************/
/*-------------------
       Raised
--------------------*/
.ui.raised.cards > .card,
.ui.raised.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}
.ui.raised.cards a.card:hover,
.ui.link.cards .raised.card:hover,
a.ui.raised.card:hover,
.ui.link.raised.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.15), 0px 2px 10px 0px rgba(34, 36, 38, 0.25);
}
.ui.raised.cards > .card,
.ui.raised.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}
/*-------------------
       Centered
--------------------*/
.ui.centered.cards {
  justify-content: center;
}
.ui.centered.card {
  margin-left: auto;
  margin-right: auto;
}
/*-------------------
        Fluid
--------------------*/
.ui.fluid.card {
  width: 100%;
  max-width: 9999px;
}
/*-------------------
        Link
--------------------*/
.ui.cards a.card,
.ui.link.cards .card,
a.ui.card,
.ui.link.card {
  transform: none;
}
.ui.cards a.card:hover,
.ui.link.cards .card:hover,
a.ui.card:hover,
.ui.link.card:hover {
  cursor: pointer;
  z-index: 5;
  background: #FFFFFF;
  border: none;
  box-shadow: 0px 1px 3px 0px #BCBDBD, 0px 0px 0px 0px #D4D4D5;
  transform: translateY(-3px);
}
/*-------------------
       Colors
--------------------*/
/* Red */
.ui.red.cards > .card,
.ui.cards > .red.card,
.ui.red.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #DB2828, 0px 1px 3px 0px #D4D4D5;
}
.ui.red.cards > .card:hover,
.ui.cards > .red.card:hover,
.ui.red.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #d01919, 0px 1px 3px 0px #BCBDBD;
}
/* Orange */
.ui.orange.cards > .card,
.ui.cards > .orange.card,
.ui.orange.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #F2711C, 0px 1px 3px 0px #D4D4D5;
}
.ui.orange.cards > .card:hover,
.ui.cards > .orange.card:hover,
.ui.orange.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #f26202, 0px 1px 3px 0px #BCBDBD;
}
/* Yellow */
.ui.yellow.cards > .card,
.ui.cards > .yellow.card,
.ui.yellow.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #FBBD08, 0px 1px 3px 0px #D4D4D5;
}
.ui.yellow.cards > .card:hover,
.ui.cards > .yellow.card:hover,
.ui.yellow.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #eaae00, 0px 1px 3px 0px #BCBDBD;
}
/* Olive */
.ui.olive.cards > .card,
.ui.cards > .olive.card,
.ui.olive.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #B5CC18, 0px 1px 3px 0px #D4D4D5;
}
.ui.olive.cards > .card:hover,
.ui.cards > .olive.card:hover,
.ui.olive.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #a7bd0d, 0px 1px 3px 0px #BCBDBD;
}
/* Green */
.ui.green.cards > .card,
.ui.cards > .green.card,
.ui.green.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #21BA45, 0px 1px 3px 0px #D4D4D5;
}
.ui.green.cards > .card:hover,
.ui.cards > .green.card:hover,
.ui.green.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #16ab39, 0px 1px 3px 0px #BCBDBD;
}
/* Teal */
.ui.teal.cards > .card,
.ui.cards > .teal.card,
.ui.teal.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #00B5AD, 0px 1px 3px 0px #D4D4D5;
}
.ui.teal.cards > .card:hover,
.ui.cards > .teal.card:hover,
.ui.teal.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #009c95, 0px 1px 3px 0px #BCBDBD;
}
/* Blue */
.ui.blue.cards > .card,
.ui.cards > .blue.card,
.ui.blue.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #2185D0, 0px 1px 3px 0px #D4D4D5;
}
.ui.blue.cards > .card:hover,
.ui.cards > .blue.card:hover,
.ui.blue.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #1678c2, 0px 1px 3px 0px #BCBDBD;
}
/* Violet */
.ui.violet.cards > .card,
.ui.cards > .violet.card,
.ui.violet.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #6435C9, 0px 1px 3px 0px #D4D4D5;
}
.ui.violet.cards > .card:hover,
.ui.cards > .violet.card:hover,
.ui.violet.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #5829bb, 0px 1px 3px 0px #BCBDBD;
}
/* Purple */
.ui.purple.cards > .card,
.ui.cards > .purple.card,
.ui.purple.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #A333C8, 0px 1px 3px 0px #D4D4D5;
}
.ui.purple.cards > .card:hover,
.ui.cards > .purple.card:hover,
.ui.purple.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #9627ba, 0px 1px 3px 0px #BCBDBD;
}
/* Pink */
.ui.pink.cards > .card,
.ui.cards > .pink.card,
.ui.pink.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #E03997, 0px 1px 3px 0px #D4D4D5;
}
.ui.pink.cards > .card:hover,
.ui.cards > .pink.card:hover,
.ui.pink.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #e61a8d, 0px 1px 3px 0px #BCBDBD;
}
/* Brown */
.ui.brown.cards > .card,
.ui.cards > .brown.card,
.ui.brown.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #A5673F, 0px 1px 3px 0px #D4D4D5;
}
.ui.brown.cards > .card:hover,
.ui.cards > .brown.card:hover,
.ui.brown.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #975b33, 0px 1px 3px 0px #BCBDBD;
}
/* Grey */
.ui.grey.cards > .card,
.ui.cards > .grey.card,
.ui.grey.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #767676, 0px 1px 3px 0px #D4D4D5;
}
.ui.grey.cards > .card:hover,
.ui.cards > .grey.card:hover,
.ui.grey.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #838383, 0px 1px 3px 0px #BCBDBD;
}
/* Black */
.ui.black.cards > .card,
.ui.cards > .black.card,
.ui.black.card {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #1B1C1D, 0px 1px 3px 0px #D4D4D5;
}
.ui.black.cards > .card:hover,
.ui.cards > .black.card:hover,
.ui.black.card:hover {
  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #27292a, 0px 1px 3px 0px #BCBDBD;
}
/*--------------
   Card Count
---------------*/
.ui.one.cards {
  margin-left: 0em;
  margin-right: 0em;
}
.ui.one.cards > .card {
  width: 100%;
}
.ui.two.cards {
  margin-left: -1em;
  margin-right: -1em;
}
.ui.two.cards > .card {
  width: calc( 50%  -  2em );
  margin-left: 1em;
  margin-right: 1em;
}
.ui.three.cards {
  margin-left: -1em;
  margin-right: -1em;
}
.ui.three.cards > .card {
  width: calc( 33.33333333%  -  2em );
  margin-left: 1em;
  margin-right: 1em;
}
.ui.four.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.ui.four.cards > .card {
  width: calc( 25%  -  1.5em );
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.ui.five.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.ui.five.cards > .card {
  width: calc( 20%  -  1.5em );
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.ui.six.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.ui.six.cards > .card {
  width: calc( 16.66666667%  -  1.5em );
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.ui.seven.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.ui.seven.cards > .card {
  width: calc( 14.28571429%  -  1em );
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.ui.eight.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.ui.eight.cards > .card {
  width: calc( 12.5%  -  1em );
  margin-left: 0.5em;
  margin-right: 0.5em;
  font-size: 11px;
}
.ui.nine.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.ui.nine.cards > .card {
  width: calc( 11.11111111%  -  1em );
  margin-left: 0.5em;
  margin-right: 0.5em;
  font-size: 10px;
}
.ui.ten.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.ui.ten.cards > .card {
  width: calc( 10%  -  1em );
  margin-left: 0.5em;
  margin-right: 0.5em;
}
/*-------------------
      Doubling
--------------------*/
/* Mobile Only */
@media only screen and (max-width: 767px) {
  .ui.two.doubling.cards {
    margin-left: 0em;
    margin-right: 0em;
  }
  .ui.two.doubling.cards > .card {
    width: 100%;
    margin-left: 0em;
    margin-right: 0em;
  }
  .ui.three.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.three.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.four.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.four.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.five.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.five.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.six.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.six.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.seven.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.seven.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.eight.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.eight.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.nine.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.nine.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.ten.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.ten.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
}
/* Tablet Only */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.two.doubling.cards {
    margin-left: 0em;
    margin-right: 0em;
  }
  .ui.two.doubling.cards > .card {
    width: 100%;
    margin-left: 0em;
    margin-right: 0em;
  }
  .ui.three.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.three.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.four.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.four.doubling.cards > .card {
    width: calc( 50%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.five.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.five.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.six.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.six.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.eight.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .ui.eight.doubling.cards > .card {
    width: calc( 33.33333333%  -  2em );
    margin-left: 1em;
    margin-right: 1em;
  }
  .ui.eight.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .ui.eight.doubling.cards > .card {
    width: calc( 25%  -  1.5em );
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
  .ui.nine.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .ui.nine.doubling.cards > .card {
    width: calc( 25%  -  1.5em );
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
  .ui.ten.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .ui.ten.doubling.cards > .card {
    width: calc( 20%  -  1.5em );
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
}
/*-------------------
      Stackable
--------------------*/
@media only screen and (max-width: 767px) {
  .ui.stackable.cards {
    display: block !important;
  }
  .ui.stackable.cards .card:first-child {
    margin-top: 0em !important;
  }
  .ui.stackable.cards > .card {
    display: block !important;
    height: auto !important;
    margin: 1em 1em;
    padding: 0 !important;
    width: calc( 100%  -  2em ) !important;
  }
}
/*--------------
      Size
---------------*/
.ui.cards > .card {
  font-size: 1em;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Comment
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Comments
*******************************/
/*-------------------
       View
--------------------*/
/*-------------------
      Elements
--------------------*/
/* Comment */
/* Nested Comment */
/* Avatar */
/* Content */
/* Author */
/* Metadata */
/* Text */
/* Actions */
/* Reply */
/*-------------------
      Variations
--------------------*/
/* Threaded */
/* Minimal */
/* Packaged Theme */
/*******************************
            Comments
*******************************/
/*-------------------
       View
--------------------*/
/*-------------------
      Elements
--------------------*/
/* Comment */
/* Nested Comment */
/* Avatar */
/* Content */
/* Author */
/* Metadata */
/* Text */
/* Actions */
/* Reply */
/*-------------------
      Variations
--------------------*/
/* Threaded */
/* Minimal */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Standard
*******************************/
/*--------------
    Comments
---------------*/
.ui.comments {
  margin: 1.5em 0em;
  max-width: 650px;
}
.ui.comments:first-child {
  margin-top: 0em;
}
.ui.comments:last-child {
  margin-bottom: 0em;
}
/*--------------
     Comment
---------------*/
.ui.comments .comment {
  position: relative;
  background: none;
  margin: 0.5em 0em 0em;
  padding: 0.5em 0em 0em;
  border: none;
  border-top: none;
  line-height: 1.2;
}
.ui.comments .comment:first-child {
  margin-top: 0em;
  padding-top: 0em;
}
/*--------------------
    Nested Comments
---------------------*/
.ui.comments .comment .comments {
  margin: 0em 0em 0.5em 0.5em;
  padding: 1em 0em 1em 1em;
}
.ui.comments .comment .comments:before {
  position: absolute;
  top: 0px;
  left: 0px;
}
.ui.comments .comment .comments .comment {
  border: none;
  border-top: none;
  background: none;
}
/*--------------
     Avatar
---------------*/
.ui.comments .comment .avatar {
  display: block;
  width: 2.5em;
  height: auto;
  float: left;
  margin: 0.2em 0em 0em;
}
.ui.comments .comment img.avatar,
.ui.comments .comment .avatar img {
  display: block;
  margin: 0em auto;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
}
/*--------------
     Content
---------------*/
.ui.comments .comment > .content {
  display: block;
}
/* If there is an avatar move content over */
.ui.comments .comment > .avatar ~ .content {
  margin-left: 3.5em;
}
/*--------------
     Author
---------------*/
.ui.comments .comment .author {
  font-size: 1em;
  color: rgba(255, 255, 255, 0.87);
  font-weight: bold;
}
.ui.comments .comment a.author {
  cursor: pointer;
}
.ui.comments .comment a.author:hover {
  color: #1e70bf;
}
/*--------------
     Metadata
---------------*/
.ui.comments .comment .metadata {
  display: inline-block;
  margin-left: 0.5em;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.875em;
}
.ui.comments .comment .metadata > * {
  display: inline-block;
  margin: 0em 0.5em 0em 0em;
}
.ui.comments .comment .metadata > :last-child {
  margin-right: 0em;
}
/*--------------------
     Comment Text
---------------------*/
.ui.comments .comment .text {
  margin: 0.25em 0em 0.5em;
  font-size: 1em;
  word-wrap: break-word;
  color: rgba(255, 255, 255, 0.87);
  line-height: 1.3;
}
/*--------------------
     User Actions
---------------------*/
.ui.comments .comment .actions {
  font-size: 0.875em;
}
.ui.comments .comment .actions a {
  cursor: pointer;
  display: inline-block;
  margin: 0em 0.75em 0em 0em;
  color: rgba(255, 255, 255, 0.4);
}
.ui.comments .comment .actions a:last-child {
  margin-right: 0em;
}
.ui.comments .comment .actions a.active,
.ui.comments .comment .actions a:hover {
  color: rgba(255, 255, 255, 0.8);
}
/*--------------------
      Reply Form
---------------------*/
.ui.comments > .reply.form {
  margin-top: 1em;
}
.ui.comments .comment .reply.form {
  width: 100%;
  margin-top: 1em;
}
.ui.comments .reply.form textarea {
  font-size: 1em;
  height: 12em;
}
/*******************************
            State
*******************************/
.ui.collapsed.comments,
.ui.comments .collapsed.comments,
.ui.comments .collapsed.comment {
  display: none;
}
/*******************************
           Variations
*******************************/
/*--------------------
        Threaded
---------------------*/
.ui.threaded.comments .comment .comments {
  margin: -1.5em 0 -1em 1.25em;
  padding: 3em 0em 2em 2.25em;
  box-shadow: -1px 0px 0px rgba(255, 255, 255, 0.15);
}
/*--------------------
        Minimal
---------------------*/
.ui.minimal.comments .comment .actions {
  opacity: 0;
  position: absolute;
  top: 0px;
  right: 0px;
  left: auto;
  transition: opacity 0.2s ease;
  transition-delay: 0.1s;
}
.ui.minimal.comments .comment > .content:hover > .actions {
  opacity: 1;
}
/*-------------------
        Sizes
--------------------*/
.ui.mini.comments {
  font-size: 0.78571429rem;
}
.ui.tiny.comments {
  font-size: 0.85714286rem;
}
.ui.small.comments {
  font-size: 0.92857143rem;
}
.ui.comments {
  font-size: 1rem;
}
.ui.large.comments {
  font-size: 1.14285714rem;
}
.ui.big.comments {
  font-size: 1.28571429rem;
}
.ui.huge.comments {
  font-size: 1.42857143rem;
}
.ui.massive.comments {
  font-size: 1.71428571rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Feed
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Feed
*******************************/
/*-------------------
        Feed
--------------------*/
/*-------------------
      Elements
--------------------*/
/* Event */
/* Event Label */
/* Icon Label */
/* Image Label */
/* Content w/ Label */
/* Content */
/* Date */
/* Summary */
/* Summary Image */
/* Summary Date */
/* User */
/* Extra Summary Data */
/* Extra Images */
/* Extra Text */
/* Metadata Group */
/* Like */
/* Metadata Divider */
/*-------------------
      Variations
--------------------*/
/* Packaged Theme */
/*******************************
             Feed
*******************************/
/*-------------------
        Feed
--------------------*/
/*-------------------
      Elements
--------------------*/
/* Event */
/* Event Label */
/* Icon Label */
/* Image Label */
/* Content w/ Label */
/* Content */
/* Date */
/* Summary */
/* Summary Image */
/* Summary Date */
/* User */
/* Extra Summary Data */
/* Extra Images */
/* Extra Text */
/* Metadata Group */
/* Like */
/* Metadata Divider */
/*-------------------
      Variations
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
         Activity Feed
*******************************/
.ui.feed {
  margin: 1em 0em;
}
.ui.feed:first-child {
  margin-top: 0em;
}
.ui.feed:last-child {
  margin-bottom: 0em;
}
/*******************************
            Content
*******************************/
/* Event */
.ui.feed > .event {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0.21428571rem 0em;
  margin: 0em;
  background: none;
  border-top: none;
}
.ui.feed > .event:first-child {
  border-top: 0px;
  padding-top: 0em;
}
.ui.feed > .event:last-child {
  padding-bottom: 0em;
}
/* Event Label */
.ui.feed > .event > .label {
  display: block;
  flex: 0 0 auto;
  width: 2.5em;
  height: auto;
  align-self: stretch;
  text-align: left;
}
.ui.feed > .event > .label .icon {
  opacity: 1;
  font-size: 1.5em;
  width: 100%;
  padding: 0.25em;
  background: none;
  border: none;
  border-radius: none;
  color: rgba(0, 0, 0, 0.6);
}
.ui.feed > .event > .label img {
  width: 100%;
  height: auto;
  border-radius: 500rem;
}
.ui.feed > .event > .label + .content {
  margin: 0.5em 0em 0.35714286em 1.14285714em;
}
/*--------------
     Content
---------------*/
/* Content */
.ui.feed > .event > .content {
  display: block;
  flex: 1 1 auto;
  align-self: stretch;
  text-align: left;
  word-wrap: break-word;
}
.ui.feed > .event:last-child > .content {
  padding-bottom: 0em;
}
/* Link */
.ui.feed > .event > .content a {
  cursor: pointer;
}
/*--------------
      Date
---------------*/
.ui.feed > .event > .content .date {
  margin: -0.5rem 0em 0em;
  padding: 0em;
  font-weight: normal;
  font-size: 1em;
  font-style: normal;
  color: rgba(255, 255, 255, 0.4);
}
/*--------------
     Summary
---------------*/
.ui.feed > .event > .content .summary {
  margin: 0em;
  font-size: 1em;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.87);
}
/* Summary Image */
.ui.feed > .event > .content .summary img {
  display: inline-block;
  width: auto;
  height: 10em;
  margin: -0.25em 0.25em 0em 0em;
  border-radius: 0.25em;
  vertical-align: middle;
}
/*--------------
      User
---------------*/
.ui.feed > .event > .content .user {
  display: inline-block;
  font-weight: bold;
  margin-right: 0em;
  vertical-align: baseline;
}
.ui.feed > .event > .content .user img {
  margin: -0.25em 0.25em 0em 0em;
  width: auto;
  height: 10em;
  vertical-align: middle;
}
/*--------------
   Inline Date
---------------*/
/* Date inside Summary */
.ui.feed > .event > .content .summary > .date {
  display: inline-block;
  float: none;
  font-weight: normal;
  font-size: 0.85714286em;
  font-style: normal;
  margin: 0em 0em 0em 0.5em;
  padding: 0em;
  color: rgba(255, 255, 255, 0.4);
}
/*--------------
  Extra Summary
---------------*/
.ui.feed > .event > .content .extra {
  margin: 0.5em 0em 0em;
  background: none;
  padding: 0em;
  color: rgba(255, 255, 255, 0.87);
}
/* Images */
.ui.feed > .event > .content .extra.images img {
  display: inline-block;
  margin: 0em 0.25em 0em 0em;
  width: 6em;
}
/* Text */
.ui.feed > .event > .content .extra.text {
  padding: 0em;
  border-left: none;
  font-size: 1em;
  max-width: 500px;
  line-height: 1.4285em;
}
/*--------------
      Meta
---------------*/
.ui.feed > .event > .content .meta {
  display: inline-block;
  font-size: 0.85714286em;
  margin: 0.5em 0em 0em;
  background: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0em;
  color: rgba(0, 0, 0, 0.6);
}
.ui.feed > .event > .content .meta > * {
  position: relative;
  margin-left: 0.75em;
}
.ui.feed > .event > .content .meta > *:after {
  content: '';
  color: rgba(0, 0, 0, 0.2);
  top: 0em;
  left: -1em;
  opacity: 1;
  position: absolute;
  vertical-align: top;
}
.ui.feed > .event > .content .meta .like {
  color: '';
  transition: 0.2s color ease;
}
.ui.feed > .event > .content .meta .like:hover .icon {
  color: #FF2733;
}
.ui.feed > .event > .content .meta .active.like .icon {
  color: #EF404A;
}
/* First element */
.ui.feed > .event > .content .meta > :first-child {
  margin-left: 0em;
}
.ui.feed > .event > .content .meta > :first-child::after {
  display: none;
}
/* Action */
.ui.feed > .event > .content .meta a,
.ui.feed > .event > .content .meta > .icon {
  cursor: pointer;
  opacity: 1;
  color: rgba(0, 0, 0, 0.5);
  transition: color 0.1s ease;
}
.ui.feed > .event > .content .meta a:hover,
.ui.feed > .event > .content .meta a:hover .icon,
.ui.feed > .event > .content .meta > .icon:hover {
  color: rgba(255, 255, 255, 0.95);
}
/*******************************
            Variations
*******************************/
.ui.small.feed {
  font-size: 0.92857143rem;
}
.ui.feed {
  font-size: 1rem;
}
.ui.large.feed {
  font-size: 1.14285714rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Item
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Item
*******************************/
/*-------------------
         View
--------------------*/
/* Group */
/* Item */
/* Responsive */
/*-------------------
       Content
--------------------*/
/* Image */
/* Content */
/* Header */
/* Metadata */
/* Icons */
/* Actions */
/* Links */
/* Description */
/* Content Image */
/* Avatar Image */
/* Paragraph */
/* Additional Content */
/*-------------------
      Variations
--------------------*/
/* Relaxed */
/* Divided */
/* Unstackable */
/* Packaged Theme */
/*******************************
             Item
*******************************/
/*-------------------
         View
--------------------*/
/* Group */
/* Item */
/* Responsive */
/*-------------------
       Content
--------------------*/
/* Image */
/* Content */
/* Header */
/* Metadata */
/* Icons */
/* Actions */
/* Links */
/* Description */
/* Content Image */
/* Avatar Image */
/* Paragraph */
/* Additional Content */
/*-------------------
      Variations
--------------------*/
/* Relaxed */
/* Divided */
/* Unstackable */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Standard
*******************************/
/*--------------
      Item
---------------*/
.ui.items > .item {
  display: flex;
  margin: 1em 0em;
  width: 100%;
  min-height: 0px;
  background: transparent;
  padding: 0em;
  border: none;
  border-radius: 0rem;
  box-shadow: none;
  transition: box-shadow 0.1s ease;
  z-index: '';
}
.ui.items > .item a {
  cursor: pointer;
}
/*--------------
      Items
---------------*/
.ui.items {
  margin: 1.5em 0em;
}
.ui.items:first-child {
  margin-top: 0em !important;
}
.ui.items:last-child {
  margin-bottom: 0em !important;
}
/*--------------
      Item
---------------*/
.ui.items > .item:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.ui.items > .item:first-child {
  margin-top: 0em;
}
.ui.items > .item:last-child {
  margin-bottom: 0em;
}
/*--------------
     Images
---------------*/
.ui.items > .item > .image {
  position: relative;
  flex: 0 0 auto;
  display: block;
  float: none;
  margin: 0em;
  padding: 0em;
  max-height: '';
  align-self: top;
}
.ui.items > .item > .image > img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0.125rem;
  border: none;
}
.ui.items > .item > .image:only-child > img {
  border-radius: 0rem;
}
/*--------------
     Content
---------------*/
.ui.items > .item > .content {
  display: block;
  flex: 1 1 auto;
  background: none;
  margin: 0em;
  padding: 0em;
  box-shadow: none;
  font-size: 1em;
  border: none;
  border-radius: 0em;
}
.ui.items > .item > .content:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.ui.items > .item > .image + .content {
  min-width: 0;
  width: auto;
  display: block;
  margin-left: 0em;
  align-self: top;
  padding-left: 1.5em;
}
.ui.items > .item > .content > .header {
  display: inline-block;
  margin: -0.21425em 0em 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.85);
}
/* Default Header Size */
.ui.items > .item > .content > .header:not(.ui) {
  font-size: 1.28571429em;
}
/*--------------
     Floated
---------------*/
.ui.items > .item [class*="left floated"] {
  float: left;
}
.ui.items > .item [class*="right floated"] {
  float: right;
}
/*--------------
  Content Image
---------------*/
.ui.items > .item .content img {
  align-self: middle;
  width: '';
}
.ui.items > .item img.avatar,
.ui.items > .item .avatar img {
  width: '';
  height: '';
  border-radius: 500rem;
}
/*--------------
   Description
---------------*/
.ui.items > .item > .content > .description {
  margin-top: 0.6em;
  max-width: auto;
  font-size: 1em;
  line-height: 1.4285em;
  color: rgba(255, 255, 255, 0.87);
}
/*--------------
    Paragraph
---------------*/
.ui.items > .item > .content p {
  margin: 0em 0em 0.5em;
}
.ui.items > .item > .content p:last-child {
  margin-bottom: 0em;
}
/*--------------
      Meta
---------------*/
.ui.items > .item .meta {
  margin: 0.5em 0em 0.5em;
  font-size: 1em;
  line-height: 1em;
  color: rgba(0, 0, 0, 0.6);
}
.ui.items > .item .meta * {
  margin-right: 0.3em;
}
.ui.items > .item .meta :last-child {
  margin-right: 0em;
}
.ui.items > .item .meta [class*="right floated"] {
  margin-right: 0em;
  margin-left: 0.3em;
}
/*--------------
      Links
---------------*/
/* Generic */
.ui.items > .item > .content a:not(.ui) {
  color: '';
  transition: color 0.1s ease;
}
.ui.items > .item > .content a:not(.ui):hover {
  color: '';
}
/* Header */
.ui.items > .item > .content > a.header {
  color: rgba(255, 255, 255, 0.85);
}
.ui.items > .item > .content > a.header:hover {
  color: #1e70bf;
}
/* Meta */
.ui.items > .item .meta > a:not(.ui) {
  color: rgba(255, 255, 255, 0.4);
}
.ui.items > .item .meta > a:not(.ui):hover {
  color: rgba(255, 255, 255, 0.87);
}
/*--------------
     Labels
---------------*/
/*-----Star----- */
/* Icon */
.ui.items > .item > .content .favorite.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.ui.items > .item > .content .favorite.icon:hover {
  opacity: 1;
  color: #FFB70A;
}
.ui.items > .item > .content .active.favorite.icon {
  color: #FFE623;
}
/*-----Like----- */
/* Icon */
.ui.items > .item > .content .like.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.ui.items > .item > .content .like.icon:hover {
  opacity: 1;
  color: #FF2733;
}
.ui.items > .item > .content .active.like.icon {
  color: #FF2733;
}
/*----------------
  Extra Content
-----------------*/
.ui.items > .item .extra {
  display: block;
  position: relative;
  background: none;
  margin: 0.5rem 0em 0em;
  width: 100%;
  padding: 0em 0em 0em;
  top: 0em;
  left: 0em;
  color: rgba(255, 255, 255, 0.4);
  box-shadow: none;
  transition: color 0.1s ease;
  border-top: none;
}
.ui.items > .item .extra > * {
  margin: 0.25rem 0.5rem 0.25rem 0em;
}
.ui.items > .item .extra > [class*="right floated"] {
  margin: 0.25rem 0em 0.25rem 0.5rem;
}
.ui.items > .item .extra:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
/*******************************
          Responsive
*******************************/
/* Default Image Width */
.ui.items > .item > .image:not(.ui) {
  width: 175px;
}
/* Tablet Only */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ui.items > .item {
    margin: 1em 0em;
  }
  .ui.items > .item > .image:not(.ui) {
    width: 150px;
  }
  .ui.items > .item > .image + .content {
    display: block;
    padding: 0em 0em 0em 1em;
  }
}
/* Mobile Only */
@media only screen and (max-width: 767px) {
  .ui.items:not(.unstackable) > .item {
    flex-direction: column;
    margin: 2em 0em;
  }
  .ui.items:not(.unstackable) > .item > .image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .ui.items:not(.unstackable) > .item > .image,
  .ui.items:not(.unstackable) > .item > .image > img {
    max-width: 100% !important;
    width: auto !important;
    max-height: 250px !important;
  }
  .ui.items:not(.unstackable) > .item > .image + .content {
    display: block;
    padding: 1.5em 0em 0em;
  }
}
/*******************************
           Variations
*******************************/
/*-------------------
       Aligned
--------------------*/
.ui.items > .item > .image + [class*="top aligned"].content {
  align-self: flex-start;
}
.ui.items > .item > .image + [class*="middle aligned"].content {
  align-self: center;
}
.ui.items > .item > .image + [class*="bottom aligned"].content {
  align-self: flex-end;
}
/*--------------
     Relaxed
---------------*/
.ui.relaxed.items > .item {
  margin: 1.5em 0em;
}
.ui[class*="very relaxed"].items > .item {
  margin: 2em 0em;
}
/*-------------------
      Divided
--------------------*/
.ui.divided.items > .item {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  margin: 0em;
  padding: 1em 0em;
}
.ui.divided.items > .item:first-child {
  border-top: none;
  margin-top: 0em !important;
  padding-top: 0em !important;
}
.ui.divided.items > .item:last-child {
  margin-bottom: 0em !important;
  padding-bottom: 0em !important;
}
/* Relaxed Divided */
.ui.relaxed.divided.items > .item {
  margin: 0em;
  padding: 1.5em 0em;
}
.ui[class*="very relaxed"].divided.items > .item {
  margin: 0em;
  padding: 2em 0em;
}
/*-------------------
        Link
--------------------*/
.ui.items a.item:hover,
.ui.link.items > .item:hover {
  cursor: pointer;
}
.ui.items a.item:hover .content .header,
.ui.link.items > .item:hover .content .header {
  color: #1e70bf;
}
/*--------------
      Size
---------------*/
.ui.items > .item {
  font-size: 1em;
}
/*---------------
   Unstackable
----------------*/
@media only screen and (max-width: 767px) {
  .ui.unstackable.items > .item > .image,
  .ui.unstackable.items > .item > .image > img {
    width: 125px !important;
  }
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Statistic
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
           Statistic
*******************************/
/*-------------------
         View
--------------------*/
/* Group */
/* Group Element */
/*-------------------
       Content
--------------------*/
/* Value */
/* Label */
/* Text */
/* Label Image */
/*-------------------
      Types
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Floated */
/* Inverted */
/* Item Width */
/* Size */
/* Packaged Theme */
/*******************************
           Statistic
*******************************/
/*-------------------
         View
--------------------*/
/* Group */
/* Group Element */
/*-------------------
       Content
--------------------*/
/* Value */
/* Label */
/* Text */
/* Label Image */
/*-------------------
      Types
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Floated */
/* Inverted */
/* Item Width */
/* Size */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           Statistic
*******************************/
/* Standalone */
.ui.statistic {
  display: inline-flex;
  flex-direction: column;
  margin: 1em 0em;
  max-width: auto;
}
.ui.statistic + .ui.statistic {
  margin: 0em 0em 0em 1.5em;
}
.ui.statistic:first-child {
  margin-top: 0em;
}
.ui.statistic:last-child {
  margin-bottom: 0em;
}
/*******************************
            Group
*******************************/
/* Grouped */
.ui.statistics {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.ui.statistics > .statistic {
  display: inline-flex;
  flex: 0 1 auto;
  flex-direction: column;
  margin: 0em 1.5em 1em;
  max-width: auto;
}
.ui.statistics {
  display: flex;
  margin: 1em -1.5em -1em;
}
/* Clearing */
.ui.statistics:after {
  display: block;
  content: ' ';
  height: 0px;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.ui.statistics:first-child {
  margin-top: 0em;
}
/*******************************
            Content
*******************************/
/*--------------
      Value
---------------*/
.ui.statistics .statistic > .value,
.ui.statistic > .value {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 4rem;
  font-weight: normal;
  line-height: 1em;
  color: #1B1C1D;
  text-transform: uppercase;
  text-align: center;
}
/*--------------
     Label
---------------*/
.ui.statistics .statistic > .label,
.ui.statistic > .label {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1em;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.87);
  text-transform: uppercase;
  text-align: center;
}
/* Top Label */
.ui.statistics .statistic > .label ~ .value,
.ui.statistic > .label ~ .value {
  margin-top: 0rem;
}
/* Bottom Label */
.ui.statistics .statistic > .value ~ .label,
.ui.statistic > .value ~ .label {
  margin-top: 0rem;
}
/*******************************
             Types
*******************************/
/*--------------
   Icon Value
---------------*/
.ui.statistics .statistic > .value .icon,
.ui.statistic > .value .icon {
  opacity: 1;
  width: auto;
  margin: 0em;
}
/*--------------
   Text Value
---------------*/
.ui.statistics .statistic > .text.value,
.ui.statistic > .text.value {
  line-height: 1em;
  min-height: 2em;
  font-weight: bold;
  text-align: center;
}
.ui.statistics .statistic > .text.value + .label,
.ui.statistic > .text.value + .label {
  text-align: center;
}
/*--------------
   Image Value
---------------*/
.ui.statistics .statistic > .value img,
.ui.statistic > .value img {
  max-height: 3rem;
  vertical-align: baseline;
}
/*******************************
            Variations
*******************************/
/*--------------
      Count
---------------*/
.ui.ten.statistics {
  margin: 0em 0em -1em;
}
.ui.ten.statistics .statistic {
  min-width: 10%;
  margin: 0em 0em 1em;
}
.ui.nine.statistics {
  margin: 0em 0em -1em;
}
.ui.nine.statistics .statistic {
  min-width: 11.11111111%;
  margin: 0em 0em 1em;
}
.ui.eight.statistics {
  margin: 0em 0em -1em;
}
.ui.eight.statistics .statistic {
  min-width: 12.5%;
  margin: 0em 0em 1em;
}
.ui.seven.statistics {
  margin: 0em 0em -1em;
}
.ui.seven.statistics .statistic {
  min-width: 14.28571429%;
  margin: 0em 0em 1em;
}
.ui.six.statistics {
  margin: 0em 0em -1em;
}
.ui.six.statistics .statistic {
  min-width: 16.66666667%;
  margin: 0em 0em 1em;
}
.ui.five.statistics {
  margin: 0em 0em -1em;
}
.ui.five.statistics .statistic {
  min-width: 20%;
  margin: 0em 0em 1em;
}
.ui.four.statistics {
  margin: 0em 0em -1em;
}
.ui.four.statistics .statistic {
  min-width: 25%;
  margin: 0em 0em 1em;
}
.ui.three.statistics {
  margin: 0em 0em -1em;
}
.ui.three.statistics .statistic {
  min-width: 33.33333333%;
  margin: 0em 0em 1em;
}
.ui.two.statistics {
  margin: 0em 0em -1em;
}
.ui.two.statistics .statistic {
  min-width: 50%;
  margin: 0em 0em 1em;
}
.ui.one.statistics {
  margin: 0em 0em -1em;
}
.ui.one.statistics .statistic {
  min-width: 100%;
  margin: 0em 0em 1em;
}
/*--------------
   Horizontal
---------------*/
.ui.horizontal.statistic {
  flex-direction: row;
  align-items: center;
}
.ui.horizontal.statistics {
  flex-direction: column;
  margin: 0em;
  max-width: none;
}
.ui.horizontal.statistics .statistic {
  flex-direction: row;
  align-items: center;
  max-width: none;
  margin: 1em 0em;
}
.ui.horizontal.statistic > .text.value,
.ui.horizontal.statistics > .statistic > .text.value {
  min-height: 0em !important;
}
.ui.horizontal.statistics .statistic > .value .icon,
.ui.horizontal.statistic > .value .icon {
  width: 1.18em;
}
.ui.horizontal.statistics .statistic > .value,
.ui.horizontal.statistic > .value {
  display: inline-block;
  vertical-align: middle;
}
.ui.horizontal.statistics .statistic > .label,
.ui.horizontal.statistic > .label {
  display: inline-block;
  vertical-align: middle;
  margin: 0em 0em 0em 0.75em;
}
/*--------------
     Colors
---------------*/
.ui.red.statistics .statistic > .value,
.ui.statistics .red.statistic > .value,
.ui.red.statistic > .value {
  color: #DB2828;
}
.ui.orange.statistics .statistic > .value,
.ui.statistics .orange.statistic > .value,
.ui.orange.statistic > .value {
  color: #F2711C;
}
.ui.yellow.statistics .statistic > .value,
.ui.statistics .yellow.statistic > .value,
.ui.yellow.statistic > .value {
  color: #FBBD08;
}
.ui.olive.statistics .statistic > .value,
.ui.statistics .olive.statistic > .value,
.ui.olive.statistic > .value {
  color: #B5CC18;
}
.ui.green.statistics .statistic > .value,
.ui.statistics .green.statistic > .value,
.ui.green.statistic > .value {
  color: #21BA45;
}
.ui.teal.statistics .statistic > .value,
.ui.statistics .teal.statistic > .value,
.ui.teal.statistic > .value {
  color: #00B5AD;
}
.ui.blue.statistics .statistic > .value,
.ui.statistics .blue.statistic > .value,
.ui.blue.statistic > .value {
  color: #2185D0;
}
.ui.violet.statistics .statistic > .value,
.ui.statistics .violet.statistic > .value,
.ui.violet.statistic > .value {
  color: #6435C9;
}
.ui.purple.statistics .statistic > .value,
.ui.statistics .purple.statistic > .value,
.ui.purple.statistic > .value {
  color: #A333C8;
}
.ui.pink.statistics .statistic > .value,
.ui.statistics .pink.statistic > .value,
.ui.pink.statistic > .value {
  color: #E03997;
}
.ui.brown.statistics .statistic > .value,
.ui.statistics .brown.statistic > .value,
.ui.brown.statistic > .value {
  color: #A5673F;
}
.ui.grey.statistics .statistic > .value,
.ui.statistics .grey.statistic > .value,
.ui.grey.statistic > .value {
  color: #767676;
}
/*--------------
    Inverted
---------------*/
.ui.inverted.statistics .statistic > .value,
.ui.inverted.statistic .value {
  color: #FFFFFF;
}
.ui.inverted.statistics .statistic > .label,
.ui.inverted.statistic .label {
  color: rgba(255, 255, 255, 0.9);
}
.ui.inverted.red.statistics .statistic > .value,
.ui.statistics .inverted.red.statistic > .value,
.ui.inverted.red.statistic > .value {
  color: #FF695E;
}
.ui.inverted.orange.statistics .statistic > .value,
.ui.statistics .inverted.orange.statistic > .value,
.ui.inverted.orange.statistic > .value {
  color: #FF851B;
}
.ui.inverted.yellow.statistics .statistic > .value,
.ui.statistics .inverted.yellow.statistic > .value,
.ui.inverted.yellow.statistic > .value {
  color: #FFE21F;
}
.ui.inverted.olive.statistics .statistic > .value,
.ui.statistics .inverted.olive.statistic > .value,
.ui.inverted.olive.statistic > .value {
  color: #D9E778;
}
.ui.inverted.green.statistics .statistic > .value,
.ui.statistics .inverted.green.statistic > .value,
.ui.inverted.green.statistic > .value {
  color: #2ECC40;
}
.ui.inverted.teal.statistics .statistic > .value,
.ui.statistics .inverted.teal.statistic > .value,
.ui.inverted.teal.statistic > .value {
  color: #6DFFFF;
}
.ui.inverted.blue.statistics .statistic > .value,
.ui.statistics .inverted.blue.statistic > .value,
.ui.inverted.blue.statistic > .value {
  color: #54C8FF;
}
.ui.inverted.violet.statistics .statistic > .value,
.ui.statistics .inverted.violet.statistic > .value,
.ui.inverted.violet.statistic > .value {
  color: #A291FB;
}
.ui.inverted.purple.statistics .statistic > .value,
.ui.statistics .inverted.purple.statistic > .value,
.ui.inverted.purple.statistic > .value {
  color: #DC73FF;
}
.ui.inverted.pink.statistics .statistic > .value,
.ui.statistics .inverted.pink.statistic > .value,
.ui.inverted.pink.statistic > .value {
  color: #FF8EDF;
}
.ui.inverted.brown.statistics .statistic > .value,
.ui.statistics .inverted.brown.statistic > .value,
.ui.inverted.brown.statistic > .value {
  color: #D67C1C;
}
.ui.inverted.grey.statistics .statistic > .value,
.ui.statistics .inverted.grey.statistic > .value,
.ui.inverted.grey.statistic > .value {
  color: #DCDDDE;
}
/*--------------
    Floated
---------------*/
.ui[class*="left floated"].statistic {
  float: left;
  margin: 0em 2em 1em 0em;
}
.ui[class*="right floated"].statistic {
  float: right;
  margin: 0em 0em 1em 2em;
}
.ui.floated.statistic:last-child {
  margin-bottom: 0em;
}
/*--------------
     Sizes
---------------*/
/* Mini */
.ui.mini.statistics .statistic > .value,
.ui.mini.statistic > .value {
  font-size: 1.5rem !important;
}
.ui.mini.horizontal.statistics .statistic > .value,
.ui.mini.horizontal.statistic > .value {
  font-size: 1.5rem !important;
}
.ui.mini.statistics .statistic > .text.value,
.ui.mini.statistic > .text.value {
  font-size: 1rem !important;
}
/* Tiny */
.ui.tiny.statistics .statistic > .value,
.ui.tiny.statistic > .value {
  font-size: 2rem !important;
}
.ui.tiny.horizontal.statistics .statistic > .value,
.ui.tiny.horizontal.statistic > .value {
  font-size: 2rem !important;
}
.ui.tiny.statistics .statistic > .text.value,
.ui.tiny.statistic > .text.value {
  font-size: 1rem !important;
}
/* Small */
.ui.small.statistics .statistic > .value,
.ui.small.statistic > .value {
  font-size: 3rem !important;
}
.ui.small.horizontal.statistics .statistic > .value,
.ui.small.horizontal.statistic > .value {
  font-size: 2rem !important;
}
.ui.small.statistics .statistic > .text.value,
.ui.small.statistic > .text.value {
  font-size: 1rem !important;
}
/* Medium */
.ui.statistics .statistic > .value,
.ui.statistic > .value {
  font-size: 4rem !important;
}
.ui.horizontal.statistics .statistic > .value,
.ui.horizontal.statistic > .value {
  font-size: 3rem !important;
}
.ui.statistics .statistic > .text.value,
.ui.statistic > .text.value {
  font-size: 2rem !important;
}
/* Large */
.ui.large.statistics .statistic > .value,
.ui.large.statistic > .value {
  font-size: 5rem !important;
}
.ui.large.horizontal.statistics .statistic > .value,
.ui.large.horizontal.statistic > .value {
  font-size: 4rem !important;
}
.ui.large.statistics .statistic > .text.value,
.ui.large.statistic > .text.value {
  font-size: 2.5rem !important;
}
/* Huge */
.ui.huge.statistics .statistic > .value,
.ui.huge.statistic > .value {
  font-size: 6rem !important;
}
.ui.huge.horizontal.statistics .statistic > .value,
.ui.huge.horizontal.statistic > .value {
  font-size: 5rem !important;
}
.ui.huge.statistics .statistic > .text.value,
.ui.huge.statistic > .text.value {
  font-size: 2.5rem !important;
}
/*******************************
         Theme Overrides
*******************************/
/* Modules */
/*!
 * # Semantic UI - Accordion
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
           Accordion
*******************************/
/* Title */
/* Icon */
/* Child Accordion */
/* Content */
/*-------------------
       Coupling
--------------------*/
/*-------------------
       States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Styled */
/* Content */
/* Child Content */
/* Styled Title */
/* Styled Title States */
/* Styled Child Title States */
/* Inverted */
/* Packaged Theme */
/*******************************
           Accordion
*******************************/
/* Title */
/* Icon */
/* Child Accordion */
/* Content */
/*-------------------
       Coupling
--------------------*/
/*-------------------
       States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Styled */
/* Content */
/* Child Content */
/* Styled Title */
/* Styled Title States */
/* Styled Child Title States */
/* Inverted */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Accordion
*******************************/
.ui.accordion,
.ui.accordion .accordion {
  max-width: 100%;
}
.ui.accordion .accordion {
  margin: 1em 0em 0em;
  padding: 0em;
}
/* Title */
.ui.accordion .title,
.ui.accordion .accordion .title {
  cursor: pointer;
}
/* Default Styling */
.ui.accordion .title:not(.ui) {
  padding: 0.5em 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1em;
  color: rgba(255, 255, 255, 0.87);
}
/* Content */
.ui.accordion .title ~ .content,
.ui.accordion .accordion .title ~ .content {
  display: none;
}
/* Default Styling */
.ui.accordion:not(.styled) .title ~ .content:not(.ui),
.ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {
  margin: '';
  padding: 0.5em 0em 1em;
}
.ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {
  padding-bottom: 0em;
}
/* Arrow */
.ui.accordion .title .dropdown.icon,
.ui.accordion .accordion .title .dropdown.icon {
  display: inline-block;
  float: none;
  opacity: 1;
  width: 1.25em;
  height: 1em;
  margin: 0em 0.25rem 0em 0rem;
  padding: 0em;
  font-size: 1em;
  transition: transform 0.1s ease, opacity 0.1s ease;
  vertical-align: baseline;
  transform: none;
}
/*--------------
    Coupling
---------------*/
/* Menu */
.ui.accordion.menu .item .title {
  display: block;
  padding: 0em;
}
.ui.accordion.menu .item .title > .dropdown.icon {
  float: right;
  margin: 0.21425em 0em 0em 1em;
  transform: rotate(180deg);
}
/* Header */
.ui.accordion .ui.header .dropdown.icon {
  font-size: 1em;
  margin: 0em 0.25rem 0em 0rem;
}
/*******************************
            States
*******************************/
.ui.accordion .active.title .dropdown.icon,
.ui.accordion .accordion .active.title .dropdown.icon {
  transform: rotate(90deg);
}
.ui.accordion.menu .item .active.title > .dropdown.icon {
  transform: rotate(90deg);
}
/*******************************
            Types
*******************************/
/*--------------
     Styled
---------------*/
.ui.styled.accordion {
  width: 600px;
}
.ui.styled.accordion,
.ui.styled.accordion .accordion {
  border-radius: 0.28571429rem;
  background: #FFFFFF;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15);
}
.ui.styled.accordion .title,
.ui.styled.accordion .accordion .title {
  margin: 0em;
  padding: 0.75em 1em;
  color: rgba(255, 255, 255, 0.4);
  font-weight: bold;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  transition: background 0.1s ease, color 0.1s ease;
}
.ui.styled.accordion > .title:first-child,
.ui.styled.accordion .accordion .title:first-child {
  border-top: none;
}
/* Content */
.ui.styled.accordion .content,
.ui.styled.accordion .accordion .content {
  margin: 0em;
  padding: 0.5em 1em 1.5em;
}
.ui.styled.accordion .accordion .content {
  padding: 0em;
  padding: 0.5em 1em 1.5em;
}
/* Hover */
.ui.styled.accordion .title:hover,
.ui.styled.accordion .active.title,
.ui.styled.accordion .accordion .title:hover,
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(255, 255, 255, 0.87);
}
.ui.styled.accordion .accordion .title:hover,
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(255, 255, 255, 0.87);
}
/* Active */
.ui.styled.accordion .active.title {
  background: transparent;
  color: rgba(255, 255, 255, 0.95);
}
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(255, 255, 255, 0.95);
}
/*******************************
            States
*******************************/
/*--------------
     Active
---------------*/
.ui.accordion .active.content,
.ui.accordion .accordion .active.content {
  display: block;
}
/*******************************
           Variations
*******************************/
/*--------------
     Fluid
---------------*/
.ui.fluid.accordion,
.ui.fluid.accordion .accordion {
  width: 100%;
}
/*--------------
     Inverted
---------------*/
.ui.inverted.accordion .title:not(.ui) {
  color: rgba(255, 255, 255, 0.9);
}
/*******************************
         Theme Overrides
*******************************/
@font-face {
  font-family: 'Accordion';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('woff');
  font-weight: normal;
  font-style: normal;
}
/* Dropdown Icon */
.ui.accordion .title .dropdown.icon,
.ui.accordion .accordion .title .dropdown.icon {
  font-family: Accordion;
  line-height: 1;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
.ui.accordion .title .dropdown.icon:before,
.ui.accordion .accordion .title .dropdown.icon:before {
  content: '\\f0da' /*rtl:'\\f0d9'*/;
}
/*!
 * # Semantic UI - Checkbox
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Checkbox
*******************************/
/* Label */
/* 26px @ 14/em */
/* Checkbox */
/* Checkmark */
/* Label */
/*-------------------
        States
--------------------*/
/* Hover */
/* Pressed */
/* Focus */
/* Active */
/* Active Focus */
/* Indeterminate */
/* Disabled */
/*-------------------
        Types
--------------------*/
/* Radio */
/* Uses px to avoid rounding issues with circles */
/* 7px as unitless value from radio size */
/* Slider & Toggle Handle */
/* Slider */
/* Slider States */
/* Toggle */
/*-------------------
      Variations
--------------------*/
/* Packaged Theme */
/*******************************
            Checkbox
*******************************/
/* Label */
/* 26px @ 14/em */
/* Checkbox */
/* Checkmark */
/* Label */
/*-------------------
        States
--------------------*/
/* Hover */
/* Pressed */
/* Focus */
/* Active */
/* Active Focus */
/* Indeterminate */
/* Disabled */
/*-------------------
        Types
--------------------*/
/* Radio */
/* Uses px to avoid rounding issues with circles */
/* 7px as unitless value from radio size */
/* Slider & Toggle Handle */
/* Slider */
/* Slider States */
/* Toggle */
/*-------------------
      Variations
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           Checkbox
*******************************/
/*--------------
    Content
---------------*/
.ui.checkbox {
  position: relative;
  display: inline-block;
  backface-visibility: hidden;
  outline: none;
  vertical-align: baseline;
  font-style: normal;
  min-height: 17px;
  font-size: 1rem;
  line-height: 17px;
  min-width: 17px;
}
/* HTML Checkbox */
.ui.checkbox input[type="checkbox"],
.ui.checkbox input[type="radio"] {
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: 0px;
  opacity: 0 !important;
  outline: none;
  z-index: 3;
  width: 17px;
  height: 17px;
}
/*--------------
      Box
---------------*/
.ui.checkbox .box,
.ui.checkbox label {
  cursor: auto;
  position: relative;
  display: block;
  padding-left: 1.85714em;
  outline: none;
  font-size: 1em;
}
.ui.checkbox .box:before,
.ui.checkbox label:before {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 17px;
  height: 17px;
  content: '';
  background: #1B1C1D;
  border-radius: 0.21428571rem;
  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;
  border: 1px solid #D4D4D5;
}
/*--------------
    Checkmark
---------------*/
.ui.checkbox .box:after,
.ui.checkbox label:after {
  position: absolute;
  font-size: 14px;
  top: 0px;
  left: 0px;
  width: 17px;
  height: 17px;
  text-align: center;
  opacity: 0;
  color: #d9d9e2;
  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;
}
/*--------------
      Label
---------------*/
/* Inside */
.ui.checkbox label,
.ui.checkbox + label {
  color: #d9d9e2;
  transition: color 0.1s ease;
}
/* Outside */
.ui.checkbox + label {
  vertical-align: middle;
}
/*******************************
           States
*******************************/
/*--------------
      Hover
---------------*/
.ui.checkbox .box:hover::before,
.ui.checkbox label:hover::before {
  background: #1B1C1D;
  border-color: rgba(255, 255, 255, 0.35);
}
.ui.checkbox label:hover,
.ui.checkbox + label:hover {
  color: rgba(255, 255, 255, 0.8);
}
/*--------------
      Down
---------------*/
.ui.checkbox .box:active::before,
.ui.checkbox label:active::before {
  background: #F9FAFB;
  border-color: rgba(255, 255, 255, 0.35);
}
.ui.checkbox .box:active::after,
.ui.checkbox label:active::after {
  color: rgba(255, 255, 255, 0.95);
}
.ui.checkbox input:active ~ label {
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Focus
---------------*/
.ui.checkbox input:focus ~ .box:before,
.ui.checkbox input:focus ~ label:before {
  background: #1B1C1D;
  border-color: #96C8DA;
}
.ui.checkbox input:focus ~ .box:after,
.ui.checkbox input:focus ~ label:after {
  color: rgba(255, 255, 255, 0.95);
}
.ui.checkbox input:focus ~ label {
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Active
---------------*/
.ui.checkbox input:checked ~ .box:before,
.ui.checkbox input:checked ~ label:before {
  background: #1B1C1D;
  border-color: rgba(255, 255, 255, 0.35);
}
.ui.checkbox input:checked ~ .box:after,
.ui.checkbox input:checked ~ label:after {
  opacity: 1;
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
  Indeterminate
---------------*/
.ui.checkbox input:not([type=radio]):indeterminate ~ .box:before,
.ui.checkbox input:not([type=radio]):indeterminate ~ label:before {
  background: #1B1C1D;
  border-color: rgba(255, 255, 255, 0.35);
}
.ui.checkbox input:not([type=radio]):indeterminate ~ .box:after,
.ui.checkbox input:not([type=radio]):indeterminate ~ label:after {
  opacity: 1;
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
  Active Focus
---------------*/
.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before,
.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before,
.ui.checkbox input:checked:focus ~ .box:before,
.ui.checkbox input:checked:focus ~ label:before {
  background: #1B1C1D;
  border-color: #96C8DA;
}
.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after,
.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after,
.ui.checkbox input:checked:focus ~ .box:after,
.ui.checkbox input:checked:focus ~ label:after {
  color: rgba(255, 255, 255, 0.95);
}
/*--------------
    Read-Only
---------------*/
.ui.read-only.checkbox,
.ui.read-only.checkbox label {
  cursor: default;
}
/*--------------
     Disabled
---------------*/
.ui.disabled.checkbox .box:after,
.ui.disabled.checkbox label,
.ui.checkbox input[disabled] ~ .box:after,
.ui.checkbox input[disabled] ~ label {
  cursor: default !important;
  opacity: 0.5;
  color: #000000;
}
/*--------------
     Hidden
---------------*/
/* Initialized checkbox moves input below element
 to prevent manually triggering */
.ui.checkbox input.hidden {
  z-index: -1;
}
/* Selectable Label */
.ui.checkbox input.hidden + label {
  cursor: pointer;
  user-select: none;
}
/*******************************
             Types
*******************************/
/*--------------
     Radio
---------------*/
.ui.radio.checkbox {
  min-height: 15px;
}
.ui.radio.checkbox .box,
.ui.radio.checkbox label {
  padding-left: 1.85714em;
}
/* Box */
.ui.radio.checkbox .box:before,
.ui.radio.checkbox label:before {
  content: '';
  transform: none;
  width: 15px;
  height: 15px;
  border-radius: 500rem;
  top: 1px;
  left: 0px;
}
/* Bullet */
.ui.radio.checkbox .box:after,
.ui.radio.checkbox label:after {
  border: none;
  content: '' !important;
  width: 15px;
  height: 15px;
  line-height: 15px;
}
/* Radio Checkbox */
.ui.radio.checkbox .box:after,
.ui.radio.checkbox label:after {
  top: 1px;
  left: 0px;
  width: 15px;
  height: 15px;
  border-radius: 500rem;
  transform: scale(0.46666667);
  background-color: rgba(255, 255, 255, 0.87);
}
/* Focus */
.ui.radio.checkbox input:focus ~ .box:before,
.ui.radio.checkbox input:focus ~ label:before {
  background-color: #1B1C1D;
}
.ui.radio.checkbox input:focus ~ .box:after,
.ui.radio.checkbox input:focus ~ label:after {
  background-color: rgba(255, 255, 255, 0.95);
}
/* Indeterminate */
.ui.radio.checkbox input:indeterminate ~ .box:after,
.ui.radio.checkbox input:indeterminate ~ label:after {
  opacity: 0;
}
/* Active */
.ui.radio.checkbox input:checked ~ .box:before,
.ui.radio.checkbox input:checked ~ label:before {
  background-color: #1B1C1D;
}
.ui.radio.checkbox input:checked ~ .box:after,
.ui.radio.checkbox input:checked ~ label:after {
  background-color: rgba(255, 255, 255, 0.95);
}
/* Active Focus */
.ui.radio.checkbox input:focus:checked ~ .box:before,
.ui.radio.checkbox input:focus:checked ~ label:before {
  background-color: #1B1C1D;
}
.ui.radio.checkbox input:focus:checked ~ .box:after,
.ui.radio.checkbox input:focus:checked ~ label:after {
  background-color: rgba(255, 255, 255, 0.95);
}
/*--------------
     Slider
---------------*/
.ui.slider.checkbox {
  min-height: 1.25rem;
}
/* Input */
.ui.slider.checkbox input {
  width: 3.5rem;
  height: 1.25rem;
}
/* Label */
.ui.slider.checkbox .box,
.ui.slider.checkbox label {
  padding-left: 4.5rem;
  line-height: 1rem;
  color: rgba(255, 255, 255, 0.4);
}
/* Line */
.ui.slider.checkbox .box:before,
.ui.slider.checkbox label:before {
  display: block;
  position: absolute;
  content: '';
  border: none !important;
  left: 0em;
  z-index: 1;
  top: 0.4rem;
  background-color: rgba(255, 255, 255, 0.08);
  width: 3.5rem;
  height: 0.21428571rem;
  transform: none;
  border-radius: 500rem;
  transition: background 0.3s ease;
}
/* Handle */
.ui.slider.checkbox .box:after,
.ui.slider.checkbox label:after {
  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  position: absolute;
  content: '' !important;
  opacity: 1;
  z-index: 2;
  border: none;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
  width: 1.5rem;
  height: 1.5rem;
  top: -0.25rem;
  left: 0em;
  transform: none;
  border-radius: 500rem;
  transition: left 0.3s ease;
}
/* Focus */
.ui.slider.checkbox input:focus ~ .box:before,
.ui.slider.checkbox input:focus ~ label:before {
  background-color: rgba(255, 255, 255, 0.15);
  border: none;
}
/* Hover */
.ui.slider.checkbox .box:hover,
.ui.slider.checkbox label:hover {
  color: rgba(255, 255, 255, 0.8);
}
.ui.slider.checkbox .box:hover::before,
.ui.slider.checkbox label:hover::before {
  background: rgba(255, 255, 255, 0.15);
}
/* Active */
.ui.slider.checkbox input:checked ~ .box,
.ui.slider.checkbox input:checked ~ label {
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.slider.checkbox input:checked ~ .box:before,
.ui.slider.checkbox input:checked ~ label:before {
  background-color: #545454 !important;
}
.ui.slider.checkbox input:checked ~ .box:after,
.ui.slider.checkbox input:checked ~ label:after {
  left: 2rem;
}
/* Active Focus */
.ui.slider.checkbox input:focus:checked ~ .box,
.ui.slider.checkbox input:focus:checked ~ label {
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.slider.checkbox input:focus:checked ~ .box:before,
.ui.slider.checkbox input:focus:checked ~ label:before {
  background-color: #000000 !important;
}
/*--------------
     Toggle
---------------*/
.ui.toggle.checkbox {
  min-height: 1.5rem;
}
/* Input */
.ui.toggle.checkbox input {
  width: 3.5rem;
  height: 1.5rem;
}
/* Label */
.ui.toggle.checkbox .box,
.ui.toggle.checkbox label {
  min-height: 1.5rem;
  padding-left: 4.5rem;
  color: #d9d9e2;
}
.ui.toggle.checkbox label {
  padding-top: 0.15em;
}
/* Switch */
.ui.toggle.checkbox .box:before,
.ui.toggle.checkbox label:before {
  display: block;
  position: absolute;
  content: '';
  z-index: 1;
  transform: none;
  border: none;
  top: 0rem;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: none;
  width: 3.5rem;
  height: 1.5rem;
  border-radius: 500rem;
}
/* Handle */
.ui.toggle.checkbox .box:after,
.ui.toggle.checkbox label:after {
  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  position: absolute;
  content: '' !important;
  opacity: 1;
  z-index: 2;
  border: none;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
  width: 1.5rem;
  height: 1.5rem;
  top: 0rem;
  left: 0em;
  border-radius: 500rem;
  transition: background 0.3s ease, left 0.3s ease;
}
.ui.toggle.checkbox input ~ .box:after,
.ui.toggle.checkbox input ~ label:after {
  left: -0.05rem;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
}
/* Focus */
.ui.toggle.checkbox input:focus ~ .box:before,
.ui.toggle.checkbox input:focus ~ label:before {
  background-color: rgba(255, 255, 255, 0.15);
  border: none;
}
/* Hover */
.ui.toggle.checkbox .box:hover::before,
.ui.toggle.checkbox label:hover::before {
  background-color: rgba(255, 255, 255, 0.15);
  border: none;
}
/* Active */
.ui.toggle.checkbox input:checked ~ .box,
.ui.toggle.checkbox input:checked ~ label {
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.toggle.checkbox input:checked ~ .box:before,
.ui.toggle.checkbox input:checked ~ label:before {
  background-color: #2185D0 !important;
}
.ui.toggle.checkbox input:checked ~ .box:after,
.ui.toggle.checkbox input:checked ~ label:after {
  left: 2.15rem;
  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
}
/* Active Focus */
.ui.toggle.checkbox input:focus:checked ~ .box,
.ui.toggle.checkbox input:focus:checked ~ label {
  color: rgba(255, 255, 255, 0.95) !important;
}
.ui.toggle.checkbox input:focus:checked ~ .box:before,
.ui.toggle.checkbox input:focus:checked ~ label:before {
  background-color: #0d71bb !important;
}
/*******************************
            Variations
*******************************/
/*--------------
     Fitted
---------------*/
.ui.fitted.checkbox .box,
.ui.fitted.checkbox label {
  padding-left: 0em !important;
}
.ui.fitted.toggle.checkbox,
.ui.fitted.toggle.checkbox {
  width: 3.5rem;
}
.ui.fitted.slider.checkbox,
.ui.fitted.slider.checkbox {
  width: 3.5rem;
}
/*******************************
         Theme Overrides
*******************************/
@font-face {
  font-family: 'Checkbox';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('truetype');
}
/* Checkmark */
.ui.checkbox label:after,
.ui.checkbox .box:after {
  font-family: 'Checkbox';
}
/* Checked */
.ui.checkbox input:checked ~ .box:after,
.ui.checkbox input:checked ~ label:after {
  content: '\\e800';
}
/* Indeterminate */
.ui.checkbox input:indeterminate ~ .box:after,
.ui.checkbox input:indeterminate ~ label:after {
  font-size: 12px;
  content: '\\e801';
}
/*  UTF Reference
.check:before { content: '\\e800'; }
.dash:before  { content: '\\e801'; }
.plus:before { content: '\\e802'; }
*/
/*!
 * # Semantic UI - Dimmer
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Dimmer
*******************************/
/* Hidden (Default) */
/* Visible */
/*-------------------
        Types
--------------------*/
/* Page Dimmer*/
/*-------------------
      Variations
--------------------*/
/* Inverted */
/* Simple */
/* Packaged Theme */
/*******************************
            Dimmer
*******************************/
/* Hidden (Default) */
/* Visible */
/*-------------------
        Types
--------------------*/
/* Page Dimmer*/
/*-------------------
      Variations
--------------------*/
/* Inverted */
/* Simple */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Dimmer
*******************************/
.dimmable:not(body) {
  position: relative;
}
.ui.dimmer {
  display: none;
  position: absolute;
  top: 0em !important;
  left: 0em !important;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.85);
  opacity: 0;
  line-height: 1;
  animation-fill-mode: both;
  animation-duration: 0.5s;
  transition: background-color 0.5s linear;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  will-change: opacity;
  z-index: 1000;
}
/* Dimmer Content */
.ui.dimmer > .content {
  user-select: text;
  color: #FFFFFF;
}
/* Loose Coupling */
.ui.segment > .ui.dimmer {
  border-radius: inherit !important;
}
/* Scrollbars */
.ui.dimmer:not(.inverted)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.15);
}
.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
/*******************************
            States
*******************************/
/* Animating */
.animating.dimmable:not(body),
.dimmed.dimmable:not(body) {
  overflow: hidden;
}
/* Animating / Active / Visible */
.dimmed.dimmable > .ui.animating.dimmer,
.dimmed.dimmable > .ui.visible.dimmer,
.ui.active.dimmer {
  display: flex;
  opacity: 1;
}
/* Disabled */
.ui.disabled.dimmer {
  width: 0 !important;
  height: 0 !important;
}
/*******************************
           Variations
*******************************/
/*--------------
    Legacy
---------------*/
/* Animating / Active / Visible */
.dimmed.dimmable > .ui.animating.legacy.dimmer,
.dimmed.dimmable > .ui.visible.legacy.dimmer,
.ui.active.legacy.dimmer {
  display: block;
}
/*--------------
    Alignment
---------------*/
.ui[class*="top aligned"].dimmer {
  justify-content: flex-start;
}
.ui[class*="bottom aligned"].dimmer {
  justify-content: flex-end;
}
/*--------------
      Page
---------------*/
.ui.page.dimmer {
  position: fixed;
  transform-style: '';
  perspective: 2000px;
  transform-origin: center center;
}
body.animating.in.dimmable,
body.dimmed.dimmable {
  overflow: hidden;
}
body.dimmable > .dimmer {
  position: fixed;
}
/*--------------
    Blurring
---------------*/
.blurring.dimmable > :not(.dimmer) {
  filter: blur(0px) grayscale(0);
  transition: 800ms filter ease;
}
.blurring.dimmed.dimmable > :not(.dimmer) {
  filter: blur(5px) grayscale(0.7);
}
/* Dimmer Color */
.blurring.dimmable > .dimmer {
  background-color: rgba(0, 0, 0, 0.6);
}
.blurring.dimmable > .inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.6);
}
/*--------------
    Aligned
---------------*/
.ui.dimmer > .top.aligned.content > * {
  vertical-align: top;
}
.ui.dimmer > .bottom.aligned.content > * {
  vertical-align: bottom;
}
/*--------------
    Inverted
---------------*/
.ui.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.85);
}
.ui.inverted.dimmer > .content > * {
  color: #FFFFFF;
}
/*--------------
     Simple
---------------*/
/* Displays without javascript */
.ui.simple.dimmer {
  display: block;
  overflow: hidden;
  opacity: 1;
  width: 0%;
  height: 0%;
  z-index: -100;
  background-color: rgba(0, 0, 0, 0);
}
.dimmed.dimmable > .ui.simple.dimmer {
  overflow: visible;
  opacity: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 1;
}
.ui.simple.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0);
}
.dimmed.dimmable > .ui.simple.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.85);
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Dropdown
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Dropdown
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Content
--------------------*/
/* Icon */
/* Current Text */
/* Menu */
/* Text */
/* Menu Item */
/* Sub Menu */
/* Menu Header */
/* Menu Divider */
/* Menu Input */
/* Menu Image */
/* Item Sub-Element */
/* Sub-Menu Dropdown Icon */
/* Description */
/* Message */
/* Floated Content */
/*-------------------
        Types
--------------------*/
/*------------
   Selection
--------------*/
/* <select> */
/* Responsive */
/* Derived */
/* 1px / em size */
/* Hover */
/* Focus */
/* Visible */
/* Visible Hover */
/*--------------
     Search
--------------*/
/* Search Selection */
/* Inline */
/*--------------
    Multiple
--------------*/
/* Split Actual Padding Between Child and Parent (allows for label spacing) */
/* Child Elements */
/* Dropdown Icon */
/* Selection Label */
/*-------------------
       States
--------------------*/
/* Hovered */
/* Default Text */
/* Loading */
/* Active Menu Item */
/* Selected */
/* Error */
/* Clearable */
/*-------------------
      Variations
--------------------*/
/* Scrolling */
/* 0px / em size */
/* Upward */
/* Flyout Direction */
/* Left */
/* Simple */
/* Floating */
/* Pointing */
/* Pointing Upward */
/* Packaged Theme */
/*******************************
            Dropdown
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Content
--------------------*/
/* Icon */
/* Current Text */
/* Menu */
/* Text */
/* Menu Item */
/* Sub Menu */
/* Menu Header */
/* Menu Divider */
/* Menu Input */
/* Menu Image */
/* Item Sub-Element */
/* Sub-Menu Dropdown Icon */
/* Description */
/* Message */
/* Floated Content */
/*-------------------
        Types
--------------------*/
/*------------
   Selection
--------------*/
/* <select> */
/* Responsive */
/* Derived */
/* 1px / em size */
/* Hover */
/* Focus */
/* Visible */
/* Visible Hover */
/*--------------
     Search
--------------*/
/* Search Selection */
/* Inline */
/*--------------
    Multiple
--------------*/
/* Split Actual Padding Between Child and Parent (allows for label spacing) */
/* Child Elements */
/* Dropdown Icon */
/* Selection Label */
/*-------------------
       States
--------------------*/
/* Hovered */
/* Default Text */
/* Loading */
/* Active Menu Item */
/* Selected */
/* Error */
/* Clearable */
/*-------------------
      Variations
--------------------*/
/* Scrolling */
/* 0px / em size */
/* Upward */
/* Flyout Direction */
/* Left */
/* Simple */
/* Floating */
/* Pointing */
/* Pointing Upward */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Dropdown
*******************************/
.ui.dropdown {
  cursor: pointer;
  position: relative;
  display: inline-block;
  outline: none;
  text-align: left;
  transition: box-shadow 0.1s ease, width 0.1s ease;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
/*******************************
            Content
*******************************/
/*--------------
      Menu
---------------*/
.ui.dropdown .menu {
  cursor: auto;
  position: absolute;
  display: none;
  outline: none;
  top: 100%;
  min-width: max-content;
  margin: 0em;
  padding: 0em 0em;
  background: #1d1e31;
  font-size: 1em;
  text-shadow: none;
  text-align: left;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
  transition: opacity 0.1s ease;
  z-index: 11;
  will-change: transform, opacity;
}
.ui.dropdown .menu > * {
  white-space: nowrap;
}
/*--------------
  Hidden Input
---------------*/
.ui.dropdown > input:not(.search):first-child,
.ui.dropdown > select {
  display: none !important;
}
/*--------------
 Dropdown Icon
---------------*/
.ui.dropdown > .dropdown.icon {
  position: relative;
  width: auto;
  font-size: 0.85714286em;
  margin: 0em 0em 0em 1em;
}
.ui.dropdown .menu > .item .dropdown.icon {
  width: auto;
  float: right;
  margin: 0em 0em 0em 1em;
}
.ui.dropdown .menu > .item .dropdown.icon + .text {
  margin-right: 1em;
}
/*--------------
      Text
---------------*/
.ui.dropdown > .text {
  display: inline-block;
  transition: none;
}
/*--------------
    Menu Item
---------------*/
.ui.dropdown .menu > .item {
  position: relative;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  color: rgba(255, 255, 255, 0.87);
  padding: 0.78571429rem 1.14285714rem !important;
  font-size: 1rem;
  text-transform: none;
  font-weight: normal;
  box-shadow: none;
  -webkit-touch-callout: none;
}
.ui.dropdown .menu > .item:first-child {
  border-top-width: 0px;
}
/*--------------
  Floated Content
---------------*/
.ui.dropdown > .text > [class*="right floated"],
.ui.dropdown .menu .item > [class*="right floated"] {
  float: right !important;
  margin-right: 0em !important;
  margin-left: 1em !important;
}
.ui.dropdown > .text > [class*="left floated"],
.ui.dropdown .menu .item > [class*="left floated"] {
  float: left !important;
  margin-left: 0em !important;
  margin-right: 1em !important;
}
.ui.dropdown .menu .item > .icon.floated,
.ui.dropdown .menu .item > .flag.floated,
.ui.dropdown .menu .item > .image.floated,
.ui.dropdown .menu .item > img.floated {
  margin-top: 0em;
}
/*--------------
  Menu Divider
---------------*/
.ui.dropdown .menu > .header {
  margin: 1rem 0rem 0.75rem;
  padding: 0em 1.14285714rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.78571429em;
  font-weight: bold;
  text-transform: uppercase;
}
.ui.dropdown .menu > .divider {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  height: 0em;
  margin: 0.5em 0em;
}
.ui.dropdown.dropdown .menu > .input {
  width: auto;
  display: flex;
  margin: 1.14285714rem 0.78571429rem;
  min-width: 10rem;
}
.ui.dropdown .menu > .header + .input {
  margin-top: 0em;
}
.ui.dropdown .menu > .input:not(.transparent) input {
  padding: 0.5em 1em;
}
.ui.dropdown .menu > .input:not(.transparent) .button,
.ui.dropdown .menu > .input:not(.transparent) .icon,
.ui.dropdown .menu > .input:not(.transparent) .label {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
/*-----------------
  Item Description
-------------------*/
.ui.dropdown > .text > .description,
.ui.dropdown .menu > .item > .description {
  float: right;
  margin: 0em 0em 0em 1em;
  color: rgba(255, 255, 255, 0.4);
}
/*-----------------
       Message
-------------------*/
.ui.dropdown .menu > .message {
  padding: 0.78571429rem 1.14285714rem;
  font-weight: normal;
}
.ui.dropdown .menu > .message:not(.ui) {
  color: rgba(255, 255, 255, 0.4);
}
/*--------------
    Sub Menu
---------------*/
.ui.dropdown .menu .menu {
  top: 0% !important;
  left: 100%;
  right: auto;
  margin: 0em 0em 0em -0.5em !important;
  border-radius: 0.28571429rem !important;
  z-index: 21 !important;
}
/* Hide Arrow */
.ui.dropdown .menu .menu:after {
  display: none;
}
/*--------------
   Sub Elements
---------------*/
/* Icons / Flags / Labels / Image */
.ui.dropdown > .text > .icon,
.ui.dropdown > .text > .label,
.ui.dropdown > .text > .flag,
.ui.dropdown > .text > img,
.ui.dropdown > .text > .image {
  margin-top: 0em;
}
.ui.dropdown .menu > .item > .icon,
.ui.dropdown .menu > .item > .label,
.ui.dropdown .menu > .item > .flag,
.ui.dropdown .menu > .item > .image,
.ui.dropdown .menu > .item > img {
  margin-top: 0em;
}
.ui.dropdown > .text > .icon,
.ui.dropdown > .text > .label,
.ui.dropdown > .text > .flag,
.ui.dropdown > .text > img,
.ui.dropdown > .text > .image,
.ui.dropdown .menu > .item > .icon,
.ui.dropdown .menu > .item > .label,
.ui.dropdown .menu > .item > .flag,
.ui.dropdown .menu > .item > .image,
.ui.dropdown .menu > .item > img {
  margin-left: 0em;
  float: none;
  margin-right: 0.78571429rem;
}
/*--------------
     Image
---------------*/
.ui.dropdown > .text > img,
.ui.dropdown > .text > .image,
.ui.dropdown .menu > .item > .image,
.ui.dropdown .menu > .item > img {
  display: inline-block;
  vertical-align: top;
  width: auto;
  margin-top: -0.5em;
  margin-bottom: -0.5em;
  max-height: 2em;
}
/*******************************
            Coupling
*******************************/
/*--------------
      Menu
---------------*/
/* Remove Menu Item Divider */
.ui.dropdown .ui.menu > .item:before,
.ui.menu .ui.dropdown .menu > .item:before {
  display: none;
}
/* Prevent Menu Item Border */
.ui.menu .ui.dropdown .menu .active.item {
  border-left: none;
}
/* Automatically float dropdown menu right on last menu item */
.ui.menu .right.menu .dropdown:last-child > .menu,
.ui.menu .right.dropdown.item > .menu,
.ui.buttons > .ui.dropdown:last-child > .menu {
  left: auto;
  right: 0em;
}
/*--------------
      Label
---------------*/
/* Dropdown Menu */
.ui.label.dropdown .menu {
  min-width: 100%;
}
/*--------------
     Button
---------------*/
/* No Margin On Icon Button */
.ui.dropdown.icon.button > .dropdown.icon {
  margin: 0em;
}
.ui.button.dropdown .menu {
  min-width: 100%;
}
/*******************************
              Types
*******************************/
/*--------------
    Selection
---------------*/
/* Displays like a select box */
.ui.selection.dropdown {
  cursor: pointer;
  word-wrap: break-word;
  line-height: 1em;
  white-space: normal;
  outline: 0;
  transform: rotateZ(0deg);
  min-width: 14em;
  min-height: 2.71428571em;
  background: rgba(255, 255, 255, 0.06);
  display: inline-block;
  padding: 0.78571429em 2.1em 0.78571429em 1em;
  color: #ffffff;
  box-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.28571429rem;
  transition: box-shadow 0.1s ease, width 0.1s ease;
}
.ui.selection.dropdown.visible,
.ui.selection.dropdown.active {
  z-index: 10;
}
select.ui.dropdown {
  height: 38px;
  padding: 0.5em;
  border: 1px solid rgba(255, 255, 255, 0.15);
  visibility: visible;
}
.ui.selection.dropdown > .search.icon,
.ui.selection.dropdown > .delete.icon,
.ui.selection.dropdown > .dropdown.icon {
  cursor: pointer;
  position: absolute;
  width: auto;
  height: auto;
  line-height: 1.21428571em;
  top: 0.78571429em;
  right: 1em;
  z-index: 3;
  margin: -0.78571429em;
  padding: 0.91666667em;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
/* Compact */
.ui.compact.selection.dropdown {
  min-width: 0px;
}
/*  Selection Menu */
.ui.selection.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
  border-top-width: 0px !important;
  width: auto;
  outline: none;
  margin: 0px -1px;
  min-width: calc(100% +  2px );
  width: calc(100% +  2px );
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
  transition: opacity 0.1s ease;
}
.ui.selection.dropdown .menu:after,
.ui.selection.dropdown .menu:before {
  display: none;
}
/*--------------
    Message
---------------*/
.ui.selection.dropdown .menu > .message {
  padding: 0.78571429rem 1.14285714rem;
}
@media only screen and (max-width: 767px) {
  .ui.selection.dropdown .menu {
    max-height: 8.01428571rem;
  }
}
@media only screen and (min-width: 768px) {
  .ui.selection.dropdown .menu {
    max-height: 10.68571429rem;
  }
}
@media only screen and (min-width: 992px) {
  .ui.selection.dropdown .menu {
    max-height: 16.02857143rem;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.selection.dropdown .menu {
    max-height: 21.37142857rem;
  }
}
/* Menu Item */
.ui.selection.dropdown .menu > .item {
  border-top: 1px solid #FAFAFA;
  padding: 0.78571429rem 1.14285714rem !important;
  white-space: normal;
  word-wrap: normal;
}
/* User Item */
.ui.selection.dropdown .menu > .hidden.addition.item {
  display: none;
}
/* Hover */
.ui.selection.dropdown:hover {
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow: none;
}
/* Active */
.ui.selection.active.dropdown {
  border-color: #96C8DA;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
}
.ui.selection.active.dropdown .menu {
  border-color: #96C8DA;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
}
/* Focus */
.ui.selection.dropdown:focus {
  border-color: #96C8DA;
  box-shadow: none;
}
.ui.selection.dropdown:focus .menu {
  border-color: #96C8DA;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
}
/* Visible */
.ui.selection.visible.dropdown > .text:not(.default) {
  font-weight: normal;
  color: rgba(255, 255, 255, 0.8);
}
/* Visible Hover */
.ui.selection.active.dropdown:hover {
  border-color: #96C8DA;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
}
.ui.selection.active.dropdown:hover .menu {
  border-color: #96C8DA;
  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);
}
/* Dropdown Icon */
.ui.active.selection.dropdown > .dropdown.icon,
.ui.visible.selection.dropdown > .dropdown.icon {
  opacity: '';
  z-index: 3;
}
/* Connecting Border */
.ui.active.selection.dropdown {
  border-bottom-left-radius: 0em !important;
  border-bottom-right-radius: 0em !important;
}
/* Empty Connecting Border */
.ui.active.empty.selection.dropdown {
  border-radius: 0.28571429rem !important;
  box-shadow: none !important;
}
.ui.active.empty.selection.dropdown .menu {
  border: none !important;
  box-shadow: none !important;
}
/*--------------
   Searchable
---------------*/
/* Search Selection */
.ui.search.dropdown {
  min-width: '';
}
/* Search Dropdown */
.ui.search.dropdown > input.search {
  background: none transparent !important;
  border: none !important;
  box-shadow: none !important;
  cursor: text;
  top: 0em;
  left: 1px;
  width: 100%;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  padding: inherit;
}
/* Text Layering */
.ui.search.dropdown > input.search {
  position: absolute;
  z-index: 2;
}
.ui.search.dropdown > .text {
  cursor: text;
  position: relative;
  left: 1px;
  z-index: 3;
}
/* Search Selection */
.ui.search.selection.dropdown > input.search {
  line-height: 1.21428571em;
  padding: 0.67857143em 2.1em 0.67857143em 1em;
}
/* Used to size multi select input to character width */
.ui.search.selection.dropdown > span.sizer {
  line-height: 1.21428571em;
  padding: 0.67857143em 2.1em 0.67857143em 1em;
  display: none;
  white-space: pre;
}
/* Active/Visible Search */
.ui.search.dropdown.active > input.search,
.ui.search.dropdown.visible > input.search {
  cursor: auto;
}
.ui.search.dropdown.active > .text,
.ui.search.dropdown.visible > .text {
  pointer-events: none;
}
/* Filtered Text */
.ui.active.search.dropdown input.search:focus + .text .icon,
.ui.active.search.dropdown input.search:focus + .text .flag {
  opacity: 0.45;
}
.ui.active.search.dropdown input.search:focus + .text {
  color: #8c8c8c !important;
}
/* Search Menu */
.ui.search.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
}
@media only screen and (max-width: 767px) {
  .ui.search.dropdown .menu {
    max-height: 8.01428571rem;
  }
}
@media only screen and (min-width: 768px) {
  .ui.search.dropdown .menu {
    max-height: 10.68571429rem;
  }
}
@media only screen and (min-width: 992px) {
  .ui.search.dropdown .menu {
    max-height: 16.02857143rem;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.search.dropdown .menu {
    max-height: 21.37142857rem;
  }
}
/*--------------
    Multiple
---------------*/
/* Multiple Selection */
.ui.multiple.dropdown {
  padding: 0.22619048em 2.1em 0.22619048em 0.35714286em;
}
.ui.multiple.dropdown .menu {
  cursor: auto;
}
/* Multiple Search Selection */
.ui.multiple.search.dropdown,
.ui.multiple.search.dropdown > input.search {
  cursor: text;
}
/* Selection Label */
.ui.multiple.dropdown > .label {
  user-select: none;
  display: inline-block;
  vertical-align: top;
  white-space: normal;
  font-size: 1em;
  padding: 0.35714286em 0.78571429em;
  margin: 0.14285714rem 0.28571429rem 0.14285714rem 0em;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;
}
/* Dropdown Icon */
.ui.multiple.dropdown .dropdown.icon {
  margin: '';
  padding: '';
}
/* Text */
.ui.multiple.dropdown > .text {
  position: static;
  padding: 0;
  max-width: 100%;
  margin: 0.45238095em 0em 0.45238095em 0.64285714em;
  line-height: 1.21428571em;
}
.ui.multiple.dropdown > .label ~ input.search {
  margin-left: 0.14285714em !important;
}
.ui.multiple.dropdown > .label ~ .text {
  display: none;
}
/*-----------------
  Multiple Search
-----------------*/
/* Prompt Text */
.ui.multiple.search.dropdown > .text {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  padding: inherit;
  margin: 0.45238095em 0em 0.45238095em 0.64285714em;
  line-height: 1.21428571em;
}
.ui.multiple.search.dropdown > .label ~ .text {
  display: none;
}
/* Search */
.ui.multiple.search.dropdown > input.search {
  position: static;
  padding: 0;
  max-width: 100%;
  margin: 0.45238095em 0em 0.45238095em 0.64285714em;
  width: 2.2em;
  line-height: 1.21428571em;
}
/*--------------
     Inline
---------------*/
.ui.inline.dropdown {
  cursor: pointer;
  display: inline-block;
  color: inherit;
}
.ui.inline.dropdown .dropdown.icon {
  margin: 0em 0.21428571em 0em 0.21428571em;
  vertical-align: baseline;
}
.ui.inline.dropdown > .text {
  font-weight: bold;
}
.ui.inline.dropdown .menu {
  cursor: auto;
  margin-top: 0.21428571em;
  border-radius: 0.28571429rem;
}
/*******************************
            States
*******************************/
/*--------------------
        Active
----------------------*/
/* Menu Item Active */
.ui.dropdown .menu .active.item {
  background: transparent;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.95);
  box-shadow: none;
  z-index: 12;
}
/*--------------------
        Hover
----------------------*/
/* Menu Item Hover */
.ui.dropdown .menu > .item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(255, 255, 255, 0.95);
  z-index: 13;
}
/*--------------------
       Loading
---------------------*/
.ui.loading.dropdown > i.icon {
  height: 1em !important;
}
.ui.loading.selection.dropdown > i.icon {
  padding: 1.5em 1.28571429em !important;
}
.ui.loading.dropdown > i.icon:before {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.ui.loading.dropdown > i.icon:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  box-shadow: 0px 0px 0px 1px transparent;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  animation: dropdown-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 transparent transparent;
  border-style: solid;
  border-width: 0.2em;
}
/* Coupling */
.ui.loading.dropdown.button > i.icon:before,
.ui.loading.dropdown.button > i.icon:after {
  display: none;
}
@keyframes dropdown-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*--------------------
     Default Text
----------------------*/
.ui.dropdown:not(.button) > .default.text,
.ui.default.dropdown:not(.button) > .text {
  color: #404040;
}
.ui.dropdown:not(.button) > input:focus ~ .default.text,
.ui.default.dropdown:not(.button) > input:focus ~ .text {
  color: #8c8c8c;
}
/*--------------------
        Loading
----------------------*/
.ui.loading.dropdown > .text {
  transition: none;
}
/* Used To Check Position */
.ui.dropdown .loading.menu {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.ui.dropdown > .loading.menu {
  left: 0px !important;
  right: auto !important;
}
.ui.dropdown > .menu .loading.menu {
  left: 100% !important;
  right: auto !important;
}
/*--------------------
    Keyboard Select
----------------------*/
/* Selected Item */
.ui.dropdown.selected,
.ui.dropdown .menu .selected.item {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(255, 255, 255, 0.95);
}
/*--------------------
    Search Filtered
----------------------*/
/* Filtered Item */
.ui.dropdown > .filtered.text {
  visibility: hidden;
}
.ui.dropdown .filtered.item {
  display: none !important;
}
/*--------------------
        Error
----------------------*/
.ui.dropdown.error,
.ui.dropdown.error > .text,
.ui.dropdown.error > .default.text {
  color: #FFFFFF;
}
.ui.selection.dropdown.error {
  background: rgba(200, 3, 3, 0.15);
  border-color: #E0B4B4;
}
.ui.selection.dropdown.error:hover {
  border-color: #E0B4B4;
}
.ui.dropdown.error > .menu,
.ui.dropdown.error > .menu .menu {
  border-color: #E0B4B4;
}
.ui.dropdown.error > .menu > .item {
  color: #FFFFFF;
}
.ui.multiple.selection.error.dropdown > .label {
  border-color: #E0B4B4;
}
/* Item Hover */
.ui.dropdown.error > .menu > .item:hover {
  background-color: #FFF2F2;
}
/* Item Active */
.ui.dropdown.error > .menu .active.item {
  background-color: #FDCFCF;
}
/*--------------------
        Clear
----------------------*/
.ui.dropdown > .clear.dropdown.icon {
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.ui.dropdown > .clear.dropdown.icon:hover {
  opacity: 1;
}
/*--------------------
        Disabled
----------------------*/
/* Disabled */
.ui.disabled.dropdown,
.ui.dropdown .menu > .disabled.item {
  cursor: default;
  pointer-events: none;
  opacity: 0.45;
}
/*******************************
           Variations
*******************************/
/*--------------
    Direction
---------------*/
/* Flyout Direction */
.ui.dropdown .menu {
  left: 0px;
}
/* Default Side (Right) */
.ui.dropdown .right.menu > .menu,
.ui.dropdown .menu .right.menu {
  left: 100% !important;
  right: auto !important;
  border-radius: 0.28571429rem !important;
}
/* Leftward Opening Menu */
.ui.dropdown > .left.menu {
  left: auto !important;
  right: 0px !important;
}
.ui.dropdown > .left.menu .menu,
.ui.dropdown .menu .left.menu {
  left: auto;
  right: 100%;
  margin: 0em -0.5em 0em 0em !important;
  border-radius: 0.28571429rem !important;
}
.ui.dropdown .item .left.dropdown.icon,
.ui.dropdown .left.menu .item .dropdown.icon {
  width: auto;
  float: left;
  margin: 0em 0em 0em 0em;
}
.ui.dropdown .item .left.dropdown.icon,
.ui.dropdown .left.menu .item .dropdown.icon {
  width: auto;
  float: left;
  margin: 0em 0em 0em 0em;
}
.ui.dropdown .item .left.dropdown.icon + .text,
.ui.dropdown .left.menu .item .dropdown.icon + .text {
  margin-left: 1em;
  margin-right: 0em;
}
/*--------------
     Upward
---------------*/
/* Upward Main Menu */
.ui.upward.dropdown > .menu {
  top: auto;
  bottom: 100%;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
/* Upward Sub Menu */
.ui.dropdown .upward.menu {
  top: auto !important;
  bottom: 0 !important;
}
/* Active Upward */
.ui.simple.upward.active.dropdown,
.ui.simple.upward.dropdown:hover {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em !important;
}
.ui.upward.dropdown.button:not(.pointing):not(.floating).active {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
/* Selection */
.ui.upward.selection.dropdown .menu {
  border-top-width: 1px !important;
  border-bottom-width: 0px !important;
  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);
}
.ui.upward.selection.dropdown:hover {
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.05);
}
/* Active Upward */
.ui.active.upward.selection.dropdown {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;
}
/* Visible Upward */
.ui.upward.selection.dropdown.visible {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;
}
/* Visible Hover Upward */
.ui.upward.active.selection.dropdown:hover {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.05);
}
.ui.upward.active.selection.dropdown:hover .menu {
  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);
}
/*--------------
     Simple
---------------*/
/*  Selection Menu */
.ui.scrolling.dropdown .menu,
.ui.dropdown .scrolling.menu {
  overflow-x: hidden;
  overflow-y: auto;
}
.ui.scrolling.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
  min-width: 100% !important;
  width: auto !important;
}
.ui.dropdown .scrolling.menu {
  position: static;
  overflow-y: auto;
  border: none;
  box-shadow: none !important;
  border-radius: 0 !important;
  margin: 0 !important;
  min-width: 100% !important;
  width: auto !important;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.scrolling.dropdown .menu .item.item.item,
.ui.dropdown .scrolling.menu > .item.item.item {
  border-top: none;
}
.ui.scrolling.dropdown .menu .item:first-child,
.ui.dropdown .scrolling.menu .item:first-child {
  border-top: none;
}
.ui.dropdown > .animating.menu .scrolling.menu,
.ui.dropdown > .visible.menu .scrolling.menu {
  display: block;
}
/* Scrollbar in IE */
@media all and (-ms-high-contrast: none) {
  .ui.scrolling.dropdown .menu,
  .ui.dropdown .scrolling.menu {
    min-width: calc(100% - 17px);
  }
}
@media only screen and (max-width: 767px) {
  .ui.scrolling.dropdown .menu,
  .ui.dropdown .scrolling.menu {
    max-height: 10.28571429rem;
  }
}
@media only screen and (min-width: 768px) {
  .ui.scrolling.dropdown .menu,
  .ui.dropdown .scrolling.menu {
    max-height: 15.42857143rem;
  }
}
@media only screen and (min-width: 992px) {
  .ui.scrolling.dropdown .menu,
  .ui.dropdown .scrolling.menu {
    max-height: 20.57142857rem;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.scrolling.dropdown .menu,
  .ui.dropdown .scrolling.menu {
    max-height: 20.57142857rem;
  }
}
/*--------------
     Simple
---------------*/
/* Displays without javascript */
.ui.simple.dropdown .menu:before,
.ui.simple.dropdown .menu:after {
  display: none;
}
.ui.simple.dropdown .menu {
  position: absolute;
  display: block;
  overflow: hidden;
  top: -9999px !important;
  opacity: 0;
  width: 0;
  height: 0;
  transition: opacity 0.1s ease;
}
.ui.simple.active.dropdown,
.ui.simple.dropdown:hover {
  border-bottom-left-radius: 0em !important;
  border-bottom-right-radius: 0em !important;
}
.ui.simple.active.dropdown > .menu,
.ui.simple.dropdown:hover > .menu {
  overflow: visible;
  width: auto;
  height: auto;
  top: 100% !important;
  opacity: 1;
}
.ui.simple.dropdown > .menu > .item:active > .menu,
.ui.simple.dropdown:hover > .menu > .item:hover > .menu {
  overflow: visible;
  width: auto;
  height: auto;
  top: 0% !important;
  left: 100% !important;
  opacity: 1;
}
.ui.simple.disabled.dropdown:hover .menu {
  display: none;
  height: 0px;
  width: 0px;
  overflow: hidden;
}
/* Visible */
.ui.simple.visible.dropdown > .menu {
  display: block;
}
/*--------------
      Fluid
---------------*/
.ui.fluid.dropdown {
  display: block;
  width: 100%;
  min-width: 0em;
}
.ui.fluid.dropdown > .dropdown.icon {
  float: right;
}
/*--------------
    Floating
---------------*/
.ui.floating.dropdown .menu {
  left: 0;
  right: auto;
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15) !important;
  border-radius: 0.28571429rem !important;
}
.ui.floating.dropdown > .menu {
  margin-top: 0.5em !important;
  border-radius: 0.28571429rem !important;
}
/*--------------
     Pointing
---------------*/
.ui.pointing.dropdown > .menu {
  top: 100%;
  margin-top: 0.78571429rem;
  border-radius: 0.28571429rem;
}
.ui.pointing.dropdown > .menu:after {
  display: block;
  position: absolute;
  pointer-events: none;
  content: '';
  visibility: visible;
  transform: rotate(45deg);
  width: 0.5em;
  height: 0.5em;
  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);
  background: #FFFFFF;
  z-index: 2;
}
.ui.pointing.dropdown > .menu:after {
  top: -0.25em;
  left: 50%;
  margin: 0em 0em 0em -0.25em;
}
/* Top Left Pointing */
.ui.top.left.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  left: 0%;
  right: auto;
  margin: 1em 0em 0em;
}
.ui.top.left.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  left: 0%;
  right: auto;
  margin: 1em 0em 0em;
}
.ui.top.left.pointing.dropdown > .menu:after {
  top: -0.25em;
  left: 1em;
  right: auto;
  margin: 0em;
  transform: rotate(45deg);
}
/* Top Right Pointing */
.ui.top.right.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  right: 0%;
  left: auto;
  margin: 1em 0em 0em;
}
.ui.top.pointing.dropdown > .left.menu:after,
.ui.top.right.pointing.dropdown > .menu:after {
  top: -0.25em;
  left: auto !important;
  right: 1em !important;
  margin: 0em;
  transform: rotate(45deg);
}
/* Left Pointing */
.ui.left.pointing.dropdown > .menu {
  top: 0%;
  left: 100%;
  right: auto;
  margin: 0em 0em 0em 1em;
}
.ui.left.pointing.dropdown > .menu:after {
  top: 1em;
  left: -0.25em;
  margin: 0em 0em 0em 0em;
  transform: rotate(-45deg);
}
.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {
  left: auto !important;
  right: 100% !important;
  margin: 0em 1em 0em 0em;
}
.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {
  top: 1em;
  left: auto;
  right: -0.25em;
  margin: 0em 0em 0em 0em;
  transform: rotate(135deg);
}
/* Right Pointing */
.ui.right.pointing.dropdown > .menu {
  top: 0%;
  left: auto;
  right: 100%;
  margin: 0em 1em 0em 0em;
}
.ui.right.pointing.dropdown > .menu:after {
  top: 1em;
  left: auto;
  right: -0.25em;
  margin: 0em 0em 0em 0em;
  transform: rotate(135deg);
}
/* Bottom Pointing */
.ui.bottom.pointing.dropdown > .menu {
  top: auto;
  bottom: 100%;
  left: 0%;
  right: auto;
  margin: 0em 0em 1em;
}
.ui.bottom.pointing.dropdown > .menu:after {
  top: auto;
  bottom: -0.25em;
  right: auto;
  margin: 0em;
  transform: rotate(-135deg);
}
/* Reverse Sub-Menu Direction */
.ui.bottom.pointing.dropdown > .menu .menu {
  top: auto !important;
  bottom: 0px !important;
}
/* Bottom Left */
.ui.bottom.left.pointing.dropdown > .menu {
  left: 0%;
  right: auto;
}
.ui.bottom.left.pointing.dropdown > .menu:after {
  left: 1em;
  right: auto;
}
/* Bottom Right */
.ui.bottom.right.pointing.dropdown > .menu {
  right: 0%;
  left: auto;
}
.ui.bottom.right.pointing.dropdown > .menu:after {
  left: auto;
  right: 1em;
}
/* Upward pointing */
.ui.pointing.upward.dropdown .menu,
.ui.top.pointing.upward.dropdown .menu {
  top: auto !important;
  bottom: 100% !important;
  margin: 0em 0em 0.78571429rem;
  border-radius: 0.28571429rem;
}
.ui.pointing.upward.dropdown .menu:after,
.ui.top.pointing.upward.dropdown .menu:after {
  top: 100% !important;
  bottom: auto !important;
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.15);
  margin: -0.25em 0em 0em;
}
/* Right Pointing Upward */
.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {
  top: auto !important;
  bottom: 0 !important;
  margin: 0em 1em 0em 0em;
}
.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {
  top: auto !important;
  bottom: 0 !important;
  margin: 0em 0em 1em 0em;
  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);
}
/* Left Pointing Upward */
.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {
  top: auto !important;
  bottom: 0 !important;
  margin: 0em 0em 0em 1em;
}
.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {
  top: auto !important;
  bottom: 0 !important;
  margin: 0em 0em 1em 0em;
  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);
}
/*******************************
         Theme Overrides
*******************************/
/* Dropdown Carets */
@font-face {
  font-family: 'Dropdown';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff');
  font-weight: normal;
  font-style: normal;
}
.ui.dropdown > .dropdown.icon {
  font-family: 'Dropdown';
  line-height: 1;
  height: 1em;
  width: 1.23em;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
.ui.dropdown > .dropdown.icon {
  width: auto;
}
.ui.dropdown > .dropdown.icon:before {
  content: '\\f0d7';
}
/* Sub Menu */
.ui.dropdown .menu .item .dropdown.icon:before {
  content: '\\f0da' /*rtl:'\\f0d9'*/;
}
.ui.dropdown .item .left.dropdown.icon:before,
.ui.dropdown .left.menu .item .dropdown.icon:before {
  content: "\\f0d9" /*rtl:"\\f0da"*/;
}
/* Vertical Menu Dropdown */
.ui.vertical.menu .dropdown.item > .dropdown.icon:before {
  content: "\\f0da" /*rtl:"\\f0d9"*/;
}
.ui.dropdown > .clear.icon:before {
  content: "\\f00d";
}
/* Icons for Reference (Subsetted in 2.4.0)
  .dropdown.down:before { content: "\\f0d7"; }
  .dropdown.up:before { content: "\\f0d8"; }
  .dropdown.left:before { content: "\\f0d9"; }
  .dropdown.right:before { content: "\\f0da"; }
  .dropdown.close:before { content: "\\f00d"; }
*/
/*!
 * # Semantic UI - Video
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Video
*******************************/
/*-------------------
       Element
--------------------*/
/* Simple */
/* Placeholder */
/* Placeholder Overlayed Background */
/* Icon */
/*-------------------
       States
--------------------*/
/* Hover */
/*-------------------
      Variations
--------------------*/
/* Aspect Ratios */
/* Packaged Theme */
/*******************************
             Video
*******************************/
/*-------------------
       Element
--------------------*/
/* Simple */
/* Placeholder */
/* Placeholder Overlayed Background */
/* Icon */
/*-------------------
       States
--------------------*/
/* Hover */
/*-------------------
      Variations
--------------------*/
/* Aspect Ratios */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Types
*******************************/
.ui.embed {
  position: relative;
  max-width: 100%;
  height: 0px;
  overflow: hidden;
  background: #DCDDDE;
  padding-bottom: 56.25%;
}
/*-----------------
  Embedded Content
------------------*/
.ui.embed iframe,
.ui.embed embed,
.ui.embed object {
  position: absolute;
  border: none;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  margin: 0em;
  padding: 0em;
}
/*-----------------
      Embed
------------------*/
.ui.embed > .embed {
  display: none;
}
/*--------------
   Placeholder
---------------*/
.ui.embed > .placeholder {
  position: absolute;
  cursor: pointer;
  top: 0px;
  left: 0px;
  display: block;
  width: 100%;
  height: 100%;
  background-color: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
}
/*--------------
      Icon
---------------*/
.ui.embed > .icon {
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.ui.embed > .icon:after {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  z-index: 3;
  content: '';
  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
  opacity: 0.5;
  transition: opacity 0.5s ease;
}
.ui.embed > .icon:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 4;
  transform: translateX(-50%) translateY(-50%);
  color: #FFFFFF;
  font-size: 6rem;
  text-shadow: 0px 2px 10px rgba(34, 36, 38, 0.2);
  transition: opacity 0.5s ease, color 0.5s ease;
  z-index: 10;
}
/*******************************
            States
*******************************/
/*--------------
     Hover
---------------*/
.ui.embed .icon:hover:after {
  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
  opacity: 1;
}
.ui.embed .icon:hover:before {
  color: #FFFFFF;
}
/*--------------
     Active
---------------*/
.ui.active.embed > .icon,
.ui.active.embed > .placeholder {
  display: none;
}
.ui.active.embed > .embed {
  display: block;
}
/*******************************
        Video Overrides
*******************************/
/*******************************
          Variations
*******************************/
.ui.square.embed {
  padding-bottom: 100%;
}
.ui[class*="4:3"].embed {
  padding-bottom: 75%;
}
.ui[class*="16:9"].embed {
  padding-bottom: 56.25%;
}
.ui[class*="21:9"].embed {
  padding-bottom: 42.85714286%;
}
/*!
 * # Semantic UI - Modal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Modal
*******************************/
/* Close Icon */
/* Header */
/* Content */
/* Image / Description */
/* Modal Actions */
/* Inner Close Position (Tablet/Mobile) */
/* Mobile Positions */
/* Responsive Widths */
/* Coupling */
/*-------------------
       States
--------------------*/
/*-------------------
        Types
--------------------*/
/* Basic */
/* Top Aligned */
/* Scrolling Margin */
/* Scrolling Content */
/*-------------------
      Variations
--------------------*/
/* Size Widths */
/* Derived Responsive Sizes */
/* Packaged Theme */
/*******************************
             Modal
*******************************/
/* Close Icon */
/* Header */
/* Content */
/* Image / Description */
/* Modal Actions */
/* Inner Close Position (Tablet/Mobile) */
/* Mobile Positions */
/* Responsive Widths */
/* Coupling */
/*-------------------
       States
--------------------*/
/*-------------------
        Types
--------------------*/
/* Basic */
/* Top Aligned */
/* Scrolling Margin */
/* Scrolling Content */
/*-------------------
      Variations
--------------------*/
/* Size Widths */
/* Derived Responsive Sizes */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Modal
*******************************/
.ui.modal {
  position: absolute;
  display: none;
  z-index: 1001;
  text-align: left;
  background: #1e1f33;
  border: none;
  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2);
  transform-origin: 50% 25%;
  flex: 0 0 auto;
  border-radius: 0.28571429rem;
  user-select: text;
  will-change: top, left, margin, transform, opacity;
}
.ui.modal > :first-child:not(.icon),
.ui.modal > .icon:first-child + * {
  border-top-left-radius: 0.28571429rem;
  border-top-right-radius: 0.28571429rem;
}
.ui.modal > :last-child {
  border-bottom-left-radius: 0.28571429rem;
  border-bottom-right-radius: 0.28571429rem;
}
/*******************************
            Content
*******************************/
/*--------------
     Close
---------------*/
.ui.modal > .close {
  cursor: pointer;
  position: absolute;
  top: -2.5rem;
  right: -2.5rem;
  z-index: 1;
  opacity: 0.8;
  font-size: 1.25em;
  color: #FFFFFF;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0.625rem 0rem 0rem 0rem;
}
.ui.modal > .close:hover {
  opacity: 1;
}
/*--------------
     Header
---------------*/
.ui.modal > .header {
  display: block;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  background: #1e1f33;
  margin: 0em;
  padding: 1.25rem 1.5rem;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.ui.modal > .header:not(.ui) {
  font-size: 1.42857143rem;
  line-height: 1.28571429em;
  font-weight: bold;
}
/*--------------
     Content
---------------*/
.ui.modal > .content {
  display: block;
  width: 100%;
  font-size: 1em;
  line-height: 1.4;
  padding: 1.5rem;
  background: #1e1f33;
}
.ui.modal > .image.content {
  display: flex;
  flex-direction: row;
}
/* Image */
.ui.modal > .content > .image {
  display: block;
  flex: 0 1 auto;
  width: '';
  align-self: top;
}
.ui.modal > [class*="top aligned"] {
  align-self: top;
}
.ui.modal > [class*="middle aligned"] {
  align-self: middle;
}
.ui.modal > [class*="stretched"] {
  align-self: stretch;
}
/* Description */
.ui.modal > .content > .description {
  display: block;
  flex: 1 0 auto;
  min-width: 0px;
  align-self: top;
}
.ui.modal > .content > .icon + .description,
.ui.modal > .content > .image + .description {
  flex: 0 1 auto;
  min-width: '';
  width: auto;
  padding-left: 2em;
}
/*rtl:ignore*/
.ui.modal > .content > .image > i.icon {
  margin: 0em;
  opacity: 1;
  width: auto;
  line-height: 1;
  font-size: 8rem;
}
/*--------------
     Actions
---------------*/
.ui.modal > .actions {
  background: #1e1f33;
  padding: 1rem 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  text-align: right;
}
.ui.modal .actions > .button {
  margin-left: 0.75em;
}
/*-------------------
       Responsive
--------------------*/
/* Modal Width */
@media only screen and (max-width: 767px) {
  .ui.modal {
    width: 95%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 768px) {
  .ui.modal {
    width: 88%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 992px) {
  .ui.modal {
    width: 850px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1200px) {
  .ui.modal {
    width: 900px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.modal {
    width: 950px;
    margin: 0em 0em 0em 0em;
  }
}
/* Tablet and Mobile */
@media only screen and (max-width: 991px) {
  .ui.modal > .header {
    padding-right: 2.25rem;
  }
  .ui.modal > .close {
    top: 1.0535rem;
    right: 1rem;
    color: rgba(255, 255, 255, 0.87);
  }
}
/* Mobile */
@media only screen and (max-width: 767px) {
  .ui.modal > .header {
    padding: 0.75rem 1rem !important;
    padding-right: 2.25rem !important;
  }
  .ui.modal > .content {
    display: block;
    padding: 1rem !important;
  }
  .ui.modal > .close {
    top: 0.5rem !important;
    right: 0.5rem !important;
  }
  /*rtl:ignore*/
  .ui.modal .image.content {
    flex-direction: column;
  }
  .ui.modal .content > .image {
    display: block;
    max-width: 100%;
    margin: 0em auto !important;
    text-align: center;
    padding: 0rem 0rem 1rem !important;
  }
  .ui.modal > .content > .image > i.icon {
    font-size: 5rem;
    text-align: center;
  }
  /*rtl:ignore*/
  .ui.modal .content > .description {
    display: block;
    width: 100% !important;
    margin: 0em !important;
    padding: 1rem 0rem !important;
    box-shadow: none;
  }
  /* Let Buttons Stack */
  .ui.modal > .actions {
    padding: 1rem 1rem 0rem !important;
  }
  .ui.modal .actions > .buttons,
  .ui.modal .actions > .button {
    margin-bottom: 1rem;
  }
}
/*--------------
    Coupling
---------------*/
.ui.inverted.dimmer > .ui.modal {
  box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2);
}
/*******************************
             Types
*******************************/
.ui.basic.modal {
  background-color: transparent;
  border: none;
  border-radius: 0em;
  box-shadow: none !important;
  color: #1e1f33;
}
.ui.basic.modal > .header,
.ui.basic.modal > .content,
.ui.basic.modal > .actions {
  background-color: transparent;
}
.ui.basic.modal > .header {
  color: #1e1f33;
}
.ui.basic.modal > .close {
  top: 1rem;
  right: 1.5rem;
}
.ui.inverted.dimmer > .basic.modal {
  color: rgba(255, 255, 255, 0.87);
}
.ui.inverted.dimmer > .ui.basic.modal > .header {
  color: rgba(255, 255, 255, 0.85);
}
/* Resort to margin positioning if legacy */
.ui.legacy.modal,
.ui.legacy.page.dimmer > .ui.modal {
  top: 50%;
  left: 50%;
}
.ui.legacy.page.dimmer > .ui.scrolling.modal,
.ui.page.dimmer > .ui.scrolling.legacy.modal,
.ui.top.aligned.legacy.page.dimmer > .ui.modal,
.ui.top.aligned.dimmer > .ui.legacy.modal {
  top: auto;
}
/* Tablet and Mobile */
@media only screen and (max-width: 991px) {
  .ui.basic.modal > .close {
    color: #FFFFFF;
  }
}
/*******************************
             States
*******************************/
.ui.loading.modal {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.ui.active.modal {
  display: block;
}
/*******************************
           Variations
*******************************/
/*--------------
   Top Aligned
---------------*/
/* Top Aligned Modal */
.modals.dimmer[class*="top aligned"] .modal {
  margin: 5vh auto;
}
@media only screen and (max-width: 767px) {
  .modals.dimmer[class*="top aligned"] .modal {
    margin: 1rem auto;
  }
}
/* Legacy Top Aligned */
.legacy.modals.dimmer[class*="top aligned"] {
  padding-top: 5vh;
}
@media only screen and (max-width: 767px) {
  .legacy.modals.dimmer[class*="top aligned"] {
    padding-top: 1rem;
  }
}
/*--------------
    Scrolling
---------------*/
/* Scrolling Dimmer */
.scrolling.dimmable.dimmed {
  overflow: hidden;
}
.scrolling.dimmable > .dimmer {
  justify-content: flex-start;
}
.scrolling.dimmable.dimmed > .dimmer {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.scrolling.dimmable > .dimmer {
  position: fixed;
}
.modals.dimmer .ui.scrolling.modal {
  margin: 1rem auto;
}
/* Undetached Scrolling */
.scrolling.undetached.dimmable.dimmed {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.scrolling.undetached.dimmable.dimmed > .dimmer {
  overflow: hidden;
}
.scrolling.undetached.dimmable .ui.scrolling.modal {
  position: absolute;
  left: 50%;
  margin-top: 1rem !important;
}
/* Scrolling Content */
.ui.modal .scrolling.content {
  max-height: calc(80vh - 10em);
  overflow: auto;
}
/*--------------
   Full Screen
---------------*/
.ui.fullscreen.modal {
  width: 95% !important;
  margin: 1em auto;
}
.ui.fullscreen.modal > .header {
  padding-right: 2.25rem;
}
.ui.fullscreen.modal > .close {
  top: 1.0535rem;
  right: 1rem;
  color: rgba(255, 255, 255, 0.87);
}
/*--------------
      Size
---------------*/
.ui.modal {
  font-size: 1rem;
}
/* Mini */
.ui.mini.modal > .header:not(.ui) {
  font-size: 1.3em;
}
/* Mini Modal Width */
@media only screen and (max-width: 767px) {
  .ui.mini.modal {
    width: 95%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 768px) {
  .ui.mini.modal {
    width: 35.2%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 992px) {
  .ui.mini.modal {
    width: 340px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1200px) {
  .ui.mini.modal {
    width: 360px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.mini.modal {
    width: 380px;
    margin: 0em 0em 0em 0em;
  }
}
/* mini */
.ui.small.modal > .header:not(.ui) {
  font-size: 1.3em;
}
/* Tiny Modal Width */
@media only screen and (max-width: 767px) {
  .ui.tiny.modal {
    width: 95%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 768px) {
  .ui.tiny.modal {
    width: 52.8%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 992px) {
  .ui.tiny.modal {
    width: 510px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1200px) {
  .ui.tiny.modal {
    width: 540px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.tiny.modal {
    width: 570px;
    margin: 0em 0em 0em 0em;
  }
}
/* Small */
.ui.small.modal > .header:not(.ui) {
  font-size: 1.3em;
}
/* Small Modal Width */
@media only screen and (max-width: 767px) {
  .ui.small.modal {
    width: 95%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 768px) {
  .ui.small.modal {
    width: 70.4%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 992px) {
  .ui.small.modal {
    width: 680px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1200px) {
  .ui.small.modal {
    width: 720px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.small.modal {
    width: 760px;
    margin: 0em 0em 0em 0em;
  }
}
/* Large Modal Width */
.ui.large.modal > .header {
  font-size: 1.6em;
}
@media only screen and (max-width: 767px) {
  .ui.large.modal {
    width: 95%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 768px) {
  .ui.large.modal {
    width: 88%;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 992px) {
  .ui.large.modal {
    width: 1020px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1200px) {
  .ui.large.modal {
    width: 1080px;
    margin: 0em 0em 0em 0em;
  }
}
@media only screen and (min-width: 1920px) {
  .ui.large.modal {
    width: 1140px;
    margin: 0em 0em 0em 0em;
  }
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Nag
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Nag
*******************************/
/*--------------
   Collection
---------------*/
/*--------------
    Elements
---------------*/
/* Title */
/*--------------
      States
---------------*/
/* Hover */
/*--------------
   Variations
---------------*/
/* Top / Bottom */
/* Inverted */
/*--------------
      Plural
---------------*/
/* Packaged Theme */
/*******************************
             Nag
*******************************/
/*--------------
   Collection
---------------*/
/*--------------
    Elements
---------------*/
/* Title */
/*--------------
      States
---------------*/
/* Hover */
/*--------------
   Variations
---------------*/
/* Top / Bottom */
/* Inverted */
/*--------------
      Plural
---------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Nag
*******************************/
.ui.nag {
  display: none;
  opacity: 0.95;
  position: relative;
  top: 0em;
  left: 0px;
  z-index: 999;
  min-height: 0em;
  width: 100%;
  margin: 0em;
  padding: 0.75em 1em;
  background: #555555;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.87);
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
  transition: 0.2s background ease;
}
a.ui.nag {
  cursor: pointer;
}
.ui.nag > .title {
  display: inline-block;
  margin: 0em 0.5em;
  color: #FFFFFF;
}
.ui.nag > .close.icon {
  cursor: pointer;
  opacity: 0.4;
  position: absolute;
  top: 50%;
  right: 1em;
  font-size: 1em;
  margin: -0.5em 0em 0em;
  color: #FFFFFF;
  transition: opacity 0.2s ease;
}
/*******************************
             States
*******************************/
/* Hover */
.ui.nag:hover {
  background: #555555;
  opacity: 1;
}
.ui.nag .close:hover {
  opacity: 1;
}
/*******************************
           Variations
*******************************/
/*--------------
     Static
---------------*/
.ui.overlay.nag {
  position: absolute;
  display: block;
}
/*--------------
     Fixed
---------------*/
.ui.fixed.nag {
  position: fixed;
}
/*--------------
     Bottom
---------------*/
.ui.bottom.nags,
.ui.bottom.nag {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
  top: auto;
  bottom: 0em;
}
/*--------------
     White
---------------*/
.ui.inverted.nags .nag,
.ui.inverted.nag {
  background-color: #F3F4F5;
  color: rgba(255, 255, 255, 0.85);
}
.ui.inverted.nags .nag .close,
.ui.inverted.nags .nag .title,
.ui.inverted.nag .close,
.ui.inverted.nag .title {
  color: rgba(255, 255, 255, 0.4);
}
/*******************************
           Groups
*******************************/
.ui.nags .nag {
  border-radius: 0em !important;
}
.ui.nags .nag:last-child {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.bottom.nags .nag:last-child {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Popup
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Popup
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Parts
--------------------*/
/* Placement */
/* Header */
/* Content Border */
/* Arrow */
/* Arrow color by position */
/*-------------------
       Types
--------------------*/
/* Tooltip */
/* Inverted */
/* Arrow */
/*-------------------
       Coupling
--------------------*/
/* Grid Inside Popup */
/* (padding * @medium) */
/*-------------------
       States
--------------------*/
/*-------------------
       Variations
--------------------*/
/* Wide */
/* Inverted */
/* Arrow color by position */
/* Packaged Theme */
/*******************************
             Popup
*******************************/
/*-------------------
       Element
--------------------*/
/*-------------------
       Parts
--------------------*/
/* Placement */
/* Header */
/* Content Border */
/* Arrow */
/* Arrow color by position */
/*-------------------
       Types
--------------------*/
/* Tooltip */
/* Inverted */
/* Arrow */
/*-------------------
       Coupling
--------------------*/
/* Grid Inside Popup */
/* (padding * @medium) */
/*-------------------
       States
--------------------*/
/*-------------------
       Variations
--------------------*/
/* Wide */
/* Inverted */
/* Arrow color by position */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Popup
*******************************/
.ui.popup {
  display: none;
  position: absolute;
  top: 0px;
  right: 0px;
  /* Fixes content being squished when inline (moz only) */
  min-width: min-content;
  z-index: 1900;
  border: 1px solid #D4D4D5;
  line-height: 1.4285em;
  max-width: 250px;
  background: rgba(0, 0, 0, 0.15);
  padding: 0.833em 1em;
  font-weight: normal;
  font-style: normal;
  color: rgba(255, 255, 255, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}
.ui.popup > .header {
  padding: 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1.14285714em;
  line-height: 1.2;
  font-weight: bold;
}
.ui.popup > .header + .content {
  padding-top: 0.5em;
}
.ui.popup:before {
  position: absolute;
  content: '';
  width: 0.71428571em;
  height: 0.71428571em;
  background: rgba(0, 0, 0, 0.15);
  transform: rotate(45deg);
  z-index: 2;
  box-shadow: 1px 1px 0px 0px #bababc;
}
/*******************************
            Types
*******************************/
/*--------------
    Tooltip
---------------*/
/* Content */
[data-tooltip] {
  position: relative;
}
/* Arrow */
[data-tooltip]:before {
  pointer-events: none;
  position: absolute;
  content: '';
  font-size: 1rem;
  width: 0.71428571em;
  height: 0.71428571em;
  background: rgba(0, 0, 0, 0.15);
  transform: rotate(45deg);
  z-index: 2;
  box-shadow: 1px 1px 0px 0px #bababc;
}
/* Popup */
[data-tooltip]:after {
  pointer-events: none;
  content: attr(data-tooltip);
  position: absolute;
  text-transform: none;
  text-align: left;
  white-space: nowrap;
  font-size: 1rem;
  border: 1px solid #D4D4D5;
  line-height: 1.4285em;
  max-width: none;
  background: rgba(0, 0, 0, 0.15);
  padding: 0.833em 1em;
  font-weight: normal;
  font-style: normal;
  color: rgba(255, 255, 255, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
  z-index: 1;
}
/* Default Position (Top Center) */
[data-tooltip]:not([data-position]):before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 50%;
  background: rgba(0, 0, 0, 0.15);
  margin-left: -0.07142857rem;
  margin-bottom: 0.14285714rem;
}
[data-tooltip]:not([data-position]):after {
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;
  margin-bottom: 0.5em;
}
/* Animation */
[data-tooltip]:before,
[data-tooltip]:after {
  pointer-events: none;
  visibility: hidden;
}
[data-tooltip]:before {
  opacity: 0;
  transform: rotate(45deg) scale(0) !important;
  transform-origin: center top;
  transition: all 0.1s ease;
}
[data-tooltip]:after {
  opacity: 1;
  transform-origin: center bottom;
  transition: all 0.1s ease;
}
[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  pointer-events: auto;
}
[data-tooltip]:hover:before {
  transform: rotate(45deg) scale(1) !important;
  opacity: 1;
}
/* Animation Position */
[data-tooltip]:after,
[data-tooltip][data-position="top center"]:after,
[data-tooltip][data-position="bottom center"]:after {
  transform: translateX(-50%) scale(0) !important;
}
[data-tooltip]:hover:after,
[data-tooltip][data-position="bottom center"]:hover:after {
  transform: translateX(-50%) scale(1) !important;
}
[data-tooltip][data-position="left center"]:after,
[data-tooltip][data-position="right center"]:after {
  transform: translateY(-50%) scale(0) !important;
}
[data-tooltip][data-position="left center"]:hover:after,
[data-tooltip][data-position="right center"]:hover:after {
  transform: translateY(-50%) scale(1) !important;
}
[data-tooltip][data-position="top left"]:after,
[data-tooltip][data-position="top right"]:after,
[data-tooltip][data-position="bottom left"]:after,
[data-tooltip][data-position="bottom right"]:after {
  transform: scale(0) !important;
}
[data-tooltip][data-position="top left"]:hover:after,
[data-tooltip][data-position="top right"]:hover:after,
[data-tooltip][data-position="bottom left"]:hover:after,
[data-tooltip][data-position="bottom right"]:hover:after {
  transform: scale(1) !important;
}
/*--------------
    Inverted
---------------*/
/* Arrow */
[data-tooltip][data-inverted]:before {
  box-shadow: none !important;
}
/* Arrow Position */
[data-tooltip][data-inverted]:before {
  background: #1B1C1D;
}
/* Popup  */
[data-tooltip][data-inverted]:after {
  background: #1B1C1D;
  color: #FFFFFF;
  border: none;
  box-shadow: none;
}
[data-tooltip][data-inverted]:after .header {
  background-color: none;
  color: #FFFFFF;
}
/*--------------
    Position
---------------*/
/* Top Center */
[data-position="top center"][data-tooltip]:after {
  top: auto;
  right: auto;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
  margin-bottom: 0.5em;
}
[data-position="top center"][data-tooltip]:before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 50%;
  background: rgba(0, 0, 0, 0.15);
  margin-left: -0.07142857rem;
  margin-bottom: 0.14285714rem;
}
/* Top Left */
[data-position="top left"][data-tooltip]:after {
  top: auto;
  right: auto;
  left: 0;
  bottom: 100%;
  margin-bottom: 0.5em;
}
[data-position="top left"][data-tooltip]:before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 1em;
  margin-left: -0.07142857rem;
  margin-bottom: 0.14285714rem;
}
/* Top Right */
[data-position="top right"][data-tooltip]:after {
  top: auto;
  left: auto;
  right: 0;
  bottom: 100%;
  margin-bottom: 0.5em;
}
[data-position="top right"][data-tooltip]:before {
  top: auto;
  left: auto;
  bottom: 100%;
  right: 1em;
  margin-left: -0.07142857rem;
  margin-bottom: 0.14285714rem;
}
/* Bottom Center */
[data-position="bottom center"][data-tooltip]:after {
  bottom: auto;
  right: auto;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  margin-top: 0.5em;
}
[data-position="bottom center"][data-tooltip]:before {
  bottom: auto;
  right: auto;
  top: 100%;
  left: 50%;
  margin-left: -0.07142857rem;
  margin-top: 0.14285714rem;
}
/* Bottom Left */
[data-position="bottom left"][data-tooltip]:after {
  left: 0;
  top: 100%;
  margin-top: 0.5em;
}
[data-position="bottom left"][data-tooltip]:before {
  bottom: auto;
  right: auto;
  top: 100%;
  left: 1em;
  margin-left: -0.07142857rem;
  margin-top: 0.14285714rem;
}
/* Bottom Right */
[data-position="bottom right"][data-tooltip]:after {
  right: 0;
  top: 100%;
  margin-top: 0.5em;
}
[data-position="bottom right"][data-tooltip]:before {
  bottom: auto;
  left: auto;
  top: 100%;
  right: 1em;
  margin-left: -0.14285714rem;
  margin-top: 0.07142857rem;
}
/* Left Center */
[data-position="left center"][data-tooltip]:after {
  right: 100%;
  top: 50%;
  margin-right: 0.5em;
  transform: translateY(-50%);
}
[data-position="left center"][data-tooltip]:before {
  right: 100%;
  top: 50%;
  margin-top: -0.14285714rem;
  margin-right: -0.07142857rem;
}
/* Right Center */
[data-position="right center"][data-tooltip]:after {
  left: 100%;
  top: 50%;
  margin-left: 0.5em;
  transform: translateY(-50%);
}
[data-position="right center"][data-tooltip]:before {
  left: 100%;
  top: 50%;
  margin-top: -0.07142857rem;
  margin-left: 0.14285714rem;
}
/* Arrow */
[data-position~="bottom"][data-tooltip]:before {
  background: rgba(0, 0, 0, 0.15);
  box-shadow: -1px -1px 0px 0px #bababc;
}
[data-position="left center"][data-tooltip]:before {
  background: rgba(0, 0, 0, 0.15);
  box-shadow: 1px -1px 0px 0px #bababc;
}
[data-position="right center"][data-tooltip]:before {
  background: rgba(0, 0, 0, 0.15);
  box-shadow: -1px 1px 0px 0px #bababc;
}
[data-position~="top"][data-tooltip]:before {
  background: rgba(0, 0, 0, 0.15);
}
/* Inverted Arrow Color */
[data-inverted][data-position~="bottom"][data-tooltip]:before {
  background: #1B1C1D;
  box-shadow: -1px -1px 0px 0px #bababc;
}
[data-inverted][data-position="left center"][data-tooltip]:before {
  background: #1B1C1D;
  box-shadow: 1px -1px 0px 0px #bababc;
}
[data-inverted][data-position="right center"][data-tooltip]:before {
  background: #1B1C1D;
  box-shadow: -1px 1px 0px 0px #bababc;
}
[data-inverted][data-position~="top"][data-tooltip]:before {
  background: #1B1C1D;
}
[data-position~="bottom"][data-tooltip]:before {
  transform-origin: center bottom;
}
[data-position~="bottom"][data-tooltip]:after {
  transform-origin: center top;
}
[data-position="left center"][data-tooltip]:before {
  transform-origin: top center;
}
[data-position="left center"][data-tooltip]:after {
  transform-origin: right center;
}
[data-position="right center"][data-tooltip]:before {
  transform-origin: right center;
}
[data-position="right center"][data-tooltip]:after {
  transform-origin: left center;
}
/*--------------
     Spacing
---------------*/
.ui.popup {
  margin: 0em;
}
/* Extending from Top */
.ui.top.popup {
  margin: 0em 0em 0.71428571em;
}
.ui.top.left.popup {
  transform-origin: left bottom;
}
.ui.top.center.popup {
  transform-origin: center bottom;
}
.ui.top.right.popup {
  transform-origin: right bottom;
}
/* Extending from Vertical Center */
.ui.left.center.popup {
  margin: 0em 0.71428571em 0em 0em;
  transform-origin: right 50%;
}
.ui.right.center.popup {
  margin: 0em 0em 0em 0.71428571em;
  transform-origin: left 50%;
}
/* Extending from Bottom */
.ui.bottom.popup {
  margin: 0.71428571em 0em 0em;
}
.ui.bottom.left.popup {
  transform-origin: left top;
}
.ui.bottom.center.popup {
  transform-origin: center top;
}
.ui.bottom.right.popup {
  transform-origin: right top;
}
/*--------------
     Pointer
---------------*/
/*--- Below ---*/
.ui.bottom.center.popup:before {
  margin-left: -0.30714286em;
  top: -0.30714286em;
  left: 50%;
  right: auto;
  bottom: auto;
  box-shadow: -1px -1px 0px 0px #bababc;
}
.ui.bottom.left.popup {
  margin-left: 0em;
}
/*rtl:rename*/
.ui.bottom.left.popup:before {
  top: -0.30714286em;
  left: 1em;
  right: auto;
  bottom: auto;
  margin-left: 0em;
  box-shadow: -1px -1px 0px 0px #bababc;
}
.ui.bottom.right.popup {
  margin-right: 0em;
}
/*rtl:rename*/
.ui.bottom.right.popup:before {
  top: -0.30714286em;
  right: 1em;
  bottom: auto;
  left: auto;
  margin-left: 0em;
  box-shadow: -1px -1px 0px 0px #bababc;
}
/*--- Above ---*/
.ui.top.center.popup:before {
  top: auto;
  right: auto;
  bottom: -0.30714286em;
  left: 50%;
  margin-left: -0.30714286em;
}
.ui.top.left.popup {
  margin-left: 0em;
}
/*rtl:rename*/
.ui.top.left.popup:before {
  bottom: -0.30714286em;
  left: 1em;
  top: auto;
  right: auto;
  margin-left: 0em;
}
.ui.top.right.popup {
  margin-right: 0em;
}
/*rtl:rename*/
.ui.top.right.popup:before {
  bottom: -0.30714286em;
  right: 1em;
  top: auto;
  left: auto;
  margin-left: 0em;
}
/*--- Left Center ---*/
/*rtl:rename*/
.ui.left.center.popup:before {
  top: 50%;
  right: -0.30714286em;
  bottom: auto;
  left: auto;
  margin-top: -0.30714286em;
  box-shadow: 1px -1px 0px 0px #bababc;
}
/*--- Right Center  ---*/
/*rtl:rename*/
.ui.right.center.popup:before {
  top: 50%;
  left: -0.30714286em;
  bottom: auto;
  right: auto;
  margin-top: -0.30714286em;
  box-shadow: -1px 1px 0px 0px #bababc;
}
/* Arrow Color By Location */
.ui.bottom.popup:before {
  background: rgba(0, 0, 0, 0.15);
}
.ui.right.center.popup:before,
.ui.left.center.popup:before {
  background: rgba(0, 0, 0, 0.15);
}
.ui.top.popup:before {
  background: rgba(0, 0, 0, 0.15);
}
/* Inverted Arrow Color */
.ui.inverted.bottom.popup:before {
  background: #1B1C1D;
}
.ui.inverted.right.center.popup:before,
.ui.inverted.left.center.popup:before {
  background: #1B1C1D;
}
.ui.inverted.top.popup:before {
  background: #1B1C1D;
}
/*******************************
            Coupling
*******************************/
/* Immediate Nested Grid */
.ui.popup > .ui.grid:not(.padded) {
  width: calc(100% + 1.75rem);
  margin: -0.7rem -0.875rem;
}
/*******************************
            States
*******************************/
.ui.loading.popup {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.ui.animating.popup,
.ui.visible.popup {
  display: block;
}
.ui.visible.popup {
  transform: translateZ(0px);
  backface-visibility: hidden;
}
/*******************************
            Variations
*******************************/
/*--------------
     Basic
---------------*/
.ui.basic.popup:before {
  display: none;
}
/*--------------
     Wide
---------------*/
.ui.wide.popup {
  max-width: 350px;
}
.ui[class*="very wide"].popup {
  max-width: 550px;
}
@media only screen and (max-width: 767px) {
  .ui.wide.popup,
  .ui[class*="very wide"].popup {
    max-width: 250px;
  }
}
/*--------------
     Fluid
---------------*/
.ui.fluid.popup {
  width: 100%;
  max-width: none;
}
/*--------------
     Colors
---------------*/
/* Inverted colors  */
.ui.inverted.popup {
  background: #1B1C1D;
  color: #FFFFFF;
  border: none;
  box-shadow: none;
}
.ui.inverted.popup .header {
  background-color: none;
  color: #FFFFFF;
}
.ui.inverted.popup:before {
  background-color: #1B1C1D;
  box-shadow: none !important;
}
/*--------------
     Flowing
---------------*/
.ui.flowing.popup {
  max-width: none;
}
/*--------------
     Sizes
---------------*/
.ui.mini.popup {
  font-size: 0.78571429rem;
}
.ui.tiny.popup {
  font-size: 0.85714286rem;
}
.ui.small.popup {
  font-size: 0.92857143rem;
}
.ui.popup {
  font-size: 1rem;
}
.ui.large.popup {
  font-size: 1.14285714rem;
}
.ui.huge.popup {
  font-size: 1.42857143rem;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Progress Bar
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Progress
*******************************/
/*-------------------
       Element
--------------------*/
/* Bar */
/* Progress Bar Label */
/* Label */
/*-------------------
        Types
--------------------*/
/*-------------------
        States
--------------------*/
/* Active */
/*-------------------
      Variations
--------------------*/
/* Attached */
/* Inverted */
/* Sizing */
/* Packaged Theme */
/*******************************
            Progress
*******************************/
/*-------------------
       Element
--------------------*/
/* Bar */
/* Progress Bar Label */
/* Label */
/*-------------------
        Types
--------------------*/
/*-------------------
        States
--------------------*/
/* Active */
/*-------------------
      Variations
--------------------*/
/* Attached */
/* Inverted */
/* Sizing */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Progress
*******************************/
.ui.progress {
  position: relative;
  display: block;
  max-width: 100%;
  border: none;
  margin: 1em 0em 2.5em;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.1);
  padding: 0em;
  border-radius: 0.28571429rem;
}
.ui.progress:first-child {
  margin: 0em 0em 2.5em;
}
.ui.progress:last-child {
  margin: 0em 0em 1.5em;
}
/*******************************
            Content
*******************************/
/* Activity Bar */
.ui.progress .bar {
  display: block;
  line-height: 1;
  position: relative;
  width: 0%;
  min-width: 2em;
  background: #888888;
  border-radius: 0.28571429rem;
  transition: width 0.1s ease, background-color 0.1s ease;
}
/* Percent Complete */
.ui.progress .bar > .progress {
  white-space: nowrap;
  position: absolute;
  width: auto;
  font-size: 0.92857143em;
  top: 50%;
  right: 0.5em;
  left: auto;
  bottom: auto;
  color: rgba(255, 255, 255, 0.7);
  text-shadow: none;
  margin-top: -0.5em;
  font-weight: bold;
  text-align: left;
}
/* Label */
.ui.progress > .label {
  position: absolute;
  width: 100%;
  font-size: 1em;
  top: 100%;
  right: auto;
  left: 0%;
  bottom: auto;
  color: rgba(255, 255, 255, 0.87);
  font-weight: bold;
  text-shadow: none;
  margin-top: 0.2em;
  text-align: center;
  transition: color 0.4s ease;
}
/*******************************
            Types
*******************************/
/* Indicating */
.ui.indicating.progress[data-percent^="1"] .bar,
.ui.indicating.progress[data-percent^="2"] .bar {
  background-color: #D95C5C;
}
.ui.indicating.progress[data-percent^="3"] .bar {
  background-color: #EFBC72;
}
.ui.indicating.progress[data-percent^="4"] .bar,
.ui.indicating.progress[data-percent^="5"] .bar {
  background-color: #E6BB48;
}
.ui.indicating.progress[data-percent^="6"] .bar {
  background-color: #DDC928;
}
.ui.indicating.progress[data-percent^="7"] .bar,
.ui.indicating.progress[data-percent^="8"] .bar {
  background-color: #B4D95C;
}
.ui.indicating.progress[data-percent^="9"] .bar,
.ui.indicating.progress[data-percent^="100"] .bar {
  background-color: #66DA81;
}
/* Indicating Label */
.ui.indicating.progress[data-percent^="1"] .label,
.ui.indicating.progress[data-percent^="2"] .label {
  color: rgba(255, 255, 255, 0.87);
}
.ui.indicating.progress[data-percent^="3"] .label {
  color: rgba(255, 255, 255, 0.87);
}
.ui.indicating.progress[data-percent^="4"] .label,
.ui.indicating.progress[data-percent^="5"] .label {
  color: rgba(255, 255, 255, 0.87);
}
.ui.indicating.progress[data-percent^="6"] .label {
  color: rgba(255, 255, 255, 0.87);
}
.ui.indicating.progress[data-percent^="7"] .label,
.ui.indicating.progress[data-percent^="8"] .label {
  color: rgba(255, 255, 255, 0.87);
}
.ui.indicating.progress[data-percent^="9"] .label,
.ui.indicating.progress[data-percent^="100"] .label {
  color: rgba(255, 255, 255, 0.87);
}
/* Single Digits */
.ui.indicating.progress[data-percent="1"] .bar,
.ui.indicating.progress[data-percent="2"] .bar,
.ui.indicating.progress[data-percent="3"] .bar,
.ui.indicating.progress[data-percent="4"] .bar,
.ui.indicating.progress[data-percent="5"] .bar,
.ui.indicating.progress[data-percent="6"] .bar,
.ui.indicating.progress[data-percent="7"] .bar,
.ui.indicating.progress[data-percent="8"] .bar,
.ui.indicating.progress[data-percent="9"] .bar {
  background-color: #D95C5C;
}
.ui.indicating.progress[data-percent="1"] .label,
.ui.indicating.progress[data-percent="2"] .label,
.ui.indicating.progress[data-percent="3"] .label,
.ui.indicating.progress[data-percent="4"] .label,
.ui.indicating.progress[data-percent="5"] .label,
.ui.indicating.progress[data-percent="6"] .label,
.ui.indicating.progress[data-percent="7"] .label,
.ui.indicating.progress[data-percent="8"] .label,
.ui.indicating.progress[data-percent="9"] .label {
  color: rgba(255, 255, 255, 0.87);
}
/* Indicating Success */
.ui.indicating.progress.success .label {
  color: #1A531B;
}
/*******************************
             States
*******************************/
/*--------------
     Success
---------------*/
.ui.progress.success .bar {
  background-color: #21BA45 !important;
}
.ui.progress.success .bar,
.ui.progress.success .bar::after {
  animation: none !important;
}
.ui.progress.success > .label {
  color: #1A531B;
}
/*--------------
     Warning
---------------*/
.ui.progress.warning .bar {
  background-color: #F2C037 !important;
}
.ui.progress.warning .bar,
.ui.progress.warning .bar::after {
  animation: none !important;
}
.ui.progress.warning > .label {
  color: #794B02;
}
/*--------------
     Error
---------------*/
.ui.progress.error .bar {
  background-color: #DB2828 !important;
}
.ui.progress.error .bar,
.ui.progress.error .bar::after {
  animation: none !important;
}
.ui.progress.error > .label {
  color: #912D2B;
}
/*--------------
     Active
---------------*/
.ui.active.progress .bar {
  position: relative;
  min-width: 2em;
}
.ui.active.progress .bar::after {
  content: '';
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: #FFFFFF;
  border-radius: 0.28571429rem;
  animation: progress-active 2s ease infinite;
}
@keyframes progress-active {
  0% {
    opacity: 0.3;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
/*--------------
    Disabled
---------------*/
.ui.disabled.progress {
  opacity: 0.35;
}
.ui.disabled.progress .bar,
.ui.disabled.progress .bar::after {
  animation: none !important;
}
/*******************************
           Variations
*******************************/
/*--------------
    Inverted
---------------*/
.ui.inverted.progress {
  background: rgba(255, 255, 255, 0.08);
  border: none;
}
.ui.inverted.progress .bar {
  background: #888888;
}
.ui.inverted.progress .bar > .progress {
  color: #F9FAFB;
}
.ui.inverted.progress > .label {
  color: #FFFFFF;
}
.ui.inverted.progress.success > .label {
  color: #21BA45;
}
.ui.inverted.progress.warning > .label {
  color: #F2C037;
}
.ui.inverted.progress.error > .label {
  color: #DB2828;
}
/*--------------
    Attached
---------------*/
/* bottom attached */
.ui.progress.attached {
  background: transparent;
  position: relative;
  border: none;
  margin: 0em;
}
.ui.progress.attached,
.ui.progress.attached .bar {
  display: block;
  height: 0.2rem;
  padding: 0px;
  overflow: hidden;
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui.progress.attached .bar {
  border-radius: 0em;
}
/* top attached */
.ui.progress.top.attached,
.ui.progress.top.attached .bar {
  top: 0px;
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.progress.top.attached .bar {
  border-radius: 0em;
}
/* Coupling */
.ui.segment > .ui.attached.progress,
.ui.card > .ui.attached.progress {
  position: absolute;
  top: auto;
  left: 0;
  bottom: 100%;
  width: 100%;
}
.ui.segment > .ui.bottom.attached.progress,
.ui.card > .ui.bottom.attached.progress {
  top: 100%;
  bottom: auto;
}
/*--------------
     Colors
---------------*/
/* Red */
.ui.red.progress .bar {
  background-color: #DB2828;
}
.ui.red.inverted.progress .bar {
  background-color: #FF695E;
}
/* Orange */
.ui.orange.progress .bar {
  background-color: #F2711C;
}
.ui.orange.inverted.progress .bar {
  background-color: #FF851B;
}
/* Yellow */
.ui.yellow.progress .bar {
  background-color: #FBBD08;
}
.ui.yellow.inverted.progress .bar {
  background-color: #FFE21F;
}
/* Olive */
.ui.olive.progress .bar {
  background-color: #B5CC18;
}
.ui.olive.inverted.progress .bar {
  background-color: #D9E778;
}
/* Green */
.ui.green.progress .bar {
  background-color: #21BA45;
}
.ui.green.inverted.progress .bar {
  background-color: #2ECC40;
}
/* Teal */
.ui.teal.progress .bar {
  background-color: #00B5AD;
}
.ui.teal.inverted.progress .bar {
  background-color: #6DFFFF;
}
/* Blue */
.ui.blue.progress .bar {
  background-color: #2185D0;
}
.ui.blue.inverted.progress .bar {
  background-color: #54C8FF;
}
/* Violet */
.ui.violet.progress .bar {
  background-color: #6435C9;
}
.ui.violet.inverted.progress .bar {
  background-color: #A291FB;
}
/* Purple */
.ui.purple.progress .bar {
  background-color: #A333C8;
}
.ui.purple.inverted.progress .bar {
  background-color: #DC73FF;
}
/* Pink */
.ui.pink.progress .bar {
  background-color: #E03997;
}
.ui.pink.inverted.progress .bar {
  background-color: #FF8EDF;
}
/* Brown */
.ui.brown.progress .bar {
  background-color: #A5673F;
}
.ui.brown.inverted.progress .bar {
  background-color: #D67C1C;
}
/* Grey */
.ui.grey.progress .bar {
  background-color: #767676;
}
.ui.grey.inverted.progress .bar {
  background-color: #DCDDDE;
}
/* Black */
.ui.black.progress .bar {
  background-color: #1B1C1D;
}
.ui.black.inverted.progress .bar {
  background-color: #545454;
}
/*--------------
     Sizes
---------------*/
.ui.tiny.progress {
  font-size: 0.85714286rem;
}
.ui.tiny.progress .bar {
  height: 0.5em;
}
.ui.small.progress {
  font-size: 0.92857143rem;
}
.ui.small.progress .bar {
  height: 1em;
}
.ui.progress {
  font-size: 1rem;
}
.ui.progress .bar {
  height: 1.75em;
}
.ui.large.progress {
  font-size: 1.14285714rem;
}
.ui.large.progress .bar {
  height: 2.5em;
}
.ui.big.progress {
  font-size: 1.28571429rem;
}
.ui.big.progress .bar {
  height: 3.5em;
}
/*******************************
            Progress
*******************************/
/*!
 * # Semantic UI - Rating
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Rating
*******************************/
/*-------------------
        Types
--------------------*/
/* Standard */
/* Star */
/* Heart */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Packaged Theme */
/*******************************
             Rating
*******************************/
/*-------------------
        Types
--------------------*/
/* Standard */
/* Star */
/* Heart */
/*-------------------
        States
--------------------*/
/*-------------------
      Variations
--------------------*/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           Rating
*******************************/
.ui.rating {
  display: inline-flex;
  white-space: nowrap;
  vertical-align: baseline;
}
.ui.rating:last-child {
  margin-right: 0em;
}
/* Icon */
.ui.rating .icon {
  padding: 0em;
  margin: 0em;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  flex: 1 0 auto;
  cursor: pointer;
  width: 1.25em;
  height: auto;
  transition: opacity 0.1s ease, background 0.1s ease, text-shadow 0.1s ease, color 0.1s ease;
}
/*******************************
             Types
*******************************/
/*-------------------
      Standard
--------------------*/
/* Inactive Icon */
.ui.rating .icon {
  background: transparent;
  color: rgba(0, 0, 0, 0.15);
}
/* Active Icon */
.ui.rating .active.icon {
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
}
/* Selected Icon */
.ui.rating .icon.selected,
.ui.rating .icon.selected.active {
  background: transparent;
  color: rgba(255, 255, 255, 0.87);
}
/*-------------------
        Star
--------------------*/
/* Inactive */
.ui.star.rating .icon {
  width: 1.25em;
  height: auto;
  background: transparent;
  color: rgba(0, 0, 0, 0.15);
  text-shadow: none;
}
/* Active Star */
.ui.star.rating .active.icon {
  background: transparent !important;
  color: #FFE623 !important;
  text-shadow: 0px -1px 0px #DDC507, -1px 0px 0px #DDC507, 0px 1px 0px #DDC507, 1px 0px 0px #DDC507 !important;
}
/* Selected Star */
.ui.star.rating .icon.selected,
.ui.star.rating .icon.selected.active {
  background: transparent !important;
  color: #FFCC00 !important;
  text-shadow: 0px -1px 0px #E6A200, -1px 0px 0px #E6A200, 0px 1px 0px #E6A200, 1px 0px 0px #E6A200 !important;
}
/*-------------------
        Heart
--------------------*/
.ui.heart.rating .icon {
  width: 1.4em;
  height: auto;
  background: transparent;
  color: rgba(0, 0, 0, 0.15);
  text-shadow: none !important;
}
/* Active Heart */
.ui.heart.rating .active.icon {
  background: transparent !important;
  color: #FF6D75 !important;
  text-shadow: 0px -1px 0px #CD0707, -1px 0px 0px #CD0707, 0px 1px 0px #CD0707, 1px 0px 0px #CD0707 !important;
}
/* Selected Heart */
.ui.heart.rating .icon.selected,
.ui.heart.rating .icon.selected.active {
  background: transparent !important;
  color: #FF3000 !important;
  text-shadow: 0px -1px 0px #AA0101, -1px 0px 0px #AA0101, 0px 1px 0px #AA0101, 1px 0px 0px #AA0101 !important;
}
/*******************************
             States
*******************************/
/*-------------------
       Disabled
--------------------*/
/* disabled rating */
.ui.disabled.rating .icon {
  cursor: default;
}
/*-------------------
   User Interactive
--------------------*/
/* Selected Rating */
.ui.rating.selected .active.icon {
  opacity: 1;
}
.ui.rating.selected .icon.selected,
.ui.rating .icon.selected {
  opacity: 1;
}
/*******************************
          Variations
*******************************/
.ui.mini.rating {
  font-size: 0.78571429rem;
}
.ui.tiny.rating {
  font-size: 0.85714286rem;
}
.ui.small.rating {
  font-size: 0.92857143rem;
}
.ui.rating {
  font-size: 1rem;
}
.ui.large.rating {
  font-size: 1.14285714rem;
}
.ui.huge.rating {
  font-size: 1.42857143rem;
}
.ui.massive.rating {
  font-size: 2rem;
}
/*******************************
         Theme Overrides
*******************************/
@font-face {
  font-family: 'Rating';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff');
  font-weight: normal;
  font-style: normal;
}
.ui.rating .icon {
  font-family: 'Rating';
  line-height: 1;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
/* Empty Star */
.ui.rating .icon:before {
  content: '\\f005';
}
/* Active Star */
.ui.rating .active.icon:before {
  content: '\\f005';
}
/*-------------------
        Star
--------------------*/
/* Unfilled Star */
.ui.star.rating .icon:before {
  content: '\\f005';
}
/* Active Star */
.ui.star.rating .active.icon:before {
  content: '\\f005';
}
/* Partial */
.ui.star.rating .partial.icon:before {
  content: '\\f006';
}
.ui.star.rating .partial.icon {
  content: '\\f005';
}
/*-------------------
        Heart
--------------------*/
/* Empty Heart
.ui.heart.rating .icon:before {
  content: '\\f08a';
}
*/
.ui.heart.rating .icon:before {
  content: '\\f004';
}
/* Active */
.ui.heart.rating .active.icon:before {
  content: '\\f004';
}
/*!
 * # Semantic UI - Search
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Search
*******************************/
/* Search Prompt */
/* Mobile */
/* Result Box */
/* Result */
/* Result Image */
/* Result Content */
/* Description */
/* Price */
/* Special Message */
/* All Results Link */
/*******************************
            States
*******************************/
/* Focus */
/* Hover */
/* Loading */
/* Active Category */
/* Active Result */
/*******************************
            Types
*******************************/
/* Selection */
/* Category */
/* Packaged Theme */
/*******************************
            Search
*******************************/
/* Search Prompt */
/* Mobile */
/* Result Box */
/* Result */
/* Result Image */
/* Result Content */
/* Description */
/* Price */
/* Special Message */
/* All Results Link */
/*******************************
            States
*******************************/
/* Focus */
/* Hover */
/* Loading */
/* Active Category */
/* Active Result */
/*******************************
            Types
*******************************/
/* Selection */
/* Category */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
             Search
*******************************/
.ui.search {
  position: relative;
}
.ui.search > .prompt {
  margin: 0em;
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-shadow: none;
  font-style: normal;
  font-weight: normal;
  line-height: 1.21428571em;
  padding: 0.67857143em 1em;
  font-size: 1em;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.87);
  box-shadow: 0em 0em 0em 0em transparent inset;
  transition: background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, border-color 0.1s ease;
}
.ui.search .prompt {
  border-radius: 500rem;
}
/*--------------
     Icon
---------------*/
.ui.search .prompt ~ .search.icon {
  cursor: pointer;
}
/*--------------
    Results
---------------*/
.ui.search > .results {
  display: none;
  position: absolute;
  top: 100%;
  left: 0%;
  transform-origin: center top;
  white-space: normal;
  text-align: left;
  text-transform: none;
  background: #FFFFFF;
  margin-top: 0.5em;
  width: 18em;
  border-radius: 0.28571429rem;
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);
  border: 1px solid #D4D4D5;
  z-index: 998;
}
.ui.search > .results > :first-child {
  border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.search > .results > :last-child {
  border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
/*--------------
    Result
---------------*/
.ui.search > .results .result {
  cursor: pointer;
  display: block;
  overflow: hidden;
  font-size: 1em;
  padding: 0.85714286em 1.14285714em;
  color: rgba(255, 255, 255, 0.87);
  line-height: 1.33;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.ui.search > .results .result:last-child {
  border-bottom: none !important;
}
/* Image */
.ui.search > .results .result .image {
  float: right;
  overflow: hidden;
  background: none;
  width: 5em;
  height: 3em;
  border-radius: 0.25em;
}
.ui.search > .results .result .image img {
  display: block;
  width: auto;
  height: 100%;
}
/*--------------
      Info
---------------*/
.ui.search > .results .result .image + .content {
  margin: 0em 6em 0em 0em;
}
.ui.search > .results .result .title {
  margin: -0.14285714em 0em 0em;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1em;
  color: rgba(255, 255, 255, 0.85);
}
.ui.search > .results .result .description {
  margin-top: 0;
  font-size: 0.92857143em;
  color: rgba(255, 255, 255, 0.4);
}
.ui.search > .results .result .price {
  float: right;
  color: #21BA45;
}
/*--------------
    Message
---------------*/
.ui.search > .results > .message {
  padding: 1em 1em;
}
.ui.search > .results > .message .header {
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.87);
}
.ui.search > .results > .message .description {
  margin-top: 0.25rem;
  font-size: 1em;
  color: rgba(255, 255, 255, 0.87);
}
/* View All Results */
.ui.search > .results > .action {
  display: block;
  border-top: none;
  background: #F3F4F5;
  padding: 0.92857143em 1em;
  color: rgba(255, 255, 255, 0.87);
  font-weight: bold;
  text-align: center;
}
/*******************************
            States
*******************************/
/*--------------------
       Focus
---------------------*/
.ui.search > .prompt:focus {
  border-color: rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.95);
}
/*--------------------
       Loading
---------------------*/
.ui.loading.search .input > i.icon:before {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.ui.loading.search .input > i.icon:after {
  position: absolute;
  content: '';
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  animation: button-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
/*--------------
      Hover
---------------*/
.ui.search > .results .result:hover,
.ui.category.search > .results .category .result:hover {
  background: #F9FAFB;
}
.ui.search .action:hover {
  background: #E0E0E0;
}
/*--------------
      Active
---------------*/
.ui.category.search > .results .category.active {
  background: #F3F4F5;
}
.ui.category.search > .results .category.active > .name {
  color: rgba(255, 255, 255, 0.87);
}
.ui.search > .results .result.active,
.ui.category.search > .results .category .result.active {
  position: relative;
  border-left-color: rgba(255, 255, 255, 0.1);
  background: #F3F4F5;
  box-shadow: none;
}
.ui.search > .results .result.active .title {
  color: rgba(255, 255, 255, 0.85);
}
.ui.search > .results .result.active .description {
  color: rgba(255, 255, 255, 0.85);
}
/*--------------------
        Disabled
----------------------*/
/* Disabled */
.ui.disabled.search {
  cursor: default;
  pointer-events: none;
  opacity: 0.45;
}
/*******************************
           Types
*******************************/
/*--------------
    Selection
---------------*/
.ui.search.selection .prompt {
  border-radius: 0.28571429rem;
}
/* Remove input */
.ui.search.selection > .icon.input > .remove.icon {
  pointer-events: none;
  position: absolute;
  left: auto;
  opacity: 0;
  color: '';
  top: 0em;
  right: 0em;
  transition: color 0.1s ease, opacity 0.1s ease;
}
.ui.search.selection > .icon.input > .active.remove.icon {
  cursor: pointer;
  opacity: 0.8;
  pointer-events: auto;
}
.ui.search.selection > .icon.input:not([class*="left icon"]) > .icon ~ .remove.icon {
  right: 1.85714em;
}
.ui.search.selection > .icon.input > .remove.icon:hover {
  opacity: 1;
  color: #DB2828;
}
/*--------------
    Category
---------------*/
.ui.category.search .results {
  width: 28em;
}
.ui.category.search .results.animating,
.ui.category.search .results.visible {
  display: table;
}
/* Category */
.ui.category.search > .results .category {
  display: table-row;
  background: #F3F4F5;
  box-shadow: none;
  transition: background 0.1s ease, border-color 0.1s ease;
}
/* Last Category */
.ui.category.search > .results .category:last-child {
  border-bottom: none;
}
/* First / Last */
.ui.category.search > .results .category:first-child .name + .result {
  border-radius: 0em 0.28571429rem 0em 0em;
}
.ui.category.search > .results .category:last-child .result:last-child {
  border-radius: 0em 0em 0.28571429rem 0em;
}
/* Category Result Name */
.ui.category.search > .results .category > .name {
  display: table-cell;
  text-overflow: ellipsis;
  width: 100px;
  white-space: nowrap;
  background: transparent;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 1em;
  padding: 0.4em 1em;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
/* Category Result */
.ui.category.search > .results .category .results {
  display: table-cell;
  background: #FFFFFF;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.ui.category.search > .results .category .result {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.1s ease, border-color 0.1s ease;
  padding: 0.85714286em 1.14285714em;
}
/*******************************
           Variations
*******************************/
/*-------------------
     Left / Right
--------------------*/
.ui[class*="left aligned"].search > .results {
  right: auto;
  left: 0%;
}
.ui[class*="right aligned"].search > .results {
  right: 0%;
  left: auto;
}
/*--------------
    Fluid
---------------*/
.ui.fluid.search .results {
  width: 100%;
}
/*--------------
      Sizes
---------------*/
.ui.mini.search {
  font-size: 0.78571429em;
}
.ui.small.search {
  font-size: 0.92857143em;
}
.ui.search {
  font-size: 1em;
}
.ui.large.search {
  font-size: 1.14285714em;
}
.ui.big.search {
  font-size: 1.28571429em;
}
.ui.huge.search {
  font-size: 1.42857143em;
}
.ui.massive.search {
  font-size: 1.71428571em;
}
/*--------------
      Mobile
---------------*/
@media only screen and (max-width: 767px) {
  .ui.search .results {
    max-width: calc(100vw - 2rem);
  }
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Shape
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Shape
*******************************/
/* Animating */
/* Side */
/*--------------
      Types
---------------*/
/* Cube */
/* Packaged Theme */
/*******************************
             Shape
*******************************/
/* Animating */
/* Side */
/*--------------
      Types
---------------*/
/* Cube */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
              Shape
*******************************/
.ui.shape {
  position: relative;
  vertical-align: top;
  display: inline-block;
  perspective: 2000px;
  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;
}
.ui.shape .sides {
  transform-style: preserve-3d;
}
.ui.shape .side {
  opacity: 1;
  width: 100%;
  margin: 0em !important;
  backface-visibility: hidden;
}
.ui.shape .side {
  display: none;
}
.ui.shape .side * {
  backface-visibility: visible !important;
}
/*******************************
             Types
*******************************/
.ui.cube.shape .side {
  min-width: 15em;
  height: 15em;
  padding: 2em;
  background-color: #E6E6E6;
  color: rgba(255, 255, 255, 0.87);
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
}
.ui.cube.shape .side > .content {
  width: 100%;
  height: 100%;
  display: table;
  text-align: center;
  user-select: text;
}
.ui.cube.shape .side > .content > div {
  display: table-cell;
  vertical-align: middle;
  font-size: 2em;
}
/*******************************
          Variations
*******************************/
.ui.text.shape.animating .sides {
  position: static;
}
.ui.text.shape .side {
  white-space: nowrap;
}
.ui.text.shape .side > * {
  white-space: normal;
}
/*******************************
             States
*******************************/
/*--------------
    Loading
---------------*/
.ui.loading.shape {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
/*--------------
    Animating
---------------*/
.ui.shape .animating.side {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  z-index: 100;
}
.ui.shape .hidden.side {
  opacity: 0.6;
}
/*--------------
      CSS
---------------*/
.ui.shape.animating .sides {
  position: absolute;
}
.ui.shape.animating .sides {
  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;
}
.ui.shape.animating .side {
  transition: opacity 0.6s ease-in-out;
}
/*--------------
     Active
---------------*/
.ui.shape .active.side {
  display: block;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Sidebar
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
             Sidebar
*******************************/
/*-------------------
       Content
--------------------*/
/* Animation */
/* Dimmer */
/* Color below page */
/* Shadow */
/* Layering */
/*-------------------
      Variations
--------------------*/
/* Width */
/* Height */
/* Packaged Theme */
/*******************************
             Sidebar
*******************************/
/*-------------------
       Content
--------------------*/
/* Animation */
/* Dimmer */
/* Color below page */
/* Shadow */
/* Layering */
/*-------------------
      Variations
--------------------*/
/* Width */
/* Height */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Sidebar
*******************************/
/* Sidebar Menu */
.ui.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  transition: none;
  will-change: transform;
  transform: translate3d(0, 0, 0);
  visibility: hidden;
  -webkit-overflow-scrolling: touch;
  height: 100% !important;
  max-height: 100%;
  border-radius: 0em !important;
  margin: 0em !important;
  overflow-y: auto !important;
  z-index: 102;
}
/* GPU Layers for Child Elements */
.ui.sidebar > * {
  backface-visibility: hidden;
}
/*--------------
   Direction
---------------*/
.ui.left.sidebar {
  right: auto;
  left: 0px;
  transform: translate3d(-100%, 0, 0);
}
.ui.right.sidebar {
  right: 0px !important;
  left: auto !important;
  transform: translate3d(100%, 0%, 0);
}
.ui.top.sidebar,
.ui.bottom.sidebar {
  width: 100% !important;
  height: auto !important;
}
.ui.top.sidebar {
  top: 0px !important;
  bottom: auto !important;
  transform: translate3d(0, -100%, 0);
}
.ui.bottom.sidebar {
  top: auto !important;
  bottom: 0px !important;
  transform: translate3d(0, 100%, 0);
}
/*--------------
     Pushable
---------------*/
.pushable {
  height: 100%;
  overflow-x: hidden;
  padding: 0em !important;
}
/* Whole Page */
body.pushable {
  background: #545454 !important;
}
/* Page Context */
.pushable:not(body) {
  transform: translate3d(0, 0, 0);
}
.pushable:not(body) > .ui.sidebar,
.pushable:not(body) > .fixed,
.pushable:not(body) > .pusher:after {
  position: absolute;
}
/*--------------
     Fixed
---------------*/
.pushable > .fixed {
  position: fixed;
  backface-visibility: hidden;
  transition: transform 500ms ease;
  will-change: transform;
  z-index: 101;
}
/*--------------
     Page
---------------*/
.pushable > .pusher {
  position: relative;
  backface-visibility: hidden;
  overflow: hidden;
  min-height: 100%;
  transition: transform 500ms ease;
  z-index: 2;
}
body.pushable > .pusher {
  background: #FFFFFF;
}
/* Pusher should inherit background from context */
.pushable > .pusher {
  background: inherit;
}
/*--------------
     Dimmer
---------------*/
.pushable > .pusher:after {
  position: fixed;
  top: 0px;
  right: 0px;
  content: '';
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  opacity: 0;
  transition: opacity 500ms;
  will-change: opacity;
  z-index: 1000;
}
/*--------------
    Coupling
---------------*/
.ui.sidebar.menu .item {
  border-radius: 0em !important;
}
/*******************************
            States
*******************************/
/*--------------
     Dimmed
---------------*/
.pushable > .pusher.dimmed:after {
  width: 100% !important;
  height: 100% !important;
  opacity: 1 !important;
}
/*--------------
    Animating
---------------*/
.ui.animating.sidebar {
  visibility: visible;
}
/*--------------
     Visible
---------------*/
.ui.visible.sidebar {
  visibility: visible;
  transform: translate3d(0, 0, 0);
}
/* Shadow Direction */
.ui.left.visible.sidebar,
.ui.right.visible.sidebar {
  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.15);
}
.ui.top.visible.sidebar,
.ui.bottom.visible.sidebar {
  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.15);
}
/* Visible On Load */
.ui.visible.left.sidebar ~ .fixed,
.ui.visible.left.sidebar ~ .pusher {
  transform: translate3d(260px, 0, 0);
}
.ui.visible.right.sidebar ~ .fixed,
.ui.visible.right.sidebar ~ .pusher {
  transform: translate3d(-260px, 0, 0);
}
.ui.visible.top.sidebar ~ .fixed,
.ui.visible.top.sidebar ~ .pusher {
  transform: translate3d(0, 36px, 0);
}
.ui.visible.bottom.sidebar ~ .fixed,
.ui.visible.bottom.sidebar ~ .pusher {
  transform: translate3d(0, -36px, 0);
}
/* opposite sides visible forces content overlay */
.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,
.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,
.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,
.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {
  transform: translate3d(0, 0, 0);
}
/*--------------
       iOS
---------------*/
/*******************************
          Variations
*******************************/
/*--------------
     Width
---------------*/
/* Left / Right */
.ui.thin.left.sidebar,
.ui.thin.right.sidebar {
  width: 150px;
}
.ui[class*="very thin"].left.sidebar,
.ui[class*="very thin"].right.sidebar {
  width: 60px;
}
.ui.left.sidebar,
.ui.right.sidebar {
  width: 260px;
}
.ui.wide.left.sidebar,
.ui.wide.right.sidebar {
  width: 350px;
}
.ui[class*="very wide"].left.sidebar,
.ui[class*="very wide"].right.sidebar {
  width: 475px;
}
/* Left Visible */
.ui.visible.thin.left.sidebar ~ .fixed,
.ui.visible.thin.left.sidebar ~ .pusher {
  transform: translate3d(150px, 0, 0);
}
.ui.visible[class*="very thin"].left.sidebar ~ .fixed,
.ui.visible[class*="very thin"].left.sidebar ~ .pusher {
  transform: translate3d(60px, 0, 0);
}
.ui.visible.wide.left.sidebar ~ .fixed,
.ui.visible.wide.left.sidebar ~ .pusher {
  transform: translate3d(350px, 0, 0);
}
.ui.visible[class*="very wide"].left.sidebar ~ .fixed,
.ui.visible[class*="very wide"].left.sidebar ~ .pusher {
  transform: translate3d(475px, 0, 0);
}
/* Right Visible */
.ui.visible.thin.right.sidebar ~ .fixed,
.ui.visible.thin.right.sidebar ~ .pusher {
  transform: translate3d(-150px, 0, 0);
}
.ui.visible[class*="very thin"].right.sidebar ~ .fixed,
.ui.visible[class*="very thin"].right.sidebar ~ .pusher {
  transform: translate3d(-60px, 0, 0);
}
.ui.visible.wide.right.sidebar ~ .fixed,
.ui.visible.wide.right.sidebar ~ .pusher {
  transform: translate3d(-350px, 0, 0);
}
.ui.visible[class*="very wide"].right.sidebar ~ .fixed,
.ui.visible[class*="very wide"].right.sidebar ~ .pusher {
  transform: translate3d(-475px, 0, 0);
}
/*******************************
          Animations
*******************************/
/*--------------
    Overlay
---------------*/
/* Set-up */
.ui.overlay.sidebar {
  z-index: 102;
}
/* Initial */
.ui.left.overlay.sidebar {
  transform: translate3d(-100%, 0%, 0);
}
.ui.right.overlay.sidebar {
  transform: translate3d(100%, 0%, 0);
}
.ui.top.overlay.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.ui.bottom.overlay.sidebar {
  transform: translate3d(0%, 100%, 0);
}
/* Animation */
.animating.ui.overlay.sidebar,
.ui.visible.overlay.sidebar {
  transition: transform 500ms ease;
}
/* End - Sidebar */
.ui.visible.left.overlay.sidebar {
  transform: translate3d(0%, 0%, 0);
}
.ui.visible.right.overlay.sidebar {
  transform: translate3d(0%, 0%, 0);
}
.ui.visible.top.overlay.sidebar {
  transform: translate3d(0%, 0%, 0);
}
.ui.visible.bottom.overlay.sidebar {
  transform: translate3d(0%, 0%, 0);
}
/* End - Pusher */
.ui.visible.overlay.sidebar ~ .fixed,
.ui.visible.overlay.sidebar ~ .pusher {
  transform: none !important;
}
/*--------------
      Push
---------------*/
/* Initial */
.ui.push.sidebar {
  transition: transform 500ms ease;
  z-index: 102;
}
/* Sidebar - Initial */
.ui.left.push.sidebar {
  transform: translate3d(-100%, 0, 0);
}
.ui.right.push.sidebar {
  transform: translate3d(100%, 0, 0);
}
.ui.top.push.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.ui.bottom.push.sidebar {
  transform: translate3d(0%, 100%, 0);
}
/* End */
.ui.visible.push.sidebar {
  transform: translate3d(0%, 0, 0);
}
/*--------------
    Uncover
---------------*/
/* Initial */
.ui.uncover.sidebar {
  transform: translate3d(0, 0, 0);
  z-index: 1;
}
/* End */
.ui.visible.uncover.sidebar {
  transform: translate3d(0, 0, 0);
  transition: transform 500ms ease;
}
/*--------------
   Slide Along
---------------*/
/* Initial */
.ui.slide.along.sidebar {
  z-index: 1;
}
/* Sidebar - Initial */
.ui.left.slide.along.sidebar {
  transform: translate3d(-50%, 0, 0);
}
.ui.right.slide.along.sidebar {
  transform: translate3d(50%, 0, 0);
}
.ui.top.slide.along.sidebar {
  transform: translate3d(0, -50%, 0);
}
.ui.bottom.slide.along.sidebar {
  transform: translate3d(0%, 50%, 0);
}
/* Animation */
.ui.animating.slide.along.sidebar {
  transition: transform 500ms ease;
}
/* End */
.ui.visible.slide.along.sidebar {
  transform: translate3d(0%, 0, 0);
}
/*--------------
   Slide Out
---------------*/
/* Initial */
.ui.slide.out.sidebar {
  z-index: 1;
}
/* Sidebar - Initial */
.ui.left.slide.out.sidebar {
  transform: translate3d(50%, 0, 0);
}
.ui.right.slide.out.sidebar {
  transform: translate3d(-50%, 0, 0);
}
.ui.top.slide.out.sidebar {
  transform: translate3d(0%, 50%, 0);
}
.ui.bottom.slide.out.sidebar {
  transform: translate3d(0%, -50%, 0);
}
/* Animation */
.ui.animating.slide.out.sidebar {
  transition: transform 500ms ease;
}
/* End */
.ui.visible.slide.out.sidebar {
  transform: translate3d(0%, 0, 0);
}
/*--------------
   Scale Down
---------------*/
/* Initial */
.ui.scale.down.sidebar {
  transition: transform 500ms ease;
  z-index: 102;
}
/* Sidebar - Initial  */
.ui.left.scale.down.sidebar {
  transform: translate3d(-100%, 0, 0);
}
.ui.right.scale.down.sidebar {
  transform: translate3d(100%, 0, 0);
}
.ui.top.scale.down.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.ui.bottom.scale.down.sidebar {
  transform: translate3d(0%, 100%, 0);
}
/* Pusher - Initial */
.ui.scale.down.left.sidebar ~ .pusher {
  transform-origin: 75% 50%;
}
.ui.scale.down.right.sidebar ~ .pusher {
  transform-origin: 25% 50%;
}
.ui.scale.down.top.sidebar ~ .pusher {
  transform-origin: 50% 75%;
}
.ui.scale.down.bottom.sidebar ~ .pusher {
  transform-origin: 50% 25%;
}
/* Animation */
.ui.animating.scale.down > .visible.ui.sidebar {
  transition: transform 500ms ease;
}
.ui.visible.scale.down.sidebar ~ .pusher,
.ui.animating.scale.down.sidebar ~ .pusher {
  display: block !important;
  width: 100%;
  height: 100%;
  overflow: hidden !important;
}
/* End */
.ui.visible.scale.down.sidebar {
  transform: translate3d(0, 0, 0);
}
.ui.visible.scale.down.sidebar ~ .pusher {
  transform: scale(0.75);
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Sticky
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
            Sticky
*******************************/
/* Packaged Theme */
/*******************************
            Sticky
*******************************/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
            Sticky
*******************************/
.ui.sticky {
  position: static;
  transition: none;
  z-index: 800;
}
/*******************************
            States
*******************************/
/* Bound */
.ui.sticky.bound {
  position: absolute;
  left: auto;
  right: auto;
}
/* Fixed */
.ui.sticky.fixed {
  position: fixed;
  left: auto;
  right: auto;
}
/* Bound/Fixed Position */
.ui.sticky.bound.top,
.ui.sticky.fixed.top {
  top: 0px;
  bottom: auto;
}
.ui.sticky.bound.bottom,
.ui.sticky.fixed.bottom {
  top: auto;
  bottom: 0px;
}
/*******************************
            Types
*******************************/
.ui.native.sticky {
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
}
/*******************************
         Theme Overrides
*******************************/
/*!
 * # Semantic UI - Tab
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
              Tab
*******************************/
/* Loading */
/* Packaged Theme */
/*******************************
              Tab
*******************************/
/* Loading */
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
           UI Tabs
*******************************/
.ui.tab {
  display: none;
}
/*******************************
             States
*******************************/
/*--------------------
       Active
---------------------*/
.ui.tab.active,
.ui.tab.open {
  display: block;
}
/*--------------------
       Loading
---------------------*/
.ui.tab.loading {
  position: relative;
  overflow: hidden;
  display: block;
  min-height: 250px;
}
.ui.tab.loading * {
  position: relative !important;
  left: -10000px !important;
}
.ui.tab.loading:before,
.ui.tab.loading.segment:before {
  position: absolute;
  content: '';
  top: 100px;
  left: 50%;
  margin: -1.25em 0em 0em -1.25em;
  width: 2.5em;
  height: 2.5em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.ui.tab.loading:after,
.ui.tab.loading.segment:after {
  position: absolute;
  content: '';
  top: 100px;
  left: 50%;
  margin: -1.25em 0em 0em -1.25em;
  width: 2.5em;
  height: 2.5em;
  animation: button-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-radius: 500rem;
  border-color: #767676 transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
/*******************************
         Tab Overrides
*******************************/
/*!
 * # Semantic UI - Transition
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
/*******************************
            Theme
*******************************/
/*

████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗
╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝
   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗
   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║
   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║
   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

*/
/*******************************
        Theme Selection
*******************************/
/* To override a theme for an individual element
   specify theme name below
*/
/* Global */
/* Elements */
/* Collections */
/* Modules */
/* Views */
/*******************************
            Folders
*******************************/
/* Path to theme packages */
/* Path to site override folder */
/*******************************
         Import Theme
*******************************/
/*******************************
        Import Directives
*******************************/
/*------------------
       Theme
-------------------*/
/*--------------------
   Site Variables
---------------------*/
/* Default site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Packaged site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Component's site.variables */
/*******************************
         Site Settings
*******************************/
/*-------------------
       Fonts
--------------------*/
/*-------------------
      Base Sizes
--------------------*/
/* This is the single variable that controls them all */
/* The size of page text  */
/*-------------------
    Border Radius
--------------------*/
/* See Power-user section below
   for explanation of @px variables
*/
/*-------------------
    Brand Colors
--------------------*/
/*--------------
  Page Heading
---------------*/
/*--------------
   Form Input
---------------*/
/* This adjusts the default form input across all elements */
/* Input Text Color */
/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */
/*-------------------
    Focused Input
--------------------*/
/* Used on inputs, textarea etc */
/* Used on dropdowns, other larger blocks */
/*-------------------
        Sizes
--------------------*/
/*
  Sizes are all expressed in terms of 14px/em (default em)
  This ensures these "ratios" remain constant despite changes in EM
*/
/*-------------------
        Page
--------------------*/
/*-------------------
      Paragraph
--------------------*/
/*-------------------
       Links
--------------------*/
/*-------------------
    Scroll Bars
--------------------*/
/* Inverted */
/*-------------------
  Highlighted Text
--------------------*/
/*-------------------
       Loader
--------------------*/
/*-------------------
        Grid
--------------------*/
/*-------------------
     Transitions
--------------------*/
/*-------------------
     Breakpoints
--------------------*/
/*-------------------
      Site Colors
--------------------*/
/*---  Colors  ---*/
/*---  Light Colors  ---*/
/*---   Neutrals  ---*/
/*--- Colored Backgrounds ---*/
/*--- Colored Headers ---*/
/*--- Colored Text ---*/
/*--- Colored Border ---*/
/*-------------------
     Alpha Colors
--------------------*/
/*-------------------
       Accents
--------------------*/
/* Differentiating Neutrals */
/* Differentiating Layers */
/*******************************
           Power-User
*******************************/
/*-------------------
    Emotive Colors
--------------------*/
/* Positive */
/* Negative */
/* Info */
/* Warning */
/*-------------------
        Paths
--------------------*/
/* For source only. Modified in gulp for dist */
/*-------------------
       Em Sizes
--------------------*/
/*
  This rounds @size values to the closest pixel then expresses that value in (r)em.
  This ensures all size values round to exact pixels
*/
/* em */
/* rem */
/*-------------------
       Icons
--------------------*/
/* Maximum Glyph Width of Icon */
/*-------------------
     Neutral Text
--------------------*/
/*-------------------
     Brand Colors
--------------------*/
/*-------------------
      Borders
--------------------*/
/*-------------------
    Derived Values
--------------------*/
/* Loaders Position Offset */
/* Rendered Scrollbar Width */
/* Maximum Single Character Glyph Width, aka Capital "W" */
/* Used to match floats with text */
/* Header Spacing */
/* Minimum Mobile Width */
/* Positive / Negative Dupes */
/* Responsive */
/*-------------------
  Exact Pixel Values
--------------------*/
/*
  These are used to specify exact pixel values in em
  for things like borders that remain constantly
  sized as emSize adjusts

  Since there are many more sizes than names for sizes,
  these are named by their original pixel values.

*/
/* Columns */
/*******************************
             States
*******************************/
/*-------------------
      Disabled
--------------------*/
/*-------------------
        Hover
--------------------*/
/*---  Shadows  ---*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Focus
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
    Down (:active)
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/*-------------------
        Active
--------------------*/
/*---  Colors  ---*/
/*---  Emotive  ---*/
/*---  Brand   ---*/
/*---  Dark Tones  ---*/
/*---  Light Tones  ---*/
/* Site theme site.variables */
/*-------------------
 Component Variables
---------------------*/
/* Default */
/*******************************
          Transition
*******************************/
/* Packaged Theme */
/*******************************
          Transition
*******************************/
/* Site Theme */
/*******************************
             Mix-ins
*******************************/
/*------------------
       Fonts
-------------------*/
/*------------------
     Overrides
-------------------*/
/* End Config */
/*******************************
          Transitions
*******************************/
.transition {
  animation-iteration-count: 1;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: both;
}
/*******************************
            States
*******************************/
/* Animating */
.animating.transition {
  backface-visibility: hidden;
  visibility: visible !important;
}
/* Loading */
.loading.transition {
  position: absolute;
  top: -99999px;
  left: -99999px;
}
/* Hidden */
.hidden.transition {
  display: none;
  visibility: hidden;
}
/* Visible */
.visible.transition {
  display: block !important;
  visibility: visible !important;
  /*  backface-visibility: @backfaceVisibility;
  transform: @use3DAcceleration;*/
}
/* Disabled */
.disabled.transition {
  animation-play-state: paused;
}
/*******************************
          Variations
*******************************/
.looping.transition {
  animation-iteration-count: infinite;
}
/*******************************
          Transitions
*******************************/
/*
  Some transitions adapted from Animate CSS
  https://github.com/daneden/animate.css

  Additional transitions adapted from Glide
  by Nick Pettit - https://github.com/nickpettit/glide
*/
/*--------------
     Browse
---------------*/
.transition.browse {
  animation-duration: 500ms;
}
.transition.browse.in {
  animation-name: browseIn;
}
.transition.browse.out,
.transition.browse.left.out {
  animation-name: browseOutLeft;
}
.transition.browse.right.out {
  animation-name: browseOutRight;
}
/* In */
@keyframes browseIn {
  0% {
    transform: scale(0.8) translateZ(0px);
    z-index: -1;
  }
  10% {
    transform: scale(0.8) translateZ(0px);
    z-index: -1;
    opacity: 0.7;
  }
  80% {
    transform: scale(1.05) translateZ(0px);
    opacity: 1;
    z-index: 999;
  }
  100% {
    transform: scale(1) translateZ(0px);
    z-index: 999;
  }
}
/* Out */
@keyframes browseOutLeft {
  0% {
    z-index: 999;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg);
  }
  50% {
    z-index: -1;
    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);
  }
  80% {
    opacity: 1;
  }
  100% {
    z-index: -1;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);
    opacity: 0;
  }
}
@keyframes browseOutRight {
  0% {
    z-index: 999;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg);
  }
  50% {
    z-index: 1;
    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);
  }
  80% {
    opacity: 1;
  }
  100% {
    z-index: 1;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);
    opacity: 0;
  }
}
/*--------------
     Drop
---------------*/
.drop.transition {
  transform-origin: top center;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);
}
.drop.transition.in {
  animation-name: dropIn;
}
.drop.transition.out {
  animation-name: dropOut;
}
/* Drop */
@keyframes dropIn {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes dropOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
/*--------------
      Fade
---------------*/
.transition.fade.in {
  animation-name: fadeIn;
}
.transition[class*="fade up"].in {
  animation-name: fadeInUp;
}
.transition[class*="fade down"].in {
  animation-name: fadeInDown;
}
.transition[class*="fade left"].in {
  animation-name: fadeInLeft;
}
.transition[class*="fade right"].in {
  animation-name: fadeInRight;
}
.transition.fade.out {
  animation-name: fadeOut;
}
.transition[class*="fade up"].out {
  animation-name: fadeOutUp;
}
.transition[class*="fade down"].out {
  animation-name: fadeOutDown;
}
.transition[class*="fade left"].out {
  animation-name: fadeOutLeft;
}
.transition[class*="fade right"].out {
  animation-name: fadeOutRight;
}
/* In */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(-10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
/* Out */
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(5%);
  }
}
@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(-5%);
  }
}
@keyframes fadeOutLeft {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  100% {
    opacity: 0;
    transform: translateX(5%);
  }
}
@keyframes fadeOutRight {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  100% {
    opacity: 0;
    transform: translateX(-5%);
  }
}
/*--------------
     Flips
---------------*/
.flip.transition.in,
.flip.transition.out {
  animation-duration: 600ms;
}
.horizontal.flip.transition.in {
  animation-name: horizontalFlipIn;
}
.horizontal.flip.transition.out {
  animation-name: horizontalFlipOut;
}
.vertical.flip.transition.in {
  animation-name: verticalFlipIn;
}
.vertical.flip.transition.out {
  animation-name: verticalFlipOut;
}
/* In */
@keyframes horizontalFlipIn {
  0% {
    transform: perspective(2000px) rotateY(-90deg);
    opacity: 0;
  }
  100% {
    transform: perspective(2000px) rotateY(0deg);
    opacity: 1;
  }
}
@keyframes verticalFlipIn {
  0% {
    transform: perspective(2000px) rotateX(-90deg);
    opacity: 0;
  }
  100% {
    transform: perspective(2000px) rotateX(0deg);
    opacity: 1;
  }
}
/* Out */
@keyframes horizontalFlipOut {
  0% {
    transform: perspective(2000px) rotateY(0deg);
    opacity: 1;
  }
  100% {
    transform: perspective(2000px) rotateY(90deg);
    opacity: 0;
  }
}
@keyframes verticalFlipOut {
  0% {
    transform: perspective(2000px) rotateX(0deg);
    opacity: 1;
  }
  100% {
    transform: perspective(2000px) rotateX(-90deg);
    opacity: 0;
  }
}
/*--------------
      Scale
---------------*/
.scale.transition.in {
  animation-name: scaleIn;
}
.scale.transition.out {
  animation-name: scaleOut;
}
@keyframes scaleIn {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
/* Out */
@keyframes scaleOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}
/*--------------
      Fly
---------------*/
/* Inward */
.transition.fly {
  animation-duration: 0.6s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
.transition.fly.in {
  animation-name: flyIn;
}
.transition[class*="fly up"].in {
  animation-name: flyInUp;
}
.transition[class*="fly down"].in {
  animation-name: flyInDown;
}
.transition[class*="fly left"].in {
  animation-name: flyInLeft;
}
.transition[class*="fly right"].in {
  animation-name: flyInRight;
}
/* Outward */
.transition.fly.out {
  animation-name: flyOut;
}
.transition[class*="fly up"].out {
  animation-name: flyOutUp;
}
.transition[class*="fly down"].out {
  animation-name: flyOutDown;
}
.transition[class*="fly left"].out {
  animation-name: flyOutLeft;
}
.transition[class*="fly right"].out {
  animation-name: flyOutRight;
}
/* In */
@keyframes flyIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
@keyframes flyInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 1500px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes flyInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -1500px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  100% {
    transform: none;
  }
}
@keyframes flyInLeft {
  0% {
    opacity: 0;
    transform: translate3d(1500px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
@keyframes flyInRight {
  0% {
    opacity: 0;
    transform: translate3d(-1500px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
/* Out */
@keyframes flyOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  50%,
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  100% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
@keyframes flyOutUp {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
@keyframes flyOutDown {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes flyOutRight {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes flyOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
/*--------------
     Slide
---------------*/
.transition.slide.in,
.transition[class*="slide down"].in {
  animation-name: slideInY;
  transform-origin: top center;
}
.transition[class*="slide up"].in {
  animation-name: slideInY;
  transform-origin: bottom center;
}
.transition[class*="slide left"].in {
  animation-name: slideInX;
  transform-origin: center right;
}
.transition[class*="slide right"].in {
  animation-name: slideInX;
  transform-origin: center left;
}
.transition.slide.out,
.transition[class*="slide down"].out {
  animation-name: slideOutY;
  transform-origin: top center;
}
.transition[class*="slide up"].out {
  animation-name: slideOutY;
  transform-origin: bottom center;
}
.transition[class*="slide left"].out {
  animation-name: slideOutX;
  transform-origin: center right;
}
.transition[class*="slide right"].out {
  animation-name: slideOutX;
  transform-origin: center left;
}
/* In */
@keyframes slideInY {
  0% {
    opacity: 0;
    transform: scaleY(0);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes slideInX {
  0% {
    opacity: 0;
    transform: scaleX(0);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}
/* Out */
@keyframes slideOutY {
  0% {
    opacity: 1;
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
    transform: scaleY(0);
  }
}
@keyframes slideOutX {
  0% {
    opacity: 1;
    transform: scaleX(1);
  }
  100% {
    opacity: 0;
    transform: scaleX(0);
  }
}
/*--------------
     Swing
---------------*/
.transition.swing {
  animation-duration: 800ms;
}
.transition[class*="swing down"].in {
  animation-name: swingInX;
  transform-origin: top center;
}
.transition[class*="swing up"].in {
  animation-name: swingInX;
  transform-origin: bottom center;
}
.transition[class*="swing left"].in {
  animation-name: swingInY;
  transform-origin: center right;
}
.transition[class*="swing right"].in {
  animation-name: swingInY;
  transform-origin: center left;
}
.transition.swing.out,
.transition[class*="swing down"].out {
  animation-name: swingOutX;
  transform-origin: top center;
}
.transition[class*="swing up"].out {
  animation-name: swingOutX;
  transform-origin: bottom center;
}
.transition[class*="swing left"].out {
  animation-name: swingOutY;
  transform-origin: center right;
}
.transition[class*="swing right"].out {
  animation-name: swingOutY;
  transform-origin: center left;
}
/* In */
@keyframes swingInX {
  0% {
    transform: perspective(1000px) rotateX(90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(1000px) rotateX(-30deg);
    opacity: 1;
  }
  60% {
    transform: perspective(1000px) rotateX(15deg);
  }
  80% {
    transform: perspective(1000px) rotateX(-7.5deg);
  }
  100% {
    transform: perspective(1000px) rotateX(0deg);
  }
}
@keyframes swingInY {
  0% {
    transform: perspective(1000px) rotateY(-90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(1000px) rotateY(30deg);
    opacity: 1;
  }
  60% {
    transform: perspective(1000px) rotateY(-17.5deg);
  }
  80% {
    transform: perspective(1000px) rotateY(7.5deg);
  }
  100% {
    transform: perspective(1000px) rotateY(0deg);
  }
}
/* Out */
@keyframes swingOutX {
  0% {
    transform: perspective(1000px) rotateX(0deg);
  }
  40% {
    transform: perspective(1000px) rotateX(-7.5deg);
  }
  60% {
    transform: perspective(1000px) rotateX(17.5deg);
  }
  80% {
    transform: perspective(1000px) rotateX(-30deg);
    opacity: 1;
  }
  100% {
    transform: perspective(1000px) rotateX(90deg);
    opacity: 0;
  }
}
@keyframes swingOutY {
  0% {
    transform: perspective(1000px) rotateY(0deg);
  }
  40% {
    transform: perspective(1000px) rotateY(7.5deg);
  }
  60% {
    transform: perspective(1000px) rotateY(-10deg);
  }
  80% {
    transform: perspective(1000px) rotateY(30deg);
    opacity: 1;
  }
  100% {
    transform: perspective(1000px) rotateY(-90deg);
    opacity: 0;
  }
}
/*--------------
      Zoom
---------------*/
.transition.zoom.in {
  animation-name: zoomIn;
}
.transition.zoom.out {
  animation-name: zoomOut;
}
@keyframes zoomIn {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes zoomOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(0);
  }
}
/*******************************
       Static Animations
*******************************/
/*--------------
    Emphasis
---------------*/
.flash.transition {
  animation-duration: 750ms;
  animation-name: flash;
}
.shake.transition {
  animation-duration: 750ms;
  animation-name: shake;
}
.bounce.transition {
  animation-duration: 750ms;
  animation-name: bounce;
}
.tada.transition {
  animation-duration: 750ms;
  animation-name: tada;
}
.pulse.transition {
  animation-duration: 500ms;
  animation-name: pulse;
}
.jiggle.transition {
  animation-duration: 750ms;
  animation-name: jiggle;
}
.transition.glow {
  animation-duration: 2000ms;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
}
.transition.glow {
  animation-name: glow;
}
/* Flash */
@keyframes flash {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
/* Shake */
@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-10px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(10px);
  }
}
/* Bounce */
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
/* Tada */
@keyframes tada {
  0% {
    transform: scale(1);
  }
  10%,
  20% {
    transform: scale(0.9) rotate(-3deg);
  }
  30%,
  50%,
  70%,
  90% {
    transform: scale(1.1) rotate(3deg);
  }
  40%,
  60%,
  80% {
    transform: scale(1.1) rotate(-3deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
/* Pulse */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/* Jiggle */
@keyframes jiggle {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
/* Glow */
@keyframes glow {
  0% {
    background-color: #FCFCFD;
  }
  30% {
    background-color: #FFF6CD;
  }
  100% {
    background-color: #FCFCFD;
  }
}
`, "",{"version":3,"sources":["webpack://./src/semantic-ui/semantic.less","webpack://./src/semantic-ui/definitions/globals/reset.less","webpack://./src/semantic-ui/themes/default/globals/reset.overrides","webpack://./src/semantic-ui/definitions/globals/site.less","webpack://./src/semantic-ui/definitions/elements/button.less","webpack://./src/semantic-ui/definitions/elements/container.less","webpack://./src/semantic-ui/definitions/elements/divider.less","webpack://./src/semantic-ui/themes/default/elements/divider.overrides","webpack://./src/semantic-ui/definitions/elements/flag.less","webpack://./src/semantic-ui/themes/default/elements/flag.overrides","webpack://./src/semantic-ui/definitions/elements/header.less","webpack://./src/semantic-ui/definitions/elements/icon.less","webpack://./src/semantic-ui/themes/default/elements/icon.overrides","webpack://./src/semantic-ui/definitions/elements/image.less","webpack://./src/semantic-ui/definitions/elements/input.less","webpack://./src/semantic-ui/definitions/elements/label.less","webpack://./src/semantic-ui/definitions/elements/list.less","webpack://./src/semantic-ui/definitions/elements/loader.less","webpack://./src/semantic-ui/definitions/elements/placeholder.less","webpack://./src/semantic-ui/definitions/elements/rail.less","webpack://./src/semantic-ui/definitions/elements/reveal.less","webpack://./src/semantic-ui/definitions/elements/segment.less","webpack://./src/semantic-ui/definitions/elements/step.less","webpack://./src/semantic-ui/themes/default/elements/step.overrides","webpack://./src/semantic-ui/definitions/collections/breadcrumb.less","webpack://./src/semantic-ui/definitions/collections/form.less","webpack://./src/semantic-ui/definitions/collections/grid.less","webpack://./src/semantic-ui/definitions/collections/menu.less","webpack://./src/semantic-ui/definitions/collections/message.less","webpack://./src/semantic-ui/definitions/collections/table.less","webpack://./src/semantic-ui/definitions/views/ad.less","webpack://./src/semantic-ui/definitions/views/card.less","webpack://./src/semantic-ui/definitions/views/comment.less","webpack://./src/semantic-ui/definitions/views/feed.less","webpack://./src/semantic-ui/definitions/views/item.less","webpack://./src/semantic-ui/definitions/views/statistic.less","webpack://./src/semantic-ui/definitions/modules/accordion.less","webpack://./src/semantic-ui/themes/default/modules/accordion.overrides","webpack://./src/semantic-ui/definitions/modules/checkbox.less","webpack://./src/semantic-ui/themes/default/modules/checkbox.overrides","webpack://./src/semantic-ui/definitions/modules/dimmer.less","webpack://./src/semantic-ui/definitions/modules/dropdown.less","webpack://./src/semantic-ui/themes/default/modules/dropdown.overrides","webpack://./src/semantic-ui/definitions/modules/embed.less","webpack://./src/semantic-ui/definitions/modules/modal.less","webpack://./src/semantic-ui/definitions/modules/nag.less","webpack://./src/semantic-ui/definitions/modules/popup.less","webpack://./src/semantic-ui/definitions/modules/progress.less","webpack://./src/semantic-ui/definitions/modules/rating.less","webpack://./src/semantic-ui/themes/default/modules/rating.overrides","webpack://./src/semantic-ui/definitions/modules/search.less","webpack://./src/semantic-ui/definitions/modules/shape.less","webpack://./src/semantic-ui/definitions/modules/sidebar.less","webpack://./src/semantic-ui/definitions/modules/sticky.less","webpack://./src/semantic-ui/definitions/modules/tab.less","webpack://./src/semantic-ui/definitions/modules/transition.less","webpack://./src/semantic-ui/themes/default/modules/transition.overrides"],"names":[],"mappings":"AAAA;;;;;;;;;;CAUC;AACD,WAAW;AACX;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB;;+BAE+B;AAC/B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,eAAe;ACjnBf;;;EAGE,mBAAA;ADonBF;AClnBA;EACE,sBAAA;ADonBF;AACA,uBAAuB;ACjnBvB;;;;EACE,wBAAA;EACA,qBAAA;EDsnBA,wBAAwB;AAC1B;AACA,2EAA2E;AAC3E;+EAC+E;AAC/E;;;;EAIE;AExpBF;EACE,iBAAA;EF0pBA,MAAM;EEzpBN,0BAAA;EF2pBA,MAAM;EE1pBN,8BAAA;EF4pBA,MAAM;AACR;AACA;+EAC+E;AAC/E;;EAEE;AExpBF;EACE,SAAA;AF0pBF;AACA;;EAEE;AEtpBF;;;;;;EAME,cAAA;AFwpBF;AACA;;;EAGE;AEppBF;EACE,cAAA;EACA,gBAAA;AFspBF;AACA;+EAC+E;AAC/E;;;EAGE;AEjpBF;;;EFqpBE,MAAM;EElpBN,cAAA;AFopBF;AACA;;EAEE;AEhpBF;EACE,gBAAA;AFkpBF;AACA;;;EAGE;AE9oBF;EACE,uBAAA;EFgpBA,MAAM;EE/oBN,SAAA;EFipBA,MAAM;EEhpBN,iBAAA;EFkpBA,MAAM;AACR;AACA;;;EAGE;AE/oBF;EACE,iCAAA;EFipBA,MAAM;EEhpBN,cAAA;EFkpBA,MAAM;AACR;AACA;+EAC+E;AAC/E;;;EAGE;AE9oBF;EACE,6BAAA;EFgpBA,MAAM;EE/oBN,qCAAA;EFipBA,MAAM;AACR;AACA;;;EAGE;AE9oBF;EACE,mBAAA;EFgpBA,MAAM;EE/oBN,0BAAA;EFipBA,MAAM;EEhpBN,iCAAA;EFkpBA,MAAM;AACR;AACA;;EAEE;AE/oBF;;EAEE,oBAAA;AFipBF;AACA;;EAEE;AE7oBF;;EAEE,mBAAA;AF+oBF;AACA;;;EAGE;AE3oBF;;;EAGE,iCAAA;EF6oBA,MAAM;EE5oBN,cAAA;EF8oBA,MAAM;AACR;AACA;;EAEE;AE3oBF;EACE,kBAAA;AF6oBF;AACA;;EAEE;AEzoBF;EACE,sBAAA;EACA,WAAA;AF2oBF;AACA;;EAEE;AEvoBF;EACE,cAAA;AFyoBF;AACA;;;EAGE;AEroBF;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AFuoBF;AEpoBA;EACE,eAAA;AFsoBF;AEnoBA;EACE,WAAA;AFqoBF;AACA;+EAC+E;AAC/E;;EAEE;AEhoBF;;EAEE,qBAAA;AFkoBF;AACA;;EAEE;AE9nBF;EACE,aAAA;EACA,SAAA;AFgoBF;AACA;;EAEE;AE5nBF;EACE,kBAAA;AF8nBF;AACA;;EAEE;AE1nBF;EACE,gBAAA;AF4nBF;AACA;+EAC+E;AAC/E;;;EAGE;AEvnBF;;;;;EAKE,uBAAA;EFynBA,MAAM;EExnBN,eAAA;EF0nBA,MAAM;EEznBN,iBAAA;EF2nBA,MAAM;EE1nBN,SAAA;EF4nBA,MAAM;AACR;AACA;;;EAGE;AEznBF;;EF4nBE,MAAM;EE1nBN,iBAAA;AF4nBF;AACA;;;EAGE;AExnBF;;EF2nBE,MAAM;EEznBN,oBAAA;AF2nBF;AACA;;;;EAIE;AEvnBF;;;;EAIE,0BAAA;EFynBA,MAAM;AACR;AACA;;EAEE;AEtnBF;;;;EAIE,kBAAA;EACA,UAAA;AFwnBF;AACA;;EAEE;AEpnBF;;;;EAIE,8BAAA;AFsnBF;AACA;;EAEE;AElnBF;EACE,8BAAA;AFonBF;AACA;;;;;EAKE;AEhnBF;EACE,sBAAA;EFknBA,MAAM;EEjnBN,cAAA;EFmnBA,MAAM;EElnBN,cAAA;EFonBA,MAAM;EEnnBN,eAAA;EFqnBA,MAAM;EEpnBN,UAAA;EFsnBA,MAAM;EErnBN,mBAAA;EFunBA,MAAM;AACR;AACA;;;EAGE;AEpnBF;EACE,qBAAA;EFsnBA,MAAM;EErnBN,wBAAA;EFunBA,MAAM;AACR;AACA;;EAEE;AEpnBF;EACE,cAAA;AFsnBF;AACA;;;EAGE;AElnBF;;EAEE,sBAAA;EFonBA,MAAM;EEnnBN,UAAA;EFqnBA,MAAM;AACR;AACA;;EAEE;AElnBF;;EAEE,YAAA;AFonBF;AACA;;;EAGE;AEhnBF;EACE,6BAAA;EFknBA,MAAM;EEjnBN,oBAAA;EFmnBA,MAAM;AACR;AACA;;EAEE;AEhnBF;;EAEE,wBAAA;AFknBF;AACA;;;EAGE;AE9mBF;EACE,0BAAA;EFgnBA,MAAM;EE/mBN,aAAA;EFinBA,MAAM;AACR;AACA;+EAC+E;AAC/E;;;EAGE;AE7mBF;;EAEE,cAAA;AF+mBF;AACA;;EAEE;AE3mBF;EACE,kBAAA;AF6mBF;AACA;+EAC+E;AAC/E;;EAEE;AExmBF;EACE,qBAAA;AF0mBF;AACA;;EAEE;AEtmBF;EACE,aAAA;AFwmBF;AACA;+EAC+E;AAC/E;;EAEE;AEnmBF;EACE,aAAA;AFqmBF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AGn/D/B;;EAEE,YAAA;AHq/DF;AGl/DA;EACE,eAAA;AHo/DF;AGj/DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mEAAA;EACA,eAAA;EACA,qBAAA;EACA,gCAAA;EACA,2BAAA;AHm/DF;AACA;;+BAE+B;AG/+D/B;;;;;EAKE,mEAAA;EACA,yBAAA;EACA,4CAAA;EACA,iBAAA;EACA,YAAA;AHi/DF;AG9+DA;EACE,gBAAA;EACA,eAAA;AHg/DF;AG9+DA;EACE,wBAAA;AHg/DF;AG9+DA;EACE,wBAAA;AHg/DF;AG9+DA;EACE,wBAAA;AHg/DF;AG9+DA;EACE,eAAA;AHg/DF;AG7+DA;;;;;EAKE,eAAA;AH++DF;AG5+DA;;;;;EAKE,kBAAA;AH8+DF;AACA;;+BAE+B;AGz+D/B;EACE,mBAAA;EACA,qBAAA;AH2+DF;AGz+DA;EACE,eAAA;AH2+DF;AGz+DA;EACE,kBAAA;AH2+DF;AACA;;qBAEqB;AGv+DrB;EACE,cAAA;EACA,qBAAA;AHy+DF;AGv+DA;EACE,cAAA;EACA,qBAAA;AHy+DF;AACA;;+BAE+B;AAC/B;;+BAE+B;AAC/B,SAAS;AG37DT;EACE,yBAAA;EACA,gCAAA;AH67DF;AG37DA;EACE,yBAAA;EACA,gCAAA;AH67DF;AG37DA;EACE,yBAAA;EACA,gCAAA;AH67DF;AACA,SAAS;AG17DT;;EAEE,0CAAA;EACA,gCAAA;AH47DF;AG17DA;;EAEE,0CAAA;EACA,gCAAA;AH47DF;AG17DA;;EAEE,0CAAA;EACA,gCAAA;AH47DF;AACA,4BAA4B;AGlgE1B;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AHogEJ;AGlgEE;EACE,8BAAA;EACA,kBAAA;AHogEJ;AGlgEE;EACE,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,2BAAA;AHogEJ;AGlgEE;EACE,+BAAA;AHogEJ;AGlgEE;EACE,oCAAA;AHogEJ;AACA,gBAAgB;AGjgEd;EACE,oCAAA;AHmgEJ;AGjgEE;EACE,qCAAA;AHmgEJ;AGjgEE;EACE,qCAAA;AHmgEJ;AGjgEE;EACE,qCAAA;AHmgEJ;AACA;;+BAE+B;AAC/B,aAAa;AACb;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,2DAA2D;AAC3D,SAAS;AACT,oBAAoB;AACpB,eAAe;AACf,SAAS;AACT,WAAW;AACX;;CAEC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,YAAY;AACZ,aAAa;AACb,iBAAiB;AACjB,WAAW;AACX,qBAAqB;AACrB,YAAY;AACZ;;qBAEqB;AACrB,OAAO;AACP,SAAS;AACT,YAAY;AACZ,2BAA2B;AAC3B,iBAAiB;AACjB,aAAa;AACb,UAAU;AACV,gBAAgB;AAChB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,aAAa;AACb,eAAe;AACf,YAAY;AACZ,aAAa;AACb,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,2DAA2D;AAC3D,SAAS;AACT,oBAAoB;AACpB,eAAe;AACf,SAAS;AACT,WAAW;AACX;;CAEC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,YAAY;AACZ,aAAa;AACb,iBAAiB;AACjB,WAAW;AACX,qBAAqB;AACrB,YAAY;AACZ;;qBAEqB;AACrB,OAAO;AACP,SAAS;AACT,YAAY;AACZ,2BAA2B;AAC3B,iBAAiB;AACjB,aAAa;AACb,UAAU;AACV,gBAAgB;AAChB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,aAAa;AACb,eAAe;AACf,YAAY;AACZ,aAAa;AACb,YAAY;AACZ,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AI93F/B;EACE,eAAA;EACA,qBAAA;EAEA,eAAA;EAEA,aAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,cAAA;EAEA,mEAAA;EAEA,0BAAA;EACA,wCAAA;EAEA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,4BAAA;EACA,8FAAA;EAEA,iBAAA;EACA,sHAAA;EACA,eAAA;EAEA,wCAAA;AJw3FF;AACA;;+BAE+B;AAC/B;;gBAEgB;AIl3FhB;EACE,yBAAA;EACA,sBAAA;EACA,8FAAA;EACA,+BAAA;AJo3FF;AIj3FA;EACE,aAAA;AJm3FF;AACA;;gBAEgB;AI/2FhB;EACE,yBAAA;EACA,+BAAA;EACA,+BAAA;EACA,yBAAA;AJi3FF;AI92FA;EACE,aAAA;AJg3FF;AACA;;gBAEgB;AI52FhB;;EAEE,yBAAA;EACA,oBAAA;EACA,+BAAA;EACA,mDAAA;AJ82FF;AACA;;gBAEgB;AI12FhB;EACE,yBAAA;EACA,sBAAA;EACA,6CAAA;EACA,gCAAA;AJ42FF;AI12FA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;AJ42FF;AI12FA;EACE,yBAAA;EACA,sBAAA;AJ42FF;AACA;;gBAEgB;AAChB,qBAAqB;AIv2FrB;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;EACA,4CAAA;AJy2FF;AIv2FA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,uCAAA;AJu2FF;AIr2FA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;AJk2FF;AIh2FA;EACE,6BAAA;EACA,gBAAA;AJk2FF;AI/1FA;EACE;IACE,uBAAA;EJi2FF;EI/1FA;IACE,yBAAA;EJi2FF;AACF;AI91FA;EACE,gCAAA;AJg2FF;AI91FA;EACE,yBAAA;AJg2FF;AACA;;qBAEqB;AI51FrB;;;;;EAKE,eAAA;EACA,wBAAA;EACA,iCAAA;EACA,2BAAA;EACA,+BAAA;AJ81FF;AACA,8BAA8B;AI31F9B;EACE,sCAAA;AJ61FF;AACA;;+BAE+B;AAC/B;;qBAEqB;AIx1FrB;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,UAAA;AJ01FF;AIv1FA;EACE,+BAAA;AJy1FF;AIv1FA;EACE,kBAAA;EACA,mBAAA;AJy1FF;AIv1FA;EACE,kBAAA;EACA,WAAA;AJy1FF;AACA,eAAe;AIt1Ff;;EAEE,8BAAA;AJw1FF;AIt1FA;EACE,UAAA;EACA,SAAA;AJw1FF;AIt1FA;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AJw1FF;AIt1FA;;EAEE,UAAA;EACA,WAAA;AJw1FF;AIt1FA;;EAEE,UAAA;EACA,SAAA;AJw1FF;AACA,aAAa;AIr1Fb;;EAEE,8CAAA;AJu1FF;AIr1FA;EACE,yBAAA;EACA,WAAA;AJu1FF;AIr1FA;EACE,SAAA;EACA,QAAA;EACA,WAAA;AJu1FF;AIr1FA;;EAEE,2BAAA;EACA,WAAA;AJu1FF;AIr1FA;;EAEE,QAAA;EACA,WAAA;AJu1FF;AACA,SAAS;AIp1FT;;EAEE,kDAAA;AJs1FF;AIp1FA;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AJs1FF;AIp1FA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;AJs1FF;AIp1FA;;EAEE,UAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;AJs1FF;AIp1FA;;EAEE,QAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AJs1FF;AACA;;qBAEqB;AIl1FrB;EACE,oDAAA;EACA,4BAAA;EACA,cAAA;EACA,4BAAA;AJo1FF;AACA,UAAU;AIj1FV;EACE,wBAAA;AJm1FF;AIj1FA;EACE,gBAAA;AJm1FF;AIj1FA;EACE,wBAAA;AJm1FF;AIj1FA;EACE,eAAA;AJm1FF;AACA,WAAW;AACX,UAAU;AI/0FV;EACE,mBAAA;EACA,oDAAA;EACA,+BAAA;AJi1FF;AACA,mBAAmB;AI90FnB;;EAEE,mBAAA;EACA,oDAAA;EACA,+BAAA;AJg1FF;AACA,iBAAiB;AI70FjB;EACE,mBAAA;EACA,oDAAA;EACA,+BAAA;AJ+0FF;AACA;;qBAEqB;AI10FrB;EACE,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AJ40FF;AIz0FA;EACE,WAAA;AJ20FF;AIz0FA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;EAEA,WAAA;EACA,cAAA;EACA,uCAAA;AJ00FF;AACA,QAAQ;AIv0FR;EACE,aAAA;EACA,cAAA;AJy0FF;AACA,UAAU;AIt0FV;EACE,4BAAA;EACA,+BAAA;AJw0FF;AIt0FA;EACE,2BAAA;EACA,8BAAA;AJw0FF;AACA,cAAc;AIr0Fd;EACE,2BAAA;EACA,8BAAA;AJu0FF;AIr0FA;EACE,4BAAA;EACA,+BAAA;AJu0FF;AACA;;qBAEqB;AACrB,aAAa;AIn0Fb;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJq0FF;AIn0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJq0FF;AIn0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJq0FF;AACA,YAAY;AIl0FZ;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJo0FF;AIl0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJo0FF;AIl0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJo0FF;AACA,gBAAgB;AIj0FhB;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJm0FF;AIj0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJm0FF;AIj0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJm0FF;AACA,cAAc;AIh0Fd;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJk0FF;AIh0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJk0FF;AIh0FA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJk0FF;AACA,YAAY;AI/zFZ;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJi0FF;AI/zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJi0FF;AI/zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJi0FF;AACA,cAAc;AI9zFd;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJg0FF;AI9zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJg0FF;AI9zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJg0FF;AACA,cAAc;AI7zFd;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,2DAAA;AJ+zFF;AI7zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+zFF;AI7zFA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+zFF;AACA,OAAO;AI5zFP;EACE,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,2DAAA;AJ8zFF;AI5zFA;EACE,yBAAA;EACA,cAAA;AJ8zFF;AI5zFA;EACE,yBAAA;EACA,cAAA;AJ8zFF;AACA;;gBAEgB;AI1zFhB;EACE,oBAAA;EACA,YAAA;EACA,0CAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;AJ4zFF;AIzzFA;EACE,0CAAA;AJ2zFF;AIzzFA;EACE,0CAAA;AJ2zFF;AACA;;+BAE+B;AAC/B;;qBAEqB;AIrzFrB;;EAEE,WAAA;EACA,gBAAA;EACA,oBAAA;AJuzFF;AIrzFA;;EAEE,YAAA;EACA,iBAAA;EACA,mBAAA;AJuzFF;AACA;;qBAEqB;AInzFrB;;EAEE,0CAAA;AJqzFF;AInzFA;;EAEE,+CAAA;AJqzFF;AInzFA;;EAEE,+CAAA;AJqzFF;AACA;;qBAEqB;AIjzFrB;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,eAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AIjzFA;;;EAGE,wBAAA;AJmzFF;AACA;;gBAEgB;AI/yFhB;;EAEE,+CAAA;AJizFF;AI/yFA;;EAEE,YAAA;EACA,sBAAA;EACA,mBAAA;AJizFF;AACA;;qBAEqB;AI5yFrB;;EAEE,uCAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oBAAA;EACA,4BAAA;EACA,2DAAA;AJ8yFF;AI5yFA;EACE,gBAAA;EACA,2CAAA;EACA,4BAAA;AJ8yFF;AI5yFA;EACE,kBAAA;AJ8yFF;AI3yFA;;EAEE,8BAAA;EACA,0CAAA;EACA,4GAAA;AJ6yFF;AI3yFA;;EAEE,8BAAA;EACA,0CAAA;EACA,4GAAA;AJ6yFF;AI3yFA;;EAEE,8BAAA;EACA,0CAAA;EACA,sGAAA;AJ6yFF;AI3yFA;;EAEE,0CAAA;EACA,yBAAA;EACA,2CAAA;AJ6yFF;AI3yFA;;EAEE,qCAAA;AJ6yFF;AACA,aAAa;AI1yFb;EACE,kHAAA;AJ4yFF;AI1yFA;EACE,4GAAA;AJ4yFF;AI1yFA;EACE,yBAAA;AJ4yFF;AACA,4BAA4B;AIzyF5B;;EAEE,wCAAA;EACA,yBAAA;EACA,qEAAA;AJ2yFF;AIzyFA;;EAEE,yBAAA;EACA,oDAAA;AJ2yFF;AIzyFA;;EAEE,yBAAA;EACA,oDAAA;AJ2yFF;AIzyFA;;EAEE,sDAAA;EACA,yBAAA;EACA,qEAAA;AJ2yFF;AIzyFA;;EAEE,2CAAA;EACA,cAAA;EACA,iBAAA;EACA,0DAAA;AJ2yFF;AIzyFA;;EAEE,2CAAA;EACA,oDAAA;AJ2yFF;AACA,gBAAgB;AIvyFhB;EACE,gDAAA;EACA,gBAAA;AJyyFF;AIvyFA;EACE,iBAAA;AJyyFF;AIvyFA;EACE,sBAAA;EACA,+CAAA;AJyyFF;AIvyFA;EACE,qBAAA;AJyyFF;AACA;;gBAEgB;AInyFhB;;EAEE,kBAAA;EACA,qCAAA;EACA,+BAAA;AJqyFF;AACA,iBAAiB;AIlyFjB;;EAEE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,kBAAA;EAEA,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,SAAA;EACA,8CAAA;AJmyFF;AACA,iBAAiB;AIhyFjB;;EAEE,QAAA;EACA,SAAA;AJkyFF;AACA,kBAAkB;AI/xFlB;EACE,sCAAA;EACA,8BAAA;AJiyFF;AI/xFA;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,mCAAA;EACA,6CAAA;AJiyFF;AI7xFA;;;;EAIE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;AJ+xFF;AACA,YAAY;AI5xFZ;EACE,eAAA;AJ8xFF;AI5xFA;EACE,yDAAA;AJ8xFF;AI3xFA;EACE;IACE,wCAAA;EJ6xFF;EI3xFA;IACE,0CAAA;EJ6xFF;AACF;AI1xFA;EACE,kBAAA;AJ4xFF;AI1xFA;EACE,qCAAA;EACA,wCAAA;AJ4xFF;AI1xFA;EACE,sCAAA;EACA,yCAAA;AJ4xFF;AI1xFA;EACE,kBAAA;EACA,qCAAA;AJ4xFF;AI1xFA;EACE,kBAAA;EACA,wCAAA;AJ4xFF;AACA,kBAAkB;AIzxFlB;;EAEE,8BAAA;EACA,+BAAA;AJ2xFF;AACA;;gBAEgB;AAChB,uDAAuD;AIpxFvD;;;EAGE,oCAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;AJsxFF;AIpxFA;EACE,oCAAA;EACA,iBAAA;EACA,yBAAA;AJsxFF;AACA;;gBAEgB;AIlxFhB;EACE,mBAAA;AJoxFF;AIlxFA;EACE,UAAA;EACA,wBAAA;AJoxFF;AACA;;qBAEqB;AI/wFrB;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AJixFF;AI/wFA;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,aAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EAEA,yBAAA;EACA,0BAAA;EAEA,mBAAA;EACA,oBAAA;EAEA,yBAAA;EACA,+BAAA;EAEA,kBAAA;EACA,iBAAA;EAEA,6CAAA;AJ2wFF;AIzwFA;EACE,wBAAA;AJ2wFF;AACA,aAAa;AIxwFb;EACE,qBAAA;AJ0wFF;AIxwFA;EACE,aAAA;AJ0wFF;AACA;;qBAEqB;AACrB,aAAa;AIpwFb;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gEAAA;AJswFF;AACA,iBAAiB;AInwFjB;EACE,kDAAA;AJqwFF;AInwFA;EACE,kDAAA;AJqwFF;AACA,iBAAiB;AIlwFjB;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,qBAAA;EACA,kDAAA;AJmwFF;AIjwFA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kDAAA;AJmwFF;AACA,WAAW;AIhwFX;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AJkwFF;AIhwFA;EACE,WAAA;AJkwFF;AIhwFA;EACE,kBAAA;AJkwFF;AIhwFA;EACE,kBAAA;AJkwFF;AACA,iBAAiB;AI/vFjB;EACE,mBAAA;EACA,kDAAA;AJiwFF;AI/vFA;EACE,wCAAA;AJiwFF;AI/vFA;EACE,wCAAA;AJiwFF;AI9vFA;EACE,gBAAA;EACA,kDAAA;AJgwFF;AI9vFA;EACE,wCAAA;AJgwFF;AI9vFA;EACE,wCAAA;AJgwFF;AACA,iBAAiB;AI7vFjB;EACE,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kDAAA;AJ+vFF;AI7vFA;EACE,iBAAA;EACA,wCAAA;AJ+vFF;AI7vFA;EACE,iBAAA;EACA,wCAAA;AJ+vFF;AI5vFA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;AJ8vFF;AI5vFA;EACE,iBAAA;EACA,wCAAA;AJ8vFF;AI5vFA;EACE,iBAAA;EACA,wCAAA;AJ8vFF;AACA;;qBAEqB;AI1vFrB;;EAEE,WAAA;AJ4vFF;AI1vFA;EACE,cAAA;AJ4vFF;AIzvFA;EACE,WAAA;AJ2vFF;AIzvFA;EACE,UAAA;AJ2vFF;AIxvFA;EACE,WAAA;AJ0vFF;AIxvFA;EACE,cAAA;AJ0vFF;AIvvFA;EACE,WAAA;AJyvFF;AIvvFA;EACE,UAAA;AJyvFF;AItvFA;EACE,WAAA;AJwvFF;AItvFA;EACE,UAAA;AJwvFF;AIrvFA;EACE,WAAA;AJuvFF;AIrvFA;EACE,cAAA;AJuvFF;AIpvFA;EACE,WAAA;AJsvFF;AIpvFA;EACE,cAAA;AJsvFF;AInvFA;EACE,WAAA;AJqvFF;AInvFA;EACE,YAAA;AJqvFF;AIlvFA;EACE,WAAA;AJovFF;AIlvFA;EACE,aAAA;AJovFF;AIjvFA;EACE,WAAA;AJmvFF;AIjvFA;EACE,UAAA;AJmvFF;AIhvFA;EACE,WAAA;AJkvFF;AIhvFA;EACE,YAAA;AJkvFF;AI/uFA;EACE,WAAA;AJivFF;AI/uFA;EACE,cAAA;AJivFF;AACA,2BAA2B;AI9uF3B;;EAEE,aAAA;EACA,WAAA;AJgvFF;AI7uFA;EACE,WAAA;AJ+uFF;AI7uFA;EACE,eAAA;AJ+uFF;AI7uFA;EACE,WAAA;AJ+uFF;AI7uFA;EACE,WAAA;AJ+uFF;AI7uFA;EACE,eAAA;AJ+uFF;AI7uFA;EACE,eAAA;AJ+uFF;AI7uFA;EACE,aAAA;AJ+uFF;AI7uFA;EACE,cAAA;AJ+uFF;AI7uFA;EACE,WAAA;AJ+uFF;AI7uFA;EACE,aAAA;AJ+uFF;AI7uFA;EACE,eAAA;AJ+uFF;AACA;;qBAEqB;AACrB,gBAAgB;AI1uFhB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ4uFF;AI1uFA;EACE,2DAAA;AJ4uFF;AI1uFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4uFF;AI1uFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4uFF;AI1uFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4uFF;AI1uFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4uFF;AACA,UAAU;AIzuFV;;EAEE,oDAAA;EACA,yBAAA;AJ2uFF;AIzuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2uFF;AIzuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2uFF;AIzuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2uFF;AIzuFA;;EAEE,oDAAA;EACA,yBAAA;AJ2uFF;AIzuFA;EACE,iBAAA;AJ2uFF;AACA,aAAa;AIxuFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ0uFF;AIxuFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ0uFF;AIxuFA;;EAEE,yBAAA;AJ0uFF;AIxuFA;;EAEE,yBAAA;AJ0uFF;AIxuFA;;EAEE,yBAAA;AJ0uFF;AIxuFA;;EAEE,yBAAA;AJ0uFF;AACA,mBAAmB;AIvuFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJyuFF;AIvuFA;;;EAGE,oDAAA;EACA,yBAAA;AJyuFF;AIvuFA;;;EAGE,oDAAA;EACA,yBAAA;AJyuFF;AIvuFA;;;EAGE,oDAAA;EACA,yBAAA;AJyuFF;AIvuFA;;;EAGE,oDAAA;EACA,yBAAA;AJyuFF;AACA,eAAe;AItuFf;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJwuFF;AItuFA;EACE,2DAAA;AJwuFF;AItuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJwuFF;AItuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJwuFF;AItuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJwuFF;AItuFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJwuFF;AACA,UAAU;AIruFV;;EAEE,oDAAA;EACA,yBAAA;AJuuFF;AIruFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJuuFF;AIruFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJuuFF;AIruFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJuuFF;AIruFA;;EAEE,oDAAA;EACA,yBAAA;AJuuFF;AIruFA;EACE,iBAAA;AJuuFF;AACA,aAAa;AIpuFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJsuFF;AIpuFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJsuFF;AIpuFA;;EAEE,yBAAA;AJsuFF;AIpuFA;;EAEE,yBAAA;AJsuFF;AIpuFA;;EAEE,yBAAA;AJsuFF;AIpuFA;;EAEE,yBAAA;AJsuFF;AACA,mBAAmB;AInuFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJquFF;AInuFA;;;EAGE,oDAAA;EACA,yBAAA;AJquFF;AInuFA;;;EAGE,oDAAA;EACA,yBAAA;AJquFF;AInuFA;;;EAGE,oDAAA;EACA,yBAAA;AJquFF;AInuFA;;;EAGE,oDAAA;EACA,yBAAA;AJquFF;AACA,gBAAgB;AIjuFhB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJmuFF;AIjuFA;EACE,2DAAA;AJmuFF;AIjuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJmuFF;AIjuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJmuFF;AIjuFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJmuFF;AIjuFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJmuFF;AACA,UAAU;AIhuFV;;EAEE,oDAAA;EACA,yBAAA;AJkuFF;AIhuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJkuFF;AIhuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJkuFF;AIhuFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJkuFF;AIhuFA;;EAEE,oDAAA;EACA,yBAAA;AJkuFF;AIhuFA;EACE,iBAAA;AJkuFF;AACA,aAAa;AI/tFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJiuFF;AI/tFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJiuFF;AI/tFA;;EAEE,yBAAA;AJiuFF;AI/tFA;;EAEE,yBAAA;AJiuFF;AI/tFA;;EAEE,yBAAA;AJiuFF;AI/tFA;;EAEE,yBAAA;AJiuFF;AACA,mBAAmB;AI9tFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJguFF;AI9tFA;;;EAGE,oDAAA;EACA,yBAAA;AJguFF;AI9tFA;;;EAGE,oDAAA;EACA,yBAAA;AJguFF;AI9tFA;;;EAGE,oDAAA;EACA,yBAAA;AJguFF;AI9tFA;;;EAGE,oDAAA;EACA,yBAAA;AJguFF;AACA,eAAe;AI7tFf;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ+tFF;AI7tFA;EACE,2DAAA;AJ+tFF;AI7tFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+tFF;AI7tFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+tFF;AI7tFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+tFF;AI7tFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ+tFF;AACA,UAAU;AI5tFV;;EAEE,oDAAA;EACA,yBAAA;AJ8tFF;AI5tFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ8tFF;AI5tFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ8tFF;AI5tFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ8tFF;AI5tFA;;EAEE,oDAAA;EACA,yBAAA;AJ8tFF;AI5tFA;EACE,iBAAA;AJ8tFF;AACA,aAAa;AI3tFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ6tFF;AI3tFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ6tFF;AI3tFA;;EAEE,yBAAA;AJ6tFF;AI3tFA;;EAEE,yBAAA;AJ6tFF;AI3tFA;;EAEE,yBAAA;AJ6tFF;AI3tFA;;EAEE,yBAAA;AJ6tFF;AACA,mBAAmB;AI1tFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJ4tFF;AI1tFA;;;EAGE,oDAAA;EACA,yBAAA;AJ4tFF;AI1tFA;;;EAGE,oDAAA;EACA,yBAAA;AJ4tFF;AI1tFA;;;EAGE,oDAAA;EACA,yBAAA;AJ4tFF;AI1tFA;;;EAGE,oDAAA;EACA,yBAAA;AJ4tFF;AACA,gBAAgB;AIztFhB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ2tFF;AIztFA;EACE,2DAAA;AJ2tFF;AIztFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2tFF;AIztFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2tFF;AIztFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2tFF;AIztFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2tFF;AACA,UAAU;AIvtFV;;EAEE,oDAAA;EACA,yBAAA;AJytFF;AIvtFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJytFF;AIvtFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJytFF;AIvtFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJytFF;AIvtFA;;EAEE,oDAAA;EACA,yBAAA;AJytFF;AIvtFA;EACE,iBAAA;AJytFF;AACA,aAAa;AIttFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJwtFF;AIttFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJwtFF;AIttFA;;EAEE,yBAAA;AJwtFF;AIttFA;;EAEE,yBAAA;AJwtFF;AIttFA;;EAEE,yBAAA;AJwtFF;AIttFA;;EAEE,yBAAA;AJwtFF;AACA,mBAAmB;AIrtFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJutFF;AIrtFA;;;EAGE,oDAAA;EACA,yBAAA;AJutFF;AIrtFA;;;EAGE,oDAAA;EACA,yBAAA;AJutFF;AIrtFA;;;EAGE,oDAAA;EACA,yBAAA;AJutFF;AIrtFA;;;EAGE,oDAAA;EACA,yBAAA;AJutFF;AACA,iBAAiB;AIptFjB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJstFF;AIptFA;EACE,2DAAA;AJstFF;AIptFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJstFF;AIptFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJstFF;AIptFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJstFF;AIptFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJstFF;AACA,UAAU;AIntFV;;EAEE,oDAAA;EACA,yBAAA;AJqtFF;AIntFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJqtFF;AIntFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJqtFF;AIntFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJqtFF;AIntFA;;EAEE,oDAAA;EACA,yBAAA;AJqtFF;AIntFA;EACE,iBAAA;AJqtFF;AACA,aAAa;AIltFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJotFF;AIltFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJotFF;AIltFA;;EAEE,yBAAA;AJotFF;AIltFA;;EAEE,yBAAA;AJotFF;AIltFA;;EAEE,yBAAA;AJotFF;AIltFA;;EAEE,yBAAA;AJotFF;AACA,mBAAmB;AIjtFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJmtFF;AIjtFA;;;EAGE,oDAAA;EACA,yBAAA;AJmtFF;AIjtFA;;;EAGE,oDAAA;EACA,yBAAA;AJmtFF;AIjtFA;;;EAGE,oDAAA;EACA,yBAAA;AJmtFF;AIjtFA;;;EAGE,oDAAA;EACA,yBAAA;AJmtFF;AACA,eAAe;AIhtFf;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJktFF;AIhtFA;EACE,2DAAA;AJktFF;AIhtFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJktFF;AIhtFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJktFF;AIhtFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJktFF;AIhtFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJktFF;AACA,UAAU;AI/sFV;;EAEE,oDAAA;EACA,yBAAA;AJitFF;AI/sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJitFF;AI/sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJitFF;AI/sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJitFF;AI/sFA;;EAEE,oDAAA;EACA,yBAAA;AJitFF;AI/sFA;EACE,iBAAA;AJitFF;AACA,aAAa;AI9sFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJgtFF;AI9sFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJgtFF;AI9sFA;;EAEE,yBAAA;AJgtFF;AI9sFA;;EAEE,yBAAA;AJgtFF;AI9sFA;;EAEE,yBAAA;AJgtFF;AI9sFA;;EAEE,yBAAA;AJgtFF;AACA,mBAAmB;AI7sFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJ+sFF;AI7sFA;;;EAGE,oDAAA;EACA,yBAAA;AJ+sFF;AI7sFA;;;EAGE,oDAAA;EACA,yBAAA;AJ+sFF;AI7sFA;;;EAGE,oDAAA;EACA,yBAAA;AJ+sFF;AI7sFA;;;EAGE,oDAAA;EACA,yBAAA;AJ+sFF;AACA,iBAAiB;AI3sFjB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ6sFF;AI3sFA;EACE,2DAAA;AJ6sFF;AI3sFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ6sFF;AI3sFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ6sFF;AI3sFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ6sFF;AI3sFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ6sFF;AACA,UAAU;AI1sFV;;EAEE,oDAAA;EACA,yBAAA;AJ4sFF;AI1sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ4sFF;AI1sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ4sFF;AI1sFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ4sFF;AI1sFA;;EAEE,oDAAA;EACA,yBAAA;AJ4sFF;AI1sFA;EACE,iBAAA;AJ4sFF;AACA,aAAa;AIzsFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ2sFF;AIzsFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ2sFF;AIzsFA;;EAEE,yBAAA;AJ2sFF;AIzsFA;;EAEE,yBAAA;AJ2sFF;AIzsFA;;EAEE,yBAAA;AJ2sFF;AIzsFA;;EAEE,yBAAA;AJ2sFF;AACA,mBAAmB;AIxsFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJ0sFF;AIxsFA;;;EAGE,oDAAA;EACA,yBAAA;AJ0sFF;AIxsFA;;;EAGE,oDAAA;EACA,yBAAA;AJ0sFF;AIxsFA;;;EAGE,oDAAA;EACA,yBAAA;AJ0sFF;AIxsFA;;;EAGE,oDAAA;EACA,yBAAA;AJ0sFF;AACA,iBAAiB;AIvsFjB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJysFF;AIvsFA;EACE,2DAAA;AJysFF;AIvsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJysFF;AIvsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJysFF;AIvsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJysFF;AIvsFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJysFF;AACA,UAAU;AItsFV;;EAEE,oDAAA;EACA,yBAAA;AJwsFF;AItsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJwsFF;AItsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJwsFF;AItsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJwsFF;AItsFA;;EAEE,oDAAA;EACA,yBAAA;AJwsFF;AItsFA;EACE,iBAAA;AJwsFF;AACA,aAAa;AIrsFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJusFF;AIrsFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJusFF;AIrsFA;;EAEE,yBAAA;AJusFF;AIrsFA;;EAEE,yBAAA;AJusFF;AIrsFA;;EAEE,yBAAA;AJusFF;AIrsFA;;EAEE,yBAAA;AJusFF;AACA,mBAAmB;AIpsFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJssFF;AIpsFA;;;EAGE,oDAAA;EACA,yBAAA;AJssFF;AIpsFA;;;EAGE,oDAAA;EACA,yBAAA;AJssFF;AIpsFA;;;EAGE,oDAAA;EACA,yBAAA;AJssFF;AIpsFA;;;EAGE,oDAAA;EACA,yBAAA;AJssFF;AACA,cAAc;AInsFd;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJqsFF;AInsFA;EACE,2DAAA;AJqsFF;AInsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJqsFF;AInsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJqsFF;AInsFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJqsFF;AInsFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJqsFF;AACA,UAAU;AIlsFV;;EAEE,oDAAA;EACA,yBAAA;AJosFF;AIlsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJosFF;AIlsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJosFF;AIlsFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJosFF;AIlsFA;;EAEE,oDAAA;EACA,yBAAA;AJosFF;AIlsFA;EACE,iBAAA;AJosFF;AACA,aAAa;AIjsFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJmsFF;AIjsFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJmsFF;AIjsFA;;EAEE,yBAAA;AJmsFF;AIjsFA;;EAEE,yBAAA;AJmsFF;AIjsFA;;EAEE,yBAAA;AJmsFF;AIjsFA;;EAEE,yBAAA;AJmsFF;AACA,mBAAmB;AIhsFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJksFF;AIhsFA;;;EAGE,oDAAA;EACA,yBAAA;AJksFF;AIhsFA;;;EAGE,oDAAA;EACA,yBAAA;AJksFF;AIhsFA;;;EAGE,oDAAA;EACA,yBAAA;AJksFF;AIhsFA;;;EAGE,oDAAA;EACA,yBAAA;AJksFF;AACA,eAAe;AI9rFf;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJgsFF;AI9rFA;EACE,2DAAA;AJgsFF;AI9rFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJgsFF;AI9rFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJgsFF;AI9rFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJgsFF;AI9rFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJgsFF;AACA,UAAU;AI7rFV;;EAEE,oDAAA;EACA,yBAAA;AJ+rFF;AI7rFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ+rFF;AI7rFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ+rFF;AI7rFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ+rFF;AI7rFA;;EAEE,oDAAA;EACA,yBAAA;AJ+rFF;AI7rFA;EACE,iBAAA;AJ+rFF;AACA,aAAa;AI5rFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ8rFF;AI5rFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ8rFF;AI5rFA;;EAEE,yBAAA;AJ8rFF;AI5rFA;;EAEE,yBAAA;AJ8rFF;AI5rFA;;EAEE,yBAAA;AJ8rFF;AI5rFA;;EAEE,yBAAA;AJ8rFF;AACA,mBAAmB;AI3rFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJ6rFF;AI3rFA;;;EAGE,oDAAA;EACA,yBAAA;AJ6rFF;AI3rFA;;;EAGE,oDAAA;EACA,yBAAA;AJ6rFF;AI3rFA;;;EAGE,oDAAA;EACA,yBAAA;AJ6rFF;AI3rFA;;;EAGE,oDAAA;EACA,yBAAA;AJ6rFF;AACA,gBAAgB;AIzrFhB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ2rFF;AIzrFA;EACE,2DAAA;AJ2rFF;AIzrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2rFF;AIzrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2rFF;AIzrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2rFF;AIzrFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ2rFF;AACA,UAAU;AIxrFV;;EAEE,oDAAA;EACA,yBAAA;AJ0rFF;AIxrFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ0rFF;AIxrFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ0rFF;AIxrFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ0rFF;AIxrFA;;EAEE,oDAAA;EACA,yBAAA;AJ0rFF;AIxrFA;EACE,iBAAA;AJ0rFF;AACA,aAAa;AIvrFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJyrFF;AIvrFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJyrFF;AIvrFA;;EAEE,yBAAA;AJyrFF;AIvrFA;;EAEE,yBAAA;AJyrFF;AIvrFA;;EAEE,yBAAA;AJyrFF;AIvrFA;;EAEE,yBAAA;AJyrFF;AACA,mBAAmB;AItrFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJwrFF;AItrFA;;;EAGE,oDAAA;EACA,yBAAA;AJwrFF;AItrFA;;;EAGE,oDAAA;EACA,yBAAA;AJwrFF;AItrFA;;;EAGE,oDAAA;EACA,yBAAA;AJwrFF;AItrFA;;;EAGE,oDAAA;EACA,yBAAA;AJwrFF;AACA,iBAAiB;AIrrFjB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJurFF;AIrrFA;EACE,2DAAA;AJurFF;AIrrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJurFF;AIrrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJurFF;AIrrFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJurFF;AIrrFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJurFF;AACA,UAAU;AIprFV;;EAEE,oDAAA;EACA,yBAAA;AJsrFF;AIprFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsrFF;AIprFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsrFF;AIprFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsrFF;AIprFA;;EAEE,oDAAA;EACA,yBAAA;AJsrFF;AIprFA;EACE,iBAAA;AJsrFF;AACA,aAAa;AInrFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJqrFF;AInrFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJqrFF;AInrFA;;EAEE,yBAAA;AJqrFF;AInrFA;;EAEE,yBAAA;AJqrFF;AInrFA;;EAEE,yBAAA;AJqrFF;AInrFA;;EAEE,yBAAA;AJqrFF;AACA,mBAAmB;AIlrFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJorFF;AIlrFA;;;EAGE,oDAAA;EACA,yBAAA;AJorFF;AIlrFA;;;EAGE,oDAAA;EACA,yBAAA;AJorFF;AIlrFA;;;EAGE,oDAAA;EACA,yBAAA;AJorFF;AIlrFA;;;EAGE,oDAAA;EACA,yBAAA;AJorFF;AACA;;qBAEqB;AACrB,mBAAmB;AI/qFnB;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJirFF;AI/qFA;EACE,2DAAA;AJirFF;AI/qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJirFF;AI/qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJirFF;AI/qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJirFF;AI/qFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJirFF;AACA,UAAU;AI9qFV;;EAEE,oDAAA;EACA,yBAAA;AJgrFF;AI9qFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJgrFF;AI9qFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJgrFF;AI9qFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJgrFF;AI9qFA;;EAEE,oDAAA;EACA,yBAAA;AJgrFF;AI9qFA;EACE,iBAAA;AJgrFF;AACA,aAAa;AI7qFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ+qFF;AI7qFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ+qFF;AI7qFA;;EAEE,yBAAA;AJ+qFF;AI7qFA;;EAEE,yBAAA;AJ+qFF;AI7qFA;;EAEE,yBAAA;AJ+qFF;AI7qFA;;EAEE,yBAAA;AJ+qFF;AACA,mBAAmB;AI5qFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJ8qFF;AI5qFA;;;EAGE,oDAAA;EACA,yBAAA;AJ8qFF;AI5qFA;;;EAGE,oDAAA;EACA,yBAAA;AJ8qFF;AI5qFA;;;EAGE,oDAAA;EACA,yBAAA;AJ8qFF;AI5qFA;;;EAGE,oDAAA;EACA,yBAAA;AJ8qFF;AACA;;qBAEqB;AACrB,aAAa;AI1qFb;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJ4qFF;AI1qFA;EACE,2DAAA;AJ4qFF;AI1qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4qFF;AI1qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4qFF;AI1qFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4qFF;AI1qFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJ4qFF;AACA,UAAU;AIzqFV;;EAEE,oDAAA;EACA,yBAAA;AJ2qFF;AIzqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2qFF;AIzqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2qFF;AIzqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJ2qFF;AIzqFA;;EAEE,oDAAA;EACA,yBAAA;AJ2qFF;AIzqFA;EACE,iBAAA;AJ2qFF;AACA,aAAa;AIxqFb;;EAEE,6BAAA;EACA,oDAAA;EACA,cAAA;AJ0qFF;AIxqFA;;;;;;;;EAQE,2BAAA;EACA,cAAA;AJ0qFF;AIxqFA;;EAEE,yBAAA;AJ0qFF;AIxqFA;;EAEE,yBAAA;AJ0qFF;AIxqFA;;EAEE,yBAAA;AJ0qFF;AIxqFA;;EAEE,yBAAA;AJ0qFF;AACA,mBAAmB;AIvqFnB;;;EAGE,6BAAA;EACA,qEAAA;EACA,yBAAA;AJyqFF;AIvqFA;;;EAGE,oDAAA;EACA,yBAAA;AJyqFF;AIvqFA;;;EAGE,oDAAA;EACA,yBAAA;AJyqFF;AIvqFA;;;EAGE,oDAAA;EACA,yBAAA;AJyqFF;AIvqFA;;;EAGE,oDAAA;EACA,yBAAA;AJyqFF;AACA;;iBAEiB;AACjB,aAAa;AIrqFb;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJuqFF;AIrqFA;EACE,2DAAA;AJuqFF;AIrqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJuqFF;AIrqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJuqFF;AIrqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJuqFF;AIrqFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJuqFF;AACA,UAAU;AIpqFV;;EAEE,oDAAA;EACA,yBAAA;AJsqFF;AIpqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsqFF;AIpqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsqFF;AIpqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJsqFF;AIpqFA;;EAEE,oDAAA;EACA,yBAAA;AJsqFF;AIpqFA;EACE,iBAAA;AJsqFF;AACA;;iBAEiB;AACjB,aAAa;AIlqFb;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AJoqFF;AIlqFA;EACE,2DAAA;AJoqFF;AIlqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJoqFF;AIlqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJoqFF;AIlqFA;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;AJoqFF;AIlqFA;;;;EAIE,yBAAA;EACA,cAAA;EACA,iBAAA;AJoqFF;AACA,UAAU;AIjqFV;;EAEE,oDAAA;EACA,yBAAA;AJmqFF;AIjqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJmqFF;AIjqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJmqFF;AIjqFA;;EAEE,kCAAA;EACA,oDAAA;EACA,yBAAA;AJmqFF;AIjqFA;;EAEE,oDAAA;EACA,yBAAA;AJmqFF;AIjqFA;EACE,iBAAA;AJmqFF;AACA;;+BAE+B;AI/pF/B;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,0BAAA;AJiqFF;AI/pFA;EACE,gBAAA;AJiqFF;AACA,aAAa;AI9pFb;EACE,YAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AJgqFF;AACA,mBAAmB;AI7pFnB;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AJ+pFF;AI7pFA;;EAEE,8FAAA;AJ+pFF;AI5pFA;EACE,iBAAA;EACA,gBAAA;EACA,qCAAA;EACA,wCAAA;AJ8pFF;AI5pFA;EACE,sCAAA;EACA,yCAAA;AJ8pFF;AACA,oBAAoB;AI3pFpB;EACE,oBAAA;EACA,sBAAA;AJ6pFF;AI3pFA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AJ6pFF;AI3pFA;EACE,qCAAA;EACA,sCAAA;AJ6pFF;AI3pFA;EACE,kBAAA;EACA,wCAAA;EACA,yCAAA;AJ6pFF;AI3pFA;EACE,4BAAA;AJ6pFF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,wFAAwF;AACxF,YAAY;AACZ,qDAAqD;AACrD;;qBAEqB;AACrB,SAAS;AACT,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,wFAAwF;AACxF,YAAY;AACZ,qDAAqD;AACrD;;qBAEqB;AACrB,SAAS;AACT,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,cAAc;AKhxNd;EACE,cAAA;EACA,0BAAA;ALkxNF;AACA,WAAW;AK/wNX;EACE;IACE,sBAAA;IACA,2BAAA;IACA,4BAAA;ELixNF;EK/wNA;IACE,sBAAA;ELixNF;EK/wNA;IACE,sBAAA;ELixNF;EK/wNA;IACE,sBAAA;ELixNF;AACF;AACA,WAAW;AK9wNX;EACE;IACE,YAAA;IACA,4BAAA;IACA,6BAAA;ELgxNF;EK9wNA;IACE,wCAAA;ELgxNF;EK9wNA;IACE,wCAAA;ELgxNF;EK9wNA;IACE,wCAAA;ELgxNF;AACF;AACA,kBAAkB;AK7wNlB;EACE;IACE,YAAA;IACA,4BAAA;IACA,6BAAA;EL+wNF;EK7wNA;IACE,wCAAA;EL+wNF;EK7wNA;IACE,wCAAA;EL+wNF;EK7wNA;IACE,wCAAA;EL+wNF;AACF;AACA,kBAAkB;AK5wNlB;EACE;IACE,aAAA;IACA,4BAAA;IACA,6BAAA;EL8wNF;EK5wNA;IACE,yCAAA;EL8wNF;EK5wNA;IACE,yCAAA;EL8wNF;EK5wNA;IACE,yCAAA;EL8wNF;AACF;AACA;;+BAE+B;AAC/B,mBAAmB;AKzwNnB;EACE,mEAAA;EACA,2BAAA;EACA,gBAAA;AL2wNF;AKxwNA;EACE,wBAAA;AL0wNF;AACA,UAAU;AKvwNV;EACE,WAAA;ALywNF;AACA;;+BAE+B;AKpwN/B;EACE,gBAAA;ALswNF;AKpwNA;EACE,kBAAA;ALswNF;AKpwNA;EACE,iBAAA;ALswNF;AKpwNA;EACE,mBAAA;EACA,aAAA;ALswNF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT;;qBAEqB;AACrB,SAAS;AACT;;+BAE+B;AAC/B,0BAA0B;AAC1B,aAAa;AACb,YAAY;AACZ,UAAU;AACV,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT;;qBAEqB;AACrB,SAAS;AACT;;+BAE+B;AAC/B,0BAA0B;AAC1B,aAAa;AACb,YAAY;AACZ,UAAU;AACV,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AMthP/B;EACE,iBAAA;EAEA,cAAA;EACA,WAAA;EAEA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;EAEA,iBAAA;EACA,6CAAA;ANqhPF;AACA;;gBAEgB;AMjhPhB;EACE,+CAAA;EACA,iDAAA;ANmhPF;AACA;;gBAEgB;AAChB,0CAA0C;AM/gP1C;;EAEE,UAAA;ANihPF;AACA;;gBAEgB;AM7gPhB;EACE,cAAA;EACA,mBAAA;EAEA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AN8gPF;AM3gPA;;EAEE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,4BAAA;AN6gPF;AM1gPA;EACE,sCAAA;AN4gPF;AM1gPA;EACE,qCAAA;AN4gPF;AACA;;gBAEgB;AMxgPhB;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEA,YAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EAEA,gBAAA;EACA,kBAAA;EACA,2BAAA;ANwgPF;AMrgPA;;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EAEA,gDAAA;EACA,gDAAA;EAEA,SAAA;EACA,2BAAA;ANqgPF;AMlgPA;EACE,UAAA;ANogPF;AMlgPA;EACE,SAAA;EACA,WAAA;ANogPF;AACA,gBAAgB;AMjgPhB;EAEE;;IAEE,cAAA;IACA,mBAAA;IACA,YAAA;IACA,UAAA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,MAAA;IACA,OAAA;IACA,eAAA;ENkgPF;EM//OA;;;;IAIE,gBAAA;IACA,OAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,4BAAA;ENigPF;EM9/OA;;IAEE,sCAAA;ENggPF;EM9/OA;;IAEE,qCAAA;ENggPF;AACF;AACA;;gBAEgB;AM5/OhB;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AN8/OF;AACA;;+BAE+B;AAC/B;;gBAEgB;AMz/OhB;EACE,oCAAA;AN2/OF;AMz/OA;;EAEE,aAAA;AN2/OF;AACA;;gBAEgB;AMv/OhB;;;EAGE,cAAA;ANy/OF;AMv/OA;;;EAGE,sDAAA;EACA,uDAAA;EACA,yDAAA;EACA,wDAAA;ANy/OF;AACA;;gBAEgB;AMr/OhB;EACE,WAAA;ANu/OF;AACA;;gBAEgB;AMn/OhB;EACE,WAAA;ANq/OF;AACA;;gBAEgB;AMj/OhB;EACE,gBAAA;EACA,mBAAA;ANm/OF;AACA;;gBAEgB;AM/+OhB;EACE,eAAA;ANi/OF;AACA;;+BAE+B;AOzuP/B;;EAEE,yDAAA;AP2uPF;AOxuPA;EACE;;;;IAIE,yDAAA;EP0uPF;AACF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AQp2Q/B;EACE,qBAAA;EAEA,WAAA;EACA,YAAA;EAEA,iBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,wBAAA;EAEA,WAAA;EACA,2BAAA;EACA,2BAAA;ARk2QF;AACA,WAAW;AQ/1QX;EACE,qBAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,YAAA;ARi2QF;AACA,mEAAmE;AACnE;;+BAE+B;AS/4Q/B;;EAEE,4BAAA;ATi5QF;AS/4QA;;;EAGE,8BAAA;ATi5QF;AS/4QA;;EAEE,8BAAA;ATi5QF;AS/4QA;;EAEE,8BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,8BAAA;ATi5QF;AS/4QA;;;EAGE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;;EAGE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,8BAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,gCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;;EAGE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;;EAGE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,+BAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,iCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AS/4QA;;EAEE,kCAAA;ATi5QF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,gBAAgB;AAChB,eAAe;AACf,SAAS;AACT,UAAU;AACV,UAAU;AACV,YAAY;AACZ,2BAA2B;AAC3B;;qBAEqB;AACrB,WAAW;AACX,eAAe;AACf,gBAAgB;AAChB,0BAA0B;AAC1B,YAAY;AACZ,UAAU;AACV,aAAa;AACb,aAAa;AACb,YAAY;AACZ,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,gBAAgB;AAChB,eAAe;AACf,SAAS;AACT,UAAU;AACV,UAAU;AACV,YAAY;AACZ,2BAA2B;AAC3B;;qBAEqB;AACrB,WAAW;AACX,eAAe;AACf,gBAAgB;AAChB,0BAA0B;AAC1B,YAAY;AACZ,UAAU;AACV,aAAa;AACb,aAAa;AACb,YAAY;AACZ,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,aAAa;AU9/Tb;EACE,YAAA;EACA,4CAAA;EACA,gBAAA;EACA,mEAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gCAAA;AVggUF;AU7/TA;EACE,yBAAA;AV+/TF;AU7/TA;EACE,kBAAA;AV+/TF;AACA;;gBAEgB;AU3/ThB;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;AV6/TF;AACA;;gBAEgB;AUz/ThB;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AV2/TF;AACA,mBAAmB;AUx/TnB;EACE,qBAAA;EACA,YAAA;EACA,qBAAA;AV0/TF;AACA;;qBAEqB;AUt/TrB;;EAEE,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AVw/TF;AUt/TA;;EAEE,qBAAA;AVw/TF;AACA;;gBAEgB;AUp/ThB;EACE,qBAAA;EACA,mBAAA;AVs/TF;AACA,gBAAgB;AUn/ThB;;EAEE,qBAAA;EACA,sBAAA;AVq/TF;AACA,eAAe;AUl/Tf;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;AVo/TF;AACA;;gBAEgB;AU/+ThB;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AVi/TF;AACA,gBAAgB;AU9+ThB;EACE,eAAA;AVg/TF;AACA;;+BAE+B;AAC/B;;gBAEgB;AUx+ThB;EACE,eAAA;AV0+TF;AUx+TA;EACE,wBAAA;AV0+TF;AUx+TA;EACE,wBAAA;AV0+TF;AUx+TA;EACE,wBAAA;AV0+TF;AUx+TA;EACE,eAAA;AV0+TF;AACA,eAAe;AUt+Tf;EACE,wBAAA;AVw+TF;AUt+TA;EACE,wBAAA;AVw+TF;AUt+TA;EACE,eAAA;AVw+TF;AUt+TA;EACE,eAAA;AVw+TF;AUt+TA;EACE,wBAAA;AVw+TF;AACA;;gBAEgB;AUn+ThB;EACE,eAAA;EACA,cAAA;AVq+TF;AUn+TA;EACE,uBAAA;AVq+TF;AUn+TA;EACE,uBAAA;AVq+TF;AUn+TA;EACE,uBAAA;AVq+TF;AUn+TA;EACE,cAAA;AVq+TF;AACA,eAAe;AUl+Tf;EACE,wBAAA;AVo+TF;AUl+TA;EACE,wBAAA;AVo+TF;AUl+TA;EACE,eAAA;AVo+TF;AUl+TA;EACE,eAAA;AVo+TF;AUl+TA;EACE,wBAAA;AVo+TF;AACA;;gBAEgB;AUh+ThB;EACE,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,SAAA;AVk+TF;AU/9TA;EACE,uBAAA;AVi+TF;AU/9TA;EACE,uBAAA;AVi+TF;AU/9TA;EACE,uBAAA;AVi+TF;AU/9TA;EACE,cAAA;AVi+TF;AACA;;qBAEqB;AU39TrB;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;AV69TF;AU39TA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AV69TF;AU19TA;EACE,eAAA;AV49TF;AU19TA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;AV49TF;AU19TA;EACE,cAAA;EACA,YAAA;AV49TF;AU19TA;EACE,cAAA;AV49TF;AU19TA;EACE,cAAA;AV49TF;AU19TA;EACE,kBAAA;AV49TF;AU19TA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AV49TF;AACA;;+BAE+B;AUx9T/B;EACE,aAAA;AV09TF;AACA;;+BAE+B;AAC/B;;qBAEqB;AUp9TrB;EACE,cAAA;AVs9TF;AUp9TA;EACE,+BAAA;AVs9TF;AUp9TA;EACE,qEAAA;EACA,gBAAA;EACA,yBAAA;AVs9TF;AUp9TA;EACE,qEAAA;EACA,gBAAA;AVs9TF;AUp9TA;EACE,mBAAA;AVs9TF;AACA;;qBAEqB;AACrB,cAAc;AUj9Td;EACE,yBAAA;AVm9TF;AUj9TA;EACE,yBAAA;AVm9TF;AUj9TA;EACE,gCAAA;AVm9TF;AACA,aAAa;AUh9Tb;EACE,yBAAA;AVk9TF;AUh9TA;EACE,yBAAA;AVk9TF;AACA,iBAAiB;AU/8TjB;EACE,yBAAA;AVi9TF;AU/8TA;EACE,yBAAA;AVi9TF;AU/8TA;EACE,gCAAA;AVi9TF;AACA,aAAa;AU/8Tb;EACE,yBAAA;AVi9TF;AU/8TA;EACE,yBAAA;AVi9TF;AACA,gBAAgB;AU98ThB;EACE,yBAAA;AVg9TF;AU98TA;EACE,yBAAA;AVg9TF;AU98TA;EACE,gCAAA;AVg9TF;AACA,aAAa;AU98Tb;EACE,yBAAA;AVg9TF;AU98TA;EACE,yBAAA;AVg9TF;AACA,iBAAiB;AU78TjB;EACE,yBAAA;AV+8TF;AU78TA;EACE,yBAAA;AV+8TF;AU78TA;EACE,gCAAA;AV+8TF;AACA,aAAa;AU78Tb;EACE,yBAAA;AV+8TF;AU78TA;EACE,yBAAA;AV+8TF;AACA,gBAAgB;AU58ThB;EACE,yBAAA;AV88TF;AU58TA;EACE,yBAAA;AV88TF;AU58TA;EACE,gCAAA;AV88TF;AACA,aAAa;AU58Tb;EACE,yBAAA;AV88TF;AU58TA;EACE,yBAAA;AV88TF;AACA,eAAe;AU38Tf;EACE,yBAAA;AV68TF;AU38TA;EACE,yBAAA;AV68TF;AU38TA;EACE,gCAAA;AV68TF;AACA,aAAa;AU38Tb;EACE,yBAAA;AV68TF;AU38TA;EACE,yBAAA;AV68TF;AACA,eAAe;AU18Tf;EACE,yBAAA;AV48TF;AU18TA;EACE,yBAAA;AV48TF;AU18TA;EACE,gCAAA;AV48TF;AACA,aAAa;AU18Tb;EACE,yBAAA;AV48TF;AU18TA;EACE,yBAAA;AV48TF;AACA,iBAAiB;AUz8TjB;EACE,yBAAA;AV28TF;AUz8TA;EACE,yBAAA;AV28TF;AUz8TA;EACE,gCAAA;AV28TF;AACA,aAAa;AUz8Tb;EACE,yBAAA;AV28TF;AUz8TA;EACE,yBAAA;AV28TF;AACA,iBAAiB;AUx8TjB;EACE,yBAAA;AV08TF;AUx8TA;EACE,yBAAA;AV08TF;AUx8TA;EACE,gCAAA;AV08TF;AACA,aAAa;AUx8Tb;EACE,yBAAA;AV08TF;AUx8TA;EACE,yBAAA;AV08TF;AACA,eAAe;AUv8Tf;EACE,yBAAA;AVy8TF;AUv8TA;EACE,yBAAA;AVy8TF;AUv8TA;EACE,gCAAA;AVy8TF;AACA,aAAa;AUv8Tb;EACE,yBAAA;AVy8TF;AUv8TA;EACE,yBAAA;AVy8TF;AACA,gBAAgB;AUt8ThB;EACE,yBAAA;AVw8TF;AUt8TA;EACE,yBAAA;AVw8TF;AUt8TA;EACE,gCAAA;AVw8TF;AACA,aAAa;AUt8Tb;EACE,yBAAA;AVw8TF;AUt8TA;EACE,yBAAA;AVw8TF;AACA,eAAe;AUr8Tf;EACE,yBAAA;AVu8TF;AUr8TA;EACE,yBAAA;AVu8TF;AUr8TA;EACE,gCAAA;AVu8TF;AACA,aAAa;AUr8Tb;EACE,yBAAA;AVu8TF;AUr8TA;EACE,yBAAA;AVu8TF;AACA;;qBAEqB;AUl8TrB;EACE,gBAAA;AVo8TF;AUl8TA;EACE,iBAAA;AVo8TF;AUl8TA;;EAEE,kBAAA;AVo8TF;AUl8TA;EACE,mBAAA;AVo8TF;AUl8TA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AVo8TF;AACA;;qBAEqB;AUh8TrB;;EAEE,WAAA;EACA,eAAA;EACA,mBAAA;AVk8TF;AUh8TA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AVk8TF;AACA;;qBAEqB;AU97TrB;EACE,YAAA;AVg8TF;AACA;;qBAEqB;AU37TrB;EACE,6BAAA;EACA,kDAAA;AV67TF;AU37TA;EACE,6BAAA;AV67TF;AU37TA;EACE,kBAAA;AV67TF;AU17TA;EACE,6CAAA;AV47TF;AACA;;qBAEqB;AUv7TrB;EACE,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;AVy7TF;AUt7TA;EACE,wBAAA;AVw7TF;AUt7TA;EACE,wBAAA;AVw7TF;AUt7TA;EACE,eAAA;AVw7TF;AUt7TA;EACE,wBAAA;AVw7TF;AUt7TA;EACE,wBAAA;AVw7TF;AACA;;qBAEqB;AUp7TrB;EACE,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AVs7TF;AUp7TA;EACE,mBAAA;AVs7TF;AUn7TA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AVq7TF;AUn7TA;EACE,kBAAA;EACA,kDAAA;AVq7TF;AUn7TA;EACE,eAAA;EACA,gBAAA;EACA,kDAAA;AVq7TF;AACA,mBAAmB;AUl7TnB;EACE,uBAAA;AVo7TF;AUl7TA;EACE,uBAAA;AVo7TF;AUl7TA;EACE,cAAA;AVo7TF;AUl7TA;EACE,uBAAA;AVo7TF;AUl7TA;EACE,uBAAA;AVo7TF;AACA;;qBAEqB;AUh7TrB;EACE,uBAAA;AVk7TF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB;;gBAEgB;AAChB,mBAAmB;AACnB,eAAe;AACf,mBAAmB;AACnB;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB;;gBAEgB;AAChB,mBAAmB;AACnB,eAAe;AACf,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AWnvW/B;EACE,oBAAA;EACA,4CAAA;EACA,4SAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,oBAAA;AXqvWF;AWlvWA;EACE,qBAAA;EACA,UAAA;EAEA,2BAAA;EAEA,aAAA;EACA,WAAA;EAEA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EAEA,WAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;AXgvWF;AW7uWA;EACE,2BAAA;AX+uWF;AACA;;+BAE+B;AAC/B;;gBAEgB;AW1uWhB;EACE,WAAA;EACA,cAAA;AX4uWF;AWzuWA;EACE,0CAAA;AX2uWF;AWxuWA;EACE;IACE,uBAAA;EX0uWF;EWxuWA;IACE,yBAAA;EX0uWF;AACF;AACA;;+BAE+B;AWtuW/B;EACE,qBAAA;AXwuWF;AWruWA;EACE,qBAAA;AXuuWF;AWpuWA;EACE,qBAAA;AXsuWF;AWnuWA;EACE,wBAAA;AXquWF;AACA;;+BAE+B;AAC/B;;qBAEqB;AW9tWrB;EACE,WAAA;EACA,sBAAA;AXguWF;AACA;;qBAEqB;AW5tWrB;;EACE,eAAA;EACA,YAAA;EACA,6BAAA;AX+tWF;AW7tWA;;EACE,qBAAA;AXguWF;AACA;;qBAEqB;AW5tWrB;EACE,+BAAA;EACA,yBAAA;EAEA,6BAAA;EACA,sDAAA;EAEA,qBAAA;EACA,sBAAA;AX4tWF;AW1tWA;EACE,YAAA;EACA,gBAAA;AX4tWF;AACA;;qBAEqB;AWxtWrB;;EAEE,uBAAA;AX0tWF;AWxtWA;EACE,uBAAA;AX0tWF;AACA;;qBAEqB;AWttWrB;;;EAGE,wBAAA;AXwtWF;AWrtWA;;EAEE,yBAAA;AXutWF;AACA;;qBAEqB;AWntWrB;EACE,cAAA;EACA,wBAAA;EAEA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,sDAAA;AXotWF;AWltWA;EACE,YAAA;EACA,gBAAA;AXotWF;AACA;;qBAEqB;AACrB,oBAAoB;AWhtWpB;;EAEE,oCAAA;EACA,yBAAA;AXktWF;AW/sWA;EACE,cAAA;AXitWF;AACA;;qBAEqB;AACrB,QAAQ;AW5sWR;EACE,yBAAA;AX8sWF;AW5sWA;EACE,yBAAA;AX8sWF;AW5sWA;;EAEE,oCAAA;EACA,yBAAA;AX8sWF;AACA,WAAW;AW3sWX;EACE,yBAAA;AX6sWF;AW3sWA;EACE,yBAAA;AX6sWF;AW3sWA;;EAEE,oCAAA;EACA,yBAAA;AX6sWF;AACA,WAAW;AW1sWX;EACE,yBAAA;AX4sWF;AW1sWA;EACE,yBAAA;AX4sWF;AW1sWA;;EAEE,oCAAA;EACA,yBAAA;AX4sWF;AACA,UAAU;AWzsWV;EACE,yBAAA;AX2sWF;AWzsWA;EACE,yBAAA;AX2sWF;AWzsWA;;EAEE,oCAAA;EACA,yBAAA;AX2sWF;AACA,UAAU;AWxsWV;EACE,yBAAA;AX0sWF;AWxsWA;EACE,yBAAA;AX0sWF;AWxsWA;;EAEE,oCAAA;EACA,yBAAA;AX0sWF;AACA,SAAS;AWvsWT;EACE,yBAAA;AXysWF;AWvsWA;EACE,yBAAA;AXysWF;AWvsWA;;EAEE,oCAAA;EACA,yBAAA;AXysWF;AACA,SAAS;AWtsWT;EACE,yBAAA;AXwsWF;AWtsWA;EACE,yBAAA;AXwsWF;AWtsWA;;EAEE,oCAAA;EACA,yBAAA;AXwsWF;AACA,WAAW;AWrsWX;EACE,yBAAA;AXusWF;AWrsWA;EACE,yBAAA;AXusWF;AWrsWA;;EAEE,oCAAA;EACA,yBAAA;AXusWF;AACA,WAAW;AWpsWX;EACE,yBAAA;AXssWF;AWpsWA;EACE,yBAAA;AXssWF;AWpsWA;;EAEE,oCAAA;EACA,yBAAA;AXssWF;AACA,SAAS;AWnsWT;EACE,yBAAA;AXqsWF;AWnsWA;EACE,yBAAA;AXqsWF;AWnsWA;;EAEE,oCAAA;EACA,yBAAA;AXqsWF;AACA,UAAU;AWlsWV;EACE,yBAAA;AXosWF;AWlsWA;EACE,yBAAA;AXosWF;AWlsWA;;EAEE,oCAAA;EACA,yBAAA;AXosWF;AACA,SAAS;AWjsWT;EACE,yBAAA;AXmsWF;AWjsWA;EACE,yBAAA;AXmsWF;AWjsWA;;EAEE,oCAAA;EACA,yBAAA;AXmsWF;AACA,UAAU;AWhsWV;EACE,yBAAA;AXksWF;AWhsWA;EACE,yBAAA;AXksWF;AWhsWA;;EAEE,oCAAA;EACA,yBAAA;AXksWF;AACA;;qBAEqB;AW9rWrB;;EAEE,cAAA;EACA,gBAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,gBAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,iBAAA;AXgsWF;AW9rWA;;EAEE,cAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,sBAAA;EACA,gBAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,sBAAA;EACA,cAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,sBAAA;EACA,cAAA;AXgsWF;AW9rWA;;EAEE,cAAA;EACA,sBAAA;EACA,cAAA;AXgsWF;AACA;;+BAE+B;AW5rW/B;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;AX8rWF;AW3rWA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,WAAA;EACA,SAAA;AX6rWF;AW1rWA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AX4rWF;AACA,gBAAgB;AWzrWhB;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,2FAAA;AX2rWF;AWzrWA;EACE,MAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AX2rWF;AWzrWA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AX2rWF;AWzrWA;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;AX2rWF;AWzrWA;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AX2rWF;AWxrWA;EACE,2FAAA;AX0rWF;AACA;;;EAGE;AACF;;;;;;;;;;;;;;;;;;;;;+BAqB+B;AAC/B;;+BAE+B;AAC/B,wCAAwC;AY3qXxC;EAA4B,gBAAA;AZ8qX5B;AY7qXA;EAAwB,gBAAA;AZgrXxB;AY/qXA;EAAyB,gBAAA;AZkrXzB;AYjrXA;EAAwB,gBAAA;AZorXxB;AYnrXA;EAAwB,gBAAA;AZsrXxB;AYrrXA;EAAwB,gBAAA;AZwrXxB;AYvrXA;EAAyB,gBAAA;AZ0rXzB;AACA,UAAU;AYxrXV;EAAyB,gBAAA;AZ2rXzB;AY1rXA;EAAgC,gBAAA;AZ6rXhC;AY5rXA;EAAyB,gBAAA;AZ+rXzB;AY9rXA;EAA6B,gBAAA;AZisX7B;AYhsXA;EAA6B,gBAAA;AZmsX7B;AYlsXA;EAAuB,gBAAA;AZqsXvB;AYpsXA;EAAoB,gBAAA;AZusXpB;AYtsXA;EAAyB,gBAAA;AZysXzB;AYxsXA;EAA+B,gBAAA;AZ2sX/B;AY1sXA;EAAwB,gBAAA;AZ6sXxB;AY5sXA;EAA6B,gBAAA;AZ+sX7B;AY9sXA;EAA8B,gBAAA;AZitX9B;AYhtXA;EAA2B,gBAAA;AZmtX3B;AYltXA;EAA4B,gBAAA;AZqtX5B;AYptXA;EAAuB,gBAAA;AZutXvB;AYttXA;EAA2B,gBAAA;AZytX3B;AYxtXA;EAA0B,gBAAA;AZ2tX1B;AY1tXA;EAAoD,gBAAA;AZ6tXpD;AY5tXA;EAAuB,gBAAA;AZ+tXvB;AY9tXA;EAAuB,gBAAA;AZiuXvB;AYhuXA;EAAwB,gBAAA;AZmuXxB;AYluXA;EAA0B,gBAAA;AZquX1B;AYpuXA;EAAkC,gBAAA;AZuuXlC;AYtuXA;EAAkC,gBAAA;AZyuXlC;AYxuXA;EAAmC,gBAAA;AZ2uXnC;AY1uXA;EAAgC,gBAAA;AZ6uXhC;AY5uXA;EAA2B,gBAAA;AZ+uX3B;AY9uXA;EAA2B,gBAAA;AZivX3B;AYhvXA;EAA4B,gBAAA;AZmvX5B;AYlvXA;EAAyB,gBAAA;AZqvXzB;AYpvXA;EAA8B,gBAAA;AZuvX9B;AYtvXA;EAAwB,gBAAA;AZyvXxB;AYxvXA;EAA0B,gBAAA;AZ2vX1B;AY1vXA;EAA8B,gBAAA;AZ6vX9B;AY5vXA;EAAsB,gBAAA;AZ+vXtB;AY9vXA;EAAsB,gBAAA;AZiwXtB;AYhwXA;EAA0B,gBAAA;AZmwX1B;AYlwXA;EAAwB,gBAAA;AZqwXxB;AYpwXA;EAA4C,gBAAA;AZuwX5C;AYtwXA;EAA4C,gBAAA;AZywX5C;AYxwXA;EAA6C,gBAAA;AZ2wX7C;AY1wXA;EAA0C,gBAAA;AZ6wX1C;AY5wXA;EAAkC,gBAAA;AZ+wXlC;AY9wXA;EAAkC,gBAAA;AZixXlC;AYhxXA;EAAmC,gBAAA;AZmxXnC;AYlxXA;EAAgC,gBAAA;AZqxXhC;AYpxXA;EAA2B,gBAAA;AZuxX3B;AYtxXA;EAA2B,gBAAA;AZyxX3B;AYxxXA;EAA4B,gBAAA;AZ2xX5B;AY1xXA;EAAyB,gBAAA;AZ6xXzB;AY5xXA;EAAiC,gBAAA;AZ+xXjC;AY9xXA;EAA4C,gBAAA;AZiyX5C;AYhyXA;EAA0C,gBAAA;AZmyX1C;AYlyXA;EAA4C,gBAAA;AZqyX5C;AYpyXA;EAAyB,gBAAA;AZuyXzB;AYtyXA;EAA2B,gBAAA;AZyyX3B;AYxyXA;EAAmB,gBAAA;AZ2yXnB;AY1yXA;EAAwB,gBAAA;AZ6yXxB;AY5yXA;EAAkC,gBAAA;AZ+yXlC;AY9yXA;EAA6B,gBAAA;AZizX7B;AYhzXA;EAAwB,gBAAA;AZmzXxB;AYlzXA;EAAuB,gBAAA;AZqzXvB;AYpzXA;EAAoB,gBAAA;AZuzXpB;AYtzXA;EAAyB,gBAAA;AZyzXzB;AYxzXA;EAA8B,gBAAA;AZ2zX9B;AY1zXA;EAAoB,gBAAA;AZ6zXpB;AY5zXA;EAAyB,gBAAA;AZ+zXzB;AY9zXA;EAAyB,gBAAA;AZi0XzB;AYh0XA;EAAwB,gBAAA;AZm0XxB;AYl0XA;EAAqB,gBAAA;AZq0XrB;AYp0XA;EAA8B,gBAAA;AZu0X9B;AYt0XA;EAAgC,gBAAA;AZy0XhC;AYx0XA;EAAqB,gBAAA;AZ20XrB;AY10XA;EAA8B,gBAAA;AZ60X9B;AY50XA;EAA6B,gBAAA;AZ+0X7B;AY90XA;EAA6B,gBAAA;AZi1X7B;AYh1XA;EAAgC,gBAAA;AZm1XhC;AYl1XA;EAAuC,gBAAA;AZq1XvC;AYp1XA;EAAoB,gBAAA;AZu1XpB;AYt1XA;EAAqB,gBAAA;AZy1XrB;AYx1XA;EAAwB,gBAAA;AZ21XxB;AY11XA;EAA+B,gBAAA;AZ61X/B;AY51XA;EAAqB,gBAAA;AZ+1XrB;AY91XA;EAA2B,gBAAA;AZi2X3B;AYh2XA;EAAwB,gBAAA;AZm2XxB;AYl2XA;EAA0B,gBAAA;AZq2X1B;AYp2XA;EAA2B,gBAAA;AZu2X3B;AYt2XA;EAA8B,gBAAA;AZy2X9B;AYx2XA;EAA0B,gBAAA;AZ22X1B;AY12XA;EAAwB,gBAAA;AZ62XxB;AY52XA;EAAqB,gBAAA;AZ+2XrB;AY92XA;EAA0B,gBAAA;AZi3X1B;AYh3XA;EAA2B,gBAAA;AZm3X3B;AYl3XA;EAAsB,gBAAA;AZq3XtB;AYp3XA;EAAwB,gBAAA;AZu3XxB;AYt3XA;EAA0B,gBAAA;AZy3X1B;AYx3XA;EAA0B,gBAAA;AZ23X1B;AY13XA;EAA4B,gBAAA;AZ63X5B;AY53XA;EAAqB,gBAAA;AZ+3XrB;AY93XA;EAAqB,gBAAA;AZi4XrB;AYh4XA;EAAqB,gBAAA;AZm4XrB;AYl4XA;EAAqB,gBAAA;AZq4XrB;AYp4XA;EAAyB,gBAAA;AZu4XzB;AYt4XA;EAA6B,gBAAA;AZy4X7B;AYx4XA;EAAoB,gBAAA;AZ24XpB;AY14XA;EAAsB,gBAAA;AZ64XtB;AY54XA;EAAwB,gBAAA;AZ+4XxB;AY94XA;EAA0B,gBAAA;AZi5X1B;AYh5XA;EAAoB,gBAAA;AZm5XpB;AYl5XA;EAAoB,gBAAA;AZq5XpB;AYp5XA;EAAyB,gBAAA;AZu5XzB;AYt5XA;EAAyB,gBAAA;AZy5XzB;AYx5XA;EAAyB,gBAAA;AZ25XzB;AY15XA;EAAiC,gBAAA;AZ65XjC;AY55XA;EAAoB,gBAAA;AZ+5XpB;AY95XA;EAA2B,gBAAA;AZi6X3B;AYh6XA;EAA2B,gBAAA;AZm6X3B;AYl6XA;EAAyB,gBAAA;AZq6XzB;AYp6XA;EAAmC,gBAAA;AZu6XnC;AYt6XA;EAA+B,gBAAA;AZy6X/B;AYx6XA;EAA+B,gBAAA;AZ26X/B;AY16XA;EAA8B,gBAAA;AZ66X9B;AY56XA;EAA+B,gBAAA;AZ+6X/B;AY96XA;EAAuB,gBAAA;AZi7XvB;AYh7XA;EAA6B,gBAAA;AZm7X7B;AYl7XA;EAAoB,gBAAA;AZq7XpB;AYp7XA;EAA2B,gBAAA;AZu7X3B;AYt7XA;EAA2B,gBAAA;AZy7X3B;AYx7XA;EAA4B,gBAAA;AZ27X5B;AY17XA;EAAkC,gBAAA;AZ67XlC;AY57XA;EAAkC,gBAAA;AZ+7XlC;AY97XA;EAAmC,gBAAA;AZi8XnC;AYh8XA;EAAgC,gBAAA;AZm8XhC;AYl8XA;EAAyB,gBAAA;AZq8XzB;AYp8XA;EAAgC,gBAAA;AZu8XhC;AYt8XA;EAA0B,gBAAA;AZy8X1B;AYx8XA;EAA8B,gBAAA;AZ28X9B;AY18XA;EAAwB,gBAAA;AZ68XxB;AY58XA;EAA6B,gBAAA;AZ+8X7B;AY98XA;EAA+B,gBAAA;AZi9X/B;AYh9XA;EAA4B,gBAAA;AZm9X5B;AYl9XA;EAAuB,gBAAA;AZq9XvB;AYp9XA;EAA8B,gBAAA;AZu9X9B;AYt9XA;EAA0B,gBAAA;AZy9X1B;AYx9XA;EAA0B,gBAAA;AZ29X1B;AY19XA;EAAwB,gBAAA;AZ69XxB;AY59XA;EAA2B,gBAAA;AZ+9X3B;AY99XA;EAA4B,gBAAA;AZi+X5B;AYh+XA;EAA2B,gBAAA;AZm+X3B;AYl+XA;EAA0B,gBAAA;AZq+X1B;AYp+XA;EAA2B,gBAAA;AZu+X3B;AYt+XA;EAA0B,gBAAA;AZy+X1B;AYx+XA;EAAsB,gBAAA;AZ2+XtB;AY1+XA;EAA6B,gBAAA;AZ6+X7B;AY5+XA;EAA6B,gBAAA;AZ++X7B;AY9+XA;EAAsB,gBAAA;AZi/XtB;AYh/XA;EAA6B,gBAAA;AZm/X7B;AYl/XA;EAA4B,gBAAA;AZq/X5B;AYp/XA;EAA2B,gBAAA;AZu/X3B;AYt/XA;EAA6B,gBAAA;AZy/X7B;AYx/XA;EAA2B,gBAAA;AZ2/X3B;AY1/XA;EAA4B,gBAAA;AZ6/X5B;AY5/XA;EAA2B,gBAAA;AZ+/X3B;AY9/XA;EAAoC,gBAAA;AZigYpC;AYhgYA;EAAoC,gBAAA;AZmgYpC;AYlgYA;EAAqC,gBAAA;AZqgYrC;AYpgYA;EAAkC,gBAAA;AZugYlC;AYtgYA;EAA6B,gBAAA;AZygY7B;AYxgYA;EAA6B,gBAAA;AZ2gY7B;AY1gYA;EAA8B,gBAAA;AZ6gY9B;AY5gYA;EAA2B,gBAAA;AZ+gY3B;AY9gYA;EAAsB,gBAAA;AZihYtB;AYhhYA;EAAuB,gBAAA;AZmhYvB;AYlhYA;EAAuB,gBAAA;AZqhYvB;AYphYA;EAA6B,gBAAA;AZuhY7B;AYthYA;EAA0B,gBAAA;AZyhY1B;AYxhYA;EAAgC,gBAAA;AZ2hYhC;AY1hYA;EAA+B,gBAAA;AZ6hY/B;AY5hYA;EAAsB,gBAAA;AZ+hYtB;AY9hYA;EAAsB,gBAAA;AZiiYtB;AYhiYA;EAAkC,gBAAA;AZmiYlC;AYliYA;EAAsB,gBAAA;AZqiYtB;AYpiYA;EAA2B,gBAAA;AZuiY3B;AYtiYA;EAA2B,gBAAA;AZyiY3B;AYxiYA;EAA6B,gBAAA;AZ2iY7B;AY1iYA;EAAqB,gBAAA;AZ6iYrB;AY5iYA;EAA4B,gBAAA;AZ+iY5B;AY9iYA;EAAwB,gBAAA;AZijYxB;AYhjYA;EAAyB,gBAAA;AZmjYzB;AYljYA;EAAuB,gBAAA;AZqjYvB;AYpjYA;EAAoB,gBAAA;AZujYpB;AYtjYA;EAAqB,gBAAA;AZyjYrB;AYxjYA;EAAwB,gBAAA;AZ2jYxB;AY1jYA;EAAwB,gBAAA;AZ6jYxB;AY5jYA;EAAkC,gBAAA;AZ+jYlC;AY9jYA;EAAyB,gBAAA;AZikYzB;AYhkYA;EAAwB,gBAAA;AZmkYxB;AYlkYA;EAAyB,gBAAA;AZqkYzB;AYpkYA;EAA+B,gBAAA;AZukY/B;AYtkYA;EAAuB,gBAAA;AZykYvB;AYxkYA;EAAqB,gBAAA;AZ2kYrB;AY1kYA;EAA0B,gBAAA;AZ6kY1B;AY5kYA;EAAuB,gBAAA;AZ+kYvB;AY9kYA;EAAiC,gBAAA;AZilYjC;AYhlYA;EAA4B,gBAAA;AZmlY5B;AYllYA;EAAqB,gBAAA;AZqlYrB;AYplYA;EAA2B,gBAAA;AZulY3B;AYtlYA;EAAqB,gBAAA;AZylYrB;AYxlYA;EAA+B,gBAAA;AZ2lY/B;AY1lYA;EAAqB,gBAAA;AZ6lYrB;AY5lYA;EAAsB,gBAAA;AZ+lYtB;AY9lYA;EAAoB,gBAAA;AZimYpB;AYhmYA;EAA2B,gBAAA;AZmmY3B;AYlmYA;EAAwB,gBAAA;AZqmYxB;AYpmYA;EAAyB,gBAAA;AZumYzB;AYtmYA;EAAyB,gBAAA;AZymYzB;AYxmYA;EAAqB,gBAAA;AZ2mYrB;AY1mYA;EAA0B,gBAAA;AZ6mY1B;AY5mYA;EAA0B,gBAAA;AZ+mY1B;AY9mYA;EAAwB,gBAAA;AZinYxB;AYhnYA;EAAwB,gBAAA;AZmnYxB;AYlnYA;EAA2B,gBAAA;AZqnY3B;AYpnYA;EAAqB,gBAAA;AZunYrB;AYtnYA;EAA8B,gBAAA;AZynY9B;AYxnYA;EAAwB,gBAAA;AZ2nYxB;AY1nYA;EAA0B,gBAAA;AZ6nY1B;AY5nYA;EAAoB,gBAAA;AZ+nYpB;AY9nYA;EAAuB,gBAAA;AZioYvB;AYhoYA;EAAuB,gBAAA;AZmoYvB;AYloYA;EAA4B,gBAAA;AZqoY5B;AYpoYA;EAAsB,gBAAA;AZuoYtB;AYtoYA;EAA8B,gBAAA;AZyoY9B;AYxoYA;EAA2B,gBAAA;AZ2oY3B;AY1oYA;EAAyB,gBAAA;AZ6oYzB;AY5oYA;EAA8B,gBAAA;AZ+oY9B;AY9oYA;EAAyB,gBAAA;AZipYzB;AYhpYA;EAAgC,gBAAA;AZmpYhC;AYlpYA;EAAwB,gBAAA;AZqpYxB;AYppYA;EAAuB,gBAAA;AZupYvB;AYtpYA;EAAuB,gBAAA;AZypYvB;AYxpYA;EAA2B,gBAAA;AZ2pY3B;AY1pYA;EAAqB,gBAAA;AZ6pYrB;AY5pYA;EAAqB,gBAAA;AZ+pYrB;AY9pYA;EAAsB,gBAAA;AZiqYtB;AYhqYA;EAA0B,gBAAA;AZmqY1B;AYlqYA;EAAoC,gBAAA;AZqqYpC;AYpqYA;EAAkC,gBAAA;AZuqYlC;AYtqYA;EAAsB,gBAAA;AZyqYtB;AYxqYA;EAAuB,gBAAA;AZ2qYvB;AY1qYA;EAAyB,gBAAA;AZ6qYzB;AY5qYA;EAA8B,gBAAA;AZ+qY9B;AY9qYA;EAAgC,gBAAA;AZirYhC;AYhrYA;EAAuB,gBAAA;AZmrYvB;AYlrYA;EAAuB,gBAAA;AZqrYvB;AYprYA;EAAuB,gBAAA;AZurYvB;AYtrYA;EAAyB,gBAAA;AZyrYzB;AYxrYA;EAAqB,gBAAA;AZ2rYrB;AY1rYA;EAA0B,gBAAA;AZ6rY1B;AY5rYA;EAAmC,gBAAA;AZ+rYnC;AY9rYA;EAA4B,gBAAA;AZisY5B;AYhsYA;EAAmC,gBAAA;AZmsYnC;AYlsYA;EAAqC,gBAAA;AZqsYrC;AYpsYA;EAAuB,gBAAA;AZusYvB;AYtsYA;EAAwC,gBAAA;AZysYxC;AYxsYA;EAA6B,gBAAA;AZ2sY7B;AY1sYA;EAAmC,gBAAA;AZ6sYnC;AY5sYA;EAA0C,gBAAA;AZ+sY1C;AY9sYA;EAAoB,gBAAA;AZitYpB;AYhtYA;EAA4B,gBAAA;AZmtY5B;AYltYA;EAA0B,gBAAA;AZqtY1B;AYptYA;EAAyB,gBAAA;AZutYzB;AYttYA;EAA2B,gBAAA;AZytY3B;AYxtYA;EAAmC,gBAAA;AZ2tYnC;AY1tYA;EAAgC,gBAAA;AZ6tYhC;AY5tYA;EAA8B,gBAAA;AZ+tY9B;AY9tYA;EAA6B,gBAAA;AZiuY7B;AYhuYA;EAAoB,gBAAA;AZmuYpB;AYluYA;EAAuB,gBAAA;AZquYvB;AYpuYA;EAA4B,gBAAA;AZuuY5B;AYtuYA;EAAqB,gBAAA;AZyuYrB;AYxuYA;EAA+B,gBAAA;AZ2uY/B;AY1uYA;EAA6B,gBAAA;AZ6uY7B;AY5uYA;EAA2B,gBAAA;AZ+uY3B;AY9uYA;EAA0B,gBAAA;AZivY1B;AYhvYA;EAA2B,gBAAA;AZmvY3B;AYlvYA;EAA2B,gBAAA;AZqvY3B;AYpvYA;EAAyB,gBAAA;AZuvYzB;AYtvYA;EAAgC,gBAAA;AZyvYhC;AYxvYA;EAA2B,gBAAA;AZ2vY3B;AY1vYA;EAA0B,gBAAA;AZ6vY1B;AY5vYA;EAAqB,gBAAA;AZ+vYrB;AY9vYA;EAAuB,gBAAA;AZiwYvB;AYhwYA;EAAqB,gBAAA;AZmwYrB;AYlwYA;EAAkC,gBAAA;AZqwYlC;AYpwYA;EAAwB,gBAAA;AZuwYxB;AYtwYA;EAA0B,gBAAA;AZywY1B;AYxwYA;EAA4B,gBAAA;AZ2wY5B;AY1wYA;EAA2B,gBAAA;AZ6wY3B;AY5wYA;EAAqB,gBAAA;AZ+wYrB;AY9wYA;EAA+B,gBAAA;AZixY/B;AYhxYA;EAAsB,gBAAA;AZmxYtB;AYlxYA;EAAuB,gBAAA;AZqxYvB;AYpxYA;EAA0B,gBAAA;AZuxY1B;AYtxYA;EAAoB,gBAAA;AZyxYpB;AYxxYA;EAAuB,gBAAA;AZ2xYvB;AY1xYA;EAA4B,gBAAA;AZ6xY5B;AY5xYA;EAAqB,gBAAA;AZ+xYrB;AY9xYA;EAA6B,gBAAA;AZiyY7B;AYhyYA;EAAuC,gBAAA;AZmyYvC;AYlyYA;EAAkC,gBAAA;AZqyYlC;AYpyYA;EAA0B,gBAAA;AZuyY1B;AYtyYA;EAA6B,gBAAA;AZyyY7B;AYxyYA;EAA8B,gBAAA;AZ2yY9B;AY1yYA;EAA6B,gBAAA;AZ6yY7B;AY5yYA;EAAuC,gBAAA;AZ+yYvC;AY9yYA;EAAyB,gBAAA;AZizYzB;AYhzYA;EAAwB,gBAAA;AZmzYxB;AYlzYA;EAA2B,gBAAA;AZqzY3B;AYpzYA;EAA+B,gBAAA;AZuzY/B;AYtzYA;EAAwB,gBAAA;AZyzYxB;AYxzYA;EAAsB,gBAAA;AZ2zYtB;AY1zYA;EAAuB,gBAAA;AZ6zYvB;AY5zYA;EAAwB,gBAAA;AZ+zYxB;AY9zYA;EAAsB,gBAAA;AZi0YtB;AYh0YA;EAAoB,gBAAA;AZm0YpB;AYl0YA;EAA2B,gBAAA;AZq0Y3B;AYp0YA;EAA2B,gBAAA;AZu0Y3B;AYt0YA;EAAmB,gBAAA;AZy0YnB;AYx0YA;EAA0B,gBAAA;AZ20Y1B;AY10YA;EAAqB,gBAAA;AZ60YrB;AY50YA;EAAoB,gBAAA;AZ+0YpB;AY90YA;EAA2B,gBAAA;AZi1Y3B;AYh1YA;EAAuB,gBAAA;AZm1YvB;AYl1YA;EAAiC,gBAAA;AZq1YjC;AYp1YA;EAA8B,gBAAA;AZu1Y9B;AYt1YA;EAA0B,gBAAA;AZy1Y1B;AYx1YA;EAAuB,gBAAA;AZ21YvB;AY11YA;EAAuB,gBAAA;AZ61YvB;AY51YA;EAA8B,gBAAA;AZ+1Y9B;AY91YA;EAAsB,gBAAA;AZi2YtB;AYh2YA;EAAwB,gBAAA;AZm2YxB;AYl2YA;EAAsB,gBAAA;AZq2YtB;AYp2YA;EAAuB,gBAAA;AZu2YvB;AYt2YA;EAA0B,gBAAA;AZy2Y1B;AYx2YA;EAA0B,gBAAA;AZ22Y1B;AY12YA;EAA4B,gBAAA;AZ62Y5B;AY52YA;EAAuB,gBAAA;AZ+2YvB;AY92YA;EAA6B,gBAAA;AZi3Y7B;AYh3YA;EAA4B,gBAAA;AZm3Y5B;AYl3YA;EAA4B,gBAAA;AZq3Y5B;AYp3YA;EAA8B,gBAAA;AZu3Y9B;AYt3YA;EAAmC,gBAAA;AZy3YnC;AYx3YA;EAA8B,gBAAA;AZ23Y9B;AY13YA;EAA+B,gBAAA;AZ63Y/B;AY53YA;EAAyB,gBAAA;AZ+3YzB;AY93YA;EAAqB,gBAAA;AZi4YrB;AYh4YA;EAAyB,gBAAA;AZm4YzB;AYl4YA;EAAsB,gBAAA;AZq4YtB;AYp4YA;EAAqB,gBAAA;AZu4YrB;AYt4YA;EAAyB,gBAAA;AZy4YzB;AYx4YA;EAA4B,gBAAA;AZ24Y5B;AY14YA;EAAmC,gBAAA;AZ64YnC;AY54YA;EAA4B,gBAAA;AZ+4Y5B;AY94YA;EAA2B,gBAAA;AZi5Y3B;AYh5YA;EAA2B,gBAAA;AZm5Y3B;AYl5YA;EAAgC,gBAAA;AZq5YhC;AYp5YA;EAAgC,gBAAA;AZu5YhC;AYt5YA;EAAiC,gBAAA;AZy5YjC;AYx5YA;EAA8B,gBAAA;AZ25Y9B;AY15YA;EAA6B,gBAAA;AZ65Y7B;AY55YA;EAA0B,gBAAA;AZ+5Y1B;AY95YA;EAA8B,gBAAA;AZi6Y9B;AYh6YA;EAA2B,gBAAA;AZm6Y3B;AYl6YA;EAA0B,gBAAA;AZq6Y1B;AYp6YA;EAAwB,gBAAA;AZu6YxB;AYt6YA;EAAoB,gBAAA;AZy6YpB;AYx6YA;EAAwB,gBAAA;AZ26YxB;AY16YA;EAA2B,gBAAA;AZ66Y3B;AY56YA;EAAsB,gBAAA;AZ+6YtB;AY96YA;EAA0B,gBAAA;AZi7Y1B;AYh7YA;EAAqB,gBAAA;AZm7YrB;AYl7YA;EAA8B,gBAAA;AZq7Y9B;AYp7YA;EAAwB,gBAAA;AZu7YxB;AYt7YA;EAA4B,gBAAA;AZy7Y5B;AYx7YA;EAAqB,gBAAA;AZ27YrB;AY17YA;EAAsB,gBAAA;AZ67YtB;AY57YA;EAAyB,gBAAA;AZ+7YzB;AY97YA;EAAgC,gBAAA;AZi8YhC;AYh8YA;EAAuB,gBAAA;AZm8YvB;AYl8YA;EAA0B,gBAAA;AZq8Y1B;AYp8YA;EAA8B,gBAAA;AZu8Y9B;AYt8YA;EAA+B,gBAAA;AZy8Y/B;AYx8YA;EAAgC,gBAAA;AZ28YhC;AY18YA;EAAsB,gBAAA;AZ68YtB;AY58YA;EAAsB,gBAAA;AZ+8YtB;AY98YA;EAAwB,gBAAA;AZi9YxB;AYh9YA;EAAyB,gBAAA;AZm9YzB;AYl9YA;EAAyB,gBAAA;AZq9YzB;AYp9YA;EAAwB,gBAAA;AZu9YxB;AYt9YA;EAAsB,gBAAA;AZy9YtB;AYx9YA;EAAuB,gBAAA;AZ29YvB;AY19YA;EAAqB,gBAAA;AZ69YrB;AY59YA;EAAsB,gBAAA;AZ+9YtB;AY99YA;EAAuB,gBAAA;AZi+YvB;AYh+YA;EAAyB,gBAAA;AZm+YzB;AYl+YA;EAAqB,gBAAA;AZq+YrB;AYp+YA;EAA4B,gBAAA;AZu+Y5B;AYt+YA;EAA0B,gBAAA;AZy+Y1B;AYx+YA;EAAkC,gBAAA;AZ2+YlC;AY1+YA;EAAwB,gBAAA;AZ6+YxB;AY5+YA;EAAuB,gBAAA;AZ++YvB;AY9+YA;EAAuB,gBAAA;AZi/YvB;AYh/YA;EAA4B,gBAAA;AZm/Y5B;AYl/YA;EAAwB,gBAAA;AZq/YxB;AYp/YA;EAAsB,gBAAA;AZu/YtB;AYt/YA;EAAuB,gBAAA;AZy/YvB;AYx/YA;EAAmB,gBAAA;AZ2/YnB;AY1/YA;EAA0B,gBAAA;AZ6/Y1B;AY5/YA;EAAyB,gBAAA;AZ+/YzB;AY9/YA;EAAoB,gBAAA;AZigZpB;AYhgZA;EAAyB,gBAAA;AZmgZzB;AYlgZA;EAAuB,gBAAA;AZqgZvB;AYpgZA;EAA4B,gBAAA;AZugZ5B;AYtgZA;EAA8B,gBAAA;AZygZ9B;AYxgZA;EAAuB,gBAAA;AZ2gZvB;AY1gZA;EAAyB,gBAAA;AZ6gZzB;AY5gZA;EAAuB,gBAAA;AZ+gZvB;AY9gZA;EAAwB,gBAAA;AZihZxB;AYhhZA;EAAuB,gBAAA;AZmhZvB;AYlhZA;EAA8B,gBAAA;AZqhZ9B;AYphZA;EAAqB,gBAAA;AZuhZrB;AYthZA;EAAwB,gBAAA;AZyhZxB;AYxhZA;EAAsB,gBAAA;AZ2hZtB;AY1hZA;EAAqB,gBAAA;AZ6hZrB;AY5hZA;EAAqC,gBAAA;AZ+hZrC;AY9hZA;EAAmC,gBAAA;AZiiZnC;AYhiZA;EAA0B,gBAAA;AZmiZ1B;AYliZA;EAA0B,gBAAA;AZqiZ1B;AYpiZA;EAAyB,gBAAA;AZuiZzB;AYtiZA;EAAwB,gBAAA;AZyiZxB;AYxiZA;EAAyB,gBAAA;AZ2iZzB;AY1iZA;EAA6B,gBAAA;AZ6iZ7B;AY5iZA;EAAuB,gBAAA;AZ+iZvB;AY9iZA;EAAsB,gBAAA;AZijZtB;AYhjZA;EAA0B,gBAAA;AZmjZ1B;AYljZA;EAAqB,gBAAA;AZqjZrB;AYpjZA;EAA+B,gBAAA;AZujZ/B;AYtjZA;EAAwB,gBAAA;AZyjZxB;AYxjZA;EAAwB,gBAAA;AZ2jZxB;AY1jZA;EAA+B,gBAAA;AZ6jZ/B;AY5jZA;EAAqB,gBAAA;AZ+jZrB;AY9jZA;EAA0B,gBAAA;AZikZ1B;AYhkZA;EAA0C,gBAAA;AZmkZ1C;AYlkZA;EAA0C,gBAAA;AZqkZ1C;AYpkZA;EAA2C,gBAAA;AZukZ3C;AYtkZA;EAAwC,gBAAA;AZykZxC;AYxkZA;EAA2B,gBAAA;AZ2kZ3B;AY1kZA;EAAqB,gBAAA;AZ6kZrB;AY5kZA;EAAwB,gBAAA;AZ+kZxB;AY9kZA;EAAsB,gBAAA;AZilZtB;AYhlZA;EAAuB,gBAAA;AZmlZvB;AYllZA;EAAqB,gBAAA;AZqlZrB;AYplZA;EAAoB,gBAAA;AZulZpB;AYtlZA;EAA2B,gBAAA;AZylZ3B;AYxlZA;EAAqC,gBAAA;AZ2lZrC;AY1lZA;EAAwB,gBAAA;AZ6lZxB;AY5lZA;EAA0B,gBAAA;AZ+lZ1B;AY9lZA;EAAqB,gBAAA;AZimZrB;AYhmZA;EAA4B,gBAAA;AZmmZ5B;AYlmZA;EAA4B,gBAAA;AZqmZ5B;AYpmZA;EAAuC,gBAAA;AZumZvC;AYtmZA;EAAqC,gBAAA;AZymZrC;AYxmZA;EAAuB,gBAAA;AZ2mZvB;AY1mZA;EAAwB,gBAAA;AZ6mZxB;AY5mZA;EAAuB,gBAAA;AZ+mZvB;AY9mZA;EAAyB,gBAAA;AZinZzB;AYhnZA;EAAuB,gBAAA;AZmnZvB;AYlnZA;EAAsB,gBAAA;AZqnZtB;AYpnZA;EAAuB,gBAAA;AZunZvB;AYtnZA;EAAoB,gBAAA;AZynZpB;AYxnZA;EAAwB,gBAAA;AZ2nZxB;AY1nZA;EAA0B,gBAAA;AZ6nZ1B;AY5nZA;EAA2B,gBAAA;AZ+nZ3B;AY9nZA;EAAiC,gBAAA;AZioZjC;AYhoZA;EAA0B,gBAAA;AZmoZ1B;AYloZA;EAAsB,gBAAA;AZqoZtB;AYpoZA;EAA6B,gBAAA;AZuoZ7B;AYtoZA;EAA6B,gBAAA;AZyoZ7B;AYxoZA;EAAoB,gBAAA;AZ2oZpB;AY1oZA;EAAyB,gBAAA;AZ6oZzB;AY5oZA;EAAuB,gBAAA;AZ+oZvB;AY9oZA;EAAuB,gBAAA;AZipZvB;AYhpZA;EAAiC,gBAAA;AZmpZjC;AYlpZA;EAAqB,gBAAA;AZqpZrB;AYppZA;EAAuB,gBAAA;AZupZvB;AYtpZA;EAAqC,gBAAA;AZypZrC;AYxpZA;EAAqB,gBAAA;AZ2pZrB;AY1pZA;EAA2B,gBAAA;AZ6pZ3B;AY5pZA;EAA8B,gBAAA;AZ+pZ9B;AY9pZA;EAAsB,gBAAA;AZiqZtB;AYhqZA;EAAwB,gBAAA;AZmqZxB;AYlqZA;EAAuB,gBAAA;AZqqZvB;AYpqZA;EAA0B,gBAAA;AZuqZ1B;AYtqZA;EAAgC,gBAAA;AZyqZhC;AYxqZA;EAAqB,gBAAA;AZ2qZrB;AY1qZA;EAAwB,gBAAA;AZ6qZxB;AY5qZA;EAAoB,gBAAA;AZ+qZpB;AY9qZA;EAAoB,gBAAA;AZirZpB;AYhrZA;EAA4B,gBAAA;AZmrZ5B;AYlrZA;EAA6B,gBAAA;AZqrZ7B;AYprZA;EAA+B,gBAAA;AZurZ/B;AYtrZA;EAA8B,gBAAA;AZyrZ9B;AYxrZA;EAAqC,gBAAA;AZ2rZrC;AY1rZA;EAAyB,gBAAA;AZ6rZzB;AY5rZA;EAAuB,gBAAA;AZ+rZvB;AY9rZA;EAAsB,gBAAA;AZisZtB;AYhsZA;EAA8B,gBAAA;AZmsZ9B;AYlsZA;EAAoB,gBAAA;AZqsZpB;AYpsZA;EAAwB,gBAAA;AZusZxB;AYtsZA;EAAsB,gBAAA;AZysZtB;AYxsZA;EAA0B,gBAAA;AZ2sZ1B;AY1sZA;EAA4B,gBAAA;AZ6sZ5B;AY5sZA;EAAuB,gBAAA;AZ+sZvB;AY9sZA;EAAuB,gBAAA;AZitZvB;AYhtZA;EAA4B,gBAAA;AZmtZ5B;AYltZA;EAA0B,gBAAA;AZqtZ1B;AYptZA;EAA0B,gBAAA;AZutZ1B;AYttZA;EAAsB,gBAAA;AZytZtB;AYxtZA;EAAwB,gBAAA;AZ2tZxB;AY1tZA;EAAsB,gBAAA;AZ6tZtB;AY5tZA;EAA6B,gBAAA;AZ+tZ7B;AY9tZA;EAAoB,gBAAA;AZiuZpB;AYhuZA;EAAuB,gBAAA;AZmuZvB;AYluZA;EAA2B,gBAAA;AZquZ3B;AYpuZA;EAAiC,gBAAA;AZuuZjC;AYtuZA;EAAwB,gBAAA;AZyuZxB;AYxuZA;EAA0B,gBAAA;AZ2uZ1B;AY1uZA;EAA4B,gBAAA;AZ6uZ5B;AY5uZA;EAAkC,gBAAA;AZ+uZlC;AY9uZA;EAAsB,gBAAA;AZivZtB;AYhvZA;EAA6B,gBAAA;AZmvZ7B;AYlvZA;EAA6B,gBAAA;AZqvZ7B;AYpvZA;EAAoB,gBAAA;AZuvZpB;AYtvZA;EAA2B,gBAAA;AZyvZ3B;AYxvZA;EAAqC,gBAAA;AZ2vZrC;AY1vZA;EAA8B,gBAAA;AZ6vZ9B;AY5vZA;EAAsB,gBAAA;AZ+vZtB;AY9vZA;EAA0B,gBAAA;AZiwZ1B;AYhwZA;EAA4B,gBAAA;AZmwZ5B;AYlwZA;EAAiC,gBAAA;AZqwZjC;AYpwZA;EAAsB,gBAAA;AZuwZtB;AYtwZA;EAAqB,gBAAA;AZywZrB;AYxwZA;EAA4B,gBAAA;AZ2wZ5B;AY1wZA;EAA4B,gBAAA;AZ6wZ5B;AY5wZA;EAAqB,gBAAA;AZ+wZrB;AY9wZA;EAAqB,gBAAA;AZixZrB;AYhxZA;EAA4B,gBAAA;AZmxZ5B;AYlxZA;EAA4B,gBAAA;AZqxZ5B;AYpxZA;EAAwB,gBAAA;AZuxZxB;AYtxZA;EAA2B,gBAAA;AZyxZ3B;AYxxZA;EAA0B,gBAAA;AZ2xZ1B;AY1xZA;EAAsB,gBAAA;AZ6xZtB;AY5xZA;EAA6B,gBAAA;AZ+xZ7B;AY9xZA;EAAuB,gBAAA;AZiyZvB;AYhyZA;EAA6B,gBAAA;AZmyZ7B;AYlyZA;EAAuB,gBAAA;AZqyZvB;AYpyZA;EAAmB,gBAAA;AZuyZnB;AYtyZA;EAAuB,gBAAA;AZyyZvB;AYxyZA;EAAyB,gBAAA;AZ2yZzB;AY1yZA;EAAgC,gBAAA;AZ6yZhC;AY5yZA;EAA0B,gBAAA;AZ+yZ1B;AY9yZA;EAA0B,gBAAA;AZizZ1B;AYhzZA;EAAsB,gBAAA;AZmzZtB;AYlzZA;EAA2B,gBAAA;AZqzZ3B;AYpzZA;EAA4B,gBAAA;AZuzZ5B;AYtzZA;EAAuB,gBAAA;AZyzZvB;AYxzZA;EAAwB,gBAAA;AZ2zZxB;AY1zZA;EAAsB,gBAAA;AZ6zZtB;AY5zZA;EAAsB,gBAAA;AZ+zZtB;AY9zZA;EAAwB,gBAAA;AZi0ZxB;AYh0ZA;EAAyB,gBAAA;AZm0ZzB;AYl0ZA;EAAuB,gBAAA;AZq0ZvB;AYp0ZA;EAA6B,gBAAA;AZu0Z7B;AYt0ZA;EAA8B,gBAAA;AZy0Z9B;AYx0ZA;EAAqB,gBAAA;AZ20ZrB;AY10ZA;EAA+B,gBAAA;AZ60Z/B;AY50ZA;EAA2B,gBAAA;AZ+0Z3B;AY90ZA;EAAwB,gBAAA;AZi1ZxB;AYh1ZA;EAAuB,gBAAA;AZm1ZvB;AYl1ZA;EAAsB,gBAAA;AZq1ZtB;AYp1ZA;EAA0B,gBAAA;AZu1Z1B;AYt1ZA;EAAuB,gBAAA;AZy1ZvB;AYx1ZA;EAA0B,gBAAA;AZ21Z1B;AY11ZA;EAAwB,gBAAA;AZ61ZxB;AY51ZA;EAAqB,gBAAA;AZ+1ZrB;AY91ZA;EAAuB,gBAAA;AZi2ZvB;AYh2ZA;EAA2B,gBAAA;AZm2Z3B;AYl2ZA;EAAwB,gBAAA;AZq2ZxB;AYp2ZA;EAAoB,gBAAA;AZu2ZpB;AYt2ZA;EAA2B,gBAAA;AZy2Z3B;AYx2ZA;EAA2B,gBAAA;AZ22Z3B;AY12ZA;EAA2B,gBAAA;AZ62Z3B;AY52ZA;EAAuB,gBAAA;AZ+2ZvB;AY92ZA;EAAqB,gBAAA;AZi3ZrB;AYh3ZA;EAAqB,gBAAA;AZm3ZrB;AYl3ZA;EAAuB,gBAAA;AZq3ZvB;AYp3ZA;EAAuB,gBAAA;AZu3ZvB;AYt3ZA;EAAuB,gBAAA;AZy3ZvB;AYx3ZA;EAA6B,gBAAA;AZ23Z7B;AY13ZA;EAA4B,gBAAA;AZ63Z5B;AY53ZA;EAA4B,gBAAA;AZ+3Z5B;AY93ZA;EAAyB,gBAAA;AZi4ZzB;AYh4ZA;EAAuB,gBAAA;AZm4ZvB;AYl4ZA;EAAuB,gBAAA;AZq4ZvB;AYp4ZA;EAA6B,gBAAA;AZu4Z7B;AYt4ZA;EAAsB,gBAAA;AZy4ZtB;AYx4ZA;EAAgC,gBAAA;AZ24ZhC;AY14ZA;EAAuC,gBAAA;AZ64ZvC;AY54ZA;EAA6B,gBAAA;AZ+4Z7B;AY94ZA;EAA4B,gBAAA;AZi5Z5B;AYh5ZA;EAAiC,gBAAA;AZm5ZjC;AYl5ZA;EAAqB,gBAAA;AZq5ZrB;AYp5ZA;EAA8B,gBAAA;AZu5Z9B;AYt5ZA;EAA6B,gBAAA;AZy5Z7B;AYx5ZA;EAA6B,gBAAA;AZ25Z7B;AY15ZA;EAAgC,gBAAA;AZ65ZhC;AY55ZA;EAA8B,gBAAA;AZ+5Z9B;AY95ZA;EAAuB,gBAAA;AZi6ZvB;AYh6ZA;EAA8B,gBAAA;AZm6Z9B;AYl6ZA;EAAuB,gBAAA;AZq6ZvB;AYp6ZA;EAA4B,gBAAA;AZu6Z5B;AYt6ZA;EAAwB,gBAAA;AZy6ZxB;AYx6ZA;EAAwB,gBAAA;AZ26ZxB;AY16ZA;EAAyB,gBAAA;AZ66ZzB;AY56ZA;EAAsB,gBAAA;AZ+6ZtB;AY96ZA;EAAsB,gBAAA;AZi7ZtB;AYh7ZA;EAA2B,gBAAA;AZm7Z3B;AYl7ZA;EAAmC,gBAAA;AZq7ZnC;AYp7ZA;EAA2B,gBAAA;AZu7Z3B;AYt7ZA;EAAsB,gBAAA;AZy7ZtB;AYx7ZA;EAAyB,gBAAA;AZ27ZzB;AY17ZA;EAA+B,gBAAA;AZ67Z/B;AY57ZA;EAAgC,gBAAA;AZ+7ZhC;AY97ZA;EAA0B,gBAAA;AZi8Z1B;AYh8ZA;EAAqB,gBAAA;AZm8ZrB;AYl8ZA;EAAmC,gBAAA;AZq8ZnC;AYp8ZA;EAAiC,gBAAA;AZu8ZjC;AYt8ZA;EAAiC,gBAAA;AZy8ZjC;AYx8ZA;EAA+B,gBAAA;AZ28Z/B;AY18ZA;EAA0B,gBAAA;AZ68Z1B;AY58ZA;EAAkC,gBAAA;AZ+8ZlC;AY98ZA;EAAgC,gBAAA;AZi9ZhC;AYh9ZA;EAAwB,gBAAA;AZm9ZxB;AYl9ZA;EAA2B,gBAAA;AZq9Z3B;AYp9ZA;EAA8B,gBAAA;AZu9Z9B;AYt9ZA;EAAwB,gBAAA;AZy9ZxB;AYx9ZA;EAAwB,gBAAA;AZ29ZxB;AY19ZA;EAAwB,gBAAA;AZ69ZxB;AY59ZA;EAAuB,gBAAA;AZ+9ZvB;AY99ZA;EAA4B,gBAAA;AZi+Z5B;AYh+ZA;EAA+B,gBAAA;AZm+Z/B;AYl+ZA;EAA+B,gBAAA;AZq+Z/B;AYp+ZA;EAAqB,gBAAA;AZu+ZrB;AYt+ZA;EAA0B,gBAAA;AZy+Z1B;AYx+ZA;EAA2B,gBAAA;AZ2+Z3B;AY1+ZA;EAAsB,gBAAA;AZ6+ZtB;AY5+ZA;EAA6B,gBAAA;AZ++Z7B;AY9+ZA;EAA6B,gBAAA;AZi/Z7B;AYh/ZA;EAA8B,gBAAA;AZm/Z9B;AYl/ZA;EAA6B,gBAAA;AZq/Z7B;AYp/ZA;EAA4B,gBAAA;AZu/Z5B;AYt/ZA;EAA6B,gBAAA;AZy/Z7B;AYx/ZA;EAA4B,gBAAA;AZ2/Z5B;AY1/ZA;EAAqB,gBAAA;AZ6/ZrB;AY5/ZA;EAA4B,gBAAA;AZ+/Z5B;AY9/ZA;EAA0B,gBAAA;AZiga1B;AYhgaA;EAAuB,gBAAA;AZmgavB;AYlgaA;EAA4B,gBAAA;AZqga5B;AYpgaA;EAA8B,gBAAA;AZuga9B;AYtgaA;EAAuB,gBAAA;AZygavB;AYxgaA;EAAyB,gBAAA;AZ2gazB;AY1gaA;EAA6B,gBAAA;AZ6ga7B;AY5gaA;EAA4B,gBAAA;AZ+ga5B;AY9gaA;EAAmC,gBAAA;AZihanC;AYhhaA;EAA0B,gBAAA;AZmha1B;AYlhaA;EAAuB,gBAAA;AZqhavB;AYphaA;EAAyB,gBAAA;AZuhazB;AYthaA;EAAoB,gBAAA;AZyhapB;AYxhaA;EAA4B,gBAAA;AZ2ha5B;AY1haA;EAA4B,gBAAA;AZ6ha5B;AY5haA;EAAuB,gBAAA;AZ+havB;AY9haA;EAAqB,gBAAA;AZiiarB;AYhiaA;EAA+B,gBAAA;AZmia/B;AYliaA;EAAwB,gBAAA;AZqiaxB;AYpiaA;EAAsB,gBAAA;AZuiatB;AYtiaA;EAA6B,gBAAA;AZyia7B;AYxiaA;EAAuB,gBAAA;AZ2iavB;AY1iaA;EAAiC,gBAAA;AZ6iajC;AY5iaA;EAAqC,gBAAA;AZ+iarC;AY9iaA;EAAoB,gBAAA;AZijapB;AYhjaA;EAAqB,gBAAA;AZmjarB;AYljaA;EAAsB,gBAAA;AZqjatB;AYpjaA;EAAqB,gBAAA;AZujarB;AYtjaA;EAAyB,gBAAA;AZyjazB;AYxjaA;EAA+B,gBAAA;AZ2ja/B;AY1jaA;EAA8B,gBAAA;AZ6ja9B;AY5jaA;EAAyB,gBAAA;AZ+jazB;AY9jaA;EAA4B,gBAAA;AZika5B;AYhkaA;EAA2B,gBAAA;AZmka3B;AYlkaA;EAAmB,gBAAA;AZqkanB;AYpkaA;EAAyB,gBAAA;AZukazB;AYtkaA;EAAwB,gBAAA;AZykaxB;AYxkaA;EAA0B,gBAAA;AZ2ka1B;AY1kaA;EAA4B,gBAAA;AZ6ka5B;AY5kaA;EAAkC,gBAAA;AZ+kalC;AY9kaA;EAAiC,gBAAA;AZilajC;AYhlaA;EAAiC,gBAAA;AZmlajC;AYllaA;EAAoC,gBAAA;AZqlapC;AYplaA;EAA2C,gBAAA;AZula3C;AYtlaA;EAA4B,gBAAA;AZyla5B;AYxlaA;EAA0B,gBAAA;AZ2la1B;AY1laA;EAA0B,gBAAA;AZ6la1B;AY5laA;EAAiC,gBAAA;AZ+lajC;AY9laA;EAAsB,gBAAA;AZimatB;AYhmaA;EAA6B,gBAAA;AZmma7B;AYlmaA;EAAqB,gBAAA;AZqmarB;AYpmaA;EAA2B,gBAAA;AZuma3B;AYtmaA;EAA0B,gBAAA;AZyma1B;AYxmaA;EAA0B,gBAAA;AZ2ma1B;AY1maA;EAAsB,gBAAA;AZ6matB;AY5maA;EAA4B,gBAAA;AZ+ma5B;AY9maA;EAAsC,gBAAA;AZinatC;AYhnaA;EAAsB,gBAAA;AZmnatB;AYlnaA;EAAgC,gBAAA;AZqnahC;AYpnaA;EAAqB,gBAAA;AZunarB;AYtnaA;EAAuB,gBAAA;AZynavB;AYxnaA;EAA4B,gBAAA;AZ2na5B;AY1naA;EAAuB,gBAAA;AZ6navB;AY5naA;EAAsB,gBAAA;AZ+natB;AY9naA;EAAoB,gBAAA;AZioapB;AYhoaA;EAAuB,gBAAA;AZmoavB;AYloaA;EAA8B,gBAAA;AZqoa9B;AYpoaA;EAAmB,gBAAA;AZuoanB;AYtoaA;EAAuB,gBAAA;AZyoavB;AYxoaA;EAAwB,gBAAA;AZ2oaxB;AY1oaA;EAA+B,gBAAA;AZ6oa/B;AY5oaA;EAAsB,gBAAA;AZ+oatB;AY9oaA;EAAqB,gBAAA;AZiparB;AYhpaA;EAAsB,gBAAA;AZmpatB;AYlpaA;EAAyB,gBAAA;AZqpazB;AYppaA;EAA0B,gBAAA;AZupa1B;AYtpaA;EAAqB,gBAAA;AZyparB;AYxpaA;EAA+B,gBAAA;AZ2pa/B;AY1paA;EAA4B,gBAAA;AZ6pa5B;AY5paA;EAAiC,gBAAA;AZ+pajC;AY9paA;EAA2B,gBAAA;AZiqa3B;AYhqaA;EAAuB,gBAAA;AZmqavB;AYlqaA;EAAuB,gBAAA;AZqqavB;AYpqaA;EAAiC,gBAAA;AZuqajC;AYtqaA;EAAwB,gBAAA;AZyqaxB;AYxqaA;EAAuB,gBAAA;AZ2qavB;AY1qaA;EAAoB,gBAAA;AZ6qapB;AY5qaA;EAAqB,gBAAA;AZ+qarB;AY9qaA;EAA4B,gBAAA;AZira5B;AYhraA;EAAwB,gBAAA;AZmraxB;AYlraA;EAA0B,gBAAA;AZqra1B;AYpraA;EAA4B,gBAAA;AZura5B;AYtraA;EAA2B,gBAAA;AZyra3B;AYxraA;EAAsB,gBAAA;AZ2ratB;AY1raA;EAAyB,gBAAA;AZ6razB;AY5raA;EAA8B,gBAAA;AZ+ra9B;AY9raA;EAAyB,gBAAA;AZisazB;AYhsaA;EAAuB,gBAAA;AZmsavB;AYlsaA;EAAsB,gBAAA;AZqsatB;AYpsaA;EAA6B,gBAAA;AZusa7B;AYtsaA;EAA2B,gBAAA;AZysa3B;AYxsaA;EAAwB,gBAAA;AZ2saxB;AY1saA;EAAuB,gBAAA;AZ6savB;AY5saA;EAA8B,gBAAA;AZ+sa9B;AY9saA;EAAsB,gBAAA;AZitatB;AYhtaA;EAAsB,gBAAA;AZmtatB;AYltaA;EAAsB,gBAAA;AZqtatB;AYptaA;EAA6B,gBAAA;AZuta7B;AYttaA;EAAwB,gBAAA;AZytaxB;AYxtaA;EAAqB,gBAAA;AZ2tarB;AY1taA;EAAmB,gBAAA;AZ6tanB;AY5taA;EAAoB,gBAAA;AZ+tapB;AY9taA;EAAgC,gBAAA;AZiuahC;AYhuaA;EAA4B,gBAAA;AZmua5B;AYluaA;EAA2B,gBAAA;AZqua3B;AYpuaA;EAA0B,gBAAA;AZuua1B;AYtuaA;EAAsB,gBAAA;AZyuatB;AYxuaA;EAA0B,gBAAA;AZ2ua1B;AY1uaA;EAAsB,gBAAA;AZ6uatB;AY5uaA;EAAuB,gBAAA;AZ+uavB;AY9uaA;EAAuB,gBAAA;AZivavB;AYhvaA;EAAyB,gBAAA;AZmvazB;AYlvaA;EAAgC,gBAAA;AZqvahC;AYpvaA;EAA2B,gBAAA;AZuva3B;AYtvaA;EAAsB,gBAAA;AZyvatB;AYxvaA;EAAqB,gBAAA;AZ2varB;AY1vaA;EAA4B,gBAAA;AZ6va5B;AY5vaA;EAA6B,gBAAA;AZ+va7B;AY9vaA;EAAgC,gBAAA;AZiwahC;AYhwaA;EAAgC,gBAAA;AZmwahC;AYlwaA;EAA+B,gBAAA;AZqwa/B;AYpwaA;EAAwB,gBAAA;AZuwaxB;AYtwaA;EAAyB,gBAAA;AZywazB;AYxwaA;EAA0B,gBAAA;AZ2wa1B;AY1waA;EAAiC,gBAAA;AZ6wajC;AY5waA;EAA2B,gBAAA;AZ+wa3B;AY9waA;EAA2B,gBAAA;AZixa3B;AYhxaA;EAAwB,gBAAA;AZmxaxB;AYlxaA;EAAuB,gBAAA;AZqxavB;AYpxaA;EAAqB,gBAAA;AZuxarB;AYtxaA;EAAqB,gBAAA;AZyxarB;AYxxaA;EAA4B,gBAAA;AZ2xa5B;AY1xaA;EAA6B,gBAAA;AZ6xa7B;AY5xaA;EAAsB,gBAAA;AZ+xatB;AY9xaA;EAAuB,gBAAA;AZiyavB;AYhyaA;EAAqC,gBAAA;AZmyarC;AYlyaA;EAAqB,gBAAA;AZqyarB;AYpyaA;EAAyB,gBAAA;AZuyazB;AYtyaA;EAAsB,gBAAA;AZyyatB;AYxyaA;EAAwB,gBAAA;AZ2yaxB;AY1yaA;EAA+B,gBAAA;AZ6ya/B;AACA,YAAY;AY3yaZ;EAA2B,gBAAA;AZ8ya3B;AY7yaA;EAA6B,gBAAA;AZgza7B;AY/yaA;EAA+B,gBAAA;AZkza/B;AYjzaA;EAA4B,gBAAA;AZoza5B;AYnzaA;EAAuB,gBAAA;AZszavB;AYrzaA;EAAuB,gBAAA;AZwzavB;AYvzaA;EAAuC,gBAAA;AZ0zavC;AYzzaA;EAA6C,gBAAA;AZ4za7C;AY3zaA;EAAwC,gBAAA;AZ8zaxC;AY7zaA;EAAqC,gBAAA;AZg0arC;AY/zaA;EAAgC,gBAAA;AZk0ahC;AYj0aA;EAAuC,gBAAA;AZo0avC;AYn0aA;EAAmC,gBAAA;AZs0anC;AYr0aA;EAAmC,gBAAA;AZw0anC;AYv0aA;EAAiC,gBAAA;AZ00ajC;AYz0aA;EAA2B,gBAAA;AZ40a3B;AY30aA;EAA2B,gBAAA;AZ80a3B;AY70aA;EAAgC,gBAAA;AZg1ahC;AY/0aA;EAA4B,gBAAA;AZk1a5B;AYj1aA;EAAyB,gBAAA;AZo1azB;AYn1aA;EAAoB,gBAAA;AZs1apB;AYr1aA;EAA2B,gBAAA;AZw1a3B;AYv1aA;EAAsB,gBAAA;AZ01atB;AYz1aA;EAAoB,gBAAA;AZ41apB;AY31aA;EAAoB,gBAAA;AZ81apB;AY71aA;EAAsC,gBAAA;AZg2atC;AY/1aA;EAAiC,gBAAA;AZk2ajC;AYj2aA;EAAqB,gBAAA;AZo2arB;AYn2aA;EAA6B,gBAAA;AZs2a7B;AYr2aA;EAA2B,gBAAA;AZw2a3B;AYv2aA;EAA2B,gBAAA;AZ02a3B;AYz2aA;EAAgC,gBAAA;AZ42ahC;AY32aA;EAAwB,gBAAA;AZ82axB;AY72aA;EAAiC,gBAAA;AZg3ajC;AY/2aA;EAAoB,gBAAA;AZk3apB;AYj3aA;EAA4C,gBAAA;AZo3a5C;AYn3aA;EAAuB,gBAAA;AZs3avB;AYr3aA;EAA0B,gBAAA;AZw3a1B;AYv3aA;EAAwB,gBAAA;AZ03axB;AYz3aA;EAAoB,gBAAA;AZ43apB;AY33aA;EAAwB,gBAAA;AZ83axB;AY73aA;EAA6B,gBAAA;AZg4a7B;AY/3aA;EAA6B,gBAAA;AZk4a7B;AYj4aA;EAA4B,gBAAA;AZo4a5B;AYn4aA;EAA+B,gBAAA;AZs4a/B;AYr4aA;EAA4B,gBAAA;AZw4a5B;AYv4aA;EAA8B,gBAAA;AZ04a9B;AYz4aA;EAA4B,gBAAA;AZ44a5B;AY34aA;EAA6B,gBAAA;AZ84a7B;AY74aA;EAAyB,gBAAA;AZg5azB;AY/4aA;EAA6B,gBAAA;AZk5a7B;AYj5aA;EAAsC,gBAAA;AZo5atC;AYn5aA;EAA6B,gBAAA;AZs5a7B;AYr5aA;EAAwB,gBAAA;AZw5axB;AYv5aA;EAA4B,gBAAA;AZ05a5B;AYz5aA;EAAqB,gBAAA;AZ45arB;AY35aA;EAAuB,gBAAA;AZ85avB;AY75aA;EAAqB,gBAAA;AZg6arB;AY/5aA;EAAmB,gBAAA;AZk6anB;AYj6aA;EAAsB,gBAAA;AZo6atB;AYn6aA;EAAqB,gBAAA;AZs6arB;AYr6aA;EAAiC,gBAAA;AZw6ajC;AYv6aA;EAA0B,gBAAA;AZ06a1B;AYz6aA;EAA+B,gBAAA;AZ46a/B;AY36aA;EAAsB,gBAAA;AZ86atB;AY76aA;EAAoB,gBAAA;AZg7apB;AY/6aA;EAAyB,gBAAA;AZk7azB;AYj7aA;EAA2B,gBAAA;AZo7a3B;AYn7aA;EAAyB,gBAAA;AZs7azB;AYr7aA;EAA0B,gBAAA;AZw7a1B;AYv7aA;EAAwB,gBAAA;AZ07axB;AYz7aA;EAAyB,gBAAA;AZ47azB;AY37aA;EAAgC,gBAAA;AZ87ahC;AY77aA;EAAuB,gBAAA;AZg8avB;AY/7aA;EAA0B,gBAAA;AZk8a1B;AYj8aA;EAAiC,gBAAA;AZo8ajC;AYn8aA;EAA4B,gBAAA;AZs8a5B;AYr8aA;EAA8B,gBAAA;AZw8a9B;AYv8aA;EAAyB,gBAAA;AZ08azB;AYz8aA;EAA4B,gBAAA;AZ48a5B;AY38aA;EAAuB,gBAAA;AZ88avB;AY78aA;EAAuB,gBAAA;AZg9avB;AY/8aA;EAAqB,gBAAA;AZk9arB;AYj9aA;EAAwB,gBAAA;AZo9axB;AYn9aA;EAAgC,gBAAA;AZs9ahC;AYr9aA;EAAyB,gBAAA;AZw9azB;AYv9aA;EAAwB,gBAAA;AZ09axB;AYz9aA;EAA0B,gBAAA;AZ49a1B;AY39aA;EAA+B,gBAAA;AZ89a/B;AY79aA;EAAsB,gBAAA;AZg+atB;AY/9aA;EAAoB,gBAAA;AZk+apB;AYj+aA;EAAqB,gBAAA;AZo+arB;AYn+aA;EAA2B,gBAAA;AZs+a3B;AYr+aA;EAAmB,gBAAA;AZw+anB;AYv+aA;EAAwB,gBAAA;AZ0+axB;AYz+aA;EAAyB,gBAAA;AZ4+azB;AY3+aA;EAAqB,gBAAA;AZ8+arB;AY7+aA;EAAkC,gBAAA;AZg/alC;AY/+aA;EAA0B,gBAAA;AZk/a1B;AYj/aA;EAAqB,gBAAA;AZo/arB;AYn/aA;EAA0B,gBAAA;AZs/a1B;AYr/aA;EAAoC,gBAAA;AZw/apC;AYv/aA;EAAqB,gBAAA;AZ0/arB;AYz/aA;EAAqB,gBAAA;AZ4/arB;AY3/aA;EAAoB,gBAAA;AZ8/apB;AY7/aA;EAAoB,gBAAA;AZggbpB;AY//aA;EAAuB,gBAAA;AZkgbvB;AYjgbA;EAAmC,gBAAA;AZogbnC;AYngbA;EAAqC,gBAAA;AZsgbrC;AYrgbA;EAAqB,gBAAA;AZwgbrB;AYvgbA;EAA2B,gBAAA;AZ0gb3B;AYzgbA;EAA4B,gBAAA;AZ4gb5B;AY3gbA;EAAsB,gBAAA;AZ8gbtB;AY7gbA;EAAkB,gBAAA;AZghblB;AY/gbA;EAA6B,gBAAA;AZkhb7B;AYjhbA;EAAyB,gBAAA;AZohbzB;AYnhbA;EAAgC,gBAAA;AZshbhC;AYrhbA;EAAuB,gBAAA;AZwhbvB;AYvhbA;EAA4B,gBAAA;AZ0hb5B;AYzhbA;EAAqB,gBAAA;AZ4hbrB;AY3hbA;EAA6B,gBAAA;AZ8hb7B;AY7hbA;EAAqB,gBAAA;AZgibrB;AY/hbA;EAAsB,gBAAA;AZkibtB;AYjibA;EAA+B,gBAAA;AZoib/B;AYnibA;EAA+B,gBAAA;AZsib/B;AYribA;EAA8B,gBAAA;AZwib9B;AYvibA;EAAgC,gBAAA;AZ0ibhC;AYzibA;EAA8B,gBAAA;AZ4ib9B;AY3ibA;EAAqB,gBAAA;AZ8ibrB;AY7ibA;EAAoB,gBAAA;AZgjbpB;AY/ibA;EAAwB,gBAAA;AZkjbxB;AYjjbA;EAAoB,gBAAA;AZojbpB;AYnjbA;EAA4B,gBAAA;AZsjb5B;AYrjbA;EAAyB,gBAAA;AZwjbzB;AYvjbA;EAAyC,gBAAA;AZ0jbzC;AYzjbA;EAAoC,gBAAA;AZ4jbpC;AY3jbA;EAAoB,gBAAA;AZ8jbpB;AY7jbA;EAAoB,gBAAA;AZgkbpB;AY/jbA;EAAoB,gBAAA;AZkkbpB;AYjkbA;EAAoB,gBAAA;AZokbpB;AYnkbA;EAAoB,gBAAA;AZskbpB;AYrkbA;EAAsB,gBAAA;AZwkbtB;AYvkbA;EAAwB,gBAAA;AZ0kbxB;AYzkbA;EAA0B,gBAAA;AZ4kb1B;AY3kbA;EAAqB,gBAAA;AZ8kbrB;AY7kbA;EAA2B,gBAAA;AZglb3B;AY/kbA;EAAgC,gBAAA;AZklbhC;AYjlbA;EAAwB,gBAAA;AZolbxB;AYnlbA;EAAqB,gBAAA;AZslbrB;AYrlbA;EAA4B,gBAAA;AZwlb5B;AYvlbA;EAAwB,gBAAA;AZ0lbxB;AYzlbA;EAA6B,gBAAA;AZ4lb7B;AY3lbA;EAA4B,gBAAA;AZ8lb5B;AY7lbA;EAAqB,gBAAA;AZgmbrB;AY/lbA;EAAgC,gBAAA;AZkmbhC;AYjmbA;EAAoB,gBAAA;AZombpB;AYnmbA;EAAuB,gBAAA;AZsmbvB;AYrmbA;EAA+B,gBAAA;AZwmb/B;AYvmbA;EAAgC,gBAAA;AZ0mbhC;AYzmbA;EAA8B,gBAAA;AZ4mb9B;AY3mbA;EAAgC,gBAAA;AZ8mbhC;AY7mbA;EAA2B,gBAAA;AZgnb3B;AY/mbA;EAA+B,gBAAA;AZknb/B;AYjnbA;EAAyB,gBAAA;AZonbzB;AYnnbA;EAAwB,gBAAA;AZsnbxB;AYrnbA;EAAqB,gBAAA;AZwnbrB;AYvnbA;EAA+B,gBAAA;AZ0nb/B;AYznbA;EAAuC,gBAAA;AZ4nbvC;AY3nbA;EAA8B,gBAAA;AZ8nb9B;AY7nbA;EAA6B,gBAAA;AZgob7B;AY/nbA;EAAwB,gBAAA;AZkobxB;AYjobA;EAAwC,gBAAA;AZoobxC;AYnobA;EAAsC,gBAAA;AZsobtC;AYrobA;EAA6B,gBAAA;AZwob7B;AYvobA;EAAwB,gBAAA;AZ0obxB;AYzobA;EAA4B,gBAAA;AZ4ob5B;AY3obA;EAA8B,gBAAA;AZ8ob9B;AY7obA;EAAsB,gBAAA;AZgpbtB;AY/obA;EAAwB,gBAAA;AZkpbxB;AYjpbA;EAA0B,gBAAA;AZopb1B;AYnpbA;EAA0B,gBAAA;AZspb1B;AYrpbA;EAA+B,gBAAA;AZwpb/B;AYvpbA;EAAoB,gBAAA;AZ0pbpB;AYzpbA;EAA0B,gBAAA;AZ4pb1B;AY3pbA;EAAuB,gBAAA;AZ8pbvB;AY7pbA;EAAsB,gBAAA;AZgqbtB;AY/pbA;EAA8B,gBAAA;AZkqb9B;AYjqbA;EAA8B,gBAAA;AZoqb9B;AYnqbA;EAA+B,gBAAA;AZsqb/B;AYrqbA;EAA4B,gBAAA;AZwqb5B;AYvqbA;EAAsB,gBAAA;AZ0qbtB;AYzqbA;EAA2B,gBAAA;AZ4qb3B;AY3qbA;EAAsB,gBAAA;AZ8qbtB;AY7qbA;EAAwB,gBAAA;AZgrbxB;AY/qbA;EAAyB,gBAAA;AZkrbzB;AYjrbA;EAAqB,gBAAA;AZorbrB;AYnrbA;EAAuB,gBAAA;AZsrbvB;AYrrbA;EAAwB,gBAAA;AZwrbxB;AYvrbA;EAA8B,gBAAA;AZ0rb9B;AYzrbA;EAAqC,gBAAA;AZ4rbrC;AY3rbA;EAA4B,gBAAA;AZ8rb5B;AY7rbA;EAAuB,gBAAA;AZgsbvB;AY/rbA;EAAuB,gBAAA;AZksbvB;AYjsbA;EAAoB,gBAAA;AZosbpB;AYnsbA;EAAuB,gBAAA;AZssbvB;AYrsbA;EAAoB,gBAAA;AZwsbpB;AYvsbA;EAAsB,gBAAA;AZ0sbtB;AYzsbA;EAAsB,gBAAA;AZ4sbtB;AY3sbA;EAAoB,gBAAA;AZ8sbpB;AY7sbA;EAA+B,gBAAA;AZgtb/B;AY/sbA;EAAqB,gBAAA;AZktbrB;AYjtbA;EAAwB,gBAAA;AZotbxB;AYntbA;EAAyB,gBAAA;AZstbzB;AYrtbA;EAAuB,gBAAA;AZwtbvB;AYvtbA;EAAuB,gBAAA;AZ0tbvB;AYztbA;EAAyB,gBAAA;AZ4tbzB;AY3tbA;EAAqB,gBAAA;AZ8tbrB;AY7tbA;EAAwB,gBAAA;AZgubxB;AY/tbA;EAAyB,gBAAA;AZkubzB;AYjubA;EAAwB,gBAAA;AZoubxB;AYnubA;EAAwB,gBAAA;AZsubxB;AYrubA;EAAuB,gBAAA;AZwubvB;AYvubA;EAAwB,gBAAA;AZ0ubxB;AYzubA;EAAuB,gBAAA;AZ4ubvB;AY3ubA;EAAwC,gBAAA;AZ8ubxC;AY7ubA;EAAyC,gBAAA;AZgvbzC;AY/ubA;EAA+B,gBAAA;AZkvb/B;AYjvbA;EAAuC,gBAAA;AZovbvC;AYnvbA;EAAwC,gBAAA;AZsvbxC;AYrvbA;EAAgC,gBAAA;AZwvbhC;AYvvbA;EAAuC,gBAAA;AZ0vbvC;AYzvbA;EAAwC,gBAAA;AZ4vbxC;AY3vbA;EAAsB,gBAAA;AZ8vbtB;AY7vbA;EAAoB,gBAAA;AZgwbpB;AY/vbA;EAA4B,gBAAA;AZkwb5B;AYjwbA;EAAwB,gBAAA;AZowbxB;AYnwbA;EAAqB,gBAAA;AZswbrB;AYrwbA;EAAuB,gBAAA;AZwwbvB;AYvwbA;EAAyB,gBAAA;AZ0wbzB;AYzwbA;EAA2B,gBAAA;AZ4wb3B;AY3wbA;EAA4B,gBAAA;AZ8wb5B;AY7wbA;EAA+B,gBAAA;AZgxb/B;AY/wbA;EAA2B,gBAAA;AZkxb3B;AYjxbA;EAAsB,gBAAA;AZoxbtB;AYnxbA;EAA4B,gBAAA;AZsxb5B;AYrxbA;EAA2B,gBAAA;AZwxb3B;AYvxbA;EAAqB,gBAAA;AZ0xbrB;AYzxbA;EAAmB,gBAAA;AZ4xbnB;AY3xbA;EAA4B,gBAAA;AZ8xb5B;AY7xbA;EAA4B,gBAAA;AZgyb5B;AY/xbA;EAA6B,gBAAA;AZkyb7B;AYjybA;EAA0B,gBAAA;AZoyb1B;AYnybA;EAA0B,gBAAA;AZsyb1B;AYrybA;EAAuB,gBAAA;AZwybvB;AYvybA;EAA0B,gBAAA;AZ0yb1B;AYzybA;EAA8B,gBAAA;AZ4yb9B;AY3ybA;EAA8B,gBAAA;AZ8yb9B;AY7ybA;EAA+B,gBAAA;AZgzb/B;AY/ybA;EAA4B,gBAAA;AZkzb5B;AYjzbA;EAAoB,gBAAA;AZozbpB;AYnzbA;EAAuB,gBAAA;AZszbvB;AYrzbA;EAA0B,gBAAA;AZwzb1B;AYvzbA;EAAuB,gBAAA;AZ0zbvB;AYzzbA;EAAoB,gBAAA;AZ4zbpB;AY3zbA;EAA4B,gBAAA;AZ8zb5B;AY7zbA;EAA2B,gBAAA;AZg0b3B;AY/zbA;EAA4B,gBAAA;AZk0b5B;AYj0bA;EAAuB,gBAAA;AZo0bvB;AYn0bA;EAAsB,gBAAA;AZs0btB;AYr0bA;EAA6B,gBAAA;AZw0b7B;AYv0bA;EAA2B,gBAAA;AZ00b3B;AYz0bA;EAA0B,gBAAA;AZ40b1B;AY30bA;EAAqB,gBAAA;AZ80brB;AY70bA;EAAqC,gBAAA;AZg1brC;AY/0bA;EAAqB,gBAAA;AZk1brB;AYj1bA;EAA+B,gBAAA;AZo1b/B;AYn1bA;EAA6B,gBAAA;AZs1b7B;AYr1bA;EAAwB,gBAAA;AZw1bxB;AYv1bA;EAAuB,gBAAA;AZ01bvB;AYz1bA;EAAsB,gBAAA;AZ41btB;AY31bA;EAA0B,gBAAA;AZ81b1B;AY71bA;EAAuB,gBAAA;AZg2bvB;AY/1bA;EAAuB,gBAAA;AZk2bvB;AYj2bA;EAAsB,gBAAA;AZo2btB;AYn2bA;EAAoB,gBAAA;AZs2bpB;AYr2bA;EAAmC,gBAAA;AZw2bnC;AYv2bA;EAAgC,gBAAA;AZ02bhC;AYz2bA;EAAsB,gBAAA;AZ42btB;AY32bA;EAA6B,gBAAA;AZ82b7B;AY72bA;EAAkB,gBAAA;AZg3blB;AY/2bA;EAAmB,gBAAA;AZk3bnB;AYj3bA;EAA4B,gBAAA;AZo3b5B;AYn3bA;EAAoB,gBAAA;AZs3bpB;AYr3bA;EAAoB,gBAAA;AZw3bpB;AYv3bA;EAAwB,gBAAA;AZ03bxB;AYz3bA;EAAyB,gBAAA;AZ43bzB;AY33bA;EAAqB,gBAAA;AZ83brB;AY73bA;EAAiC,gBAAA;AZg4bjC;AY/3bA;EAA8B,gBAAA;AZk4b9B;AYj4bA;EAA4B,gBAAA;AZo4b5B;AYn4bA;EAA+B,gBAAA;AZs4b/B;AYr4bA;EAA6B,gBAAA;AZw4b7B;AYv4bA;EAAwB,gBAAA;AZ04bxB;AYz4bA;EAA6B,gBAAA;AZ44b7B;AY34bA;EAAwC,gBAAA;AZ84bxC;AY74bA;EAAyB,gBAAA;AZg5bzB;AY/4bA;EAA0B,gBAAA;AZk5b1B;AYj5bA;EAAwB,gBAAA;AZo5bxB;AYn5bA;EAAqB,gBAAA;AZs5brB;AYr5bA;EAAyB,gBAAA;AZw5bzB;AYv5bA;EAA+B,gBAAA;AZ05b/B;AYz5bA;EAAgC,gBAAA;AZ45bhC;AY35bA;EAAyB,gBAAA;AZ85bzB;AY75bA;EAAkC,gBAAA;AZg6blC;AY/5bA;EAAqB,gBAAA;AZk6brB;AYj6bA;EAA+B,gBAAA;AZo6b/B;AYn6bA;EAA2B,gBAAA;AZs6b3B;AYr6bA;EAAyB,gBAAA;AZw6bzB;AYv6bA;EAAuB,gBAAA;AZ06bvB;AYz6bA;EAAyB,gBAAA;AZ46bzB;AY36bA;EAAsB,gBAAA;AZ86btB;AY76bA;EAAqB,gBAAA;AZg7brB;AY/6bA;EAAuB,gBAAA;AZk7bvB;AYj7bA;EAAwB,gBAAA;AZo7bxB;AYn7bA;EAAsB,gBAAA;AZs7btB;AYr7bA;EAAgC,gBAAA;AZw7bhC;AYv7bA;EAAkC,gBAAA;AZ07blC;AYz7bA;EAAgC,gBAAA;AZ47bhC;AY37bA;EAAwB,gBAAA;AZ87bxB;AY77bA;EAAyB,gBAAA;AZg8bzB;AY/7bA;EAAsB,gBAAA;AZk8btB;AYj8bA;EAAgC,gBAAA;AZo8bhC;AYn8bA;EAA+B,gBAAA;AZs8b/B;AYr8bA;EAAuB,gBAAA;AZw8bvB;AYv8bA;EAAgC,gBAAA;AZ08bhC;AYz8bA;EAAsB,gBAAA;AZ48btB;AY38bA;EAA6B,gBAAA;AZ88b7B;AACA;;+BAE+B;AAC/B,iBAAiB;AACjB,4BAA4B;AYx8b1B;EACE,4BAAA;EACA,4CAAA;EACA,gTAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,oBAAA;AZ08bJ;AYx8bE;EACE,4BAAA;AZ08bJ;AACA,qBAAqB;AYx8bnB;EAAqC,gBAAA;AZ28bvC;AY18bE;EAAqC,gBAAA;AZ68bvC;AY58bE;EAAoD,gBAAA;AZ+8btD;AY98bE;EAAoD,gBAAA;AZi9btD;AYh9bE;EAAqD,gBAAA;AZm9bvD;AYl9bE;EAAkD,gBAAA;AZq9bpD;AYp9bE;EAA6B,gBAAA;AZu9b/B;AYt9bE;EAAmC,gBAAA;AZy9brC;AYx9bE;EAAiC,gBAAA;AZ29bnC;AY19bE;EAAiC,gBAAA;AZ69bnC;AY59bE;EAAiC,gBAAA;AZ+9bnC;AY99bE;EAA2C,gBAAA;AZi+b7C;AYh+bE;EAAuC,gBAAA;AZm+bzC;AYl+bE;EAAuC,gBAAA;AZq+bzC;AYp+bE;EAAsC,gBAAA;AZu+bxC;AYt+bE;EAAuC,gBAAA;AZy+bzC;AYx+bE;EAA0C,gBAAA;AZ2+b5C;AY1+bE;EAA0C,gBAAA;AZ6+b5C;AY5+bE;EAA2C,gBAAA;AZ++b7C;AY9+bE;EAAwC,gBAAA;AZi/b1C;AYh/bE;EAAkC,gBAAA;AZm/bpC;AYl/bE;EAAqC,gBAAA;AZq/bvC;AYp/bE;EAAqC,gBAAA;AZu/bvC;AYt/bE;EAA+B,gBAAA;AZy/bjC;AYx/bE;EAAkC,gBAAA;AZ2/bpC;AY1/bE;EAA8B,gBAAA;AZ6/bhC;AY5/bE;EAA8B,gBAAA;AZ+/bhC;AY9/bE;EAA0C,gBAAA;AZigc5C;AYhgcE;EAAgC,gBAAA;AZmgclC;AYlgcE;EAA0C,gBAAA;AZqgc5C;AYpgcE;EAAiC,gBAAA;AZugcnC;AYtgcE;EAAgC,gBAAA;AZygclC;AYxgcE;EAA6B,gBAAA;AZ2gc/B;AY1gcE;EAAkC,gBAAA;AZ6gcpC;AY5gcE;EAAoC,gBAAA;AZ+gctC;AY9gcE;EAAmC,gBAAA;AZihcrC;AYhhcE;EAA6B,gBAAA;AZmhc/B;AYlhcE;EAAiC,gBAAA;AZqhcnC;AYphcE;EAAsC,gBAAA;AZuhcxC;AYthcE;EAAkC,gBAAA;AZyhcpC;AYxhcE;EAA6B,gBAAA;AZ2hc/B;AY1hcE;EAAuC,gBAAA;AZ6hczC;AY5hcE;EAAqC,gBAAA;AZ+hcvC;AY9hcE;EAAmC,gBAAA;AZiicrC;AYhicE;EAAkC,gBAAA;AZmicpC;AYlicE;EAAmC,gBAAA;AZqicrC;AYpicE;EAAmC,gBAAA;AZuicrC;AYticE;EAAiC,gBAAA;AZyicnC;AYxicE;EAAwC,gBAAA;AZ2ic1C;AY1icE;EAAmC,gBAAA;AZ6icrC;AY5icE;EAAkC,gBAAA;AZ+icpC;AY9icE;EAA6B,gBAAA;AZijc/B;AYhjcE;EAA+B,gBAAA;AZmjcjC;AYljcE;EAAoC,gBAAA;AZqjctC;AYpjcE;EAA8B,gBAAA;AZujchC;AYtjcE;EAA+B,gBAAA;AZyjcjC;AYxjcE;EAA4B,gBAAA;AZ2jc9B;AY1jcE;EAAoC,gBAAA;AZ6jctC;AY5jcE;EAAmC,gBAAA;AZ+jcrC;AY9jcE;EAAmC,gBAAA;AZikcrC;AYhkcE;EAAwC,gBAAA;AZmkc1C;AYlkcE;EAAwC,gBAAA;AZqkc1C;AYpkcE;EAAyC,gBAAA;AZukc3C;AYtkcE;EAAsC,gBAAA;AZykcxC;AYxkcE;EAAqC,gBAAA;AZ2kcvC;AY1kcE;EAAkC,gBAAA;AZ6kcpC;AY5kcE;EAAsC,gBAAA;AZ+kcxC;AY9kcE;EAAmC,gBAAA;AZilcrC;AYhlcE;EAAkC,gBAAA;AZmlcpC;AYllcE;EAA4B,gBAAA;AZqlc9B;AYplcE;EAA8B,gBAAA;AZulchC;AYtlcE;EAAiC,gBAAA;AZylcnC;AYxlcE;EAAkC,gBAAA;AZ2lcpC;AY1lcE;EAAiC,gBAAA;AZ6lcnC;AY5lcE;EAAgC,gBAAA;AZ+lclC;AY9lcE;EAA8B,gBAAA;AZimchC;AYhmcE;EAA+B,gBAAA;AZmmcjC;AYlmcE;EAAiC,gBAAA;AZqmcnC;AYpmcE;EAA8B,gBAAA;AZumchC;AYtmcE;EAAkC,gBAAA;AZymcpC;AYxmcE;EAAkC,gBAAA;AZ2mcpC;AY1mcE;EAAuC,gBAAA;AZ6mczC;AY5mcE;EAA4B,gBAAA;AZ+mc9B;AY9mcE;EAA4B,gBAAA;AZinc9B;AYhncE;EAAqC,gBAAA;AZmncvC;AYlncE;EAA6C,gBAAA;AZqnc/C;AYpncE;EAA6B,gBAAA;AZunc/B;AYtncE;EAAkC,gBAAA;AZyncpC;AYxncE;EAAqC,gBAAA;AZ2ncvC;AY1ncE;EAAuC,gBAAA;AZ6nczC;AY5ncE;EAAoC,gBAAA;AZ+nctC;AY9ncE;EAAqC,gBAAA;AZiocvC;AYhocE;EAAoC,gBAAA;AZmoctC;AYlocE;EAAoC,gBAAA;AZqoctC;AYpocE;EAAwC,gBAAA;AZuoc1C;AYtocE;EAAmC,gBAAA;AZyocrC;AYxocE;EAA6B,gBAAA;AZ2oc/B;AY1ocE;EAAqC,gBAAA;AZ6ocvC;AY5ocE;EAA8B,gBAAA;AZ+ochC;AY9ocE;EAAkC,gBAAA;AZipcpC;AYhpcE;EAA+B,gBAAA;AZmpcjC;AYlpcE;EAA6B,gBAAA;AZqpc/B;AYppcE;EAAkC,gBAAA;AZupcpC;AYtpcE;EAAoC,gBAAA;AZypctC;AYxpcE;EAAoC,gBAAA;AZ2pctC;AY1pcE;EAA4B,gBAAA;AZ6pc9B;AY5pcE;EAAoC,gBAAA;AZ+pctC;AY9pcE;EAAkC,gBAAA;AZiqcpC;AYhqcE;EAAqC,gBAAA;AZmqcvC;AYlqcE;EAAwC,gBAAA;AZqqc1C;AYpqcE;EAA6B,gBAAA;AZuqc/B;AYtqcE;EAAoC,gBAAA;AZyqctC;AYxqcE;EAAqC,gBAAA;AZ2qcvC;AY1qcE;EAAwC,gBAAA;AZ6qc1C;AY5qcE;EAAwC,gBAAA;AZ+qc1C;AY9qcE;EAAuC,gBAAA;AZirczC;AACA,oBAAoB;AY/qclB;EAA6B,gBAAA;AZkrc/B;AYjrcE;;EAEE,4BAAA;AZmrcJ;AYjrcE;EAA4B,gBAAA;AZorc9B;AYnrcE;EAA2B,gBAAA;AZsrc7B;AACA;;+BAE+B;AAC/B,6BAA6B;AY/qc3B;EACE,0BAAA;EACA,6CAAA;EACA,iTAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,oBAAA;AZircJ;AACA,2BAA2B;AY/qczB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4UE,0BAAA;AZircJ;AACA,8CAA8C;AAC9C;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,SAAS;AACT,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,SAAS;AACT,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;Aa99gB/B;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;Abg+gBF;Aa79gBA;EACE,cAAA;Ab+9gBF;Aa59gBA;;EAEE,cAAA;EACA,eAAA;EACA,YAAA;Ab89gBF;AACA;;+BAE+B;Aaz9gB/B;;EAEE,aAAA;Ab29gBF;Aaz9gBA;;EAEE,cAAA;EACA,kBAAA;Ab29gBF;Aaz9gBA;EACE,qBAAA;EACA,kBAAA;Ab29gBF;Aav9gBA;;EAEE,eAAA;EACA,aAAA;Aby9gBF;AACA;;+BAE+B;AAC/B;;gBAEgB;Aal9gBhB;;;EAGE,qBAAA;Abo9gBF;AACA;;oBAEoB;Aah9gBpB;;;;EAIE,qBAAA;EACA,mBAAA;Abk9gBF;Aah9gBA;;;;EAIE,qBAAA;EACA,sBAAA;Abk9gBF;Aah9gBA;;;;EAIE,qBAAA;EACA,sBAAA;Abk9gBF;AACA;;gBAEgB;Aa98gBhB;;;;EAIE,uBAAA;Abg9gBF;AACA;;gBAEgB;Aa58gBhB;;;;;;EAME,oCAAA;Ab88gBF;AACA;;gBAEgB;Aa18gBhB;;EAEE,gBAAA;Ab48gBF;Aaz8gBA;;;;EAIE,6BAAA;EACA,0BAAA;EACA,qBAAA;Ab28gBF;AACA;;gBAEgB;Aav8gBhB;;;;;;EAME,cAAA;EACA,WAAA;EACA,YAAA;Aby8gBF;AACA;;gBAEgB;Aap8gBhB;;;;;;EAME,oBAAA;EAEA,qBAAA;EACA,UAAA;EACA,WAAA;EAEA,6BAAA;EACA,0BAAA;EACA,qBAAA;Abo8gBF;AACA;;qBAEqB;Aah8gBrB;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;Abk8gBF;Aa/7gBA;EACE,kBAAA;EACA,iBAAA;Abi8gBF;Aa97gBA;EACE,gBAAA;EACA,mBAAA;Abg8gBF;AACA;;qBAEqB;Aa57gBrB;;EAEE,WAAA;EACA,iBAAA;EACA,kBAAA;Ab87gBF;Aa57gBA;;EAEE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;Ab87gBF;Aa37gBA;;EAEE,kBAAA;Ab67gBF;Aaz7gBA;;EAEE,iBAAA;EACA,kBAAA;Ab27gBF;AACA;;gBAEgB;Aav7gBhB;;;;EAIE,WAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,WAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,eAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;Aav7gBA;;;;EAIE,YAAA;EACA,YAAA;EACA,wBAAA;Aby7gBF;AACA;;+BAE+B;Aap7gB/B;EACE,cAAA;EACA,yBAAA;Abs7gBF;Aan7gBA;;;EAGE,qBAAA;EACA,0BAAA;Abq7gBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,eAAe;AACf,wBAAwB;AACxB,kBAAkB;AAClB;;qBAEqB;AACrB,gBAAgB;AAChB,SAAS;AACT,UAAU;AACV,UAAU;AACV,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,eAAe;AACf,wBAAwB;AACxB,kBAAkB;AAClB;;qBAEqB;AACrB,gBAAgB;AAChB,SAAS;AACT,UAAU;AACV,UAAU;AACV,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;sBAEsB;Acz4iBtB;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;Ad24iBF;Acz4iBA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;EACA,gBAAA;EACA,yBAAA;EAEA,mEAAA;EACA,yBAAA;EAEA,qCAAA;EACA,2CAAA;EACA,cAAA;EACA,4BAAA;EACA,wDAAA;EAEA,gBAAA;Adw4iBF;AACA;;sBAEsB;AACtB,0CAA0C;Acl4iB1C;EACE,cAAA;Ado4iBF;Acl4iBA;EACE,cAAA;Ado4iBF;Acl4iBA;EACE,cAAA;Ado4iBF;AACA;;+BAE+B;AAC/B;;sBAEsB;Ac93iBtB;;EAEE,aAAA;Adg4iBF;Ac73iBA;;EAEE,oBAAA;Ad+3iBF;AACA;;sBAEsB;Ac33iBtB;;EAEE,gCAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;Ad63iBF;AACA;;sBAEsB;Acz3iBtB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,sCAAA;Ady3iBF;Acv3iBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;Ado3iBF;AACA;;sBAEsB;Ac/2iBtB;;EAEE,qBAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;Adi3iBF;Ac/2iBA;;EAEE,cAAA;Adi3iBF;Ac/2iBA;;EAEE,cAAA;Adi3iBF;Ac/2iBA;;EAEE,cAAA;Adi3iBF;AACA;;sBAEsB;Ac32iBtB;EACE,uCAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;Ad62iBF;AACA,sBAAsB;Ac12iBtB;EACE,cAAA;Ad42iBF;Ac12iBA;EACE,cAAA;Ad42iBF;Ac12iBA;EACE,yBAAA;Ad42iBF;AACA,8BAA8B;Acz2iB9B;EACE,cAAA;Ad22iBF;Acz2iBA;EACE,cAAA;Ad22iBF;Acz2iBA;EACE,yBAAA;Ad22iBF;AACA;;+BAE+B;AAC/B;;sBAEsB;Acr2iBtB;EACE,oCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;Adu2iBF;AACA,qBAAqB;Acp2iBrB;EACE,YAAA;Ads2iBF;Acp2iBA;EACE,4BAAA;EACA,6BAAA;Ads2iBF;Acp2iBA;EACE,4BAAA;EACA,6BAAA;Ads2iBF;AACA,yBAAyB;Acn2iBzB;EACE,cAAA;Adq2iBF;Acn2iBA;EACE,cAAA;Adq2iBF;Acl2iBA;EACE,+BAAA;Ado2iBF;Acl2iBA;EACE,+BAAA;Ado2iBF;Acl2iBA;EACE,+BAAA;Ado2iBF;AACA;;sBAEsB;Ac/1iBtB;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,YAAA;EACA,kDAAA;EACA,6BAAA;Adg2iBF;Ac91iBA;EACE,oBAAA;Adg2iBF;Ac91iBA;EACE,sCAAA;Adg2iBF;Ac71iBA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;Ad+1iBF;Ac71iBA;EACE,eAAA;Ad+1iBF;Ac71iBA;EACE,WAAA;EACA,YAAA;Ad+1iBF;AACA,oBAAoB;Ac51iBpB;EACE,WAAA;EACA,SAAA;EACA,kDAAA;Ad81iBF;Ac51iBA;EACE,WAAA;EACA,WAAA;Ad81iBF;Ac51iBA;EACE,qCAAA;EACA,6BAAA;Ad81iBF;AACA,UAAU;Ac31iBV;EACE,UAAA;Ad61iBF;AACA;;sBAEsB;AACtB,mBAAmB;Acz1iBnB;EACE,cAAA;EACA,SAAA;EACA,cAAA;Ad21iBF;Acz1iBA;EACE,yBAAA;EACA,4BAAA;Ad21iBF;AACA,0BAA0B;Acx1iB1B;EACE,4BAAA;EACA,+BAAA;Ad01iBF;Acx1iBA;EACE,2BAAA;EACA,8BAAA;EACA,8BAAA;Ad01iBF;Acx1iBA;EACE,0BAAA;Ad01iBF;AACA,2BAA2B;Acv1iB3B;EACE,uCAAA;EACA,0CAAA;EACA,0CAAA;Ady1iBF;Acv1iBA;EACE,2BAAA;EACA,8BAAA;Ady1iBF;Act1iBA;EACE,sCAAA;Adw1iBF;AACA,iBAAiB;Acr1iBjB;EACE,QAAA;EACA,UAAA;EACA,uBAAA;EACA,wCAAA;Adu1iBF;AACA,8BAA8B;Acp1iB9B;EACE,+BAAA;Ads1iBF;Acp1iBA;EACE,gCAAA;Ads1iBF;Acp1iBA;EACE,oBAAA;Ads1iBF;AACA,iBAAiB;Acn1iBjB;EACE,8BAAA;Adq1iBF;Acn1iBA;EACE,+BAAA;Adq1iBF;Acn1iBA;EACE,mBAAA;Adq1iBF;AACA,2BAA2B;Acl1iB3B;EACE,QAAA;EACA,UAAA;Ado1iBF;Acl1iBA;EACE,WAAA;EACA,SAAA;Ado1iBF;AACA;;sBAEsB;Ac/0iBtB;;EAEE,aAAA;EACA,mBAAA;EACA,cAAA;Adi1iBF;Ac/0iBA;;EAEE,yBAAA;EACA,4BAAA;EACA,SAAA;Adi1iBF;AACA,oBAAoB;Ac90iBpB;EACE,uCAAA;EACA,0CAAA;EACA,0CAAA;Adg1iBF;Ac90iBA;;;EAGE,kBAAA;Adg1iBF;Ac90iBA;;;EAGE,kDAAA;Adg1iBF;AACA,gBAAgB;Ac70iBhB;EACE,sCAAA;Ad+0iBF;AACA,mBAAmB;Ac50iBnB;EACE,sCAAA;EACA,yCAAA;EACA,yCAAA;Ad80iBF;Ac50iBA;;;EAGE,kBAAA;Ad80iBF;Ac50iBA;;;EAGE,kDAAA;Ad80iBF;AACA,gBAAgB;Ac50iBhB;EACE,qCAAA;Ad80iBF;AACA;;sBAEsB;AACtB,aAAa;Ac10iBb;EACE,YAAA;Ad40iBF;AACA;;sBAEsB;Acx0iBtB;EACE,aAAA;Ad00iBF;Acx0iBA;EACE,qBAAA;Ad00iBF;AACA;;sBAEsB;Act0iBtB;EACE,uBAAA;Adw0iBF;Act0iBA;EACE,uBAAA;Adw0iBF;Act0iBA;EACE,cAAA;Adw0iBF;Act0iBA;EACE,uBAAA;Adw0iBF;Act0iBA;EACE,uBAAA;Adw0iBF;Act0iBA;EACE,uBAAA;Adw0iBF;Act0iBA;EACE,uBAAA;Adw0iBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,gDAAgD;AAChD,UAAU;AACV;;qBAEqB;AACrB,SAAS;AACT,SAAS;AACT,UAAU;AACV,WAAW;AACX,WAAW;AACX;;qBAEqB;AACrB,gBAAgB;AAChB;;qBAEqB;AACrB,UAAU;AACV,WAAW;AACX,iBAAiB;AACjB;;qBAEqB;AACrB,UAAU;AACV,QAAQ;AACR,wDAAwD;AACxD,WAAW;AACX,gCAAgC;AAChC,gCAAgC;AAChC,WAAW;AACX,aAAa;AACb,WAAW;AACX,gBAAgB;AAChB,eAAe;AACf,qBAAqB;AACrB,aAAa;AACb,mBAAmB;AACnB,aAAa;AACb;;qBAEqB;AACrB,WAAW;AACX,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,gDAAgD;AAChD,UAAU;AACV;;qBAEqB;AACrB,SAAS;AACT,SAAS;AACT,UAAU;AACV,WAAW;AACX,WAAW;AACX;;qBAEqB;AACrB,gBAAgB;AAChB;;qBAEqB;AACrB,UAAU;AACV,WAAW;AACX,iBAAiB;AACjB;;qBAEqB;AACrB,UAAU;AACV,QAAQ;AACR,wDAAwD;AACxD,WAAW;AACX,gCAAgC;AAChC,gCAAgC;AAChC,WAAW;AACX,aAAa;AACb,WAAW;AACX,gBAAgB;AAChB,eAAe;AACf,qBAAqB;AACrB,aAAa;AACb,mBAAmB;AACnB,aAAa;AACb;;qBAEqB;AACrB,WAAW;AACX,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AelglB/B;EACE,qBAAA;EACA,cAAA;EACA,wBAAA;EAEA,wBAAA;EAEA,kCAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,oBAAA;EACA,iBAAA;EAEA,6BAAA;EACA,4BAAA;EACA,gCAAA;AfgglBF;Ae7/kBA;EACE,gBAAA;Af+/kBF;Ae7/kBA;EACE,iBAAA;Af+/kBF;AACA,SAAS;Ae5/kBT;EACE,eAAA;Af8/kBF;AACA,gBAAgB;Ae3/kBhB;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,6BAAA;Af6/kBF;Ae3/kBA;EACE,UAAA;Af6/kBF;AACA,UAAU;Ae1/kBV;EACE,sBAAA;EACA,sBAAA;EACA,2BAAA;Af4/kBF;AACA,SAAS;Aez/kBT;EACE,WAAA;EACA,0BAAA;Af2/kBF;AACA,WAAW;Aex/kBX;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;Af0/kBF;Aex/kBA;EACE,0BAAA;Af0/kBF;AACA,oBAAoB;Aet/kBpB;;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;Afw/kBF;Aet/kBA;EACE,UAAA;Afw/kBF;AACA;;qBAEqB;Aep/kBrB;EACE,2BAAA;Afs/kBF;AACA;;qBAEqB;Aej/kBrB;EACE,sBAAA;Afm/kBF;AACA,6CAA6C;Ae/+kB7C;;EAEE,yBAAA;Afi/kBF;Ae/+kBA;;EAEE,0BAAA;Afi/kBF;Ae/+kBA;EACE,4BAAA;Afi/kBF;Ae/+kBA;EACE,6BAAA;Afi/kBF;AACA,0CAA0C;Ae9+kB1C;;EAEE,2BAAA;Afg/kBF;Ae9+kBA;EACE,eAAA;EACA,8BAAA;Afg/kBF;AACA;;+BAE+B;Ae3+kB/B;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,oBAAA;EAEA,4BAAA;EACA,wCAAA;EACA,4BAAA;EACA,gBAAA;Af4+kBF;Aez+kBA;EACE,qBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,wCAAA;EACA,kDAAA;Af0+kBF;Aev+kBA;EACE,8BAAA;EACA,0CAAA;EACA,yBAAA;EACA,kDAAA;Afy+kBF;AACA;;qBAEqB;Aer+kBrB;;EAEE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kDAAA;EACA,gBAAA;Afs+kBF;Aep+kBA;;EAEI,kBAAA;EACA,0DAAA;EAEA,QAAA;EACA,WAAA;EACA,WAAA;EAEA,yBAAA;EACA,sBAAA;EAEA,aAAA;EACA,cAAA;EACA,gBAAA;Afm+kBJ;Ae/9kBA;;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EAEA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EAEA,2CAAA;EACA,qBAAA;Af+9kBF;AACA;;qBAEqB;Ae19kBrB;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,8BAAA;EAEA,UAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;Af09kBF;AACA,eAAe;Aev9kBf;EACE,wCAAA;Afy9kBF;Aev9kBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EAEA,UAAA;EACA,WAAA;EACA,wCAAA;EAEA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EAEA,2BAAA;EACA,kCAAA;Afs9kBF;Aen9kBA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;Afq9kBF;AACA,gBAAgB;Ael9kBhB;;EAEE,WAAA;EACA,SAAA;Afo9kBF;Ael9kBA;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EAEA,yBAAA;Afm9kBF;Aej9kBA;EACE,mBAAA;Afm9kBF;AACA,YAAY;Aeh9kBZ;EACE,SAAA;EACA,WAAA;Afk9kBF;Aeh9kBA;EACE,WAAA;EACA,UAAA;Afk9kBF;AACA;;qBAEqB;Ae98kBrB;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kDAAA;EACA,iCAAA;Afg9kBF;Ae78kBA;EACE,kBAAA;EACA,WAAA;EAEA,SAAA;EACA,QAAA;EACA,wCAAA;EAEA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,2BAAA;EAEA,UAAA;EACA,WAAA;Af48kBF;AACA,gBAAgB;Ae18kBhB;EACE,yBAAA;EACA,oBAAA;EACA,gCAAA;EACA,oBAAA;Af48kBF;Ae18kBA;EACE,+BAAA;EACA,mBAAA;EACA,iCAAA;Af48kBF;AACA,iBAAiB;Aez8kBjB;EACE,gBAAA;EACA,4BAAA;EACA,kDAAA;Af28kBF;Aez8kBA;EACE,UAAA;EACA,SAAA;EAEA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;Af08kBF;AACA,iBAAiB;Aev8kBjB;;EAEE,kBAAA;EACA,SAAA;Afy8kBF;Aev8kBA;;EAEE,6BAAA;Afy8kBF;Aev8kBA;;EAEE,mCAAA;EACA,qBAAA;Afy8kBF;AACA,iBAAiB;Aet8kBjB;EACE,iCAAA;Afw8kBF;Aet8kBA;EACE,uCAAA;EACA,qBAAA;Afw8kBF;AACA;;qBAEqB;Aen8kBrB;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,kDAAA;Afm8kBF;Aej8kBA;EACE,SAAA;EACA,WAAA;EACA,kDAAA;Afm8kBF;Aeh8kBA;EACE,WAAA;EACA,0BAAA;EACA,kDAAA;Afk8kBF;Ae/7kBA;EACE,WAAA;EACA,UAAA;EACA,UAAA;EACA,kDAAA;Afi8kBF;Ae/7kBA;EACE,WAAA;EACA,SAAA;EACA,WAAA;EACA,kDAAA;Afi8kBF;Ae/7kBA;EACE,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kDAAA;Afi8kBF;AACA;;+BAE+B;AAC/B;;qBAEqB;Ae37kBrB;EACE,YAAA;Af67kBF;AACA;;qBAEqB;Aez7kBrB;;EAEE,yBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,+BAAA;Af07kBF;Aex7kBA;;EAEE,+BAAA;Af07kBF;AACA;;qBAEqB;Aet7kBrB;EACE,yBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,gCAAA;Afu7kBF;Aer7kBA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;Afu7kBF;AACA;;qBAEqB;Aen7kBrB;;EAEE,yBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,gCAAA;Afo7kBF;Ael7kBA;;EAEE,yBAAA;EACA,sBAAA;EACA,gCAAA;Afo7kBF;AACA;;qBAEqB;Ae/6kBrB;;EAEE,gCAAA;Afi7kBF;AACA;;qBAEqB;Ae76kBrB;;EAEE,wBAAA;Af+6kBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AACrB,cAAc;Aex6kBd;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af06kBF;AACA,SAAS;Aex6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af06kBF;AACA,WAAW;Aex6kBX;;EAEE,wCAAA;Af06kBF;AACA,WAAW;Aex6kBX;EACE,gCAAA;Af06kBF;AACA,UAAU;Aex6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Af06kBF;Aex6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Af06kBF;AACA,iBAAiB;Aev6kBjB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afy6kBF;AACA,SAAS;Aev6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afy6kBF;AACA,WAAW;Aev6kBX;;EAEE,wCAAA;Afy6kBF;AACA,WAAW;Aev6kBX;EACE,gCAAA;Afy6kBF;AACA,UAAU;Aev6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afy6kBF;Aev6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afy6kBF;AACA,iBAAiB;Aet6kBjB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afw6kBF;AACA,SAAS;Aet6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afw6kBF;AACA,WAAW;Aet6kBX;;EAEE,wCAAA;Afw6kBF;AACA,WAAW;Aet6kBX;EACE,gCAAA;Afw6kBF;AACA,UAAU;Aet6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afw6kBF;Aet6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afw6kBF;AACA,gBAAgB;Aer6kBhB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afu6kBF;AACA,SAAS;Aer6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afu6kBF;AACA,WAAW;Aer6kBX;;EAEE,wCAAA;Afu6kBF;AACA,WAAW;Aer6kBX;EACE,gCAAA;Afu6kBF;AACA,UAAU;Aer6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afu6kBF;Aer6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afu6kBF;AACA,gBAAgB;Aep6kBhB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afs6kBF;AACA,SAAS;Aep6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afs6kBF;AACA,WAAW;Aep6kBX;;EAEE,wCAAA;Afs6kBF;AACA,WAAW;Aep6kBX;EACE,gCAAA;Afs6kBF;AACA,UAAU;Aep6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afs6kBF;Aep6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afs6kBF;AACA,eAAe;Aen6kBf;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afq6kBF;AACA,SAAS;Aen6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afq6kBF;AACA,WAAW;Aen6kBX;;EAEE,wCAAA;Afq6kBF;AACA,WAAW;Aen6kBX;EACE,gCAAA;Afq6kBF;AACA,UAAU;Aen6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afq6kBF;Aen6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afq6kBF;AACA,eAAe;Ael6kBf;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afo6kBF;AACA,SAAS;Ael6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afo6kBF;AACA,WAAW;Ael6kBX;;EAEE,wCAAA;Afo6kBF;AACA,WAAW;Ael6kBX;EACE,gCAAA;Afo6kBF;AACA,UAAU;Ael6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afo6kBF;Ael6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afo6kBF;AACA,iBAAiB;Aej6kBjB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afm6kBF;AACA,SAAS;Aej6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afm6kBF;AACA,WAAW;Aej6kBX;;EAEE,wCAAA;Afm6kBF;AACA,WAAW;Aej6kBX;EACE,gCAAA;Afm6kBF;AACA,UAAU;Aej6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afm6kBF;Aej6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afm6kBF;AACA,iBAAiB;Aeh6kBjB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afk6kBF;AACA,SAAS;Aeh6kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afk6kBF;AACA,WAAW;Aeh6kBX;;EAEE,wCAAA;Afk6kBF;AACA,WAAW;Aeh6kBX;EACE,gCAAA;Afk6kBF;AACA,UAAU;Aeh6kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afk6kBF;Aeh6kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afk6kBF;AACA,eAAe;Ae/5kBf;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afi6kBF;AACA,SAAS;Ae/5kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afi6kBF;AACA,WAAW;Ae/5kBX;;EAEE,wCAAA;Afi6kBF;AACA,WAAW;Ae/5kBX;EACE,gCAAA;Afi6kBF;AACA,UAAU;Ae/5kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afi6kBF;Ae/5kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afi6kBF;AACA,gBAAgB;Ae95kBhB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afg6kBF;AACA,SAAS;Ae95kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Afg6kBF;AACA,WAAW;Ae95kBX;;EAEE,wCAAA;Afg6kBF;AACA,WAAW;Ae95kBX;EACE,gCAAA;Afg6kBF;AACA,UAAU;Ae95kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Afg6kBF;Ae95kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Afg6kBF;AACA,eAAe;Ae75kBf;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af+5kBF;AACA,SAAS;Ae75kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af+5kBF;AACA,WAAW;Ae75kBX;;EAEE,wCAAA;Af+5kBF;AACA,WAAW;Ae75kBX;EACE,gCAAA;Af+5kBF;AACA,UAAU;Ae75kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Af+5kBF;Ae75kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Af+5kBF;AACA,gBAAgB;Ae55kBhB;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af85kBF;AACA,SAAS;Ae55kBT;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;Af85kBF;AACA,WAAW;Ae55kBX;;EAEE,wCAAA;Af85kBF;AACA,WAAW;Ae55kBX;EACE,gCAAA;Af85kBF;AACA,UAAU;Ae55kBV;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;Af85kBF;Ae55kBA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;Af85kBF;AACA;;qBAEqB;Aez5kBrB;EACE,wBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gBAAA;Af25kBF;AACA,SAAS;Aex5kBT;EACE,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,+CAAA;EACA,gBAAA;Af05kBF;AACA,aAAa;Aev5kBb;EACE,qBAAA;Afy5kBF;AACA;;qBAEqB;Aep5kBrB;;EAEE,WAAA;EACA,sBAAA;Afs5kBF;AACA;;qBAEqB;Ael5kBrB;;EAEE,0CAAA;Afo5kBF;AACA;;qBAEqB;Aeh5kBrB;;EAEE,yBAAA;EAEA,sBAAA;EACA,cAAA;EACA,kBAAA;Afi5kBF;AACA;;qBAEqB;Ae54kBrB;;EAEE,cAAA;EACA,eAAA;EAEA,yBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;Af44kBF;Ae14kBA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;Af44kBF;AACA;;qBAEqB;Aex4kBrB;EACE,kBAAA;Af04kBF;Aev4kBA;EACE,kBAAA;Afy4kBF;Aet4kBA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;Afw4kBF;AACA,UAAU;Aet4kBV;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EAEA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;Afu4kBF;AACA,gBAAgB;Aep4kBhB;;EAEE,eAAA;Afs4kBF;Aep4kBA;;EAEE,6BAAA;EACA,0DAAA;EACA,OAAA;EACA,SAAA;Afs4kBF;AACA,gBAAgB;Aep4kBhB;;EAEE,eAAA;EACA,kBAAA;Afs4kBF;Aep4kBA;;EAEE,6BAAA;EACA,SAAA;EACA,WAAA;EACA,0DAAA;EACA,SAAA;EACA,SAAA;Afs4kBF;AACA,eAAe;Aep4kBf;EACE,eAAA;EACA,qBAAA;Afs4kBF;Aep4kBA;EACE,6BAAA;EACA,0DAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;Afs4kBF;AACA,gBAAgB;Aep4kBhB;EACE,eAAA;EACA,sBAAA;Afs4kBF;Aep4kBA;EACE,6BAAA;EACA,yDAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;Afs4kBF;AACA,mBAAmB;AACnB,gBAAgB;Ael4kBhB;;EAEE,gBAAA;Afo4kBF;AACA,gBAAgB;Ael4kBhB;;EAEE,YAAA;EACA,SAAA;EACA,eAAA;Afo4kBF;AACA,eAAe;Ael4kBf;EACE,QAAA;EACA,UAAA;Afo4kBF;AACA,gBAAgB;Ael4kBhB;EACE,QAAA;EACA,WAAA;Afo4kBF;AACA;;oBAEoB;Ae/3kBpB;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;Afi4kBF;AACA;;qBAEqB;Ae73kBrB;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,eAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;Ae73kBA;;EAEE,wBAAA;Af+3kBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,cAAc;AACd,aAAa;AACb,kBAAkB;AAClB;;qBAEqB;AACrB,SAAS;AACT,UAAU;AACV,YAAY;AACZ,WAAW;AACX,gBAAgB;AAChB,SAAS;AACT,gBAAgB;AAChB,gBAAgB;AAChB;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,eAAe;AACf,aAAa;AACb,cAAc;AACd,uBAAuB;AACvB,mBAAmB;AACnB,0BAA0B;AAC1B,4BAA4B;AAC5B,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,iBAAiB;AACjB,uBAAuB;AACvB,YAAY;AACZ,uBAAuB;AACvB,YAAY;AACZ,uBAAuB;AACvB,YAAY;AACZ,iBAAiB;AACjB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,cAAc;AACd,aAAa;AACb,kBAAkB;AAClB;;qBAEqB;AACrB,SAAS;AACT,UAAU;AACV,YAAY;AACZ,WAAW;AACX,gBAAgB;AAChB,SAAS;AACT,gBAAgB;AAChB,gBAAgB;AAChB;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,eAAe;AACf,aAAa;AACb,cAAc;AACd,uBAAuB;AACvB,mBAAmB;AACnB,0BAA0B;AAC1B,4BAA4B;AAC5B,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,iBAAiB;AACjB,uBAAuB;AACvB,YAAY;AACZ,uBAAuB;AACvB,YAAY;AACZ,uBAAuB;AACvB,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AgBpyoB/B;;;EAGE,qBAAA;EACA,eAAA;EACA,gBAAA;AhBsyoBF;AgBnyoBA;;;EAGE,eAAA;EACA,gBAAA;AhBqyoBF;AgBlyoBA;;;EAGE,kBAAA;EACA,mBAAA;AhBoyoBF;AACA;;+BAE+B;AAC/B,cAAc;AgBhyoBd;;;;EAIE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,yBAAA;AhBiyoBF;AgB9xoBA;;;;EAIE,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AhBgyoBF;AgB7xoBA;;;;EAIE,gBAAA;AhB+xoBF;AgB7xoBA;;;;EAIE,mBAAA;AhB+xoBF;AACA,eAAe;AgB5xoBf;;;EAGE,WAAA;EACA,WAAA;EACA,gCAAA;AhB8xoBF;AACA,eAAe;AgB3xoBf;;;EAGE,yBAAA;EACA,oBAAA;AhB6xoBF;AACA,SAAS;AgBzxoBT;;EAEE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;AhB2xoBF;AgBzxoBA;;EAEE,qBAAA;EACA,mBAAA;AhB2xoBF;AACA,UAAU;AgBvxoBV;;EAEE,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,mBAAA;AhByxoBF;AgBvxoBA;;EAEE,oBAAA;AhByxoBF;AgBvxoBA;;EAEE,mBAAA;AhByxoBF;AgBtxoBA;;;;EAIE,qBAAA;AhBwxoBF;AACA,YAAY;AgBrxoBZ;;EAEE,yBAAA;AhBuxoBF;AgBrxoBA;;;;EAIE,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;AhBuxoBF;AgBrxoBA;;EAEE,qBAAA;EACA,WAAA;AhBuxoBF;AgBrxoBA;;EAEE,gBAAA;EACA,iBAAA;AhBuxoBF;AACA,WAAW;AgBpxoBX;;EAEE,cAAA;EACA,WAAA;EACA,mEAAA;EACA,iBAAA;EACA,gCAAA;AhBsxoBF;AACA,gBAAgB;AgBnxoBhB;;EAEE,cAAA;EACA,yBAAA;AhBqxoBF;AACA,eAAe;AgBlxoBf;;EAEE,eAAA;AhBoxoBF;AACA,iBAAiB;AgBjxoBjB;;EAEE,eAAA;EACA,cAAA;AhBmxoBF;AgBjxoBA;;EAEE,cAAA;AhBmxoBF;AACA,sBAAsB;AgBhxoBtB;;EAEE,+BAAA;AhBkxoBF;AACA,gBAAgB;AgB/woBhB;;EAEE,eAAA;EACA,yBAAA;AhBixoBF;AgB/woBA;;EAEE,yBAAA;AhBixoBF;AACA,oBAAoB;AgB9woBpB;EACE,WAAA;AhBgxoBF;AgB9woBA;EACE,YAAA;AhBgxoBF;AgB7woBA;;EAEE,WAAA;EACA,uBAAA;AhB+woBF;AgB7woBA;;EAEE,YAAA;EACA,uBAAA;AhB+woBF;AACA;;+BAE+B;AgB3woB/B;;EAEE,kBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,yBAAA;AhB2woBF;AgBzwoBA;;EAEE,YAAA;EACA,gBAAA;AhB2woBF;AgBzwoBA;;EAEE,gBAAA;AhB2woBF;AgBzwoBA;;EAEE,mBAAA;AhB2woBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AgBrwoBrB;EACE,qBAAA;EACA,cAAA;AhBuwoBF;AgBrwoBA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;AhBuwoBF;AgBrwoBA;EACE,2BAAA;EACA,4BAAA;AhBuwoBF;AgBrwoBA;EACE,iBAAA;EACA,mBAAA;AhBuwoBF;AgBpwoBA;;;;;;EAME,sBAAA;AhBswoBF;AACA,4BAA4B;AgBnwoB5B;;EAEE,yBAAA;EACA,4BAAA;AhBqwoBF;AACA,oBAAoB;AgBlwoBpB;EACE,WAAA;EACA,2BAAA;AhBowoBF;AgBlwoBA;;EAEE,WAAA;EACA,qBAAA;AhBowoBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AgB9voBrB;;EAEE,oBAAA;EACA,uCAAA;AhBgwoBF;AgB9voBA;;EAEE,0CAAA;AhBgwoBF;AACA;;qBAEqB;AgB5voBrB;;EAEE,gCAAA;AhB8voBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AgBxvoBrB;;EAEE,+BAAA;AhB0voBF;AgBxvoBA;;EAEE,+BAAA;AhB0voBF;AgBxvoBA;;EAEE,+BAAA;AhB0voBF;AACA,cAAc;AgBvvoBd;;EAEE,eAAA;EACA,+BAAA;AhByvoBF;AgBvvoBA;;EAEE,cAAA;AhByvoBF;AACA,oBAAoB;AgBrvoBpB;EACE,0CAAA;AhBuvoBF;AgBrvoBA;EACE,yBAAA;AhBuvoBF;AACA;;qBAEqB;AgBnvoBrB;;;EAGE,8BAAA;AhBqvoBF;AgBnvoBA;;;EAGE,iCAAA;AhBqvoBF;AgBnvoBA;;;EAGE,iCAAA;AhBqvoBF;AACA;;qBAEqB;AgBjvoBrB;;;EAGE,+BAAA;EACA,2BAAA;AhBmvoBF;AgBjvoBA;;EAEE,+BAAA;AhBmvoBF;AgBjvoBA;;EAEE,+BAAA;AhBmvoBF;AgBjvoBA;;EAEE,gCAAA;AhBmvoBF;AACA,aAAa;AgBhvoBb;;;EAGE,+BAAA;AhBkvoBF;AgBhvoBA;;EAEE,cAAA;AhBkvoBF;AgBhvoBA;;EAEE,cAAA;AhBkvoBF;AgBhvoBA;;EAEE,cAAA;AhBkvoBF;AACA;;qBAEqB;AgB9uoBrB;;EAEE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,+BAAA;EACA,oBAAA;EACA,+EAAA;AhBgvoBF;AgB9uoBA;;EAEE,kBAAA;AhBgvoBF;AgB9uoBA;;EAEE,+BAAA;EACA,+BAAA;AhBgvoBF;AgB9uoBA;;EAEE,+BAAA;EACA,+BAAA;AhBgvoBF;AgB9uoBA;;EAEE,+BAAA;EACA,gCAAA;AhBgvoBF;AACA,aAAa;AgB7uoBb;;EAEE,uBAAA;EACA,+BAAA;AhB+uoBF;AgB7uoBA;;EAEE,qCAAA;EACA,cAAA;AhB+uoBF;AgB7uoBA;;EAEE,qCAAA;EACA,cAAA;AhB+uoBF;AgB7uoBA;;EAEE,qCAAA;EACA,cAAA;AhB+uoBF;AACA,oCAAoC;AgB5uoBpC;;;;EAIE,kBAAA;AhB8uoBF;AACA;;qBAEqB;AgB1uoBrB;EACE,iGAAA;AhB4uoBF;AgB1uoBA;EACE,iBAAA;AhB4uoBF;AACA;;qBAEqB;AgBzuoBrB;;EAEE,iBAAA;EACA,kBAAA;AhB2uoBF;AgBzuoBA;;EAEE,mBAAA;EACA,oBAAA;AhB2uoBF;AACA;;qBAEqB;AgBvuoBrB;;EAEE,oBAAA;AhByuoBF;AgBvuoBA;;;EAGE,kBAAA;AhByuoBF;AgBvuoBA;;;EAGE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;AhByuoBF;AgBtuoBA;;;EAGE,gCAAA;AhBwuoBF;AgBruoBA;;EAEE,qBAAA;AhBuuoBF;AACA,wBAAwB;AgBpuoBxB;;EAEE,gBAAA;AhBsuoBF;AgBpuoBA;;EAEE,oBAAA;AhBsuoBF;AgBpuoBA;;EAEE,gBAAA;AhBsuoBF;AgBpuoBA;;EAEE,gCAAA;AhBsuoBF;AgBpuoBA;;EAEE,aAAA;AhBsuoBF;AACA;;qBAEqB;AgBluoBrB;;;;EAIE,sBAAA;EACA,oBAAA;EACA,qBAAA;AhBouoBF;AgBluoBA;;;EAGE,qBAAA;EACA,kBAAA;AhBouoBF;AgBluoBA;;;EAGE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,0BAAA;EACA,mCAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;AhBouoBF;AgBjuoBA;;;EAGE,+BAAA;AhBmuoBF;AACA,UAAU;AgBhuoBV;;EAEE,yBAAA;AhBkuoBF;AgBhuoBA;EACE,oBAAA;AhBkuoBF;AACA,gBAAgB;AgB/toBhB;;EAEE,gBAAA;AhBiuoBF;AgB/toBA;;EAEE,iBAAA;AhBiuoBF;AACA,uBAAuB;AgB9toBvB;;EAEE,gBAAA;AhBguoBF;AgB9toBA;;;EAGE,gBAAA;EACA,yBAAA;AhBguoBF;AACA;;qBAEqB;AgB5toBrB;EACE,+CAAA;AhB8toBF;AgB5toBA;EACE,gBAAA;AhB8toBF;AgB5toBA;EACE,gBAAA;AhB8toBF;AgB5toBA;;EAEE,gBAAA;AhB8toBF;AACA,aAAa;AgB3toBb;EACE,qBAAA;AhB6toBF;AACA,qBAAqB;AgB1toBrB;;EAEE,gBAAA;EACA,iBAAA;AhB4toBF;AgB1toBA;EACE,qBAAA;AhB4toBF;AACA,oBAAoB;AgBztoBpB;EACE,gBAAA;AhB2toBF;AgBztoBA;;EAEE,qBAAA;AhB2toBF;AgBztoBA;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;AhB2toBF;AgBztoBA;EACE,iBAAA;AhB2toBF;AACA,sBAAsB;AgBxtoBtB;;EAEE,WAAA;EACA,kBAAA;AhB0toBF;AACA,uBAAuB;AgBvtoBvB;EACE,gBAAA;AhBytoBF;AgBvtoBA;EACE,mBAAA;AhBytoBF;AgBvtoBA;EACE,oBAAA;AhBytoBF;AgBvtoBA;EACE,gBAAA;EACA,gDAAA;EACA,WAAA;EACA,gBAAA;AhBytoBF;AgBvtoBA;EACE,iBAAA;AhBytoBF;AACA,aAAa;AgBvtoBb;;;EAGE,sCAAA;AhBytoBF;AACA;;qBAEqB;AgBptoBrB;;EAEE,+CAAA;EACA,mBAAA;EACA,oBAAA;AhBstoBF;AgBptoBA;EACE,kDAAA;AhBstoBF;AACA,4BAA4B;AgBntoB5B;;EAEE,yBAAA;EACA,4BAAA;AhBqtoBF;AACA,aAAa;AgBltoBb;EACE,iBAAA;AhBotoBF;AgBltoBA;EACE,qBAAA;AhBotoBF;AACA,oBAAoB;AgBjtoBpB;EACE,gBAAA;AhBmtoBF;AgBjtoBA;;EAEE,qBAAA;AhBmtoBF;AgBjtoBA;EACE,qBAAA;EACA,sBAAA;EACA,4BAAA;AhBmtoBF;AACA,mBAAmB;AgBhtoBnB;EACE,gBAAA;AhBktoBF;AgBhtoBA;;EAEE,qBAAA;AhBktoBF;AgBhtoBA;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;AhBktoBF;AgBhtoBA;EACE,iBAAA;AhBktoBF;AACA,sBAAsB;AgB/soBtB;EACE,gBAAA;AhBitoBF;AgB/soBA;;EAEE,gBAAA;EACA,gDAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EAEA,gBAAA;AhBgtoBF;AgB9soBA;;EAEE,mBAAA;EACA,iDAAA;AhBgtoBF;AACA,aAAa;AgB7soBb;;EAEE,gDAAA;AhB+soBF;AgB7soBA;;EAEE,gDAAA;AhB+soBF;AACA;;qBAEqB;AgB3soBrB;EACE,yBAAA;AhB6soBF;AgB3soBA;EACE,4BAAA;AhB6soBF;AgB3soBA;;EAEE,kBAAA;AhB6soBF;AgB3soBA;;EAEE,mBAAA;AhB6soBF;AACA,iBAAiB;AgB1soBjB;EACE,yBAAA;AhB4soBF;AgB1soBA;EACE,4BAAA;AhB4soBF;AgB1soBA;;EAEE,oBAAA;AhB4soBF;AgB1soBA;;EAEE,qBAAA;AhB4soBF;AACA;;qBAEqB;AgBxsoBrB;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,cAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBxsoBA;EACE,uBAAA;AhB0soBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,eAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AgBvsoBA;;EAEE,wBAAA;AhBysoBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,wDAAwD;AACxD;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT;;qBAEqB;AACrB;;qBAEqB;AACrB,yCAAyC;AACzC,mBAAmB;AACnB;;+BAE+B;AAC/B,wDAAwD;AACxD;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT;;qBAEqB;AACrB;;qBAEqB;AACrB,yCAAyC;AACzC,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,kBAAkB;AiBpwrBlB;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,4CAAA;AjBswrBF;AACA,iBAAiB;AiBnwrBjB;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,qBAAA;EACA,sCAAA;AjBowrBF;AACA,iBAAiB;AiBjwrBjB;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,6BAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;AjB+vrBF;AACA,qBAAqB;AiB5vrBrB;EACE;IACE,uBAAA;EjB8vrBF;EiB5vrBA;IACE,yBAAA;EjB8vrBF;AACF;AACA,UAAU;AiB3vrBV;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AiB3vrBA;;EAEE,oBAAA;EACA,qBAAA;EACA,kCAAA;AjB6vrBF;AACA;;qBAEqB;AACrB,8BAA8B;AiBzvrB9B;EACE,cAAA;AjB2vrBF;AACA,iBAAiB;AiBxvrBjB;EACE,+BAAA;AjB0vrBF;AiBxvrBA;EACE,uCAAA;AjB0vrBF;AiBxvrBA;EACE,6CAAA;AjB0vrBF;AACA,4BAA4B;AiBvvrB5B;EACE,gCAAA;AjByvrBF;AiBvvrBA;EACE,gCAAA;AjByvrBF;AiBvvrBA;EACE,6CAAA;AjByvrBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AiBpvrBrB;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AjBsvrBF;AACA;;+BAE+B;AiBjvrB/B;EACE,4BAAA;EACA,wBAAA;AjBmvrBF;AiBhvrBA;;EAEE,cAAA;AjBkvrBF;AiBhvrBA;;EAEE,aAAA;AjBkvrBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AiB3urBX;;EAEE,WAAA;EACA,YAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,cAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AiB3urBA;;EAEE,oBAAA;EACA,qBAAA;EACA,uBAAA;AjB6urBF;AACA,gBAAgB;AiB1urBhB;EACE,eAAA;EACA,0BAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,0BAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,mBAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,0BAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,0BAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,mBAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,0BAAA;AjB4urBF;AiB1urBA;EACE,wBAAA;EACA,0BAAA;AjB4urBF;AACA;;qBAEqB;AiBvurBrB;EACE,+BAAA;AjByurBF;AiBvurBA;EACE,uCAAA;AjByurBF;AiBvurBA;EACE,yBAAA;AjByurBF;AACA;;qBAEqB;AiBrurBrB;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;AjBuurBF;AiBpurBA;;EAEE,qBAAA;AjBsurBF;AACA,oBAAoB;AiBnurBpB;;EAEE,cAAA;EACA,iBAAA;EACA,kBAAA;AjBqurBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ,uBAAuB;AACvB,8CAA8C;AAC9C,yBAAyB;AACzB,UAAU;AACV,iBAAiB;AACjB,cAAc;AACd,kBAAkB;AAClB,eAAe;AACf,mBAAmB;AACnB,uBAAuB;AACvB,8CAA8C;AAC9C,yBAAyB;AACzB,UAAU;AACV,iBAAiB;AACjB,cAAc;AACd,kBAAkB;AAClB,eAAe;AACf,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;qBAEqB;AkB/ptBrB;EACE,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,qHAAA;EACA,4BAAA;EACA,gBAAA;AlBiqtBF;AkB9ptBA;EACE;IACE,8BAAA;ElBgqtBF;EkB9ptBA;IACE,6BAAA;ElBgqtBF;AACF;AkB7ptBA;EACE,gBAAA;AlB+ptBF;AkB7ptBA;EACE,sBAAA;AlB+ptBF;AkB7ptBA;EACE,qBAAA;AlB+ptBF;AkB7ptBA;EACE,sBAAA;AlB+ptBF;AkB7ptBA;EACE,qBAAA;AlB+ptBF;AkB5ptBA;;;;;EAKE,yBAAA;AlB8ptBF;AACA,UAAU;AkB3ptBV;EACE,aAAA;AlB6ptBF;AkB3ptBA;EACE,WAAA;EACA,gBAAA;ElB6ptBA,qBAAqB;EkB3ptBrB,iBAAA;AlB6ptBF;AkB3ptBA;EACE,WAAA;EACA,gBAAA;ElB6ptBA,qBAAqB;EkB3ptBrB,gBAAA;AlB6ptBF;AACA,UAAU;AkBzptBV;EACE,kBAAA;EACA,oBAAA;AlB2ptBF;AkBzptBA;;EAEE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AlB2ptBF;AkBzptBA;EACE,SAAA;AlB2ptBF;AkBzptBA;EACE,UAAA;AlB2ptBF;AACA,cAAc;AkBxptBd;EACE,oBAAA;AlB0ptBF;AkBxptBA;;EAEE,aAAA;AlB0ptBF;AkBxptBA;EACE,iBAAA;AlB0ptBF;AACA,2BAA2B;AkBvptB3B;EACE,kBAAA;EACA,gBAAA;AlByptBF;AACA,iBAAiB;AkBtptBjB;EACE,SAAA;AlBwptBF;AkBtptBA;EACE,UAAA;AlBwptBF;AkBtptBA;EACE,UAAA;AlBwptBF;AkBtptBA;EACE,UAAA;AlBwptBF;AkBtptBA;EACE,UAAA;AlBwptBF;AACA,qBAAqB;AkBrptBrB;EACE,2BAAA;AlBuptBF;AkBrptBA;;EAEE,oBAAA;AlBuptBF;AkBrptBA;EACE,wBAAA;AlBuptBF;AkBrptBA;EACE,UAAA;AlBuptBF;AkBrptBA;EACE,UAAA;AlBuptBF;AACA,iBAAiB;AkBpptBjB;EACE,gBAAA;AlBsptBF;AkBpptBA;EACE,oBAAA;AlBsptBF;AkBpptBA;EACE,cAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AlBsptBF;AACA,YAAY;AkBnptBZ;;;EAGE,cAAA;AlBqptBF;AkBnptBA;;;EAGE,oBAAA;EACA,WAAA;EACA,cAAA;AlBqptBF;AACA,4BAA4B;AkBlptB5B;EACE,uIAAA;AlBoptBF;AkBlptBA;;;;;EAKE,yBAAA;AlBoptBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AkB9otBrB;EACE,SAAA;AlBgptBF;AkB9otBA;EACE,UAAA;AlBgptBF;AkB9otBA;EACE,UAAA;AlBgptBF;AkB9otBA;EACE,UAAA;AlBgptBF;AkB9otBA;EACE,UAAA;AlBgptBF;AkB9otBA;EACE,UAAA;AlBgptBF;AACA;;qBAEqB;AkB3otBrB;EACE,eAAA;AlB6otBF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AmBz+uB/B;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;AnB2+uBF;AmBx+uBA;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;AnB0+uBF;AmBv+uBA;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;AnBy+uBF;AACA;;+BAE+B;AAC/B;;gBAEgB;AmBp+uBhB;EACE,QAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;AnBs+uBF;AmBn+uBA;EACE,UAAA;EACA,SAAA;EACA,yBAAA;EACA,wBAAA;AnBq+uBF;AACA;;gBAEgB;AmBh+uBhB;EACE,cAAA;AnBk+uBF;AmBh+uBA;EACE,2BAAA;EACA,0BAAA;EACA,iDAAA;AnBk+uBF;AmBh+uBA;EACE,gDAAA;EACA,2BAAA;EACA,0BAAA;AnBk+uBF;AACA;;gBAEgB;AmB99uBhB;EACE,4BAAA;AnBg+uBF;AmB99uBA;EACE,wBAAA;EACA,uBAAA;AnBg+uBF;AmB99uBA;EACE,wBAAA;EACA,uBAAA;AnBg+uBF;AmB79uBA;EACE,8BAAA;AnB+9uBF;AmB79uBA;EACE,0BAAA;EACA,yBAAA;AnB+9uBF;AmB79uBA;EACE,0BAAA;EACA,yBAAA;AnB+9uBF;AACA;;gBAEgB;AmB39uBhB;;EAEE,YAAA;EACA,WAAA;AnB69uBF;AACA;;gBAEgB;AmBz9uBhB;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,eAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AmBz9uBA;EACE,wBAAA;AnB29uBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,UAAU;AACV,mBAAmB;AACnB;;+BAE+B;AAC/B,UAAU;AACV,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AoB3twB/B;EACE,gBAAA;EACA,6BAAA;EACA,yBAAA;ApB6twBF;AoB1twBA;EACE,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;ApB4twBF;AoB1twBA;EACE,6BAAA;EACA,qBAAA;ApB4twBF;AACA,wDAAwD;AoBztwBxD;;EAEE,qBAAA;ApB2twBF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoBptwBhB;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;ApBstwBF;AoBntwBA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EAEA,WAAA;EACA,oCAAA;ApBotwBF;AoBjtwBA;EACE,6BAAA;ApBmtwBF;AoBjtwBA;EACE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,sCAAA;ApBmtwBF;AoBjtwBA;;EAEE,uCAAA;ApBmtwBF;AoBjtwBA;;EAEE,oCAAA;ApBmtwBF;AoBhtwBA;EACE,oCAAA;ApBktwBF;AoBhtwBA;EACE,uCAAA;ApBktwBF;AoBhtwBA;;EAEE,sCAAA;ApBktwBF;AoBhtwBA;;EAEE,oCAAA;ApBktwBF;AoB/swBA;EACE,sCAAA;ApBitwBF;AoB/swBA;;EAEE,uCAAA;ApBitwBF;AoB/swBA;;EAEE,oCAAA;ApBitwBF;AoB9swBA;EACE,uCAAA;ApBgtwBF;AoB9swBA;;EAEE,sCAAA;ApBgtwBF;AoB9swBA;;EAEE,oCAAA;ApBgtwBF;AACA;;gBAEgB;AoB3swBhB;EACE,UAAA;ApB6swBF;AoB3swBA;;EAEE,UAAA;ApB6swBF;AACA;;gBAEgB;AoBxswBhB;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;ApB0swBF;AoBvswBA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EAEA,WAAA;EACA,mEAAA;ApBwswBF;AoBrswBA;EACE,6BAAA;ApBuswBF;AoBrswBA;EACE,6BAAA;EACA,mBAAA;EACA,sBAAA;ApBuswBF;AoBrswBA;;EAEE,uCAAA;ApBuswBF;AoBrswBA;;EAEE,sCAAA;ApBuswBF;AoBrswBA;;EAEE,uCAAA;ApBuswBF;AoBrswBA;;EAEE,sCAAA;ApBuswBF;AACA;;gBAEgB;AoBjswBhB;EACE,yBAAA;EACA,uBAAA;ApBmswBF;AoBhswBA;;EAEE,8BAAA;ApBkswBF;AoBhswBA;;;;EAIE,yBAAA;ApBkswBF;AoB/rwBA;EACE,6BAAA;ApBiswBF;AoB/rwBA;;EAEE,0BAAA;ApBiswBF;AACA;;+BAE+B;AoB7rwB/B;EACE,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;ApB+rwBF;AoB7rwBA;EACE,wBAAA;ApB+rwBF;AACA;;+BAE+B;AoB1rwB/B;EACE,UAAA;ApB4rwBF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoBvrwBhB;EACE,iBAAA;ApByrwBF;AACA;;gBAEgB;AoBrrwBhB;EACE,+BAAA;ApBurwBF;AACA;;gBAEgB;AoBlrwBhB;EACE,0BAAA;ApBorwBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,sBAAsB;AACtB;;+BAE+B;AAC/B,gBAAgB;AAChB,UAAU;AACV,aAAa;AACb,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB,oBAAoB;AACpB;;+BAE+B;AAC/B,WAAW;AACX,WAAW;AACX,aAAa;AACb,aAAa;AACb,YAAY;AACZ,UAAU;AACV,WAAW;AACX,eAAe;AACf,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,sBAAsB;AACtB;;+BAE+B;AAC/B,gBAAgB;AAChB,UAAU;AACV,aAAa;AACb,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB,oBAAoB;AACpB;;+BAE+B;AAC/B,WAAW;AACX,WAAW;AACX,aAAa;AACb,aAAa;AACb,YAAY;AACZ,UAAU;AACV,WAAW;AACX,eAAe;AACf,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AqB5myB/B;EACE,kBAAA;EACA,4BAAA;EACA,mDAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2CAAA;ArB8myBF;AqB3myBA;EACE,eAAA;ArB6myBF;AqB3myBA;EACE,kBAAA;ArB6myBF;AACA,aAAa;AqBzmyBb;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EAEA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kDAAA;ArB0myBF;AqBxmyBA;EACE,mBAAA;ArB0myBF;AACA;;qBAEqB;AACrB,WAAW;AqBrmyBX;EACE,cAAA;ArBumyBF;AACA,UAAU;AqBpmyBV;EACE,2BAAA;EACA,4BAAA;ArBsmyBF;AqBpmyBA;EACE,8BAAA;EACA,+BAAA;ArBsmyBF;AqBpmyBA;EACE,2BAAA;EACA,4BAAA;ArBsmyBF;AqBpmyBA;EACE,8BAAA;EACA,+BAAA;ArBsmyBF;AACA,SAAS;AqBnmyBT;;;EAGE,gBAAA;EACA,mBAAA;ArBqmyBF;AqBnmyBA;EACE,gBAAA;EACA,4BAAA;ArBqmyBF;AACA,UAAU;AqBlmyBV;EACE,4BAAA;EACA,2CAAA;EACA,mDAAA;ArBomyBF;AqBlmyBA;EACE,gBAAA;ArBomyBF;AACA;;+BAE+B;AAC/B;;qBAEqB;AqB7lyBrB;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uCAAA;EACA,uDAAA;ArB+lyBF;AqB5lyBA;;EAEE,cAAA;ArB8lyBF;AqB5lyBA;;;;EAIE,gBAAA;EACA,iBAAA;EACA,kBAAA;ArB8lyBF;AqB5lyBA;;;;EAIE,gBAAA;EACA,iBAAA;EACA,kBAAA;ArB8lyBF;AqB3lyBA;EACE,kBAAA;ArB6lyBF;AqB3lyBA;EACE,qBAAA;EACA,WAAA;EACA,iCAAA;ArB6lyBF;AqB3lyBA;EACE,iBAAA;ArB6lyBF;AACA;;qBAEqB;AqBxlyBrB;;EAEE,eAAA;EACA,cAAA;EACA,aAAA;ArB0lyBF;AqBxlyBA;EACE,eAAA;ArB0lyBF;AqBxlyBA;EACE,kBAAA;ArB0lyBF;AqBxlyBA;;;;EAIE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,cAAA;ArB0lyBF;AqBxlyBA;;EAEE,0BAAA;EACA,MAAA;EACA,WAAA;ArB0lyBF;AqBxlyBA;;EAEE,yBAAA;EACA,MAAA;EACA,WAAA;ArB0lyBF;AACA,mBAAmB;AqBvlyBnB;EACE,eAAA;EACA,kBAAA;ArBylyBF;AqBvlyBA;EACE,eAAA;ArBylyBF;AqBvlyBA;EACE,eAAA;EACA,kBAAA;ArBylyBF;AqBvlyBA;EACE,kBAAA;ArBylyBF;AACA;;qBAEqB;AqBrlyBrB;EACE,qBAAA;ArBulyBF;AqBrlyBA;;;;EAIE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EAEA,+CAAA;EACA,+BAAA;EAEA,WAAA;EACA,WAAA;EACA,mBAAA;ArBqlyBF;AqBnlyBA;;EAEE,aAAA;ArBqlyBF;AACA,wBAAwB;AqBllyBxB;;EAEE,cAAA;EACA,WAAA;ArBolyBF;AACA,aAAa;AqBjlyBb;;;;EAIE,qCAAA;EACA,+CAAA;ArBmlyBF;AACA;;qBAEqB;AqB/kyBrB;EACE,cAAA;ArBilyBF;AqB9kyBA;EACE,YAAA;ArBglyBF;AACA,oBAAoB;AqB7kyBpB;;EAEE,iBAAA;EACA,kBAAA;ArB+kyBF;AACA;;qBAEqB;AqB3kyBrB;EACE,cAAA;ArB6kyBF;AACA,kBAAkB;AqB1kyBlB;EACE,oBAAA;ArB4kyBF;AqB1kyBA;;EAEE,cAAA;EACA,cAAA;ArB4kyBF;AACA;;qBAEqB;AqBxkyBrB;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;ArB0kyBF;AACA;;qBAEqB;AqBtkyBrB;;EAEE,2FAAA;ArBwkyBF;AACA;;+BAE+B;AAC/B,UAAU;AqBnkyBV;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mDAAA;EACA,4BAAA;ArBqkyBF;AqBnkyBA;EACE,eAAA;ArBqkyBF;AqBnkyBA;EACE,kBAAA;ArBqkyBF;AACA,mBAAmB;AqBjkyBnB;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,+CAAA;ArBmkyBF;AqBhkyBA;EAGE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kDAAA;ArBgkyBF;AACA,WAAW;AqB7jyBX;EACE,QAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yDAAA;EACA,kDAAA;ArB+jyBF;AACA,SAAS;AqB5jyBT;EACE,4BAAA;ArB8jyBF;AACA,iBAAiB;AqB1jyBjB;EACE,+CAAA;EACA,iBAAA;ArB4jyBF;AqB1jyBA;EACE,gBAAA;ArB4jyBF;AqB1jyBA;EACE,eAAA;ArB4jyBF;AACA,qBAAqB;AqBzjyBrB;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,mDAAA;EACA,gBAAA;EACA,4BAAA;EACA,2CAAA;ArB2jyBF;AACA,4BAA4B;AqBxjyB5B;EACE,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,+CAAA;ArB0jyBF;AACA,uBAAuB;AqBvjyBvB;EACE,cAAA;EACA,iBAAA;ErByjyBA,yBAAyB;EqBxjyBzB,WAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;ArB0jyBF;AACA,iBAAiB;AqBvjyBjB;EACE,gBAAA;ArByjyBF;AqBvjyBA;EACE,iBAAA;ArByjyBF;AACA;;+BAE+B;AAC/B;;gBAEgB;AqBnjyBhB;EACE,aAAA;EACA,4BAAA;ArBqjyBF;AACA;;gBAEgB;AqBjjyBhB;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;ArBmjyBF;AqBjjyBA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,YAAA;ArBmjyBF;AqBjjyBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,6BAAA;EACA,UAAA;EACA,WAAA;EAEA,mCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,8EAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;EACA,mBAAA;EACA,YAAA;ArB8iyBF;AqB3iyBA;EACE;IACE,uBAAA;ErB6iyBF;EqB3iyBA;IACE,yBAAA;ErB6iyBF;AACF;AACA;;+BAE+B;AAC/B;;qBAEqB;AqBtiyBrB;EACE,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ArBwiyBF;AACA;;qBAEqB;AqBpiyBrB;EACE,YAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;ArBsiyBF;AACA;;qBAEqB;AACrB,QAAQ;AqBliyBR;EACE,wCAAA;ArBoiyBF;AqBliyBA;EACE,oCAAA;EACA,yBAAA;ArBoiyBF;AACA,WAAW;AqBjiyBX;EACE,wCAAA;ArBmiyBF;AqBjiyBA;EACE,oCAAA;EACA,yBAAA;ArBmiyBF;AACA,WAAW;AqBhiyBX;EACE,wCAAA;ArBkiyBF;AqBhiyBA;EACE,oCAAA;EACA,yBAAA;ArBkiyBF;AACA,UAAU;AqB/hyBV;EACE,wCAAA;ArBiiyBF;AqB/hyBA;EACE,oCAAA;EACA,yBAAA;ArBiiyBF;AACA,UAAU;AqB9hyBV;EACE,wCAAA;ArBgiyBF;AqB9hyBA;EACE,oCAAA;EACA,yBAAA;ArBgiyBF;AACA,SAAS;AqB7hyBT;EACE,wCAAA;ArB+hyBF;AqB7hyBA;EACE,oCAAA;EACA,yBAAA;ArB+hyBF;AACA,SAAS;AqB5hyBT;EACE,wCAAA;ArB8hyBF;AqB5hyBA;EACE,oCAAA;EACA,yBAAA;ArB8hyBF;AACA,WAAW;AqB3hyBX;EACE,wCAAA;ArB6hyBF;AqB3hyBA;EACE,oCAAA;EACA,yBAAA;ArB6hyBF;AACA,WAAW;AqB1hyBX;EACE,wCAAA;ArB4hyBF;AqB1hyBA;EACE,oCAAA;EACA,yBAAA;ArB4hyBF;AACA,SAAS;AqBzhyBT;EACE,wCAAA;ArB2hyBF;AqBzhyBA;EACE,oCAAA;EACA,yBAAA;ArB2hyBF;AACA,UAAU;AqBxhyBV;EACE,wCAAA;ArB0hyBF;AqBxhyBA;EACE,oCAAA;EACA,yBAAA;ArB0hyBF;AACA,SAAS;AqBvhyBT;EACE,wCAAA;ArByhyBF;AqBvhyBA;EACE,oCAAA;EACA,yBAAA;ArByhyBF;AACA,UAAU;AqBthyBV;EACE,wCAAA;ArBwhyBF;AqBthyBA;EACE,oCAAA;EACA,yBAAA;ArBwhyBF;AACA;;qBAEqB;AqBphyBrB;EACE,gBAAA;ArBshyBF;AqBphyBA;EACE,iBAAA;ArBshyBF;AqBphyBA;EACE,kBAAA;ArBshyBF;AACA;;qBAEqB;AqBlhyBrB;;EAEE,WAAA;EACA,iBAAA;ArBohyBF;AqBlhyBA;EACE,YAAA;EACA,gBAAA;ArBohyBF;AACA;;qBAEqB;AqB/gyBrB;EACE,YAAA;EACA,gBAAA;ArBihyBF;AqB/gyBA;;EAEE,mBAAA;EACA,+BAAA;ArBihyBF;AACA,WAAW;AqB9gyBX;EACE,gCAAA;ArBghyBF;AqB9gyBA;EACE,+BAAA;ArBghyBF;AACA,aAAa;AqB7gyBb;EACE,qBAAA;ArB+gyBF;AACA;;qBAEqB;AACrB,cAAc;AqB3gyBd;EACE,mBAAA;EACA,+BAAA;ArB6gyBF;AqB3gyBA;EACE,+FAAA;EACA,+BAAA;ArB6gyBF;AACA,aAAa;AqB1gyBb;EACE,mBAAA;EACA,+BAAA;ArB4gyBF;AqB1gyBA;EACE,iGAAA;EACA,+BAAA;ArB4gyBF;AACA;;qBAEqB;AACrB,WAAW;AqBvgyBX;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,yBAAA;ArBygyBF;AqBvgyBA;EACE,gBAAA;ArBygyBF;AACA,QAAQ;AqBtgyBR;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,kDAAA;ArBwgyBF;AqBtgyBA;EACE,eAAA;ArBwgyBF;AACA,WAAW;AqBrgyBX;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yDAAA;EACA,kDAAA;ArBugyBF;AqBrgyBA;EACE,kBAAA;ArBugyBF;AACA;;qBAEqB;AqBngyBrB;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,eAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AqBngyBA;;EAEE,wBAAA;ArBqgyBF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;gBAEgB;AAChB;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,UAAU;AACV,gBAAgB;AAChB,UAAU;AACV,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB,cAAc;AACd,UAAU;AACV,SAAS;AACT,WAAW;AACX,mBAAmB;AACnB,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,UAAU;AACV,gBAAgB;AAChB,UAAU;AACV,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB,cAAc;AACd,UAAU;AACV,SAAS;AACT,WAAW;AACX,mBAAmB;AACnB,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AsB790B/B;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,2CAAA;AtB+90BF;AACA,gBAAgB;AsB590BhB;EACE,eAAA;AtB890BF;AACA,eAAe;AsB390Bf;EACE,kBAAA;AtB690BF;AACA;;+BAE+B;AsBx90B/B;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,gGAAA;AtBy90BF;AACA,UAAU;AsBt90BV;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,mBAAA;EACA,uCAAA;EACA,6BAAA;EAEA,gGAAA;EACA,0DAAA;AtBs90BF;AACA,eAAe;AsBn90Bf;EACE,iBAAA;EACA,kDAAA;AtBq90BF;AACA,cAAc;AsBl90Bd;EACE,kDAAA;AtBo90BF;AsBl90BA;EACE,kBAAA;EACA,iBAAA;AtBo90BF;AACA,cAAc;AsBj90Bd;EACE,4BAAA;AtBm90BF;AACA;;+BAE+B;AAC/B,UAAU;AsB980BV;EACE,mEAAA;EACA,uBAAA;EACA,iBAAA;AtBg90BF;AsB980BA;EACE,WAAA;AtBg90BF;AACA,gBAAgB;AsB780BhB;EACE,mBAAA;EACA,uBAAA;EACA,gCAAA;AtB+80BF;AsB780BA;EACE,WAAA;AtB+80BF;AsB780BA;EACE,kBAAA;AtB+80BF;AACA,SAAS;AsB580BT;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;AtB880BF;AsB580BA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;AtB880BF;AsB580BA;EACE,mBAAA;AtB880BF;AACA,oBAAoB;AsB380BpB;EACE,WAAA;AtB680BF;AACA,SAAS;AsB180BT;;EAEE,eAAA;AtB480BF;AACA;;+BAE+B;AAC/B;;gBAEgB;AsBv80BhB;EACE,sBAAA;AtBy80BF;AsBv80BA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;EACA,iBAAA;AtBy80BF;AsBt80BA;EACE,cAAA;EACA,kBAAA;AtBw80BF;AACA;;gBAEgB;AsBn80BhB;EACE,oBAAA;EACA,sBAAA;EACA,iBAAA;AtBq80BF;AsBn80BA;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;AtBq80BF;AsBn80BA;EACE,yBAAA;EACA,kDAAA;AtBq80BF;AsBn80BA;EACE,mBAAA;EACA,kDAAA;AtBq80BF;AsBn80BA;EACE,4BAAA;AtBq80BF;AACA,UAAU;AsBj80BV;EACE,aAAA;AtBm80BF;AsBj80BA;EACE,QAAA;EACA,SAAA;EACA,6BAAA;AtBm80BF;AsBh80BA;EACE,aAAA;AtBk80BF;AsBh80BA;EACE,cAAA;AtBk80BF;AsBh80BA;EACE,aAAA;AtBk80BF;AsBh80BA;EACE,cAAA;AtBk80BF;AACA;;iBAEiB;AACjB,qBAAqB;AsB770BrB;EAEE;IACE,oBAAA;IACA,iBAAA;IACA,sBAAA;EtB870BF;EsB570BA;IACE,sBAAA;IACA,sBAAA;IACA,kBAAA;IACA,yBAAA;EtB870BF;EsB570BA;IACE,yBAAA;IACA,kDAAA;EtB870BF;EsB570BA;IACE,kDAAA;EtB870BF;EACA,UAAU;EsB370BV;IACE,wBAAA;EtB670BF;EACA,YAAY;EsB170BZ;IACE,kBAAA;EtB470BF;EACA,SAAS;EsBz70BT;;IAEE,wBAAA;EtB270BF;AACF;AACA;;+BAE+B;AAC/B,eAAe;AsBt70Bf;;;;EAIE,mBAAA;EACA,+BAAA;AtBw70BF;AACA,cAAc;AsBr70Bd;;;;EAIE,mBAAA;EACA,+BAAA;AtBu70BF;AACA,WAAW;AsBp70BX;EACE,YAAA;EACA,mBAAA;AtBs70BF;AsBp70BA;EACE,mBAAA;AtBs70BF;AsBp70BA;EACE,cAAA;AtBs70BF;AsBp70BA;;EAEE,gCAAA;AtBs70BF;AACA,iBAAiB;AsBn70BjB;EACE,cAAA;AtBq70BF;AsBn70BA;EACE,cAAA;AtBq70BF;AsBn70BA;EACE,aAAA;AtBq70BF;AsBn70BA;EACE,aAAA;AtBq70BF;AACA,iBAAiB;AsBl70BjB;;;;EAIE,eAAA;EACA,mBAAA;EACA,gCAAA;AtBo70BF;AACA,cAAc;AsBj70Bd;;EAEE,cAAA;AtBm70BF;AACA,aAAa;AsBh70Bb;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AtBk70BF;AsBh70BA;;;EAGE,4BAAA;AtBk70BF;AsBh70BA;EACE,mBAAA;AtBk70BF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,oBAAoB;AsB360BpB;EAEA;IACE,oBAAA;IACA,iBAAA;IACA,sBAAA;EtB460BA;EACA,UAAU;EsBz60BZ;IACE,sBAAA;IACA,kBAAA;IACA,yBAAA;EtB260BA;EsBz60BF;IACE,yBAAA;IACA,kDAAA;EtB260BA;EsBz60BF;IACE,kDAAA;EtB260BA;EACA,UAAU;EsBx60BZ;IACE,wBAAA;EtB060BA;EACA,YAAY;EsBv60Bd;IACE,kBAAA;EtBy60BA;EACA,SAAS;EsBt60BX;;IAEE,wBAAA;EtBw60BA;AACF;AACA;;gBAEgB;AAChB,UAAU;AsBn60BV;EACE,aAAA;EACA,WAAA;AtBq60BF;AACA;;gBAEgB;AAChB,QAAQ;AsBj60BR;EACE,0CAAA;EACA,kBAAA;EACA,mCAAA;EACA,kDAAA;AtBm60BF;AsBj60BA;EACE,wCAAA;AtBm60BF;AsBj60BA;EACE,wCAAA;AtBm60BF;AACA,WAAW;AsBh60BX;EACE,kBAAA;EACA,kDAAA;AtBk60BF;AsBh60BA;EACE,wCAAA;AtBk60BF;AsBh60BA;EACE,wCAAA;AtBk60BF;AACA;;qBAEqB;AsB950BrB;;;;;;;;EAQE,WAAA;AtBg60BF;AsB950BA;;;;;;;;EAQE,iBAAA;AtBg60BF;AsB950BA;EACE,WAAA;AtBg60BF;AsB950BA;EACE,UAAA;AtBg60BF;AsB950BA;EACE,cAAA;AtBg60BF;AsB950BA;EACE,UAAA;AtBg60BF;AsB950BA;EACE,UAAA;AtBg60BF;AsB950BA;EACE,cAAA;AtBg60BF;AsB950BA;EACE,cAAA;AtBg60BF;AsB950BA;EACE,YAAA;AtBg60BF;AACA;;qBAEqB;AsB350BrB;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,eAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AsB350BA;;EAEE,wBAAA;AtB650BF;AACA;;+BAE+B;AuBz81B/B;EACE,mBAAA;EACA,yHAAA;AvB281BF;AuBt81BA;;EAEE,mBAAA;EACA,gBAAA;EvBw81BA,QAAQ;AACV;AACA,gBAAgB;AAChB;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AwB3k3B/B;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AxB6k3BF;AwB3k3BA;EACE,eAAA;AxB6k3BF;AwB3k3BA;EACE,kBAAA;AxB6k3BF;AACA;;+BAE+B;AAC/B,YAAY;AwBzk3BZ;EACE,qBAAA;EACA,YAAA;EACA,6BAAA;EAEA,uBAAA;EACA,+BAAA;EACA,wBAAA;AxB0k3BF;AACA,SAAS;AwBvk3BT;EACE,cAAA;AxByk3BF;AwBvk3BA;EACE,cAAA;AxByk3BF;AACA,iBAAiB;AwBrk3BjB;EACE,uBAAA;EACA,wBAAA;AxBuk3BF;AACA,YAAY;AwBpk3BZ;EACE,eAAA;AxBsk3BF;AwBpk3BA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AxBsk3BF;AACA,mBAAmB;AwBnk3BnB;EACE,qBAAA;EACA,yBAAA;AxBqk3BF;AACA;;+BAE+B;AwBjk3B/B;EACE,iBAAA;AxBmk3BF;AACA;;+BAE+B;AwB9j3B/B;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,eAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AwB9j3BA;EACE,wBAAA;AxBgk3BF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,SAAS;AACT,UAAU;AACV,WAAW;AACX,eAAe;AACf,UAAU;AACV,WAAW;AACX,cAAc;AACd,aAAa;AACb,6BAA6B;AAC7B;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,oBAAoB;AACpB,aAAa;AACb,kBAAkB;AAClB,aAAa;AACb,gBAAgB;AAChB,mBAAmB;AACnB,kBAAkB;AAClB,sBAAsB;AACtB,mBAAmB;AACnB,oBAAoB;AACpB;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb;;qBAEqB;AACrB,mBAAmB;AACnB,WAAW;AACX;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,SAAS;AACT,UAAU;AACV,WAAW;AACX,eAAe;AACf,UAAU;AACV,WAAW;AACX,cAAc;AACd,aAAa;AACb,6BAA6B;AAC7B;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,oBAAoB;AACpB,aAAa;AACb,kBAAkB;AAClB,aAAa;AACb,gBAAgB;AAChB,mBAAmB;AACnB,kBAAkB;AAClB,sBAAsB;AACtB,mBAAmB;AACnB,oBAAoB;AACpB;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb;;qBAEqB;AACrB,mBAAmB;AACnB,WAAW;AACX;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;sBAEsB;AyBh34BtB;EACE,kBAAA;EACA,eAAA;AzBk34BF;AACA;;sBAEsB;AyB924BtB;EACE,eAAA;AzBg34BF;AACA;;sBAEsB;AyB524BtB;EACE,WAAA;EACA,mBAAA;AzB824BF;AyB324BA;;EAEE,kBAAA;AzB624BF;AyB124BA;EACE,WAAA;EACA,WAAA;AzB424BF;AACA;;sBAEsB;AyBv24BtB;EACE,cAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AzBy24BF;AACA;;sBAEsB;AyBp24BtB;;;;;;;;;;;;;EAaE,WAAA;EACA,mBAAA;AzBs24BF;AACA,oCAAoC;AyBn24BpC;;EAEE,oBAAA;AzBq24BF;AyBl24BA;;;;;;;;;;;;EAYE,mEAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,2CAAA;EAEA,yBAAA;EACA,yBAAA;EACA,cAAA;EAEA,qCAAA;EACA,2CAAA;EACA,gCAAA;EACA,4BAAA;EACA,6CAAA;EACA,mDAAA;AzBk24BF;AACA,cAAc;AyB/14Bd;EACE,WAAA;EACA,wBAAA;EACA,2CAAA;EAEA,yBAAA;EAEA,qCAAA;EACA,2CAAA;EACA,aAAA;EACA,gCAAA;EACA,4BAAA;EACA,6CAAA;EACA,mDAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AzB+14BF;AyB714BA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AzB+14BF;AyB514BA;;EAEE,mBAAA;AzB814BF;AACA;;4BAE4B;AyB114B5B;EACE,WAAA;AzB414BF;AACA;;sBAEsB;AyBv14BtB;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,4BAAA;EACA,6CAAA;EACA,mBAAA;EACA,gCAAA;EACA,mDAAA;AzBy14BF;AACA;;sBAEsB;AACtB,UAAU;AyBr14BV;EACE,WAAA;AzBu14BF;AyBr14BA;EACE,YAAA;AzBu14BF;AACA,WAAW;AyBp14BX;;EAEE,WAAA;AzBs14BF;AyBp14BA;;EAEE,WAAA;AzBs14BF;AACA;;sBAEsB;AACtB,UAAU;AyBl14BV;;;EAGE,WAAA;AzBo14BF;AACA,YAAY;AyBj14BZ;;EAEE,WAAA;EACA,sBAAA;AzBm14BF;AACA,eAAe;AyBh14Bf;;EAEE,WAAA;AzBk14BF;AACA,qBAAqB;AyB/04BrB;;;;;;;;;;EAUE,cAAA;EACA,UAAA;AzBi14BF;AACA;;sBAEsB;AyB504BtB;;;EAGE,aAAA;AzB804BF;AACA,gBAAgB;AyB304BhB;EACE,eAAA;AzB604BF;AACA;;sBAEsB;AyBz04BtB;EACE,mBAAA;EACA,8BAAA;EACA,oCAAA;EACA,yBAAA;AzB204BF;AyBz04BA;;EAEE,mBAAA;EACA,gCAAA;AzB204BF;AyBz04BA;;EAEE,6BAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AzB204BF;AACA;;+BAE+B;AAC/B;;sBAEsB;AyBr04BtB;EACE,sDAAA;EACA,gCAAA;AzBu04BF;AACA,UAAU;AyBp04BV;EACE,sDAAA;EACA,gCAAA;AzBs04BF;AACA,UAAU;AyBn04BV;EACE,sDAAA;EACA,gCAAA;AzBq04BF;AACA;;sBAEsB;AACtB,0CAA0C;AyB/z4B1C;EACE,6BAAA;AzBi04BF;AyB/z4BA;EACE,wCAAA;AzBi04BF;AyB/z4BA;EACE,6BAAA;AzBi04BF;AyB9z4BA;EACE,gCAAA;AzBg04BF;AyB9z4BA;EACE,2CAAA;AzBg04BF;AyB9z4BA;EACE,gCAAA;AzBg04BF;AACA,sBAAsB;AyB7z4BtB;EACE,cAAA;AzB+z4BF;AyB7z4BA;EACE,yBAAA;AzB+z4BF;AyB7z4BA;EACE,cAAA;AzB+z4BF;AyB5z4BA;EACE,cAAA;AzB8z4BF;AyB5z4BA;EACE,yBAAA;AzB8z4BF;AyB5z4BA;EACE,cAAA;AzB8z4BF;AACA;;sBAEsB;AyBzz4BtB;;;;;;;;;;;;EAYE,gCAAA;EACA,qBAAA;EACA,4BAAA;EACA,qCAAA;EACA,2DAAA;AzB2z4BF;AyBzz4BA;EACE,gCAAA;EACA,qBAAA;EACA,4BAAA;EACA,qCAAA;EACA,2DAAA;EACA,wBAAA;AzB2z4BF;AACA;;sBAEsB;AACtB,YAAY;AyBtz4BZ;EACE,cAAA;AzBwz4BF;AyBtz4BA;EACE,qBAAA;AzBwz4BF;AyBtz4BA;EACE,aAAA;AzBwz4BF;AACA;;sBAEsB;AACtB,YAAY;AyBpz4BZ;EACE,cAAA;AzBsz4BF;AyBpz4BA;EACE,qBAAA;AzBsz4BF;AyBpz4BA;EACE,aAAA;AzBsz4BF;AACA;;sBAEsB;AACtB,YAAY;AyBlz4BZ;EACE,cAAA;AzBoz4BF;AyBlz4BA;EACE,qBAAA;AzBoz4BF;AyBlz4BA;EACE,aAAA;AzBoz4BF;AACA,gBAAgB;AyBjz4BhB;;;;EAIE,cAAA;AzBmz4BF;AyBhz4BA;;EAEE,qBAAA;EACA,cAAA;AzBkz4BF;AyB/y4BA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,iCAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AzBiz4BF;AyB/y4BA;;;;;;;;;;;;;;EAcE,iCAAA;EACA,qBAAA;EACA,cAAA;EAEA,wBAAA;EACA,gBAAA;AzBgz4BF;AACA,oCAAoC;AyB7y4BpC;EACE,mCAAA;AzB+y4BF;AACA;;qBAEqB;AyB3y4BrB;;;;;EAKE,iCAAA;EACA,cAAA;AzB6y4BF;AyB3y4BA;;EAEE,gCAAA;AzB6y4BF;AyB3y4BA;;EAEE,gCAAA;AzB6y4BF;AyB3y4BA;;EAEE,qBAAA;AzB6y4BF;AyB3y4BA;;EAEE,yBAAA;EACA,cAAA;AzB6y4BF;AACA,UAAU;AyB1y4BV;;EAEE,yBAAA;AzB4y4BF;AACA,aAAa;AyBzy4Bb;;EAEE,yBAAA;AzB2y4BF;AACA,WAAW;AyBvy4BX;;EAEE,oCAAA;AzByy4BF;AACA;;sBAEsB;AyBry4BtB;;;;EAIE,cAAA;AzBuy4BF;AyBry4BA;;;;EAIE,iCAAA;EACA,qBAAA;AzBuy4BF;AyBry4BA;;;;EAIE,cAAA;AzBuy4BF;AACA;;sBAEsB;AyBny4BtB;;;EAGE,oBAAA;EACA,aAAA;AzBqy4BF;AyBny4BA;;EAEE,aAAA;AzBqy4BF;AyBny4BA;EACE,UAAA;AzBqy4BF;AACA;;gBAEgB;AyBhy4BhB;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;AzBky4BF;AyBhy4BA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AzBky4BF;AyBhy4BA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,6BAAA;EACA,UAAA;EACA,WAAA;EAEA,gCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,8EAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;EACA,mBAAA;EACA,YAAA;AzB6x4BF;AyB1x4BA;EACE;IACE,uBAAA;EzB4x4BF;EyB1x4BA;IACE,yBAAA;EzB4x4BF;AACF;AACA;;+BAE+B;AAC/B;;sBAEsB;AyBtx4BtB;;;;;EAKE,4BAAA;EACA,YAAA;EACA,cAAA;AzBwx4BF;AyBrx4BA;;;EAGE,qBAAA;EACA,mBAAA;AzBux4BF;AyBpx4BA;;EAEE,kBAAA;EACA,OAAA;EACA,UAAA;AzBsx4BF;AACA;;+BAE+B;AAC/B;;sBAEsB;AyB/w4BtB;;;;;;;;;;;EAWE,+BAAA;AzBix4BF;AACA,mBAAmB;AyB9w4BnB;;;;;;;;;;;;EAYE,qCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gBAAA;AzBgx4BF;AACA;;sBAEsB;AACtB,uBAAuB;AyB3w4BvB;EACE,cAAA;EACA,mBAAA;AzB6w4BF;AyB3w4BA;EACE,kBAAA;AzB6w4BF;AyB1w4BA;EACE,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AzB4w4BF;AyBzw4BA;;EAEE,cAAA;EACA,iBAAA;EACA,YAAA;AzB2w4BF;AACA;;sBAEsB;AACtB,iBAAiB;AyBvw4BjB;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AzByw4BF;AyBvw4BA;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;AzByw4BF;AyBvw4BA;EACE,iBAAA;EACA,gBAAA;AzByw4BF;AACA,uBAAuB;AyBtw4BvB;;EAEE,UAAA;AzBww4BF;AyBtw4BA;;EAEE,mBAAA;AzBww4BF;AyBtw4BA;;EAEE,UAAA;AzBww4BF;AyBtw4BA;;EAEE,UAAA;AzBww4BF;AyBtw4BA;;EAEE,mBAAA;AzBww4BF;AyBtw4BA;;EAEE,mBAAA;AzBww4BF;AyBtw4BA;;EAEE,YAAA;AzBww4BF;AyBtw4BA;;EAEE,mBAAA;AzBww4BF;AyBtw4BA;;EAEE,UAAA;AzBww4BF;AACA,iCAAiC;AyBrw4BjC;EACE;IACE,eAAA;EzBuw4BF;EyBpw4BA;;;;;;;;;;;;;;;;;;;;IAoBE,sBAAA;IACA,mBAAA;EzBsw4BF;AACF;AACA,wBAAwB;AyBlw4BxB;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AzBow4BF;AyBjw4BA;EACE,uBAAA;AzBmw4BF;AyBjw4BA;EACE,uBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,qBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,uBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,qBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,uBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,qBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,uBAAA;AzBmw4BF;AyBjw4BA;EACE,wBAAA;AzBmw4BF;AyBjw4BA;EACE,sBAAA;AzBmw4BF;AACA,iCAAiC;AyBhw4BjC;EACE;;;;;;;;;;;;;;;;;;;;;;;IAuBE,sBAAA;EzBkw4BF;EyBhw4BA;IACE,kBAAA;EzBkw4BF;AACF;AACA;;sBAEsB;AyB9v4BtB;;EAEE,WAAA;EACA,cAAA;AzBgw4BF;AACA;;sBAEsB;AyB5v4BtB;EACE,mBAAA;EACA,mBAAA;AzB8v4BF;AyB5v4BA;EACE,WAAA;EACA,wBAAA;AzB8v4BF;AACA,iBAAiB;AyB3v4BjB;;;;;EAKE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gCAAA;EACA,oBAAA;AzB6v4BF;AACA,yBAAyB;AyB1v4BzB;EACE,8BAAA;AzB4v4BF;AACA,iBAAiB;AyBzv4BjB;;;;EAIE,qBAAA;EACA,WAAA;EAEA,eAAA;EACA,kBAAA;EAEA,sBAAA;EACA,cAAA;AzByv4BF;AACA,UAAU;AyBtv4BV;;EAEE,gCAAA;AzBwv4BF;AyBtv4BA;;EAEE,WAAA;AzBwv4BF;AACA,SAAS;AyBrv4BT;EACE,aAAA;EACA,mBAAA;AzBuv4BF;AyBrv4BA;;EAEE,WAAA;AzBuv4BF;AACA;;sBAEsB;AyBlv4BtB;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,eAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AyBlv4BA;EACE,wBAAA;AzBov4BF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,wBAAwB;AACxB;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB;;gBAEgB;AAChB;;gBAEgB;AAChB;;+BAE+B;AAC/B;;gBAEgB;AAChB;EACE;AACF,mBAAmB;AACnB;;+BAE+B;AAC/B,wBAAwB;AACxB;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB;;gBAEgB;AAChB;;gBAEgB;AAChB;;+BAE+B;AAC/B;;gBAEgB;AAChB;EACE;AACF,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A0B567B/B;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;A1B867BF;AACA;;wBAEwB;A0B167BxB;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;A1B467BF;A0B167BA;EACE,oBAAA;EACA,qBAAA;A1B467BF;A0B167BA;EACE,oBAAA;EACA,qBAAA;A1B467BF;AACA,+CAA+C;A0Bx67B/C;EACE,gBAAA;A1B067BF;AACA;;qBAEqB;AACrB,uBAAuB;A0Bt67BvB;;EAEE,kBAAA;EACA,qBAAA;EAEA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;A1Bu67BF;A0Bp67BA;EACE,kBAAA;EACA,mBAAA;A1Bs67BF;AACA;;qBAEqB;A0Bl67BrB;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;A1Bo67BF;AACA;;qBAEqB;AACrB,kCAAkC;A0Bh67BlC;EACE,iBAAA;EACA,oBAAA;A1Bk67BF;A0Bh67BA;EACE,eAAA;EACA,kBAAA;A1Bk67BF;AACA;;qBAEqB;A0B957BrB;;EAEE,eAAA;A1Bg67BF;AACA;;qBAEqB;AACrB,wCAAwC;A0B557BxC;EACE,eAAA;A1B857BF;A0B557BA;EACE,kBAAA;A1B857BF;AACA,gCAAgC;A0B357BhC;;EAEE,WAAA;A1B657BF;AACA,+BAA+B;A0B157B/B;EACE,YAAA;EACA,iBAAA;A1B457BF;A0B157BA;EACE,8BAAA;A1B457BF;AACA,6CAA6C;A0Bz57B7C;;EAEE,gBAAA;A1B257BF;AACA;;+BAE+B;AAC/B;;0BAE0B;A0Br57B1B;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;E1Bu57BF;AACF;A0Br57BA;EACE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;E1Bu57BF;AACF;A0Br57BA;EACE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;E1Bu57BF;AACF;A0Br57BA;EACE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;E1Bu57BF;AACF;A0Br57BA;EACE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;E1Bu57BF;AACF;AACA;;qBAEqB;AACrB,sCAAsC;A0Bl57BtC;;EAEE,WAAA;A1Bo57BF;AACA,eAAe;A0Bj57Bf;;EAEE,WAAA;A1Bm57BF;A0Bj57BA;;EAEE,UAAA;A1Bm57BF;A0Bj57BA;;EAEE,mBAAA;A1Bm57BF;A0Bj57BA;;EAEE,UAAA;A1Bm57BF;A0Bj57BA;;EAEE,UAAA;A1Bm57BF;A0Bj57BA;;EAEE,mBAAA;A1Bm57BF;A0Bj57BA;;EAEE,mBAAA;A1Bm57BF;A0Bj57BA;;EAEE,YAAA;A1Bm57BF;A0Bj57BA;;EAEE,mBAAA;A1Bm57BF;A0Bj57BA;;EAEE,UAAA;A1Bm57BF;A0Bj57BA;;EAEE,kBAAA;A1Bm57BF;A0Bj57BA;;EAEE,kBAAA;A1Bm57BF;A0Bj57BA;;EAEE,kBAAA;A1Bm57BF;A0Bj57BA;;EAEE,kBAAA;A1Bm57BF;A0Bj57BA;;EAEE,kBAAA;A1Bm57BF;A0Bj57BA;;EAEE,YAAA;A1Bm57BF;AACA,wBAAwB;A0Bh57BxB;EACE,sBAAA;A1Bk57BF;A0Bh57BA;EACE,qBAAA;A1Bk57BF;A0Bh57BA;EACE,8BAAA;A1Bk57BF;A0Bh57BA;EACE,qBAAA;A1Bk57BF;A0Bh57BA;EACE,qBAAA;A1Bk57BF;A0Bh57BA;EACE,8BAAA;A1Bk57BF;A0Bh57BA;EACE,8BAAA;A1Bk57BF;A0Bh57BA;EACE,uBAAA;A1Bk57BF;A0Bh57BA;EACE,8BAAA;A1Bk57BF;A0Bh57BA;EACE,qBAAA;A1Bk57BF;A0Bh57BA;EACE,6BAAA;A1Bk57BF;A0Bh57BA;EACE,6BAAA;A1Bk57BF;A0Bh57BA;EACE,6BAAA;A1Bk57BF;A0Bh57BA;EACE,6BAAA;A1Bk57BF;A0Bh57BA;EACE,6BAAA;A1Bk57BF;A0Bh57BA;EACE,uBAAA;A1Bk57BF;AACA,gBAAgB;A0B/47BhB;EACE,gBAAA;A1Bi57BF;AACA;;qBAEqB;AACrB,wBAAwB;A0B747BxB;;;;EAIE,uBAAA;A1B+47BF;A0B747BA;;;;EAIE,uBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,qBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,uBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,qBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,uBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,qBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,uBAAA;A1B+47BF;A0B747BA;;;;EAIE,wBAAA;A1B+47BF;A0B747BA;;;;EAIE,sBAAA;A1B+47BF;AACA;;wBAEwB;AACxB,+BAA+B;A0B347B/B;EACE;;;;IAIE,uBAAA;E1B647BF;E0B347BA;;;;IAIE,uBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,qBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,uBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,qBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,uBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,qBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,uBAAA;E1B647BF;E0B347BA;;;;IAIE,wBAAA;E1B647BF;E0B347BA;;;;IAIE,sBAAA;E1B647BF;AACF;AACA,+BAA+B;A0B147B/B;EACE;;;;IAIE,uBAAA;E1B447BF;E0B147BA;;;;IAIE,uBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,qBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,uBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,qBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,uBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,qBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,uBAAA;E1B447BF;E0B147BA;;;;IAIE,wBAAA;E1B447BF;E0B147BA;;;;IAIE,sBAAA;E1B447BF;AACF;AACA,yCAAyC;A0Bz47BzC;EACI;;;;IAIA,uBAAA;E1B247BF;E0Bz47BA;;;;IAIE,uBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,qBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,uBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,qBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,uBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,qBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,uBAAA;E1B247BF;E0Bz47BA;;;;IAIE,wBAAA;E1B247BF;E0Bz47BA;;;;IAIE,sBAAA;E1B247BF;AACF;AACA,sCAAsC;A0Bx47BtC;EACE;;;;IAIE,uBAAA;E1B047BF;E0Bx47BA;;;;IAIE,uBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,qBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,uBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,qBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,uBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,qBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,uBAAA;E1B047BF;E0Bx47BA;;;;IAIE,wBAAA;E1B047BF;E0Bx47BA;;;;IAIE,sBAAA;E1B047BF;AACF;AACA,mCAAmC;A0Bv47BnC;EACE;;;;IAIE,uBAAA;E1By47BF;E0Bv47BA;;;;IAIE,uBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,qBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,uBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,qBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,uBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,qBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,uBAAA;E1By47BF;E0Bv47BA;;;;IAIE,wBAAA;E1By47BF;E0Bv47BA;;;;IAIE,sBAAA;E1By47BF;AACF;AACA;;wBAEwB;A0Br47BxB;;;EAGE,kBAAA;EACA,uBAAA;A1Bu47BF;A0Br47BA;;;EAGE,gBAAA;A1Bu47BF;A0Bp47BA;;EAEE,cAAA;EACA,iBAAA;EACA,kBAAA;A1Bs47BF;AACA;;wBAEwB;A0Bl47BxB;;;EAGE,oBAAA;EACA,qBAAA;A1Bo47BF;A0Bj47BA;;;EAGE,oBAAA;EACA,qBAAA;A1Bm47BF;AACA,6BAA6B;A0Bh47B7B;;EAEE,mBAAA;EACA,oBAAA;A1Bk47BF;A0Bh47BA;;EAEE,mBAAA;EACA,oBAAA;A1Bk47BF;AACA;;wBAEwB;A0B737BxB;EACE,sBAAA;A1B+37BF;A0B737BA;EACE,2BAAA;EACA,4BAAA;A1B+37BF;A0B737BA;EACE,0BAAA;EACA,6BAAA;A1B+37BF;AACA;;wBAEwB;A0B337BxB;EACE,kBAAA;A1B637BF;A0B337BA;EACE,iBAAA;A1B637BF;AACA;;wBAEwB;A0Bx37BxB;;EAEE,sDAAA;A1B037BF;AACA,kEAAkE;A0Bv37BlE;;EAEE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;A1By37BF;A0Bv37BA;EACE,eAAA;EACA,kBAAA;A1By37BF;AACA,sCAAsC;A0Bp37BtC;;EAEE,gBAAA;A1Bs37BF;AACA,iCAAiC;A0Bn37BjC;EACE,eAAA;A1Bq37BF;AACA,gBAAgB;A0Bj37BhB;EACE,sDAAA;A1Bm37BF;A0Bj37BA;EACE,gBAAA;A1Bm37BF;AACA,uBAAuB;A0Bh37BvB;EACE,kBAAA;A1Bk37BF;A0Bh37BA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,wBAAA;EACA,WAAA;EAEA,eAAA;EACA,sDAAA;A1Bg37BF;AACA,gCAAgC;A0B727BhC;;EAEE,WAAA;A1B+27BF;AACA,iCAAiC;A0B527BjC;EACE,gBAAA;A1B827BF;AACA,qBAAqB;A0B327BrB;;EAEE,qDAAA;A1B627BF;A0B327BA;;EAEE,gBAAA;A1B627BF;A0B327BA;EACE,qDAAA;A1B627BF;AACA,YAAY;A0B127BZ;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;A1B427BF;A0B127BA;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;A1B427BF;AACA;;wBAEwB;A0Bx27BxB;EACE,WAAA;EACA,eAAA;EACA,mCAAA;A1B027BF;A0Bv27BA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;A1By27BF;A0Bv27BA;;EAEE,oCAAA;A1By27BF;A0Bt27BA;;EAEE,gBAAA;A1Bw27BF;A0Br27BA;;EAEE,YAAA;A1Bu27BF;A0Br27BA;;EAEE,cAAA;A1Bu27BF;A0Br27BA;;EAEE,YAAA;A1Bu27BF;AACA,sBAAsB;A0Bp27BtB;EACE,gBAAA;EACA,WAAA;A1Bs27BF;A0Bp27BA;EACE,gBAAA;A1Bs27BF;A0Bp27BA;EACE,gBAAA;A1Bs27BF;AACA;;wBAEwB;AACxB,gBAAgB;A0Bl27BhB;;;;;EAKE,sBAAA;EACA,mBAAA;EACA,iCAAA;A1Bo27BF;AACA,mBAAmB;A0Bj27BnB;;;;;EAKE,sBAAA;EACA,sBAAA;EACA,6BAAA;A1Bm27BF;AACA,mBAAmB;A0Bh27BnB;;;;;EAKE,sBAAA;EACA,sBAAA;EACA,+BAAA;A1Bk27BF;AACA,cAAc;A0B/17Bd;;;;;EAKE,+BAAA;EACA,mBAAA;EACA,sBAAA;A1Bi27BF;A0B917BA;;;;;EAKE,YAAA;A1Bg27BF;AACA;;wBAEwB;AACxB,iBAAiB;A0B517BjB;;;;;EAKE,gBAAA;EACA,mBAAA;A1B817BF;AACA,mBAAmB;A0B317BnB;;;;;EAKE,kBAAA;EACA,mBAAA;A1B617BF;A0B317BA;EACE,uBAAA;A1B617BF;AACA,kBAAkB;A0B117BlB;;;;;EAKE,iBAAA;EACA,mBAAA;A1B417BF;AACA,cAAc;A0Bz17Bd;;;;;EAKE,mBAAA;EACA,aAAA;A1B217BF;AACA;;wBAEwB;A0Bv17BxB;;;;;;;;;;;;;EAaE,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;A1By17BF;AACA,QAAQ;A0Bt17BR;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,WAAW;A0Bt17BX;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,WAAW;A0Bt17BX;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,UAAU;A0Bt17BV;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,UAAU;A0Bt17BV;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,SAAS;A0Bt17BT;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,SAAS;A0Bt17BT;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,WAAW;A0Bt17BX;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,WAAW;A0Bt17BX;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,SAAS;A0Bt17BT;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,UAAU;A0Bt17BV;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,SAAS;A0Bt17BT;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA,UAAU;A0Bt17BV;;;EAGE,oCAAA;EACA,cAAA;A1Bw17BF;AACA;;wBAEwB;A0Bn17BxB;;;EAGE,qBAAA;EACA,YAAA;A1Bq17BF;A0Bn17BA;;;EAGE,YAAA;A1Bq17BF;AACA;;wBAEwB;AACxB,WAAW;A0B/07BX;EACE;;;IAGE,2BAAA;E1Bi17BF;E0B/07BA;;IAEE,8BAAA;E1Bi17BF;EACA,qBAAqB;E0B907BrB;;IAEE,sDAAA;E1Bg17BF;E0B907BA;;IAEE,gBAAA;E1Bg17BF;EACA,gCAAgC;E0B907BhC;IACE,sDAAA;E1Bg17BF;E0B907BA;IACE,gBAAA;E1Bg17BF;EACA,oBAAoB;E0B907BpB;IACE,oCAAA;E1Bg17BF;E0B907BA;IACE,gBAAA;E1Bg17BF;AACF;AACA,WAAW;A0B707BX;EACE;;;IAGE,2BAAA;E1B+07BF;E0B707BA;IACE,8BAAA;E1B+07BF;EACA,qBAAqB;E0B507BrB;;IAEE,sDAAA;E1B807BF;E0B507BA;;IAEE,gBAAA;E1B807BF;EACA,gCAAgC;E0B507BhC;IACE,sDAAA;E1B807BF;E0B507BA;IACE,gBAAA;E1B807BF;EACA,oBAAoB;E0B507BpB;IACE,oCAAA;E1B807BF;E0B507BA;IACE,gBAAA;E1B807BF;AACF;AACA,aAAa;A0B307Bb;EACE;;;IAGE,2BAAA;E1B607BF;E0B307BA;IACE,8BAAA;E1B607BF;EACA,qBAAqB;E0B107BrB;;IAEE,sDAAA;E1B407BF;E0B107BA;;IAEE,gBAAA;E1B407BF;EACA,gCAAgC;E0B107BhC;IACE,sDAAA;E1B407BF;E0B107BA;IACE,gBAAA;E1B407BF;EACA,oBAAoB;E0B107BpB;IACE,oCAAA;E1B407BF;E0B107BA;IACE,gBAAA;E1B407BF;AACF;AACA;;qBAEqB;AACrB,gBAAgB;A0Bv07BhB;EACE;IACE,WAAA;E1By07BF;E0Bv07BA;;IAEE,sBAAA;IACA,uBAAA;E1By07BF;E0Bv07BA;;IAEE,gCAAA;IACA,4BAAA;IACA,+BAAA;IACA,2BAAA;IACA,WAAA;E1By07BF;E0Bv07BA;;;IAGE,sBAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,qBAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,8BAAA;E1By07BF;E0Bv07BA;;;IAGE,uBAAA;E1By07BF;AACF;AACA,gBAAgB;A0Bt07BhB;EACE;;IAEE,sBAAA;IACA,uBAAA;E1Bw07BF;E0Bt07BA;;IAEE,4BAAA;IACA,+BAAA;IACA,sBAAA;IACA,2BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,sBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,8BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,8BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,8BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,8BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,8BAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;E0Bt07BA;;;IAGE,qBAAA;E1Bw07BF;AACF;AACA;;qBAEqB;A0Bp07BrB;EACE;IACE,WAAA;IACA,2BAAA;IACA,4BAAA;E1Bs07BF;E0Bp07BA;;;;;;;IAOE,sBAAA;IACA,0BAAA;IACA,2BAAA;IACA,6BAAA;E1Bs07BF;E0Bp07BA;IACE,WAAA;IACA,YAAA;E1Bs07BF;EACA,aAAa;E0Bn07Bb;;IAEE,4BAAA;IACA,6BAAA;E1Bq07BF;EACA,4CAA4C;E0Bl07B5C;;IAEE,6BAAA;IACA,8BAAA;E1Bo07BF;EACA,sBAAsB;E0Bj07BtB;;;;IAIE,2BAAA;E1Bm07BF;E0Bj07BA;;;;IAIE,8CAAA;E1Bm07BF;E0Bh07BA;;;;IAIE,+CAAA;IACA,2BAAA;IACA,4BAAA;IACA,+BAAA;E1Bk07BF;E0B/z7BA;IACE,2BAAA;E1Bi07BF;E0B/z7BA;;IAEE,4BAAA;IACA,6BAAA;E1Bi07BF;AACF;AACA;;wBAEwB;AACxB,qEAAqE;AACrE,qBAAqB;A0B1z7BrB;EACE;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;AACF;AACA,qBAAqB;A0B1z7BrB;EACE;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;E0B1z7BA;;;;IAIE,wBAAA;E1B4z7BF;AACF;AACA,uBAAuB;A0Bzz7BvB;EACE;;;;IAIE,wBAAA;E1B2z7BF;E0Bzz7BA;;;;IAIE,wBAAA;E1B2z7BF;E0Bzz7BA;;;;IAIE,wBAAA;E1B2z7BF;E0Bzz7BA;;;;IAIE,wBAAA;E1B2z7BF;AACF;AACA,2BAA2B;A0Bxz7B3B;EACE;;;;IAIE,wBAAA;E1B0z7BF;E0Bxz7BA;;;;IAIE,wBAAA;E1B0z7BF;E0Bxz7BA;;;;IAIE,wBAAA;E1B0z7BF;AACF;AACA,yBAAyB;A0Bvz7BzB;EACE;;;;IAIE,wBAAA;E1Byz7BF;E0Bvz7BA;;;;IAIE,wBAAA;E1Byz7BF;AACF;AACA;;+BAE+B;AAC/B;;;;;;;;;EASE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,cAAc;AACd,YAAY;AACZ,aAAa;AACb,cAAc;AACd;;gBAEgB;AAChB,SAAS;AACT,kBAAkB;AAClB,WAAW;AACX,kBAAkB;AAClB,oBAAoB;AACpB,mBAAmB;AACnB;;gBAEgB;AAChB,WAAW;AACX,UAAU;AACV,UAAU;AACV,UAAU;AACV,qBAAqB;AACrB,wBAAwB;AACxB;;gBAEgB;AAChB,iBAAiB;AACjB,iBAAiB;AACjB,gBAAgB;AAChB,wBAAwB;AACxB,sBAAsB;AACtB,oBAAoB;AACpB,oBAAoB;AACpB;;gBAEgB;AAChB,aAAa;AACb,cAAc;AACd,aAAa;AACb,uBAAuB;AACvB,sBAAsB;AACtB,WAAW;AACX,SAAS;AACT,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,SAAS;AACT;;gBAEgB;AAChB,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,YAAY;AACZ,oBAAoB;AACpB,2BAA2B;AAC3B,0BAA0B;AAC1B,qBAAqB;AACrB,UAAU;AACV,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,UAAU;AACV,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,SAAS;AACT,cAAc;AACd,YAAY;AACZ,aAAa;AACb,cAAc;AACd;;gBAEgB;AAChB,SAAS;AACT,kBAAkB;AAClB,WAAW;AACX,kBAAkB;AAClB,oBAAoB;AACpB,mBAAmB;AACnB;;gBAEgB;AAChB,WAAW;AACX,UAAU;AACV,UAAU;AACV,UAAU;AACV,qBAAqB;AACrB,wBAAwB;AACxB;;gBAEgB;AAChB,iBAAiB;AACjB,iBAAiB;AACjB,gBAAgB;AAChB,wBAAwB;AACxB,sBAAsB;AACtB,oBAAoB;AACpB,oBAAoB;AACpB;;gBAEgB;AAChB,aAAa;AACb,cAAc;AACd,aAAa;AACb,uBAAuB;AACvB,sBAAsB;AACtB,WAAW;AACX,SAAS;AACT,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,SAAS;AACT;;gBAEgB;AAChB,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,YAAY;AACZ,oBAAoB;AACpB,2BAA2B;AAC3B,0BAA0B;AAC1B,qBAAqB;AACrB,UAAU;AACV,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,UAAU;AACV,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;gBAEgB;A2B/5gChB;EACE,aAAA;EACA,gBAAA;EACA,mEAAA;EACA,+BAAA;EACA,mBAAA;EACA,2CAAA;EACA,mDAAA;EACA,4BAAA;EACA,wBAAA;A3Bi6gCF;A2B95gCA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A3Bg6gCF;A2B75gCA;EACE,gBAAA;A3B+5gCF;A2B75gCA;EACE,mBAAA;A3B+5gCF;AACA;;gBAEgB;A2B15gChB;EACE,WAAA;A3B45gCF;A2Bz5gCA;EACE,aAAA;A3B25gCF;AACA;;gBAEgB;A2Bv5gChB;EACE,aAAA;EACA,mBAAA;A3By5gCF;A2Bt5gCA;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kCAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,uEAAA;A3Bu5gCF;A2Bp5gCA;EACE,kDAAA;A3Bs5gCF;AACA,WAAW;A2Bn5gCX;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EAEA,UAAA;EACA,oCAAA;A3Bo5gCF;AACA;;gBAEgB;A2Bh5gChB;;;EAGE,iBAAA;EACA,gBAAA;A3Bk5gCF;A2Bh5gCA;EACE,aAAA;A3Bk5gCF;A2Bh5gCA;EACE,gBAAA;A3Bk5gCF;AACA;;gBAEgB;A2B94gChB;EACE,YAAA;EACA,WAAA;EACA,gCAAA;A3Bg5gCF;AACA;;gBAEgB;A2B54gChB;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,cAAA;A3B84gCF;AACA;;kBAEkB;A2B14gClB;;EAEE,aAAA;EACA,oBAAA;EACA,uBAAA;A3B44gCF;AACA;;gBAEgB;A2Bx4gChB;EACE,WAAA;A3B04gCF;A2Bx4gCA;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;A3B04gCF;A2Bx4gCA;EACE,cAAA;EACA,yBAAA;EACA,4BAAA;A3B04gCF;AACA;;gBAEgB;A2Br4gChB;;EAEE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;A3Bu4gCF;A2Bp4gCA;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;A3Bs4gCF;AACA;;gBAEgB;AAChB,kBAAkB;A2Bj4gClB;EACE,YAAA;EACA,YAAA;EACA,uBAAA;A3Bm4gCF;AACA,SAAS;A2Bh4gCT;EACE,2BAAA;EACA,kDAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;EACA,iCAAA;A3Bk4gCF;AACA,eAAe;A2B93gCf;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,6CAAA;EACA,kCAAA;EACA,2CAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;A3Bg4gCF;A2B93gCA;EACE,0CAAA;EACA,2CAAA;A3Bg4gCF;A2B93gCA;EACE,0CAAA;EACA,2CAAA;A3Bg4gCF;A2B93gCA;EACE,0CAAA;EACA,4BAAA;EACA,2CAAA;A3Bg4gCF;A2B73gCA;EACE,cAAA;A3B+3gCF;A2B73gCA;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,qCAAA;A3B+3gCF;AACA,cAAc;A2B33gCd;;EAEE,4BAAA;EACA,wBAAA;A3B63gCF;AACA,aAAa;A2B13gCb;EACE,kBAAA;A3B43gCF;AACA,aAAa;A2Bz3gCb;;EAEE,+BAAA;A3B23gCF;AACA,aAAa;A2Bx3gCb;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;A3B03gCF;A2Bx3gCA;EACE,UAAA;EACA,YAAA;EACA,uBAAA;EACA,6CAAA;EACA,4DAAA;A3B03gCF;A2Bx3gCA;EACE,SAAA;A3B03gCF;A2Bx3gCA;EACE,MAAA;A3B03gCF;A2Bx3gCA;EACE,4BAAA;EACA,+BAAA;A3B03gCF;A2Bx3gCA;EACE,gBAAA;A3B03gCF;AACA,mBAAmB;A2Bv3gCnB;EACE,WAAA;A3By3gCF;AACA;;gBAEgB;A2Br3gChB;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;A3Bu3gCF;A2Br3gCA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;A3Bu3gCF;A2Br3gCA;EACE,2BAAA;A3Bu3gCF;AACA;;gBAEgB;A2Bn3gChB;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;A3Bq3gCF;A2Bn3gCA;EACE,cAAA;EACA,eAAA;EACA,WAAA;A3Bq3gCF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,gCAAgC;A2Bh3gChC;EACE,2BAAA;A3Bk3gCF;AACA;;gBAEgB;AAChB,sCAAsC;A2B72gCtC;EACE,yBAAA;A3B+2gCF;A2B72gCA;EACE,SAAA;EACA,WAAA;A3B+2gCF;AACA;;gBAEgB;A2B32gChB;EACE;IACE,sBAAA;IACA,2BAAA;IACA,4BAAA;E3B62gCF;AACF;A2B32gCA;EACE;IACE,+CAAA;E3B62gCF;AACF;AACA;;+BAE+B;AAC/B;;gBAEgB;A2Bt2gChB;;;;EAIE,eAAA;EACA,+BAAA;EACA,gCAAA;A3Bw2gCF;AACA;;gBAEgB;A2Bn2gChB;;;EAGE,+BAAA;EACA,gCAAA;A3Bq2gCF;AACA;;gBAEgB;A2Bh2gChB;EACE,+BAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;A3Bk2gCF;A2Bh2gCA;EACE,UAAA;A3Bk2gCF;AACA;;gBAEgB;A2B91gChB;;EAEE,qCAAA;EACA,gCAAA;A3Bg2gCF;AACA;;gBAEgB;A2B31gChB;;EAEE,0BAAA;EACA,wCAAA;EACA,uCAAA;A3B61gCF;AACA;;+BAE+B;AAC/B;;oBAEoB;AACpB,iBAAiB;A2Bv1gCjB;;EAEE,aAAA;EACA,6BAAA;A3By1gCF;AACA,kBAAkB;A2Bv1gClB;;EAEE,aAAA;EACA,4BAAA;A3By1gCF;AACA,oBAAoB;A2Bt1gCpB;;EAEE,WAAA;EACA,OAAA;A3Bw1gCF;AACA;;gBAEgB;A2Bn1gChB;EACE,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,mDAAA;A3Bq1gCF;AACA,eAAe;A2Bl1gCf;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A3Bo1gCF;A2Bl1gCA;EACE,kDAAA;A3Bo1gCF;A2Bl1gCA;EACE,kDAAA;A3Bo1gCF;AACA,gBAAgB;A2Bj1gChB;EACE,YAAA;EACA,kBAAA;A3Bm1gCF;AACA,eAAe;A2Bh1gCf;EACE,aAAA;EACA,YAAA;EACA,yBAAA;A3Bk1gCF;A2Bh1gCA;EACE,WAAA;EACA,yBAAA;A3Bk1gCF;AACA,iBAAiB;A2B90gCjB;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;A3Bg1gCF;A2B70gCA;EACE,wBAAA;A3B+0gCF;AACA,mBAAmB;A2B30gCnB;EACE,+BAAA;A3B60gCF;A2B30gCA;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;A3B60gCF;A2B30gCA;;EAEE,gCAAA;A3B60gCF;A2B30gCA;EACE,aAAA;A3B60gCF;AACA,oBAAoB;A2B10gCpB;EACE,+BAAA;EACA,kBAAA;EACA,gBAAA;A3B40gCF;A2B10gCA;EACE,kDAAA;A3B40gCF;A2B10gCA;EACE,kDAAA;A3B40gCF;A2B10gCA;EACE,4BAAA;A3B40gCF;A2B10gCA;EACE,iBAAA;A3B40gCF;A2B10gCA;EACE,6BAAA;EACA,iBAAA;EACA,gCAAA;A3B40gCF;AACA;;gBAEgB;A2Bv0gChB;EACE,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,4BAAA;EACA,gCAAA;A3By0gCF;A2Bv0gCA;EACE,wCAAA;A3By0gCF;A2Bv0gCA;EACE,uBAAA;EACA,mBAAA;EAEA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kCAAA;EACA,gCAAA;A3Bw0gCF;A2Bt0gCA;EACE,aAAA;A3Bw0gCF;AACA,UAAU;A2Br0gCV;EACE,6BAAA;EACA,+BAAA;A3Bu0gCF;AACA,WAAW;A2Bp0gCX;EACE,wBAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6DAAA;A3Bs0gCF;AACA,yCAAyC;A2Bn0gCzC;;EAEE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;A3Bq0gCF;A2Bn0gCA;EACE,kBAAA;EACA,6BAAA;EACA,UAAA;A3Bq0gCF;AACA,4BAA4B;A2Bl0gC5B;EACE,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;A3Bo0gCF;A2Bl0gCA;EACE,gBAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;EACA,gBAAA;A3Bo0gCF;A2Bl0gCA;EACE,wBAAA;EACA,gCAAA;EACA,qBAAA;EACA,wBAAA;EACA,6DAAA;A3Bo0gCF;AACA,4BAA4B;A2Bj0gC5B;EACE,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,+BAAA;A3Bm0gCF;A2Bj0gCA;EACE,gBAAA;EACA,kCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;A3Bm0gCF;A2Bj0gCA;EACE,wBAAA;EACA,gCAAA;EACA,qBAAA;EACA,wBAAA;EACA,6DAAA;A3Bm0gCF;AACA,2BAA2B;A2Bh0gC3B;EACE,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;A3Bk0gCF;A2Bh0gCA;EACE,gBAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,iBAAA;A3Bk0gCF;A2Bh0gCA;EACE,wBAAA;EACA,gCAAA;EACA,qBAAA;EACA,wBAAA;EACA,6DAAA;A3Bk0gCF;AACA,aAAa;A2B/zgCb;EACE,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;A3Bi0gCF;AACA;;gBAEgB;A2B3zgChB;EACE,WAAA;EACA,oBAAA;EACA,sBAAA;A3B6zgCF;A2B3zgCA;EACE,kDAAA;A3B6zgCF;A2B3zgCA;EACE,kDAAA;A3B6zgCF;A2B3zgCA;EACE,aAAA;A3B6zgCF;A2B1zgCA;EACE,cAAA;EACA,kBAAA;A3B4zgCF;A2B1zgCA;EACE,mBAAA;A3B4zgCF;AACA,WAAW;A2BzzgCX;EACE,gBAAA;EACA,yBAAA;EACA,qCAAA;EACA,gCAAA;EACA,gBAAA;A3B2zgCF;AACA;;gBAEgB;A2BvzgChB;EACE,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;A3ByzgCF;AACA,SAAS;A2BtzgCT;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;A3BwzgCF;AACA,eAAe;A2BrzgCf;EACE,wBAAA;A3BuzgCF;AACA,WAAW;A2BpzgCX;EACE,kBAAA;EACA,kBAAA;EACA,4BAAA;A3BszgCF;AACA,UAAU;A2BnzgCV;EACE,WAAA;A3BqzgCF;AACA,UAAU;A2BlzgCV;;;EAGE,+BAAA;EACA,gCAAA;A3BozgCF;AACA,WAAW;A2BjzgCX;EACE,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,4BAAA;A3BmzgCF;AACA,iBAAiB;A2BhzgCjB;EACE,gBAAA;EACA,+BAAA;EACA,gCAAA;A3BkzgCF;AACA,aAAa;A2B9ygCb;;EAEE,0CAAA;A3BgzgCF;A2B9ygCA;;;EAGE,qCAAA;EACA,yBAAA;A3BgzgCF;A2B9ygCA;EACE,qCAAA;EACA,yBAAA;A3BgzgCF;AACA,qBAAqB;A2B7ygCrB;EACE,gBAAA;EACA,iBAAA;A3B+ygCF;A2B7ygCA;EACE,iBAAA;A3B+ygCF;A2B7ygCA;EACE,gBAAA;A3B+ygCF;AACA,aAAa;A2B5ygCb;EACE,yBAAA;A3B8ygCF;A2B5ygCA;EACE,WAAA;EACA,2BAAA;A3B8ygCF;AACA;;wBAEwB;A2BzygCxB;EACE,YAAA;EACA,4BAAA;EACA,uCAAA;A3B2ygCF;A2BzygCA;EACE,kBAAA;A3B2ygCF;AACA,aAAa;A2BxygCb;EACE,6BAAA;A3B0ygCF;AACA,aAAa;A2BvygCb;EACE,6BAAA;A3ByygCF;AACA;;wBAEwB;A2BrygCxB;EACE,gBAAA;EACA,iBAAA;EACA,kDAAA;A3BuygCF;A2BpygCA;EACE,gCAAA;EACA,0BAAA;EACA,kBAAA;EACA,oBAAA;EAEA,oBAAA;EACA,kCAAA;EACA,wBAAA;EACA,2BAAA;A3BqygCF;AACA,eAAe;A2BlygCf;EACE,2CAAA;A3BoygCF;A2BlygCA;EACE,2BAAA;A3BoygCF;A2BlygCA;EACE,aAAA;A3BoygCF;AACA,UAAU;A2BjygCV;;;EAGE,6BAAA;EACA,gCAAA;A3BmygCF;AACA,YAAY;A2BhygCZ;;;EAGE,6BAAA;EACA,uCAAA;A3BkygCF;AACA,WAAW;A2B/xgCX;EACE,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;A3BiygCF;AACA,iBAAiB;A2B9xgCjB;EACE,qBAAA;EACA,gCAAA;A3BgygCF;AACA,oBAAoB;A2B7xgCpB;EACE,yBAAA;A3B+xgCF;AACA,sBAAsB;A2B5xgCtB;EACE,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,6CAAA;A3B8xgCF;A2B5xgCA;EACE,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,wBAAA;EACA,uBAAA;A3B8xgCF;AACA,oBAAoB;A2B3xgCpB;EACE,qBAAA;A3B6xgCF;AACA,aAAa;A2B1xgCb;EACE,sCAAA;A3B4xgCF;A2BzxgCA;EACE,iBAAA;EACA,uCAAA;A3B2xgCF;A2BzxgCA;EACE,+BAAA;A3B2xgCF;A2BzxgCA;EACE,yBAAA;A3B2xgCF;AACA,UAAU;A2BxxgCV;;EAEE,gCAAA;A3B0xgCF;AACA,WAAW;A2BtxgCX;EACE,qBAAA;EACA,cAAA;A3BwxgCF;AACA;;gBAEgB;A2BpxgChB;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EAEA,kBAAA;A3BqxgCF;A2BnxgCA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;A3BqxgCF;AACA,WAAW;A2BlxgCX;;EAEE,wBAAA;A3BoxgCF;AACA,WAAW;A2BjxgCX;EACE,6BAAA;EACA,UAAA;EACA,gCAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;A3BmxgCF;AACA,UAAU;A2BhxgCV;EACE,WAAA;A3BkxgCF;AACA,qBAAqB;A2B/wgCrB;EACE,WAAA;A3BixgCF;AACA,wBAAwB;A2B9wgCxB;EACE,eAAA;A3BgxgCF;A2B9wgCA;EACE,gBAAA;A3BgxgCF;A2B9wgCA;EACE,mBAAA;A3BgxgCF;A2B9wgCA;EACE,wBAAA;EACA,iBAAA;EACA,kBAAA;A3BgxgCF;A2B9wgCA;EACE,WAAA;EACA,gCAAA;A3BgxgCF;A2B9wgCA;EACE,qCAAA;A3BgxgCF;AACA,sBAAsB;A2B7wgCtB;EACE,WAAA;A3B+wgCF;A2B7wgCA;EACE,WAAA;EACA,kBAAA;A3B+wgCF;AACA,gBAAgB;A2B5wgChB;EACE,UAAA;EACA,6BAAA;A3B8wgCF;AACA,iBAAiB;A2B3wgCjB;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;A3B6wgCF;AACA,uBAAuB;A2B1wgCvB;EACE,6BAAA;A3B4wgCF;AACA,uBAAuB;A2BzwgCvB;EACE,gBAAA;A3B2wgCF;A2BzwgCA;EACE,gBAAA;A3B2wgCF;AACA,aAAa;A2BxwgCb;;;;EAIE,wCAAA;A3B0wgCF;AACA,UAAU;A2BvwgCV;EACE,gBAAA;EACA,iBAAA;A3BywgCF;AACA;;gBAEgB;AAChB,kBAAkB;A2BrwgClB;EACE,qBAAA;EACA,WAAA;A3BuwgCF;AACA,SAAS;A2BpwgCT;EACE,YAAA;EACA,kBAAA;EACA,cAAA;A3BswgCF;AACA,SAAS;A2BnwgCT;EACE,SAAA;EACA,UAAA;A3BqwgCF;AACA,eAAe;A2BlwgCf;EACE,UAAA;A3BowgCF;AACA,kBAAkB;A2BjwgClB;EACE,WAAA;EACA,gBAAA;A3BmwgCF;AACA,kBAAkB;A2BhwgClB;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;A3BkwgCF;AACA,aAAa;A2B/vgCb;EACE,cAAA;A3BiwgCF;AACA;;gBAEgB;AAChB,SAAS;A2B7vgCT;EACE,kBAAA;A3B+vgCF;AACA,SAAS;A2B5vgCT;EACE,cAAA;EACA,sBAAA;A3B8vgCF;AACA,SAAS;A2B3vgCT;EACE,WAAA;EACA,cAAA;EACA,kCAAA;EACA,kCAAA;A3B6vgCF;AACA,UAAU;A2B1vgCV;EACE,cAAA;A3B4vgCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A2BtvgChB;EACE;IACE,sBAAA;E3BwvgCF;E2BtvgCA;IACE,sBAAA;E3BwvgCF;E2BtvgCA;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,oCAAA;E3BwvgCF;E2BrvgCA;;IAEE,0BAAA;E3BuvgCF;E2BrvgCA;;IAEE,yBAAA;E3BuvgCF;E2BpvgCA;;IAEE,sBAAA;E3BsvgCF;AACF;AACA;;gBAEgB;AAChB,2BAA2B;A2BlvgC3B;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;A2BlvgCA;;EAEE,gCAAA;EACA,yBAAA;A3BovgCF;AACA;;gBAEgB;A2B/ugChB;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;A3BivgCF;AACA,cAAc;A2B9ugCd;;EAEE,uBAAA;EACA,+BAAA;A3BgvgCF;A2B9ugCA;EACE,uBAAA;A3BgvgCF;AACA,iBAAiB;A2B7ugCjB;EACE,qCAAA;A3B+ugCF;A2B7ugCA;EACE,qCAAA;A3B+ugCF;AACA,aAAa;A2B5ugCb;;EAEE,+BAAA;A3B8ugCF;AACA,WAAW;A2B3ugCX;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;A3B6ugCF;AACA,aAAa;A2B1ugCb;;EAEE,+BAAA;A3B4ugCF;AACA,gBAAgB;A2BzugChB;;;;EAIE,qCAAA;EACA,cAAA;A3B2ugCF;A2BzugCA;;EAEE,uBAAA;EACA,cAAA;A3B2ugCF;AACA,kBAAkB;A2BxugClB;;EAEE,qCAAA;EACA,cAAA;A3B0ugCF;AACA,iBAAiB;A2BvugCjB;EACE,qCAAA;EACA,yBAAA;A3ByugCF;A2BvugCA;EACE,uBAAA;EACA,cAAA;A3ByugCF;A2BvugCA;EACE,8BAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;A3ByugCF;AACA,uBAAuB;A2BtugCvB;EACE,qCAAA;EACA,yBAAA;A3BwugCF;A2BtugCA;EACE,8BAAA;A3BwugCF;AACA;;gBAEgB;A2BnugChB;EACE,WAAA;EACA,6BAAA;A3BqugCF;A2BnugCA;EACE,aAAA;A3BqugCF;A2BlugCA;EACE,YAAA;EACA,6BAAA;A3BougCF;AACA;;gBAEgB;AAChB,QAAQ;A2B/tgCR;;EAEE,yBAAA;A3BiugCF;A2B/tgCA;EACE,0CAAA;A3BiugCF;A2B/tgCA;EACE,+CAAA;A3BiugCF;AACA,WAAW;A2B9tgCX;;EAEE,yBAAA;A3BgugCF;A2B9tgCA;EACE,0CAAA;A3BgugCF;A2B9tgCA;EACE,+CAAA;A3BgugCF;AACA,WAAW;A2B7tgCX;;EAEE,yBAAA;A3B+tgCF;A2B7tgCA;EACE,0CAAA;A3B+tgCF;A2B7tgCA;EACE,+CAAA;A3B+tgCF;AACA,UAAU;A2B5tgCV;;EAEE,yBAAA;A3B8tgCF;A2B5tgCA;EACE,0CAAA;A3B8tgCF;A2B5tgCA;EACE,+CAAA;A3B8tgCF;AACA,UAAU;A2B3tgCV;;EAEE,yBAAA;A3B6tgCF;A2B3tgCA;EACE,0CAAA;A3B6tgCF;A2B3tgCA;EACE,+CAAA;A3B6tgCF;AACA,SAAS;A2B1tgCT;;EAEE,yBAAA;A3B4tgCF;A2B1tgCA;EACE,0CAAA;A3B4tgCF;A2B1tgCA;EACE,+CAAA;A3B4tgCF;AACA,SAAS;A2BztgCT;;EAEE,yBAAA;A3B2tgCF;A2BztgCA;EACE,0CAAA;A3B2tgCF;A2BztgCA;EACE,+CAAA;A3B2tgCF;AACA,WAAW;A2BxtgCX;;EAEE,yBAAA;A3B0tgCF;A2BxtgCA;EACE,0CAAA;A3B0tgCF;A2BxtgCA;EACE,+CAAA;A3B0tgCF;AACA,WAAW;A2BvtgCX;;EAEE,yBAAA;A3BytgCF;A2BvtgCA;EACE,0CAAA;A3BytgCF;A2BvtgCA;EACE,+CAAA;A3BytgCF;AACA,SAAS;A2BttgCT;;EAEE,yBAAA;A3BwtgCF;A2BttgCA;EACE,0CAAA;A3BwtgCF;A2BttgCA;EACE,+CAAA;A3BwtgCF;AACA,UAAU;A2BrtgCV;;EAEE,yBAAA;A3ButgCF;A2BrtgCA;EACE,0CAAA;A3ButgCF;A2BrtgCA;EACE,+CAAA;A3ButgCF;AACA,SAAS;A2BptgCT;;EAEE,yBAAA;A3BstgCF;A2BptgCA;EACE,0CAAA;A3BstgCF;A2BptgCA;EACE,+CAAA;A3BstgCF;AACA;;gBAEgB;A2BjtgChB;;;EAGE,YAAA;A3BmtgCF;A2BjtgCA;;;EAGE,yBAAA;EACA,4BAAA;A3BmtgCF;A2BjtgCA;;;EAGE,0BAAA;EACA,2BAAA;A3BmtgCF;AACA;;gBAEgB;A2B/sgChB;;;EAGE,2BAAA;A3BitgCF;AACA;;qBAEqB;A2B7sgCrB;EACE,oBAAA;EACA,WAAA;EACA,sBAAA;A3B+sgCF;A2B7sgCA;EACE,qBAAA;A3B+sgCF;A2B7sgCA;EACE,kDAAA;A3B+sgCF;A2B7sgCA;EACE,aAAA;A3B+sgCF;A2B7sgCA;EACE,sBAAA;A3B+sgCF;A2B7sgCA;EACE,cAAA;A3B+sgCF;AACA;;qBAEqB;A2B3sgCrB;;EAEE,sBAAA;A3B6sgCF;AACA;;qBAEqB;A2BxsgCrB;;EAEE,WAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,uBAAA;A3B0sgCF;A2BxsgCA;EACE,2BAAA;A3B0sgCF;A2BvsgCA;EACE,aAAA;A3BysgCF;A2BtsgCA;EACE,UAAA;A3BwsgCF;A2BtsgCA;EACE,cAAA;A3BwsgCF;A2BtsgCA;EACE,UAAA;A3BwsgCF;A2BtsgCA;EACE,UAAA;A3BwsgCF;A2BtsgCA;EACE,cAAA;A3BwsgCF;A2BtsgCA;EACE,cAAA;A3BwsgCF;A2BtsgCA;EACE,YAAA;A3BwsgCF;A2BtsgCA;EACE,aAAA;A3BwsgCF;A2BtsgCA;EACE,UAAA;A3BwsgCF;A2BtsgCA;EACE,YAAA;A3BwsgCF;A2BtsgCA;EACE,aAAA;A3BwsgCF;AACA;;gBAEgB;A2BpsgChB;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;A3BssgCF;A2BpsgCA;;;EAGE,6BAAA;A3BssgCF;A2BnsgCA;;EAEE,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A3BqsgCF;A2BnsgCA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;A3BqsgCF;A2BnsgCA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;A3BqsgCF;A2BnsgCA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;A3BqsgCF;A2BnsgCA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;A3BqsgCF;AACA,uBAAuB;A2BlsgCvB;EACE,oBAAA;A3BosgCF;AACA;;qBAEqB;A2B/rgCrB;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,0DAAA;EACA,gBAAA;EAEA,qBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,YAAA;EACA,gCAAA;EACA,+BAAA;EAEA,UAAA;EACA,gCAAA;A3B8rgCF;A2B5rgCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EAEA,yDAAA;EACA,0BAAA;EAEA,YAAA;EACA,6BAAA;EACA,+BAAA;A3B4rgCF;AACA,WAAW;A2BzrgCX;EACE,mBAAA;A3B2rgCF;A2BzrgCA;EACE,kBAAA;A3B2rgCF;AACA,6BAA6B;A2BxrgC7B;;EAEE,aAAA;A3B0rgCF;AACA,WAAW;A2BvrgCX;EACE,yBAAA;A3ByrgCF;A2BvrgCA;EACE,yBAAA;A3ByrgCF;A2BvrgCA;EACE,yBAAA;A3ByrgCF;A2BtrgCA;EACE,yBAAA;A3BwrgCF;A2BtrgCA;EACE,yBAAA;A3BwrgCF;A2BtrgCA;EACE,yBAAA;A3BwrgCF;AACA;;gBAEgB;AAChB,WAAW;A2BlrgCX;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,gBAAA;A3BorgCF;A2BlrgCA;EACE,gBAAA;A3BorgCF;AACA,QAAQ;A2BjrgCR;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,kDAAA;A3BmrgCF;A2BjrgCA;EACE,eAAA;A3BmrgCF;AACA,WAAW;A2BhrgCX;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yDAAA;EACA,kDAAA;A3BkrgCF;A2BhrgCA;EACE,kBAAA;A3BkrgCF;AACA,uBAAuB;A2B/qgCvB;EACE,wCAAA;A3BirgCF;A2B/qgCA;EACE,wCAAA;A3BirgCF;AACA,qBAAqB;A2B9qgCrB;EACE,yBAAA;A3BgrgCF;A2B9qgCA;EACE,YAAA;A3BgrgCF;A2B9qgCA;EACE,cAAA;EACA,eAAA;EACA,WAAA;A3BgrgCF;AACA;;gBAEgB;AAChB,SAAS;A2B5qgCT;EACE,wBAAA;A3B8qgCF;A2B5qgCA;EACE,WAAA;A3B8qgCF;AACA,SAAS;A2B3qgCT;EACE,wBAAA;A3B6qgCF;A2B3qgCA;EACE,YAAA;A3B6qgCF;AACA,UAAU;A2B1qgCV;EACE,wBAAA;A3B4qgCF;A2B1qgCA;EACE,YAAA;A3B4qgCF;AACA,WAAW;A2BzqgCX;EACE,eAAA;A3B2qgCF;A2BzqgCA;EACE,YAAA;A3B2qgCF;AACA,UAAU;A2BxqgCV;EACE,wBAAA;A3B0qgCF;A2BxqgCA;EACE,YAAA;A3B0qgCF;AACA,SAAS;A2BvqgCT;EACE,wBAAA;A3ByqgCF;A2BvqgCA;EACE,YAAA;A3ByqgCF;AACA,QAAQ;A2BtqgCR;EACE,wBAAA;A3BwqgCF;A2BtqgCA;EACE,YAAA;A3BwqgCF;AACA,YAAY;A2BrqgCZ;EACE,wBAAA;A3BuqgCF;A2BrqgCA;EACE,YAAA;A3BuqgCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,cAAc;AACd,SAAS;AACT,SAAS;AACT,eAAe;AACf;;qBAEqB;AACrB,iBAAiB;AACjB,aAAa;AACb,aAAa;AACb,WAAW;AACX,yCAAyC;AACzC,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,cAAc;AACd,SAAS;AACT,SAAS;AACT,eAAe;AACf;;qBAEqB;AACrB,iBAAiB;AACjB,aAAa;AACb,aAAa;AACb,WAAW;AACX,yCAAyC;AACzC,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A4BzulC/B;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,0FAAA;EACA,4BAAA;EACA,6FAAA;A5B2ulCF;A4BxulCA;EACE,eAAA;A5B0ulCF;A4BxulCA;EACE,kBAAA;A5B0ulCF;AACA;;gBAEgB;AAChB,WAAW;A4BrulCX;EACE,cAAA;EACA,mEAAA;EACA,iBAAA;EACA,kCAAA;A5BuulCF;AACA,sBAAsB;A4BpulCtB;EACE,uBAAA;A5BsulCF;AACA,cAAc;A4BnulCd;EACE,aAAA;EACA,kBAAA;A5BqulCF;A4BnulCA;EACE,eAAA;A5BqulCF;A4BnulCA;EACE,kBAAA;A5BqulCF;A4BnulCA;EACE,kBAAA;A5BqulCF;AACA,SAAS;A4BlulCT;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,qBAAA;A5BoulCF;A4BlulCA;EACE,eAAA;A5BoulCF;A4BlulCA;EACE,kBAAA;A5BoulCF;A4BlulCA;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;A5BoulCF;A4BlulCA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;A5BoulCF;A4BlulCA;EACE,kBAAA;A5BoulCF;AACA,SAAS;A4BhulCT;EACE,mBAAA;A5BkulCF;AACA,eAAe;A4B/tlCf;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;A5BiulCF;A4B/tlCA;EACE,UAAA;A5BiulCF;AACA,yBAAyB;A4B9tlCzB;EACE,eAAA;A5BgulCF;A4B9tlCA;EACE,kBAAA;A5BgulCF;AACA;;+BAE+B;A4B5tlC/B;EACE,gBAAA;A5B8tlCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A4BztlChB;EACE,cAAA;A5B2tlCF;A4BxtlCA;EACE,aAAA;A5B0tlCF;AACA;;gBAEgB;A4BttlChB;EACE,aAAA;A5BwtlCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A4BltlChB;EACE,qBAAA;A5BotlCF;A4BltlCA;EACE,oBAAA;A5BotlCF;AACA;;gBAEgB;A4B/slChB;EACE,mBAAA;EACA,kDAAA;EACA,2DAAA;EACA,iBAAA;EACA,kBAAA;A5BitlCF;A4B/slCA;EACE,gBAAA;EACA,kBAAA;A5BitlCF;A4B/slCA;EACE,gBAAA;EACA,kDAAA;EACA,oGAAA;A5BitlCF;A4B/slCA;EACE,kBAAA;A5BitlCF;A4B/slCA;EACE,WAAA;A5BitlCF;AACA;;gBAEgB;A4B5slChB;EACE,aAAA;EACA,WAAA;EACA,mBAAA;A5B8slCF;A4B5slCA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;A5B8slCF;A4B5slCA;EACE,cAAA;EACA,cAAA;EACA,sBAAA;A5B8slCF;A4B1slCA;EACE,kBAAA;A5B4slCF;A4B1slCA;EACE,UAAA;A5B4slCF;AACA;;gBAEgB;A4BxslChB;EACE,4IAAA;A5B0slCF;AACA;;gBAEgB;A4BrslChB;EACE,yBAAA;EACA,+BAAA;A5BuslCF;AACA;;gBAEgB;AAChB,aAAa;A4BnslCb;EACE,yBAAA;EACA,cAAA;A5BqslCF;A4BnslCA;;EAEE,2EAAA;A5BqslCF;A4BnslCA;EACE,cAAA;A5BqslCF;AACA,aAAa;A4BlslCb;EACE,uCAAA;EACA,cAAA;A5BoslCF;A4BlslCA;;EAEE,2EAAA;A5BoslCF;A4BlslCA;EACE,cAAA;A5BoslCF;AACA,SAAS;A4BjslCT;EACE,yBAAA;EACA,cAAA;A5BmslCF;A4BjslCA;;EAEE,2EAAA;A5BmslCF;A4BjslCA;EACE,cAAA;A5BmslCF;AACA,YAAY;A4BhslCZ;EACE,yBAAA;EACA,cAAA;A5BkslCF;A4BhslCA;;EAEE,2EAAA;A5BkslCF;A4BhslCA;EACE,cAAA;A5BkslCF;AACA,UAAU;A4B/rlCV;EACE,uCAAA;EACA,cAAA;A5BislCF;A4B/rlCA;;EAEE,2EAAA;A5BislCF;A4B/rlCA;EACE,cAAA;A5BislCF;AACA,YAAY;A4B9rlCZ;EACE,yBAAA;EACA,cAAA;A5BgslCF;A4B9rlCA;;EAEE,2EAAA;A5BgslCF;A4B9rlCA;EACE,cAAA;A5BgslCF;AACA,WAAW;A4B5rlCX;;EAEE,yBAAA;EACA,+BAAA;A5B8rlCF;A4B3rlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5B6rlCF;A4B3rlCA;EACE,cAAA;A5B6rlCF;A4B1rlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5B4rlCF;A4B1rlCA;EACE,cAAA;A5B4rlCF;A4BzrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5B2rlCF;A4BzrlCA;EACE,cAAA;A5B2rlCF;A4BxrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5B0rlCF;A4BxrlCA;EACE,cAAA;A5B0rlCF;A4BvrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5ByrlCF;A4BvrlCA;EACE,cAAA;A5ByrlCF;A4BtrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BwrlCF;A4BtrlCA;EACE,cAAA;A5BwrlCF;A4BrrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BurlCF;A4BrrlCA;EACE,cAAA;A5BurlCF;A4BprlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BsrlCF;A4BprlCA;EACE,cAAA;A5BsrlCF;A4BnrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BqrlCF;A4BnrlCA;EACE,cAAA;A5BqrlCF;A4BlrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BorlCF;A4BlrlCA;EACE,cAAA;A5BorlCF;A4BjrlCA;EACE,yBAAA;EACA,cAAA;EACA,2EAAA;A5BmrlCF;A4BjrlCA;EACE,cAAA;A5BmrlCF;AACA;;gBAEgB;A4B/qlChB;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,cAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;A4B/qlCA;EACE,uBAAA;A5BirlCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;gBAEgB;AAChB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,iBAAiB;AACjB,oBAAoB;AACpB;;qBAEqB;AACrB,eAAe;AACf;;gBAEgB;AAChB;;gBAEgB;AAChB,aAAa;AACb,aAAa;AACb,UAAU;AACV,YAAY;AACZ,WAAW;AACX;;gBAEgB;AAChB,aAAa;AACb,YAAY;AACZ,eAAe;AACf,aAAa;AACb,WAAW;AACX,aAAa;AACb,UAAU;AACV,WAAW;AACX,YAAY;AACZ,UAAU;AACV,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;gBAEgB;AAChB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,iBAAiB;AACjB,oBAAoB;AACpB;;qBAEqB;AACrB,eAAe;AACf;;gBAEgB;AAChB;;gBAEgB;AAChB,aAAa;AACb,aAAa;AACb,UAAU;AACV,YAAY;AACZ,WAAW;AACX;;gBAEgB;AAChB,aAAa;AACb,YAAY;AACZ,eAAe;AACf,aAAa;AACb,WAAW;AACX,aAAa;AACb,UAAU;AACV,WAAW;AACX,YAAY;AACZ,UAAU;AACV,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,cAAc;A6Bp0nCd;EACE,WAAA;EACA,+BAAA;EACA,eAAA;EACA,2CAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;A7Bs0nCF;A6Bn0nCA;EACE,eAAA;A7Bq0nCF;A6Bn0nCA;EACE,kBAAA;A7Bq0nCF;AACA;;+BAE+B;AAC/B,kBAAkB;A6Bj0nClB;;EAEE,iDAAA;A7Bm0nCF;AACA,YAAY;A6Bh0nCZ;EACE,gBAAA;A7Bk0nCF;A6Bh0nCA;EACE,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,gCAAA;EACA,kCAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iDAAA;EACA,iBAAA;A7Bk0nCF;A6B/znCA;EACE,iBAAA;A7Bi0nCF;A6B9znCA;EACE,wCAAA;A7Bg0nCF;A6B9znCA;EACE,wCAAA;A7Bg0nCF;A6B9znCA;EACE,kDAAA;A7Bg0nCF;AACA,WAAW;A6B7znCX;EACE,gBAAA;A7B+znCF;A6B7znCA;EACE,YAAA;EACA,+CAAA;EACA,qCAAA;EACA,mBAAA;EACA,gCAAA;EACA,kCAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;A7B+znCF;A6B7znCA;EACE,iBAAA;A7B+znCF;A6B7znCA;EACE,wCAAA;A7B+znCF;A6B7znCA;EACE,wCAAA;A7B+znCF;A6B7znCA;EACE,kDAAA;A7B+znCF;AACA,cAAc;A6B5znCd;EACE,8CAAA;A7B8znCF;A6B5znCA;EACE,gBAAA;A7B8znCF;AACA,mBAAmB;A6B3znCnB;EACE,8CAAA;A7B6znCF;AACA,gBAAgB;A6B1znChB;EACE,kCAAA;EACA,mBAAA;A7B4znCF;AACA,UAAU;A6BzznCV;EACE,wBAAA;A7B2znCF;A6BzznCA;EACE,WAAA;A7B2znCF;AACA,kBAAkB;A6BxznClB;EACE,YAAA;A7B0znCF;A6BxznCA;EACE,aAAA;A7B0znCF;A6BxznCA;EACE,cAAA;A7B0znCF;AACA,eAAe;A6BtznCf;EACE;IACE,WAAA;E7BwznCF;E6BtznCA;;;;IAKE,sBAAA;IACA,yBAAA;E7BuznCF;E6BpznCA;IACE,YAAA;E7BsznCF;E6BpznCA;IACE,cAAA;E7BsznCF;E6BpznCA;IACE,cAAA;E7BsznCF;E6BpznCA;IACE,gBAAA;IACA,mBAAA;IACA,gEAAA;E7BsznCF;E6BnznCA;;IAEE,gBAAA;IACA,uBAAA;IACA,iCAAA;IACA,2BAAA;E7BqznCF;E6BnznCA;;IAEE,iBAAA;E7BqznCF;EACA,qBAAqB;E6BlznCrB;IACE,2BAAA;E7BoznCF;AACF;AACA;;+BAE+B;AAC/B,aAAa;A6B/ynCb;;;;EAIE,eAAA;A7BiznCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A6B3ynChB;EACE,yBAAA;A7B6ynCF;A6B3ynCA;EACE,iBAAA;EACA,kBAAA;A7B6ynCF;A6B3ynCA;EACE,gDAAA;EACA,iDAAA;A7B6ynCF;A6B3ynCA;EACE,iBAAA;EACA,kBAAA;A7B6ynCF;A6B3ynCA;;EAEE,+CAAA;EACA,gDAAA;A7B6ynCF;AACA;;gBAEgB;A6BzynChB;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qCAAA;A7B2ynCF;A6BxynCA;EACE,oBAAA;EACA,uBAAA;EACA,qCAAA;EACA,aAAA;EACA,mCAAA;A7B0ynCF;AACA,kBAAkB;A6BvynClB;EACE,oCAAA;A7ByynCF;A6BvynCA;EACE,mCAAA;A7ByynCF;AACA,8BAA8B;A6BtynC9B;;EAEE,+BAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;A7BwynCF;AACA,mBAAmB;A6BpynCnB;EACE,gDAAA;A7BsynCF;A6BpynCA;EACE,gDAAA;A7BsynCF;A6BpynCA;EACE,gDAAA;A7BsynCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A6BhynChB;;EAEE,qCAAA;A7BkynCF;A6BhynCA;;EAEE,8BAAA;EACA,yBAAA;A7BkynCF;AACA;;gBAEgB;A6B9xnChB;;EAEE,qCAAA;A7BgynCF;A6B9xnCA;;;EAGE,4CAAA;EACA,yBAAA;A7BgynCF;AACA;;gBAEgB;A6B5xnChB;;EAEE,qCAAA;A7B8xnCF;A6B5xnCA;;EAEE,4CAAA;EACA,yBAAA;A7B8xnCF;AACA;;gBAEgB;A6B3xnChB;;EAEE,qCAAA;A7B6xnCF;A6B3xnCA;;EAEE,8BAAA;EACA,yBAAA;A7B6xnCF;AACA;;gBAEgB;A6BzxnChB;;EAEE,uDAAA;A7B2xnCF;A6BzxnCA;;EAEE,8BAAA;EACA,2CAAA;A7B2xnCF;AACA;;gBAEgB;A6BrxnChB;;;;EAIE,oBAAA;EACA,4BAAA;A7BuxnCF;AACA;;+BAE+B;AAC/B;;gBAEgB;A6BlxnChB;EAEE;;;;;IAME,sBAAA;IACA,yBAAA;E7BkxnCF;E6B/wnCA;IACE,YAAA;E7BixnCF;E6B/wnCA;IACE,cAAA;E7BixnCF;E6B/wnCA;IACE,cAAA;E7BixnCF;E6B/wnCA;IACE,gBAAA;IACA,mBAAA;IACA,gEAAA;E7BixnCF;E6B/wnCA;;IAEE,gBAAA;IACA,uBAAA;IACA,sBAAA;IACA,2BAAA;E7BixnCF;EACA,qBAAqB;E6B9wnCrB;IACE,2BAAA;E7BgxnCF;AACF;AACA;;gBAEgB;A6B5wnChB;;EAEE,gBAAA;A7B8wnCF;A6B5wnCA;;EAEE,kBAAA;A7B8wnCF;A6B5wnCA;;EAEE,iBAAA;A7B8wnCF;AACA;;mBAEmB;A6B1wnCnB;;EAEE,mBAAA;A7B4wnCF;A6B1wnCA;;EAEE,sBAAA;A7B4wnCF;A6B1wnCA;;EAEE,sBAAA;A7B4wnCF;AACA;;gBAEgB;A6BxwnChB;;EAEE,UAAA;EACA,mBAAA;A7B0wnCF;AACA;;gBAEgB;A6BtwnChB;EACE,mBAAA;A7BwwnCF;A6BrwnCA;;EAEE,gBAAA;EACA,uBAAA;A7BuwnCF;AACA;;gBAEgB;A6BlwnChB;;EAEE,0CAAA;EACA,2CAAA;A7BownCF;A6BlwnCA;;EAEE,gDAAA;EACA,yBAAA;A7BownCF;AACA,yBAAyB;A6BjwnCzB;EACE,YAAA;A7BmwnCF;A6BjwnCA;EACE,cAAA;EACA,cAAA;EACA,kCAAA;A7BmwnCF;AACA,iBAAiB;A6BhwnCjB;;;EAGE,4CAAA;EACA,yBAAA;A7BkwnCF;A6BhwnCA;;;EAGE,8BAAA;EACA,yBAAA;A7BkwnCF;A6BhwnCA;;;EAGE,8BAAA;EACA,2CAAA;A7BkwnCF;A6BhwnCA;;;EAGE,8BAAA;EACA,yBAAA;A7BkwnCF;A6BhwnCA;;;EAGE,4CAAA;EACA,yBAAA;A7BkwnCF;AACA;;qBAEqB;AACrB,WAAW;A6B5vnCX;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,yBAAA;A7B8vnCF;A6B5vnCA;EACE,gBAAA;A7B8vnCF;AACA,QAAQ;A6B3vnCR;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,kDAAA;A7B6vnCF;A6B3vnCA;EACE,eAAA;A7B6vnCF;AACA,WAAW;A6B1vnCX;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,sBAAA;EACA,kDAAA;A7B4vnCF;A6B1vnCA;EACE,kBAAA;A7B4vnCF;AACA;;gBAEgB;AAChB,mBAAmB;A6BxvnCnB;;EAEE,sCAAA;A7B0vnCF;AACA,YAAY;A6BvvnCZ;;EAEE,2CAAA;A7ByvnCF;AACA,+BAA+B;A6BtvnC/B;EACE,8BAAA;EACA,2CAAA;A7BwvnCF;AACA;;gBAEgB;A6BpvnChB;;EAEE,mBAAA;A7BsvnCF;A6BpvnCA;;EAEE,mBAAA;A7BsvnCF;AACA;;qBAEqB;AACrB,QAAQ;A6BlvnCR;EACE,+BAAA;A7BovnCF;A6BlvnCA;EACE,oCAAA;EACA,yBAAA;A7BovnCF;AACA,WAAW;A6BjvnCX;EACE,+BAAA;A7BmvnCF;A6BjvnCA;EACE,oCAAA;EACA,yBAAA;A7BmvnCF;AACA,WAAW;A6BhvnCX;EACE,+BAAA;A7BkvnCF;A6BhvnCA;EACE,oCAAA;EACA,yBAAA;A7BkvnCF;AACA,UAAU;A6B/unCV;EACE,+BAAA;A7BivnCF;A6B/unCA;EACE,oCAAA;EACA,yBAAA;A7BivnCF;AACA,UAAU;A6B9unCV;EACE,+BAAA;A7BgvnCF;A6B9unCA;EACE,oCAAA;EACA,yBAAA;A7BgvnCF;AACA,SAAS;A6B7unCT;EACE,+BAAA;A7B+unCF;A6B7unCA;EACE,oCAAA;EACA,yBAAA;A7B+unCF;AACA,SAAS;A6B5unCT;EACE,+BAAA;A7B8unCF;A6B5unCA;EACE,oCAAA;EACA,yBAAA;A7B8unCF;AACA,WAAW;A6B3unCX;EACE,+BAAA;A7B6unCF;A6B3unCA;EACE,oCAAA;EACA,yBAAA;A7B6unCF;AACA,WAAW;A6B1unCX;EACE,+BAAA;A7B4unCF;A6B1unCA;EACE,oCAAA;EACA,yBAAA;A7B4unCF;AACA,SAAS;A6BzunCT;EACE,+BAAA;A7B2unCF;A6BzunCA;EACE,oCAAA;EACA,yBAAA;A7B2unCF;AACA,UAAU;A6BxunCV;EACE,+BAAA;A7B0unCF;A6BxunCA;EACE,oCAAA;EACA,yBAAA;A7B0unCF;AACA,SAAS;A6BvunCT;EACE,+BAAA;A7ByunCF;A6BvunCA;EACE,oCAAA;EACA,yBAAA;A7ByunCF;AACA,UAAU;A6BtunCV;EACE,+BAAA;A7BwunCF;A6BtunCA;EACE,oCAAA;EACA,yBAAA;A7BwunCF;AACA;;gBAEgB;AAChB,eAAe;A6BnunCf;EACE,WAAA;A7BqunCF;A6BnunCA;EACE,UAAA;A7BqunCF;A6BnunCA;EACE,mBAAA;A7BqunCF;A6BnunCA;EACE,UAAA;A7BqunCF;A6BnunCA;EACE,UAAA;A7BqunCF;A6BnunCA;EACE,mBAAA;A7BqunCF;A6BnunCA;EACE,mBAAA;A7BqunCF;A6BnunCA;EACE,YAAA;A7BqunCF;A6BnunCA;EACE,mBAAA;A7BqunCF;A6BnunCA;EACE,UAAA;A7BqunCF;A6BnunCA;EACE,kBAAA;A7BqunCF;A6BnunCA;EACE,kBAAA;A7BqunCF;A6BnunCA;EACE,kBAAA;A7BqunCF;A6BnunCA;EACE,kBAAA;A7BqunCF;A6BnunCA;EACE,kBAAA;A7BqunCF;A6BnunCA;EACE,YAAA;A7BqunCF;AACA,iBAAiB;A6BlunCjB;;EAEE,YAAA;A7BounCF;A6BlunCA;;EAEE,YAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,UAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,YAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,UAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,YAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,UAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,YAAA;A7BounCF;A6BlunCA;;EAEE,aAAA;A7BounCF;A6BlunCA;;EAEE,WAAA;A7BounCF;AACA;;gBAEgB;A6BhunChB;EACE,eAAA;EACA,mBAAA;EACA,gDAAA;EACA,gCAAA;A7BkunCF;A6BhunCA;EACE,iBAAA;A7BkunCF;A6BhunCA;;EAEE,iBAAA;A7BkunCF;A6B/tnCA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;A7BiunCF;A6B/tnCA;EACE,gBAAA;A7BiunCF;A6B/tnCA;EACE,gBAAA;A7BiunCF;AACA,UAAU;A6B9tnCV;EACE,YAAA;EACA,4BAAA;A7BgunCF;A6B9tnCA;EACE,+BAAA;EACA,+BAAA;A7BgunCF;AACA,WAAW;A6B7tnCX;EACE,+BAAA;EACA,gCAAA;A7B+tnCF;A6B7tnCA;EACE,qBAAA;A7B+tnCF;AACA,iBAAiB;A6B5tnCjB;EACE,+BAAA;EACA,gCAAA;A7B8tnCF;AACA,aAAa;A6B3tnCb;EACE,uFAAA;EACA,cAAA;A7B6tnCF;A6B3tnCA;EACE,uFAAA;EACA,cAAA;A7B6tnCF;A6B3tnCA;EACE,8BAAA;EACA,+BAAA;A7B6tnCF;AACA;;gBAEgB;AAChB,eAAe;A6BxtnCf;EACE,mBAAA;EACA,+BAAA;EACA,YAAA;A7B0tnCF;A6BxtnCA;EACE,qCAAA;EACA,iDAAA;EACA,0CAAA;A7B0tnCF;A6BxtnCA;EACE,iDAAA;A7B0tnCF;A6BvtnCA;;;;EAIE,oBAAA;EACA,+BAAA;A7BytnCF;AACA,eAAe;A6BttnCf;;EAEE,mBAAA;A7BwtnCF;A6BttnCA;EACE,qCAAA;EACA,cAAA;A7BwtnCF;AACA;;gBAEgB;A6BptnChB;EACE,WAAA;A7BstnCF;AACA;;gBAEgB;A6BltnChB;EACE,uBAAA;EACA,2CAAA;EACA,gBAAA;A7BotnCF;A6BltnCA;;EAEE,gBAAA;A7BotnCF;A6BltnCA;EACE,mBAAA;EACA,iBAAA;A7BotnCF;A6BltnCA;EACE,2CAAA;A7BotnCF;A6BltnCA;EACE,uBAAA;A7BotnCF;A6BltnCA;EACE,gDAAA;A7BotnCF;AACA,eAAe;A6BjtnCf;EACE,YAAA;A7BmtnCF;A6BjtnCA;;EAEE,WAAA;A7BmtnCF;A6BjtnCA;;EAEE,iBAAA;A7BmtnCF;A6BjtnCA;;EAEE,kBAAA;A7BmtnCF;A6BjtnCA;EACE,gBAAA;A7BmtnCF;AACA;;gBAEgB;A6B/snChB;;EAEE,+CAAA;A7BitnCF;A6B/snCA;;EAEE,iBAAA;A7BitnCF;AACA;;gBAEgB;A6B7snChB;EACE,iBAAA;EACA,kBAAA;A7B+snCF;A6B7snCA;;EAEE,gBAAA;A7B+snCF;AACA,SAAS;A6B5snCT;EACE,mBAAA;EACA,oBAAA;A7B8snCF;A6B5snCA;EACE,oBAAA;A7B8snCF;AACA;;gBAEgB;A6B1snChB;EACE,mBAAA;EACA,oBAAA;A7B4snCF;A6B1snCA;EACE,oBAAA;A7B4snCF;AACA,SAAS;A6BzsnCT;EACE,mBAAA;EACA,oBAAA;A7B2snCF;A6BzsnCA;EACE,oBAAA;A7B2snCF;AACA;;gBAEgB;AAChB,UAAU;A6BvsnCV;EACE,gBAAA;A7BysnCF;AACA,aAAa;A6BtsnCb;EACE,cAAA;A7BwsnCF;AACA,UAAU;A6BrsnCV;EACE,gBAAA;A7BusnCF;AACA,UAAU;AACV;;;;;;;;;EASE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB;;+BAE+B;AAC/B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A8B14qC/B;EACE,cAAA;EACA,gBAAA;EACA,eAAA;A9B44qCF;A8Bz4qCA;EACE,WAAA;A9B24qCF;A8Bx4qCA;EACE,WAAA;A9B04qCF;A8Bv4qCA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;A9By4qCF;AACA;;gBAEgB;AAChB,gBAAgB;A8Br4qChB;EACE,YAAA;EACA,YAAA;A9Bu4qCF;AACA,qBAAqB;A8Bp4qCrB;EACE,YAAA;EACA,aAAA;A9Bs4qCF;AACA,oBAAoB;A8Bn4qCpB;EACE,YAAA;EACA,aAAA;A9Bq4qCF;AACA,cAAc;A8Bn4qCd;EACE,YAAA;EACA,aAAA;A9Bq4qCF;AACA;;gBAEgB;AAChB,WAAW;A8Bj4qCX;EACE,YAAA;EACA,aAAA;A9Bm4qCF;AACA,iBAAiB;A8Bh4qCjB;EACE,YAAA;EACA,aAAA;A9Bk4qCF;AACA;;gBAEgB;AAChB,oBAAoB;A8B93qCpB;EACE,YAAA;EACA,aAAA;A9Bg4qCF;AACA,uBAAuB;A8B73qCvB;EACE,YAAA;EACA,aAAA;A9B+3qCF;AACA;;gBAEgB;A8B33qChB;EACE,YAAA;EACA,YAAA;A9B63qCF;A8B33qCA;EACE,YAAA;EACA,aAAA;A9B63qCF;A8B33qCA;EACE,YAAA;EACA,YAAA;A9B63qCF;AACA;;gBAEgB;AAChB,eAAe;A8Bz3qCf;EACE,YAAA;EACA,aAAA;A9B23qCF;AACA,oBAAoB;A8Bx3qCpB;EACE,YAAA;A9B03qCF;AACA;;gBAEgB;AAChB,WAAW;A8Bt3qCX;EACE,YAAA;EACA,YAAA;A9Bw3qCF;AACA,oBAAoB;A8Br3qCpB;EACE,YAAA;EACA,aAAA;A9Bu3qCF;AACA,eAAe;A8Bp3qCf;EACE,YAAA;EACA,aAAA;A9Bs3qCF;AACA,gBAAgB;A8Bn3qChB;EACE,YAAA;EACA,YAAA;A9Bq3qCF;AACA;;gBAEgB;AAChB,gBAAgB;A8Bj3qChB;EACE,YAAA;EACA,YAAA;A9Bm3qCF;AACA,cAAc;A8Bh3qCd;EACE,YAAA;EACA,aAAA;A9Bk3qCF;AACA;;gBAEgB;AAChB,aAAa;A8B92qCb;EACE,YAAA;EACA,aAAA;A9Bg3qCF;AACA;;gBAEgB;AAChB,aAAa;A8B52qCb;EACE,YAAA;EACA,aAAA;A9B82qCF;AACA;;gBAEgB;AAChB,wBAAwB;A8Bx2qCxB;EACE,YAAA;EACA,aAAA;A9B02qCF;AACA,uBAAuB;A8Bv2qCvB;EACE,YAAA;EACA,YAAA;A9By2qCF;AACA;;+BAE+B;AAC/B,iBAAiB;A8Br2qCjB;EACE,aAAA;A9Bu2qCF;A8Bp2qCA;EACE;IACE,cAAA;E9Bs2qCF;AACF;AACA;;+BAE+B;A8Bj2qC/B;EACE,iBAAA;EACA,kBAAA;A9Bm2qCF;A8Bh2qCA;EACE,kBAAA;EACA,mBAAA;A9Bk2qCF;A8Bh2qCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;EAEA,aAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;A9Bi2qCF;A8B/1qCA;EACE,uBAAA;A9Bi2qCF;A8B/1qCA;EACE,wBAAA;A9Bi2qCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,SAAS;AACT,eAAe;AACf,sBAAsB;AACtB;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,WAAW;AACX,aAAa;AACb,UAAU;AACV,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB;AACjB,cAAc;AACd,WAAW;AACX,uBAAuB;AACvB,gBAAgB;AAChB,YAAY;AACZ;;qBAEqB;AACrB,SAAS;AACT,WAAW;AACX,eAAe;AACf,cAAc;AACd,UAAU;AACV,YAAY;AACZ,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,SAAS;AACT,eAAe;AACf,sBAAsB;AACtB;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,WAAW;AACX,aAAa;AACb,UAAU;AACV,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB;AACjB,cAAc;AACd,WAAW;AACX,uBAAuB;AACvB,gBAAgB;AAChB,YAAY;AACZ;;qBAEqB;AACrB,SAAS;AACT,WAAW;AACX,eAAe;AACf,cAAc;AACd,UAAU;AACV,YAAY;AACZ,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;gBAEgB;A+BnxsChB;;EAEE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EAEA,YAAA;EACA,4BAAA;EACA,4DAAA;EACA,qDAAA;EACA,WAAA;A/BmxsCF;A+BjxsCA;EACE,eAAA;A/BmxsCF;A+BhxsCA;;EAEE,eAAA;A/BkxsCF;A+B/wsCA;EACE,eAAA;A/BixsCF;A+B/wsCA;EACE,kBAAA;A/BixsCF;AACA;;gBAEgB;A+B7wsChB;EACE,aAAA;EACA,uBAAA;EACA,eAAA;A/B+wsCF;A+B5wsCA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;A/B8wsCF;AACA,aAAa;A+B3wsCb;;EAEE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;A/B6wsCF;AACA,iDAAiD;A+BzwsCjD;EACE,mBAAA;A/B2wsCF;AACA;;gBAEgB;A+BtwsChB;;EAEE,6DAAA;EACA,2BAAA;A/BwwsCF;A+BrwsCA;;EAEE,6DAAA;A/BuwsCF;A+BpwsCA;;EAEE,uCAAA;A/BswsCF;AACA;;gBAEgB;A+BlwsChB;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,+BAAA;A/BowsCF;A+BlwsCA;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;A/BowsCF;A+BlwsCA;;EAEE,YAAA;A/BowsCF;AACA;;gBAEgB;A+BhwsChB;;EAEE,YAAA;EACA,YAAA;EACA,8CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;A/BkwsCF;A+B/vsCA;;EAEE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;A/BiwsCF;A+B9vsCA;;EAEE,cAAA;EACA,UAAA;EACA,mEAAA;EACA,gCAAA;A/BgwsCF;AACA,wBAAwB;A+B7vsCxB;;EAEE,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;A/B+vsCF;A+B5vsCA;;;;EAIE,iBAAA;A/B8vsCF;AACA;;kBAEkB;A+B1vsClB;;EAEE,WAAA;A/B4vsCF;A+B1vsCA;;EAEE,YAAA;A/B4vsCF;AACA;;gBAEgB;A+BxvsChB;;EAEE,gBAAA;A/B0vsCF;A+BxvsCA;;EAEE,kBAAA;A/B0vsCF;A+BxvsCA;;EAEE,iBAAA;A/B0vsCF;AACA;;gBAEgB;A+BrvsChB;;EAEE,qBAAA;EACA,sBAAA;EACA,SAAA;A/BuvsCF;A+BrvsCA;;;;EAIE,UAAA;EACA,WAAA;EACA,qBAAA;A/BuvsCF;AACA;;gBAEgB;A+BlvsChB;;EAEE,WAAA;EACA,cAAA;A/BovsCF;AACA;;gBAEgB;A+BhvsChB;;EAEE,qBAAA;A/BkvsCF;A+BhvsCA;;EAEE,kBAAA;A/BkvsCF;AACA;;gBAEgB;A+B9usChB;;EAEE,cAAA;EACA,+BAAA;A/BgvsCF;A+B9usCA;;EAEE,mBAAA;A/BgvsCF;A+B9usCA;;EAEE,iBAAA;A/BgvsCF;A+B7usCA;;EAEE,iBAAA;EACA,kBAAA;A/B+usCF;AACA;;gBAEgB;AAChB,YAAY;A+B3usCZ;;EAEE,SAAA;EACA,2BAAA;A/B6usCF;A+B3usCA;;EAEE,SAAA;A/B6usCF;AACA,WAAW;A+B1usCX;;EAEE,gCAAA;A/B4usCF;A+B1usCA;;EAEE,cAAA;A/B4usCF;AACA,SAAS;A+BzusCT;;EAEE,+BAAA;A/B2usCF;A+BzusCA;;EAEE,gCAAA;A/B2usCF;AACA;;gBAEgB;A+BvusChB;;;;EAIE,eAAA;EACA,yBAAA;A/ByusCF;AACA;;gBAEgB;A+BrusChB;;EAEE,oBAAA;EACA,WAAA;A/BuusCF;AACA;;gBAEgB;AAChB,kBAAkB;AAClB,SAAS;A+BlusCT;;EAEE,eAAA;EACA,aAAA;EACA,2BAAA;A/BousCF;A+BlusCA;;EAEE,UAAA;EACA,cAAA;A/BousCF;A+BlusCA;;EAEE,cAAA;A/BousCF;AACA,kBAAkB;AAClB,SAAS;A+BhusCT;;EAEE,eAAA;EACA,aAAA;EACA,2BAAA;A/BkusCF;A+BhusCA;;EAEE,UAAA;EACA,cAAA;A/BkusCF;A+BhusCA;;EAEE,cAAA;A/BkusCF;AACA;;kBAEkB;A+B9tsClB;;EAEE,eAAA;EACA,0BAAA;EACA,YAAA;EACA,oDAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,gBAAA;EACA,2BAAA;A/BgusCF;A+B9tsCA;;EAEE,+BAAA;A/BgusCF;A+B9tsCA;;EAEE,cAAA;A/BgusCF;AACA;;+BAE+B;AAC/B;;qBAEqB;A+B1tsCrB;;EAEE,oHAAA;A/B4tsCF;A+B1tsCA;;;;EAIE,oHAAA;A/B4tsCF;A+BztsCA;;EAEE,oHAAA;A/B2tsCF;AACA;;qBAEqB;A+BxtsCrB;EACE,uBAAA;A/B0tsCF;A+BxtsCA;EACE,iBAAA;EACA,kBAAA;A/B0tsCF;AACA;;qBAEqB;A+BttsCrB;EACE,WAAA;EACA,iBAAA;A/BwtsCF;AACA;;qBAEqB;A+BptsCrB;;;;EAIE,eAAA;A/BstsCF;A+BltsCA;;;;EAIE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,4DAAA;EACA,2BAAA;A/BotsCF;AACA;;qBAEqB;AACrB,QAAQ;A+BhtsCR;;;EAGE,qFAAA;A/BktsCF;A+B5ssCA;;;EAGE,qFAAA;A/B8ssCF;AACA,WAAW;A+BvssCX;;;EAGE,qFAAA;A/ByssCF;A+BnssCA;;;EAGE,qFAAA;A/BqssCF;AACA,WAAW;A+B9rsCX;;;EAGE,qFAAA;A/BgssCF;A+B1rsCA;;;EAGE,qFAAA;A/B4rsCF;AACA,UAAU;A+BrrsCV;;;EAGE,qFAAA;A/BursCF;A+BjrsCA;;;EAGE,qFAAA;A/BmrsCF;AACA,UAAU;A+B5qsCV;;;EAGE,qFAAA;A/B8qsCF;A+BxqsCA;;;EAGE,qFAAA;A/B0qsCF;AACA,SAAS;A+BnqsCT;;;EAGE,qFAAA;A/BqqsCF;A+B/psCA;;;EAGE,qFAAA;A/BiqsCF;AACA,SAAS;A+B1psCT;;;EAGE,qFAAA;A/B4psCF;A+BtpsCA;;;EAGE,qFAAA;A/BwpsCF;AACA,WAAW;A+BjpsCX;;;EAGE,qFAAA;A/BmpsCF;A+B7osCA;;;EAGE,qFAAA;A/B+osCF;AACA,WAAW;A+BxosCX;;;EAGE,qFAAA;A/B0osCF;A+BposCA;;;EAGE,qFAAA;A/BsosCF;AACA,SAAS;A+B/nsCT;;;EAGE,qFAAA;A/BiosCF;A+B3nsCA;;;EAGE,qFAAA;A/B6nsCF;AACA,UAAU;A+BtnsCV;;;EAGE,qFAAA;A/BwnsCF;A+BlnsCA;;;EAGE,qFAAA;A/BonsCF;AACA,SAAS;A+B7msCT;;;EAGE,qFAAA;A/B+msCF;A+BzmsCA;;;EAGE,qFAAA;A/B2msCF;AACA,UAAU;A+BpmsCV;;;EAGE,qFAAA;A/BsmsCF;A+BhmsCA;;;EAGE,qFAAA;A/BkmsCF;AACA;;gBAEgB;A+B1lsChB;EACE,gBAAA;EACA,iBAAA;A/B4lsCF;A+B1lsCA;EACE,WAAA;A/B4lsCF;A+BzlsCA;EACE,iBAAA;EACA,kBAAA;A/B2lsCF;A+BzlsCA;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;A/B2lsCF;A+BxlsCA;EACE,iBAAA;EACA,kBAAA;A/B0lsCF;A+BxlsCA;EACE,mCAAA;EACA,gBAAA;EACA,iBAAA;A/B0lsCF;A+BvlsCA;EACE,oBAAA;EACA,qBAAA;A/BylsCF;A+BvlsCA;EACE,4BAAA;EACA,mBAAA;EACA,oBAAA;A/BylsCF;A+BtlsCA;EACE,oBAAA;EACA,qBAAA;A/BwlsCF;A+BtlsCA;EACE,4BAAA;EACA,mBAAA;EACA,oBAAA;A/BwlsCF;A+BrlsCA;EACE,oBAAA;EACA,qBAAA;A/BulsCF;A+BrlsCA;EACE,qCAAA;EACA,mBAAA;EACA,oBAAA;A/BulsCF;A+BplsCA;EACE,mBAAA;EACA,oBAAA;A/BslsCF;A+BplsCA;EACE,mCAAA;EACA,kBAAA;EACA,mBAAA;A/BslsCF;A+BnlsCA;EACE,mBAAA;EACA,oBAAA;A/BqlsCF;A+BnlsCA;EACE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;A/BqlsCF;A+BllsCA;EACE,mBAAA;EACA,oBAAA;A/BolsCF;A+BllsCA;EACE,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;A/BolsCF;A+BjlsCA;EACE,mBAAA;EACA,oBAAA;A/BmlsCF;A+BjlsCA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;A/BmlsCF;AACA;;qBAEqB;AACrB,gBAAgB;A+B9ksChB;EACE;IACE,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;E+B9ksCA;IACE,iBAAA;IACA,kBAAA;E/BglsCF;E+B9ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/BglsCF;AACF;AACA,gBAAgB;A+B7ksChB;EACE;IACE,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,iBAAA;IACA,kBAAA;E/B+ksCF;E+B7ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,iBAAA;IACA,kBAAA;E/B+ksCF;E+B7ksCA;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,iBAAA;IACA,kBAAA;E/B+ksCF;E+B7ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,iBAAA;IACA,kBAAA;E/B+ksCF;E+B7ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,iBAAA;IACA,kBAAA;E/B+ksCF;E+B7ksCA;IACE,mCAAA;IACA,gBAAA;IACA,iBAAA;E/B+ksCF;E+B7ksCA;IACE,oBAAA;IACA,qBAAA;E/B+ksCF;E+B7ksCA;IACE,4BAAA;IACA,mBAAA;IACA,oBAAA;E/B+ksCF;E+B7ksCA;IACE,oBAAA;IACA,qBAAA;E/B+ksCF;E+B7ksCA;IACE,4BAAA;IACA,mBAAA;IACA,oBAAA;E/B+ksCF;E+B7ksCA;IACE,oBAAA;IACA,qBAAA;E/B+ksCF;E+B7ksCA;IACE,4BAAA;IACA,mBAAA;IACA,oBAAA;E/B+ksCF;AACF;AACA;;qBAEqB;A+B3ksCrB;EACE;IACE,yBAAA;E/B6ksCF;E+B3ksCA;IACE,0BAAA;E/B6ksCF;E+B3ksCA;IACE,yBAAA;IACA,uBAAA;IACA,eAAA;IACA,qBAAA;IACA,sCAAA;E/B6ksCF;AACF;AACA;;gBAEgB;A+BxksChB;EACE,cAAA;A/B0ksCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,aAAa;AACb,SAAS;AACT,YAAY;AACZ,UAAU;AACV;;qBAEqB;AACrB,aAAa;AACb,YAAY;AACZ,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,aAAa;AACb,SAAS;AACT,YAAY;AACZ,UAAU;AACV;;qBAEqB;AACrB,aAAa;AACb,YAAY;AACZ,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;gBAEgB;AgCvvvChB;EACE,iBAAA;EACA,gBAAA;AhCyvvCF;AgCtvvCA;EACE,eAAA;AhCwvvCF;AgCtvvCA;EACE,kBAAA;AhCwvvCF;AACA;;gBAEgB;AgCpvvChB;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AhCsvvCF;AgCpvvCA;EACE,eAAA;EACA,gBAAA;AhCsvvCF;AACA;;sBAEsB;AgCjvvCtB;EACE,2BAAA;EACA,wBAAA;AhCmvvCF;AgCjvvCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AhCmvvCF;AgCjvvCA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AhCmvvCF;AACA;;gBAEgB;AgC/uvChB;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AhCivvCF;AgC/uvCA;;EAEE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AhCivvCF;AACA;;gBAEgB;AgC7uvChB;EACE,cAAA;AhC+uvCF;AACA,4CAA4C;AgC7uvC5C;EACE,kBAAA;AhC+uvCF;AACA;;gBAEgB;AgC3uvChB;EACE,cAAA;EACA,gCAAA;EACA,iBAAA;AhC6uvCF;AgC3uvCA;EACE,eAAA;AhC6uvCF;AgC3uvCA;EACE,cAAA;AhC6uvCF;AACA;;gBAEgB;AgCzuvChB;EACE,qBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AhC2uvCF;AgCzuvCA;EACE,qBAAA;EACA,yBAAA;AhC2uvCF;AgCzuvCA;EACE,iBAAA;AhC2uvCF;AACA;;sBAEsB;AgCvuvCtB;EACE,wBAAA;EACA,cAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;AhCyuvCF;AACA;;sBAEsB;AgCpuvCtB;EACE,kBAAA;AhCsuvCF;AgCpuvCA;EACE,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,+BAAA;AhCsuvCF;AgCpuvCA;EACE,iBAAA;AhCsuvCF;AgCpuvCA;;EAEE,+BAAA;AhCsuvCF;AACA;;sBAEsB;AgCluvCtB;EACE,eAAA;AhCouvCF;AgCluvCA;EACE,WAAA;EACA,eAAA;AhCouvCF;AgCluvCA;EACE,cAAA;EACA,YAAA;AhCouvCF;AACA;;+BAE+B;AgChuvC/B;;;EAGE,aAAA;AhCkuvCF;AACA;;+BAE+B;AAC/B;;sBAEsB;AgC5tvCtB;EACE,4BAAA;EACA,2BAAA;EACA,kDAAA;AhC8tvCF;AACA;;sBAEsB;AgC1tvCtB;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;EACA,sBAAA;AhC4tvCF;AgC1tvCA;EACE,UAAA;AhC4tvCF;AACA;;qBAEqB;AgCvtvCrB;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,eAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AgCvtvCA;EACE,wBAAA;AhCytvCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,eAAe;AACf,gBAAgB;AAChB,qBAAqB;AACrB,YAAY;AACZ,SAAS;AACT,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,SAAS;AACT,uBAAuB;AACvB,iBAAiB;AACjB,eAAe;AACf,mBAAmB;AACnB,SAAS;AACT,qBAAqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,eAAe;AACf,gBAAgB;AAChB,qBAAqB;AACrB,YAAY;AACZ,SAAS;AACT,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,SAAS;AACT,uBAAuB;AACvB,iBAAiB;AACjB,eAAe;AACf,mBAAmB;AACnB,SAAS;AACT,qBAAqB;AACrB;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AiC9nxC/B;EACE,eAAA;AjCgoxCF;AiC9nxCA;EACE,eAAA;AjCgoxCF;AiC9nxCA;EACE,kBAAA;AjCgoxCF;AACA;;+BAE+B;AAC/B,UAAU;AiC3nxCV;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AjC6nxCF;AiC3nxCA;EACE,eAAA;EACA,gBAAA;AjC6nxCF;AiC3nxCA;EACE,mBAAA;AjC6nxCF;AACA,gBAAgB;AiC1nxChB;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AjC4nxCF;AiC1nxCA;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AjC4nxCF;AiC1nxCA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AjC4nxCF;AiC1nxCA;EACE,2CAAA;AjC4nxCF;AACA;;gBAEgB;AAChB,YAAY;AiCxnxCZ;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AjC0nxCF;AiCxnxCA;EACE,mBAAA;AjC0nxCF;AACA,SAAS;AiCvnxCT;EACE,eAAA;AjCynxCF;AACA;;gBAEgB;AiCrnxChB;EACE,uBAAA;EACA,YAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;AjCsnxCF;AACA;;gBAEgB;AiClnxChB;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gCAAA;AjConxCF;AACA,kBAAkB;AiCjnxClB;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;AjCmnxCF;AACA;;gBAEgB;AiChnxChB;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;AjCknxCF;AiChnxCA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AjCknxCF;AACA;;gBAEgB;AAChB,wBAAwB;AiC/mxCxB;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,+BAAA;AjCinxCF;AACA;;gBAEgB;AiC7mxChB;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;AjC+mxCF;AACA,WAAW;AiC5mxCX;EACE,qBAAA;EACA,0BAAA;EACA,UAAA;AjC8mxCF;AACA,SAAS;AiC3mxCT;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AjC6mxCF;AACA;;gBAEgB;AiCzmxChB;EACE,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AjC2mxCF;AiCxmxCA;EACE,kBAAA;EACA,mBAAA;AjC0mxCF;AiCxmxCA;EACE,WAAA;EACA,yBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AjC0mxCF;AiCvmxCA;EACE,SAAA;EACA,2BAAA;AjCymxCF;AiCvmxCA;EACE,cAAA;AjCymxCF;AiCvmxCA;EACE,cAAA;AjCymxCF;AACA,kBAAkB;AiCtmxClB;EACE,gBAAA;AjCwmxCF;AiCtmxCA;EACE,aAAA;AjCwmxCF;AACA,WAAW;AiCrmxCX;;EAEE,eAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AjCumxCF;AiCrmxCA;;;EAGE,gCAAA;AjCumxCF;AACA;;+BAE+B;AiCjmxC/B;EACE,wBAAA;AjCmmxCF;AiCjmxCA;EACE,eAAA;AjCmmxCF;AiCjmxCA;EACE,wBAAA;AjCmmxCF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,UAAU;AACV,SAAS;AACT,eAAe;AACf;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,WAAW;AACX,aAAa;AACb,UAAU;AACV,YAAY;AACZ,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB;AACjB,cAAc;AACd,uBAAuB;AACvB;;qBAEqB;AACrB,YAAY;AACZ,YAAY;AACZ,gBAAgB;AAChB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,UAAU;AACV,SAAS;AACT,eAAe;AACf;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,WAAW;AACX,aAAa;AACb,UAAU;AACV,YAAY;AACZ,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB;AACjB,cAAc;AACd,uBAAuB;AACvB;;qBAEqB;AACrB,YAAY;AACZ,YAAY;AACZ,gBAAgB;AAChB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;gBAEgB;AkCnhzChB;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EAEA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,WAAA;AlCohzCF;AkClhzCA;EACE,eAAA;AlCohzCF;AACA;;gBAEgB;AkChhzChB;EACE,iBAAA;AlCkhzCF;AkC/gzCA;EACE,0BAAA;AlCihzCF;AkC/gzCA;EACE,6BAAA;AlCihzCF;AACA;;gBAEgB;AkC7gzChB;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlC+gzCF;AkC7gzCA;EACE,eAAA;AlC+gzCF;AkC7gzCA;EACE,kBAAA;AlC+gzCF;AACA;;gBAEgB;AkCzgzChB;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AlC2gzCF;AkCzgzCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AlC2gzCF;AkCxgzCA;EACE,mBAAA;AlC0gzCF;AACA;;gBAEgB;AkCrgzChB;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AlCugzCF;AkCrgzCA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlCugzCF;AkCpgzCA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AlCsgzCF;AkCngzCA;EACE,qBAAA;EACA,0BAAA;EACA,mEAAA;EACA,iBAAA;EACA,gCAAA;AlCqgzCF;AACA,wBAAwB;AkCngzCxB;EACE,uBAAA;AlCqgzCF;AACA;;gBAEgB;AkCjgzChB;EACE,WAAA;AlCmgzCF;AkCjgzCA;EACE,YAAA;AlCmgzCF;AACA;;gBAEgB;AkC9/yChB;EACE,kBAAA;EACA,SAAA;AlCggzCF;AkC9/yCA;;EAEE,SAAA;EACA,UAAA;EACA,qBAAA;AlCggzCF;AACA;;gBAEgB;AkC3/yChB;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gCAAA;AlC6/yCF;AACA;;gBAEgB;AkCz/yChB;EACE,qBAAA;AlC2/yCF;AkCz/yCA;EACE,kBAAA;AlC2/yCF;AACA;;gBAEgB;AkCv/yChB;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AlCy/yCF;AkCv/yCA;EACE,mBAAA;AlCy/yCF;AkCv/yCA;EACE,iBAAA;AlCy/yCF;AkCt/yCA;EACE,iBAAA;EACA,kBAAA;AlCw/yCF;AACA;;gBAEgB;AAChB,YAAY;AkCp/yCZ;EACE,SAAA;EACA,2BAAA;AlCs/yCF;AkCp/yCA;EACE,SAAA;AlCs/yCF;AACA,WAAW;AkCn/yCX;EACE,gCAAA;AlCq/yCF;AkCn/yCA;EACE,cAAA;AlCq/yCF;AACA,SAAS;AkCl/yCT;EACE,+BAAA;AlCo/yCF;AkCl/yCA;EACE,gCAAA;AlCo/yCF;AACA;;gBAEgB;AAChB,kBAAkB;AAClB,SAAS;AkC7+yCT;EACE,eAAA;EACA,aAAA;EACA,2BAAA;AlC++yCF;AkC7+yCA;EACE,UAAA;EACA,cAAA;AlC++yCF;AkC7+yCA;EACE,cAAA;AlC++yCF;AACA,kBAAkB;AAClB,SAAS;AkC3+yCT;EACE,eAAA;EACA,aAAA;EACA,2BAAA;AlC6+yCF;AkC3+yCA;EACE,UAAA;EACA,cAAA;AlC6+yCF;AkC3+yCA;EACE,cAAA;AlC6+yCF;AACA;;kBAEkB;AkCz+yClB;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;AlC2+yCF;AkCz+yCA;EACE,kCAAA;AlC2+yCF;AkCz+yCA;EACE,kCAAA;AlC2+yCF;AkCx+yCA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlC0+yCF;AACA;;+BAE+B;AAC/B,wBAAwB;AkCr+yCxB;EACE,YAAA;AlCu+yCF;AACA,gBAAgB;AkCn+yChB;EACE;IACE,eAAA;ElCq+yCF;EkCn+yCA;IACE,YAAA;ElCq+yCF;EkCn+yCA;IACE,cAAA;IACA,wBAAA;ElCq+yCF;AACF;AACA,gBAAgB;AkCj+yChB;EACE;IACE,sBAAA;IACA,eAAA;ElCm+yCF;EkCj+yCA;IACE,cAAA;IACA,iBAAA;IACA,kBAAA;ElCm+yCF;EkCj+yCA;;IAEE,0BAAA;IACA,sBAAA;IACA,4BAAA;ElCm+yCF;EkCj+yCA;IACE,cAAA;IACA,sBAAA;ElCm+yCF;AACF;AACA;;+BAE+B;AAC/B;;qBAEqB;AkC59yCrB;EACE,sBAAA;AlC89yCF;AkC59yCA;EACE,kBAAA;AlC89yCF;AkC59yCA;EACE,oBAAA;AlC89yCF;AACA;;gBAEgB;AkCz9yChB;EACE,iBAAA;AlC29yCF;AkCz9yCA;EACE,eAAA;AlC29yCF;AACA;;qBAEqB;AkCt9yCrB;EACE,+CAAA;EACA,WAAA;EACA,gBAAA;AlCw9yCF;AkCt9yCA;EACE,gBAAA;EACA,0BAAA;EACA,2BAAA;AlCw9yCF;AkCt9yCA;EACE,6BAAA;EACA,8BAAA;AlCw9yCF;AACA,oBAAoB;AkCr9yCpB;EACE,WAAA;EACA,kBAAA;AlCu9yCF;AkCr9yCA;EACE,WAAA;EACA,gBAAA;AlCu9yCF;AACA;;qBAEqB;AkCl9yCrB;;EAEE,eAAA;AlCo9yCF;AkCj9yCA;;EAEE,cAAA;AlCm9yCF;AACA;;gBAEgB;AkC98yChB;EACE,cAAA;AlCg9yCF;AACA;;iBAEiB;AkC58yCjB;EACE;;IAEE,uBAAA;ElC88yCF;AACF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,UAAU;AACV,kBAAkB;AAClB;;qBAEqB;AACrB,UAAU;AACV,UAAU;AACV,SAAS;AACT,gBAAgB;AAChB;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,aAAa;AACb,eAAe;AACf,SAAS;AACT,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,UAAU;AACV,kBAAkB;AAClB;;qBAEqB;AACrB,UAAU;AACV,UAAU;AACV,SAAS;AACT,gBAAgB;AAChB;;qBAEqB;AACrB;;qBAEqB;AACrB,YAAY;AACZ,aAAa;AACb,eAAe;AACf,SAAS;AACT,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,eAAe;AmCzj1Cf;EACE,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AnC2j1CF;AmCxj1CA;EACE,yBAAA;AnC0j1CF;AmCvj1CA;EACE,eAAA;AnCyj1CF;AmCvj1CA;EACE,kBAAA;AnCyj1CF;AACA;;+BAE+B;AAC/B,YAAY;AmCnj1CZ;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AnCqj1CF;AmCnj1CA;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AnCqj1CF;AmCnj1CA;EACE,aAAA;EACA,uBAAA;AnCqj1CF;AACA,aAAa;AmClj1Cb;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AnCoj1CF;AmCjj1CA;EACE,eAAA;AnCmj1CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AmC5i1ChB;;EAEE,mEAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AnC8i1CF;AACA;;gBAEgB;AmC1i1ChB;;EAEE,mEAAA;EACA,cAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;AnC4i1CF;AACA,cAAc;AmCzi1Cd;;EAEE,gBAAA;AnC2i1CF;AACA,iBAAiB;AmCxi1CjB;;EAEE,gBAAA;AnC0i1CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AmCni1ChB;;EAEE,UAAA;EACA,WAAA;EACA,WAAA;AnCqi1CF;AACA;;gBAEgB;AmCji1ChB;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AnCmi1CF;AmCji1CA;;EAEE,kBAAA;AnCmi1CF;AACA;;gBAEgB;AmC/h1ChB;;EAEE,gBAAA;EACA,wBAAA;AnCii1CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AmCxh1ChB;EACE,oBAAA;AnC0h1CF;AmCxh1CA;EACE,cAAA;EACA,mBAAA;AnC0h1CF;AmCvh1CA;EACE,oBAAA;AnCyh1CF;AmCvh1CA;EACE,uBAAA;EACA,mBAAA;AnCyh1CF;AmCth1CA;EACE,oBAAA;AnCwh1CF;AmCth1CA;EACE,gBAAA;EACA,mBAAA;AnCwh1CF;AmCrh1CA;EACE,oBAAA;AnCuh1CF;AmCrh1CA;EACE,uBAAA;EACA,mBAAA;AnCuh1CF;AmCph1CA;EACE,oBAAA;AnCsh1CF;AmCph1CA;EACE,uBAAA;EACA,mBAAA;AnCsh1CF;AmCnh1CA;EACE,oBAAA;AnCqh1CF;AmCnh1CA;EACE,cAAA;EACA,mBAAA;AnCqh1CF;AmClh1CA;EACE,oBAAA;AnCoh1CF;AmClh1CA;EACE,cAAA;EACA,mBAAA;AnCoh1CF;AmCjh1CA;EACE,oBAAA;AnCmh1CF;AmCjh1CA;EACE,uBAAA;EACA,mBAAA;AnCmh1CF;AmChh1CA;EACE,oBAAA;AnCkh1CF;AmChh1CA;EACE,cAAA;EACA,mBAAA;AnCkh1CF;AmC/g1CA;EACE,oBAAA;AnCih1CF;AmC/g1CA;EACE,eAAA;EACA,mBAAA;AnCih1CF;AACA;;gBAEgB;AmC1g1ChB;EACE,mBAAA;EACA,mBAAA;AnC4g1CF;AmC1g1CA;EACE,sBAAA;EACA,WAAA;EACA,eAAA;AnC4g1CF;AmC1g1CA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AnC4g1CF;AmCzg1CA;;EAEE,0BAAA;AnC2g1CF;AmCzg1CA;;EAEE,aAAA;AnC2g1CF;AmCxg1CA;;EAEE,qBAAA;EACA,sBAAA;AnC0g1CF;AmCxg1CA;;EAEE,qBAAA;EACA,sBAAA;EACA,0BAAA;AnC0g1CF;AACA;;gBAEgB;AmCtg1ChB;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AmCtg1CA;;;EAGE,cAAA;AnCwg1CF;AACA;;gBAEgB;AmCpg1ChB;;EAEE,cAAA;AnCsg1CF;AmCpg1CA;;EAEE,+BAAA;AnCsg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AmCng1CA;;;EAGE,cAAA;AnCqg1CF;AACA;;gBAEgB;AmCjg1ChB;EACE,WAAA;EACA,uBAAA;AnCmg1CF;AmCjg1CA;EACE,YAAA;EACA,uBAAA;AnCmg1CF;AmCjg1CA;EACE,kBAAA;AnCmg1CF;AACA;;gBAEgB;AAChB,SAAS;AmC7/0CT;;EAEE,4BAAA;AnC+/0CF;AmC7/0CA;;EAEE,4BAAA;AnC+/0CF;AmC7/0CA;;EAEE,0BAAA;AnC+/0CF;AACA,SAAS;AmC3/0CT;;EAEE,0BAAA;AnC6/0CF;AmC3/0CA;;EAEE,0BAAA;AnC6/0CF;AmC3/0CA;;EAEE,0BAAA;AnC6/0CF;AACA,UAAU;AmC1/0CV;;EAEE,0BAAA;AnC4/0CF;AmC1/0CA;;EAEE,0BAAA;AnC4/0CF;AmC1/0CA;;EAEE,0BAAA;AnC4/0CF;AACA,WAAW;AmCz/0CX;;EAEE,0BAAA;AnC2/0CF;AmCz/0CA;;EAEE,0BAAA;AnC2/0CF;AmCz/0CA;;EAEE,0BAAA;AnC2/0CF;AACA,UAAU;AmCx/0CV;;EAEE,0BAAA;AnC0/0CF;AmCx/0CA;;EAEE,0BAAA;AnC0/0CF;AmCx/0CA;;EAEE,4BAAA;AnC0/0CF;AACA,SAAS;AmCv/0CT;;EAEE,0BAAA;AnCy/0CF;AmCv/0CA;;EAEE,0BAAA;AnCy/0CF;AmCv/0CA;;EAEE,4BAAA;AnCy/0CF;AACA;;+BAE+B;AAC/B,YAAY;AACZ;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,UAAU;AACV,SAAS;AACT,oBAAoB;AACpB,YAAY;AACZ;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,wBAAwB;AACxB,8BAA8B;AAC9B,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B,UAAU;AACV,SAAS;AACT,oBAAoB;AACpB,YAAY;AACZ;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,wBAAwB;AACxB,8BAA8B;AAC9B,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AoChr3C/B;;EAEE,eAAA;ApCkr3CF;AoChr3CA;EACE,mBAAA;EACA,YAAA;ApCkr3CF;AACA,UAAU;AoC/q3CV;;EAEE,eAAA;ApCir3CF;AACA,oBAAoB;AoC9q3CpB;EACE,kBAAA;EACA,mEAAA;EACA,cAAA;EACA,gCAAA;ApCgr3CF;AACA,YAAY;AoC7q3CZ;;EAEE,aAAA;ApC+q3CF;AACA,oBAAoB;AoC5q3CpB;;EAEE,UAAA;EACA,sBAAA;ApC8q3CF;AoC5q3CA;EACE,mBAAA;ApC8q3CF;AACA,UAAU;AoC3q3CV;;EAEE,qBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,cAAA;EACA,kDAAA;EACA,wBAAA;EACA,eAAA;ApC6q3CF;AACA;;gBAEgB;AAChB,SAAS;AoCzq3CT;EACE,cAAA;EACA,YAAA;ApC2q3CF;AoCzq3CA;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;ApC2q3CF;AACA,WAAW;AoCxq3CX;EACE,cAAA;EACA,4BAAA;ApC0q3CF;AACA;;+BAE+B;AoCtq3C/B;;EAEE,wBAAA;ApCwq3CF;AoCrq3CA;EACE,wBAAA;ApCuq3CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoClq3ChB;EACE,YAAA;ApCoq3CF;AoCjq3CA;;EAEE,4BAAA;EACA,mBAAA;EACA,8FAAA;ApCmq3CF;AoCjq3CA;;EAEE,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,+CAAA;EACA,iDAAA;ApCmq3CF;AoCjq3CA;;EAEE,gBAAA;ApCmq3CF;AACA,YAAY;AoC/p3CZ;;EAEE,WAAA;EACA,wBAAA;ApCiq3CF;AoC/p3CA;EACE,YAAA;EACA,wBAAA;ApCiq3CF;AACA,UAAU;AoC7p3CV;;;;EAIE,uBAAA;EACA,gCAAA;ApC+p3CF;AoC7p3CA;;EAEE,uBAAA;EACA,gCAAA;ApC+p3CF;AACA,WAAW;AoC3p3CX;EACE,uBAAA;EACA,gCAAA;ApC6p3CF;AoC3p3CA;EACE,uBAAA;EACA,gCAAA;ApC6p3CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoCvp3ChB;;EAEE,cAAA;ApCyp3CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoCpp3ChB;;EAEE,WAAA;ApCsp3CF;AACA;;gBAEgB;AoClp3ChB;EACE,+BAAA;ApCop3CF;AACA;;+BAE+B;AqC123C/B;EACE,wBAAA;EACA,yHAAA;EAIA,mBAAA;EACA,kBAAA;ArCy23CF;AACA,kBAAkB;AqCt23ClB;;EAEE,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArCw23CF;AqCr23CA;;EAEE,gCAAA;ArCu23CF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,UAAU;AACV,iBAAiB;AACjB,aAAa;AACb,cAAc;AACd,UAAU;AACV;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,UAAU;AACV,WAAW;AACX,iBAAiB;AACjB,kBAAkB;AAClB,aAAa;AACb;;qBAEqB;AACrB,UAAU;AACV,kDAAkD;AAClD,0CAA0C;AAC1C,2BAA2B;AAC3B,WAAW;AACX,kBAAkB;AAClB,WAAW;AACX;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B,UAAU;AACV,iBAAiB;AACjB,aAAa;AACb,cAAc;AACd,UAAU;AACV;;qBAEqB;AACrB,UAAU;AACV,YAAY;AACZ,UAAU;AACV,WAAW;AACX,iBAAiB;AACjB,kBAAkB;AAClB,aAAa;AACb;;qBAEqB;AACrB,UAAU;AACV,kDAAkD;AAClD,0CAA0C;AAC1C,2BAA2B;AAC3B,WAAW;AACX,kBAAkB;AAClB,WAAW;AACX;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;gBAEgB;AsC7h5ChB;EACE,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AtC8h5CF;AACA,kBAAkB;AsC3h5ClB;;EAEE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AtC6h5CF;AACA;;gBAEgB;AsCvh5ChB;;EAEE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AtCyh5CF;AsCth5CA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,mBAAA;EACA,4BAAA;EAEA,0FAAA;EACA,yBAAA;AtCqh5CF;AACA;;gBAEgB;AsCjh5ChB;;EAEE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,cAAA;EACA,0FAAA;AtCkh5CF;AACA;;gBAEgB;AAChB,WAAW;AsC9g5CX;;EAEE,cAAA;EACA,2BAAA;AtCgh5CF;AACA,YAAY;AsC7g5CZ;EACE,sBAAA;AtC+g5CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AsCxg5ChB;;EAEE,mBAAA;EACA,uCAAA;AtC0g5CF;AsCxg5CA;;EAEE,+BAAA;AtC0g5CF;AACA;;gBAEgB;AsCtg5ChB;;EAEE,mBAAA;EACA,uCAAA;AtCwg5CF;AsCtg5CA;;EAEE,gCAAA;AtCwg5CF;AsCtg5CA;EACE,gCAAA;AtCwg5CF;AACA;;gBAEgB;AsCpg5ChB;;EAEE,mBAAA;EACA,qBAAA;AtCsg5CF;AsCpg5CA;;EAEE,gCAAA;AtCsg5CF;AsCpg5CA;EACE,gCAAA;AtCsg5CF;AACA;;gBAEgB;AsClg5ChB;;EAEE,mBAAA;EACA,uCAAA;AtCog5CF;AsClg5CA;;EAEE,UAAA;EACA,gCAAA;AtCog5CF;AACA;;gBAEgB;AsChg5ChB;;EAEE,mBAAA;EACA,uCAAA;AtCkg5CF;AsChg5CA;;EAEE,UAAA;EACA,gCAAA;AtCkg5CF;AACA;;gBAEgB;AsC9/4ChB;;;;EAIE,mBAAA;EACA,qBAAA;AtCgg5CF;AsC9/4CA;;;;EAIE,gCAAA;AtCgg5CF;AACA;;gBAEgB;AsC3/4ChB;;EAEE,eAAA;AtC6/4CF;AACA;;gBAEgB;AsCx/4ChB;;;;EAIE,0BAAA;EACA,YAAA;EACA,cAAA;AtC0/4CF;AACA;;gBAEgB;AAChB;iCACiC;AsCt/4CjC;EACE,WAAA;AtCw/4CF;AACA,qBAAqB;AsCr/4CrB;EACE,eAAA;EACA,iBAAA;AtCu/4CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AsCh/4ChB;EACE,gBAAA;AtCk/4CF;AsC/+4CA;;EAEE,uBAAA;AtCi/4CF;AACA,QAAQ;AsC9+4CR;;EAEE,WAAA;EACA,eAAA;EAEA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;AtC++4CF;AACA,WAAW;AsC5+4CX;;EAEE,YAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AtC8+4CF;AACA,mBAAmB;AsC3+4CnB;;EAEE,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,2CAAA;AtC6+4CF;AACA,UAAU;AsC1+4CV;;EAEE,yBAAA;AtC4+4CF;AsC1+4CA;;EAEE,2CAAA;AtC4+4CF;AACA,kBAAkB;AsCz+4ClB;;EAEE,UAAA;AtC2+4CF;AACA,WAAW;AsCx+4CX;;EAEE,yBAAA;AtC0+4CF;AsCx+4CA;;EAEE,2CAAA;AtC0+4CF;AACA,iBAAiB;AsCv+4CjB;;EAEE,yBAAA;AtCy+4CF;AsCv+4CA;;EAEE,2CAAA;AtCy+4CF;AACA;;gBAEgB;AsCr+4ChB;EACE,mBAAA;AtCu+4CF;AACA,UAAU;AsCp+4CV;EACE,aAAA;EACA,eAAA;AtCs+4CF;AACA,UAAU;AsCn+4CV;;EAEE,oBAAA;EACA,iBAAA;EACA,+BAAA;AtCq+4CF;AACA,SAAS;AsCl+4CT;;EAEE,cAAA;EACA,kBAAA;EACA,WAAA;EAEA,uBAAA;EACA,SAAA;EACA,UAAA;EAEA,WAAA;EAEA,2CAAA;EACA,aAAA;EACA,qBAAA;EAEA,eAAA;EACA,qBAAA;EACA,gCAAA;AtCg+4CF;AACA,WAAW;AsC594CX;;EAEE,qEAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,oGAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EAEA,qBAAA;EACA,0BAAA;AtC494CF;AACA,UAAU;AsCz94CV;;EAEE,2CAAA;EACA,YAAA;AtC294CF;AACA,UAAU;AsCx94CV;;EAEE,+BAAA;AtC094CF;AsCx94CA;;EAEE,qCAAA;AtC094CF;AACA,WAAW;AsCv94CX;;EAEE,2CAAA;AtCy94CF;AsCv94CA;;EAEE,oCAAA;AtCy94CF;AsCv94CA;;EAEE,UAAA;AtCy94CF;AACA,iBAAiB;AsCt94CjB;;EAEE,2CAAA;AtCw94CF;AsCt94CA;;EAEE,oCAAA;AtCw94CF;AACA;;gBAEgB;AsCn94ChB;EACE,kBAAA;AtCq94CF;AACA,UAAU;AsCl94CV;EACE,aAAA;EACA,cAAA;AtCo94CF;AACA,UAAU;AsCj94CV;;EAEE,kBAAA;EACA,oBAAA;EACA,cAAA;AtCm94CF;AsCj94CA;EACE,mBAAA;AtCm94CF;AACA,WAAW;AsCh94CX;;EAEE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EAEA,SAAA;EAEA,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AtCg94CF;AACA,WAAW;AsC784CX;;EAEE,qEAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,oGAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EAEA,qBAAA;EACA,gDAAA;AtC684CF;AsC184CA;;EAEE,cAAA;EACA,oGAAA;AtC484CF;AACA,UAAU;AsCz84CV;;EAEE,2CAAA;EACA,YAAA;AtC284CF;AACA,UAAU;AsCx84CV;;EAEE,2CAAA;EACA,YAAA;AtC084CF;AACA,WAAW;AsCv84CX;;EAEE,2CAAA;AtCy84CF;AsCv84CA;;EAEE,oCAAA;AtCy84CF;AsCv84CA;;EAEE,aAAA;EACA,oGAAA;AtCy84CF;AACA,iBAAiB;AsCr84CjB;;EAEE,2CAAA;AtCu84CF;AsCr84CA;;EAEE,oCAAA;AtCu84CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AsCl84ChB;;EAEE,4BAAA;AtCo84CF;AsCj84CA;;EAEE,aAAA;AtCm84CF;AsCh84CA;;EAEE,aAAA;AtCk84CF;AACA;;+BAE+B;AuCnh6C/B;EACE,uBAAA;EACA,gEAAA;AvCqh6CF;AACA,cAAc;AuChh6Cd;;EAEE,uBAAA;AvCkh6CF;AACA,YAAY;AuC/g6CZ;;EAEE,gBAAA;AvCih6CF;AACA,kBAAkB;AuC9g6ClB;;EAEE,eAAA;EACA,gBAAA;AvCgh6CF;AACA;;;;CAIC;AACD;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,qBAAqB;AACrB,YAAY;AACZ;;qBAEqB;AACrB,eAAe;AACf;;qBAEqB;AACrB,aAAa;AACb,WAAW;AACX,mBAAmB;AACnB;;+BAE+B;AAC/B,qBAAqB;AACrB,YAAY;AACZ;;qBAEqB;AACrB,eAAe;AACf;;qBAEqB;AACrB,aAAa;AACb,WAAW;AACX,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AwC5q7C/B;EACE,kBAAA;AxC8q7CF;AwC3q7CA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,sBAAA;EACA,YAAA;EAEA,qCAAA;EACA,UAAA;EACA,cAAA;EAEA,yBAAA;EACA,wBAAA;EACA,wCAAA;EAEA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,oBAAA;EACA,aAAA;AxCuq7CF;AACA,mBAAmB;AwCpq7CnB;EACE,iBAAA;EACA,cAAA;AxCsq7CF;AACA,mBAAmB;AwClq7CnB;EACE,iCAAA;AxCoq7CF;AACA,eAAe;AwChq7Cb;EACE,oCAAA;AxCkq7CJ;AwChq7CE;EACE,qCAAA;AxCkq7CJ;AwChq7CE;EACE,qCAAA;AxCkq7CJ;AwChq7CE;EACE,qCAAA;AxCkq7CJ;AACA;;+BAE+B;AAC/B,cAAc;AwC5p7Cd;;EAEE,gBAAA;AxC8p7CF;AACA,iCAAiC;AwC3p7CjC;;;EAGE,aAAA;EACA,UAAA;AxC6p7CF;AACA,aAAa;AwC1p7Cb;EACE,mBAAA;EACA,oBAAA;AxC4p7CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,iCAAiC;AwCrp7CjC;;;EAGE,cAAA;AxCup7CF;AACA;;gBAEgB;AwCnp7ChB;EACE,2BAAA;AxCqp7CF;AwCnp7CA;EACE,yBAAA;AxCqp7CF;AACA;;gBAEgB;AwCjp7ChB;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AxCmp7CF;AwChp7CA;;EAEE,gBAAA;AxCkp7CF;AwC/o7CA;EACE,eAAA;AxCip7CF;AACA;;gBAEgB;AwC7o7ChB;EACE,8BAAA;EACA,6BAAA;AxC+o7CF;AwC7o7CA;EACE,gCAAA;AxC+o7CF;AACA,iBAAiB;AwC5o7CjB;EACE,oCAAA;AxC8o7CF;AwC5o7CA;EACE,0CAAA;AxC8o7CF;AACA;;gBAEgB;AwC1o7ChB;EACE,mBAAA;AxC4o7CF;AwC1o7CA;EACE,sBAAA;AxC4o7CF;AACA;;gBAEgB;AwCxo7ChB;EACE,2CAAA;AxC0o7CF;AwCxo7CA;EACE,cAAA;AxC0o7CF;AACA;;gBAEgB;AAChB,gCAAgC;AwCto7ChC;EACE,cAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,kCAAA;AxCwo7CF;AwCto7CA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;AxCwo7CF;AwCro7CA;EACE,wCAAA;AxCuo7CF;AwCro7CA;EACE,2CAAA;AxCuo7CF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,iBAAiB;AACjB,SAAS;AACT,SAAS;AACT,cAAc;AACd,aAAa;AACb,gBAAgB;AAChB,iBAAiB;AACjB,eAAe;AACf,eAAe;AACf,qBAAqB;AACrB,2BAA2B;AAC3B,gBAAgB;AAChB,YAAY;AACZ,oBAAoB;AACpB;;qBAEqB;AACrB;;eAEe;AACf,aAAa;AACb,eAAe;AACf,YAAY;AACZ,kBAAkB;AAClB,UAAU;AACV,UAAU;AACV,YAAY;AACZ,kBAAkB;AAClB;;eAEe;AACf,qBAAqB;AACrB,WAAW;AACX;;eAEe;AACf,6EAA6E;AAC7E,mBAAmB;AACnB,kBAAkB;AAClB,oBAAoB;AACpB;;qBAEqB;AACrB,YAAY;AACZ,iBAAiB;AACjB,YAAY;AACZ,qBAAqB;AACrB,aAAa;AACb,UAAU;AACV,cAAc;AACd;;qBAEqB;AACrB,cAAc;AACd,kBAAkB;AAClB,WAAW;AACX,qBAAqB;AACrB,SAAS;AACT,WAAW;AACX,aAAa;AACb,aAAa;AACb,oBAAoB;AACpB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,iBAAiB;AACjB,SAAS;AACT,SAAS;AACT,cAAc;AACd,aAAa;AACb,gBAAgB;AAChB,iBAAiB;AACjB,eAAe;AACf,eAAe;AACf,qBAAqB;AACrB,2BAA2B;AAC3B,gBAAgB;AAChB,YAAY;AACZ,oBAAoB;AACpB;;qBAEqB;AACrB;;eAEe;AACf,aAAa;AACb,eAAe;AACf,YAAY;AACZ,kBAAkB;AAClB,UAAU;AACV,UAAU;AACV,YAAY;AACZ,kBAAkB;AAClB;;eAEe;AACf,qBAAqB;AACrB,WAAW;AACX;;eAEe;AACf,6EAA6E;AAC7E,mBAAmB;AACnB,kBAAkB;AAClB,oBAAoB;AACpB;;qBAEqB;AACrB,YAAY;AACZ,iBAAiB;AACjB,YAAY;AACZ,qBAAqB;AACrB,aAAa;AACb,UAAU;AACV,cAAc;AACd;;qBAEqB;AACrB,cAAc;AACd,kBAAkB;AAClB,WAAW;AACX,qBAAqB;AACrB,SAAS;AACT,WAAW;AACX,aAAa;AACb,aAAa;AACb,oBAAoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AyC5l9C/B;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,iDAAA;EAEA,6CAAA;AzC6l9CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AyCxl9ChB;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EAGA,WAAA;EACA,gBAAA;EACA,mBAAA;EAEA,cAAA;EACA,iBAAA;EACA,gBAAA;EAEA,qDAAA;EACA,2CAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,+BAAA;AzCsl9CF;AyCnl9CA;EACE,mBAAA;AzCql9CF;AACA;;gBAEgB;AyChl9ChB;;EAEE,wBAAA;AzCkl9CF;AACA;;gBAEgB;AyC9k9ChB;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;AzCgl9CF;AyC9k9CA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AzCgl9CF;AyC9k9CA;EACE,iBAAA;AzCgl9CF;AACA;;gBAEgB;AyC3k9ChB;EACE,qBAAA;EACA,gBAAA;AzC6k9CF;AACA;;gBAEgB;AyCzk9ChB;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,gCAAA;EAEA,+CAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AzCwk9CF;AyCtk9CA;EACE,qBAAA;AzCwk9CF;AACA;;gBAEgB;AyCpk9ChB;;EAEE,uBAAA;EACA,4BAAA;EACA,2BAAA;AzCsk9CF;AyCpk9CA;;EAEE,sBAAA;EACA,2BAAA;EACA,4BAAA;AzCsk9CF;AyCnk9CA;;;;EAIE,eAAA;AzCqk9CF;AACA;;gBAEgB;AyChk9ChB;EACE,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;AzCkk9CF;AyC/j9CA;EACE,8CAAA;EACA,WAAA;EACA,iBAAA;AzCik9CF;AyC9j9CA;EACE,WAAA;EACA,aAAA;EACA,mCAAA;EACA,gBAAA;AzCgk9CF;AyC9j9CA;EACE,eAAA;AzCgk9CF;AyC9j9CA;EACE,kBAAA;AzCgk9CF;AyC9j9CA;;;EAGE,kBAAA;EACA,qBAAA;AzCgk9CF;AACA;;oBAEoB;AyC5j9CpB;;EAEE,YAAA;EACA,uBAAA;EACA,+BAAA;AzC8j9CF;AACA;;oBAEoB;AyC1j9CpB;EACE,oCAAA;EACA,mBAAA;AzC4j9CF;AyC1j9CA;EACE,+BAAA;AzC4j9CF;AACA;;gBAEgB;AyCxj9ChB;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;EACA,uCAAA;EACA,sBAAA;AzC0j9CF;AACA,eAAe;AyCvj9Cf;EACE,aAAA;AzCyj9CF;AACA;;gBAEgB;AAChB,mCAAmC;AyCrj9CnC;;;;;EAKE,eAAA;AzCuj9CF;AyCrj9CA;;;;;EAKE,eAAA;AzCuj9CF;AyCpj9CA;;;;;;;;;;EAUE,gBAAA;EACA,WAAA;EACA,2BAAA;AzCsj9CF;AACA;;gBAEgB;AyClj9ChB;;;;EAIE,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AzCoj9CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,6BAA6B;AyC7i9C7B;;EAEE,aAAA;AzC+i9CF;AACA,6BAA6B;AyC5i9C7B;EACE,iBAAA;AzC8i9CF;AACA,8DAA8D;AyC3i9C9D;;;EAGE,UAAA;EACA,UAAA;AzC6i9CF;AACA;;gBAEgB;AAChB,kBAAkB;AyCzi9ClB;EACE,eAAA;AzC2i9CF;AACA;;gBAEgB;AAChB,6BAA6B;AyCvi9C7B;EACE,WAAA;AzCyi9CF;AyCvi9CA;EACE,eAAA;AzCyi9CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,+BAA+B;AyCli9C/B;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;EAEA,eAAA;EACA,wBAAA;EAEA,qCAAA;EACA,qBAAA;EACA,4CAAA;EACA,cAAA;EACA,gBAAA;EACA,2CAAA;EACA,4BAAA;EACA,iDAAA;AzCki9CF;AyChi9CA;;EAEE,WAAA;AzCki9CF;AyC/h9CA;EACE,YAAA;EACA,cAAA;EACA,2CAAA;EACA,mBAAA;AzCii9CF;AyC/h9CA;;;EAGE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;AzCii9CF;AACA,YAAY;AyC9h9CZ;EACE,cAAA;AzCgi9CF;AACA,oBAAoB;AyC7h9CpB;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EAEA,kDAAA;EACA,qDAAA;EACA,6BAAA;AzC8h9CF;AyC5h9CA;;EAEE,aAAA;AzC8h9CF;AACA;;gBAEgB;AyC1h9ChB;EACE,oCAAA;AzC4h9CF;AyCzh9CA;EACE;IACE,yBAAA;EzC2h9CF;AACF;AyCzh9CA;EACE;IACE,0BAAA;EzC2h9CF;AACF;AyCzh9CA;EACE;IACE,0BAAA;EzC2h9CF;AACF;AyCzh9CA;EACE;IACE,0BAAA;EzC2h9CF;AACF;AACA,cAAc;AyCxh9Cd;EACE,6BAAA;EACA,+CAAA;EACA,mBAAA;EACA,iBAAA;AzC0h9CF;AACA,cAAc;AyCvh9Cd;EACE,aAAA;AzCyh9CF;AACA,UAAU;AyCth9CV;EACE,uCAAA;EACA,gBAAA;AzCwh9CF;AACA,WAAW;AyCrh9CX;EACE,qBAAA;EACA,qDAAA;AzCuh9CF;AyCrh9CA;EACE,qBAAA;EACA,qDAAA;AzCuh9CF;AACA,UAAU;AyCph9CV;EACE,qBAAA;EACA,gBAAA;AzCsh9CF;AyCph9CA;EACE,qBAAA;EACA,qDAAA;AzCsh9CF;AACA,YAAY;AyCnh9CZ;EACE,mBAAA;EACA,+BAAA;AzCqh9CF;AACA,kBAAkB;AyClh9ClB;EACE,qBAAA;EACA,qDAAA;AzCoh9CF;AyClh9CA;EACE,qBAAA;EACA,qDAAA;AzCoh9CF;AACA,kBAAkB;AyCjh9ClB;;EAEE,WAAA;EACA,UAAA;AzCmh9CF;AACA,sBAAsB;AyChh9CtB;EACE,yCAAA;EACA,0CAAA;AzCkh9CF;AACA,4BAA4B;AyC/g9C5B;EACE,uCAAA;EACA,2BAAA;AzCih9CF;AyC/g9CA;EACE,uBAAA;EACA,2BAAA;AzCih9CF;AACA;;gBAEgB;AAChB,qBAAqB;AyC7g9CrB;EACE,aAAA;AzC+g9CF;AACA,oBAAoB;AyC5g9CpB;EACE,uCAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mDAAA;EACA,gBAAA;AzC8g9CF;AACA,kBAAkB;AyC3g9ClB;EACE,kBAAA;EACA,UAAA;AzC6g9CF;AyC3g9CA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AzC6g9CF;AACA,qBAAqB;AyC1g9CrB;EACE,yBAAA;EACA,4CAAA;AzC4g9CF;AACA,uDAAuD;AyCzg9CvD;EACE,yBAAA;EACA,4CAAA;EACA,aAAA;EACA,gBAAA;AzC2g9CF;AACA,0BAA0B;AyCxg9C1B;;EAEE,YAAA;AzC0g9CF;AyCxg9CA;;EAEE,oBAAA;AzC0g9CF;AACA,kBAAkB;AyCvg9ClB;;EAEE,aAAA;AzCyg9CF;AyCvg9CA;EACE,yBAAA;AzCyg9CF;AACA,gBAAgB;AyCtg9ChB;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;AzCwg9CF;AyCtg9CA;EACE;IACE,yBAAA;EzCwg9CF;AACF;AyCtg9CA;EACE;IACE,0BAAA;EzCwg9CF;AACF;AyCtg9CA;EACE;IACE,0BAAA;EzCwg9CF;AACF;AyCtg9CA;EACE;IACE,0BAAA;EzCwg9CF;AACF;AACA;;gBAEgB;AAChB,uBAAuB;AyCpg9CvB;EACE,qDAAA;AzCsg9CF;AyCpg9CA;EACE,YAAA;AzCsg9CF;AACA,8BAA8B;AyCng9C9B;;EAEE,YAAA;AzCqg9CF;AACA,oBAAoB;AyClg9CpB;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kCAAA;EACA,qDAAA;EACA,2DAAA;AzCog9CF;AACA,kBAAkB;AyCjg9ClB;EACE,UAAA;EACA,WAAA;AzCmg9CF;AACA,SAAS;AyChg9CT;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kDAAA;EACA,yBAAA;AzCkg9CF;AyChg9CA;EACE,oCAAA;AzCkg9CF;AyChg9CA;EACE,aAAA;AzCkg9CF;AACA;;kBAEkB;AAClB,gBAAgB;AyC9/8ChB;EACE,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,kDAAA;EACA,yBAAA;AzCgg9CF;AyC7/8CA;EACE,aAAA;AzC+/8CF;AACA,WAAW;AyC5/8CX;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kDAAA;EACA,YAAA;EACA,yBAAA;AzC8/8CF;AACA;;gBAEgB;AyCz/8ChB;EACE,eAAA;EACA,qBAAA;EACA,cAAA;AzC2/8CF;AyCz/8CA;EACE,yCAAA;EACA,wBAAA;AzC2/8CF;AyCz/8CA;EACE,iBAAA;AzC2/8CF;AyCz/8CA;EACE,YAAA;EACA,wBAAA;EACA,4BAAA;AzC2/8CF;AACA;;+BAE+B;AAC/B;;uBAEuB;AACvB,qBAAqB;AyCp/8CrB;EACE,uBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;AzCs/8CF;AACA;;uBAEuB;AACvB,oBAAoB;AyCj/8CpB;EACE,+BAAA;EACA,gCAAA;EACA,WAAA;AzCm/8CF;AACA;;sBAEsB;AyC/+8CtB;EACE,sBAAA;AzCi/8CF;AyC/+8CA;EACE,sCAAA;AzCi/8CF;AyC/+8CA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,sCAAA;AzC++8CF;AyC7+8CA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,oCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;AzC2+8CF;AACA,aAAa;AyCx+8Cb;;EAEE,aAAA;AzC0+8CF;AyCv+8CA;EACE;IACE,uBAAA;EzCy+8CF;EyCv+8CA;IACE,yBAAA;EzCy+8CF;AACF;AACA;;uBAEuB;AyCp+8CvB;;EAEE,cAAA;AzCs+8CF;AyCp+8CA;;EAEE,cAAA;AzCs+8CF;AACA;;uBAEuB;AyCn+8CvB;EACE,gBAAA;AzCq+8CF;AACA,2BAA2B;AyCl+8C3B;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AzCo+8CF;AyCl+8CA;EACE,oBAAA;EACA,sBAAA;AzCo+8CF;AyCl+8CA;EACE,qBAAA;EACA,sBAAA;AzCo+8CF;AACA;;uBAEuB;AACvB,kBAAkB;AyCh+8ClB;;EAEE,+BAAA;EACA,gCAAA;AzCk+8CF;AACA;;uBAEuB;AACvB,kBAAkB;AyC798ClB;EACE,kBAAA;AzC+98CF;AyC798CA;EACE,wBAAA;AzC+98CF;AACA;;uBAEuB;AyC198CvB;;;EAGE,cAAA;AzC498CF;AyCz98CA;EACE,iCAAA;EACA,qBAAA;AzC298CF;AyCz98CA;EACE,qBAAA;AzC298CF;AyCx98CA;;EAEE,qBAAA;AzC098CF;AyCx98CA;EACE,cAAA;AzC098CF;AyCx98CA;EACE,qBAAA;AzC098CF;AACA,eAAe;AyCv98Cf;EACE,yBAAA;AzCy98CF;AACA,gBAAgB;AyCt98ChB;EACE,yBAAA;AzCw98CF;AACA;;uBAEuB;AyCn98CvB;EACE,YAAA;EACA,6BAAA;AzCq98CF;AyCn98CA;EACE,UAAA;AzCq98CF;AACA;;uBAEuB;AACvB,aAAa;AyCh98Cb;;EAEE,eAAA;EACA,oBAAA;EACA,aAAA;AzCk98CF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,qBAAqB;AyC588CrB;EACE,SAAA;AzC888CF;AACA,yBAAyB;AyC188CzB;;EAEE,qBAAA;EACA,sBAAA;EACA,uCAAA;AzC488CF;AACA,0BAA0B;AyCz88C1B;EACE,qBAAA;EACA,qBAAA;AzC288CF;AyCx88CA;;EAEE,UAAA;EACA,WAAA;EACA,qCAAA;EACA,uCAAA;AzC088CF;AyCv88CA;;EAEE,WAAA;EACA,WAAA;EACA,uBAAA;AzCy88CF;AyCv88CA;;EAEE,WAAA;EACA,WAAA;EACA,uBAAA;AzCy88CF;AyCv88CA;;EAEE,gBAAA;EACA,iBAAA;AzCy88CF;AACA;;gBAEgB;AAChB,qBAAqB;AyCp88CrB;EACE,SAAA;EACA,YAAA;EACA,+CAAA;EACA,kDAAA;AzCs88CF;AACA,oBAAoB;AyCn88CpB;EACE,oBAAA;EACA,oBAAA;AzCq88CF;AACA,kBAAkB;AyCl88ClB;;EAEE,6DAAA;AzCo88CF;AyCl88CA;EACE,kDAAA;AzCo88CF;AACA,cAAc;AyCj88Cd;EACE,gCAAA;EACA,mCAAA;EACA,gDAAA;AzCm88CF;AyCj88CA;EACE,+CAAA;AzCm88CF;AACA,kBAAkB;AyCh88ClB;EACE,6DAAA;AzCk88CF;AACA,mBAAmB;AyC/78CnB;EACE,+CAAA;EACA,6DAAA;AzCi88CF;AACA,yBAAyB;AyC978CzB;EACE,+CAAA;AzCg88CF;AyC978CA;EACE,gDAAA;AzCg88CF;AACA;;gBAEgB;AAChB,oBAAoB;AyC578CpB;;EAEE,kBAAA;EACA,gBAAA;AzC878CF;AyC378CA;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,0BAAA;EACA,sBAAA;AzC678CF;AyC178CA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,sBAAA;EACA,+CAAA;AzC478CF;AyC178CA;;EAEE,gBAAA;AzC478CF;AyC178CA;;EAEE,gBAAA;AzC478CF;AyC178CA;;EAEE,cAAA;AzC478CF;AACA,oBAAoB;AyCz78CpB;EACE;;IAEE,4BAAA;EzC278CF;AACF;AyCz78CA;EACE;;IAEE,0BAAA;EzC278CF;AACF;AyCz78CA;EACE;;IAEE,0BAAA;EzC278CF;AACF;AyCz78CA;EACE;;IAEE,0BAAA;EzC278CF;AACF;AyCz78CA;EACE;;IAEE,0BAAA;EzC278CF;AACF;AACA;;gBAEgB;AAChB,gCAAgC;AyCt78ChC;;EAEE,aAAA;AzCw78CF;AyCt78CA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AzCw78CF;AyCr78CA;;EAEE,yCAAA;EACA,0CAAA;AzCu78CF;AyCp78CA;;EAEE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AzCs78CF;AyCp78CA;;EAEE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AzCs78CF;AyCp78CA;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AzCs78CF;AACA,YAAY;AyCn78CZ;EACE,cAAA;AzCq78CF;AACA;;gBAEgB;AyCj78ChB;EACE,cAAA;EACA,WAAA;EACA,cAAA;AzCm78CF;AyCj78CA;EACE,YAAA;AzCm78CF;AACA;;gBAEgB;AyC968ChB;EACE,OAAA;EACA,WAAA;EACA,sGAAA;EACA,uCAAA;AzCg78CF;AyC968CA;EACE,4BAAA;EACA,uCAAA;AzCg78CF;AACA;;gBAEgB;AyC568ChB;EACE,SAAA;EACA,yBAAA;EACA,4BAAA;AzC868CF;AyC368CA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EAEA,YAAA;EACA,aAAA;EACA,uDAAA;EACA,mBAAA;EACA,UAAA;AzC468CF;AyCz68CA;EACE,YAAA;EACA,SAAA;EACA,2BAAA;AzC268CF;AACA,sBAAsB;AyCx68CtB;EACE,SAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AzC068CF;AyCx68CA;EACE,SAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AzC068CF;AyCx68CA;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;AzC068CF;AACA,uBAAuB;AyCx68CvB;EACE,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AzC068CF;AyCx68CA;;EAEE,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,WAAA;EACA,wBAAA;AzC068CF;AACA,kBAAkB;AyCv68ClB;EACE,OAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AzCy68CF;AyCv68CA;EACE,QAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;AzCy68CF;AyCv68CA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;AzCy68CF;AyCv68CA;EACE,QAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AzCy68CF;AACA,mBAAmB;AyCr68CnB;EACE,OAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AzCu68CF;AyCr68CA;EACE,QAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AzCu68CF;AACA,oBAAoB;AyCp68CpB;EACE,SAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AzCs68CF;AyCp68CA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AzCs68CF;AACA,+BAA+B;AyCp68C/B;EACE,oBAAA;EACA,sBAAA;AzCs68CF;AACA,gBAAgB;AyCn68ChB;EACE,QAAA;EACA,WAAA;AzCq68CF;AyCn68CA;EACE,SAAA;EACA,WAAA;AzCq68CF;AACA,iBAAiB;AyCl68CjB;EACE,SAAA;EACA,UAAA;AzCo68CF;AyCl68CA;EACE,UAAA;EACA,UAAA;AzCo68CF;AACA,oBAAoB;AyCj68CpB;;EAEE,oBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;AzCm68CF;AyCj68CA;;EAEE,oBAAA;EACA,uBAAA;EACA,qDAAA;EACA,uBAAA;AzCm68CF;AACA,0BAA0B;AyCh68C1B;EACE,oBAAA;EACA,oBAAA;EACA,uBAAA;AzCk68CF;AyCh68CA;EACE,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,uDAAA;AzCk68CF;AACA,yBAAyB;AyC958CzB;EACE,oBAAA;EACA,oBAAA;EACA,uBAAA;AzCg68CF;AyC958CA;EACE,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,uDAAA;AzCg68CF;AACA;;+BAE+B;AAC/B,oBAAoB;A0Czy/CpB;EACE,uBAAA;EACA,4DAAA;EAGA,mBAAA;EACA,kBAAA;A1Cyy/CF;A0Cty/CA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A1Cwy/CF;A0Cry/CA;EACE,WAAA;A1Cuy/CF;A0Cry/CA;EACE,gBAAA;A1Cuy/CF;AACA,aAAa;A0Cpy/Cb;EACE,gCAAA;A1Csy/CF;A0Cny/CA;;EAEE,gCAAA;A1Cqy/CF;AACA,2BAA2B;A0Cly/C3B;EACE,gCAAA;A1Coy/CF;A0Cjy/CA;EACE,gBAAA;A1Cmy/CF;AACA;;;;;;CAMC;AACD;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,gBAAgB;AAChB,qCAAqC;AACrC,SAAS;AACT;;qBAEqB;AACrB,UAAU;AACV;;qBAEqB;AACrB,kBAAkB;AAClB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,WAAW;AACX,gBAAgB;AAChB,qCAAqC;AACrC,SAAS;AACT;;qBAEqB;AACrB,UAAU;AACV;;qBAEqB;AACrB,kBAAkB;AAClB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A2C79gD/B;EAEE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;A3C89gDF;AACA;;mBAEmB;A2C19gDnB;;;EAGE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A3C49gDF;AACA;;mBAEmB;A2Cx9gDnB;EACE,aAAA;A3C09gDF;AACA;;gBAEgB;A2Ct9gDhB;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sEAAA;A3Cw9gDF;AACA;;gBAEgB;A2Cp9gDhB;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A3Cs9gDF;A2Cp9gDA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,gEAAA;EACA,YAAA;EACA,6BAAA;A3Cs9gDF;A2Cp9gDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;EAEA,cAAA;EACA,eAAA;EACA,+CAAA;EACA,8CAAA;EACA,WAAA;A3Cq9gDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A2Ch9gDhB;EACE,gEAAA;EACA,UAAA;A3Ck9gDF;A2Ch9gDA;EACE,cAAA;A3Ck9gDF;AACA;;gBAEgB;A2C98gDhB;;EAEE,aAAA;A3Cg9gDF;A2C98gDA;EACE,cAAA;A3Cg9gDF;AACA;;+BAE+B;AAC/B;;+BAE+B;A2C58gD/B;EACE,oBAAA;A3C88gDF;A2C58gDA;EACE,mBAAA;A3C88gDF;A2C58gDA;EACE,sBAAA;A3C88gDF;A2C58gDA;EACE,4BAAA;A3C88gDF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,eAAe;AACf,WAAW;AACX,YAAY;AACZ,wBAAwB;AACxB,kBAAkB;AAClB,yCAAyC;AACzC,qBAAqB;AACrB,sBAAsB;AACtB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,qBAAqB;AACrB,sBAAsB;AACtB;;qBAEqB;AACrB,gBAAgB;AAChB,6BAA6B;AAC7B,mBAAmB;AACnB;;+BAE+B;AAC/B,eAAe;AACf,WAAW;AACX,YAAY;AACZ,wBAAwB;AACxB,kBAAkB;AAClB,yCAAyC;AACzC,qBAAqB;AACrB,sBAAsB;AACtB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB,UAAU;AACV,gBAAgB;AAChB,qBAAqB;AACrB,sBAAsB;AACtB;;qBAEqB;AACrB,gBAAgB;AAChB,6BAA6B;AAC7B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A4CjwiD/B;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EAEA,mBAAA;EACA,YAAA;EACA,mFAAA;EACA,yBAAA;EAEA,cAAA;EAEA,4BAAA;EACA,iBAAA;EACA,kDAAA;A5CgwiDF;A4C7viDA;;EAEE,qCAAA;EACA,sCAAA;A5C+viDF;A4C5viDA;EACE,wCAAA;EACA,yCAAA;A5C8viDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A4CzviDhB;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EAEA,YAAA;EACA,iBAAA;EACA,cAAA;EAEA,cAAA;EACA,eAAA;EACA,gCAAA;A5CyviDF;A4CvviDA;EACE,UAAA;A5CyviDF;AACA;;gBAEgB;A4CrviDhB;EACE,cAAA;EACA,mEAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EAEA,gCAAA;EACA,kDAAA;A5CsviDF;A4CpviDA;EACE,wBAAA;EACA,yBAAA;EACA,iBAAA;A5CsviDF;AACA;;gBAEgB;A4ClviDhB;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;A5CoviDF;A4ClviDA;EACE,aAAA;EACA,mBAAA;A5CoviDF;AACA,UAAU;A4CjviDV;EACE,cAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;A5CmviDF;A4CjviDA;EACE,eAAA;A5CmviDF;A4CjviDA;EACE,kBAAA;A5CmviDF;A4CjviDA;EACE,mBAAA;A5CmviDF;AACA,gBAAgB;A4ChviDhB;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;A5CkviDF;A4C/uiDA;;EAEE,cAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;A5CiviDF;AACA,aAAa;A4C9uiDb;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;A5CgviDF;AACA;;gBAEgB;A4C5uiDhB;EACE,mBAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;A5C8uiDF;A4C5uiDA;EACE,mBAAA;A5C8uiDF;AACA;;qBAEqB;AACrB,gBAAgB;A4C1uiDhB;EACE;IACE,UAAA;IACA,uBAAA;E5C4uiDF;AACF;A4C1uiDA;EACE;IACE,UAAA;IACA,uBAAA;E5C4uiDF;AACF;A4C1uiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4uiDF;AACF;A4C1uiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4uiDF;AACF;A4C1uiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4uiDF;AACF;AACA,sBAAsB;A4CzuiDtB;EACE;IACE,sBAAA;E5C2uiDF;E4CzuiDA;IACE,cAAA;IACA,WAAA;IACA,gCAAA;E5C2uiDF;AACF;AACA,WAAW;A4CxuiDX;EAEE;IACE,gCAAA;IACA,iCAAA;E5CyuiDF;E4CvuiDA;IACE,cAAA;IACA,wBAAA;E5CyuiDF;E4CvuiDA;IACE,sBAAA;IACA,wBAAA;E5CyuiDF;EACA,aAAa;E4CtuiDb;IACE,sBAAA;E5CwuiDF;E4CtuiDA;IACE,cAAA;IACA,eAAA;IACA,2BAAA;IACA,kBAAA;IACA,kCAAA;E5CwuiDF;E4CtuiDA;IACE,eAAA;IACA,kBAAA;E5CwuiDF;EACA,aAAa;E4CruiDb;IACE,cAAA;IACA,sBAAA;IACA,sBAAA;IACA,6BAAA;IACA,gBAAA;E5CuuiDF;EACA,sBAAsB;E4CpuiDtB;IACE,kCAAA;E5CsuiDF;E4CpuiDA;;IAEE,mBAAA;E5CsuiDF;AACF;AACA;;gBAEgB;A4CluiDhB;EACE,+CAAA;A5CouiDF;AACA;;+BAE+B;A4ChuiD/B;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;A5CkuiDF;A4ChuiDA;;;EAGE,6BAAA;A5CkuiDF;A4ChuiDA;EACE,cAAA;A5CkuiDF;A4ChuiDA;EACE,SAAA;EACA,aAAA;A5CkuiDF;A4C/tiDA;EACE,gCAAA;A5CiuiDF;A4C/tiDA;EACE,gCAAA;A5CiuiDF;AACA,2CAA2C;A4C9tiD3C;;EAEE,QAAA;EACA,SAAA;A5CguiDF;A4C7tiDA;;;;EAIE,SAAA;A5C+tiDF;AACA,sBAAsB;A4C5tiDtB;EACE;IACE,cAAA;E5C8tiDF;AACF;AACA;;+BAE+B;A4CztiD/B;EACE,cAAA;EACA,kBAAA;EACA,WAAA;A5C2tiDF;A4CxtiDA;EACE,cAAA;A5C0tiDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,sBAAsB;A4CrtiDtB;EACE,gBAAA;A5CutiDF;A4CrtiDA;EACE;IACE,iBAAA;E5CutiDF;AACF;AACA,uBAAuB;A4CrtiDvB;EACE,gBAAA;A5CutiDF;A4CrtiDA;EACE;IACE,iBAAA;E5CutiDF;AACF;AACA;;gBAEgB;AAChB,qBAAqB;A4CntiDrB;EACE,gBAAA;A5CqtiDF;A4CntiDA;EACE,2BAAA;A5CqtiDF;A4CntiDA;EACE,cAAA;EACA,iCAAA;A5CqtiDF;A4CntiDA;EACE,eAAA;A5CqtiDF;A4CntiDA;EACE,iBAAA;A5CqtiDF;AACA,yBAAyB;A4CltiDzB;EACE,cAAA;EACA,iCAAA;A5CotiDF;A4CltiDA;EACE,gBAAA;A5CotiDF;A4CltiDA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;A5CotiDF;AACA,sBAAsB;A4CjtiDtB;EACE,6BAAA;EACA,cAAA;A5CmtiDF;AACA;;gBAEgB;A4C/siDhB;EACE,qBAAA;EACA,gBAAA;A5CitiDF;A4C/siDA;EACE,sBAAA;A5CitiDF;A4C/siDA;EACE,cAAA;EACA,WAAA;EACA,gCAAA;A5CitiDF;AACA;;gBAEgB;A4C5siDhB;EACE,eAAA;A5C8siDF;AACA,SAAS;A4C3siDT;EACE,gBAAA;A5C6siDF;AACA,qBAAqB;A4C1siDrB;EACE;IACE,UAAA;IACA,uBAAA;E5C4siDF;AACF;A4C1siDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4siDF;AACF;A4C1siDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4siDF;AACF;A4C1siDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4siDF;AACF;A4C1siDA;EACE;IACE,YAAA;IACA,uBAAA;E5C4siDF;AACF;AACA,SAAS;A4CzsiDT;EACE,gBAAA;A5C2siDF;AACA,qBAAqB;A4CxsiDrB;EACE;IACE,UAAA;IACA,uBAAA;E5C0siDF;AACF;A4CxsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C0siDF;AACF;A4CxsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C0siDF;AACF;A4CxsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C0siDF;AACF;A4CxsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5C0siDF;AACF;AACA,UAAU;A4CvsiDV;EACE,gBAAA;A5CysiDF;AACA,sBAAsB;A4CtsiDtB;EACE;IACE,UAAA;IACA,uBAAA;E5CwsiDF;AACF;A4CtsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5CwsiDF;AACF;A4CtsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5CwsiDF;AACF;A4CtsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5CwsiDF;AACF;A4CtsiDA;EACE;IACE,YAAA;IACA,uBAAA;E5CwsiDF;AACF;AACA,sBAAsB;A4CrsiDtB;EACE,gBAAA;A5CusiDF;A4CrsiDA;EACE;IACE,UAAA;IACA,uBAAA;E5CusiDF;AACF;A4CrsiDA;EACE;IACE,UAAA;IACA,uBAAA;E5CusiDF;AACF;A4CrsiDA;EACE;IACE,aAAA;IACA,uBAAA;E5CusiDF;AACF;A4CrsiDA;EACE;IACE,aAAA;IACA,uBAAA;E5CusiDF;AACF;A4CrsiDA;EACE;IACE,aAAA;IACA,uBAAA;E5CusiDF;AACF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB,UAAU;AACV;;gBAEgB;AAChB,UAAU;AACV;;gBAEgB;AAChB,iBAAiB;AACjB,aAAa;AACb;;gBAEgB;AAChB,mBAAmB;AACnB;;+BAE+B;AAC/B;;gBAEgB;AAChB;;gBAEgB;AAChB,UAAU;AACV;;gBAEgB;AAChB,UAAU;AACV;;gBAEgB;AAChB,iBAAiB;AACjB,aAAa;AACb;;gBAEgB;AAChB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A6C/5kD/B;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EAEA,QAAA;EACA,SAAA;EACA,YAAA;EAEA,eAAA;EACA,WAAA;EAEA,WAAA;EACA,mBAAA;EAEA,mBAAA;EACA,8CAAA;EAEA,eAAA;EACA,kBAAA;EACA,gCAAA;EAEA,kDAAA;EACA,gCAAA;A7C25kDF;A6Cx5kDA;EACE,eAAA;A7C05kDF;A6Cv5kDA;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;A7Cy5kDF;A6Cr5kDA;EACE,eAAA;EACA,YAAA;EAEA,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,cAAA;EAEA,sBAAA;EACA,cAAA;EACA,6BAAA;A7Co5kDF;AACA;;+BAE+B;AAC/B,UAAU;A6C94kDV;EACE,mBAAA;EACA,UAAA;A7Cg5kDF;A6C74kDA;EACE,UAAA;A7C+4kDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A6Cx4kDhB;EACE,kBAAA;EACA,cAAA;A7C04kDF;AACA;;gBAEgB;A6Ct4kDhB;EACE,eAAA;A7Cw4kDF;AACA;;gBAEgB;A6Cp4kDhB;;EAEE,kDAAA;EACA,SAAA;EACA,WAAA;A7Cs4kDF;AACA;;gBAEgB;A6Cl4kDhB;;EAEE,yBAAA;EACA,gCAAA;A7Co4kDF;A6Cl4kDA;;;;EAIE,+BAAA;A7Co4kDF;AACA;;+BAE+B;A6C/3kD/B;EACE,6BAAA;A7Ci4kDF;A6C/3kDA;EACE,kDAAA;A7Ci4kDF;A6C/3kDA;EACE,kDAAA;A7Ci4kDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,cAAc;AACd,WAAW;AACX,mBAAmB;AACnB,UAAU;AACV,4BAA4B;AAC5B;;qBAEqB;AACrB,YAAY;AACZ,aAAa;AACb,UAAU;AACV;;qBAEqB;AACrB,sBAAsB;AACtB,wBAAwB;AACxB;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,aAAa;AACb,4BAA4B;AAC5B,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,cAAc;AACd,WAAW;AACX,mBAAmB;AACnB,UAAU;AACV,4BAA4B;AAC5B;;qBAEqB;AACrB,YAAY;AACZ,aAAa;AACb,UAAU;AACV;;qBAEqB;AACrB,sBAAsB;AACtB,wBAAwB;AACxB;;qBAEqB;AACrB;;qBAEqB;AACrB,SAAS;AACT,aAAa;AACb,4BAA4B;AAC5B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A8ChsmD/B;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;E9CksmDA,wDAAwD;E8C/rmDxD,sBAAA;EACA,aAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;EAEA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2FAAA;A9C8rmDF;A8C5rmDA;EACE,YAAA;EAEA,mEAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;A9C6rmDF;A8C3rmDA;EACE,kBAAA;A9C6rmDF;A8C1rmDA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EAEA,+BAAA;EACA,wBAAA;EAEA,UAAA;EACA,mCAAA;A9C0rmDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,YAAY;A8CrrmDZ;EACE,kBAAA;A9CurmDF;AACA,UAAU;A8CprmDV;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EAEA,+BAAA;EACA,wBAAA;EAEA,UAAA;EACA,mCAAA;A9CormDF;AACA,UAAU;A8CjrmDV;EACE,oBAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,eAAA;EAEA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,+BAAA;EAEA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2FAAA;EACA,UAAA;A9C+qmDF;AACA,kCAAkC;A8C5qmDlC;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;A9C8qmDF;A8C5qmDA;EACE,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oBAAA;A9C8qmDF;AACA,cAAc;A8C3qmDd;;EAEE,oBAAA;EACA,kBAAA;A9C6qmDF;A8C3qmDA;EACE,UAAA;EACA,4CAAA;EACA,4BAAA;EACA,yBAAA;A9C6qmDF;A8CzqmDA;EACE,UAAA;EACA,+BAAA;EACA,yBAAA;A9C2qmDF;A8CvqmDA;;EAEE,mBAAA;EACA,oBAAA;A9CyqmDF;A8CvqmDA;EACE,4CAAA;EACA,UAAA;A9CyqmDF;AACA,uBAAuB;A8CtqmDvB;;;EAGE,+CAAA;A9CwqmDF;A8CtqmDA;;EAEE,+CAAA;A9CwqmDF;A8CtqmDA;;EAEE,+CAAA;A9CwqmDF;A8CtqmDA;;EAEE,+CAAA;A9CwqmDF;A8CtqmDA;;;;EAIE,8BAAA;A9CwqmDF;A8CtqmDA;;;;EAIE,8BAAA;A9CwqmDF;AACA;;gBAEgB;AAChB,UAAU;A8CnqmDV;EACE,2BAAA;A9CqqmDF;AACA,mBAAmB;A8ClqmDnB;EACE,mBAAA;A9CoqmDF;AACA,WAAW;A8CjqmDX;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;A9CmqmDF;A8CjqmDA;EACE,sBAAA;EACA,cAAA;A9CmqmDF;AACA;;gBAEgB;AAChB,eAAe;A8C/pmDf;EACE,SAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,oBAAA;A9CiqmDF;A8C/pmDA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;A9CiqmDF;AACA,aAAa;A8C9pmDb;EACE,SAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;A9CgqmDF;A8C9pmDA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;A9CgqmDF;AACA,cAAc;A8C7pmDd;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;A9C+pmDF;A8C7pmDA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,4BAAA;A9C+pmDF;AACA,kBAAkB;A8C3pmDlB;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;A9C6pmDF;A8C3pmDA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;A9C6pmDF;AACA,gBAAgB;A8C1pmDhB;EACE,OAAA;EACA,SAAA;EACA,iBAAA;A9C4pmDF;A8C1pmDA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;A9C4pmDF;AACA,iBAAiB;A8CzpmDjB;EACE,QAAA;EACA,SAAA;EACA,iBAAA;A9C2pmDF;A8CzpmDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;A9C2pmDF;AACA,gBAAgB;A8CxpmDhB;EACE,WAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;A9C0pmDF;A8CxpmDA;EACE,WAAA;EACA,QAAA;EACA,0BAAA;EACA,4BAAA;A9C0pmDF;AACA,iBAAiB;A8CvpmDjB;EACE,UAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;A9CypmDF;A8CvpmDA;EACE,UAAA;EACA,QAAA;EACA,0BAAA;EACA,0BAAA;A9CypmDF;AACA,UAAU;A8CtpmDV;EACE,+BAAA;EACA,qCAAA;A9CwpmDF;A8CtpmDA;EACE,+BAAA;EACA,oCAAA;A9CwpmDF;A8CtpmDA;EACE,+BAAA;EACA,oCAAA;A9CwpmDF;A8CtpmDA;EACE,+BAAA;A9CwpmDF;AACA,yBAAyB;A8CrpmDzB;EACE,mBAAA;EACA,qCAAA;A9CupmDF;A8CrpmDA;EACE,mBAAA;EACA,oCAAA;A9CupmDF;A8CrpmDA;EACE,mBAAA;EACA,oCAAA;A9CupmDF;A8CrpmDA;EACE,mBAAA;A9CupmDF;A8CppmDA;EACE,+BAAA;A9CspmDF;A8CppmDA;EACE,4BAAA;A9CspmDF;A8CppmDA;EACE,4BAAA;A9CspmDF;A8CppmDA;EACE,8BAAA;A9CspmDF;A8CppmDA;EACE,8BAAA;A9CspmDF;A8CppmDA;EACE,6BAAA;A9CspmDF;AACA;;gBAEgB;A8ClpmDhB;EACE,WAAA;A9CopmDF;AACA,uBAAuB;A8CjpmDvB;EACE,4BAAA;A9CmpmDF;A8CjpmDA;EACE,6BAAA;A9CmpmDF;A8CjpmDA;EACE,+BAAA;A9CmpmDF;A8CjpmDA;EACE,8BAAA;A9CmpmDF;AACA,mCAAmC;A8ChpmDnC;EACE,gCAAA;EACA,2BAAA;A9CkpmDF;A8ChpmDA;EACE,gCAAA;EACA,0BAAA;A9CkpmDF;AACA,0BAA0B;A8C/omD1B;EACE,4BAAA;A9CipmDF;A8C/omDA;EACE,0BAAA;A9CipmDF;A8C/omDA;EACE,4BAAA;A9CipmDF;A8C/omDA;EACE,2BAAA;A9CipmDF;AACA;;gBAEgB;AAChB,gBAAgB;A8C7omDhB;EACE,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;A9C+omDF;A8C5omDA;EACE,gBAAA;A9C8omDF;AACA,aAAa;A8C5omDb;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;A9C8omDF;A8C3omDA;EACE,iBAAA;A9C6omDF;AACA,aAAa;A8C3omDb;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,qCAAA;A9C6omDF;AACA,gBAAgB;A8C1omDhB;EACE,SAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;EACA,0BAAA;A9C4omDF;A8C1omDA;EACE,gBAAA;A9C4omDF;AACA,aAAa;A8C1omDb;EACE,qBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;A9C4omDF;A8C1omDA;EACE,iBAAA;A9C4omDF;AACA,aAAa;A8C1omDb;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A9C4omDF;AACA,sBAAsB;AACtB,aAAa;A8CzomDb;EACE,QAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,oCAAA;A9C2omDF;AACA,wBAAwB;AACxB,aAAa;A8CxomDb;EACE,QAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,oCAAA;A9C0omDF;AACA,4BAA4B;A8CvomD5B;EACE,+BAAA;A9CyomDF;A8CvomDA;;EAEE,+BAAA;A9CyomDF;A8CvomDA;EACE,+BAAA;A9CyomDF;AACA,yBAAyB;A8CtomDzB;EACE,mBAAA;A9CwomDF;A8CtomDA;;EAEE,mBAAA;A9CwomDF;A8CtomDA;EACE,mBAAA;A9CwomDF;AACA;;+BAE+B;AAC/B,0BAA0B;A8CnomD1B;EACE,2BAAA;EACA,yBAAA;A9CqomDF;AACA;;+BAE+B;A8CjomD/B;EACE,cAAA;EACA,kBAAA;EACA,WAAA;A9CmomDF;A8ChomDA;;EAEE,cAAA;A9CkomDF;A8C/nmDA;EACE,0BAAA;EACA,2BAAA;A9CiomDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A8C3nmDhB;EACE,aAAA;A9C6nmDF;AACA;;gBAEgB;A8CxnmDhB;EACE,gBAAA;A9C0nmDF;A8CxnmDA;EACE,gBAAA;A9C0nmDF;A8CvnmDA;EACE;;IAEE,gBAAA;E9CynmDF;AACF;AACA;;gBAEgB;A8CpnmDhB;EACE,WAAA;EACA,eAAA;A9CsnmDF;AACA;;gBAEgB;AAChB,qBAAqB;A8CjnmDrB;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;A9CmnmDF;A8CjnmDA;EACE,sBAAA;EACA,cAAA;A9CmnmDF;A8CjnmDA;EACE,yBAAA;EACA,2BAAA;A9CmnmDF;AACA;;gBAEgB;A8C/mmDhB;EACE,eAAA;A9CinmDF;AACA;;gBAEgB;A8C5mmDhB;EACE,wBAAA;A9C8mmDF;A8C5mmDA;EACE,wBAAA;A9C8mmDF;A8C5mmDA;EACE,wBAAA;A9C8mmDF;A8C5mmDA;EACE,eAAA;A9C8mmDF;A8C5mmDA;EACE,wBAAA;A9C8mmDF;A8C5mmDA;EACE,wBAAA;A9C8mmDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,QAAQ;AACR,uBAAuB;AACvB,UAAU;AACV;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,WAAW;AACX,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,QAAQ;AACR,uBAAuB;AACvB,UAAU;AACV;;qBAEqB;AACrB;;qBAEqB;AACrB,WAAW;AACX;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,WAAW;AACX,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;A+C/7oD/B;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;A/Ci8oDF;A+C97oDA;EACE,qBAAA;A/Cg8oDF;A+C97oDA;EACE,qBAAA;A/Cg8oDF;AACA;;+BAE+B;AAC/B,iBAAiB;A+C57oDjB;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,4BAAA;EACA,uDAAA;A/C87oDF;AACA,qBAAqB;A+C37oDrB;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;A/C67oDF;AACA,UAAU;A+C17oDV;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;A/C47oDF;AACA;;+BAE+B;AAC/B,eAAe;A+Ct7oDf;;EAEE,yBAAA;A/Cw7oDF;A+Ct7oDA;EACE,yBAAA;A/Cw7oDF;A+Ct7oDA;;EAEE,yBAAA;A/Cw7oDF;A+Ct7oDA;EACE,yBAAA;A/Cw7oDF;A+Ct7oDA;;EAEE,yBAAA;A/Cw7oDF;A+Ct7oDA;;EAEE,yBAAA;A/Cw7oDF;AACA,qBAAqB;A+Cr7oDrB;;EAEE,gCAAA;A/Cu7oDF;A+Cr7oDA;EACE,gCAAA;A/Cu7oDF;A+Cr7oDA;;EAEE,gCAAA;A/Cu7oDF;A+Cr7oDA;EACE,gCAAA;A/Cu7oDF;A+Cr7oDA;;EAEE,gCAAA;A/Cu7oDF;A+Cr7oDA;;EAEE,gCAAA;A/Cu7oDF;AACA,kBAAkB;A+Cp7oDlB;;;;;;;;;EASE,yBAAA;A/Cs7oDF;A+Cp7oDA;;;;;;;;;EASE,gCAAA;A/Cs7oDF;AACA,uBAAuB;A+Cn7oDvB;EACE,cAAA;A/Cq7oDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A+C/6oDhB;EACE,oCAAA;A/Ci7oDF;A+C/6oDA;;EAEE,0BAAA;A/Ci7oDF;A+C/6oDA;EACE,cAAA;A/Ci7oDF;AACA;;gBAEgB;A+C76oDhB;EACE,oCAAA;A/C+6oDF;A+C76oDA;;EAEE,0BAAA;A/C+6oDF;A+C76oDA;EACE,cAAA;A/C+6oDF;AACA;;gBAEgB;A+C36oDhB;EACE,oCAAA;A/C66oDF;A+C36oDA;;EAEE,0BAAA;A/C66oDF;A+C36oDA;EACE,cAAA;A/C66oDF;AACA;;gBAEgB;A+Cz6oDhB;EACE,kBAAA;EACA,cAAA;A/C26oDF;A+Cz6oDA;EACE,WAAA;EACA,UAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EAEA,4BAAA;EAEA,2CAAA;A/Cw6oDF;A+Ct6oDA;EACE;IACE,YAAA;IACA,QAAA;E/Cw6oDF;E+Cp6oDA;IACE,UAAA;IACA,WAAA;E/Cs6oDF;AACF;AACA;;gBAEgB;A+Cl6oDhB;EACE,aAAA;A/Co6oDF;A+Cl6oDA;;EAEE,0BAAA;A/Co6oDF;AACA;;+BAE+B;AAC/B;;gBAEgB;A+C75oDhB;EACE,qCAAA;EACA,YAAA;A/C+5oDF;A+C75oDA;EACE,mBAAA;A/C+5oDF;A+C75oDA;EACE,cAAA;A/C+5oDF;A+C75oDA;EACE,cAAA;A/C+5oDF;A+C75oDA;EACE,cAAA;A/C+5oDF;A+C75oDA;EACE,cAAA;A/C+5oDF;A+C75oDA;EACE,cAAA;A/C+5oDF;AACA;;gBAEgB;AAChB,oBAAoB;A+C35oDpB;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;A/C65oDF;A+C35oDA;;EAEE,cAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kDAAA;A/C65oDF;A+C35oDA;EACE,kBAAA;A/C65oDF;AACA,iBAAiB;A+C15oDjB;;EAEE,QAAA;EACA,kDAAA;A/C45oDF;A+C15oDA;EACE,kBAAA;A/C45oDF;AACA,aAAa;A+Cz5oDb;;EAEE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;A/C25oDF;A+Cz5oDA;;EAEE,SAAA;EACA,YAAA;A/C25oDF;AACA;;gBAEgB;AAChB,QAAQ;A+Cv5oDR;EACE,yBAAA;A/Cy5oDF;A+Cv5oDA;EACE,yBAAA;A/Cy5oDF;AACA,WAAW;A+Ct5oDX;EACE,yBAAA;A/Cw5oDF;A+Ct5oDA;EACE,yBAAA;A/Cw5oDF;AACA,WAAW;A+Cr5oDX;EACE,yBAAA;A/Cu5oDF;A+Cr5oDA;EACE,yBAAA;A/Cu5oDF;AACA,UAAU;A+Cp5oDV;EACE,yBAAA;A/Cs5oDF;A+Cp5oDA;EACE,yBAAA;A/Cs5oDF;AACA,UAAU;A+Cn5oDV;EACE,yBAAA;A/Cq5oDF;A+Cn5oDA;EACE,yBAAA;A/Cq5oDF;AACA,SAAS;A+Cl5oDT;EACE,yBAAA;A/Co5oDF;A+Cl5oDA;EACE,yBAAA;A/Co5oDF;AACA,SAAS;A+Cj5oDT;EACE,yBAAA;A/Cm5oDF;A+Cj5oDA;EACE,yBAAA;A/Cm5oDF;AACA,WAAW;A+Ch5oDX;EACE,yBAAA;A/Ck5oDF;A+Ch5oDA;EACE,yBAAA;A/Ck5oDF;AACA,WAAW;A+C/4oDX;EACE,yBAAA;A/Ci5oDF;A+C/4oDA;EACE,yBAAA;A/Ci5oDF;AACA,SAAS;A+C94oDT;EACE,yBAAA;A/Cg5oDF;A+C94oDA;EACE,yBAAA;A/Cg5oDF;AACA,UAAU;A+C74oDV;EACE,yBAAA;A/C+4oDF;A+C74oDA;EACE,yBAAA;A/C+4oDF;AACA,SAAS;A+C54oDT;EACE,yBAAA;A/C84oDF;A+C54oDA;EACE,yBAAA;A/C84oDF;AACA,UAAU;A+C34oDV;EACE,yBAAA;A/C64oDF;A+C34oDA;EACE,yBAAA;A/C64oDF;AACA;;gBAEgB;A+Cz4oDhB;EACE,wBAAA;A/C24oDF;A+Cz4oDA;EACE,aAAA;A/C24oDF;A+Cx4oDA;EACE,wBAAA;A/C04oDF;A+Cx4oDA;EACE,WAAA;A/C04oDF;A+Cv4oDA;EACE,eAAA;A/Cy4oDF;A+Cv4oDA;EACE,cAAA;A/Cy4oDF;A+Ct4oDA;EACE,wBAAA;A/Cw4oDF;A+Ct4oDA;EACE,aAAA;A/Cw4oDF;A+Cr4oDA;EACE,wBAAA;A/Cu4oDF;A+Cr4oDA;EACE,aAAA;A/Cu4oDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,SAAS;AACT,UAAU;AACV;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,SAAS;AACT,UAAU;AACV;;qBAEqB;AACrB;;qBAEqB;AACrB,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AgD1/qD/B;EACE,oBAAA;EACA,mBAAA;EACA,wBAAA;AhD4/qDF;AgD1/qDA;EACE,iBAAA;AhD4/qDF;AACA,SAAS;AgDz/qDT;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,2FAAA;AhD2/qDF;AACA;;+BAE+B;AAC/B;;qBAEqB;AACrB,kBAAkB;AgDp/qDlB;EACE,uBAAA;EACA,0BAAA;AhDs/qDF;AACA,gBAAgB;AgDn/qDhB;EACE,uBAAA;EACA,gCAAA;AhDq/qDF;AACA,kBAAkB;AgDl/qDlB;;EAEE,uBAAA;EACA,gCAAA;AhDo/qDF;AACA;;qBAEqB;AACrB,aAAa;AgD/+qDb;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;AhDi/qDF;AACA,gBAAgB;AgD9+qDhB;EACE,kCAAA;EACA,yBAAA;EACA,4GAAA;AhDg/qDF;AACA,kBAAkB;AgD7+qDlB;;EAEE,kCAAA;EACA,yBAAA;EACA,4GAAA;AhD++qDF;AACA;;qBAEqB;AgD1+qDrB;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;AhD4+qDF;AACA,iBAAiB;AgDz+qDjB;EACE,kCAAA;EACA,yBAAA;EACA,4GAAA;AhD2+qDF;AACA,mBAAmB;AgDx+qDnB;;EAEE,kCAAA;EACA,yBAAA;EACA,4GAAA;AhD0+qDF;AACA;;+BAE+B;AAC/B;;qBAEqB;AACrB,oBAAoB;AgDp+qDpB;EACE,eAAA;AhDs+qDF;AACA;;qBAEqB;AACrB,oBAAoB;AgDj+qDpB;EACE,UAAA;AhDm+qDF;AgDj+qDA;;EAEE,UAAA;AhDm+qDF;AACA;;+BAE+B;AgD79qD/B;EACE,wBAAA;AhD+9qDF;AgD79qDA;EACE,wBAAA;AhD+9qDF;AgD79qDA;EACE,wBAAA;AhD+9qDF;AgD79qDA;EACE,eAAA;AhD+9qDF;AgD79qDA;EACE,wBAAA;AhD+9qDF;AgD79qDA;EACE,wBAAA;AhD+9qDF;AgD79qDA;EACE,eAAA;AhD+9qDF;AACA;;+BAE+B;AiDxprD/B;EACE,qBAAA;EACA,yHAAA;EAIA,mBAAA;EACA,kBAAA;AjDuprDF;AiDrprDA;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AjDuprDF;AACA,eAAe;AiDpprDf;EACE,gBAAA;AjDsprDF;AACA,gBAAgB;AiDpprDhB;EACE,gBAAA;AjDsprDF;AACA;;qBAEqB;AACrB,kBAAkB;AiDlprDlB;EACE,gBAAA;AjDoprDF;AACA,gBAAgB;AiDlprDhB;EACE,gBAAA;AjDoprDF;AACA,YAAY;AiDjprDZ;EACE,gBAAA;AjDmprDF;AiDjprDA;EACE,gBAAA;AjDmprDF;AACA;;qBAEqB;AACrB;;;;CAIC;AiD/orDD;EACE,gBAAA;AjDiprDF;AACA,WAAW;AiD/orDX;EACE,gBAAA;AjDiprDF;AACA;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,kBAAkB;AAClB,WAAW;AACX,eAAe;AACf,WAAW;AACX,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB,UAAU;AACV,oBAAoB;AACpB,qBAAqB;AACrB;;+BAE+B;AAC/B,UAAU;AACV,UAAU;AACV,YAAY;AACZ,oBAAoB;AACpB,kBAAkB;AAClB;;+BAE+B;AAC/B,cAAc;AACd,aAAa;AACb,mBAAmB;AACnB;;+BAE+B;AAC/B,kBAAkB;AAClB,WAAW;AACX,eAAe;AACf,WAAW;AACX,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB,UAAU;AACV,oBAAoB;AACpB,qBAAqB;AACrB;;+BAE+B;AAC/B,UAAU;AACV,UAAU;AACV,YAAY;AACZ,oBAAoB;AACpB,kBAAkB;AAClB;;+BAE+B;AAC/B,cAAc;AACd,aAAa;AACb,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AkDt2sD/B;EACE,kBAAA;AlDw2sDF;AkDr2sDA;EACE,WAAA;EACA,aAAA;EACA,wBAAA;EACA,mDAAA;EAEA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,yBAAA;EACA,cAAA;EAEA,qCAAA;EACA,2CAAA;EACA,gCAAA;EACA,6CAAA;EACA,qGAAA;AlDo2sDF;AkDj2sDA;EACE,qBAAA;AlDm2sDF;AACA;;gBAEgB;AkD91sDhB;EACE,eAAA;AlDg2sDF;AACA;;gBAEgB;AkD51sDhB;EACE,aAAA;EAEA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,mBAAA;EAEA,iBAAA;EACA,WAAA;EAEA,4BAAA;EACA,2FAAA;EACA,yBAAA;EACA,YAAA;AlD01sDF;AkDx1sDA;EACE,kDAAA;AlD01sDF;AkDx1sDA;EACE,kDAAA;AlD01sDF;AACA;;gBAEgB;AkDt1sDhB;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,gCAAA;EACA,iBAAA;EACA,iDAAA;AlDw1sDF;AkDt1sDA;EACE,8BAAA;AlDw1sDF;AACA,UAAU;AkDr1sDV;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;AlDu1sDF;AkDr1sDA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AlDu1sDF;AACA;;gBAEgB;AkDn1sDhB;EACE,uBAAA;AlDq1sDF;AkDl1sDA;EACE,6BAAA;EACA,mEAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AlDo1sDF;AkDl1sDA;EACE,aAAA;EACA,uBAAA;EACA,+BAAA;AlDo1sDF;AkDl1sDA;EACE,YAAA;EACA,cAAA;AlDo1sDF;AACA;;gBAEgB;AkDh1sDhB;EACE,gBAAA;AlDk1sDF;AkDh1sDA;EACE,mEAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AlDk1sDF;AkDh1sDA;EACE,mBAAA;EACA,cAAA;EACA,gCAAA;AlDk1sDF;AACA,qBAAqB;AkD/0sDrB;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;AlDi1sDF;AACA;;+BAE+B;AAC/B;;sBAEsB;AkD30sDtB;EACE,uCAAA;EACA,qCAAA;EACA,gCAAA;AlD60sDF;AACA;;sBAEsB;AkDz0sDtB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,sCAAA;AlDy0sDF;AkDv0sDA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;AlDo0sDF;AACA;;gBAEgB;AkD/zsDhB;;EAEE,mBAAA;AlDi0sDF;AkD/zsDA;EACE,mBAAA;AlDi0sDF;AACA;;gBAEgB;AkD7zsDhB;EACE,mBAAA;AlD+zsDF;AkD7zsDA;EACE,gCAAA;AlD+zsDF;AkD5zsDA;;EAEE,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AlD8zsDF;AkD5zsDA;EACE,gCAAA;AlD8zsDF;AkD5zsDA;EACE,gCAAA;AlD8zsDF;AACA;;uBAEuB;AACvB,aAAa;AkD1zsDb;EACE,eAAA;EACA,oBAAA;EACA,aAAA;AlD4zsDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AkDtzsDhB;EACE,4BAAA;AlDwzsDF;AACA,iBAAiB;AkDrzsDjB;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,8CAAA;AlDuzsDF;AkDrzsDA;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AlDuzsDF;AkDrzsDA;EACE,gBAAA;AlDuzsDF;AkDrzsDA;EACE,UAAA;EACA,cAAA;AlDuzsDF;AACA;;gBAEgB;AkDlzsDhB;EACE,WAAA;AlDozsDF;AkDjzsDA;;EAEE,cAAA;AlDmzsDF;AACA,aAAa;AkDhzsDb;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wDAAA;AlDkzsDF;AACA,kBAAkB;AkD/ysDlB;EACE,mBAAA;AlDizsDF;AACA,iBAAiB;AkD9ysDjB;EACE,wCAAA;AlDgzsDF;AkD9ysDA;EACE,wCAAA;AlDgzsDF;AACA,yBAAyB;AkD7ysDzB;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mEAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,iDAAA;AlD+ysDF;AACA,oBAAoB;AkD5ysDpB;EACE,mBAAA;EACA,mBAAA;EACA,gDAAA;EACA,iDAAA;AlD8ysDF;AkD5ysDA;EACE,iDAAA;EACA,wDAAA;EACA,kCAAA;AlD8ysDF;AACA;;+BAE+B;AAC/B;;qBAEqB;AkDzysDrB;EACE,WAAA;EACA,QAAA;AlD2ysDF;AkDzysDA;EACE,SAAA;EACA,UAAA;AlD2ysDF;AACA;;gBAEgB;AkDvysDhB;EACE,WAAA;AlDyysDF;AACA;;gBAEgB;AkDpysDhB;EACE,uBAAA;AlDsysDF;AkDpysDA;EACE,uBAAA;AlDsysDF;AkDpysDA;EACE,cAAA;AlDsysDF;AkDpysDA;EACE,uBAAA;AlDsysDF;AkDpysDA;EACE,uBAAA;AlDsysDF;AkDpysDA;EACE,uBAAA;AlDsysDF;AkDpysDA;EACE,uBAAA;AlDsysDF;AACA;;gBAEgB;AkDlysDhB;EACE;IACE,6BAAA;ElDoysDF;AACF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,cAAc;AACd,SAAS;AACT;;gBAEgB;AAChB,SAAS;AACT,mBAAmB;AACnB;;+BAE+B;AAC/B,cAAc;AACd,SAAS;AACT;;gBAEgB;AAChB,SAAS;AACT,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AmDn1uD/B;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8GAAA;AnDq1uDF;AmDl1uDA;EACE,4BAAA;AnDo1uDF;AmDj1uDA;EACE,UAAA;EACA,WAAA;EAEA,sBAAA;EACA,2BAAA;AnDk1uDF;AmD/0uDA;EACE,aAAA;AnDi1uDF;AmD90uDA;EACE,uCAAA;AnDg1uDF;AACA;;+BAE+B;AmD50uD/B;EACE,eAAA;EACA,YAAA;EAEA,YAAA;EAEA,yBAAA;EACA,gCAAA;EACA,0CAAA;AnD40uDF;AmD10uDA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;EACA,iBAAA;AnD20uDF;AmDz0uDA;EACE,mBAAA;EACA,sBAAA;EACA,cAAA;AnD20uDF;AACA;;+BAE+B;AmDv0uD/B;EACE,gBAAA;AnDy0uDF;AmDv0uDA;EACE,mBAAA;AnDy0uDF;AmDv0uDA;EACE,mBAAA;AnDy0uDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AmDn0uDhB;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AnDq0uDF;AACA;;gBAEgB;AmDh0uDhB;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;AnDk0uDF;AmDh0uDA;EACE,YAAA;AnDk0uDF;AACA;;gBAEgB;AmD7zuDhB;EACE,kBAAA;AnD+zuDF;AmD7zuDA;EACE,8GAAA;AnD+zuDF;AmD7zuDA;EACE,oCAAA;AnD+zuDF;AACA;;gBAEgB;AmD3zuDhB;EACE,cAAA;AnD6zuDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB,cAAc;AACd,WAAW;AACX,qBAAqB;AACrB,WAAW;AACX,aAAa;AACb;;qBAEqB;AACrB,UAAU;AACV,WAAW;AACX,mBAAmB;AACnB;;+BAE+B;AAC/B;;qBAEqB;AACrB,cAAc;AACd,WAAW;AACX,qBAAqB;AACrB,WAAW;AACX,aAAa;AACb;;qBAEqB;AACrB,UAAU;AACV,WAAW;AACX,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AAC/B,iBAAiB;AoDhlwDjB;EACE,eAAA;EACA,MAAA;EACA,OAAA;EAEA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iCAAA;EAEA,uBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;ApDglwDF;AACA,kCAAkC;AoD7kwDlC;EACE,2BAAA;ApD+kwDF;AACA;;gBAEgB;AoD1kwDhB;EACE,WAAA;EACA,SAAA;EACA,mCAAA;ApD4kwDF;AoD1kwDA;EACE,qBAAA;EACA,qBAAA;EACA,mCAAA;ApD4kwDF;AoDzkwDA;;EAEE,sBAAA;EACA,uBAAA;ApD2kwDF;AoDzkwDA;EACE,mBAAA;EACA,uBAAA;EACA,mCAAA;ApD2kwDF;AoDzkwDA;EACE,oBAAA;EACA,sBAAA;EACA,kCAAA;ApD2kwDF;AACA;;gBAEgB;AoDtkwDhB;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;ApDwkwDF;AACA,eAAe;AoDrkwDf;EACE,8BAAA;ApDukwDF;AACA,iBAAiB;AoDpkwDjB;EACE,+BAAA;ApDskwDF;AoDpkwDA;;;EAGE,kBAAA;ApDskwDF;AACA;;gBAEgB;AoDjkwDhB;EACE,eAAA;EACA,2BAAA;EAEA,gCAAA;EACA,sBAAA;EACA,YAAA;ApDkkwDF;AACA;;gBAEgB;AoD9jwDhB;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,UAAA;ApDgkwDF;AoD7jwDA;EACE,mBAAA;ApD+jwDF;AACA,kDAAkD;AoD5jwDlD;EACE,mBAAA;ApD8jwDF;AACA;;gBAEgB;AoD1jwDhB;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;ApD4jwDF;AACA;;gBAEgB;AoDxjwDhB;EACE,6BAAA;ApD0jwDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AoDrjwDhB;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;ApDujwDF;AACA;;gBAEgB;AoDnjwDhB;EACE,mBAAA;ApDqjwDF;AACA;;gBAEgB;AoDjjwDhB;EACE,mBAAA;EACA,+BAAA;ApDmjwDF;AACA,qBAAqB;AoDhjwDrB;;EAEE,kDAAA;ApDkjwDF;AoDhjwDA;;EAEE,kDAAA;ApDkjwDF;AACA,oBAAoB;AoD/iwDpB;;EAEE,mCAAA;ApDijwDF;AoD/iwDA;;EAEE,oCAAA;ApDijwDF;AoD/iwDA;;EAEE,kCAAA;ApDijwDF;AoD/iwDA;;EAEE,mCAAA;ApDijwDF;AACA,kDAAkD;AoD9iwDlD;;;;EAIE,+BAAA;ApDgjwDF;AACA;;gBAEgB;AAChB;;+BAE+B;AAC/B;;gBAEgB;AAChB,iBAAiB;AoDziwDjB;;EAEE,YAAA;ApD2iwDF;AoDziwDA;;EAEE,WAAA;ApD2iwDF;AoDziwDA;;EAEE,YAAA;ApD2iwDF;AoDziwDA;;EAEE,YAAA;ApD2iwDF;AoDziwDA;;EAEE,YAAA;ApD2iwDF;AACA,iBAAiB;AoDxiwDjB;;EAEE,mCAAA;ApD0iwDF;AoDxiwDA;;EAEE,kCAAA;ApD0iwDF;AoDxiwDA;;EAEE,mCAAA;ApD0iwDF;AoDxiwDA;;EAEE,mCAAA;ApD0iwDF;AACA,kBAAkB;AoDviwDlB;;EAEE,oCAAA;ApDyiwDF;AoDviwDA;;EAEE,mCAAA;ApDyiwDF;AoDviwDA;;EAEE,oCAAA;ApDyiwDF;AoDviwDA;;EAEE,oCAAA;ApDyiwDF;AACA;;+BAE+B;AAC/B;;gBAEgB;AAChB,WAAW;AoDliwDX;EACE,YAAA;ApDoiwDF;AACA,YAAY;AoDjiwDZ;EACE,oCAAA;ApDmiwDF;AoDjiwDA;EACE,mCAAA;ApDmiwDF;AoDjiwDA;EACE,oCAAA;ApDmiwDF;AoDjiwDA;EACE,mCAAA;ApDmiwDF;AACA,cAAc;AoDhiwDd;;EAEE,gCAAA;ApDkiwDF;AACA,kBAAkB;AoD/hwDlB;EACE,iCAAA;ApDiiwDF;AoD/hwDA;EACE,iCAAA;ApDiiwDF;AoD/hwDA;EACE,iCAAA;ApDiiwDF;AoD/hwDA;EACE,iCAAA;ApDiiwDF;AACA,iBAAiB;AoD9hwDjB;;EAEE,0BAAA;ApDgiwDF;AACA;;gBAEgB;AAChB,YAAY;AoD1hwDZ;EACE,gCAAA;EACA,YAAA;ApD4hwDF;AACA,sBAAsB;AoDzhwDtB;EACE,mCAAA;ApD2hwDF;AoDzhwDA;EACE,kCAAA;ApD2hwDF;AoDzhwDA;EACE,oCAAA;ApD2hwDF;AoDzhwDA;EACE,mCAAA;ApD2hwDF;AACA,QAAQ;AoDxhwDR;EACE,gCAAA;ApD0hwDF;AACA;;gBAEgB;AAChB,YAAY;AoDrhwDZ;EACE,+BAAA;EACA,UAAA;ApDuhwDF;AACA,QAAQ;AoDphwDR;EACE,+BAAA;EACA,gCAAA;ApDshwDF;AACA;;gBAEgB;AAChB,YAAY;AoDjhwDZ;EACE,UAAA;ApDmhwDF;AACA,sBAAsB;AoDhhwDtB;EACE,kCAAA;ApDkhwDF;AoDhhwDA;EACE,iCAAA;ApDkhwDF;AoDhhwDA;EACE,kCAAA;ApDkhwDF;AoDhhwDA;EACE,kCAAA;ApDkhwDF;AACA,cAAc;AoD/gwDd;EACE,gCAAA;ApDihwDF;AACA,QAAQ;AoD9gwDR;EACE,gCAAA;ApDghwDF;AACA;;gBAEgB;AAChB,YAAY;AoD3gwDZ;EACE,UAAA;ApD6gwDF;AACA,sBAAsB;AoD1gwDtB;EACE,iCAAA;ApD4gwDF;AoD1gwDA;EACE,kCAAA;ApD4gwDF;AoD1gwDA;EACE,kCAAA;ApD4gwDF;AoD1gwDA;EACE,mCAAA;ApD4gwDF;AACA,cAAc;AoDzgwDd;EACE,gCAAA;ApD2gwDF;AACA,QAAQ;AoDxgwDR;EACE,gCAAA;ApD0gwDF;AACA;;gBAEgB;AAChB,YAAY;AoDtgwDZ;EACE,gCAAA;EACA,YAAA;ApDwgwDF;AACA,uBAAuB;AoDrgwDvB;EACE,mCAAA;ApDugwDF;AoDrgwDA;EACE,kCAAA;ApDugwDF;AoDrgwDA;EACE,oCAAA;ApDugwDF;AoDrgwDA;EACE,mCAAA;ApDugwDF;AACA,qBAAqB;AoDpgwDrB;EACE,yBAAA;ApDsgwDF;AoDpgwDA;EACE,yBAAA;ApDsgwDF;AoDpgwDA;EACE,yBAAA;ApDsgwDF;AoDpgwDA;EACE,yBAAA;ApDsgwDF;AACA,cAAc;AoDngwDd;EACE,gCAAA;ApDqgwDF;AoDngwDA;;EAEE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;ApDqgwDF;AACA,QAAQ;AoDlgwDR;EACE,+BAAA;ApDogwDF;AoDlgwDA;EACE,sBAAA;ApDogwDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB;;+BAE+B;AAC/B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AqDloyD/B;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;ArDooyDF;AACA;;+BAE+B;AAC/B,UAAU;AqDhoyDV;EACE,kBAAA;EACA,UAAA;EACA,WAAA;ArDkoyDF;AACA,UAAU;AqD/nyDV;EACE,eAAA;EACA,UAAA;EACA,WAAA;ArDioyDF;AACA,yBAAyB;AqD9nyDzB;;EAEE,QAAA;EACA,YAAA;ArDgoyDF;AqD9nyDA;;EAEE,SAAA;EACA,WAAA;ArDgoyDF;AACA;;+BAE+B;AqD3nyD/B;EACE,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;ArD6nyDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,YAAY;AACZ,mBAAmB;AACnB;;+BAE+B;AAC/B,YAAY;AACZ,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AsD7yzD/B;EACE,aAAA;AtD+yzDF;AACA;;+BAE+B;AAC/B;;sBAEsB;AsD1yzDtB;;EAEE,cAAA;AtD4yzDF;AACA;;sBAEsB;AsDxyzDtB;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AtD0yzDF;AsDxyzDA;EACE,6BAAA;EACA,yBAAA;AtD0yzDF;AsDvyzDA;;EAEE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EAEA,+BAAA;EACA,YAAA;EACA,aAAA;EAEA,qBAAA;EACA,sCAAA;AtDuyzDF;AsDryzDA;;EAEE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EAEA,+BAAA;EACA,YAAA;EACA,aAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,qBAAA;EAEA,6CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,uCAAA;AtDkyzDF;AACA;;+BAE+B;AAC/B;;;;;;;;EAQE;AACF;;+BAE+B;AAC/B;;;;;;;;;CASC;AACD;;+BAE+B;AAC/B;;CAEC;AACD,WAAW;AACX,aAAa;AACb,gBAAgB;AAChB,YAAY;AACZ,UAAU;AACV;;+BAE+B;AAC/B,2BAA2B;AAC3B,iCAAiC;AACjC;;+BAE+B;AAC/B;;+BAE+B;AAC/B;;oBAEoB;AACpB;;sBAEsB;AACtB,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,4BAA4B;AAC5B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,+BAA+B;AAC/B;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,uDAAuD;AACvD,2BAA2B;AAC3B;;qBAEqB;AACrB;;CAEC;AACD;;qBAEqB;AACrB;;gBAEgB;AAChB;;gBAEgB;AAChB,4DAA4D;AAC5D,qBAAqB;AACrB,oFAAoF;AACpF;;qBAEqB;AACrB,iCAAiC;AACjC,2CAA2C;AAC3C;;qBAEqB;AACrB;;;CAGC;AACD;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,aAAa;AACb;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,8BAA8B;AAC9B,0BAA0B;AAC1B,uBAAuB;AACvB,yBAAyB;AACzB;;qBAEqB;AACrB;;qBAEqB;AACrB,6BAA6B;AAC7B,2BAA2B;AAC3B;;+BAE+B;AAC/B;;qBAEqB;AACrB,aAAa;AACb,aAAa;AACb,SAAS;AACT,YAAY;AACZ;;qBAEqB;AACrB,+CAA+C;AAC/C;;qBAEqB;AACrB;;;CAGC;AACD,OAAO;AACP,QAAQ;AACR;;qBAEqB;AACrB,gCAAgC;AAChC;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB;;qBAEqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,0DAA0D;AAC1D,mCAAmC;AACnC,mBAAmB;AACnB,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf;;qBAEqB;AACrB;;;;;;;;CAQC;AACD,YAAY;AACZ;;+BAE+B;AAC/B;;qBAEqB;AACrB;;qBAEqB;AACrB,oBAAoB;AACpB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB;;qBAEqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,8BAA8B;AAC9B;;sBAEsB;AACtB,YAAY;AACZ;;+BAE+B;AAC/B,mBAAmB;AACnB;;+BAE+B;AAC/B,eAAe;AACf;;+BAE+B;AAC/B;;oBAEoB;AACpB;;oBAEoB;AACpB,eAAe;AACf;;+BAE+B;AuDp+0D/B;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,yBAAA;AvDs+0DF;AACA;;+BAE+B;AAC/B,cAAc;AuDj+0Dd;EACE,2BAAA;EACA,8BAAA;AvDm+0DF;AACA,YAAY;AuDh+0DZ;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AvDk+0DF;AACA,WAAW;AuD/90DX;EACE,aAAA;EACA,kBAAA;AvDi+0DF;AACA,YAAY;AuD990DZ;EACE,yBAAA;EACA,8BAAA;EvDg+0DA;iCAC+B;AACjC;AACA,aAAa;AuD790Db;EACE,4BAAA;AvD+90DF;AACA;;+BAE+B;AuD390D/B;EACE,mCAAA;AvD690DF;AACA;;+BAE+B;AAC/B;;;;;;CAMC;AACD;;gBAEgB;AwDni1DhB;EACE,yBAAA;AxDqi1DF;AwDni1DA;EACE,wBAAA;AxDqi1DF;AwDni1DA;;EAEE,6BAAA;AxDqi1DF;AwDni1DA;EACE,8BAAA;AxDqi1DF;AACA,OAAO;AwDli1DP;EACE;IACE,qCAAA;IACA,WAAA;ExDoi1DF;EwDli1DA;IACE,qCAAA;IACA,WAAA;IACA,YAAA;ExDoi1DF;EwDli1DA;IACE,sCAAA;IACA,UAAA;IACA,YAAA;ExDoi1DF;EwDli1DA;IACE,mCAAA;IACA,YAAA;ExDoi1DF;AACF;AACA,QAAQ;AwDji1DR;EACE;IACE,YAAA;IACA,qDAAA;ExDmi1DF;EwDji1DA;IACE,WAAA;IACA,4EAAA;ExDmi1DF;EwDji1DA;IACE,UAAA;ExDmi1DF;EwDji1DA;IACE,WAAA;IACA,uEAAA;IACA,UAAA;ExDmi1DF;AACF;AwDji1DA;EACE;IACE,YAAA;IACA,qDAAA;ExDmi1DF;EwDji1DA;IACE,UAAA;IACA,2EAAA;ExDmi1DF;EwDji1DA;IACE,UAAA;ExDmi1DF;EwDji1DA;IACE,UAAA;IACA,uEAAA;IACA,UAAA;ExDmi1DF;AACF;AACA;;gBAEgB;AwD9h1DhB;EACE,4BAAA;EACA,yBAAA;EACA,2DAAA;AxDgi1DF;AwD9h1DA;EACE,sBAAA;AxDgi1DF;AwD9h1DA;EACE,uBAAA;AxDgi1DF;AACA,SAAS;AwD7h1DT;EACE;IACE,UAAA;IACA,mBAAA;ExD+h1DF;EwD7h1DA;IACE,UAAA;IACA,mBAAA;ExD+h1DF;AACF;AwD7h1DA;EACE;IACE,UAAA;IACA,mBAAA;ExD+h1DF;EwD7h1DA;IACE,UAAA;IACA,mBAAA;ExD+h1DF;AACF;AACA;;gBAEgB;AwD3h1DhB;EACE,sBAAA;AxD6h1DF;AwD3h1DA;EACE,wBAAA;AxD6h1DF;AwD3h1DA;EACE,0BAAA;AxD6h1DF;AwD3h1DA;EACE,0BAAA;AxD6h1DF;AwD3h1DA;EACE,2BAAA;AxD6h1DF;AwD1h1DA;EACE,uBAAA;AxD4h1DF;AwD1h1DA;EACE,yBAAA;AxD4h1DF;AwD1h1DA;EACE,2BAAA;AxD4h1DF;AwD1h1DA;EACE,2BAAA;AxD4h1DF;AwD1h1DA;EACE,4BAAA;AxD4h1DF;AACA,OAAO;AwDzh1DP;EACE;IACE,UAAA;ExD2h1DF;EwDzh1DA;IACE,UAAA;ExD2h1DF;AACF;AwDzh1DA;EACE;IACE,UAAA;IACA,0BAAA;ExD2h1DF;EwDzh1DA;IACE,UAAA;IACA,yBAAA;ExD2h1DF;AACF;AwDzh1DA;EACE;IACE,UAAA;IACA,2BAAA;ExD2h1DF;EwDzh1DA;IACE,UAAA;IACA,yBAAA;ExD2h1DF;AACF;AwDzh1DA;EACE;IACE,UAAA;IACA,0BAAA;ExD2h1DF;EwDzh1DA;IACE,UAAA;IACA,yBAAA;ExD2h1DF;AACF;AwDzh1DA;EACE;IACE,UAAA;IACA,2BAAA;ExD2h1DF;EwDzh1DA;IACE,UAAA;IACA,yBAAA;ExD2h1DF;AACF;AACA,QAAQ;AwDxh1DR;EACE;IACE,UAAA;ExD0h1DF;EwDxh1DA;IACE,UAAA;ExD0h1DF;AACF;AwDxh1DA;EACE;IACE,UAAA;IACA,yBAAA;ExD0h1DF;EwDxh1DA;IACE,UAAA;IACA,yBAAA;ExD0h1DF;AACF;AwDxh1DA;EACE;IACE,UAAA;IACA,yBAAA;ExD0h1DF;EwDxh1DA;IACE,UAAA;IACA,0BAAA;ExD0h1DF;AACF;AwDxh1DA;EACE;IACE,UAAA;IACA,yBAAA;ExD0h1DF;EwDxh1DA;IACE,UAAA;IACA,yBAAA;ExD0h1DF;AACF;AwDxh1DA;EACE;IACE,UAAA;IACA,yBAAA;ExD0h1DF;EwDxh1DA;IACE,UAAA;IACA,0BAAA;ExD0h1DF;AACF;AACA;;gBAEgB;AwDth1DhB;;EAEE,yBAAA;AxDwh1DF;AwDth1DA;EACE,gCAAA;AxDwh1DF;AwDth1DA;EACE,iCAAA;AxDwh1DF;AwDth1DA;EACE,8BAAA;AxDwh1DF;AwDth1DA;EACE,+BAAA;AxDwh1DF;AACA,OAAO;AwDrh1DP;EACE;IACE,8CAAA;IACA,UAAA;ExDuh1DF;EwDrh1DA;IACE,4CAAA;IACA,UAAA;ExDuh1DF;AACF;AwDrh1DA;EACE;IACE,8CAAA;IACA,UAAA;ExDuh1DF;EwDrh1DA;IACE,4CAAA;IACA,UAAA;ExDuh1DF;AACF;AACA,QAAQ;AwDph1DR;EACE;IACE,4CAAA;IACA,UAAA;ExDsh1DF;EwDph1DA;IACE,6CAAA;IACA,UAAA;ExDsh1DF;AACF;AwDph1DA;EACE;IACE,4CAAA;IACA,UAAA;ExDsh1DF;EwDph1DA;IACE,8CAAA;IACA,UAAA;ExDsh1DF;AACF;AACA;;gBAEgB;AwDlh1DhB;EACE,uBAAA;AxDoh1DF;AwDlh1DA;EACE,wBAAA;AxDoh1DF;AwDjh1DA;EACE;IACE,UAAA;IACA,qBAAA;ExDmh1DF;EwDjh1DA;IACE,UAAA;IACA,mBAAA;ExDmh1DF;AACF;AACA,QAAQ;AwDhh1DR;EACE;IACE,UAAA;IACA,mBAAA;ExDkh1DF;EwDhh1DA;IACE,UAAA;IACA,qBAAA;ExDkh1DF;AACF;AACA;;gBAEgB;AAChB,WAAW;AwD7g1DX;EACE,wBAAA;EACA,+DAAA;AxD+g1DF;AwD7g1DA;EACE,qBAAA;AxD+g1DF;AwD7g1DA;EACE,uBAAA;AxD+g1DF;AwD7g1DA;EACE,yBAAA;AxD+g1DF;AwD7g1DA;EACE,yBAAA;AxD+g1DF;AwD7g1DA;EACE,0BAAA;AxD+g1DF;AACA,YAAY;AwD5g1DZ;EACE,sBAAA;AxD8g1DF;AwD5g1DA;EACE,wBAAA;AxD8g1DF;AwD5g1DA;EACE,0BAAA;AxD8g1DF;AwD5g1DA;EACE,0BAAA;AxD8g1DF;AwD5g1DA;EACE,2BAAA;AxD8g1DF;AACA,OAAO;AwD3g1DP;EACE;IACE,UAAA;IACA,iCAAA;ExD6g1DF;EwD3g1DA;IACE,iCAAA;ExD6g1DF;EwD3g1DA;IACE,iCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,oCAAA;ExD6g1DF;EwD3g1DA;IACE,oCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,2BAAA;ExD6g1DF;AACF;AwD3g1DA;EACE;IACE,UAAA;IACA,oCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,mCAAA;ExD6g1DF;EwD3g1DA;IACE,kCAAA;ExD6g1DF;EwD3g1DA;IACE,kCAAA;ExD6g1DF;EwD3g1DA;IACE,+BAAA;ExD6g1DF;AACF;AwD3g1DA;EACE;IACE,UAAA;IACA,qCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,kCAAA;ExD6g1DF;EwD3g1DA;IACE,mCAAA;ExD6g1DF;EwD3g1DA;IACE,iCAAA;ExD6g1DF;EwD3g1DA;IACE,eAAA;ExD6g1DF;AACF;AwD3g1DA;EACE;IACE,UAAA;IACA,oCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,mCAAA;ExD6g1DF;EwD3g1DA;IACE,kCAAA;ExD6g1DF;EwD3g1DA;IACE,kCAAA;ExD6g1DF;EwD3g1DA;IACE,eAAA;ExD6g1DF;AACF;AwD3g1DA;EACE;IACE,UAAA;IACA,qCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,kCAAA;ExD6g1DF;EwD3g1DA;IACE,mCAAA;ExD6g1DF;EwD3g1DA;IACE,iCAAA;ExD6g1DF;EwD3g1DA;IACE,eAAA;ExD6g1DF;AACF;AACA,QAAQ;AwD1g1DR;EACE;IACE,iCAAA;ExD4g1DF;EwD1g1DA;;IACE,UAAA;IACA,iCAAA;ExD6g1DF;EwD3g1DA;IACE,UAAA;IACA,iCAAA;ExD6g1DF;AACF;AwD3g1DA;EACE;IACE,kCAAA;ExD6g1DF;EwD3g1DA;;IACE,UAAA;IACA,mCAAA;ExD8g1DF;EwD5g1DA;IACE,UAAA;IACA,oCAAA;ExD8g1DF;AACF;AwD5g1DA;EACE;IACE,mCAAA;ExD8g1DF;EwD5g1DA;;IACE,UAAA;IACA,kCAAA;ExD+g1DF;EwD7g1DA;IACE,UAAA;IACA,qCAAA;ExD+g1DF;AACF;AwD7g1DA;EACE;IACE,UAAA;IACA,kCAAA;ExD+g1DF;EwD7g1DA;IACE,UAAA;IACA,qCAAA;ExD+g1DF;AACF;AwD7g1DA;EACE;IACE,UAAA;IACA,mCAAA;ExD+g1DF;EwD7g1DA;IACE,UAAA;IACA,oCAAA;ExD+g1DF;AACF;AACA;;gBAEgB;AwD3g1DhB;;EAEE,wBAAA;EACA,4BAAA;AxD6g1DF;AwD3g1DA;EACE,wBAAA;EACA,+BAAA;AxD6g1DF;AwD3g1DA;EACE,wBAAA;EACA,8BAAA;AxD6g1DF;AwD3g1DA;EACE,wBAAA;EACA,6BAAA;AxD6g1DF;AwD1g1DA;;EAEE,yBAAA;EACA,4BAAA;AxD4g1DF;AwD1g1DA;EACE,yBAAA;EACA,+BAAA;AxD4g1DF;AwD1g1DA;EACE,yBAAA;EACA,8BAAA;AxD4g1DF;AwD1g1DA;EACE,yBAAA;EACA,6BAAA;AxD4g1DF;AACA,OAAO;AwDzg1DP;EACE;IACE,UAAA;IACA,oBAAA;ExD2g1DF;EwDzg1DA;IACE,UAAA;IACA,oBAAA;ExD2g1DF;AACF;AwDzg1DA;EACE;IACE,UAAA;IACA,oBAAA;ExD2g1DF;EwDzg1DA;IACE,UAAA;IACA,oBAAA;ExD2g1DF;AACF;AACA,QAAQ;AwDxg1DR;EACE;IACE,UAAA;IACA,oBAAA;ExD0g1DF;EwDxg1DA;IACE,UAAA;IACA,oBAAA;ExD0g1DF;AACF;AwDxg1DA;EACE;IACE,UAAA;IACA,oBAAA;ExD0g1DF;EwDxg1DA;IACE,UAAA;IACA,oBAAA;ExD0g1DF;AACF;AACA;;gBAEgB;AwDrg1DhB;EACE,yBAAA;AxDug1DF;AwDpg1DA;EACE,wBAAA;EACA,4BAAA;AxDsg1DF;AwDpg1DA;EACE,wBAAA;EACA,+BAAA;AxDsg1DF;AwDpg1DA;EACE,wBAAA;EACA,8BAAA;AxDsg1DF;AwDpg1DA;EACE,wBAAA;EACA,6BAAA;AxDsg1DF;AwDng1DA;;EAEE,yBAAA;EACA,4BAAA;AxDqg1DF;AwDng1DA;EACE,yBAAA;EACA,+BAAA;AxDqg1DF;AwDng1DA;EACE,yBAAA;EACA,8BAAA;AxDqg1DF;AwDng1DA;EACE,yBAAA;EACA,6BAAA;AxDqg1DF;AACA,OAAO;AwDlg1DP;EACE;IACE,6CAAA;IACA,UAAA;ExDog1DF;EwDlg1DA;IACE,8CAAA;IACA,UAAA;ExDog1DF;EwDlg1DA;IACE,6CAAA;ExDog1DF;EwDlg1DA;IACE,+CAAA;ExDog1DF;EwDlg1DA;IACE,4CAAA;ExDog1DF;AACF;AwDlg1DA;EACE;IACE,8CAAA;IACA,UAAA;ExDog1DF;EwDlg1DA;IACE,6CAAA;IACA,UAAA;ExDog1DF;EwDlg1DA;IACE,gDAAA;ExDog1DF;EwDlg1DA;IACE,8CAAA;ExDog1DF;EwDlg1DA;IACE,4CAAA;ExDog1DF;AACF;AACA,QAAQ;AwDjg1DR;EACE;IACE,4CAAA;ExDmg1DF;EwDjg1DA;IACE,+CAAA;ExDmg1DF;EwDjg1DA;IACE,+CAAA;ExDmg1DF;EwDjg1DA;IACE,8CAAA;IACA,UAAA;ExDmg1DF;EwDjg1DA;IACE,6CAAA;IACA,UAAA;ExDmg1DF;AACF;AwDjg1DA;EACE;IACE,4CAAA;ExDmg1DF;EwDjg1DA;IACE,8CAAA;ExDmg1DF;EwDjg1DA;IACE,8CAAA;ExDmg1DF;EwDjg1DA;IACE,6CAAA;IACA,UAAA;ExDmg1DF;EwDjg1DA;IACE,8CAAA;IACA,UAAA;ExDmg1DF;AACF;AACA;;gBAEgB;AwD9/0DhB;EACE,sBAAA;AxDgg1DF;AwD9/0DA;EACE,uBAAA;AxDgg1DF;AwD9/0DA;EACE;IACE,UAAA;IACA,mBAAA;ExDgg1DF;EwD9/0DA;IACE,UAAA;IACA,mBAAA;ExDgg1DF;AACF;AwD9/0DA;EACE;IACE,UAAA;IACA,mBAAA;ExDgg1DF;EwD9/0DA;IACE,UAAA;IACA,mBAAA;ExDgg1DF;AACF;AACA;;+BAE+B;AAC/B;;gBAEgB;AwDz/0DhB;EACE,yBAAA;EACA,qBAAA;AxD2/0DF;AwDz/0DA;EACE,yBAAA;EACA,qBAAA;AxD2/0DF;AwDz/0DA;EACE,yBAAA;EACA,sBAAA;AxD2/0DF;AwDz/0DA;EACE,yBAAA;EACA,oBAAA;AxD2/0DF;AwDz/0DA;EACE,yBAAA;EACA,qBAAA;AxD2/0DF;AwDz/0DA;EACE,yBAAA;EACA,sBAAA;AxD2/0DF;AwDz/0DA;EACE,0BAAA;EACA,yDAAA;AxD2/0DF;AwDz/0DA;EACE,oBAAA;AxD2/0DF;AACA,UAAU;AwDv/0DV;EACE;;;IACE,UAAA;ExD2/0DF;EwDz/0DA;;IACE,UAAA;ExD4/0DF;AACF;AACA,UAAU;AwDz/0DV;EACE;;IACE,wBAAA;ExD4/0DF;EwD1/0DA;;;;;IACE,4BAAA;ExDgg1DF;EwD9/0DA;;;;IACE,2BAAA;ExDmg1DF;AACF;AACA,WAAW;AwDhg1DX;EACE;;;;;IACE,wBAAA;ExDsg1DF;EwDpg1DA;IACE,4BAAA;ExDsg1DF;EwDpg1DA;IACE,4BAAA;ExDsg1DF;AACF;AACA,SAAS;AwDng1DT;EACE;IACE,mBAAA;ExDqg1DF;EwDng1DA;;IACE,mCAAA;ExDsg1DF;EwDpg1DA;;;;IACE,kCAAA;ExDyg1DF;EwDvg1DA;;;IACE,mCAAA;ExD2g1DF;EwDzg1DA;IACE,6BAAA;ExD2g1DF;AACF;AACA,UAAU;AwDxg1DV;EACE;IACE,mBAAA;IACA,UAAA;ExD0g1DF;EwDxg1DA;IACE,qBAAA;IACA,YAAA;ExD0g1DF;EwDxg1DA;IACE,mBAAA;IACA,UAAA;ExD0g1DF;AACF;AACA,WAAW;AwDtg1DX;EACE;IACE,2BAAA;ExDwg1DF;EwDtg1DA;IACE,iCAAA;ExDwg1DF;EwDtg1DA;IACE,iCAAA;ExDwg1DF;EwDtg1DA;IACE,iCAAA;ExDwg1DF;EwDtg1DA;IACE,iCAAA;ExDwg1DF;EwDtg1DA;IACE,iCAAA;ExDwg1DF;EwDtg1DA;IACE,2BAAA;ExDwg1DF;AACF;AACA,SAAS;AwDrg1DT;EACE;IACE,yBAAA;ExDug1DF;EwDrg1DA;IACE,yBAAA;ExDug1DF;EwDrg1DA;IACE,yBAAA;ExDug1DF;AACF","sourcesContent":["/*\n\n███████╗███████╗███╗   ███╗ █████╗ ███╗   ██╗████████╗██╗ ██████╗    ██╗   ██╗██╗\n██╔════╝██╔════╝████╗ ████║██╔══██╗████╗  ██║╚══██╔══╝██║██╔════╝    ██║   ██║██║\n███████╗█████╗  ██╔████╔██║███████║██╔██╗ ██║   ██║   ██║██║         ██║   ██║██║\n╚════██║██╔══╝  ██║╚██╔╝██║██╔══██║██║╚██╗██║   ██║   ██║██║         ██║   ██║██║\n███████║███████╗██║ ╚═╝ ██║██║  ██║██║ ╚████║   ██║   ██║╚██████╗    ╚██████╔╝██║\n╚══════╝╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚═╝ ╚═════╝     ╚═════╝ ╚═╝\n\n  Import this file into your LESS project to use Semantic UI without build tools\n*/\n/* Global */\n/*!\n * # Semantic UI - Reset\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Reset\n*******************************/\n/* Packaged Theme */\n/*******************************\n             Reset\n*******************************/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Reset\n*******************************/\n/* Border-Box */\n@import url('https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic&subset=latin');\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\nhtml {\n  box-sizing: border-box;\n}\n/* iPad Input Shadows */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"search\"],\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  /* mobile firefox too! */\n}\n/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n/* Document\n   ========================================================================== */\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\nhtml {\n  line-height: 1.15;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n/* Sections\n   ========================================================================== */\n/**\n * Remove the margin in all browsers (opinionated).\n */\nbody {\n  margin: 0;\n}\n/**\n * Add the correct display in IE 9-.\n */\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n/* Grouping content\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\nfigcaption,\nfigure,\nmain {\n  /* 1 */\n  display: block;\n}\n/**\n * Add the correct margin in IE 8.\n */\nfigure {\n  margin: 1em 40px;\n}\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box;\n  /* 1 */\n  height: 0;\n  /* 1 */\n  overflow: visible;\n  /* 2 */\n}\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\npre {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n/* Text-level semantics\n   ========================================================================== */\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\na {\n  background-color: transparent;\n  /* 1 */\n  -webkit-text-decoration-skip: objects;\n  /* 2 */\n}\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none;\n  /* 1 */\n  text-decoration: underline;\n  /* 2 */\n  text-decoration: underline dotted;\n  /* 2 */\n}\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\nb,\nstrong {\n  font-weight: inherit;\n}\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder;\n}\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n/**\n * Add the correct font style in Android 4.3-.\n */\ndfn {\n  font-style: italic;\n}\n/**\n * Add the correct background and color in IE 9-.\n */\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n/* Embedded content\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n */\naudio,\nvideo {\n  display: inline-block;\n}\n/**\n * Add the correct display in iOS 4-7.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n/**\n * Remove the border on images inside links in IE 10-.\n */\nimg {\n  border-style: none;\n}\n/**\n * Hide the overflow in IE.\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n/* Forms\n   ========================================================================== */\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  line-height: 1.15;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n}\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n}\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n/**\n * Correct the padding in Firefox.\n */\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\nlegend {\n  box-sizing: border-box;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  display: table;\n  /* 1 */\n  max-width: 100%;\n  /* 1 */\n  padding: 0;\n  /* 3 */\n  white-space: normal;\n  /* 1 */\n}\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n/**\n * Remove the default vertical scrollbar in IE.\n */\ntextarea {\n  overflow: auto;\n}\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n/* Interactive\n   ========================================================================== */\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\ndetails,\nmenu {\n  display: block;\n}\n/*\n * Add the correct display in all browsers.\n */\nsummary {\n  display: list-item;\n}\n/* Scripting\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n */\ncanvas {\n  display: inline-block;\n}\n/**\n * Add the correct display in IE.\n */\ntemplate {\n  display: none;\n}\n/* Hidden\n   ========================================================================== */\n/**\n * Add the correct display in IE 10-.\n */\n[hidden] {\n  display: none;\n}\n/*!\n * # Semantic UI - Site\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged Theme */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Page\n*******************************/\nhtml,\nbody {\n  height: 100%;\n}\nhtml {\n  font-size: 14px;\n}\nbody {\n  margin: 0px;\n  padding: 0px;\n  overflow-x: hidden;\n  min-width: 320px;\n  background: #FFFFFF;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 14px;\n  line-height: 1.4285em;\n  color: rgba(255, 255, 255, 0.87);\n  font-smoothing: antialiased;\n}\n/*******************************\n             Headers\n*******************************/\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  line-height: 1.28571429em;\n  margin: calc(2rem -  0.14285714em ) 0em 1rem;\n  font-weight: bold;\n  padding: 0em;\n}\nh1 {\n  min-height: 1rem;\n  font-size: 2rem;\n}\nh2 {\n  font-size: 1.71428571rem;\n}\nh3 {\n  font-size: 1.28571429rem;\n}\nh4 {\n  font-size: 1.07142857rem;\n}\nh5 {\n  font-size: 1rem;\n}\nh1:first-child,\nh2:first-child,\nh3:first-child,\nh4:first-child,\nh5:first-child {\n  margin-top: 0em;\n}\nh1:last-child,\nh2:last-child,\nh3:last-child,\nh4:last-child,\nh5:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n             Text\n*******************************/\np {\n  margin: 0em 0em 1em;\n  line-height: 1.4285em;\n}\np:first-child {\n  margin-top: 0em;\n}\np:last-child {\n  margin-bottom: 0em;\n}\n/*-------------------\n        Links\n--------------------*/\na {\n  color: #4183C4;\n  text-decoration: none;\n}\na:hover {\n  color: #1e70bf;\n  text-decoration: none;\n}\n/*******************************\n         Scrollbars\n*******************************/\n/*******************************\n          Highlighting\n*******************************/\n/* Site */\n::-webkit-selection {\n  background-color: #CCE2FF;\n  color: rgba(255, 255, 255, 0.87);\n}\n::-moz-selection {\n  background-color: #CCE2FF;\n  color: rgba(255, 255, 255, 0.87);\n}\n::selection {\n  background-color: #CCE2FF;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Form */\ntextarea::-webkit-selection,\ninput::-webkit-selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(255, 255, 255, 0.87);\n}\ntextarea::-moz-selection,\ninput::-moz-selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(255, 255, 255, 0.87);\n}\ntextarea::selection,\ninput::selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Force Simple Scrollbars */\nbody ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 10px;\n  height: 10px;\n}\nbody ::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 0px;\n}\nbody ::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, 0.25);\n  transition: color 0.2s ease;\n}\nbody ::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(0, 0, 0, 0.15);\n}\nbody ::-webkit-scrollbar-thumb:hover {\n  background: rgba(128, 135, 139, 0.8);\n}\n/* Inverted UI */\nbody .ui.inverted::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\nbody .ui.inverted::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\nbody .ui.inverted::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(255, 255, 255, 0.15);\n}\nbody .ui.inverted::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n/*******************************\n        Global Overrides\n*******************************/\n/* Elements */\n/*!\n * # Semantic UI - Button\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Button\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Button */\n/* Button defaults to using same height as input globally */\n/* Text */\n/* Internal Shadow */\n/* Box Shadow */\n/* Icon */\n/* Loader */\n/*\n@willChange: box-shadow, transform, opacity, color, background;\n*/\n/*-------------------\n        Group\n--------------------*/\n/*-------------------\n        States\n--------------------*/\n/* Hovered */\n/* Focused */\n/* Disabled */\n/* Pressed Down */\n/* Active */\n/* Active + Hovered */\n/* Loading */\n/*-------------------\n        Types\n--------------------*/\n/* Or */\n/* Icon */\n/* Labeled */\n/* hypotenuse of triangle */\n/* Labeled Icon */\n/* Inverted */\n/* Basic */\n/* Basic Hover */\n/* Basic Focus */\n/* Basic Down */\n/* Basic Active */\n/* Basic Inverted */\n/* Basic Group */\n/*-------------------\n      Variations\n--------------------*/\n/* Colors */\n/* Colored */\n/* Inverted */\n/* Ordinality */\n/* Compact */\n/* Attached */\n/* Floated */\n/* Animated */\n/* Packaged Theme */\n/*******************************\n            Button\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Button */\n/* Button defaults to using same height as input globally */\n/* Text */\n/* Internal Shadow */\n/* Box Shadow */\n/* Icon */\n/* Loader */\n/*\n@willChange: box-shadow, transform, opacity, color, background;\n*/\n/*-------------------\n        Group\n--------------------*/\n/*-------------------\n        States\n--------------------*/\n/* Hovered */\n/* Focused */\n/* Disabled */\n/* Pressed Down */\n/* Active */\n/* Active + Hovered */\n/* Loading */\n/*-------------------\n        Types\n--------------------*/\n/* Or */\n/* Icon */\n/* Labeled */\n/* hypotenuse of triangle */\n/* Labeled Icon */\n/* Inverted */\n/* Basic */\n/* Basic Hover */\n/* Basic Focus */\n/* Basic Down */\n/* Basic Active */\n/* Basic Inverted */\n/* Basic Group */\n/*-------------------\n      Variations\n--------------------*/\n/* Colors */\n/* Colored */\n/* Inverted */\n/* Ordinality */\n/* Compact */\n/* Attached */\n/* Floated */\n/* Animated */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Button\n*******************************/\n.ui.button {\n  cursor: pointer;\n  display: inline-block;\n  min-height: 1em;\n  outline: none;\n  border: none;\n  vertical-align: baseline;\n  background: #5855f4 none;\n  color: #eceff8;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  margin: 0em 0.25em 0em 0em;\n  padding: 0.78571429em 1.5em 0.78571429em;\n  text-transform: none;\n  text-shadow: none;\n  font-weight: bold;\n  line-height: 1em;\n  font-style: normal;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n  user-select: none;\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;\n  will-change: '';\n  -webkit-tap-highlight-color: transparent;\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n      Hover\n---------------*/\n.ui.button:hover {\n  background-color: #CACBCD;\n  background-image: none;\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.button:hover .icon {\n  opacity: 0.85;\n}\n/*--------------\n      Focus\n---------------*/\n.ui.button:focus {\n  background-color: #CACBCD;\n  color: rgba(255, 255, 255, 0.8);\n  background-image: '' !important;\n  box-shadow: '' !important;\n}\n.ui.button:focus .icon {\n  opacity: 0.85;\n}\n/*--------------\n      Down\n---------------*/\n.ui.button:active,\n.ui.active.button:active {\n  background-color: #BABBBC;\n  background-image: '';\n  color: rgba(255, 255, 255, 0.9);\n  box-shadow: 0px 0px 0px 1px transparent inset, none;\n}\n/*--------------\n     Active\n---------------*/\n.ui.active.button {\n  background-color: #C0C1C2;\n  background-image: none;\n  box-shadow: 0px 0px 0px 1px transparent inset;\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.active.button:hover {\n  background-color: #C0C1C2;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.active.button:active {\n  background-color: #C0C1C2;\n  background-image: none;\n}\n/*--------------\n    Loading\n---------------*/\n/* Specificity hack */\n.ui.loading.loading.loading.loading.loading.loading.button {\n  position: relative;\n  cursor: default;\n  text-shadow: none !important;\n  color: transparent !important;\n  opacity: 1;\n  pointer-events: auto;\n  transition: all 0s linear, opacity 0.1s ease;\n}\n.ui.loading.button:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.ui.loading.button:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  animation: button-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #FFFFFF transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n.ui.labeled.icon.loading.button .icon {\n  background-color: transparent;\n  box-shadow: none;\n}\n@keyframes button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ui.basic.loading.button:not(.inverted):before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.ui.basic.loading.button:not(.inverted):after {\n  border-top-color: #767676;\n}\n/*-------------------\n      Disabled\n--------------------*/\n.ui.buttons .disabled.button,\n.ui.disabled.button,\n.ui.button:disabled,\n.ui.disabled.button:hover,\n.ui.disabled.active.button {\n  cursor: default;\n  opacity: 0.45 !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n}\n/* Basic Group With Disabled */\n.ui.basic.buttons .ui.disabled.button {\n  border-color: rgba(255, 255, 255, 0.5);\n}\n/*******************************\n             Types\n*******************************/\n/*-------------------\n       Animated\n--------------------*/\n.ui.animated.button {\n  position: relative;\n  overflow: hidden;\n  padding-right: 0em !important;\n  vertical-align: middle;\n  z-index: 1;\n}\n.ui.animated.button .content {\n  will-change: transform, opacity;\n}\n.ui.animated.button .visible.content {\n  position: relative;\n  margin-right: 1.5em;\n}\n.ui.animated.button .hidden.content {\n  position: absolute;\n  width: 100%;\n}\n/* Horizontal */\n.ui.animated.button .visible.content,\n.ui.animated.button .hidden.content {\n  transition: right 0.3s ease 0s;\n}\n.ui.animated.button .visible.content {\n  left: auto;\n  right: 0%;\n}\n.ui.animated.button .hidden.content {\n  top: 50%;\n  left: auto;\n  right: -100%;\n  margin-top: -0.5em;\n}\n.ui.animated.button:focus .visible.content,\n.ui.animated.button:hover .visible.content {\n  left: auto;\n  right: 200%;\n}\n.ui.animated.button:focus .hidden.content,\n.ui.animated.button:hover .hidden.content {\n  left: auto;\n  right: 0%;\n}\n/* Vertical */\n.ui.vertical.animated.button .visible.content,\n.ui.vertical.animated.button .hidden.content {\n  transition: top 0.3s ease, transform 0.3s ease;\n}\n.ui.vertical.animated.button .visible.content {\n  transform: translateY(0%);\n  right: auto;\n}\n.ui.vertical.animated.button .hidden.content {\n  top: -50%;\n  left: 0%;\n  right: auto;\n}\n.ui.vertical.animated.button:focus .visible.content,\n.ui.vertical.animated.button:hover .visible.content {\n  transform: translateY(200%);\n  right: auto;\n}\n.ui.vertical.animated.button:focus .hidden.content,\n.ui.vertical.animated.button:hover .hidden.content {\n  top: 50%;\n  right: auto;\n}\n/* Fade */\n.ui.fade.animated.button .visible.content,\n.ui.fade.animated.button .hidden.content {\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n.ui.fade.animated.button .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 1;\n  transform: scale(1);\n}\n.ui.fade.animated.button .hidden.content {\n  opacity: 0;\n  left: 0%;\n  right: auto;\n  transform: scale(1.5);\n}\n.ui.fade.animated.button:focus .visible.content,\n.ui.fade.animated.button:hover .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 0;\n  transform: scale(0.75);\n}\n.ui.fade.animated.button:focus .hidden.content,\n.ui.fade.animated.button:hover .hidden.content {\n  left: 0%;\n  right: auto;\n  opacity: 1;\n  transform: scale(1);\n}\n/*-------------------\n       Inverted\n--------------------*/\n.ui.inverted.button {\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  background: transparent none;\n  color: #FFFFFF;\n  text-shadow: none !important;\n}\n/* Group */\n.ui.inverted.buttons .button {\n  margin: 0px 0px 0px -2px;\n}\n.ui.inverted.buttons .button:first-child {\n  margin-left: 0em;\n}\n.ui.inverted.vertical.buttons .button {\n  margin: 0px 0px -2px 0px;\n}\n.ui.inverted.vertical.buttons .button:first-child {\n  margin-top: 0em;\n}\n/* States */\n/* Hover */\n.ui.inverted.button:hover {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Active / Focus */\n.ui.inverted.button:focus,\n.ui.inverted.button.active {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Active Focus */\n.ui.inverted.button.active:focus {\n  background: #DCDDDE;\n  box-shadow: 0px 0px 0px 2px #DCDDDE inset !important;\n  color: rgba(255, 255, 255, 0.8);\n}\n/*-------------------\n    Labeled Button\n--------------------*/\n.ui.labeled.button:not(.icon) {\n  display: inline-flex;\n  flex-direction: row;\n  background: none !important;\n  padding: 0px !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n.ui.labeled.button > .button {\n  margin: 0px;\n}\n.ui.labeled.button > .label {\n  display: flex;\n  align-items: center;\n  margin: 0px 0px 0px -1px !important;\n  padding: '';\n  font-size: 1em;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n/* Tag */\n.ui.labeled.button > .tag.label:before {\n  width: 1.85em;\n  height: 1.85em;\n}\n/* Right */\n.ui.labeled.button:not([class*=\"left labeled\"]) > .button {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.ui.labeled.button:not([class*=\"left labeled\"]) > .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n/* Left Side */\n.ui[class*=\"left labeled\"].button > .button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n.ui[class*=\"left labeled\"].button > .label {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n/*-------------------\n       Social\n--------------------*/\n/* Facebook */\n.ui.facebook.button {\n  background-color: #3B5998;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.facebook.button:hover {\n  background-color: #304d8a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.facebook.button:active {\n  background-color: #2d4373;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Twitter */\n.ui.twitter.button {\n  background-color: #55ACEE;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.twitter.button:hover {\n  background-color: #35a2f4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.twitter.button:active {\n  background-color: #2795e9;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Google Plus */\n.ui.google.plus.button {\n  background-color: #DD4B39;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.google.plus.button:hover {\n  background-color: #e0321c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.google.plus.button:active {\n  background-color: #c23321;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Linked In */\n.ui.linkedin.button {\n  background-color: #1F88BE;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.linkedin.button:hover {\n  background-color: #147baf;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.linkedin.button:active {\n  background-color: #186992;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* YouTube */\n.ui.youtube.button {\n  background-color: #FF0000;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.youtube.button:hover {\n  background-color: #e60000;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.youtube.button:active {\n  background-color: #cc0000;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Instagram */\n.ui.instagram.button {\n  background-color: #49769C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.instagram.button:hover {\n  background-color: #3d698e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.instagram.button:active {\n  background-color: #395c79;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Pinterest */\n.ui.pinterest.button {\n  background-color: #BD081C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.pinterest.button:hover {\n  background-color: #ac0013;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.pinterest.button:active {\n  background-color: #8c0615;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* VK */\n.ui.vk.button {\n  background-color: #4D7198;\n  color: #FFFFFF;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.vk.button:hover {\n  background-color: #41648a;\n  color: #FFFFFF;\n}\n.ui.vk.button:active {\n  background-color: #3c5876;\n  color: #FFFFFF;\n}\n/*--------------\n     Icon\n---------------*/\n.ui.button > .icon:not(.button) {\n  height: 0.85714286em;\n  opacity: 0.8;\n  margin: 0em 0.42857143em 0em -0.21428571em;\n  transition: opacity 0.1s ease;\n  vertical-align: '';\n  color: '';\n}\n.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {\n  margin: 0em 0.42857143em 0em -0.21428571em;\n}\n.ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {\n  margin: 0em -0.21428571em 0em 0.42857143em;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Floated\n--------------------*/\n.ui[class*=\"left floated\"].buttons,\n.ui[class*=\"left floated\"].button {\n  float: left;\n  margin-left: 0em;\n  margin-right: 0.25em;\n}\n.ui[class*=\"right floated\"].buttons,\n.ui[class*=\"right floated\"].button {\n  float: right;\n  margin-right: 0em;\n  margin-left: 0.25em;\n}\n/*-------------------\n       Compact\n--------------------*/\n.ui.compact.buttons .button,\n.ui.compact.button {\n  padding: 0.58928571em 1.125em 0.58928571em;\n}\n.ui.compact.icon.buttons .button,\n.ui.compact.icon.button {\n  padding: 0.58928571em 0.58928571em 0.58928571em;\n}\n.ui.compact.labeled.icon.buttons .button,\n.ui.compact.labeled.icon.button {\n  padding: 0.58928571em 3.69642857em 0.58928571em;\n}\n/*-------------------\n        Sizes\n--------------------*/\n.ui.mini.buttons .button,\n.ui.mini.buttons .or,\n.ui.mini.button {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.buttons .button,\n.ui.tiny.buttons .or,\n.ui.tiny.button {\n  font-size: 0.85714286rem;\n}\n.ui.small.buttons .button,\n.ui.small.buttons .or,\n.ui.small.button {\n  font-size: 0.92857143rem;\n}\n.ui.buttons .button,\n.ui.buttons .or,\n.ui.button {\n  font-size: 1rem;\n}\n.ui.large.buttons .button,\n.ui.large.buttons .or,\n.ui.large.button {\n  font-size: 1.14285714rem;\n}\n.ui.big.buttons .button,\n.ui.big.buttons .or,\n.ui.big.button {\n  font-size: 1.28571429rem;\n}\n.ui.huge.buttons .button,\n.ui.huge.buttons .or,\n.ui.huge.button {\n  font-size: 1.42857143rem;\n}\n.ui.massive.buttons .button,\n.ui.massive.buttons .or,\n.ui.massive.button {\n  font-size: 1.71428571rem;\n}\n/*--------------\n    Icon Only\n---------------*/\n.ui.icon.buttons .button,\n.ui.icon.button {\n  padding: 0.78571429em 0.78571429em 0.78571429em;\n}\n.ui.icon.buttons .button > .icon,\n.ui.icon.button > .icon {\n  opacity: 0.9;\n  margin: 0em !important;\n  vertical-align: top;\n}\n/*-------------------\n        Basic\n--------------------*/\n.ui.basic.buttons .button,\n.ui.basic.button {\n  background: transparent none !important;\n  color: #eceff8 !important;\n  font-weight: normal;\n  border-radius: 0.28571429rem;\n  text-transform: none;\n  text-shadow: none !important;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.basic.buttons {\n  box-shadow: none;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n}\n.ui.basic.buttons .button {\n  border-radius: 0em;\n}\n.ui.basic.buttons .button:hover,\n.ui.basic.button:hover {\n  background: #FFFFFF !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.basic.buttons .button:focus,\n.ui.basic.button:focus {\n  background: #FFFFFF !important;\n  color: rgba(255, 255, 255, 0.8) !important;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.basic.buttons .button:active,\n.ui.basic.button:active {\n  background: #F8F8F8 !important;\n  color: rgba(255, 255, 255, 0.9) !important;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.basic.buttons .active.button,\n.ui.basic.active.button {\n  background: rgba(0, 0, 0, 0.05) !important;\n  box-shadow: '' !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.basic.buttons .active.button:hover,\n.ui.basic.active.button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n/* Vertical */\n.ui.basic.buttons .button:hover {\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.35) inset, 0px 0px 0px 0px rgba(255, 255, 255, 0.15) inset inset;\n}\n.ui.basic.buttons .button:active {\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(255, 255, 255, 0.15) inset inset;\n}\n.ui.basic.buttons .active.button {\n  box-shadow: '' !important;\n}\n/* Standard Basic Inverted */\n.ui.basic.inverted.buttons .button,\n.ui.basic.inverted.button {\n  background-color: transparent !important;\n  color: #F9FAFB !important;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n}\n.ui.basic.inverted.buttons .button:hover,\n.ui.basic.inverted.button:hover {\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n.ui.basic.inverted.buttons .button:focus,\n.ui.basic.inverted.button:focus {\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n.ui.basic.inverted.buttons .button:active,\n.ui.basic.inverted.button:active {\n  background-color: rgba(255, 255, 255, 0.08) !important;\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.9) inset !important;\n}\n.ui.basic.inverted.buttons .active.button,\n.ui.basic.inverted.active.button {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #FFFFFF;\n  text-shadow: none;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7) inset;\n}\n.ui.basic.inverted.buttons .active.button:hover,\n.ui.basic.inverted.active.button:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n/* Basic Group */\n.ui.basic.buttons .button {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: none;\n}\n.ui.basic.vertical.buttons .button {\n  border-left: none;\n}\n.ui.basic.vertical.buttons .button {\n  border-left-width: 0px;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.basic.vertical.buttons .button:first-child {\n  border-top-width: 0px;\n}\n/*--------------\n  Labeled Icon\n---------------*/\n.ui.labeled.icon.buttons .button,\n.ui.labeled.icon.button {\n  position: relative;\n  padding-left: 4.07142857em !important;\n  padding-right: 1.5em !important;\n}\n/* Left Labeled */\n.ui.labeled.icon.buttons > .button > .icon,\n.ui.labeled.icon.button > .icon {\n  position: absolute;\n  height: 100%;\n  line-height: 1;\n  border-radius: 0px;\n  border-top-left-radius: inherit;\n  border-bottom-left-radius: inherit;\n  text-align: center;\n  margin: 0em;\n  width: 2.57142857em;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: '';\n  box-shadow: -1px 0px 0px 0px transparent inset;\n}\n/* Left Labeled */\n.ui.labeled.icon.buttons > .button > .icon,\n.ui.labeled.icon.button > .icon {\n  top: 0em;\n  left: 0em;\n}\n/* Right Labeled */\n.ui[class*=\"right labeled\"].icon.button {\n  padding-right: 4.07142857em !important;\n  padding-left: 1.5em !important;\n}\n.ui[class*=\"right labeled\"].icon.button > .icon {\n  left: auto;\n  right: 0em;\n  border-radius: 0px;\n  border-top-right-radius: inherit;\n  border-bottom-right-radius: inherit;\n  box-shadow: 1px 0px 0px 0px transparent inset;\n}\n.ui.labeled.icon.buttons > .button > .icon:before,\n.ui.labeled.icon.button > .icon:before,\n.ui.labeled.icon.buttons > .button > .icon:after,\n.ui.labeled.icon.button > .icon:after {\n  display: block;\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  text-align: center;\n  transform: translateY(-50%);\n}\n/* Loading */\n.ui.labeled.icon.button > .icon.loading {\n  animation: none;\n}\n.ui.labeled.icon.button > .icon.loading:before {\n  animation: labeled-button-icon-loading 2s linear infinite;\n}\n@keyframes labeled-button-icon-loading {\n  from {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n.ui.labeled.icon.buttons .button > .icon {\n  border-radius: 0em;\n}\n.ui.labeled.icon.buttons .button:first-child > .icon {\n  border-top-left-radius: 0.28571429rem;\n  border-bottom-left-radius: 0.28571429rem;\n}\n.ui.labeled.icon.buttons .button:last-child > .icon {\n  border-top-right-radius: 0.28571429rem;\n  border-bottom-right-radius: 0.28571429rem;\n}\n.ui.vertical.labeled.icon.buttons .button:first-child > .icon {\n  border-radius: 0em;\n  border-top-left-radius: 0.28571429rem;\n}\n.ui.vertical.labeled.icon.buttons .button:last-child > .icon {\n  border-radius: 0em;\n  border-bottom-left-radius: 0.28571429rem;\n}\n/* Fluid Labeled */\n.ui.fluid[class*=\"left labeled\"].icon.button,\n.ui.fluid[class*=\"right labeled\"].icon.button {\n  padding-left: 1.5em !important;\n  padding-right: 1.5em !important;\n}\n/*--------------\n     Toggle\n---------------*/\n/* Toggle (Modifies active state to give affordances) */\n.ui.toggle.buttons .active.button,\n.ui.buttons .button.toggle.active,\n.ui.button.toggle.active {\n  background-color: #21BA45 !important;\n  box-shadow: none !important;\n  text-shadow: none;\n  color: #FFFFFF !important;\n}\n.ui.button.toggle.active:hover {\n  background-color: #16ab39 !important;\n  text-shadow: none;\n  color: #FFFFFF !important;\n}\n/*--------------\n    Circular\n---------------*/\n.ui.circular.button {\n  border-radius: 10em;\n}\n.ui.circular.button > .icon {\n  width: 1em;\n  vertical-align: baseline;\n}\n/*-------------------\n      Or Buttons\n--------------------*/\n.ui.buttons .or {\n  position: relative;\n  width: 0.3em;\n  height: 2.57142857em;\n  z-index: 3;\n}\n.ui.buttons .or:before {\n  position: absolute;\n  text-align: center;\n  border-radius: 500rem;\n  content: 'or';\n  top: 50%;\n  left: 50%;\n  background-color: #FFFFFF;\n  text-shadow: none;\n  margin-top: -0.89285714em;\n  margin-left: -0.89285714em;\n  width: 1.78571429em;\n  height: 1.78571429em;\n  line-height: 1.78571429em;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: normal;\n  font-weight: bold;\n  box-shadow: 0px 0px 0px 1px transparent inset;\n}\n.ui.buttons .or[data-text]:before {\n  content: attr(data-text);\n}\n/* Fluid Or */\n.ui.fluid.buttons .or {\n  width: 0em !important;\n}\n.ui.fluid.buttons .or:after {\n  display: none;\n}\n/*-------------------\n       Attached\n--------------------*/\n/* Singular */\n.ui.attached.button {\n  position: relative;\n  display: block;\n  margin: 0em;\n  border-radius: 0em;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) !important;\n}\n/* Top / Bottom */\n.ui.attached.top.button {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.attached.bottom.button {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n/* Left / Right */\n.ui.left.attached.button {\n  display: inline-block;\n  border-left: none;\n  text-align: right;\n  padding-right: 0.75em;\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n.ui.right.attached.button {\n  display: inline-block;\n  text-align: left;\n  padding-left: 0.75em;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n/* Plural */\n.ui.attached.buttons {\n  position: relative;\n  display: flex;\n  border-radius: 0em;\n  width: auto !important;\n  z-index: 2;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n.ui.attached.buttons .button {\n  margin: 0em;\n}\n.ui.attached.buttons .button:first-child {\n  border-radius: 0em;\n}\n.ui.attached.buttons .button:last-child {\n  border-radius: 0em;\n}\n/* Top / Bottom */\n.ui[class*=\"top attached\"].buttons {\n  margin-bottom: -1px;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui[class*=\"top attached\"].buttons .button:first-child {\n  border-radius: 0.28571429rem 0em 0em 0em;\n}\n.ui[class*=\"top attached\"].buttons .button:last-child {\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n.ui[class*=\"bottom attached\"].buttons {\n  margin-top: -1px;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui[class*=\"bottom attached\"].buttons .button:first-child {\n  border-radius: 0em 0em 0em 0.28571429rem;\n}\n.ui[class*=\"bottom attached\"].buttons .button:last-child {\n  border-radius: 0em 0em 0.28571429rem 0em;\n}\n/* Left / Right */\n.ui[class*=\"left attached\"].buttons {\n  display: inline-flex;\n  margin-right: 0em;\n  margin-left: -1px;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n.ui[class*=\"left attached\"].buttons .button:first-child {\n  margin-left: -1px;\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n.ui[class*=\"left attached\"].buttons .button:last-child {\n  margin-left: -1px;\n  border-radius: 0em 0em 0.28571429rem 0em;\n}\n.ui[class*=\"right attached\"].buttons {\n  display: inline-flex;\n  margin-left: 0em;\n  margin-right: -1px;\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n.ui[class*=\"right attached\"].buttons .button:first-child {\n  margin-left: -1px;\n  border-radius: 0.28571429rem 0em 0em 0em;\n}\n.ui[class*=\"right attached\"].buttons .button:last-child {\n  margin-left: -1px;\n  border-radius: 0em 0em 0em 0.28571429rem;\n}\n/*-------------------\n        Fluid\n--------------------*/\n.ui.fluid.buttons,\n.ui.fluid.button {\n  width: 100%;\n}\n.ui.fluid.button {\n  display: block;\n}\n.ui.two.buttons {\n  width: 100%;\n}\n.ui.two.buttons > .button {\n  width: 50%;\n}\n.ui.three.buttons {\n  width: 100%;\n}\n.ui.three.buttons > .button {\n  width: 33.333%;\n}\n.ui.four.buttons {\n  width: 100%;\n}\n.ui.four.buttons > .button {\n  width: 25%;\n}\n.ui.five.buttons {\n  width: 100%;\n}\n.ui.five.buttons > .button {\n  width: 20%;\n}\n.ui.six.buttons {\n  width: 100%;\n}\n.ui.six.buttons > .button {\n  width: 16.666%;\n}\n.ui.seven.buttons {\n  width: 100%;\n}\n.ui.seven.buttons > .button {\n  width: 14.285%;\n}\n.ui.eight.buttons {\n  width: 100%;\n}\n.ui.eight.buttons > .button {\n  width: 12.5%;\n}\n.ui.nine.buttons {\n  width: 100%;\n}\n.ui.nine.buttons > .button {\n  width: 11.11%;\n}\n.ui.ten.buttons {\n  width: 100%;\n}\n.ui.ten.buttons > .button {\n  width: 10%;\n}\n.ui.eleven.buttons {\n  width: 100%;\n}\n.ui.eleven.buttons > .button {\n  width: 9.09%;\n}\n.ui.twelve.buttons {\n  width: 100%;\n}\n.ui.twelve.buttons > .button {\n  width: 8.3333%;\n}\n/* Fluid Vertical Buttons */\n.ui.fluid.vertical.buttons,\n.ui.fluid.vertical.buttons > .button {\n  display: flex;\n  width: auto;\n}\n.ui.two.vertical.buttons > .button {\n  height: 50%;\n}\n.ui.three.vertical.buttons > .button {\n  height: 33.333%;\n}\n.ui.four.vertical.buttons > .button {\n  height: 25%;\n}\n.ui.five.vertical.buttons > .button {\n  height: 20%;\n}\n.ui.six.vertical.buttons > .button {\n  height: 16.666%;\n}\n.ui.seven.vertical.buttons > .button {\n  height: 14.285%;\n}\n.ui.eight.vertical.buttons > .button {\n  height: 12.5%;\n}\n.ui.nine.vertical.buttons > .button {\n  height: 11.11%;\n}\n.ui.ten.vertical.buttons > .button {\n  height: 10%;\n}\n.ui.eleven.vertical.buttons > .button {\n  height: 9.09%;\n}\n.ui.twelve.vertical.buttons > .button {\n  height: 8.3333%;\n}\n/*-------------------\n       Colors\n--------------------*/\n/*--- Black ---*/\n.ui.black.buttons .button,\n.ui.black.button {\n  background-color: #1B1C1D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.black.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.black.buttons .button:hover,\n.ui.black.button:hover {\n  background-color: #27292a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.black.buttons .button:focus,\n.ui.black.button:focus {\n  background-color: #2f3032;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.black.buttons .button:active,\n.ui.black.button:active {\n  background-color: #343637;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.black.buttons .active.button,\n.ui.black.buttons .active.button:active,\n.ui.black.active.button,\n.ui.black.button .active.button:active {\n  background-color: #0f0f10;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.black.buttons .button,\n.ui.basic.black.button {\n  box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;\n  color: #1B1C1D !important;\n}\n.ui.basic.black.buttons .button:hover,\n.ui.basic.black.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #27292a inset !important;\n  color: #27292a !important;\n}\n.ui.basic.black.buttons .button:focus,\n.ui.basic.black.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #2f3032 inset !important;\n  color: #27292a !important;\n}\n.ui.basic.black.buttons .active.button,\n.ui.basic.black.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0f0f10 inset !important;\n  color: #343637 !important;\n}\n.ui.basic.black.buttons .button:active,\n.ui.basic.black.button:active {\n  box-shadow: 0px 0px 0px 1px #343637 inset !important;\n  color: #343637 !important;\n}\n.ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.black.buttons .button,\n.ui.inverted.black.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;\n  color: #FFFFFF;\n}\n.ui.inverted.black.buttons .button:hover,\n.ui.inverted.black.button:hover,\n.ui.inverted.black.buttons .button:focus,\n.ui.inverted.black.button:focus,\n.ui.inverted.black.buttons .button.active,\n.ui.inverted.black.button.active,\n.ui.inverted.black.buttons .button:active,\n.ui.inverted.black.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.black.buttons .button:hover,\n.ui.inverted.black.button:hover {\n  background-color: #000000;\n}\n.ui.inverted.black.buttons .button:focus,\n.ui.inverted.black.button:focus {\n  background-color: #000000;\n}\n.ui.inverted.black.buttons .active.button,\n.ui.inverted.black.active.button {\n  background-color: #000000;\n}\n.ui.inverted.black.buttons .button:active,\n.ui.inverted.black.button:active {\n  background-color: #000000;\n}\n/* Inverted Basic */\n.ui.inverted.black.basic.buttons .button,\n.ui.inverted.black.buttons .basic.button,\n.ui.inverted.black.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.black.basic.buttons .button:hover,\n.ui.inverted.black.buttons .basic.button:hover,\n.ui.inverted.black.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.black.basic.buttons .button:focus,\n.ui.inverted.black.basic.buttons .button:focus,\n.ui.inverted.black.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #545454 !important;\n}\n.ui.inverted.black.basic.buttons .active.button,\n.ui.inverted.black.buttons .basic.active.button,\n.ui.inverted.black.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.black.basic.buttons .button:active,\n.ui.inverted.black.buttons .basic.button:active,\n.ui.inverted.black.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n/*--- Grey ---*/\n.ui.grey.buttons .button,\n.ui.grey.button {\n  background-color: #767676;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.grey.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.grey.buttons .button:hover,\n.ui.grey.button:hover {\n  background-color: #838383;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.grey.buttons .button:focus,\n.ui.grey.button:focus {\n  background-color: #8a8a8a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.grey.buttons .button:active,\n.ui.grey.button:active {\n  background-color: #909090;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.grey.buttons .active.button,\n.ui.grey.buttons .active.button:active,\n.ui.grey.active.button,\n.ui.grey.button .active.button:active {\n  background-color: #696969;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.grey.buttons .button,\n.ui.basic.grey.button {\n  box-shadow: 0px 0px 0px 1px #767676 inset !important;\n  color: #767676 !important;\n}\n.ui.basic.grey.buttons .button:hover,\n.ui.basic.grey.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #838383 inset !important;\n  color: #838383 !important;\n}\n.ui.basic.grey.buttons .button:focus,\n.ui.basic.grey.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #8a8a8a inset !important;\n  color: #838383 !important;\n}\n.ui.basic.grey.buttons .active.button,\n.ui.basic.grey.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #696969 inset !important;\n  color: #909090 !important;\n}\n.ui.basic.grey.buttons .button:active,\n.ui.basic.grey.button:active {\n  box-shadow: 0px 0px 0px 1px #909090 inset !important;\n  color: #909090 !important;\n}\n.ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.grey.buttons .button,\n.ui.inverted.grey.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;\n  color: #FFFFFF;\n}\n.ui.inverted.grey.buttons .button:hover,\n.ui.inverted.grey.button:hover,\n.ui.inverted.grey.buttons .button:focus,\n.ui.inverted.grey.button:focus,\n.ui.inverted.grey.buttons .button.active,\n.ui.inverted.grey.button.active,\n.ui.inverted.grey.buttons .button:active,\n.ui.inverted.grey.button:active {\n  box-shadow: none !important;\n  color: #eceff8;\n}\n.ui.inverted.grey.buttons .button:hover,\n.ui.inverted.grey.button:hover {\n  background-color: #cfd0d2;\n}\n.ui.inverted.grey.buttons .button:focus,\n.ui.inverted.grey.button:focus {\n  background-color: #c7c9cb;\n}\n.ui.inverted.grey.buttons .active.button,\n.ui.inverted.grey.active.button {\n  background-color: #cfd0d2;\n}\n.ui.inverted.grey.buttons .button:active,\n.ui.inverted.grey.button:active {\n  background-color: #c2c4c5;\n}\n/* Inverted Basic */\n.ui.inverted.grey.basic.buttons .button,\n.ui.inverted.grey.buttons .basic.button,\n.ui.inverted.grey.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.grey.basic.buttons .button:hover,\n.ui.inverted.grey.buttons .basic.button:hover,\n.ui.inverted.grey.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.grey.basic.buttons .button:focus,\n.ui.inverted.grey.basic.buttons .button:focus,\n.ui.inverted.grey.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #c7c9cb inset !important;\n  color: #DCDDDE !important;\n}\n.ui.inverted.grey.basic.buttons .active.button,\n.ui.inverted.grey.buttons .basic.active.button,\n.ui.inverted.grey.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.grey.basic.buttons .button:active,\n.ui.inverted.grey.buttons .basic.button:active,\n.ui.inverted.grey.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #c2c4c5 inset !important;\n  color: #FFFFFF !important;\n}\n/*--- Brown ---*/\n.ui.brown.buttons .button,\n.ui.brown.button {\n  background-color: #A5673F;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.brown.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.brown.buttons .button:hover,\n.ui.brown.button:hover {\n  background-color: #975b33;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.brown.buttons .button:focus,\n.ui.brown.button:focus {\n  background-color: #90532b;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.brown.buttons .button:active,\n.ui.brown.button:active {\n  background-color: #805031;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.brown.buttons .active.button,\n.ui.brown.buttons .active.button:active,\n.ui.brown.active.button,\n.ui.brown.button .active.button:active {\n  background-color: #995a31;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.brown.buttons .button,\n.ui.basic.brown.button {\n  box-shadow: 0px 0px 0px 1px #A5673F inset !important;\n  color: #A5673F !important;\n}\n.ui.basic.brown.buttons .button:hover,\n.ui.basic.brown.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #975b33 inset !important;\n  color: #975b33 !important;\n}\n.ui.basic.brown.buttons .button:focus,\n.ui.basic.brown.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #90532b inset !important;\n  color: #975b33 !important;\n}\n.ui.basic.brown.buttons .active.button,\n.ui.basic.brown.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #995a31 inset !important;\n  color: #805031 !important;\n}\n.ui.basic.brown.buttons .button:active,\n.ui.basic.brown.button:active {\n  box-shadow: 0px 0px 0px 1px #805031 inset !important;\n  color: #805031 !important;\n}\n.ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.brown.buttons .button,\n.ui.inverted.brown.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D67C1C inset !important;\n  color: #D67C1C;\n}\n.ui.inverted.brown.buttons .button:hover,\n.ui.inverted.brown.button:hover,\n.ui.inverted.brown.buttons .button:focus,\n.ui.inverted.brown.button:focus,\n.ui.inverted.brown.buttons .button.active,\n.ui.inverted.brown.button.active,\n.ui.inverted.brown.buttons .button:active,\n.ui.inverted.brown.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.brown.buttons .button:hover,\n.ui.inverted.brown.button:hover {\n  background-color: #c86f11;\n}\n.ui.inverted.brown.buttons .button:focus,\n.ui.inverted.brown.button:focus {\n  background-color: #c16808;\n}\n.ui.inverted.brown.buttons .active.button,\n.ui.inverted.brown.active.button {\n  background-color: #cc6f0d;\n}\n.ui.inverted.brown.buttons .button:active,\n.ui.inverted.brown.button:active {\n  background-color: #a96216;\n}\n/* Inverted Basic */\n.ui.inverted.brown.basic.buttons .button,\n.ui.inverted.brown.buttons .basic.button,\n.ui.inverted.brown.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.brown.basic.buttons .button:hover,\n.ui.inverted.brown.buttons .basic.button:hover,\n.ui.inverted.brown.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #c86f11 inset !important;\n  color: #D67C1C !important;\n}\n.ui.inverted.brown.basic.buttons .button:focus,\n.ui.inverted.brown.basic.buttons .button:focus,\n.ui.inverted.brown.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #c16808 inset !important;\n  color: #D67C1C !important;\n}\n.ui.inverted.brown.basic.buttons .active.button,\n.ui.inverted.brown.buttons .basic.active.button,\n.ui.inverted.brown.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #cc6f0d inset !important;\n  color: #D67C1C !important;\n}\n.ui.inverted.brown.basic.buttons .button:active,\n.ui.inverted.brown.buttons .basic.button:active,\n.ui.inverted.brown.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #a96216 inset !important;\n  color: #D67C1C !important;\n}\n/*--- Blue ---*/\n.ui.blue.buttons .button,\n.ui.blue.button {\n  background-color: #2185D0;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.blue.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.blue.buttons .button:hover,\n.ui.blue.button:hover {\n  background-color: #1678c2;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.blue.buttons .button:focus,\n.ui.blue.button:focus {\n  background-color: #0d71bb;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.blue.buttons .button:active,\n.ui.blue.button:active {\n  background-color: #1a69a4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.blue.buttons .active.button,\n.ui.blue.buttons .active.button:active,\n.ui.blue.active.button,\n.ui.blue.button .active.button:active {\n  background-color: #1279c6;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.blue.buttons .button,\n.ui.basic.blue.button {\n  box-shadow: 0px 0px 0px 1px #2185D0 inset !important;\n  color: #2185D0 !important;\n}\n.ui.basic.blue.buttons .button:hover,\n.ui.basic.blue.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1678c2 inset !important;\n  color: #1678c2 !important;\n}\n.ui.basic.blue.buttons .button:focus,\n.ui.basic.blue.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0d71bb inset !important;\n  color: #1678c2 !important;\n}\n.ui.basic.blue.buttons .active.button,\n.ui.basic.blue.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1279c6 inset !important;\n  color: #1a69a4 !important;\n}\n.ui.basic.blue.buttons .button:active,\n.ui.basic.blue.button:active {\n  box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;\n  color: #1a69a4 !important;\n}\n.ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.blue.buttons .button,\n.ui.inverted.blue.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;\n  color: #54C8FF;\n}\n.ui.inverted.blue.buttons .button:hover,\n.ui.inverted.blue.button:hover,\n.ui.inverted.blue.buttons .button:focus,\n.ui.inverted.blue.button:focus,\n.ui.inverted.blue.buttons .button.active,\n.ui.inverted.blue.button.active,\n.ui.inverted.blue.buttons .button:active,\n.ui.inverted.blue.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.blue.buttons .button:hover,\n.ui.inverted.blue.button:hover {\n  background-color: #3ac0ff;\n}\n.ui.inverted.blue.buttons .button:focus,\n.ui.inverted.blue.button:focus {\n  background-color: #2bbbff;\n}\n.ui.inverted.blue.buttons .active.button,\n.ui.inverted.blue.active.button {\n  background-color: #3ac0ff;\n}\n.ui.inverted.blue.buttons .button:active,\n.ui.inverted.blue.button:active {\n  background-color: #21b8ff;\n}\n/* Inverted Basic */\n.ui.inverted.blue.basic.buttons .button,\n.ui.inverted.blue.buttons .basic.button,\n.ui.inverted.blue.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.blue.basic.buttons .button:hover,\n.ui.inverted.blue.buttons .basic.button:hover,\n.ui.inverted.blue.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.blue.basic.buttons .button:focus,\n.ui.inverted.blue.basic.buttons .button:focus,\n.ui.inverted.blue.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.blue.basic.buttons .active.button,\n.ui.inverted.blue.buttons .basic.active.button,\n.ui.inverted.blue.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.blue.basic.buttons .button:active,\n.ui.inverted.blue.buttons .basic.button:active,\n.ui.inverted.blue.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;\n  color: #54C8FF !important;\n}\n/*--- Green ---*/\n.ui.green.buttons .button,\n.ui.green.button {\n  background-color: #21BA45;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.green.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.green.buttons .button:hover,\n.ui.green.button:hover {\n  background-color: #16ab39;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.green.buttons .button:focus,\n.ui.green.button:focus {\n  background-color: #0ea432;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.green.buttons .button:active,\n.ui.green.button:active {\n  background-color: #198f35;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.green.buttons .active.button,\n.ui.green.buttons .active.button:active,\n.ui.green.active.button,\n.ui.green.button .active.button:active {\n  background-color: #13ae38;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.green.buttons .button,\n.ui.basic.green.button {\n  box-shadow: 0px 0px 0px 1px #21BA45 inset !important;\n  color: #21BA45 !important;\n}\n.ui.basic.green.buttons .button:hover,\n.ui.basic.green.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #16ab39 inset !important;\n  color: #16ab39 !important;\n}\n.ui.basic.green.buttons .button:focus,\n.ui.basic.green.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0ea432 inset !important;\n  color: #16ab39 !important;\n}\n.ui.basic.green.buttons .active.button,\n.ui.basic.green.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #13ae38 inset !important;\n  color: #198f35 !important;\n}\n.ui.basic.green.buttons .button:active,\n.ui.basic.green.button:active {\n  box-shadow: 0px 0px 0px 1px #198f35 inset !important;\n  color: #198f35 !important;\n}\n.ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.green.buttons .button,\n.ui.inverted.green.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #2ECC40 inset !important;\n  color: #2ECC40;\n}\n.ui.inverted.green.buttons .button:hover,\n.ui.inverted.green.button:hover,\n.ui.inverted.green.buttons .button:focus,\n.ui.inverted.green.button:focus,\n.ui.inverted.green.buttons .button.active,\n.ui.inverted.green.button.active,\n.ui.inverted.green.buttons .button:active,\n.ui.inverted.green.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.green.buttons .button:hover,\n.ui.inverted.green.button:hover {\n  background-color: #22be34;\n}\n.ui.inverted.green.buttons .button:focus,\n.ui.inverted.green.button:focus {\n  background-color: #19b82b;\n}\n.ui.inverted.green.buttons .active.button,\n.ui.inverted.green.active.button {\n  background-color: #1fc231;\n}\n.ui.inverted.green.buttons .button:active,\n.ui.inverted.green.button:active {\n  background-color: #25a233;\n}\n/* Inverted Basic */\n.ui.inverted.green.basic.buttons .button,\n.ui.inverted.green.buttons .basic.button,\n.ui.inverted.green.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.green.basic.buttons .button:hover,\n.ui.inverted.green.buttons .basic.button:hover,\n.ui.inverted.green.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #22be34 inset !important;\n  color: #2ECC40 !important;\n}\n.ui.inverted.green.basic.buttons .button:focus,\n.ui.inverted.green.basic.buttons .button:focus,\n.ui.inverted.green.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #19b82b inset !important;\n  color: #2ECC40 !important;\n}\n.ui.inverted.green.basic.buttons .active.button,\n.ui.inverted.green.buttons .basic.active.button,\n.ui.inverted.green.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #1fc231 inset !important;\n  color: #2ECC40 !important;\n}\n.ui.inverted.green.basic.buttons .button:active,\n.ui.inverted.green.buttons .basic.button:active,\n.ui.inverted.green.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #25a233 inset !important;\n  color: #2ECC40 !important;\n}\n/*--- Orange ---*/\n.ui.orange.buttons .button,\n.ui.orange.button {\n  background-color: #F2711C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.orange.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.orange.buttons .button:hover,\n.ui.orange.button:hover {\n  background-color: #f26202;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.orange.buttons .button:focus,\n.ui.orange.button:focus {\n  background-color: #e55b00;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.orange.buttons .button:active,\n.ui.orange.button:active {\n  background-color: #cf590c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.orange.buttons .active.button,\n.ui.orange.buttons .active.button:active,\n.ui.orange.active.button,\n.ui.orange.button .active.button:active {\n  background-color: #f56100;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.orange.buttons .button,\n.ui.basic.orange.button {\n  box-shadow: 0px 0px 0px 1px #F2711C inset !important;\n  color: #F2711C !important;\n}\n.ui.basic.orange.buttons .button:hover,\n.ui.basic.orange.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #f26202 inset !important;\n  color: #f26202 !important;\n}\n.ui.basic.orange.buttons .button:focus,\n.ui.basic.orange.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #e55b00 inset !important;\n  color: #f26202 !important;\n}\n.ui.basic.orange.buttons .active.button,\n.ui.basic.orange.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #f56100 inset !important;\n  color: #cf590c !important;\n}\n.ui.basic.orange.buttons .button:active,\n.ui.basic.orange.button:active {\n  box-shadow: 0px 0px 0px 1px #cf590c inset !important;\n  color: #cf590c !important;\n}\n.ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.orange.buttons .button,\n.ui.inverted.orange.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF851B inset !important;\n  color: #FF851B;\n}\n.ui.inverted.orange.buttons .button:hover,\n.ui.inverted.orange.button:hover,\n.ui.inverted.orange.buttons .button:focus,\n.ui.inverted.orange.button:focus,\n.ui.inverted.orange.buttons .button.active,\n.ui.inverted.orange.button.active,\n.ui.inverted.orange.buttons .button:active,\n.ui.inverted.orange.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.orange.buttons .button:hover,\n.ui.inverted.orange.button:hover {\n  background-color: #ff7701;\n}\n.ui.inverted.orange.buttons .button:focus,\n.ui.inverted.orange.button:focus {\n  background-color: #f17000;\n}\n.ui.inverted.orange.buttons .active.button,\n.ui.inverted.orange.active.button {\n  background-color: #ff7701;\n}\n.ui.inverted.orange.buttons .button:active,\n.ui.inverted.orange.button:active {\n  background-color: #e76b00;\n}\n/* Inverted Basic */\n.ui.inverted.orange.basic.buttons .button,\n.ui.inverted.orange.buttons .basic.button,\n.ui.inverted.orange.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.orange.basic.buttons .button:hover,\n.ui.inverted.orange.buttons .basic.button:hover,\n.ui.inverted.orange.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;\n  color: #FF851B !important;\n}\n.ui.inverted.orange.basic.buttons .button:focus,\n.ui.inverted.orange.basic.buttons .button:focus,\n.ui.inverted.orange.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #f17000 inset !important;\n  color: #FF851B !important;\n}\n.ui.inverted.orange.basic.buttons .active.button,\n.ui.inverted.orange.buttons .basic.active.button,\n.ui.inverted.orange.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;\n  color: #FF851B !important;\n}\n.ui.inverted.orange.basic.buttons .button:active,\n.ui.inverted.orange.buttons .basic.button:active,\n.ui.inverted.orange.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #e76b00 inset !important;\n  color: #FF851B !important;\n}\n/*--- Pink ---*/\n.ui.pink.buttons .button,\n.ui.pink.button {\n  background-color: #E03997;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.pink.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.pink.buttons .button:hover,\n.ui.pink.button:hover {\n  background-color: #e61a8d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.pink.buttons .button:focus,\n.ui.pink.button:focus {\n  background-color: #e10f85;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.pink.buttons .button:active,\n.ui.pink.button:active {\n  background-color: #c71f7e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.pink.buttons .active.button,\n.ui.pink.buttons .active.button:active,\n.ui.pink.active.button,\n.ui.pink.button .active.button:active {\n  background-color: #ea158d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.pink.buttons .button,\n.ui.basic.pink.button {\n  box-shadow: 0px 0px 0px 1px #E03997 inset !important;\n  color: #E03997 !important;\n}\n.ui.basic.pink.buttons .button:hover,\n.ui.basic.pink.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #e61a8d inset !important;\n  color: #e61a8d !important;\n}\n.ui.basic.pink.buttons .button:focus,\n.ui.basic.pink.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #e10f85 inset !important;\n  color: #e61a8d !important;\n}\n.ui.basic.pink.buttons .active.button,\n.ui.basic.pink.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ea158d inset !important;\n  color: #c71f7e !important;\n}\n.ui.basic.pink.buttons .button:active,\n.ui.basic.pink.button:active {\n  box-shadow: 0px 0px 0px 1px #c71f7e inset !important;\n  color: #c71f7e !important;\n}\n.ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.pink.buttons .button,\n.ui.inverted.pink.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF8EDF inset !important;\n  color: #FF8EDF;\n}\n.ui.inverted.pink.buttons .button:hover,\n.ui.inverted.pink.button:hover,\n.ui.inverted.pink.buttons .button:focus,\n.ui.inverted.pink.button:focus,\n.ui.inverted.pink.buttons .button.active,\n.ui.inverted.pink.button.active,\n.ui.inverted.pink.buttons .button:active,\n.ui.inverted.pink.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.pink.buttons .button:hover,\n.ui.inverted.pink.button:hover {\n  background-color: #ff74d8;\n}\n.ui.inverted.pink.buttons .button:focus,\n.ui.inverted.pink.button:focus {\n  background-color: #ff65d3;\n}\n.ui.inverted.pink.buttons .active.button,\n.ui.inverted.pink.active.button {\n  background-color: #ff74d8;\n}\n.ui.inverted.pink.buttons .button:active,\n.ui.inverted.pink.button:active {\n  background-color: #ff5bd1;\n}\n/* Inverted Basic */\n.ui.inverted.pink.basic.buttons .button,\n.ui.inverted.pink.buttons .basic.button,\n.ui.inverted.pink.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.pink.basic.buttons .button:hover,\n.ui.inverted.pink.buttons .basic.button:hover,\n.ui.inverted.pink.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;\n  color: #FF8EDF !important;\n}\n.ui.inverted.pink.basic.buttons .button:focus,\n.ui.inverted.pink.basic.buttons .button:focus,\n.ui.inverted.pink.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #ff65d3 inset !important;\n  color: #FF8EDF !important;\n}\n.ui.inverted.pink.basic.buttons .active.button,\n.ui.inverted.pink.buttons .basic.active.button,\n.ui.inverted.pink.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;\n  color: #FF8EDF !important;\n}\n.ui.inverted.pink.basic.buttons .button:active,\n.ui.inverted.pink.buttons .basic.button:active,\n.ui.inverted.pink.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ff5bd1 inset !important;\n  color: #FF8EDF !important;\n}\n/*--- Violet ---*/\n.ui.violet.buttons .button,\n.ui.violet.button {\n  background-color: #6435C9;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.violet.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.violet.buttons .button:hover,\n.ui.violet.button:hover {\n  background-color: #5829bb;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.violet.buttons .button:focus,\n.ui.violet.button:focus {\n  background-color: #4f20b5;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.violet.buttons .button:active,\n.ui.violet.button:active {\n  background-color: #502aa1;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.violet.buttons .active.button,\n.ui.violet.buttons .active.button:active,\n.ui.violet.active.button,\n.ui.violet.button .active.button:active {\n  background-color: #5626bf;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.violet.buttons .button,\n.ui.basic.violet.button {\n  box-shadow: 0px 0px 0px 1px #6435C9 inset !important;\n  color: #6435C9 !important;\n}\n.ui.basic.violet.buttons .button:hover,\n.ui.basic.violet.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #5829bb inset !important;\n  color: #5829bb !important;\n}\n.ui.basic.violet.buttons .button:focus,\n.ui.basic.violet.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #4f20b5 inset !important;\n  color: #5829bb !important;\n}\n.ui.basic.violet.buttons .active.button,\n.ui.basic.violet.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #5626bf inset !important;\n  color: #502aa1 !important;\n}\n.ui.basic.violet.buttons .button:active,\n.ui.basic.violet.button:active {\n  box-shadow: 0px 0px 0px 1px #502aa1 inset !important;\n  color: #502aa1 !important;\n}\n.ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.violet.buttons .button,\n.ui.inverted.violet.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #A291FB inset !important;\n  color: #A291FB;\n}\n.ui.inverted.violet.buttons .button:hover,\n.ui.inverted.violet.button:hover,\n.ui.inverted.violet.buttons .button:focus,\n.ui.inverted.violet.button:focus,\n.ui.inverted.violet.buttons .button.active,\n.ui.inverted.violet.button.active,\n.ui.inverted.violet.buttons .button:active,\n.ui.inverted.violet.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.violet.buttons .button:hover,\n.ui.inverted.violet.button:hover {\n  background-color: #8a73ff;\n}\n.ui.inverted.violet.buttons .button:focus,\n.ui.inverted.violet.button:focus {\n  background-color: #7d64ff;\n}\n.ui.inverted.violet.buttons .active.button,\n.ui.inverted.violet.active.button {\n  background-color: #8a73ff;\n}\n.ui.inverted.violet.buttons .button:active,\n.ui.inverted.violet.button:active {\n  background-color: #7860f9;\n}\n/* Inverted Basic */\n.ui.inverted.violet.basic.buttons .button,\n.ui.inverted.violet.buttons .basic.button,\n.ui.inverted.violet.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.violet.basic.buttons .button:hover,\n.ui.inverted.violet.buttons .basic.button:hover,\n.ui.inverted.violet.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;\n  color: #A291FB !important;\n}\n.ui.inverted.violet.basic.buttons .button:focus,\n.ui.inverted.violet.basic.buttons .button:focus,\n.ui.inverted.violet.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #7d64ff inset !important;\n  color: #A291FB !important;\n}\n.ui.inverted.violet.basic.buttons .active.button,\n.ui.inverted.violet.buttons .basic.active.button,\n.ui.inverted.violet.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;\n  color: #A291FB !important;\n}\n.ui.inverted.violet.basic.buttons .button:active,\n.ui.inverted.violet.buttons .basic.button:active,\n.ui.inverted.violet.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #7860f9 inset !important;\n  color: #A291FB !important;\n}\n/*--- Purple ---*/\n.ui.purple.buttons .button,\n.ui.purple.button {\n  background-color: #A333C8;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.purple.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.purple.buttons .button:hover,\n.ui.purple.button:hover {\n  background-color: #9627ba;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.purple.buttons .button:focus,\n.ui.purple.button:focus {\n  background-color: #8f1eb4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.purple.buttons .button:active,\n.ui.purple.button:active {\n  background-color: #82299f;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.purple.buttons .active.button,\n.ui.purple.buttons .active.button:active,\n.ui.purple.active.button,\n.ui.purple.button .active.button:active {\n  background-color: #9724be;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.purple.buttons .button,\n.ui.basic.purple.button {\n  box-shadow: 0px 0px 0px 1px #A333C8 inset !important;\n  color: #A333C8 !important;\n}\n.ui.basic.purple.buttons .button:hover,\n.ui.basic.purple.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #9627ba inset !important;\n  color: #9627ba !important;\n}\n.ui.basic.purple.buttons .button:focus,\n.ui.basic.purple.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #8f1eb4 inset !important;\n  color: #9627ba !important;\n}\n.ui.basic.purple.buttons .active.button,\n.ui.basic.purple.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #9724be inset !important;\n  color: #82299f !important;\n}\n.ui.basic.purple.buttons .button:active,\n.ui.basic.purple.button:active {\n  box-shadow: 0px 0px 0px 1px #82299f inset !important;\n  color: #82299f !important;\n}\n.ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.purple.buttons .button,\n.ui.inverted.purple.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #DC73FF inset !important;\n  color: #DC73FF;\n}\n.ui.inverted.purple.buttons .button:hover,\n.ui.inverted.purple.button:hover,\n.ui.inverted.purple.buttons .button:focus,\n.ui.inverted.purple.button:focus,\n.ui.inverted.purple.buttons .button.active,\n.ui.inverted.purple.button.active,\n.ui.inverted.purple.buttons .button:active,\n.ui.inverted.purple.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.purple.buttons .button:hover,\n.ui.inverted.purple.button:hover {\n  background-color: #d65aff;\n}\n.ui.inverted.purple.buttons .button:focus,\n.ui.inverted.purple.button:focus {\n  background-color: #d24aff;\n}\n.ui.inverted.purple.buttons .active.button,\n.ui.inverted.purple.active.button {\n  background-color: #d65aff;\n}\n.ui.inverted.purple.buttons .button:active,\n.ui.inverted.purple.button:active {\n  background-color: #cf40ff;\n}\n/* Inverted Basic */\n.ui.inverted.purple.basic.buttons .button,\n.ui.inverted.purple.buttons .basic.button,\n.ui.inverted.purple.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.purple.basic.buttons .button:hover,\n.ui.inverted.purple.buttons .basic.button:hover,\n.ui.inverted.purple.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #d65aff inset !important;\n  color: #DC73FF !important;\n}\n.ui.inverted.purple.basic.buttons .button:focus,\n.ui.inverted.purple.basic.buttons .button:focus,\n.ui.inverted.purple.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #d24aff inset !important;\n  color: #DC73FF !important;\n}\n.ui.inverted.purple.basic.buttons .active.button,\n.ui.inverted.purple.buttons .basic.active.button,\n.ui.inverted.purple.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #d65aff inset !important;\n  color: #DC73FF !important;\n}\n.ui.inverted.purple.basic.buttons .button:active,\n.ui.inverted.purple.buttons .basic.button:active,\n.ui.inverted.purple.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #cf40ff inset !important;\n  color: #DC73FF !important;\n}\n/*--- Red ---*/\n.ui.red.buttons .button,\n.ui.red.button {\n  background-color: #DB2828;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.red.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.red.buttons .button:hover,\n.ui.red.button:hover {\n  background-color: #d01919;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.red.buttons .button:focus,\n.ui.red.button:focus {\n  background-color: #ca1010;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.red.buttons .button:active,\n.ui.red.button:active {\n  background-color: #b21e1e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.red.buttons .active.button,\n.ui.red.buttons .active.button:active,\n.ui.red.active.button,\n.ui.red.button .active.button:active {\n  background-color: #d41515;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.red.buttons .button,\n.ui.basic.red.button {\n  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;\n  color: #DB2828 !important;\n}\n.ui.basic.red.buttons .button:hover,\n.ui.basic.red.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d01919 inset !important;\n  color: #d01919 !important;\n}\n.ui.basic.red.buttons .button:focus,\n.ui.basic.red.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;\n  color: #d01919 !important;\n}\n.ui.basic.red.buttons .active.button,\n.ui.basic.red.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d41515 inset !important;\n  color: #b21e1e !important;\n}\n.ui.basic.red.buttons .button:active,\n.ui.basic.red.button:active {\n  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;\n  color: #b21e1e !important;\n}\n.ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.red.buttons .button,\n.ui.inverted.red.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF695E inset !important;\n  color: #FF695E;\n}\n.ui.inverted.red.buttons .button:hover,\n.ui.inverted.red.button:hover,\n.ui.inverted.red.buttons .button:focus,\n.ui.inverted.red.button:focus,\n.ui.inverted.red.buttons .button.active,\n.ui.inverted.red.button.active,\n.ui.inverted.red.buttons .button:active,\n.ui.inverted.red.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.red.buttons .button:hover,\n.ui.inverted.red.button:hover {\n  background-color: #ff5144;\n}\n.ui.inverted.red.buttons .button:focus,\n.ui.inverted.red.button:focus {\n  background-color: #ff4335;\n}\n.ui.inverted.red.buttons .active.button,\n.ui.inverted.red.active.button {\n  background-color: #ff5144;\n}\n.ui.inverted.red.buttons .button:active,\n.ui.inverted.red.button:active {\n  background-color: #ff392b;\n}\n/* Inverted Basic */\n.ui.inverted.red.basic.buttons .button,\n.ui.inverted.red.buttons .basic.button,\n.ui.inverted.red.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.red.basic.buttons .button:hover,\n.ui.inverted.red.buttons .basic.button:hover,\n.ui.inverted.red.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;\n  color: #FF695E !important;\n}\n.ui.inverted.red.basic.buttons .button:focus,\n.ui.inverted.red.basic.buttons .button:focus,\n.ui.inverted.red.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #ff4335 inset !important;\n  color: #FF695E !important;\n}\n.ui.inverted.red.basic.buttons .active.button,\n.ui.inverted.red.buttons .basic.active.button,\n.ui.inverted.red.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;\n  color: #FF695E !important;\n}\n.ui.inverted.red.basic.buttons .button:active,\n.ui.inverted.red.buttons .basic.button:active,\n.ui.inverted.red.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ff392b inset !important;\n  color: #FF695E !important;\n}\n/*--- Teal ---*/\n.ui.teal.buttons .button,\n.ui.teal.button {\n  background-color: #00B5AD;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.teal.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.teal.buttons .button:hover,\n.ui.teal.button:hover {\n  background-color: #009c95;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.teal.buttons .button:focus,\n.ui.teal.button:focus {\n  background-color: #008c86;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.teal.buttons .button:active,\n.ui.teal.button:active {\n  background-color: #00827c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.teal.buttons .active.button,\n.ui.teal.buttons .active.button:active,\n.ui.teal.active.button,\n.ui.teal.button .active.button:active {\n  background-color: #009c95;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.teal.buttons .button,\n.ui.basic.teal.button {\n  box-shadow: 0px 0px 0px 1px #00B5AD inset !important;\n  color: #00B5AD !important;\n}\n.ui.basic.teal.buttons .button:hover,\n.ui.basic.teal.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #009c95 inset !important;\n  color: #009c95 !important;\n}\n.ui.basic.teal.buttons .button:focus,\n.ui.basic.teal.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #008c86 inset !important;\n  color: #009c95 !important;\n}\n.ui.basic.teal.buttons .active.button,\n.ui.basic.teal.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #009c95 inset !important;\n  color: #00827c !important;\n}\n.ui.basic.teal.buttons .button:active,\n.ui.basic.teal.button:active {\n  box-shadow: 0px 0px 0px 1px #00827c inset !important;\n  color: #00827c !important;\n}\n.ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.teal.buttons .button,\n.ui.inverted.teal.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #6DFFFF inset !important;\n  color: #6DFFFF;\n}\n.ui.inverted.teal.buttons .button:hover,\n.ui.inverted.teal.button:hover,\n.ui.inverted.teal.buttons .button:focus,\n.ui.inverted.teal.button:focus,\n.ui.inverted.teal.buttons .button.active,\n.ui.inverted.teal.button.active,\n.ui.inverted.teal.buttons .button:active,\n.ui.inverted.teal.button:active {\n  box-shadow: none !important;\n  color: #eceff8;\n}\n.ui.inverted.teal.buttons .button:hover,\n.ui.inverted.teal.button:hover {\n  background-color: #54ffff;\n}\n.ui.inverted.teal.buttons .button:focus,\n.ui.inverted.teal.button:focus {\n  background-color: #44ffff;\n}\n.ui.inverted.teal.buttons .active.button,\n.ui.inverted.teal.active.button {\n  background-color: #54ffff;\n}\n.ui.inverted.teal.buttons .button:active,\n.ui.inverted.teal.button:active {\n  background-color: #3affff;\n}\n/* Inverted Basic */\n.ui.inverted.teal.basic.buttons .button,\n.ui.inverted.teal.buttons .basic.button,\n.ui.inverted.teal.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.teal.basic.buttons .button:hover,\n.ui.inverted.teal.buttons .basic.button:hover,\n.ui.inverted.teal.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #54ffff inset !important;\n  color: #6DFFFF !important;\n}\n.ui.inverted.teal.basic.buttons .button:focus,\n.ui.inverted.teal.basic.buttons .button:focus,\n.ui.inverted.teal.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #44ffff inset !important;\n  color: #6DFFFF !important;\n}\n.ui.inverted.teal.basic.buttons .active.button,\n.ui.inverted.teal.buttons .basic.active.button,\n.ui.inverted.teal.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #54ffff inset !important;\n  color: #6DFFFF !important;\n}\n.ui.inverted.teal.basic.buttons .button:active,\n.ui.inverted.teal.buttons .basic.button:active,\n.ui.inverted.teal.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #3affff inset !important;\n  color: #6DFFFF !important;\n}\n/*--- Olive ---*/\n.ui.olive.buttons .button,\n.ui.olive.button {\n  background-color: #B5CC18;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.olive.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.olive.buttons .button:hover,\n.ui.olive.button:hover {\n  background-color: #a7bd0d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.olive.buttons .button:focus,\n.ui.olive.button:focus {\n  background-color: #a0b605;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.olive.buttons .button:active,\n.ui.olive.button:active {\n  background-color: #8d9e13;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.olive.buttons .active.button,\n.ui.olive.buttons .active.button:active,\n.ui.olive.active.button,\n.ui.olive.button .active.button:active {\n  background-color: #aac109;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.olive.buttons .button,\n.ui.basic.olive.button {\n  box-shadow: 0px 0px 0px 1px #B5CC18 inset !important;\n  color: #B5CC18 !important;\n}\n.ui.basic.olive.buttons .button:hover,\n.ui.basic.olive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #a7bd0d inset !important;\n  color: #a7bd0d !important;\n}\n.ui.basic.olive.buttons .button:focus,\n.ui.basic.olive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #a0b605 inset !important;\n  color: #a7bd0d !important;\n}\n.ui.basic.olive.buttons .active.button,\n.ui.basic.olive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #aac109 inset !important;\n  color: #8d9e13 !important;\n}\n.ui.basic.olive.buttons .button:active,\n.ui.basic.olive.button:active {\n  box-shadow: 0px 0px 0px 1px #8d9e13 inset !important;\n  color: #8d9e13 !important;\n}\n.ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.olive.buttons .button,\n.ui.inverted.olive.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D9E778 inset !important;\n  color: #D9E778;\n}\n.ui.inverted.olive.buttons .button:hover,\n.ui.inverted.olive.button:hover,\n.ui.inverted.olive.buttons .button:focus,\n.ui.inverted.olive.button:focus,\n.ui.inverted.olive.buttons .button.active,\n.ui.inverted.olive.button.active,\n.ui.inverted.olive.buttons .button:active,\n.ui.inverted.olive.button:active {\n  box-shadow: none !important;\n  color: #eceff8;\n}\n.ui.inverted.olive.buttons .button:hover,\n.ui.inverted.olive.button:hover {\n  background-color: #d8ea5c;\n}\n.ui.inverted.olive.buttons .button:focus,\n.ui.inverted.olive.button:focus {\n  background-color: #daef47;\n}\n.ui.inverted.olive.buttons .active.button,\n.ui.inverted.olive.active.button {\n  background-color: #daed59;\n}\n.ui.inverted.olive.buttons .button:active,\n.ui.inverted.olive.button:active {\n  background-color: #cddf4d;\n}\n/* Inverted Basic */\n.ui.inverted.olive.basic.buttons .button,\n.ui.inverted.olive.buttons .basic.button,\n.ui.inverted.olive.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.olive.basic.buttons .button:hover,\n.ui.inverted.olive.buttons .basic.button:hover,\n.ui.inverted.olive.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #d8ea5c inset !important;\n  color: #D9E778 !important;\n}\n.ui.inverted.olive.basic.buttons .button:focus,\n.ui.inverted.olive.basic.buttons .button:focus,\n.ui.inverted.olive.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #daef47 inset !important;\n  color: #D9E778 !important;\n}\n.ui.inverted.olive.basic.buttons .active.button,\n.ui.inverted.olive.buttons .basic.active.button,\n.ui.inverted.olive.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #daed59 inset !important;\n  color: #D9E778 !important;\n}\n.ui.inverted.olive.basic.buttons .button:active,\n.ui.inverted.olive.buttons .basic.button:active,\n.ui.inverted.olive.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #cddf4d inset !important;\n  color: #D9E778 !important;\n}\n/*--- Yellow ---*/\n.ui.yellow.buttons .button,\n.ui.yellow.button {\n  background-color: #FBBD08;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.yellow.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.yellow.buttons .button:hover,\n.ui.yellow.button:hover {\n  background-color: #eaae00;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.yellow.buttons .button:focus,\n.ui.yellow.button:focus {\n  background-color: #daa300;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.yellow.buttons .button:active,\n.ui.yellow.button:active {\n  background-color: #cd9903;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.yellow.buttons .active.button,\n.ui.yellow.buttons .active.button:active,\n.ui.yellow.active.button,\n.ui.yellow.button .active.button:active {\n  background-color: #eaae00;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.yellow.buttons .button,\n.ui.basic.yellow.button {\n  box-shadow: 0px 0px 0px 1px #FBBD08 inset !important;\n  color: #FBBD08 !important;\n}\n.ui.basic.yellow.buttons .button:hover,\n.ui.basic.yellow.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #eaae00 inset !important;\n  color: #eaae00 !important;\n}\n.ui.basic.yellow.buttons .button:focus,\n.ui.basic.yellow.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #daa300 inset !important;\n  color: #eaae00 !important;\n}\n.ui.basic.yellow.buttons .active.button,\n.ui.basic.yellow.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #eaae00 inset !important;\n  color: #cd9903 !important;\n}\n.ui.basic.yellow.buttons .button:active,\n.ui.basic.yellow.button:active {\n  box-shadow: 0px 0px 0px 1px #cd9903 inset !important;\n  color: #cd9903 !important;\n}\n.ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.yellow.buttons .button,\n.ui.inverted.yellow.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FFE21F inset !important;\n  color: #FFE21F;\n}\n.ui.inverted.yellow.buttons .button:hover,\n.ui.inverted.yellow.button:hover,\n.ui.inverted.yellow.buttons .button:focus,\n.ui.inverted.yellow.button:focus,\n.ui.inverted.yellow.buttons .button.active,\n.ui.inverted.yellow.button.active,\n.ui.inverted.yellow.buttons .button:active,\n.ui.inverted.yellow.button:active {\n  box-shadow: none !important;\n  color: #eceff8;\n}\n.ui.inverted.yellow.buttons .button:hover,\n.ui.inverted.yellow.button:hover {\n  background-color: #ffdf05;\n}\n.ui.inverted.yellow.buttons .button:focus,\n.ui.inverted.yellow.button:focus {\n  background-color: #f5d500;\n}\n.ui.inverted.yellow.buttons .active.button,\n.ui.inverted.yellow.active.button {\n  background-color: #ffdf05;\n}\n.ui.inverted.yellow.buttons .button:active,\n.ui.inverted.yellow.button:active {\n  background-color: #ebcd00;\n}\n/* Inverted Basic */\n.ui.inverted.yellow.basic.buttons .button,\n.ui.inverted.yellow.buttons .basic.button,\n.ui.inverted.yellow.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.yellow.basic.buttons .button:hover,\n.ui.inverted.yellow.buttons .basic.button:hover,\n.ui.inverted.yellow.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;\n  color: #FFE21F !important;\n}\n.ui.inverted.yellow.basic.buttons .button:focus,\n.ui.inverted.yellow.basic.buttons .button:focus,\n.ui.inverted.yellow.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #f5d500 inset !important;\n  color: #FFE21F !important;\n}\n.ui.inverted.yellow.basic.buttons .active.button,\n.ui.inverted.yellow.buttons .basic.active.button,\n.ui.inverted.yellow.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;\n  color: #FFE21F !important;\n}\n.ui.inverted.yellow.basic.buttons .button:active,\n.ui.inverted.yellow.buttons .basic.button:active,\n.ui.inverted.yellow.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ebcd00 inset !important;\n  color: #FFE21F !important;\n}\n/*-------------------\n       Primary\n--------------------*/\n/*--- Standard ---*/\n.ui.primary.buttons .button,\n.ui.primary.button {\n  background-color: #2185D0;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.primary.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.primary.buttons .button:hover,\n.ui.primary.button:hover {\n  background-color: #1678c2;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.primary.buttons .button:focus,\n.ui.primary.button:focus {\n  background-color: #0d71bb;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.primary.buttons .button:active,\n.ui.primary.button:active {\n  background-color: #1a69a4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.primary.buttons .active.button,\n.ui.primary.buttons .active.button:active,\n.ui.primary.active.button,\n.ui.primary.button .active.button:active {\n  background-color: #1279c6;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.primary.buttons .button,\n.ui.basic.primary.button {\n  box-shadow: 0px 0px 0px 1px #2185D0 inset !important;\n  color: #2185D0 !important;\n}\n.ui.basic.primary.buttons .button:hover,\n.ui.basic.primary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1678c2 inset !important;\n  color: #1678c2 !important;\n}\n.ui.basic.primary.buttons .button:focus,\n.ui.basic.primary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0d71bb inset !important;\n  color: #1678c2 !important;\n}\n.ui.basic.primary.buttons .active.button,\n.ui.basic.primary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1279c6 inset !important;\n  color: #1a69a4 !important;\n}\n.ui.basic.primary.buttons .button:active,\n.ui.basic.primary.button:active {\n  box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;\n  color: #1a69a4 !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.primary.buttons .button,\n.ui.inverted.primary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;\n  color: #54C8FF;\n}\n.ui.inverted.primary.buttons .button:hover,\n.ui.inverted.primary.button:hover,\n.ui.inverted.primary.buttons .button:focus,\n.ui.inverted.primary.button:focus,\n.ui.inverted.primary.buttons .button.active,\n.ui.inverted.primary.button.active,\n.ui.inverted.primary.buttons .button:active,\n.ui.inverted.primary.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.primary.buttons .button:hover,\n.ui.inverted.primary.button:hover {\n  background-color: #3ac0ff;\n}\n.ui.inverted.primary.buttons .button:focus,\n.ui.inverted.primary.button:focus {\n  background-color: #2bbbff;\n}\n.ui.inverted.primary.buttons .active.button,\n.ui.inverted.primary.active.button {\n  background-color: #3ac0ff;\n}\n.ui.inverted.primary.buttons .button:active,\n.ui.inverted.primary.button:active {\n  background-color: #21b8ff;\n}\n/* Inverted Basic */\n.ui.inverted.primary.basic.buttons .button,\n.ui.inverted.primary.buttons .basic.button,\n.ui.inverted.primary.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.primary.basic.buttons .button:hover,\n.ui.inverted.primary.buttons .basic.button:hover,\n.ui.inverted.primary.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.primary.basic.buttons .button:focus,\n.ui.inverted.primary.basic.buttons .button:focus,\n.ui.inverted.primary.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.primary.basic.buttons .active.button,\n.ui.inverted.primary.buttons .basic.active.button,\n.ui.inverted.primary.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n.ui.inverted.primary.basic.buttons .button:active,\n.ui.inverted.primary.buttons .basic.button:active,\n.ui.inverted.primary.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;\n  color: #54C8FF !important;\n}\n/*-------------------\n      Secondary\n--------------------*/\n/* Standard */\n.ui.secondary.buttons .button,\n.ui.secondary.button {\n  background-color: #1B1C1D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.secondary.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.secondary.buttons .button:hover,\n.ui.secondary.button:hover {\n  background-color: #27292a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.secondary.buttons .button:focus,\n.ui.secondary.button:focus {\n  background-color: #2e3032;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.secondary.buttons .button:active,\n.ui.secondary.button:active {\n  background-color: #343637;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.secondary.buttons .active.button,\n.ui.secondary.buttons .active.button:active,\n.ui.secondary.active.button,\n.ui.secondary.button .active.button:active {\n  background-color: #27292a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.secondary.buttons .button,\n.ui.basic.secondary.button {\n  box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;\n  color: #1B1C1D !important;\n}\n.ui.basic.secondary.buttons .button:hover,\n.ui.basic.secondary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #27292a inset !important;\n  color: #27292a !important;\n}\n.ui.basic.secondary.buttons .button:focus,\n.ui.basic.secondary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #2e3032 inset !important;\n  color: #27292a !important;\n}\n.ui.basic.secondary.buttons .active.button,\n.ui.basic.secondary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #27292a inset !important;\n  color: #343637 !important;\n}\n.ui.basic.secondary.buttons .button:active,\n.ui.basic.secondary.button:active {\n  box-shadow: 0px 0px 0px 1px #343637 inset !important;\n  color: #343637 !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n/* Inverted */\n.ui.inverted.secondary.buttons .button,\n.ui.inverted.secondary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #545454 inset !important;\n  color: #545454;\n}\n.ui.inverted.secondary.buttons .button:hover,\n.ui.inverted.secondary.button:hover,\n.ui.inverted.secondary.buttons .button:focus,\n.ui.inverted.secondary.button:focus,\n.ui.inverted.secondary.buttons .button.active,\n.ui.inverted.secondary.button.active,\n.ui.inverted.secondary.buttons .button:active,\n.ui.inverted.secondary.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n.ui.inverted.secondary.buttons .button:hover,\n.ui.inverted.secondary.button:hover {\n  background-color: #616161;\n}\n.ui.inverted.secondary.buttons .button:focus,\n.ui.inverted.secondary.button:focus {\n  background-color: #686868;\n}\n.ui.inverted.secondary.buttons .active.button,\n.ui.inverted.secondary.active.button {\n  background-color: #616161;\n}\n.ui.inverted.secondary.buttons .button:active,\n.ui.inverted.secondary.button:active {\n  background-color: #6e6e6e;\n}\n/* Inverted Basic */\n.ui.inverted.secondary.basic.buttons .button,\n.ui.inverted.secondary.buttons .basic.button,\n.ui.inverted.secondary.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n.ui.inverted.secondary.basic.buttons .button:hover,\n.ui.inverted.secondary.buttons .basic.button:hover,\n.ui.inverted.secondary.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #616161 inset !important;\n  color: #545454 !important;\n}\n.ui.inverted.secondary.basic.buttons .button:focus,\n.ui.inverted.secondary.basic.buttons .button:focus,\n.ui.inverted.secondary.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #686868 inset !important;\n  color: #545454 !important;\n}\n.ui.inverted.secondary.basic.buttons .active.button,\n.ui.inverted.secondary.buttons .basic.active.button,\n.ui.inverted.secondary.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #616161 inset !important;\n  color: #545454 !important;\n}\n.ui.inverted.secondary.basic.buttons .button:active,\n.ui.inverted.secondary.buttons .basic.button:active,\n.ui.inverted.secondary.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #6e6e6e inset !important;\n  color: #545454 !important;\n}\n/*---------------\n    Positive\n----------------*/\n/* Standard */\n.ui.positive.buttons .button,\n.ui.positive.button {\n  background-color: #21BA45;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.positive.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.positive.buttons .button:hover,\n.ui.positive.button:hover {\n  background-color: #16ab39;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.positive.buttons .button:focus,\n.ui.positive.button:focus {\n  background-color: #0ea432;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.positive.buttons .button:active,\n.ui.positive.button:active {\n  background-color: #198f35;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.positive.buttons .active.button,\n.ui.positive.buttons .active.button:active,\n.ui.positive.active.button,\n.ui.positive.button .active.button:active {\n  background-color: #13ae38;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.positive.buttons .button,\n.ui.basic.positive.button {\n  box-shadow: 0px 0px 0px 1px #21BA45 inset !important;\n  color: #21BA45 !important;\n}\n.ui.basic.positive.buttons .button:hover,\n.ui.basic.positive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #16ab39 inset !important;\n  color: #16ab39 !important;\n}\n.ui.basic.positive.buttons .button:focus,\n.ui.basic.positive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0ea432 inset !important;\n  color: #16ab39 !important;\n}\n.ui.basic.positive.buttons .active.button,\n.ui.basic.positive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #13ae38 inset !important;\n  color: #198f35 !important;\n}\n.ui.basic.positive.buttons .button:active,\n.ui.basic.positive.button:active {\n  box-shadow: 0px 0px 0px 1px #198f35 inset !important;\n  color: #198f35 !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n/*---------------\n     Negative\n----------------*/\n/* Standard */\n.ui.negative.buttons .button,\n.ui.negative.button {\n  background-color: #DB2828;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n.ui.negative.button {\n  box-shadow: 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.negative.buttons .button:hover,\n.ui.negative.button:hover {\n  background-color: #d01919;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.negative.buttons .button:focus,\n.ui.negative.button:focus {\n  background-color: #ca1010;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.negative.buttons .button:active,\n.ui.negative.button:active {\n  background-color: #b21e1e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n.ui.negative.buttons .active.button,\n.ui.negative.buttons .active.button:active,\n.ui.negative.active.button,\n.ui.negative.button .active.button:active {\n  background-color: #d41515;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n/* Basic */\n.ui.basic.negative.buttons .button,\n.ui.basic.negative.button {\n  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;\n  color: #DB2828 !important;\n}\n.ui.basic.negative.buttons .button:hover,\n.ui.basic.negative.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d01919 inset !important;\n  color: #d01919 !important;\n}\n.ui.basic.negative.buttons .button:focus,\n.ui.basic.negative.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;\n  color: #d01919 !important;\n}\n.ui.basic.negative.buttons .active.button,\n.ui.basic.negative.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d41515 inset !important;\n  color: #b21e1e !important;\n}\n.ui.basic.negative.buttons .button:active,\n.ui.basic.negative.button:active {\n  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;\n  color: #b21e1e !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n/*******************************\n            Groups\n*******************************/\n.ui.buttons {\n  display: inline-flex;\n  flex-direction: row;\n  font-size: 0em;\n  vertical-align: baseline;\n  margin: 0em 0.25em 0em 0em;\n}\n.ui.buttons:not(.basic):not(.inverted) {\n  box-shadow: none;\n}\n/* Clearfix */\n.ui.buttons:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n/* Standard Group */\n.ui.buttons .button {\n  flex: 1 0 auto;\n  margin: 0em;\n  border-radius: 0em;\n  margin: 0px 0px 0px 0px;\n}\n.ui.buttons > .ui.button:not(.basic):not(.inverted),\n.ui.buttons:not(.basic):not(.inverted) > .button {\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(255, 255, 255, 0.15) inset;\n}\n.ui.buttons .button:first-child {\n  border-left: none;\n  margin-left: 0em;\n  border-top-left-radius: 0.28571429rem;\n  border-bottom-left-radius: 0.28571429rem;\n}\n.ui.buttons .button:last-child {\n  border-top-right-radius: 0.28571429rem;\n  border-bottom-right-radius: 0.28571429rem;\n}\n/* Vertical  Style */\n.ui.vertical.buttons {\n  display: inline-flex;\n  flex-direction: column;\n}\n.ui.vertical.buttons .button {\n  display: block;\n  float: none;\n  width: 100%;\n  margin: 0px 0px 0px 0px;\n  box-shadow: none;\n  border-radius: 0em;\n}\n.ui.vertical.buttons .button:first-child {\n  border-top-left-radius: 0.28571429rem;\n  border-top-right-radius: 0.28571429rem;\n}\n.ui.vertical.buttons .button:last-child {\n  margin-bottom: 0px;\n  border-bottom-left-radius: 0.28571429rem;\n  border-bottom-right-radius: 0.28571429rem;\n}\n.ui.vertical.buttons .button:only-child {\n  border-radius: 0.28571429rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Container\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Container\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Minimum Gutter is used to determine  the maximum container width for a given device */\n/* Devices */\n/* Coupling (Add Negative Margin to container size) */\n/*-------------------\n       Types\n--------------------*/\n/* Text */\n/* Packaged Theme */\n/*******************************\n            Container\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Minimum Gutter is used to determine  the maximum container width for a given device */\n/* Devices */\n/* Coupling (Add Negative Margin to container size) */\n/*-------------------\n       Types\n--------------------*/\n/* Text */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Container\n*******************************/\n/* All Sizes */\n.ui.container {\n  display: block;\n  max-width: 100% !important;\n}\n/* Mobile */\n@media only screen and (max-width: 767px) {\n  .ui.container {\n    width: auto !important;\n    margin-left: 1em !important;\n    margin-right: 1em !important;\n  }\n  .ui.grid.container {\n    width: auto !important;\n  }\n  .ui.relaxed.grid.container {\n    width: auto !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: auto !important;\n  }\n}\n/* Tablet */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.container {\n    width: 723px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  .ui.grid.container {\n    width: calc( 723px  +  2rem ) !important;\n  }\n  .ui.relaxed.grid.container {\n    width: calc( 723px  +  3rem ) !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: calc( 723px  +  5rem ) !important;\n  }\n}\n/* Small Monitor */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui.container {\n    width: 933px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  .ui.grid.container {\n    width: calc( 933px  +  2rem ) !important;\n  }\n  .ui.relaxed.grid.container {\n    width: calc( 933px  +  3rem ) !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: calc( 933px  +  5rem ) !important;\n  }\n}\n/* Large Monitor */\n@media only screen and (min-width: 1200px) {\n  .ui.container {\n    width: 1127px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  .ui.grid.container {\n    width: calc( 1127px  +  2rem ) !important;\n  }\n  .ui.relaxed.grid.container {\n    width: calc( 1127px  +  3rem ) !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: calc( 1127px  +  5rem ) !important;\n  }\n}\n/*******************************\n             Types\n*******************************/\n/* Text Container */\n.ui.text.container {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  max-width: 700px !important;\n  line-height: 1.5;\n}\n.ui.text.container {\n  font-size: 1.14285714rem;\n}\n/* Fluid */\n.ui.fluid.container {\n  width: 100%;\n}\n/*******************************\n           Variations\n*******************************/\n.ui[class*=\"left aligned\"].container {\n  text-align: left;\n}\n.ui[class*=\"center aligned\"].container {\n  text-align: center;\n}\n.ui[class*=\"right aligned\"].container {\n  text-align: right;\n}\n.ui.justified.container {\n  text-align: justify;\n  hyphens: auto;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Divider\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Divider\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Text */\n/*-------------------\n       Coupling\n--------------------*/\n/* Icon */\n/*******************************\n         Variations\n*******************************/\n/* Horizontal / Vertical */\n/* Inverted */\n/* Section */\n/* Sizes */\n/* Packaged Theme */\n/*******************************\n            Divider\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Text */\n/*-------------------\n       Coupling\n--------------------*/\n/* Icon */\n/*******************************\n         Variations\n*******************************/\n/* Horizontal / Vertical */\n/* Inverted */\n/* Section */\n/* Sizes */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Divider\n*******************************/\n.ui.divider {\n  margin: 1rem 0rem;\n  line-height: 1;\n  height: 0em;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: rgba(255, 255, 255, 0.85);\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n/*--------------\n      Basic\n---------------*/\n.ui.divider:not(.vertical):not(.horizontal) {\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n/*--------------\n    Coupling\n---------------*/\n/* Allow divider between each column row */\n.ui.grid > .column + .divider,\n.ui.grid > .row > .column + .divider {\n  left: auto;\n}\n/*--------------\n   Horizontal\n---------------*/\n.ui.horizontal.divider {\n  display: table;\n  white-space: nowrap;\n  height: auto;\n  margin: '';\n  line-height: 1;\n  text-align: center;\n}\n.ui.horizontal.divider:before,\n.ui.horizontal.divider:after {\n  content: '';\n  display: table-cell;\n  position: relative;\n  top: 50%;\n  width: 50%;\n  background-repeat: no-repeat;\n}\n.ui.horizontal.divider:before {\n  background-position: right 1em top 50%;\n}\n.ui.horizontal.divider:after {\n  background-position: left 1em top 50%;\n}\n/*--------------\n    Vertical\n---------------*/\n.ui.vertical.divider {\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  margin: 0rem;\n  padding: 0em;\n  width: auto;\n  height: 50%;\n  line-height: 0em;\n  text-align: center;\n  transform: translateX(-50%);\n}\n.ui.vertical.divider:before,\n.ui.vertical.divider:after {\n  position: absolute;\n  left: 50%;\n  content: '';\n  z-index: 3;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  width: 0%;\n  height: calc(100% -  1rem );\n}\n.ui.vertical.divider:before {\n  top: -100%;\n}\n.ui.vertical.divider:after {\n  top: auto;\n  bottom: 0px;\n}\n/* Inside grid */\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid .ui.vertical.divider,\n  .ui.grid .stackable.row .ui.vertical.divider {\n    display: table;\n    white-space: nowrap;\n    height: auto;\n    margin: '';\n    overflow: hidden;\n    line-height: 1;\n    text-align: center;\n    position: static;\n    top: 0;\n    left: 0;\n    transform: none;\n  }\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before,\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    position: static;\n    left: 0;\n    border-left: none;\n    border-right: none;\n    content: '';\n    display: table-cell;\n    position: relative;\n    top: 50%;\n    width: 50%;\n    background-repeat: no-repeat;\n  }\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before {\n    background-position: right 1em top 50%;\n  }\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-position: left 1em top 50%;\n  }\n}\n/*--------------\n      Icon\n---------------*/\n.ui.divider > .icon {\n  margin: 0rem;\n  font-size: 1rem;\n  height: 1em;\n  vertical-align: middle;\n}\n/*******************************\n          Variations\n*******************************/\n/*--------------\n    Hidden\n---------------*/\n.ui.hidden.divider {\n  border-color: transparent !important;\n}\n.ui.hidden.divider:before,\n.ui.hidden.divider:after {\n  display: none;\n}\n/*--------------\n    Inverted\n---------------*/\n.ui.divider.inverted,\n.ui.vertical.inverted.divider,\n.ui.horizontal.inverted.divider {\n  color: #FFFFFF;\n}\n.ui.divider.inverted,\n.ui.divider.inverted:after,\n.ui.divider.inverted:before {\n  border-top-color: rgba(255, 255, 255, 0.15) !important;\n  border-left-color: rgba(255, 255, 255, 0.15) !important;\n  border-bottom-color: rgba(255, 255, 255, 0.15) !important;\n  border-right-color: rgba(255, 255, 255, 0.15) !important;\n}\n/*--------------\n    Fitted\n---------------*/\n.ui.fitted.divider {\n  margin: 0em;\n}\n/*--------------\n    Clearing\n---------------*/\n.ui.clearing.divider {\n  clear: both;\n}\n/*--------------\n    Section\n---------------*/\n.ui.section.divider {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n/*--------------\n     Sizes\n---------------*/\n.ui.divider {\n  font-size: 1rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n.ui.horizontal.divider:before,\n.ui.horizontal.divider:after {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n}\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before,\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n  }\n}\n/*!\n * # Semantic UI - Flag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Flag\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Packaged Theme */\n/*******************************\n            Flag\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Flag\n*******************************/\ni.flag:not(.icon) {\n  display: inline-block;\n  width: 16px;\n  height: 11px;\n  line-height: 11px;\n  vertical-align: baseline;\n  margin: 0em 0.5em 0em 0em;\n  text-decoration: inherit;\n  speak: none;\n  font-smoothing: antialiased;\n  backface-visibility: hidden;\n}\n/* Sprite */\ni.flag:not(.icon):before {\n  display: inline-block;\n  content: '';\n  background: url(\"./themes/default/assets/images/flags.png\") no-repeat -108px -1976px;\n  width: 16px;\n  height: 11px;\n}\n/* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */\n/*******************************\n         Theme Overrides\n*******************************/\ni.flag.ad:before,\ni.flag.andorra:before {\n  background-position: 0px 0px;\n}\ni.flag.ae:before,\ni.flag.united.arab.emirates:before,\ni.flag.uae:before {\n  background-position: 0px -26px;\n}\ni.flag.af:before,\ni.flag.afghanistan:before {\n  background-position: 0px -52px;\n}\ni.flag.ag:before,\ni.flag.antigua:before {\n  background-position: 0px -78px;\n}\ni.flag.ai:before,\ni.flag.anguilla:before {\n  background-position: 0px -104px;\n}\ni.flag.al:before,\ni.flag.albania:before {\n  background-position: 0px -130px;\n}\ni.flag.am:before,\ni.flag.armenia:before {\n  background-position: 0px -156px;\n}\ni.flag.an:before,\ni.flag.netherlands.antilles:before {\n  background-position: 0px -182px;\n}\ni.flag.ao:before,\ni.flag.angola:before {\n  background-position: 0px -208px;\n}\ni.flag.ar:before,\ni.flag.argentina:before {\n  background-position: 0px -234px;\n}\ni.flag.as:before,\ni.flag.american.samoa:before {\n  background-position: 0px -260px;\n}\ni.flag.at:before,\ni.flag.austria:before {\n  background-position: 0px -286px;\n}\ni.flag.au:before,\ni.flag.australia:before {\n  background-position: 0px -312px;\n}\ni.flag.aw:before,\ni.flag.aruba:before {\n  background-position: 0px -338px;\n}\ni.flag.ax:before,\ni.flag.aland.islands:before {\n  background-position: 0px -364px;\n}\ni.flag.az:before,\ni.flag.azerbaijan:before {\n  background-position: 0px -390px;\n}\ni.flag.ba:before,\ni.flag.bosnia:before {\n  background-position: 0px -416px;\n}\ni.flag.bb:before,\ni.flag.barbados:before {\n  background-position: 0px -442px;\n}\ni.flag.bd:before,\ni.flag.bangladesh:before {\n  background-position: 0px -468px;\n}\ni.flag.be:before,\ni.flag.belgium:before {\n  background-position: 0px -494px;\n}\ni.flag.bf:before,\ni.flag.burkina.faso:before {\n  background-position: 0px -520px;\n}\ni.flag.bg:before,\ni.flag.bulgaria:before {\n  background-position: 0px -546px;\n}\ni.flag.bh:before,\ni.flag.bahrain:before {\n  background-position: 0px -572px;\n}\ni.flag.bi:before,\ni.flag.burundi:before {\n  background-position: 0px -598px;\n}\ni.flag.bj:before,\ni.flag.benin:before {\n  background-position: 0px -624px;\n}\ni.flag.bm:before,\ni.flag.bermuda:before {\n  background-position: 0px -650px;\n}\ni.flag.bn:before,\ni.flag.brunei:before {\n  background-position: 0px -676px;\n}\ni.flag.bo:before,\ni.flag.bolivia:before {\n  background-position: 0px -702px;\n}\ni.flag.br:before,\ni.flag.brazil:before {\n  background-position: 0px -728px;\n}\ni.flag.bs:before,\ni.flag.bahamas:before {\n  background-position: 0px -754px;\n}\ni.flag.bt:before,\ni.flag.bhutan:before {\n  background-position: 0px -780px;\n}\ni.flag.bv:before,\ni.flag.bouvet.island:before {\n  background-position: 0px -806px;\n}\ni.flag.bw:before,\ni.flag.botswana:before {\n  background-position: 0px -832px;\n}\ni.flag.by:before,\ni.flag.belarus:before {\n  background-position: 0px -858px;\n}\ni.flag.bz:before,\ni.flag.belize:before {\n  background-position: 0px -884px;\n}\ni.flag.ca:before,\ni.flag.canada:before {\n  background-position: 0px -910px;\n}\ni.flag.cc:before,\ni.flag.cocos.islands:before {\n  background-position: 0px -962px;\n}\ni.flag.cd:before,\ni.flag.congo:before {\n  background-position: 0px -988px;\n}\ni.flag.cf:before,\ni.flag.central.african.republic:before {\n  background-position: 0px -1014px;\n}\ni.flag.cg:before,\ni.flag.congo.brazzaville:before {\n  background-position: 0px -1040px;\n}\ni.flag.ch:before,\ni.flag.switzerland:before {\n  background-position: 0px -1066px;\n}\ni.flag.ci:before,\ni.flag.cote.divoire:before {\n  background-position: 0px -1092px;\n}\ni.flag.ck:before,\ni.flag.cook.islands:before {\n  background-position: 0px -1118px;\n}\ni.flag.cl:before,\ni.flag.chile:before {\n  background-position: 0px -1144px;\n}\ni.flag.cm:before,\ni.flag.cameroon:before {\n  background-position: 0px -1170px;\n}\ni.flag.cn:before,\ni.flag.china:before {\n  background-position: 0px -1196px;\n}\ni.flag.co:before,\ni.flag.colombia:before {\n  background-position: 0px -1222px;\n}\ni.flag.cr:before,\ni.flag.costa.rica:before {\n  background-position: 0px -1248px;\n}\ni.flag.cs:before,\ni.flag.serbia:before {\n  background-position: 0px -1274px;\n}\ni.flag.cu:before,\ni.flag.cuba:before {\n  background-position: 0px -1300px;\n}\ni.flag.cv:before,\ni.flag.cape.verde:before {\n  background-position: 0px -1326px;\n}\ni.flag.cx:before,\ni.flag.christmas.island:before {\n  background-position: 0px -1352px;\n}\ni.flag.cy:before,\ni.flag.cyprus:before {\n  background-position: 0px -1378px;\n}\ni.flag.cz:before,\ni.flag.czech.republic:before {\n  background-position: 0px -1404px;\n}\ni.flag.de:before,\ni.flag.germany:before {\n  background-position: 0px -1430px;\n}\ni.flag.dj:before,\ni.flag.djibouti:before {\n  background-position: 0px -1456px;\n}\ni.flag.dk:before,\ni.flag.denmark:before {\n  background-position: 0px -1482px;\n}\ni.flag.dm:before,\ni.flag.dominica:before {\n  background-position: 0px -1508px;\n}\ni.flag.do:before,\ni.flag.dominican.republic:before {\n  background-position: 0px -1534px;\n}\ni.flag.dz:before,\ni.flag.algeria:before {\n  background-position: 0px -1560px;\n}\ni.flag.ec:before,\ni.flag.ecuador:before {\n  background-position: 0px -1586px;\n}\ni.flag.ee:before,\ni.flag.estonia:before {\n  background-position: 0px -1612px;\n}\ni.flag.eg:before,\ni.flag.egypt:before {\n  background-position: 0px -1638px;\n}\ni.flag.eh:before,\ni.flag.western.sahara:before {\n  background-position: 0px -1664px;\n}\ni.flag.gb.eng:before,\ni.flag.england:before {\n  background-position: 0px -1690px;\n}\ni.flag.er:before,\ni.flag.eritrea:before {\n  background-position: 0px -1716px;\n}\ni.flag.es:before,\ni.flag.spain:before {\n  background-position: 0px -1742px;\n}\ni.flag.et:before,\ni.flag.ethiopia:before {\n  background-position: 0px -1768px;\n}\ni.flag.eu:before,\ni.flag.european.union:before {\n  background-position: 0px -1794px;\n}\ni.flag.fi:before,\ni.flag.finland:before {\n  background-position: 0px -1846px;\n}\ni.flag.fj:before,\ni.flag.fiji:before {\n  background-position: 0px -1872px;\n}\ni.flag.fk:before,\ni.flag.falkland.islands:before {\n  background-position: 0px -1898px;\n}\ni.flag.fm:before,\ni.flag.micronesia:before {\n  background-position: 0px -1924px;\n}\ni.flag.fo:before,\ni.flag.faroe.islands:before {\n  background-position: 0px -1950px;\n}\ni.flag.fr:before,\ni.flag.france:before {\n  background-position: 0px -1976px;\n}\ni.flag.ga:before,\ni.flag.gabon:before {\n  background-position: -36px 0px;\n}\ni.flag.gb:before,\ni.flag.uk:before,\ni.flag.united.kingdom:before {\n  background-position: -36px -26px;\n}\ni.flag.gd:before,\ni.flag.grenada:before {\n  background-position: -36px -52px;\n}\ni.flag.ge:before,\ni.flag.georgia:before {\n  background-position: -36px -78px;\n}\ni.flag.gf:before,\ni.flag.french.guiana:before {\n  background-position: -36px -104px;\n}\ni.flag.gh:before,\ni.flag.ghana:before {\n  background-position: -36px -130px;\n}\ni.flag.gi:before,\ni.flag.gibraltar:before {\n  background-position: -36px -156px;\n}\ni.flag.gl:before,\ni.flag.greenland:before {\n  background-position: -36px -182px;\n}\ni.flag.gm:before,\ni.flag.gambia:before {\n  background-position: -36px -208px;\n}\ni.flag.gn:before,\ni.flag.guinea:before {\n  background-position: -36px -234px;\n}\ni.flag.gp:before,\ni.flag.guadeloupe:before {\n  background-position: -36px -260px;\n}\ni.flag.gq:before,\ni.flag.equatorial.guinea:before {\n  background-position: -36px -286px;\n}\ni.flag.gr:before,\ni.flag.greece:before {\n  background-position: -36px -312px;\n}\ni.flag.gs:before,\ni.flag.sandwich.islands:before {\n  background-position: -36px -338px;\n}\ni.flag.gt:before,\ni.flag.guatemala:before {\n  background-position: -36px -364px;\n}\ni.flag.gu:before,\ni.flag.guam:before {\n  background-position: -36px -390px;\n}\ni.flag.gw:before,\ni.flag.guinea-bissau:before {\n  background-position: -36px -416px;\n}\ni.flag.gy:before,\ni.flag.guyana:before {\n  background-position: -36px -442px;\n}\ni.flag.hk:before,\ni.flag.hong.kong:before {\n  background-position: -36px -468px;\n}\ni.flag.hm:before,\ni.flag.heard.island:before {\n  background-position: -36px -494px;\n}\ni.flag.hn:before,\ni.flag.honduras:before {\n  background-position: -36px -520px;\n}\ni.flag.hr:before,\ni.flag.croatia:before {\n  background-position: -36px -546px;\n}\ni.flag.ht:before,\ni.flag.haiti:before {\n  background-position: -36px -572px;\n}\ni.flag.hu:before,\ni.flag.hungary:before {\n  background-position: -36px -598px;\n}\ni.flag.id:before,\ni.flag.indonesia:before {\n  background-position: -36px -624px;\n}\ni.flag.ie:before,\ni.flag.ireland:before {\n  background-position: -36px -650px;\n}\ni.flag.il:before,\ni.flag.israel:before {\n  background-position: -36px -676px;\n}\ni.flag.in:before,\ni.flag.india:before {\n  background-position: -36px -702px;\n}\ni.flag.io:before,\ni.flag.indian.ocean.territory:before {\n  background-position: -36px -728px;\n}\ni.flag.iq:before,\ni.flag.iraq:before {\n  background-position: -36px -754px;\n}\ni.flag.ir:before,\ni.flag.iran:before {\n  background-position: -36px -780px;\n}\ni.flag.is:before,\ni.flag.iceland:before {\n  background-position: -36px -806px;\n}\ni.flag.it:before,\ni.flag.italy:before {\n  background-position: -36px -832px;\n}\ni.flag.jm:before,\ni.flag.jamaica:before {\n  background-position: -36px -858px;\n}\ni.flag.jo:before,\ni.flag.jordan:before {\n  background-position: -36px -884px;\n}\ni.flag.jp:before,\ni.flag.japan:before {\n  background-position: -36px -910px;\n}\ni.flag.ke:before,\ni.flag.kenya:before {\n  background-position: -36px -936px;\n}\ni.flag.kg:before,\ni.flag.kyrgyzstan:before {\n  background-position: -36px -962px;\n}\ni.flag.kh:before,\ni.flag.cambodia:before {\n  background-position: -36px -988px;\n}\ni.flag.ki:before,\ni.flag.kiribati:before {\n  background-position: -36px -1014px;\n}\ni.flag.km:before,\ni.flag.comoros:before {\n  background-position: -36px -1040px;\n}\ni.flag.kn:before,\ni.flag.saint.kitts.and.nevis:before {\n  background-position: -36px -1066px;\n}\ni.flag.kp:before,\ni.flag.north.korea:before {\n  background-position: -36px -1092px;\n}\ni.flag.kr:before,\ni.flag.south.korea:before {\n  background-position: -36px -1118px;\n}\ni.flag.kw:before,\ni.flag.kuwait:before {\n  background-position: -36px -1144px;\n}\ni.flag.ky:before,\ni.flag.cayman.islands:before {\n  background-position: -36px -1170px;\n}\ni.flag.kz:before,\ni.flag.kazakhstan:before {\n  background-position: -36px -1196px;\n}\ni.flag.la:before,\ni.flag.laos:before {\n  background-position: -36px -1222px;\n}\ni.flag.lb:before,\ni.flag.lebanon:before {\n  background-position: -36px -1248px;\n}\ni.flag.lc:before,\ni.flag.saint.lucia:before {\n  background-position: -36px -1274px;\n}\ni.flag.li:before,\ni.flag.liechtenstein:before {\n  background-position: -36px -1300px;\n}\ni.flag.lk:before,\ni.flag.sri.lanka:before {\n  background-position: -36px -1326px;\n}\ni.flag.lr:before,\ni.flag.liberia:before {\n  background-position: -36px -1352px;\n}\ni.flag.ls:before,\ni.flag.lesotho:before {\n  background-position: -36px -1378px;\n}\ni.flag.lt:before,\ni.flag.lithuania:before {\n  background-position: -36px -1404px;\n}\ni.flag.lu:before,\ni.flag.luxembourg:before {\n  background-position: -36px -1430px;\n}\ni.flag.lv:before,\ni.flag.latvia:before {\n  background-position: -36px -1456px;\n}\ni.flag.ly:before,\ni.flag.libya:before {\n  background-position: -36px -1482px;\n}\ni.flag.ma:before,\ni.flag.morocco:before {\n  background-position: -36px -1508px;\n}\ni.flag.mc:before,\ni.flag.monaco:before {\n  background-position: -36px -1534px;\n}\ni.flag.md:before,\ni.flag.moldova:before {\n  background-position: -36px -1560px;\n}\ni.flag.me:before,\ni.flag.montenegro:before {\n  background-position: -36px -1586px;\n}\ni.flag.mg:before,\ni.flag.madagascar:before {\n  background-position: -36px -1613px;\n}\ni.flag.mh:before,\ni.flag.marshall.islands:before {\n  background-position: -36px -1639px;\n}\ni.flag.mk:before,\ni.flag.macedonia:before {\n  background-position: -36px -1665px;\n}\ni.flag.ml:before,\ni.flag.mali:before {\n  background-position: -36px -1691px;\n}\ni.flag.mm:before,\ni.flag.myanmar:before,\ni.flag.burma:before {\n  background-position: -73px -1821px;\n}\ni.flag.mn:before,\ni.flag.mongolia:before {\n  background-position: -36px -1743px;\n}\ni.flag.mo:before,\ni.flag.macau:before {\n  background-position: -36px -1769px;\n}\ni.flag.mp:before,\ni.flag.northern.mariana.islands:before {\n  background-position: -36px -1795px;\n}\ni.flag.mq:before,\ni.flag.martinique:before {\n  background-position: -36px -1821px;\n}\ni.flag.mr:before,\ni.flag.mauritania:before {\n  background-position: -36px -1847px;\n}\ni.flag.ms:before,\ni.flag.montserrat:before {\n  background-position: -36px -1873px;\n}\ni.flag.mt:before,\ni.flag.malta:before {\n  background-position: -36px -1899px;\n}\ni.flag.mu:before,\ni.flag.mauritius:before {\n  background-position: -36px -1925px;\n}\ni.flag.mv:before,\ni.flag.maldives:before {\n  background-position: -36px -1951px;\n}\ni.flag.mw:before,\ni.flag.malawi:before {\n  background-position: -36px -1977px;\n}\ni.flag.mx:before,\ni.flag.mexico:before {\n  background-position: -72px 0px;\n}\ni.flag.my:before,\ni.flag.malaysia:before {\n  background-position: -72px -26px;\n}\ni.flag.mz:before,\ni.flag.mozambique:before {\n  background-position: -72px -52px;\n}\ni.flag.na:before,\ni.flag.namibia:before {\n  background-position: -72px -78px;\n}\ni.flag.nc:before,\ni.flag.new.caledonia:before {\n  background-position: -72px -104px;\n}\ni.flag.ne:before,\ni.flag.niger:before {\n  background-position: -72px -130px;\n}\ni.flag.nf:before,\ni.flag.norfolk.island:before {\n  background-position: -72px -156px;\n}\ni.flag.ng:before,\ni.flag.nigeria:before {\n  background-position: -72px -182px;\n}\ni.flag.ni:before,\ni.flag.nicaragua:before {\n  background-position: -72px -208px;\n}\ni.flag.nl:before,\ni.flag.netherlands:before {\n  background-position: -72px -234px;\n}\ni.flag.no:before,\ni.flag.norway:before {\n  background-position: -72px -260px;\n}\ni.flag.np:before,\ni.flag.nepal:before {\n  background-position: -72px -286px;\n}\ni.flag.nr:before,\ni.flag.nauru:before {\n  background-position: -72px -312px;\n}\ni.flag.nu:before,\ni.flag.niue:before {\n  background-position: -72px -338px;\n}\ni.flag.nz:before,\ni.flag.new.zealand:before {\n  background-position: -72px -364px;\n}\ni.flag.om:before,\ni.flag.oman:before {\n  background-position: -72px -390px;\n}\ni.flag.pa:before,\ni.flag.panama:before {\n  background-position: -72px -416px;\n}\ni.flag.pe:before,\ni.flag.peru:before {\n  background-position: -72px -442px;\n}\ni.flag.pf:before,\ni.flag.french.polynesia:before {\n  background-position: -72px -468px;\n}\ni.flag.pg:before,\ni.flag.new.guinea:before {\n  background-position: -72px -494px;\n}\ni.flag.ph:before,\ni.flag.philippines:before {\n  background-position: -72px -520px;\n}\ni.flag.pk:before,\ni.flag.pakistan:before {\n  background-position: -72px -546px;\n}\ni.flag.pl:before,\ni.flag.poland:before {\n  background-position: -72px -572px;\n}\ni.flag.pm:before,\ni.flag.saint.pierre:before {\n  background-position: -72px -598px;\n}\ni.flag.pn:before,\ni.flag.pitcairn.islands:before {\n  background-position: -72px -624px;\n}\ni.flag.pr:before,\ni.flag.puerto.rico:before {\n  background-position: -72px -650px;\n}\ni.flag.ps:before,\ni.flag.palestine:before {\n  background-position: -72px -676px;\n}\ni.flag.pt:before,\ni.flag.portugal:before {\n  background-position: -72px -702px;\n}\ni.flag.pw:before,\ni.flag.palau:before {\n  background-position: -72px -728px;\n}\ni.flag.py:before,\ni.flag.paraguay:before {\n  background-position: -72px -754px;\n}\ni.flag.qa:before,\ni.flag.qatar:before {\n  background-position: -72px -780px;\n}\ni.flag.re:before,\ni.flag.reunion:before {\n  background-position: -72px -806px;\n}\ni.flag.ro:before,\ni.flag.romania:before {\n  background-position: -72px -832px;\n}\ni.flag.rs:before,\ni.flag.serbia:before {\n  background-position: -72px -858px;\n}\ni.flag.ru:before,\ni.flag.russia:before {\n  background-position: -72px -884px;\n}\ni.flag.rw:before,\ni.flag.rwanda:before {\n  background-position: -72px -910px;\n}\ni.flag.sa:before,\ni.flag.saudi.arabia:before {\n  background-position: -72px -936px;\n}\ni.flag.sb:before,\ni.flag.solomon.islands:before {\n  background-position: -72px -962px;\n}\ni.flag.sc:before,\ni.flag.seychelles:before {\n  background-position: -72px -988px;\n}\ni.flag.gb.sct:before,\ni.flag.scotland:before {\n  background-position: -72px -1014px;\n}\ni.flag.sd:before,\ni.flag.sudan:before {\n  background-position: -72px -1040px;\n}\ni.flag.se:before,\ni.flag.sweden:before {\n  background-position: -72px -1066px;\n}\ni.flag.sg:before,\ni.flag.singapore:before {\n  background-position: -72px -1092px;\n}\ni.flag.sh:before,\ni.flag.saint.helena:before {\n  background-position: -72px -1118px;\n}\ni.flag.si:before,\ni.flag.slovenia:before {\n  background-position: -72px -1144px;\n}\ni.flag.sj:before,\ni.flag.svalbard:before,\ni.flag.jan.mayen:before {\n  background-position: -72px -1170px;\n}\ni.flag.sk:before,\ni.flag.slovakia:before {\n  background-position: -72px -1196px;\n}\ni.flag.sl:before,\ni.flag.sierra.leone:before {\n  background-position: -72px -1222px;\n}\ni.flag.sm:before,\ni.flag.san.marino:before {\n  background-position: -72px -1248px;\n}\ni.flag.sn:before,\ni.flag.senegal:before {\n  background-position: -72px -1274px;\n}\ni.flag.so:before,\ni.flag.somalia:before {\n  background-position: -72px -1300px;\n}\ni.flag.sr:before,\ni.flag.suriname:before {\n  background-position: -72px -1326px;\n}\ni.flag.st:before,\ni.flag.sao.tome:before {\n  background-position: -72px -1352px;\n}\ni.flag.sv:before,\ni.flag.el.salvador:before {\n  background-position: -72px -1378px;\n}\ni.flag.sy:before,\ni.flag.syria:before {\n  background-position: -72px -1404px;\n}\ni.flag.sz:before,\ni.flag.swaziland:before {\n  background-position: -72px -1430px;\n}\ni.flag.tc:before,\ni.flag.caicos.islands:before {\n  background-position: -72px -1456px;\n}\ni.flag.td:before,\ni.flag.chad:before {\n  background-position: -72px -1482px;\n}\ni.flag.tf:before,\ni.flag.french.territories:before {\n  background-position: -72px -1508px;\n}\ni.flag.tg:before,\ni.flag.togo:before {\n  background-position: -72px -1534px;\n}\ni.flag.th:before,\ni.flag.thailand:before {\n  background-position: -72px -1560px;\n}\ni.flag.tj:before,\ni.flag.tajikistan:before {\n  background-position: -72px -1586px;\n}\ni.flag.tk:before,\ni.flag.tokelau:before {\n  background-position: -72px -1612px;\n}\ni.flag.tl:before,\ni.flag.timorleste:before {\n  background-position: -72px -1638px;\n}\ni.flag.tm:before,\ni.flag.turkmenistan:before {\n  background-position: -72px -1664px;\n}\ni.flag.tn:before,\ni.flag.tunisia:before {\n  background-position: -72px -1690px;\n}\ni.flag.to:before,\ni.flag.tonga:before {\n  background-position: -72px -1716px;\n}\ni.flag.tr:before,\ni.flag.turkey:before {\n  background-position: -72px -1742px;\n}\ni.flag.tt:before,\ni.flag.trinidad:before {\n  background-position: -72px -1768px;\n}\ni.flag.tv:before,\ni.flag.tuvalu:before {\n  background-position: -72px -1794px;\n}\ni.flag.tw:before,\ni.flag.taiwan:before {\n  background-position: -72px -1820px;\n}\ni.flag.tz:before,\ni.flag.tanzania:before {\n  background-position: -72px -1846px;\n}\ni.flag.ua:before,\ni.flag.ukraine:before {\n  background-position: -72px -1872px;\n}\ni.flag.ug:before,\ni.flag.uganda:before {\n  background-position: -72px -1898px;\n}\ni.flag.um:before,\ni.flag.us.minor.islands:before {\n  background-position: -72px -1924px;\n}\ni.flag.us:before,\ni.flag.america:before,\ni.flag.united.states:before {\n  background-position: -72px -1950px;\n}\ni.flag.uy:before,\ni.flag.uruguay:before {\n  background-position: -72px -1976px;\n}\ni.flag.uz:before,\ni.flag.uzbekistan:before {\n  background-position: -108px 0px;\n}\ni.flag.va:before,\ni.flag.vatican.city:before {\n  background-position: -108px -26px;\n}\ni.flag.vc:before,\ni.flag.saint.vincent:before {\n  background-position: -108px -52px;\n}\ni.flag.ve:before,\ni.flag.venezuela:before {\n  background-position: -108px -78px;\n}\ni.flag.vg:before,\ni.flag.british.virgin.islands:before {\n  background-position: -108px -104px;\n}\ni.flag.vi:before,\ni.flag.us.virgin.islands:before {\n  background-position: -108px -130px;\n}\ni.flag.vn:before,\ni.flag.vietnam:before {\n  background-position: -108px -156px;\n}\ni.flag.vu:before,\ni.flag.vanuatu:before {\n  background-position: -108px -182px;\n}\ni.flag.gb.wls:before,\ni.flag.wales:before {\n  background-position: -108px -208px;\n}\ni.flag.wf:before,\ni.flag.wallis.and.futuna:before {\n  background-position: -108px -234px;\n}\ni.flag.ws:before,\ni.flag.samoa:before {\n  background-position: -108px -260px;\n}\ni.flag.ye:before,\ni.flag.yemen:before {\n  background-position: -108px -286px;\n}\ni.flag.yt:before,\ni.flag.mayotte:before {\n  background-position: -108px -312px;\n}\ni.flag.za:before,\ni.flag.south.africa:before {\n  background-position: -108px -338px;\n}\ni.flag.zm:before,\ni.flag.zambia:before {\n  background-position: -108px -364px;\n}\ni.flag.zw:before,\ni.flag.zimbabwe:before {\n  background-position: -108px -390px;\n}\n/*!\n * # Semantic UI - Header\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Header\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Sub Heading */\n/* Sub Header */\n/* Icon */\n/* Image */\n/* Label */\n/* Content */\n/* Paragraph after Header */\n/*-------------------\n      Variations\n--------------------*/\n/* Sizing */\n/* Sub Header */\n/* Icon Header */\n/* No Line Height Offset */\n/* Divided */\n/* Block */\n/* Attached */\n/* Inverted */\n/* Floated */\n/* Packaged Theme */\n/*******************************\n            Header\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Sub Heading */\n/* Sub Header */\n/* Icon */\n/* Image */\n/* Label */\n/* Content */\n/* Paragraph after Header */\n/*-------------------\n      Variations\n--------------------*/\n/* Sizing */\n/* Sub Header */\n/* Icon Header */\n/* No Line Height Offset */\n/* Divided */\n/* Block */\n/* Attached */\n/* Inverted */\n/* Floated */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Header\n*******************************/\n/* Standard */\n.ui.header {\n  border: none;\n  margin: calc(2rem -  0.14285714em ) 0em 1rem;\n  padding: 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  line-height: 1.28571429em;\n  text-transform: none;\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.header:first-child {\n  margin-top: -0.14285714em;\n}\n.ui.header:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n   Sub Header\n---------------*/\n.ui.header .sub.header {\n  display: block;\n  font-weight: normal;\n  padding: 0em;\n  margin: 0em;\n  font-size: 1rem;\n  line-height: 1.2em;\n  color: rgba(255, 255, 255, 0.6);\n}\n/*--------------\n      Icon\n---------------*/\n.ui.header > .icon {\n  display: table-cell;\n  opacity: 1;\n  font-size: 1.5em;\n  padding-top: 0em;\n  vertical-align: middle;\n}\n/* With Text Node */\n.ui.header .icon:only-child {\n  display: inline-block;\n  padding: 0em;\n  margin-right: 0.75rem;\n}\n/*-------------------\n        Image\n--------------------*/\n.ui.header > .image:not(.icon),\n.ui.header > img {\n  display: inline-block;\n  margin-top: 0.14285714em;\n  width: 2.5em;\n  height: auto;\n  vertical-align: middle;\n}\n.ui.header > .image:not(.icon):only-child,\n.ui.header > img:only-child {\n  margin-right: 0.75rem;\n}\n/*--------------\n     Content\n---------------*/\n.ui.header .content {\n  display: inline-block;\n  vertical-align: top;\n}\n/* After Image */\n.ui.header > img + .content,\n.ui.header > .image + .content {\n  padding-left: 0.75rem;\n  vertical-align: middle;\n}\n/* After Icon */\n.ui.header > .icon + .content {\n  padding-left: 0.75rem;\n  display: table-cell;\n  vertical-align: middle;\n}\n/*--------------\n Loose Coupling\n---------------*/\n.ui.header .ui.label {\n  font-size: '';\n  margin-left: 0.5rem;\n  vertical-align: middle;\n}\n/* Positioning */\n.ui.header + p {\n  margin-top: 0em;\n}\n/*******************************\n            Types\n*******************************/\n/*--------------\n     Page\n---------------*/\nh1.ui.header {\n  font-size: 2rem;\n}\nh2.ui.header {\n  font-size: 1.71428571rem;\n}\nh3.ui.header {\n  font-size: 1.28571429rem;\n}\nh4.ui.header {\n  font-size: 1.07142857rem;\n}\nh5.ui.header {\n  font-size: 1rem;\n}\n/* Sub Header */\nh1.ui.header .sub.header {\n  font-size: 1.14285714rem;\n}\nh2.ui.header .sub.header {\n  font-size: 1.14285714rem;\n}\nh3.ui.header .sub.header {\n  font-size: 1rem;\n}\nh4.ui.header .sub.header {\n  font-size: 1rem;\n}\nh5.ui.header .sub.header {\n  font-size: 0.92857143rem;\n}\n/*--------------\n Content Heading\n---------------*/\n.ui.huge.header {\n  min-height: 1em;\n  font-size: 2em;\n}\n.ui.large.header {\n  font-size: 1.71428571em;\n}\n.ui.medium.header {\n  font-size: 1.28571429em;\n}\n.ui.small.header {\n  font-size: 1.07142857em;\n}\n.ui.tiny.header {\n  font-size: 1em;\n}\n/* Sub Header */\n.ui.huge.header .sub.header {\n  font-size: 1.14285714rem;\n}\n.ui.large.header .sub.header {\n  font-size: 1.14285714rem;\n}\n.ui.header .sub.header {\n  font-size: 1rem;\n}\n.ui.small.header .sub.header {\n  font-size: 1rem;\n}\n.ui.tiny.header .sub.header {\n  font-size: 0.92857143rem;\n}\n/*--------------\n   Sub Heading\n---------------*/\n.ui.sub.header {\n  padding: 0em;\n  margin-bottom: 0.14285714rem;\n  font-weight: bold;\n  font-size: 0.85714286em;\n  text-transform: uppercase;\n  color: '';\n}\n.ui.small.sub.header {\n  font-size: 0.78571429em;\n}\n.ui.sub.header {\n  font-size: 0.85714286em;\n}\n.ui.large.sub.header {\n  font-size: 0.92857143em;\n}\n.ui.huge.sub.header {\n  font-size: 1em;\n}\n/*-------------------\n        Icon\n--------------------*/\n.ui.icon.header {\n  display: inline-block;\n  text-align: center;\n  margin: 2rem 0em 1rem;\n}\n.ui.icon.header:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n.ui.icon.header:first-child {\n  margin-top: 0em;\n}\n.ui.icon.header .icon {\n  float: none;\n  display: block;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 0em;\n  font-size: 3em;\n  margin: 0em auto 0.5rem;\n  opacity: 1;\n}\n.ui.icon.header .content {\n  display: block;\n  padding: 0em;\n}\n.ui.icon.header .circular.icon {\n  font-size: 2em;\n}\n.ui.icon.header .square.icon {\n  font-size: 2em;\n}\n.ui.block.icon.header .icon {\n  margin-bottom: 0em;\n}\n.ui.icon.header.aligned {\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n/*******************************\n            States\n*******************************/\n.ui.disabled.header {\n  opacity: 0.45;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n      Inverted\n--------------------*/\n.ui.inverted.header {\n  color: #FFFFFF;\n}\n.ui.inverted.header .sub.header {\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.inverted.attached.header {\n  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  box-shadow: none;\n  border-color: transparent;\n}\n.ui.inverted.block.header {\n  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  box-shadow: none;\n}\n.ui.inverted.block.header {\n  border-bottom: none;\n}\n/*-------------------\n       Colors\n--------------------*/\n/*--- Red ---*/\n.ui.red.header {\n  color: #DB2828 !important;\n}\na.ui.red.header:hover {\n  color: #d01919 !important;\n}\n.ui.red.dividing.header {\n  border-bottom: 2px solid #DB2828;\n}\n/* Inverted */\n.ui.inverted.red.header {\n  color: #FF695E !important;\n}\na.ui.inverted.red.header:hover {\n  color: #ff5144 !important;\n}\n/*--- Orange ---*/\n.ui.orange.header {\n  color: #F2711C !important;\n}\na.ui.orange.header:hover {\n  color: #f26202 !important;\n}\n.ui.orange.dividing.header {\n  border-bottom: 2px solid #F2711C;\n}\n/* Inverted */\n.ui.inverted.orange.header {\n  color: #FF851B !important;\n}\na.ui.inverted.orange.header:hover {\n  color: #ff7701 !important;\n}\n/*--- Olive ---*/\n.ui.olive.header {\n  color: #B5CC18 !important;\n}\na.ui.olive.header:hover {\n  color: #a7bd0d !important;\n}\n.ui.olive.dividing.header {\n  border-bottom: 2px solid #B5CC18;\n}\n/* Inverted */\n.ui.inverted.olive.header {\n  color: #D9E778 !important;\n}\na.ui.inverted.olive.header:hover {\n  color: #d8ea5c !important;\n}\n/*--- Yellow ---*/\n.ui.yellow.header {\n  color: #FBBD08 !important;\n}\na.ui.yellow.header:hover {\n  color: #eaae00 !important;\n}\n.ui.yellow.dividing.header {\n  border-bottom: 2px solid #FBBD08;\n}\n/* Inverted */\n.ui.inverted.yellow.header {\n  color: #FFE21F !important;\n}\na.ui.inverted.yellow.header:hover {\n  color: #ffdf05 !important;\n}\n/*--- Green ---*/\n.ui.green.header {\n  color: #21BA45 !important;\n}\na.ui.green.header:hover {\n  color: #16ab39 !important;\n}\n.ui.green.dividing.header {\n  border-bottom: 2px solid #21BA45;\n}\n/* Inverted */\n.ui.inverted.green.header {\n  color: #2ECC40 !important;\n}\na.ui.inverted.green.header:hover {\n  color: #22be34 !important;\n}\n/*--- Teal ---*/\n.ui.teal.header {\n  color: #00B5AD !important;\n}\na.ui.teal.header:hover {\n  color: #009c95 !important;\n}\n.ui.teal.dividing.header {\n  border-bottom: 2px solid #00B5AD;\n}\n/* Inverted */\n.ui.inverted.teal.header {\n  color: #6DFFFF !important;\n}\na.ui.inverted.teal.header:hover {\n  color: #54ffff !important;\n}\n/*--- Blue ---*/\n.ui.blue.header {\n  color: #2185D0 !important;\n}\na.ui.blue.header:hover {\n  color: #1678c2 !important;\n}\n.ui.blue.dividing.header {\n  border-bottom: 2px solid #2185D0;\n}\n/* Inverted */\n.ui.inverted.blue.header {\n  color: #54C8FF !important;\n}\na.ui.inverted.blue.header:hover {\n  color: #3ac0ff !important;\n}\n/*--- Violet ---*/\n.ui.violet.header {\n  color: #6435C9 !important;\n}\na.ui.violet.header:hover {\n  color: #5829bb !important;\n}\n.ui.violet.dividing.header {\n  border-bottom: 2px solid #6435C9;\n}\n/* Inverted */\n.ui.inverted.violet.header {\n  color: #A291FB !important;\n}\na.ui.inverted.violet.header:hover {\n  color: #8a73ff !important;\n}\n/*--- Purple ---*/\n.ui.purple.header {\n  color: #A333C8 !important;\n}\na.ui.purple.header:hover {\n  color: #9627ba !important;\n}\n.ui.purple.dividing.header {\n  border-bottom: 2px solid #A333C8;\n}\n/* Inverted */\n.ui.inverted.purple.header {\n  color: #DC73FF !important;\n}\na.ui.inverted.purple.header:hover {\n  color: #d65aff !important;\n}\n/*--- Pink ---*/\n.ui.pink.header {\n  color: #E03997 !important;\n}\na.ui.pink.header:hover {\n  color: #e61a8d !important;\n}\n.ui.pink.dividing.header {\n  border-bottom: 2px solid #E03997;\n}\n/* Inverted */\n.ui.inverted.pink.header {\n  color: #FF8EDF !important;\n}\na.ui.inverted.pink.header:hover {\n  color: #ff74d8 !important;\n}\n/*--- Brown ---*/\n.ui.brown.header {\n  color: #A5673F !important;\n}\na.ui.brown.header:hover {\n  color: #975b33 !important;\n}\n.ui.brown.dividing.header {\n  border-bottom: 2px solid #A5673F;\n}\n/* Inverted */\n.ui.inverted.brown.header {\n  color: #D67C1C !important;\n}\na.ui.inverted.brown.header:hover {\n  color: #c86f11 !important;\n}\n/*--- Grey ---*/\n.ui.grey.header {\n  color: #767676 !important;\n}\na.ui.grey.header:hover {\n  color: #838383 !important;\n}\n.ui.grey.dividing.header {\n  border-bottom: 2px solid #767676;\n}\n/* Inverted */\n.ui.inverted.grey.header {\n  color: #DCDDDE !important;\n}\na.ui.inverted.grey.header:hover {\n  color: #cfd0d2 !important;\n}\n/*-------------------\n       Aligned\n--------------------*/\n.ui.left.aligned.header {\n  text-align: left;\n}\n.ui.right.aligned.header {\n  text-align: right;\n}\n.ui.centered.header,\n.ui.center.aligned.header {\n  text-align: center;\n}\n.ui.justified.header {\n  text-align: justify;\n}\n.ui.justified.header:after {\n  display: inline-block;\n  content: '';\n  width: 100%;\n}\n/*-------------------\n       Floated\n--------------------*/\n.ui.floated.header,\n.ui[class*=\"left floated\"].header {\n  float: left;\n  margin-top: 0em;\n  margin-right: 0.5em;\n}\n.ui[class*=\"right floated\"].header {\n  float: right;\n  margin-top: 0em;\n  margin-left: 0.5em;\n}\n/*-------------------\n       Fitted\n--------------------*/\n.ui.fitted.header {\n  padding: 0em;\n}\n/*-------------------\n      Dividing\n--------------------*/\n.ui.dividing.header {\n  padding-bottom: 0.21428571rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.dividing.header .sub.header {\n  padding-bottom: 0.21428571rem;\n}\n.ui.dividing.header .icon {\n  margin-bottom: 0em;\n}\n.ui.inverted.dividing.header {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n/*-------------------\n        Block\n--------------------*/\n.ui.block.header {\n  background: #F3F4F5;\n  padding: 0.78571429rem 1rem;\n  box-shadow: none;\n  border: 1px solid #D4D4D5;\n  border-radius: 0.28571429rem;\n}\n.ui.tiny.block.header {\n  font-size: 0.85714286rem;\n}\n.ui.small.block.header {\n  font-size: 0.92857143rem;\n}\n.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1rem;\n}\n.ui.large.block.header {\n  font-size: 1.14285714rem;\n}\n.ui.huge.block.header {\n  font-size: 1.42857143rem;\n}\n/*-------------------\n       Attached\n--------------------*/\n.ui.attached.header {\n  background: #FFFFFF;\n  padding: 0.78571429rem 1rem;\n  margin-left: -1px;\n  margin-right: -1px;\n  box-shadow: none;\n  border: 1px solid #D4D4D5;\n}\n.ui.attached.block.header {\n  background: #F3F4F5;\n}\n.ui.attached:not(.top):not(.bottom).header {\n  margin-top: 0em;\n  margin-bottom: 0em;\n  border-top: none;\n  border-radius: 0em;\n}\n.ui.top.attached.header {\n  margin-bottom: 0em;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.bottom.attached.header {\n  margin-top: 0em;\n  border-top: none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n/* Attached Sizes */\n.ui.tiny.attached.header {\n  font-size: 0.85714286em;\n}\n.ui.small.attached.header {\n  font-size: 0.92857143em;\n}\n.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1em;\n}\n.ui.large.attached.header {\n  font-size: 1.14285714em;\n}\n.ui.huge.attached.header {\n  font-size: 1.42857143em;\n}\n/*-------------------\n        Sizing\n--------------------*/\n.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1.28571429em;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Icon\n*******************************/\n/*--------------\n   Font Files\n---------------*/\n/*--------------\n Optional Files\n---------------*/\n/* Outline Icons */\n/* Brand Icons */\n/*--------------\n   Definition\n---------------*/\n/* Icon Variables */\n/* Variations */\n/* Packaged Theme */\n/*******************************\n             Icon\n*******************************/\n/*--------------\n   Font Files\n---------------*/\n/*--------------\n Optional Files\n---------------*/\n/* Outline Icons */\n/* Brand Icons */\n/*--------------\n   Definition\n---------------*/\n/* Icon Variables */\n/* Variations */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Icon\n*******************************/\n@font-face {\n  font-family: 'Icons';\n  src: url(\"./themes/default/assets/fonts/icons.eot\");\n  src: url(\"./themes/default/assets/fonts/icons.eot?#iefix\") format('embedded-opentype'), url(\"./themes/default/assets/fonts/icons.woff2\") format('woff2'), url(\"./themes/default/assets/fonts/icons.woff\") format('woff'), url(\"./themes/default/assets/fonts/icons.ttf\") format('truetype'), url(\"./themes/default/assets/fonts/icons.svg#icons\") format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\ni.icon {\n  display: inline-block;\n  opacity: 1;\n  margin: 0em 0.25rem 0em 0em;\n  width: 1.18em;\n  height: 1em;\n  font-family: 'Icons';\n  font-style: normal;\n  font-weight: normal;\n  text-decoration: inherit;\n  text-align: center;\n  speak: none;\n  font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  backface-visibility: hidden;\n}\ni.icon:before {\n  background: none !important;\n}\n/*******************************\n             Types\n*******************************/\n/*--------------\n    Loading\n---------------*/\ni.icon.loading {\n  height: 1em;\n  line-height: 1;\n}\ni.icon.loading {\n  animation: icon-loading 2s linear infinite;\n}\n@keyframes icon-loading {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/*******************************\n             States\n*******************************/\ni.icon.hover {\n  opacity: 1 !important;\n}\ni.icon.active {\n  opacity: 1 !important;\n}\ni.emphasized.icon {\n  opacity: 1 !important;\n}\ni.disabled.icon {\n  opacity: 0.45 !important;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n        Fitted\n--------------------*/\ni.fitted.icon {\n  width: auto;\n  margin: 0em !important;\n}\n/*-------------------\n         Link\n--------------------*/\ni.link.icon,\ni.link.icons {\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\ni.link.icon:hover,\ni.link.icons:hover {\n  opacity: 1 !important;\n}\n/*-------------------\n      Circular\n--------------------*/\ni.circular.icon {\n  border-radius: 500em !important;\n  line-height: 1 !important;\n  padding: 0.5em 0em !important;\n  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;\n  width: 2em !important;\n  height: 2em !important;\n}\ni.circular.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n/*-------------------\n      Flipped\n--------------------*/\ni.flipped.icon,\ni.horizontally.flipped.icon {\n  transform: scale(-1, 1);\n}\ni.vertically.flipped.icon {\n  transform: scale(1, -1);\n}\n/*-------------------\n      Rotated\n--------------------*/\ni.rotated.icon,\ni.right.rotated.icon,\ni.clockwise.rotated.icon {\n  transform: rotate(90deg);\n}\ni.left.rotated.icon,\ni.counterclockwise.rotated.icon {\n  transform: rotate(-90deg);\n}\n/*-------------------\n      Bordered\n--------------------*/\ni.bordered.icon {\n  line-height: 1;\n  vertical-align: baseline;\n  width: 2em;\n  height: 2em;\n  padding: 0.5em 0em !important;\n  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;\n}\ni.bordered.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n/*-------------------\n      Inverted\n--------------------*/\n/* Inverted Shapes */\ni.inverted.bordered.icon,\ni.inverted.circular.icon {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\ni.inverted.icon {\n  color: #FFFFFF;\n}\n/*-------------------\n       Colors\n--------------------*/\n/* Red */\ni.red.icon {\n  color: #DB2828 !important;\n}\ni.inverted.red.icon {\n  color: #FF695E !important;\n}\ni.inverted.bordered.red.icon,\ni.inverted.circular.red.icon {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n/* Orange */\ni.orange.icon {\n  color: #F2711C !important;\n}\ni.inverted.orange.icon {\n  color: #FF851B !important;\n}\ni.inverted.bordered.orange.icon,\ni.inverted.circular.orange.icon {\n  background-color: #F2711C !important;\n  color: #FFFFFF !important;\n}\n/* Yellow */\ni.yellow.icon {\n  color: #FBBD08 !important;\n}\ni.inverted.yellow.icon {\n  color: #FFE21F !important;\n}\ni.inverted.bordered.yellow.icon,\ni.inverted.circular.yellow.icon {\n  background-color: #FBBD08 !important;\n  color: #FFFFFF !important;\n}\n/* Olive */\ni.olive.icon {\n  color: #B5CC18 !important;\n}\ni.inverted.olive.icon {\n  color: #D9E778 !important;\n}\ni.inverted.bordered.olive.icon,\ni.inverted.circular.olive.icon {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n/* Green */\ni.green.icon {\n  color: #21BA45 !important;\n}\ni.inverted.green.icon {\n  color: #2ECC40 !important;\n}\ni.inverted.bordered.green.icon,\ni.inverted.circular.green.icon {\n  background-color: #21BA45 !important;\n  color: #FFFFFF !important;\n}\n/* Teal */\ni.teal.icon {\n  color: #00B5AD !important;\n}\ni.inverted.teal.icon {\n  color: #6DFFFF !important;\n}\ni.inverted.bordered.teal.icon,\ni.inverted.circular.teal.icon {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n/* Blue */\ni.blue.icon {\n  color: #2185D0 !important;\n}\ni.inverted.blue.icon {\n  color: #54C8FF !important;\n}\ni.inverted.bordered.blue.icon,\ni.inverted.circular.blue.icon {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n/* Violet */\ni.violet.icon {\n  color: #6435C9 !important;\n}\ni.inverted.violet.icon {\n  color: #A291FB !important;\n}\ni.inverted.bordered.violet.icon,\ni.inverted.circular.violet.icon {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n/* Purple */\ni.purple.icon {\n  color: #A333C8 !important;\n}\ni.inverted.purple.icon {\n  color: #DC73FF !important;\n}\ni.inverted.bordered.purple.icon,\ni.inverted.circular.purple.icon {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n/* Pink */\ni.pink.icon {\n  color: #E03997 !important;\n}\ni.inverted.pink.icon {\n  color: #FF8EDF !important;\n}\ni.inverted.bordered.pink.icon,\ni.inverted.circular.pink.icon {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n/* Brown */\ni.brown.icon {\n  color: #A5673F !important;\n}\ni.inverted.brown.icon {\n  color: #D67C1C !important;\n}\ni.inverted.bordered.brown.icon,\ni.inverted.circular.brown.icon {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n/* Grey */\ni.grey.icon {\n  color: #767676 !important;\n}\ni.inverted.grey.icon {\n  color: #DCDDDE !important;\n}\ni.inverted.bordered.grey.icon,\ni.inverted.circular.grey.icon {\n  background-color: #767676 !important;\n  color: #FFFFFF !important;\n}\n/* Black */\ni.black.icon {\n  color: #1B1C1D !important;\n}\ni.inverted.black.icon {\n  color: #545454 !important;\n}\ni.inverted.bordered.black.icon,\ni.inverted.circular.black.icon {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n/*-------------------\n        Sizes\n--------------------*/\ni.mini.icon,\ni.mini.icons {\n  line-height: 1;\n  font-size: 0.4em;\n}\ni.tiny.icon,\ni.tiny.icons {\n  line-height: 1;\n  font-size: 0.5em;\n}\ni.small.icon,\ni.small.icons {\n  line-height: 1;\n  font-size: 0.75em;\n}\ni.icon,\ni.icons {\n  font-size: 1em;\n}\ni.large.icon,\ni.large.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 1.5em;\n}\ni.big.icon,\ni.big.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 2em;\n}\ni.huge.icon,\ni.huge.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 4em;\n}\ni.massive.icon,\ni.massive.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 8em;\n}\n/*******************************\n            Groups\n*******************************/\ni.icons {\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n}\ni.icons .icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  margin: 0em;\n  margin: 0;\n}\ni.icons .icon:first-child {\n  position: static;\n  width: auto;\n  height: auto;\n  vertical-align: top;\n  transform: none;\n  margin-right: 0.25rem;\n}\n/* Corner Icon */\ni.icons .corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  transform: none;\n  font-size: 0.45em;\n  text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF;\n}\ni.icons .top.right.corner.icon {\n  top: 0;\n  left: auto;\n  right: 0;\n  bottom: auto;\n}\ni.icons .top.left.corner.icon {\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: auto;\n}\ni.icons .bottom.left.corner.icon {\n  top: auto;\n  left: 0;\n  right: auto;\n  bottom: 0;\n}\ni.icons .bottom.right.corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n}\ni.icons .inverted.corner.icon {\n  text-shadow: -1px -1px 0 #1B1C1D, 1px -1px 0 #1B1C1D, -1px 1px 0 #1B1C1D, 1px 1px 0 #1B1C1D;\n}\n/*\n * Font Awesome 5.0.8 by @fontawesome - http://fontawesome.io - @fontawesome\n * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)\n */\n/*******************************\n\nSemantic-UI integration of font-awesome :\n\n///class names are separated\ni.icon.circle => i.icon.circle\ni.icon.circle-o => i.icon.circle.outline\n\n//abbreviation are replaced by full letters:\ni.icon.ellipsis-h => i.icon.ellipsis.horizontal\ni.icon.ellipsis-v => i.icon.ellipsis.vertical\n.alpha => .i.icon.alphabet\n.asc => .i.icon.ascending\n.desc => .i.icon.descending\n.alt =>.alternate\n\nASCII order is conserved for easier maintenance.\n\nIcons that only have one style 'outline', 'square' etc do not require this class\nfor instance `lemon icon` not `lemon outline icon` since there is only one lemon\n\n*******************************/\n/*******************************\n            Icons\n*******************************/\n/* Deprecated *In/Out Naming Conflict) */\ni.icon.linkedin.in:before {\n  content: \"\\f0e1\";\n}\ni.icon.zoom.in:before {\n  content: \"\\f00e\";\n}\ni.icon.zoom.out:before {\n  content: \"\\f010\";\n}\ni.icon.sign.in:before {\n  content: \"\\f2f6\";\n}\ni.icon.in.cart:before {\n  content: \"\\f218\";\n}\ni.icon.log.out:before {\n  content: \"\\f2f5\";\n}\ni.icon.sign.out:before {\n  content: \"\\f2f5\";\n}\n/* Icons */\ni.icon.\\35 00px:before {\n  content: \"\\f26e\";\n}\ni.icon.accessible.icon:before {\n  content: \"\\f368\";\n}\ni.icon.accusoft:before {\n  content: \"\\f369\";\n}\ni.icon.address.book:before {\n  content: \"\\f2b9\";\n}\ni.icon.address.card:before {\n  content: \"\\f2bb\";\n}\ni.icon.adjust:before {\n  content: \"\\f042\";\n}\ni.icon.adn:before {\n  content: \"\\f170\";\n}\ni.icon.adversal:before {\n  content: \"\\f36a\";\n}\ni.icon.affiliatetheme:before {\n  content: \"\\f36b\";\n}\ni.icon.algolia:before {\n  content: \"\\f36c\";\n}\ni.icon.align.center:before {\n  content: \"\\f037\";\n}\ni.icon.align.justify:before {\n  content: \"\\f039\";\n}\ni.icon.align.left:before {\n  content: \"\\f036\";\n}\ni.icon.align.right:before {\n  content: \"\\f038\";\n}\ni.icon.amazon:before {\n  content: \"\\f270\";\n}\ni.icon.amazon.pay:before {\n  content: \"\\f42c\";\n}\ni.icon.ambulance:before {\n  content: \"\\f0f9\";\n}\ni.icon.american.sign.language.interpreting:before {\n  content: \"\\f2a3\";\n}\ni.icon.amilia:before {\n  content: \"\\f36d\";\n}\ni.icon.anchor:before {\n  content: \"\\f13d\";\n}\ni.icon.android:before {\n  content: \"\\f17b\";\n}\ni.icon.angellist:before {\n  content: \"\\f209\";\n}\ni.icon.angle.double.down:before {\n  content: \"\\f103\";\n}\ni.icon.angle.double.left:before {\n  content: \"\\f100\";\n}\ni.icon.angle.double.right:before {\n  content: \"\\f101\";\n}\ni.icon.angle.double.up:before {\n  content: \"\\f102\";\n}\ni.icon.angle.down:before {\n  content: \"\\f107\";\n}\ni.icon.angle.left:before {\n  content: \"\\f104\";\n}\ni.icon.angle.right:before {\n  content: \"\\f105\";\n}\ni.icon.angle.up:before {\n  content: \"\\f106\";\n}\ni.icon.angrycreative:before {\n  content: \"\\f36e\";\n}\ni.icon.angular:before {\n  content: \"\\f420\";\n}\ni.icon.app.store:before {\n  content: \"\\f36f\";\n}\ni.icon.app.store.ios:before {\n  content: \"\\f370\";\n}\ni.icon.apper:before {\n  content: \"\\f371\";\n}\ni.icon.apple:before {\n  content: \"\\f179\";\n}\ni.icon.apple.pay:before {\n  content: \"\\f415\";\n}\ni.icon.archive:before {\n  content: \"\\f187\";\n}\ni.icon.arrow.alternate.circle.down:before {\n  content: \"\\f358\";\n}\ni.icon.arrow.alternate.circle.left:before {\n  content: \"\\f359\";\n}\ni.icon.arrow.alternate.circle.right:before {\n  content: \"\\f35a\";\n}\ni.icon.arrow.alternate.circle.up:before {\n  content: \"\\f35b\";\n}\ni.icon.arrow.circle.down:before {\n  content: \"\\f0ab\";\n}\ni.icon.arrow.circle.left:before {\n  content: \"\\f0a8\";\n}\ni.icon.arrow.circle.right:before {\n  content: \"\\f0a9\";\n}\ni.icon.arrow.circle.up:before {\n  content: \"\\f0aa\";\n}\ni.icon.arrow.down:before {\n  content: \"\\f063\";\n}\ni.icon.arrow.left:before {\n  content: \"\\f060\";\n}\ni.icon.arrow.right:before {\n  content: \"\\f061\";\n}\ni.icon.arrow.up:before {\n  content: \"\\f062\";\n}\ni.icon.arrows.alternate:before {\n  content: \"\\f0b2\";\n}\ni.icon.arrows.alternate.horizontal:before {\n  content: \"\\f337\";\n}\ni.icon.arrows.alternate.vertical:before {\n  content: \"\\f338\";\n}\ni.icon.assistive.listening.systems:before {\n  content: \"\\f2a2\";\n}\ni.icon.asterisk:before {\n  content: \"\\f069\";\n}\ni.icon.asymmetrik:before {\n  content: \"\\f372\";\n}\ni.icon.at:before {\n  content: \"\\f1fa\";\n}\ni.icon.audible:before {\n  content: \"\\f373\";\n}\ni.icon.audio.description:before {\n  content: \"\\f29e\";\n}\ni.icon.autoprefixer:before {\n  content: \"\\f41c\";\n}\ni.icon.avianex:before {\n  content: \"\\f374\";\n}\ni.icon.aviato:before {\n  content: \"\\f421\";\n}\ni.icon.aws:before {\n  content: \"\\f375\";\n}\ni.icon.backward:before {\n  content: \"\\f04a\";\n}\ni.icon.balance.scale:before {\n  content: \"\\f24e\";\n}\ni.icon.ban:before {\n  content: \"\\f05e\";\n}\ni.icon.band.aid:before {\n  content: \"\\f462\";\n}\ni.icon.bandcamp:before {\n  content: \"\\f2d5\";\n}\ni.icon.barcode:before {\n  content: \"\\f02a\";\n}\ni.icon.bars:before {\n  content: \"\\f0c9\";\n}\ni.icon.baseball.ball:before {\n  content: \"\\f433\";\n}\ni.icon.basketball.ball:before {\n  content: \"\\f434\";\n}\ni.icon.bath:before {\n  content: \"\\f2cd\";\n}\ni.icon.battery.empty:before {\n  content: \"\\f244\";\n}\ni.icon.battery.full:before {\n  content: \"\\f240\";\n}\ni.icon.battery.half:before {\n  content: \"\\f242\";\n}\ni.icon.battery.quarter:before {\n  content: \"\\f243\";\n}\ni.icon.battery.three.quarters:before {\n  content: \"\\f241\";\n}\ni.icon.bed:before {\n  content: \"\\f236\";\n}\ni.icon.beer:before {\n  content: \"\\f0fc\";\n}\ni.icon.behance:before {\n  content: \"\\f1b4\";\n}\ni.icon.behance.square:before {\n  content: \"\\f1b5\";\n}\ni.icon.bell:before {\n  content: \"\\f0f3\";\n}\ni.icon.bell.slash:before {\n  content: \"\\f1f6\";\n}\ni.icon.bicycle:before {\n  content: \"\\f206\";\n}\ni.icon.bimobject:before {\n  content: \"\\f378\";\n}\ni.icon.binoculars:before {\n  content: \"\\f1e5\";\n}\ni.icon.birthday.cake:before {\n  content: \"\\f1fd\";\n}\ni.icon.bitbucket:before {\n  content: \"\\f171\";\n}\ni.icon.bitcoin:before {\n  content: \"\\f379\";\n}\ni.icon.bity:before {\n  content: \"\\f37a\";\n}\ni.icon.black.tie:before {\n  content: \"\\f27e\";\n}\ni.icon.blackberry:before {\n  content: \"\\f37b\";\n}\ni.icon.blind:before {\n  content: \"\\f29d\";\n}\ni.icon.blogger:before {\n  content: \"\\f37c\";\n}\ni.icon.blogger.b:before {\n  content: \"\\f37d\";\n}\ni.icon.bluetooth:before {\n  content: \"\\f293\";\n}\ni.icon.bluetooth.b:before {\n  content: \"\\f294\";\n}\ni.icon.bold:before {\n  content: \"\\f032\";\n}\ni.icon.bolt:before {\n  content: \"\\f0e7\";\n}\ni.icon.bomb:before {\n  content: \"\\f1e2\";\n}\ni.icon.book:before {\n  content: \"\\f02d\";\n}\ni.icon.bookmark:before {\n  content: \"\\f02e\";\n}\ni.icon.bowling.ball:before {\n  content: \"\\f436\";\n}\ni.icon.box:before {\n  content: \"\\f466\";\n}\ni.icon.boxes:before {\n  content: \"\\f468\";\n}\ni.icon.braille:before {\n  content: \"\\f2a1\";\n}\ni.icon.briefcase:before {\n  content: \"\\f0b1\";\n}\ni.icon.btc:before {\n  content: \"\\f15a\";\n}\ni.icon.bug:before {\n  content: \"\\f188\";\n}\ni.icon.building:before {\n  content: \"\\f1ad\";\n}\ni.icon.bullhorn:before {\n  content: \"\\f0a1\";\n}\ni.icon.bullseye:before {\n  content: \"\\f140\";\n}\ni.icon.buromobelexperte:before {\n  content: \"\\f37f\";\n}\ni.icon.bus:before {\n  content: \"\\f207\";\n}\ni.icon.buysellads:before {\n  content: \"\\f20d\";\n}\ni.icon.calculator:before {\n  content: \"\\f1ec\";\n}\ni.icon.calendar:before {\n  content: \"\\f133\";\n}\ni.icon.calendar.alternate:before {\n  content: \"\\f073\";\n}\ni.icon.calendar.check:before {\n  content: \"\\f274\";\n}\ni.icon.calendar.minus:before {\n  content: \"\\f272\";\n}\ni.icon.calendar.plus:before {\n  content: \"\\f271\";\n}\ni.icon.calendar.times:before {\n  content: \"\\f273\";\n}\ni.icon.camera:before {\n  content: \"\\f030\";\n}\ni.icon.camera.retro:before {\n  content: \"\\f083\";\n}\ni.icon.car:before {\n  content: \"\\f1b9\";\n}\ni.icon.caret.down:before {\n  content: \"\\f0d7\";\n}\ni.icon.caret.left:before {\n  content: \"\\f0d9\";\n}\ni.icon.caret.right:before {\n  content: \"\\f0da\";\n}\ni.icon.caret.square.down:before {\n  content: \"\\f150\";\n}\ni.icon.caret.square.left:before {\n  content: \"\\f191\";\n}\ni.icon.caret.square.right:before {\n  content: \"\\f152\";\n}\ni.icon.caret.square.up:before {\n  content: \"\\f151\";\n}\ni.icon.caret.up:before {\n  content: \"\\f0d8\";\n}\ni.icon.cart.arrow.down:before {\n  content: \"\\f218\";\n}\ni.icon.cart.plus:before {\n  content: \"\\f217\";\n}\ni.icon.cc.amazon.pay:before {\n  content: \"\\f42d\";\n}\ni.icon.cc.amex:before {\n  content: \"\\f1f3\";\n}\ni.icon.cc.apple.pay:before {\n  content: \"\\f416\";\n}\ni.icon.cc.diners.club:before {\n  content: \"\\f24c\";\n}\ni.icon.cc.discover:before {\n  content: \"\\f1f2\";\n}\ni.icon.cc.jcb:before {\n  content: \"\\f24b\";\n}\ni.icon.cc.mastercard:before {\n  content: \"\\f1f1\";\n}\ni.icon.cc.paypal:before {\n  content: \"\\f1f4\";\n}\ni.icon.cc.stripe:before {\n  content: \"\\f1f5\";\n}\ni.icon.cc.visa:before {\n  content: \"\\f1f0\";\n}\ni.icon.centercode:before {\n  content: \"\\f380\";\n}\ni.icon.certificate:before {\n  content: \"\\f0a3\";\n}\ni.icon.chart.area:before {\n  content: \"\\f1fe\";\n}\ni.icon.chart.bar:before {\n  content: \"\\f080\";\n}\ni.icon.chart.line:before {\n  content: \"\\f201\";\n}\ni.icon.chart.pie:before {\n  content: \"\\f200\";\n}\ni.icon.check:before {\n  content: \"\\f00c\";\n}\ni.icon.check.circle:before {\n  content: \"\\f058\";\n}\ni.icon.check.square:before {\n  content: \"\\f14a\";\n}\ni.icon.chess:before {\n  content: \"\\f439\";\n}\ni.icon.chess.bishop:before {\n  content: \"\\f43a\";\n}\ni.icon.chess.board:before {\n  content: \"\\f43c\";\n}\ni.icon.chess.king:before {\n  content: \"\\f43f\";\n}\ni.icon.chess.knight:before {\n  content: \"\\f441\";\n}\ni.icon.chess.pawn:before {\n  content: \"\\f443\";\n}\ni.icon.chess.queen:before {\n  content: \"\\f445\";\n}\ni.icon.chess.rook:before {\n  content: \"\\f447\";\n}\ni.icon.chevron.circle.down:before {\n  content: \"\\f13a\";\n}\ni.icon.chevron.circle.left:before {\n  content: \"\\f137\";\n}\ni.icon.chevron.circle.right:before {\n  content: \"\\f138\";\n}\ni.icon.chevron.circle.up:before {\n  content: \"\\f139\";\n}\ni.icon.chevron.down:before {\n  content: \"\\f078\";\n}\ni.icon.chevron.left:before {\n  content: \"\\f053\";\n}\ni.icon.chevron.right:before {\n  content: \"\\f054\";\n}\ni.icon.chevron.up:before {\n  content: \"\\f077\";\n}\ni.icon.child:before {\n  content: \"\\f1ae\";\n}\ni.icon.chrome:before {\n  content: \"\\f268\";\n}\ni.icon.circle:before {\n  content: \"\\f111\";\n}\ni.icon.circle.notch:before {\n  content: \"\\f1ce\";\n}\ni.icon.clipboard:before {\n  content: \"\\f328\";\n}\ni.icon.clipboard.check:before {\n  content: \"\\f46c\";\n}\ni.icon.clipboard.list:before {\n  content: \"\\f46d\";\n}\ni.icon.clock:before {\n  content: \"\\f017\";\n}\ni.icon.clone:before {\n  content: \"\\f24d\";\n}\ni.icon.closed.captioning:before {\n  content: \"\\f20a\";\n}\ni.icon.cloud:before {\n  content: \"\\f0c2\";\n}\ni.icon.cloudscale:before {\n  content: \"\\f383\";\n}\ni.icon.cloudsmith:before {\n  content: \"\\f384\";\n}\ni.icon.cloudversify:before {\n  content: \"\\f385\";\n}\ni.icon.code:before {\n  content: \"\\f121\";\n}\ni.icon.code.branch:before {\n  content: \"\\f126\";\n}\ni.icon.codepen:before {\n  content: \"\\f1cb\";\n}\ni.icon.codiepie:before {\n  content: \"\\f284\";\n}\ni.icon.coffee:before {\n  content: \"\\f0f4\";\n}\ni.icon.cog:before {\n  content: \"\\f013\";\n}\ni.icon.cogs:before {\n  content: \"\\f085\";\n}\ni.icon.columns:before {\n  content: \"\\f0db\";\n}\ni.icon.comment:before {\n  content: \"\\f075\";\n}\ni.icon.comment.alternate:before {\n  content: \"\\f27a\";\n}\ni.icon.comments:before {\n  content: \"\\f086\";\n}\ni.icon.compass:before {\n  content: \"\\f14e\";\n}\ni.icon.compress:before {\n  content: \"\\f066\";\n}\ni.icon.connectdevelop:before {\n  content: \"\\f20e\";\n}\ni.icon.contao:before {\n  content: \"\\f26d\";\n}\ni.icon.copy:before {\n  content: \"\\f0c5\";\n}\ni.icon.copyright:before {\n  content: \"\\f1f9\";\n}\ni.icon.cpanel:before {\n  content: \"\\f388\";\n}\ni.icon.creative.commons:before {\n  content: \"\\f25e\";\n}\ni.icon.credit.card:before {\n  content: \"\\f09d\";\n}\ni.icon.crop:before {\n  content: \"\\f125\";\n}\ni.icon.crosshairs:before {\n  content: \"\\f05b\";\n}\ni.icon.css3:before {\n  content: \"\\f13c\";\n}\ni.icon.css3.alternate:before {\n  content: \"\\f38b\";\n}\ni.icon.cube:before {\n  content: \"\\f1b2\";\n}\ni.icon.cubes:before {\n  content: \"\\f1b3\";\n}\ni.icon.cut:before {\n  content: \"\\f0c4\";\n}\ni.icon.cuttlefish:before {\n  content: \"\\f38c\";\n}\ni.icon.d.and.d:before {\n  content: \"\\f38d\";\n}\ni.icon.dashcube:before {\n  content: \"\\f210\";\n}\ni.icon.database:before {\n  content: \"\\f1c0\";\n}\ni.icon.deaf:before {\n  content: \"\\f2a4\";\n}\ni.icon.delicious:before {\n  content: \"\\f1a5\";\n}\ni.icon.deploydog:before {\n  content: \"\\f38e\";\n}\ni.icon.deskpro:before {\n  content: \"\\f38f\";\n}\ni.icon.desktop:before {\n  content: \"\\f108\";\n}\ni.icon.deviantart:before {\n  content: \"\\f1bd\";\n}\ni.icon.digg:before {\n  content: \"\\f1a6\";\n}\ni.icon.digital.ocean:before {\n  content: \"\\f391\";\n}\ni.icon.discord:before {\n  content: \"\\f392\";\n}\ni.icon.discourse:before {\n  content: \"\\f393\";\n}\ni.icon.dna:before {\n  content: \"\\f471\";\n}\ni.icon.dochub:before {\n  content: \"\\f394\";\n}\ni.icon.docker:before {\n  content: \"\\f395\";\n}\ni.icon.dollar.sign:before {\n  content: \"\\f155\";\n}\ni.icon.dolly:before {\n  content: \"\\f472\";\n}\ni.icon.dolly.flatbed:before {\n  content: \"\\f474\";\n}\ni.icon.dot.circle:before {\n  content: \"\\f192\";\n}\ni.icon.download:before {\n  content: \"\\f019\";\n}\ni.icon.draft2digital:before {\n  content: \"\\f396\";\n}\ni.icon.dribbble:before {\n  content: \"\\f17d\";\n}\ni.icon.dribbble.square:before {\n  content: \"\\f397\";\n}\ni.icon.dropbox:before {\n  content: \"\\f16b\";\n}\ni.icon.drupal:before {\n  content: \"\\f1a9\";\n}\ni.icon.dyalog:before {\n  content: \"\\f399\";\n}\ni.icon.earlybirds:before {\n  content: \"\\f39a\";\n}\ni.icon.edge:before {\n  content: \"\\f282\";\n}\ni.icon.edit:before {\n  content: \"\\f044\";\n}\ni.icon.eject:before {\n  content: \"\\f052\";\n}\ni.icon.elementor:before {\n  content: \"\\f430\";\n}\ni.icon.ellipsis.horizontal:before {\n  content: \"\\f141\";\n}\ni.icon.ellipsis.vertical:before {\n  content: \"\\f142\";\n}\ni.icon.ember:before {\n  content: \"\\f423\";\n}\ni.icon.empire:before {\n  content: \"\\f1d1\";\n}\ni.icon.envelope:before {\n  content: \"\\f0e0\";\n}\ni.icon.envelope.open:before {\n  content: \"\\f2b6\";\n}\ni.icon.envelope.square:before {\n  content: \"\\f199\";\n}\ni.icon.envira:before {\n  content: \"\\f299\";\n}\ni.icon.eraser:before {\n  content: \"\\f12d\";\n}\ni.icon.erlang:before {\n  content: \"\\f39d\";\n}\ni.icon.ethereum:before {\n  content: \"\\f42e\";\n}\ni.icon.etsy:before {\n  content: \"\\f2d7\";\n}\ni.icon.euro.sign:before {\n  content: \"\\f153\";\n}\ni.icon.exchange.alternate:before {\n  content: \"\\f362\";\n}\ni.icon.exclamation:before {\n  content: \"\\f12a\";\n}\ni.icon.exclamation.circle:before {\n  content: \"\\f06a\";\n}\ni.icon.exclamation.triangle:before {\n  content: \"\\f071\";\n}\ni.icon.expand:before {\n  content: \"\\f065\";\n}\ni.icon.expand.arrows.alternate:before {\n  content: \"\\f31e\";\n}\ni.icon.expeditedssl:before {\n  content: \"\\f23e\";\n}\ni.icon.external.alternate:before {\n  content: \"\\f35d\";\n}\ni.icon.external.square.alternate:before {\n  content: \"\\f360\";\n}\ni.icon.eye:before {\n  content: \"\\f06e\";\n}\ni.icon.eye.dropper:before {\n  content: \"\\f1fb\";\n}\ni.icon.eye.slash:before {\n  content: \"\\f070\";\n}\ni.icon.facebook:before {\n  content: \"\\f09a\";\n}\ni.icon.facebook.f:before {\n  content: \"\\f39e\";\n}\ni.icon.facebook.messenger:before {\n  content: \"\\f39f\";\n}\ni.icon.facebook.square:before {\n  content: \"\\f082\";\n}\ni.icon.fast.backward:before {\n  content: \"\\f049\";\n}\ni.icon.fast.forward:before {\n  content: \"\\f050\";\n}\ni.icon.fax:before {\n  content: \"\\f1ac\";\n}\ni.icon.female:before {\n  content: \"\\f182\";\n}\ni.icon.fighter.jet:before {\n  content: \"\\f0fb\";\n}\ni.icon.file:before {\n  content: \"\\f15b\";\n}\ni.icon.file.alternate:before {\n  content: \"\\f15c\";\n}\ni.icon.file.archive:before {\n  content: \"\\f1c6\";\n}\ni.icon.file.audio:before {\n  content: \"\\f1c7\";\n}\ni.icon.file.code:before {\n  content: \"\\f1c9\";\n}\ni.icon.file.excel:before {\n  content: \"\\f1c3\";\n}\ni.icon.file.image:before {\n  content: \"\\f1c5\";\n}\ni.icon.file.pdf:before {\n  content: \"\\f1c1\";\n}\ni.icon.file.powerpoint:before {\n  content: \"\\f1c4\";\n}\ni.icon.file.video:before {\n  content: \"\\f1c8\";\n}\ni.icon.file.word:before {\n  content: \"\\f1c2\";\n}\ni.icon.film:before {\n  content: \"\\f008\";\n}\ni.icon.filter:before {\n  content: \"\\f0b0\";\n}\ni.icon.fire:before {\n  content: \"\\f06d\";\n}\ni.icon.fire.extinguisher:before {\n  content: \"\\f134\";\n}\ni.icon.firefox:before {\n  content: \"\\f269\";\n}\ni.icon.first.aid:before {\n  content: \"\\f479\";\n}\ni.icon.first.order:before {\n  content: \"\\f2b0\";\n}\ni.icon.firstdraft:before {\n  content: \"\\f3a1\";\n}\ni.icon.flag:before {\n  content: \"\\f024\";\n}\ni.icon.flag.checkered:before {\n  content: \"\\f11e\";\n}\ni.icon.flask:before {\n  content: \"\\f0c3\";\n}\ni.icon.flickr:before {\n  content: \"\\f16e\";\n}\ni.icon.flipboard:before {\n  content: \"\\f44d\";\n}\ni.icon.fly:before {\n  content: \"\\f417\";\n}\ni.icon.folder:before {\n  content: \"\\f07b\";\n}\ni.icon.folder.open:before {\n  content: \"\\f07c\";\n}\ni.icon.font:before {\n  content: \"\\f031\";\n}\ni.icon.font.awesome:before {\n  content: \"\\f2b4\";\n}\ni.icon.font.awesome.alternate:before {\n  content: \"\\f35c\";\n}\ni.icon.font.awesome.flag:before {\n  content: \"\\f425\";\n}\ni.icon.fonticons:before {\n  content: \"\\f280\";\n}\ni.icon.fonticons.fi:before {\n  content: \"\\f3a2\";\n}\ni.icon.football.ball:before {\n  content: \"\\f44e\";\n}\ni.icon.fort.awesome:before {\n  content: \"\\f286\";\n}\ni.icon.fort.awesome.alternate:before {\n  content: \"\\f3a3\";\n}\ni.icon.forumbee:before {\n  content: \"\\f211\";\n}\ni.icon.forward:before {\n  content: \"\\f04e\";\n}\ni.icon.foursquare:before {\n  content: \"\\f180\";\n}\ni.icon.free.code.camp:before {\n  content: \"\\f2c5\";\n}\ni.icon.freebsd:before {\n  content: \"\\f3a4\";\n}\ni.icon.frown:before {\n  content: \"\\f119\";\n}\ni.icon.futbol:before {\n  content: \"\\f1e3\";\n}\ni.icon.gamepad:before {\n  content: \"\\f11b\";\n}\ni.icon.gavel:before {\n  content: \"\\f0e3\";\n}\ni.icon.gem:before {\n  content: \"\\f3a5\";\n}\ni.icon.genderless:before {\n  content: \"\\f22d\";\n}\ni.icon.get.pocket:before {\n  content: \"\\f265\";\n}\ni.icon.gg:before {\n  content: \"\\f260\";\n}\ni.icon.gg.circle:before {\n  content: \"\\f261\";\n}\ni.icon.gift:before {\n  content: \"\\f06b\";\n}\ni.icon.git:before {\n  content: \"\\f1d3\";\n}\ni.icon.git.square:before {\n  content: \"\\f1d2\";\n}\ni.icon.github:before {\n  content: \"\\f09b\";\n}\ni.icon.github.alternate:before {\n  content: \"\\f113\";\n}\ni.icon.github.square:before {\n  content: \"\\f092\";\n}\ni.icon.gitkraken:before {\n  content: \"\\f3a6\";\n}\ni.icon.gitlab:before {\n  content: \"\\f296\";\n}\ni.icon.gitter:before {\n  content: \"\\f426\";\n}\ni.icon.glass.martini:before {\n  content: \"\\f000\";\n}\ni.icon.glide:before {\n  content: \"\\f2a5\";\n}\ni.icon.glide.g:before {\n  content: \"\\f2a6\";\n}\ni.icon.globe:before {\n  content: \"\\f0ac\";\n}\ni.icon.gofore:before {\n  content: \"\\f3a7\";\n}\ni.icon.golf.ball:before {\n  content: \"\\f450\";\n}\ni.icon.goodreads:before {\n  content: \"\\f3a8\";\n}\ni.icon.goodreads.g:before {\n  content: \"\\f3a9\";\n}\ni.icon.google:before {\n  content: \"\\f1a0\";\n}\ni.icon.google.drive:before {\n  content: \"\\f3aa\";\n}\ni.icon.google.play:before {\n  content: \"\\f3ab\";\n}\ni.icon.google.plus:before {\n  content: \"\\f2b3\";\n}\ni.icon.google.plus.g:before {\n  content: \"\\f0d5\";\n}\ni.icon.google.plus.square:before {\n  content: \"\\f0d4\";\n}\ni.icon.google.wallet:before {\n  content: \"\\f1ee\";\n}\ni.icon.graduation.cap:before {\n  content: \"\\f19d\";\n}\ni.icon.gratipay:before {\n  content: \"\\f184\";\n}\ni.icon.grav:before {\n  content: \"\\f2d6\";\n}\ni.icon.gripfire:before {\n  content: \"\\f3ac\";\n}\ni.icon.grunt:before {\n  content: \"\\f3ad\";\n}\ni.icon.gulp:before {\n  content: \"\\f3ae\";\n}\ni.icon.h.square:before {\n  content: \"\\f0fd\";\n}\ni.icon.hacker.news:before {\n  content: \"\\f1d4\";\n}\ni.icon.hacker.news.square:before {\n  content: \"\\f3af\";\n}\ni.icon.hand.lizard:before {\n  content: \"\\f258\";\n}\ni.icon.hand.paper:before {\n  content: \"\\f256\";\n}\ni.icon.hand.peace:before {\n  content: \"\\f25b\";\n}\ni.icon.hand.point.down:before {\n  content: \"\\f0a7\";\n}\ni.icon.hand.point.left:before {\n  content: \"\\f0a5\";\n}\ni.icon.hand.point.right:before {\n  content: \"\\f0a4\";\n}\ni.icon.hand.point.up:before {\n  content: \"\\f0a6\";\n}\ni.icon.hand.pointer:before {\n  content: \"\\f25a\";\n}\ni.icon.hand.rock:before {\n  content: \"\\f255\";\n}\ni.icon.hand.scissors:before {\n  content: \"\\f257\";\n}\ni.icon.hand.spock:before {\n  content: \"\\f259\";\n}\ni.icon.handshake:before {\n  content: \"\\f2b5\";\n}\ni.icon.hashtag:before {\n  content: \"\\f292\";\n}\ni.icon.hdd:before {\n  content: \"\\f0a0\";\n}\ni.icon.heading:before {\n  content: \"\\f1dc\";\n}\ni.icon.headphones:before {\n  content: \"\\f025\";\n}\ni.icon.heart:before {\n  content: \"\\f004\";\n}\ni.icon.heartbeat:before {\n  content: \"\\f21e\";\n}\ni.icon.hips:before {\n  content: \"\\f452\";\n}\ni.icon.hire.a.helper:before {\n  content: \"\\f3b0\";\n}\ni.icon.history:before {\n  content: \"\\f1da\";\n}\ni.icon.hockey.puck:before {\n  content: \"\\f453\";\n}\ni.icon.home:before {\n  content: \"\\f015\";\n}\ni.icon.hooli:before {\n  content: \"\\f427\";\n}\ni.icon.hospital:before {\n  content: \"\\f0f8\";\n}\ni.icon.hospital.symbol:before {\n  content: \"\\f47e\";\n}\ni.icon.hotjar:before {\n  content: \"\\f3b1\";\n}\ni.icon.hourglass:before {\n  content: \"\\f254\";\n}\ni.icon.hourglass.end:before {\n  content: \"\\f253\";\n}\ni.icon.hourglass.half:before {\n  content: \"\\f252\";\n}\ni.icon.hourglass.start:before {\n  content: \"\\f251\";\n}\ni.icon.houzz:before {\n  content: \"\\f27c\";\n}\ni.icon.html5:before {\n  content: \"\\f13b\";\n}\ni.icon.hubspot:before {\n  content: \"\\f3b2\";\n}\ni.icon.i.cursor:before {\n  content: \"\\f246\";\n}\ni.icon.id.badge:before {\n  content: \"\\f2c1\";\n}\ni.icon.id.card:before {\n  content: \"\\f2c2\";\n}\ni.icon.image:before {\n  content: \"\\f03e\";\n}\ni.icon.images:before {\n  content: \"\\f302\";\n}\ni.icon.imdb:before {\n  content: \"\\f2d8\";\n}\ni.icon.inbox:before {\n  content: \"\\f01c\";\n}\ni.icon.indent:before {\n  content: \"\\f03c\";\n}\ni.icon.industry:before {\n  content: \"\\f275\";\n}\ni.icon.info:before {\n  content: \"\\f129\";\n}\ni.icon.info.circle:before {\n  content: \"\\f05a\";\n}\ni.icon.instagram:before {\n  content: \"\\f16d\";\n}\ni.icon.internet.explorer:before {\n  content: \"\\f26b\";\n}\ni.icon.ioxhost:before {\n  content: \"\\f208\";\n}\ni.icon.italic:before {\n  content: \"\\f033\";\n}\ni.icon.itunes:before {\n  content: \"\\f3b4\";\n}\ni.icon.itunes.note:before {\n  content: \"\\f3b5\";\n}\ni.icon.jenkins:before {\n  content: \"\\f3b6\";\n}\ni.icon.joget:before {\n  content: \"\\f3b7\";\n}\ni.icon.joomla:before {\n  content: \"\\f1aa\";\n}\ni.icon.js:before {\n  content: \"\\f3b8\";\n}\ni.icon.js.square:before {\n  content: \"\\f3b9\";\n}\ni.icon.jsfiddle:before {\n  content: \"\\f1cc\";\n}\ni.icon.key:before {\n  content: \"\\f084\";\n}\ni.icon.keyboard:before {\n  content: \"\\f11c\";\n}\ni.icon.keycdn:before {\n  content: \"\\f3ba\";\n}\ni.icon.kickstarter:before {\n  content: \"\\f3bb\";\n}\ni.icon.kickstarter.k:before {\n  content: \"\\f3bc\";\n}\ni.icon.korvue:before {\n  content: \"\\f42f\";\n}\ni.icon.language:before {\n  content: \"\\f1ab\";\n}\ni.icon.laptop:before {\n  content: \"\\f109\";\n}\ni.icon.laravel:before {\n  content: \"\\f3bd\";\n}\ni.icon.lastfm:before {\n  content: \"\\f202\";\n}\ni.icon.lastfm.square:before {\n  content: \"\\f203\";\n}\ni.icon.leaf:before {\n  content: \"\\f06c\";\n}\ni.icon.leanpub:before {\n  content: \"\\f212\";\n}\ni.icon.lemon:before {\n  content: \"\\f094\";\n}\ni.icon.less:before {\n  content: \"\\f41d\";\n}\ni.icon.level.down.alternate:before {\n  content: \"\\f3be\";\n}\ni.icon.level.up.alternate:before {\n  content: \"\\f3bf\";\n}\ni.icon.life.ring:before {\n  content: \"\\f1cd\";\n}\ni.icon.lightbulb:before {\n  content: \"\\f0eb\";\n}\ni.icon.linechat:before {\n  content: \"\\f3c0\";\n}\ni.icon.linkify:before {\n  content: \"\\f0c1\";\n}\ni.icon.linkedin:before {\n  content: \"\\f08c\";\n}\ni.icon.linkedin.alt:before {\n  content: \"\\f0e1\";\n}\ni.icon.linode:before {\n  content: \"\\f2b8\";\n}\ni.icon.linux:before {\n  content: \"\\f17c\";\n}\ni.icon.lira.sign:before {\n  content: \"\\f195\";\n}\ni.icon.list:before {\n  content: \"\\f03a\";\n}\ni.icon.list.alternate:before {\n  content: \"\\f022\";\n}\ni.icon.list.ol:before {\n  content: \"\\f0cb\";\n}\ni.icon.list.ul:before {\n  content: \"\\f0ca\";\n}\ni.icon.location.arrow:before {\n  content: \"\\f124\";\n}\ni.icon.lock:before {\n  content: \"\\f023\";\n}\ni.icon.lock.open:before {\n  content: \"\\f3c1\";\n}\ni.icon.long.arrow.alternate.down:before {\n  content: \"\\f309\";\n}\ni.icon.long.arrow.alternate.left:before {\n  content: \"\\f30a\";\n}\ni.icon.long.arrow.alternate.right:before {\n  content: \"\\f30b\";\n}\ni.icon.long.arrow.alternate.up:before {\n  content: \"\\f30c\";\n}\ni.icon.low.vision:before {\n  content: \"\\f2a8\";\n}\ni.icon.lyft:before {\n  content: \"\\f3c3\";\n}\ni.icon.magento:before {\n  content: \"\\f3c4\";\n}\ni.icon.magic:before {\n  content: \"\\f0d0\";\n}\ni.icon.magnet:before {\n  content: \"\\f076\";\n}\ni.icon.male:before {\n  content: \"\\f183\";\n}\ni.icon.map:before {\n  content: \"\\f279\";\n}\ni.icon.map.marker:before {\n  content: \"\\f041\";\n}\ni.icon.map.marker.alternate:before {\n  content: \"\\f3c5\";\n}\ni.icon.map.pin:before {\n  content: \"\\f276\";\n}\ni.icon.map.signs:before {\n  content: \"\\f277\";\n}\ni.icon.mars:before {\n  content: \"\\f222\";\n}\ni.icon.mars.double:before {\n  content: \"\\f227\";\n}\ni.icon.mars.stroke:before {\n  content: \"\\f229\";\n}\ni.icon.mars.stroke.horizontal:before {\n  content: \"\\f22b\";\n}\ni.icon.mars.stroke.vertical:before {\n  content: \"\\f22a\";\n}\ni.icon.maxcdn:before {\n  content: \"\\f136\";\n}\ni.icon.medapps:before {\n  content: \"\\f3c6\";\n}\ni.icon.medium:before {\n  content: \"\\f23a\";\n}\ni.icon.medium.m:before {\n  content: \"\\f3c7\";\n}\ni.icon.medkit:before {\n  content: \"\\f0fa\";\n}\ni.icon.medrt:before {\n  content: \"\\f3c8\";\n}\ni.icon.meetup:before {\n  content: \"\\f2e0\";\n}\ni.icon.meh:before {\n  content: \"\\f11a\";\n}\ni.icon.mercury:before {\n  content: \"\\f223\";\n}\ni.icon.microchip:before {\n  content: \"\\f2db\";\n}\ni.icon.microphone:before {\n  content: \"\\f130\";\n}\ni.icon.microphone.slash:before {\n  content: \"\\f131\";\n}\ni.icon.microsoft:before {\n  content: \"\\f3ca\";\n}\ni.icon.minus:before {\n  content: \"\\f068\";\n}\ni.icon.minus.circle:before {\n  content: \"\\f056\";\n}\ni.icon.minus.square:before {\n  content: \"\\f146\";\n}\ni.icon.mix:before {\n  content: \"\\f3cb\";\n}\ni.icon.mixcloud:before {\n  content: \"\\f289\";\n}\ni.icon.mizuni:before {\n  content: \"\\f3cc\";\n}\ni.icon.mobile:before {\n  content: \"\\f10b\";\n}\ni.icon.mobile.alternate:before {\n  content: \"\\f3cd\";\n}\ni.icon.modx:before {\n  content: \"\\f285\";\n}\ni.icon.monero:before {\n  content: \"\\f3d0\";\n}\ni.icon.money.bill.alternate:before {\n  content: \"\\f3d1\";\n}\ni.icon.moon:before {\n  content: \"\\f186\";\n}\ni.icon.motorcycle:before {\n  content: \"\\f21c\";\n}\ni.icon.mouse.pointer:before {\n  content: \"\\f245\";\n}\ni.icon.music:before {\n  content: \"\\f001\";\n}\ni.icon.napster:before {\n  content: \"\\f3d2\";\n}\ni.icon.neuter:before {\n  content: \"\\f22c\";\n}\ni.icon.newspaper:before {\n  content: \"\\f1ea\";\n}\ni.icon.nintendo.switch:before {\n  content: \"\\f418\";\n}\ni.icon.node:before {\n  content: \"\\f419\";\n}\ni.icon.node.js:before {\n  content: \"\\f3d3\";\n}\ni.icon.npm:before {\n  content: \"\\f3d4\";\n}\ni.icon.ns8:before {\n  content: \"\\f3d5\";\n}\ni.icon.nutritionix:before {\n  content: \"\\f3d6\";\n}\ni.icon.object.group:before {\n  content: \"\\f247\";\n}\ni.icon.object.ungroup:before {\n  content: \"\\f248\";\n}\ni.icon.odnoklassniki:before {\n  content: \"\\f263\";\n}\ni.icon.odnoklassniki.square:before {\n  content: \"\\f264\";\n}\ni.icon.opencart:before {\n  content: \"\\f23d\";\n}\ni.icon.openid:before {\n  content: \"\\f19b\";\n}\ni.icon.opera:before {\n  content: \"\\f26a\";\n}\ni.icon.optin.monster:before {\n  content: \"\\f23c\";\n}\ni.icon.osi:before {\n  content: \"\\f41a\";\n}\ni.icon.outdent:before {\n  content: \"\\f03b\";\n}\ni.icon.page4:before {\n  content: \"\\f3d7\";\n}\ni.icon.pagelines:before {\n  content: \"\\f18c\";\n}\ni.icon.paint.brush:before {\n  content: \"\\f1fc\";\n}\ni.icon.palfed:before {\n  content: \"\\f3d8\";\n}\ni.icon.pallet:before {\n  content: \"\\f482\";\n}\ni.icon.paper.plane:before {\n  content: \"\\f1d8\";\n}\ni.icon.paperclip:before {\n  content: \"\\f0c6\";\n}\ni.icon.paragraph:before {\n  content: \"\\f1dd\";\n}\ni.icon.paste:before {\n  content: \"\\f0ea\";\n}\ni.icon.patreon:before {\n  content: \"\\f3d9\";\n}\ni.icon.pause:before {\n  content: \"\\f04c\";\n}\ni.icon.pause.circle:before {\n  content: \"\\f28b\";\n}\ni.icon.paw:before {\n  content: \"\\f1b0\";\n}\ni.icon.paypal:before {\n  content: \"\\f1ed\";\n}\ni.icon.pen.square:before {\n  content: \"\\f14b\";\n}\ni.icon.pencil.alternate:before {\n  content: \"\\f303\";\n}\ni.icon.percent:before {\n  content: \"\\f295\";\n}\ni.icon.periscope:before {\n  content: \"\\f3da\";\n}\ni.icon.phabricator:before {\n  content: \"\\f3db\";\n}\ni.icon.phoenix.framework:before {\n  content: \"\\f3dc\";\n}\ni.icon.phone:before {\n  content: \"\\f095\";\n}\ni.icon.phone.square:before {\n  content: \"\\f098\";\n}\ni.icon.phone.volume:before {\n  content: \"\\f2a0\";\n}\ni.icon.php:before {\n  content: \"\\f457\";\n}\ni.icon.pied.piper:before {\n  content: \"\\f2ae\";\n}\ni.icon.pied.piper.alternate:before {\n  content: \"\\f1a8\";\n}\ni.icon.pied.piper.pp:before {\n  content: \"\\f1a7\";\n}\ni.icon.pills:before {\n  content: \"\\f484\";\n}\ni.icon.pinterest:before {\n  content: \"\\f0d2\";\n}\ni.icon.pinterest.p:before {\n  content: \"\\f231\";\n}\ni.icon.pinterest.square:before {\n  content: \"\\f0d3\";\n}\ni.icon.plane:before {\n  content: \"\\f072\";\n}\ni.icon.play:before {\n  content: \"\\f04b\";\n}\ni.icon.play.circle:before {\n  content: \"\\f144\";\n}\ni.icon.playstation:before {\n  content: \"\\f3df\";\n}\ni.icon.plug:before {\n  content: \"\\f1e6\";\n}\ni.icon.plus:before {\n  content: \"\\f067\";\n}\ni.icon.plus.circle:before {\n  content: \"\\f055\";\n}\ni.icon.plus.square:before {\n  content: \"\\f0fe\";\n}\ni.icon.podcast:before {\n  content: \"\\f2ce\";\n}\ni.icon.pound.sign:before {\n  content: \"\\f154\";\n}\ni.icon.power.off:before {\n  content: \"\\f011\";\n}\ni.icon.print:before {\n  content: \"\\f02f\";\n}\ni.icon.product.hunt:before {\n  content: \"\\f288\";\n}\ni.icon.pushed:before {\n  content: \"\\f3e1\";\n}\ni.icon.puzzle.piece:before {\n  content: \"\\f12e\";\n}\ni.icon.python:before {\n  content: \"\\f3e2\";\n}\ni.icon.qq:before {\n  content: \"\\f1d6\";\n}\ni.icon.qrcode:before {\n  content: \"\\f029\";\n}\ni.icon.question:before {\n  content: \"\\f128\";\n}\ni.icon.question.circle:before {\n  content: \"\\f059\";\n}\ni.icon.quidditch:before {\n  content: \"\\f458\";\n}\ni.icon.quinscape:before {\n  content: \"\\f459\";\n}\ni.icon.quora:before {\n  content: \"\\f2c4\";\n}\ni.icon.quote.left:before {\n  content: \"\\f10d\";\n}\ni.icon.quote.right:before {\n  content: \"\\f10e\";\n}\ni.icon.random:before {\n  content: \"\\f074\";\n}\ni.icon.ravelry:before {\n  content: \"\\f2d9\";\n}\ni.icon.react:before {\n  content: \"\\f41b\";\n}\ni.icon.rebel:before {\n  content: \"\\f1d0\";\n}\ni.icon.recycle:before {\n  content: \"\\f1b8\";\n}\ni.icon.redriver:before {\n  content: \"\\f3e3\";\n}\ni.icon.reddit:before {\n  content: \"\\f1a1\";\n}\ni.icon.reddit.alien:before {\n  content: \"\\f281\";\n}\ni.icon.reddit.square:before {\n  content: \"\\f1a2\";\n}\ni.icon.redo:before {\n  content: \"\\f01e\";\n}\ni.icon.redo.alternate:before {\n  content: \"\\f2f9\";\n}\ni.icon.registered:before {\n  content: \"\\f25d\";\n}\ni.icon.rendact:before {\n  content: \"\\f3e4\";\n}\ni.icon.renren:before {\n  content: \"\\f18b\";\n}\ni.icon.reply:before {\n  content: \"\\f3e5\";\n}\ni.icon.reply.all:before {\n  content: \"\\f122\";\n}\ni.icon.replyd:before {\n  content: \"\\f3e6\";\n}\ni.icon.resolving:before {\n  content: \"\\f3e7\";\n}\ni.icon.retweet:before {\n  content: \"\\f079\";\n}\ni.icon.road:before {\n  content: \"\\f018\";\n}\ni.icon.rocket:before {\n  content: \"\\f135\";\n}\ni.icon.rocketchat:before {\n  content: \"\\f3e8\";\n}\ni.icon.rockrms:before {\n  content: \"\\f3e9\";\n}\ni.icon.rss:before {\n  content: \"\\f09e\";\n}\ni.icon.rss.square:before {\n  content: \"\\f143\";\n}\ni.icon.ruble.sign:before {\n  content: \"\\f158\";\n}\ni.icon.rupee.sign:before {\n  content: \"\\f156\";\n}\ni.icon.safari:before {\n  content: \"\\f267\";\n}\ni.icon.sass:before {\n  content: \"\\f41e\";\n}\ni.icon.save:before {\n  content: \"\\f0c7\";\n}\ni.icon.schlix:before {\n  content: \"\\f3ea\";\n}\ni.icon.scribd:before {\n  content: \"\\f28a\";\n}\ni.icon.search:before {\n  content: \"\\f002\";\n}\ni.icon.search.minus:before {\n  content: \"\\f010\";\n}\ni.icon.search.plus:before {\n  content: \"\\f00e\";\n}\ni.icon.searchengin:before {\n  content: \"\\f3eb\";\n}\ni.icon.sellcast:before {\n  content: \"\\f2da\";\n}\ni.icon.sellsy:before {\n  content: \"\\f213\";\n}\ni.icon.server:before {\n  content: \"\\f233\";\n}\ni.icon.servicestack:before {\n  content: \"\\f3ec\";\n}\ni.icon.share:before {\n  content: \"\\f064\";\n}\ni.icon.share.alternate:before {\n  content: \"\\f1e0\";\n}\ni.icon.share.alternate.square:before {\n  content: \"\\f1e1\";\n}\ni.icon.share.square:before {\n  content: \"\\f14d\";\n}\ni.icon.shekel.sign:before {\n  content: \"\\f20b\";\n}\ni.icon.shield.alternate:before {\n  content: \"\\f3ed\";\n}\ni.icon.ship:before {\n  content: \"\\f21a\";\n}\ni.icon.shipping.fast:before {\n  content: \"\\f48b\";\n}\ni.icon.shirtsinbulk:before {\n  content: \"\\f214\";\n}\ni.icon.shopping.bag:before {\n  content: \"\\f290\";\n}\ni.icon.shopping.basket:before {\n  content: \"\\f291\";\n}\ni.icon.shopping.cart:before {\n  content: \"\\f07a\";\n}\ni.icon.shower:before {\n  content: \"\\f2cc\";\n}\ni.icon.sign.language:before {\n  content: \"\\f2a7\";\n}\ni.icon.signal:before {\n  content: \"\\f012\";\n}\ni.icon.simplybuilt:before {\n  content: \"\\f215\";\n}\ni.icon.sistrix:before {\n  content: \"\\f3ee\";\n}\ni.icon.sitemap:before {\n  content: \"\\f0e8\";\n}\ni.icon.skyatlas:before {\n  content: \"\\f216\";\n}\ni.icon.skype:before {\n  content: \"\\f17e\";\n}\ni.icon.slack:before {\n  content: \"\\f198\";\n}\ni.icon.slack.hash:before {\n  content: \"\\f3ef\";\n}\ni.icon.sliders.horizontal:before {\n  content: \"\\f1de\";\n}\ni.icon.slideshare:before {\n  content: \"\\f1e7\";\n}\ni.icon.smile:before {\n  content: \"\\f118\";\n}\ni.icon.snapchat:before {\n  content: \"\\f2ab\";\n}\ni.icon.snapchat.ghost:before {\n  content: \"\\f2ac\";\n}\ni.icon.snapchat.square:before {\n  content: \"\\f2ad\";\n}\ni.icon.snowflake:before {\n  content: \"\\f2dc\";\n}\ni.icon.sort:before {\n  content: \"\\f0dc\";\n}\ni.icon.sort.alphabet.down:before {\n  content: \"\\f15d\";\n}\ni.icon.sort.alphabet.up:before {\n  content: \"\\f15e\";\n}\ni.icon.sort.amount.down:before {\n  content: \"\\f160\";\n}\ni.icon.sort.amount.up:before {\n  content: \"\\f161\";\n}\ni.icon.sort.down:before {\n  content: \"\\f0dd\";\n}\ni.icon.sort.numeric.down:before {\n  content: \"\\f162\";\n}\ni.icon.sort.numeric.up:before {\n  content: \"\\f163\";\n}\ni.icon.sort.up:before {\n  content: \"\\f0de\";\n}\ni.icon.soundcloud:before {\n  content: \"\\f1be\";\n}\ni.icon.space.shuttle:before {\n  content: \"\\f197\";\n}\ni.icon.speakap:before {\n  content: \"\\f3f3\";\n}\ni.icon.spinner:before {\n  content: \"\\f110\";\n}\ni.icon.spotify:before {\n  content: \"\\f1bc\";\n}\ni.icon.square:before {\n  content: \"\\f0c8\";\n}\ni.icon.square.full:before {\n  content: \"\\f45c\";\n}\ni.icon.stack.exchange:before {\n  content: \"\\f18d\";\n}\ni.icon.stack.overflow:before {\n  content: \"\\f16c\";\n}\ni.icon.star:before {\n  content: \"\\f005\";\n}\ni.icon.star.half:before {\n  content: \"\\f089\";\n}\ni.icon.staylinked:before {\n  content: \"\\f3f5\";\n}\ni.icon.steam:before {\n  content: \"\\f1b6\";\n}\ni.icon.steam.square:before {\n  content: \"\\f1b7\";\n}\ni.icon.steam.symbol:before {\n  content: \"\\f3f6\";\n}\ni.icon.step.backward:before {\n  content: \"\\f048\";\n}\ni.icon.step.forward:before {\n  content: \"\\f051\";\n}\ni.icon.stethoscope:before {\n  content: \"\\f0f1\";\n}\ni.icon.sticker.mule:before {\n  content: \"\\f3f7\";\n}\ni.icon.sticky.note:before {\n  content: \"\\f249\";\n}\ni.icon.stop:before {\n  content: \"\\f04d\";\n}\ni.icon.stop.circle:before {\n  content: \"\\f28d\";\n}\ni.icon.stopwatch:before {\n  content: \"\\f2f2\";\n}\ni.icon.strava:before {\n  content: \"\\f428\";\n}\ni.icon.street.view:before {\n  content: \"\\f21d\";\n}\ni.icon.strikethrough:before {\n  content: \"\\f0cc\";\n}\ni.icon.stripe:before {\n  content: \"\\f429\";\n}\ni.icon.stripe.s:before {\n  content: \"\\f42a\";\n}\ni.icon.studiovinari:before {\n  content: \"\\f3f8\";\n}\ni.icon.stumbleupon:before {\n  content: \"\\f1a4\";\n}\ni.icon.stumbleupon.circle:before {\n  content: \"\\f1a3\";\n}\ni.icon.subscript:before {\n  content: \"\\f12c\";\n}\ni.icon.subway:before {\n  content: \"\\f239\";\n}\ni.icon.suitcase:before {\n  content: \"\\f0f2\";\n}\ni.icon.sun:before {\n  content: \"\\f185\";\n}\ni.icon.superpowers:before {\n  content: \"\\f2dd\";\n}\ni.icon.superscript:before {\n  content: \"\\f12b\";\n}\ni.icon.supple:before {\n  content: \"\\f3f9\";\n}\ni.icon.sync:before {\n  content: \"\\f021\";\n}\ni.icon.sync.alternate:before {\n  content: \"\\f2f1\";\n}\ni.icon.syringe:before {\n  content: \"\\f48e\";\n}\ni.icon.table:before {\n  content: \"\\f0ce\";\n}\ni.icon.table.tennis:before {\n  content: \"\\f45d\";\n}\ni.icon.tablet:before {\n  content: \"\\f10a\";\n}\ni.icon.tablet.alternate:before {\n  content: \"\\f3fa\";\n}\ni.icon.tachometer.alternate:before {\n  content: \"\\f3fd\";\n}\ni.icon.tag:before {\n  content: \"\\f02b\";\n}\ni.icon.tags:before {\n  content: \"\\f02c\";\n}\ni.icon.tasks:before {\n  content: \"\\f0ae\";\n}\ni.icon.taxi:before {\n  content: \"\\f1ba\";\n}\ni.icon.telegram:before {\n  content: \"\\f2c6\";\n}\ni.icon.telegram.plane:before {\n  content: \"\\f3fe\";\n}\ni.icon.tencent.weibo:before {\n  content: \"\\f1d5\";\n}\ni.icon.terminal:before {\n  content: \"\\f120\";\n}\ni.icon.text.height:before {\n  content: \"\\f034\";\n}\ni.icon.text.width:before {\n  content: \"\\f035\";\n}\ni.icon.th:before {\n  content: \"\\f00a\";\n}\ni.icon.th.large:before {\n  content: \"\\f009\";\n}\ni.icon.th.list:before {\n  content: \"\\f00b\";\n}\ni.icon.themeisle:before {\n  content: \"\\f2b2\";\n}\ni.icon.thermometer:before {\n  content: \"\\f491\";\n}\ni.icon.thermometer.empty:before {\n  content: \"\\f2cb\";\n}\ni.icon.thermometer.full:before {\n  content: \"\\f2c7\";\n}\ni.icon.thermometer.half:before {\n  content: \"\\f2c9\";\n}\ni.icon.thermometer.quarter:before {\n  content: \"\\f2ca\";\n}\ni.icon.thermometer.three.quarters:before {\n  content: \"\\f2c8\";\n}\ni.icon.thumbs.down:before {\n  content: \"\\f165\";\n}\ni.icon.thumbs.up:before {\n  content: \"\\f164\";\n}\ni.icon.thumbtack:before {\n  content: \"\\f08d\";\n}\ni.icon.ticket.alternate:before {\n  content: \"\\f3ff\";\n}\ni.icon.times:before {\n  content: \"\\f00d\";\n}\ni.icon.times.circle:before {\n  content: \"\\f057\";\n}\ni.icon.tint:before {\n  content: \"\\f043\";\n}\ni.icon.toggle.off:before {\n  content: \"\\f204\";\n}\ni.icon.toggle.on:before {\n  content: \"\\f205\";\n}\ni.icon.trademark:before {\n  content: \"\\f25c\";\n}\ni.icon.train:before {\n  content: \"\\f238\";\n}\ni.icon.transgender:before {\n  content: \"\\f224\";\n}\ni.icon.transgender.alternate:before {\n  content: \"\\f225\";\n}\ni.icon.trash:before {\n  content: \"\\f1f8\";\n}\ni.icon.trash.alternate:before {\n  content: \"\\f2ed\";\n}\ni.icon.tree:before {\n  content: \"\\f1bb\";\n}\ni.icon.trello:before {\n  content: \"\\f181\";\n}\ni.icon.tripadvisor:before {\n  content: \"\\f262\";\n}\ni.icon.trophy:before {\n  content: \"\\f091\";\n}\ni.icon.truck:before {\n  content: \"\\f0d1\";\n}\ni.icon.tty:before {\n  content: \"\\f1e4\";\n}\ni.icon.tumblr:before {\n  content: \"\\f173\";\n}\ni.icon.tumblr.square:before {\n  content: \"\\f174\";\n}\ni.icon.tv:before {\n  content: \"\\f26c\";\n}\ni.icon.twitch:before {\n  content: \"\\f1e8\";\n}\ni.icon.twitter:before {\n  content: \"\\f099\";\n}\ni.icon.twitter.square:before {\n  content: \"\\f081\";\n}\ni.icon.typo3:before {\n  content: \"\\f42b\";\n}\ni.icon.uber:before {\n  content: \"\\f402\";\n}\ni.icon.uikit:before {\n  content: \"\\f403\";\n}\ni.icon.umbrella:before {\n  content: \"\\f0e9\";\n}\ni.icon.underline:before {\n  content: \"\\f0cd\";\n}\ni.icon.undo:before {\n  content: \"\\f0e2\";\n}\ni.icon.undo.alternate:before {\n  content: \"\\f2ea\";\n}\ni.icon.uniregistry:before {\n  content: \"\\f404\";\n}\ni.icon.universal.access:before {\n  content: \"\\f29a\";\n}\ni.icon.university:before {\n  content: \"\\f19c\";\n}\ni.icon.unlink:before {\n  content: \"\\f127\";\n}\ni.icon.unlock:before {\n  content: \"\\f09c\";\n}\ni.icon.unlock.alternate:before {\n  content: \"\\f13e\";\n}\ni.icon.untappd:before {\n  content: \"\\f405\";\n}\ni.icon.upload:before {\n  content: \"\\f093\";\n}\ni.icon.usb:before {\n  content: \"\\f287\";\n}\ni.icon.user:before {\n  content: \"\\f007\";\n}\ni.icon.user.circle:before {\n  content: \"\\f2bd\";\n}\ni.icon.user.md:before {\n  content: \"\\f0f0\";\n}\ni.icon.user.plus:before {\n  content: \"\\f234\";\n}\ni.icon.user.secret:before {\n  content: \"\\f21b\";\n}\ni.icon.user.times:before {\n  content: \"\\f235\";\n}\ni.icon.users:before {\n  content: \"\\f0c0\";\n}\ni.icon.ussunnah:before {\n  content: \"\\f407\";\n}\ni.icon.utensil.spoon:before {\n  content: \"\\f2e5\";\n}\ni.icon.utensils:before {\n  content: \"\\f2e7\";\n}\ni.icon.vaadin:before {\n  content: \"\\f408\";\n}\ni.icon.venus:before {\n  content: \"\\f221\";\n}\ni.icon.venus.double:before {\n  content: \"\\f226\";\n}\ni.icon.venus.mars:before {\n  content: \"\\f228\";\n}\ni.icon.viacoin:before {\n  content: \"\\f237\";\n}\ni.icon.viadeo:before {\n  content: \"\\f2a9\";\n}\ni.icon.viadeo.square:before {\n  content: \"\\f2aa\";\n}\ni.icon.viber:before {\n  content: \"\\f409\";\n}\ni.icon.video:before {\n  content: \"\\f03d\";\n}\ni.icon.vimeo:before {\n  content: \"\\f40a\";\n}\ni.icon.vimeo.square:before {\n  content: \"\\f194\";\n}\ni.icon.vimeo.v:before {\n  content: \"\\f27d\";\n}\ni.icon.vine:before {\n  content: \"\\f1ca\";\n}\ni.icon.vk:before {\n  content: \"\\f189\";\n}\ni.icon.vnv:before {\n  content: \"\\f40b\";\n}\ni.icon.volleyball.ball:before {\n  content: \"\\f45f\";\n}\ni.icon.volume.down:before {\n  content: \"\\f027\";\n}\ni.icon.volume.off:before {\n  content: \"\\f026\";\n}\ni.icon.volume.up:before {\n  content: \"\\f028\";\n}\ni.icon.vuejs:before {\n  content: \"\\f41f\";\n}\ni.icon.warehouse:before {\n  content: \"\\f494\";\n}\ni.icon.weibo:before {\n  content: \"\\f18a\";\n}\ni.icon.weight:before {\n  content: \"\\f496\";\n}\ni.icon.weixin:before {\n  content: \"\\f1d7\";\n}\ni.icon.whatsapp:before {\n  content: \"\\f232\";\n}\ni.icon.whatsapp.square:before {\n  content: \"\\f40c\";\n}\ni.icon.wheelchair:before {\n  content: \"\\f193\";\n}\ni.icon.whmcs:before {\n  content: \"\\f40d\";\n}\ni.icon.wifi:before {\n  content: \"\\f1eb\";\n}\ni.icon.wikipedia.w:before {\n  content: \"\\f266\";\n}\ni.icon.window.close:before {\n  content: \"\\f410\";\n}\ni.icon.window.maximize:before {\n  content: \"\\f2d0\";\n}\ni.icon.window.minimize:before {\n  content: \"\\f2d1\";\n}\ni.icon.window.restore:before {\n  content: \"\\f2d2\";\n}\ni.icon.windows:before {\n  content: \"\\f17a\";\n}\ni.icon.won.sign:before {\n  content: \"\\f159\";\n}\ni.icon.wordpress:before {\n  content: \"\\f19a\";\n}\ni.icon.wordpress.simple:before {\n  content: \"\\f411\";\n}\ni.icon.wpbeginner:before {\n  content: \"\\f297\";\n}\ni.icon.wpexplorer:before {\n  content: \"\\f2de\";\n}\ni.icon.wpforms:before {\n  content: \"\\f298\";\n}\ni.icon.wrench:before {\n  content: \"\\f0ad\";\n}\ni.icon.xbox:before {\n  content: \"\\f412\";\n}\ni.icon.xing:before {\n  content: \"\\f168\";\n}\ni.icon.xing.square:before {\n  content: \"\\f169\";\n}\ni.icon.y.combinator:before {\n  content: \"\\f23b\";\n}\ni.icon.yahoo:before {\n  content: \"\\f19e\";\n}\ni.icon.yandex:before {\n  content: \"\\f413\";\n}\ni.icon.yandex.international:before {\n  content: \"\\f414\";\n}\ni.icon.yelp:before {\n  content: \"\\f1e9\";\n}\ni.icon.yen.sign:before {\n  content: \"\\f157\";\n}\ni.icon.yoast:before {\n  content: \"\\f2b1\";\n}\ni.icon.youtube:before {\n  content: \"\\f167\";\n}\ni.icon.youtube.square:before {\n  content: \"\\f431\";\n}\n/* Aliases */\ni.icon.chess.rock:before {\n  content: \"\\f447\";\n}\ni.icon.ordered.list:before {\n  content: \"\\f0cb\";\n}\ni.icon.unordered.list:before {\n  content: \"\\f0ca\";\n}\ni.icon.user.doctor:before {\n  content: \"\\f0f0\";\n}\ni.icon.shield:before {\n  content: \"\\f3ed\";\n}\ni.icon.puzzle:before {\n  content: \"\\f12e\";\n}\ni.icon.credit.card.amazon.pay:before {\n  content: \"\\f42d\";\n}\ni.icon.credit.card.american.express:before {\n  content: \"\\f1f3\";\n}\ni.icon.credit.card.diners.club:before {\n  content: \"\\f24c\";\n}\ni.icon.credit.card.discover:before {\n  content: \"\\f1f2\";\n}\ni.icon.credit.card.jcb:before {\n  content: \"\\f24b\";\n}\ni.icon.credit.card.mastercard:before {\n  content: \"\\f1f1\";\n}\ni.icon.credit.card.paypal:before {\n  content: \"\\f1f4\";\n}\ni.icon.credit.card.stripe:before {\n  content: \"\\f1f5\";\n}\ni.icon.credit.card.visa:before {\n  content: \"\\f1f0\";\n}\ni.icon.add.circle:before {\n  content: \"\\f055\";\n}\ni.icon.add.square:before {\n  content: \"\\f0fe\";\n}\ni.icon.add.to.calendar:before {\n  content: \"\\f271\";\n}\ni.icon.add.to.cart:before {\n  content: \"\\f217\";\n}\ni.icon.add.user:before {\n  content: \"\\f234\";\n}\ni.icon.add:before {\n  content: \"\\f067\";\n}\ni.icon.alarm.mute:before {\n  content: \"\\f1f6\";\n}\ni.icon.alarm:before {\n  content: \"\\f0f3\";\n}\ni.icon.ald:before {\n  content: \"\\f2a2\";\n}\ni.icon.als:before {\n  content: \"\\f2a2\";\n}\ni.icon.american.express.card:before {\n  content: \"\\f1f3\";\n}\ni.icon.american.express:before {\n  content: \"\\f1f3\";\n}\ni.icon.amex:before {\n  content: \"\\f1f3\";\n}\ni.icon.announcement:before {\n  content: \"\\f0a1\";\n}\ni.icon.area.chart:before {\n  content: \"\\f1fe\";\n}\ni.icon.area.graph:before {\n  content: \"\\f1fe\";\n}\ni.icon.arrow.down.cart:before {\n  content: \"\\f218\";\n}\ni.icon.asexual:before {\n  content: \"\\f22d\";\n}\ni.icon.asl.interpreting:before {\n  content: \"\\f2a3\";\n}\ni.icon.asl:before {\n  content: \"\\f2a3\";\n}\ni.icon.assistive.listening.devices:before {\n  content: \"\\f2a2\";\n}\ni.icon.attach:before {\n  content: \"\\f0c6\";\n}\ni.icon.attention:before {\n  content: \"\\f06a\";\n}\ni.icon.balance:before {\n  content: \"\\f24e\";\n}\ni.icon.bar:before {\n  content: \"\\f0fc\";\n}\ni.icon.bathtub:before {\n  content: \"\\f2cd\";\n}\ni.icon.battery.four:before {\n  content: \"\\f240\";\n}\ni.icon.battery.high:before {\n  content: \"\\f241\";\n}\ni.icon.battery.low:before {\n  content: \"\\f243\";\n}\ni.icon.battery.medium:before {\n  content: \"\\f242\";\n}\ni.icon.battery.one:before {\n  content: \"\\f243\";\n}\ni.icon.battery.three:before {\n  content: \"\\f241\";\n}\ni.icon.battery.two:before {\n  content: \"\\f242\";\n}\ni.icon.battery.zero:before {\n  content: \"\\f244\";\n}\ni.icon.birthday:before {\n  content: \"\\f1fd\";\n}\ni.icon.block.layout:before {\n  content: \"\\f009\";\n}\ni.icon.bluetooth.alternative:before {\n  content: \"\\f294\";\n}\ni.icon.broken.chain:before {\n  content: \"\\f127\";\n}\ni.icon.browser:before {\n  content: \"\\f022\";\n}\ni.icon.call.square:before {\n  content: \"\\f098\";\n}\ni.icon.call:before {\n  content: \"\\f095\";\n}\ni.icon.cancel:before {\n  content: \"\\f00d\";\n}\ni.icon.cart:before {\n  content: \"\\f07a\";\n}\ni.icon.cc:before {\n  content: \"\\f20a\";\n}\ni.icon.chain:before {\n  content: \"\\f0c1\";\n}\ni.icon.chat:before {\n  content: \"\\f075\";\n}\ni.icon.checked.calendar:before {\n  content: \"\\f274\";\n}\ni.icon.checkmark:before {\n  content: \"\\f00c\";\n}\ni.icon.circle.notched:before {\n  content: \"\\f1ce\";\n}\ni.icon.close:before {\n  content: \"\\f00d\";\n}\ni.icon.cny:before {\n  content: \"\\f157\";\n}\ni.icon.cocktail:before {\n  content: \"\\f000\";\n}\ni.icon.commenting:before {\n  content: \"\\f27a\";\n}\ni.icon.computer:before {\n  content: \"\\f108\";\n}\ni.icon.configure:before {\n  content: \"\\f0ad\";\n}\ni.icon.content:before {\n  content: \"\\f0c9\";\n}\ni.icon.deafness:before {\n  content: \"\\f2a4\";\n}\ni.icon.delete.calendar:before {\n  content: \"\\f273\";\n}\ni.icon.delete:before {\n  content: \"\\f00d\";\n}\ni.icon.detective:before {\n  content: \"\\f21b\";\n}\ni.icon.diners.club.card:before {\n  content: \"\\f24c\";\n}\ni.icon.diners.club:before {\n  content: \"\\f24c\";\n}\ni.icon.discover.card:before {\n  content: \"\\f1f2\";\n}\ni.icon.discover:before {\n  content: \"\\f1f2\";\n}\ni.icon.discussions:before {\n  content: \"\\f086\";\n}\ni.icon.doctor:before {\n  content: \"\\f0f0\";\n}\ni.icon.dollar:before {\n  content: \"\\f155\";\n}\ni.icon.dont:before {\n  content: \"\\f05e\";\n}\ni.icon.dribble:before {\n  content: \"\\f17d\";\n}\ni.icon.drivers.license:before {\n  content: \"\\f2c2\";\n}\ni.icon.dropdown:before {\n  content: \"\\f0d7\";\n}\ni.icon.eercast:before {\n  content: \"\\f2da\";\n}\ni.icon.emergency:before {\n  content: \"\\f0f9\";\n}\ni.icon.envira.gallery:before {\n  content: \"\\f299\";\n}\ni.icon.erase:before {\n  content: \"\\f12d\";\n}\ni.icon.eur:before {\n  content: \"\\f153\";\n}\ni.icon.euro:before {\n  content: \"\\f153\";\n}\ni.icon.eyedropper:before {\n  content: \"\\f1fb\";\n}\ni.icon.fa:before {\n  content: \"\\f2b4\";\n}\ni.icon.factory:before {\n  content: \"\\f275\";\n}\ni.icon.favorite:before {\n  content: \"\\f005\";\n}\ni.icon.feed:before {\n  content: \"\\f09e\";\n}\ni.icon.female.homosexual:before {\n  content: \"\\f226\";\n}\ni.icon.file.text:before {\n  content: \"\\f15c\";\n}\ni.icon.find:before {\n  content: \"\\f1e5\";\n}\ni.icon.first.aid:before {\n  content: \"\\f0fa\";\n}\ni.icon.five.hundred.pixels:before {\n  content: \"\\f26e\";\n}\ni.icon.fork:before {\n  content: \"\\f126\";\n}\ni.icon.game:before {\n  content: \"\\f11b\";\n}\ni.icon.gay:before {\n  content: \"\\f227\";\n}\ni.icon.gbp:before {\n  content: \"\\f154\";\n}\ni.icon.gittip:before {\n  content: \"\\f184\";\n}\ni.icon.google.plus.circle:before {\n  content: \"\\f2b3\";\n}\ni.icon.google.plus.official:before {\n  content: \"\\f2b3\";\n}\ni.icon.grab:before {\n  content: \"\\f255\";\n}\ni.icon.graduation:before {\n  content: \"\\f19d\";\n}\ni.icon.grid.layout:before {\n  content: \"\\f00a\";\n}\ni.icon.group:before {\n  content: \"\\f0c0\";\n}\ni.icon.h:before {\n  content: \"\\f0fd\";\n}\ni.icon.hand.victory:before {\n  content: \"\\f25b\";\n}\ni.icon.handicap:before {\n  content: \"\\f193\";\n}\ni.icon.hard.of.hearing:before {\n  content: \"\\f2a4\";\n}\ni.icon.header:before {\n  content: \"\\f1dc\";\n}\ni.icon.help.circle:before {\n  content: \"\\f059\";\n}\ni.icon.help:before {\n  content: \"\\f128\";\n}\ni.icon.heterosexual:before {\n  content: \"\\f228\";\n}\ni.icon.hide:before {\n  content: \"\\f070\";\n}\ni.icon.hotel:before {\n  content: \"\\f236\";\n}\ni.icon.hourglass.four:before {\n  content: \"\\f254\";\n}\ni.icon.hourglass.full:before {\n  content: \"\\f254\";\n}\ni.icon.hourglass.one:before {\n  content: \"\\f251\";\n}\ni.icon.hourglass.three:before {\n  content: \"\\f253\";\n}\ni.icon.hourglass.two:before {\n  content: \"\\f252\";\n}\ni.icon.idea:before {\n  content: \"\\f0eb\";\n}\ni.icon.ils:before {\n  content: \"\\f20b\";\n}\ni.icon.in-cart:before {\n  content: \"\\f218\";\n}\ni.icon.inr:before {\n  content: \"\\f156\";\n}\ni.icon.intergender:before {\n  content: \"\\f224\";\n}\ni.icon.intersex:before {\n  content: \"\\f224\";\n}\ni.icon.japan.credit.bureau.card:before {\n  content: \"\\f24b\";\n}\ni.icon.japan.credit.bureau:before {\n  content: \"\\f24b\";\n}\ni.icon.jcb:before {\n  content: \"\\f24b\";\n}\ni.icon.jpy:before {\n  content: \"\\f157\";\n}\ni.icon.krw:before {\n  content: \"\\f159\";\n}\ni.icon.lab:before {\n  content: \"\\f0c3\";\n}\ni.icon.law:before {\n  content: \"\\f24e\";\n}\ni.icon.legal:before {\n  content: \"\\f0e3\";\n}\ni.icon.lesbian:before {\n  content: \"\\f226\";\n}\ni.icon.lightning:before {\n  content: \"\\f0e7\";\n}\ni.icon.like:before {\n  content: \"\\f004\";\n}\ni.icon.line.graph:before {\n  content: \"\\f201\";\n}\ni.icon.linkedin.square:before {\n  content: \"\\f08c\";\n}\ni.icon.linkify:before {\n  content: \"\\f0c1\";\n}\ni.icon.lira:before {\n  content: \"\\f195\";\n}\ni.icon.list.layout:before {\n  content: \"\\f00b\";\n}\ni.icon.magnify:before {\n  content: \"\\f00e\";\n}\ni.icon.mail.forward:before {\n  content: \"\\f064\";\n}\ni.icon.mail.square:before {\n  content: \"\\f199\";\n}\ni.icon.mail:before {\n  content: \"\\f0e0\";\n}\ni.icon.male.homosexual:before {\n  content: \"\\f227\";\n}\ni.icon.man:before {\n  content: \"\\f222\";\n}\ni.icon.marker:before {\n  content: \"\\f041\";\n}\ni.icon.mars.alternate:before {\n  content: \"\\f229\";\n}\ni.icon.mars.horizontal:before {\n  content: \"\\f22b\";\n}\ni.icon.mars.vertical:before {\n  content: \"\\f22a\";\n}\ni.icon.mastercard.card:before {\n  content: \"\\f1f1\";\n}\ni.icon.mastercard:before {\n  content: \"\\f1f1\";\n}\ni.icon.microsoft.edge:before {\n  content: \"\\f282\";\n}\ni.icon.military:before {\n  content: \"\\f0fb\";\n}\ni.icon.ms.edge:before {\n  content: \"\\f282\";\n}\ni.icon.mute:before {\n  content: \"\\f131\";\n}\ni.icon.new.pied.piper:before {\n  content: \"\\f2ae\";\n}\ni.icon.non.binary.transgender:before {\n  content: \"\\f223\";\n}\ni.icon.numbered.list:before {\n  content: \"\\f0cb\";\n}\ni.icon.optinmonster:before {\n  content: \"\\f23c\";\n}\ni.icon.options:before {\n  content: \"\\f1de\";\n}\ni.icon.other.gender.horizontal:before {\n  content: \"\\f22b\";\n}\ni.icon.other.gender.vertical:before {\n  content: \"\\f22a\";\n}\ni.icon.other.gender:before {\n  content: \"\\f229\";\n}\ni.icon.payment:before {\n  content: \"\\f09d\";\n}\ni.icon.paypal.card:before {\n  content: \"\\f1f4\";\n}\ni.icon.pencil.square:before {\n  content: \"\\f14b\";\n}\ni.icon.photo:before {\n  content: \"\\f030\";\n}\ni.icon.picture:before {\n  content: \"\\f03e\";\n}\ni.icon.pie.chart:before {\n  content: \"\\f200\";\n}\ni.icon.pie.graph:before {\n  content: \"\\f200\";\n}\ni.icon.pied.piper.hat:before {\n  content: \"\\f2ae\";\n}\ni.icon.pin:before {\n  content: \"\\f08d\";\n}\ni.icon.plus.cart:before {\n  content: \"\\f217\";\n}\ni.icon.pocket:before {\n  content: \"\\f265\";\n}\ni.icon.point:before {\n  content: \"\\f041\";\n}\ni.icon.pointing.down:before {\n  content: \"\\f0a7\";\n}\ni.icon.pointing.left:before {\n  content: \"\\f0a5\";\n}\ni.icon.pointing.right:before {\n  content: \"\\f0a4\";\n}\ni.icon.pointing.up:before {\n  content: \"\\f0a6\";\n}\ni.icon.pound:before {\n  content: \"\\f154\";\n}\ni.icon.power.cord:before {\n  content: \"\\f1e6\";\n}\ni.icon.power:before {\n  content: \"\\f011\";\n}\ni.icon.privacy:before {\n  content: \"\\f084\";\n}\ni.icon.r.circle:before {\n  content: \"\\f25d\";\n}\ni.icon.rain:before {\n  content: \"\\f0e9\";\n}\ni.icon.record:before {\n  content: \"\\f03d\";\n}\ni.icon.refresh:before {\n  content: \"\\f021\";\n}\ni.icon.remove.circle:before {\n  content: \"\\f057\";\n}\ni.icon.remove.from.calendar:before {\n  content: \"\\f272\";\n}\ni.icon.remove.user:before {\n  content: \"\\f235\";\n}\ni.icon.remove:before {\n  content: \"\\f00d\";\n}\ni.icon.repeat:before {\n  content: \"\\f01e\";\n}\ni.icon.rmb:before {\n  content: \"\\f157\";\n}\ni.icon.rouble:before {\n  content: \"\\f158\";\n}\ni.icon.rub:before {\n  content: \"\\f158\";\n}\ni.icon.ruble:before {\n  content: \"\\f158\";\n}\ni.icon.rupee:before {\n  content: \"\\f156\";\n}\ni.icon.s15:before {\n  content: \"\\f2cd\";\n}\ni.icon.selected.radio:before {\n  content: \"\\f192\";\n}\ni.icon.send:before {\n  content: \"\\f1d8\";\n}\ni.icon.setting:before {\n  content: \"\\f013\";\n}\ni.icon.settings:before {\n  content: \"\\f085\";\n}\ni.icon.shekel:before {\n  content: \"\\f20b\";\n}\ni.icon.sheqel:before {\n  content: \"\\f20b\";\n}\ni.icon.shipping:before {\n  content: \"\\f0d1\";\n}\ni.icon.shop:before {\n  content: \"\\f07a\";\n}\ni.icon.shuffle:before {\n  content: \"\\f074\";\n}\ni.icon.shutdown:before {\n  content: \"\\f011\";\n}\ni.icon.sidebar:before {\n  content: \"\\f0c9\";\n}\ni.icon.signing:before {\n  content: \"\\f2a7\";\n}\ni.icon.signup:before {\n  content: \"\\f044\";\n}\ni.icon.sliders:before {\n  content: \"\\f1de\";\n}\ni.icon.soccer:before {\n  content: \"\\f1e3\";\n}\ni.icon.sort.alphabet.ascending:before {\n  content: \"\\f15d\";\n}\ni.icon.sort.alphabet.descending:before {\n  content: \"\\f15e\";\n}\ni.icon.sort.ascending:before {\n  content: \"\\f0de\";\n}\ni.icon.sort.content.ascending:before {\n  content: \"\\f160\";\n}\ni.icon.sort.content.descending:before {\n  content: \"\\f161\";\n}\ni.icon.sort.descending:before {\n  content: \"\\f0dd\";\n}\ni.icon.sort.numeric.ascending:before {\n  content: \"\\f162\";\n}\ni.icon.sort.numeric.descending:before {\n  content: \"\\f163\";\n}\ni.icon.sound:before {\n  content: \"\\f025\";\n}\ni.icon.spy:before {\n  content: \"\\f21b\";\n}\ni.icon.stripe.card:before {\n  content: \"\\f1f5\";\n}\ni.icon.student:before {\n  content: \"\\f19d\";\n}\ni.icon.talk:before {\n  content: \"\\f27a\";\n}\ni.icon.target:before {\n  content: \"\\f140\";\n}\ni.icon.teletype:before {\n  content: \"\\f1e4\";\n}\ni.icon.television:before {\n  content: \"\\f26c\";\n}\ni.icon.text.cursor:before {\n  content: \"\\f246\";\n}\ni.icon.text.telephone:before {\n  content: \"\\f1e4\";\n}\ni.icon.theme.isle:before {\n  content: \"\\f2b2\";\n}\ni.icon.theme:before {\n  content: \"\\f043\";\n}\ni.icon.thermometer:before {\n  content: \"\\f2c7\";\n}\ni.icon.thumb.tack:before {\n  content: \"\\f08d\";\n}\ni.icon.time:before {\n  content: \"\\f017\";\n}\ni.icon.tm:before {\n  content: \"\\f25c\";\n}\ni.icon.toggle.down:before {\n  content: \"\\f150\";\n}\ni.icon.toggle.left:before {\n  content: \"\\f191\";\n}\ni.icon.toggle.right:before {\n  content: \"\\f152\";\n}\ni.icon.toggle.up:before {\n  content: \"\\f151\";\n}\ni.icon.translate:before {\n  content: \"\\f1ab\";\n}\ni.icon.travel:before {\n  content: \"\\f0b1\";\n}\ni.icon.treatment:before {\n  content: \"\\f0f1\";\n}\ni.icon.triangle.down:before {\n  content: \"\\f0d7\";\n}\ni.icon.triangle.left:before {\n  content: \"\\f0d9\";\n}\ni.icon.triangle.right:before {\n  content: \"\\f0da\";\n}\ni.icon.triangle.up:before {\n  content: \"\\f0d8\";\n}\ni.icon.try:before {\n  content: \"\\f195\";\n}\ni.icon.unhide:before {\n  content: \"\\f06e\";\n}\ni.icon.unlinkify:before {\n  content: \"\\f127\";\n}\ni.icon.unmute:before {\n  content: \"\\f130\";\n}\ni.icon.usd:before {\n  content: \"\\f155\";\n}\ni.icon.user.cancel:before {\n  content: \"\\f235\";\n}\ni.icon.user.close:before {\n  content: \"\\f235\";\n}\ni.icon.user.delete:before {\n  content: \"\\f235\";\n}\ni.icon.user.x:before {\n  content: \"\\f235\";\n}\ni.icon.vcard:before {\n  content: \"\\f2bb\";\n}\ni.icon.video.camera:before {\n  content: \"\\f03d\";\n}\ni.icon.video.play:before {\n  content: \"\\f144\";\n}\ni.icon.visa.card:before {\n  content: \"\\f1f0\";\n}\ni.icon.visa:before {\n  content: \"\\f1f0\";\n}\ni.icon.volume.control.phone:before {\n  content: \"\\f2a0\";\n}\ni.icon.wait:before {\n  content: \"\\f017\";\n}\ni.icon.warning.circle:before {\n  content: \"\\f06a\";\n}\ni.icon.warning.sign:before {\n  content: \"\\f071\";\n}\ni.icon.warning:before {\n  content: \"\\f12a\";\n}\ni.icon.wechat:before {\n  content: \"\\f1d7\";\n}\ni.icon.wi-fi:before {\n  content: \"\\f1eb\";\n}\ni.icon.wikipedia:before {\n  content: \"\\f266\";\n}\ni.icon.winner:before {\n  content: \"\\f091\";\n}\ni.icon.wizard:before {\n  content: \"\\f0d0\";\n}\ni.icon.woman:before {\n  content: \"\\f221\";\n}\ni.icon.won:before {\n  content: \"\\f159\";\n}\ni.icon.wordpress.beginner:before {\n  content: \"\\f297\";\n}\ni.icon.wordpress.forms:before {\n  content: \"\\f298\";\n}\ni.icon.world:before {\n  content: \"\\f0ac\";\n}\ni.icon.write.square:before {\n  content: \"\\f14b\";\n}\ni.icon.x:before {\n  content: \"\\f00d\";\n}\ni.icon.yc:before {\n  content: \"\\f23b\";\n}\ni.icon.ycombinator:before {\n  content: \"\\f23b\";\n}\ni.icon.yen:before {\n  content: \"\\f157\";\n}\ni.icon.zip:before {\n  content: \"\\f187\";\n}\ni.icon.zoom-in:before {\n  content: \"\\f00e\";\n}\ni.icon.zoom-out:before {\n  content: \"\\f010\";\n}\ni.icon.zoom:before {\n  content: \"\\f00e\";\n}\ni.icon.bitbucket.square:before {\n  content: \"\\f171\";\n}\ni.icon.checkmark.box:before {\n  content: \"\\f14a\";\n}\ni.icon.circle.thin:before {\n  content: \"\\f111\";\n}\ni.icon.cloud.download:before {\n  content: \"\\f381\";\n}\ni.icon.cloud.upload:before {\n  content: \"\\f382\";\n}\ni.icon.compose:before {\n  content: \"\\f303\";\n}\ni.icon.conversation:before {\n  content: \"\\f086\";\n}\ni.icon.credit.card.alternative:before {\n  content: \"\\f09d\";\n}\ni.icon.currency:before {\n  content: \"\\f3d1\";\n}\ni.icon.dashboard:before {\n  content: \"\\f3fd\";\n}\ni.icon.diamond:before {\n  content: \"\\f3a5\";\n}\ni.icon.disk:before {\n  content: \"\\f0a0\";\n}\ni.icon.exchange:before {\n  content: \"\\f362\";\n}\ni.icon.external.share:before {\n  content: \"\\f14d\";\n}\ni.icon.external.square:before {\n  content: \"\\f360\";\n}\ni.icon.external:before {\n  content: \"\\f35d\";\n}\ni.icon.facebook.official:before {\n  content: \"\\f082\";\n}\ni.icon.food:before {\n  content: \"\\f2e7\";\n}\ni.icon.hourglass.zero:before {\n  content: \"\\f253\";\n}\ni.icon.level.down:before {\n  content: \"\\f3be\";\n}\ni.icon.level.up:before {\n  content: \"\\f3bf\";\n}\ni.icon.logout:before {\n  content: \"\\f2f5\";\n}\ni.icon.meanpath:before {\n  content: \"\\f0c8\";\n}\ni.icon.money:before {\n  content: \"\\f3d1\";\n}\ni.icon.move:before {\n  content: \"\\f0b2\";\n}\ni.icon.pencil:before {\n  content: \"\\f303\";\n}\ni.icon.protect:before {\n  content: \"\\f023\";\n}\ni.icon.radio:before {\n  content: \"\\f192\";\n}\ni.icon.remove.bookmark:before {\n  content: \"\\f02e\";\n}\ni.icon.resize.horizontal:before {\n  content: \"\\f337\";\n}\ni.icon.resize.vertical:before {\n  content: \"\\f338\";\n}\ni.icon.sign-in:before {\n  content: \"\\f2f6\";\n}\ni.icon.sign-out:before {\n  content: \"\\f2f5\";\n}\ni.icon.spoon:before {\n  content: \"\\f2e5\";\n}\ni.icon.star.half.empty:before {\n  content: \"\\f089\";\n}\ni.icon.star.half.full:before {\n  content: \"\\f089\";\n}\ni.icon.ticket:before {\n  content: \"\\f3ff\";\n}\ni.icon.times.rectangle:before {\n  content: \"\\f410\";\n}\ni.icon.write:before {\n  content: \"\\f303\";\n}\ni.icon.youtube.play:before {\n  content: \"\\f167\";\n}\n/*******************************\n        Outline Icons\n*******************************/\n/* Outline Icon */\n/* Load & Define Icon Font */\n@font-face {\n  font-family: 'outline-icons';\n  src: url(\"./themes/default/assets/fonts/outline-icons.eot\");\n  src: url(\"./themes/default/assets/fonts/outline-icons.eot?#iefix\") format('embedded-opentype'), url(\"./themes/default/assets/fonts/outline-icons.woff2\") format('woff2'), url(\"./themes/default/assets/fonts/outline-icons.woff\") format('woff'), url(\"./themes/default/assets/fonts/outline-icons.ttf\") format('truetype'), url(\"./themes/default/assets/fonts/outline-icons.svg#icons\") format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\ni.icon.outline {\n  font-family: 'outline-icons';\n}\n/* Icon Definitions */\ni.icon.address.book.outline:before {\n  content: \"\\f2b9\";\n}\ni.icon.address.card.outline:before {\n  content: \"\\f2bb\";\n}\ni.icon.arrow.alternate.circle.down.outline:before {\n  content: \"\\f358\";\n}\ni.icon.arrow.alternate.circle.left.outline:before {\n  content: \"\\f359\";\n}\ni.icon.arrow.alternate.circle.right.outline:before {\n  content: \"\\f35a\";\n}\ni.icon.arrow.alternate.circle.up.outline:before {\n  content: \"\\f35b\";\n}\ni.icon.bell.outline:before {\n  content: \"\\f0f3\";\n}\ni.icon.bell.slash.outline:before {\n  content: \"\\f1f6\";\n}\ni.icon.bookmark.outline:before {\n  content: \"\\f02e\";\n}\ni.icon.building.outline:before {\n  content: \"\\f1ad\";\n}\ni.icon.calendar.outline:before {\n  content: \"\\f133\";\n}\ni.icon.calendar.alternate.outline:before {\n  content: \"\\f073\";\n}\ni.icon.calendar.check.outline:before {\n  content: \"\\f274\";\n}\ni.icon.calendar.minus.outline:before {\n  content: \"\\f272\";\n}\ni.icon.calendar.plus.outline:before {\n  content: \"\\f271\";\n}\ni.icon.calendar.times.outline:before {\n  content: \"\\f273\";\n}\ni.icon.caret.square.down.outline:before {\n  content: \"\\f150\";\n}\ni.icon.caret.square.left.outline:before {\n  content: \"\\f191\";\n}\ni.icon.caret.square.right.outline:before {\n  content: \"\\f152\";\n}\ni.icon.caret.square.up.outline:before {\n  content: \"\\f151\";\n}\ni.icon.chart.bar.outline:before {\n  content: \"\\f080\";\n}\ni.icon.check.circle.outline:before {\n  content: \"\\f058\";\n}\ni.icon.check.square.outline:before {\n  content: \"\\f14a\";\n}\ni.icon.circle.outline:before {\n  content: \"\\f111\";\n}\ni.icon.clipboard.outline:before {\n  content: \"\\f328\";\n}\ni.icon.clock.outline:before {\n  content: \"\\f017\";\n}\ni.icon.clone.outline:before {\n  content: \"\\f24d\";\n}\ni.icon.closed.captioning.outline:before {\n  content: \"\\f20a\";\n}\ni.icon.comment.outline:before {\n  content: \"\\f075\";\n}\ni.icon.comment.alternate.outline:before {\n  content: \"\\f27a\";\n}\ni.icon.comments.outline:before {\n  content: \"\\f086\";\n}\ni.icon.compass.outline:before {\n  content: \"\\f14e\";\n}\ni.icon.copy.outline:before {\n  content: \"\\f0c5\";\n}\ni.icon.copyright.outline:before {\n  content: \"\\f1f9\";\n}\ni.icon.credit.card.outline:before {\n  content: \"\\f09d\";\n}\ni.icon.dot.circle.outline:before {\n  content: \"\\f192\";\n}\ni.icon.edit.outline:before {\n  content: \"\\f044\";\n}\ni.icon.envelope.outline:before {\n  content: \"\\f0e0\";\n}\ni.icon.envelope.open.outline:before {\n  content: \"\\f2b6\";\n}\ni.icon.eye.slash.outline:before {\n  content: \"\\f070\";\n}\ni.icon.file.outline:before {\n  content: \"\\f15b\";\n}\ni.icon.file.alternate.outline:before {\n  content: \"\\f15c\";\n}\ni.icon.file.archive.outline:before {\n  content: \"\\f1c6\";\n}\ni.icon.file.audio.outline:before {\n  content: \"\\f1c7\";\n}\ni.icon.file.code.outline:before {\n  content: \"\\f1c9\";\n}\ni.icon.file.excel.outline:before {\n  content: \"\\f1c3\";\n}\ni.icon.file.image.outline:before {\n  content: \"\\f1c5\";\n}\ni.icon.file.pdf.outline:before {\n  content: \"\\f1c1\";\n}\ni.icon.file.powerpoint.outline:before {\n  content: \"\\f1c4\";\n}\ni.icon.file.video.outline:before {\n  content: \"\\f1c8\";\n}\ni.icon.file.word.outline:before {\n  content: \"\\f1c2\";\n}\ni.icon.flag.outline:before {\n  content: \"\\f024\";\n}\ni.icon.folder.outline:before {\n  content: \"\\f07b\";\n}\ni.icon.folder.open.outline:before {\n  content: \"\\f07c\";\n}\ni.icon.frown.outline:before {\n  content: \"\\f119\";\n}\ni.icon.futbol.outline:before {\n  content: \"\\f1e3\";\n}\ni.icon.gem.outline:before {\n  content: \"\\f3a5\";\n}\ni.icon.hand.lizard.outline:before {\n  content: \"\\f258\";\n}\ni.icon.hand.paper.outline:before {\n  content: \"\\f256\";\n}\ni.icon.hand.peace.outline:before {\n  content: \"\\f25b\";\n}\ni.icon.hand.point.down.outline:before {\n  content: \"\\f0a7\";\n}\ni.icon.hand.point.left.outline:before {\n  content: \"\\f0a5\";\n}\ni.icon.hand.point.right.outline:before {\n  content: \"\\f0a4\";\n}\ni.icon.hand.point.up.outline:before {\n  content: \"\\f0a6\";\n}\ni.icon.hand.pointer.outline:before {\n  content: \"\\f25a\";\n}\ni.icon.hand.rock.outline:before {\n  content: \"\\f255\";\n}\ni.icon.hand.scissors.outline:before {\n  content: \"\\f257\";\n}\ni.icon.hand.spock.outline:before {\n  content: \"\\f259\";\n}\ni.icon.handshake.outline:before {\n  content: \"\\f2b5\";\n}\ni.icon.hdd.outline:before {\n  content: \"\\f0a0\";\n}\ni.icon.heart.outline:before {\n  content: \"\\f004\";\n}\ni.icon.hospital.outline:before {\n  content: \"\\f0f8\";\n}\ni.icon.hourglass.outline:before {\n  content: \"\\f254\";\n}\ni.icon.id.badge.outline:before {\n  content: \"\\f2c1\";\n}\ni.icon.id.card.outline:before {\n  content: \"\\f2c2\";\n}\ni.icon.image.outline:before {\n  content: \"\\f03e\";\n}\ni.icon.images.outline:before {\n  content: \"\\f302\";\n}\ni.icon.keyboard.outline:before {\n  content: \"\\f11c\";\n}\ni.icon.lemon.outline:before {\n  content: \"\\f094\";\n}\ni.icon.life.ring.outline:before {\n  content: \"\\f1cd\";\n}\ni.icon.lightbulb.outline:before {\n  content: \"\\f0eb\";\n}\ni.icon.list.alternate.outline:before {\n  content: \"\\f022\";\n}\ni.icon.map.outline:before {\n  content: \"\\f279\";\n}\ni.icon.meh.outline:before {\n  content: \"\\f11a\";\n}\ni.icon.minus.square.outline:before {\n  content: \"\\f146\";\n}\ni.icon.money.bill.alternate.outline:before {\n  content: \"\\f3d1\";\n}\ni.icon.moon.outline:before {\n  content: \"\\f186\";\n}\ni.icon.newspaper.outline:before {\n  content: \"\\f1ea\";\n}\ni.icon.object.group.outline:before {\n  content: \"\\f247\";\n}\ni.icon.object.ungroup.outline:before {\n  content: \"\\f248\";\n}\ni.icon.paper.plane.outline:before {\n  content: \"\\f1d8\";\n}\ni.icon.pause.circle.outline:before {\n  content: \"\\f28b\";\n}\ni.icon.play.circle.outline:before {\n  content: \"\\f144\";\n}\ni.icon.plus.square.outline:before {\n  content: \"\\f0fe\";\n}\ni.icon.question.circle.outline:before {\n  content: \"\\f059\";\n}\ni.icon.registered.outline:before {\n  content: \"\\f25d\";\n}\ni.icon.save.outline:before {\n  content: \"\\f0c7\";\n}\ni.icon.share.square.outline:before {\n  content: \"\\f14d\";\n}\ni.icon.smile.outline:before {\n  content: \"\\f118\";\n}\ni.icon.snowflake.outline:before {\n  content: \"\\f2dc\";\n}\ni.icon.square.outline:before {\n  content: \"\\f0c8\";\n}\ni.icon.star.outline:before {\n  content: \"\\f005\";\n}\ni.icon.star.half.outline:before {\n  content: \"\\f089\";\n}\ni.icon.sticky.note.outline:before {\n  content: \"\\f249\";\n}\ni.icon.stop.circle.outline:before {\n  content: \"\\f28d\";\n}\ni.icon.sun.outline:before {\n  content: \"\\f185\";\n}\ni.icon.thumbs.down.outline:before {\n  content: \"\\f165\";\n}\ni.icon.thumbs.up.outline:before {\n  content: \"\\f164\";\n}\ni.icon.times.circle.outline:before {\n  content: \"\\f057\";\n}\ni.icon.trash.alternate.outline:before {\n  content: \"\\f2ed\";\n}\ni.icon.user.outline:before {\n  content: \"\\f007\";\n}\ni.icon.user.circle.outline:before {\n  content: \"\\f2bd\";\n}\ni.icon.window.close.outline:before {\n  content: \"\\f410\";\n}\ni.icon.window.maximize.outline:before {\n  content: \"\\f2d0\";\n}\ni.icon.window.minimize.outline:before {\n  content: \"\\f2d1\";\n}\ni.icon.window.restore.outline:before {\n  content: \"\\f2d2\";\n}\n/* Outline Aliases */\ni.icon.disk.outline:before {\n  content: \"\\f0a0\";\n}\ni.icon.heart.empty,\ni.icon.star.empty {\n  font-family: 'outline-icons';\n}\ni.icon.heart.empty:before {\n  content: \"\\f004\";\n}\ni.icon.star.empty:before {\n  content: \"\\f089\";\n}\n/*******************************\n           Brand Icons\n*******************************/\n/* Load & Define Brand Font */\n@font-face {\n  font-family: 'brand-icons';\n  src: url(\"./themes/default/assets/fonts/brand-icons.eot\");\n  src: url(\"./themes/default/assets/fonts/brand-icons.eot?#iefix\") format('embedded-opentype'), url(\"./themes/default/assets/fonts/brand-icons.woff2\") format('woff2'), url(\"./themes/default/assets/fonts/brand-icons.woff\") format('woff'), url(\"./themes/default/assets/fonts/brand-icons.ttf\") format('truetype'), url(\"./themes/default/assets/fonts/brand-icons.svg#icons\") format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\n/* Brand Icon Font Family */\ni.icon.\\35 00px,\ni.icon.accessible.icon,\ni.icon.accusoft,\ni.icon.adn,\ni.icon.adversal,\ni.icon.affiliatetheme,\ni.icon.algolia,\ni.icon.amazon,\ni.icon.amazon.pay,\ni.icon.amilia,\ni.icon.android,\ni.icon.angellist,\ni.icon.angrycreative,\ni.icon.angular,\ni.icon.app.store,\ni.icon.app.store.ios,\ni.icon.apper,\ni.icon.apple,\ni.icon.apple.pay,\ni.icon.asymmetrik,\ni.icon.audible,\ni.icon.autoprefixer,\ni.icon.avianex,\ni.icon.aviato,\ni.icon.aws,\ni.icon.bandcamp,\ni.icon.behance,\ni.icon.behance.square,\ni.icon.bimobject,\ni.icon.bitbucket,\ni.icon.bitcoin,\ni.icon.bity,\ni.icon.black.tie,\ni.icon.blackberry,\ni.icon.blogger,\ni.icon.blogger.b,\ni.icon.bluetooth,\ni.icon.bluetooth.b,\ni.icon.btc,\ni.icon.buromobelexperte,\ni.icon.buysellads,\ni.icon.cc.amazon.pay,\ni.icon.cc.amex,\ni.icon.cc.apple.pay,\ni.icon.cc.diners.club,\ni.icon.cc.discover,\ni.icon.cc.jcb,\ni.icon.cc.mastercard,\ni.icon.cc.paypal,\ni.icon.cc.stripe,\ni.icon.cc.visa,\ni.icon.centercode,\ni.icon.chrome,\ni.icon.cloudscale,\ni.icon.cloudsmith,\ni.icon.cloudversify,\ni.icon.codepen,\ni.icon.codiepie,\ni.icon.connectdevelop,\ni.icon.contao,\ni.icon.cpanel,\ni.icon.creative.commons,\ni.icon.css3,\ni.icon.css3.alternate,\ni.icon.cuttlefish,\ni.icon.d.and.d,\ni.icon.dashcube,\ni.icon.delicious,\ni.icon.deploydog,\ni.icon.deskpro,\ni.icon.deviantart,\ni.icon.digg,\ni.icon.digital.ocean,\ni.icon.discord,\ni.icon.discourse,\ni.icon.dochub,\ni.icon.docker,\ni.icon.draft2digital,\ni.icon.dribbble,\ni.icon.dribbble.square,\ni.icon.dropbox,\ni.icon.drupal,\ni.icon.dyalog,\ni.icon.earlybirds,\ni.icon.edge,\ni.icon.elementor,\ni.icon.ember,\ni.icon.empire,\ni.icon.envira,\ni.icon.erlang,\ni.icon.ethereum,\ni.icon.etsy,\ni.icon.expeditedssl,\ni.icon.facebook,\ni.icon.facebook.f,\ni.icon.facebook.messenger,\ni.icon.facebook.square,\ni.icon.firefox,\ni.icon.first.order,\ni.icon.firstdraft,\ni.icon.flickr,\ni.icon.flipboard,\ni.icon.fly,\ni.icon.font.awesome,\ni.icon.font.awesome.alternate,\ni.icon.font.awesome.flag,\ni.icon.fonticons,\ni.icon.fonticons.fi,\ni.icon.fort.awesome,\ni.icon.fort.awesome.alternate,\ni.icon.forumbee,\ni.icon.foursquare,\ni.icon.free.code.camp,\ni.icon.freebsd,\ni.icon.get.pocket,\ni.icon.gg,\ni.icon.gg.circle,\ni.icon.git,\ni.icon.git.square,\ni.icon.github,\ni.icon.github.alternate,\ni.icon.github.square,\ni.icon.gitkraken,\ni.icon.gitlab,\ni.icon.gitter,\ni.icon.glide,\ni.icon.glide.g,\ni.icon.gofore,\ni.icon.goodreads,\ni.icon.goodreads.g,\ni.icon.google,\ni.icon.google.drive,\ni.icon.google.play,\ni.icon.google.plus,\ni.icon.google.plus.g,\ni.icon.google.plus.square,\ni.icon.google.wallet,\ni.icon.gratipay,\ni.icon.grav,\ni.icon.gripfire,\ni.icon.grunt,\ni.icon.gulp,\ni.icon.hacker.news,\ni.icon.hacker.news.square,\ni.icon.hips,\ni.icon.hire.a.helper,\ni.icon.hooli,\ni.icon.hotjar,\ni.icon.houzz,\ni.icon.html5,\ni.icon.hubspot,\ni.icon.imdb,\ni.icon.instagram,\ni.icon.internet.explorer,\ni.icon.ioxhost,\ni.icon.itunes,\ni.icon.itunes.note,\ni.icon.jenkins,\ni.icon.joget,\ni.icon.joomla,\ni.icon.js,\ni.icon.js.square,\ni.icon.jsfiddle,\ni.icon.keycdn,\ni.icon.kickstarter,\ni.icon.kickstarter.k,\ni.icon.korvue,\ni.icon.laravel,\ni.icon.lastfm,\ni.icon.lastfm.square,\ni.icon.leanpub,\ni.icon.less,\ni.icon.linechat,\ni.icon.linkedin,\ni.icon.linkedin.alternate,\ni.icon.linkedin.in,\ni.icon.linode,\ni.icon.linux,\ni.icon.lyft,\ni.icon.magento,\ni.icon.maxcdn,\ni.icon.medapps,\ni.icon.medium,\ni.icon.medium.m,\ni.icon.medrt,\ni.icon.meetup,\ni.icon.microsoft,\ni.icon.mix,\ni.icon.mixcloud,\ni.icon.mizuni,\ni.icon.modx,\ni.icon.monero,\ni.icon.napster,\ni.icon.nintendo.switch,\ni.icon.node,\ni.icon.node.js,\ni.icon.npm,\ni.icon.ns8,\ni.icon.nutritionix,\ni.icon.odnoklassniki,\ni.icon.odnoklassniki.square,\ni.icon.opencart,\ni.icon.openid,\ni.icon.opera,\ni.icon.optin.monster,\ni.icon.osi,\ni.icon.page4,\ni.icon.pagelines,\ni.icon.palfed,\ni.icon.patreon,\ni.icon.paypal,\ni.icon.periscope,\ni.icon.phabricator,\ni.icon.phoenix.framework,\ni.icon.php,\ni.icon.pied.piper,\ni.icon.pied.piper.alternate,\ni.icon.pied.piper.pp,\ni.icon.pinterest,\ni.icon.pinterest.p,\ni.icon.pinterest.square,\ni.icon.playstation,\ni.icon.product.hunt,\ni.icon.pushed,\ni.icon.python,\ni.icon.qq,\ni.icon.quinscape,\ni.icon.quora,\ni.icon.ravelry,\ni.icon.react,\ni.icon.rebel,\ni.icon.redriver,\ni.icon.reddit,\ni.icon.reddit.alien,\ni.icon.reddit.square,\ni.icon.rendact,\ni.icon.renren,\ni.icon.replyd,\ni.icon.resolving,\ni.icon.rocketchat,\ni.icon.rockrms,\ni.icon.safari,\ni.icon.sass,\ni.icon.schlix,\ni.icon.scribd,\ni.icon.searchengin,\ni.icon.sellcast,\ni.icon.sellsy,\ni.icon.servicestack,\ni.icon.shirtsinbulk,\ni.icon.simplybuilt,\ni.icon.sistrix,\ni.icon.skyatlas,\ni.icon.skype,\ni.icon.slack,\ni.icon.slack.hash,\ni.icon.slideshare,\ni.icon.snapchat,\ni.icon.snapchat.ghost,\ni.icon.snapchat.square,\ni.icon.soundcloud,\ni.icon.speakap,\ni.icon.spotify,\ni.icon.stack.exchange,\ni.icon.stack.overflow,\ni.icon.staylinked,\ni.icon.steam,\ni.icon.steam.square,\ni.icon.steam.symbol,\ni.icon.sticker.mule,\ni.icon.strava,\ni.icon.stripe,\ni.icon.stripe.s,\ni.icon.studiovinari,\ni.icon.stumbleupon,\ni.icon.stumbleupon.circle,\ni.icon.superpowers,\ni.icon.supple,\ni.icon.telegram,\ni.icon.telegram.plane,\ni.icon.tencent.weibo,\ni.icon.themeisle,\ni.icon.trello,\ni.icon.tripadvisor,\ni.icon.tumblr,\ni.icon.tumblr.square,\ni.icon.twitch,\ni.icon.twitter,\ni.icon.twitter.square,\ni.icon.typo3,\ni.icon.uber,\ni.icon.uikit,\ni.icon.uniregistry,\ni.icon.untappd,\ni.icon.usb,\ni.icon.ussunnah,\ni.icon.vaadin,\ni.icon.viacoin,\ni.icon.viadeo,\ni.icon.viadeo.square,\ni.icon.viber,\ni.icon.vimeo,\ni.icon.vimeo.square,\ni.icon.vimeo.v,\ni.icon.vine,\ni.icon.vk,\ni.icon.vnv,\ni.icon.vuejs,\ni.icon.wechat,\ni.icon.weibo,\ni.icon.weixin,\ni.icon.whatsapp,\ni.icon.whatsapp.square,\ni.icon.whmcs,\ni.icon.wikipedia.w,\ni.icon.windows,\ni.icon.wordpress,\ni.icon.wordpress.simple,\ni.icon.wpbeginner,\ni.icon.wpexplorer,\ni.icon.wpforms,\ni.icon.xbox,\ni.icon.xing,\ni.icon.xing.square,\ni.icon.y.combinator,\ni.icon.yahoo,\ni.icon.yandex,\ni.icon.yandex.international,\ni.icon.yelp,\ni.icon.yoast,\ni.icon.youtube,\ni.icon.youtube.square {\n  font-family: 'brand-icons';\n}\n/* Brand Icons Ideally Would Be Defined Here */\n/*!\n * # Semantic UI - Image\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Image\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Types\n--------------------*/\n/* Avatar */\n/*-------------------\n       Variations\n--------------------*/\n/* Spaced */\n/* Floated */\n/* Size */\n/* Packaged Theme */\n/*******************************\n            Image\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Types\n--------------------*/\n/* Avatar */\n/*-------------------\n       Variations\n--------------------*/\n/* Spaced */\n/* Floated */\n/* Size */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Image\n*******************************/\n.ui.image {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 100%;\n  background-color: transparent;\n}\nimg.ui.image {\n  display: block;\n}\n.ui.image svg,\n.ui.image img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n/*******************************\n            States\n*******************************/\n.ui.hidden.images,\n.ui.hidden.image {\n  display: none;\n}\n.ui.hidden.transition.images,\n.ui.hidden.transition.image {\n  display: block;\n  visibility: hidden;\n}\n.ui.images > .hidden.transition {\n  display: inline-block;\n  visibility: hidden;\n}\n.ui.disabled.images,\n.ui.disabled.image {\n  cursor: default;\n  opacity: 0.45;\n}\n/*******************************\n          Variations\n*******************************/\n/*--------------\n     Inline\n---------------*/\n.ui.inline.image,\n.ui.inline.image svg,\n.ui.inline.image img {\n  display: inline-block;\n}\n/*------------------\n  Vertical Aligned\n-------------------*/\n.ui.top.aligned.images .image,\n.ui.top.aligned.image,\n.ui.top.aligned.image svg,\n.ui.top.aligned.image img {\n  display: inline-block;\n  vertical-align: top;\n}\n.ui.middle.aligned.images .image,\n.ui.middle.aligned.image,\n.ui.middle.aligned.image svg,\n.ui.middle.aligned.image img {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ui.bottom.aligned.images .image,\n.ui.bottom.aligned.image,\n.ui.bottom.aligned.image svg,\n.ui.bottom.aligned.image img {\n  display: inline-block;\n  vertical-align: bottom;\n}\n/*--------------\n     Rounded\n---------------*/\n.ui.rounded.images .image,\n.ui.rounded.image,\n.ui.rounded.images .image > *,\n.ui.rounded.image > * {\n  border-radius: 0.3125em;\n}\n/*--------------\n    Bordered\n---------------*/\n.ui.bordered.images .image,\n.ui.bordered.images img,\n.ui.bordered.images svg,\n.ui.bordered.image img,\n.ui.bordered.image svg,\nimg.ui.bordered.image {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n/*--------------\n    Circular\n---------------*/\n.ui.circular.images,\n.ui.circular.image {\n  overflow: hidden;\n}\n.ui.circular.images .image,\n.ui.circular.image,\n.ui.circular.images .image > *,\n.ui.circular.image > * {\n  -webkit-border-radius: 500rem;\n  -moz-border-radius: 500rem;\n  border-radius: 500rem;\n}\n/*--------------\n     Fluid\n---------------*/\n.ui.fluid.images,\n.ui.fluid.image,\n.ui.fluid.images img,\n.ui.fluid.images svg,\n.ui.fluid.image svg,\n.ui.fluid.image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n/*--------------\n     Avatar\n---------------*/\n.ui.avatar.images .image,\n.ui.avatar.images img,\n.ui.avatar.images svg,\n.ui.avatar.image img,\n.ui.avatar.image svg,\n.ui.avatar.image {\n  margin-right: 0.25em;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  -webkit-border-radius: 500rem;\n  -moz-border-radius: 500rem;\n  border-radius: 500rem;\n}\n/*-------------------\n       Spaced\n--------------------*/\n.ui.spaced.image {\n  display: inline-block !important;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n.ui[class*=\"left spaced\"].image {\n  margin-left: 0.5em;\n  margin-right: 0em;\n}\n.ui[class*=\"right spaced\"].image {\n  margin-left: 0em;\n  margin-right: 0.5em;\n}\n/*-------------------\n       Floated\n--------------------*/\n.ui.floated.image,\n.ui.floated.images {\n  float: left;\n  margin-right: 1em;\n  margin-bottom: 1em;\n}\n.ui.right.floated.images,\n.ui.right.floated.image {\n  float: right;\n  margin-right: 0em;\n  margin-bottom: 1em;\n  margin-left: 1em;\n}\n.ui.floated.images:last-child,\n.ui.floated.image:last-child {\n  margin-bottom: 0em;\n}\n.ui.centered.images,\n.ui.centered.image {\n  margin-left: auto;\n  margin-right: auto;\n}\n/*--------------\n     Sizes\n---------------*/\n.ui.mini.images .image,\n.ui.mini.images img,\n.ui.mini.images svg,\n.ui.mini.image {\n  width: 35px;\n  height: auto;\n  font-size: 0.78571429rem;\n}\n.ui.tiny.images .image,\n.ui.tiny.images img,\n.ui.tiny.images svg,\n.ui.tiny.image {\n  width: 80px;\n  height: auto;\n  font-size: 0.85714286rem;\n}\n.ui.small.images .image,\n.ui.small.images img,\n.ui.small.images svg,\n.ui.small.image {\n  width: 150px;\n  height: auto;\n  font-size: 0.92857143rem;\n}\n.ui.medium.images .image,\n.ui.medium.images img,\n.ui.medium.images svg,\n.ui.medium.image {\n  width: 300px;\n  height: auto;\n  font-size: 1rem;\n}\n.ui.large.images .image,\n.ui.large.images img,\n.ui.large.images svg,\n.ui.large.image {\n  width: 450px;\n  height: auto;\n  font-size: 1.14285714rem;\n}\n.ui.big.images .image,\n.ui.big.images img,\n.ui.big.images svg,\n.ui.big.image {\n  width: 600px;\n  height: auto;\n  font-size: 1.28571429rem;\n}\n.ui.huge.images .image,\n.ui.huge.images img,\n.ui.huge.images svg,\n.ui.huge.image {\n  width: 800px;\n  height: auto;\n  font-size: 1.42857143rem;\n}\n.ui.massive.images .image,\n.ui.massive.images img,\n.ui.massive.images svg,\n.ui.massive.image {\n  width: 960px;\n  height: auto;\n  font-size: 1.71428571rem;\n}\n/*******************************\n              Groups\n*******************************/\n.ui.images {\n  font-size: 0em;\n  margin: 0em -0.25rem 0rem;\n}\n.ui.images .image,\n.ui.images > img,\n.ui.images > svg {\n  display: inline-block;\n  margin: 0em 0.25rem 0.5rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Input\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Input\n*******************************/\n/*-------------------\n      Element\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Icon Input */\n/* Circular Icon Input */\n/* Labeled Input */\n/*-------------------\n        States\n--------------------*/\n/* Placeholder */\n/* Down */\n/* Focus */\n/* Error */\n/* Loader */\n/*-------------------\n      Variations\n--------------------*/\n/* Inverted */\n/* Packaged Theme */\n/*******************************\n            Input\n*******************************/\n/*-------------------\n      Element\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Icon Input */\n/* Circular Icon Input */\n/* Labeled Input */\n/*-------------------\n        States\n--------------------*/\n/* Placeholder */\n/* Down */\n/* Focus */\n/* Error */\n/* Loader */\n/*-------------------\n      Variations\n--------------------*/\n/* Inverted */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           Standard\n*******************************/\n/*--------------------\n        Inputs\n---------------------*/\n.ui.input {\n  position: relative;\n  font-weight: normal;\n  font-style: normal;\n  display: inline-flex;\n  color: #ffffff;\n}\n.ui.input > input {\n  margin: 0em;\n  max-width: 100%;\n  flex: 1 0 auto;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.21428571em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  padding: 0.67857143em 1em;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n  border-radius: 0.28571429rem;\n  transition: box-shadow 0.1s ease, border-color 0.1s ease;\n  box-shadow: none;\n}\n/*--------------------\n      Placeholder\n---------------------*/\n/* browsers require these rules separate */\n.ui.input > input::-webkit-input-placeholder {\n  color: #404040;\n}\n.ui.input > input::-moz-placeholder {\n  color: #404040;\n}\n.ui.input > input:-ms-input-placeholder {\n  color: #404040;\n}\n/*******************************\n            States\n*******************************/\n/*--------------------\n        Disabled\n---------------------*/\n.ui.disabled.input,\n.ui.input:not(.disabled) input[disabled] {\n  opacity: 0.45;\n}\n.ui.disabled.input > input,\n.ui.input:not(.disabled) input[disabled] {\n  pointer-events: none;\n}\n/*--------------------\n        Active\n---------------------*/\n.ui.input > input:active,\n.ui.input.down input {\n  border-color: rgba(0, 0, 0, 0.3);\n  background: #FAFAFA;\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: none;\n}\n/*--------------------\n       Loading\n---------------------*/\n.ui.loading.loading.input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n.ui.loading.loading.input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  animation: button-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n/*--------------------\n        Focus\n---------------------*/\n.ui.input.focus > input,\n.ui.input > input:focus {\n  border-color: #85B7D9;\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.8);\n  box-shadow: none;\n}\n.ui.input.focus > input::-webkit-input-placeholder,\n.ui.input > input:focus::-webkit-input-placeholder {\n  color: #8c8c8c;\n}\n.ui.input.focus > input::-moz-placeholder,\n.ui.input > input:focus::-moz-placeholder {\n  color: #8c8c8c;\n}\n.ui.input.focus > input:-ms-input-placeholder,\n.ui.input > input:focus:-ms-input-placeholder {\n  color: #8c8c8c;\n}\n/*--------------------\n        Error\n---------------------*/\n.ui.input.error > input {\n  background-color: rgba(200, 3, 3, 0.15);\n  border-color: #E0B4B4;\n  color: #FFFFFF;\n  box-shadow: none;\n}\n/* Error Placeholder */\n.ui.input.error > input::-webkit-input-placeholder {\n  color: #ffffff;\n}\n.ui.input.error > input::-moz-placeholder {\n  color: #ffffff;\n}\n.ui.input.error > input:-ms-input-placeholder {\n  color: #ffffff !important;\n}\n/* Focused Error Placeholder */\n.ui.input.error > input:focus::-webkit-input-placeholder {\n  color: #ffffff;\n}\n.ui.input.error > input:focus::-moz-placeholder {\n  color: #ffffff;\n}\n.ui.input.error > input:focus:-ms-input-placeholder {\n  color: #ffffff !important;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------------\n      Transparent\n---------------------*/\n.ui.transparent.input > input {\n  border-color: transparent !important;\n  background-color: transparent !important;\n  padding: 0em !important;\n  box-shadow: none !important;\n  border-radius: 0px !important;\n}\n/* Transparent Icon */\n.ui.transparent.icon.input > i.icon {\n  width: 1.1em;\n}\n.ui.transparent.icon.input > input {\n  padding-left: 0em !important;\n  padding-right: 2em !important;\n}\n.ui.transparent[class*=\"left icon\"].input > input {\n  padding-left: 2em !important;\n  padding-right: 0em !important;\n}\n/* Transparent Inverted */\n.ui.transparent.inverted.input {\n  color: #FFFFFF;\n}\n.ui.transparent.inverted.input > input {\n  color: inherit;\n}\n.ui.transparent.inverted.input > input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n.ui.transparent.inverted.input > input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n.ui.transparent.inverted.input > input:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n/*--------------------\n         Icon\n---------------------*/\n.ui.icon.input > i.icon {\n  cursor: default;\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  top: 0px;\n  right: 0px;\n  margin: 0em;\n  height: 100%;\n  width: 2.67142857em;\n  opacity: 0.5;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n  transition: opacity 0.3s ease;\n}\n.ui.icon.input > i.icon:not(.link) {\n  pointer-events: none;\n}\n.ui.icon.input > input {\n  padding-right: 2.67142857em !important;\n}\n.ui.icon.input > i.icon:before,\n.ui.icon.input > i.icon:after {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 100%;\n  margin-top: -0.5em;\n}\n.ui.icon.input > i.link.icon {\n  cursor: pointer;\n}\n.ui.icon.input > i.circular.icon {\n  top: 0.35em;\n  right: 0.5em;\n}\n/* Left Icon Input */\n.ui[class*=\"left icon\"].input > i.icon {\n  right: auto;\n  left: 1px;\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n.ui[class*=\"left icon\"].input > i.circular.icon {\n  right: auto;\n  left: 0.5em;\n}\n.ui[class*=\"left icon\"].input > input {\n  padding-left: 2.67142857em !important;\n  padding-right: 1em !important;\n}\n/* Focus */\n.ui.icon.input > input:focus ~ i.icon {\n  opacity: 1;\n}\n/*--------------------\n        Labeled\n---------------------*/\n/* Adjacent Label */\n.ui.labeled.input > .label {\n  flex: 0 0 auto;\n  margin: 0;\n  font-size: 1em;\n}\n.ui.labeled.input > .label:not(.corner) {\n  padding-top: 0.78571429em;\n  padding-bottom: 0.78571429em;\n}\n/* Regular Label on Left */\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-left-color: transparent;\n}\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input:focus {\n  border-left-color: #85B7D9;\n}\n/* Regular Label on Right */\n.ui[class*=\"right labeled\"].input > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n.ui[class*=\"right labeled\"].input > input + .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n.ui[class*=\"right labeled\"].input > input:focus {\n  border-right-color: #85B7D9 !important;\n}\n/* Corner Label */\n.ui.labeled.input .corner.label {\n  top: 1px;\n  right: 1px;\n  font-size: 0.64285714em;\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n/* Spacing with corner label */\n.ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input > input {\n  padding-right: 2.5em !important;\n}\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > input {\n  padding-right: 3.25em !important;\n}\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > .icon {\n  margin-right: 1.25em;\n}\n/* Left Labeled */\n.ui[class*=\"left corner labeled\"].labeled.input > input {\n  padding-left: 2.5em !important;\n}\n.ui[class*=\"left corner labeled\"].icon.input > input {\n  padding-left: 3.25em !important;\n}\n.ui[class*=\"left corner labeled\"].icon.input > .icon {\n  margin-left: 1.25em;\n}\n/* Corner Label Position  */\n.ui.input > .ui.corner.label {\n  top: 1px;\n  right: 1px;\n}\n.ui.input > .ui.left.corner.label {\n  right: auto;\n  left: 1px;\n}\n/*--------------------\n        Action\n---------------------*/\n.ui.action.input > .button,\n.ui.action.input > .buttons {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n.ui.action.input > .button,\n.ui.action.input > .buttons > .button {\n  padding-top: 0.78571429em;\n  padding-bottom: 0.78571429em;\n  margin: 0;\n}\n/* Button on Right */\n.ui.action.input:not([class*=\"left action\"]) > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:not(:first-child),\n.ui.action.input:not([class*=\"left action\"]) > .button:not(:first-child),\n.ui.action.input:not([class*=\"left action\"]) > .buttons:not(:first-child) > .button {\n  border-radius: 0px;\n}\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:last-child,\n.ui.action.input:not([class*=\"left action\"]) > .button:last-child,\n.ui.action.input:not([class*=\"left action\"]) > .buttons:last-child > .button {\n  border-radius: 0px 0.28571429rem 0.28571429rem 0px;\n}\n/* Input Focus */\n.ui.action.input:not([class*=\"left action\"]) > input:focus {\n  border-right-color: #85B7D9 !important;\n}\n/* Button on Left */\n.ui[class*=\"left action\"].input > input {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  border-left-color: transparent !important;\n}\n.ui[class*=\"left action\"].input > .dropdown,\n.ui[class*=\"left action\"].input > .button,\n.ui[class*=\"left action\"].input > .buttons > .button {\n  border-radius: 0px;\n}\n.ui[class*=\"left action\"].input > .dropdown:first-child,\n.ui[class*=\"left action\"].input > .button:first-child,\n.ui[class*=\"left action\"].input > .buttons:first-child > .button {\n  border-radius: 0.28571429rem 0px 0px 0.28571429rem;\n}\n/* Input Focus */\n.ui[class*=\"left action\"].input > input:focus {\n  border-left-color: #85B7D9 !important;\n}\n/*--------------------\n       Inverted\n---------------------*/\n/* Standard */\n.ui.inverted.input > input {\n  border: none;\n}\n/*--------------------\n        Fluid\n---------------------*/\n.ui.fluid.input {\n  display: flex;\n}\n.ui.fluid.input > input {\n  width: 0px !important;\n}\n/*--------------------\n        Size\n---------------------*/\n.ui.mini.input {\n  font-size: 0.78571429em;\n}\n.ui.small.input {\n  font-size: 0.92857143em;\n}\n.ui.input {\n  font-size: 1em;\n}\n.ui.large.input {\n  font-size: 1.14285714em;\n}\n.ui.big.input {\n  font-size: 1.28571429em;\n}\n.ui.huge.input {\n  font-size: 1.42857143em;\n}\n.ui.massive.input {\n  font-size: 1.71428571em;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Label\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Label\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* medium is not @emSize custom value required */\n/* Group */\n/*-------------------\n        Parts\n--------------------*/\n/* Link */\n/* Icon */\n/* Image */\n/* Detail */\n/* Delete */\n/*-------------------\n        Types\n--------------------*/\n/* Image Label */\n/*-------------------\n        States\n--------------------*/\n/* Hover */\n/* Active */\n/* Active Hover */\n/*-------------------\n      Variations\n--------------------*/\n/* Basic */\n/* Tag */\n/* Avoids error with background: inherit; on animation */\n/* Ribbon */\n/* Rounding Offset on Triangle */\n/* Rounding Offset on Triangle */\n/* Colors */\n/* Attached */\n/* Corner */\n/* Corner Text */\n/* Horizontal */\n/* Circular Padding */\n/* Pointing */\n/* Basic Pointing */\n/* Floating */\n/*-------------------\n        Group\n--------------------*/\n/* Sizing */\n/* Packaged Theme */\n/*******************************\n             Label\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* medium is not @emSize custom value required */\n/* Group */\n/*-------------------\n        Parts\n--------------------*/\n/* Link */\n/* Icon */\n/* Image */\n/* Detail */\n/* Delete */\n/*-------------------\n        Types\n--------------------*/\n/* Image Label */\n/*-------------------\n        States\n--------------------*/\n/* Hover */\n/* Active */\n/* Active Hover */\n/*-------------------\n      Variations\n--------------------*/\n/* Basic */\n/* Tag */\n/* Avoids error with background: inherit; on animation */\n/* Ribbon */\n/* Rounding Offset on Triangle */\n/* Rounding Offset on Triangle */\n/* Colors */\n/* Attached */\n/* Corner */\n/* Corner Text */\n/* Horizontal */\n/* Circular Padding */\n/* Pointing */\n/* Basic Pointing */\n/* Floating */\n/*-------------------\n        Group\n--------------------*/\n/* Sizing */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Label\n*******************************/\n.ui.label {\n  display: inline-block;\n  line-height: 1;\n  vertical-align: baseline;\n  margin: 0em 0.14285714em;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: none;\n  padding: 0.5833em 0.833em;\n  color: rgba(255, 255, 255, 0.3);\n  text-transform: none;\n  font-weight: bold;\n  border: 0px solid transparent;\n  border-radius: 0.28571429rem;\n  transition: background 0.1s ease;\n}\n.ui.label:first-child {\n  margin-left: 0em;\n}\n.ui.label:last-child {\n  margin-right: 0em;\n}\n/* Link */\na.ui.label {\n  cursor: pointer;\n}\n/* Inside Link */\n.ui.label > a {\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.5;\n  transition: 0.1s opacity ease;\n}\n.ui.label > a:hover {\n  opacity: 1;\n}\n/* Image */\n.ui.label > img {\n  width: auto !important;\n  vertical-align: middle;\n  height: 2.1666em !important;\n}\n/* Icon */\n.ui.label > .icon {\n  width: auto;\n  margin: 0em 0.75em 0em 0em;\n}\n/* Detail */\n.ui.label > .detail {\n  display: inline-block;\n  vertical-align: top;\n  font-weight: bold;\n  margin-left: 1em;\n  opacity: 0.8;\n}\n.ui.label > .detail .icon {\n  margin: 0em 0.25em 0em 0em;\n}\n/* Removable label */\n.ui.label > .close.icon,\n.ui.label > .delete.icon {\n  cursor: pointer;\n  margin-right: 0em;\n  margin-left: 0.5em;\n  font-size: 0.92857143em;\n  opacity: 0.5;\n  transition: background 0.1s ease;\n}\n.ui.label > .delete.icon:hover {\n  opacity: 1;\n}\n/*-------------------\n       Group\n--------------------*/\n.ui.labels > .label {\n  margin: 0em 0.5em 0.5em 0em;\n}\n/*-------------------\n       Coupling\n--------------------*/\n.ui.header > .ui.label {\n  margin-top: -0.29165em;\n}\n/* Remove border radius on attached segment */\n.ui.attached.segment > .ui.top.left.attached.label,\n.ui.bottom.attached.segment > .ui.top.left.attached.label {\n  border-top-left-radius: 0;\n}\n.ui.attached.segment > .ui.top.right.attached.label,\n.ui.bottom.attached.segment > .ui.top.right.attached.label {\n  border-top-right-radius: 0;\n}\n.ui.top.attached.segment > .ui.bottom.left.attached.label {\n  border-bottom-left-radius: 0;\n}\n.ui.top.attached.segment > .ui.bottom.right.attached.label {\n  border-bottom-right-radius: 0;\n}\n/* Padding on next content after a label */\n.ui.top.attached.label:first-child + :not(.attached),\n.ui.top.attached.label + [class*=\"right floated\"] + * {\n  margin-top: 2rem !important;\n}\n.ui.bottom.attached.label:first-child ~ :last-child:not(.attached) {\n  margin-top: 0em;\n  margin-bottom: 2rem !important;\n}\n/*******************************\n             Types\n*******************************/\n.ui.image.label {\n  width: auto !important;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  max-width: 9999px;\n  vertical-align: baseline;\n  text-transform: none;\n  background: rgba(0, 0, 0, 0);\n  padding: 0.5833em 0.833em 0.5833em 0.5em;\n  border-radius: 0.28571429rem;\n  box-shadow: none;\n}\n.ui.image.label img {\n  display: inline-block;\n  vertical-align: top;\n  height: 2.1666em;\n  margin: -0.5833em 0.5em -0.5833em -0.5em;\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n.ui.image.label .detail {\n  background: rgba(0, 0, 0, 0.1);\n  margin: -0.5833em -0.833em -0.5833em 0.5em;\n  padding: 0.5833em 0.833em;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n/*-------------------\n         Tag\n--------------------*/\n.ui.tag.labels .label,\n.ui.tag.label {\n  margin-left: 1em;\n  position: relative;\n  padding-left: 1.5em;\n  padding-right: 1.5em;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n  transition: none;\n}\n.ui.tag.labels .label:before,\n.ui.tag.label:before {\n  position: absolute;\n  transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  top: 50%;\n  right: 100%;\n  content: '';\n  background-color: inherit;\n  background-image: none;\n  width: 1.56em;\n  height: 1.56em;\n  transition: none;\n}\n.ui.tag.labels .label:after,\n.ui.tag.label:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: -0.25em;\n  margin-top: -0.25em;\n  background-color: #FFFFFF !important;\n  width: 0.5em;\n  height: 0.5em;\n  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 500rem;\n}\n/*-------------------\n    Corner Label\n--------------------*/\n.ui.corner.label {\n  position: absolute;\n  top: 0em;\n  right: 0em;\n  margin: 0em;\n  padding: 0em;\n  text-align: center;\n  border-color: rgba(0, 0, 0, 0);\n  width: 4em;\n  height: 4em;\n  z-index: 1;\n  transition: border-color 0.1s ease;\n}\n/* Icon Label */\n.ui.corner.label {\n  background-color: transparent !important;\n}\n.ui.corner.label:after {\n  position: absolute;\n  content: \"\";\n  right: 0em;\n  top: 0em;\n  z-index: -1;\n  width: 0em;\n  height: 0em;\n  background-color: transparent !important;\n  border-top: 0em solid transparent;\n  border-right: 4em solid transparent;\n  border-bottom: 4em solid transparent;\n  border-left: 0em solid transparent;\n  border-right-color: inherit;\n  transition: border-color 0.1s ease;\n}\n.ui.corner.label .icon {\n  cursor: default;\n  position: relative;\n  top: 0.64285714em;\n  left: 0.78571429em;\n  font-size: 1.14285714em;\n  margin: 0em;\n}\n/* Left Corner */\n.ui.left.corner.label,\n.ui.left.corner.label:after {\n  right: auto;\n  left: 0em;\n}\n.ui.left.corner.label:after {\n  border-top: 4em solid transparent;\n  border-right: 4em solid transparent;\n  border-bottom: 0em solid transparent;\n  border-left: 0em solid transparent;\n  border-top-color: inherit;\n}\n.ui.left.corner.label .icon {\n  left: -0.78571429em;\n}\n/* Segment */\n.ui.segment > .ui.corner.label {\n  top: -1px;\n  right: -1px;\n}\n.ui.segment > .ui.left.corner.label {\n  right: auto;\n  left: -1px;\n}\n/*-------------------\n       Ribbon\n--------------------*/\n.ui.ribbon.label {\n  position: relative;\n  margin: 0em;\n  min-width: max-content;\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.ui.ribbon.label:after {\n  position: absolute;\n  content: '';\n  top: 100%;\n  left: 0%;\n  background-color: transparent !important;\n  border-style: solid;\n  border-width: 0em 1.2em 1.2em 0em;\n  border-color: transparent;\n  border-right-color: inherit;\n  width: 0em;\n  height: 0em;\n}\n/* Positioning */\n.ui.ribbon.label {\n  left: calc(-1rem - 1.2em);\n  margin-right: -1.2em;\n  padding-left: calc(1rem + 1.2em);\n  padding-right: 1.2em;\n}\n.ui[class*=\"right ribbon\"].label {\n  left: calc(100% + 1rem + 1.2em);\n  padding-left: 1.2em;\n  padding-right: calc(1rem + 1.2em);\n}\n/* Right Ribbon */\n.ui[class*=\"right ribbon\"].label {\n  text-align: left;\n  transform: translateX(-100%);\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n.ui[class*=\"right ribbon\"].label:after {\n  left: auto;\n  right: 0%;\n  border-style: solid;\n  border-width: 1.2em 1.2em 0em 0em;\n  border-color: transparent;\n  border-top-color: inherit;\n}\n/* Inside Table */\n.ui.image > .ribbon.label,\n.ui.card .image > .ribbon.label {\n  position: absolute;\n  top: 1rem;\n}\n.ui.card .image > .ui.ribbon.label,\n.ui.image > .ui.ribbon.label {\n  left: calc(--0.05rem - 1.2em);\n}\n.ui.card .image > .ui[class*=\"right ribbon\"].label,\n.ui.image > .ui[class*=\"right ribbon\"].label {\n  left: calc(100% + -0.05rem + 1.2em);\n  padding-left: 0.833em;\n}\n/* Inside Table */\n.ui.table td > .ui.ribbon.label {\n  left: calc(-0.78571429em - 1.2em);\n}\n.ui.table td > .ui[class*=\"right ribbon\"].label {\n  left: calc(100% + 0.78571429em + 1.2em);\n  padding-left: 0.833em;\n}\n/*-------------------\n      Attached\n--------------------*/\n.ui[class*=\"top attached\"].label,\n.ui.attached.label {\n  width: 100%;\n  position: absolute;\n  margin: 0em;\n  top: 0em;\n  left: 0em;\n  padding: 0.75em 1em;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n.ui[class*=\"bottom attached\"].label {\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n.ui[class*=\"top left attached\"].label {\n  width: auto;\n  margin-top: 0em !important;\n  border-radius: 0.21428571rem 0em 0.28571429rem 0em;\n}\n.ui[class*=\"top right attached\"].label {\n  width: auto;\n  left: auto;\n  right: 0em;\n  border-radius: 0em 0.21428571rem 0em 0.28571429rem;\n}\n.ui[class*=\"bottom left attached\"].label {\n  width: auto;\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em 0.28571429rem 0em 0.21428571rem;\n}\n.ui[class*=\"bottom right attached\"].label {\n  top: auto;\n  bottom: 0em;\n  left: auto;\n  right: 0em;\n  width: auto;\n  border-radius: 0.28571429rem 0em 0.21428571rem 0em;\n}\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n.ui.label.disabled {\n  opacity: 0.5;\n}\n/*-------------------\n        Hover\n--------------------*/\na.ui.labels .label:hover,\na.ui.label:hover {\n  background-color: #E0E0E0;\n  border-color: #E0E0E0;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.labels a.label:hover:before,\na.ui.label:hover:before {\n  color: rgba(255, 255, 255, 0.8);\n}\n/*-------------------\n        Active\n--------------------*/\n.ui.active.label {\n  background-color: #D0D0D0;\n  border-color: #D0D0D0;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.active.label:before {\n  background-color: #D0D0D0;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*-------------------\n     Active Hover\n--------------------*/\na.ui.labels .active.label:hover,\na.ui.active.label:hover {\n  background-color: #C8C8C8;\n  border-color: #C8C8C8;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.labels a.active.label:ActiveHover:before,\na.ui.active.label:ActiveHover:before {\n  background-color: #C8C8C8;\n  background-image: none;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*-------------------\n      Visible\n--------------------*/\n.ui.labels.visible .label,\n.ui.label.visible:not(.dropdown) {\n  display: inline-block !important;\n}\n/*-------------------\n      Hidden\n--------------------*/\n.ui.labels.hidden .label,\n.ui.label.hidden {\n  display: none !important;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Colors\n--------------------*/\n/*--- Red ---*/\n.ui.red.labels .label,\n.ui.red.label {\n  background-color: #DB2828 !important;\n  border-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.red.labels .label:hover,\na.ui.red.label:hover {\n  background-color: #d01919 !important;\n  border-color: #d01919 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.red.corner.label,\n.ui.red.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.red.ribbon.label {\n  border-color: #b21e1e !important;\n}\n/* Basic */\n.ui.basic.red.label {\n  background: none #FFFFFF !important;\n  color: #DB2828 !important;\n  border-color: #DB2828 !important;\n}\n.ui.basic.red.labels a.label:hover,\na.ui.basic.red.label:hover {\n  background-color: #FFFFFF !important;\n  color: #d01919 !important;\n  border-color: #d01919 !important;\n}\n/*--- Orange ---*/\n.ui.orange.labels .label,\n.ui.orange.label {\n  background-color: #F2711C !important;\n  border-color: #F2711C !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.orange.labels .label:hover,\na.ui.orange.label:hover {\n  background-color: #f26202 !important;\n  border-color: #f26202 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.orange.corner.label,\n.ui.orange.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.orange.ribbon.label {\n  border-color: #cf590c !important;\n}\n/* Basic */\n.ui.basic.orange.label {\n  background: none #FFFFFF !important;\n  color: #F2711C !important;\n  border-color: #F2711C !important;\n}\n.ui.basic.orange.labels a.label:hover,\na.ui.basic.orange.label:hover {\n  background-color: #FFFFFF !important;\n  color: #f26202 !important;\n  border-color: #f26202 !important;\n}\n/*--- Yellow ---*/\n.ui.yellow.labels .label,\n.ui.yellow.label {\n  background-color: #FBBD08 !important;\n  border-color: #FBBD08 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.yellow.labels .label:hover,\na.ui.yellow.label:hover {\n  background-color: #eaae00 !important;\n  border-color: #eaae00 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.yellow.corner.label,\n.ui.yellow.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.yellow.ribbon.label {\n  border-color: #cd9903 !important;\n}\n/* Basic */\n.ui.basic.yellow.label {\n  background: none #FFFFFF !important;\n  color: #FBBD08 !important;\n  border-color: #FBBD08 !important;\n}\n.ui.basic.yellow.labels a.label:hover,\na.ui.basic.yellow.label:hover {\n  background-color: #FFFFFF !important;\n  color: #eaae00 !important;\n  border-color: #eaae00 !important;\n}\n/*--- Olive ---*/\n.ui.olive.labels .label,\n.ui.olive.label {\n  background-color: #B5CC18 !important;\n  border-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.olive.labels .label:hover,\na.ui.olive.label:hover {\n  background-color: #a7bd0d !important;\n  border-color: #a7bd0d !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.olive.corner.label,\n.ui.olive.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.olive.ribbon.label {\n  border-color: #198f35 !important;\n}\n/* Basic */\n.ui.basic.olive.label {\n  background: none #FFFFFF !important;\n  color: #B5CC18 !important;\n  border-color: #B5CC18 !important;\n}\n.ui.basic.olive.labels a.label:hover,\na.ui.basic.olive.label:hover {\n  background-color: #FFFFFF !important;\n  color: #a7bd0d !important;\n  border-color: #a7bd0d !important;\n}\n/*--- Green ---*/\n.ui.green.labels .label,\n.ui.green.label {\n  background-color: #21BA45 !important;\n  border-color: #21BA45 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.green.labels .label:hover,\na.ui.green.label:hover {\n  background-color: #16ab39 !important;\n  border-color: #16ab39 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.green.corner.label,\n.ui.green.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.green.ribbon.label {\n  border-color: #198f35 !important;\n}\n/* Basic */\n.ui.basic.green.label {\n  background: none #FFFFFF !important;\n  color: #21BA45 !important;\n  border-color: #21BA45 !important;\n}\n.ui.basic.green.labels a.label:hover,\na.ui.basic.green.label:hover {\n  background-color: #FFFFFF !important;\n  color: #16ab39 !important;\n  border-color: #16ab39 !important;\n}\n/*--- Teal ---*/\n.ui.teal.labels .label,\n.ui.teal.label {\n  background-color: #00B5AD !important;\n  border-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.teal.labels .label:hover,\na.ui.teal.label:hover {\n  background-color: #009c95 !important;\n  border-color: #009c95 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.teal.corner.label,\n.ui.teal.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.teal.ribbon.label {\n  border-color: #00827c !important;\n}\n/* Basic */\n.ui.basic.teal.label {\n  background: none #FFFFFF !important;\n  color: #00B5AD !important;\n  border-color: #00B5AD !important;\n}\n.ui.basic.teal.labels a.label:hover,\na.ui.basic.teal.label:hover {\n  background-color: #FFFFFF !important;\n  color: #009c95 !important;\n  border-color: #009c95 !important;\n}\n/*--- Blue ---*/\n.ui.blue.labels .label,\n.ui.blue.label {\n  background-color: #2185D0 !important;\n  border-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.blue.labels .label:hover,\na.ui.blue.label:hover {\n  background-color: #1678c2 !important;\n  border-color: #1678c2 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.blue.corner.label,\n.ui.blue.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.blue.ribbon.label {\n  border-color: #1a69a4 !important;\n}\n/* Basic */\n.ui.basic.blue.label {\n  background: none #FFFFFF !important;\n  color: #2185D0 !important;\n  border-color: #2185D0 !important;\n}\n.ui.basic.blue.labels a.label:hover,\na.ui.basic.blue.label:hover {\n  background-color: #FFFFFF !important;\n  color: #1678c2 !important;\n  border-color: #1678c2 !important;\n}\n/*--- Violet ---*/\n.ui.violet.labels .label,\n.ui.violet.label {\n  background-color: #6435C9 !important;\n  border-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.violet.labels .label:hover,\na.ui.violet.label:hover {\n  background-color: #5829bb !important;\n  border-color: #5829bb !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.violet.corner.label,\n.ui.violet.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.violet.ribbon.label {\n  border-color: #502aa1 !important;\n}\n/* Basic */\n.ui.basic.violet.label {\n  background: none #FFFFFF !important;\n  color: #6435C9 !important;\n  border-color: #6435C9 !important;\n}\n.ui.basic.violet.labels a.label:hover,\na.ui.basic.violet.label:hover {\n  background-color: #FFFFFF !important;\n  color: #5829bb !important;\n  border-color: #5829bb !important;\n}\n/*--- Purple ---*/\n.ui.purple.labels .label,\n.ui.purple.label {\n  background-color: #A333C8 !important;\n  border-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.purple.labels .label:hover,\na.ui.purple.label:hover {\n  background-color: #9627ba !important;\n  border-color: #9627ba !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.purple.corner.label,\n.ui.purple.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.purple.ribbon.label {\n  border-color: #82299f !important;\n}\n/* Basic */\n.ui.basic.purple.label {\n  background: none #FFFFFF !important;\n  color: #A333C8 !important;\n  border-color: #A333C8 !important;\n}\n.ui.basic.purple.labels a.label:hover,\na.ui.basic.purple.label:hover {\n  background-color: #FFFFFF !important;\n  color: #9627ba !important;\n  border-color: #9627ba !important;\n}\n/*--- Pink ---*/\n.ui.pink.labels .label,\n.ui.pink.label {\n  background-color: #E03997 !important;\n  border-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.pink.labels .label:hover,\na.ui.pink.label:hover {\n  background-color: #e61a8d !important;\n  border-color: #e61a8d !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.pink.corner.label,\n.ui.pink.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.pink.ribbon.label {\n  border-color: #c71f7e !important;\n}\n/* Basic */\n.ui.basic.pink.label {\n  background: none #FFFFFF !important;\n  color: #E03997 !important;\n  border-color: #E03997 !important;\n}\n.ui.basic.pink.labels a.label:hover,\na.ui.basic.pink.label:hover {\n  background-color: #FFFFFF !important;\n  color: #e61a8d !important;\n  border-color: #e61a8d !important;\n}\n/*--- Brown ---*/\n.ui.brown.labels .label,\n.ui.brown.label {\n  background-color: #A5673F !important;\n  border-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.brown.labels .label:hover,\na.ui.brown.label:hover {\n  background-color: #975b33 !important;\n  border-color: #975b33 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.brown.corner.label,\n.ui.brown.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.brown.ribbon.label {\n  border-color: #805031 !important;\n}\n/* Basic */\n.ui.basic.brown.label {\n  background: none #FFFFFF !important;\n  color: #A5673F !important;\n  border-color: #A5673F !important;\n}\n.ui.basic.brown.labels a.label:hover,\na.ui.basic.brown.label:hover {\n  background-color: #FFFFFF !important;\n  color: #975b33 !important;\n  border-color: #975b33 !important;\n}\n/*--- Grey ---*/\n.ui.grey.labels .label,\n.ui.grey.label {\n  background-color: #767676 !important;\n  border-color: #767676 !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.grey.labels .label:hover,\na.ui.grey.label:hover {\n  background-color: #838383 !important;\n  border-color: #838383 !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.grey.corner.label,\n.ui.grey.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.grey.ribbon.label {\n  border-color: #805031 !important;\n}\n/* Basic */\n.ui.basic.grey.label {\n  background: none #FFFFFF !important;\n  color: #767676 !important;\n  border-color: #767676 !important;\n}\n.ui.basic.grey.labels a.label:hover,\na.ui.basic.grey.label:hover {\n  background-color: #FFFFFF !important;\n  color: #838383 !important;\n  border-color: #838383 !important;\n}\n/*--- Black ---*/\n.ui.black.labels .label,\n.ui.black.label {\n  background-color: #1B1C1D !important;\n  border-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n/* Link */\n.ui.black.labels .label:hover,\na.ui.black.label:hover {\n  background-color: #27292a !important;\n  border-color: #27292a !important;\n  color: #FFFFFF !important;\n}\n/* Corner */\n.ui.black.corner.label,\n.ui.black.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.black.ribbon.label {\n  border-color: #805031 !important;\n}\n/* Basic */\n.ui.basic.black.label {\n  background: none #FFFFFF !important;\n  color: #1B1C1D !important;\n  border-color: #1B1C1D !important;\n}\n.ui.basic.black.labels a.label:hover,\na.ui.basic.black.label:hover {\n  background-color: #FFFFFF !important;\n  color: #27292a !important;\n  border-color: #27292a !important;\n}\n/*-------------------\n        Basic\n--------------------*/\n.ui.basic.label {\n  background: none #FFFFFF;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: none;\n}\n/* Link */\na.ui.basic.label:hover {\n  text-decoration: none;\n  background: none #FFFFFF;\n  color: #1e70bf;\n  box-shadow: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: none;\n}\n/* Pointing */\n.ui.basic.pointing.label:before {\n  border-color: inherit;\n}\n/*-------------------\n       Fluid\n--------------------*/\n.ui.label.fluid,\n.ui.fluid.labels > .label {\n  width: 100%;\n  box-sizing: border-box;\n}\n/*-------------------\n       Inverted\n--------------------*/\n.ui.inverted.labels .label,\n.ui.inverted.label {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n/*-------------------\n     Horizontal\n--------------------*/\n.ui.horizontal.labels .label,\n.ui.horizontal.label {\n  margin: 0em 0.5em 0em 0em;\n  padding: 0.4em 0.833em;\n  min-width: 3em;\n  text-align: center;\n}\n/*-------------------\n       Circular\n--------------------*/\n.ui.circular.labels .label,\n.ui.circular.label {\n  min-width: 2em;\n  min-height: 2em;\n  padding: 0.5em !important;\n  line-height: 1em;\n  text-align: center;\n  border-radius: 500rem;\n}\n.ui.empty.circular.labels .label,\n.ui.empty.circular.label {\n  min-width: 0em;\n  min-height: 0em;\n  overflow: hidden;\n  width: 0.5em;\n  height: 0.5em;\n  vertical-align: baseline;\n}\n/*-------------------\n       Pointing\n--------------------*/\n.ui.pointing.label {\n  position: relative;\n}\n.ui.attached.pointing.label {\n  position: absolute;\n}\n.ui.pointing.label:before {\n  background-color: inherit;\n  background-image: inherit;\n  border-width: none;\n  border-style: solid;\n  border-color: inherit;\n}\n/* Arrow */\n.ui.pointing.label:before {\n  position: absolute;\n  content: '';\n  transform: rotate(45deg);\n  background-image: none;\n  z-index: 2;\n  width: 0.6666em;\n  height: 0.6666em;\n  transition: background 0.1s ease;\n}\n/*--- Above ---*/\n.ui.pointing.label,\n.ui[class*=\"pointing above\"].label {\n  margin-top: 1em;\n}\n.ui.pointing.label:before,\n.ui[class*=\"pointing above\"].label:before {\n  border-width: 1px 0px 0px 1px;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 0%;\n  left: 50%;\n}\n/*--- Below ---*/\n.ui[class*=\"bottom pointing\"].label,\n.ui[class*=\"pointing below\"].label {\n  margin-top: 0em;\n  margin-bottom: 1em;\n}\n.ui[class*=\"bottom pointing\"].label:before,\n.ui[class*=\"pointing below\"].label:before {\n  border-width: 0px 1px 1px 0px;\n  top: auto;\n  right: auto;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 100%;\n  left: 50%;\n}\n/*--- Left ---*/\n.ui[class*=\"left pointing\"].label {\n  margin-top: 0em;\n  margin-left: 0.6666em;\n}\n.ui[class*=\"left pointing\"].label:before {\n  border-width: 0px 0px 1px 1px;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n/*--- Right ---*/\n.ui[class*=\"right pointing\"].label {\n  margin-top: 0em;\n  margin-right: 0.6666em;\n}\n.ui[class*=\"right pointing\"].label:before {\n  border-width: 1px 1px 0px 0px;\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n}\n/* Basic Pointing */\n/*--- Above ---*/\n.ui.basic.pointing.label:before,\n.ui.basic[class*=\"pointing above\"].label:before {\n  margin-top: -1px;\n}\n/*--- Below ---*/\n.ui.basic[class*=\"bottom pointing\"].label:before,\n.ui.basic[class*=\"pointing below\"].label:before {\n  bottom: auto;\n  top: 100%;\n  margin-top: 1px;\n}\n/*--- Left ---*/\n.ui.basic[class*=\"left pointing\"].label:before {\n  top: 50%;\n  left: -1px;\n}\n/*--- Right ---*/\n.ui.basic[class*=\"right pointing\"].label:before {\n  top: 50%;\n  right: -1px;\n}\n/*------------------\n   Floating Label\n-------------------*/\n.ui.floating.label {\n  position: absolute;\n  z-index: 100;\n  top: -1em;\n  left: 100%;\n  margin: 0em 0em 0em -1.5em !important;\n}\n/*-------------------\n        Sizes\n--------------------*/\n.ui.mini.labels .label,\n.ui.mini.label {\n  font-size: 0.64285714rem;\n}\n.ui.tiny.labels .label,\n.ui.tiny.label {\n  font-size: 0.71428571rem;\n}\n.ui.small.labels .label,\n.ui.small.label {\n  font-size: 0.78571429rem;\n}\n.ui.labels .label,\n.ui.label {\n  font-size: 0.85714286rem;\n}\n.ui.large.labels .label,\n.ui.large.label {\n  font-size: 1rem;\n}\n.ui.big.labels .label,\n.ui.big.label {\n  font-size: 1.28571429rem;\n}\n.ui.huge.labels .label,\n.ui.huge.label {\n  font-size: 1.42857143rem;\n}\n.ui.massive.labels .label,\n.ui.massive.label {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - List\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             List\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* List */\n/* List Item */\n/* Sub List */\n/* Sub List Item */\n/*-------------------\n      Elements\n--------------------*/\n/* Icon */\n/* Image */\n/* Content */\n/* Header */\n/* Description */\n/* Link */\n/* Header Link */\n/* Linked Icon */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Float */\n/* Horizontal */\n/* Inverted */\n/* Link List */\n/* Inverted Link List */\n/* Selection List */\n/* Selection List States */\n/* Inverted Selection List */\n/* Animated List */\n/* Bulleted */\n/* Horizontal Bullets */\n/* Ordered List */\n/* Horizontal Ordered */\n/* Divided */\n/* Divided Horizontal */\n/* Divided */\n/* Divided Horizontal */\n/* Relaxed */\n/* Very Relaxed */\n/* Packaged Theme */\n/*******************************\n             List\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* List */\n/* List Item */\n/* Sub List */\n/* Sub List Item */\n/*-------------------\n      Elements\n--------------------*/\n/* Icon */\n/* Image */\n/* Content */\n/* Header */\n/* Description */\n/* Link */\n/* Header Link */\n/* Linked Icon */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Float */\n/* Horizontal */\n/* Inverted */\n/* Link List */\n/* Inverted Link List */\n/* Selection List */\n/* Selection List States */\n/* Inverted Selection List */\n/* Animated List */\n/* Bulleted */\n/* Horizontal Bullets */\n/* Ordered List */\n/* Horizontal Ordered */\n/* Divided */\n/* Divided Horizontal */\n/* Divided */\n/* Divided Horizontal */\n/* Relaxed */\n/* Very Relaxed */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            List\n*******************************/\nul.ui.list,\nol.ui.list,\n.ui.list {\n  list-style-type: none;\n  margin: 1em 0em;\n  padding: 0em 0em;\n}\nul.ui.list:first-child,\nol.ui.list:first-child,\n.ui.list:first-child {\n  margin-top: 0em;\n  padding-top: 0em;\n}\nul.ui.list:last-child,\nol.ui.list:last-child,\n.ui.list:last-child {\n  margin-bottom: 0em;\n  padding-bottom: 0em;\n}\n/*******************************\n            Content\n*******************************/\n/* List Item */\nul.ui.list li,\nol.ui.list li,\n.ui.list > .item,\n.ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  list-style-type: none;\n  list-style-position: outside;\n  padding: 0.21428571em 0em;\n  line-height: 1.14285714em;\n}\nul.ui.list > li:first-child:after,\nol.ui.list > li:first-child:after,\n.ui.list > .list > .item,\n.ui.list > .item:after {\n  content: '';\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\nul.ui.list li:first-child,\nol.ui.list li:first-child,\n.ui.list .list > .item:first-child,\n.ui.list > .item:first-child {\n  padding-top: 0em;\n}\nul.ui.list li:last-child,\nol.ui.list li:last-child,\n.ui.list .list > .item:last-child,\n.ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n/* Child List */\nul.ui.list ul,\nol.ui.list ol,\n.ui.list .list {\n  clear: both;\n  margin: 0em;\n  padding: 0.75em 0em 0.25em 0.5em;\n}\n/* Child Item */\nul.ui.list ul li,\nol.ui.list ol li,\n.ui.list .list > .item {\n  padding: 0.14285714em 0em;\n  line-height: inherit;\n}\n/* Icon */\n.ui.list .list > .item > i.icon,\n.ui.list > .item > i.icon {\n  display: table-cell;\n  margin: 0em;\n  padding-top: 0em;\n  padding-right: 0.28571429em;\n  vertical-align: top;\n  transition: color 0.1s ease;\n}\n.ui.list .list > .item > i.icon:only-child,\n.ui.list > .item > i.icon:only-child {\n  display: inline-block;\n  vertical-align: top;\n}\n/* Image */\n.ui.list .list > .item > .image,\n.ui.list > .item > .image {\n  display: table-cell;\n  background-color: transparent;\n  margin: 0em;\n  vertical-align: top;\n}\n.ui.list .list > .item > .image:not(:only-child):not(img),\n.ui.list > .item > .image:not(:only-child):not(img) {\n  padding-right: 0.5em;\n}\n.ui.list .list > .item > .image img,\n.ui.list > .item > .image img {\n  vertical-align: top;\n}\n.ui.list .list > .item > img.image,\n.ui.list .list > .item > .image:only-child,\n.ui.list > .item > img.image,\n.ui.list > .item > .image:only-child {\n  display: inline-block;\n}\n/* Content */\n.ui.list .list > .item > .content,\n.ui.list > .item > .content {\n  line-height: 1.14285714em;\n}\n.ui.list .list > .item > .image + .content,\n.ui.list .list > .item > .icon + .content,\n.ui.list > .item > .image + .content,\n.ui.list > .item > .icon + .content {\n  display: table-cell;\n  width: 100%;\n  padding: 0em 0em 0em 0.5em;\n  vertical-align: top;\n}\n.ui.list .list > .item > img.image + .content,\n.ui.list > .item > img.image + .content {\n  display: inline-block;\n  width: auto;\n}\n.ui.list .list > .item > .content > .list,\n.ui.list > .item > .content > .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n/* Header */\n.ui.list .list > .item .header,\n.ui.list > .item .header {\n  display: block;\n  margin: 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Description */\n.ui.list .list > .item .description,\n.ui.list > .item .description {\n  display: block;\n  color: rgba(0, 0, 0, 0.7);\n}\n/* Child Link */\n.ui.list > .item a,\n.ui.list .list > .item a {\n  cursor: pointer;\n}\n/* Linking Item */\n.ui.list .list > a.item,\n.ui.list > a.item {\n  cursor: pointer;\n  color: #4183C4;\n}\n.ui.list .list > a.item:hover,\n.ui.list > a.item:hover {\n  color: #1e70bf;\n}\n/* Linked Item Icons */\n.ui.list .list > a.item i.icon,\n.ui.list > a.item i.icon {\n  color: rgba(255, 255, 255, 0.4);\n}\n/* Header Link */\n.ui.list .list > .item a.header,\n.ui.list > .item a.header {\n  cursor: pointer;\n  color: #4183C4 !important;\n}\n.ui.list .list > .item a.header:hover,\n.ui.list > .item a.header:hover {\n  color: #1e70bf !important;\n}\n/* Floated Content */\n.ui[class*=\"left floated\"].list {\n  float: left;\n}\n.ui[class*=\"right floated\"].list {\n  float: right;\n}\n.ui.list .list > .item [class*=\"left floated\"],\n.ui.list > .item [class*=\"left floated\"] {\n  float: left;\n  margin: 0em 1em 0em 0em;\n}\n.ui.list .list > .item [class*=\"right floated\"],\n.ui.list > .item [class*=\"right floated\"] {\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n/*******************************\n            Coupling\n*******************************/\n.ui.menu .ui.list > .item,\n.ui.menu .ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  background-color: transparent;\n  list-style-type: none;\n  list-style-position: outside;\n  padding: 0.21428571em 0em;\n  line-height: 1.14285714em;\n}\n.ui.menu .ui.list .list > .item:before,\n.ui.menu .ui.list > .item:before {\n  border: none;\n  background: none;\n}\n.ui.menu .ui.list .list > .item:first-child,\n.ui.menu .ui.list > .item:first-child {\n  padding-top: 0em;\n}\n.ui.menu .ui.list .list > .item:last-child,\n.ui.menu .ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n/*******************************\n            Types\n*******************************/\n/*-------------------\n      Horizontal\n--------------------*/\n.ui.horizontal.list {\n  display: inline-block;\n  font-size: 0em;\n}\n.ui.horizontal.list > .item {\n  display: inline-block;\n  margin-left: 1em;\n  font-size: 1rem;\n}\n.ui.horizontal.list:not(.celled) > .item:first-child {\n  margin-left: 0em !important;\n  padding-left: 0em !important;\n}\n.ui.horizontal.list .list {\n  padding-left: 0em;\n  padding-bottom: 0em;\n}\n.ui.horizontal.list > .item > .image,\n.ui.horizontal.list .list > .item > .image,\n.ui.horizontal.list > .item > .icon,\n.ui.horizontal.list .list > .item > .icon,\n.ui.horizontal.list > .item > .content,\n.ui.horizontal.list .list > .item > .content {\n  vertical-align: middle;\n}\n/* Padding on all elements */\n.ui.horizontal.list > .item:first-child,\n.ui.horizontal.list > .item:last-child {\n  padding-top: 0.21428571em;\n  padding-bottom: 0.21428571em;\n}\n/* Horizontal List */\n.ui.horizontal.list > .item > i.icon {\n  margin: 0em;\n  padding: 0em 0.25em 0em 0em;\n}\n.ui.horizontal.list > .item > .icon,\n.ui.horizontal.list > .item > .icon + .content {\n  float: none;\n  display: inline-block;\n}\n/*******************************\n             States\n*******************************/\n/*-------------------\n       Disabled\n--------------------*/\n.ui.list .list > .disabled.item,\n.ui.list > .disabled.item {\n  pointer-events: none;\n  color: rgba(40, 40, 40, 0.3) !important;\n}\n.ui.inverted.list .list > .disabled.item,\n.ui.inverted.list > .disabled.item {\n  color: rgba(225, 225, 225, 0.3) !important;\n}\n/*-------------------\n        Hover\n--------------------*/\n.ui.list .list > a.item:hover .icon,\n.ui.list > a.item:hover .icon {\n  color: rgba(255, 255, 255, 0.87);\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Inverted\n--------------------*/\n.ui.inverted.list .list > a.item > .icon,\n.ui.inverted.list > a.item > .icon {\n  color: rgba(255, 255, 255, 0.7);\n}\n.ui.inverted.list .list > .item .header,\n.ui.inverted.list > .item .header {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.inverted.list .list > .item .description,\n.ui.inverted.list > .item .description {\n  color: rgba(255, 255, 255, 0.7);\n}\n/* Item Link */\n.ui.inverted.list .list > a.item,\n.ui.inverted.list > a.item {\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.inverted.list .list > a.item:hover,\n.ui.inverted.list > a.item:hover {\n  color: #1e70bf;\n}\n/* Linking Content */\n.ui.inverted.list .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n.ui.inverted.list .item a:not(.ui):hover {\n  color: #1e70bf !important;\n}\n/*-------------------\n       Aligned\n--------------------*/\n.ui.list[class*=\"top aligned\"] .image,\n.ui.list[class*=\"top aligned\"] .content,\n.ui.list [class*=\"top aligned\"] {\n  vertical-align: top !important;\n}\n.ui.list[class*=\"middle aligned\"] .image,\n.ui.list[class*=\"middle aligned\"] .content,\n.ui.list [class*=\"middle aligned\"] {\n  vertical-align: middle !important;\n}\n.ui.list[class*=\"bottom aligned\"] .image,\n.ui.list[class*=\"bottom aligned\"] .content,\n.ui.list [class*=\"bottom aligned\"] {\n  vertical-align: bottom !important;\n}\n/*-------------------\n       Link\n--------------------*/\n.ui.link.list .item,\n.ui.link.list a.item,\n.ui.link.list .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.4);\n  transition: 0.1s color ease;\n}\n.ui.link.list.list a.item:hover,\n.ui.link.list.list .item a:not(.ui):hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.link.list.list a.item:active,\n.ui.link.list.list .item a:not(.ui):active {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.link.list.list .active.item,\n.ui.link.list.list .active.item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Inverted */\n.ui.inverted.link.list .item,\n.ui.inverted.link.list a.item,\n.ui.inverted.link.list .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.5);\n}\n.ui.inverted.link.list.list a.item:hover,\n.ui.inverted.link.list.list .item a:not(.ui):hover {\n  color: #ffffff;\n}\n.ui.inverted.link.list.list a.item:active,\n.ui.inverted.link.list.list .item a:not(.ui):active {\n  color: #ffffff;\n}\n.ui.inverted.link.list.list a.active.item,\n.ui.inverted.link.list.list .active.item a:not(.ui) {\n  color: #ffffff;\n}\n/*-------------------\n      Selection\n--------------------*/\n.ui.selection.list .list > .item,\n.ui.selection.list > .item {\n  cursor: pointer;\n  background: transparent;\n  padding: 0.5em 0.5em;\n  margin: 0em;\n  color: rgba(255, 255, 255, 0.4);\n  border-radius: 0.5em;\n  transition: 0.1s color ease, 0.1s padding-left ease, 0.1s background-color ease;\n}\n.ui.selection.list .list > .item:last-child,\n.ui.selection.list > .item:last-child {\n  margin-bottom: 0em;\n}\n.ui.selection.list.list > .item:hover,\n.ui.selection.list > .item:hover {\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.selection.list .list > .item:active,\n.ui.selection.list > .item:active {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.selection.list .list > .item.active,\n.ui.selection.list > .item.active {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Inverted */\n.ui.inverted.selection.list > .item,\n.ui.inverted.selection.list > .item {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.5);\n}\n.ui.inverted.selection.list > .item:hover,\n.ui.inverted.selection.list > .item:hover {\n  background: rgba(255, 255, 255, 0.02);\n  color: #ffffff;\n}\n.ui.inverted.selection.list > .item:active,\n.ui.inverted.selection.list > .item:active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n.ui.inverted.selection.list > .item.active,\n.ui.inverted.selection.list > .item.active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n/* Celled / Divided Selection List */\n.ui.celled.selection.list .list > .item,\n.ui.divided.selection.list .list > .item,\n.ui.celled.selection.list > .item,\n.ui.divided.selection.list > .item {\n  border-radius: 0em;\n}\n/*-------------------\n       Animated\n--------------------*/\n.ui.animated.list > .item {\n  transition: 0.25s color ease 0.1s, 0.25s padding-left ease 0.1s, 0.25s background-color ease 0.1s;\n}\n.ui.animated.list:not(.horizontal) > .item:hover {\n  padding-left: 1em;\n}\n/*-------------------\n       Fitted\n--------------------*/\n.ui.fitted.list:not(.selection) .list > .item,\n.ui.fitted.list:not(.selection) > .item {\n  padding-left: 0em;\n  padding-right: 0em;\n}\n.ui.fitted.selection.list .list > .item,\n.ui.fitted.selection.list > .item {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n/*-------------------\n      Bulleted\n--------------------*/\nul.ui.list,\n.ui.bulleted.list {\n  margin-left: 1.25rem;\n}\nul.ui.list li,\n.ui.bulleted.list .list > .item,\n.ui.bulleted.list > .item {\n  position: relative;\n}\nul.ui.list li:before,\n.ui.bulleted.list .list > .item:before,\n.ui.bulleted.list > .item:before {\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  top: auto;\n  left: auto;\n  font-weight: normal;\n  margin-left: -1.25rem;\n  content: '•';\n  opacity: 1;\n  color: inherit;\n  vertical-align: top;\n}\nul.ui.list li:before,\n.ui.bulleted.list .list > a.item:before,\n.ui.bulleted.list > a.item:before {\n  color: rgba(255, 255, 255, 0.87);\n}\nul.ui.list ul,\n.ui.bulleted.list .list {\n  padding-left: 1.25rem;\n}\n/* Horizontal Bulleted */\nul.ui.horizontal.bulleted.list,\n.ui.horizontal.bulleted.list {\n  margin-left: 0em;\n}\nul.ui.horizontal.bulleted.list li,\n.ui.horizontal.bulleted.list > .item {\n  margin-left: 1.75rem;\n}\nul.ui.horizontal.bulleted.list li:first-child,\n.ui.horizontal.bulleted.list > .item:first-child {\n  margin-left: 0em;\n}\nul.ui.horizontal.bulleted.list li::before,\n.ui.horizontal.bulleted.list > .item::before {\n  color: rgba(255, 255, 255, 0.87);\n}\nul.ui.horizontal.bulleted.list li:first-child::before,\n.ui.horizontal.bulleted.list > .item:first-child::before {\n  display: none;\n}\n/*-------------------\n       Ordered\n--------------------*/\nol.ui.list,\n.ui.ordered.list,\n.ui.ordered.list .list,\nol.ui.list ol {\n  counter-reset: ordered;\n  margin-left: 1.25rem;\n  list-style-type: none;\n}\nol.ui.list li,\n.ui.ordered.list .list > .item,\n.ui.ordered.list > .item {\n  list-style-type: none;\n  position: relative;\n}\nol.ui.list li:before,\n.ui.ordered.list .list > .item:before,\n.ui.ordered.list > .item:before {\n  position: absolute;\n  top: auto;\n  left: auto;\n  user-select: none;\n  pointer-events: none;\n  margin-left: -1.25rem;\n  counter-increment: ordered;\n  content: counters(ordered, \".\") \" \";\n  text-align: right;\n  color: rgba(255, 255, 255, 0.87);\n  vertical-align: middle;\n  opacity: 0.8;\n}\nol.ui.inverted.list li:before,\n.ui.ordered.inverted.list .list > .item:before,\n.ui.ordered.inverted.list > .item:before {\n  color: rgba(255, 255, 255, 0.7);\n}\n/* Value */\n.ui.ordered.list > .list > .item[data-value],\n.ui.ordered.list > .item[data-value] {\n  content: attr(data-value);\n}\nol.ui.list li[value]:before {\n  content: attr(value);\n}\n/* Child Lists */\nol.ui.list ol,\n.ui.ordered.list .list {\n  margin-left: 1em;\n}\nol.ui.list ol li:before,\n.ui.ordered.list .list > .item:before {\n  margin-left: -2em;\n}\n/* Horizontal Ordered */\nol.ui.horizontal.list,\n.ui.ordered.horizontal.list {\n  margin-left: 0em;\n}\nol.ui.horizontal.list li:before,\n.ui.ordered.horizontal.list .list > .item:before,\n.ui.ordered.horizontal.list > .item:before {\n  position: static;\n  margin: 0em 0.5em 0em 0em;\n}\n/*-------------------\n       Divided\n--------------------*/\n.ui.divided.list > .item {\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.divided.list .list > .item {\n  border-top: none;\n}\n.ui.divided.list .item .list > .item {\n  border-top: none;\n}\n.ui.divided.list .list > .item:first-child,\n.ui.divided.list > .item:first-child {\n  border-top: none;\n}\n/* Sub Menu */\n.ui.divided.list:not(.horizontal) .list > .item:first-child {\n  border-top-width: 1px;\n}\n/* Divided bulleted */\n.ui.divided.bulleted.list:not(.horizontal),\n.ui.divided.bulleted.list .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n.ui.divided.bulleted.list > .item:not(.horizontal) {\n  padding-left: 1.25rem;\n}\n/* Divided Ordered */\n.ui.divided.ordered.list {\n  margin-left: 0em;\n}\n.ui.divided.ordered.list .list > .item,\n.ui.divided.ordered.list > .item {\n  padding-left: 1.25rem;\n}\n.ui.divided.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: 0.21428571em;\n}\n.ui.divided.ordered.list .item .list > .item {\n  padding-left: 1em;\n}\n/* Divided Selection */\n.ui.divided.selection.list .list > .item,\n.ui.divided.selection.list > .item {\n  margin: 0em;\n  border-radius: 0em;\n}\n/* Divided horizontal */\n.ui.divided.horizontal.list {\n  margin-left: 0em;\n}\n.ui.divided.horizontal.list > .item:not(:first-child) {\n  padding-left: 0.5em;\n}\n.ui.divided.horizontal.list > .item:not(:last-child) {\n  padding-right: 0.5em;\n}\n.ui.divided.horizontal.list > .item {\n  border-top: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: 0em;\n  line-height: 0.6;\n}\n.ui.horizontal.divided.list > .item:first-child {\n  border-left: none;\n}\n/* Inverted */\n.ui.divided.inverted.list > .item,\n.ui.divided.inverted.list > .list,\n.ui.divided.inverted.horizontal.list > .item {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n/*-------------------\n        Celled\n--------------------*/\n.ui.celled.list > .item,\n.ui.celled.list > .list {\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n.ui.celled.list > .item:last-child {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* Padding on all elements */\n.ui.celled.list > .item:first-child,\n.ui.celled.list > .item:last-child {\n  padding-top: 0.21428571em;\n  padding-bottom: 0.21428571em;\n}\n/* Sub Menu */\n.ui.celled.list .item .list > .item {\n  border-width: 0px;\n}\n.ui.celled.list .list > .item:first-child {\n  border-top-width: 0px;\n}\n/* Celled Bulleted */\n.ui.celled.bulleted.list {\n  margin-left: 0em;\n}\n.ui.celled.bulleted.list .list > .item,\n.ui.celled.bulleted.list > .item {\n  padding-left: 1.25rem;\n}\n.ui.celled.bulleted.list .item .list {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n  padding-bottom: 0.21428571em;\n}\n/* Celled Ordered */\n.ui.celled.ordered.list {\n  margin-left: 0em;\n}\n.ui.celled.ordered.list .list > .item,\n.ui.celled.ordered.list > .item {\n  padding-left: 1.25rem;\n}\n.ui.celled.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: 0.21428571em;\n}\n.ui.celled.ordered.list .list > .item {\n  padding-left: 1em;\n}\n/* Celled Horizontal */\n.ui.horizontal.celled.list {\n  margin-left: 0em;\n}\n.ui.horizontal.celled.list .list > .item,\n.ui.horizontal.celled.list > .item {\n  border-top: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  margin: 0em;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  line-height: 0.6;\n}\n.ui.horizontal.celled.list .list > .item:last-child,\n.ui.horizontal.celled.list > .item:last-child {\n  border-bottom: none;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* Inverted */\n.ui.celled.inverted.list > .item,\n.ui.celled.inverted.list > .list {\n  border-color: 1px solid rgba(255, 255, 255, 0.1);\n}\n.ui.celled.inverted.horizontal.list .list > .item,\n.ui.celled.inverted.horizontal.list > .item {\n  border-color: 1px solid rgba(255, 255, 255, 0.1);\n}\n/*-------------------\n       Relaxed\n--------------------*/\n.ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: 0.42857143em;\n}\n.ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: 0.42857143em;\n}\n.ui.horizontal.relaxed.list .list > .item:not(:first-child),\n.ui.horizontal.relaxed.list > .item:not(:first-child) {\n  padding-left: 1rem;\n}\n.ui.horizontal.relaxed.list .list > .item:not(:last-child),\n.ui.horizontal.relaxed.list > .item:not(:last-child) {\n  padding-right: 1rem;\n}\n/* Very Relaxed */\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: 0.85714286em;\n}\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: 0.85714286em;\n}\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:first-child),\n.ui.horizontal[class*=\"very relaxed\"].list > .item:not(:first-child) {\n  padding-left: 1.5rem;\n}\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:last-child),\n.ui.horizontal[class*=\"very relaxed\"].list > .item:not(:last-child) {\n  padding-right: 1.5rem;\n}\n/*-------------------\n      Sizes\n--------------------*/\n.ui.mini.list {\n  font-size: 0.78571429em;\n}\n.ui.tiny.list {\n  font-size: 0.85714286em;\n}\n.ui.small.list {\n  font-size: 0.92857143em;\n}\n.ui.list {\n  font-size: 1em;\n}\n.ui.large.list {\n  font-size: 1.14285714em;\n}\n.ui.big.list {\n  font-size: 1.28571429em;\n}\n.ui.huge.list {\n  font-size: 1.42857143em;\n}\n.ui.massive.list {\n  font-size: 1.71428571em;\n}\n.ui.mini.horizontal.list .list > .item,\n.ui.mini.horizontal.list > .item {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.horizontal.list .list > .item,\n.ui.tiny.horizontal.list > .item {\n  font-size: 0.85714286rem;\n}\n.ui.small.horizontal.list .list > .item,\n.ui.small.horizontal.list > .item {\n  font-size: 0.92857143rem;\n}\n.ui.horizontal.list .list > .item,\n.ui.horizontal.list > .item {\n  font-size: 1rem;\n}\n.ui.large.horizontal.list .list > .item,\n.ui.large.horizontal.list > .item {\n  font-size: 1.14285714rem;\n}\n.ui.big.horizontal.list .list > .item,\n.ui.big.horizontal.list > .item {\n  font-size: 1.28571429rem;\n}\n.ui.huge.horizontal.list .list > .item,\n.ui.huge.horizontal.list > .item {\n  font-size: 1.42857143rem;\n}\n.ui.massive.horizontal.list .list > .item,\n.ui.massive.horizontal.list > .item {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Loader\n*******************************/\n/* Some global loader styles defined in site.variables */\n/*-------------------\n      Standard\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Text */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Exact Sizes (Avoids Rounding Errors) */\n/* Packaged Theme */\n/*******************************\n             Loader\n*******************************/\n/* Some global loader styles defined in site.variables */\n/*-------------------\n      Standard\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Text */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Exact Sizes (Avoids Rounding Errors) */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Loader\n*******************************/\n/* Standard Size */\n.ui.loader {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: 0px;\n  text-align: center;\n  z-index: 1000;\n  transform: translateX(-50%) translateY(-50%);\n}\n/* Static Shape */\n.ui.loader:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n/* Active Shape */\n.ui.loader:after {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  animation: loader 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n/* Active Animation */\n@keyframes loader {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Sizes */\n.ui.mini.loader:before,\n.ui.mini.loader:after {\n  width: 1rem;\n  height: 1rem;\n  margin: 0em 0em 0em -0.5rem;\n}\n.ui.tiny.loader:before,\n.ui.tiny.loader:after {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  margin: 0em 0em 0em -0.57142857rem;\n}\n.ui.small.loader:before,\n.ui.small.loader:after {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  margin: 0em 0em 0em -0.85714286rem;\n}\n.ui.loader:before,\n.ui.loader:after {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  margin: 0em 0em 0em -1.14285714rem;\n}\n.ui.large.loader:before,\n.ui.large.loader:after {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  margin: 0em 0em 0em -1.71428571rem;\n}\n.ui.big.loader:before,\n.ui.big.loader:after {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  margin: 0em 0em 0em -1.85714286rem;\n}\n.ui.huge.loader:before,\n.ui.huge.loader:after {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  margin: 0em 0em 0em -2.07142857rem;\n}\n.ui.massive.loader:before,\n.ui.massive.loader:after {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  margin: 0em 0em 0em -2.28571429rem;\n}\n/*-------------------\n      Coupling\n--------------------*/\n/* Show inside active dimmer */\n.ui.dimmer .loader {\n  display: block;\n}\n/* Black Dimmer */\n.ui.dimmer .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.dimmer .ui.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.dimmer .ui.loader:after {\n  border-color: #FFFFFF transparent transparent;\n}\n/* White Dimmer (Inverted) */\n.ui.inverted.dimmer .ui.loader {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.inverted.dimmer .ui.loader:before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.ui.inverted.dimmer .ui.loader:after {\n  border-color: #767676 transparent transparent;\n}\n/*******************************\n             Types\n*******************************/\n/*-------------------\n        Text\n--------------------*/\n.ui.text.loader {\n  width: auto !important;\n  height: auto !important;\n  text-align: center;\n  font-style: normal;\n}\n/*******************************\n            States\n*******************************/\n.ui.indeterminate.loader:after {\n  animation-direction: reverse;\n  animation-duration: 1.2s;\n}\n.ui.loader.active,\n.ui.loader.visible {\n  display: block;\n}\n.ui.loader.disabled,\n.ui.loader.hidden {\n  display: none;\n}\n/*******************************\n            Variations\n*******************************/\n/*-------------------\n        Sizes\n--------------------*/\n/* Loader */\n.ui.inverted.dimmer .ui.mini.loader,\n.ui.mini.loader {\n  width: 1rem;\n  height: 1rem;\n  font-size: 0.78571429em;\n}\n.ui.inverted.dimmer .ui.tiny.loader,\n.ui.tiny.loader {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  font-size: 0.85714286em;\n}\n.ui.inverted.dimmer .ui.small.loader,\n.ui.small.loader {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  font-size: 0.92857143em;\n}\n.ui.inverted.dimmer .ui.loader,\n.ui.loader {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  font-size: 1em;\n}\n.ui.inverted.dimmer .ui.large.loader,\n.ui.large.loader {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  font-size: 1.14285714em;\n}\n.ui.inverted.dimmer .ui.big.loader,\n.ui.big.loader {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  font-size: 1.28571429em;\n}\n.ui.inverted.dimmer .ui.huge.loader,\n.ui.huge.loader {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  font-size: 1.42857143em;\n}\n.ui.inverted.dimmer .ui.massive.loader,\n.ui.massive.loader {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  font-size: 1.71428571em;\n}\n/* Text Loader */\n.ui.mini.text.loader {\n  min-width: 1rem;\n  padding-top: 1.78571429rem;\n}\n.ui.tiny.text.loader {\n  min-width: 1.14285714rem;\n  padding-top: 1.92857143rem;\n}\n.ui.small.text.loader {\n  min-width: 1.71428571rem;\n  padding-top: 2.5rem;\n}\n.ui.text.loader {\n  min-width: 2.28571429rem;\n  padding-top: 3.07142857rem;\n}\n.ui.large.text.loader {\n  min-width: 3.42857143rem;\n  padding-top: 4.21428571rem;\n}\n.ui.big.text.loader {\n  min-width: 3.71428571rem;\n  padding-top: 4.5rem;\n}\n.ui.huge.text.loader {\n  min-width: 4.14285714rem;\n  padding-top: 4.92857143rem;\n}\n.ui.massive.text.loader {\n  min-width: 4.57142857rem;\n  padding-top: 5.35714286rem;\n}\n/*-------------------\n       Inverted\n--------------------*/\n.ui.inverted.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.inverted.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.inverted.loader:after {\n  border-top-color: #FFFFFF;\n}\n/*-------------------\n       Inline\n--------------------*/\n.ui.inline.loader {\n  position: relative;\n  vertical-align: middle;\n  margin: 0em;\n  left: 0em;\n  top: 0em;\n  transform: none;\n}\n.ui.inline.loader.active,\n.ui.inline.loader.visible {\n  display: inline-block;\n}\n/* Centered Inline */\n.ui.centered.inline.loader.active,\n.ui.centered.inline.loader.visible {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/* Key Content Sizing */\n/* Interval between consecutive placeholders */\n/* Repeated Placeholder */\n/* Image */\n/* Header Image */\n/* Paragraph */\n/* Glow Gradient */\n/* Variations */\n/* Packaged Theme */\n/* Key Content Sizing */\n/* Interval between consecutive placeholders */\n/* Repeated Placeholder */\n/* Image */\n/* Header Image */\n/* Paragraph */\n/* Glow Gradient */\n/* Variations */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*-------------------\n      Content\n--------------------*/\n.ui.placeholder {\n  position: static;\n  overflow: hidden;\n  animation: placeholderShimmer 2s linear;\n  animation-iteration-count: infinite;\n  background-color: #FFFFFF;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.15) 15%, rgba(0, 0, 0, 0.08) 30%);\n  background-size: 1200px 100%;\n  max-width: 30rem;\n}\n@keyframes placeholderShimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n  100% {\n    background-position: 1200px 0;\n  }\n}\n.ui.placeholder + .ui.placeholder {\n  margin-top: 2rem;\n}\n.ui.placeholder + .ui.placeholder {\n  animation-delay: 0.15s;\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: 0.3s;\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: 0.45s;\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: 0.6s;\n}\n.ui.placeholder,\n.ui.placeholder > :before,\n.ui.placeholder .image.header:after,\n.ui.placeholder .line,\n.ui.placeholder .line:after {\n  background-color: #FFFFFF;\n}\n/* Image */\n.ui.placeholder .image:not(.header):not(.ui) {\n  height: 100px;\n}\n.ui.placeholder .square.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 1/1 aspect ratio */\n  padding-top: 100%;\n}\n.ui.placeholder .rectangular.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 4/3 aspect ratio */\n  padding-top: 75%;\n}\n/* Lines */\n.ui.placeholder .line {\n  position: relative;\n  height: 0.85714286em;\n}\n.ui.placeholder .line:before,\n.ui.placeholder .line:after {\n  top: 100%;\n  position: absolute;\n  content: '';\n  background-color: inherit;\n}\n.ui.placeholder .line:before {\n  left: 0px;\n}\n.ui.placeholder .line:after {\n  right: 0px;\n}\n/* Any Lines */\n.ui.placeholder .line {\n  margin-bottom: 0.5em;\n}\n.ui.placeholder .line:before,\n.ui.placeholder .line:after {\n  height: 0.5em;\n}\n.ui.placeholder .line:not(:first-child) {\n  margin-top: 0.5em;\n}\n/* Header Image + 2 Lines */\n.ui.placeholder .header {\n  position: relative;\n  overflow: hidden;\n}\n/* Line Outdent */\n.ui.placeholder .line:nth-child(1):after {\n  width: 0%;\n}\n.ui.placeholder .line:nth-child(2):after {\n  width: 50%;\n}\n.ui.placeholder .line:nth-child(3):after {\n  width: 10%;\n}\n.ui.placeholder .line:nth-child(4):after {\n  width: 35%;\n}\n.ui.placeholder .line:nth-child(5):after {\n  width: 65%;\n}\n/* Header Line 1 & 2*/\n.ui.placeholder .header .line {\n  margin-bottom: 0.64285714em;\n}\n.ui.placeholder .header .line:before,\n.ui.placeholder .header .line:after {\n  height: 0.64285714em;\n}\n.ui.placeholder .header .line:not(:first-child) {\n  margin-top: 0.64285714em;\n}\n.ui.placeholder .header .line:after {\n  width: 20%;\n}\n.ui.placeholder .header .line:nth-child(2):after {\n  width: 60%;\n}\n/* Image Header */\n.ui.placeholder .image.header .line {\n  margin-left: 3em;\n}\n.ui.placeholder .image.header .line:before {\n  width: 0.71428571rem;\n}\n.ui.placeholder .image.header:after {\n  display: block;\n  height: 0.85714286em;\n  content: '';\n  margin-left: 3em;\n}\n/* Spacing */\n.ui.placeholder .image .line:first-child,\n.ui.placeholder .paragraph .line:first-child,\n.ui.placeholder .header .line:first-child {\n  height: 0.01px;\n}\n.ui.placeholder .image:not(:first-child):before,\n.ui.placeholder .paragraph:not(:first-child):before,\n.ui.placeholder .header:not(:first-child):before {\n  height: 1.42857143em;\n  content: '';\n  display: block;\n}\n/* Inverted Content Loader */\n.ui.inverted.placeholder {\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.14) 15%, rgba(255, 255, 255, 0.08) 30%);\n}\n.ui.inverted.placeholder,\n.ui.inverted.placeholder > :before,\n.ui.inverted.placeholder .image.header:after,\n.ui.inverted.placeholder .line,\n.ui.inverted.placeholder .line:after {\n  background-color: #1B1C1D;\n}\n/*******************************\n            Variations\n*******************************/\n/*-------------------\n        Sizes\n--------------------*/\n.ui.placeholder .full.line.line.line:after {\n  width: 0%;\n}\n.ui.placeholder .very.long.line.line.line:after {\n  width: 10%;\n}\n.ui.placeholder .long.line.line.line:after {\n  width: 35%;\n}\n.ui.placeholder .medium.line.line.line:after {\n  width: 50%;\n}\n.ui.placeholder .short.line.line.line:after {\n  width: 65%;\n}\n.ui.placeholder .very.short.line.line.line:after {\n  width: 80%;\n}\n/*-------------------\n        Fluid\n--------------------*/\n.ui.fluid.placeholder {\n  max-width: none;\n}\n/*!\n * # Semantic UI - Rail\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Rail\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Close */\n/* Dividing */\n/* Packaged Theme */\n/*******************************\n            Rail\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Close */\n/* Dividing */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Rails\n*******************************/\n.ui.rail {\n  position: absolute;\n  top: 0%;\n  width: 300px;\n  height: 100%;\n}\n.ui.left.rail {\n  left: auto;\n  right: 100%;\n  padding: 0em 2rem 0em 0em;\n  margin: 0em 2rem 0em 0em;\n}\n.ui.right.rail {\n  left: 100%;\n  right: auto;\n  padding: 0em 0em 0em 2rem;\n  margin: 0em 0em 0em 2rem;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Internal\n---------------*/\n.ui.left.internal.rail {\n  left: 0%;\n  right: auto;\n  padding: 0em 0em 0em 2rem;\n  margin: 0em 0em 0em 2rem;\n}\n.ui.right.internal.rail {\n  left: auto;\n  right: 0%;\n  padding: 0em 2rem 0em 0em;\n  margin: 0em 2rem 0em 0em;\n}\n/*--------------\n    Dividing\n---------------*/\n.ui.dividing.rail {\n  width: 302.5px;\n}\n.ui.left.dividing.rail {\n  padding: 0em 2.5rem 0em 0em;\n  margin: 0em 2.5rem 0em 0em;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.right.dividing.rail {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 0em 0em 0em 2.5rem;\n  margin: 0em 0em 0em 2.5rem;\n}\n/*--------------\n    Distance\n---------------*/\n.ui.close.rail {\n  width: calc( 300px  +  1em );\n}\n.ui.close.left.rail {\n  padding: 0em 1em 0em 0em;\n  margin: 0em 1em 0em 0em;\n}\n.ui.close.right.rail {\n  padding: 0em 0em 0em 1em;\n  margin: 0em 0em 0em 1em;\n}\n.ui.very.close.rail {\n  width: calc( 300px  +  0.5em );\n}\n.ui.very.close.left.rail {\n  padding: 0em 0.5em 0em 0em;\n  margin: 0em 0.5em 0em 0em;\n}\n.ui.very.close.right.rail {\n  padding: 0em 0em 0em 0.5em;\n  margin: 0em 0em 0em 0.5em;\n}\n/*--------------\n    Attached\n---------------*/\n.ui.attached.left.rail,\n.ui.attached.right.rail {\n  padding: 0em;\n  margin: 0em;\n}\n/*--------------\n     Sizing\n---------------*/\n.ui.mini.rail {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.rail {\n  font-size: 0.85714286rem;\n}\n.ui.small.rail {\n  font-size: 0.92857143rem;\n}\n.ui.rail {\n  font-size: 1rem;\n}\n.ui.large.rail {\n  font-size: 1.14285714rem;\n}\n.ui.big.rail {\n  font-size: 1.28571429rem;\n}\n.ui.huge.rail {\n  font-size: 1.42857143rem;\n}\n.ui.massive.rail {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Reveal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Reveal\n*******************************/\n/* Types */\n/* Packaged Theme */\n/*******************************\n            Reveal\n*******************************/\n/* Types */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Reveal\n*******************************/\n.ui.reveal {\n  display: inherit;\n  position: relative !important;\n  font-size: 0em !important;\n}\n.ui.reveal > .visible.content {\n  position: absolute !important;\n  top: 0em !important;\n  left: 0em !important;\n  z-index: 3 !important;\n  transition: all 0.5s ease 0.1s;\n}\n.ui.reveal > .hidden.content {\n  position: relative !important;\n  z-index: 2 !important;\n}\n/* Make sure hovered element is on top of other reveal */\n.ui.active.reveal .visible.content,\n.ui.reveal:hover .visible.content {\n  z-index: 4 !important;\n}\n/*******************************\n              Types\n*******************************/\n/*--------------\n      Slide\n---------------*/\n.ui.slide.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n.ui.slide.reveal > .content {\n  display: block;\n  width: 100%;\n  white-space: normal;\n  float: left;\n  margin: 0em;\n  transition: transform 0.5s ease 0.1s;\n}\n.ui.slide.reveal > .visible.content {\n  position: relative !important;\n}\n.ui.slide.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n  transform: translateX(100%) !important;\n}\n.ui.slide.active.reveal > .visible.content,\n.ui.slide.reveal:hover > .visible.content {\n  transform: translateX(-100%) !important;\n}\n.ui.slide.active.reveal > .hidden.content,\n.ui.slide.reveal:hover > .hidden.content {\n  transform: translateX(0%) !important;\n}\n.ui.slide.right.reveal > .visible.content {\n  transform: translateX(0%) !important;\n}\n.ui.slide.right.reveal > .hidden.content {\n  transform: translateX(-100%) !important;\n}\n.ui.slide.right.active.reveal > .visible.content,\n.ui.slide.right.reveal:hover > .visible.content {\n  transform: translateX(100%) !important;\n}\n.ui.slide.right.active.reveal > .hidden.content,\n.ui.slide.right.reveal:hover > .hidden.content {\n  transform: translateX(0%) !important;\n}\n.ui.slide.up.reveal > .hidden.content {\n  transform: translateY(100%) !important;\n}\n.ui.slide.up.active.reveal > .visible.content,\n.ui.slide.up.reveal:hover > .visible.content {\n  transform: translateY(-100%) !important;\n}\n.ui.slide.up.active.reveal > .hidden.content,\n.ui.slide.up.reveal:hover > .hidden.content {\n  transform: translateY(0%) !important;\n}\n.ui.slide.down.reveal > .hidden.content {\n  transform: translateY(-100%) !important;\n}\n.ui.slide.down.active.reveal > .visible.content,\n.ui.slide.down.reveal:hover > .visible.content {\n  transform: translateY(100%) !important;\n}\n.ui.slide.down.active.reveal > .hidden.content,\n.ui.slide.down.reveal:hover > .hidden.content {\n  transform: translateY(0%) !important;\n}\n/*--------------\n      Fade\n---------------*/\n.ui.fade.reveal > .visible.content {\n  opacity: 1;\n}\n.ui.fade.active.reveal > .visible.content,\n.ui.fade.reveal:hover > .visible.content {\n  opacity: 0;\n}\n/*--------------\n      Move\n---------------*/\n.ui.move.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n.ui.move.reveal > .content {\n  display: block;\n  float: left;\n  white-space: normal;\n  margin: 0em;\n  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;\n}\n.ui.move.reveal > .visible.content {\n  position: relative !important;\n}\n.ui.move.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n}\n.ui.move.active.reveal > .visible.content,\n.ui.move.reveal:hover > .visible.content {\n  transform: translateX(-100%) !important;\n}\n.ui.move.right.active.reveal > .visible.content,\n.ui.move.right.reveal:hover > .visible.content {\n  transform: translateX(100%) !important;\n}\n.ui.move.up.active.reveal > .visible.content,\n.ui.move.up.reveal:hover > .visible.content {\n  transform: translateY(-100%) !important;\n}\n.ui.move.down.active.reveal > .visible.content,\n.ui.move.down.reveal:hover > .visible.content {\n  transform: translateY(100%) !important;\n}\n/*--------------\n     Rotate\n---------------*/\n.ui.rotate.reveal > .visible.content {\n  transition-duration: 0.5s;\n  transform: rotate(0deg);\n}\n.ui.rotate.reveal > .visible.content,\n.ui.rotate.right.reveal > .visible.content {\n  transform-origin: bottom right;\n}\n.ui.rotate.active.reveal > .visible.content,\n.ui.rotate.reveal:hover > .visible.content,\n.ui.rotate.right.active.reveal > .visible.content,\n.ui.rotate.right.reveal:hover > .visible.content {\n  transform: rotate(110deg);\n}\n.ui.rotate.left.reveal > .visible.content {\n  transform-origin: bottom left;\n}\n.ui.rotate.left.active.reveal > .visible.content,\n.ui.rotate.left.reveal:hover > .visible.content {\n  transform: rotate(-110deg);\n}\n/*******************************\n              States\n*******************************/\n.ui.disabled.reveal:hover > .visible.visible.content {\n  position: static !important;\n  display: block !important;\n  opacity: 1 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: none !important;\n}\n.ui.disabled.reveal:hover > .hidden.hidden.content {\n  display: none !important;\n}\n/*******************************\n           Coupling\n*******************************/\n.ui.reveal > .ui.ribbon.label {\n  z-index: 5;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Visible\n---------------*/\n.ui.visible.reveal {\n  overflow: visible;\n}\n/*--------------\n     Instant\n---------------*/\n.ui.instant.reveal > .content {\n  transition-delay: 0s !important;\n}\n/*--------------\n     Sizing\n---------------*/\n.ui.reveal > .content {\n  font-size: 1rem !important;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Segment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Segment\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Group\n--------------------*/\n/*-------------------\n       Coupling\n--------------------*/\n/* Page Grid Segment */\n/*******************************\n            Types\n*******************************/\n/* Placeholder */\n/* Piled */\n/* Circular */\n/* Stacked */\n/*******************************\n            States\n*******************************/\n/* Loading Dimmer */\n/* Loading Spinner */\n/*******************************\n            Variations\n*******************************/\n/* Raised */\n/* Padded */\n/* Attached */\n/* Inverted */\n/* Floated */\n/* Basic */\n/* Colors */\n/* Ordinality */\n/* Packaged Theme */\n/*******************************\n            Segment\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Group\n--------------------*/\n/*-------------------\n       Coupling\n--------------------*/\n/* Page Grid Segment */\n/*******************************\n            Types\n*******************************/\n/* Placeholder */\n/* Piled */\n/* Circular */\n/* Stacked */\n/*******************************\n            States\n*******************************/\n/* Loading Dimmer */\n/* Loading Spinner */\n/*******************************\n            Variations\n*******************************/\n/* Raised */\n/* Padded */\n/* Attached */\n/* Inverted */\n/* Floated */\n/* Basic */\n/* Colors */\n/* Ordinality */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Segment\n*******************************/\n.ui.segment {\n  position: relative;\n  background: rgba(0, 0, 0, 0);\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n  margin: 1rem 0em;\n  padding: 1em 1em;\n  border-radius: 0.28571429rem;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.segment:first-child {\n  margin-top: 0em;\n}\n.ui.segment:last-child {\n  margin-bottom: 0em;\n}\n/* Vertical */\n.ui.vertical.segment {\n  margin: 0em;\n  padding-left: 0em;\n  padding-right: 0em;\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.vertical.segment:last-child {\n  border-bottom: none;\n}\n/*-------------------\n    Loose Coupling\n--------------------*/\n/* Header */\n.ui.inverted.segment > .ui.header {\n  color: #FFFFFF;\n}\n/* Label */\n.ui[class*=\"bottom attached\"].segment > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n.ui[class*=\"top attached\"].segment > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n/* Grid */\n.ui.page.grid.segment,\n.ui.grid > .row > .ui.segment.column,\n.ui.grid > .ui.segment.column {\n  padding-top: 2em;\n  padding-bottom: 2em;\n}\n.ui.grid.segment {\n  margin: 1rem 0em;\n  border-radius: 0.28571429rem;\n}\n/* Table */\n.ui.basic.table.segment {\n  background: rgba(0, 0, 0, 0);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n}\n.ui[class*=\"very basic\"].table.segment {\n  padding: 1em 1em;\n}\n/*******************************\n             Types\n*******************************/\n/*-------------------\n     Placeholder\n--------------------*/\n.ui.placeholder.segment {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  max-width: initial;\n  animation: none;\n  overflow: visible;\n  padding: 1em 1em;\n  min-height: 18rem;\n  background: #F9FAFB;\n  border-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 2px 25px 0 rgba(34, 36, 38, 0.05) inset;\n}\n.ui.placeholder.segment .button,\n.ui.placeholder.segment textarea {\n  display: block;\n}\n.ui.placeholder.segment .field,\n.ui.placeholder.segment textarea,\n.ui.placeholder.segment > .ui.input,\n.ui.placeholder.segment .button {\n  max-width: 15rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n.ui.placeholder.segment .column .button,\n.ui.placeholder.segment .column .field,\n.ui.placeholder.segment .column textarea,\n.ui.placeholder.segment .column > .ui.input {\n  max-width: 15rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n.ui.placeholder.segment > .inline {\n  align-self: center;\n}\n.ui.placeholder.segment > .inline > .button {\n  display: inline-block;\n  width: auto;\n  margin: 0px 0.35714286rem 0px 0px;\n}\n.ui.placeholder.segment > .inline > .button:last-child {\n  margin-right: 0px;\n}\n/*-------------------\n        Piled\n--------------------*/\n.ui.piled.segments,\n.ui.piled.segment {\n  margin: 3em 0em;\n  box-shadow: '';\n  z-index: auto;\n}\n.ui.piled.segment:first-child {\n  margin-top: 0em;\n}\n.ui.piled.segment:last-child {\n  margin-bottom: 0em;\n}\n.ui.piled.segments:after,\n.ui.piled.segments:before,\n.ui.piled.segment:after,\n.ui.piled.segment:before {\n  background-color: #CCE2FF;\n  visibility: visible;\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: '';\n}\n.ui.piled.segments:before,\n.ui.piled.segment:before {\n  transform: rotate(-1.2deg);\n  top: 0;\n  z-index: -2;\n}\n.ui.piled.segments:after,\n.ui.piled.segment:after {\n  transform: rotate(1.2deg);\n  top: 0;\n  z-index: -1;\n}\n/* Piled Attached */\n.ui[class*=\"top attached\"].piled.segment {\n  margin-top: 3em;\n  margin-bottom: 0em;\n}\n.ui.piled.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n.ui.piled.segment[class*=\"bottom attached\"] {\n  margin-top: 0em;\n  margin-bottom: 3em;\n}\n.ui.piled.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n/*-------------------\n       Stacked\n--------------------*/\n.ui.stacked.segment {\n  padding-bottom: 1.4em;\n}\n.ui.stacked.segments:before,\n.ui.stacked.segments:after,\n.ui.stacked.segment:before,\n.ui.stacked.segment:after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: 0%;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(0, 0, 0, 0.03);\n  width: 100%;\n  height: 6px;\n  visibility: visible;\n}\n.ui.stacked.segments:before,\n.ui.stacked.segment:before {\n  display: none;\n}\n/* Add additional page */\n.ui.tall.stacked.segments:before,\n.ui.tall.stacked.segment:before {\n  display: block;\n  bottom: 0px;\n}\n/* Inverted */\n.ui.stacked.inverted.segments:before,\n.ui.stacked.inverted.segments:after,\n.ui.stacked.inverted.segment:before,\n.ui.stacked.inverted.segment:after {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(255, 255, 255, 0.35);\n}\n/*-------------------\n       Padded\n--------------------*/\n.ui.padded.segment {\n  padding: 1.5em;\n}\n.ui[class*=\"very padded\"].segment {\n  padding: 3em;\n}\n/* Padded vertical */\n.ui.padded.segment.vertical.segment,\n.ui[class*=\"very padded\"].vertical.segment {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n/*-------------------\n       Compact\n--------------------*/\n.ui.compact.segment {\n  display: table;\n}\n/* Compact Group */\n.ui.compact.segments {\n  display: inline-flex;\n}\n.ui.compact.segments .segment,\n.ui.segments .compact.segment {\n  display: block;\n  flex: 0 1 auto;\n}\n/*-------------------\n       Circular\n--------------------*/\n.ui.circular.segment {\n  display: table-cell;\n  padding: 2em;\n  text-align: center;\n  vertical-align: middle;\n  border-radius: 500em;\n}\n/*-------------------\n       Raised\n--------------------*/\n.ui.raised.segments,\n.ui.raised.segment {\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n/*******************************\n            Groups\n*******************************/\n/* Group */\n.ui.segments {\n  flex-direction: column;\n  position: relative;\n  margin: 1rem 0em;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n}\n.ui.segments:first-child {\n  margin-top: 0em;\n}\n.ui.segments:last-child {\n  margin-bottom: 0em;\n}\n/* Nested Segment */\n.ui.segments > .segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em;\n  width: auto;\n  box-shadow: none;\n  border: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.segments:not(.horizontal) > .segment:first-child {\n  border-top: none;\n  margin-top: 0em;\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n/* Bottom */\n.ui.segments:not(.horizontal) > .segment:last-child {\n  top: 0px;\n  bottom: 0px;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n/* Only */\n.ui.segments:not(.horizontal) > .segment:only-child {\n  border-radius: 0.28571429rem;\n}\n/* Nested Group */\n.ui.segments > .ui.segments {\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  margin: 1rem 1rem;\n}\n.ui.segments > .segments:first-child {\n  border-top: none;\n}\n.ui.segments > .segment + .segments:not(.horizontal) {\n  margin-top: 0em;\n}\n/* Horizontal Group */\n.ui.horizontal.segments {\n  display: flex;\n  flex-direction: row;\n  background-color: transparent;\n  border-radius: 0px;\n  padding: 0em;\n  background-color: rgba(0, 0, 0, 0);\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n  margin: 1rem 0em;\n  border-radius: 0.28571429rem;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* Nested Horizontal Group */\n.ui.segments > .horizontal.segments {\n  margin: 0em;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* Horizontal Segment */\n.ui.horizontal.segments > .segment {\n  flex: 1 1 auto;\n  -ms-flex: 1 1 0px;\n  /* Solves #2550 MS Flex */\n  margin: 0em;\n  min-width: 0px;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* Border Fixes */\n.ui.segments > .horizontal.segments:first-child {\n  border-top: none;\n}\n.ui.horizontal.segments > .segment:first-child {\n  border-left: none;\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n    Disabled\n---------------*/\n.ui.disabled.segment {\n  opacity: 0.45;\n  color: rgba(40, 40, 40, 0.3);\n}\n/*--------------\n    Loading\n---------------*/\n.ui.loading.segment {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n  text-shadow: none !important;\n  color: transparent !important;\n  transition: all 0s linear;\n}\n.ui.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: rgba(255, 255, 255, 0.8);\n  width: 100%;\n  height: 100%;\n  border-radius: 0.28571429rem;\n  z-index: 100;\n}\n.ui.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -1.5em 0em 0em -1.5em;\n  width: 3em;\n  height: 3em;\n  animation: segment-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: 101;\n}\n@keyframes segment-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Basic\n--------------------*/\n.ui.basic.segment {\n  background: none transparent;\n  box-shadow: none;\n  border: none;\n  border-radius: 0px;\n}\n/*-------------------\n       Clearing\n--------------------*/\n.ui.clearing.segment:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n/*-------------------\n       Colors\n--------------------*/\n/* Red */\n.ui.red.segment:not(.inverted) {\n  border-top: 2px solid #DB2828 !important;\n}\n.ui.inverted.red.segment {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n/* Orange */\n.ui.orange.segment:not(.inverted) {\n  border-top: 2px solid #F2711C !important;\n}\n.ui.inverted.orange.segment {\n  background-color: #F2711C !important;\n  color: #FFFFFF !important;\n}\n/* Yellow */\n.ui.yellow.segment:not(.inverted) {\n  border-top: 2px solid #FBBD08 !important;\n}\n.ui.inverted.yellow.segment {\n  background-color: #FBBD08 !important;\n  color: #FFFFFF !important;\n}\n/* Olive */\n.ui.olive.segment:not(.inverted) {\n  border-top: 2px solid #B5CC18 !important;\n}\n.ui.inverted.olive.segment {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n/* Green */\n.ui.green.segment:not(.inverted) {\n  border-top: 2px solid #21BA45 !important;\n}\n.ui.inverted.green.segment {\n  background-color: #21BA45 !important;\n  color: #FFFFFF !important;\n}\n/* Teal */\n.ui.teal.segment:not(.inverted) {\n  border-top: 2px solid #00B5AD !important;\n}\n.ui.inverted.teal.segment {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n/* Blue */\n.ui.blue.segment:not(.inverted) {\n  border-top: 2px solid #2185D0 !important;\n}\n.ui.inverted.blue.segment {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n/* Violet */\n.ui.violet.segment:not(.inverted) {\n  border-top: 2px solid #6435C9 !important;\n}\n.ui.inverted.violet.segment {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n/* Purple */\n.ui.purple.segment:not(.inverted) {\n  border-top: 2px solid #A333C8 !important;\n}\n.ui.inverted.purple.segment {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n/* Pink */\n.ui.pink.segment:not(.inverted) {\n  border-top: 2px solid #E03997 !important;\n}\n.ui.inverted.pink.segment {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n/* Brown */\n.ui.brown.segment:not(.inverted) {\n  border-top: 2px solid #A5673F !important;\n}\n.ui.inverted.brown.segment {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n/* Grey */\n.ui.grey.segment:not(.inverted) {\n  border-top: 2px solid #767676 !important;\n}\n.ui.inverted.grey.segment {\n  background-color: #767676 !important;\n  color: #FFFFFF !important;\n}\n/* Black */\n.ui.black.segment:not(.inverted) {\n  border-top: 2px solid #1B1C1D !important;\n}\n.ui.inverted.black.segment {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n/*-------------------\n       Aligned\n--------------------*/\n.ui[class*=\"left aligned\"].segment {\n  text-align: left;\n}\n.ui[class*=\"right aligned\"].segment {\n  text-align: right;\n}\n.ui[class*=\"center aligned\"].segment {\n  text-align: center;\n}\n/*-------------------\n       Floated\n--------------------*/\n.ui.floated.segment,\n.ui[class*=\"left floated\"].segment {\n  float: left;\n  margin-right: 1em;\n}\n.ui[class*=\"right floated\"].segment {\n  float: right;\n  margin-left: 1em;\n}\n/*-------------------\n      Inverted\n--------------------*/\n.ui.inverted.segment {\n  border: none;\n  box-shadow: none;\n}\n.ui.inverted.segment,\n.ui.primary.inverted.segment {\n  background: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n/* Nested */\n.ui.inverted.segment .segment {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.inverted.segment .inverted.segment {\n  color: rgba(255, 255, 255, 0.9);\n}\n/* Attached */\n.ui.inverted.attached.segment {\n  border-color: #555555;\n}\n/*-------------------\n     Emphasis\n--------------------*/\n/* Secondary */\n.ui.secondary.segment {\n  background: #F3F4F5;\n  color: rgba(255, 255, 255, 0.6);\n}\n.ui.secondary.inverted.segment {\n  background: #4c4f52 linear-gradient(rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Tertiary */\n.ui.tertiary.segment {\n  background: #DCDDDE;\n  color: rgba(255, 255, 255, 0.6);\n}\n.ui.tertiary.inverted.segment {\n  background: #717579 linear-gradient(rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.35) 100%);\n  color: rgba(255, 255, 255, 0.8);\n}\n/*-------------------\n      Attached\n--------------------*/\n/* Middle */\n.ui.attached.segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% - (-1px * 2));\n  max-width: calc(100% - (-1px * 2));\n  box-shadow: none;\n  border: 1px solid #D4D4D5;\n}\n.ui.attached:not(.message) + .ui.attached.segment:not(.top) {\n  border-top: none;\n}\n/* Top */\n.ui[class*=\"top attached\"].segment {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1rem;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n/* Bottom */\n.ui.segment[class*=\"bottom attached\"] {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1rem;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n/*-------------------\n        Size\n--------------------*/\n.ui.mini.segments .segment,\n.ui.mini.segment {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.segments .segment,\n.ui.tiny.segment {\n  font-size: 0.85714286rem;\n}\n.ui.small.segments .segment,\n.ui.small.segment {\n  font-size: 0.92857143rem;\n}\n.ui.segments .segment,\n.ui.segment {\n  font-size: 1rem;\n}\n.ui.large.segments .segment,\n.ui.large.segment {\n  font-size: 1.14285714rem;\n}\n.ui.big.segments .segment,\n.ui.big.segment {\n  font-size: 1.28571429rem;\n}\n.ui.huge.segments .segment,\n.ui.huge.segment {\n  font-size: 1.42857143rem;\n}\n.ui.massive.segments .segment,\n.ui.massive.segment {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Step\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n             Step\n*******************************/\n/*--------------\n   Load Theme\n---------------*/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Step\n*******************************/\n/*-------------------\n       Group\n--------------------*/\n/*-------------------\n      Element\n--------------------*/\n/* Icon */\n/* Title */\n/* Description */\n/* Arrow */\n/* Mobile */\n/*-------------------\n       Types\n--------------------*/\n/* Vertical */\n/*-------------------\n      Variations\n--------------------*/\n/*-------------------\n       States\n--------------------*/\n/* Completed */\n/* Hover */\n/* Down */\n/* Active */\n/* Active + Hover */\n/* Disabled */\n/* Packaged Theme */\n/*******************************\n             Step\n*******************************/\n/*-------------------\n       Group\n--------------------*/\n/*-------------------\n      Element\n--------------------*/\n/* Icon */\n/* Title */\n/* Description */\n/* Arrow */\n/* Mobile */\n/*-------------------\n       Types\n--------------------*/\n/* Vertical */\n/*-------------------\n      Variations\n--------------------*/\n/*-------------------\n       States\n--------------------*/\n/* Completed */\n/* Hover */\n/* Down */\n/* Active */\n/* Active + Hover */\n/* Disabled */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Plural\n*******************************/\n.ui.steps {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: stretch;\n  margin: 1em 0em;\n  background: '';\n  box-shadow: none;\n  line-height: 1.14285714em;\n  border-radius: 0.28571429rem;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n/* First Steps */\n.ui.steps:first-child {\n  margin-top: 0em;\n}\n/* Last Steps */\n.ui.steps:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n           Singular\n*******************************/\n.ui.steps .step {\n  position: relative;\n  display: flex;\n  flex: 1 0 auto;\n  flex-wrap: wrap;\n  flex-direction: row;\n  vertical-align: middle;\n  align-items: center;\n  justify-content: center;\n  margin: 0em 0em;\n  padding: 1.14285714em 2em;\n  background: #FFFFFF;\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: none;\n  border-radius: 0em;\n  border: none;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;\n}\n/* Arrow */\n.ui.steps .step:after {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  content: '';\n  top: 50%;\n  right: 0%;\n  border: medium none;\n  background-color: #FFFFFF;\n  width: 1.14285714em;\n  height: 1.14285714em;\n  border-style: solid;\n  border-color: rgba(255, 255, 255, 0.15);\n  border-width: 0px 1px 1px 0px;\n  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;\n  transform: translateY(-50%) translateX(50%) rotate(-45deg);\n}\n/* First Step */\n.ui.steps .step:first-child {\n  padding-left: 2em;\n  border-radius: 0.28571429rem 0em 0em 0.28571429rem;\n}\n/* Last Step */\n.ui.steps .step:last-child {\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n.ui.steps .step:last-child {\n  border-right: none;\n  margin-right: 0em;\n}\n/* Only Step */\n.ui.steps .step:only-child {\n  border-radius: 0.28571429rem;\n}\n/*******************************\n            Content\n*******************************/\n/* Title */\n.ui.steps .step .title {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1.14285714em;\n  font-weight: bold;\n}\n.ui.steps .step > .title {\n  width: 100%;\n}\n/* Description */\n.ui.steps .step .description {\n  font-weight: normal;\n  font-size: 0.92857143em;\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.steps .step > .description {\n  width: 100%;\n}\n.ui.steps .step .title ~ .description {\n  margin-top: 0.25em;\n}\n/* Icon */\n.ui.steps .step > .icon {\n  line-height: 1;\n  font-size: 2.5em;\n  margin: 0em 1rem 0em 0em;\n}\n.ui.steps .step > .icon,\n.ui.steps .step > .icon ~ .content {\n  display: block;\n  flex: 0 1 auto;\n  align-self: middle;\n}\n.ui.steps .step > .icon ~ .content {\n  flex-grow: 1 0 auto;\n}\n/* Horizontal Icon */\n.ui.steps:not(.vertical) .step > .icon {\n  width: auto;\n}\n/* Link */\n.ui.steps .link.step,\n.ui.steps a.step {\n  cursor: pointer;\n}\n/*******************************\n            Types\n*******************************/\n/*--------------\n     Ordered\n---------------*/\n.ui.ordered.steps {\n  counter-reset: ordered;\n}\n.ui.ordered.steps .step:before {\n  display: block;\n  position: static;\n  text-align: center;\n  content: counters(ordered, \".\");\n  align-self: middle;\n  margin-right: 1rem;\n  font-size: 2.5em;\n  counter-increment: ordered;\n  font-family: inherit;\n  font-weight: bold;\n}\n.ui.ordered.steps .step > * {\n  display: block;\n  align-self: middle;\n}\n/*--------------\n    Vertical\n---------------*/\n.ui.vertical.steps {\n  display: inline-flex;\n  flex-direction: column;\n  overflow: visible;\n}\n.ui.vertical.steps .step {\n  justify-content: flex-start;\n  border-radius: 0em;\n  padding: 1.14285714em 2em;\n  border-right: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.vertical.steps .step:first-child {\n  padding: 1.14285714em 2em;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.vertical.steps .step:last-child {\n  border-bottom: none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.vertical.steps .step:only-child {\n  border-radius: 0.28571429rem;\n}\n/* Arrow */\n.ui.vertical.steps .step:after {\n  display: none;\n}\n.ui.vertical.steps .step:after {\n  top: 50%;\n  right: 0%;\n  border-width: 0px 1px 1px 0px;\n}\n.ui.vertical.steps .step:after {\n  display: none;\n}\n.ui.vertical.steps .active.step:after {\n  display: block;\n}\n.ui.vertical.steps .step:last-child:after {\n  display: none;\n}\n.ui.vertical.steps .active.step:last-child:after {\n  display: block;\n}\n/*---------------\n    Responsive\n----------------*/\n/* Mobile (Default) */\n@media only screen and (max-width: 767px) {\n  .ui.steps:not(.unstackable) {\n    display: inline-flex;\n    overflow: visible;\n    flex-direction: column;\n  }\n  .ui.steps:not(.unstackable) .step {\n    width: 100% !important;\n    flex-direction: column;\n    border-radius: 0em;\n    padding: 1.14285714em 2em;\n  }\n  .ui.steps:not(.unstackable) .step:first-child {\n    padding: 1.14285714em 2em;\n    border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n  }\n  .ui.steps:not(.unstackable) .step:last-child {\n    border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  }\n  /* Arrow */\n  .ui.steps:not(.unstackable) .step:after {\n    display: none !important;\n  }\n  /* Content */\n  .ui.steps:not(.unstackable) .step .content {\n    text-align: center;\n  }\n  /* Icon */\n  .ui.steps:not(.unstackable) .step > .icon,\n  .ui.ordered.steps:not(.unstackable) .step:before {\n    margin: 0em 0em 1rem 0em;\n  }\n}\n/*******************************\n             States\n*******************************/\n/* Link Hover */\n.ui.steps .link.step:hover::after,\n.ui.steps .link.step:hover,\n.ui.steps a.step:hover::after,\n.ui.steps a.step:hover {\n  background: #F9FAFB;\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Link Down */\n.ui.steps .link.step:active::after,\n.ui.steps .link.step:active,\n.ui.steps a.step:active::after,\n.ui.steps a.step:active {\n  background: #F3F4F5;\n  color: rgba(255, 255, 255, 0.9);\n}\n/* Active */\n.ui.steps .step.active {\n  cursor: auto;\n  background: #F3F4F5;\n}\n.ui.steps .step.active:after {\n  background: #F3F4F5;\n}\n.ui.steps .step.active .title {\n  color: #4183C4;\n}\n.ui.ordered.steps .step.active:before,\n.ui.steps .active.step .icon {\n  color: rgba(255, 255, 255, 0.85);\n}\n/* Active Arrow */\n.ui.steps .step:after {\n  display: block;\n}\n.ui.steps .active.step:after {\n  display: block;\n}\n.ui.steps .step:last-child:after {\n  display: none;\n}\n.ui.steps .active.step:last-child:after {\n  display: none;\n}\n/* Active Hover */\n.ui.steps .link.active.step:hover::after,\n.ui.steps .link.active.step:hover,\n.ui.steps a.active.step:hover::after,\n.ui.steps a.active.step:hover {\n  cursor: pointer;\n  background: #DCDDDE;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Completed */\n.ui.steps .step.completed > .icon:before,\n.ui.ordered.steps .step.completed:before {\n  color: #21BA45;\n}\n/* Disabled */\n.ui.steps .disabled.step {\n  cursor: auto;\n  background: #FFFFFF;\n  pointer-events: none;\n}\n.ui.steps .disabled.step,\n.ui.steps .disabled.step .title,\n.ui.steps .disabled.step .description {\n  color: rgba(40, 40, 40, 0.3);\n}\n.ui.steps .disabled.step:after {\n  background: #FFFFFF;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n   Stackable\n---------------*/\n/* Tablet Or Below */\n@media only screen and (max-width: 991px) {\n  .ui[class*=\"tablet stackable\"].steps {\n    display: inline-flex;\n    overflow: visible;\n    flex-direction: column;\n  }\n  /* Steps */\n  .ui[class*=\"tablet stackable\"].steps .step {\n    flex-direction: column;\n    border-radius: 0em;\n    padding: 1.14285714em 2em;\n  }\n  .ui[class*=\"tablet stackable\"].steps .step:first-child {\n    padding: 1.14285714em 2em;\n    border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n  }\n  .ui[class*=\"tablet stackable\"].steps .step:last-child {\n    border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  }\n  /* Arrow */\n  .ui[class*=\"tablet stackable\"].steps .step:after {\n    display: none !important;\n  }\n  /* Content */\n  .ui[class*=\"tablet stackable\"].steps .step .content {\n    text-align: center;\n  }\n  /* Icon */\n  .ui[class*=\"tablet stackable\"].steps .step > .icon,\n  .ui[class*=\"tablet stackable\"].ordered.steps .step:before {\n    margin: 0em 0em 1rem 0em;\n  }\n}\n/*--------------\n      Fluid\n---------------*/\n/* Fluid */\n.ui.fluid.steps {\n  display: flex;\n  width: 100%;\n}\n/*--------------\n    Attached\n---------------*/\n/* Top */\n.ui.attached.steps {\n  width: calc(100% + (--1px * 2)) !important;\n  margin: 0em -1px 0;\n  max-width: calc(100% + (--1px * 2));\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.attached.steps .step:first-child {\n  border-radius: 0.28571429rem 0em 0em 0em;\n}\n.ui.attached.steps .step:last-child {\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n/* Bottom */\n.ui.bottom.attached.steps {\n  margin: 0 -1px 0em;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.bottom.attached.steps .step:first-child {\n  border-radius: 0em 0em 0em 0.28571429rem;\n}\n.ui.bottom.attached.steps .step:last-child {\n  border-radius: 0em 0em 0.28571429rem 0em;\n}\n/*-------------------\n    Evenly Divided\n--------------------*/\n.ui.one.steps,\n.ui.two.steps,\n.ui.three.steps,\n.ui.four.steps,\n.ui.five.steps,\n.ui.six.steps,\n.ui.seven.steps,\n.ui.eight.steps {\n  width: 100%;\n}\n.ui.one.steps > .step,\n.ui.two.steps > .step,\n.ui.three.steps > .step,\n.ui.four.steps > .step,\n.ui.five.steps > .step,\n.ui.six.steps > .step,\n.ui.seven.steps > .step,\n.ui.eight.steps > .step {\n  flex-wrap: nowrap;\n}\n.ui.one.steps > .step {\n  width: 100%;\n}\n.ui.two.steps > .step {\n  width: 50%;\n}\n.ui.three.steps > .step {\n  width: 33.333%;\n}\n.ui.four.steps > .step {\n  width: 25%;\n}\n.ui.five.steps > .step {\n  width: 20%;\n}\n.ui.six.steps > .step {\n  width: 16.666%;\n}\n.ui.seven.steps > .step {\n  width: 14.285%;\n}\n.ui.eight.steps > .step {\n  width: 12.5%;\n}\n/*-------------------\n       Sizes\n--------------------*/\n.ui.mini.steps .step,\n.ui.mini.step {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.steps .step,\n.ui.tiny.step {\n  font-size: 0.85714286rem;\n}\n.ui.small.steps .step,\n.ui.small.step {\n  font-size: 0.92857143rem;\n}\n.ui.steps .step,\n.ui.step {\n  font-size: 1rem;\n}\n.ui.large.steps .step,\n.ui.large.step {\n  font-size: 1.14285714rem;\n}\n.ui.big.steps .step,\n.ui.big.step {\n  font-size: 1.28571429rem;\n}\n.ui.huge.steps .step,\n.ui.huge.step {\n  font-size: 1.42857143rem;\n}\n.ui.massive.steps .step,\n.ui.massive.step {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n@font-face {\n  font-family: 'Step';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,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) format('woff');\n}\n.ui.steps .step.completed > .icon:before,\n.ui.ordered.steps .step.completed:before {\n  font-family: 'Step';\n  content: '\\e800';\n  /* '' */\n}\n/* Collections */\n/*!\n * # Semantic UI - Breadcrumb\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n          Breadcrumb\n*******************************/\n/*-------------------\n     Breadcrumb\n--------------------*/\n/* Coupling */\n/*-------------------\n       States\n--------------------*/\n/* Packaged Theme */\n/*******************************\n          Breadcrumb\n*******************************/\n/*-------------------\n     Breadcrumb\n--------------------*/\n/* Coupling */\n/*-------------------\n       States\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           Breadcrumb\n*******************************/\n.ui.breadcrumb {\n  line-height: 1;\n  display: inline-block;\n  margin: 0em 0em;\n  vertical-align: middle;\n}\n.ui.breadcrumb:first-child {\n  margin-top: 0em;\n}\n.ui.breadcrumb:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n          Content\n*******************************/\n/* Divider */\n.ui.breadcrumb .divider {\n  display: inline-block;\n  opacity: 0.7;\n  margin: 0em 0.21428571rem 0em;\n  font-size: 0.92857143em;\n  color: rgba(255, 255, 255, 0.4);\n  vertical-align: baseline;\n}\n/* Link */\n.ui.breadcrumb a {\n  color: #4183C4;\n}\n.ui.breadcrumb a:hover {\n  color: #1e70bf;\n}\n/* Icon Divider */\n.ui.breadcrumb .icon.divider {\n  font-size: 0.85714286em;\n  vertical-align: baseline;\n}\n/* Section */\n.ui.breadcrumb a.section {\n  cursor: pointer;\n}\n.ui.breadcrumb .section {\n  display: inline-block;\n  margin: 0em;\n  padding: 0em;\n}\n/* Loose Coupling */\n.ui.breadcrumb.segment {\n  display: inline-block;\n  padding: 0.78571429em 1em;\n}\n/*******************************\n            States\n*******************************/\n.ui.breadcrumb .active.section {\n  font-weight: bold;\n}\n/*******************************\n           Variations\n*******************************/\n.ui.mini.breadcrumb {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.breadcrumb {\n  font-size: 0.85714286rem;\n}\n.ui.small.breadcrumb {\n  font-size: 0.92857143rem;\n}\n.ui.breadcrumb {\n  font-size: 1rem;\n}\n.ui.large.breadcrumb {\n  font-size: 1.14285714rem;\n}\n.ui.big.breadcrumb {\n  font-size: 1.28571429rem;\n}\n.ui.huge.breadcrumb {\n  font-size: 1.42857143rem;\n}\n.ui.massive.breadcrumb {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Form\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Form\n*******************************/\n/*-------------------\n       Elements\n--------------------*/\n/* Form */\n/* Text */\n/* Field */\n/* Fields */\n/* Form Label */\n/* Input */\n/* Select */\n/* Text Area */\n/* Checkbox */\n/* Inline Validation Prompt */\n/*-------------------\n        States\n--------------------*/\n/* Focus */\n/* Input Focus */\n/* Text Area Focus */\n/* Disabled */\n/* Errored Input */\n/* AutoFill */\n/* Input Error */\n/* Dropdown Error */\n/* Focused Error */\n/* Placeholder Error */\n/* Loading Dimmer */\n/* Loading Spinner */\n/*-------------------\n        Types\n--------------------*/\n/* Required */\n/* Inverted */\n/*-------------------\n      Variations\n--------------------*/\n/* Grouped Fields */\n/* Inline */\n/*-------------------\n       Groups\n--------------------*/\n/* Packaged Theme */\n/*******************************\n             Form\n*******************************/\n/*-------------------\n       Elements\n--------------------*/\n/* Form */\n/* Text */\n/* Field */\n/* Fields */\n/* Form Label */\n/* Input */\n/* Select */\n/* Text Area */\n/* Checkbox */\n/* Inline Validation Prompt */\n/*-------------------\n        States\n--------------------*/\n/* Focus */\n/* Input Focus */\n/* Text Area Focus */\n/* Disabled */\n/* Errored Input */\n/* AutoFill */\n/* Input Error */\n/* Dropdown Error */\n/* Focused Error */\n/* Placeholder Error */\n/* Loading Dimmer */\n/* Loading Spinner */\n/*-------------------\n        Types\n--------------------*/\n/* Required */\n/* Inverted */\n/*-------------------\n      Variations\n--------------------*/\n/* Grouped Fields */\n/* Inline */\n/*-------------------\n       Groups\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Elements\n*******************************/\n/*--------------------\n        Form\n---------------------*/\n.ui.form {\n  position: relative;\n  max-width: 100%;\n}\n/*--------------------\n        Content\n---------------------*/\n.ui.form > p {\n  margin: 1em 0em;\n}\n/*--------------------\n        Field\n---------------------*/\n.ui.form .field {\n  clear: both;\n  margin: 0em 0em 1em;\n}\n.ui.form .field:last-child,\n.ui.form .fields:last-child .field {\n  margin-bottom: 0em;\n}\n.ui.form .fields .field {\n  clear: both;\n  margin: 0em;\n}\n/*--------------------\n        Labels\n---------------------*/\n.ui.form .field > label {\n  display: block;\n  margin: 0em 0em 0.28571429rem 0em;\n  color: rgba(255, 255, 255, 0.87);\n  font-size: 0.92857143em;\n  font-weight: bold;\n  text-transform: none;\n}\n/*--------------------\n    Standard Inputs\n---------------------*/\n.ui.form textarea,\n.ui.form input:not([type]),\n.ui.form input[type=\"date\"],\n.ui.form input[type=\"datetime-local\"],\n.ui.form input[type=\"email\"],\n.ui.form input[type=\"number\"],\n.ui.form input[type=\"password\"],\n.ui.form input[type=\"search\"],\n.ui.form input[type=\"tel\"],\n.ui.form input[type=\"time\"],\n.ui.form input[type=\"text\"],\n.ui.form input[type=\"file\"],\n.ui.form input[type=\"url\"] {\n  width: 100%;\n  vertical-align: top;\n}\n/* Set max height on unusual input */\n.ui.form ::-webkit-datetime-edit,\n.ui.form ::-webkit-inner-spin-button {\n  height: 1.21428571em;\n}\n.ui.form input:not([type]),\n.ui.form input[type=\"date\"],\n.ui.form input[type=\"datetime-local\"],\n.ui.form input[type=\"email\"],\n.ui.form input[type=\"number\"],\n.ui.form input[type=\"password\"],\n.ui.form input[type=\"search\"],\n.ui.form input[type=\"tel\"],\n.ui.form input[type=\"time\"],\n.ui.form input[type=\"text\"],\n.ui.form input[type=\"file\"],\n.ui.form input[type=\"url\"] {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  line-height: 1.21428571em;\n  padding: 0.67857143em 1em;\n  font-size: 1em;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.87);\n  border-radius: 0.28571429rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: color 0.1s ease, border-color 0.1s ease;\n}\n/* Text Area */\n.ui.form textarea {\n  margin: 0em;\n  -webkit-appearance: none;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  padding: 0.78571429em 1em;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  outline: none;\n  color: rgba(255, 255, 255, 0.87);\n  border-radius: 0.28571429rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: color 0.1s ease, border-color 0.1s ease;\n  font-size: 1em;\n  line-height: 1.2857;\n  resize: vertical;\n}\n.ui.form textarea:not([rows]) {\n  height: 12em;\n  min-height: 8em;\n  max-height: 24em;\n}\n.ui.form textarea,\n.ui.form input[type=\"checkbox\"] {\n  vertical-align: top;\n}\n/*--------------------------\n  Input w/ attached Button\n---------------------------*/\n.ui.form input.attached {\n  width: auto;\n}\n/*--------------------\n     Basic Select\n---------------------*/\n.ui.form select {\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #FFFFFF;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  padding: 0.62em 1em;\n  color: rgba(255, 255, 255, 0.87);\n  transition: color 0.1s ease, border-color 0.1s ease;\n}\n/*--------------------\n       Dropdown\n---------------------*/\n/* Block */\n.ui.form .field > .selection.dropdown {\n  width: 100%;\n}\n.ui.form .field > .selection.dropdown > .dropdown.icon {\n  float: right;\n}\n/* Inline */\n.ui.form .inline.fields .field > .selection.dropdown,\n.ui.form .inline.field > .selection.dropdown {\n  width: auto;\n}\n.ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon,\n.ui.form .inline.field > .selection.dropdown > .dropdown.icon {\n  float: none;\n}\n/*--------------------\n       UI Input\n---------------------*/\n/* Block */\n.ui.form .field .ui.input,\n.ui.form .fields .field .ui.input,\n.ui.form .wide.field .ui.input {\n  width: 100%;\n}\n/* Inline  */\n.ui.form .inline.fields .field:not(.wide) .ui.input,\n.ui.form .inline.field:not(.wide) .ui.input {\n  width: auto;\n  vertical-align: middle;\n}\n/* Auto Input */\n.ui.form .fields .field .ui.input input,\n.ui.form .field .ui.input input {\n  width: auto;\n}\n/* Full Width Input */\n.ui.form .ten.fields .ui.input input,\n.ui.form .nine.fields .ui.input input,\n.ui.form .eight.fields .ui.input input,\n.ui.form .seven.fields .ui.input input,\n.ui.form .six.fields .ui.input input,\n.ui.form .five.fields .ui.input input,\n.ui.form .four.fields .ui.input input,\n.ui.form .three.fields .ui.input input,\n.ui.form .two.fields .ui.input input,\n.ui.form .wide.field .ui.input input {\n  flex: 1 0 auto;\n  width: 0px;\n}\n/*--------------------\n   Types of Messages\n---------------------*/\n.ui.form .success.message,\n.ui.form .warning.message,\n.ui.form .error.message {\n  display: none;\n}\n/* Assumptions */\n.ui.form .message:first-child {\n  margin-top: 0px;\n}\n/*--------------------\n   Validation Prompt\n---------------------*/\n.ui.form .field .prompt.label {\n  white-space: normal;\n  background: #FFFFFF !important;\n  border: 1px solid #E0B4B4 !important;\n  color: #FFFFFF !important;\n}\n.ui.form .inline.fields .field .prompt,\n.ui.form .inline.field .prompt {\n  vertical-align: top;\n  margin: -0.25em 0em -0.5em 0.5em;\n}\n.ui.form .inline.fields .field .prompt:before,\n.ui.form .inline.field .prompt:before {\n  border-width: 0px 0px 1px 1px;\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n/*******************************\n            States\n*******************************/\n/*--------------------\n      Autofilled\n---------------------*/\n.ui.form .field.field input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;\n  border-color: #E5DFA1 !important;\n}\n/* Focus */\n.ui.form .field.field input:-webkit-autofill:focus {\n  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;\n  border-color: #D5C315 !important;\n}\n/* Error */\n.ui.form .error.error input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px #FFFAF0 inset !important;\n  border-color: #E0B4B4 !important;\n}\n/*--------------------\n      Placeholder\n---------------------*/\n/* browsers require these rules separate */\n.ui.form ::-webkit-input-placeholder {\n  color: rgba(64, 64, 64, 0.87);\n}\n.ui.form :-ms-input-placeholder {\n  color: rgba(64, 64, 64, 0.87) !important;\n}\n.ui.form ::-moz-placeholder {\n  color: rgba(64, 64, 64, 0.87);\n}\n.ui.form :focus::-webkit-input-placeholder {\n  color: rgba(140, 140, 140, 0.87);\n}\n.ui.form :focus:-ms-input-placeholder {\n  color: rgba(140, 140, 140, 0.87) !important;\n}\n.ui.form :focus::-moz-placeholder {\n  color: rgba(140, 140, 140, 0.87);\n}\n/* Error Placeholder */\n.ui.form .error ::-webkit-input-placeholder {\n  color: #ffffff;\n}\n.ui.form .error :-ms-input-placeholder {\n  color: #ffffff !important;\n}\n.ui.form .error ::-moz-placeholder {\n  color: #ffffff;\n}\n.ui.form .error :focus::-webkit-input-placeholder {\n  color: #ffffff;\n}\n.ui.form .error :focus:-ms-input-placeholder {\n  color: #ffffff !important;\n}\n.ui.form .error :focus::-moz-placeholder {\n  color: #ffffff;\n}\n/*--------------------\n        Focus\n---------------------*/\n.ui.form input:not([type]):focus,\n.ui.form input[type=\"date\"]:focus,\n.ui.form input[type=\"datetime-local\"]:focus,\n.ui.form input[type=\"email\"]:focus,\n.ui.form input[type=\"number\"]:focus,\n.ui.form input[type=\"password\"]:focus,\n.ui.form input[type=\"search\"]:focus,\n.ui.form input[type=\"tel\"]:focus,\n.ui.form input[type=\"time\"]:focus,\n.ui.form input[type=\"text\"]:focus,\n.ui.form input[type=\"file\"]:focus,\n.ui.form input[type=\"url\"]:focus {\n  color: rgba(255, 255, 255, 0.95);\n  border-color: #85B7D9;\n  border-radius: 0.28571429rem;\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: 0px 0em 0em 0em rgba(255, 255, 255, 0.35) inset;\n}\n.ui.form textarea:focus {\n  color: rgba(255, 255, 255, 0.95);\n  border-color: #85B7D9;\n  border-radius: 0.28571429rem;\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: 0px 0em 0em 0em rgba(255, 255, 255, 0.35) inset;\n  -webkit-appearance: none;\n}\n/*--------------------\n        Success\n---------------------*/\n/* On Form */\n.ui.form.success .success.message:not(:empty) {\n  display: block;\n}\n.ui.form.success .compact.success.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.success .icon.success.message:not(:empty) {\n  display: flex;\n}\n/*--------------------\n        Warning\n---------------------*/\n/* On Form */\n.ui.form.warning .warning.message:not(:empty) {\n  display: block;\n}\n.ui.form.warning .compact.warning.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.warning .icon.warning.message:not(:empty) {\n  display: flex;\n}\n/*--------------------\n        Error\n---------------------*/\n/* On Form */\n.ui.form.error .error.message:not(:empty) {\n  display: block;\n}\n.ui.form.error .compact.error.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.error .icon.error.message:not(:empty) {\n  display: flex;\n}\n/* On Field(s) */\n.ui.form .fields.error .field label,\n.ui.form .field.error label,\n.ui.form .fields.error .field .input,\n.ui.form .field.error .input {\n  color: #FFFFFF;\n}\n.ui.form .fields.error .field .corner.label,\n.ui.form .field.error .corner.label {\n  border-color: #FFFFFF;\n  color: #FFFFFF;\n}\n.ui.form .fields.error .field textarea,\n.ui.form .fields.error .field select,\n.ui.form .fields.error .field input:not([type]),\n.ui.form .fields.error .field input[type=\"date\"],\n.ui.form .fields.error .field input[type=\"datetime-local\"],\n.ui.form .fields.error .field input[type=\"email\"],\n.ui.form .fields.error .field input[type=\"number\"],\n.ui.form .fields.error .field input[type=\"password\"],\n.ui.form .fields.error .field input[type=\"search\"],\n.ui.form .fields.error .field input[type=\"tel\"],\n.ui.form .fields.error .field input[type=\"time\"],\n.ui.form .fields.error .field input[type=\"text\"],\n.ui.form .fields.error .field input[type=\"file\"],\n.ui.form .fields.error .field input[type=\"url\"],\n.ui.form .field.error textarea,\n.ui.form .field.error select,\n.ui.form .field.error input:not([type]),\n.ui.form .field.error input[type=\"date\"],\n.ui.form .field.error input[type=\"datetime-local\"],\n.ui.form .field.error input[type=\"email\"],\n.ui.form .field.error input[type=\"number\"],\n.ui.form .field.error input[type=\"password\"],\n.ui.form .field.error input[type=\"search\"],\n.ui.form .field.error input[type=\"tel\"],\n.ui.form .field.error input[type=\"time\"],\n.ui.form .field.error input[type=\"text\"],\n.ui.form .field.error input[type=\"file\"],\n.ui.form .field.error input[type=\"url\"] {\n  background: rgba(200, 3, 3, 0.15);\n  border-color: #E0B4B4;\n  color: #FFFFFF;\n  border-radius: '';\n  box-shadow: none;\n}\n.ui.form .field.error textarea:focus,\n.ui.form .field.error select:focus,\n.ui.form .field.error input:not([type]):focus,\n.ui.form .field.error input[type=\"date\"]:focus,\n.ui.form .field.error input[type=\"datetime-local\"]:focus,\n.ui.form .field.error input[type=\"email\"]:focus,\n.ui.form .field.error input[type=\"number\"]:focus,\n.ui.form .field.error input[type=\"password\"]:focus,\n.ui.form .field.error input[type=\"search\"]:focus,\n.ui.form .field.error input[type=\"tel\"]:focus,\n.ui.form .field.error input[type=\"time\"]:focus,\n.ui.form .field.error input[type=\"text\"]:focus,\n.ui.form .field.error input[type=\"file\"]:focus,\n.ui.form .field.error input[type=\"url\"]:focus {\n  background: rgba(200, 3, 3, 0.15);\n  border-color: #E0B4B4;\n  color: #FFFFFF;\n  -webkit-appearance: none;\n  box-shadow: none;\n}\n/* Preserve Native Select Stylings */\n.ui.form .field.error select {\n  -webkit-appearance: menulist-button;\n}\n/*------------------\n    Dropdown Error\n--------------------*/\n.ui.form .fields.error .field .ui.dropdown,\n.ui.form .fields.error .field .ui.dropdown .item,\n.ui.form .field.error .ui.dropdown,\n.ui.form .field.error .ui.dropdown .text,\n.ui.form .field.error .ui.dropdown .item {\n  background: rgba(200, 3, 3, 0.15);\n  color: #FFFFFF;\n}\n.ui.form .fields.error .field .ui.dropdown,\n.ui.form .field.error .ui.dropdown {\n  border-color: #E0B4B4 !important;\n}\n.ui.form .fields.error .field .ui.dropdown:hover,\n.ui.form .field.error .ui.dropdown:hover {\n  border-color: #E0B4B4 !important;\n}\n.ui.form .fields.error .field .ui.dropdown:hover .menu,\n.ui.form .field.error .ui.dropdown:hover .menu {\n  border-color: #E0B4B4;\n}\n.ui.form .fields.error .field .ui.multiple.selection.dropdown > .label,\n.ui.form .field.error .ui.multiple.selection.dropdown > .label {\n  background-color: #EACBCB;\n  color: #FFFFFF;\n}\n/* Hover */\n.ui.form .fields.error .field .ui.dropdown .menu .item:hover,\n.ui.form .field.error .ui.dropdown .menu .item:hover {\n  background-color: #FBE7E7;\n}\n/* Selected */\n.ui.form .fields.error .field .ui.dropdown .menu .selected.item,\n.ui.form .field.error .ui.dropdown .menu .selected.item {\n  background-color: #FBE7E7;\n}\n/* Active */\n.ui.form .fields.error .field .ui.dropdown .menu .active.item,\n.ui.form .field.error .ui.dropdown .menu .active.item {\n  background-color: #FDCFCF !important;\n}\n/*--------------------\n    Checkbox Error\n---------------------*/\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) label,\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {\n  color: #FFFFFF;\n}\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before,\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {\n  background: rgba(200, 3, 3, 0.15);\n  border-color: #E0B4B4;\n}\n.ui.form .fields.error .field .checkbox label:after,\n.ui.form .field.error .checkbox label:after,\n.ui.form .fields.error .field .checkbox .box:after,\n.ui.form .field.error .checkbox .box:after {\n  color: #FFFFFF;\n}\n/*--------------------\n       Disabled\n---------------------*/\n.ui.form .disabled.fields .field,\n.ui.form .disabled.field,\n.ui.form .field :disabled {\n  pointer-events: none;\n  opacity: 0.45;\n}\n.ui.form .field.disabled > label,\n.ui.form .fields.disabled > label {\n  opacity: 0.45;\n}\n.ui.form .field.disabled :disabled {\n  opacity: 1;\n}\n/*--------------\n    Loading\n---------------*/\n.ui.loading.form {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n}\n.ui.loading.form:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: rgba(255, 255, 255, 0.8);\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n.ui.loading.form:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -1.5em 0em 0em -1.5em;\n  width: 3em;\n  height: 3em;\n  animation: form-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: 101;\n}\n@keyframes form-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/*******************************\n         Element Types\n*******************************/\n/*--------------------\n     Required Field\n---------------------*/\n.ui.form .required.fields:not(.grouped) > .field > label:after,\n.ui.form .required.fields.grouped > label:after,\n.ui.form .required.field > label:after,\n.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n.ui.form .required.field > .checkbox:after {\n  margin: -0.2em 0em 0em 0.2em;\n  content: '*';\n  color: #DB2828;\n}\n.ui.form .required.fields:not(.grouped) > .field > label:after,\n.ui.form .required.fields.grouped > label:after,\n.ui.form .required.field > label:after {\n  display: inline-block;\n  vertical-align: top;\n}\n.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n.ui.form .required.field > .checkbox:after {\n  position: absolute;\n  top: 0%;\n  left: 100%;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------------\n    Inverted Colors\n---------------------*/\n.ui.inverted.form label,\n.ui.form .inverted.segment label,\n.ui.form .inverted.segment .ui.checkbox label,\n.ui.form .inverted.segment .ui.checkbox .box,\n.ui.inverted.form .ui.checkbox label,\n.ui.inverted.form .ui.checkbox .box,\n.ui.inverted.form .inline.fields > label,\n.ui.inverted.form .inline.fields .field > label,\n.ui.inverted.form .inline.fields .field > p,\n.ui.inverted.form .inline.field > label,\n.ui.inverted.form .inline.field > p {\n  color: rgba(255, 255, 255, 0.9);\n}\n/* Inverted Field */\n.ui.inverted.form input:not([type]),\n.ui.inverted.form input[type=\"date\"],\n.ui.inverted.form input[type=\"datetime-local\"],\n.ui.inverted.form input[type=\"email\"],\n.ui.inverted.form input[type=\"number\"],\n.ui.inverted.form input[type=\"password\"],\n.ui.inverted.form input[type=\"search\"],\n.ui.inverted.form input[type=\"tel\"],\n.ui.inverted.form input[type=\"time\"],\n.ui.inverted.form input[type=\"text\"],\n.ui.inverted.form input[type=\"file\"],\n.ui.inverted.form input[type=\"url\"] {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: none;\n}\n/*--------------------\n     Field Groups\n---------------------*/\n/* Grouped Vertically */\n.ui.form .grouped.fields {\n  display: block;\n  margin: 0em 0em 1em;\n}\n.ui.form .grouped.fields:last-child {\n  margin-bottom: 0em;\n}\n.ui.form .grouped.fields > label {\n  margin: 0em 0em 0.28571429rem 0em;\n  color: rgba(255, 255, 255, 0.87);\n  font-size: 0.92857143em;\n  font-weight: bold;\n  text-transform: none;\n}\n.ui.form .grouped.fields .field,\n.ui.form .grouped.inline.fields .field {\n  display: block;\n  margin: 0.5em 0em;\n  padding: 0em;\n}\n/*--------------------\n        Fields\n---------------------*/\n/* Split fields */\n.ui.form .fields {\n  display: flex;\n  flex-direction: row;\n  margin: 0em -0.5em 1em;\n}\n.ui.form .fields > .field {\n  flex: 0 1 auto;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n.ui.form .fields > .field:first-child {\n  border-left: none;\n  box-shadow: none;\n}\n/* Other Combinations */\n.ui.form .two.fields > .fields,\n.ui.form .two.fields > .field {\n  width: 50%;\n}\n.ui.form .three.fields > .fields,\n.ui.form .three.fields > .field {\n  width: 33.33333333%;\n}\n.ui.form .four.fields > .fields,\n.ui.form .four.fields > .field {\n  width: 25%;\n}\n.ui.form .five.fields > .fields,\n.ui.form .five.fields > .field {\n  width: 20%;\n}\n.ui.form .six.fields > .fields,\n.ui.form .six.fields > .field {\n  width: 16.66666667%;\n}\n.ui.form .seven.fields > .fields,\n.ui.form .seven.fields > .field {\n  width: 14.28571429%;\n}\n.ui.form .eight.fields > .fields,\n.ui.form .eight.fields > .field {\n  width: 12.5%;\n}\n.ui.form .nine.fields > .fields,\n.ui.form .nine.fields > .field {\n  width: 11.11111111%;\n}\n.ui.form .ten.fields > .fields,\n.ui.form .ten.fields > .field {\n  width: 10%;\n}\n/* Swap to full width on mobile */\n@media only screen and (max-width: 767px) {\n  .ui.form .fields {\n    flex-wrap: wrap;\n  }\n  .ui[class*=\"equal width\"].form:not(.unstackable) .fields > .field,\n  .ui.form:not(.unstackable) [class*=\"equal width\"].fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {\n    width: 100% !important;\n    margin: 0em 0em 1em;\n  }\n}\n/* Sizing Combinations */\n.ui.form .fields .wide.field {\n  width: 6.25%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n.ui.form .one.wide.field {\n  width: 6.25% !important;\n}\n.ui.form .two.wide.field {\n  width: 12.5% !important;\n}\n.ui.form .three.wide.field {\n  width: 18.75% !important;\n}\n.ui.form .four.wide.field {\n  width: 25% !important;\n}\n.ui.form .five.wide.field {\n  width: 31.25% !important;\n}\n.ui.form .six.wide.field {\n  width: 37.5% !important;\n}\n.ui.form .seven.wide.field {\n  width: 43.75% !important;\n}\n.ui.form .eight.wide.field {\n  width: 50% !important;\n}\n.ui.form .nine.wide.field {\n  width: 56.25% !important;\n}\n.ui.form .ten.wide.field {\n  width: 62.5% !important;\n}\n.ui.form .eleven.wide.field {\n  width: 68.75% !important;\n}\n.ui.form .twelve.wide.field {\n  width: 75% !important;\n}\n.ui.form .thirteen.wide.field {\n  width: 81.25% !important;\n}\n.ui.form .fourteen.wide.field {\n  width: 87.5% !important;\n}\n.ui.form .fifteen.wide.field {\n  width: 93.75% !important;\n}\n.ui.form .sixteen.wide.field {\n  width: 100% !important;\n}\n/* Swap to full width on mobile */\n@media only screen and (max-width: 767px) {\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {\n    width: 100% !important;\n  }\n  .ui.form .fields {\n    margin-bottom: 0em;\n  }\n}\n/*--------------------\n     Equal Width\n---------------------*/\n.ui[class*=\"equal width\"].form .fields > .field,\n.ui.form [class*=\"equal width\"].fields > .field {\n  width: 100%;\n  flex: 1 1 auto;\n}\n/*--------------------\n    Inline Fields\n---------------------*/\n.ui.form .inline.fields {\n  margin: 0em 0em 1em;\n  align-items: center;\n}\n.ui.form .inline.fields .field {\n  margin: 0em;\n  padding: 0em 1em 0em 0em;\n}\n/* Inline Label */\n.ui.form .inline.fields > label,\n.ui.form .inline.fields .field > label,\n.ui.form .inline.fields .field > p,\n.ui.form .inline.field > label,\n.ui.form .inline.field > p {\n  display: inline-block;\n  width: auto;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  vertical-align: baseline;\n  font-size: 0.92857143em;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.87);\n  text-transform: none;\n}\n/* Grouped Inline Label */\n.ui.form .inline.fields > label {\n  margin: 0.035714em 1em 0em 0em;\n}\n/* Inline Input */\n.ui.form .inline.fields .field > input,\n.ui.form .inline.fields .field > select,\n.ui.form .inline.field > input,\n.ui.form .inline.field > select {\n  display: inline-block;\n  width: auto;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  vertical-align: middle;\n  font-size: 1em;\n}\n/* Label */\n.ui.form .inline.fields .field > :first-child,\n.ui.form .inline.field > :first-child {\n  margin: 0em 0.85714286em 0em 0em;\n}\n.ui.form .inline.fields .field > :only-child,\n.ui.form .inline.field > :only-child {\n  margin: 0em;\n}\n/* Wide */\n.ui.form .inline.fields .wide.field {\n  display: flex;\n  align-items: center;\n}\n.ui.form .inline.fields .wide.field > input,\n.ui.form .inline.fields .wide.field > select {\n  width: 100%;\n}\n/*--------------------\n        Sizes\n---------------------*/\n.ui.mini.form {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.form {\n  font-size: 0.85714286rem;\n}\n.ui.small.form {\n  font-size: 0.92857143rem;\n}\n.ui.form {\n  font-size: 1rem;\n}\n.ui.large.form {\n  font-size: 1.14285714rem;\n}\n.ui.big.form {\n  font-size: 1.28571429rem;\n}\n.ui.huge.form {\n  font-size: 1.42857143rem;\n}\n.ui.massive.form {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Grid\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Grid\n*******************************/\n/* Inherited From Site */\n/*******************************\n            Grid\n*******************************/\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Relaxed\n---------------*/\n/*--------------\n     Divided\n---------------*/\n/*--------------\n    Celled\n---------------*/\n/*--------------\n    Stackable\n---------------*/\n/*******************************\n             Legacy\n*******************************/\n/*--------------\n     Page\n---------------*/\n/* Legacy (DO NOT USE)\n */\n/* Packaged Theme */\n/*******************************\n             Grid\n*******************************/\n/* Inherited From Site */\n/*******************************\n            Grid\n*******************************/\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Relaxed\n---------------*/\n/*--------------\n     Divided\n---------------*/\n/*--------------\n    Celled\n---------------*/\n/*--------------\n    Stackable\n---------------*/\n/*******************************\n             Legacy\n*******************************/\n/*--------------\n     Page\n---------------*/\n/* Legacy (DO NOT USE)\n */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Standard\n*******************************/\n.ui.grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  padding: 0em;\n}\n/*----------------------\n      Remove Gutters\n-----------------------*/\n.ui.grid {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.ui.relaxed.grid {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n.ui[class*=\"very relaxed\"].grid {\n  margin-left: -2.5rem;\n  margin-right: -2.5rem;\n}\n/* Preserve Rows Spacing on Consecutive Grids */\n.ui.grid + .grid {\n  margin-top: 1rem;\n}\n/*-------------------\n       Columns\n--------------------*/\n/* Standard 16 column */\n.ui.grid > .column:not(.row),\n.ui.grid > .row > .column {\n  position: relative;\n  display: inline-block;\n  width: 6.25%;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  vertical-align: top;\n}\n.ui.grid > * {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n/*-------------------\n        Rows\n--------------------*/\n.ui.grid > .row {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: inherit;\n  align-items: stretch;\n  width: 100% !important;\n  padding: 0rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n/*-------------------\n       Columns\n--------------------*/\n/* Vertical padding when no rows */\n.ui.grid > .column:not(.row) {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.ui.grid > .row > .column {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n/*-------------------\n      Content\n--------------------*/\n.ui.grid > .row > img,\n.ui.grid > .row > .column > img {\n  max-width: 100%;\n}\n/*-------------------\n    Loose Coupling\n--------------------*/\n/* Collapse Margin on Consecutive Grid */\n.ui.grid > .ui.grid:first-child {\n  margin-top: 0em;\n}\n.ui.grid > .ui.grid:last-child {\n  margin-bottom: 0em;\n}\n/* Segment inside Aligned Grid */\n.ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached),\n.ui.aligned.grid .column > .segment:not(.compact):not(.attached) {\n  width: 100%;\n}\n/* Align Dividers with Gutter */\n.ui.grid .row + .ui.divider {\n  flex-grow: 1;\n  margin: 1rem 1rem;\n}\n.ui.grid .column + .ui.vertical.divider {\n  height: calc(50% - (2rem / 2));\n}\n/* Remove Border on Last Horizontal Segment */\n.ui.grid > .row > .column:last-child > .horizontal.segment,\n.ui.grid > .column:last-child > .horizontal.segment {\n  box-shadow: none;\n}\n/*******************************\n           Variations\n*******************************/\n/*-----------------------\n       Page Grid\n-------------------------*/\n@media only screen and (max-width: 767px) {\n  .ui.page.grid {\n    width: auto;\n    padding-left: 0em;\n    padding-right: 0em;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 2em;\n    padding-right: 2em;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 3%;\n    padding-right: 3%;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 15%;\n    padding-right: 15%;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 23%;\n    padding-right: 23%;\n  }\n}\n/*-------------------\n     Column Count\n--------------------*/\n/* Assume full width with one column */\n.ui.grid > .column:only-child,\n.ui.grid > .row > .column:only-child {\n  width: 100%;\n}\n/* Grid Based */\n.ui[class*=\"one column\"].grid > .row > .column,\n.ui[class*=\"one column\"].grid > .column:not(.row) {\n  width: 100%;\n}\n.ui[class*=\"two column\"].grid > .row > .column,\n.ui[class*=\"two column\"].grid > .column:not(.row) {\n  width: 50%;\n}\n.ui[class*=\"three column\"].grid > .row > .column,\n.ui[class*=\"three column\"].grid > .column:not(.row) {\n  width: 33.33333333%;\n}\n.ui[class*=\"four column\"].grid > .row > .column,\n.ui[class*=\"four column\"].grid > .column:not(.row) {\n  width: 25%;\n}\n.ui[class*=\"five column\"].grid > .row > .column,\n.ui[class*=\"five column\"].grid > .column:not(.row) {\n  width: 20%;\n}\n.ui[class*=\"six column\"].grid > .row > .column,\n.ui[class*=\"six column\"].grid > .column:not(.row) {\n  width: 16.66666667%;\n}\n.ui[class*=\"seven column\"].grid > .row > .column,\n.ui[class*=\"seven column\"].grid > .column:not(.row) {\n  width: 14.28571429%;\n}\n.ui[class*=\"eight column\"].grid > .row > .column,\n.ui[class*=\"eight column\"].grid > .column:not(.row) {\n  width: 12.5%;\n}\n.ui[class*=\"nine column\"].grid > .row > .column,\n.ui[class*=\"nine column\"].grid > .column:not(.row) {\n  width: 11.11111111%;\n}\n.ui[class*=\"ten column\"].grid > .row > .column,\n.ui[class*=\"ten column\"].grid > .column:not(.row) {\n  width: 10%;\n}\n.ui[class*=\"eleven column\"].grid > .row > .column,\n.ui[class*=\"eleven column\"].grid > .column:not(.row) {\n  width: 9.09090909%;\n}\n.ui[class*=\"twelve column\"].grid > .row > .column,\n.ui[class*=\"twelve column\"].grid > .column:not(.row) {\n  width: 8.33333333%;\n}\n.ui[class*=\"thirteen column\"].grid > .row > .column,\n.ui[class*=\"thirteen column\"].grid > .column:not(.row) {\n  width: 7.69230769%;\n}\n.ui[class*=\"fourteen column\"].grid > .row > .column,\n.ui[class*=\"fourteen column\"].grid > .column:not(.row) {\n  width: 7.14285714%;\n}\n.ui[class*=\"fifteen column\"].grid > .row > .column,\n.ui[class*=\"fifteen column\"].grid > .column:not(.row) {\n  width: 6.66666667%;\n}\n.ui[class*=\"sixteen column\"].grid > .row > .column,\n.ui[class*=\"sixteen column\"].grid > .column:not(.row) {\n  width: 6.25%;\n}\n/* Row Based Overrides */\n.ui.grid > [class*=\"one column\"].row > .column {\n  width: 100% !important;\n}\n.ui.grid > [class*=\"two column\"].row > .column {\n  width: 50% !important;\n}\n.ui.grid > [class*=\"three column\"].row > .column {\n  width: 33.33333333% !important;\n}\n.ui.grid > [class*=\"four column\"].row > .column {\n  width: 25% !important;\n}\n.ui.grid > [class*=\"five column\"].row > .column {\n  width: 20% !important;\n}\n.ui.grid > [class*=\"six column\"].row > .column {\n  width: 16.66666667% !important;\n}\n.ui.grid > [class*=\"seven column\"].row > .column {\n  width: 14.28571429% !important;\n}\n.ui.grid > [class*=\"eight column\"].row > .column {\n  width: 12.5% !important;\n}\n.ui.grid > [class*=\"nine column\"].row > .column {\n  width: 11.11111111% !important;\n}\n.ui.grid > [class*=\"ten column\"].row > .column {\n  width: 10% !important;\n}\n.ui.grid > [class*=\"eleven column\"].row > .column {\n  width: 9.09090909% !important;\n}\n.ui.grid > [class*=\"twelve column\"].row > .column {\n  width: 8.33333333% !important;\n}\n.ui.grid > [class*=\"thirteen column\"].row > .column {\n  width: 7.69230769% !important;\n}\n.ui.grid > [class*=\"fourteen column\"].row > .column {\n  width: 7.14285714% !important;\n}\n.ui.grid > [class*=\"fifteen column\"].row > .column {\n  width: 6.66666667% !important;\n}\n.ui.grid > [class*=\"sixteen column\"].row > .column {\n  width: 6.25% !important;\n}\n/* Celled Page */\n.ui.celled.page.grid {\n  box-shadow: none;\n}\n/*-------------------\n    Column Width\n--------------------*/\n/* Sizing Combinations */\n.ui.grid > .row > [class*=\"one wide\"].column,\n.ui.grid > .column.row > [class*=\"one wide\"].column,\n.ui.grid > [class*=\"one wide\"].column,\n.ui.column.grid > [class*=\"one wide\"].column {\n  width: 6.25% !important;\n}\n.ui.grid > .row > [class*=\"two wide\"].column,\n.ui.grid > .column.row > [class*=\"two wide\"].column,\n.ui.grid > [class*=\"two wide\"].column,\n.ui.column.grid > [class*=\"two wide\"].column {\n  width: 12.5% !important;\n}\n.ui.grid > .row > [class*=\"three wide\"].column,\n.ui.grid > .column.row > [class*=\"three wide\"].column,\n.ui.grid > [class*=\"three wide\"].column,\n.ui.column.grid > [class*=\"three wide\"].column {\n  width: 18.75% !important;\n}\n.ui.grid > .row > [class*=\"four wide\"].column,\n.ui.grid > .column.row > [class*=\"four wide\"].column,\n.ui.grid > [class*=\"four wide\"].column,\n.ui.column.grid > [class*=\"four wide\"].column {\n  width: 25% !important;\n}\n.ui.grid > .row > [class*=\"five wide\"].column,\n.ui.grid > .column.row > [class*=\"five wide\"].column,\n.ui.grid > [class*=\"five wide\"].column,\n.ui.column.grid > [class*=\"five wide\"].column {\n  width: 31.25% !important;\n}\n.ui.grid > .row > [class*=\"six wide\"].column,\n.ui.grid > .column.row > [class*=\"six wide\"].column,\n.ui.grid > [class*=\"six wide\"].column,\n.ui.column.grid > [class*=\"six wide\"].column {\n  width: 37.5% !important;\n}\n.ui.grid > .row > [class*=\"seven wide\"].column,\n.ui.grid > .column.row > [class*=\"seven wide\"].column,\n.ui.grid > [class*=\"seven wide\"].column,\n.ui.column.grid > [class*=\"seven wide\"].column {\n  width: 43.75% !important;\n}\n.ui.grid > .row > [class*=\"eight wide\"].column,\n.ui.grid > .column.row > [class*=\"eight wide\"].column,\n.ui.grid > [class*=\"eight wide\"].column,\n.ui.column.grid > [class*=\"eight wide\"].column {\n  width: 50% !important;\n}\n.ui.grid > .row > [class*=\"nine wide\"].column,\n.ui.grid > .column.row > [class*=\"nine wide\"].column,\n.ui.grid > [class*=\"nine wide\"].column,\n.ui.column.grid > [class*=\"nine wide\"].column {\n  width: 56.25% !important;\n}\n.ui.grid > .row > [class*=\"ten wide\"].column,\n.ui.grid > .column.row > [class*=\"ten wide\"].column,\n.ui.grid > [class*=\"ten wide\"].column,\n.ui.column.grid > [class*=\"ten wide\"].column {\n  width: 62.5% !important;\n}\n.ui.grid > .row > [class*=\"eleven wide\"].column,\n.ui.grid > .column.row > [class*=\"eleven wide\"].column,\n.ui.grid > [class*=\"eleven wide\"].column,\n.ui.column.grid > [class*=\"eleven wide\"].column {\n  width: 68.75% !important;\n}\n.ui.grid > .row > [class*=\"twelve wide\"].column,\n.ui.grid > .column.row > [class*=\"twelve wide\"].column,\n.ui.grid > [class*=\"twelve wide\"].column,\n.ui.column.grid > [class*=\"twelve wide\"].column {\n  width: 75% !important;\n}\n.ui.grid > .row > [class*=\"thirteen wide\"].column,\n.ui.grid > .column.row > [class*=\"thirteen wide\"].column,\n.ui.grid > [class*=\"thirteen wide\"].column,\n.ui.column.grid > [class*=\"thirteen wide\"].column {\n  width: 81.25% !important;\n}\n.ui.grid > .row > [class*=\"fourteen wide\"].column,\n.ui.grid > .column.row > [class*=\"fourteen wide\"].column,\n.ui.grid > [class*=\"fourteen wide\"].column,\n.ui.column.grid > [class*=\"fourteen wide\"].column {\n  width: 87.5% !important;\n}\n.ui.grid > .row > [class*=\"fifteen wide\"].column,\n.ui.grid > .column.row > [class*=\"fifteen wide\"].column,\n.ui.grid > [class*=\"fifteen wide\"].column,\n.ui.column.grid > [class*=\"fifteen wide\"].column {\n  width: 93.75% !important;\n}\n.ui.grid > .row > [class*=\"sixteen wide\"].column,\n.ui.grid > .column.row > [class*=\"sixteen wide\"].column,\n.ui.grid > [class*=\"sixteen wide\"].column,\n.ui.column.grid > [class*=\"sixteen wide\"].column {\n  width: 100% !important;\n}\n/*----------------------\n    Width per Device\n-----------------------*/\n/* Mobile Sizing Combinations */\n@media only screen and (min-width: 320px) and (max-width: 767px) {\n  .ui.grid > .row > [class*=\"one wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"one wide mobile\"].column,\n  .ui.grid > [class*=\"one wide mobile\"].column,\n  .ui.column.grid > [class*=\"one wide mobile\"].column {\n    width: 6.25% !important;\n  }\n  .ui.grid > .row > [class*=\"two wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"two wide mobile\"].column,\n  .ui.grid > [class*=\"two wide mobile\"].column,\n  .ui.column.grid > [class*=\"two wide mobile\"].column {\n    width: 12.5% !important;\n  }\n  .ui.grid > .row > [class*=\"three wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"three wide mobile\"].column,\n  .ui.grid > [class*=\"three wide mobile\"].column,\n  .ui.column.grid > [class*=\"three wide mobile\"].column {\n    width: 18.75% !important;\n  }\n  .ui.grid > .row > [class*=\"four wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"four wide mobile\"].column,\n  .ui.grid > [class*=\"four wide mobile\"].column,\n  .ui.column.grid > [class*=\"four wide mobile\"].column {\n    width: 25% !important;\n  }\n  .ui.grid > .row > [class*=\"five wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"five wide mobile\"].column,\n  .ui.grid > [class*=\"five wide mobile\"].column,\n  .ui.column.grid > [class*=\"five wide mobile\"].column {\n    width: 31.25% !important;\n  }\n  .ui.grid > .row > [class*=\"six wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"six wide mobile\"].column,\n  .ui.grid > [class*=\"six wide mobile\"].column,\n  .ui.column.grid > [class*=\"six wide mobile\"].column {\n    width: 37.5% !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide mobile\"].column,\n  .ui.grid > [class*=\"seven wide mobile\"].column,\n  .ui.column.grid > [class*=\"seven wide mobile\"].column {\n    width: 43.75% !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide mobile\"].column,\n  .ui.grid > [class*=\"eight wide mobile\"].column,\n  .ui.column.grid > [class*=\"eight wide mobile\"].column {\n    width: 50% !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide mobile\"].column,\n  .ui.grid > [class*=\"nine wide mobile\"].column,\n  .ui.column.grid > [class*=\"nine wide mobile\"].column {\n    width: 56.25% !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide mobile\"].column,\n  .ui.grid > [class*=\"ten wide mobile\"].column,\n  .ui.column.grid > [class*=\"ten wide mobile\"].column {\n    width: 62.5% !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide mobile\"].column,\n  .ui.grid > [class*=\"eleven wide mobile\"].column,\n  .ui.column.grid > [class*=\"eleven wide mobile\"].column {\n    width: 68.75% !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide mobile\"].column,\n  .ui.grid > [class*=\"twelve wide mobile\"].column,\n  .ui.column.grid > [class*=\"twelve wide mobile\"].column {\n    width: 75% !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide mobile\"].column,\n  .ui.grid > [class*=\"thirteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"thirteen wide mobile\"].column {\n    width: 81.25% !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide mobile\"].column,\n  .ui.grid > [class*=\"fourteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"fourteen wide mobile\"].column {\n    width: 87.5% !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide mobile\"].column,\n  .ui.grid > [class*=\"fifteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"fifteen wide mobile\"].column {\n    width: 93.75% !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide mobile\"].column,\n  .ui.grid > [class*=\"sixteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"sixteen wide mobile\"].column {\n    width: 100% !important;\n  }\n}\n/* Tablet Sizing Combinations */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.grid > .row > [class*=\"one wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"one wide tablet\"].column,\n  .ui.grid > [class*=\"one wide tablet\"].column,\n  .ui.column.grid > [class*=\"one wide tablet\"].column {\n    width: 6.25% !important;\n  }\n  .ui.grid > .row > [class*=\"two wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"two wide tablet\"].column,\n  .ui.grid > [class*=\"two wide tablet\"].column,\n  .ui.column.grid > [class*=\"two wide tablet\"].column {\n    width: 12.5% !important;\n  }\n  .ui.grid > .row > [class*=\"three wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"three wide tablet\"].column,\n  .ui.grid > [class*=\"three wide tablet\"].column,\n  .ui.column.grid > [class*=\"three wide tablet\"].column {\n    width: 18.75% !important;\n  }\n  .ui.grid > .row > [class*=\"four wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"four wide tablet\"].column,\n  .ui.grid > [class*=\"four wide tablet\"].column,\n  .ui.column.grid > [class*=\"four wide tablet\"].column {\n    width: 25% !important;\n  }\n  .ui.grid > .row > [class*=\"five wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"five wide tablet\"].column,\n  .ui.grid > [class*=\"five wide tablet\"].column,\n  .ui.column.grid > [class*=\"five wide tablet\"].column {\n    width: 31.25% !important;\n  }\n  .ui.grid > .row > [class*=\"six wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"six wide tablet\"].column,\n  .ui.grid > [class*=\"six wide tablet\"].column,\n  .ui.column.grid > [class*=\"six wide tablet\"].column {\n    width: 37.5% !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide tablet\"].column,\n  .ui.grid > [class*=\"seven wide tablet\"].column,\n  .ui.column.grid > [class*=\"seven wide tablet\"].column {\n    width: 43.75% !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide tablet\"].column,\n  .ui.grid > [class*=\"eight wide tablet\"].column,\n  .ui.column.grid > [class*=\"eight wide tablet\"].column {\n    width: 50% !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide tablet\"].column,\n  .ui.grid > [class*=\"nine wide tablet\"].column,\n  .ui.column.grid > [class*=\"nine wide tablet\"].column {\n    width: 56.25% !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide tablet\"].column,\n  .ui.grid > [class*=\"ten wide tablet\"].column,\n  .ui.column.grid > [class*=\"ten wide tablet\"].column {\n    width: 62.5% !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide tablet\"].column,\n  .ui.grid > [class*=\"eleven wide tablet\"].column,\n  .ui.column.grid > [class*=\"eleven wide tablet\"].column {\n    width: 68.75% !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide tablet\"].column,\n  .ui.grid > [class*=\"twelve wide tablet\"].column,\n  .ui.column.grid > [class*=\"twelve wide tablet\"].column {\n    width: 75% !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide tablet\"].column,\n  .ui.grid > [class*=\"thirteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"thirteen wide tablet\"].column {\n    width: 81.25% !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide tablet\"].column,\n  .ui.grid > [class*=\"fourteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"fourteen wide tablet\"].column {\n    width: 87.5% !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide tablet\"].column,\n  .ui.grid > [class*=\"fifteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"fifteen wide tablet\"].column {\n    width: 93.75% !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide tablet\"].column,\n  .ui.grid > [class*=\"sixteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"sixteen wide tablet\"].column {\n    width: 100% !important;\n  }\n}\n/* Computer/Desktop Sizing Combinations */\n@media only screen and (min-width: 992px) {\n  .ui.grid > .row > [class*=\"one wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"one wide computer\"].column,\n  .ui.grid > [class*=\"one wide computer\"].column,\n  .ui.column.grid > [class*=\"one wide computer\"].column {\n    width: 6.25% !important;\n  }\n  .ui.grid > .row > [class*=\"two wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"two wide computer\"].column,\n  .ui.grid > [class*=\"two wide computer\"].column,\n  .ui.column.grid > [class*=\"two wide computer\"].column {\n    width: 12.5% !important;\n  }\n  .ui.grid > .row > [class*=\"three wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"three wide computer\"].column,\n  .ui.grid > [class*=\"three wide computer\"].column,\n  .ui.column.grid > [class*=\"three wide computer\"].column {\n    width: 18.75% !important;\n  }\n  .ui.grid > .row > [class*=\"four wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"four wide computer\"].column,\n  .ui.grid > [class*=\"four wide computer\"].column,\n  .ui.column.grid > [class*=\"four wide computer\"].column {\n    width: 25% !important;\n  }\n  .ui.grid > .row > [class*=\"five wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"five wide computer\"].column,\n  .ui.grid > [class*=\"five wide computer\"].column,\n  .ui.column.grid > [class*=\"five wide computer\"].column {\n    width: 31.25% !important;\n  }\n  .ui.grid > .row > [class*=\"six wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"six wide computer\"].column,\n  .ui.grid > [class*=\"six wide computer\"].column,\n  .ui.column.grid > [class*=\"six wide computer\"].column {\n    width: 37.5% !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide computer\"].column,\n  .ui.grid > [class*=\"seven wide computer\"].column,\n  .ui.column.grid > [class*=\"seven wide computer\"].column {\n    width: 43.75% !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide computer\"].column,\n  .ui.grid > [class*=\"eight wide computer\"].column,\n  .ui.column.grid > [class*=\"eight wide computer\"].column {\n    width: 50% !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide computer\"].column,\n  .ui.grid > [class*=\"nine wide computer\"].column,\n  .ui.column.grid > [class*=\"nine wide computer\"].column {\n    width: 56.25% !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide computer\"].column,\n  .ui.grid > [class*=\"ten wide computer\"].column,\n  .ui.column.grid > [class*=\"ten wide computer\"].column {\n    width: 62.5% !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide computer\"].column,\n  .ui.grid > [class*=\"eleven wide computer\"].column,\n  .ui.column.grid > [class*=\"eleven wide computer\"].column {\n    width: 68.75% !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide computer\"].column,\n  .ui.grid > [class*=\"twelve wide computer\"].column,\n  .ui.column.grid > [class*=\"twelve wide computer\"].column {\n    width: 75% !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide computer\"].column,\n  .ui.grid > [class*=\"thirteen wide computer\"].column,\n  .ui.column.grid > [class*=\"thirteen wide computer\"].column {\n    width: 81.25% !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide computer\"].column,\n  .ui.grid > [class*=\"fourteen wide computer\"].column,\n  .ui.column.grid > [class*=\"fourteen wide computer\"].column {\n    width: 87.5% !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide computer\"].column,\n  .ui.grid > [class*=\"fifteen wide computer\"].column,\n  .ui.column.grid > [class*=\"fifteen wide computer\"].column {\n    width: 93.75% !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide computer\"].column,\n  .ui.grid > [class*=\"sixteen wide computer\"].column,\n  .ui.column.grid > [class*=\"sixteen wide computer\"].column {\n    width: 100% !important;\n  }\n}\n/* Large Monitor Sizing Combinations */\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui.grid > .row > [class*=\"one wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"one wide large screen\"].column,\n  .ui.grid > [class*=\"one wide large screen\"].column,\n  .ui.column.grid > [class*=\"one wide large screen\"].column {\n    width: 6.25% !important;\n  }\n  .ui.grid > .row > [class*=\"two wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"two wide large screen\"].column,\n  .ui.grid > [class*=\"two wide large screen\"].column,\n  .ui.column.grid > [class*=\"two wide large screen\"].column {\n    width: 12.5% !important;\n  }\n  .ui.grid > .row > [class*=\"three wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"three wide large screen\"].column,\n  .ui.grid > [class*=\"three wide large screen\"].column,\n  .ui.column.grid > [class*=\"three wide large screen\"].column {\n    width: 18.75% !important;\n  }\n  .ui.grid > .row > [class*=\"four wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"four wide large screen\"].column,\n  .ui.grid > [class*=\"four wide large screen\"].column,\n  .ui.column.grid > [class*=\"four wide large screen\"].column {\n    width: 25% !important;\n  }\n  .ui.grid > .row > [class*=\"five wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"five wide large screen\"].column,\n  .ui.grid > [class*=\"five wide large screen\"].column,\n  .ui.column.grid > [class*=\"five wide large screen\"].column {\n    width: 31.25% !important;\n  }\n  .ui.grid > .row > [class*=\"six wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"six wide large screen\"].column,\n  .ui.grid > [class*=\"six wide large screen\"].column,\n  .ui.column.grid > [class*=\"six wide large screen\"].column {\n    width: 37.5% !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide large screen\"].column,\n  .ui.grid > [class*=\"seven wide large screen\"].column,\n  .ui.column.grid > [class*=\"seven wide large screen\"].column {\n    width: 43.75% !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide large screen\"].column,\n  .ui.grid > [class*=\"eight wide large screen\"].column,\n  .ui.column.grid > [class*=\"eight wide large screen\"].column {\n    width: 50% !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide large screen\"].column,\n  .ui.grid > [class*=\"nine wide large screen\"].column,\n  .ui.column.grid > [class*=\"nine wide large screen\"].column {\n    width: 56.25% !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide large screen\"].column,\n  .ui.grid > [class*=\"ten wide large screen\"].column,\n  .ui.column.grid > [class*=\"ten wide large screen\"].column {\n    width: 62.5% !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide large screen\"].column,\n  .ui.grid > [class*=\"eleven wide large screen\"].column,\n  .ui.column.grid > [class*=\"eleven wide large screen\"].column {\n    width: 68.75% !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide large screen\"].column,\n  .ui.grid > [class*=\"twelve wide large screen\"].column,\n  .ui.column.grid > [class*=\"twelve wide large screen\"].column {\n    width: 75% !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide large screen\"].column,\n  .ui.grid > [class*=\"thirteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"thirteen wide large screen\"].column {\n    width: 81.25% !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide large screen\"].column,\n  .ui.grid > [class*=\"fourteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"fourteen wide large screen\"].column {\n    width: 87.5% !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide large screen\"].column,\n  .ui.grid > [class*=\"fifteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"fifteen wide large screen\"].column {\n    width: 93.75% !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide large screen\"].column,\n  .ui.grid > [class*=\"sixteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"sixteen wide large screen\"].column {\n    width: 100% !important;\n  }\n}\n/* Widescreen Sizing Combinations */\n@media only screen and (min-width: 1920px) {\n  .ui.grid > .row > [class*=\"one wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"one wide widescreen\"].column,\n  .ui.grid > [class*=\"one wide widescreen\"].column,\n  .ui.column.grid > [class*=\"one wide widescreen\"].column {\n    width: 6.25% !important;\n  }\n  .ui.grid > .row > [class*=\"two wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"two wide widescreen\"].column,\n  .ui.grid > [class*=\"two wide widescreen\"].column,\n  .ui.column.grid > [class*=\"two wide widescreen\"].column {\n    width: 12.5% !important;\n  }\n  .ui.grid > .row > [class*=\"three wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"three wide widescreen\"].column,\n  .ui.grid > [class*=\"three wide widescreen\"].column,\n  .ui.column.grid > [class*=\"three wide widescreen\"].column {\n    width: 18.75% !important;\n  }\n  .ui.grid > .row > [class*=\"four wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"four wide widescreen\"].column,\n  .ui.grid > [class*=\"four wide widescreen\"].column,\n  .ui.column.grid > [class*=\"four wide widescreen\"].column {\n    width: 25% !important;\n  }\n  .ui.grid > .row > [class*=\"five wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"five wide widescreen\"].column,\n  .ui.grid > [class*=\"five wide widescreen\"].column,\n  .ui.column.grid > [class*=\"five wide widescreen\"].column {\n    width: 31.25% !important;\n  }\n  .ui.grid > .row > [class*=\"six wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"six wide widescreen\"].column,\n  .ui.grid > [class*=\"six wide widescreen\"].column,\n  .ui.column.grid > [class*=\"six wide widescreen\"].column {\n    width: 37.5% !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide widescreen\"].column,\n  .ui.grid > [class*=\"seven wide widescreen\"].column,\n  .ui.column.grid > [class*=\"seven wide widescreen\"].column {\n    width: 43.75% !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide widescreen\"].column,\n  .ui.grid > [class*=\"eight wide widescreen\"].column,\n  .ui.column.grid > [class*=\"eight wide widescreen\"].column {\n    width: 50% !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide widescreen\"].column,\n  .ui.grid > [class*=\"nine wide widescreen\"].column,\n  .ui.column.grid > [class*=\"nine wide widescreen\"].column {\n    width: 56.25% !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide widescreen\"].column,\n  .ui.grid > [class*=\"ten wide widescreen\"].column,\n  .ui.column.grid > [class*=\"ten wide widescreen\"].column {\n    width: 62.5% !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide widescreen\"].column,\n  .ui.grid > [class*=\"eleven wide widescreen\"].column,\n  .ui.column.grid > [class*=\"eleven wide widescreen\"].column {\n    width: 68.75% !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide widescreen\"].column,\n  .ui.grid > [class*=\"twelve wide widescreen\"].column,\n  .ui.column.grid > [class*=\"twelve wide widescreen\"].column {\n    width: 75% !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide widescreen\"].column,\n  .ui.grid > [class*=\"thirteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"thirteen wide widescreen\"].column {\n    width: 81.25% !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide widescreen\"].column,\n  .ui.grid > [class*=\"fourteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"fourteen wide widescreen\"].column {\n    width: 87.5% !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide widescreen\"].column,\n  .ui.grid > [class*=\"fifteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"fifteen wide widescreen\"].column {\n    width: 93.75% !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide widescreen\"].column,\n  .ui.grid > [class*=\"sixteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"sixteen wide widescreen\"].column {\n    width: 100% !important;\n  }\n}\n/*----------------------\n        Centered\n-----------------------*/\n.ui.centered.grid,\n.ui.centered.grid > .row,\n.ui.grid > .centered.row {\n  text-align: center;\n  justify-content: center;\n}\n.ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),\n.ui.centered.grid > .row > .column:not(.aligned):not(.justified),\n.ui.grid .centered.row > .column:not(.aligned):not(.justified) {\n  text-align: left;\n}\n.ui.grid > .centered.column,\n.ui.grid > .row > .centered.column {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n/*----------------------\n        Relaxed\n-----------------------*/\n.ui.relaxed.grid > .column:not(.row),\n.ui.relaxed.grid > .row > .column,\n.ui.grid > .relaxed.row > .column {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.ui[class*=\"very relaxed\"].grid > .column:not(.row),\n.ui[class*=\"very relaxed\"].grid > .row > .column,\n.ui.grid > [class*=\"very relaxed\"].row > .column {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n/* Coupling with UI Divider */\n.ui.relaxed.grid .row + .ui.divider,\n.ui.grid .relaxed.row + .ui.divider {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.ui[class*=\"very relaxed\"].grid .row + .ui.divider,\n.ui.grid [class*=\"very relaxed\"].row + .ui.divider {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n}\n/*----------------------\n        Padded\n-----------------------*/\n.ui.padded.grid:not(.vertically):not(.horizontally) {\n  margin: 0em !important;\n}\n[class*=\"horizontally padded\"].ui.grid {\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n}\n[class*=\"vertically padded\"].ui.grid {\n  margin-top: 0em !important;\n  margin-bottom: 0em !important;\n}\n/*----------------------\n       \"Floated\"\n-----------------------*/\n.ui.grid [class*=\"left floated\"].column {\n  margin-right: auto;\n}\n.ui.grid [class*=\"right floated\"].column {\n  margin-left: auto;\n}\n/*----------------------\n        Divided\n-----------------------*/\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);\n}\n/* Swap from padding to margin on columns to have dividers align */\n.ui[class*=\"vertically divided\"].grid > .column:not(.row),\n.ui[class*=\"vertically divided\"].grid > .row > .column {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n.ui[class*=\"vertically divided\"].grid > .row {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n/* No divider on first column on row */\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n/* No space on top of first row */\n.ui[class*=\"vertically divided\"].grid > .row:first-child > .column {\n  margin-top: 0em;\n}\n/* Divided Row */\n.ui.grid > .divided.row > .column {\n  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);\n}\n.ui.grid > .divided.row > .column:first-child {\n  box-shadow: none;\n}\n/* Vertically Divided */\n.ui[class*=\"vertically divided\"].grid > .row {\n  position: relative;\n}\n.ui[class*=\"vertically divided\"].grid > .row:before {\n  position: absolute;\n  content: \"\";\n  top: 0em;\n  left: 0px;\n  width: calc(100% - 2rem);\n  height: 1px;\n  margin: 0% 1rem;\n  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);\n}\n/* Padded Horizontally Divided */\n[class*=\"horizontally padded\"].ui.divided.grid,\n.ui.padded.divided.grid:not(.vertically):not(.horizontally) {\n  width: 100%;\n}\n/* First Row Vertically Divided */\n.ui[class*=\"vertically divided\"].grid > .row:first-child:before {\n  box-shadow: none;\n}\n/* Inverted Divided */\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row):first-child,\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n.ui.inverted[class*=\"vertically divided\"].grid > .row:before {\n  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1);\n}\n/* Relaxed */\n.ui.relaxed[class*=\"vertically divided\"].grid > .row:before {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n  width: calc(100% - 3rem);\n}\n.ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid > .row:before {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n  width: calc(100% - 5rem);\n}\n/*----------------------\n         Celled\n-----------------------*/\n.ui.celled.grid {\n  width: 100%;\n  margin: 1em 0em;\n  box-shadow: 0px 0px 0px 1px #D4D4D5;\n}\n.ui.celled.grid > .row {\n  width: 100% !important;\n  margin: 0em;\n  padding: 0em;\n  box-shadow: 0px -1px 0px 0px #D4D4D5;\n}\n.ui.celled.grid > .column:not(.row),\n.ui.celled.grid > .row > .column {\n  box-shadow: -1px 0px 0px 0px #D4D4D5;\n}\n.ui.celled.grid > .column:first-child,\n.ui.celled.grid > .row > .column:first-child {\n  box-shadow: none;\n}\n.ui.celled.grid > .column:not(.row),\n.ui.celled.grid > .row > .column {\n  padding: 1em;\n}\n.ui.relaxed.celled.grid > .column:not(.row),\n.ui.relaxed.celled.grid > .row > .column {\n  padding: 1.5em;\n}\n.ui[class*=\"very relaxed\"].celled.grid > .column:not(.row),\n.ui[class*=\"very relaxed\"].celled.grid > .row > .column {\n  padding: 2em;\n}\n/* Internally Celled */\n.ui[class*=\"internally celled\"].grid {\n  box-shadow: none;\n  margin: 0em;\n}\n.ui[class*=\"internally celled\"].grid > .row:first-child {\n  box-shadow: none;\n}\n.ui[class*=\"internally celled\"].grid > .row > .column:first-child {\n  box-shadow: none;\n}\n/*----------------------\n   Vertically Aligned\n-----------------------*/\n/* Top Aligned */\n.ui[class*=\"top aligned\"].grid > .column:not(.row),\n.ui[class*=\"top aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"top aligned\"].row > .column,\n.ui.grid > [class*=\"top aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"top aligned\"].column {\n  flex-direction: column;\n  vertical-align: top;\n  align-self: flex-start !important;\n}\n/* Middle Aligned */\n.ui[class*=\"middle aligned\"].grid > .column:not(.row),\n.ui[class*=\"middle aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"middle aligned\"].row > .column,\n.ui.grid > [class*=\"middle aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"middle aligned\"].column {\n  flex-direction: column;\n  vertical-align: middle;\n  align-self: center !important;\n}\n/* Bottom Aligned */\n.ui[class*=\"bottom aligned\"].grid > .column:not(.row),\n.ui[class*=\"bottom aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"bottom aligned\"].row > .column,\n.ui.grid > [class*=\"bottom aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"bottom aligned\"].column {\n  flex-direction: column;\n  vertical-align: bottom;\n  align-self: flex-end !important;\n}\n/* Stretched */\n.ui.stretched.grid > .row > .column,\n.ui.stretched.grid > .column,\n.ui.grid > .stretched.row > .column,\n.ui.grid > .stretched.column:not(.row),\n.ui.grid > .row > .stretched.column {\n  display: inline-flex !important;\n  align-self: stretch;\n  flex-direction: column;\n}\n.ui.stretched.grid > .row > .column > *,\n.ui.stretched.grid > .column > *,\n.ui.grid > .stretched.row > .column > *,\n.ui.grid > .stretched.column:not(.row) > *,\n.ui.grid > .row > .stretched.column > * {\n  flex-grow: 1;\n}\n/*----------------------\n  Horizontally Centered\n-----------------------*/\n/* Left Aligned */\n.ui[class*=\"left aligned\"].grid > .column,\n.ui[class*=\"left aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"left aligned\"].row > .column,\n.ui.grid > [class*=\"left aligned\"].column.column,\n.ui.grid > .row > [class*=\"left aligned\"].column.column {\n  text-align: left;\n  align-self: inherit;\n}\n/* Center Aligned */\n.ui[class*=\"center aligned\"].grid > .column,\n.ui[class*=\"center aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"center aligned\"].row > .column,\n.ui.grid > [class*=\"center aligned\"].column.column,\n.ui.grid > .row > [class*=\"center aligned\"].column.column {\n  text-align: center;\n  align-self: inherit;\n}\n.ui[class*=\"center aligned\"].grid {\n  justify-content: center;\n}\n/* Right Aligned */\n.ui[class*=\"right aligned\"].grid > .column,\n.ui[class*=\"right aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"right aligned\"].row > .column,\n.ui.grid > [class*=\"right aligned\"].column.column,\n.ui.grid > .row > [class*=\"right aligned\"].column.column {\n  text-align: right;\n  align-self: inherit;\n}\n/* Justified */\n.ui.justified.grid > .column,\n.ui.justified.grid > .row > .column,\n.ui.grid > .justified.row > .column,\n.ui.grid > .justified.column.column,\n.ui.grid > .row > .justified.column.column {\n  text-align: justify;\n  hyphens: auto;\n}\n/*----------------------\n         Colored\n-----------------------*/\n.ui.grid > .row > .red.column,\n.ui.grid > .row > .orange.column,\n.ui.grid > .row > .yellow.column,\n.ui.grid > .row > .olive.column,\n.ui.grid > .row > .green.column,\n.ui.grid > .row > .teal.column,\n.ui.grid > .row > .blue.column,\n.ui.grid > .row > .violet.column,\n.ui.grid > .row > .purple.column,\n.ui.grid > .row > .pink.column,\n.ui.grid > .row > .brown.column,\n.ui.grid > .row > .grey.column,\n.ui.grid > .row > .black.column {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n/* Red */\n.ui.grid > .red.row,\n.ui.grid > .red.column,\n.ui.grid > .row > .red.column {\n  background-color: #DB2828 !important;\n  color: #FFFFFF;\n}\n/* Orange */\n.ui.grid > .orange.row,\n.ui.grid > .orange.column,\n.ui.grid > .row > .orange.column {\n  background-color: #F2711C !important;\n  color: #FFFFFF;\n}\n/* Yellow */\n.ui.grid > .yellow.row,\n.ui.grid > .yellow.column,\n.ui.grid > .row > .yellow.column {\n  background-color: #FBBD08 !important;\n  color: #FFFFFF;\n}\n/* Olive */\n.ui.grid > .olive.row,\n.ui.grid > .olive.column,\n.ui.grid > .row > .olive.column {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF;\n}\n/* Green */\n.ui.grid > .green.row,\n.ui.grid > .green.column,\n.ui.grid > .row > .green.column {\n  background-color: #21BA45 !important;\n  color: #FFFFFF;\n}\n/* Teal */\n.ui.grid > .teal.row,\n.ui.grid > .teal.column,\n.ui.grid > .row > .teal.column {\n  background-color: #00B5AD !important;\n  color: #FFFFFF;\n}\n/* Blue */\n.ui.grid > .blue.row,\n.ui.grid > .blue.column,\n.ui.grid > .row > .blue.column {\n  background-color: #2185D0 !important;\n  color: #FFFFFF;\n}\n/* Violet */\n.ui.grid > .violet.row,\n.ui.grid > .violet.column,\n.ui.grid > .row > .violet.column {\n  background-color: #6435C9 !important;\n  color: #FFFFFF;\n}\n/* Purple */\n.ui.grid > .purple.row,\n.ui.grid > .purple.column,\n.ui.grid > .row > .purple.column {\n  background-color: #A333C8 !important;\n  color: #FFFFFF;\n}\n/* Pink */\n.ui.grid > .pink.row,\n.ui.grid > .pink.column,\n.ui.grid > .row > .pink.column {\n  background-color: #E03997 !important;\n  color: #FFFFFF;\n}\n/* Brown */\n.ui.grid > .brown.row,\n.ui.grid > .brown.column,\n.ui.grid > .row > .brown.column {\n  background-color: #A5673F !important;\n  color: #FFFFFF;\n}\n/* Grey */\n.ui.grid > .grey.row,\n.ui.grid > .grey.column,\n.ui.grid > .row > .grey.column {\n  background-color: #767676 !important;\n  color: #FFFFFF;\n}\n/* Black */\n.ui.grid > .black.row,\n.ui.grid > .black.column,\n.ui.grid > .row > .black.column {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF;\n}\n/*----------------------\n      Equal Width\n-----------------------*/\n.ui[class*=\"equal width\"].grid > .column:not(.row),\n.ui[class*=\"equal width\"].grid > .row > .column,\n.ui.grid > [class*=\"equal width\"].row > .column {\n  display: inline-block;\n  flex-grow: 1;\n}\n.ui[class*=\"equal width\"].grid > .wide.column,\n.ui[class*=\"equal width\"].grid > .row > .wide.column,\n.ui.grid > [class*=\"equal width\"].row > .wide.column {\n  flex-grow: 0;\n}\n/*----------------------\n        Reverse\n-----------------------*/\n/* Mobile */\n@media only screen and (max-width: 767px) {\n  .ui[class*=\"mobile reversed\"].grid,\n  .ui[class*=\"mobile reversed\"].grid > .row,\n  .ui.grid > [class*=\"mobile reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"mobile vertically reversed\"].grid,\n  .ui.stackable[class*=\"mobile reversed\"] {\n    flex-direction: column-reverse;\n  }\n  /* Divided Reversed */\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #D4D4D5;\n  }\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n/* Tablet */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui[class*=\"tablet reversed\"].grid,\n  .ui[class*=\"tablet reversed\"].grid > .row,\n  .ui.grid > [class*=\"tablet reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"tablet vertically reversed\"].grid {\n    flex-direction: column-reverse;\n  }\n  /* Divided Reversed */\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #D4D4D5;\n  }\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n/* Computer */\n@media only screen and (min-width: 992px) {\n  .ui[class*=\"computer reversed\"].grid,\n  .ui[class*=\"computer reversed\"].grid > .row,\n  .ui.grid > [class*=\"computer reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"computer vertically reversed\"].grid {\n    flex-direction: column-reverse;\n  }\n  /* Divided Reversed */\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15);\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #D4D4D5;\n  }\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n/*-------------------\n      Doubling\n--------------------*/\n/* Tablet Only */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.doubling.grid {\n    width: auto;\n  }\n  .ui.grid > .doubling.row,\n  .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n  .ui.grid > .doubling.row > .column,\n  .ui.doubling.grid > .row > .column {\n    display: inline-block !important;\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n    box-shadow: none !important;\n    margin: 0em;\n  }\n  .ui[class*=\"two column\"].doubling.grid > .row > .column,\n  .ui[class*=\"two column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"two column\"].doubling.row.row > .column {\n    width: 100% !important;\n  }\n  .ui[class*=\"three column\"].doubling.grid > .row > .column,\n  .ui[class*=\"three column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"three column\"].doubling.row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"four column\"].doubling.grid > .row > .column,\n  .ui[class*=\"four column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"four column\"].doubling.row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"five column\"].doubling.grid > .row > .column,\n  .ui[class*=\"five column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"five column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"six column\"].doubling.grid > .row > .column,\n  .ui[class*=\"six column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"six column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"seven column\"].doubling.grid > .row > .column,\n  .ui[class*=\"seven column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"seven column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"eight column\"].doubling.grid > .row > .column,\n  .ui[class*=\"eight column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"eight column\"].doubling.row.row > .column {\n    width: 25% !important;\n  }\n  .ui[class*=\"nine column\"].doubling.grid > .row > .column,\n  .ui[class*=\"nine column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"nine column\"].doubling.row.row > .column {\n    width: 25% !important;\n  }\n  .ui[class*=\"ten column\"].doubling.grid > .row > .column,\n  .ui[class*=\"ten column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"ten column\"].doubling.row.row > .column {\n    width: 20% !important;\n  }\n  .ui[class*=\"eleven column\"].doubling.grid > .row > .column,\n  .ui[class*=\"eleven column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"eleven column\"].doubling.row.row > .column {\n    width: 20% !important;\n  }\n  .ui[class*=\"twelve column\"].doubling.grid > .row > .column,\n  .ui[class*=\"twelve column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"twelve column\"].doubling.row.row > .column {\n    width: 16.66666667% !important;\n  }\n  .ui[class*=\"thirteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"thirteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"thirteen column\"].doubling.row.row > .column {\n    width: 16.66666667% !important;\n  }\n  .ui[class*=\"fourteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"fourteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"fourteen column\"].doubling.row.row > .column {\n    width: 14.28571429% !important;\n  }\n  .ui[class*=\"fifteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"fifteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"fifteen column\"].doubling.row.row > .column {\n    width: 14.28571429% !important;\n  }\n  .ui[class*=\"sixteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"sixteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"sixteen column\"].doubling.row.row > .column {\n    width: 12.5% !important;\n  }\n}\n/* Mobile Only */\n@media only screen and (max-width: 767px) {\n  .ui.grid > .doubling.row,\n  .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n  .ui.grid > .doubling.row > .column,\n  .ui.doubling.grid > .row > .column {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n    margin: 0em !important;\n    box-shadow: none !important;\n  }\n  .ui[class*=\"two column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"two column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"two column\"].doubling:not(.stackable).row.row > .column {\n    width: 100% !important;\n  }\n  .ui[class*=\"three column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"three column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"three column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"four column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"four column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"four column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"five column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"five column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"five column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"six column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"six column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"six column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"seven column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"eight column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n  .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"nine column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"ten column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"eleven column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"twelve column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"thirteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n  .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"fourteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n  .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"fifteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n  .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"sixteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n}\n/*-------------------\n      Stackable\n--------------------*/\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid {\n    width: auto;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n  .ui.stackable.grid > .row > .wide.column,\n  .ui.stackable.grid > .wide.column,\n  .ui.stackable.grid > .column.grid > .column,\n  .ui.stackable.grid > .column.row > .column,\n  .ui.stackable.grid > .row > .column,\n  .ui.stackable.grid > .column:not(.row),\n  .ui.grid > .stackable.stackable.row > .column {\n    width: 100% !important;\n    margin: 0em 0em !important;\n    box-shadow: none !important;\n    padding: 1rem 1rem !important;\n  }\n  .ui.stackable.grid:not(.vertically) > .row {\n    margin: 0em;\n    padding: 0em;\n  }\n  /* Coupling */\n  .ui.container > .ui.stackable.grid > .column,\n  .ui.container > .ui.stackable.grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n  /* Don't pad inside segment or nested grid */\n  .ui.grid .ui.stackable.grid,\n  .ui.segment:not(.vertical) .ui.stackable.page.grid {\n    margin-left: -1rem !important;\n    margin-right: -1rem !important;\n  }\n  /* Divided Stackable */\n  .ui.stackable.divided.grid > .row:first-child > .column:first-child,\n  .ui.stackable.celled.grid > .row:first-child > .column:first-child,\n  .ui.stackable.divided.grid > .column:not(.row):first-child,\n  .ui.stackable.celled.grid > .column:not(.row):first-child {\n    border-top: none !important;\n  }\n  .ui.inverted.stackable.celled.grid > .column:not(.row),\n  .ui.inverted.stackable.divided.grid > .column:not(.row),\n  .ui.inverted.stackable.celled.grid > .row > .column,\n  .ui.inverted.stackable.divided.grid > .row > .column {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  .ui.stackable.celled.grid > .column:not(.row),\n  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n  .ui.stackable.celled.grid > .row > .column,\n  .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    box-shadow: none !important;\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .ui.stackable.celled.grid > .row {\n    box-shadow: none !important;\n  }\n  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n  .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n}\n/*----------------------\n     Only (Device)\n-----------------------*/\n/* These include arbitrary class repetitions for forced specificity */\n/* Mobile Only Hide */\n@media only screen and (max-width: 767px) {\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n/* Tablet Only Hide */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.tablet),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.tablet) {\n    display: none !important;\n  }\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.tablet),\n  .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.tablet) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n/* Computer Only Hide */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n/* Large Screen Only Hide */\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n/* Widescreen Only Hide */\n@media only screen and (min-width: 1920px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*\n * # Semantic - Menu\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2015 Contributor\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Menu\n*******************************/\n/*-------------------\n      Collection\n--------------------*/\n/* Menu */\n/* Menu Item */\n/* Divider */\n/* Sub Menu */\n/* Text Item */\n/*--------------\n    Elements\n---------------*/\n/* Icon */\n/* Dropdown Icon */\n/* Header */\n/* Vertical Icon */\n/* Vertical Header */\n/* Pointing Arrow */\n/*--------------\n    Couplings\n---------------*/\n/* Button */\n/* Input */\n/* Image */\n/* Label */\n/* Dropdown in Menu */\n/* Dropdown Variations */\n/*--------------\n     States\n---------------*/\n/* Hovered Item */\n/* Pressed Item */\n/* Active Item */\n/* Active Hovered Item */\n/* Selected Dropdown */\n/* Active Dropdown */\n/* Active Sub Menu */\n/*--------------\n     Types\n---------------*/\n/* Vertical */\n/* Secondary */\n/* Pointing */\n/* Inverted Secondary */\n/* Inverted Pointing */\n/* Tiered */\n/* Icon */\n/* Tabular */\n/* Pagination */\n/* Labeled Icon */\n/* Text */\n/*--------------\n   Variations\n---------------*/\n/* Inverted */\n/* Inverted Sub Menu */\n/* Inverted Hover */\n/* Pressed */\n/* Inverted Active */\n/* Inverted Active Hover  */\n/* Inverted Menu Divider */\n/* Inverted Colored */\n/* Fixed */\n/* Floated */\n/* Attached */\n/* Resize large sizes */\n/* Sizes */\n/* Packaged Theme */\n/*******************************\n             Menu\n*******************************/\n/*-------------------\n      Collection\n--------------------*/\n/* Menu */\n/* Menu Item */\n/* Divider */\n/* Sub Menu */\n/* Text Item */\n/*--------------\n    Elements\n---------------*/\n/* Icon */\n/* Dropdown Icon */\n/* Header */\n/* Vertical Icon */\n/* Vertical Header */\n/* Pointing Arrow */\n/*--------------\n    Couplings\n---------------*/\n/* Button */\n/* Input */\n/* Image */\n/* Label */\n/* Dropdown in Menu */\n/* Dropdown Variations */\n/*--------------\n     States\n---------------*/\n/* Hovered Item */\n/* Pressed Item */\n/* Active Item */\n/* Active Hovered Item */\n/* Selected Dropdown */\n/* Active Dropdown */\n/* Active Sub Menu */\n/*--------------\n     Types\n---------------*/\n/* Vertical */\n/* Secondary */\n/* Pointing */\n/* Inverted Secondary */\n/* Inverted Pointing */\n/* Tiered */\n/* Icon */\n/* Tabular */\n/* Pagination */\n/* Labeled Icon */\n/* Text */\n/*--------------\n   Variations\n---------------*/\n/* Inverted */\n/* Inverted Sub Menu */\n/* Inverted Hover */\n/* Pressed */\n/* Inverted Active */\n/* Inverted Active Hover  */\n/* Inverted Menu Divider */\n/* Inverted Colored */\n/* Fixed */\n/* Floated */\n/* Attached */\n/* Resize large sizes */\n/* Sizes */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Standard\n*******************************/\n/*--------------\n      Menu\n---------------*/\n.ui.menu {\n  display: flex;\n  margin: 1rem 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  background: rgba(0, 0, 0, 0.15);\n  font-weight: normal;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n  min-height: 2.85714286em;\n}\n.ui.menu:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n.ui.menu:first-child {\n  margin-top: 0rem;\n}\n.ui.menu:last-child {\n  margin-bottom: 0rem;\n}\n/*--------------\n    Sub-Menu\n---------------*/\n.ui.menu .menu {\n  margin: 0em;\n}\n.ui.menu:not(.vertical) > .menu {\n  display: flex;\n}\n/*--------------\n      Item\n---------------*/\n.ui.menu:not(.vertical) .item {\n  display: flex;\n  align-items: center;\n}\n.ui.menu .item {\n  position: relative;\n  vertical-align: middle;\n  line-height: 1;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  flex: 0 0 auto;\n  user-select: none;\n  background: none;\n  padding: 0.92857143em 1.14285714em;\n  text-transform: none;\n  color: rgba(255, 255, 255, 0.87);\n  font-weight: normal;\n  transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;\n}\n.ui.menu > .item:first-child {\n  border-radius: 0.28571429rem 0px 0px 0.28571429rem;\n}\n/* Border */\n.ui.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  right: 0px;\n  height: 100%;\n  width: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n/*--------------\n  Text Content\n---------------*/\n.ui.menu .text.item > *,\n.ui.menu .item > a:not(.ui),\n.ui.menu .item > p:only-child {\n  user-select: text;\n  line-height: 1.3;\n}\n.ui.menu .item > p:first-child {\n  margin-top: 0;\n}\n.ui.menu .item > p:last-child {\n  margin-bottom: 0;\n}\n/*--------------\n      Icons\n---------------*/\n.ui.menu .item > i.icon {\n  opacity: 0.9;\n  float: none;\n  margin: 0em 0.35714286em 0em 0em;\n}\n/*--------------\n     Button\n---------------*/\n.ui.menu:not(.vertical) .item > .button {\n  position: relative;\n  top: 0em;\n  margin: -0.5em 0em;\n  padding-bottom: 0.78571429em;\n  padding-top: 0.78571429em;\n  font-size: 1em;\n}\n/*----------------\n Grid / Container\n-----------------*/\n.ui.menu > .grid,\n.ui.menu > .container {\n  display: flex;\n  align-items: inherit;\n  flex-direction: inherit;\n}\n/*--------------\n     Inputs\n---------------*/\n.ui.menu .item > .input {\n  width: 100%;\n}\n.ui.menu:not(.vertical) .item > .input {\n  position: relative;\n  top: 0em;\n  margin: -0.5em 0em;\n}\n.ui.menu .item > .input input {\n  font-size: 1em;\n  padding-top: 0.57142857em;\n  padding-bottom: 0.57142857em;\n}\n/*--------------\n     Header\n---------------*/\n.ui.menu .header.item,\n.ui.vertical.menu .header.item {\n  margin: 0em;\n  background: '';\n  text-transform: normal;\n  font-weight: bold;\n}\n.ui.vertical.menu .item > .header:not(.ui) {\n  margin: 0em 0em 0.5em;\n  font-size: 1em;\n  font-weight: bold;\n}\n/*--------------\n    Dropdowns\n---------------*/\n/* Dropdown Icon */\n.ui.menu .item > i.dropdown.icon {\n  padding: 0em;\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n/* Menu */\n.ui.menu .dropdown.item .menu {\n  min-width: calc(100% - 1px);\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  background: #FFFFFF;\n  margin: 0em 0px 0px;\n  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08);\n  flex-direction: column !important;\n}\n/* Menu Items */\n.ui.menu .ui.dropdown .menu > .item {\n  margin: 0;\n  text-align: left;\n  font-size: 1em !important;\n  padding: 0.78571429em 1.14285714em !important;\n  background: transparent !important;\n  color: rgba(255, 255, 255, 0.87) !important;\n  text-transform: none !important;\n  font-weight: normal !important;\n  box-shadow: none !important;\n  transition: none !important;\n}\n.ui.menu .ui.dropdown .menu > .item:hover {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.menu .ui.dropdown .menu > .selected.item {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.menu .ui.dropdown .menu > .active.item {\n  background: rgba(0, 0, 0, 0.03) !important;\n  font-weight: bold !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.menu .ui.dropdown.item .menu .item:not(.filtered) {\n  display: block;\n}\n.ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {\n  display: inline-block;\n  font-size: 1em !important;\n  float: none;\n  margin: 0em 0.75em 0em 0em !important;\n}\n/* Secondary */\n.ui.secondary.menu .dropdown.item > .menu,\n.ui.text.menu .dropdown.item > .menu {\n  border-radius: 0.28571429rem;\n  margin-top: 0.35714286em;\n}\n/* Pointing */\n.ui.menu .pointing.dropdown.item .menu {\n  margin-top: 0.75em;\n}\n/* Inverted */\n.ui.inverted.menu .search.dropdown.item > .search,\n.ui.inverted.menu .search.dropdown.item > .text {\n  color: rgba(255, 255, 255, 0.9);\n}\n/* Vertical */\n.ui.vertical.menu .dropdown.item > .icon {\n  float: right;\n  content: \"\\f0da\";\n  margin-left: 1em;\n}\n.ui.vertical.menu .dropdown.item .menu {\n  left: 100%;\n  min-width: 0;\n  margin: 0em 0em 0em 0em;\n  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0em 0.28571429rem 0.28571429rem 0.28571429rem;\n}\n.ui.vertical.menu .dropdown.item.upward .menu {\n  bottom: 0;\n}\n.ui.vertical.menu .dropdown.item:not(.upward) .menu {\n  top: 0;\n}\n.ui.vertical.menu .active.dropdown.item {\n  border-top-right-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n.ui.vertical.menu .dropdown.active.item {\n  box-shadow: none;\n}\n/* Evenly Divided */\n.ui.item.menu .dropdown .menu .item {\n  width: 100%;\n}\n/*--------------\n     Labels\n---------------*/\n.ui.menu .item > .label {\n  background: #999999;\n  color: #FFFFFF;\n  margin-left: 1em;\n  padding: 0.3em 0.78571429em;\n}\n.ui.vertical.menu .item > .label {\n  background: #999999;\n  color: #FFFFFF;\n  margin-top: -0.15em;\n  margin-bottom: -0.15em;\n  padding: 0.3em 0.78571429em;\n}\n.ui.menu .item > .floating.label {\n  padding: 0.3em 0.78571429em;\n}\n/*--------------\n     Images\n---------------*/\n.ui.menu .item > img:not(.ui) {\n  display: inline-block;\n  vertical-align: middle;\n  margin: -0.3em 0em;\n  width: 2.5em;\n}\n.ui.vertical.menu .item > img:not(.ui):only-child {\n  display: block;\n  max-width: 100%;\n  width: auto;\n}\n/*******************************\n          Coupling\n*******************************/\n/*--------------\n     List\n---------------*/\n/* Menu divider shouldnt apply */\n.ui.menu .list .item:before {\n  background: none !important;\n}\n/*--------------\n     Sidebar\n---------------*/\n/* Show vertical dividers below last */\n.ui.vertical.sidebar.menu > .item:first-child:before {\n  display: block !important;\n}\n.ui.vertical.sidebar.menu > .item::before {\n  top: auto;\n  bottom: 0px;\n}\n/*--------------\n    Container\n---------------*/\n@media only screen and (max-width: 767px) {\n  .ui.menu > .ui.container {\n    width: 100% !important;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n  }\n}\n/*******************************\n             States\n*******************************/\n/*--------------\n      Hover\n---------------*/\n.ui.link.menu .item:hover,\n.ui.menu .dropdown.item:hover,\n.ui.menu .link.item:hover,\n.ui.menu a.item:hover {\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Pressed\n---------------*/\n.ui.link.menu .item:active,\n.ui.menu .link.item:active,\n.ui.menu a.item:active {\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Active\n---------------*/\n.ui.menu .active.item {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: normal;\n  box-shadow: none;\n}\n.ui.menu .active.item > i.icon {\n  opacity: 1;\n}\n/*--------------\n  Active Hover\n---------------*/\n.ui.menu .active.item:hover,\n.ui.vertical.menu .active.item:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Disabled\n---------------*/\n.ui.menu .item.disabled,\n.ui.menu .item.disabled:hover {\n  cursor: default !important;\n  background-color: transparent !important;\n  color: rgba(40, 40, 40, 0.3) !important;\n}\n/*******************************\n             Types\n*******************************/\n/*------------------\nFloated Menu / Item\n-------------------*/\n/* Left Floated */\n.ui.menu:not(.vertical) .left.item,\n.ui.menu:not(.vertical) :not(.dropdown) > .left.menu {\n  display: flex;\n  margin-right: auto !important;\n}\n/* Right Floated */\n.ui.menu:not(.vertical) .right.item,\n.ui.menu:not(.vertical) .right.menu {\n  display: flex;\n  margin-left: auto !important;\n}\n/* Swapped Borders */\n.ui.menu .right.item::before,\n.ui.menu .right.menu > .item::before {\n  right: auto;\n  left: 0;\n}\n/*--------------\n    Vertical\n---------------*/\n.ui.vertical.menu {\n  display: block;\n  flex-direction: column;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n}\n/*--- Item ---*/\n.ui.vertical.menu .item {\n  display: block;\n  background: none;\n  border-top: none;\n  border-right: none;\n}\n.ui.vertical.menu > .item:first-child {\n  border-radius: 0.28571429rem 0.28571429rem 0px 0px;\n}\n.ui.vertical.menu > .item:last-child {\n  border-radius: 0px 0px 0.28571429rem 0.28571429rem;\n}\n/*--- Label ---*/\n.ui.vertical.menu .item > .label {\n  float: right;\n  text-align: center;\n}\n/*--- Icon ---*/\n.ui.vertical.menu .item > i.icon {\n  width: 1.18em;\n  float: right;\n  margin: 0em 0em 0em 0.5em;\n}\n.ui.vertical.menu .item > .label + i.icon {\n  float: none;\n  margin: 0em 0.5em 0em 0em;\n}\n/*--- Border ---*/\n.ui.vertical.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0px;\n  width: 100%;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n.ui.vertical.menu .item:first-child:before {\n  display: none !important;\n}\n/*--- Sub Menu ---*/\n.ui.vertical.menu .item > .menu {\n  margin: 0.5em -1.14285714em 0em;\n}\n.ui.vertical.menu .menu .item {\n  background: none;\n  padding: 0.5em 1.33333333em;\n  font-size: 0.85714286em;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ui.vertical.menu .item .menu a.item:hover,\n.ui.vertical.menu .item .menu .link.item:hover {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.vertical.menu .menu .item:before {\n  display: none;\n}\n/* Vertical Active */\n.ui.vertical.menu .active.item {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 0em;\n  box-shadow: none;\n}\n.ui.vertical.menu > .active.item:first-child {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.vertical.menu > .active.item:last-child {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.vertical.menu > .active.item:only-child {\n  border-radius: 0.28571429rem;\n}\n.ui.vertical.menu .active.item .menu .active.item {\n  border-left: none;\n}\n.ui.vertical.menu .item .menu .active.item {\n  background-color: transparent;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Tabular\n---------------*/\n.ui.tabular.menu {\n  border-radius: 0em;\n  box-shadow: none !important;\n  border: none;\n  background: none transparent;\n  border-bottom: 1px solid #D4D4D5;\n}\n.ui.tabular.fluid.menu {\n  width: calc(100% + (1px * 2)) !important;\n}\n.ui.tabular.menu .item {\n  background: transparent;\n  border-bottom: none;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-top: 2px solid transparent;\n  padding: 0.92857143em 1.42857143em;\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.tabular.menu .item:before {\n  display: none;\n}\n/* Hover */\n.ui.tabular.menu .item:hover {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Active */\n.ui.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: rgba(255, 255, 255, 0.95);\n  border-top-width: 1px;\n  border-color: #D4D4D5;\n  font-weight: bold;\n  margin-bottom: -1px;\n  box-shadow: none;\n  border-radius: 0.28571429rem 0.28571429rem 0px 0px !important;\n}\n/* Coupling with segment for attachment */\n.ui.tabular.menu + .attached:not(.top).segment,\n.ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {\n  border-top: none;\n  margin-left: 0px;\n  margin-top: 0px;\n  margin-right: 0px;\n  width: 100%;\n}\n.top.attached.segment + .ui.bottom.tabular.menu {\n  position: relative;\n  width: calc(100% + (1px * 2));\n  left: -1px;\n}\n/* Bottom Vertical Tabular */\n.ui.bottom.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-top: 1px solid #D4D4D5;\n}\n.ui.bottom.tabular.menu .item {\n  background: none;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: none;\n}\n.ui.bottom.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: rgba(255, 255, 255, 0.95);\n  border-color: #D4D4D5;\n  margin: -1px 0px 0px 0px;\n  border-radius: 0px 0px 0.28571429rem 0.28571429rem !important;\n}\n/* Vertical Tabular (Left) */\n.ui.vertical.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: 1px solid #D4D4D5;\n}\n.ui.vertical.tabular.menu .item {\n  background: none;\n  border-left: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: 1px solid transparent;\n  border-right: none;\n}\n.ui.vertical.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: rgba(255, 255, 255, 0.95);\n  border-color: #D4D4D5;\n  margin: 0px -1px 0px 0px;\n  border-radius: 0.28571429rem 0px 0px 0.28571429rem !important;\n}\n/* Vertical Right Tabular */\n.ui.vertical.right.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: none;\n  border-left: 1px solid #D4D4D5;\n}\n.ui.vertical.right.tabular.menu .item {\n  background: none;\n  border-right: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: 1px solid transparent;\n  border-left: none;\n}\n.ui.vertical.right.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: rgba(255, 255, 255, 0.95);\n  border-color: #D4D4D5;\n  margin: 0px 0px 0px -1px;\n  border-radius: 0px 0.28571429rem 0.28571429rem 0px !important;\n}\n/* Dropdown */\n.ui.tabular.menu .active.dropdown.item {\n  margin-bottom: 0px;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-top: 2px solid transparent;\n  border-bottom: none;\n}\n/*--------------\n   Pagination\n---------------*/\n.ui.pagination.menu {\n  margin: 0em;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.ui.pagination.menu .item:last-child {\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n.ui.compact.menu .item:last-child {\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n.ui.pagination.menu .item:last-child:before {\n  display: none;\n}\n.ui.pagination.menu .item {\n  min-width: 3em;\n  text-align: center;\n}\n.ui.pagination.menu .icon.item i.icon {\n  vertical-align: top;\n}\n/* Active */\n.ui.pagination.menu .active.item {\n  border-top: none;\n  padding-top: 0.92857143em;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n  box-shadow: none;\n}\n/*--------------\n   Secondary\n---------------*/\n.ui.secondary.menu {\n  background: none;\n  margin-left: -0.35714286em;\n  margin-right: -0.35714286em;\n  border-radius: 0em;\n  border: none;\n  box-shadow: none;\n}\n/* Item */\n.ui.secondary.menu .item {\n  align-self: center;\n  box-shadow: none;\n  border: none;\n  padding: 0.78571429em 0.92857143em;\n  margin: 0em 0.35714286em;\n  background: none;\n  transition: color 0.1s ease;\n  border-radius: 0.28571429rem;\n}\n/* No Divider */\n.ui.secondary.menu .item:before {\n  display: none !important;\n}\n/* Header */\n.ui.secondary.menu .header.item {\n  border-radius: 0em;\n  border-right: none;\n  background: none transparent;\n}\n/* Image */\n.ui.secondary.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n/* Hover */\n.ui.secondary.menu .dropdown.item:hover,\n.ui.secondary.menu .link.item:hover,\n.ui.secondary.menu a.item:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Active */\n.ui.secondary.menu .active.item {\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n  border-radius: 0.28571429rem;\n}\n/* Active Hover */\n.ui.secondary.menu .active.item:hover {\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Inverted */\n.ui.secondary.inverted.menu .link.item,\n.ui.secondary.inverted.menu a.item {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n.ui.secondary.inverted.menu .dropdown.item:hover,\n.ui.secondary.inverted.menu .link.item:hover,\n.ui.secondary.inverted.menu a.item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff !important;\n}\n.ui.secondary.inverted.menu .active.item {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff !important;\n}\n/* Fix item margins */\n.ui.secondary.item.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n.ui.secondary.item.menu .item:last-child {\n  margin-right: 0em;\n}\n.ui.secondary.attached.menu {\n  box-shadow: none;\n}\n/* Sub Menu */\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu {\n  margin: 0em -0.92857143em;\n}\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {\n  margin: 0em;\n  padding: 0.5em 1.33333333em;\n}\n/*---------------------\n   Secondary Vertical\n-----------------------*/\n.ui.secondary.vertical.menu > .item {\n  border: none;\n  margin: 0em 0em 0.35714286em;\n  border-radius: 0.28571429rem !important;\n}\n.ui.secondary.vertical.menu > .header.item {\n  border-radius: 0em;\n}\n/* Sub Menu */\n.ui.vertical.secondary.menu .item > .menu .item {\n  background-color: transparent;\n}\n/* Inverted */\n.ui.secondary.inverted.menu {\n  background-color: transparent;\n}\n/*---------------------\n   Secondary Pointing\n-----------------------*/\n.ui.secondary.pointing.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.15);\n}\n.ui.secondary.pointing.menu .item {\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-radius: 0em;\n  align-self: flex-end;\n  margin: 0em 0em -2px;\n  padding: 0.85714286em 1.14285714em;\n  border-bottom-width: 2px;\n  transition: color 0.1s ease;\n}\n/* Item Types */\n.ui.secondary.pointing.menu .header.item {\n  color: rgba(255, 255, 255, 0.85) !important;\n}\n.ui.secondary.pointing.menu .text.item {\n  box-shadow: none !important;\n}\n.ui.secondary.pointing.menu .item:after {\n  display: none;\n}\n/* Hover */\n.ui.secondary.pointing.menu .dropdown.item:hover,\n.ui.secondary.pointing.menu .link.item:hover,\n.ui.secondary.pointing.menu a.item:hover {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Pressed */\n.ui.secondary.pointing.menu .dropdown.item:active,\n.ui.secondary.pointing.menu .link.item:active,\n.ui.secondary.pointing.menu a.item:active {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n/* Active */\n.ui.secondary.pointing.menu .active.item {\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #1B1C1D;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Active Hover */\n.ui.secondary.pointing.menu .active.item:hover {\n  border-color: #1B1C1D;\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Active Dropdown */\n.ui.secondary.pointing.menu .active.dropdown.item {\n  border-color: transparent;\n}\n/* Vertical Pointing */\n.ui.secondary.vertical.pointing.menu {\n  border-bottom-width: 0px;\n  border-right-width: 2px;\n  border-right-style: solid;\n  border-right-color: rgba(255, 255, 255, 0.15);\n}\n.ui.secondary.vertical.pointing.menu .item {\n  border-bottom: none;\n  border-right-style: solid;\n  border-right-color: transparent;\n  border-radius: 0em !important;\n  margin: 0em -2px 0em 0em;\n  border-right-width: 2px;\n}\n/* Vertical Active */\n.ui.secondary.vertical.pointing.menu .active.item {\n  border-color: #1B1C1D;\n}\n/* Inverted */\n.ui.secondary.inverted.pointing.menu {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.ui.secondary.inverted.pointing.menu {\n  border-width: 2px;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.secondary.inverted.pointing.menu .item {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.secondary.inverted.pointing.menu .header.item {\n  color: #FFFFFF !important;\n}\n/* Hover */\n.ui.secondary.inverted.pointing.menu .link.item:hover,\n.ui.secondary.inverted.pointing.menu a.item:hover {\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Active */\n.ui.secondary.inverted.pointing.menu .active.item {\n  border-color: #FFFFFF;\n  color: #ffffff;\n}\n/*--------------\n    Text Menu\n---------------*/\n.ui.text.menu {\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n  margin: 1em -0.5em;\n}\n.ui.text.menu .item {\n  border-radius: 0px;\n  box-shadow: none;\n  align-self: center;\n  margin: 0em 0em;\n  padding: 0.35714286em 0.5em;\n  font-weight: normal;\n  color: rgba(255, 255, 255, 0.6);\n  transition: opacity 0.1s ease;\n}\n/* Border */\n.ui.text.menu .item:before,\n.ui.text.menu .menu .item:before {\n  display: none !important;\n}\n/* Header */\n.ui.text.menu .header.item {\n  background-color: transparent;\n  opacity: 1;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.92857143em;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n/* Image */\n.ui.text.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n/*--- fluid text ---*/\n.ui.text.item.menu .item {\n  margin: 0em;\n}\n/*--- vertical text ---*/\n.ui.vertical.text.menu {\n  margin: 1em 0em;\n}\n.ui.vertical.text.menu:first-child {\n  margin-top: 0rem;\n}\n.ui.vertical.text.menu:last-child {\n  margin-bottom: 0rem;\n}\n.ui.vertical.text.menu .item {\n  margin: 0.57142857em 0em;\n  padding-left: 0em;\n  padding-right: 0em;\n}\n.ui.vertical.text.menu .item > i.icon {\n  float: none;\n  margin: 0em 0.35714286em 0em 0em;\n}\n.ui.vertical.text.menu .header.item {\n  margin: 0.57142857em 0em 0.71428571em;\n}\n/* Vertical Sub Menu */\n.ui.vertical.text.menu .item:not(.dropdown) > .menu {\n  margin: 0em;\n}\n.ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {\n  margin: 0em;\n  padding: 0.5em 0em;\n}\n/*--- hover ---*/\n.ui.text.menu .item:hover {\n  opacity: 1;\n  background-color: transparent;\n}\n/*--- active ---*/\n.ui.text.menu .active.item {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-weight: normal;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--- active hover ---*/\n.ui.text.menu .active.item:hover {\n  background-color: transparent;\n}\n/* Disable Bariations */\n.ui.text.pointing.menu .active.item:after {\n  box-shadow: none;\n}\n.ui.text.attached.menu {\n  box-shadow: none;\n}\n/* Inverted */\n.ui.inverted.text.menu,\n.ui.inverted.text.menu .item,\n.ui.inverted.text.menu .item:hover,\n.ui.inverted.text.menu .active.item {\n  background-color: transparent !important;\n}\n/* Fluid */\n.ui.fluid.text.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n/*--------------\n    Icon Only\n---------------*/\n/* Vertical Menu */\n.ui.vertical.icon.menu {\n  display: inline-block;\n  width: auto;\n}\n/* Item */\n.ui.icon.menu .item {\n  height: auto;\n  text-align: center;\n  color: #1B1C1D;\n}\n/* Icon */\n.ui.icon.menu .item > .icon:not(.dropdown) {\n  margin: 0;\n  opacity: 1;\n}\n/* Icon Gylph */\n.ui.icon.menu .icon:before {\n  opacity: 1;\n}\n/* (x) Item Icon */\n.ui.menu .icon.item > .icon {\n  width: auto;\n  margin: 0em auto;\n}\n/* Vertical Icon */\n.ui.vertical.icon.menu .item > .icon:not(.dropdown) {\n  display: block;\n  opacity: 1;\n  margin: 0em auto;\n  float: none;\n}\n/* Inverted */\n.ui.inverted.icon.menu .item {\n  color: #FFFFFF;\n}\n/*--------------\n   Labeled Icon\n---------------*/\n/* Menu */\n.ui.labeled.icon.menu {\n  text-align: center;\n}\n/* Item */\n.ui.labeled.icon.menu .item {\n  min-width: 6em;\n  flex-direction: column;\n}\n/* Icon */\n.ui.labeled.icon.menu .item > .icon:not(.dropdown) {\n  height: 1em;\n  display: block;\n  font-size: 1.71428571em !important;\n  margin: 0em auto 0.5rem !important;\n}\n/* Fluid */\n.ui.fluid.labeled.icon.menu > .item {\n  min-width: 0em;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n    Stackable\n---------------*/\n@media only screen and (max-width: 767px) {\n  .ui.stackable.menu {\n    flex-direction: column;\n  }\n  .ui.stackable.menu .item {\n    width: 100% !important;\n  }\n  .ui.stackable.menu .item:before {\n    position: absolute;\n    content: '';\n    top: auto;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.1);\n  }\n  .ui.stackable.menu .left.menu,\n  .ui.stackable.menu .left.item {\n    margin-right: 0 !important;\n  }\n  .ui.stackable.menu .right.menu,\n  .ui.stackable.menu .right.item {\n    margin-left: 0 !important;\n  }\n  .ui.stackable.menu .right.menu,\n  .ui.stackable.menu .left.menu {\n    flex-direction: column;\n  }\n}\n/*--------------\n     Colors\n---------------*/\n/*--- Standard Colors  ---*/\n.ui.menu .red.active.item,\n.ui.red.menu .active.item {\n  border-color: #DB2828 !important;\n  color: #DB2828 !important;\n}\n.ui.menu .orange.active.item,\n.ui.orange.menu .active.item {\n  border-color: #F2711C !important;\n  color: #F2711C !important;\n}\n.ui.menu .yellow.active.item,\n.ui.yellow.menu .active.item {\n  border-color: #FBBD08 !important;\n  color: #FBBD08 !important;\n}\n.ui.menu .olive.active.item,\n.ui.olive.menu .active.item {\n  border-color: #B5CC18 !important;\n  color: #B5CC18 !important;\n}\n.ui.menu .green.active.item,\n.ui.green.menu .active.item {\n  border-color: #21BA45 !important;\n  color: #21BA45 !important;\n}\n.ui.menu .teal.active.item,\n.ui.teal.menu .active.item {\n  border-color: #00B5AD !important;\n  color: #00B5AD !important;\n}\n.ui.menu .blue.active.item,\n.ui.blue.menu .active.item {\n  border-color: #2185D0 !important;\n  color: #2185D0 !important;\n}\n.ui.menu .violet.active.item,\n.ui.violet.menu .active.item {\n  border-color: #6435C9 !important;\n  color: #6435C9 !important;\n}\n.ui.menu .purple.active.item,\n.ui.purple.menu .active.item {\n  border-color: #A333C8 !important;\n  color: #A333C8 !important;\n}\n.ui.menu .pink.active.item,\n.ui.pink.menu .active.item {\n  border-color: #E03997 !important;\n  color: #E03997 !important;\n}\n.ui.menu .brown.active.item,\n.ui.brown.menu .active.item {\n  border-color: #A5673F !important;\n  color: #A5673F !important;\n}\n.ui.menu .grey.active.item,\n.ui.grey.menu .active.item {\n  border-color: #767676 !important;\n  color: #767676 !important;\n}\n/*--------------\n    Inverted\n---------------*/\n.ui.inverted.menu {\n  border: 0px solid transparent;\n  background: #1B1C1D;\n  box-shadow: none;\n}\n/* Menu Item */\n.ui.inverted.menu .item,\n.ui.inverted.menu .item > a:not(.ui) {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.inverted.menu .item.menu {\n  background: transparent;\n}\n/*--- Border ---*/\n.ui.inverted.menu .item:before {\n  background: rgba(255, 255, 255, 0.08);\n}\n.ui.vertical.inverted.menu .item:before {\n  background: rgba(255, 255, 255, 0.08);\n}\n/* Sub Menu */\n.ui.vertical.inverted.menu .menu .item,\n.ui.vertical.inverted.menu .menu .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.5);\n}\n/* Header */\n.ui.inverted.menu .header.item {\n  margin: 0em;\n  background: transparent;\n  box-shadow: none;\n}\n/* Disabled */\n.ui.inverted.menu .item.disabled,\n.ui.inverted.menu .item.disabled:hover {\n  color: rgba(225, 225, 225, 0.3);\n}\n/*--- Hover ---*/\n.ui.link.inverted.menu .item:hover,\n.ui.inverted.menu .dropdown.item:hover,\n.ui.inverted.menu .link.item:hover,\n.ui.inverted.menu a.item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n.ui.vertical.inverted.menu .item .menu a.item:hover,\n.ui.vertical.inverted.menu .item .menu .link.item:hover {\n  background: transparent;\n  color: #ffffff;\n}\n/*--- Pressed ---*/\n.ui.inverted.menu a.item:active,\n.ui.inverted.menu .link.item:active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n/*--- Active ---*/\n.ui.inverted.menu .active.item {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff !important;\n}\n.ui.inverted.vertical.menu .item .menu .active.item {\n  background: transparent;\n  color: #FFFFFF;\n}\n.ui.inverted.pointing.menu .active.item:after {\n  background: #3D3E3F !important;\n  margin: 0em !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n/*--- Active Hover ---*/\n.ui.inverted.menu .active.item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: #FFFFFF !important;\n}\n.ui.inverted.pointing.menu .active.item:hover:after {\n  background: #3D3E3F !important;\n}\n/*--------------\n     Floated\n---------------*/\n.ui.floated.menu {\n  float: left;\n  margin: 0rem 0.5rem 0rem 0rem;\n}\n.ui.floated.menu .item:last-child:before {\n  display: none;\n}\n.ui.right.floated.menu {\n  float: right;\n  margin: 0rem 0rem 0rem 0.5rem;\n}\n/*--------------\n    Inverted\n---------------*/\n/* Red */\n.ui.inverted.menu .red.active.item,\n.ui.inverted.red.menu {\n  background-color: #DB2828;\n}\n.ui.inverted.red.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.red.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Orange */\n.ui.inverted.menu .orange.active.item,\n.ui.inverted.orange.menu {\n  background-color: #F2711C;\n}\n.ui.inverted.orange.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.orange.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Yellow */\n.ui.inverted.menu .yellow.active.item,\n.ui.inverted.yellow.menu {\n  background-color: #FBBD08;\n}\n.ui.inverted.yellow.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.yellow.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Olive */\n.ui.inverted.menu .olive.active.item,\n.ui.inverted.olive.menu {\n  background-color: #B5CC18;\n}\n.ui.inverted.olive.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.olive.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Green */\n.ui.inverted.menu .green.active.item,\n.ui.inverted.green.menu {\n  background-color: #21BA45;\n}\n.ui.inverted.green.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.green.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Teal */\n.ui.inverted.menu .teal.active.item,\n.ui.inverted.teal.menu {\n  background-color: #00B5AD;\n}\n.ui.inverted.teal.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.teal.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Blue */\n.ui.inverted.menu .blue.active.item,\n.ui.inverted.blue.menu {\n  background-color: #2185D0;\n}\n.ui.inverted.blue.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.blue.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Violet */\n.ui.inverted.menu .violet.active.item,\n.ui.inverted.violet.menu {\n  background-color: #6435C9;\n}\n.ui.inverted.violet.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.violet.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Purple */\n.ui.inverted.menu .purple.active.item,\n.ui.inverted.purple.menu {\n  background-color: #A333C8;\n}\n.ui.inverted.purple.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.purple.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Pink */\n.ui.inverted.menu .pink.active.item,\n.ui.inverted.pink.menu {\n  background-color: #E03997;\n}\n.ui.inverted.pink.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.pink.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Brown */\n.ui.inverted.menu .brown.active.item,\n.ui.inverted.brown.menu {\n  background-color: #A5673F;\n}\n.ui.inverted.brown.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.brown.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/* Grey */\n.ui.inverted.menu .grey.active.item,\n.ui.inverted.grey.menu {\n  background-color: #767676;\n}\n.ui.inverted.grey.menu .item:before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.ui.inverted.grey.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n/*--------------\n     Fitted\n---------------*/\n.ui.fitted.menu .item,\n.ui.fitted.menu .item .menu .item,\n.ui.menu .fitted.item {\n  padding: 0em;\n}\n.ui.horizontally.fitted.menu .item,\n.ui.horizontally.fitted.menu .item .menu .item,\n.ui.menu .horizontally.fitted.item {\n  padding-top: 0.92857143em;\n  padding-bottom: 0.92857143em;\n}\n.ui.vertically.fitted.menu .item,\n.ui.vertically.fitted.menu .item .menu .item,\n.ui.menu .vertically.fitted.item {\n  padding-left: 1.14285714em;\n  padding-right: 1.14285714em;\n}\n/*--------------\n   Borderless\n---------------*/\n.ui.borderless.menu .item:before,\n.ui.borderless.menu .item .menu .item:before,\n.ui.menu .borderless.item:before {\n  background: none !important;\n}\n/*-------------------\n       Compact\n--------------------*/\n.ui.compact.menu {\n  display: inline-flex;\n  margin: 0em;\n  vertical-align: middle;\n}\n.ui.compact.vertical.menu {\n  display: inline-block;\n}\n.ui.compact.menu .item:last-child {\n  border-radius: 0em 0.28571429rem 0.28571429rem 0em;\n}\n.ui.compact.menu .item:last-child:before {\n  display: none;\n}\n.ui.compact.vertical.menu {\n  width: auto !important;\n}\n.ui.compact.vertical.menu .item:last-child::before {\n  display: block;\n}\n/*-------------------\n        Fluid\n--------------------*/\n.ui.menu.fluid,\n.ui.vertical.menu.fluid {\n  width: 100% !important;\n}\n/*-------------------\n      Evenly Sized\n--------------------*/\n.ui.item.menu,\n.ui.item.menu .item {\n  width: 100%;\n  padding-left: 0em !important;\n  padding-right: 0em !important;\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n  text-align: center;\n  justify-content: center;\n}\n.ui.attached.item.menu {\n  margin: 0em -1px !important;\n}\n.ui.item.menu .item:last-child:before {\n  display: none;\n}\n.ui.menu.two.item .item {\n  width: 50%;\n}\n.ui.menu.three.item .item {\n  width: 33.333%;\n}\n.ui.menu.four.item .item {\n  width: 25%;\n}\n.ui.menu.five.item .item {\n  width: 20%;\n}\n.ui.menu.six.item .item {\n  width: 16.666%;\n}\n.ui.menu.seven.item .item {\n  width: 14.285%;\n}\n.ui.menu.eight.item .item {\n  width: 12.5%;\n}\n.ui.menu.nine.item .item {\n  width: 11.11%;\n}\n.ui.menu.ten.item .item {\n  width: 10%;\n}\n.ui.menu.eleven.item .item {\n  width: 9.09%;\n}\n.ui.menu.twelve.item .item {\n  width: 8.333%;\n}\n/*--------------\n     Fixed\n---------------*/\n.ui.menu.fixed {\n  position: fixed;\n  z-index: 101;\n  margin: 0em;\n  width: 100%;\n}\n.ui.menu.fixed,\n.ui.menu.fixed .item:first-child,\n.ui.menu.fixed .item:last-child {\n  border-radius: 0px !important;\n}\n.ui.fixed.menu,\n.ui[class*=\"top fixed\"].menu {\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n}\n.ui[class*=\"top fixed\"].menu {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n.ui[class*=\"right fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n  top: 0px;\n  right: 0px;\n  left: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n.ui[class*=\"bottom fixed\"].menu {\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  bottom: 0px;\n  left: 0px;\n  top: auto;\n  right: auto;\n}\n.ui[class*=\"left fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n/* Coupling with Grid */\n.ui.fixed.menu + .ui.grid {\n  padding-top: 2.75rem;\n}\n/*-------------------\n       Pointing\n--------------------*/\n.ui.pointing.menu .item:after {\n  visibility: hidden;\n  position: absolute;\n  content: '';\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  background: none;\n  margin: 0.5px 0em 0em;\n  width: 0.57142857em;\n  height: 0.57142857em;\n  border: none;\n  border-bottom: 1px solid #D4D4D5;\n  border-right: 1px solid #D4D4D5;\n  z-index: 2;\n  transition: background 0.1s ease;\n}\n.ui.vertical.pointing.menu .item:after {\n  position: absolute;\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  margin: 0em -0.5px 0em 0em;\n  border: none;\n  border-top: 1px solid #D4D4D5;\n  border-right: 1px solid #D4D4D5;\n}\n/* Active */\n.ui.pointing.menu .active.item:after {\n  visibility: visible;\n}\n.ui.pointing.menu .active.dropdown.item:after {\n  visibility: hidden;\n}\n/* Don't double up pointers */\n.ui.pointing.menu .dropdown.active.item:after,\n.ui.pointing.menu .active.item .menu .active.item:after {\n  display: none;\n}\n/* Colors */\n.ui.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n.ui.pointing.menu .active.item:after {\n  background-color: #F2F2F2;\n}\n.ui.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n.ui.vertical.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n.ui.vertical.pointing.menu .active.item:after {\n  background-color: #F2F2F2;\n}\n.ui.vertical.pointing.menu .menu .active.item:after {\n  background-color: #FFFFFF;\n}\n/*--------------\n    Attached\n---------------*/\n/* Middle */\n.ui.attached.menu {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% - (-1px * 2));\n  max-width: calc(100% - (-1px * 2));\n  box-shadow: none;\n}\n.ui.attached + .ui.attached.menu:not(.top) {\n  border-top: none;\n}\n/* Top */\n.ui[class*=\"top attached\"].menu {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1rem;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.menu[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n/* Bottom */\n.ui[class*=\"bottom attached\"].menu {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1rem;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui[class*=\"bottom attached\"].menu:last-child {\n  margin-bottom: 0em;\n}\n/* Attached Menu Item */\n.ui.top.attached.menu > .item:first-child {\n  border-radius: 0.28571429rem 0em 0em 0em;\n}\n.ui.bottom.attached.menu > .item:first-child {\n  border-radius: 0em 0em 0em 0.28571429rem;\n}\n/* Tabular Attached */\n.ui.attached.menu:not(.tabular) {\n  border: 1px solid #D4D4D5;\n}\n.ui.attached.inverted.menu {\n  border: none;\n}\n.ui.attached.tabular.menu {\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n}\n/*--------------\n     Sizes\n---------------*/\n/* Mini */\n.ui.mini.menu {\n  font-size: 0.78571429rem;\n}\n.ui.mini.vertical.menu {\n  width: 9rem;\n}\n/* Tiny */\n.ui.tiny.menu {\n  font-size: 0.85714286rem;\n}\n.ui.tiny.vertical.menu {\n  width: 11rem;\n}\n/* Small */\n.ui.small.menu {\n  font-size: 0.92857143rem;\n}\n.ui.small.vertical.menu {\n  width: 13rem;\n}\n/* Medium */\n.ui.menu {\n  font-size: 1rem;\n}\n.ui.vertical.menu {\n  width: 15rem;\n}\n/* Large */\n.ui.large.menu {\n  font-size: 1.07142857rem;\n}\n.ui.large.vertical.menu {\n  width: 18rem;\n}\n/* Huge */\n.ui.huge.menu {\n  font-size: 1.21428571rem;\n}\n.ui.huge.vertical.menu {\n  width: 22rem;\n}\n/* Big */\n.ui.big.menu {\n  font-size: 1.14285714rem;\n}\n.ui.big.vertical.menu {\n  width: 20rem;\n}\n/* Massive */\n.ui.massive.menu {\n  font-size: 1.28571429rem;\n}\n.ui.massive.vertical.menu {\n  width: 25rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Message\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Message\n*******************************/\n/*-------------------\n       Elements\n--------------------*/\n/* Header */\n/* Paragraph */\n/* List */\n/* Icon */\n/* Close Icon */\n/*-------------------\n        Types\n--------------------*/\n/* Icon Message */\n/* Attached */\n/* Floating */\n/* Colors */\n/* Warning / Positive / Negative / Info */\n/* Packaged Theme */\n/*******************************\n            Message\n*******************************/\n/*-------------------\n       Elements\n--------------------*/\n/* Header */\n/* Paragraph */\n/* List */\n/* Icon */\n/* Close Icon */\n/*-------------------\n        Types\n--------------------*/\n/* Icon Message */\n/* Attached */\n/* Floating */\n/* Colors */\n/* Warning / Positive / Negative / Info */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Message\n*******************************/\n.ui.message {\n  position: relative;\n  min-height: 1em;\n  margin: 1em 0em;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 1em 1.5em;\n  line-height: 1.4285em;\n  color: rgba(255, 255, 255, 0.87);\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.22) inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.message:first-child {\n  margin-top: 0em;\n}\n.ui.message:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n     Content\n---------------*/\n/* Header */\n.ui.message .header {\n  display: block;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  margin: -0.14285714em 0em 0rem 0em;\n}\n/* Default font size */\n.ui.message .header:not(.ui) {\n  font-size: 1.14285714em;\n}\n/* Paragraph */\n.ui.message p {\n  opacity: 0.85;\n  margin: 0.75em 0em;\n}\n.ui.message p:first-child {\n  margin-top: 0em;\n}\n.ui.message p:last-child {\n  margin-bottom: 0em;\n}\n.ui.message .header + p {\n  margin-top: 0.25em;\n}\n/* List */\n.ui.message .list:not(.ui) {\n  text-align: left;\n  padding: 0em;\n  opacity: 0.85;\n  list-style-position: inside;\n  margin: 0.5em 0em 0em;\n}\n.ui.message .list:not(.ui):first-child {\n  margin-top: 0em;\n}\n.ui.message .list:not(.ui):last-child {\n  margin-bottom: 0em;\n}\n.ui.message .list:not(.ui) li {\n  position: relative;\n  list-style-type: none;\n  margin: 0em 0em 0.3em 1em;\n  padding: 0em;\n}\n.ui.message .list:not(.ui) li:before {\n  position: absolute;\n  content: '•';\n  left: -1em;\n  height: 100%;\n  vertical-align: baseline;\n}\n.ui.message .list:not(.ui) li:last-child {\n  margin-bottom: 0em;\n}\n/* Icon */\n.ui.message > .icon {\n  margin-right: 0.6em;\n}\n/* Close Icon */\n.ui.message > .close.icon {\n  cursor: pointer;\n  position: absolute;\n  margin: 0em;\n  top: 0.78575em;\n  right: 0.5em;\n  opacity: 0.7;\n  transition: opacity 0.1s ease;\n}\n.ui.message > .close.icon:hover {\n  opacity: 1;\n}\n/* First / Last Element */\n.ui.message > :first-child {\n  margin-top: 0em;\n}\n.ui.message > :last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n            Coupling\n*******************************/\n.ui.dropdown .menu > .message {\n  margin: 0px -1px;\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n    Visible\n---------------*/\n.ui.visible.visible.visible.visible.message {\n  display: block;\n}\n.ui.icon.visible.visible.visible.visible.message {\n  display: flex;\n}\n/*--------------\n     Hidden\n---------------*/\n.ui.hidden.hidden.hidden.hidden.message {\n  display: none;\n}\n/*******************************\n            Variations\n*******************************/\n/*--------------\n    Compact\n---------------*/\n.ui.compact.message {\n  display: inline-block;\n}\n.ui.compact.icon.message {\n  display: inline-flex;\n}\n/*--------------\n    Attached\n---------------*/\n.ui.attached.message {\n  margin-bottom: -1px;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n  box-shadow: 0em 0em 0em 1px rgba(255, 255, 255, 0.15) inset;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n.ui.attached + .ui.attached.message:not(.top):not(.bottom) {\n  margin-top: -1px;\n  border-radius: 0em;\n}\n.ui.bottom.attached.message {\n  margin-top: -1px;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  box-shadow: 0em 0em 0em 1px rgba(255, 255, 255, 0.15) inset, 0px 1px 2px 0 rgba(255, 255, 255, 0.15);\n}\n.ui.bottom.attached.message:not(:last-child) {\n  margin-bottom: 1em;\n}\n.ui.attached.icon.message {\n  width: auto;\n}\n/*--------------\n      Icon\n---------------*/\n.ui.icon.message {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.ui.icon.message > .icon:not(.close) {\n  display: block;\n  flex: 0 0 auto;\n  width: auto;\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 3em;\n  opacity: 0.8;\n}\n.ui.icon.message > .content {\n  display: block;\n  flex: 1 1 auto;\n  vertical-align: middle;\n}\n.ui.icon.message .icon:not(.close) + .content {\n  padding-left: 0rem;\n}\n.ui.icon.message .circular.icon {\n  width: 1em;\n}\n/*--------------\n    Floating\n---------------*/\n.ui.floating.message {\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.22) inset, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n/*--------------\n     Colors\n---------------*/\n.ui.black.message {\n  background-color: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n/*--------------\n     Types\n---------------*/\n/* Positive */\n.ui.positive.message {\n  background-color: #FCFFF5;\n  color: #2C662D;\n}\n.ui.positive.message,\n.ui.attached.positive.message {\n  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.positive.message .header {\n  color: #1A531B;\n}\n/* Negative */\n.ui.negative.message {\n  background-color: rgba(200, 3, 3, 0.15);\n  color: #FFFFFF;\n}\n.ui.negative.message,\n.ui.attached.negative.message {\n  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.negative.message .header {\n  color: #912D2B;\n}\n/* Info */\n.ui.info.message {\n  background-color: #F8FFFF;\n  color: #276F86;\n}\n.ui.info.message,\n.ui.attached.info.message {\n  box-shadow: 0px 0px 0px 1px #A9D5DE inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.info.message .header {\n  color: #0E566C;\n}\n/* Warning */\n.ui.warning.message {\n  background-color: #FFFAF3;\n  color: #573A08;\n}\n.ui.warning.message,\n.ui.attached.warning.message {\n  box-shadow: 0px 0px 0px 1px #C9BA9B inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.warning.message .header {\n  color: #794B02;\n}\n/* Error */\n.ui.error.message {\n  background-color: rgba(200, 3, 3, 0.15);\n  color: #FFFFFF;\n}\n.ui.error.message,\n.ui.attached.error.message {\n  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.error.message .header {\n  color: #912D2B;\n}\n/* Success */\n.ui.success.message {\n  background-color: #FCFFF5;\n  color: #2C662D;\n}\n.ui.success.message,\n.ui.attached.success.message {\n  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.success.message .header {\n  color: #1A531B;\n}\n/* Colors */\n.ui.inverted.message,\n.ui.black.message {\n  background-color: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.red.message {\n  background-color: #FFE8E6;\n  color: #DB2828;\n  box-shadow: 0px 0px 0px 1px #DB2828 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.red.message .header {\n  color: #c82121;\n}\n.ui.orange.message {\n  background-color: #FFEDDE;\n  color: #F2711C;\n  box-shadow: 0px 0px 0px 1px #F2711C inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.orange.message .header {\n  color: #e7640d;\n}\n.ui.yellow.message {\n  background-color: #FFF8DB;\n  color: #B58105;\n  box-shadow: 0px 0px 0px 1px #B58105 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.yellow.message .header {\n  color: #9c6f04;\n}\n.ui.olive.message {\n  background-color: #FBFDEF;\n  color: #8ABC1E;\n  box-shadow: 0px 0px 0px 1px #8ABC1E inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.olive.message .header {\n  color: #7aa61a;\n}\n.ui.green.message {\n  background-color: #E5F9E7;\n  color: #1EBC30;\n  box-shadow: 0px 0px 0px 1px #1EBC30 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.green.message .header {\n  color: #1aa62a;\n}\n.ui.teal.message {\n  background-color: #E1F7F7;\n  color: #10A3A3;\n  box-shadow: 0px 0px 0px 1px #10A3A3 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.teal.message .header {\n  color: #0e8c8c;\n}\n.ui.blue.message {\n  background-color: #DFF0FF;\n  color: #2185D0;\n  box-shadow: 0px 0px 0px 1px #2185D0 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.blue.message .header {\n  color: #1e77ba;\n}\n.ui.violet.message {\n  background-color: #EAE7FF;\n  color: #6435C9;\n  box-shadow: 0px 0px 0px 1px #6435C9 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.violet.message .header {\n  color: #5a30b5;\n}\n.ui.purple.message {\n  background-color: #F6E7FF;\n  color: #A333C8;\n  box-shadow: 0px 0px 0px 1px #A333C8 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.purple.message .header {\n  color: #922eb4;\n}\n.ui.pink.message {\n  background-color: #FFE3FB;\n  color: #E03997;\n  box-shadow: 0px 0px 0px 1px #E03997 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.pink.message .header {\n  color: #dd238b;\n}\n.ui.brown.message {\n  background-color: #F1E2D3;\n  color: #A5673F;\n  box-shadow: 0px 0px 0px 1px #A5673F inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n.ui.brown.message .header {\n  color: #935b38;\n}\n/*--------------\n     Sizes\n---------------*/\n.ui.mini.message {\n  font-size: 0.78571429em;\n}\n.ui.tiny.message {\n  font-size: 0.85714286em;\n}\n.ui.small.message {\n  font-size: 0.92857143em;\n}\n.ui.message {\n  font-size: 1em;\n}\n.ui.large.message {\n  font-size: 1.14285714em;\n}\n.ui.big.message {\n  font-size: 1.28571429em;\n}\n.ui.huge.message {\n  font-size: 1.42857143em;\n}\n.ui.massive.message {\n  font-size: 1.71428571em;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Table\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Table\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*--------------\n     Parts\n---------------*/\n/* Table Row */\n/* Table Cell */\n/* Table Header */\n/* Table Footer */\n/* Responsive Size */\n/*-------------------\n       Types\n--------------------*/\n/* Definition */\n/*--------------\n    Couplings\n---------------*/\n/*--------------\n     States\n---------------*/\n/* Positive */\n/* Negative */\n/* Error */\n/* Warning */\n/* Active */\n/*--------------\n     Types\n---------------*/\n/* Attached */\n/* Striped */\n/* Selectable */\n/* Sortable */\n/* Colors */\n/* Inverted */\n/* Basic */\n/* Padded */\n/* Compact */\n/* Sizes */\n/* Packaged Theme */\n/*******************************\n             Table\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*--------------\n     Parts\n---------------*/\n/* Table Row */\n/* Table Cell */\n/* Table Header */\n/* Table Footer */\n/* Responsive Size */\n/*-------------------\n       Types\n--------------------*/\n/* Definition */\n/*--------------\n    Couplings\n---------------*/\n/*--------------\n     States\n---------------*/\n/* Positive */\n/* Negative */\n/* Error */\n/* Warning */\n/* Active */\n/*--------------\n     Types\n---------------*/\n/* Attached */\n/* Striped */\n/* Selectable */\n/* Sortable */\n/* Colors */\n/* Inverted */\n/* Basic */\n/* Padded */\n/* Compact */\n/* Sizes */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Table\n*******************************/\n/* Prototype */\n.ui.table {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.15);\n  margin: 1em 0em;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: none;\n  border-radius: 0.28571429rem;\n  text-align: left;\n  color: rgba(255, 255, 255, 0.87);\n  border-collapse: separate;\n  border-spacing: 0px;\n}\n.ui.table:first-child {\n  margin-top: 0em;\n}\n.ui.table:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n             Parts\n*******************************/\n/* Table Content */\n.ui.table th,\n.ui.table td {\n  transition: background 0.1s ease, color 0.1s ease;\n}\n/* Headers */\n.ui.table thead {\n  box-shadow: none;\n}\n.ui.table thead th {\n  cursor: auto;\n  background: rgba(255, 255, 255, 0.15);\n  text-align: inherit;\n  color: rgba(255, 255, 255, 0.87);\n  padding: 0.92857143em 0.78571429em;\n  vertical-align: inherit;\n  font-style: none;\n  font-weight: bold;\n  text-transform: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  border-left: none;\n}\n.ui.table thead tr > th:first-child {\n  border-left: none;\n}\n.ui.table thead tr:first-child > th:first-child {\n  border-radius: 0.28571429rem 0em 0em 0em;\n}\n.ui.table thead tr:first-child > th:last-child {\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n.ui.table thead tr:first-child > th:only-child {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n/* Footer */\n.ui.table tfoot {\n  box-shadow: none;\n}\n.ui.table tfoot th {\n  cursor: auto;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.15);\n  text-align: inherit;\n  color: rgba(255, 255, 255, 0.87);\n  padding: 0.78571429em 0.78571429em;\n  vertical-align: middle;\n  font-style: normal;\n  font-weight: normal;\n  text-transform: none;\n}\n.ui.table tfoot tr > th:first-child {\n  border-left: none;\n}\n.ui.table tfoot tr:first-child > th:first-child {\n  border-radius: 0em 0em 0em 0.28571429rem;\n}\n.ui.table tfoot tr:first-child > th:last-child {\n  border-radius: 0em 0em 0.28571429rem 0em;\n}\n.ui.table tfoot tr:first-child > th:only-child {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n/* Table Row */\n.ui.table tr td {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n.ui.table tr:first-child td {\n  border-top: none;\n}\n/* Repeated tbody */\n.ui.table tbody + tbody tr:first-child td {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n/* Table Cells */\n.ui.table td {\n  padding: 0.78571429em 0.78571429em;\n  text-align: inherit;\n}\n/* Icons */\n.ui.table > .icon {\n  vertical-align: baseline;\n}\n.ui.table > .icon:only-child {\n  margin: 0em;\n}\n/* Table Segment */\n.ui.table.segment {\n  padding: 0em;\n}\n.ui.table.segment:after {\n  display: none;\n}\n.ui.table.segment.stacked:after {\n  display: block;\n}\n/* Responsive */\n@media only screen and (max-width: 767px) {\n  .ui.table:not(.unstackable) {\n    width: 100%;\n  }\n  .ui.table:not(.unstackable) tbody,\n  .ui.table:not(.unstackable) tr,\n  .ui.table:not(.unstackable) tr > th,\n  .ui.table:not(.unstackable) tr > td {\n    width: auto !important;\n    display: block !important;\n  }\n  .ui.table:not(.unstackable) {\n    padding: 0em;\n  }\n  .ui.table:not(.unstackable) thead {\n    display: block;\n  }\n  .ui.table:not(.unstackable) tfoot {\n    display: block;\n  }\n  .ui.table:not(.unstackable) tr {\n    padding-top: 1em;\n    padding-bottom: 1em;\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;\n  }\n  .ui.table:not(.unstackable) tr > th,\n  .ui.table:not(.unstackable) tr > td {\n    background: none;\n    border: none !important;\n    padding: 0.25em 0.75em !important;\n    box-shadow: none !important;\n  }\n  .ui.table:not(.unstackable) th:first-child,\n  .ui.table:not(.unstackable) td:first-child {\n    font-weight: bold;\n  }\n  /* Definition Table */\n  .ui.definition.table:not(.unstackable) thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n/*******************************\n            Coupling\n*******************************/\n/* UI Image */\n.ui.table th .image,\n.ui.table th .image img,\n.ui.table td .image,\n.ui.table td .image img {\n  max-width: none;\n}\n/*******************************\n             Types\n*******************************/\n/*--------------\n    Complex\n---------------*/\n.ui.structured.table {\n  border-collapse: collapse;\n}\n.ui.structured.table thead th {\n  border-left: none;\n  border-right: none;\n}\n.ui.structured.sortable.table thead th {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.structured.basic.table th {\n  border-left: none;\n  border-right: none;\n}\n.ui.structured.celled.table tr th,\n.ui.structured.celled.table tr td {\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n/*--------------\n   Definition\n---------------*/\n.ui.definition.table thead:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: transparent;\n  font-weight: normal;\n  color: rgba(255, 255, 255, 0.4);\n  box-shadow: -1px -1px 0px 1px #FFFFFF;\n}\n.ui.definition.table tfoot:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: transparent;\n  font-weight: rgba(255, 255, 255, 0.4);\n  color: normal;\n  box-shadow: 1px 1px 0px 1px #FFFFFF;\n}\n/* Remove Border */\n.ui.celled.definition.table thead:not(.full-width) th:first-child {\n  box-shadow: 0px -1px 0px 1px #FFFFFF;\n}\n.ui.celled.definition.table tfoot:not(.full-width) th:first-child {\n  box-shadow: 0px 1px 0px 1px #FFFFFF;\n}\n/* Highlight Defining Column */\n.ui.definition.table tr td:first-child:not(.ignored),\n.ui.definition.table tr td.definition {\n  background: rgba(0, 0, 0, 0.03);\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.95);\n  text-transform: '';\n  box-shadow: '';\n  text-align: '';\n  font-size: 1em;\n  padding-left: '';\n  padding-right: '';\n}\n/* Fix 2nd Column */\n.ui.definition.table thead:not(.full-width) th:nth-child(2) {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.definition.table tfoot:not(.full-width) th:nth-child(2) {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.definition.table td:nth-child(2) {\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n}\n/*******************************\n             States\n*******************************/\n/*--------------\n    Positive\n---------------*/\n.ui.table tr.positive,\n.ui.table td.positive {\n  box-shadow: 0px 0px 0px #A3C293 inset;\n}\n.ui.table tr.positive,\n.ui.table td.positive {\n  background: #FCFFF5 !important;\n  color: #2C662D !important;\n}\n/*--------------\n     Negative\n---------------*/\n.ui.table tr.negative,\n.ui.table td.negative {\n  box-shadow: 0px 0px 0px #E0B4B4 inset;\n}\n.ui.table tr.negative,\n.ui.table td.negative,\n.ui.table th.negative {\n  background: rgba(200, 3, 3, 0.15) !important;\n  color: #FFFFFF !important;\n}\n/*--------------\n      Error\n---------------*/\n.ui.table tr.error,\n.ui.table td.error {\n  box-shadow: 0px 0px 0px #E0B4B4 inset;\n}\n.ui.table tr.error,\n.ui.table td.error {\n  background: rgba(200, 3, 3, 0.15) !important;\n  color: #FFFFFF !important;\n}\n/*--------------\n     Warning\n---------------*/\n.ui.table tr.warning,\n.ui.table td.warning {\n  box-shadow: 0px 0px 0px #C9BA9B inset;\n}\n.ui.table tr.warning,\n.ui.table td.warning {\n  background: #FFFAF3 !important;\n  color: #573A08 !important;\n}\n/*--------------\n     Active\n---------------*/\n.ui.table tr.active,\n.ui.table td.active {\n  box-shadow: 0px 0px 0px rgba(255, 255, 255, 0.87) inset;\n}\n.ui.table tr.active,\n.ui.table td.active {\n  background: #E0E0E0 !important;\n  color: rgba(255, 255, 255, 0.87) !important;\n}\n/*--------------\n     Disabled\n---------------*/\n.ui.table tr.disabled td,\n.ui.table tr td.disabled,\n.ui.table tr.disabled:hover,\n.ui.table tr:hover td.disabled {\n  pointer-events: none;\n  color: rgba(40, 40, 40, 0.3);\n}\n/*******************************\n          Variations\n*******************************/\n/*--------------\n    Stackable\n---------------*/\n@media only screen and (max-width: 991px) {\n  .ui[class*=\"tablet stackable\"].table,\n  .ui[class*=\"tablet stackable\"].table tbody,\n  .ui[class*=\"tablet stackable\"].table tr,\n  .ui[class*=\"tablet stackable\"].table tr > th,\n  .ui[class*=\"tablet stackable\"].table tr > td {\n    width: 100% !important;\n    display: block !important;\n  }\n  .ui[class*=\"tablet stackable\"].table {\n    padding: 0em;\n  }\n  .ui[class*=\"tablet stackable\"].table thead {\n    display: block;\n  }\n  .ui[class*=\"tablet stackable\"].table tfoot {\n    display: block;\n  }\n  .ui[class*=\"tablet stackable\"].table tr {\n    padding-top: 1em;\n    padding-bottom: 1em;\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;\n  }\n  .ui[class*=\"tablet stackable\"].table tr > th,\n  .ui[class*=\"tablet stackable\"].table tr > td {\n    background: none;\n    border: none !important;\n    padding: 0.25em 0.75em;\n    box-shadow: none !important;\n  }\n  /* Definition Table */\n  .ui.definition[class*=\"tablet stackable\"].table thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n/*--------------\n Text Alignment\n---------------*/\n.ui.table[class*=\"left aligned\"],\n.ui.table [class*=\"left aligned\"] {\n  text-align: left;\n}\n.ui.table[class*=\"center aligned\"],\n.ui.table [class*=\"center aligned\"] {\n  text-align: center;\n}\n.ui.table[class*=\"right aligned\"],\n.ui.table [class*=\"right aligned\"] {\n  text-align: right;\n}\n/*------------------\n Vertical Alignment\n------------------*/\n.ui.table[class*=\"top aligned\"],\n.ui.table [class*=\"top aligned\"] {\n  vertical-align: top;\n}\n.ui.table[class*=\"middle aligned\"],\n.ui.table [class*=\"middle aligned\"] {\n  vertical-align: middle;\n}\n.ui.table[class*=\"bottom aligned\"],\n.ui.table [class*=\"bottom aligned\"] {\n  vertical-align: bottom;\n}\n/*--------------\n    Collapsing\n---------------*/\n.ui.table th.collapsing,\n.ui.table td.collapsing {\n  width: 1px;\n  white-space: nowrap;\n}\n/*--------------\n     Fixed\n---------------*/\n.ui.fixed.table {\n  table-layout: fixed;\n}\n.ui.fixed.table th,\n.ui.fixed.table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/*--------------\n   Selectable\n---------------*/\n.ui.selectable.table tbody tr:hover,\n.ui.table tbody tr td.selectable:hover {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.selectable.inverted.table tbody tr:hover,\n.ui.inverted.table tbody tr td.selectable:hover {\n  background: rgba(255, 255, 255, 0.08) !important;\n  color: #ffffff !important;\n}\n/* Selectable Cell Link */\n.ui.table tbody tr td.selectable {\n  padding: 0em;\n}\n.ui.table tbody tr td.selectable > a:not(.ui) {\n  display: block;\n  color: inherit;\n  padding: 0.78571429em 0.78571429em;\n}\n/* Other States */\n.ui.selectable.table tr.error:hover,\n.ui.table tr td.selectable.error:hover,\n.ui.selectable.table tr:hover td.error {\n  background: rgba(185, 3, 3, 0.15) !important;\n  color: #f7f7f7 !important;\n}\n.ui.selectable.table tr.warning:hover,\n.ui.table tr td.selectable.warning:hover,\n.ui.selectable.table tr:hover td.warning {\n  background: #fff4e4 !important;\n  color: #493107 !important;\n}\n.ui.selectable.table tr.active:hover,\n.ui.table tr td.selectable.active:hover,\n.ui.selectable.table tr:hover td.active {\n  background: #E0E0E0 !important;\n  color: rgba(255, 255, 255, 0.87) !important;\n}\n.ui.selectable.table tr.positive:hover,\n.ui.table tr td.selectable.positive:hover,\n.ui.selectable.table tr:hover td.positive {\n  background: #f7ffe6 !important;\n  color: #275b28 !important;\n}\n.ui.selectable.table tr.negative:hover,\n.ui.table tr td.selectable.negative:hover,\n.ui.selectable.table tr:hover td.negative {\n  background: rgba(185, 3, 3, 0.15) !important;\n  color: #f7f7f7 !important;\n}\n/*-------------------\n      Attached\n--------------------*/\n/* Middle */\n.ui.attached.table {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% - (-1px * 2));\n  max-width: calc(100% - (-1px * 2));\n  box-shadow: none;\n  border: 1px solid #D4D4D5;\n}\n.ui.attached + .ui.attached.table:not(.top) {\n  border-top: none;\n}\n/* Top */\n.ui[class*=\"top attached\"].table {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1em;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.table[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n/* Bottom */\n.ui[class*=\"bottom attached\"].table {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1em;\n  box-shadow: none, none;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui[class*=\"bottom attached\"].table:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n     Striped\n---------------*/\n/* Table Striping */\n.ui.striped.table > tr:nth-child(2n),\n.ui.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(0, 0, 50, 0.02);\n}\n/* Stripes */\n.ui.inverted.striped.table > tr:nth-child(2n),\n.ui.inverted.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n/* Allow striped active hover */\n.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {\n  background: #EFEFEF !important;\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n/*--------------\n   Single Line\n---------------*/\n.ui.table[class*=\"single line\"],\n.ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n.ui.table[class*=\"single line\"],\n.ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n/*-------------------\n       Colors\n--------------------*/\n/* Red */\n.ui.red.table {\n  border-top: 0.2em solid #DB2828;\n}\n.ui.inverted.red.table {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n/* Orange */\n.ui.orange.table {\n  border-top: 0.2em solid #F2711C;\n}\n.ui.inverted.orange.table {\n  background-color: #F2711C !important;\n  color: #FFFFFF !important;\n}\n/* Yellow */\n.ui.yellow.table {\n  border-top: 0.2em solid #FBBD08;\n}\n.ui.inverted.yellow.table {\n  background-color: #FBBD08 !important;\n  color: #FFFFFF !important;\n}\n/* Olive */\n.ui.olive.table {\n  border-top: 0.2em solid #B5CC18;\n}\n.ui.inverted.olive.table {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n/* Green */\n.ui.green.table {\n  border-top: 0.2em solid #21BA45;\n}\n.ui.inverted.green.table {\n  background-color: #21BA45 !important;\n  color: #FFFFFF !important;\n}\n/* Teal */\n.ui.teal.table {\n  border-top: 0.2em solid #00B5AD;\n}\n.ui.inverted.teal.table {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n/* Blue */\n.ui.blue.table {\n  border-top: 0.2em solid #2185D0;\n}\n.ui.inverted.blue.table {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n/* Violet */\n.ui.violet.table {\n  border-top: 0.2em solid #6435C9;\n}\n.ui.inverted.violet.table {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n/* Purple */\n.ui.purple.table {\n  border-top: 0.2em solid #A333C8;\n}\n.ui.inverted.purple.table {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n/* Pink */\n.ui.pink.table {\n  border-top: 0.2em solid #E03997;\n}\n.ui.inverted.pink.table {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n/* Brown */\n.ui.brown.table {\n  border-top: 0.2em solid #A5673F;\n}\n.ui.inverted.brown.table {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n/* Grey */\n.ui.grey.table {\n  border-top: 0.2em solid #767676;\n}\n.ui.inverted.grey.table {\n  background-color: #767676 !important;\n  color: #FFFFFF !important;\n}\n/* Black */\n.ui.black.table {\n  border-top: 0.2em solid #1B1C1D;\n}\n.ui.inverted.black.table {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n/*--------------\n  Column Count\n---------------*/\n/* Grid Based */\n.ui.one.column.table td {\n  width: 100%;\n}\n.ui.two.column.table td {\n  width: 50%;\n}\n.ui.three.column.table td {\n  width: 33.33333333%;\n}\n.ui.four.column.table td {\n  width: 25%;\n}\n.ui.five.column.table td {\n  width: 20%;\n}\n.ui.six.column.table td {\n  width: 16.66666667%;\n}\n.ui.seven.column.table td {\n  width: 14.28571429%;\n}\n.ui.eight.column.table td {\n  width: 12.5%;\n}\n.ui.nine.column.table td {\n  width: 11.11111111%;\n}\n.ui.ten.column.table td {\n  width: 10%;\n}\n.ui.eleven.column.table td {\n  width: 9.09090909%;\n}\n.ui.twelve.column.table td {\n  width: 8.33333333%;\n}\n.ui.thirteen.column.table td {\n  width: 7.69230769%;\n}\n.ui.fourteen.column.table td {\n  width: 7.14285714%;\n}\n.ui.fifteen.column.table td {\n  width: 6.66666667%;\n}\n.ui.sixteen.column.table td {\n  width: 6.25%;\n}\n/* Column Width */\n.ui.table th.one.wide,\n.ui.table td.one.wide {\n  width: 6.25%;\n}\n.ui.table th.two.wide,\n.ui.table td.two.wide {\n  width: 12.5%;\n}\n.ui.table th.three.wide,\n.ui.table td.three.wide {\n  width: 18.75%;\n}\n.ui.table th.four.wide,\n.ui.table td.four.wide {\n  width: 25%;\n}\n.ui.table th.five.wide,\n.ui.table td.five.wide {\n  width: 31.25%;\n}\n.ui.table th.six.wide,\n.ui.table td.six.wide {\n  width: 37.5%;\n}\n.ui.table th.seven.wide,\n.ui.table td.seven.wide {\n  width: 43.75%;\n}\n.ui.table th.eight.wide,\n.ui.table td.eight.wide {\n  width: 50%;\n}\n.ui.table th.nine.wide,\n.ui.table td.nine.wide {\n  width: 56.25%;\n}\n.ui.table th.ten.wide,\n.ui.table td.ten.wide {\n  width: 62.5%;\n}\n.ui.table th.eleven.wide,\n.ui.table td.eleven.wide {\n  width: 68.75%;\n}\n.ui.table th.twelve.wide,\n.ui.table td.twelve.wide {\n  width: 75%;\n}\n.ui.table th.thirteen.wide,\n.ui.table td.thirteen.wide {\n  width: 81.25%;\n}\n.ui.table th.fourteen.wide,\n.ui.table td.fourteen.wide {\n  width: 87.5%;\n}\n.ui.table th.fifteen.wide,\n.ui.table td.fifteen.wide {\n  width: 93.75%;\n}\n.ui.table th.sixteen.wide,\n.ui.table td.sixteen.wide {\n  width: 100%;\n}\n/*--------------\n    Sortable\n---------------*/\n.ui.sortable.table thead th {\n  cursor: pointer;\n  white-space: nowrap;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.sortable.table thead th:first-child {\n  border-left: none;\n}\n.ui.sortable.table thead th.sorted,\n.ui.sortable.table thead th.sorted:hover {\n  user-select: none;\n}\n.ui.sortable.table thead th:after {\n  display: none;\n  font-style: normal;\n  font-weight: normal;\n  text-decoration: inherit;\n  content: '';\n  height: 1em;\n  width: auto;\n  opacity: 0.8;\n  margin: 0em 0em 0em 0.5em;\n  font-family: 'Icons';\n}\n.ui.sortable.table thead th.ascending:after {\n  content: '\\f0d8';\n}\n.ui.sortable.table thead th.descending:after {\n  content: '\\f0d7';\n}\n/* Hover */\n.ui.sortable.table th.disabled:hover {\n  cursor: auto;\n  color: rgba(40, 40, 40, 0.3);\n}\n.ui.sortable.table thead th:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Sorted */\n.ui.sortable.table thead th.sorted {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.sortable.table thead th.sorted:after {\n  display: inline-block;\n}\n/* Sorted Hover */\n.ui.sortable.table thead th.sorted:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Inverted */\n.ui.inverted.sortable.table thead th.sorted {\n  background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  color: #ffffff;\n}\n.ui.inverted.sortable.table thead th:hover {\n  background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  color: #ffffff;\n}\n.ui.inverted.sortable.table thead th {\n  border-left-color: transparent;\n  border-right-color: transparent;\n}\n/*--------------\n    Inverted\n---------------*/\n/* Text Color */\n.ui.inverted.table {\n  background: #333333;\n  color: rgba(255, 255, 255, 0.9);\n  border: none;\n}\n.ui.inverted.table th {\n  background-color: rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.1) !important;\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n.ui.inverted.table tr td {\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n.ui.inverted.table tr.disabled td,\n.ui.inverted.table tr td.disabled,\n.ui.inverted.table tr.disabled:hover td,\n.ui.inverted.table tr:hover td.disabled {\n  pointer-events: none;\n  color: rgba(225, 225, 225, 0.3);\n}\n/* Definition */\n.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,\n.ui.inverted.definition.table thead:not(.full-width) th:first-child {\n  background: #FFFFFF;\n}\n.ui.inverted.definition.table tr td:first-child {\n  background: rgba(255, 255, 255, 0.02);\n  color: #ffffff;\n}\n/*--------------\n   Collapsing\n---------------*/\n.ui.collapsing.table {\n  width: auto;\n}\n/*--------------\n      Basic\n---------------*/\n.ui.basic.table {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  box-shadow: none;\n}\n.ui.basic.table thead,\n.ui.basic.table tfoot {\n  box-shadow: none;\n}\n.ui.basic.table th {\n  background: #d9d9e2;\n  border-left: none;\n}\n.ui.basic.table tbody tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.ui.basic.table td {\n  background: transparent;\n}\n.ui.basic.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n/* Very Basic */\n.ui[class*=\"very basic\"].table {\n  border: none;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td {\n  padding: '';\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:first-child,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:first-child {\n  padding-left: 0em;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:last-child,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:last-child {\n  padding-right: 0em;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) thead tr:first-child th {\n  padding-top: 0em;\n}\n/*--------------\n     Celled\n---------------*/\n.ui.celled.table tr th,\n.ui.celled.table tr td {\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n.ui.celled.table tr th:first-child,\n.ui.celled.table tr td:first-child {\n  border-left: none;\n}\n/*--------------\n     Padded\n---------------*/\n.ui.padded.table th {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.ui.padded.table th,\n.ui.padded.table td {\n  padding: 1em 1em;\n}\n/* Very */\n.ui[class*=\"very padded\"].table th {\n  padding-left: 1.5em;\n  padding-right: 1.5em;\n}\n.ui[class*=\"very padded\"].table td {\n  padding: 1.5em 1.5em;\n}\n/*--------------\n     Compact\n---------------*/\n.ui.compact.table th {\n  padding-left: 0.7em;\n  padding-right: 0.7em;\n}\n.ui.compact.table td {\n  padding: 0.5em 0.7em;\n}\n/* Very */\n.ui[class*=\"very compact\"].table th {\n  padding-left: 0.6em;\n  padding-right: 0.6em;\n}\n.ui[class*=\"very compact\"].table td {\n  padding: 0.4em 0.6em;\n}\n/*--------------\n      Sizes\n---------------*/\n/* Small */\n.ui.small.table {\n  font-size: 0.9em;\n}\n/* Standard */\n.ui.table {\n  font-size: 1em;\n}\n/* Large */\n.ui.large.table {\n  font-size: 1.1em;\n}\n/* Views */\n/*!\n * # Semantic UI - Ad\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2013 Contributors\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n          Advertisement\n*******************************/\n/* Packaged Theme */\n/*******************************\n          Advertisement\n*******************************/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n         Advertisement\n*******************************/\n.ui.ad {\n  display: block;\n  overflow: hidden;\n  margin: 1em 0em;\n}\n.ui.ad:first-child {\n  margin: 0em;\n}\n.ui.ad:last-child {\n  margin: 0em;\n}\n.ui.ad iframe {\n  margin: 0em;\n  padding: 0em;\n  border: none;\n  overflow: hidden;\n}\n/*--------------\n     Common\n---------------*/\n/* Leaderboard */\n.ui.leaderboard.ad {\n  width: 728px;\n  height: 90px;\n}\n/* Medium Rectangle */\n.ui[class*=\"medium rectangle\"].ad {\n  width: 300px;\n  height: 250px;\n}\n/* Large Rectangle */\n.ui[class*=\"large rectangle\"].ad {\n  width: 336px;\n  height: 280px;\n}\n/* Half Page */\n.ui[class*=\"half page\"].ad {\n  width: 300px;\n  height: 600px;\n}\n/*--------------\n     Square\n---------------*/\n/* Square */\n.ui.square.ad {\n  width: 250px;\n  height: 250px;\n}\n/* Small Square */\n.ui[class*=\"small square\"].ad {\n  width: 200px;\n  height: 200px;\n}\n/*--------------\n    Rectangle\n---------------*/\n/* Small Rectangle */\n.ui[class*=\"small rectangle\"].ad {\n  width: 180px;\n  height: 150px;\n}\n/* Vertical Rectangle */\n.ui[class*=\"vertical rectangle\"].ad {\n  width: 240px;\n  height: 400px;\n}\n/*--------------\n     Button\n---------------*/\n.ui.button.ad {\n  width: 120px;\n  height: 90px;\n}\n.ui[class*=\"square button\"].ad {\n  width: 125px;\n  height: 125px;\n}\n.ui[class*=\"small button\"].ad {\n  width: 120px;\n  height: 60px;\n}\n/*--------------\n   Skyscrapers\n---------------*/\n/* Skyscraper */\n.ui.skyscraper.ad {\n  width: 120px;\n  height: 600px;\n}\n/* Wide Skyscraper */\n.ui[class*=\"wide skyscraper\"].ad {\n  width: 160px;\n}\n/*--------------\n     Banners\n---------------*/\n/* Banner */\n.ui.banner.ad {\n  width: 468px;\n  height: 60px;\n}\n/* Vertical Banner */\n.ui[class*=\"vertical banner\"].ad {\n  width: 120px;\n  height: 240px;\n}\n/* Top Banner */\n.ui[class*=\"top banner\"].ad {\n  width: 930px;\n  height: 180px;\n}\n/* Half Banner */\n.ui[class*=\"half banner\"].ad {\n  width: 234px;\n  height: 60px;\n}\n/*--------------\n    Boards\n---------------*/\n/* Leaderboard */\n.ui[class*=\"large leaderboard\"].ad {\n  width: 970px;\n  height: 90px;\n}\n/* Billboard */\n.ui.billboard.ad {\n  width: 970px;\n  height: 250px;\n}\n/*--------------\n    Panorama\n---------------*/\n/* Panorama */\n.ui.panorama.ad {\n  width: 980px;\n  height: 120px;\n}\n/*--------------\n     Netboard\n---------------*/\n/* Netboard */\n.ui.netboard.ad {\n  width: 580px;\n  height: 400px;\n}\n/*--------------\n     Mobile\n---------------*/\n/* Large Mobile Banner */\n.ui[class*=\"large mobile banner\"].ad {\n  width: 320px;\n  height: 100px;\n}\n/* Mobile Leaderboard */\n.ui[class*=\"mobile leaderboard\"].ad {\n  width: 320px;\n  height: 50px;\n}\n/*******************************\n             Types\n*******************************/\n/* Mobile Sizes */\n.ui.mobile.ad {\n  display: none;\n}\n@media only screen and (max-width: 767px) {\n  .ui.mobile.ad {\n    display: block;\n  }\n}\n/*******************************\n           Variations\n*******************************/\n.ui.centered.ad {\n  margin-left: auto;\n  margin-right: auto;\n}\n.ui.test.ad {\n  position: relative;\n  background: #545454;\n}\n.ui.test.ad:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  text-align: center;\n  transform: translateX(-50%) translateY(-50%);\n  content: 'Ad';\n  color: #FFFFFF;\n  font-size: 1em;\n  font-weight: bold;\n}\n.ui.mobile.test.ad:after {\n  font-size: 0.85714286em;\n}\n.ui.test.ad[data-text]:after {\n  content: attr(data-text);\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Card\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Shadow */\n/* Card */\n/* Card Group */\n/* Consecutive Cards */\n/*-------------------\n       Content\n--------------------*/\n/* Image */\n/* Content */\n/* Header */\n/* Metadata */\n/* Icons */\n/* Links */\n/* Description */\n/* Content Image */\n/* Avatar Image */\n/* Paragraph */\n/* Dimmer */\n/* Additional Content */\n/* Extra Links */\n/* Buttons */\n/*-------------------\n      Variations\n--------------------*/\n/* Link */\n/* Raised */\n/* Card Count */\n/* Stackable */\n/* Sizes */\n/* Colored */\n/* Packaged Theme */\n/*******************************\n             Card\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Shadow */\n/* Card */\n/* Card Group */\n/* Consecutive Cards */\n/*-------------------\n       Content\n--------------------*/\n/* Image */\n/* Content */\n/* Header */\n/* Metadata */\n/* Icons */\n/* Links */\n/* Description */\n/* Content Image */\n/* Avatar Image */\n/* Paragraph */\n/* Dimmer */\n/* Additional Content */\n/* Extra Links */\n/* Buttons */\n/*-------------------\n      Variations\n--------------------*/\n/* Link */\n/* Raised */\n/* Card Count */\n/* Stackable */\n/* Sizes */\n/* Colored */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Standard\n*******************************/\n/*--------------\n      Card\n---------------*/\n.ui.cards > .card,\n.ui.card {\n  max-width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 290px;\n  min-height: 0px;\n  background: #1e1f33;\n  padding: 0em;\n  border: none;\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 1px 3px 0px #D4D4D5, 0px 0px 0px 0px #D4D4D5;\n  transition: box-shadow 0.1s ease, transform 0.1s ease;\n  z-index: '';\n}\n.ui.card {\n  margin: 1em 0em;\n}\n.ui.cards > .card a,\n.ui.card a {\n  cursor: pointer;\n}\n.ui.card:first-child {\n  margin-top: 0em;\n}\n.ui.card:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n      Cards\n---------------*/\n.ui.cards {\n  display: flex;\n  margin: -0.875em -0.5em;\n  flex-wrap: wrap;\n}\n.ui.cards > .card {\n  display: flex;\n  margin: 0.875em 0.5em;\n  float: none;\n}\n/* Clearing */\n.ui.cards:after,\n.ui.card:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n/* Consecutive Card Groups Preserve Row Spacing */\n.ui.cards ~ .ui.cards {\n  margin-top: 0.875em;\n}\n/*--------------\n  Rounded Edges\n---------------*/\n.ui.cards > .card > :first-child,\n.ui.card > :first-child {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em !important;\n  border-top: none !important;\n}\n.ui.cards > .card > :last-child,\n.ui.card > :last-child {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;\n}\n.ui.cards > .card > :only-child,\n.ui.card > :only-child {\n  border-radius: 0.28571429rem !important;\n}\n/*--------------\n     Images\n---------------*/\n.ui.cards > .card > .image,\n.ui.card > .image {\n  position: relative;\n  display: block;\n  flex: 0 0 auto;\n  padding: 0em;\n  background: rgba(0, 0, 0, 0.05);\n}\n.ui.cards > .card > .image > img,\n.ui.card > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: inherit;\n}\n.ui.cards > .card > .image:not(.ui) > img,\n.ui.card > .image:not(.ui) > img {\n  border: none;\n}\n/*--------------\n     Content\n---------------*/\n.ui.cards > .card > .content,\n.ui.card > .content {\n  flex-grow: 1;\n  border: none;\n  border-top: 0px solid rgba(255, 255, 255, 0.1);\n  background: none;\n  margin: 0em;\n  padding: 1em 1em;\n  box-shadow: none;\n  font-size: 1em;\n  border-radius: 0em;\n}\n.ui.cards > .card > .content:after,\n.ui.card > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ui.cards > .card > .content > .header,\n.ui.card > .content > .header {\n  display: block;\n  margin: '';\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  color: rgba(255, 255, 255, 0.85);\n}\n/* Default Header Size */\n.ui.cards > .card > .content > .header:not(.ui),\n.ui.card > .content > .header:not(.ui) {\n  font-weight: bold;\n  font-size: 1.28571429em;\n  margin-top: -0.21425em;\n  line-height: 1.28571429em;\n}\n.ui.cards > .card > .content > .meta + .description,\n.ui.cards > .card > .content > .header + .description,\n.ui.card > .content > .meta + .description,\n.ui.card > .content > .header + .description {\n  margin-top: 0.5em;\n}\n/*----------------\n Floated Content\n-----------------*/\n.ui.cards > .card [class*=\"left floated\"],\n.ui.card [class*=\"left floated\"] {\n  float: left;\n}\n.ui.cards > .card [class*=\"right floated\"],\n.ui.card [class*=\"right floated\"] {\n  float: right;\n}\n/*--------------\n     Aligned\n---------------*/\n.ui.cards > .card [class*=\"left aligned\"],\n.ui.card [class*=\"left aligned\"] {\n  text-align: left;\n}\n.ui.cards > .card [class*=\"center aligned\"],\n.ui.card [class*=\"center aligned\"] {\n  text-align: center;\n}\n.ui.cards > .card [class*=\"right aligned\"],\n.ui.card [class*=\"right aligned\"] {\n  text-align: right;\n}\n/*--------------\n  Content Image\n---------------*/\n.ui.cards > .card .content img,\n.ui.card .content img {\n  display: inline-block;\n  vertical-align: middle;\n  width: '';\n}\n.ui.cards > .card img.avatar,\n.ui.cards > .card .avatar img,\n.ui.card img.avatar,\n.ui.card .avatar img {\n  width: 2em;\n  height: 2em;\n  border-radius: 500rem;\n}\n/*--------------\n   Description\n---------------*/\n.ui.cards > .card > .content > .description,\n.ui.card > .content > .description {\n  clear: both;\n  color: #eceff8;\n}\n/*--------------\n    Paragraph\n---------------*/\n.ui.cards > .card > .content p,\n.ui.card > .content p {\n  margin: 0em 0em 0.5em;\n}\n.ui.cards > .card > .content p:last-child,\n.ui.card > .content p:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n      Meta\n---------------*/\n.ui.cards > .card .meta,\n.ui.card .meta {\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.cards > .card .meta *,\n.ui.card .meta * {\n  margin-right: 0.3em;\n}\n.ui.cards > .card .meta :last-child,\n.ui.card .meta :last-child {\n  margin-right: 0em;\n}\n.ui.cards > .card .meta [class*=\"right floated\"],\n.ui.card .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: 0.3em;\n}\n/*--------------\n      Links\n---------------*/\n/* Generic */\n.ui.cards > .card > .content a:not(.ui),\n.ui.card > .content a:not(.ui) {\n  color: '';\n  transition: color 0.1s ease;\n}\n.ui.cards > .card > .content a:not(.ui):hover,\n.ui.card > .content a:not(.ui):hover {\n  color: '';\n}\n/* Header */\n.ui.cards > .card > .content > a.header,\n.ui.card > .content > a.header {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.cards > .card > .content > a.header:hover,\n.ui.card > .content > a.header:hover {\n  color: #1e70bf;\n}\n/* Meta */\n.ui.cards > .card .meta > a:not(.ui),\n.ui.card .meta > a:not(.ui) {\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.cards > .card .meta > a:not(.ui):hover,\n.ui.card .meta > a:not(.ui):hover {\n  color: rgba(255, 255, 255, 0.87);\n}\n/*--------------\n     Buttons\n---------------*/\n.ui.cards > .card > .buttons,\n.ui.card > .buttons,\n.ui.cards > .card > .button,\n.ui.card > .button {\n  margin: 0px 0px;\n  width: calc(100% +  0px );\n}\n/*--------------\n      Dimmer\n---------------*/\n.ui.cards > .card .dimmer,\n.ui.card .dimmer {\n  background-color: '';\n  z-index: 10;\n}\n/*--------------\n     Labels\n---------------*/\n/*-----Star----- */\n/* Icon */\n.ui.cards > .card > .content .star.icon,\n.ui.card > .content .star.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n.ui.cards > .card > .content .star.icon:hover,\n.ui.card > .content .star.icon:hover {\n  opacity: 1;\n  color: #FFB70A;\n}\n.ui.cards > .card > .content .active.star.icon,\n.ui.card > .content .active.star.icon {\n  color: #FFE623;\n}\n/*-----Like----- */\n/* Icon */\n.ui.cards > .card > .content .like.icon,\n.ui.card > .content .like.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n.ui.cards > .card > .content .like.icon:hover,\n.ui.card > .content .like.icon:hover {\n  opacity: 1;\n  color: #FF2733;\n}\n.ui.cards > .card > .content .active.like.icon,\n.ui.card > .content .active.like.icon {\n  color: #FF2733;\n}\n/*----------------\n  Extra Content\n-----------------*/\n.ui.cards > .card > .extra,\n.ui.card > .extra {\n  max-width: 100%;\n  min-height: 0em !important;\n  flex-grow: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;\n  position: static;\n  background: none;\n  width: auto;\n  margin: 0em 0em;\n  padding: 0.75em 1em;\n  top: 0em;\n  left: 0em;\n  color: rgba(255, 255, 255, 0.4);\n  box-shadow: none;\n  transition: color 0.1s ease;\n}\n.ui.cards > .card > .extra a:not(.ui),\n.ui.card > .extra a:not(.ui) {\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.cards > .card > .extra a:not(.ui):hover,\n.ui.card > .extra a:not(.ui):hover {\n  color: #1e70bf;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Raised\n--------------------*/\n.ui.raised.cards > .card,\n.ui.raised.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n.ui.raised.cards a.card:hover,\n.ui.link.cards .raised.card:hover,\na.ui.raised.card:hover,\n.ui.link.raised.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.15), 0px 2px 10px 0px rgba(34, 36, 38, 0.25);\n}\n.ui.raised.cards > .card,\n.ui.raised.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n/*-------------------\n       Centered\n--------------------*/\n.ui.centered.cards {\n  justify-content: center;\n}\n.ui.centered.card {\n  margin-left: auto;\n  margin-right: auto;\n}\n/*-------------------\n        Fluid\n--------------------*/\n.ui.fluid.card {\n  width: 100%;\n  max-width: 9999px;\n}\n/*-------------------\n        Link\n--------------------*/\n.ui.cards a.card,\n.ui.link.cards .card,\na.ui.card,\n.ui.link.card {\n  transform: none;\n}\n.ui.cards a.card:hover,\n.ui.link.cards .card:hover,\na.ui.card:hover,\n.ui.link.card:hover {\n  cursor: pointer;\n  z-index: 5;\n  background: #FFFFFF;\n  border: none;\n  box-shadow: 0px 1px 3px 0px #BCBDBD, 0px 0px 0px 0px #D4D4D5;\n  transform: translateY(-3px);\n}\n/*-------------------\n       Colors\n--------------------*/\n/* Red */\n.ui.red.cards > .card,\n.ui.cards > .red.card,\n.ui.red.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #DB2828, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.red.cards > .card:hover,\n.ui.cards > .red.card:hover,\n.ui.red.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #d01919, 0px 1px 3px 0px #BCBDBD;\n}\n/* Orange */\n.ui.orange.cards > .card,\n.ui.cards > .orange.card,\n.ui.orange.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #F2711C, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.orange.cards > .card:hover,\n.ui.cards > .orange.card:hover,\n.ui.orange.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #f26202, 0px 1px 3px 0px #BCBDBD;\n}\n/* Yellow */\n.ui.yellow.cards > .card,\n.ui.cards > .yellow.card,\n.ui.yellow.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #FBBD08, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.yellow.cards > .card:hover,\n.ui.cards > .yellow.card:hover,\n.ui.yellow.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #eaae00, 0px 1px 3px 0px #BCBDBD;\n}\n/* Olive */\n.ui.olive.cards > .card,\n.ui.cards > .olive.card,\n.ui.olive.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #B5CC18, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.olive.cards > .card:hover,\n.ui.cards > .olive.card:hover,\n.ui.olive.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #a7bd0d, 0px 1px 3px 0px #BCBDBD;\n}\n/* Green */\n.ui.green.cards > .card,\n.ui.cards > .green.card,\n.ui.green.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #21BA45, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.green.cards > .card:hover,\n.ui.cards > .green.card:hover,\n.ui.green.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #16ab39, 0px 1px 3px 0px #BCBDBD;\n}\n/* Teal */\n.ui.teal.cards > .card,\n.ui.cards > .teal.card,\n.ui.teal.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #00B5AD, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.teal.cards > .card:hover,\n.ui.cards > .teal.card:hover,\n.ui.teal.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #009c95, 0px 1px 3px 0px #BCBDBD;\n}\n/* Blue */\n.ui.blue.cards > .card,\n.ui.cards > .blue.card,\n.ui.blue.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #2185D0, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.blue.cards > .card:hover,\n.ui.cards > .blue.card:hover,\n.ui.blue.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #1678c2, 0px 1px 3px 0px #BCBDBD;\n}\n/* Violet */\n.ui.violet.cards > .card,\n.ui.cards > .violet.card,\n.ui.violet.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #6435C9, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.violet.cards > .card:hover,\n.ui.cards > .violet.card:hover,\n.ui.violet.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #5829bb, 0px 1px 3px 0px #BCBDBD;\n}\n/* Purple */\n.ui.purple.cards > .card,\n.ui.cards > .purple.card,\n.ui.purple.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #A333C8, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.purple.cards > .card:hover,\n.ui.cards > .purple.card:hover,\n.ui.purple.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #9627ba, 0px 1px 3px 0px #BCBDBD;\n}\n/* Pink */\n.ui.pink.cards > .card,\n.ui.cards > .pink.card,\n.ui.pink.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #E03997, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.pink.cards > .card:hover,\n.ui.cards > .pink.card:hover,\n.ui.pink.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #e61a8d, 0px 1px 3px 0px #BCBDBD;\n}\n/* Brown */\n.ui.brown.cards > .card,\n.ui.cards > .brown.card,\n.ui.brown.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #A5673F, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.brown.cards > .card:hover,\n.ui.cards > .brown.card:hover,\n.ui.brown.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #975b33, 0px 1px 3px 0px #BCBDBD;\n}\n/* Grey */\n.ui.grey.cards > .card,\n.ui.cards > .grey.card,\n.ui.grey.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #767676, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.grey.cards > .card:hover,\n.ui.cards > .grey.card:hover,\n.ui.grey.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #838383, 0px 1px 3px 0px #BCBDBD;\n}\n/* Black */\n.ui.black.cards > .card,\n.ui.cards > .black.card,\n.ui.black.card {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #1B1C1D, 0px 1px 3px 0px #D4D4D5;\n}\n.ui.black.cards > .card:hover,\n.ui.cards > .black.card:hover,\n.ui.black.card:hover {\n  box-shadow: 0px 0px 0px 0px #D4D4D5, 0px 2px 0px 0px #27292a, 0px 1px 3px 0px #BCBDBD;\n}\n/*--------------\n   Card Count\n---------------*/\n.ui.one.cards {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n.ui.one.cards > .card {\n  width: 100%;\n}\n.ui.two.cards {\n  margin-left: -1em;\n  margin-right: -1em;\n}\n.ui.two.cards > .card {\n  width: calc( 50%  -  2em );\n  margin-left: 1em;\n  margin-right: 1em;\n}\n.ui.three.cards {\n  margin-left: -1em;\n  margin-right: -1em;\n}\n.ui.three.cards > .card {\n  width: calc( 33.33333333%  -  2em );\n  margin-left: 1em;\n  margin-right: 1em;\n}\n.ui.four.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n.ui.four.cards > .card {\n  width: calc( 25%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n.ui.five.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n.ui.five.cards > .card {\n  width: calc( 20%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n.ui.six.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n.ui.six.cards > .card {\n  width: calc( 16.66666667%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n.ui.seven.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n.ui.seven.cards > .card {\n  width: calc( 14.28571429%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n.ui.eight.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n.ui.eight.cards > .card {\n  width: calc( 12.5%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  font-size: 11px;\n}\n.ui.nine.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n.ui.nine.cards > .card {\n  width: calc( 11.11111111%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  font-size: 10px;\n}\n.ui.ten.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n.ui.ten.cards > .card {\n  width: calc( 10%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n/*-------------------\n      Doubling\n--------------------*/\n/* Mobile Only */\n@media only screen and (max-width: 767px) {\n  .ui.two.doubling.cards {\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n  .ui.two.doubling.cards > .card {\n    width: 100%;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n  .ui.three.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.three.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.four.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.four.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.five.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.five.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.six.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.six.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.seven.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.seven.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.nine.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.nine.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.ten.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.ten.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n}\n/* Tablet Only */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.two.doubling.cards {\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n  .ui.two.doubling.cards > .card {\n    width: 100%;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n  .ui.three.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.three.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.four.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.four.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.five.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.five.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.six.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.six.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: calc( 25%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n  .ui.nine.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n  .ui.nine.doubling.cards > .card {\n    width: calc( 25%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n  .ui.ten.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n  .ui.ten.doubling.cards > .card {\n    width: calc( 20%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n}\n/*-------------------\n      Stackable\n--------------------*/\n@media only screen and (max-width: 767px) {\n  .ui.stackable.cards {\n    display: block !important;\n  }\n  .ui.stackable.cards .card:first-child {\n    margin-top: 0em !important;\n  }\n  .ui.stackable.cards > .card {\n    display: block !important;\n    height: auto !important;\n    margin: 1em 1em;\n    padding: 0 !important;\n    width: calc( 100%  -  2em ) !important;\n  }\n}\n/*--------------\n      Size\n---------------*/\n.ui.cards > .card {\n  font-size: 1em;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Comment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Comments\n*******************************/\n/*-------------------\n       View\n--------------------*/\n/*-------------------\n      Elements\n--------------------*/\n/* Comment */\n/* Nested Comment */\n/* Avatar */\n/* Content */\n/* Author */\n/* Metadata */\n/* Text */\n/* Actions */\n/* Reply */\n/*-------------------\n      Variations\n--------------------*/\n/* Threaded */\n/* Minimal */\n/* Packaged Theme */\n/*******************************\n            Comments\n*******************************/\n/*-------------------\n       View\n--------------------*/\n/*-------------------\n      Elements\n--------------------*/\n/* Comment */\n/* Nested Comment */\n/* Avatar */\n/* Content */\n/* Author */\n/* Metadata */\n/* Text */\n/* Actions */\n/* Reply */\n/*-------------------\n      Variations\n--------------------*/\n/* Threaded */\n/* Minimal */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Standard\n*******************************/\n/*--------------\n    Comments\n---------------*/\n.ui.comments {\n  margin: 1.5em 0em;\n  max-width: 650px;\n}\n.ui.comments:first-child {\n  margin-top: 0em;\n}\n.ui.comments:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n     Comment\n---------------*/\n.ui.comments .comment {\n  position: relative;\n  background: none;\n  margin: 0.5em 0em 0em;\n  padding: 0.5em 0em 0em;\n  border: none;\n  border-top: none;\n  line-height: 1.2;\n}\n.ui.comments .comment:first-child {\n  margin-top: 0em;\n  padding-top: 0em;\n}\n/*--------------------\n    Nested Comments\n---------------------*/\n.ui.comments .comment .comments {\n  margin: 0em 0em 0.5em 0.5em;\n  padding: 1em 0em 1em 1em;\n}\n.ui.comments .comment .comments:before {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n}\n.ui.comments .comment .comments .comment {\n  border: none;\n  border-top: none;\n  background: none;\n}\n/*--------------\n     Avatar\n---------------*/\n.ui.comments .comment .avatar {\n  display: block;\n  width: 2.5em;\n  height: auto;\n  float: left;\n  margin: 0.2em 0em 0em;\n}\n.ui.comments .comment img.avatar,\n.ui.comments .comment .avatar img {\n  display: block;\n  margin: 0em auto;\n  width: 100%;\n  height: 100%;\n  border-radius: 0.25rem;\n}\n/*--------------\n     Content\n---------------*/\n.ui.comments .comment > .content {\n  display: block;\n}\n/* If there is an avatar move content over */\n.ui.comments .comment > .avatar ~ .content {\n  margin-left: 3.5em;\n}\n/*--------------\n     Author\n---------------*/\n.ui.comments .comment .author {\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.87);\n  font-weight: bold;\n}\n.ui.comments .comment a.author {\n  cursor: pointer;\n}\n.ui.comments .comment a.author:hover {\n  color: #1e70bf;\n}\n/*--------------\n     Metadata\n---------------*/\n.ui.comments .comment .metadata {\n  display: inline-block;\n  margin-left: 0.5em;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 0.875em;\n}\n.ui.comments .comment .metadata > * {\n  display: inline-block;\n  margin: 0em 0.5em 0em 0em;\n}\n.ui.comments .comment .metadata > :last-child {\n  margin-right: 0em;\n}\n/*--------------------\n     Comment Text\n---------------------*/\n.ui.comments .comment .text {\n  margin: 0.25em 0em 0.5em;\n  font-size: 1em;\n  word-wrap: break-word;\n  color: rgba(255, 255, 255, 0.87);\n  line-height: 1.3;\n}\n/*--------------------\n     User Actions\n---------------------*/\n.ui.comments .comment .actions {\n  font-size: 0.875em;\n}\n.ui.comments .comment .actions a {\n  cursor: pointer;\n  display: inline-block;\n  margin: 0em 0.75em 0em 0em;\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.comments .comment .actions a:last-child {\n  margin-right: 0em;\n}\n.ui.comments .comment .actions a.active,\n.ui.comments .comment .actions a:hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n/*--------------------\n      Reply Form\n---------------------*/\n.ui.comments > .reply.form {\n  margin-top: 1em;\n}\n.ui.comments .comment .reply.form {\n  width: 100%;\n  margin-top: 1em;\n}\n.ui.comments .reply.form textarea {\n  font-size: 1em;\n  height: 12em;\n}\n/*******************************\n            State\n*******************************/\n.ui.collapsed.comments,\n.ui.comments .collapsed.comments,\n.ui.comments .collapsed.comment {\n  display: none;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------------\n        Threaded\n---------------------*/\n.ui.threaded.comments .comment .comments {\n  margin: -1.5em 0 -1em 1.25em;\n  padding: 3em 0em 2em 2.25em;\n  box-shadow: -1px 0px 0px rgba(255, 255, 255, 0.15);\n}\n/*--------------------\n        Minimal\n---------------------*/\n.ui.minimal.comments .comment .actions {\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  left: auto;\n  transition: opacity 0.2s ease;\n  transition-delay: 0.1s;\n}\n.ui.minimal.comments .comment > .content:hover > .actions {\n  opacity: 1;\n}\n/*-------------------\n        Sizes\n--------------------*/\n.ui.mini.comments {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.comments {\n  font-size: 0.85714286rem;\n}\n.ui.small.comments {\n  font-size: 0.92857143rem;\n}\n.ui.comments {\n  font-size: 1rem;\n}\n.ui.large.comments {\n  font-size: 1.14285714rem;\n}\n.ui.big.comments {\n  font-size: 1.28571429rem;\n}\n.ui.huge.comments {\n  font-size: 1.42857143rem;\n}\n.ui.massive.comments {\n  font-size: 1.71428571rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Feed\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Feed\n*******************************/\n/*-------------------\n        Feed\n--------------------*/\n/*-------------------\n      Elements\n--------------------*/\n/* Event */\n/* Event Label */\n/* Icon Label */\n/* Image Label */\n/* Content w/ Label */\n/* Content */\n/* Date */\n/* Summary */\n/* Summary Image */\n/* Summary Date */\n/* User */\n/* Extra Summary Data */\n/* Extra Images */\n/* Extra Text */\n/* Metadata Group */\n/* Like */\n/* Metadata Divider */\n/*-------------------\n      Variations\n--------------------*/\n/* Packaged Theme */\n/*******************************\n             Feed\n*******************************/\n/*-------------------\n        Feed\n--------------------*/\n/*-------------------\n      Elements\n--------------------*/\n/* Event */\n/* Event Label */\n/* Icon Label */\n/* Image Label */\n/* Content w/ Label */\n/* Content */\n/* Date */\n/* Summary */\n/* Summary Image */\n/* Summary Date */\n/* User */\n/* Extra Summary Data */\n/* Extra Images */\n/* Extra Text */\n/* Metadata Group */\n/* Like */\n/* Metadata Divider */\n/*-------------------\n      Variations\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n         Activity Feed\n*******************************/\n.ui.feed {\n  margin: 1em 0em;\n}\n.ui.feed:first-child {\n  margin-top: 0em;\n}\n.ui.feed:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n            Content\n*******************************/\n/* Event */\n.ui.feed > .event {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: 0.21428571rem 0em;\n  margin: 0em;\n  background: none;\n  border-top: none;\n}\n.ui.feed > .event:first-child {\n  border-top: 0px;\n  padding-top: 0em;\n}\n.ui.feed > .event:last-child {\n  padding-bottom: 0em;\n}\n/* Event Label */\n.ui.feed > .event > .label {\n  display: block;\n  flex: 0 0 auto;\n  width: 2.5em;\n  height: auto;\n  align-self: stretch;\n  text-align: left;\n}\n.ui.feed > .event > .label .icon {\n  opacity: 1;\n  font-size: 1.5em;\n  width: 100%;\n  padding: 0.25em;\n  background: none;\n  border: none;\n  border-radius: none;\n  color: rgba(0, 0, 0, 0.6);\n}\n.ui.feed > .event > .label img {\n  width: 100%;\n  height: auto;\n  border-radius: 500rem;\n}\n.ui.feed > .event > .label + .content {\n  margin: 0.5em 0em 0.35714286em 1.14285714em;\n}\n/*--------------\n     Content\n---------------*/\n/* Content */\n.ui.feed > .event > .content {\n  display: block;\n  flex: 1 1 auto;\n  align-self: stretch;\n  text-align: left;\n  word-wrap: break-word;\n}\n.ui.feed > .event:last-child > .content {\n  padding-bottom: 0em;\n}\n/* Link */\n.ui.feed > .event > .content a {\n  cursor: pointer;\n}\n/*--------------\n      Date\n---------------*/\n.ui.feed > .event > .content .date {\n  margin: -0.5rem 0em 0em;\n  padding: 0em;\n  font-weight: normal;\n  font-size: 1em;\n  font-style: normal;\n  color: rgba(255, 255, 255, 0.4);\n}\n/*--------------\n     Summary\n---------------*/\n.ui.feed > .event > .content .summary {\n  margin: 0em;\n  font-size: 1em;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Summary Image */\n.ui.feed > .event > .content .summary img {\n  display: inline-block;\n  width: auto;\n  height: 10em;\n  margin: -0.25em 0.25em 0em 0em;\n  border-radius: 0.25em;\n  vertical-align: middle;\n}\n/*--------------\n      User\n---------------*/\n.ui.feed > .event > .content .user {\n  display: inline-block;\n  font-weight: bold;\n  margin-right: 0em;\n  vertical-align: baseline;\n}\n.ui.feed > .event > .content .user img {\n  margin: -0.25em 0.25em 0em 0em;\n  width: auto;\n  height: 10em;\n  vertical-align: middle;\n}\n/*--------------\n   Inline Date\n---------------*/\n/* Date inside Summary */\n.ui.feed > .event > .content .summary > .date {\n  display: inline-block;\n  float: none;\n  font-weight: normal;\n  font-size: 0.85714286em;\n  font-style: normal;\n  margin: 0em 0em 0em 0.5em;\n  padding: 0em;\n  color: rgba(255, 255, 255, 0.4);\n}\n/*--------------\n  Extra Summary\n---------------*/\n.ui.feed > .event > .content .extra {\n  margin: 0.5em 0em 0em;\n  background: none;\n  padding: 0em;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Images */\n.ui.feed > .event > .content .extra.images img {\n  display: inline-block;\n  margin: 0em 0.25em 0em 0em;\n  width: 6em;\n}\n/* Text */\n.ui.feed > .event > .content .extra.text {\n  padding: 0em;\n  border-left: none;\n  font-size: 1em;\n  max-width: 500px;\n  line-height: 1.4285em;\n}\n/*--------------\n      Meta\n---------------*/\n.ui.feed > .event > .content .meta {\n  display: inline-block;\n  font-size: 0.85714286em;\n  margin: 0.5em 0em 0em;\n  background: none;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0em;\n  color: rgba(0, 0, 0, 0.6);\n}\n.ui.feed > .event > .content .meta > * {\n  position: relative;\n  margin-left: 0.75em;\n}\n.ui.feed > .event > .content .meta > *:after {\n  content: '';\n  color: rgba(0, 0, 0, 0.2);\n  top: 0em;\n  left: -1em;\n  opacity: 1;\n  position: absolute;\n  vertical-align: top;\n}\n.ui.feed > .event > .content .meta .like {\n  color: '';\n  transition: 0.2s color ease;\n}\n.ui.feed > .event > .content .meta .like:hover .icon {\n  color: #FF2733;\n}\n.ui.feed > .event > .content .meta .active.like .icon {\n  color: #EF404A;\n}\n/* First element */\n.ui.feed > .event > .content .meta > :first-child {\n  margin-left: 0em;\n}\n.ui.feed > .event > .content .meta > :first-child::after {\n  display: none;\n}\n/* Action */\n.ui.feed > .event > .content .meta a,\n.ui.feed > .event > .content .meta > .icon {\n  cursor: pointer;\n  opacity: 1;\n  color: rgba(0, 0, 0, 0.5);\n  transition: color 0.1s ease;\n}\n.ui.feed > .event > .content .meta a:hover,\n.ui.feed > .event > .content .meta a:hover .icon,\n.ui.feed > .event > .content .meta > .icon:hover {\n  color: rgba(255, 255, 255, 0.95);\n}\n/*******************************\n            Variations\n*******************************/\n.ui.small.feed {\n  font-size: 0.92857143rem;\n}\n.ui.feed {\n  font-size: 1rem;\n}\n.ui.large.feed {\n  font-size: 1.14285714rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Item\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Group */\n/* Item */\n/* Responsive */\n/*-------------------\n       Content\n--------------------*/\n/* Image */\n/* Content */\n/* Header */\n/* Metadata */\n/* Icons */\n/* Actions */\n/* Links */\n/* Description */\n/* Content Image */\n/* Avatar Image */\n/* Paragraph */\n/* Additional Content */\n/*-------------------\n      Variations\n--------------------*/\n/* Relaxed */\n/* Divided */\n/* Unstackable */\n/* Packaged Theme */\n/*******************************\n             Item\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Group */\n/* Item */\n/* Responsive */\n/*-------------------\n       Content\n--------------------*/\n/* Image */\n/* Content */\n/* Header */\n/* Metadata */\n/* Icons */\n/* Actions */\n/* Links */\n/* Description */\n/* Content Image */\n/* Avatar Image */\n/* Paragraph */\n/* Additional Content */\n/*-------------------\n      Variations\n--------------------*/\n/* Relaxed */\n/* Divided */\n/* Unstackable */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Standard\n*******************************/\n/*--------------\n      Item\n---------------*/\n.ui.items > .item {\n  display: flex;\n  margin: 1em 0em;\n  width: 100%;\n  min-height: 0px;\n  background: transparent;\n  padding: 0em;\n  border: none;\n  border-radius: 0rem;\n  box-shadow: none;\n  transition: box-shadow 0.1s ease;\n  z-index: '';\n}\n.ui.items > .item a {\n  cursor: pointer;\n}\n/*--------------\n      Items\n---------------*/\n.ui.items {\n  margin: 1.5em 0em;\n}\n.ui.items:first-child {\n  margin-top: 0em !important;\n}\n.ui.items:last-child {\n  margin-bottom: 0em !important;\n}\n/*--------------\n      Item\n---------------*/\n.ui.items > .item:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ui.items > .item:first-child {\n  margin-top: 0em;\n}\n.ui.items > .item:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n     Images\n---------------*/\n.ui.items > .item > .image {\n  position: relative;\n  flex: 0 0 auto;\n  display: block;\n  float: none;\n  margin: 0em;\n  padding: 0em;\n  max-height: '';\n  align-self: top;\n}\n.ui.items > .item > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 0.125rem;\n  border: none;\n}\n.ui.items > .item > .image:only-child > img {\n  border-radius: 0rem;\n}\n/*--------------\n     Content\n---------------*/\n.ui.items > .item > .content {\n  display: block;\n  flex: 1 1 auto;\n  background: none;\n  margin: 0em;\n  padding: 0em;\n  box-shadow: none;\n  font-size: 1em;\n  border: none;\n  border-radius: 0em;\n}\n.ui.items > .item > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ui.items > .item > .image + .content {\n  min-width: 0;\n  width: auto;\n  display: block;\n  margin-left: 0em;\n  align-self: top;\n  padding-left: 1.5em;\n}\n.ui.items > .item > .content > .header {\n  display: inline-block;\n  margin: -0.21425em 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.85);\n}\n/* Default Header Size */\n.ui.items > .item > .content > .header:not(.ui) {\n  font-size: 1.28571429em;\n}\n/*--------------\n     Floated\n---------------*/\n.ui.items > .item [class*=\"left floated\"] {\n  float: left;\n}\n.ui.items > .item [class*=\"right floated\"] {\n  float: right;\n}\n/*--------------\n  Content Image\n---------------*/\n.ui.items > .item .content img {\n  align-self: middle;\n  width: '';\n}\n.ui.items > .item img.avatar,\n.ui.items > .item .avatar img {\n  width: '';\n  height: '';\n  border-radius: 500rem;\n}\n/*--------------\n   Description\n---------------*/\n.ui.items > .item > .content > .description {\n  margin-top: 0.6em;\n  max-width: auto;\n  font-size: 1em;\n  line-height: 1.4285em;\n  color: rgba(255, 255, 255, 0.87);\n}\n/*--------------\n    Paragraph\n---------------*/\n.ui.items > .item > .content p {\n  margin: 0em 0em 0.5em;\n}\n.ui.items > .item > .content p:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n      Meta\n---------------*/\n.ui.items > .item .meta {\n  margin: 0.5em 0em 0.5em;\n  font-size: 1em;\n  line-height: 1em;\n  color: rgba(0, 0, 0, 0.6);\n}\n.ui.items > .item .meta * {\n  margin-right: 0.3em;\n}\n.ui.items > .item .meta :last-child {\n  margin-right: 0em;\n}\n.ui.items > .item .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: 0.3em;\n}\n/*--------------\n      Links\n---------------*/\n/* Generic */\n.ui.items > .item > .content a:not(.ui) {\n  color: '';\n  transition: color 0.1s ease;\n}\n.ui.items > .item > .content a:not(.ui):hover {\n  color: '';\n}\n/* Header */\n.ui.items > .item > .content > a.header {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.items > .item > .content > a.header:hover {\n  color: #1e70bf;\n}\n/* Meta */\n.ui.items > .item .meta > a:not(.ui) {\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.items > .item .meta > a:not(.ui):hover {\n  color: rgba(255, 255, 255, 0.87);\n}\n/*--------------\n     Labels\n---------------*/\n/*-----Star----- */\n/* Icon */\n.ui.items > .item > .content .favorite.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n.ui.items > .item > .content .favorite.icon:hover {\n  opacity: 1;\n  color: #FFB70A;\n}\n.ui.items > .item > .content .active.favorite.icon {\n  color: #FFE623;\n}\n/*-----Like----- */\n/* Icon */\n.ui.items > .item > .content .like.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n.ui.items > .item > .content .like.icon:hover {\n  opacity: 1;\n  color: #FF2733;\n}\n.ui.items > .item > .content .active.like.icon {\n  color: #FF2733;\n}\n/*----------------\n  Extra Content\n-----------------*/\n.ui.items > .item .extra {\n  display: block;\n  position: relative;\n  background: none;\n  margin: 0.5rem 0em 0em;\n  width: 100%;\n  padding: 0em 0em 0em;\n  top: 0em;\n  left: 0em;\n  color: rgba(255, 255, 255, 0.4);\n  box-shadow: none;\n  transition: color 0.1s ease;\n  border-top: none;\n}\n.ui.items > .item .extra > * {\n  margin: 0.25rem 0.5rem 0.25rem 0em;\n}\n.ui.items > .item .extra > [class*=\"right floated\"] {\n  margin: 0.25rem 0em 0.25rem 0.5rem;\n}\n.ui.items > .item .extra:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n/*******************************\n          Responsive\n*******************************/\n/* Default Image Width */\n.ui.items > .item > .image:not(.ui) {\n  width: 175px;\n}\n/* Tablet Only */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.items > .item {\n    margin: 1em 0em;\n  }\n  .ui.items > .item > .image:not(.ui) {\n    width: 150px;\n  }\n  .ui.items > .item > .image + .content {\n    display: block;\n    padding: 0em 0em 0em 1em;\n  }\n}\n/* Mobile Only */\n@media only screen and (max-width: 767px) {\n  .ui.items:not(.unstackable) > .item {\n    flex-direction: column;\n    margin: 2em 0em;\n  }\n  .ui.items:not(.unstackable) > .item > .image {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .ui.items:not(.unstackable) > .item > .image,\n  .ui.items:not(.unstackable) > .item > .image > img {\n    max-width: 100% !important;\n    width: auto !important;\n    max-height: 250px !important;\n  }\n  .ui.items:not(.unstackable) > .item > .image + .content {\n    display: block;\n    padding: 1.5em 0em 0em;\n  }\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n       Aligned\n--------------------*/\n.ui.items > .item > .image + [class*=\"top aligned\"].content {\n  align-self: flex-start;\n}\n.ui.items > .item > .image + [class*=\"middle aligned\"].content {\n  align-self: center;\n}\n.ui.items > .item > .image + [class*=\"bottom aligned\"].content {\n  align-self: flex-end;\n}\n/*--------------\n     Relaxed\n---------------*/\n.ui.relaxed.items > .item {\n  margin: 1.5em 0em;\n}\n.ui[class*=\"very relaxed\"].items > .item {\n  margin: 2em 0em;\n}\n/*-------------------\n      Divided\n--------------------*/\n.ui.divided.items > .item {\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  margin: 0em;\n  padding: 1em 0em;\n}\n.ui.divided.items > .item:first-child {\n  border-top: none;\n  margin-top: 0em !important;\n  padding-top: 0em !important;\n}\n.ui.divided.items > .item:last-child {\n  margin-bottom: 0em !important;\n  padding-bottom: 0em !important;\n}\n/* Relaxed Divided */\n.ui.relaxed.divided.items > .item {\n  margin: 0em;\n  padding: 1.5em 0em;\n}\n.ui[class*=\"very relaxed\"].divided.items > .item {\n  margin: 0em;\n  padding: 2em 0em;\n}\n/*-------------------\n        Link\n--------------------*/\n.ui.items a.item:hover,\n.ui.link.items > .item:hover {\n  cursor: pointer;\n}\n.ui.items a.item:hover .content .header,\n.ui.link.items > .item:hover .content .header {\n  color: #1e70bf;\n}\n/*--------------\n      Size\n---------------*/\n.ui.items > .item {\n  font-size: 1em;\n}\n/*---------------\n   Unstackable\n----------------*/\n@media only screen and (max-width: 767px) {\n  .ui.unstackable.items > .item > .image,\n  .ui.unstackable.items > .item > .image > img {\n    width: 125px !important;\n  }\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Statistic\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n           Statistic\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Group */\n/* Group Element */\n/*-------------------\n       Content\n--------------------*/\n/* Value */\n/* Label */\n/* Text */\n/* Label Image */\n/*-------------------\n      Types\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Floated */\n/* Inverted */\n/* Item Width */\n/* Size */\n/* Packaged Theme */\n/*******************************\n           Statistic\n*******************************/\n/*-------------------\n         View\n--------------------*/\n/* Group */\n/* Group Element */\n/*-------------------\n       Content\n--------------------*/\n/* Value */\n/* Label */\n/* Text */\n/* Label Image */\n/*-------------------\n      Types\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Floated */\n/* Inverted */\n/* Item Width */\n/* Size */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           Statistic\n*******************************/\n/* Standalone */\n.ui.statistic {\n  display: inline-flex;\n  flex-direction: column;\n  margin: 1em 0em;\n  max-width: auto;\n}\n.ui.statistic + .ui.statistic {\n  margin: 0em 0em 0em 1.5em;\n}\n.ui.statistic:first-child {\n  margin-top: 0em;\n}\n.ui.statistic:last-child {\n  margin-bottom: 0em;\n}\n/*******************************\n            Group\n*******************************/\n/* Grouped */\n.ui.statistics {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.ui.statistics > .statistic {\n  display: inline-flex;\n  flex: 0 1 auto;\n  flex-direction: column;\n  margin: 0em 1.5em 1em;\n  max-width: auto;\n}\n.ui.statistics {\n  display: flex;\n  margin: 1em -1.5em -1em;\n}\n/* Clearing */\n.ui.statistics:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ui.statistics:first-child {\n  margin-top: 0em;\n}\n/*******************************\n            Content\n*******************************/\n/*--------------\n      Value\n---------------*/\n.ui.statistics .statistic > .value,\n.ui.statistic > .value {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 4rem;\n  font-weight: normal;\n  line-height: 1em;\n  color: #1B1C1D;\n  text-transform: uppercase;\n  text-align: center;\n}\n/*--------------\n     Label\n---------------*/\n.ui.statistics .statistic > .label,\n.ui.statistic > .label {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.87);\n  text-transform: uppercase;\n  text-align: center;\n}\n/* Top Label */\n.ui.statistics .statistic > .label ~ .value,\n.ui.statistic > .label ~ .value {\n  margin-top: 0rem;\n}\n/* Bottom Label */\n.ui.statistics .statistic > .value ~ .label,\n.ui.statistic > .value ~ .label {\n  margin-top: 0rem;\n}\n/*******************************\n             Types\n*******************************/\n/*--------------\n   Icon Value\n---------------*/\n.ui.statistics .statistic > .value .icon,\n.ui.statistic > .value .icon {\n  opacity: 1;\n  width: auto;\n  margin: 0em;\n}\n/*--------------\n   Text Value\n---------------*/\n.ui.statistics .statistic > .text.value,\n.ui.statistic > .text.value {\n  line-height: 1em;\n  min-height: 2em;\n  font-weight: bold;\n  text-align: center;\n}\n.ui.statistics .statistic > .text.value + .label,\n.ui.statistic > .text.value + .label {\n  text-align: center;\n}\n/*--------------\n   Image Value\n---------------*/\n.ui.statistics .statistic > .value img,\n.ui.statistic > .value img {\n  max-height: 3rem;\n  vertical-align: baseline;\n}\n/*******************************\n            Variations\n*******************************/\n/*--------------\n      Count\n---------------*/\n.ui.ten.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.ten.statistics .statistic {\n  min-width: 10%;\n  margin: 0em 0em 1em;\n}\n.ui.nine.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.nine.statistics .statistic {\n  min-width: 11.11111111%;\n  margin: 0em 0em 1em;\n}\n.ui.eight.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.eight.statistics .statistic {\n  min-width: 12.5%;\n  margin: 0em 0em 1em;\n}\n.ui.seven.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.seven.statistics .statistic {\n  min-width: 14.28571429%;\n  margin: 0em 0em 1em;\n}\n.ui.six.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.six.statistics .statistic {\n  min-width: 16.66666667%;\n  margin: 0em 0em 1em;\n}\n.ui.five.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.five.statistics .statistic {\n  min-width: 20%;\n  margin: 0em 0em 1em;\n}\n.ui.four.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.four.statistics .statistic {\n  min-width: 25%;\n  margin: 0em 0em 1em;\n}\n.ui.three.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.three.statistics .statistic {\n  min-width: 33.33333333%;\n  margin: 0em 0em 1em;\n}\n.ui.two.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.two.statistics .statistic {\n  min-width: 50%;\n  margin: 0em 0em 1em;\n}\n.ui.one.statistics {\n  margin: 0em 0em -1em;\n}\n.ui.one.statistics .statistic {\n  min-width: 100%;\n  margin: 0em 0em 1em;\n}\n/*--------------\n   Horizontal\n---------------*/\n.ui.horizontal.statistic {\n  flex-direction: row;\n  align-items: center;\n}\n.ui.horizontal.statistics {\n  flex-direction: column;\n  margin: 0em;\n  max-width: none;\n}\n.ui.horizontal.statistics .statistic {\n  flex-direction: row;\n  align-items: center;\n  max-width: none;\n  margin: 1em 0em;\n}\n.ui.horizontal.statistic > .text.value,\n.ui.horizontal.statistics > .statistic > .text.value {\n  min-height: 0em !important;\n}\n.ui.horizontal.statistics .statistic > .value .icon,\n.ui.horizontal.statistic > .value .icon {\n  width: 1.18em;\n}\n.ui.horizontal.statistics .statistic > .value,\n.ui.horizontal.statistic > .value {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ui.horizontal.statistics .statistic > .label,\n.ui.horizontal.statistic > .label {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0em 0em 0em 0.75em;\n}\n/*--------------\n     Colors\n---------------*/\n.ui.red.statistics .statistic > .value,\n.ui.statistics .red.statistic > .value,\n.ui.red.statistic > .value {\n  color: #DB2828;\n}\n.ui.orange.statistics .statistic > .value,\n.ui.statistics .orange.statistic > .value,\n.ui.orange.statistic > .value {\n  color: #F2711C;\n}\n.ui.yellow.statistics .statistic > .value,\n.ui.statistics .yellow.statistic > .value,\n.ui.yellow.statistic > .value {\n  color: #FBBD08;\n}\n.ui.olive.statistics .statistic > .value,\n.ui.statistics .olive.statistic > .value,\n.ui.olive.statistic > .value {\n  color: #B5CC18;\n}\n.ui.green.statistics .statistic > .value,\n.ui.statistics .green.statistic > .value,\n.ui.green.statistic > .value {\n  color: #21BA45;\n}\n.ui.teal.statistics .statistic > .value,\n.ui.statistics .teal.statistic > .value,\n.ui.teal.statistic > .value {\n  color: #00B5AD;\n}\n.ui.blue.statistics .statistic > .value,\n.ui.statistics .blue.statistic > .value,\n.ui.blue.statistic > .value {\n  color: #2185D0;\n}\n.ui.violet.statistics .statistic > .value,\n.ui.statistics .violet.statistic > .value,\n.ui.violet.statistic > .value {\n  color: #6435C9;\n}\n.ui.purple.statistics .statistic > .value,\n.ui.statistics .purple.statistic > .value,\n.ui.purple.statistic > .value {\n  color: #A333C8;\n}\n.ui.pink.statistics .statistic > .value,\n.ui.statistics .pink.statistic > .value,\n.ui.pink.statistic > .value {\n  color: #E03997;\n}\n.ui.brown.statistics .statistic > .value,\n.ui.statistics .brown.statistic > .value,\n.ui.brown.statistic > .value {\n  color: #A5673F;\n}\n.ui.grey.statistics .statistic > .value,\n.ui.statistics .grey.statistic > .value,\n.ui.grey.statistic > .value {\n  color: #767676;\n}\n/*--------------\n    Inverted\n---------------*/\n.ui.inverted.statistics .statistic > .value,\n.ui.inverted.statistic .value {\n  color: #FFFFFF;\n}\n.ui.inverted.statistics .statistic > .label,\n.ui.inverted.statistic .label {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.inverted.red.statistics .statistic > .value,\n.ui.statistics .inverted.red.statistic > .value,\n.ui.inverted.red.statistic > .value {\n  color: #FF695E;\n}\n.ui.inverted.orange.statistics .statistic > .value,\n.ui.statistics .inverted.orange.statistic > .value,\n.ui.inverted.orange.statistic > .value {\n  color: #FF851B;\n}\n.ui.inverted.yellow.statistics .statistic > .value,\n.ui.statistics .inverted.yellow.statistic > .value,\n.ui.inverted.yellow.statistic > .value {\n  color: #FFE21F;\n}\n.ui.inverted.olive.statistics .statistic > .value,\n.ui.statistics .inverted.olive.statistic > .value,\n.ui.inverted.olive.statistic > .value {\n  color: #D9E778;\n}\n.ui.inverted.green.statistics .statistic > .value,\n.ui.statistics .inverted.green.statistic > .value,\n.ui.inverted.green.statistic > .value {\n  color: #2ECC40;\n}\n.ui.inverted.teal.statistics .statistic > .value,\n.ui.statistics .inverted.teal.statistic > .value,\n.ui.inverted.teal.statistic > .value {\n  color: #6DFFFF;\n}\n.ui.inverted.blue.statistics .statistic > .value,\n.ui.statistics .inverted.blue.statistic > .value,\n.ui.inverted.blue.statistic > .value {\n  color: #54C8FF;\n}\n.ui.inverted.violet.statistics .statistic > .value,\n.ui.statistics .inverted.violet.statistic > .value,\n.ui.inverted.violet.statistic > .value {\n  color: #A291FB;\n}\n.ui.inverted.purple.statistics .statistic > .value,\n.ui.statistics .inverted.purple.statistic > .value,\n.ui.inverted.purple.statistic > .value {\n  color: #DC73FF;\n}\n.ui.inverted.pink.statistics .statistic > .value,\n.ui.statistics .inverted.pink.statistic > .value,\n.ui.inverted.pink.statistic > .value {\n  color: #FF8EDF;\n}\n.ui.inverted.brown.statistics .statistic > .value,\n.ui.statistics .inverted.brown.statistic > .value,\n.ui.inverted.brown.statistic > .value {\n  color: #D67C1C;\n}\n.ui.inverted.grey.statistics .statistic > .value,\n.ui.statistics .inverted.grey.statistic > .value,\n.ui.inverted.grey.statistic > .value {\n  color: #DCDDDE;\n}\n/*--------------\n    Floated\n---------------*/\n.ui[class*=\"left floated\"].statistic {\n  float: left;\n  margin: 0em 2em 1em 0em;\n}\n.ui[class*=\"right floated\"].statistic {\n  float: right;\n  margin: 0em 0em 1em 2em;\n}\n.ui.floated.statistic:last-child {\n  margin-bottom: 0em;\n}\n/*--------------\n     Sizes\n---------------*/\n/* Mini */\n.ui.mini.statistics .statistic > .value,\n.ui.mini.statistic > .value {\n  font-size: 1.5rem !important;\n}\n.ui.mini.horizontal.statistics .statistic > .value,\n.ui.mini.horizontal.statistic > .value {\n  font-size: 1.5rem !important;\n}\n.ui.mini.statistics .statistic > .text.value,\n.ui.mini.statistic > .text.value {\n  font-size: 1rem !important;\n}\n/* Tiny */\n.ui.tiny.statistics .statistic > .value,\n.ui.tiny.statistic > .value {\n  font-size: 2rem !important;\n}\n.ui.tiny.horizontal.statistics .statistic > .value,\n.ui.tiny.horizontal.statistic > .value {\n  font-size: 2rem !important;\n}\n.ui.tiny.statistics .statistic > .text.value,\n.ui.tiny.statistic > .text.value {\n  font-size: 1rem !important;\n}\n/* Small */\n.ui.small.statistics .statistic > .value,\n.ui.small.statistic > .value {\n  font-size: 3rem !important;\n}\n.ui.small.horizontal.statistics .statistic > .value,\n.ui.small.horizontal.statistic > .value {\n  font-size: 2rem !important;\n}\n.ui.small.statistics .statistic > .text.value,\n.ui.small.statistic > .text.value {\n  font-size: 1rem !important;\n}\n/* Medium */\n.ui.statistics .statistic > .value,\n.ui.statistic > .value {\n  font-size: 4rem !important;\n}\n.ui.horizontal.statistics .statistic > .value,\n.ui.horizontal.statistic > .value {\n  font-size: 3rem !important;\n}\n.ui.statistics .statistic > .text.value,\n.ui.statistic > .text.value {\n  font-size: 2rem !important;\n}\n/* Large */\n.ui.large.statistics .statistic > .value,\n.ui.large.statistic > .value {\n  font-size: 5rem !important;\n}\n.ui.large.horizontal.statistics .statistic > .value,\n.ui.large.horizontal.statistic > .value {\n  font-size: 4rem !important;\n}\n.ui.large.statistics .statistic > .text.value,\n.ui.large.statistic > .text.value {\n  font-size: 2.5rem !important;\n}\n/* Huge */\n.ui.huge.statistics .statistic > .value,\n.ui.huge.statistic > .value {\n  font-size: 6rem !important;\n}\n.ui.huge.horizontal.statistics .statistic > .value,\n.ui.huge.horizontal.statistic > .value {\n  font-size: 5rem !important;\n}\n.ui.huge.statistics .statistic > .text.value,\n.ui.huge.statistic > .text.value {\n  font-size: 2.5rem !important;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/* Modules */\n/*!\n * # Semantic UI - Accordion\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n           Accordion\n*******************************/\n/* Title */\n/* Icon */\n/* Child Accordion */\n/* Content */\n/*-------------------\n       Coupling\n--------------------*/\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Styled */\n/* Content */\n/* Child Content */\n/* Styled Title */\n/* Styled Title States */\n/* Styled Child Title States */\n/* Inverted */\n/* Packaged Theme */\n/*******************************\n           Accordion\n*******************************/\n/* Title */\n/* Icon */\n/* Child Accordion */\n/* Content */\n/*-------------------\n       Coupling\n--------------------*/\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Styled */\n/* Content */\n/* Child Content */\n/* Styled Title */\n/* Styled Title States */\n/* Styled Child Title States */\n/* Inverted */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Accordion\n*******************************/\n.ui.accordion,\n.ui.accordion .accordion {\n  max-width: 100%;\n}\n.ui.accordion .accordion {\n  margin: 1em 0em 0em;\n  padding: 0em;\n}\n/* Title */\n.ui.accordion .title,\n.ui.accordion .accordion .title {\n  cursor: pointer;\n}\n/* Default Styling */\n.ui.accordion .title:not(.ui) {\n  padding: 0.5em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Content */\n.ui.accordion .title ~ .content,\n.ui.accordion .accordion .title ~ .content {\n  display: none;\n}\n/* Default Styling */\n.ui.accordion:not(.styled) .title ~ .content:not(.ui),\n.ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {\n  margin: '';\n  padding: 0.5em 0em 1em;\n}\n.ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {\n  padding-bottom: 0em;\n}\n/* Arrow */\n.ui.accordion .title .dropdown.icon,\n.ui.accordion .accordion .title .dropdown.icon {\n  display: inline-block;\n  float: none;\n  opacity: 1;\n  width: 1.25em;\n  height: 1em;\n  margin: 0em 0.25rem 0em 0rem;\n  padding: 0em;\n  font-size: 1em;\n  transition: transform 0.1s ease, opacity 0.1s ease;\n  vertical-align: baseline;\n  transform: none;\n}\n/*--------------\n    Coupling\n---------------*/\n/* Menu */\n.ui.accordion.menu .item .title {\n  display: block;\n  padding: 0em;\n}\n.ui.accordion.menu .item .title > .dropdown.icon {\n  float: right;\n  margin: 0.21425em 0em 0em 1em;\n  transform: rotate(180deg);\n}\n/* Header */\n.ui.accordion .ui.header .dropdown.icon {\n  font-size: 1em;\n  margin: 0em 0.25rem 0em 0rem;\n}\n/*******************************\n            States\n*******************************/\n.ui.accordion .active.title .dropdown.icon,\n.ui.accordion .accordion .active.title .dropdown.icon {\n  transform: rotate(90deg);\n}\n.ui.accordion.menu .item .active.title > .dropdown.icon {\n  transform: rotate(90deg);\n}\n/*******************************\n            Types\n*******************************/\n/*--------------\n     Styled\n---------------*/\n.ui.styled.accordion {\n  width: 600px;\n}\n.ui.styled.accordion,\n.ui.styled.accordion .accordion {\n  border-radius: 0.28571429rem;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15);\n}\n.ui.styled.accordion .title,\n.ui.styled.accordion .accordion .title {\n  margin: 0em;\n  padding: 0.75em 1em;\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: bold;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  transition: background 0.1s ease, color 0.1s ease;\n}\n.ui.styled.accordion > .title:first-child,\n.ui.styled.accordion .accordion .title:first-child {\n  border-top: none;\n}\n/* Content */\n.ui.styled.accordion .content,\n.ui.styled.accordion .accordion .content {\n  margin: 0em;\n  padding: 0.5em 1em 1.5em;\n}\n.ui.styled.accordion .accordion .content {\n  padding: 0em;\n  padding: 0.5em 1em 1.5em;\n}\n/* Hover */\n.ui.styled.accordion .title:hover,\n.ui.styled.accordion .active.title,\n.ui.styled.accordion .accordion .title:hover,\n.ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.styled.accordion .accordion .title:hover,\n.ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Active */\n.ui.styled.accordion .active.title {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n     Active\n---------------*/\n.ui.accordion .active.content,\n.ui.accordion .accordion .active.content {\n  display: block;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Fluid\n---------------*/\n.ui.fluid.accordion,\n.ui.fluid.accordion .accordion {\n  width: 100%;\n}\n/*--------------\n     Inverted\n---------------*/\n.ui.inverted.accordion .title:not(.ui) {\n  color: rgba(255, 255, 255, 0.9);\n}\n/*******************************\n         Theme Overrides\n*******************************/\n@font-face {\n  font-family: 'Accordion';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n/* Dropdown Icon */\n.ui.accordion .title .dropdown.icon,\n.ui.accordion .accordion .title .dropdown.icon {\n  font-family: Accordion;\n  line-height: 1;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n.ui.accordion .title .dropdown.icon:before,\n.ui.accordion .accordion .title .dropdown.icon:before {\n  content: '\\f0da' /*rtl:'\\f0d9'*/;\n}\n/*!\n * # Semantic UI - Checkbox\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Checkbox\n*******************************/\n/* Label */\n/* 26px @ 14/em */\n/* Checkbox */\n/* Checkmark */\n/* Label */\n/*-------------------\n        States\n--------------------*/\n/* Hover */\n/* Pressed */\n/* Focus */\n/* Active */\n/* Active Focus */\n/* Indeterminate */\n/* Disabled */\n/*-------------------\n        Types\n--------------------*/\n/* Radio */\n/* Uses px to avoid rounding issues with circles */\n/* 7px as unitless value from radio size */\n/* Slider & Toggle Handle */\n/* Slider */\n/* Slider States */\n/* Toggle */\n/*-------------------\n      Variations\n--------------------*/\n/* Packaged Theme */\n/*******************************\n            Checkbox\n*******************************/\n/* Label */\n/* 26px @ 14/em */\n/* Checkbox */\n/* Checkmark */\n/* Label */\n/*-------------------\n        States\n--------------------*/\n/* Hover */\n/* Pressed */\n/* Focus */\n/* Active */\n/* Active Focus */\n/* Indeterminate */\n/* Disabled */\n/*-------------------\n        Types\n--------------------*/\n/* Radio */\n/* Uses px to avoid rounding issues with circles */\n/* 7px as unitless value from radio size */\n/* Slider & Toggle Handle */\n/* Slider */\n/* Slider States */\n/* Toggle */\n/*-------------------\n      Variations\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           Checkbox\n*******************************/\n/*--------------\n    Content\n---------------*/\n.ui.checkbox {\n  position: relative;\n  display: inline-block;\n  backface-visibility: hidden;\n  outline: none;\n  vertical-align: baseline;\n  font-style: normal;\n  min-height: 17px;\n  font-size: 1rem;\n  line-height: 17px;\n  min-width: 17px;\n}\n/* HTML Checkbox */\n.ui.checkbox input[type=\"checkbox\"],\n.ui.checkbox input[type=\"radio\"] {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  opacity: 0 !important;\n  outline: none;\n  z-index: 3;\n  width: 17px;\n  height: 17px;\n}\n/*--------------\n      Box\n---------------*/\n.ui.checkbox .box,\n.ui.checkbox label {\n  cursor: auto;\n  position: relative;\n  display: block;\n  padding-left: 1.85714em;\n  outline: none;\n  font-size: 1em;\n}\n.ui.checkbox .box:before,\n.ui.checkbox label:before {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 17px;\n  height: 17px;\n  content: '';\n  background: #1B1C1D;\n  border-radius: 0.21428571rem;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;\n  border: 1px solid #D4D4D5;\n}\n/*--------------\n    Checkmark\n---------------*/\n.ui.checkbox .box:after,\n.ui.checkbox label:after {\n  position: absolute;\n  font-size: 14px;\n  top: 0px;\n  left: 0px;\n  width: 17px;\n  height: 17px;\n  text-align: center;\n  opacity: 0;\n  color: #d9d9e2;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;\n}\n/*--------------\n      Label\n---------------*/\n/* Inside */\n.ui.checkbox label,\n.ui.checkbox + label {\n  color: #d9d9e2;\n  transition: color 0.1s ease;\n}\n/* Outside */\n.ui.checkbox + label {\n  vertical-align: middle;\n}\n/*******************************\n           States\n*******************************/\n/*--------------\n      Hover\n---------------*/\n.ui.checkbox .box:hover::before,\n.ui.checkbox label:hover::before {\n  background: #1B1C1D;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n.ui.checkbox label:hover,\n.ui.checkbox + label:hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n/*--------------\n      Down\n---------------*/\n.ui.checkbox .box:active::before,\n.ui.checkbox label:active::before {\n  background: #F9FAFB;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n.ui.checkbox .box:active::after,\n.ui.checkbox label:active::after {\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.checkbox input:active ~ label {\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Focus\n---------------*/\n.ui.checkbox input:focus ~ .box:before,\n.ui.checkbox input:focus ~ label:before {\n  background: #1B1C1D;\n  border-color: #96C8DA;\n}\n.ui.checkbox input:focus ~ .box:after,\n.ui.checkbox input:focus ~ label:after {\n  color: rgba(255, 255, 255, 0.95);\n}\n.ui.checkbox input:focus ~ label {\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Active\n---------------*/\n.ui.checkbox input:checked ~ .box:before,\n.ui.checkbox input:checked ~ label:before {\n  background: #1B1C1D;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n.ui.checkbox input:checked ~ .box:after,\n.ui.checkbox input:checked ~ label:after {\n  opacity: 1;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n  Indeterminate\n---------------*/\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:before,\n.ui.checkbox input:not([type=radio]):indeterminate ~ label:before {\n  background: #1B1C1D;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:after,\n.ui.checkbox input:not([type=radio]):indeterminate ~ label:after {\n  opacity: 1;\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n  Active Focus\n---------------*/\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before,\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before,\n.ui.checkbox input:checked:focus ~ .box:before,\n.ui.checkbox input:checked:focus ~ label:before {\n  background: #1B1C1D;\n  border-color: #96C8DA;\n}\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after,\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after,\n.ui.checkbox input:checked:focus ~ .box:after,\n.ui.checkbox input:checked:focus ~ label:after {\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n    Read-Only\n---------------*/\n.ui.read-only.checkbox,\n.ui.read-only.checkbox label {\n  cursor: default;\n}\n/*--------------\n     Disabled\n---------------*/\n.ui.disabled.checkbox .box:after,\n.ui.disabled.checkbox label,\n.ui.checkbox input[disabled] ~ .box:after,\n.ui.checkbox input[disabled] ~ label {\n  cursor: default !important;\n  opacity: 0.5;\n  color: #000000;\n}\n/*--------------\n     Hidden\n---------------*/\n/* Initialized checkbox moves input below element\n to prevent manually triggering */\n.ui.checkbox input.hidden {\n  z-index: -1;\n}\n/* Selectable Label */\n.ui.checkbox input.hidden + label {\n  cursor: pointer;\n  user-select: none;\n}\n/*******************************\n             Types\n*******************************/\n/*--------------\n     Radio\n---------------*/\n.ui.radio.checkbox {\n  min-height: 15px;\n}\n.ui.radio.checkbox .box,\n.ui.radio.checkbox label {\n  padding-left: 1.85714em;\n}\n/* Box */\n.ui.radio.checkbox .box:before,\n.ui.radio.checkbox label:before {\n  content: '';\n  transform: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 500rem;\n  top: 1px;\n  left: 0px;\n}\n/* Bullet */\n.ui.radio.checkbox .box:after,\n.ui.radio.checkbox label:after {\n  border: none;\n  content: '' !important;\n  width: 15px;\n  height: 15px;\n  line-height: 15px;\n}\n/* Radio Checkbox */\n.ui.radio.checkbox .box:after,\n.ui.radio.checkbox label:after {\n  top: 1px;\n  left: 0px;\n  width: 15px;\n  height: 15px;\n  border-radius: 500rem;\n  transform: scale(0.46666667);\n  background-color: rgba(255, 255, 255, 0.87);\n}\n/* Focus */\n.ui.radio.checkbox input:focus ~ .box:before,\n.ui.radio.checkbox input:focus ~ label:before {\n  background-color: #1B1C1D;\n}\n.ui.radio.checkbox input:focus ~ .box:after,\n.ui.radio.checkbox input:focus ~ label:after {\n  background-color: rgba(255, 255, 255, 0.95);\n}\n/* Indeterminate */\n.ui.radio.checkbox input:indeterminate ~ .box:after,\n.ui.radio.checkbox input:indeterminate ~ label:after {\n  opacity: 0;\n}\n/* Active */\n.ui.radio.checkbox input:checked ~ .box:before,\n.ui.radio.checkbox input:checked ~ label:before {\n  background-color: #1B1C1D;\n}\n.ui.radio.checkbox input:checked ~ .box:after,\n.ui.radio.checkbox input:checked ~ label:after {\n  background-color: rgba(255, 255, 255, 0.95);\n}\n/* Active Focus */\n.ui.radio.checkbox input:focus:checked ~ .box:before,\n.ui.radio.checkbox input:focus:checked ~ label:before {\n  background-color: #1B1C1D;\n}\n.ui.radio.checkbox input:focus:checked ~ .box:after,\n.ui.radio.checkbox input:focus:checked ~ label:after {\n  background-color: rgba(255, 255, 255, 0.95);\n}\n/*--------------\n     Slider\n---------------*/\n.ui.slider.checkbox {\n  min-height: 1.25rem;\n}\n/* Input */\n.ui.slider.checkbox input {\n  width: 3.5rem;\n  height: 1.25rem;\n}\n/* Label */\n.ui.slider.checkbox .box,\n.ui.slider.checkbox label {\n  padding-left: 4.5rem;\n  line-height: 1rem;\n  color: rgba(255, 255, 255, 0.4);\n}\n/* Line */\n.ui.slider.checkbox .box:before,\n.ui.slider.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  border: none !important;\n  left: 0em;\n  z-index: 1;\n  top: 0.4rem;\n  background-color: rgba(255, 255, 255, 0.08);\n  width: 3.5rem;\n  height: 0.21428571rem;\n  transform: none;\n  border-radius: 500rem;\n  transition: background 0.3s ease;\n}\n/* Handle */\n.ui.slider.checkbox .box:after,\n.ui.slider.checkbox label:after {\n  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: -0.25rem;\n  left: 0em;\n  transform: none;\n  border-radius: 500rem;\n  transition: left 0.3s ease;\n}\n/* Focus */\n.ui.slider.checkbox input:focus ~ .box:before,\n.ui.slider.checkbox input:focus ~ label:before {\n  background-color: rgba(255, 255, 255, 0.15);\n  border: none;\n}\n/* Hover */\n.ui.slider.checkbox .box:hover,\n.ui.slider.checkbox label:hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n.ui.slider.checkbox .box:hover::before,\n.ui.slider.checkbox label:hover::before {\n  background: rgba(255, 255, 255, 0.15);\n}\n/* Active */\n.ui.slider.checkbox input:checked ~ .box,\n.ui.slider.checkbox input:checked ~ label {\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.slider.checkbox input:checked ~ .box:before,\n.ui.slider.checkbox input:checked ~ label:before {\n  background-color: #545454 !important;\n}\n.ui.slider.checkbox input:checked ~ .box:after,\n.ui.slider.checkbox input:checked ~ label:after {\n  left: 2rem;\n}\n/* Active Focus */\n.ui.slider.checkbox input:focus:checked ~ .box,\n.ui.slider.checkbox input:focus:checked ~ label {\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.slider.checkbox input:focus:checked ~ .box:before,\n.ui.slider.checkbox input:focus:checked ~ label:before {\n  background-color: #000000 !important;\n}\n/*--------------\n     Toggle\n---------------*/\n.ui.toggle.checkbox {\n  min-height: 1.5rem;\n}\n/* Input */\n.ui.toggle.checkbox input {\n  width: 3.5rem;\n  height: 1.5rem;\n}\n/* Label */\n.ui.toggle.checkbox .box,\n.ui.toggle.checkbox label {\n  min-height: 1.5rem;\n  padding-left: 4.5rem;\n  color: #d9d9e2;\n}\n.ui.toggle.checkbox label {\n  padding-top: 0.15em;\n}\n/* Switch */\n.ui.toggle.checkbox .box:before,\n.ui.toggle.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  z-index: 1;\n  transform: none;\n  border: none;\n  top: 0rem;\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n  width: 3.5rem;\n  height: 1.5rem;\n  border-radius: 500rem;\n}\n/* Handle */\n.ui.toggle.checkbox .box:after,\n.ui.toggle.checkbox label:after {\n  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: 0rem;\n  left: 0em;\n  border-radius: 500rem;\n  transition: background 0.3s ease, left 0.3s ease;\n}\n.ui.toggle.checkbox input ~ .box:after,\n.ui.toggle.checkbox input ~ label:after {\n  left: -0.05rem;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n}\n/* Focus */\n.ui.toggle.checkbox input:focus ~ .box:before,\n.ui.toggle.checkbox input:focus ~ label:before {\n  background-color: rgba(255, 255, 255, 0.15);\n  border: none;\n}\n/* Hover */\n.ui.toggle.checkbox .box:hover::before,\n.ui.toggle.checkbox label:hover::before {\n  background-color: rgba(255, 255, 255, 0.15);\n  border: none;\n}\n/* Active */\n.ui.toggle.checkbox input:checked ~ .box,\n.ui.toggle.checkbox input:checked ~ label {\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.toggle.checkbox input:checked ~ .box:before,\n.ui.toggle.checkbox input:checked ~ label:before {\n  background-color: #2185D0 !important;\n}\n.ui.toggle.checkbox input:checked ~ .box:after,\n.ui.toggle.checkbox input:checked ~ label:after {\n  left: 2.15rem;\n  box-shadow: 0px 1px 2px 0 rgba(255, 255, 255, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n}\n/* Active Focus */\n.ui.toggle.checkbox input:focus:checked ~ .box,\n.ui.toggle.checkbox input:focus:checked ~ label {\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n.ui.toggle.checkbox input:focus:checked ~ .box:before,\n.ui.toggle.checkbox input:focus:checked ~ label:before {\n  background-color: #0d71bb !important;\n}\n/*******************************\n            Variations\n*******************************/\n/*--------------\n     Fitted\n---------------*/\n.ui.fitted.checkbox .box,\n.ui.fitted.checkbox label {\n  padding-left: 0em !important;\n}\n.ui.fitted.toggle.checkbox,\n.ui.fitted.toggle.checkbox {\n  width: 3.5rem;\n}\n.ui.fitted.slider.checkbox,\n.ui.fitted.slider.checkbox {\n  width: 3.5rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n@font-face {\n  font-family: 'Checkbox';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype');\n}\n/* Checkmark */\n.ui.checkbox label:after,\n.ui.checkbox .box:after {\n  font-family: 'Checkbox';\n}\n/* Checked */\n.ui.checkbox input:checked ~ .box:after,\n.ui.checkbox input:checked ~ label:after {\n  content: '\\e800';\n}\n/* Indeterminate */\n.ui.checkbox input:indeterminate ~ .box:after,\n.ui.checkbox input:indeterminate ~ label:after {\n  font-size: 12px;\n  content: '\\e801';\n}\n/*  UTF Reference\n.check:before { content: '\\e800'; }\n.dash:before  { content: '\\e801'; }\n.plus:before { content: '\\e802'; }\n*/\n/*!\n * # Semantic UI - Dimmer\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Dimmer\n*******************************/\n/* Hidden (Default) */\n/* Visible */\n/*-------------------\n        Types\n--------------------*/\n/* Page Dimmer*/\n/*-------------------\n      Variations\n--------------------*/\n/* Inverted */\n/* Simple */\n/* Packaged Theme */\n/*******************************\n            Dimmer\n*******************************/\n/* Hidden (Default) */\n/* Visible */\n/*-------------------\n        Types\n--------------------*/\n/* Page Dimmer*/\n/*-------------------\n      Variations\n--------------------*/\n/* Inverted */\n/* Simple */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Dimmer\n*******************************/\n.dimmable:not(body) {\n  position: relative;\n}\n.ui.dimmer {\n  display: none;\n  position: absolute;\n  top: 0em !important;\n  left: 0em !important;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  padding: 1em;\n  background-color: rgba(0, 0, 0, 0.85);\n  opacity: 0;\n  line-height: 1;\n  animation-fill-mode: both;\n  animation-duration: 0.5s;\n  transition: background-color 0.5s linear;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  will-change: opacity;\n  z-index: 1000;\n}\n/* Dimmer Content */\n.ui.dimmer > .content {\n  user-select: text;\n  color: #FFFFFF;\n}\n/* Loose Coupling */\n.ui.segment > .ui.dimmer {\n  border-radius: inherit !important;\n}\n/* Scrollbars */\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(255, 255, 255, 0.15);\n}\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n/*******************************\n            States\n*******************************/\n/* Animating */\n.animating.dimmable:not(body),\n.dimmed.dimmable:not(body) {\n  overflow: hidden;\n}\n/* Animating / Active / Visible */\n.dimmed.dimmable > .ui.animating.dimmer,\n.dimmed.dimmable > .ui.visible.dimmer,\n.ui.active.dimmer {\n  display: flex;\n  opacity: 1;\n}\n/* Disabled */\n.ui.disabled.dimmer {\n  width: 0 !important;\n  height: 0 !important;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n    Legacy\n---------------*/\n/* Animating / Active / Visible */\n.dimmed.dimmable > .ui.animating.legacy.dimmer,\n.dimmed.dimmable > .ui.visible.legacy.dimmer,\n.ui.active.legacy.dimmer {\n  display: block;\n}\n/*--------------\n    Alignment\n---------------*/\n.ui[class*=\"top aligned\"].dimmer {\n  justify-content: flex-start;\n}\n.ui[class*=\"bottom aligned\"].dimmer {\n  justify-content: flex-end;\n}\n/*--------------\n      Page\n---------------*/\n.ui.page.dimmer {\n  position: fixed;\n  transform-style: '';\n  perspective: 2000px;\n  transform-origin: center center;\n}\nbody.animating.in.dimmable,\nbody.dimmed.dimmable {\n  overflow: hidden;\n}\nbody.dimmable > .dimmer {\n  position: fixed;\n}\n/*--------------\n    Blurring\n---------------*/\n.blurring.dimmable > :not(.dimmer) {\n  filter: blur(0px) grayscale(0);\n  transition: 800ms filter ease;\n}\n.blurring.dimmed.dimmable > :not(.dimmer) {\n  filter: blur(5px) grayscale(0.7);\n}\n/* Dimmer Color */\n.blurring.dimmable > .dimmer {\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.blurring.dimmable > .inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n/*--------------\n    Aligned\n---------------*/\n.ui.dimmer > .top.aligned.content > * {\n  vertical-align: top;\n}\n.ui.dimmer > .bottom.aligned.content > * {\n  vertical-align: bottom;\n}\n/*--------------\n    Inverted\n---------------*/\n.ui.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n.ui.inverted.dimmer > .content > * {\n  color: #FFFFFF;\n}\n/*--------------\n     Simple\n---------------*/\n/* Displays without javascript */\n.ui.simple.dimmer {\n  display: block;\n  overflow: hidden;\n  opacity: 1;\n  width: 0%;\n  height: 0%;\n  z-index: -100;\n  background-color: rgba(0, 0, 0, 0);\n}\n.dimmed.dimmable > .ui.simple.dimmer {\n  overflow: visible;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.85);\n  z-index: 1;\n}\n.ui.simple.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0);\n}\n.dimmed.dimmable > .ui.simple.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Dropdown\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Dropdown\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Content\n--------------------*/\n/* Icon */\n/* Current Text */\n/* Menu */\n/* Text */\n/* Menu Item */\n/* Sub Menu */\n/* Menu Header */\n/* Menu Divider */\n/* Menu Input */\n/* Menu Image */\n/* Item Sub-Element */\n/* Sub-Menu Dropdown Icon */\n/* Description */\n/* Message */\n/* Floated Content */\n/*-------------------\n        Types\n--------------------*/\n/*------------\n   Selection\n--------------*/\n/* <select> */\n/* Responsive */\n/* Derived */\n/* 1px / em size */\n/* Hover */\n/* Focus */\n/* Visible */\n/* Visible Hover */\n/*--------------\n     Search\n--------------*/\n/* Search Selection */\n/* Inline */\n/*--------------\n    Multiple\n--------------*/\n/* Split Actual Padding Between Child and Parent (allows for label spacing) */\n/* Child Elements */\n/* Dropdown Icon */\n/* Selection Label */\n/*-------------------\n       States\n--------------------*/\n/* Hovered */\n/* Default Text */\n/* Loading */\n/* Active Menu Item */\n/* Selected */\n/* Error */\n/* Clearable */\n/*-------------------\n      Variations\n--------------------*/\n/* Scrolling */\n/* 0px / em size */\n/* Upward */\n/* Flyout Direction */\n/* Left */\n/* Simple */\n/* Floating */\n/* Pointing */\n/* Pointing Upward */\n/* Packaged Theme */\n/*******************************\n            Dropdown\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Content\n--------------------*/\n/* Icon */\n/* Current Text */\n/* Menu */\n/* Text */\n/* Menu Item */\n/* Sub Menu */\n/* Menu Header */\n/* Menu Divider */\n/* Menu Input */\n/* Menu Image */\n/* Item Sub-Element */\n/* Sub-Menu Dropdown Icon */\n/* Description */\n/* Message */\n/* Floated Content */\n/*-------------------\n        Types\n--------------------*/\n/*------------\n   Selection\n--------------*/\n/* <select> */\n/* Responsive */\n/* Derived */\n/* 1px / em size */\n/* Hover */\n/* Focus */\n/* Visible */\n/* Visible Hover */\n/*--------------\n     Search\n--------------*/\n/* Search Selection */\n/* Inline */\n/*--------------\n    Multiple\n--------------*/\n/* Split Actual Padding Between Child and Parent (allows for label spacing) */\n/* Child Elements */\n/* Dropdown Icon */\n/* Selection Label */\n/*-------------------\n       States\n--------------------*/\n/* Hovered */\n/* Default Text */\n/* Loading */\n/* Active Menu Item */\n/* Selected */\n/* Error */\n/* Clearable */\n/*-------------------\n      Variations\n--------------------*/\n/* Scrolling */\n/* 0px / em size */\n/* Upward */\n/* Flyout Direction */\n/* Left */\n/* Simple */\n/* Floating */\n/* Pointing */\n/* Pointing Upward */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Dropdown\n*******************************/\n.ui.dropdown {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  outline: none;\n  text-align: left;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n/*******************************\n            Content\n*******************************/\n/*--------------\n      Menu\n---------------*/\n.ui.dropdown .menu {\n  cursor: auto;\n  position: absolute;\n  display: none;\n  outline: none;\n  top: 100%;\n  min-width: max-content;\n  margin: 0em;\n  padding: 0em 0em;\n  background: #1d1e31;\n  font-size: 1em;\n  text-shadow: none;\n  text-align: left;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n  transition: opacity 0.1s ease;\n  z-index: 11;\n  will-change: transform, opacity;\n}\n.ui.dropdown .menu > * {\n  white-space: nowrap;\n}\n/*--------------\n  Hidden Input\n---------------*/\n.ui.dropdown > input:not(.search):first-child,\n.ui.dropdown > select {\n  display: none !important;\n}\n/*--------------\n Dropdown Icon\n---------------*/\n.ui.dropdown > .dropdown.icon {\n  position: relative;\n  width: auto;\n  font-size: 0.85714286em;\n  margin: 0em 0em 0em 1em;\n}\n.ui.dropdown .menu > .item .dropdown.icon {\n  width: auto;\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n.ui.dropdown .menu > .item .dropdown.icon + .text {\n  margin-right: 1em;\n}\n/*--------------\n      Text\n---------------*/\n.ui.dropdown > .text {\n  display: inline-block;\n  transition: none;\n}\n/*--------------\n    Menu Item\n---------------*/\n.ui.dropdown .menu > .item {\n  position: relative;\n  cursor: pointer;\n  display: block;\n  border: none;\n  height: auto;\n  text-align: left;\n  border-top: none;\n  line-height: 1em;\n  color: rgba(255, 255, 255, 0.87);\n  padding: 0.78571429rem 1.14285714rem !important;\n  font-size: 1rem;\n  text-transform: none;\n  font-weight: normal;\n  box-shadow: none;\n  -webkit-touch-callout: none;\n}\n.ui.dropdown .menu > .item:first-child {\n  border-top-width: 0px;\n}\n/*--------------\n  Floated Content\n---------------*/\n.ui.dropdown > .text > [class*=\"right floated\"],\n.ui.dropdown .menu .item > [class*=\"right floated\"] {\n  float: right !important;\n  margin-right: 0em !important;\n  margin-left: 1em !important;\n}\n.ui.dropdown > .text > [class*=\"left floated\"],\n.ui.dropdown .menu .item > [class*=\"left floated\"] {\n  float: left !important;\n  margin-left: 0em !important;\n  margin-right: 1em !important;\n}\n.ui.dropdown .menu .item > .icon.floated,\n.ui.dropdown .menu .item > .flag.floated,\n.ui.dropdown .menu .item > .image.floated,\n.ui.dropdown .menu .item > img.floated {\n  margin-top: 0em;\n}\n/*--------------\n  Menu Divider\n---------------*/\n.ui.dropdown .menu > .header {\n  margin: 1rem 0rem 0.75rem;\n  padding: 0em 1.14285714rem;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.78571429em;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.ui.dropdown .menu > .divider {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  height: 0em;\n  margin: 0.5em 0em;\n}\n.ui.dropdown.dropdown .menu > .input {\n  width: auto;\n  display: flex;\n  margin: 1.14285714rem 0.78571429rem;\n  min-width: 10rem;\n}\n.ui.dropdown .menu > .header + .input {\n  margin-top: 0em;\n}\n.ui.dropdown .menu > .input:not(.transparent) input {\n  padding: 0.5em 1em;\n}\n.ui.dropdown .menu > .input:not(.transparent) .button,\n.ui.dropdown .menu > .input:not(.transparent) .icon,\n.ui.dropdown .menu > .input:not(.transparent) .label {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n/*-----------------\n  Item Description\n-------------------*/\n.ui.dropdown > .text > .description,\n.ui.dropdown .menu > .item > .description {\n  float: right;\n  margin: 0em 0em 0em 1em;\n  color: rgba(255, 255, 255, 0.4);\n}\n/*-----------------\n       Message\n-------------------*/\n.ui.dropdown .menu > .message {\n  padding: 0.78571429rem 1.14285714rem;\n  font-weight: normal;\n}\n.ui.dropdown .menu > .message:not(.ui) {\n  color: rgba(255, 255, 255, 0.4);\n}\n/*--------------\n    Sub Menu\n---------------*/\n.ui.dropdown .menu .menu {\n  top: 0% !important;\n  left: 100%;\n  right: auto;\n  margin: 0em 0em 0em -0.5em !important;\n  border-radius: 0.28571429rem !important;\n  z-index: 21 !important;\n}\n/* Hide Arrow */\n.ui.dropdown .menu .menu:after {\n  display: none;\n}\n/*--------------\n   Sub Elements\n---------------*/\n/* Icons / Flags / Labels / Image */\n.ui.dropdown > .text > .icon,\n.ui.dropdown > .text > .label,\n.ui.dropdown > .text > .flag,\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image {\n  margin-top: 0em;\n}\n.ui.dropdown .menu > .item > .icon,\n.ui.dropdown .menu > .item > .label,\n.ui.dropdown .menu > .item > .flag,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img {\n  margin-top: 0em;\n}\n.ui.dropdown > .text > .icon,\n.ui.dropdown > .text > .label,\n.ui.dropdown > .text > .flag,\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image,\n.ui.dropdown .menu > .item > .icon,\n.ui.dropdown .menu > .item > .label,\n.ui.dropdown .menu > .item > .flag,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img {\n  margin-left: 0em;\n  float: none;\n  margin-right: 0.78571429rem;\n}\n/*--------------\n     Image\n---------------*/\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img {\n  display: inline-block;\n  vertical-align: top;\n  width: auto;\n  margin-top: -0.5em;\n  margin-bottom: -0.5em;\n  max-height: 2em;\n}\n/*******************************\n            Coupling\n*******************************/\n/*--------------\n      Menu\n---------------*/\n/* Remove Menu Item Divider */\n.ui.dropdown .ui.menu > .item:before,\n.ui.menu .ui.dropdown .menu > .item:before {\n  display: none;\n}\n/* Prevent Menu Item Border */\n.ui.menu .ui.dropdown .menu .active.item {\n  border-left: none;\n}\n/* Automatically float dropdown menu right on last menu item */\n.ui.menu .right.menu .dropdown:last-child > .menu,\n.ui.menu .right.dropdown.item > .menu,\n.ui.buttons > .ui.dropdown:last-child > .menu {\n  left: auto;\n  right: 0em;\n}\n/*--------------\n      Label\n---------------*/\n/* Dropdown Menu */\n.ui.label.dropdown .menu {\n  min-width: 100%;\n}\n/*--------------\n     Button\n---------------*/\n/* No Margin On Icon Button */\n.ui.dropdown.icon.button > .dropdown.icon {\n  margin: 0em;\n}\n.ui.button.dropdown .menu {\n  min-width: 100%;\n}\n/*******************************\n              Types\n*******************************/\n/*--------------\n    Selection\n---------------*/\n/* Displays like a select box */\n.ui.selection.dropdown {\n  cursor: pointer;\n  word-wrap: break-word;\n  line-height: 1em;\n  white-space: normal;\n  outline: 0;\n  transform: rotateZ(0deg);\n  min-width: 14em;\n  min-height: 2.71428571em;\n  background: rgba(255, 255, 255, 0.06);\n  display: inline-block;\n  padding: 0.78571429em 2.1em 0.78571429em 1em;\n  color: #ffffff;\n  box-shadow: none;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 0.28571429rem;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n}\n.ui.selection.dropdown.visible,\n.ui.selection.dropdown.active {\n  z-index: 10;\n}\nselect.ui.dropdown {\n  height: 38px;\n  padding: 0.5em;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  visibility: visible;\n}\n.ui.selection.dropdown > .search.icon,\n.ui.selection.dropdown > .delete.icon,\n.ui.selection.dropdown > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.21428571em;\n  top: 0.78571429em;\n  right: 1em;\n  z-index: 3;\n  margin: -0.78571429em;\n  padding: 0.91666667em;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n/* Compact */\n.ui.compact.selection.dropdown {\n  min-width: 0px;\n}\n/*  Selection Menu */\n.ui.selection.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  border-top-width: 0px !important;\n  width: auto;\n  outline: none;\n  margin: 0px -1px;\n  min-width: calc(100% +  2px );\n  width: calc(100% +  2px );\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n  transition: opacity 0.1s ease;\n}\n.ui.selection.dropdown .menu:after,\n.ui.selection.dropdown .menu:before {\n  display: none;\n}\n/*--------------\n    Message\n---------------*/\n.ui.selection.dropdown .menu > .message {\n  padding: 0.78571429rem 1.14285714rem;\n}\n@media only screen and (max-width: 767px) {\n  .ui.selection.dropdown .menu {\n    max-height: 8.01428571rem;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.selection.dropdown .menu {\n    max-height: 10.68571429rem;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.selection.dropdown .menu {\n    max-height: 16.02857143rem;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.selection.dropdown .menu {\n    max-height: 21.37142857rem;\n  }\n}\n/* Menu Item */\n.ui.selection.dropdown .menu > .item {\n  border-top: 1px solid #FAFAFA;\n  padding: 0.78571429rem 1.14285714rem !important;\n  white-space: normal;\n  word-wrap: normal;\n}\n/* User Item */\n.ui.selection.dropdown .menu > .hidden.addition.item {\n  display: none;\n}\n/* Hover */\n.ui.selection.dropdown:hover {\n  border-color: rgba(255, 255, 255, 0.35);\n  box-shadow: none;\n}\n/* Active */\n.ui.selection.active.dropdown {\n  border-color: #96C8DA;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n}\n.ui.selection.active.dropdown .menu {\n  border-color: #96C8DA;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n}\n/* Focus */\n.ui.selection.dropdown:focus {\n  border-color: #96C8DA;\n  box-shadow: none;\n}\n.ui.selection.dropdown:focus .menu {\n  border-color: #96C8DA;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n}\n/* Visible */\n.ui.selection.visible.dropdown > .text:not(.default) {\n  font-weight: normal;\n  color: rgba(255, 255, 255, 0.8);\n}\n/* Visible Hover */\n.ui.selection.active.dropdown:hover {\n  border-color: #96C8DA;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n}\n.ui.selection.active.dropdown:hover .menu {\n  border-color: #96C8DA;\n  box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 0.15);\n}\n/* Dropdown Icon */\n.ui.active.selection.dropdown > .dropdown.icon,\n.ui.visible.selection.dropdown > .dropdown.icon {\n  opacity: '';\n  z-index: 3;\n}\n/* Connecting Border */\n.ui.active.selection.dropdown {\n  border-bottom-left-radius: 0em !important;\n  border-bottom-right-radius: 0em !important;\n}\n/* Empty Connecting Border */\n.ui.active.empty.selection.dropdown {\n  border-radius: 0.28571429rem !important;\n  box-shadow: none !important;\n}\n.ui.active.empty.selection.dropdown .menu {\n  border: none !important;\n  box-shadow: none !important;\n}\n/*--------------\n   Searchable\n---------------*/\n/* Search Selection */\n.ui.search.dropdown {\n  min-width: '';\n}\n/* Search Dropdown */\n.ui.search.dropdown > input.search {\n  background: none transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  cursor: text;\n  top: 0em;\n  left: 1px;\n  width: 100%;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  padding: inherit;\n}\n/* Text Layering */\n.ui.search.dropdown > input.search {\n  position: absolute;\n  z-index: 2;\n}\n.ui.search.dropdown > .text {\n  cursor: text;\n  position: relative;\n  left: 1px;\n  z-index: 3;\n}\n/* Search Selection */\n.ui.search.selection.dropdown > input.search {\n  line-height: 1.21428571em;\n  padding: 0.67857143em 2.1em 0.67857143em 1em;\n}\n/* Used to size multi select input to character width */\n.ui.search.selection.dropdown > span.sizer {\n  line-height: 1.21428571em;\n  padding: 0.67857143em 2.1em 0.67857143em 1em;\n  display: none;\n  white-space: pre;\n}\n/* Active/Visible Search */\n.ui.search.dropdown.active > input.search,\n.ui.search.dropdown.visible > input.search {\n  cursor: auto;\n}\n.ui.search.dropdown.active > .text,\n.ui.search.dropdown.visible > .text {\n  pointer-events: none;\n}\n/* Filtered Text */\n.ui.active.search.dropdown input.search:focus + .text .icon,\n.ui.active.search.dropdown input.search:focus + .text .flag {\n  opacity: 0.45;\n}\n.ui.active.search.dropdown input.search:focus + .text {\n  color: #8c8c8c !important;\n}\n/* Search Menu */\n.ui.search.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n@media only screen and (max-width: 767px) {\n  .ui.search.dropdown .menu {\n    max-height: 8.01428571rem;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.search.dropdown .menu {\n    max-height: 10.68571429rem;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.search.dropdown .menu {\n    max-height: 16.02857143rem;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.search.dropdown .menu {\n    max-height: 21.37142857rem;\n  }\n}\n/*--------------\n    Multiple\n---------------*/\n/* Multiple Selection */\n.ui.multiple.dropdown {\n  padding: 0.22619048em 2.1em 0.22619048em 0.35714286em;\n}\n.ui.multiple.dropdown .menu {\n  cursor: auto;\n}\n/* Multiple Search Selection */\n.ui.multiple.search.dropdown,\n.ui.multiple.search.dropdown > input.search {\n  cursor: text;\n}\n/* Selection Label */\n.ui.multiple.dropdown > .label {\n  user-select: none;\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n  font-size: 1em;\n  padding: 0.35714286em 0.78571429em;\n  margin: 0.14285714rem 0.28571429rem 0.14285714rem 0em;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset;\n}\n/* Dropdown Icon */\n.ui.multiple.dropdown .dropdown.icon {\n  margin: '';\n  padding: '';\n}\n/* Text */\n.ui.multiple.dropdown > .text {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  line-height: 1.21428571em;\n}\n.ui.multiple.dropdown > .label ~ input.search {\n  margin-left: 0.14285714em !important;\n}\n.ui.multiple.dropdown > .label ~ .text {\n  display: none;\n}\n/*-----------------\n  Multiple Search\n-----------------*/\n/* Prompt Text */\n.ui.multiple.search.dropdown > .text {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: inherit;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  line-height: 1.21428571em;\n}\n.ui.multiple.search.dropdown > .label ~ .text {\n  display: none;\n}\n/* Search */\n.ui.multiple.search.dropdown > input.search {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  width: 2.2em;\n  line-height: 1.21428571em;\n}\n/*--------------\n     Inline\n---------------*/\n.ui.inline.dropdown {\n  cursor: pointer;\n  display: inline-block;\n  color: inherit;\n}\n.ui.inline.dropdown .dropdown.icon {\n  margin: 0em 0.21428571em 0em 0.21428571em;\n  vertical-align: baseline;\n}\n.ui.inline.dropdown > .text {\n  font-weight: bold;\n}\n.ui.inline.dropdown .menu {\n  cursor: auto;\n  margin-top: 0.21428571em;\n  border-radius: 0.28571429rem;\n}\n/*******************************\n            States\n*******************************/\n/*--------------------\n        Active\n----------------------*/\n/* Menu Item Active */\n.ui.dropdown .menu .active.item {\n  background: transparent;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.95);\n  box-shadow: none;\n  z-index: 12;\n}\n/*--------------------\n        Hover\n----------------------*/\n/* Menu Item Hover */\n.ui.dropdown .menu > .item:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(255, 255, 255, 0.95);\n  z-index: 13;\n}\n/*--------------------\n       Loading\n---------------------*/\n.ui.loading.dropdown > i.icon {\n  height: 1em !important;\n}\n.ui.loading.selection.dropdown > i.icon {\n  padding: 1.5em 1.28571429em !important;\n}\n.ui.loading.dropdown > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n.ui.loading.dropdown > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  box-shadow: 0px 0px 0px 1px transparent;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  animation: dropdown-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n}\n/* Coupling */\n.ui.loading.dropdown.button > i.icon:before,\n.ui.loading.dropdown.button > i.icon:after {\n  display: none;\n}\n@keyframes dropdown-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/*--------------------\n     Default Text\n----------------------*/\n.ui.dropdown:not(.button) > .default.text,\n.ui.default.dropdown:not(.button) > .text {\n  color: #404040;\n}\n.ui.dropdown:not(.button) > input:focus ~ .default.text,\n.ui.default.dropdown:not(.button) > input:focus ~ .text {\n  color: #8c8c8c;\n}\n/*--------------------\n        Loading\n----------------------*/\n.ui.loading.dropdown > .text {\n  transition: none;\n}\n/* Used To Check Position */\n.ui.dropdown .loading.menu {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n.ui.dropdown > .loading.menu {\n  left: 0px !important;\n  right: auto !important;\n}\n.ui.dropdown > .menu .loading.menu {\n  left: 100% !important;\n  right: auto !important;\n}\n/*--------------------\n    Keyboard Select\n----------------------*/\n/* Selected Item */\n.ui.dropdown.selected,\n.ui.dropdown .menu .selected.item {\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------------\n    Search Filtered\n----------------------*/\n/* Filtered Item */\n.ui.dropdown > .filtered.text {\n  visibility: hidden;\n}\n.ui.dropdown .filtered.item {\n  display: none !important;\n}\n/*--------------------\n        Error\n----------------------*/\n.ui.dropdown.error,\n.ui.dropdown.error > .text,\n.ui.dropdown.error > .default.text {\n  color: #FFFFFF;\n}\n.ui.selection.dropdown.error {\n  background: rgba(200, 3, 3, 0.15);\n  border-color: #E0B4B4;\n}\n.ui.selection.dropdown.error:hover {\n  border-color: #E0B4B4;\n}\n.ui.dropdown.error > .menu,\n.ui.dropdown.error > .menu .menu {\n  border-color: #E0B4B4;\n}\n.ui.dropdown.error > .menu > .item {\n  color: #FFFFFF;\n}\n.ui.multiple.selection.error.dropdown > .label {\n  border-color: #E0B4B4;\n}\n/* Item Hover */\n.ui.dropdown.error > .menu > .item:hover {\n  background-color: #FFF2F2;\n}\n/* Item Active */\n.ui.dropdown.error > .menu .active.item {\n  background-color: #FDCFCF;\n}\n/*--------------------\n        Clear\n----------------------*/\n.ui.dropdown > .clear.dropdown.icon {\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n.ui.dropdown > .clear.dropdown.icon:hover {\n  opacity: 1;\n}\n/*--------------------\n        Disabled\n----------------------*/\n/* Disabled */\n.ui.disabled.dropdown,\n.ui.dropdown .menu > .disabled.item {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.45;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n    Direction\n---------------*/\n/* Flyout Direction */\n.ui.dropdown .menu {\n  left: 0px;\n}\n/* Default Side (Right) */\n.ui.dropdown .right.menu > .menu,\n.ui.dropdown .menu .right.menu {\n  left: 100% !important;\n  right: auto !important;\n  border-radius: 0.28571429rem !important;\n}\n/* Leftward Opening Menu */\n.ui.dropdown > .left.menu {\n  left: auto !important;\n  right: 0px !important;\n}\n.ui.dropdown > .left.menu .menu,\n.ui.dropdown .menu .left.menu {\n  left: auto;\n  right: 100%;\n  margin: 0em -0.5em 0em 0em !important;\n  border-radius: 0.28571429rem !important;\n}\n.ui.dropdown .item .left.dropdown.icon,\n.ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: left;\n  margin: 0em 0em 0em 0em;\n}\n.ui.dropdown .item .left.dropdown.icon,\n.ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: left;\n  margin: 0em 0em 0em 0em;\n}\n.ui.dropdown .item .left.dropdown.icon + .text,\n.ui.dropdown .left.menu .item .dropdown.icon + .text {\n  margin-left: 1em;\n  margin-right: 0em;\n}\n/*--------------\n     Upward\n---------------*/\n/* Upward Main Menu */\n.ui.upward.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n/* Upward Sub Menu */\n.ui.dropdown .upward.menu {\n  top: auto !important;\n  bottom: 0 !important;\n}\n/* Active Upward */\n.ui.simple.upward.active.dropdown,\n.ui.simple.upward.dropdown:hover {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em !important;\n}\n.ui.upward.dropdown.button:not(.pointing):not(.floating).active {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n/* Selection */\n.ui.upward.selection.dropdown .menu {\n  border-top-width: 1px !important;\n  border-bottom-width: 0px !important;\n  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);\n}\n.ui.upward.selection.dropdown:hover {\n  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.05);\n}\n/* Active Upward */\n.ui.active.upward.selection.dropdown {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;\n}\n/* Visible Upward */\n.ui.upward.selection.dropdown.visible {\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem !important;\n}\n/* Visible Hover Upward */\n.ui.upward.active.selection.dropdown:hover {\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.05);\n}\n.ui.upward.active.selection.dropdown:hover .menu {\n  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);\n}\n/*--------------\n     Simple\n---------------*/\n/*  Selection Menu */\n.ui.scrolling.dropdown .menu,\n.ui.dropdown .scrolling.menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.ui.scrolling.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  min-width: 100% !important;\n  width: auto !important;\n}\n.ui.dropdown .scrolling.menu {\n  position: static;\n  overflow-y: auto;\n  border: none;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  min-width: 100% !important;\n  width: auto !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.scrolling.dropdown .menu .item.item.item,\n.ui.dropdown .scrolling.menu > .item.item.item {\n  border-top: none;\n}\n.ui.scrolling.dropdown .menu .item:first-child,\n.ui.dropdown .scrolling.menu .item:first-child {\n  border-top: none;\n}\n.ui.dropdown > .animating.menu .scrolling.menu,\n.ui.dropdown > .visible.menu .scrolling.menu {\n  display: block;\n}\n/* Scrollbar in IE */\n@media all and (-ms-high-contrast: none) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    min-width: calc(100% - 17px);\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: 10.28571429rem;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: 15.42857143rem;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: 20.57142857rem;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: 20.57142857rem;\n  }\n}\n/*--------------\n     Simple\n---------------*/\n/* Displays without javascript */\n.ui.simple.dropdown .menu:before,\n.ui.simple.dropdown .menu:after {\n  display: none;\n}\n.ui.simple.dropdown .menu {\n  position: absolute;\n  display: block;\n  overflow: hidden;\n  top: -9999px !important;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  transition: opacity 0.1s ease;\n}\n.ui.simple.active.dropdown,\n.ui.simple.dropdown:hover {\n  border-bottom-left-radius: 0em !important;\n  border-bottom-right-radius: 0em !important;\n}\n.ui.simple.active.dropdown > .menu,\n.ui.simple.dropdown:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 100% !important;\n  opacity: 1;\n}\n.ui.simple.dropdown > .menu > .item:active > .menu,\n.ui.simple.dropdown:hover > .menu > .item:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 0% !important;\n  left: 100% !important;\n  opacity: 1;\n}\n.ui.simple.disabled.dropdown:hover .menu {\n  display: none;\n  height: 0px;\n  width: 0px;\n  overflow: hidden;\n}\n/* Visible */\n.ui.simple.visible.dropdown > .menu {\n  display: block;\n}\n/*--------------\n      Fluid\n---------------*/\n.ui.fluid.dropdown {\n  display: block;\n  width: 100%;\n  min-width: 0em;\n}\n.ui.fluid.dropdown > .dropdown.icon {\n  float: right;\n}\n/*--------------\n    Floating\n---------------*/\n.ui.floating.dropdown .menu {\n  left: 0;\n  right: auto;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15) !important;\n  border-radius: 0.28571429rem !important;\n}\n.ui.floating.dropdown > .menu {\n  margin-top: 0.5em !important;\n  border-radius: 0.28571429rem !important;\n}\n/*--------------\n     Pointing\n---------------*/\n.ui.pointing.dropdown > .menu {\n  top: 100%;\n  margin-top: 0.78571429rem;\n  border-radius: 0.28571429rem;\n}\n.ui.pointing.dropdown > .menu:after {\n  display: block;\n  position: absolute;\n  pointer-events: none;\n  content: '';\n  visibility: visible;\n  transform: rotate(45deg);\n  width: 0.5em;\n  height: 0.5em;\n  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);\n  background: #FFFFFF;\n  z-index: 2;\n}\n.ui.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: 50%;\n  margin: 0em 0em 0em -0.25em;\n}\n/* Top Left Pointing */\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: 1em 0em 0em;\n}\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: 1em 0em 0em;\n}\n.ui.top.left.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: 1em;\n  right: auto;\n  margin: 0em;\n  transform: rotate(45deg);\n}\n/* Top Right Pointing */\n.ui.top.right.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  right: 0%;\n  left: auto;\n  margin: 1em 0em 0em;\n}\n.ui.top.pointing.dropdown > .left.menu:after,\n.ui.top.right.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: auto !important;\n  right: 1em !important;\n  margin: 0em;\n  transform: rotate(45deg);\n}\n/* Left Pointing */\n.ui.left.pointing.dropdown > .menu {\n  top: 0%;\n  left: 100%;\n  right: auto;\n  margin: 0em 0em 0em 1em;\n}\n.ui.left.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: -0.25em;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(-45deg);\n}\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {\n  left: auto !important;\n  right: 100% !important;\n  margin: 0em 1em 0em 0em;\n}\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {\n  top: 1em;\n  left: auto;\n  right: -0.25em;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(135deg);\n}\n/* Right Pointing */\n.ui.right.pointing.dropdown > .menu {\n  top: 0%;\n  left: auto;\n  right: 100%;\n  margin: 0em 1em 0em 0em;\n}\n.ui.right.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: auto;\n  right: -0.25em;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(135deg);\n}\n/* Bottom Pointing */\n.ui.bottom.pointing.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  left: 0%;\n  right: auto;\n  margin: 0em 0em 1em;\n}\n.ui.bottom.pointing.dropdown > .menu:after {\n  top: auto;\n  bottom: -0.25em;\n  right: auto;\n  margin: 0em;\n  transform: rotate(-135deg);\n}\n/* Reverse Sub-Menu Direction */\n.ui.bottom.pointing.dropdown > .menu .menu {\n  top: auto !important;\n  bottom: 0px !important;\n}\n/* Bottom Left */\n.ui.bottom.left.pointing.dropdown > .menu {\n  left: 0%;\n  right: auto;\n}\n.ui.bottom.left.pointing.dropdown > .menu:after {\n  left: 1em;\n  right: auto;\n}\n/* Bottom Right */\n.ui.bottom.right.pointing.dropdown > .menu {\n  right: 0%;\n  left: auto;\n}\n.ui.bottom.right.pointing.dropdown > .menu:after {\n  left: auto;\n  right: 1em;\n}\n/* Upward pointing */\n.ui.pointing.upward.dropdown .menu,\n.ui.top.pointing.upward.dropdown .menu {\n  top: auto !important;\n  bottom: 100% !important;\n  margin: 0em 0em 0.78571429rem;\n  border-radius: 0.28571429rem;\n}\n.ui.pointing.upward.dropdown .menu:after,\n.ui.top.pointing.upward.dropdown .menu:after {\n  top: 100% !important;\n  bottom: auto !important;\n  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.15);\n  margin: -0.25em 0em 0em;\n}\n/* Right Pointing Upward */\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 1em 0em 0em;\n}\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 1em 0em;\n  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);\n}\n/* Left Pointing Upward */\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 0em 1em;\n}\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 1em 0em;\n  box-shadow: -1px -1px 0px 0px rgba(255, 255, 255, 0.15);\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/* Dropdown Carets */\n@font-face {\n  font-family: 'Dropdown';\n  src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAVgAA8AAAAACFAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABWAAAABwAAAAchGgaq0dERUYAAAF0AAAAHAAAAB4AJwAPT1MvMgAAAZAAAABDAAAAVnW4TJdjbWFwAAAB1AAAAEsAAAFS8CcaqmN2dCAAAAIgAAAABAAAAAQAEQFEZ2FzcAAAAiQAAAAIAAAACP//AANnbHlmAAACLAAAAQoAAAGkrRHP9WhlYWQAAAM4AAAAMAAAADYPK8YyaGhlYQAAA2gAAAAdAAAAJANCAb1obXR4AAADiAAAACIAAAAiCBkAOGxvY2EAAAOsAAAAFAAAABQBnAIybWF4cAAAA8AAAAAfAAAAIAEVAF5uYW1lAAAD4AAAATAAAAKMFGlj5HBvc3QAAAUQAAAARgAAAHJoedjqd2ViZgAABVgAAAAGAAAABrO7W5UAAAABAAAAANXulPUAAAAA1r4hgAAAAADXu2Q1eNpjYGRgYOABYjEgZmJgBEIOIGYB8xgAA/YAN3jaY2BktGOcwMDKwMI4jTGNgYHBHUp/ZZBkaGFgYGJgZWbACgLSXFMYHFT/fLjFeOD/AQY9xjMMbkBhRpAcAN48DQYAeNpjYGBgZoBgGQZGBhDwAfIYwXwWBgMgzQGETAwMqn8+8H649f8/lHX9//9b7Pzf+fWgusCAkY0BzmUE6gHpQwGMDMMeAACbxg7SAAARAUQAAAAB//8AAnjadZBPSsNAGMXfS+yMqYgOhpSuSlKadmUhiVEhEMQzFF22m17BbbvzCh5BXCUn6EG8gjeQ4DepwYo4i+/ffL95j4EDA+CFC7jQuKyIeVHrI3wkleq9F7XrSInKteOeHdda8bOoaeepSc00NWPz/LRec9G8GabyGtEdF7h19z033GAMTK7zbM42xNEZpzYof0RtQ5CUHAQJ73OtVyutc+3b7Ou//b8XNlsPx3jgjUifABdhEohKJJL5iM5p39uqc7X1+sRQSqmGrUVhlsJ4lpmEUVwyT8SUYtg0P9DyNzPADDs+tjrGV6KRCRfsui3eHcL4/p8ZXvfMlcnEU+CLv7hDykOP+AKTPTxbAAB42mNgZGBgAGKuf5KP4vltvjLIMzGAwLV9ig0g+vruFFMQzdjACOJzMIClARh0CTJ42mNgZGBgPPD/AJD8wgAEjA0MjAyogAMAbOQEAQAAAAC7ABEAAAAAAKoAAAH0AAABgAAAAUAACAFAAAgAwAAXAAAAAAAAACoAKgAqADIAbACGAKAAugDSeNpjYGRgYOBkUGFgYgABEMkFhAwM/xn0QAIADdUBdAB42qWQvUoDQRSFv3GjaISUQaymSmGxJoGAsRC0iPYLsU50Y6IxrvlRtPCJJKUPIBb+PIHv4EN4djKuKAqCDHfmu+feOdwZoMCUAJNbAlYUMzaUlM14jjxbngOq7HnOia89z1Pk1vMCa9x7ztPkzfMyJbPj+ZGi6Xp+omxuPD+zaD7meaFg7mb8GrBqHmhwxoAxlm0uiRkpP9X5m26pKRoMxTGR1D49Dv/Yb/91o6l8qL6eu5n2hZQzn68utR9m3FU2cB4t9cdSLG2utI+44Eh/P9bqKO+oJ/WxmXssj77YkrjasZQD6SFddythk3Wtzrf+UF2p076Udla1VNzsERP3kkjVRKel7mp1udXYcHtZSlV7RfmJe1GiFWveluaeKD5/MuJcSk8Tpm/vvwPIbmJleNpjYGKAAFYG7ICTgYGRiZGZkYWRlZGNkZ2Rg5GTLT2nsiDDEEIZsZfmZRqZujmDaDcDAxcI7WIOpS2gtCWUdgQAZkcSmQAAAAFblbO6AAA=) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n.ui.dropdown > .dropdown.icon {\n  font-family: 'Dropdown';\n  line-height: 1;\n  height: 1em;\n  width: 1.23em;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n.ui.dropdown > .dropdown.icon {\n  width: auto;\n}\n.ui.dropdown > .dropdown.icon:before {\n  content: '\\f0d7';\n}\n/* Sub Menu */\n.ui.dropdown .menu .item .dropdown.icon:before {\n  content: '\\f0da' /*rtl:'\\f0d9'*/;\n}\n.ui.dropdown .item .left.dropdown.icon:before,\n.ui.dropdown .left.menu .item .dropdown.icon:before {\n  content: \"\\f0d9\" /*rtl:\"\\f0da\"*/;\n}\n/* Vertical Menu Dropdown */\n.ui.vertical.menu .dropdown.item > .dropdown.icon:before {\n  content: \"\\f0da\" /*rtl:\"\\f0d9\"*/;\n}\n.ui.dropdown > .clear.icon:before {\n  content: \"\\f00d\";\n}\n/* Icons for Reference (Subsetted in 2.4.0)\n  .dropdown.down:before { content: \"\\f0d7\"; }\n  .dropdown.up:before { content: \"\\f0d8\"; }\n  .dropdown.left:before { content: \"\\f0d9\"; }\n  .dropdown.right:before { content: \"\\f0da\"; }\n  .dropdown.close:before { content: \"\\f00d\"; }\n*/\n/*!\n * # Semantic UI - Video\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Video\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Simple */\n/* Placeholder */\n/* Placeholder Overlayed Background */\n/* Icon */\n/*-------------------\n       States\n--------------------*/\n/* Hover */\n/*-------------------\n      Variations\n--------------------*/\n/* Aspect Ratios */\n/* Packaged Theme */\n/*******************************\n             Video\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Simple */\n/* Placeholder */\n/* Placeholder Overlayed Background */\n/* Icon */\n/*-------------------\n       States\n--------------------*/\n/* Hover */\n/*-------------------\n      Variations\n--------------------*/\n/* Aspect Ratios */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Types\n*******************************/\n.ui.embed {\n  position: relative;\n  max-width: 100%;\n  height: 0px;\n  overflow: hidden;\n  background: #DCDDDE;\n  padding-bottom: 56.25%;\n}\n/*-----------------\n  Embedded Content\n------------------*/\n.ui.embed iframe,\n.ui.embed embed,\n.ui.embed object {\n  position: absolute;\n  border: none;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  margin: 0em;\n  padding: 0em;\n}\n/*-----------------\n      Embed\n------------------*/\n.ui.embed > .embed {\n  display: none;\n}\n/*--------------\n   Placeholder\n---------------*/\n.ui.embed > .placeholder {\n  position: absolute;\n  cursor: pointer;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n}\n/*--------------\n      Icon\n---------------*/\n.ui.embed > .icon {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.ui.embed > .icon:after {\n  position: absolute;\n  top: 0%;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  content: '';\n  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n  opacity: 0.5;\n  transition: opacity 0.5s ease;\n}\n.ui.embed > .icon:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 4;\n  transform: translateX(-50%) translateY(-50%);\n  color: #FFFFFF;\n  font-size: 6rem;\n  text-shadow: 0px 2px 10px rgba(34, 36, 38, 0.2);\n  transition: opacity 0.5s ease, color 0.5s ease;\n  z-index: 10;\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n     Hover\n---------------*/\n.ui.embed .icon:hover:after {\n  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n  opacity: 1;\n}\n.ui.embed .icon:hover:before {\n  color: #FFFFFF;\n}\n/*--------------\n     Active\n---------------*/\n.ui.active.embed > .icon,\n.ui.active.embed > .placeholder {\n  display: none;\n}\n.ui.active.embed > .embed {\n  display: block;\n}\n/*******************************\n        Video Overrides\n*******************************/\n/*******************************\n          Variations\n*******************************/\n.ui.square.embed {\n  padding-bottom: 100%;\n}\n.ui[class*=\"4:3\"].embed {\n  padding-bottom: 75%;\n}\n.ui[class*=\"16:9\"].embed {\n  padding-bottom: 56.25%;\n}\n.ui[class*=\"21:9\"].embed {\n  padding-bottom: 42.85714286%;\n}\n/*!\n * # Semantic UI - Modal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Modal\n*******************************/\n/* Close Icon */\n/* Header */\n/* Content */\n/* Image / Description */\n/* Modal Actions */\n/* Inner Close Position (Tablet/Mobile) */\n/* Mobile Positions */\n/* Responsive Widths */\n/* Coupling */\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Basic */\n/* Top Aligned */\n/* Scrolling Margin */\n/* Scrolling Content */\n/*-------------------\n      Variations\n--------------------*/\n/* Size Widths */\n/* Derived Responsive Sizes */\n/* Packaged Theme */\n/*******************************\n             Modal\n*******************************/\n/* Close Icon */\n/* Header */\n/* Content */\n/* Image / Description */\n/* Modal Actions */\n/* Inner Close Position (Tablet/Mobile) */\n/* Mobile Positions */\n/* Responsive Widths */\n/* Coupling */\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n        Types\n--------------------*/\n/* Basic */\n/* Top Aligned */\n/* Scrolling Margin */\n/* Scrolling Content */\n/*-------------------\n      Variations\n--------------------*/\n/* Size Widths */\n/* Derived Responsive Sizes */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Modal\n*******************************/\n.ui.modal {\n  position: absolute;\n  display: none;\n  z-index: 1001;\n  text-align: left;\n  background: #1e1f33;\n  border: none;\n  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2);\n  transform-origin: 50% 25%;\n  flex: 0 0 auto;\n  border-radius: 0.28571429rem;\n  user-select: text;\n  will-change: top, left, margin, transform, opacity;\n}\n.ui.modal > :first-child:not(.icon),\n.ui.modal > .icon:first-child + * {\n  border-top-left-radius: 0.28571429rem;\n  border-top-right-radius: 0.28571429rem;\n}\n.ui.modal > :last-child {\n  border-bottom-left-radius: 0.28571429rem;\n  border-bottom-right-radius: 0.28571429rem;\n}\n/*******************************\n            Content\n*******************************/\n/*--------------\n     Close\n---------------*/\n.ui.modal > .close {\n  cursor: pointer;\n  position: absolute;\n  top: -2.5rem;\n  right: -2.5rem;\n  z-index: 1;\n  opacity: 0.8;\n  font-size: 1.25em;\n  color: #FFFFFF;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 0.625rem 0rem 0rem 0rem;\n}\n.ui.modal > .close:hover {\n  opacity: 1;\n}\n/*--------------\n     Header\n---------------*/\n.ui.modal > .header {\n  display: block;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  background: #1e1f33;\n  margin: 0em;\n  padding: 1.25rem 1.5rem;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.85);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.ui.modal > .header:not(.ui) {\n  font-size: 1.42857143rem;\n  line-height: 1.28571429em;\n  font-weight: bold;\n}\n/*--------------\n     Content\n---------------*/\n.ui.modal > .content {\n  display: block;\n  width: 100%;\n  font-size: 1em;\n  line-height: 1.4;\n  padding: 1.5rem;\n  background: #1e1f33;\n}\n.ui.modal > .image.content {\n  display: flex;\n  flex-direction: row;\n}\n/* Image */\n.ui.modal > .content > .image {\n  display: block;\n  flex: 0 1 auto;\n  width: '';\n  align-self: top;\n}\n.ui.modal > [class*=\"top aligned\"] {\n  align-self: top;\n}\n.ui.modal > [class*=\"middle aligned\"] {\n  align-self: middle;\n}\n.ui.modal > [class*=\"stretched\"] {\n  align-self: stretch;\n}\n/* Description */\n.ui.modal > .content > .description {\n  display: block;\n  flex: 1 0 auto;\n  min-width: 0px;\n  align-self: top;\n}\n.ui.modal > .content > .icon + .description,\n.ui.modal > .content > .image + .description {\n  flex: 0 1 auto;\n  min-width: '';\n  width: auto;\n  padding-left: 2em;\n}\n/*rtl:ignore*/\n.ui.modal > .content > .image > i.icon {\n  margin: 0em;\n  opacity: 1;\n  width: auto;\n  line-height: 1;\n  font-size: 8rem;\n}\n/*--------------\n     Actions\n---------------*/\n.ui.modal > .actions {\n  background: #1e1f33;\n  padding: 1rem 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  text-align: right;\n}\n.ui.modal .actions > .button {\n  margin-left: 0.75em;\n}\n/*-------------------\n       Responsive\n--------------------*/\n/* Modal Width */\n@media only screen and (max-width: 767px) {\n  .ui.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.modal {\n    width: 88%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.modal {\n    width: 850px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ui.modal {\n    width: 900px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.modal {\n    width: 950px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n/* Tablet and Mobile */\n@media only screen and (max-width: 991px) {\n  .ui.modal > .header {\n    padding-right: 2.25rem;\n  }\n  .ui.modal > .close {\n    top: 1.0535rem;\n    right: 1rem;\n    color: rgba(255, 255, 255, 0.87);\n  }\n}\n/* Mobile */\n@media only screen and (max-width: 767px) {\n  .ui.modal > .header {\n    padding: 0.75rem 1rem !important;\n    padding-right: 2.25rem !important;\n  }\n  .ui.modal > .content {\n    display: block;\n    padding: 1rem !important;\n  }\n  .ui.modal > .close {\n    top: 0.5rem !important;\n    right: 0.5rem !important;\n  }\n  /*rtl:ignore*/\n  .ui.modal .image.content {\n    flex-direction: column;\n  }\n  .ui.modal .content > .image {\n    display: block;\n    max-width: 100%;\n    margin: 0em auto !important;\n    text-align: center;\n    padding: 0rem 0rem 1rem !important;\n  }\n  .ui.modal > .content > .image > i.icon {\n    font-size: 5rem;\n    text-align: center;\n  }\n  /*rtl:ignore*/\n  .ui.modal .content > .description {\n    display: block;\n    width: 100% !important;\n    margin: 0em !important;\n    padding: 1rem 0rem !important;\n    box-shadow: none;\n  }\n  /* Let Buttons Stack */\n  .ui.modal > .actions {\n    padding: 1rem 1rem 0rem !important;\n  }\n  .ui.modal .actions > .buttons,\n  .ui.modal .actions > .button {\n    margin-bottom: 1rem;\n  }\n}\n/*--------------\n    Coupling\n---------------*/\n.ui.inverted.dimmer > .ui.modal {\n  box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2);\n}\n/*******************************\n             Types\n*******************************/\n.ui.basic.modal {\n  background-color: transparent;\n  border: none;\n  border-radius: 0em;\n  box-shadow: none !important;\n  color: #1e1f33;\n}\n.ui.basic.modal > .header,\n.ui.basic.modal > .content,\n.ui.basic.modal > .actions {\n  background-color: transparent;\n}\n.ui.basic.modal > .header {\n  color: #1e1f33;\n}\n.ui.basic.modal > .close {\n  top: 1rem;\n  right: 1.5rem;\n}\n.ui.inverted.dimmer > .basic.modal {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.inverted.dimmer > .ui.basic.modal > .header {\n  color: rgba(255, 255, 255, 0.85);\n}\n/* Resort to margin positioning if legacy */\n.ui.legacy.modal,\n.ui.legacy.page.dimmer > .ui.modal {\n  top: 50%;\n  left: 50%;\n}\n.ui.legacy.page.dimmer > .ui.scrolling.modal,\n.ui.page.dimmer > .ui.scrolling.legacy.modal,\n.ui.top.aligned.legacy.page.dimmer > .ui.modal,\n.ui.top.aligned.dimmer > .ui.legacy.modal {\n  top: auto;\n}\n/* Tablet and Mobile */\n@media only screen and (max-width: 991px) {\n  .ui.basic.modal > .close {\n    color: #FFFFFF;\n  }\n}\n/*******************************\n             States\n*******************************/\n.ui.loading.modal {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n.ui.active.modal {\n  display: block;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n   Top Aligned\n---------------*/\n/* Top Aligned Modal */\n.modals.dimmer[class*=\"top aligned\"] .modal {\n  margin: 5vh auto;\n}\n@media only screen and (max-width: 767px) {\n  .modals.dimmer[class*=\"top aligned\"] .modal {\n    margin: 1rem auto;\n  }\n}\n/* Legacy Top Aligned */\n.legacy.modals.dimmer[class*=\"top aligned\"] {\n  padding-top: 5vh;\n}\n@media only screen and (max-width: 767px) {\n  .legacy.modals.dimmer[class*=\"top aligned\"] {\n    padding-top: 1rem;\n  }\n}\n/*--------------\n    Scrolling\n---------------*/\n/* Scrolling Dimmer */\n.scrolling.dimmable.dimmed {\n  overflow: hidden;\n}\n.scrolling.dimmable > .dimmer {\n  justify-content: flex-start;\n}\n.scrolling.dimmable.dimmed > .dimmer {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling.dimmable > .dimmer {\n  position: fixed;\n}\n.modals.dimmer .ui.scrolling.modal {\n  margin: 1rem auto;\n}\n/* Undetached Scrolling */\n.scrolling.undetached.dimmable.dimmed {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling.undetached.dimmable.dimmed > .dimmer {\n  overflow: hidden;\n}\n.scrolling.undetached.dimmable .ui.scrolling.modal {\n  position: absolute;\n  left: 50%;\n  margin-top: 1rem !important;\n}\n/* Scrolling Content */\n.ui.modal .scrolling.content {\n  max-height: calc(80vh - 10em);\n  overflow: auto;\n}\n/*--------------\n   Full Screen\n---------------*/\n.ui.fullscreen.modal {\n  width: 95% !important;\n  margin: 1em auto;\n}\n.ui.fullscreen.modal > .header {\n  padding-right: 2.25rem;\n}\n.ui.fullscreen.modal > .close {\n  top: 1.0535rem;\n  right: 1rem;\n  color: rgba(255, 255, 255, 0.87);\n}\n/*--------------\n      Size\n---------------*/\n.ui.modal {\n  font-size: 1rem;\n}\n/* Mini */\n.ui.mini.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n/* Mini Modal Width */\n@media only screen and (max-width: 767px) {\n  .ui.mini.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.mini.modal {\n    width: 35.2%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.mini.modal {\n    width: 340px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ui.mini.modal {\n    width: 360px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.mini.modal {\n    width: 380px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n/* mini */\n.ui.small.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n/* Tiny Modal Width */\n@media only screen and (max-width: 767px) {\n  .ui.tiny.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.tiny.modal {\n    width: 52.8%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.tiny.modal {\n    width: 510px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ui.tiny.modal {\n    width: 540px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.tiny.modal {\n    width: 570px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n/* Small */\n.ui.small.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n/* Small Modal Width */\n@media only screen and (max-width: 767px) {\n  .ui.small.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.small.modal {\n    width: 70.4%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.small.modal {\n    width: 680px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ui.small.modal {\n    width: 720px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.small.modal {\n    width: 760px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n/* Large Modal Width */\n.ui.large.modal > .header {\n  font-size: 1.6em;\n}\n@media only screen and (max-width: 767px) {\n  .ui.large.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.large.modal {\n    width: 88%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .ui.large.modal {\n    width: 1020px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ui.large.modal {\n    width: 1080px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .ui.large.modal {\n    width: 1140px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Nag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Nag\n*******************************/\n/*--------------\n   Collection\n---------------*/\n/*--------------\n    Elements\n---------------*/\n/* Title */\n/*--------------\n      States\n---------------*/\n/* Hover */\n/*--------------\n   Variations\n---------------*/\n/* Top / Bottom */\n/* Inverted */\n/*--------------\n      Plural\n---------------*/\n/* Packaged Theme */\n/*******************************\n             Nag\n*******************************/\n/*--------------\n   Collection\n---------------*/\n/*--------------\n    Elements\n---------------*/\n/* Title */\n/*--------------\n      States\n---------------*/\n/* Hover */\n/*--------------\n   Variations\n---------------*/\n/* Top / Bottom */\n/* Inverted */\n/*--------------\n      Plural\n---------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Nag\n*******************************/\n.ui.nag {\n  display: none;\n  opacity: 0.95;\n  position: relative;\n  top: 0em;\n  left: 0px;\n  z-index: 999;\n  min-height: 0em;\n  width: 100%;\n  margin: 0em;\n  padding: 0.75em 1em;\n  background: #555555;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);\n  font-size: 1rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.87);\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n  transition: 0.2s background ease;\n}\na.ui.nag {\n  cursor: pointer;\n}\n.ui.nag > .title {\n  display: inline-block;\n  margin: 0em 0.5em;\n  color: #FFFFFF;\n}\n.ui.nag > .close.icon {\n  cursor: pointer;\n  opacity: 0.4;\n  position: absolute;\n  top: 50%;\n  right: 1em;\n  font-size: 1em;\n  margin: -0.5em 0em 0em;\n  color: #FFFFFF;\n  transition: opacity 0.2s ease;\n}\n/*******************************\n             States\n*******************************/\n/* Hover */\n.ui.nag:hover {\n  background: #555555;\n  opacity: 1;\n}\n.ui.nag .close:hover {\n  opacity: 1;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n     Static\n---------------*/\n.ui.overlay.nag {\n  position: absolute;\n  display: block;\n}\n/*--------------\n     Fixed\n---------------*/\n.ui.fixed.nag {\n  position: fixed;\n}\n/*--------------\n     Bottom\n---------------*/\n.ui.bottom.nags,\n.ui.bottom.nag {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n  top: auto;\n  bottom: 0em;\n}\n/*--------------\n     White\n---------------*/\n.ui.inverted.nags .nag,\n.ui.inverted.nag {\n  background-color: #F3F4F5;\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.inverted.nags .nag .close,\n.ui.inverted.nags .nag .title,\n.ui.inverted.nag .close,\n.ui.inverted.nag .title {\n  color: rgba(255, 255, 255, 0.4);\n}\n/*******************************\n           Groups\n*******************************/\n.ui.nags .nag {\n  border-radius: 0em !important;\n}\n.ui.nags .nag:last-child {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.bottom.nags .nag:last-child {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Popup\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Popup\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Parts\n--------------------*/\n/* Placement */\n/* Header */\n/* Content Border */\n/* Arrow */\n/* Arrow color by position */\n/*-------------------\n       Types\n--------------------*/\n/* Tooltip */\n/* Inverted */\n/* Arrow */\n/*-------------------\n       Coupling\n--------------------*/\n/* Grid Inside Popup */\n/* (padding * @medium) */\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n       Variations\n--------------------*/\n/* Wide */\n/* Inverted */\n/* Arrow color by position */\n/* Packaged Theme */\n/*******************************\n             Popup\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/*-------------------\n       Parts\n--------------------*/\n/* Placement */\n/* Header */\n/* Content Border */\n/* Arrow */\n/* Arrow color by position */\n/*-------------------\n       Types\n--------------------*/\n/* Tooltip */\n/* Inverted */\n/* Arrow */\n/*-------------------\n       Coupling\n--------------------*/\n/* Grid Inside Popup */\n/* (padding * @medium) */\n/*-------------------\n       States\n--------------------*/\n/*-------------------\n       Variations\n--------------------*/\n/* Wide */\n/* Inverted */\n/* Arrow color by position */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Popup\n*******************************/\n.ui.popup {\n  display: none;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  /* Fixes content being squished when inline (moz only) */\n  min-width: min-content;\n  z-index: 1900;\n  border: 1px solid #D4D4D5;\n  line-height: 1.4285em;\n  max-width: 250px;\n  background: rgba(0, 0, 0, 0.15);\n  padding: 0.833em 1em;\n  font-weight: normal;\n  font-style: normal;\n  color: rgba(255, 255, 255, 0.87);\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n.ui.popup > .header {\n  padding: 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1.14285714em;\n  line-height: 1.2;\n  font-weight: bold;\n}\n.ui.popup > .header + .content {\n  padding-top: 0.5em;\n}\n.ui.popup:before {\n  position: absolute;\n  content: '';\n  width: 0.71428571em;\n  height: 0.71428571em;\n  background: rgba(0, 0, 0, 0.15);\n  transform: rotate(45deg);\n  z-index: 2;\n  box-shadow: 1px 1px 0px 0px #bababc;\n}\n/*******************************\n            Types\n*******************************/\n/*--------------\n    Tooltip\n---------------*/\n/* Content */\n[data-tooltip] {\n  position: relative;\n}\n/* Arrow */\n[data-tooltip]:before {\n  pointer-events: none;\n  position: absolute;\n  content: '';\n  font-size: 1rem;\n  width: 0.71428571em;\n  height: 0.71428571em;\n  background: rgba(0, 0, 0, 0.15);\n  transform: rotate(45deg);\n  z-index: 2;\n  box-shadow: 1px 1px 0px 0px #bababc;\n}\n/* Popup */\n[data-tooltip]:after {\n  pointer-events: none;\n  content: attr(data-tooltip);\n  position: absolute;\n  text-transform: none;\n  text-align: left;\n  white-space: nowrap;\n  font-size: 1rem;\n  border: 1px solid #D4D4D5;\n  line-height: 1.4285em;\n  max-width: none;\n  background: rgba(0, 0, 0, 0.15);\n  padding: 0.833em 1em;\n  font-weight: normal;\n  font-style: normal;\n  color: rgba(255, 255, 255, 0.87);\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n  z-index: 1;\n}\n/* Default Position (Top Center) */\n[data-tooltip]:not([data-position]):before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: rgba(0, 0, 0, 0.15);\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n[data-tooltip]:not([data-position]):after {\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n/* Animation */\n[data-tooltip]:before,\n[data-tooltip]:after {\n  pointer-events: none;\n  visibility: hidden;\n}\n[data-tooltip]:before {\n  opacity: 0;\n  transform: rotate(45deg) scale(0) !important;\n  transform-origin: center top;\n  transition: all 0.1s ease;\n}\n[data-tooltip]:after {\n  opacity: 1;\n  transform-origin: center bottom;\n  transition: all 0.1s ease;\n}\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after {\n  visibility: visible;\n  pointer-events: auto;\n}\n[data-tooltip]:hover:before {\n  transform: rotate(45deg) scale(1) !important;\n  opacity: 1;\n}\n/* Animation Position */\n[data-tooltip]:after,\n[data-tooltip][data-position=\"top center\"]:after,\n[data-tooltip][data-position=\"bottom center\"]:after {\n  transform: translateX(-50%) scale(0) !important;\n}\n[data-tooltip]:hover:after,\n[data-tooltip][data-position=\"bottom center\"]:hover:after {\n  transform: translateX(-50%) scale(1) !important;\n}\n[data-tooltip][data-position=\"left center\"]:after,\n[data-tooltip][data-position=\"right center\"]:after {\n  transform: translateY(-50%) scale(0) !important;\n}\n[data-tooltip][data-position=\"left center\"]:hover:after,\n[data-tooltip][data-position=\"right center\"]:hover:after {\n  transform: translateY(-50%) scale(1) !important;\n}\n[data-tooltip][data-position=\"top left\"]:after,\n[data-tooltip][data-position=\"top right\"]:after,\n[data-tooltip][data-position=\"bottom left\"]:after,\n[data-tooltip][data-position=\"bottom right\"]:after {\n  transform: scale(0) !important;\n}\n[data-tooltip][data-position=\"top left\"]:hover:after,\n[data-tooltip][data-position=\"top right\"]:hover:after,\n[data-tooltip][data-position=\"bottom left\"]:hover:after,\n[data-tooltip][data-position=\"bottom right\"]:hover:after {\n  transform: scale(1) !important;\n}\n/*--------------\n    Inverted\n---------------*/\n/* Arrow */\n[data-tooltip][data-inverted]:before {\n  box-shadow: none !important;\n}\n/* Arrow Position */\n[data-tooltip][data-inverted]:before {\n  background: #1B1C1D;\n}\n/* Popup  */\n[data-tooltip][data-inverted]:after {\n  background: #1B1C1D;\n  color: #FFFFFF;\n  border: none;\n  box-shadow: none;\n}\n[data-tooltip][data-inverted]:after .header {\n  background-color: none;\n  color: #FFFFFF;\n}\n/*--------------\n    Position\n---------------*/\n/* Top Center */\n[data-position=\"top center\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 50%;\n  bottom: 100%;\n  transform: translateX(-50%);\n  margin-bottom: 0.5em;\n}\n[data-position=\"top center\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: rgba(0, 0, 0, 0.15);\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n/* Top Left */\n[data-position=\"top left\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 0;\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n[data-position=\"top left\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 1em;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n/* Top Right */\n[data-position=\"top right\"][data-tooltip]:after {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n[data-position=\"top right\"][data-tooltip]:before {\n  top: auto;\n  left: auto;\n  bottom: 100%;\n  right: 1em;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n/* Bottom Center */\n[data-position=\"bottom center\"][data-tooltip]:after {\n  bottom: auto;\n  right: auto;\n  left: 50%;\n  top: 100%;\n  transform: translateX(-50%);\n  margin-top: 0.5em;\n}\n[data-position=\"bottom center\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: 50%;\n  margin-left: -0.07142857rem;\n  margin-top: 0.14285714rem;\n}\n/* Bottom Left */\n[data-position=\"bottom left\"][data-tooltip]:after {\n  left: 0;\n  top: 100%;\n  margin-top: 0.5em;\n}\n[data-position=\"bottom left\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: 1em;\n  margin-left: -0.07142857rem;\n  margin-top: 0.14285714rem;\n}\n/* Bottom Right */\n[data-position=\"bottom right\"][data-tooltip]:after {\n  right: 0;\n  top: 100%;\n  margin-top: 0.5em;\n}\n[data-position=\"bottom right\"][data-tooltip]:before {\n  bottom: auto;\n  left: auto;\n  top: 100%;\n  right: 1em;\n  margin-left: -0.14285714rem;\n  margin-top: 0.07142857rem;\n}\n/* Left Center */\n[data-position=\"left center\"][data-tooltip]:after {\n  right: 100%;\n  top: 50%;\n  margin-right: 0.5em;\n  transform: translateY(-50%);\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  right: 100%;\n  top: 50%;\n  margin-top: -0.14285714rem;\n  margin-right: -0.07142857rem;\n}\n/* Right Center */\n[data-position=\"right center\"][data-tooltip]:after {\n  left: 100%;\n  top: 50%;\n  margin-left: 0.5em;\n  transform: translateY(-50%);\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  left: 100%;\n  top: 50%;\n  margin-top: -0.07142857rem;\n  margin-left: 0.14285714rem;\n}\n/* Arrow */\n[data-position~=\"bottom\"][data-tooltip]:before {\n  background: rgba(0, 0, 0, 0.15);\n  box-shadow: -1px -1px 0px 0px #bababc;\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  background: rgba(0, 0, 0, 0.15);\n  box-shadow: 1px -1px 0px 0px #bababc;\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  background: rgba(0, 0, 0, 0.15);\n  box-shadow: -1px 1px 0px 0px #bababc;\n}\n[data-position~=\"top\"][data-tooltip]:before {\n  background: rgba(0, 0, 0, 0.15);\n}\n/* Inverted Arrow Color */\n[data-inverted][data-position~=\"bottom\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: -1px -1px 0px 0px #bababc;\n}\n[data-inverted][data-position=\"left center\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: 1px -1px 0px 0px #bababc;\n}\n[data-inverted][data-position=\"right center\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: -1px 1px 0px 0px #bababc;\n}\n[data-inverted][data-position~=\"top\"][data-tooltip]:before {\n  background: #1B1C1D;\n}\n[data-position~=\"bottom\"][data-tooltip]:before {\n  transform-origin: center bottom;\n}\n[data-position~=\"bottom\"][data-tooltip]:after {\n  transform-origin: center top;\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  transform-origin: top center;\n}\n[data-position=\"left center\"][data-tooltip]:after {\n  transform-origin: right center;\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  transform-origin: right center;\n}\n[data-position=\"right center\"][data-tooltip]:after {\n  transform-origin: left center;\n}\n/*--------------\n     Spacing\n---------------*/\n.ui.popup {\n  margin: 0em;\n}\n/* Extending from Top */\n.ui.top.popup {\n  margin: 0em 0em 0.71428571em;\n}\n.ui.top.left.popup {\n  transform-origin: left bottom;\n}\n.ui.top.center.popup {\n  transform-origin: center bottom;\n}\n.ui.top.right.popup {\n  transform-origin: right bottom;\n}\n/* Extending from Vertical Center */\n.ui.left.center.popup {\n  margin: 0em 0.71428571em 0em 0em;\n  transform-origin: right 50%;\n}\n.ui.right.center.popup {\n  margin: 0em 0em 0em 0.71428571em;\n  transform-origin: left 50%;\n}\n/* Extending from Bottom */\n.ui.bottom.popup {\n  margin: 0.71428571em 0em 0em;\n}\n.ui.bottom.left.popup {\n  transform-origin: left top;\n}\n.ui.bottom.center.popup {\n  transform-origin: center top;\n}\n.ui.bottom.right.popup {\n  transform-origin: right top;\n}\n/*--------------\n     Pointer\n---------------*/\n/*--- Below ---*/\n.ui.bottom.center.popup:before {\n  margin-left: -0.30714286em;\n  top: -0.30714286em;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  box-shadow: -1px -1px 0px 0px #bababc;\n}\n.ui.bottom.left.popup {\n  margin-left: 0em;\n}\n/*rtl:rename*/\n.ui.bottom.left.popup:before {\n  top: -0.30714286em;\n  left: 1em;\n  right: auto;\n  bottom: auto;\n  margin-left: 0em;\n  box-shadow: -1px -1px 0px 0px #bababc;\n}\n.ui.bottom.right.popup {\n  margin-right: 0em;\n}\n/*rtl:rename*/\n.ui.bottom.right.popup:before {\n  top: -0.30714286em;\n  right: 1em;\n  bottom: auto;\n  left: auto;\n  margin-left: 0em;\n  box-shadow: -1px -1px 0px 0px #bababc;\n}\n/*--- Above ---*/\n.ui.top.center.popup:before {\n  top: auto;\n  right: auto;\n  bottom: -0.30714286em;\n  left: 50%;\n  margin-left: -0.30714286em;\n}\n.ui.top.left.popup {\n  margin-left: 0em;\n}\n/*rtl:rename*/\n.ui.top.left.popup:before {\n  bottom: -0.30714286em;\n  left: 1em;\n  top: auto;\n  right: auto;\n  margin-left: 0em;\n}\n.ui.top.right.popup {\n  margin-right: 0em;\n}\n/*rtl:rename*/\n.ui.top.right.popup:before {\n  bottom: -0.30714286em;\n  right: 1em;\n  top: auto;\n  left: auto;\n  margin-left: 0em;\n}\n/*--- Left Center ---*/\n/*rtl:rename*/\n.ui.left.center.popup:before {\n  top: 50%;\n  right: -0.30714286em;\n  bottom: auto;\n  left: auto;\n  margin-top: -0.30714286em;\n  box-shadow: 1px -1px 0px 0px #bababc;\n}\n/*--- Right Center  ---*/\n/*rtl:rename*/\n.ui.right.center.popup:before {\n  top: 50%;\n  left: -0.30714286em;\n  bottom: auto;\n  right: auto;\n  margin-top: -0.30714286em;\n  box-shadow: -1px 1px 0px 0px #bababc;\n}\n/* Arrow Color By Location */\n.ui.bottom.popup:before {\n  background: rgba(0, 0, 0, 0.15);\n}\n.ui.right.center.popup:before,\n.ui.left.center.popup:before {\n  background: rgba(0, 0, 0, 0.15);\n}\n.ui.top.popup:before {\n  background: rgba(0, 0, 0, 0.15);\n}\n/* Inverted Arrow Color */\n.ui.inverted.bottom.popup:before {\n  background: #1B1C1D;\n}\n.ui.inverted.right.center.popup:before,\n.ui.inverted.left.center.popup:before {\n  background: #1B1C1D;\n}\n.ui.inverted.top.popup:before {\n  background: #1B1C1D;\n}\n/*******************************\n            Coupling\n*******************************/\n/* Immediate Nested Grid */\n.ui.popup > .ui.grid:not(.padded) {\n  width: calc(100% + 1.75rem);\n  margin: -0.7rem -0.875rem;\n}\n/*******************************\n            States\n*******************************/\n.ui.loading.popup {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n.ui.animating.popup,\n.ui.visible.popup {\n  display: block;\n}\n.ui.visible.popup {\n  transform: translateZ(0px);\n  backface-visibility: hidden;\n}\n/*******************************\n            Variations\n*******************************/\n/*--------------\n     Basic\n---------------*/\n.ui.basic.popup:before {\n  display: none;\n}\n/*--------------\n     Wide\n---------------*/\n.ui.wide.popup {\n  max-width: 350px;\n}\n.ui[class*=\"very wide\"].popup {\n  max-width: 550px;\n}\n@media only screen and (max-width: 767px) {\n  .ui.wide.popup,\n  .ui[class*=\"very wide\"].popup {\n    max-width: 250px;\n  }\n}\n/*--------------\n     Fluid\n---------------*/\n.ui.fluid.popup {\n  width: 100%;\n  max-width: none;\n}\n/*--------------\n     Colors\n---------------*/\n/* Inverted colors  */\n.ui.inverted.popup {\n  background: #1B1C1D;\n  color: #FFFFFF;\n  border: none;\n  box-shadow: none;\n}\n.ui.inverted.popup .header {\n  background-color: none;\n  color: #FFFFFF;\n}\n.ui.inverted.popup:before {\n  background-color: #1B1C1D;\n  box-shadow: none !important;\n}\n/*--------------\n     Flowing\n---------------*/\n.ui.flowing.popup {\n  max-width: none;\n}\n/*--------------\n     Sizes\n---------------*/\n.ui.mini.popup {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.popup {\n  font-size: 0.85714286rem;\n}\n.ui.small.popup {\n  font-size: 0.92857143rem;\n}\n.ui.popup {\n  font-size: 1rem;\n}\n.ui.large.popup {\n  font-size: 1.14285714rem;\n}\n.ui.huge.popup {\n  font-size: 1.42857143rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Progress Bar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Progress\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Bar */\n/* Progress Bar Label */\n/* Label */\n/*-------------------\n        Types\n--------------------*/\n/*-------------------\n        States\n--------------------*/\n/* Active */\n/*-------------------\n      Variations\n--------------------*/\n/* Attached */\n/* Inverted */\n/* Sizing */\n/* Packaged Theme */\n/*******************************\n            Progress\n*******************************/\n/*-------------------\n       Element\n--------------------*/\n/* Bar */\n/* Progress Bar Label */\n/* Label */\n/*-------------------\n        Types\n--------------------*/\n/*-------------------\n        States\n--------------------*/\n/* Active */\n/*-------------------\n      Variations\n--------------------*/\n/* Attached */\n/* Inverted */\n/* Sizing */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Progress\n*******************************/\n.ui.progress {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  border: none;\n  margin: 1em 0em 2.5em;\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 0em;\n  border-radius: 0.28571429rem;\n}\n.ui.progress:first-child {\n  margin: 0em 0em 2.5em;\n}\n.ui.progress:last-child {\n  margin: 0em 0em 1.5em;\n}\n/*******************************\n            Content\n*******************************/\n/* Activity Bar */\n.ui.progress .bar {\n  display: block;\n  line-height: 1;\n  position: relative;\n  width: 0%;\n  min-width: 2em;\n  background: #888888;\n  border-radius: 0.28571429rem;\n  transition: width 0.1s ease, background-color 0.1s ease;\n}\n/* Percent Complete */\n.ui.progress .bar > .progress {\n  white-space: nowrap;\n  position: absolute;\n  width: auto;\n  font-size: 0.92857143em;\n  top: 50%;\n  right: 0.5em;\n  left: auto;\n  bottom: auto;\n  color: rgba(255, 255, 255, 0.7);\n  text-shadow: none;\n  margin-top: -0.5em;\n  font-weight: bold;\n  text-align: left;\n}\n/* Label */\n.ui.progress > .label {\n  position: absolute;\n  width: 100%;\n  font-size: 1em;\n  top: 100%;\n  right: auto;\n  left: 0%;\n  bottom: auto;\n  color: rgba(255, 255, 255, 0.87);\n  font-weight: bold;\n  text-shadow: none;\n  margin-top: 0.2em;\n  text-align: center;\n  transition: color 0.4s ease;\n}\n/*******************************\n            Types\n*******************************/\n/* Indicating */\n.ui.indicating.progress[data-percent^=\"1\"] .bar,\n.ui.indicating.progress[data-percent^=\"2\"] .bar {\n  background-color: #D95C5C;\n}\n.ui.indicating.progress[data-percent^=\"3\"] .bar {\n  background-color: #EFBC72;\n}\n.ui.indicating.progress[data-percent^=\"4\"] .bar,\n.ui.indicating.progress[data-percent^=\"5\"] .bar {\n  background-color: #E6BB48;\n}\n.ui.indicating.progress[data-percent^=\"6\"] .bar {\n  background-color: #DDC928;\n}\n.ui.indicating.progress[data-percent^=\"7\"] .bar,\n.ui.indicating.progress[data-percent^=\"8\"] .bar {\n  background-color: #B4D95C;\n}\n.ui.indicating.progress[data-percent^=\"9\"] .bar,\n.ui.indicating.progress[data-percent^=\"100\"] .bar {\n  background-color: #66DA81;\n}\n/* Indicating Label */\n.ui.indicating.progress[data-percent^=\"1\"] .label,\n.ui.indicating.progress[data-percent^=\"2\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.indicating.progress[data-percent^=\"3\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.indicating.progress[data-percent^=\"4\"] .label,\n.ui.indicating.progress[data-percent^=\"5\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.indicating.progress[data-percent^=\"6\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.indicating.progress[data-percent^=\"7\"] .label,\n.ui.indicating.progress[data-percent^=\"8\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.indicating.progress[data-percent^=\"9\"] .label,\n.ui.indicating.progress[data-percent^=\"100\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Single Digits */\n.ui.indicating.progress[data-percent=\"1\"] .bar,\n.ui.indicating.progress[data-percent=\"2\"] .bar,\n.ui.indicating.progress[data-percent=\"3\"] .bar,\n.ui.indicating.progress[data-percent=\"4\"] .bar,\n.ui.indicating.progress[data-percent=\"5\"] .bar,\n.ui.indicating.progress[data-percent=\"6\"] .bar,\n.ui.indicating.progress[data-percent=\"7\"] .bar,\n.ui.indicating.progress[data-percent=\"8\"] .bar,\n.ui.indicating.progress[data-percent=\"9\"] .bar {\n  background-color: #D95C5C;\n}\n.ui.indicating.progress[data-percent=\"1\"] .label,\n.ui.indicating.progress[data-percent=\"2\"] .label,\n.ui.indicating.progress[data-percent=\"3\"] .label,\n.ui.indicating.progress[data-percent=\"4\"] .label,\n.ui.indicating.progress[data-percent=\"5\"] .label,\n.ui.indicating.progress[data-percent=\"6\"] .label,\n.ui.indicating.progress[data-percent=\"7\"] .label,\n.ui.indicating.progress[data-percent=\"8\"] .label,\n.ui.indicating.progress[data-percent=\"9\"] .label {\n  color: rgba(255, 255, 255, 0.87);\n}\n/* Indicating Success */\n.ui.indicating.progress.success .label {\n  color: #1A531B;\n}\n/*******************************\n             States\n*******************************/\n/*--------------\n     Success\n---------------*/\n.ui.progress.success .bar {\n  background-color: #21BA45 !important;\n}\n.ui.progress.success .bar,\n.ui.progress.success .bar::after {\n  animation: none !important;\n}\n.ui.progress.success > .label {\n  color: #1A531B;\n}\n/*--------------\n     Warning\n---------------*/\n.ui.progress.warning .bar {\n  background-color: #F2C037 !important;\n}\n.ui.progress.warning .bar,\n.ui.progress.warning .bar::after {\n  animation: none !important;\n}\n.ui.progress.warning > .label {\n  color: #794B02;\n}\n/*--------------\n     Error\n---------------*/\n.ui.progress.error .bar {\n  background-color: #DB2828 !important;\n}\n.ui.progress.error .bar,\n.ui.progress.error .bar::after {\n  animation: none !important;\n}\n.ui.progress.error > .label {\n  color: #912D2B;\n}\n/*--------------\n     Active\n---------------*/\n.ui.active.progress .bar {\n  position: relative;\n  min-width: 2em;\n}\n.ui.active.progress .bar::after {\n  content: '';\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background: #FFFFFF;\n  border-radius: 0.28571429rem;\n  animation: progress-active 2s ease infinite;\n}\n@keyframes progress-active {\n  0% {\n    opacity: 0.3;\n    width: 0;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n/*--------------\n    Disabled\n---------------*/\n.ui.disabled.progress {\n  opacity: 0.35;\n}\n.ui.disabled.progress .bar,\n.ui.disabled.progress .bar::after {\n  animation: none !important;\n}\n/*******************************\n           Variations\n*******************************/\n/*--------------\n    Inverted\n---------------*/\n.ui.inverted.progress {\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n}\n.ui.inverted.progress .bar {\n  background: #888888;\n}\n.ui.inverted.progress .bar > .progress {\n  color: #F9FAFB;\n}\n.ui.inverted.progress > .label {\n  color: #FFFFFF;\n}\n.ui.inverted.progress.success > .label {\n  color: #21BA45;\n}\n.ui.inverted.progress.warning > .label {\n  color: #F2C037;\n}\n.ui.inverted.progress.error > .label {\n  color: #DB2828;\n}\n/*--------------\n    Attached\n---------------*/\n/* bottom attached */\n.ui.progress.attached {\n  background: transparent;\n  position: relative;\n  border: none;\n  margin: 0em;\n}\n.ui.progress.attached,\n.ui.progress.attached .bar {\n  display: block;\n  height: 0.2rem;\n  padding: 0px;\n  overflow: hidden;\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n.ui.progress.attached .bar {\n  border-radius: 0em;\n}\n/* top attached */\n.ui.progress.top.attached,\n.ui.progress.top.attached .bar {\n  top: 0px;\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.progress.top.attached .bar {\n  border-radius: 0em;\n}\n/* Coupling */\n.ui.segment > .ui.attached.progress,\n.ui.card > .ui.attached.progress {\n  position: absolute;\n  top: auto;\n  left: 0;\n  bottom: 100%;\n  width: 100%;\n}\n.ui.segment > .ui.bottom.attached.progress,\n.ui.card > .ui.bottom.attached.progress {\n  top: 100%;\n  bottom: auto;\n}\n/*--------------\n     Colors\n---------------*/\n/* Red */\n.ui.red.progress .bar {\n  background-color: #DB2828;\n}\n.ui.red.inverted.progress .bar {\n  background-color: #FF695E;\n}\n/* Orange */\n.ui.orange.progress .bar {\n  background-color: #F2711C;\n}\n.ui.orange.inverted.progress .bar {\n  background-color: #FF851B;\n}\n/* Yellow */\n.ui.yellow.progress .bar {\n  background-color: #FBBD08;\n}\n.ui.yellow.inverted.progress .bar {\n  background-color: #FFE21F;\n}\n/* Olive */\n.ui.olive.progress .bar {\n  background-color: #B5CC18;\n}\n.ui.olive.inverted.progress .bar {\n  background-color: #D9E778;\n}\n/* Green */\n.ui.green.progress .bar {\n  background-color: #21BA45;\n}\n.ui.green.inverted.progress .bar {\n  background-color: #2ECC40;\n}\n/* Teal */\n.ui.teal.progress .bar {\n  background-color: #00B5AD;\n}\n.ui.teal.inverted.progress .bar {\n  background-color: #6DFFFF;\n}\n/* Blue */\n.ui.blue.progress .bar {\n  background-color: #2185D0;\n}\n.ui.blue.inverted.progress .bar {\n  background-color: #54C8FF;\n}\n/* Violet */\n.ui.violet.progress .bar {\n  background-color: #6435C9;\n}\n.ui.violet.inverted.progress .bar {\n  background-color: #A291FB;\n}\n/* Purple */\n.ui.purple.progress .bar {\n  background-color: #A333C8;\n}\n.ui.purple.inverted.progress .bar {\n  background-color: #DC73FF;\n}\n/* Pink */\n.ui.pink.progress .bar {\n  background-color: #E03997;\n}\n.ui.pink.inverted.progress .bar {\n  background-color: #FF8EDF;\n}\n/* Brown */\n.ui.brown.progress .bar {\n  background-color: #A5673F;\n}\n.ui.brown.inverted.progress .bar {\n  background-color: #D67C1C;\n}\n/* Grey */\n.ui.grey.progress .bar {\n  background-color: #767676;\n}\n.ui.grey.inverted.progress .bar {\n  background-color: #DCDDDE;\n}\n/* Black */\n.ui.black.progress .bar {\n  background-color: #1B1C1D;\n}\n.ui.black.inverted.progress .bar {\n  background-color: #545454;\n}\n/*--------------\n     Sizes\n---------------*/\n.ui.tiny.progress {\n  font-size: 0.85714286rem;\n}\n.ui.tiny.progress .bar {\n  height: 0.5em;\n}\n.ui.small.progress {\n  font-size: 0.92857143rem;\n}\n.ui.small.progress .bar {\n  height: 1em;\n}\n.ui.progress {\n  font-size: 1rem;\n}\n.ui.progress .bar {\n  height: 1.75em;\n}\n.ui.large.progress {\n  font-size: 1.14285714rem;\n}\n.ui.large.progress .bar {\n  height: 2.5em;\n}\n.ui.big.progress {\n  font-size: 1.28571429rem;\n}\n.ui.big.progress .bar {\n  height: 3.5em;\n}\n/*******************************\n            Progress\n*******************************/\n/*!\n * # Semantic UI - Rating\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Rating\n*******************************/\n/*-------------------\n        Types\n--------------------*/\n/* Standard */\n/* Star */\n/* Heart */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Packaged Theme */\n/*******************************\n             Rating\n*******************************/\n/*-------------------\n        Types\n--------------------*/\n/* Standard */\n/* Star */\n/* Heart */\n/*-------------------\n        States\n--------------------*/\n/*-------------------\n      Variations\n--------------------*/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           Rating\n*******************************/\n.ui.rating {\n  display: inline-flex;\n  white-space: nowrap;\n  vertical-align: baseline;\n}\n.ui.rating:last-child {\n  margin-right: 0em;\n}\n/* Icon */\n.ui.rating .icon {\n  padding: 0em;\n  margin: 0em;\n  text-align: center;\n  font-weight: normal;\n  font-style: normal;\n  flex: 1 0 auto;\n  cursor: pointer;\n  width: 1.25em;\n  height: auto;\n  transition: opacity 0.1s ease, background 0.1s ease, text-shadow 0.1s ease, color 0.1s ease;\n}\n/*******************************\n             Types\n*******************************/\n/*-------------------\n      Standard\n--------------------*/\n/* Inactive Icon */\n.ui.rating .icon {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n}\n/* Active Icon */\n.ui.rating .active.icon {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n}\n/* Selected Icon */\n.ui.rating .icon.selected,\n.ui.rating .icon.selected.active {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.87);\n}\n/*-------------------\n        Star\n--------------------*/\n/* Inactive */\n.ui.star.rating .icon {\n  width: 1.25em;\n  height: auto;\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n  text-shadow: none;\n}\n/* Active Star */\n.ui.star.rating .active.icon {\n  background: transparent !important;\n  color: #FFE623 !important;\n  text-shadow: 0px -1px 0px #DDC507, -1px 0px 0px #DDC507, 0px 1px 0px #DDC507, 1px 0px 0px #DDC507 !important;\n}\n/* Selected Star */\n.ui.star.rating .icon.selected,\n.ui.star.rating .icon.selected.active {\n  background: transparent !important;\n  color: #FFCC00 !important;\n  text-shadow: 0px -1px 0px #E6A200, -1px 0px 0px #E6A200, 0px 1px 0px #E6A200, 1px 0px 0px #E6A200 !important;\n}\n/*-------------------\n        Heart\n--------------------*/\n.ui.heart.rating .icon {\n  width: 1.4em;\n  height: auto;\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n  text-shadow: none !important;\n}\n/* Active Heart */\n.ui.heart.rating .active.icon {\n  background: transparent !important;\n  color: #FF6D75 !important;\n  text-shadow: 0px -1px 0px #CD0707, -1px 0px 0px #CD0707, 0px 1px 0px #CD0707, 1px 0px 0px #CD0707 !important;\n}\n/* Selected Heart */\n.ui.heart.rating .icon.selected,\n.ui.heart.rating .icon.selected.active {\n  background: transparent !important;\n  color: #FF3000 !important;\n  text-shadow: 0px -1px 0px #AA0101, -1px 0px 0px #AA0101, 0px 1px 0px #AA0101, 1px 0px 0px #AA0101 !important;\n}\n/*******************************\n             States\n*******************************/\n/*-------------------\n       Disabled\n--------------------*/\n/* disabled rating */\n.ui.disabled.rating .icon {\n  cursor: default;\n}\n/*-------------------\n   User Interactive\n--------------------*/\n/* Selected Rating */\n.ui.rating.selected .active.icon {\n  opacity: 1;\n}\n.ui.rating.selected .icon.selected,\n.ui.rating .icon.selected {\n  opacity: 1;\n}\n/*******************************\n          Variations\n*******************************/\n.ui.mini.rating {\n  font-size: 0.78571429rem;\n}\n.ui.tiny.rating {\n  font-size: 0.85714286rem;\n}\n.ui.small.rating {\n  font-size: 0.92857143rem;\n}\n.ui.rating {\n  font-size: 1rem;\n}\n.ui.large.rating {\n  font-size: 1.14285714rem;\n}\n.ui.huge.rating {\n  font-size: 1.42857143rem;\n}\n.ui.massive.rating {\n  font-size: 2rem;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n@font-face {\n  font-family: 'Rating';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,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) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n.ui.rating .icon {\n  font-family: 'Rating';\n  line-height: 1;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n/* Empty Star */\n.ui.rating .icon:before {\n  content: '\\f005';\n}\n/* Active Star */\n.ui.rating .active.icon:before {\n  content: '\\f005';\n}\n/*-------------------\n        Star\n--------------------*/\n/* Unfilled Star */\n.ui.star.rating .icon:before {\n  content: '\\f005';\n}\n/* Active Star */\n.ui.star.rating .active.icon:before {\n  content: '\\f005';\n}\n/* Partial */\n.ui.star.rating .partial.icon:before {\n  content: '\\f006';\n}\n.ui.star.rating .partial.icon {\n  content: '\\f005';\n}\n/*-------------------\n        Heart\n--------------------*/\n/* Empty Heart\n.ui.heart.rating .icon:before {\n  content: '\\f08a';\n}\n*/\n.ui.heart.rating .icon:before {\n  content: '\\f004';\n}\n/* Active */\n.ui.heart.rating .active.icon:before {\n  content: '\\f004';\n}\n/*!\n * # Semantic UI - Search\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Search\n*******************************/\n/* Search Prompt */\n/* Mobile */\n/* Result Box */\n/* Result */\n/* Result Image */\n/* Result Content */\n/* Description */\n/* Price */\n/* Special Message */\n/* All Results Link */\n/*******************************\n            States\n*******************************/\n/* Focus */\n/* Hover */\n/* Loading */\n/* Active Category */\n/* Active Result */\n/*******************************\n            Types\n*******************************/\n/* Selection */\n/* Category */\n/* Packaged Theme */\n/*******************************\n            Search\n*******************************/\n/* Search Prompt */\n/* Mobile */\n/* Result Box */\n/* Result */\n/* Result Image */\n/* Result Content */\n/* Description */\n/* Price */\n/* Special Message */\n/* All Results Link */\n/*******************************\n            States\n*******************************/\n/* Focus */\n/* Hover */\n/* Loading */\n/* Active Category */\n/* Active Result */\n/*******************************\n            Types\n*******************************/\n/* Selection */\n/* Category */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n             Search\n*******************************/\n.ui.search {\n  position: relative;\n}\n.ui.search > .prompt {\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  text-shadow: none;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.21428571em;\n  padding: 0.67857143em 1em;\n  font-size: 1em;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, border-color 0.1s ease;\n}\n.ui.search .prompt {\n  border-radius: 500rem;\n}\n/*--------------\n     Icon\n---------------*/\n.ui.search .prompt ~ .search.icon {\n  cursor: pointer;\n}\n/*--------------\n    Results\n---------------*/\n.ui.search > .results {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0%;\n  transform-origin: center top;\n  white-space: normal;\n  text-align: left;\n  text-transform: none;\n  background: #FFFFFF;\n  margin-top: 0.5em;\n  width: 18em;\n  border-radius: 0.28571429rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n  border: 1px solid #D4D4D5;\n  z-index: 998;\n}\n.ui.search > .results > :first-child {\n  border-radius: 0.28571429rem 0.28571429rem 0em 0em;\n}\n.ui.search > .results > :last-child {\n  border-radius: 0em 0em 0.28571429rem 0.28571429rem;\n}\n/*--------------\n    Result\n---------------*/\n.ui.search > .results .result {\n  cursor: pointer;\n  display: block;\n  overflow: hidden;\n  font-size: 1em;\n  padding: 0.85714286em 1.14285714em;\n  color: rgba(255, 255, 255, 0.87);\n  line-height: 1.33;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n.ui.search > .results .result:last-child {\n  border-bottom: none !important;\n}\n/* Image */\n.ui.search > .results .result .image {\n  float: right;\n  overflow: hidden;\n  background: none;\n  width: 5em;\n  height: 3em;\n  border-radius: 0.25em;\n}\n.ui.search > .results .result .image img {\n  display: block;\n  width: auto;\n  height: 100%;\n}\n/*--------------\n      Info\n---------------*/\n.ui.search > .results .result .image + .content {\n  margin: 0em 6em 0em 0em;\n}\n.ui.search > .results .result .title {\n  margin: -0.14285714em 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.search > .results .result .description {\n  margin-top: 0;\n  font-size: 0.92857143em;\n  color: rgba(255, 255, 255, 0.4);\n}\n.ui.search > .results .result .price {\n  float: right;\n  color: #21BA45;\n}\n/*--------------\n    Message\n---------------*/\n.ui.search > .results > .message {\n  padding: 1em 1em;\n}\n.ui.search > .results > .message .header {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1rem;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.search > .results > .message .description {\n  margin-top: 0.25rem;\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.87);\n}\n/* View All Results */\n.ui.search > .results > .action {\n  display: block;\n  border-top: none;\n  background: #F3F4F5;\n  padding: 0.92857143em 1em;\n  color: rgba(255, 255, 255, 0.87);\n  font-weight: bold;\n  text-align: center;\n}\n/*******************************\n            States\n*******************************/\n/*--------------------\n       Focus\n---------------------*/\n.ui.search > .prompt:focus {\n  border-color: rgba(255, 255, 255, 0.35);\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.95);\n}\n/*--------------------\n       Loading\n---------------------*/\n.ui.loading.search .input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n.ui.loading.search .input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  animation: button-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n/*--------------\n      Hover\n---------------*/\n.ui.search > .results .result:hover,\n.ui.category.search > .results .category .result:hover {\n  background: #F9FAFB;\n}\n.ui.search .action:hover {\n  background: #E0E0E0;\n}\n/*--------------\n      Active\n---------------*/\n.ui.category.search > .results .category.active {\n  background: #F3F4F5;\n}\n.ui.category.search > .results .category.active > .name {\n  color: rgba(255, 255, 255, 0.87);\n}\n.ui.search > .results .result.active,\n.ui.category.search > .results .category .result.active {\n  position: relative;\n  border-left-color: rgba(255, 255, 255, 0.1);\n  background: #F3F4F5;\n  box-shadow: none;\n}\n.ui.search > .results .result.active .title {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ui.search > .results .result.active .description {\n  color: rgba(255, 255, 255, 0.85);\n}\n/*--------------------\n        Disabled\n----------------------*/\n/* Disabled */\n.ui.disabled.search {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.45;\n}\n/*******************************\n           Types\n*******************************/\n/*--------------\n    Selection\n---------------*/\n.ui.search.selection .prompt {\n  border-radius: 0.28571429rem;\n}\n/* Remove input */\n.ui.search.selection > .icon.input > .remove.icon {\n  pointer-events: none;\n  position: absolute;\n  left: auto;\n  opacity: 0;\n  color: '';\n  top: 0em;\n  right: 0em;\n  transition: color 0.1s ease, opacity 0.1s ease;\n}\n.ui.search.selection > .icon.input > .active.remove.icon {\n  cursor: pointer;\n  opacity: 0.8;\n  pointer-events: auto;\n}\n.ui.search.selection > .icon.input:not([class*=\"left icon\"]) > .icon ~ .remove.icon {\n  right: 1.85714em;\n}\n.ui.search.selection > .icon.input > .remove.icon:hover {\n  opacity: 1;\n  color: #DB2828;\n}\n/*--------------\n    Category\n---------------*/\n.ui.category.search .results {\n  width: 28em;\n}\n.ui.category.search .results.animating,\n.ui.category.search .results.visible {\n  display: table;\n}\n/* Category */\n.ui.category.search > .results .category {\n  display: table-row;\n  background: #F3F4F5;\n  box-shadow: none;\n  transition: background 0.1s ease, border-color 0.1s ease;\n}\n/* Last Category */\n.ui.category.search > .results .category:last-child {\n  border-bottom: none;\n}\n/* First / Last */\n.ui.category.search > .results .category:first-child .name + .result {\n  border-radius: 0em 0.28571429rem 0em 0em;\n}\n.ui.category.search > .results .category:last-child .result:last-child {\n  border-radius: 0em 0em 0.28571429rem 0em;\n}\n/* Category Result Name */\n.ui.category.search > .results .category > .name {\n  display: table-cell;\n  text-overflow: ellipsis;\n  width: 100px;\n  white-space: nowrap;\n  background: transparent;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  padding: 0.4em 1em;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n/* Category Result */\n.ui.category.search > .results .category .results {\n  display: table-cell;\n  background: #FFFFFF;\n  border-left: 1px solid rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n.ui.category.search > .results .category .result {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background 0.1s ease, border-color 0.1s ease;\n  padding: 0.85714286em 1.14285714em;\n}\n/*******************************\n           Variations\n*******************************/\n/*-------------------\n     Left / Right\n--------------------*/\n.ui[class*=\"left aligned\"].search > .results {\n  right: auto;\n  left: 0%;\n}\n.ui[class*=\"right aligned\"].search > .results {\n  right: 0%;\n  left: auto;\n}\n/*--------------\n    Fluid\n---------------*/\n.ui.fluid.search .results {\n  width: 100%;\n}\n/*--------------\n      Sizes\n---------------*/\n.ui.mini.search {\n  font-size: 0.78571429em;\n}\n.ui.small.search {\n  font-size: 0.92857143em;\n}\n.ui.search {\n  font-size: 1em;\n}\n.ui.large.search {\n  font-size: 1.14285714em;\n}\n.ui.big.search {\n  font-size: 1.28571429em;\n}\n.ui.huge.search {\n  font-size: 1.42857143em;\n}\n.ui.massive.search {\n  font-size: 1.71428571em;\n}\n/*--------------\n      Mobile\n---------------*/\n@media only screen and (max-width: 767px) {\n  .ui.search .results {\n    max-width: calc(100vw - 2rem);\n  }\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Shape\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Shape\n*******************************/\n/* Animating */\n/* Side */\n/*--------------\n      Types\n---------------*/\n/* Cube */\n/* Packaged Theme */\n/*******************************\n             Shape\n*******************************/\n/* Animating */\n/* Side */\n/*--------------\n      Types\n---------------*/\n/* Cube */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n              Shape\n*******************************/\n.ui.shape {\n  position: relative;\n  vertical-align: top;\n  display: inline-block;\n  perspective: 2000px;\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;\n}\n.ui.shape .sides {\n  transform-style: preserve-3d;\n}\n.ui.shape .side {\n  opacity: 1;\n  width: 100%;\n  margin: 0em !important;\n  backface-visibility: hidden;\n}\n.ui.shape .side {\n  display: none;\n}\n.ui.shape .side * {\n  backface-visibility: visible !important;\n}\n/*******************************\n             Types\n*******************************/\n.ui.cube.shape .side {\n  min-width: 15em;\n  height: 15em;\n  padding: 2em;\n  background-color: #E6E6E6;\n  color: rgba(255, 255, 255, 0.87);\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);\n}\n.ui.cube.shape .side > .content {\n  width: 100%;\n  height: 100%;\n  display: table;\n  text-align: center;\n  user-select: text;\n}\n.ui.cube.shape .side > .content > div {\n  display: table-cell;\n  vertical-align: middle;\n  font-size: 2em;\n}\n/*******************************\n          Variations\n*******************************/\n.ui.text.shape.animating .sides {\n  position: static;\n}\n.ui.text.shape .side {\n  white-space: nowrap;\n}\n.ui.text.shape .side > * {\n  white-space: normal;\n}\n/*******************************\n             States\n*******************************/\n/*--------------\n    Loading\n---------------*/\n.ui.loading.shape {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n}\n/*--------------\n    Animating\n---------------*/\n.ui.shape .animating.side {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: block;\n  z-index: 100;\n}\n.ui.shape .hidden.side {\n  opacity: 0.6;\n}\n/*--------------\n      CSS\n---------------*/\n.ui.shape.animating .sides {\n  position: absolute;\n}\n.ui.shape.animating .sides {\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;\n}\n.ui.shape.animating .side {\n  transition: opacity 0.6s ease-in-out;\n}\n/*--------------\n     Active\n---------------*/\n.ui.shape .active.side {\n  display: block;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Sidebar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n             Sidebar\n*******************************/\n/*-------------------\n       Content\n--------------------*/\n/* Animation */\n/* Dimmer */\n/* Color below page */\n/* Shadow */\n/* Layering */\n/*-------------------\n      Variations\n--------------------*/\n/* Width */\n/* Height */\n/* Packaged Theme */\n/*******************************\n             Sidebar\n*******************************/\n/*-------------------\n       Content\n--------------------*/\n/* Animation */\n/* Dimmer */\n/* Color below page */\n/* Shadow */\n/* Layering */\n/*-------------------\n      Variations\n--------------------*/\n/* Width */\n/* Height */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Sidebar\n*******************************/\n/* Sidebar Menu */\n.ui.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  backface-visibility: hidden;\n  transition: none;\n  will-change: transform;\n  transform: translate3d(0, 0, 0);\n  visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  height: 100% !important;\n  max-height: 100%;\n  border-radius: 0em !important;\n  margin: 0em !important;\n  overflow-y: auto !important;\n  z-index: 102;\n}\n/* GPU Layers for Child Elements */\n.ui.sidebar > * {\n  backface-visibility: hidden;\n}\n/*--------------\n   Direction\n---------------*/\n.ui.left.sidebar {\n  right: auto;\n  left: 0px;\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.sidebar {\n  right: 0px !important;\n  left: auto !important;\n  transform: translate3d(100%, 0%, 0);\n}\n.ui.top.sidebar,\n.ui.bottom.sidebar {\n  width: 100% !important;\n  height: auto !important;\n}\n.ui.top.sidebar {\n  top: 0px !important;\n  bottom: auto !important;\n  transform: translate3d(0, -100%, 0);\n}\n.ui.bottom.sidebar {\n  top: auto !important;\n  bottom: 0px !important;\n  transform: translate3d(0, 100%, 0);\n}\n/*--------------\n     Pushable\n---------------*/\n.pushable {\n  height: 100%;\n  overflow-x: hidden;\n  padding: 0em !important;\n}\n/* Whole Page */\nbody.pushable {\n  background: #545454 !important;\n}\n/* Page Context */\n.pushable:not(body) {\n  transform: translate3d(0, 0, 0);\n}\n.pushable:not(body) > .ui.sidebar,\n.pushable:not(body) > .fixed,\n.pushable:not(body) > .pusher:after {\n  position: absolute;\n}\n/*--------------\n     Fixed\n---------------*/\n.pushable > .fixed {\n  position: fixed;\n  backface-visibility: hidden;\n  transition: transform 500ms ease;\n  will-change: transform;\n  z-index: 101;\n}\n/*--------------\n     Page\n---------------*/\n.pushable > .pusher {\n  position: relative;\n  backface-visibility: hidden;\n  overflow: hidden;\n  min-height: 100%;\n  transition: transform 500ms ease;\n  z-index: 2;\n}\nbody.pushable > .pusher {\n  background: #FFFFFF;\n}\n/* Pusher should inherit background from context */\n.pushable > .pusher {\n  background: inherit;\n}\n/*--------------\n     Dimmer\n---------------*/\n.pushable > .pusher:after {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  content: '';\n  background-color: rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 500ms;\n  will-change: opacity;\n  z-index: 1000;\n}\n/*--------------\n    Coupling\n---------------*/\n.ui.sidebar.menu .item {\n  border-radius: 0em !important;\n}\n/*******************************\n            States\n*******************************/\n/*--------------\n     Dimmed\n---------------*/\n.pushable > .pusher.dimmed:after {\n  width: 100% !important;\n  height: 100% !important;\n  opacity: 1 !important;\n}\n/*--------------\n    Animating\n---------------*/\n.ui.animating.sidebar {\n  visibility: visible;\n}\n/*--------------\n     Visible\n---------------*/\n.ui.visible.sidebar {\n  visibility: visible;\n  transform: translate3d(0, 0, 0);\n}\n/* Shadow Direction */\n.ui.left.visible.sidebar,\n.ui.right.visible.sidebar {\n  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.15);\n}\n.ui.top.visible.sidebar,\n.ui.bottom.visible.sidebar {\n  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.15);\n}\n/* Visible On Load */\n.ui.visible.left.sidebar ~ .fixed,\n.ui.visible.left.sidebar ~ .pusher {\n  transform: translate3d(260px, 0, 0);\n}\n.ui.visible.right.sidebar ~ .fixed,\n.ui.visible.right.sidebar ~ .pusher {\n  transform: translate3d(-260px, 0, 0);\n}\n.ui.visible.top.sidebar ~ .fixed,\n.ui.visible.top.sidebar ~ .pusher {\n  transform: translate3d(0, 36px, 0);\n}\n.ui.visible.bottom.sidebar ~ .fixed,\n.ui.visible.bottom.sidebar ~ .pusher {\n  transform: translate3d(0, -36px, 0);\n}\n/* opposite sides visible forces content overlay */\n.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,\n.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,\n.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,\n.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {\n  transform: translate3d(0, 0, 0);\n}\n/*--------------\n       iOS\n---------------*/\n/*******************************\n          Variations\n*******************************/\n/*--------------\n     Width\n---------------*/\n/* Left / Right */\n.ui.thin.left.sidebar,\n.ui.thin.right.sidebar {\n  width: 150px;\n}\n.ui[class*=\"very thin\"].left.sidebar,\n.ui[class*=\"very thin\"].right.sidebar {\n  width: 60px;\n}\n.ui.left.sidebar,\n.ui.right.sidebar {\n  width: 260px;\n}\n.ui.wide.left.sidebar,\n.ui.wide.right.sidebar {\n  width: 350px;\n}\n.ui[class*=\"very wide\"].left.sidebar,\n.ui[class*=\"very wide\"].right.sidebar {\n  width: 475px;\n}\n/* Left Visible */\n.ui.visible.thin.left.sidebar ~ .fixed,\n.ui.visible.thin.left.sidebar ~ .pusher {\n  transform: translate3d(150px, 0, 0);\n}\n.ui.visible[class*=\"very thin\"].left.sidebar ~ .fixed,\n.ui.visible[class*=\"very thin\"].left.sidebar ~ .pusher {\n  transform: translate3d(60px, 0, 0);\n}\n.ui.visible.wide.left.sidebar ~ .fixed,\n.ui.visible.wide.left.sidebar ~ .pusher {\n  transform: translate3d(350px, 0, 0);\n}\n.ui.visible[class*=\"very wide\"].left.sidebar ~ .fixed,\n.ui.visible[class*=\"very wide\"].left.sidebar ~ .pusher {\n  transform: translate3d(475px, 0, 0);\n}\n/* Right Visible */\n.ui.visible.thin.right.sidebar ~ .fixed,\n.ui.visible.thin.right.sidebar ~ .pusher {\n  transform: translate3d(-150px, 0, 0);\n}\n.ui.visible[class*=\"very thin\"].right.sidebar ~ .fixed,\n.ui.visible[class*=\"very thin\"].right.sidebar ~ .pusher {\n  transform: translate3d(-60px, 0, 0);\n}\n.ui.visible.wide.right.sidebar ~ .fixed,\n.ui.visible.wide.right.sidebar ~ .pusher {\n  transform: translate3d(-350px, 0, 0);\n}\n.ui.visible[class*=\"very wide\"].right.sidebar ~ .fixed,\n.ui.visible[class*=\"very wide\"].right.sidebar ~ .pusher {\n  transform: translate3d(-475px, 0, 0);\n}\n/*******************************\n          Animations\n*******************************/\n/*--------------\n    Overlay\n---------------*/\n/* Set-up */\n.ui.overlay.sidebar {\n  z-index: 102;\n}\n/* Initial */\n.ui.left.overlay.sidebar {\n  transform: translate3d(-100%, 0%, 0);\n}\n.ui.right.overlay.sidebar {\n  transform: translate3d(100%, 0%, 0);\n}\n.ui.top.overlay.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.overlay.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n/* Animation */\n.animating.ui.overlay.sidebar,\n.ui.visible.overlay.sidebar {\n  transition: transform 500ms ease;\n}\n/* End - Sidebar */\n.ui.visible.left.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.right.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.top.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.bottom.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n/* End - Pusher */\n.ui.visible.overlay.sidebar ~ .fixed,\n.ui.visible.overlay.sidebar ~ .pusher {\n  transform: none !important;\n}\n/*--------------\n      Push\n---------------*/\n/* Initial */\n.ui.push.sidebar {\n  transition: transform 500ms ease;\n  z-index: 102;\n}\n/* Sidebar - Initial */\n.ui.left.push.sidebar {\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.push.sidebar {\n  transform: translate3d(100%, 0, 0);\n}\n.ui.top.push.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.push.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n/* End */\n.ui.visible.push.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n/*--------------\n    Uncover\n---------------*/\n/* Initial */\n.ui.uncover.sidebar {\n  transform: translate3d(0, 0, 0);\n  z-index: 1;\n}\n/* End */\n.ui.visible.uncover.sidebar {\n  transform: translate3d(0, 0, 0);\n  transition: transform 500ms ease;\n}\n/*--------------\n   Slide Along\n---------------*/\n/* Initial */\n.ui.slide.along.sidebar {\n  z-index: 1;\n}\n/* Sidebar - Initial */\n.ui.left.slide.along.sidebar {\n  transform: translate3d(-50%, 0, 0);\n}\n.ui.right.slide.along.sidebar {\n  transform: translate3d(50%, 0, 0);\n}\n.ui.top.slide.along.sidebar {\n  transform: translate3d(0, -50%, 0);\n}\n.ui.bottom.slide.along.sidebar {\n  transform: translate3d(0%, 50%, 0);\n}\n/* Animation */\n.ui.animating.slide.along.sidebar {\n  transition: transform 500ms ease;\n}\n/* End */\n.ui.visible.slide.along.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n/*--------------\n   Slide Out\n---------------*/\n/* Initial */\n.ui.slide.out.sidebar {\n  z-index: 1;\n}\n/* Sidebar - Initial */\n.ui.left.slide.out.sidebar {\n  transform: translate3d(50%, 0, 0);\n}\n.ui.right.slide.out.sidebar {\n  transform: translate3d(-50%, 0, 0);\n}\n.ui.top.slide.out.sidebar {\n  transform: translate3d(0%, 50%, 0);\n}\n.ui.bottom.slide.out.sidebar {\n  transform: translate3d(0%, -50%, 0);\n}\n/* Animation */\n.ui.animating.slide.out.sidebar {\n  transition: transform 500ms ease;\n}\n/* End */\n.ui.visible.slide.out.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n/*--------------\n   Scale Down\n---------------*/\n/* Initial */\n.ui.scale.down.sidebar {\n  transition: transform 500ms ease;\n  z-index: 102;\n}\n/* Sidebar - Initial  */\n.ui.left.scale.down.sidebar {\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.scale.down.sidebar {\n  transform: translate3d(100%, 0, 0);\n}\n.ui.top.scale.down.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.scale.down.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n/* Pusher - Initial */\n.ui.scale.down.left.sidebar ~ .pusher {\n  transform-origin: 75% 50%;\n}\n.ui.scale.down.right.sidebar ~ .pusher {\n  transform-origin: 25% 50%;\n}\n.ui.scale.down.top.sidebar ~ .pusher {\n  transform-origin: 50% 75%;\n}\n.ui.scale.down.bottom.sidebar ~ .pusher {\n  transform-origin: 50% 25%;\n}\n/* Animation */\n.ui.animating.scale.down > .visible.ui.sidebar {\n  transition: transform 500ms ease;\n}\n.ui.visible.scale.down.sidebar ~ .pusher,\n.ui.animating.scale.down.sidebar ~ .pusher {\n  display: block !important;\n  width: 100%;\n  height: 100%;\n  overflow: hidden !important;\n}\n/* End */\n.ui.visible.scale.down.sidebar {\n  transform: translate3d(0, 0, 0);\n}\n.ui.visible.scale.down.sidebar ~ .pusher {\n  transform: scale(0.75);\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Sticky\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n            Sticky\n*******************************/\n/* Packaged Theme */\n/*******************************\n            Sticky\n*******************************/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n            Sticky\n*******************************/\n.ui.sticky {\n  position: static;\n  transition: none;\n  z-index: 800;\n}\n/*******************************\n            States\n*******************************/\n/* Bound */\n.ui.sticky.bound {\n  position: absolute;\n  left: auto;\n  right: auto;\n}\n/* Fixed */\n.ui.sticky.fixed {\n  position: fixed;\n  left: auto;\n  right: auto;\n}\n/* Bound/Fixed Position */\n.ui.sticky.bound.top,\n.ui.sticky.fixed.top {\n  top: 0px;\n  bottom: auto;\n}\n.ui.sticky.bound.bottom,\n.ui.sticky.fixed.bottom {\n  top: auto;\n  bottom: 0px;\n}\n/*******************************\n            Types\n*******************************/\n.ui.native.sticky {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n}\n/*******************************\n         Theme Overrides\n*******************************/\n/*!\n * # Semantic UI - Tab\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n              Tab\n*******************************/\n/* Loading */\n/* Packaged Theme */\n/*******************************\n              Tab\n*******************************/\n/* Loading */\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n           UI Tabs\n*******************************/\n.ui.tab {\n  display: none;\n}\n/*******************************\n             States\n*******************************/\n/*--------------------\n       Active\n---------------------*/\n.ui.tab.active,\n.ui.tab.open {\n  display: block;\n}\n/*--------------------\n       Loading\n---------------------*/\n.ui.tab.loading {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  min-height: 250px;\n}\n.ui.tab.loading * {\n  position: relative !important;\n  left: -10000px !important;\n}\n.ui.tab.loading:before,\n.ui.tab.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: 100px;\n  left: 50%;\n  margin: -1.25em 0em 0em -1.25em;\n  width: 2.5em;\n  height: 2.5em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n.ui.tab.loading:after,\n.ui.tab.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: 100px;\n  left: 50%;\n  margin: -1.25em 0em 0em -1.25em;\n  width: 2.5em;\n  height: 2.5em;\n  animation: button-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #767676 transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n/*******************************\n         Tab Overrides\n*******************************/\n/*!\n * # Semantic UI - Transition\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n/*\n\n████████╗██╗  ██╗███████╗███╗   ███╗███████╗███████╗\n╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝██╔════╝\n   ██║   ███████║█████╗  ██╔████╔██║█████╗  ███████╗\n   ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝  ╚════██║\n   ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗███████║\n   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝\n\n*/\n/*******************************\n        Theme Selection\n*******************************/\n/* To override a theme for an individual element\n   specify theme name below\n*/\n/* Global */\n/* Elements */\n/* Collections */\n/* Modules */\n/* Views */\n/*******************************\n            Folders\n*******************************/\n/* Path to theme packages */\n/* Path to site override folder */\n/*******************************\n         Import Theme\n*******************************/\n/*******************************\n        Import Directives\n*******************************/\n/*------------------\n       Theme\n-------------------*/\n/*--------------------\n   Site Variables\n---------------------*/\n/* Default site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Packaged site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Component's site.variables */\n/*******************************\n         Site Settings\n*******************************/\n/*-------------------\n       Fonts\n--------------------*/\n/*-------------------\n      Base Sizes\n--------------------*/\n/* This is the single variable that controls them all */\n/* The size of page text  */\n/*-------------------\n    Border Radius\n--------------------*/\n/* See Power-user section below\n   for explanation of @px variables\n*/\n/*-------------------\n    Brand Colors\n--------------------*/\n/*--------------\n  Page Heading\n---------------*/\n/*--------------\n   Form Input\n---------------*/\n/* This adjusts the default form input across all elements */\n/* Input Text Color */\n/* Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\n/*-------------------\n    Focused Input\n--------------------*/\n/* Used on inputs, textarea etc */\n/* Used on dropdowns, other larger blocks */\n/*-------------------\n        Sizes\n--------------------*/\n/*\n  Sizes are all expressed in terms of 14px/em (default em)\n  This ensures these \"ratios\" remain constant despite changes in EM\n*/\n/*-------------------\n        Page\n--------------------*/\n/*-------------------\n      Paragraph\n--------------------*/\n/*-------------------\n       Links\n--------------------*/\n/*-------------------\n    Scroll Bars\n--------------------*/\n/* Inverted */\n/*-------------------\n  Highlighted Text\n--------------------*/\n/*-------------------\n       Loader\n--------------------*/\n/*-------------------\n        Grid\n--------------------*/\n/*-------------------\n     Transitions\n--------------------*/\n/*-------------------\n     Breakpoints\n--------------------*/\n/*-------------------\n      Site Colors\n--------------------*/\n/*---  Colors  ---*/\n/*---  Light Colors  ---*/\n/*---   Neutrals  ---*/\n/*--- Colored Backgrounds ---*/\n/*--- Colored Headers ---*/\n/*--- Colored Text ---*/\n/*--- Colored Border ---*/\n/*-------------------\n     Alpha Colors\n--------------------*/\n/*-------------------\n       Accents\n--------------------*/\n/* Differentiating Neutrals */\n/* Differentiating Layers */\n/*******************************\n           Power-User\n*******************************/\n/*-------------------\n    Emotive Colors\n--------------------*/\n/* Positive */\n/* Negative */\n/* Info */\n/* Warning */\n/*-------------------\n        Paths\n--------------------*/\n/* For source only. Modified in gulp for dist */\n/*-------------------\n       Em Sizes\n--------------------*/\n/*\n  This rounds @size values to the closest pixel then expresses that value in (r)em.\n  This ensures all size values round to exact pixels\n*/\n/* em */\n/* rem */\n/*-------------------\n       Icons\n--------------------*/\n/* Maximum Glyph Width of Icon */\n/*-------------------\n     Neutral Text\n--------------------*/\n/*-------------------\n     Brand Colors\n--------------------*/\n/*-------------------\n      Borders\n--------------------*/\n/*-------------------\n    Derived Values\n--------------------*/\n/* Loaders Position Offset */\n/* Rendered Scrollbar Width */\n/* Maximum Single Character Glyph Width, aka Capital \"W\" */\n/* Used to match floats with text */\n/* Header Spacing */\n/* Minimum Mobile Width */\n/* Positive / Negative Dupes */\n/* Responsive */\n/*-------------------\n  Exact Pixel Values\n--------------------*/\n/*\n  These are used to specify exact pixel values in em\n  for things like borders that remain constantly\n  sized as emSize adjusts\n\n  Since there are many more sizes than names for sizes,\n  these are named by their original pixel values.\n\n*/\n/* Columns */\n/*******************************\n             States\n*******************************/\n/*-------------------\n      Disabled\n--------------------*/\n/*-------------------\n        Hover\n--------------------*/\n/*---  Shadows  ---*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Focus\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n    Down (:active)\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/*-------------------\n        Active\n--------------------*/\n/*---  Colors  ---*/\n/*---  Emotive  ---*/\n/*---  Brand   ---*/\n/*---  Dark Tones  ---*/\n/*---  Light Tones  ---*/\n/* Site theme site.variables */\n/*-------------------\n Component Variables\n---------------------*/\n/* Default */\n/*******************************\n          Transition\n*******************************/\n/* Packaged Theme */\n/*******************************\n          Transition\n*******************************/\n/* Site Theme */\n/*******************************\n             Mix-ins\n*******************************/\n/*------------------\n       Fonts\n-------------------*/\n/*------------------\n     Overrides\n-------------------*/\n/* End Config */\n/*******************************\n          Transitions\n*******************************/\n.transition {\n  animation-iteration-count: 1;\n  animation-duration: 300ms;\n  animation-timing-function: ease;\n  animation-fill-mode: both;\n}\n/*******************************\n            States\n*******************************/\n/* Animating */\n.animating.transition {\n  backface-visibility: hidden;\n  visibility: visible !important;\n}\n/* Loading */\n.loading.transition {\n  position: absolute;\n  top: -99999px;\n  left: -99999px;\n}\n/* Hidden */\n.hidden.transition {\n  display: none;\n  visibility: hidden;\n}\n/* Visible */\n.visible.transition {\n  display: block !important;\n  visibility: visible !important;\n  /*  backface-visibility: @backfaceVisibility;\n  transform: @use3DAcceleration;*/\n}\n/* Disabled */\n.disabled.transition {\n  animation-play-state: paused;\n}\n/*******************************\n          Variations\n*******************************/\n.looping.transition {\n  animation-iteration-count: infinite;\n}\n/*******************************\n          Transitions\n*******************************/\n/*\n  Some transitions adapted from Animate CSS\n  https://github.com/daneden/animate.css\n\n  Additional transitions adapted from Glide\n  by Nick Pettit - https://github.com/nickpettit/glide\n*/\n/*--------------\n     Browse\n---------------*/\n.transition.browse {\n  animation-duration: 500ms;\n}\n.transition.browse.in {\n  animation-name: browseIn;\n}\n.transition.browse.out,\n.transition.browse.left.out {\n  animation-name: browseOutLeft;\n}\n.transition.browse.right.out {\n  animation-name: browseOutRight;\n}\n/* In */\n@keyframes browseIn {\n  0% {\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n  }\n  10% {\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1.05) translateZ(0px);\n    opacity: 1;\n    z-index: 999;\n  }\n  100% {\n    transform: scale(1) translateZ(0px);\n    z-index: 999;\n  }\n}\n/* Out */\n@keyframes browseOutLeft {\n  0% {\n    z-index: 999;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n  50% {\n    z-index: -1;\n    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    z-index: -1;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n@keyframes browseOutRight {\n  0% {\n    z-index: 999;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n  50% {\n    z-index: 1;\n    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    z-index: 1;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n/*--------------\n     Drop\n---------------*/\n.drop.transition {\n  transform-origin: top center;\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);\n}\n.drop.transition.in {\n  animation-name: dropIn;\n}\n.drop.transition.out {\n  animation-name: dropOut;\n}\n/* Drop */\n@keyframes dropIn {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes dropOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0);\n  }\n}\n/*--------------\n      Fade\n---------------*/\n.transition.fade.in {\n  animation-name: fadeIn;\n}\n.transition[class*=\"fade up\"].in {\n  animation-name: fadeInUp;\n}\n.transition[class*=\"fade down\"].in {\n  animation-name: fadeInDown;\n}\n.transition[class*=\"fade left\"].in {\n  animation-name: fadeInLeft;\n}\n.transition[class*=\"fade right\"].in {\n  animation-name: fadeInRight;\n}\n.transition.fade.out {\n  animation-name: fadeOut;\n}\n.transition[class*=\"fade up\"].out {\n  animation-name: fadeOutUp;\n}\n.transition[class*=\"fade down\"].out {\n  animation-name: fadeOutDown;\n}\n.transition[class*=\"fade left\"].out {\n  animation-name: fadeOutLeft;\n}\n.transition[class*=\"fade right\"].out {\n  animation-name: fadeOutRight;\n}\n/* In */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translateX(-10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n/* Out */\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(5%);\n  }\n}\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-5%);\n  }\n}\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(5%);\n  }\n}\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-5%);\n  }\n}\n/*--------------\n     Flips\n---------------*/\n.flip.transition.in,\n.flip.transition.out {\n  animation-duration: 600ms;\n}\n.horizontal.flip.transition.in {\n  animation-name: horizontalFlipIn;\n}\n.horizontal.flip.transition.out {\n  animation-name: horizontalFlipOut;\n}\n.vertical.flip.transition.in {\n  animation-name: verticalFlipIn;\n}\n.vertical.flip.transition.out {\n  animation-name: verticalFlipOut;\n}\n/* In */\n@keyframes horizontalFlipIn {\n  0% {\n    transform: perspective(2000px) rotateY(-90deg);\n    opacity: 0;\n  }\n  100% {\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n}\n@keyframes verticalFlipIn {\n  0% {\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n  100% {\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n}\n/* Out */\n@keyframes horizontalFlipOut {\n  0% {\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(2000px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n@keyframes verticalFlipOut {\n  0% {\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n}\n/*--------------\n      Scale\n---------------*/\n.scale.transition.in {\n  animation-name: scaleIn;\n}\n.scale.transition.out {\n  animation-name: scaleOut;\n}\n@keyframes scaleIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n/* Out */\n@keyframes scaleOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n}\n/*--------------\n      Fly\n---------------*/\n/* Inward */\n.transition.fly {\n  animation-duration: 0.6s;\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.transition.fly.in {\n  animation-name: flyIn;\n}\n.transition[class*=\"fly up\"].in {\n  animation-name: flyInUp;\n}\n.transition[class*=\"fly down\"].in {\n  animation-name: flyInDown;\n}\n.transition[class*=\"fly left\"].in {\n  animation-name: flyInLeft;\n}\n.transition[class*=\"fly right\"].in {\n  animation-name: flyInRight;\n}\n/* Outward */\n.transition.fly.out {\n  animation-name: flyOut;\n}\n.transition[class*=\"fly up\"].out {\n  animation-name: flyOutUp;\n}\n.transition[class*=\"fly down\"].out {\n  animation-name: flyOutDown;\n}\n.transition[class*=\"fly left\"].out {\n  animation-name: flyOutLeft;\n}\n.transition[class*=\"fly right\"].out {\n  animation-name: flyOutRight;\n}\n/* In */\n@keyframes flyIn {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  40% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n  80% {\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n  100% {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n}\n@keyframes flyInUp {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 1500px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes flyInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -1500px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n@keyframes flyInLeft {\n  0% {\n    opacity: 0;\n    transform: translate3d(1500px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n@keyframes flyInRight {\n  0% {\n    opacity: 0;\n    transform: translate3d(-1500px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n/* Out */\n@keyframes flyOut {\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n  50%,\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n@keyframes flyOutUp {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n@keyframes flyOutDown {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes flyOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes flyOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n/*--------------\n     Slide\n---------------*/\n.transition.slide.in,\n.transition[class*=\"slide down\"].in {\n  animation-name: slideInY;\n  transform-origin: top center;\n}\n.transition[class*=\"slide up\"].in {\n  animation-name: slideInY;\n  transform-origin: bottom center;\n}\n.transition[class*=\"slide left\"].in {\n  animation-name: slideInX;\n  transform-origin: center right;\n}\n.transition[class*=\"slide right\"].in {\n  animation-name: slideInX;\n  transform-origin: center left;\n}\n.transition.slide.out,\n.transition[class*=\"slide down\"].out {\n  animation-name: slideOutY;\n  transform-origin: top center;\n}\n.transition[class*=\"slide up\"].out {\n  animation-name: slideOutY;\n  transform-origin: bottom center;\n}\n.transition[class*=\"slide left\"].out {\n  animation-name: slideOutX;\n  transform-origin: center right;\n}\n.transition[class*=\"slide right\"].out {\n  animation-name: slideOutX;\n  transform-origin: center left;\n}\n/* In */\n@keyframes slideInY {\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n@keyframes slideInX {\n  0% {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n/* Out */\n@keyframes slideOutY {\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n}\n@keyframes slideOutX {\n  0% {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n}\n/*--------------\n     Swing\n---------------*/\n.transition.swing {\n  animation-duration: 800ms;\n}\n.transition[class*=\"swing down\"].in {\n  animation-name: swingInX;\n  transform-origin: top center;\n}\n.transition[class*=\"swing up\"].in {\n  animation-name: swingInX;\n  transform-origin: bottom center;\n}\n.transition[class*=\"swing left\"].in {\n  animation-name: swingInY;\n  transform-origin: center right;\n}\n.transition[class*=\"swing right\"].in {\n  animation-name: swingInY;\n  transform-origin: center left;\n}\n.transition.swing.out,\n.transition[class*=\"swing down\"].out {\n  animation-name: swingOutX;\n  transform-origin: top center;\n}\n.transition[class*=\"swing up\"].out {\n  animation-name: swingOutX;\n  transform-origin: bottom center;\n}\n.transition[class*=\"swing left\"].out {\n  animation-name: swingOutY;\n  transform-origin: center right;\n}\n.transition[class*=\"swing right\"].out {\n  animation-name: swingOutY;\n  transform-origin: center left;\n}\n/* In */\n@keyframes swingInX {\n  0% {\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n  60% {\n    transform: perspective(1000px) rotateX(15deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n  100% {\n    transform: perspective(1000px) rotateX(0deg);\n  }\n}\n@keyframes swingInY {\n  0% {\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n  60% {\n    transform: perspective(1000px) rotateY(-17.5deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n  100% {\n    transform: perspective(1000px) rotateY(0deg);\n  }\n}\n/* Out */\n@keyframes swingOutX {\n  0% {\n    transform: perspective(1000px) rotateX(0deg);\n  }\n  40% {\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n  60% {\n    transform: perspective(1000px) rotateX(17.5deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n@keyframes swingOutY {\n  0% {\n    transform: perspective(1000px) rotateY(0deg);\n  }\n  40% {\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n  60% {\n    transform: perspective(1000px) rotateY(-10deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n}\n/*--------------\n      Zoom\n---------------*/\n.transition.zoom.in {\n  animation-name: zoomIn;\n}\n.transition.zoom.out {\n  animation-name: zoomOut;\n}\n@keyframes zoomIn {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(0);\n  }\n}\n/*******************************\n       Static Animations\n*******************************/\n/*--------------\n    Emphasis\n---------------*/\n.flash.transition {\n  animation-duration: 750ms;\n  animation-name: flash;\n}\n.shake.transition {\n  animation-duration: 750ms;\n  animation-name: shake;\n}\n.bounce.transition {\n  animation-duration: 750ms;\n  animation-name: bounce;\n}\n.tada.transition {\n  animation-duration: 750ms;\n  animation-name: tada;\n}\n.pulse.transition {\n  animation-duration: 500ms;\n  animation-name: pulse;\n}\n.jiggle.transition {\n  animation-duration: 750ms;\n  animation-name: jiggle;\n}\n.transition.glow {\n  animation-duration: 2000ms;\n  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n}\n.transition.glow {\n  animation-name: glow;\n}\n/* Flash */\n@keyframes flash {\n  0%,\n  50%,\n  100% {\n    opacity: 1;\n  }\n  25%,\n  75% {\n    opacity: 0;\n  }\n}\n/* Shake */\n@keyframes shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translateX(-10px);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translateX(10px);\n  }\n}\n/* Bounce */\n@keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n}\n/* Tada */\n@keyframes tada {\n  0% {\n    transform: scale(1);\n  }\n  10%,\n  20% {\n    transform: scale(0.9) rotate(-3deg);\n  }\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale(1.1) rotate(3deg);\n  }\n  40%,\n  60%,\n  80% {\n    transform: scale(1.1) rotate(-3deg);\n  }\n  100% {\n    transform: scale(1) rotate(0);\n  }\n}\n/* Pulse */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n/* Jiggle */\n@keyframes jiggle {\n  0% {\n    transform: scale3d(1, 1, 1);\n  }\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n}\n/* Glow */\n@keyframes glow {\n  0% {\n    background-color: #FCFCFD;\n  }\n  30% {\n    background-color: #FFF6CD;\n  }\n  100% {\n    background-color: #FCFCFD;\n  }\n}\n","/*!\n * # Semantic UI - Reset\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'global';\n@element : 'reset';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Reset\n*******************************/\n\n/* Border-Box */\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\nhtml {\n  box-sizing: border-box;\n}\n\n/* iPad Input Shadows */\ninput[type=\"text\"], input[type=\"email\"], input[type=\"search\"], input[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none; /* mobile firefox too! */\n}\n\n.loadUIOverrides();\n","/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n","/*!\n * # Semantic UI - Site\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'global';\n@element : 'site';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Page\n*******************************/\n\n.loadFonts();\n\nhtml,\nbody {\n  height: 100%;\n}\n\nhtml {\n  font-size: @emSize;\n}\n\nbody {\n  margin: 0px;\n  padding: 0px;\n  overflow-x: @pageOverflowX;\n  min-width: @pageMinWidth;\n  background: @pageBackground;\n  font-family: @pageFont;\n  font-size: @fontSize;\n  line-height: @lineHeight;\n  color: @textColor;\n  font-smoothing: @fontSmoothing;\n}\n\n/*******************************\n             Headers\n*******************************/\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-family: @headerFont;\n  line-height: @headerLineHeight;\n  margin: @headerMargin;\n  font-weight: @headerFontWeight;\n  padding: 0em;\n}\n\nh1 {\n  min-height: 1rem;\n  font-size: @h1;\n}\nh2 {\n  font-size: @h2;\n}\nh3 {\n  font-size: @h3;\n}\nh4 {\n  font-size: @h4;\n}\nh5 {\n  font-size: @h5;\n}\n\nh1:first-child,\nh2:first-child,\nh3:first-child,\nh4:first-child,\nh5:first-child {\n  margin-top: 0em;\n}\n\nh1:last-child,\nh2:last-child,\nh3:last-child,\nh4:last-child,\nh5:last-child {\n  margin-bottom: 0em;\n}\n\n\n/*******************************\n             Text\n*******************************/\n\np {\n  margin: @paragraphMargin;\n  line-height: @paragraphLineHeight;\n}\np:first-child {\n  margin-top: 0em;\n}\np:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n        Links\n--------------------*/\n\na {\n  color: @linkColor;\n  text-decoration: @linkUnderline;\n}\na:hover {\n  color: @linkHoverColor;\n  text-decoration: @linkHoverUnderline;\n}\n\n\n/*******************************\n         Scrollbars\n*******************************/\n\n.addScrollbars() when (@useCustomScrollbars) {\n\n  /* Force Simple Scrollbars */\n  body ::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: @customScrollbarWidth;\n    height: @customScrollbarHeight;\n  }\n  body ::-webkit-scrollbar-track {\n    background: @trackBackground;\n    border-radius: @trackBorderRadius;\n  }\n  body ::-webkit-scrollbar-thumb {\n    cursor: pointer;\n    border-radius: @thumbBorderRadius;\n    background: @thumbBackground;\n    transition: @thumbTransition;\n  }\n  body ::-webkit-scrollbar-thumb:window-inactive {\n    background: @thumbInactiveBackground;\n  }\n  body ::-webkit-scrollbar-thumb:hover {\n    background: @thumbHoverBackground;\n  }\n\n  /* Inverted UI */\n  body .ui.inverted::-webkit-scrollbar-track {\n    background: @trackInvertedBackground;\n  }\n  body .ui.inverted::-webkit-scrollbar-thumb {\n    background: @thumbInvertedBackground;\n  }\n  body .ui.inverted::-webkit-scrollbar-thumb:window-inactive {\n    background: @thumbInvertedInactiveBackground;\n  }\n  body .ui.inverted::-webkit-scrollbar-thumb:hover {\n    background: @thumbInvertedHoverBackground;\n  }\n}\n\n/*******************************\n          Highlighting\n*******************************/\n\n/* Site */\n::-webkit-selection {\n  background-color: @highlightBackground;\n  color: @highlightColor;\n}\n::-moz-selection {\n  background-color: @highlightBackground;\n  color: @highlightColor;\n}\n::selection {\n  background-color: @highlightBackground;\n  color: @highlightColor;\n}\n\n/* Form */\ntextarea::-webkit-selection,\ninput::-webkit-selection {\n  background-color: @inputHighlightBackground;\n  color: @inputHighlightColor;\n}\ntextarea::-moz-selection,\ninput::-moz-selection {\n  background-color: @inputHighlightBackground;\n  color: @inputHighlightColor;\n}\ntextarea::selection,\ninput::selection {\n  background-color: @inputHighlightBackground;\n  color: @inputHighlightColor;\n}\n\n.addScrollbars();\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Button\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'button';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Button\n*******************************/\n\n.ui.button {\n  cursor: pointer;\n  display: inline-block;\n\n  min-height: 1em;\n\n  outline: none;\n  border: none;\n  vertical-align: @verticalAlign;\n  background: @background;\n  color: @textColor;\n\n  font-family: @fontFamily;\n\n  margin: 0em @horizontalMargin @verticalMargin 0em;\n  padding: @verticalPadding @horizontalPadding (@verticalPadding + @shadowOffset);\n\n  text-transform: @textTransform;\n  text-shadow: @textShadow;\n  font-weight: @fontWeight;\n  line-height: @lineHeight;\n  font-style: normal;\n  text-align: center;\n  text-decoration: none;\n\n  border-radius: @borderRadius;\n  box-shadow: @boxShadow;\n\n  user-select: none;\n  transition: @transition;\n  will-change: @willChange;\n\n  -webkit-tap-highlight-color: @tapColor;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.button:hover {\n  background-color: @hoverBackgroundColor;\n  background-image: @hoverBackgroundImage;\n  box-shadow: @hoverBoxShadow;\n  color: @hoverColor;\n}\n\n.ui.button:hover .icon {\n  opacity: @iconHoverOpacity;\n}\n\n/*--------------\n      Focus\n---------------*/\n\n.ui.button:focus {\n  background-color: @focusBackgroundColor;\n  color: @focusColor;\n  background-image: @focusBackgroundImage !important;\n  box-shadow: @focusBoxShadow !important;\n}\n\n.ui.button:focus .icon {\n  opacity: @iconFocusOpacity;\n}\n\n/*--------------\n      Down\n---------------*/\n\n.ui.button:active,\n.ui.active.button:active {\n  background-color: @downBackgroundColor;\n  background-image: @downBackgroundImage;\n  color: @downColor;\n  box-shadow: @downBoxShadow;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.button {\n  background-color: @activeBackgroundColor;\n  background-image: @activeBackgroundImage;\n  box-shadow: @activeBoxShadow;\n  color: @activeColor;\n}\n.ui.active.button:hover {\n  background-color: @activeHoverBackgroundColor;\n  background-image: @activeHoverBackgroundImage;\n  color: @activeHoverColor;\n}\n.ui.active.button:active {\n  background-color: @activeBackgroundColor;\n  background-image: @activeBackgroundImage;\n}\n\n\n/*--------------\n    Loading\n---------------*/\n\n/* Specificity hack */\n.ui.loading.loading.loading.loading.loading.loading.button {\n  position: relative;\n  cursor: default;\n  text-shadow: none !important;\n  color: transparent !important;\n  opacity: @loadingOpacity;\n  pointer-events: @loadingPointerEvents;\n  transition: @loadingTransition;\n}\n.ui.loading.button:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @invertedLoaderFillColor;\n}\n.ui.loading.button:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: button-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @invertedLoaderLineColor transparent transparent;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n.ui.labeled.icon.loading.button .icon {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n@keyframes button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ui.basic.loading.button:not(.inverted):before {\n  border-color: @loaderFillColor;\n}\n.ui.basic.loading.button:not(.inverted):after {\n  border-top-color: @loaderLineColor;\n}\n\n/*-------------------\n      Disabled\n--------------------*/\n\n.ui.buttons .disabled.button,\n.ui.disabled.button,\n.ui.button:disabled,\n.ui.disabled.button:hover,\n.ui.disabled.active.button {\n  cursor: default;\n  opacity: @disabledOpacity !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n}\n\n/* Basic Group With Disabled */\n.ui.basic.buttons .ui.disabled.button {\n  border-color: @disabledBorderColor;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n       Animated\n--------------------*/\n\n.ui.animated.button {\n  position: relative;\n  overflow: hidden;\n  padding-right: 0em !important;\n  vertical-align: @animatedVerticalAlign;\n  z-index: @animatedZIndex;\n}\n\n.ui.animated.button .content {\n  will-change: transform, opacity;\n}\n.ui.animated.button .visible.content {\n  position: relative;\n  margin-right: @horizontalPadding;\n}\n.ui.animated.button .hidden.content {\n  position: absolute;\n  width: 100%;\n}\n\n/* Horizontal */\n.ui.animated.button .visible.content,\n.ui.animated.button .hidden.content {\n  transition: right @animationDuration @animationEasing 0s;\n}\n.ui.animated.button .visible.content {\n  left: auto;\n  right: 0%;\n}\n.ui.animated.button .hidden.content {\n  top: 50%;\n  left: auto;\n  right: -100%;\n  margin-top: -(@lineHeight / 2);\n}\n.ui.animated.button:focus .visible.content,\n.ui.animated.button:hover .visible.content {\n  left: auto;\n  right: 200%;\n}\n.ui.animated.button:focus .hidden.content,\n.ui.animated.button:hover .hidden.content {\n  left: auto;\n  right: 0%;\n}\n\n/* Vertical */\n.ui.vertical.animated.button .visible.content,\n.ui.vertical.animated.button .hidden.content {\n  transition: top @animationDuration @animationEasing, transform @animationDuration @animationEasing;\n}\n.ui.vertical.animated.button .visible.content {\n  transform: translateY(0%);\n  right: auto;\n}\n.ui.vertical.animated.button .hidden.content {\n  top: -50%;\n  left: 0%;\n  right: auto;\n}\n.ui.vertical.animated.button:focus .visible.content,\n.ui.vertical.animated.button:hover .visible.content {\n  transform: translateY(200%);\n  right: auto;\n}\n.ui.vertical.animated.button:focus .hidden.content,\n.ui.vertical.animated.button:hover .hidden.content {\n  top: 50%;\n  right: auto;\n}\n\n/* Fade */\n.ui.fade.animated.button .visible.content,\n.ui.fade.animated.button .hidden.content {\n  transition: opacity @animationDuration @animationEasing, transform @animationDuration @animationEasing;\n}\n.ui.fade.animated.button .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 1;\n  transform: scale(1);\n}\n.ui.fade.animated.button .hidden.content {\n  opacity: 0;\n  left: 0%;\n  right: auto;\n  transform: scale(@fadeScaleHigh);\n}\n.ui.fade.animated.button:focus .visible.content,\n.ui.fade.animated.button:hover .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 0;\n  transform: scale(@fadeScaleLow);\n}\n.ui.fade.animated.button:focus .hidden.content,\n.ui.fade.animated.button:hover .hidden.content {\n  left: 0%;\n  right: auto;\n  opacity: 1;\n  transform: scale(1);\n}\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @white inset !important;\n  background: transparent none;\n  color: @white;\n  text-shadow: none !important;\n}\n\n/* Group */\n.ui.inverted.buttons .button {\n  margin: @invertedGroupButtonOffset;\n}\n.ui.inverted.buttons .button:first-child {\n  margin-left: 0em;\n}\n.ui.inverted.vertical.buttons .button {\n  margin: @invertedVerticalGroupButtonOffset;\n}\n.ui.inverted.vertical.buttons .button:first-child {\n  margin-top: 0em;\n}\n\n/* States */\n\n/* Hover */\n.ui.inverted.button:hover {\n  background: @white;\n  box-shadow: 0px 0px 0px @invertedBorderSize @white inset !important;\n  color: @hoverColor;\n}\n\n/* Active / Focus */\n.ui.inverted.button:focus,\n.ui.inverted.button.active {\n  background: @white;\n  box-shadow: 0px 0px 0px @invertedBorderSize @white inset !important;\n  color: @focusColor;\n}\n\n/* Active Focus */\n.ui.inverted.button.active:focus {\n  background: @midWhite;\n  box-shadow: 0px 0px 0px @invertedBorderSize @midWhite inset !important;\n  color: @focusColor;\n}\n\n\n/*-------------------\n    Labeled Button\n--------------------*/\n\n.ui.labeled.button:not(.icon) {\n  display: inline-flex;\n  flex-direction: row;\n  background: none !important;\n  padding: 0px !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.ui.labeled.button > .button {\n  margin: 0px;\n}\n.ui.labeled.button > .label {\n  display: flex;\n  align-items: @labeledLabelAlign;\n  margin: 0px 0px 0px @labeledLabelBorderOffset !important;\n  font-size: @labeledLabelFontSize;\n  padding: @labeledLabelPadding;\n  font-size: @labeledLabelFontSize;\n  border-color: @labeledLabelBorderColor;\n}\n\n/* Tag */\n.ui.labeled.button > .tag.label:before {\n  width: @labeledTagLabelSize;\n  height: @labeledTagLabelSize;\n}\n\n/* Right */\n.ui.labeled.button:not([class*=\"left labeled\"]) > .button {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.ui.labeled.button:not([class*=\"left labeled\"]) > .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n/* Left Side */\n.ui[class*=\"left labeled\"].button > .button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n.ui[class*=\"left labeled\"].button > .label {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n/*-------------------\n       Social\n--------------------*/\n\n/* Facebook */\n.ui.facebook.button {\n  background-color: @facebookColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.facebook.button:hover {\n  background-color: @facebookHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.facebook.button:active {\n  background-color: @facebookDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* Twitter */\n.ui.twitter.button {\n  background-color: @twitterColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.twitter.button:hover {\n  background-color: @twitterHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.twitter.button:active {\n  background-color: @twitterDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* Google Plus */\n.ui.google.plus.button {\n  background-color: @googlePlusColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.google.plus.button:hover {\n  background-color: @googlePlusHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.google.plus.button:active {\n  background-color: @googlePlusDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* Linked In */\n.ui.linkedin.button {\n  background-color: @linkedInColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.linkedin.button:hover {\n  background-color: @linkedInHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.linkedin.button:active {\n  background-color: @linkedInDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* YouTube */\n.ui.youtube.button {\n  background-color: @youtubeColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.youtube.button:hover {\n  background-color: @youtubeHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.youtube.button:active {\n  background-color: @youtubeDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* Instagram */\n.ui.instagram.button {\n  background-color: @instagramColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.instagram.button:hover {\n  background-color: @instagramHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.instagram.button:active {\n  background-color: @instagramDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* Pinterest */\n.ui.pinterest.button {\n  background-color: @pinterestColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.pinterest.button:hover {\n  background-color: @pinterestHoverColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n.ui.pinterest.button:active {\n  background-color: @pinterestDownColor;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n}\n\n/* VK */\n.ui.vk.button {\n  background-color: #4D7198;\n  color: @white;\n  background-image: @coloredBackgroundImage;\n  box-shadow: @coloredBoxShadow;\n}\n.ui.vk.button:hover {\n  background-color: @vkHoverColor;\n  color: @white;\n}\n.ui.vk.button:active {\n  background-color: @vkDownColor;\n  color: @white;\n}\n\n/*--------------\n     Icon\n---------------*/\n\n.ui.button > .icon:not(.button) {\n  height: @iconHeight;\n  opacity: @iconOpacity;\n  margin: @iconMargin;\n  transition: @iconTransition;\n  vertical-align: @iconVerticalAlign;\n  color: @iconColor;\n}\n\n.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {\n  margin: @iconMargin;\n}\n.ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {\n  margin: @rightIconMargin;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui[class*=\"left floated\"].buttons,\n.ui[class*=\"left floated\"].button {\n  float: left;\n  margin-left: 0em;\n  margin-right: @floatedMargin;\n}\n.ui[class*=\"right floated\"].buttons,\n.ui[class*=\"right floated\"].button {\n  float: right;\n  margin-right: 0em;\n  margin-left: @floatedMargin;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.buttons .button,\n.ui.compact.button {\n  padding: @compactVerticalPadding @compactHorizontalPadding ( @compactVerticalPadding + @shadowOffset );\n}\n.ui.compact.icon.buttons .button,\n.ui.compact.icon.button {\n  padding: @compactVerticalPadding @compactVerticalPadding ( @compactVerticalPadding + @shadowOffset );\n}\n.ui.compact.labeled.icon.buttons .button,\n.ui.compact.labeled.icon.button {\n  padding: @compactVerticalPadding (@compactHorizontalPadding + @labeledIconWidth) ( @compactVerticalPadding + @shadowOffset );\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.buttons .button,\n.ui.mini.buttons .or,\n.ui.mini.button {\n  font-size: @mini;\n}\n.ui.tiny.buttons .button,\n.ui.tiny.buttons .or,\n.ui.tiny.button {\n  font-size: @tiny;\n}\n.ui.small.buttons .button,\n.ui.small.buttons .or,\n.ui.small.button {\n  font-size: @small;\n}\n.ui.buttons .button,\n.ui.buttons .or,\n.ui.button {\n  font-size: @medium;\n}\n.ui.large.buttons .button,\n.ui.large.buttons .or,\n.ui.large.button {\n  font-size: @large;\n}\n.ui.big.buttons .button,\n.ui.big.buttons .or,\n.ui.big.button {\n  font-size: @big;\n}\n.ui.huge.buttons .button,\n.ui.huge.buttons .or,\n.ui.huge.button {\n  font-size: @huge;\n}\n.ui.massive.buttons .button,\n.ui.massive.buttons .or,\n.ui.massive.button {\n  font-size: @massive;\n}\n\n/*--------------\n    Icon Only\n---------------*/\n\n.ui.icon.buttons .button,\n.ui.icon.button {\n  padding: @verticalPadding @verticalPadding ( @verticalPadding + @shadowOffset );\n}\n.ui.icon.buttons .button > .icon,\n.ui.icon.button > .icon {\n  opacity: @iconButtonOpacity;\n  margin: 0em !important;\n  vertical-align: top;\n}\n\n\n/*-------------------\n        Basic\n--------------------*/\n\n.ui.basic.buttons .button,\n.ui.basic.button {\n  background: @basicBackground !important;\n  color: @basicTextColor !important;\n  font-weight: @basicFontWeight;\n  border-radius: @basicBorderRadius;\n  text-transform: @basicTextTransform;\n  text-shadow: none !important;\n  box-shadow: @basicBoxShadow;\n}\n.ui.basic.buttons {\n  box-shadow: @basicGroupBoxShadow;\n  border: @basicGroupBorder;\n  border-radius: @borderRadius;\n}\n.ui.basic.buttons .button {\n  border-radius: 0em;\n}\n\n.ui.basic.buttons .button:hover,\n.ui.basic.button:hover {\n  background: @basicHoverBackground !important;\n  color: @basicHoverTextColor !important;\n  box-shadow: @basicHoverBoxShadow;\n}\n.ui.basic.buttons .button:focus,\n.ui.basic.button:focus {\n  background: @basicFocusBackground !important;\n  color: @basicFocusTextColor !important;\n  box-shadow: @basicFocusBoxShadow;\n}\n.ui.basic.buttons .button:active,\n.ui.basic.button:active {\n  background: @basicDownBackground !important;\n  color: @basicDownTextColor !important;\n  box-shadow: @basicDownBoxShadow;\n}\n.ui.basic.buttons .active.button,\n.ui.basic.active.button {\n  background: @basicActiveBackground !important;\n  box-shadow: @basicActiveBoxShadow !important;\n  color: @basicActiveTextColor !important;\n}\n.ui.basic.buttons .active.button:hover,\n.ui.basic.active.button:hover {\n  background-color: @transparentBlack;\n}\n\n/* Vertical */\n.ui.basic.buttons .button:hover {\n  box-shadow: @basicHoverBoxShadow inset;\n}\n.ui.basic.buttons .button:active {\n  box-shadow: @basicDownBoxShadow inset;\n}\n.ui.basic.buttons .active.button {\n  box-shadow: @basicActiveBoxShadow !important;\n}\n\n/* Standard Basic Inverted */\n.ui.basic.inverted.buttons .button,\n.ui.basic.inverted.button {\n  background-color: transparent !important;\n  color: @offWhite !important;\n  box-shadow: @basicInvertedBoxShadow !important;\n}\n.ui.basic.inverted.buttons .button:hover,\n.ui.basic.inverted.button:hover {\n  color: @white !important;\n  box-shadow: @basicInvertedHoverBoxShadow !important;\n}\n.ui.basic.inverted.buttons .button:focus,\n.ui.basic.inverted.button:focus {\n  color: @white !important;\n  box-shadow: @basicInvertedFocusBoxShadow !important;\n}\n.ui.basic.inverted.buttons .button:active,\n.ui.basic.inverted.button:active {\n  background-color: @transparentWhite !important;\n  color: @white !important;\n  box-shadow: @basicInvertedDownBoxShadow !important;\n}\n.ui.basic.inverted.buttons .active.button,\n.ui.basic.inverted.active.button {\n  background-color: @transparentWhite;\n  color: @invertedTextColor;\n  text-shadow: @invertedTextShadow;\n  box-shadow: @basicInvertedActiveBoxShadow;\n}\n.ui.basic.inverted.buttons .active.button:hover,\n.ui.basic.inverted.active.button:hover {\n  background-color: @strongTransparentWhite;\n  box-shadow: @basicInvertedHoverBoxShadow !important;\n}\n\n\n/* Basic Group */\n.ui.basic.buttons .button {\n  border-left: @basicGroupBorder;\n  box-shadow: none;\n}\n.ui.basic.vertical.buttons .button {\n  border-left: none;\n}\n.ui.basic.vertical.buttons .button {\n  border-left-width: 0px;\n  border-top: @basicGroupBorder;\n}\n.ui.basic.vertical.buttons .button:first-child {\n  border-top-width: 0px;\n}\n\n\n\n/*--------------\n  Labeled Icon\n---------------*/\n\n.ui.labeled.icon.buttons .button,\n.ui.labeled.icon.button {\n  position: relative;\n  padding-left: @labeledIconPadding !important;\n  padding-right: @horizontalPadding !important;\n}\n\n/* Left Labeled */\n.ui.labeled.icon.buttons > .button > .icon,\n.ui.labeled.icon.button > .icon {\n  position: absolute;\n  height: 100%;\n  line-height: 1;\n  border-radius: 0px;\n  border-top-left-radius: inherit;\n  border-bottom-left-radius: inherit;\n  text-align: center;\n\n  margin: @labeledIconMargin;\n  width: @labeledIconWidth;\n  background-color: @labeledIconBackgroundColor;\n  color: @labeledIconColor;\n  box-shadow: @labeledIconLeftShadow;\n}\n\n/* Left Labeled */\n.ui.labeled.icon.buttons > .button > .icon,\n.ui.labeled.icon.button > .icon {\n  top: 0em;\n  left: 0em;\n}\n\n/* Right Labeled */\n.ui[class*=\"right labeled\"].icon.button {\n  padding-right: @labeledIconPadding !important;\n  padding-left: @horizontalPadding !important;\n}\n.ui[class*=\"right labeled\"].icon.button > .icon {\n  left: auto;\n  right: 0em;\n  border-radius: 0px;\n  border-top-right-radius: inherit;\n  border-bottom-right-radius: inherit;\n  box-shadow: @labeledIconRightShadow;\n}\n\n\n.ui.labeled.icon.buttons > .button > .icon:before,\n.ui.labeled.icon.button > .icon:before,\n.ui.labeled.icon.buttons > .button > .icon:after,\n.ui.labeled.icon.button > .icon:after {\n  display: block;\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  text-align: center;\n  transform: translateY(-50%);\n}\n\n/* Loading */\n.ui.labeled.icon.button > .icon.loading {\n  animation: none;\n}\n.ui.labeled.icon.button > .icon.loading:before {\n  animation: labeled-button-icon-loading @loadingIconDuration linear infinite;\n}\n\n@keyframes labeled-button-icon-loading {\n  from {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n\n.ui.labeled.icon.buttons .button > .icon {\n  border-radius: 0em;\n}\n.ui.labeled.icon.buttons .button:first-child > .icon {\n  border-top-left-radius: @borderRadius;\n  border-bottom-left-radius: @borderRadius;\n}\n.ui.labeled.icon.buttons .button:last-child > .icon {\n  border-top-right-radius: @borderRadius;\n  border-bottom-right-radius: @borderRadius;\n}\n.ui.vertical.labeled.icon.buttons .button:first-child > .icon {\n  border-radius: 0em;\n  border-top-left-radius: @borderRadius;\n}\n.ui.vertical.labeled.icon.buttons .button:last-child > .icon {\n  border-radius: 0em;\n  border-bottom-left-radius: @borderRadius;\n}\n\n/* Fluid Labeled */\n.ui.fluid[class*=\"left labeled\"].icon.button,\n.ui.fluid[class*=\"right labeled\"].icon.button {\n  padding-left: @horizontalPadding !important;\n  padding-right: @horizontalPadding !important;\n}\n\n\n\n\n/*--------------\n     Toggle\n---------------*/\n\n/* Toggle (Modifies active state to give affordances) */\n.ui.toggle.buttons .active.button,\n.ui.buttons .button.toggle.active,\n.ui.button.toggle.active {\n  background-color: @positiveColor !important;\n  box-shadow: none !important;\n  text-shadow: @invertedTextShadow;\n  color: @invertedTextColor !important;\n}\n.ui.button.toggle.active:hover {\n  background-color: @positiveColorHover !important;\n  text-shadow: @invertedTextShadow;\n  color: @invertedTextColor !important;\n}\n\n/*--------------\n    Circular\n---------------*/\n\n.ui.circular.button {\n  border-radius: 10em;\n}\n.ui.circular.button > .icon {\n  width: 1em;\n  vertical-align: baseline;\n}\n\n\n/*-------------------\n      Or Buttons\n--------------------*/\n\n.ui.buttons .or {\n  position: relative;\n  width: @orGap;\n  height: @orHeight;\n  z-index: @orZIndex;\n}\n.ui.buttons .or:before {\n  position: absolute;\n  text-align: center;\n  border-radius: @circularRadius;\n\n  content: @orText;\n  top: 50%;\n  left: 50%;\n  background-color: @orBackgroundColor;\n  text-shadow: @orTextShadow;\n\n  margin-top: @orVerticalOffset;\n  margin-left: @orHorizontalOffset;\n\n  width: @orCircleSize;\n  height: @orCircleSize;\n\n  line-height: @orLineHeight;\n  color: @orTextColor;\n\n  font-style: @orTextStyle;\n  font-weight: @orTextWeight;\n\n  box-shadow: @orBoxShadow;\n}\n.ui.buttons .or[data-text]:before {\n  content: attr(data-text);\n}\n\n/* Fluid Or */\n.ui.fluid.buttons .or {\n  width: 0em !important;\n}\n.ui.fluid.buttons .or:after {\n  display: none;\n}\n\n\n/*-------------------\n       Attached\n--------------------*/\n\n\n/* Singular */\n.ui.attached.button {\n  position: relative;\n  display: block;\n  margin: 0em;\n  border-radius: 0em;\n  box-shadow: @attachedBoxShadow !important;\n}\n\n/* Top / Bottom */\n.ui.attached.top.button {\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui.attached.bottom.button {\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n\n/* Left / Right */\n.ui.left.attached.button {\n  display: inline-block;\n  border-left: none;\n  text-align: right;\n\n  padding-right: @attachedHorizontalPadding;\n  border-radius: @borderRadius 0em 0em @borderRadius;\n}\n.ui.right.attached.button {\n  display: inline-block;\n  text-align: left;\n  padding-left: @attachedHorizontalPadding;\n  border-radius: 0em @borderRadius @borderRadius 0em;\n}\n\n/* Plural */\n.ui.attached.buttons {\n  position: relative;\n  display: flex;\n  border-radius: 0em;\n  width: auto !important;\n  z-index: @attachedZIndex;\n  margin-left: @attachedOffset;\n  margin-right: @attachedOffset;\n}\n.ui.attached.buttons .button {\n  margin: 0em;\n}\n.ui.attached.buttons .button:first-child {\n  border-radius: 0em;\n}\n.ui.attached.buttons .button:last-child {\n  border-radius: 0em;\n}\n\n/* Top / Bottom */\n.ui[class*=\"top attached\"].buttons {\n  margin-bottom: @attachedOffset;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui[class*=\"top attached\"].buttons .button:first-child {\n  border-radius: @borderRadius 0em 0em 0em;\n}\n.ui[class*=\"top attached\"].buttons .button:last-child {\n  border-radius: 0em @borderRadius 0em 0em;\n}\n\n.ui[class*=\"bottom attached\"].buttons {\n  margin-top: @attachedOffset;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n.ui[class*=\"bottom attached\"].buttons .button:first-child {\n  border-radius: 0em 0em 0em @borderRadius;\n}\n.ui[class*=\"bottom attached\"].buttons .button:last-child {\n  border-radius: 0em 0em @borderRadius 0em;\n}\n\n/* Left / Right */\n.ui[class*=\"left attached\"].buttons {\n  display: inline-flex;\n  margin-right: 0em;\n  margin-left: @attachedOffset;\n  border-radius: 0em @borderRadius @borderRadius 0em;\n}\n.ui[class*=\"left attached\"].buttons .button:first-child {\n  margin-left: @attachedOffset;\n  border-radius: 0em @borderRadius 0em 0em;\n}\n.ui[class*=\"left attached\"].buttons .button:last-child {\n  margin-left: @attachedOffset;\n  border-radius: 0em 0em @borderRadius 0em;\n}\n\n.ui[class*=\"right attached\"].buttons {\n  display: inline-flex;\n  margin-left: 0em;\n  margin-right: @attachedOffset;\n  border-radius: @borderRadius 0em 0em @borderRadius;\n}\n.ui[class*=\"right attached\"].buttons .button:first-child {\n  margin-left: @attachedOffset;\n  border-radius: @borderRadius 0em 0em 0em;\n}\n.ui[class*=\"right attached\"].buttons .button:last-child {\n  margin-left: @attachedOffset;\n  border-radius: 0em 0em 0em @borderRadius;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.buttons,\n.ui.fluid.button {\n  width: 100%;\n}\n.ui.fluid.button {\n  display: block;\n}\n\n.ui.two.buttons {\n  width: 100%;\n}\n.ui.two.buttons > .button {\n  width: 50%;\n}\n\n.ui.three.buttons {\n  width: 100%;\n}\n.ui.three.buttons > .button {\n  width: 33.333%;\n}\n\n.ui.four.buttons {\n  width: 100%;\n}\n.ui.four.buttons > .button {\n  width: 25%;\n}\n\n.ui.five.buttons {\n  width: 100%;\n}\n.ui.five.buttons > .button {\n  width: 20%;\n}\n\n.ui.six.buttons {\n  width: 100%;\n}\n.ui.six.buttons > .button {\n  width: 16.666%;\n}\n\n.ui.seven.buttons {\n  width: 100%;\n}\n.ui.seven.buttons > .button {\n  width: 14.285%;\n}\n\n.ui.eight.buttons {\n  width: 100%;\n}\n.ui.eight.buttons > .button {\n  width: 12.500%;\n}\n\n.ui.nine.buttons {\n  width: 100%;\n}\n.ui.nine.buttons > .button {\n  width: 11.11%;\n}\n\n.ui.ten.buttons {\n  width: 100%;\n}\n.ui.ten.buttons > .button {\n  width: 10%;\n}\n\n.ui.eleven.buttons {\n  width: 100%;\n}\n.ui.eleven.buttons > .button {\n  width: 9.09%;\n}\n\n.ui.twelve.buttons {\n  width: 100%;\n}\n.ui.twelve.buttons > .button {\n  width: 8.3333%;\n}\n\n/* Fluid Vertical Buttons */\n.ui.fluid.vertical.buttons,\n.ui.fluid.vertical.buttons > .button {\n  display: flex;\n  width: auto;\n}\n\n.ui.two.vertical.buttons > .button {\n  height: 50%;\n}\n.ui.three.vertical.buttons > .button {\n  height: 33.333%;\n}\n.ui.four.vertical.buttons > .button {\n  height: 25%;\n}\n.ui.five.vertical.buttons > .button {\n  height: 20%;\n}\n.ui.six.vertical.buttons > .button {\n  height: 16.666%;\n}\n.ui.seven.vertical.buttons > .button {\n  height: 14.285%;\n}\n.ui.eight.vertical.buttons > .button {\n  height: 12.500%;\n}\n.ui.nine.vertical.buttons > .button {\n  height: 11.11%;\n}\n.ui.ten.vertical.buttons > .button {\n  height: 10%;\n}\n.ui.eleven.vertical.buttons > .button {\n  height: 9.09%;\n}\n.ui.twelve.vertical.buttons > .button {\n  height: 8.3333%;\n}\n\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Black ---*/\n.ui.black.buttons .button,\n.ui.black.button {\n  background-color: @black;\n  color: @blackTextColor;\n  text-shadow: @blackTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.black.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.black.buttons .button:hover,\n.ui.black.button:hover {\n  background-color: @blackHover;\n  color: @blackTextColor;\n  text-shadow: @blackTextShadow;\n}\n.ui.black.buttons .button:focus,\n.ui.black.button:focus {\n  background-color: @blackFocus;\n  color: @blackTextColor;\n  text-shadow: @blackTextShadow;\n}\n.ui.black.buttons .button:active,\n.ui.black.button:active {\n  background-color: @blackDown;\n  color: @blackTextColor;\n  text-shadow: @blackTextShadow;\n}\n.ui.black.buttons .active.button,\n.ui.black.buttons .active.button:active,\n.ui.black.active.button,\n.ui.black.button .active.button:active {\n  background-color: @blackActive;\n  color: @blackTextColor;\n  text-shadow: @blackTextShadow;\n}\n\n/* Basic */\n.ui.basic.black.buttons .button,\n.ui.basic.black.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @black inset !important;\n  color: @black !important;\n}\n.ui.basic.black.buttons .button:hover,\n.ui.basic.black.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blackHover inset !important;\n  color: @blackHover !important;\n}\n.ui.basic.black.buttons .button:focus,\n.ui.basic.black.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blackFocus inset !important;\n  color: @blackHover !important;\n}\n.ui.basic.black.buttons .active.button,\n.ui.basic.black.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blackActive inset !important;\n  color: @blackDown !important;\n}\n.ui.basic.black.buttons .button:active,\n.ui.basic.black.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blackDown inset !important;\n  color: @blackDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.black.buttons .button,\n.ui.inverted.black.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @solidBorderColor inset !important;\n  color: @invertedTextColor;\n}\n.ui.inverted.black.buttons .button:hover,\n.ui.inverted.black.button:hover,\n.ui.inverted.black.buttons .button:focus,\n.ui.inverted.black.button:focus,\n.ui.inverted.black.buttons .button.active,\n.ui.inverted.black.button.active,\n.ui.inverted.black.buttons .button:active,\n.ui.inverted.black.button:active {\n  box-shadow: none !important;\n  color: @lightBlackTextColor;\n}\n.ui.inverted.black.buttons .button:hover,\n.ui.inverted.black.button:hover {\n  background-color: @lightBlackHover;\n}\n.ui.inverted.black.buttons .button:focus,\n.ui.inverted.black.button:focus {\n  background-color: @lightBlackFocus;\n}\n.ui.inverted.black.buttons .active.button,\n.ui.inverted.black.active.button {\n  background-color: @lightBlackActive;\n}\n.ui.inverted.black.buttons .button:active,\n.ui.inverted.black.button:active {\n  background-color: @lightBlackDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.black.basic.buttons .button,\n.ui.inverted.black.buttons .basic.button,\n.ui.inverted.black.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.black.basic.buttons .button:hover,\n.ui.inverted.black.buttons .basic.button:hover,\n.ui.inverted.black.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlackHover inset !important;\n  color: @white !important;\n}\n.ui.inverted.black.basic.buttons .button:focus,\n.ui.inverted.black.basic.buttons .button:focus,\n.ui.inverted.black.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlackFocus inset !important;\n  color: @lightBlack !important;\n}\n.ui.inverted.black.basic.buttons .active.button,\n.ui.inverted.black.buttons .basic.active.button,\n.ui.inverted.black.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlackActive inset !important;\n  color: @white !important;\n}\n.ui.inverted.black.basic.buttons .button:active,\n.ui.inverted.black.buttons .basic.button:active,\n.ui.inverted.black.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlackDown inset !important;\n  color: @white !important;\n}\n\n/*--- Grey ---*/\n.ui.grey.buttons .button,\n.ui.grey.button {\n  background-color: @grey;\n  color: @greyTextColor;\n  text-shadow: @greyTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.grey.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.grey.buttons .button:hover,\n.ui.grey.button:hover {\n  background-color: @greyHover;\n  color: @greyTextColor;\n  text-shadow: @greyTextShadow;\n}\n.ui.grey.buttons .button:focus,\n.ui.grey.button:focus {\n  background-color: @greyFocus;\n  color: @greyTextColor;\n  text-shadow: @greyTextShadow;\n}\n.ui.grey.buttons .button:active,\n.ui.grey.button:active {\n  background-color: @greyDown;\n  color: @greyTextColor;\n  text-shadow: @greyTextShadow;\n}\n.ui.grey.buttons .active.button,\n.ui.grey.buttons .active.button:active,\n.ui.grey.active.button,\n.ui.grey.button .active.button:active {\n  background-color: @greyActive;\n  color: @greyTextColor;\n  text-shadow: @greyTextShadow;\n}\n\n/* Basic */\n.ui.basic.grey.buttons .button,\n.ui.basic.grey.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @grey inset !important;\n  color: @grey !important;\n}\n.ui.basic.grey.buttons .button:hover,\n.ui.basic.grey.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greyHover inset !important;\n  color: @greyHover !important;\n}\n.ui.basic.grey.buttons .button:focus,\n.ui.basic.grey.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greyFocus inset !important;\n  color: @greyHover !important;\n}\n.ui.basic.grey.buttons .active.button,\n.ui.basic.grey.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greyActive inset !important;\n  color: @greyDown !important;\n}\n.ui.basic.grey.buttons .button:active,\n.ui.basic.grey.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greyDown inset !important;\n  color: @greyDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.grey.buttons .button,\n.ui.inverted.grey.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @solidBorderColor inset !important;\n  color: @invertedTextColor;\n}\n.ui.inverted.grey.buttons .button:hover,\n.ui.inverted.grey.button:hover,\n.ui.inverted.grey.buttons .button:focus,\n.ui.inverted.grey.button:focus,\n.ui.inverted.grey.buttons .button.active,\n.ui.inverted.grey.button.active,\n.ui.inverted.grey.buttons .button:active,\n.ui.inverted.grey.button:active {\n  box-shadow: none !important;\n  color: @lightGreyTextColor;\n}\n.ui.inverted.grey.buttons .button:hover,\n.ui.inverted.grey.button:hover {\n  background-color: @lightGreyHover;\n}\n.ui.inverted.grey.buttons .button:focus,\n.ui.inverted.grey.button:focus {\n  background-color: @lightGreyFocus;\n}\n.ui.inverted.grey.buttons .active.button,\n.ui.inverted.grey.active.button {\n  background-color: @lightGreyActive;\n}\n.ui.inverted.grey.buttons .button:active,\n.ui.inverted.grey.button:active {\n  background-color: @lightGreyDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.grey.basic.buttons .button,\n.ui.inverted.grey.buttons .basic.button,\n.ui.inverted.grey.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.grey.basic.buttons .button:hover,\n.ui.inverted.grey.buttons .basic.button:hover,\n.ui.inverted.grey.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreyHover inset !important;\n  color: @white !important;\n}\n.ui.inverted.grey.basic.buttons .button:focus,\n.ui.inverted.grey.basic.buttons .button:focus,\n.ui.inverted.grey.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreyFocus inset !important;\n  color: @lightGrey !important;\n}\n.ui.inverted.grey.basic.buttons .active.button,\n.ui.inverted.grey.buttons .basic.active.button,\n.ui.inverted.grey.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreyActive inset !important;\n  color: @white !important;\n}\n.ui.inverted.grey.basic.buttons .button:active,\n.ui.inverted.grey.buttons .basic.button:active,\n.ui.inverted.grey.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreyDown inset !important;\n  color: @white !important;\n}\n\n\n/*--- Brown ---*/\n.ui.brown.buttons .button,\n.ui.brown.button {\n  background-color: @brown;\n  color: @brownTextColor;\n  text-shadow: @brownTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.brown.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.brown.buttons .button:hover,\n.ui.brown.button:hover {\n  background-color: @brownHover;\n  color: @brownTextColor;\n  text-shadow: @brownTextShadow;\n}\n.ui.brown.buttons .button:focus,\n.ui.brown.button:focus {\n  background-color: @brownFocus;\n  color: @brownTextColor;\n  text-shadow: @brownTextShadow;\n}\n.ui.brown.buttons .button:active,\n.ui.brown.button:active {\n  background-color: @brownDown;\n  color: @brownTextColor;\n  text-shadow: @brownTextShadow;\n}\n.ui.brown.buttons .active.button,\n.ui.brown.buttons .active.button:active,\n.ui.brown.active.button,\n.ui.brown.button .active.button:active {\n  background-color: @brownActive;\n  color: @brownTextColor;\n  text-shadow: @brownTextShadow;\n}\n\n/* Basic */\n.ui.basic.brown.buttons .button,\n.ui.basic.brown.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @brown inset !important;\n  color: @brown !important;\n}\n.ui.basic.brown.buttons .button:hover,\n.ui.basic.brown.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @brownHover inset !important;\n  color: @brownHover !important;\n}\n.ui.basic.brown.buttons .button:focus,\n.ui.basic.brown.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @brownFocus inset !important;\n  color: @brownHover !important;\n}\n.ui.basic.brown.buttons .active.button,\n.ui.basic.brown.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @brownActive inset !important;\n  color: @brownDown !important;\n}\n.ui.basic.brown.buttons .button:active,\n.ui.basic.brown.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @brownDown inset !important;\n  color: @brownDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.brown.buttons .button,\n.ui.inverted.brown.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBrown inset !important;\n  color: @lightBrown;\n}\n.ui.inverted.brown.buttons .button:hover,\n.ui.inverted.brown.button:hover,\n.ui.inverted.brown.buttons .button:focus,\n.ui.inverted.brown.button:focus,\n.ui.inverted.brown.buttons .button.active,\n.ui.inverted.brown.button.active,\n.ui.inverted.brown.buttons .button:active,\n.ui.inverted.brown.button:active {\n  box-shadow: none !important;\n  color: @lightBrownTextColor;\n}\n.ui.inverted.brown.buttons .button:hover,\n.ui.inverted.brown.button:hover {\n  background-color: @lightBrownHover;\n}\n.ui.inverted.brown.buttons .button:focus,\n.ui.inverted.brown.button:focus {\n  background-color: @lightBrownFocus;\n}\n.ui.inverted.brown.buttons .active.button,\n.ui.inverted.brown.active.button {\n  background-color: @lightBrownActive;\n}\n.ui.inverted.brown.buttons .button:active,\n.ui.inverted.brown.button:active {\n  background-color: @lightBrownDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.brown.basic.buttons .button,\n.ui.inverted.brown.buttons .basic.button,\n.ui.inverted.brown.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.brown.basic.buttons .button:hover,\n.ui.inverted.brown.buttons .basic.button:hover,\n.ui.inverted.brown.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBrownHover inset !important;\n  color: @lightBrown !important;\n}\n.ui.inverted.brown.basic.buttons .button:focus,\n.ui.inverted.brown.basic.buttons .button:focus,\n.ui.inverted.brown.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBrownFocus inset !important;\n  color: @lightBrown !important;\n}\n.ui.inverted.brown.basic.buttons .active.button,\n.ui.inverted.brown.buttons .basic.active.button,\n.ui.inverted.brown.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBrownActive inset !important;\n  color: @lightBrown !important;\n}\n.ui.inverted.brown.basic.buttons .button:active,\n.ui.inverted.brown.buttons .basic.button:active,\n.ui.inverted.brown.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBrownDown inset !important;\n  color: @lightBrown !important;\n}\n\n/*--- Blue ---*/\n.ui.blue.buttons .button,\n.ui.blue.button {\n  background-color: @blue;\n  color: @blueTextColor;\n  text-shadow: @blueTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.blue.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.blue.buttons .button:hover,\n.ui.blue.button:hover {\n  background-color: @blueHover;\n  color: @blueTextColor;\n  text-shadow: @blueTextShadow;\n}\n.ui.blue.buttons .button:focus,\n.ui.blue.button:focus {\n  background-color: @blueFocus;\n  color: @blueTextColor;\n  text-shadow: @blueTextShadow;\n}\n.ui.blue.buttons .button:active,\n.ui.blue.button:active {\n  background-color: @blueDown;\n  color: @blueTextColor;\n  text-shadow: @blueTextShadow;\n}\n.ui.blue.buttons .active.button,\n.ui.blue.buttons .active.button:active,\n.ui.blue.active.button,\n.ui.blue.button .active.button:active {\n  background-color: @blueActive;\n  color: @blueTextColor;\n  text-shadow: @blueTextShadow;\n}\n\n/* Basic */\n.ui.basic.blue.buttons .button,\n.ui.basic.blue.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @blue inset !important;\n  color: @blue !important;\n}\n.ui.basic.blue.buttons .button:hover,\n.ui.basic.blue.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blueHover inset !important;\n  color: @blueHover !important;\n}\n.ui.basic.blue.buttons .button:focus,\n.ui.basic.blue.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blueFocus inset !important;\n  color: @blueHover !important;\n}\n.ui.basic.blue.buttons .active.button,\n.ui.basic.blue.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blueActive inset !important;\n  color: @blueDown !important;\n}\n.ui.basic.blue.buttons .button:active,\n.ui.basic.blue.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @blueDown inset !important;\n  color: @blueDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.blue.buttons .button,\n.ui.inverted.blue.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlue inset !important;\n  color: @lightBlue;\n}\n.ui.inverted.blue.buttons .button:hover,\n.ui.inverted.blue.button:hover,\n.ui.inverted.blue.buttons .button:focus,\n.ui.inverted.blue.button:focus,\n.ui.inverted.blue.buttons .button.active,\n.ui.inverted.blue.button.active,\n.ui.inverted.blue.buttons .button:active,\n.ui.inverted.blue.button:active {\n  box-shadow: none !important;\n  color: @lightBlueTextColor;\n}\n.ui.inverted.blue.buttons .button:hover,\n.ui.inverted.blue.button:hover {\n  background-color: @lightBlueHover;\n}\n.ui.inverted.blue.buttons .button:focus,\n.ui.inverted.blue.button:focus {\n  background-color: @lightBlueFocus;\n}\n.ui.inverted.blue.buttons .active.button,\n.ui.inverted.blue.active.button {\n  background-color: @lightBlueActive;\n}\n.ui.inverted.blue.buttons .button:active,\n.ui.inverted.blue.button:active {\n  background-color: @lightBlueDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.blue.basic.buttons .button,\n.ui.inverted.blue.buttons .basic.button,\n.ui.inverted.blue.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.blue.basic.buttons .button:hover,\n.ui.inverted.blue.buttons .basic.button:hover,\n.ui.inverted.blue.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlueHover inset !important;\n  color: @lightBlue !important;\n}\n.ui.inverted.blue.basic.buttons .button:focus,\n.ui.inverted.blue.basic.buttons .button:focus,\n.ui.inverted.blue.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlueFocus inset !important;\n  color: @lightBlue !important;\n}\n.ui.inverted.blue.basic.buttons .active.button,\n.ui.inverted.blue.buttons .basic.active.button,\n.ui.inverted.blue.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlueActive inset !important;\n  color: @lightBlue !important;\n}\n.ui.inverted.blue.basic.buttons .button:active,\n.ui.inverted.blue.buttons .basic.button:active,\n.ui.inverted.blue.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightBlueDown inset !important;\n  color: @lightBlue !important;\n}\n\n/*--- Green ---*/\n.ui.green.buttons .button,\n.ui.green.button {\n  background-color: @green;\n  color: @greenTextColor;\n  text-shadow: @greenTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.green.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.green.buttons .button:hover,\n.ui.green.button:hover {\n  background-color: @greenHover;\n  color: @greenTextColor;\n  text-shadow: @greenTextShadow;\n}\n.ui.green.buttons .button:focus,\n.ui.green.button:focus {\n  background-color: @greenFocus;\n  color: @greenTextColor;\n  text-shadow: @greenTextShadow;\n}\n.ui.green.buttons .button:active,\n.ui.green.button:active {\n  background-color: @greenDown;\n  color: @greenTextColor;\n  text-shadow: @greenTextShadow;\n}\n.ui.green.buttons .active.button,\n.ui.green.buttons .active.button:active,\n.ui.green.active.button,\n.ui.green.button .active.button:active {\n  background-color: @greenActive;\n  color: @greenTextColor;\n  text-shadow: @greenTextShadow;\n}\n\n\n/* Basic */\n.ui.basic.green.buttons .button,\n.ui.basic.green.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @green inset !important;\n  color: @green !important;\n}\n.ui.basic.green.buttons .button:hover,\n.ui.basic.green.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greenHover inset !important;\n  color: @greenHover !important;\n}\n.ui.basic.green.buttons .button:focus,\n.ui.basic.green.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greenFocus inset !important;\n  color: @greenHover !important;\n}\n.ui.basic.green.buttons .active.button,\n.ui.basic.green.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greenActive inset !important;\n  color: @greenDown !important;\n}\n.ui.basic.green.buttons .button:active,\n.ui.basic.green.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @greenDown inset !important;\n  color: @greenDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.green.buttons .button,\n.ui.inverted.green.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreen inset !important;\n  color: @lightGreen;\n}\n.ui.inverted.green.buttons .button:hover,\n.ui.inverted.green.button:hover,\n.ui.inverted.green.buttons .button:focus,\n.ui.inverted.green.button:focus,\n.ui.inverted.green.buttons .button.active,\n.ui.inverted.green.button.active,\n.ui.inverted.green.buttons .button:active,\n.ui.inverted.green.button:active {\n  box-shadow: none !important;\n  color: @greenTextColor;\n}\n.ui.inverted.green.buttons .button:hover,\n.ui.inverted.green.button:hover {\n  background-color: @lightGreenHover;\n}\n.ui.inverted.green.buttons .button:focus,\n.ui.inverted.green.button:focus {\n  background-color: @lightGreenFocus;\n}\n.ui.inverted.green.buttons .active.button,\n.ui.inverted.green.active.button {\n  background-color: @lightGreenActive;\n}\n.ui.inverted.green.buttons .button:active,\n.ui.inverted.green.button:active {\n  background-color: @lightGreenDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.green.basic.buttons .button,\n.ui.inverted.green.buttons .basic.button,\n.ui.inverted.green.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.green.basic.buttons .button:hover,\n.ui.inverted.green.buttons .basic.button:hover,\n.ui.inverted.green.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreenHover inset !important;\n  color: @lightGreen !important;\n}\n.ui.inverted.green.basic.buttons .button:focus,\n.ui.inverted.green.basic.buttons .button:focus,\n.ui.inverted.green.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreenFocus inset !important;\n  color: @lightGreen !important;\n}\n.ui.inverted.green.basic.buttons .active.button,\n.ui.inverted.green.buttons .basic.active.button,\n.ui.inverted.green.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreenActive inset !important;\n  color: @lightGreen !important;\n}\n.ui.inverted.green.basic.buttons .button:active,\n.ui.inverted.green.buttons .basic.button:active,\n.ui.inverted.green.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightGreenDown inset !important;\n  color: @lightGreen !important;\n}\n\n/*--- Orange ---*/\n.ui.orange.buttons .button,\n.ui.orange.button {\n  background-color: @orange;\n  color: @orangeTextColor;\n  text-shadow: @orangeTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.orange.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.orange.buttons .button:hover,\n.ui.orange.button:hover {\n  background-color: @orangeHover;\n  color: @orangeTextColor;\n  text-shadow: @orangeTextShadow;\n}\n.ui.orange.buttons .button:focus,\n.ui.orange.button:focus {\n  background-color: @orangeFocus;\n  color: @orangeTextColor;\n  text-shadow: @orangeTextShadow;\n}\n.ui.orange.buttons .button:active,\n.ui.orange.button:active {\n  background-color: @orangeDown;\n  color: @orangeTextColor;\n  text-shadow: @orangeTextShadow;\n}\n.ui.orange.buttons .active.button,\n.ui.orange.buttons .active.button:active,\n.ui.orange.active.button,\n.ui.orange.button .active.button:active {\n  background-color: @orangeActive;\n  color: @orangeTextColor;\n  text-shadow: @orangeTextShadow;\n}\n\n/* Basic */\n.ui.basic.orange.buttons .button,\n.ui.basic.orange.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @orange inset !important;\n  color: @orange !important;\n}\n.ui.basic.orange.buttons .button:hover,\n.ui.basic.orange.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @orangeHover inset !important;\n  color: @orangeHover !important;\n}\n.ui.basic.orange.buttons .button:focus,\n.ui.basic.orange.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @orangeFocus inset !important;\n  color: @orangeHover !important;\n}\n.ui.basic.orange.buttons .active.button,\n.ui.basic.orange.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @orangeActive inset !important;\n  color: @orangeDown !important;\n}\n.ui.basic.orange.buttons .button:active,\n.ui.basic.orange.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @orangeDown inset !important;\n  color: @orangeDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.orange.buttons .button,\n.ui.inverted.orange.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOrange inset !important;\n  color: @lightOrange;\n}\n.ui.inverted.orange.buttons .button:hover,\n.ui.inverted.orange.button:hover,\n.ui.inverted.orange.buttons .button:focus,\n.ui.inverted.orange.button:focus,\n.ui.inverted.orange.buttons .button.active,\n.ui.inverted.orange.button.active,\n.ui.inverted.orange.buttons .button:active,\n.ui.inverted.orange.button:active {\n  box-shadow: none !important;\n  color: @lightOrangeTextColor;\n}\n.ui.inverted.orange.buttons .button:hover,\n.ui.inverted.orange.button:hover {\n  background-color: @lightOrangeHover;\n}\n.ui.inverted.orange.buttons .button:focus,\n.ui.inverted.orange.button:focus {\n  background-color: @lightOrangeFocus;\n}\n.ui.inverted.orange.buttons .active.button,\n.ui.inverted.orange.active.button {\n  background-color: @lightOrangeActive;\n}\n.ui.inverted.orange.buttons .button:active,\n.ui.inverted.orange.button:active {\n  background-color: @lightOrangeDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.orange.basic.buttons .button,\n.ui.inverted.orange.buttons .basic.button,\n.ui.inverted.orange.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.orange.basic.buttons .button:hover,\n.ui.inverted.orange.buttons .basic.button:hover,\n.ui.inverted.orange.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOrangeHover inset !important;\n  color: @lightOrange !important;\n}\n.ui.inverted.orange.basic.buttons .button:focus,\n.ui.inverted.orange.basic.buttons .button:focus,\n.ui.inverted.orange.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOrangeFocus inset !important;\n  color: @lightOrange !important;\n}\n.ui.inverted.orange.basic.buttons .active.button,\n.ui.inverted.orange.buttons .basic.active.button,\n.ui.inverted.orange.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOrangeActive inset !important;\n  color: @lightOrange !important;\n}\n.ui.inverted.orange.basic.buttons .button:active,\n.ui.inverted.orange.buttons .basic.button:active,\n.ui.inverted.orange.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOrangeDown inset !important;\n  color: @lightOrange !important;\n}\n\n/*--- Pink ---*/\n.ui.pink.buttons .button,\n.ui.pink.button {\n  background-color: @pink;\n  color: @pinkTextColor;\n  text-shadow: @pinkTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.pink.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.pink.buttons .button:hover,\n.ui.pink.button:hover {\n  background-color: @pinkHover;\n  color: @pinkTextColor;\n  text-shadow: @pinkTextShadow;\n}\n.ui.pink.buttons .button:focus,\n.ui.pink.button:focus {\n  background-color: @pinkFocus;\n  color: @pinkTextColor;\n  text-shadow: @pinkTextShadow;\n}\n.ui.pink.buttons .button:active,\n.ui.pink.button:active {\n  background-color: @pinkDown;\n  color: @pinkTextColor;\n  text-shadow: @pinkTextShadow;\n}\n.ui.pink.buttons .active.button,\n.ui.pink.buttons .active.button:active,\n.ui.pink.active.button,\n.ui.pink.button .active.button:active {\n  background-color: @pinkActive;\n  color: @pinkTextColor;\n  text-shadow: @pinkTextShadow;\n}\n\n/* Basic */\n.ui.basic.pink.buttons .button,\n.ui.basic.pink.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @pink inset !important;\n  color: @pink !important;\n}\n.ui.basic.pink.buttons .button:hover,\n.ui.basic.pink.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @pinkHover inset !important;\n  color: @pinkHover !important;\n}\n.ui.basic.pink.buttons .button:focus,\n.ui.basic.pink.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @pinkFocus inset !important;\n  color: @pinkHover !important;\n}\n.ui.basic.pink.buttons .active.button,\n.ui.basic.pink.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @pinkActive inset !important;\n  color: @pinkDown !important;\n}\n.ui.basic.pink.buttons .button:active,\n.ui.basic.pink.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @pinkDown inset !important;\n  color: @pinkDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.pink.buttons .button,\n.ui.inverted.pink.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPink inset !important;\n  color: @lightPink;\n}\n.ui.inverted.pink.buttons .button:hover,\n.ui.inverted.pink.button:hover,\n.ui.inverted.pink.buttons .button:focus,\n.ui.inverted.pink.button:focus,\n.ui.inverted.pink.buttons .button.active,\n.ui.inverted.pink.button.active,\n.ui.inverted.pink.buttons .button:active,\n.ui.inverted.pink.button:active {\n  box-shadow: none !important;\n  color: @lightPinkTextColor;\n}\n.ui.inverted.pink.buttons .button:hover,\n.ui.inverted.pink.button:hover {\n  background-color: @lightPinkHover;\n}\n.ui.inverted.pink.buttons .button:focus,\n.ui.inverted.pink.button:focus {\n  background-color: @lightPinkFocus;\n}\n.ui.inverted.pink.buttons .active.button,\n.ui.inverted.pink.active.button {\n  background-color: @lightPinkActive;\n}\n.ui.inverted.pink.buttons .button:active,\n.ui.inverted.pink.button:active {\n  background-color: @lightPinkDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.pink.basic.buttons .button,\n.ui.inverted.pink.buttons .basic.button,\n.ui.inverted.pink.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.pink.basic.buttons .button:hover,\n.ui.inverted.pink.buttons .basic.button:hover,\n.ui.inverted.pink.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPinkHover inset !important;\n  color: @lightPink !important;\n}\n.ui.inverted.pink.basic.buttons .button:focus,\n.ui.inverted.pink.basic.buttons .button:focus,\n.ui.inverted.pink.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPinkFocus inset !important;\n  color: @lightPink !important;\n}\n.ui.inverted.pink.basic.buttons .active.button,\n.ui.inverted.pink.buttons .basic.active.button,\n.ui.inverted.pink.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPinkActive inset !important;\n  color: @lightPink !important;\n}\n.ui.inverted.pink.basic.buttons .button:active,\n.ui.inverted.pink.buttons .basic.button:active,\n.ui.inverted.pink.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPinkDown inset !important;\n  color: @lightPink !important;\n}\n\n\n/*--- Violet ---*/\n.ui.violet.buttons .button,\n.ui.violet.button {\n  background-color: @violet;\n  color: @violetTextColor;\n  text-shadow: @violetTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.violet.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.violet.buttons .button:hover,\n.ui.violet.button:hover {\n  background-color: @violetHover;\n  color: @violetTextColor;\n  text-shadow: @violetTextShadow;\n}\n.ui.violet.buttons .button:focus,\n.ui.violet.button:focus {\n  background-color: @violetFocus;\n  color: @violetTextColor;\n  text-shadow: @violetTextShadow;\n}\n.ui.violet.buttons .button:active,\n.ui.violet.button:active {\n  background-color: @violetDown;\n  color: @violetTextColor;\n  text-shadow: @violetTextShadow;\n}\n.ui.violet.buttons .active.button,\n.ui.violet.buttons .active.button:active,\n.ui.violet.active.button,\n.ui.violet.button .active.button:active {\n  background-color: @violetActive;\n  color: @violetTextColor;\n  text-shadow: @violetTextShadow;\n}\n\n/* Basic */\n.ui.basic.violet.buttons .button,\n.ui.basic.violet.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @violet inset !important;\n  color: @violet !important;\n}\n.ui.basic.violet.buttons .button:hover,\n.ui.basic.violet.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @violetHover inset !important;\n  color: @violetHover !important;\n}\n.ui.basic.violet.buttons .button:focus,\n.ui.basic.violet.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @violetFocus inset !important;\n  color: @violetHover !important;\n}\n.ui.basic.violet.buttons .active.button,\n.ui.basic.violet.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @violetActive inset !important;\n  color: @violetDown !important;\n}\n.ui.basic.violet.buttons .button:active,\n.ui.basic.violet.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @violetDown inset !important;\n  color: @violetDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.violet.buttons .button,\n.ui.inverted.violet.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightViolet inset !important;\n  color: @lightViolet;\n}\n.ui.inverted.violet.buttons .button:hover,\n.ui.inverted.violet.button:hover,\n.ui.inverted.violet.buttons .button:focus,\n.ui.inverted.violet.button:focus,\n.ui.inverted.violet.buttons .button.active,\n.ui.inverted.violet.button.active,\n.ui.inverted.violet.buttons .button:active,\n.ui.inverted.violet.button:active {\n  box-shadow: none !important;\n  color: @lightVioletTextColor;\n}\n.ui.inverted.violet.buttons .button:hover,\n.ui.inverted.violet.button:hover {\n  background-color: @lightVioletHover;\n}\n.ui.inverted.violet.buttons .button:focus,\n.ui.inverted.violet.button:focus {\n  background-color: @lightVioletFocus;\n}\n.ui.inverted.violet.buttons .active.button,\n.ui.inverted.violet.active.button {\n  background-color: @lightVioletActive;\n}\n.ui.inverted.violet.buttons .button:active,\n.ui.inverted.violet.button:active {\n  background-color: @lightVioletDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.violet.basic.buttons .button,\n.ui.inverted.violet.buttons .basic.button,\n.ui.inverted.violet.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.violet.basic.buttons .button:hover,\n.ui.inverted.violet.buttons .basic.button:hover,\n.ui.inverted.violet.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightVioletHover inset !important;\n  color: @lightViolet !important;\n}\n.ui.inverted.violet.basic.buttons .button:focus,\n.ui.inverted.violet.basic.buttons .button:focus,\n.ui.inverted.violet.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightVioletFocus inset !important;\n  color: @lightViolet !important;\n}\n.ui.inverted.violet.basic.buttons .active.button,\n.ui.inverted.violet.buttons .basic.active.button,\n.ui.inverted.violet.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightVioletActive inset !important;\n  color: @lightViolet !important;\n}\n.ui.inverted.violet.basic.buttons .button:active,\n.ui.inverted.violet.buttons .basic.button:active,\n.ui.inverted.violet.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightVioletDown inset !important;\n  color: @lightViolet !important;\n}\n\n/*--- Purple ---*/\n.ui.purple.buttons .button,\n.ui.purple.button {\n  background-color: @purple;\n  color: @purpleTextColor;\n  text-shadow: @purpleTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.purple.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.purple.buttons .button:hover,\n.ui.purple.button:hover {\n  background-color: @purpleHover;\n  color: @purpleTextColor;\n  text-shadow: @purpleTextShadow;\n}\n.ui.purple.buttons .button:focus,\n.ui.purple.button:focus {\n  background-color: @purpleFocus;\n  color: @purpleTextColor;\n  text-shadow: @purpleTextShadow;\n}\n.ui.purple.buttons .button:active,\n.ui.purple.button:active {\n  background-color: @purpleDown;\n  color: @purpleTextColor;\n  text-shadow: @purpleTextShadow;\n}\n.ui.purple.buttons .active.button,\n.ui.purple.buttons .active.button:active,\n.ui.purple.active.button,\n.ui.purple.button .active.button:active {\n  background-color: @purpleActive;\n  color: @purpleTextColor;\n  text-shadow: @purpleTextShadow;\n}\n\n/* Basic */\n.ui.basic.purple.buttons .button,\n.ui.basic.purple.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @purple inset !important;\n  color: @purple !important;\n}\n.ui.basic.purple.buttons .button:hover,\n.ui.basic.purple.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @purpleHover inset !important;\n  color: @purpleHover !important;\n}\n.ui.basic.purple.buttons .button:focus,\n.ui.basic.purple.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @purpleFocus inset !important;\n  color: @purpleHover !important;\n}\n.ui.basic.purple.buttons .active.button,\n.ui.basic.purple.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @purpleActive inset !important;\n  color: @purpleDown !important;\n}\n.ui.basic.purple.buttons .button:active,\n.ui.basic.purple.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @purpleDown inset !important;\n  color: @purpleDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.purple.buttons .button,\n.ui.inverted.purple.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPurple inset !important;\n  color: @lightPurple;\n}\n.ui.inverted.purple.buttons .button:hover,\n.ui.inverted.purple.button:hover,\n.ui.inverted.purple.buttons .button:focus,\n.ui.inverted.purple.button:focus,\n.ui.inverted.purple.buttons .button.active,\n.ui.inverted.purple.button.active,\n.ui.inverted.purple.buttons .button:active,\n.ui.inverted.purple.button:active {\n  box-shadow: none !important;\n  color: @lightPurpleTextColor;\n}\n.ui.inverted.purple.buttons .button:hover,\n.ui.inverted.purple.button:hover {\n  background-color: @lightPurpleHover;\n}\n.ui.inverted.purple.buttons .button:focus,\n.ui.inverted.purple.button:focus {\n  background-color: @lightPurpleFocus;\n}\n.ui.inverted.purple.buttons .active.button,\n.ui.inverted.purple.active.button {\n  background-color: @lightPurpleActive;\n}\n.ui.inverted.purple.buttons .button:active,\n.ui.inverted.purple.button:active {\n  background-color: @lightPurpleDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.purple.basic.buttons .button,\n.ui.inverted.purple.buttons .basic.button,\n.ui.inverted.purple.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.purple.basic.buttons .button:hover,\n.ui.inverted.purple.buttons .basic.button:hover,\n.ui.inverted.purple.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPurpleHover inset !important;\n  color: @lightPurple !important;\n}\n.ui.inverted.purple.basic.buttons .button:focus,\n.ui.inverted.purple.basic.buttons .button:focus,\n.ui.inverted.purple.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPurpleFocus inset !important;\n  color: @lightPurple !important;\n}\n.ui.inverted.purple.basic.buttons .active.button,\n.ui.inverted.purple.buttons .basic.active.button,\n.ui.inverted.purple.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPurpleActive inset !important;\n  color: @lightPurple !important;\n}\n.ui.inverted.purple.basic.buttons .button:active,\n.ui.inverted.purple.buttons .basic.button:active,\n.ui.inverted.purple.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPurpleDown inset !important;\n  color: @lightPurple !important;\n}\n\n/*--- Red ---*/\n.ui.red.buttons .button,\n.ui.red.button {\n  background-color: @red;\n  color: @redTextColor;\n  text-shadow: @redTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.red.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.red.buttons .button:hover,\n.ui.red.button:hover {\n  background-color: @redHover;\n  color: @redTextColor;\n  text-shadow: @redTextShadow;\n}\n.ui.red.buttons .button:focus,\n.ui.red.button:focus {\n  background-color: @redFocus;\n  color: @redTextColor;\n  text-shadow: @redTextShadow;\n}\n.ui.red.buttons .button:active,\n.ui.red.button:active {\n  background-color: @redDown;\n  color: @redTextColor;\n  text-shadow: @redTextShadow;\n}\n.ui.red.buttons .active.button,\n.ui.red.buttons .active.button:active,\n.ui.red.active.button,\n.ui.red.button .active.button:active {\n  background-color: @redActive;\n  color: @redTextColor;\n  text-shadow: @redTextShadow;\n}\n\n/* Basic */\n.ui.basic.red.buttons .button,\n.ui.basic.red.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @red inset !important;\n  color: @red !important;\n}\n.ui.basic.red.buttons .button:hover,\n.ui.basic.red.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @redHover inset !important;\n  color: @redHover !important;\n}\n.ui.basic.red.buttons .button:focus,\n.ui.basic.red.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @redFocus inset !important;\n  color: @redHover !important;\n}\n.ui.basic.red.buttons .active.button,\n.ui.basic.red.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @redActive inset !important;\n  color: @redDown !important;\n}\n.ui.basic.red.buttons .button:active,\n.ui.basic.red.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @redDown inset !important;\n  color: @redDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.red.buttons .button,\n.ui.inverted.red.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightRed inset !important;\n  color: @lightRed;\n}\n.ui.inverted.red.buttons .button:hover,\n.ui.inverted.red.button:hover,\n.ui.inverted.red.buttons .button:focus,\n.ui.inverted.red.button:focus,\n.ui.inverted.red.buttons .button.active,\n.ui.inverted.red.button.active,\n.ui.inverted.red.buttons .button:active,\n.ui.inverted.red.button:active {\n  box-shadow: none !important;\n  color: @lightRedTextColor;\n}\n.ui.inverted.red.buttons .button:hover,\n.ui.inverted.red.button:hover {\n  background-color: @lightRedHover;\n}\n.ui.inverted.red.buttons .button:focus,\n.ui.inverted.red.button:focus {\n  background-color: @lightRedFocus;\n}\n.ui.inverted.red.buttons .active.button,\n.ui.inverted.red.active.button {\n  background-color: @lightRedActive;\n}\n.ui.inverted.red.buttons .button:active,\n.ui.inverted.red.button:active {\n  background-color: @lightRedDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.red.basic.buttons .button,\n.ui.inverted.red.buttons .basic.button,\n.ui.inverted.red.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.red.basic.buttons .button:hover,\n.ui.inverted.red.buttons .basic.button:hover,\n.ui.inverted.red.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightRedHover inset !important;\n  color: @lightRed !important;\n}\n.ui.inverted.red.basic.buttons .button:focus,\n.ui.inverted.red.basic.buttons .button:focus,\n.ui.inverted.red.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightRedFocus inset !important;\n  color: @lightRed !important;\n}\n.ui.inverted.red.basic.buttons .active.button,\n.ui.inverted.red.buttons .basic.active.button,\n.ui.inverted.red.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightRedActive inset !important;\n  color: @lightRed !important;\n}\n.ui.inverted.red.basic.buttons .button:active,\n.ui.inverted.red.buttons .basic.button:active,\n.ui.inverted.red.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightRedDown inset !important;\n  color: @lightRed !important;\n}\n\n\n/*--- Teal ---*/\n.ui.teal.buttons .button,\n.ui.teal.button {\n  background-color: @teal;\n  color: @tealTextColor;\n  text-shadow: @tealTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.teal.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.teal.buttons .button:hover,\n.ui.teal.button:hover {\n  background-color: @tealHover;\n  color: @tealTextColor;\n  text-shadow: @tealTextShadow;\n}\n.ui.teal.buttons .button:focus,\n.ui.teal.button:focus {\n  background-color: @tealFocus;\n  color: @tealTextColor;\n  text-shadow: @tealTextShadow;\n}\n.ui.teal.buttons .button:active,\n.ui.teal.button:active {\n  background-color: @tealDown;\n  color: @tealTextColor;\n  text-shadow: @tealTextShadow;\n}\n.ui.teal.buttons .active.button,\n.ui.teal.buttons .active.button:active,\n.ui.teal.active.button,\n.ui.teal.button .active.button:active {\n  background-color: @tealActive;\n  color: @tealTextColor;\n  text-shadow: @tealTextShadow;\n}\n\n/* Basic */\n.ui.basic.teal.buttons .button,\n.ui.basic.teal.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @teal inset !important;\n  color: @teal !important;\n}\n.ui.basic.teal.buttons .button:hover,\n.ui.basic.teal.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @tealHover inset !important;\n  color: @tealHover !important;\n}\n.ui.basic.teal.buttons .button:focus,\n.ui.basic.teal.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @tealFocus inset !important;\n  color: @tealHover !important;\n}\n.ui.basic.teal.buttons .active.button,\n.ui.basic.teal.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @tealActive inset !important;\n  color: @tealDown !important;\n}\n.ui.basic.teal.buttons .button:active,\n.ui.basic.teal.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @tealDown inset !important;\n  color: @tealDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.teal.buttons .button,\n.ui.inverted.teal.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightTeal inset !important;\n  color: @lightTeal;\n}\n.ui.inverted.teal.buttons .button:hover,\n.ui.inverted.teal.button:hover,\n.ui.inverted.teal.buttons .button:focus,\n.ui.inverted.teal.button:focus,\n.ui.inverted.teal.buttons .button.active,\n.ui.inverted.teal.button.active,\n.ui.inverted.teal.buttons .button:active,\n.ui.inverted.teal.button:active {\n  box-shadow: none !important;\n  color: @lightTealTextColor;\n}\n.ui.inverted.teal.buttons .button:hover,\n.ui.inverted.teal.button:hover {\n  background-color: @lightTealHover;\n}\n.ui.inverted.teal.buttons .button:focus,\n.ui.inverted.teal.button:focus {\n  background-color: @lightTealFocus;\n}\n.ui.inverted.teal.buttons .active.button,\n.ui.inverted.teal.active.button {\n  background-color: @lightTealActive;\n}\n.ui.inverted.teal.buttons .button:active,\n.ui.inverted.teal.button:active {\n  background-color: @lightTealDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.teal.basic.buttons .button,\n.ui.inverted.teal.buttons .basic.button,\n.ui.inverted.teal.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.teal.basic.buttons .button:hover,\n.ui.inverted.teal.buttons .basic.button:hover,\n.ui.inverted.teal.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightTealHover inset !important;\n  color: @lightTeal !important;\n}\n.ui.inverted.teal.basic.buttons .button:focus,\n.ui.inverted.teal.basic.buttons .button:focus,\n.ui.inverted.teal.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightTealFocus inset !important;\n  color: @lightTeal !important;\n}\n.ui.inverted.teal.basic.buttons .active.button,\n.ui.inverted.teal.buttons .basic.active.button,\n.ui.inverted.teal.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightTealActive inset !important;\n  color: @lightTeal !important;\n}\n.ui.inverted.teal.basic.buttons .button:active,\n.ui.inverted.teal.buttons .basic.button:active,\n.ui.inverted.teal.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightTealDown inset !important;\n  color: @lightTeal !important;\n}\n\n\n/*--- Olive ---*/\n.ui.olive.buttons .button,\n.ui.olive.button {\n  background-color: @olive;\n  color: @oliveTextColor;\n  text-shadow: @oliveTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.olive.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.olive.buttons .button:hover,\n.ui.olive.button:hover {\n  background-color: @oliveHover;\n  color: @oliveTextColor;\n  text-shadow: @oliveTextShadow;\n}\n.ui.olive.buttons .button:focus,\n.ui.olive.button:focus {\n  background-color: @oliveFocus;\n  color: @oliveTextColor;\n  text-shadow: @oliveTextShadow;\n}\n.ui.olive.buttons .button:active,\n.ui.olive.button:active {\n  background-color: @oliveDown;\n  color: @oliveTextColor;\n  text-shadow: @oliveTextShadow;\n}\n.ui.olive.buttons .active.button,\n.ui.olive.buttons .active.button:active,\n.ui.olive.active.button,\n.ui.olive.button .active.button:active {\n  background-color: @oliveActive;\n  color: @oliveTextColor;\n  text-shadow: @oliveTextShadow;\n}\n\n/* Basic */\n.ui.basic.olive.buttons .button,\n.ui.basic.olive.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @olive inset !important;\n  color: @olive !important;\n}\n.ui.basic.olive.buttons .button:hover,\n.ui.basic.olive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @oliveHover inset !important;\n  color: @oliveHover !important;\n}\n.ui.basic.olive.buttons .button:focus,\n.ui.basic.olive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @oliveFocus inset !important;\n  color: @oliveHover !important;\n}\n.ui.basic.olive.buttons .active.button,\n.ui.basic.olive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @oliveActive inset !important;\n  color: @oliveDown !important;\n}\n.ui.basic.olive.buttons .button:active,\n.ui.basic.olive.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @oliveDown inset !important;\n  color: @oliveDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.olive.buttons .button,\n.ui.inverted.olive.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOlive inset !important;\n  color: @lightOlive;\n}\n.ui.inverted.olive.buttons .button:hover,\n.ui.inverted.olive.button:hover,\n.ui.inverted.olive.buttons .button:focus,\n.ui.inverted.olive.button:focus,\n.ui.inverted.olive.buttons .button.active,\n.ui.inverted.olive.button.active,\n.ui.inverted.olive.buttons .button:active,\n.ui.inverted.olive.button:active {\n  box-shadow: none !important;\n  color: @lightOliveTextColor;\n}\n.ui.inverted.olive.buttons .button:hover,\n.ui.inverted.olive.button:hover {\n  background-color: @lightOliveHover;\n}\n.ui.inverted.olive.buttons .button:focus,\n.ui.inverted.olive.button:focus {\n  background-color: @lightOliveFocus;\n}\n.ui.inverted.olive.buttons .active.button,\n.ui.inverted.olive.active.button {\n  background-color: @lightOliveActive;\n}\n.ui.inverted.olive.buttons .button:active,\n.ui.inverted.olive.button:active {\n  background-color: @lightOliveDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.olive.basic.buttons .button,\n.ui.inverted.olive.buttons .basic.button,\n.ui.inverted.olive.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.olive.basic.buttons .button:hover,\n.ui.inverted.olive.buttons .basic.button:hover,\n.ui.inverted.olive.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOliveHover inset !important;\n  color: @lightOlive !important;\n}\n.ui.inverted.olive.basic.buttons .button:focus,\n.ui.inverted.olive.basic.buttons .button:focus,\n.ui.inverted.olive.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOliveFocus inset !important;\n  color: @lightOlive !important;\n}\n.ui.inverted.olive.basic.buttons .active.button,\n.ui.inverted.olive.buttons .basic.active.button,\n.ui.inverted.olive.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOliveActive inset !important;\n  color: @lightOlive !important;\n}\n.ui.inverted.olive.basic.buttons .button:active,\n.ui.inverted.olive.buttons .basic.button:active,\n.ui.inverted.olive.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightOliveDown inset !important;\n  color: @lightOlive !important;\n}\n\n/*--- Yellow ---*/\n.ui.yellow.buttons .button,\n.ui.yellow.button {\n  background-color: @yellow;\n  color: @yellowTextColor;\n  text-shadow: @yellowTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.yellow.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.yellow.buttons .button:hover,\n.ui.yellow.button:hover {\n  background-color: @yellowHover;\n  color: @yellowTextColor;\n  text-shadow: @yellowTextShadow;\n}\n.ui.yellow.buttons .button:focus,\n.ui.yellow.button:focus {\n  background-color: @yellowFocus;\n  color: @yellowTextColor;\n  text-shadow: @yellowTextShadow;\n}\n.ui.yellow.buttons .button:active,\n.ui.yellow.button:active {\n  background-color: @yellowDown;\n  color: @yellowTextColor;\n  text-shadow: @yellowTextShadow;\n}\n.ui.yellow.buttons .active.button,\n.ui.yellow.buttons .active.button:active,\n.ui.yellow.active.button,\n.ui.yellow.button .active.button:active {\n  background-color: @yellowActive;\n  color: @yellowTextColor;\n  text-shadow: @yellowTextShadow;\n}\n\n/* Basic */\n.ui.basic.yellow.buttons .button,\n.ui.basic.yellow.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @yellow inset !important;\n  color: @yellow !important;\n}\n.ui.basic.yellow.buttons .button:hover,\n.ui.basic.yellow.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @yellowHover inset !important;\n  color: @yellowHover !important;\n}\n.ui.basic.yellow.buttons .button:focus,\n.ui.basic.yellow.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @yellowFocus inset !important;\n  color: @yellowHover !important;\n}\n.ui.basic.yellow.buttons .active.button,\n.ui.basic.yellow.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @yellowActive inset !important;\n  color: @yellowDown !important;\n}\n.ui.basic.yellow.buttons .button:active,\n.ui.basic.yellow.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @yellowDown inset !important;\n  color: @yellowDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.yellow.buttons .button,\n.ui.inverted.yellow.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightYellow inset !important;\n  color: @lightYellow;\n}\n.ui.inverted.yellow.buttons .button:hover,\n.ui.inverted.yellow.button:hover,\n.ui.inverted.yellow.buttons .button:focus,\n.ui.inverted.yellow.button:focus,\n.ui.inverted.yellow.buttons .button.active,\n.ui.inverted.yellow.button.active,\n.ui.inverted.yellow.buttons .button:active,\n.ui.inverted.yellow.button:active {\n  box-shadow: none !important;\n  color: @lightYellowTextColor;\n}\n.ui.inverted.yellow.buttons .button:hover,\n.ui.inverted.yellow.button:hover {\n  background-color: @lightYellowHover;\n}\n.ui.inverted.yellow.buttons .button:focus,\n.ui.inverted.yellow.button:focus {\n  background-color: @lightYellowFocus;\n}\n.ui.inverted.yellow.buttons .active.button,\n.ui.inverted.yellow.active.button {\n  background-color: @lightYellowActive;\n}\n.ui.inverted.yellow.buttons .button:active,\n.ui.inverted.yellow.button:active {\n  background-color: @lightYellowDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.yellow.basic.buttons .button,\n.ui.inverted.yellow.buttons .basic.button,\n.ui.inverted.yellow.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.yellow.basic.buttons .button:hover,\n.ui.inverted.yellow.buttons .basic.button:hover,\n.ui.inverted.yellow.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightYellowHover inset !important;\n  color: @lightYellow !important;\n}\n.ui.inverted.yellow.basic.buttons .button:focus,\n.ui.inverted.yellow.basic.buttons .button:focus,\n.ui.inverted.yellow.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightYellowFocus inset !important;\n  color: @lightYellow !important;\n}\n.ui.inverted.yellow.basic.buttons .active.button,\n.ui.inverted.yellow.buttons .basic.active.button,\n.ui.inverted.yellow.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightYellowActive inset !important;\n  color: @lightYellow !important;\n}\n.ui.inverted.yellow.basic.buttons .button:active,\n.ui.inverted.yellow.buttons .basic.button:active,\n.ui.inverted.yellow.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightYellowDown inset !important;\n  color: @lightYellow !important;\n}\n\n\n/*-------------------\n       Primary\n--------------------*/\n\n/*--- Standard ---*/\n.ui.primary.buttons .button,\n.ui.primary.button {\n  background-color: @primaryColor;\n  color: @primaryTextColor;\n  text-shadow: @primaryTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.primary.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.primary.buttons .button:hover,\n.ui.primary.button:hover {\n  background-color: @primaryColorHover;\n  color: @primaryTextColor;\n  text-shadow: @primaryTextShadow;\n}\n.ui.primary.buttons .button:focus,\n.ui.primary.button:focus {\n  background-color: @primaryColorFocus;\n  color: @primaryTextColor;\n  text-shadow: @primaryTextShadow;\n}\n.ui.primary.buttons .button:active,\n.ui.primary.button:active {\n  background-color: @primaryColorDown;\n  color: @primaryTextColor;\n  text-shadow: @primaryTextShadow;\n}\n.ui.primary.buttons .active.button,\n.ui.primary.buttons .active.button:active,\n.ui.primary.active.button,\n.ui.primary.button .active.button:active {\n  background-color: @primaryColorActive;\n  color: @primaryTextColor;\n  text-shadow: @primaryTextShadow;\n}\n\n/* Basic */\n.ui.basic.primary.buttons .button,\n.ui.basic.primary.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @primaryColor inset !important;\n  color: @primaryColor !important;\n}\n.ui.basic.primary.buttons .button:hover,\n.ui.basic.primary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @primaryColorHover inset !important;\n  color: @primaryColorHover !important;\n}\n.ui.basic.primary.buttons .button:focus,\n.ui.basic.primary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @primaryColorFocus inset !important;\n  color: @primaryColorHover !important;\n}\n.ui.basic.primary.buttons .active.button,\n.ui.basic.primary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @primaryColorActive inset !important;\n  color: @primaryColorDown !important;\n}\n.ui.basic.primary.buttons .button:active,\n.ui.basic.primary.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @primaryColorDown inset !important;\n  color: @primaryColorDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.primary.buttons .button,\n.ui.inverted.primary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPrimaryColor inset !important;\n  color: @lightPrimaryColor;\n}\n.ui.inverted.primary.buttons .button:hover,\n.ui.inverted.primary.button:hover,\n.ui.inverted.primary.buttons .button:focus,\n.ui.inverted.primary.button:focus,\n.ui.inverted.primary.buttons .button.active,\n.ui.inverted.primary.button.active,\n.ui.inverted.primary.buttons .button:active,\n.ui.inverted.primary.button:active {\n  box-shadow: none !important;\n  color: @lightPrimaryTextColor;\n}\n.ui.inverted.primary.buttons .button:hover,\n.ui.inverted.primary.button:hover {\n  background-color: @lightPrimaryColorHover;\n}\n.ui.inverted.primary.buttons .button:focus,\n.ui.inverted.primary.button:focus {\n  background-color: @lightPrimaryColorFocus;\n}\n.ui.inverted.primary.buttons .active.button,\n.ui.inverted.primary.active.button {\n  background-color: @lightPrimaryColorActive;\n}\n.ui.inverted.primary.buttons .button:active,\n.ui.inverted.primary.button:active {\n  background-color: @lightPrimaryColorDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.primary.basic.buttons .button,\n.ui.inverted.primary.buttons .basic.button,\n.ui.inverted.primary.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.primary.basic.buttons .button:hover,\n.ui.inverted.primary.buttons .basic.button:hover,\n.ui.inverted.primary.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPrimaryColorHover inset !important;\n  color: @lightPrimaryColor !important;\n}\n.ui.inverted.primary.basic.buttons .button:focus,\n.ui.inverted.primary.basic.buttons .button:focus,\n.ui.inverted.primary.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPrimaryColorFocus inset !important;\n  color: @lightPrimaryColor !important;\n}\n.ui.inverted.primary.basic.buttons .active.button,\n.ui.inverted.primary.buttons .basic.active.button,\n.ui.inverted.primary.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPrimaryColorActive inset !important;\n  color: @lightPrimaryColor !important;\n}\n.ui.inverted.primary.basic.buttons .button:active,\n.ui.inverted.primary.buttons .basic.button:active,\n.ui.inverted.primary.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightPrimaryColorDown inset !important;\n  color: @lightPrimaryColor !important;\n}\n\n/*-------------------\n      Secondary\n--------------------*/\n\n/* Standard */\n.ui.secondary.buttons .button,\n.ui.secondary.button {\n  background-color: @secondaryColor;\n  color: @secondaryTextColor;\n  text-shadow: @secondaryTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.secondary.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.secondary.buttons .button:hover,\n.ui.secondary.button:hover {\n  background-color: @secondaryColorHover;\n  color: @secondaryTextColor;\n  text-shadow: @secondaryTextShadow;\n}\n.ui.secondary.buttons .button:focus,\n.ui.secondary.button:focus {\n  background-color: @secondaryColorFocus;\n  color: @secondaryTextColor;\n  text-shadow: @secondaryTextShadow;\n}\n.ui.secondary.buttons .button:active,\n.ui.secondary.button:active {\n  background-color: @secondaryColorDown;\n  color: @secondaryTextColor;\n  text-shadow: @secondaryTextShadow;\n}\n.ui.secondary.buttons .active.button,\n.ui.secondary.buttons .active.button:active,\n.ui.secondary.active.button,\n.ui.secondary.button .active.button:active {\n  background-color: @secondaryColorActive;\n  color: @secondaryTextColor;\n  text-shadow: @secondaryTextShadow;\n}\n\n/* Basic */\n.ui.basic.secondary.buttons .button,\n.ui.basic.secondary.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @secondaryColor inset !important;\n  color: @secondaryColor !important;\n}\n.ui.basic.secondary.buttons .button:hover,\n.ui.basic.secondary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @secondaryColorHover inset !important;\n  color: @secondaryColorHover !important;\n}\n.ui.basic.secondary.buttons .button:focus,\n.ui.basic.secondary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @secondaryColorFocus inset !important;\n  color: @secondaryColorHover !important;\n}\n.ui.basic.secondary.buttons .active.button,\n.ui.basic.secondary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @secondaryColorActive inset !important;\n  color: @secondaryColorDown !important;\n}\n.ui.basic.secondary.buttons .button:active,\n.ui.basic.secondary.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @secondaryColorDown inset !important;\n  color: @secondaryColorDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/* Inverted */\n.ui.inverted.secondary.buttons .button,\n.ui.inverted.secondary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightSecondaryColor inset !important;\n  color: @lightSecondaryColor;\n}\n.ui.inverted.secondary.buttons .button:hover,\n.ui.inverted.secondary.button:hover,\n.ui.inverted.secondary.buttons .button:focus,\n.ui.inverted.secondary.button:focus,\n.ui.inverted.secondary.buttons .button.active,\n.ui.inverted.secondary.button.active,\n.ui.inverted.secondary.buttons .button:active,\n.ui.inverted.secondary.button:active {\n  box-shadow: none !important;\n  color: @lightSecondaryTextColor;\n}\n.ui.inverted.secondary.buttons .button:hover,\n.ui.inverted.secondary.button:hover {\n  background-color: @lightSecondaryColorHover;\n}\n.ui.inverted.secondary.buttons .button:focus,\n.ui.inverted.secondary.button:focus {\n  background-color: @lightSecondaryColorFocus;\n}\n.ui.inverted.secondary.buttons .active.button,\n.ui.inverted.secondary.active.button {\n  background-color: @lightSecondaryColorActive;\n}\n.ui.inverted.secondary.buttons .button:active,\n.ui.inverted.secondary.button:active {\n  background-color: @lightSecondaryColorDown;\n}\n\n/* Inverted Basic */\n.ui.inverted.secondary.basic.buttons .button,\n.ui.inverted.secondary.buttons .basic.button,\n.ui.inverted.secondary.basic.button {\n  background-color: transparent;\n  box-shadow: @basicInvertedBoxShadow !important;\n  color: @white !important;\n}\n.ui.inverted.secondary.basic.buttons .button:hover,\n.ui.inverted.secondary.buttons .basic.button:hover,\n.ui.inverted.secondary.basic.button:hover {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightSecondaryColorHover inset !important;\n  color: @lightSecondaryColor !important;\n}\n.ui.inverted.secondary.basic.buttons .button:focus,\n.ui.inverted.secondary.basic.buttons .button:focus,\n.ui.inverted.secondary.basic.button:focus {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightSecondaryColorFocus inset !important;\n  color: @lightSecondaryColor !important;\n}\n.ui.inverted.secondary.basic.buttons .active.button,\n.ui.inverted.secondary.buttons .basic.active.button,\n.ui.inverted.secondary.basic.active.button {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightSecondaryColorActive inset !important;\n  color: @lightSecondaryColor !important;\n}\n.ui.inverted.secondary.basic.buttons .button:active,\n.ui.inverted.secondary.buttons .basic.button:active,\n.ui.inverted.secondary.basic.button:active {\n  box-shadow: 0px 0px 0px @invertedBorderSize @lightSecondaryColorDown inset !important;\n  color: @lightSecondaryColor !important;\n}\n\n/*---------------\n    Positive\n----------------*/\n\n/* Standard */\n.ui.positive.buttons .button,\n.ui.positive.button {\n  background-color: @positiveColor;\n  color: @positiveTextColor;\n  text-shadow: @positiveTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.positive.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.positive.buttons .button:hover,\n.ui.positive.button:hover {\n  background-color: @positiveColorHover;\n  color: @positiveTextColor;\n  text-shadow: @positiveTextShadow;\n}\n.ui.positive.buttons .button:focus,\n.ui.positive.button:focus {\n  background-color: @positiveColorFocus;\n  color: @positiveTextColor;\n  text-shadow: @positiveTextShadow;\n}\n.ui.positive.buttons .button:active,\n.ui.positive.button:active {\n  background-color: @positiveColorDown;\n  color: @positiveTextColor;\n  text-shadow: @positiveTextShadow;\n}\n.ui.positive.buttons .active.button,\n.ui.positive.buttons .active.button:active,\n.ui.positive.active.button,\n.ui.positive.button .active.button:active {\n  background-color: @positiveColorActive;\n  color: @positiveTextColor;\n  text-shadow: @positiveTextShadow;\n}\n\n/* Basic */\n.ui.basic.positive.buttons .button,\n.ui.basic.positive.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @positiveColor inset !important;\n  color: @positiveColor !important;\n}\n.ui.basic.positive.buttons .button:hover,\n.ui.basic.positive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @positiveColorHover inset !important;\n  color: @positiveColorHover !important;\n}\n.ui.basic.positive.buttons .button:focus,\n.ui.basic.positive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @positiveColorFocus inset !important;\n  color: @positiveColorHover !important;\n}\n.ui.basic.positive.buttons .active.button,\n.ui.basic.positive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @positiveColorActive inset !important;\n  color: @positiveColorDown !important;\n}\n.ui.basic.positive.buttons .button:active,\n.ui.basic.positive.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @positiveColorDown inset !important;\n  color: @positiveColorDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/*---------------\n     Negative\n----------------*/\n\n/* Standard */\n.ui.negative.buttons .button,\n.ui.negative.button {\n  background-color: @negativeColor;\n  color: @negativeTextColor;\n  text-shadow: @negativeTextShadow;\n  background-image: @coloredBackgroundImage;\n}\n.ui.negative.button {\n  box-shadow: @coloredBoxShadow;\n}\n.ui.negative.buttons .button:hover,\n.ui.negative.button:hover {\n  background-color: @negativeColorHover;\n  color: @negativeTextColor;\n  text-shadow: @negativeTextShadow;\n}\n.ui.negative.buttons .button:focus,\n.ui.negative.button:focus {\n  background-color: @negativeColorFocus;\n  color: @negativeTextColor;\n  text-shadow: @negativeTextShadow;\n}\n.ui.negative.buttons .button:active,\n.ui.negative.button:active {\n  background-color: @negativeColorDown;\n  color: @negativeTextColor;\n  text-shadow: @negativeTextShadow;\n}\n.ui.negative.buttons .active.button,\n.ui.negative.buttons .active.button:active,\n.ui.negative.active.button,\n.ui.negative.button .active.button:active {\n  background-color: @negativeColorActive;\n  color: @negativeTextColor;\n  text-shadow: @negativeTextShadow;\n}\n\n/* Basic */\n.ui.basic.negative.buttons .button,\n.ui.basic.negative.button {\n  box-shadow: 0px 0px 0px @basicBorderSize @negativeColor inset !important;\n  color: @negativeColor !important;\n}\n.ui.basic.negative.buttons .button:hover,\n.ui.basic.negative.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @negativeColorHover inset !important;\n  color: @negativeColorHover !important;\n}\n.ui.basic.negative.buttons .button:focus,\n.ui.basic.negative.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @negativeColorFocus inset !important;\n  color: @negativeColorHover !important;\n}\n.ui.basic.negative.buttons .active.button,\n.ui.basic.negative.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @negativeColorActive inset !important;\n  color: @negativeColorDown !important;\n}\n.ui.basic.negative.buttons .button:active,\n.ui.basic.negative.button:active {\n  box-shadow: 0px 0px 0px @basicColoredBorderSize @negativeColorDown inset !important;\n  color: @negativeColorDown !important;\n}\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -@basicColoredBorderSize;\n}\n\n/*******************************\n            Groups\n*******************************/\n\n.ui.buttons {\n  display: inline-flex;\n  flex-direction: row;\n  font-size: 0em;\n  vertical-align: baseline;\n  margin: @verticalMargin @horizontalMargin 0em 0em;\n}\n.ui.buttons:not(.basic):not(.inverted) {\n  box-shadow: @groupBoxShadow;\n}\n\n/* Clearfix */\n.ui.buttons:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\n/* Standard Group */\n.ui.buttons .button {\n  flex: 1 0 auto;\n  margin: 0em;\n  border-radius: 0em;\n  margin: @groupButtonOffset;\n}\n.ui.buttons > .ui.button:not(.basic):not(.inverted),\n.ui.buttons:not(.basic):not(.inverted) > .button {\n  box-shadow: @groupButtonBoxShadow;\n}\n\n.ui.buttons .button:first-child {\n  border-left: none;\n  margin-left: 0em;\n  border-top-left-radius: @borderRadius;\n  border-bottom-left-radius: @borderRadius;\n}\n.ui.buttons .button:last-child {\n  border-top-right-radius: @borderRadius;\n  border-bottom-right-radius: @borderRadius;\n}\n\n/* Vertical  Style */\n.ui.vertical.buttons {\n  display: inline-flex;\n  flex-direction: column;\n}\n.ui.vertical.buttons .button {\n  display: block;\n  float: none;\n  width: 100%;\n  margin: @verticalGroupOffset;\n  box-shadow: @verticalBoxShadow;\n  border-radius: 0em;\n}\n.ui.vertical.buttons .button:first-child {\n  border-top-left-radius: @borderRadius;\n  border-top-right-radius: @borderRadius;\n}\n.ui.vertical.buttons .button:last-child {\n  margin-bottom: 0px;\n  border-bottom-left-radius: @borderRadius;\n  border-bottom-right-radius: @borderRadius;\n}\n.ui.vertical.buttons .button:only-child {\n  border-radius: @borderRadius;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Container\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'container';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Container\n*******************************/\n\n/* All Sizes */\n.ui.container {\n  display: block;\n  max-width: @maxWidth !important;\n}\n\n/* Mobile */\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.container {\n    width: @mobileWidth !important;\n    margin-left: @mobileGutter !important;\n    margin-right: @mobileGutter !important;\n  }\n  .ui.grid.container {\n    width: @mobileGridWidth !important;\n  }\n  .ui.relaxed.grid.container {\n    width: @mobileRelaxedGridWidth !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: @mobileVeryRelaxedGridWidth !important;\n  }\n}\n\n/* Tablet */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui.container {\n    width: @tabletWidth;\n    margin-left: @tabletGutter !important;\n    margin-right: @tabletGutter !important;\n  }\n  .ui.grid.container {\n    width: @tabletGridWidth !important;\n  }\n  .ui.relaxed.grid.container {\n    width: @tabletRelaxedGridWidth !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: @tabletVeryRelaxedGridWidth !important;\n  }\n}\n\n/* Small Monitor */\n@media only screen and (min-width: @computerBreakpoint) and (max-width: @largestSmallMonitor) {\n  .ui.container {\n    width: @computerWidth;\n    margin-left: @computerGutter !important;\n    margin-right: @computerGutter !important;\n  }\n  .ui.grid.container {\n    width: @computerGridWidth !important;\n  }\n  .ui.relaxed.grid.container {\n    width: @computerRelaxedGridWidth !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: @computerVeryRelaxedGridWidth !important;\n  }\n}\n\n/* Large Monitor */\n@media only screen and (min-width: @largeMonitorBreakpoint) {\n  .ui.container {\n    width: @largeMonitorWidth;\n    margin-left: @largeMonitorGutter !important;\n    margin-right: @largeMonitorGutter !important;\n  }\n  .ui.grid.container {\n    width: @largeMonitorGridWidth !important;\n  }\n  .ui.relaxed.grid.container {\n    width: @largeMonitorRelaxedGridWidth !important;\n  }\n  .ui.very.relaxed.grid.container {\n    width: @largeMonitorVeryRelaxedGridWidth !important;\n  }\n}\n\n/*******************************\n             Types\n*******************************/\n\n\n/* Text Container */\n.ui.text.container {\n  font-family: @textFontFamily;\n  max-width: @textWidth !important;\n  line-height: @textLineHeight;\n}\n\n.ui.text.container {\n  font-size: @textSize;\n}\n\n/* Fluid */\n.ui.fluid.container {\n  width: 100%;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n.ui[class*=\"left aligned\"].container {\n  text-align: left;\n}\n.ui[class*=\"center aligned\"].container {\n  text-align: center;\n}\n.ui[class*=\"right aligned\"].container {\n  text-align: right;\n}\n.ui.justified.container {\n  text-align: justify;\n  hyphens: auto;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Divider\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'divider';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n            Divider\n*******************************/\n\n.ui.divider {\n  margin: @margin;\n\n  line-height: 1;\n  height: 0em;\n\n  font-weight: @fontWeight;\n  text-transform: @textTransform;\n  letter-spacing: @letterSpacing;\n  color: @color;\n\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/*--------------\n      Basic\n---------------*/\n\n.ui.divider:not(.vertical):not(.horizontal) {\n  border-top: @shadowWidth solid @shadowColor;\n  border-bottom: @highlightWidth solid @highlightColor;\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n/* Allow divider between each column row */\n.ui.grid > .column + .divider,\n.ui.grid > .row > .column + .divider {\n  left: auto;\n}\n\n/*--------------\n   Horizontal\n---------------*/\n\n.ui.horizontal.divider {\n  display: table;\n  white-space: nowrap;\n\n  height: auto;\n  margin: @horizontalMargin;\n  line-height: 1;\n  text-align: center;\n}\n\n.ui.horizontal.divider:before,\n.ui.horizontal.divider:after {\n  content: '';\n  display: table-cell;\n  position: relative;\n  top: 50%;\n  width: 50%;\n  background-repeat: no-repeat;\n}\n\n.ui.horizontal.divider:before {\n  background-position: right @horizontalDividerMargin top 50%;\n}\n.ui.horizontal.divider:after {\n  background-position: left @horizontalDividerMargin top 50%;\n}\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.divider {\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n\n  margin: 0rem;\n  padding: 0em;\n  width: auto;\n  height: 50%;\n\n  line-height: 0em;\n  text-align: center;\n  transform: translateX(-50%);\n}\n\n.ui.vertical.divider:before,\n.ui.vertical.divider:after {\n  position: absolute;\n  left: 50%;\n  content: '';\n  z-index: 3;\n\n  border-left: @shadowWidth solid @shadowColor;\n  border-right: @highlightWidth solid @highlightColor;\n\n  width: 0%;\n  height: @verticalDividerHeight;\n}\n\n.ui.vertical.divider:before {\n  top: -100%;\n}\n.ui.vertical.divider:after {\n  top: auto;\n  bottom: 0px;\n}\n\n/* Inside grid */\n@media only screen and (max-width : @largestMobileScreen) {\n\n  .ui.stackable.grid .ui.vertical.divider,\n  .ui.grid .stackable.row .ui.vertical.divider {\n    display: table;\n    white-space: nowrap;\n    height: auto;\n    margin: @horizontalMargin;\n    overflow: hidden;\n    line-height: 1;\n    text-align: center;\n    position: static;\n    top: 0;\n    left: 0;\n    transform: none;\n  }\n\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before,\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    position: static;\n    left: 0;\n    border-left: none;\n    border-right: none;\n    content: '';\n    display: table-cell;\n    position: relative;\n    top: 50%;\n    width: 50%;\n    background-repeat: no-repeat;\n  }\n\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before {\n    background-position: right @horizontalDividerMargin top 50%;\n  }\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-position: left @horizontalDividerMargin top 50%;\n  }\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.divider > .icon {\n  margin: @dividerIconMargin;\n  font-size: @dividerIconSize;\n  height: 1em;\n  vertical-align: middle;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n    Hidden\n---------------*/\n\n.ui.hidden.divider {\n  border-color: transparent !important;\n}\n.ui.hidden.divider:before,\n.ui.hidden.divider:after {\n  display: none;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.divider.inverted,\n.ui.vertical.inverted.divider,\n.ui.horizontal.inverted.divider {\n  color: @invertedTextColor;\n}\n.ui.divider.inverted,\n.ui.divider.inverted:after,\n.ui.divider.inverted:before {\n  border-top-color: @invertedShadowColor !important;\n  border-left-color: @invertedShadowColor !important;\n  border-bottom-color: @invertedHighlightColor !important;\n  border-right-color: @invertedHighlightColor !important;\n}\n\n/*--------------\n    Fitted\n---------------*/\n\n.ui.fitted.divider {\n  margin: 0em;\n}\n\n/*--------------\n    Clearing\n---------------*/\n\n.ui.clearing.divider {\n  clear: both;\n}\n\n/*--------------\n    Section\n---------------*/\n\n.ui.section.divider {\n  margin-top: @sectionMargin;\n  margin-bottom: @sectionMargin;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.divider {\n  font-size: @medium;\n}\n\n\n.loadUIOverrides();\n","/*******************************\n         Theme Overrides\n*******************************/\n\n\n.ui.horizontal.divider:before,\n.ui.horizontal.divider:after {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n}\n\n@media only screen and (max-width : (@tabletBreakpoint - 1px)) {\n  .ui.stackable.grid .ui.vertical.divider:before,\n  .ui.grid .stackable.row .ui.vertical.divider:before,\n  .ui.stackable.grid .ui.vertical.divider:after,\n  .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n  }\n}","/*!\n * # Semantic UI - Flag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'flag';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n             Flag\n*******************************/\n\ni.flag:not(.icon) {\n  display: inline-block;\n\n  width: @width;\n  height: @height;\n\n  line-height: @height;\n  vertical-align: @verticalAlign;\n  margin: 0em @margin 0em 0em;\n\n  text-decoration: inherit;\n\n  speak: none;\n  font-smoothing: antialiased;\n  backface-visibility: hidden;\n}\n\n/* Sprite */\ni.flag:not(.icon):before {\n  display: inline-block;\n  content: '';\n  background: url(@spritePath) no-repeat -108px -1976px;\n  width: @width;\n  height: @height;\n}\n\n.loadUIOverrides();\n","/* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */\n\n/*******************************\n         Theme Overrides\n*******************************/\n\ni.flag.ad:before,\ni.flag.andorra:before {\n  background-position: 0px 0px;\n}\ni.flag.ae:before,\ni.flag.united.arab.emirates:before,\ni.flag.uae:before {\n  background-position: 0px -26px;\n}\ni.flag.af:before,\ni.flag.afghanistan:before {\n  background-position: 0px -52px;\n}\ni.flag.ag:before,\ni.flag.antigua:before {\n  background-position: 0px -78px;\n}\ni.flag.ai:before,\ni.flag.anguilla:before {\n  background-position: 0px -104px;\n}\ni.flag.al:before,\ni.flag.albania:before {\n  background-position: 0px -130px;\n}\ni.flag.am:before,\ni.flag.armenia:before {\n  background-position: 0px -156px;\n}\ni.flag.an:before,\ni.flag.netherlands.antilles:before {\n  background-position: 0px -182px;\n}\ni.flag.ao:before,\ni.flag.angola:before {\n  background-position: 0px -208px;\n}\ni.flag.ar:before,\ni.flag.argentina:before {\n  background-position: 0px -234px;\n}\ni.flag.as:before,\ni.flag.american.samoa:before {\n  background-position: 0px -260px;\n}\ni.flag.at:before,\ni.flag.austria:before {\n  background-position: 0px -286px;\n}\ni.flag.au:before,\ni.flag.australia:before {\n  background-position: 0px -312px;\n}\ni.flag.aw:before,\ni.flag.aruba:before {\n  background-position: 0px -338px;\n}\ni.flag.ax:before,\ni.flag.aland.islands:before {\n  background-position: 0px -364px;\n}\ni.flag.az:before,\ni.flag.azerbaijan:before {\n  background-position: 0px -390px;\n}\ni.flag.ba:before,\ni.flag.bosnia:before {\n  background-position: 0px -416px;\n}\ni.flag.bb:before,\ni.flag.barbados:before {\n  background-position: 0px -442px;\n}\ni.flag.bd:before,\ni.flag.bangladesh:before {\n  background-position: 0px -468px;\n}\ni.flag.be:before,\ni.flag.belgium:before {\n  background-position: 0px -494px;\n}\ni.flag.bf:before,\ni.flag.burkina.faso:before {\n  background-position: 0px -520px;\n}\ni.flag.bg:before,\ni.flag.bulgaria:before {\n  background-position: 0px -546px;\n}\ni.flag.bh:before,\ni.flag.bahrain:before {\n  background-position: 0px -572px;\n}\ni.flag.bi:before,\ni.flag.burundi:before {\n  background-position: 0px -598px;\n}\ni.flag.bj:before,\ni.flag.benin:before {\n  background-position: 0px -624px;\n}\ni.flag.bm:before,\ni.flag.bermuda:before {\n  background-position: 0px -650px;\n}\ni.flag.bn:before,\ni.flag.brunei:before {\n  background-position: 0px -676px;\n}\ni.flag.bo:before,\ni.flag.bolivia:before {\n  background-position: 0px -702px;\n}\ni.flag.br:before,\ni.flag.brazil:before {\n  background-position: 0px -728px;\n}\ni.flag.bs:before,\ni.flag.bahamas:before {\n  background-position: 0px -754px;\n}\ni.flag.bt:before,\ni.flag.bhutan:before {\n  background-position: 0px -780px;\n}\ni.flag.bv:before,\ni.flag.bouvet.island:before {\n  background-position: 0px -806px;\n}\ni.flag.bw:before,\ni.flag.botswana:before {\n  background-position: 0px -832px;\n}\ni.flag.by:before,\ni.flag.belarus:before {\n  background-position: 0px -858px;\n}\ni.flag.bz:before,\ni.flag.belize:before {\n  background-position: 0px -884px;\n}\ni.flag.ca:before,\ni.flag.canada:before {\n  background-position: 0px -910px;\n}\ni.flag.cc:before,\ni.flag.cocos.islands:before {\n  background-position: 0px -962px;\n}\ni.flag.cd:before,\ni.flag.congo:before {\n  background-position: 0px -988px;\n}\ni.flag.cf:before,\ni.flag.central.african.republic:before {\n  background-position: 0px -1014px;\n}\ni.flag.cg:before,\ni.flag.congo.brazzaville:before {\n  background-position: 0px -1040px;\n}\ni.flag.ch:before,\ni.flag.switzerland:before {\n  background-position: 0px -1066px;\n}\ni.flag.ci:before,\ni.flag.cote.divoire:before {\n  background-position: 0px -1092px;\n}\ni.flag.ck:before,\ni.flag.cook.islands:before {\n  background-position: 0px -1118px;\n}\ni.flag.cl:before,\ni.flag.chile:before {\n  background-position: 0px -1144px;\n}\ni.flag.cm:before,\ni.flag.cameroon:before {\n  background-position: 0px -1170px;\n}\ni.flag.cn:before,\ni.flag.china:before {\n  background-position: 0px -1196px;\n}\ni.flag.co:before,\ni.flag.colombia:before {\n  background-position: 0px -1222px;\n}\ni.flag.cr:before,\ni.flag.costa.rica:before {\n  background-position: 0px -1248px;\n}\ni.flag.cs:before,\ni.flag.serbia:before {\n  background-position: 0px -1274px;\n}\ni.flag.cu:before,\ni.flag.cuba:before {\n  background-position: 0px -1300px;\n}\ni.flag.cv:before,\ni.flag.cape.verde:before {\n  background-position: 0px -1326px;\n}\ni.flag.cx:before,\ni.flag.christmas.island:before {\n  background-position: 0px -1352px;\n}\ni.flag.cy:before,\ni.flag.cyprus:before {\n  background-position: 0px -1378px;\n}\ni.flag.cz:before,\ni.flag.czech.republic:before {\n  background-position: 0px -1404px;\n}\ni.flag.de:before,\ni.flag.germany:before {\n  background-position: 0px -1430px;\n}\ni.flag.dj:before,\ni.flag.djibouti:before {\n  background-position: 0px -1456px;\n}\ni.flag.dk:before,\ni.flag.denmark:before {\n  background-position: 0px -1482px;\n}\ni.flag.dm:before,\ni.flag.dominica:before {\n  background-position: 0px -1508px;\n}\ni.flag.do:before,\ni.flag.dominican.republic:before {\n  background-position: 0px -1534px;\n}\ni.flag.dz:before,\ni.flag.algeria:before {\n  background-position: 0px -1560px;\n}\ni.flag.ec:before,\ni.flag.ecuador:before {\n  background-position: 0px -1586px;\n}\ni.flag.ee:before,\ni.flag.estonia:before {\n  background-position: 0px -1612px;\n}\ni.flag.eg:before,\ni.flag.egypt:before {\n  background-position: 0px -1638px;\n}\ni.flag.eh:before,\ni.flag.western.sahara:before {\n  background-position: 0px -1664px;\n}\ni.flag.gb.eng:before,\ni.flag.england:before {\n  background-position: 0px -1690px;\n}\ni.flag.er:before,\ni.flag.eritrea:before {\n  background-position: 0px -1716px;\n}\ni.flag.es:before,\ni.flag.spain:before {\n  background-position: 0px -1742px;\n}\ni.flag.et:before,\ni.flag.ethiopia:before {\n  background-position: 0px -1768px;\n}\ni.flag.eu:before,\ni.flag.european.union:before {\n  background-position: 0px -1794px;\n}\ni.flag.fi:before,\ni.flag.finland:before {\n  background-position: 0px -1846px;\n}\ni.flag.fj:before,\ni.flag.fiji:before {\n  background-position: 0px -1872px;\n}\ni.flag.fk:before,\ni.flag.falkland.islands:before {\n  background-position: 0px -1898px;\n}\ni.flag.fm:before,\ni.flag.micronesia:before {\n  background-position: 0px -1924px;\n}\ni.flag.fo:before,\ni.flag.faroe.islands:before {\n  background-position: 0px -1950px;\n}\ni.flag.fr:before,\ni.flag.france:before {\n  background-position: 0px -1976px;\n}\ni.flag.ga:before,\ni.flag.gabon:before {\n  background-position: -36px 0px;\n}\ni.flag.gb:before,\ni.flag.uk:before,\ni.flag.united.kingdom:before {\n  background-position: -36px -26px;\n}\ni.flag.gd:before,\ni.flag.grenada:before {\n  background-position: -36px -52px;\n}\ni.flag.ge:before,\ni.flag.georgia:before {\n  background-position: -36px -78px;\n}\ni.flag.gf:before,\ni.flag.french.guiana:before {\n  background-position: -36px -104px;\n}\ni.flag.gh:before,\ni.flag.ghana:before {\n  background-position: -36px -130px;\n}\ni.flag.gi:before,\ni.flag.gibraltar:before {\n  background-position: -36px -156px;\n}\ni.flag.gl:before,\ni.flag.greenland:before {\n  background-position: -36px -182px;\n}\ni.flag.gm:before,\ni.flag.gambia:before {\n  background-position: -36px -208px;\n}\ni.flag.gn:before,\ni.flag.guinea:before {\n  background-position: -36px -234px;\n}\ni.flag.gp:before,\ni.flag.guadeloupe:before {\n  background-position: -36px -260px;\n}\ni.flag.gq:before,\ni.flag.equatorial.guinea:before {\n  background-position: -36px -286px;\n}\ni.flag.gr:before,\ni.flag.greece:before {\n  background-position: -36px -312px;\n}\ni.flag.gs:before,\ni.flag.sandwich.islands:before {\n  background-position: -36px -338px;\n}\ni.flag.gt:before,\ni.flag.guatemala:before {\n  background-position: -36px -364px;\n}\ni.flag.gu:before,\ni.flag.guam:before {\n  background-position: -36px -390px;\n}\ni.flag.gw:before,\ni.flag.guinea-bissau:before {\n  background-position: -36px -416px;\n}\ni.flag.gy:before,\ni.flag.guyana:before {\n  background-position: -36px -442px;\n}\ni.flag.hk:before,\ni.flag.hong.kong:before {\n  background-position: -36px -468px;\n}\ni.flag.hm:before,\ni.flag.heard.island:before {\n  background-position: -36px -494px;\n}\ni.flag.hn:before,\ni.flag.honduras:before {\n  background-position: -36px -520px;\n}\ni.flag.hr:before,\ni.flag.croatia:before {\n  background-position: -36px -546px;\n}\ni.flag.ht:before,\ni.flag.haiti:before {\n  background-position: -36px -572px;\n}\ni.flag.hu:before,\ni.flag.hungary:before {\n  background-position: -36px -598px;\n}\ni.flag.id:before,\ni.flag.indonesia:before {\n  background-position: -36px -624px;\n}\ni.flag.ie:before,\ni.flag.ireland:before {\n  background-position: -36px -650px;\n}\ni.flag.il:before,\ni.flag.israel:before {\n  background-position: -36px -676px;\n}\ni.flag.in:before,\ni.flag.india:before {\n  background-position: -36px -702px;\n}\ni.flag.io:before,\ni.flag.indian.ocean.territory:before {\n  background-position: -36px -728px;\n}\ni.flag.iq:before,\ni.flag.iraq:before {\n  background-position: -36px -754px;\n}\ni.flag.ir:before,\ni.flag.iran:before {\n  background-position: -36px -780px;\n}\ni.flag.is:before,\ni.flag.iceland:before {\n  background-position: -36px -806px;\n}\ni.flag.it:before,\ni.flag.italy:before {\n  background-position: -36px -832px;\n}\ni.flag.jm:before,\ni.flag.jamaica:before {\n  background-position: -36px -858px;\n}\ni.flag.jo:before,\ni.flag.jordan:before {\n  background-position: -36px -884px;\n}\ni.flag.jp:before,\ni.flag.japan:before {\n  background-position: -36px -910px;\n}\ni.flag.ke:before,\ni.flag.kenya:before {\n  background-position: -36px -936px;\n}\ni.flag.kg:before,\ni.flag.kyrgyzstan:before {\n  background-position: -36px -962px;\n}\ni.flag.kh:before,\ni.flag.cambodia:before {\n  background-position: -36px -988px;\n}\ni.flag.ki:before,\ni.flag.kiribati:before {\n  background-position: -36px -1014px;\n}\ni.flag.km:before,\ni.flag.comoros:before {\n  background-position: -36px -1040px;\n}\ni.flag.kn:before,\ni.flag.saint.kitts.and.nevis:before {\n  background-position: -36px -1066px;\n}\ni.flag.kp:before,\ni.flag.north.korea:before {\n  background-position: -36px -1092px;\n}\ni.flag.kr:before,\ni.flag.south.korea:before {\n  background-position: -36px -1118px;\n}\ni.flag.kw:before,\ni.flag.kuwait:before {\n  background-position: -36px -1144px;\n}\ni.flag.ky:before,\ni.flag.cayman.islands:before {\n  background-position: -36px -1170px;\n}\ni.flag.kz:before,\ni.flag.kazakhstan:before {\n  background-position: -36px -1196px;\n}\ni.flag.la:before,\ni.flag.laos:before {\n  background-position: -36px -1222px;\n}\ni.flag.lb:before,\ni.flag.lebanon:before {\n  background-position: -36px -1248px;\n}\ni.flag.lc:before,\ni.flag.saint.lucia:before {\n  background-position: -36px -1274px;\n}\ni.flag.li:before,\ni.flag.liechtenstein:before {\n  background-position: -36px -1300px;\n}\ni.flag.lk:before,\ni.flag.sri.lanka:before {\n  background-position: -36px -1326px;\n}\ni.flag.lr:before,\ni.flag.liberia:before {\n  background-position: -36px -1352px;\n}\ni.flag.ls:before,\ni.flag.lesotho:before {\n  background-position: -36px -1378px;\n}\ni.flag.lt:before,\ni.flag.lithuania:before {\n  background-position: -36px -1404px;\n}\ni.flag.lu:before,\ni.flag.luxembourg:before {\n  background-position: -36px -1430px;\n}\ni.flag.lv:before,\ni.flag.latvia:before {\n  background-position: -36px -1456px;\n}\ni.flag.ly:before,\ni.flag.libya:before {\n  background-position: -36px -1482px;\n}\ni.flag.ma:before,\ni.flag.morocco:before {\n  background-position: -36px -1508px;\n}\ni.flag.mc:before,\ni.flag.monaco:before {\n  background-position: -36px -1534px;\n}\ni.flag.md:before,\ni.flag.moldova:before {\n  background-position: -36px -1560px;\n}\ni.flag.me:before,\ni.flag.montenegro:before {\n  background-position: -36px -1586px;\n}\ni.flag.mg:before,\ni.flag.madagascar:before {\n  background-position: -36px -1613px;\n}\ni.flag.mh:before,\ni.flag.marshall.islands:before {\n  background-position: -36px -1639px;\n}\ni.flag.mk:before,\ni.flag.macedonia:before {\n  background-position: -36px -1665px;\n}\ni.flag.ml:before,\ni.flag.mali:before {\n  background-position: -36px -1691px;\n}\ni.flag.mm:before,\ni.flag.myanmar:before,\ni.flag.burma:before {\n  background-position: -73px -1821px;\n}\ni.flag.mn:before,\ni.flag.mongolia:before {\n  background-position: -36px -1743px;\n}\ni.flag.mo:before,\ni.flag.macau:before {\n  background-position: -36px -1769px;\n}\ni.flag.mp:before,\ni.flag.northern.mariana.islands:before {\n  background-position: -36px -1795px;\n}\ni.flag.mq:before,\ni.flag.martinique:before {\n  background-position: -36px -1821px;\n}\ni.flag.mr:before,\ni.flag.mauritania:before {\n  background-position: -36px -1847px;\n}\ni.flag.ms:before,\ni.flag.montserrat:before {\n  background-position: -36px -1873px;\n}\ni.flag.mt:before,\ni.flag.malta:before {\n  background-position: -36px -1899px;\n}\ni.flag.mu:before,\ni.flag.mauritius:before {\n  background-position: -36px -1925px;\n}\ni.flag.mv:before,\ni.flag.maldives:before {\n  background-position: -36px -1951px;\n}\ni.flag.mw:before,\ni.flag.malawi:before {\n  background-position: -36px -1977px;\n}\ni.flag.mx:before,\ni.flag.mexico:before {\n  background-position: -72px 0px;\n}\ni.flag.my:before,\ni.flag.malaysia:before {\n  background-position: -72px -26px;\n}\ni.flag.mz:before,\ni.flag.mozambique:before {\n  background-position: -72px -52px;\n}\ni.flag.na:before,\ni.flag.namibia:before {\n  background-position: -72px -78px;\n}\ni.flag.nc:before,\ni.flag.new.caledonia:before {\n  background-position: -72px -104px;\n}\ni.flag.ne:before,\ni.flag.niger:before {\n  background-position: -72px -130px;\n}\ni.flag.nf:before,\ni.flag.norfolk.island:before {\n  background-position: -72px -156px;\n}\ni.flag.ng:before,\ni.flag.nigeria:before {\n  background-position: -72px -182px;\n}\ni.flag.ni:before,\ni.flag.nicaragua:before {\n  background-position: -72px -208px;\n}\ni.flag.nl:before,\ni.flag.netherlands:before {\n  background-position: -72px -234px;\n}\ni.flag.no:before,\ni.flag.norway:before {\n  background-position: -72px -260px;\n}\ni.flag.np:before,\ni.flag.nepal:before {\n  background-position: -72px -286px;\n}\ni.flag.nr:before,\ni.flag.nauru:before {\n  background-position: -72px -312px;\n}\ni.flag.nu:before,\ni.flag.niue:before {\n  background-position: -72px -338px;\n}\ni.flag.nz:before,\ni.flag.new.zealand:before {\n  background-position: -72px -364px;\n}\ni.flag.om:before,\ni.flag.oman:before {\n  background-position: -72px -390px;\n}\ni.flag.pa:before,\ni.flag.panama:before {\n  background-position: -72px -416px;\n}\ni.flag.pe:before,\ni.flag.peru:before {\n  background-position: -72px -442px;\n}\ni.flag.pf:before,\ni.flag.french.polynesia:before {\n  background-position: -72px -468px;\n}\ni.flag.pg:before,\ni.flag.new.guinea:before {\n  background-position: -72px -494px;\n}\ni.flag.ph:before,\ni.flag.philippines:before {\n  background-position: -72px -520px;\n}\ni.flag.pk:before,\ni.flag.pakistan:before {\n  background-position: -72px -546px;\n}\ni.flag.pl:before,\ni.flag.poland:before {\n  background-position: -72px -572px;\n}\ni.flag.pm:before,\ni.flag.saint.pierre:before {\n  background-position: -72px -598px;\n}\ni.flag.pn:before,\ni.flag.pitcairn.islands:before {\n  background-position: -72px -624px;\n}\ni.flag.pr:before,\ni.flag.puerto.rico:before {\n  background-position: -72px -650px;\n}\ni.flag.ps:before,\ni.flag.palestine:before {\n  background-position: -72px -676px;\n}\ni.flag.pt:before,\ni.flag.portugal:before {\n  background-position: -72px -702px;\n}\ni.flag.pw:before,\ni.flag.palau:before {\n  background-position: -72px -728px;\n}\ni.flag.py:before,\ni.flag.paraguay:before {\n  background-position: -72px -754px;\n}\ni.flag.qa:before,\ni.flag.qatar:before {\n  background-position: -72px -780px;\n}\ni.flag.re:before,\ni.flag.reunion:before {\n  background-position: -72px -806px;\n}\ni.flag.ro:before,\ni.flag.romania:before {\n  background-position: -72px -832px;\n}\ni.flag.rs:before,\ni.flag.serbia:before {\n  background-position: -72px -858px;\n}\ni.flag.ru:before,\ni.flag.russia:before {\n  background-position: -72px -884px;\n}\ni.flag.rw:before,\ni.flag.rwanda:before {\n  background-position: -72px -910px;\n}\ni.flag.sa:before,\ni.flag.saudi.arabia:before {\n  background-position: -72px -936px;\n}\ni.flag.sb:before,\ni.flag.solomon.islands:before {\n  background-position: -72px -962px;\n}\ni.flag.sc:before,\ni.flag.seychelles:before {\n  background-position: -72px -988px;\n}\ni.flag.gb.sct:before,\ni.flag.scotland:before {\n  background-position: -72px -1014px;\n}\ni.flag.sd:before,\ni.flag.sudan:before {\n  background-position: -72px -1040px;\n}\ni.flag.se:before,\ni.flag.sweden:before {\n  background-position: -72px -1066px;\n}\ni.flag.sg:before,\ni.flag.singapore:before {\n  background-position: -72px -1092px;\n}\ni.flag.sh:before,\ni.flag.saint.helena:before {\n  background-position: -72px -1118px;\n}\ni.flag.si:before,\ni.flag.slovenia:before {\n  background-position: -72px -1144px;\n}\ni.flag.sj:before,\ni.flag.svalbard:before,\ni.flag.jan.mayen:before {\n  background-position: -72px -1170px;\n}\ni.flag.sk:before,\ni.flag.slovakia:before {\n  background-position: -72px -1196px;\n}\ni.flag.sl:before,\ni.flag.sierra.leone:before {\n  background-position: -72px -1222px;\n}\ni.flag.sm:before,\ni.flag.san.marino:before {\n  background-position: -72px -1248px;\n}\ni.flag.sn:before,\ni.flag.senegal:before {\n  background-position: -72px -1274px;\n}\ni.flag.so:before,\ni.flag.somalia:before {\n  background-position: -72px -1300px;\n}\ni.flag.sr:before,\ni.flag.suriname:before {\n  background-position: -72px -1326px;\n}\ni.flag.st:before,\ni.flag.sao.tome:before {\n  background-position: -72px -1352px;\n}\ni.flag.sv:before,\ni.flag.el.salvador:before {\n  background-position: -72px -1378px;\n}\ni.flag.sy:before,\ni.flag.syria:before {\n  background-position: -72px -1404px;\n}\ni.flag.sz:before,\ni.flag.swaziland:before {\n  background-position: -72px -1430px;\n}\ni.flag.tc:before,\ni.flag.caicos.islands:before {\n  background-position: -72px -1456px;\n}\ni.flag.td:before,\ni.flag.chad:before {\n  background-position: -72px -1482px;\n}\ni.flag.tf:before,\ni.flag.french.territories:before {\n  background-position: -72px -1508px;\n}\ni.flag.tg:before,\ni.flag.togo:before {\n  background-position: -72px -1534px;\n}\ni.flag.th:before,\ni.flag.thailand:before {\n  background-position: -72px -1560px;\n}\ni.flag.tj:before,\ni.flag.tajikistan:before {\n  background-position: -72px -1586px;\n}\ni.flag.tk:before,\ni.flag.tokelau:before {\n  background-position: -72px -1612px;\n}\ni.flag.tl:before,\ni.flag.timorleste:before {\n  background-position: -72px -1638px;\n}\ni.flag.tm:before,\ni.flag.turkmenistan:before {\n  background-position: -72px -1664px;\n}\ni.flag.tn:before,\ni.flag.tunisia:before {\n  background-position: -72px -1690px;\n}\ni.flag.to:before,\ni.flag.tonga:before {\n  background-position: -72px -1716px;\n}\ni.flag.tr:before,\ni.flag.turkey:before {\n  background-position: -72px -1742px;\n}\ni.flag.tt:before,\ni.flag.trinidad:before {\n  background-position: -72px -1768px;\n}\ni.flag.tv:before,\ni.flag.tuvalu:before {\n  background-position: -72px -1794px;\n}\ni.flag.tw:before,\ni.flag.taiwan:before {\n  background-position: -72px -1820px;\n}\ni.flag.tz:before,\ni.flag.tanzania:before {\n  background-position: -72px -1846px;\n}\ni.flag.ua:before,\ni.flag.ukraine:before {\n  background-position: -72px -1872px;\n}\ni.flag.ug:before,\ni.flag.uganda:before {\n  background-position: -72px -1898px;\n}\ni.flag.um:before,\ni.flag.us.minor.islands:before {\n  background-position: -72px -1924px;\n}\ni.flag.us:before,\ni.flag.america:before,\ni.flag.united.states:before {\n  background-position: -72px -1950px;\n}\ni.flag.uy:before,\ni.flag.uruguay:before {\n  background-position: -72px -1976px;\n}\ni.flag.uz:before,\ni.flag.uzbekistan:before {\n  background-position: -108px 0px;\n}\ni.flag.va:before,\ni.flag.vatican.city:before {\n  background-position: -108px -26px;\n}\ni.flag.vc:before,\ni.flag.saint.vincent:before {\n  background-position: -108px -52px;\n}\ni.flag.ve:before,\ni.flag.venezuela:before {\n  background-position: -108px -78px;\n}\ni.flag.vg:before,\ni.flag.british.virgin.islands:before {\n  background-position: -108px -104px;\n}\ni.flag.vi:before,\ni.flag.us.virgin.islands:before {\n  background-position: -108px -130px;\n}\ni.flag.vn:before,\ni.flag.vietnam:before {\n  background-position: -108px -156px;\n}\ni.flag.vu:before,\ni.flag.vanuatu:before {\n  background-position: -108px -182px;\n}\ni.flag.gb.wls:before,\ni.flag.wales:before {\n  background-position: -108px -208px;\n}\ni.flag.wf:before,\ni.flag.wallis.and.futuna:before {\n  background-position: -108px -234px;\n}\ni.flag.ws:before,\ni.flag.samoa:before {\n  background-position: -108px -260px;\n}\ni.flag.ye:before,\ni.flag.yemen:before {\n  background-position: -108px -286px;\n}\ni.flag.yt:before,\ni.flag.mayotte:before {\n  background-position: -108px -312px;\n}\ni.flag.za:before,\ni.flag.south.africa:before {\n  background-position: -108px -338px;\n}\ni.flag.zm:before,\ni.flag.zambia:before {\n  background-position: -108px -364px;\n}\ni.flag.zw:before,\ni.flag.zimbabwe:before {\n  background-position: -108px -390px;\n}\n","/*!\n * # Semantic UI - Header\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'header';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n            Header\n*******************************/\n\n/* Standard */\n.ui.header {\n  border: none;\n  margin: @margin;\n  padding: @verticalPadding @horizontalPadding;\n  font-family: @fontFamily;\n  font-weight: @fontWeight;\n  line-height: @lineHeight;\n  text-transform: @textTransform;\n  color: @textColor;\n}\n\n.ui.header:first-child {\n  margin-top: @firstMargin;\n}\n.ui.header:last-child {\n  margin-bottom: @lastMargin;\n}\n\n/*--------------\n   Sub Header\n---------------*/\n\n.ui.header .sub.header {\n  display: block;\n  font-weight: @normal;\n  padding: 0em;\n  margin: @subHeaderMargin;\n  font-size: @subHeaderFontSize;\n  line-height: @subHeaderLineHeight;\n  color: @subHeaderColor;\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.header > .icon {\n  display: table-cell;\n  opacity: @iconOpacity;\n  font-size: @iconSize;\n  padding-top: @iconOffset;\n  vertical-align: @iconAlignment;\n}\n\n/* With Text Node */\n.ui.header .icon:only-child {\n  display: inline-block;\n  padding: 0em;\n  margin-right: @iconMargin;\n}\n\n/*-------------------\n        Image\n--------------------*/\n\n.ui.header > .image:not(.icon),\n.ui.header > img {\n  display: inline-block;\n  margin-top: @imageOffset;\n  width: @imageWidth;\n  height: @imageHeight;\n  vertical-align: @imageAlignment;\n}\n.ui.header > .image:not(.icon):only-child,\n.ui.header > img:only-child {\n  margin-right: @imageMargin;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.header .content {\n  display: inline-block;\n  vertical-align: @contentAlignment;\n}\n\n/* After Image */\n.ui.header > img + .content,\n.ui.header > .image + .content {\n  padding-left: @imageMargin;\n  vertical-align: @contentImageAlignment;\n}\n\n/* After Icon */\n.ui.header > .icon + .content {\n  padding-left: @iconMargin;\n  display: table-cell;\n  vertical-align: @contentIconAlignment;\n}\n\n\n/*--------------\n Loose Coupling\n---------------*/\n\n.ui.header .ui.label {\n  font-size: @labelSize;\n  margin-left: @labelDistance;\n  vertical-align: @labelVerticalAlign;\n}\n\n/* Positioning */\n.ui.header + p {\n  margin-top: @nextParagraphDistance;\n}\n\n\n\n/*******************************\n            Types\n*******************************/\n\n\n/*--------------\n     Page\n---------------*/\n\nh1.ui.header {\n  font-size: @h1;\n}\nh2.ui.header {\n  font-size: @h2;\n}\nh3.ui.header {\n  font-size: @h3;\n}\nh4.ui.header {\n  font-size: @h4;\n}\nh5.ui.header {\n  font-size: @h5;\n}\n\n\n/* Sub Header */\nh1.ui.header .sub.header {\n  font-size: @h1SubHeaderFontSize;\n}\nh2.ui.header .sub.header {\n  font-size: @h2SubHeaderFontSize;\n}\nh3.ui.header .sub.header {\n  font-size: @h3SubHeaderFontSize;\n}\nh4.ui.header .sub.header {\n  font-size: @h4SubHeaderFontSize;\n}\nh5.ui.header .sub.header {\n  font-size: @h5SubHeaderFontSize;\n}\n\n\n/*--------------\n Content Heading\n---------------*/\n\n.ui.huge.header {\n  min-height: 1em;\n  font-size: @hugeFontSize;\n}\n.ui.large.header {\n  font-size: @largeFontSize;\n}\n.ui.medium.header {\n  font-size: @mediumFontSize;\n}\n.ui.small.header {\n  font-size: @smallFontSize;\n}\n.ui.tiny.header {\n  font-size: @tinyFontSize;\n}\n\n/* Sub Header */\n.ui.huge.header .sub.header {\n  font-size: @hugeSubHeaderFontSize;\n}\n.ui.large.header .sub.header {\n  font-size: @hugeSubHeaderFontSize;\n}\n.ui.header .sub.header {\n  font-size: @subHeaderFontSize;\n}\n.ui.small.header .sub.header {\n  font-size: @smallSubHeaderFontSize;\n}\n.ui.tiny.header .sub.header {\n  font-size: @tinySubHeaderFontSize;\n}\n\n/*--------------\n   Sub Heading\n---------------*/\n\n.ui.sub.header {\n  padding: 0em;\n  margin-bottom: @subHeadingDistance;\n  font-weight: @subHeadingFontWeight;\n  font-size: @subHeadingFontSize;\n  text-transform: @subHeadingTextTransform;\n  color: @subHeadingColor;\n}\n\n.ui.small.sub.header {\n  font-size: @smallSubHeadingSize;\n}\n.ui.sub.header {\n  font-size: @subHeadingFontSize;\n}\n.ui.large.sub.header {\n  font-size: @largeSubHeadingSize;\n}\n.ui.huge.sub.header {\n  font-size: @hugeSubHeadingSize;\n}\n\n\n\n/*-------------------\n        Icon\n--------------------*/\n\n.ui.icon.header {\n  display: inline-block;\n  text-align: center;\n  margin: @iconHeaderTopMargin 0em @iconHeaderBottomMargin;\n}\n.ui.icon.header:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n\n.ui.icon.header:first-child {\n  margin-top: @iconHeaderFirstMargin;\n}\n.ui.icon.header .icon {\n  float: none;\n  display: block;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 0em;\n  font-size: @iconHeaderSize;\n  margin: 0em auto @iconHeaderMargin;\n  opacity: @iconHeaderOpacity;\n}\n.ui.icon.header .content {\n  display: block;\n  padding: 0em;\n}\n.ui.icon.header .circular.icon {\n  font-size: @circularHeaderIconSize;\n}\n.ui.icon.header .square.icon {\n  font-size: @squareHeaderIconSize;\n}\n.ui.block.icon.header .icon {\n  margin-bottom: 0em;\n}\n.ui.icon.header.aligned {\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.disabled.header {\n  opacity: @disabledOpacity;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n      Inverted\n--------------------*/\n\n.ui.inverted.header {\n  color: @invertedColor;\n}\n.ui.inverted.header .sub.header {\n  color: @invertedSubHeaderColor;\n}\n.ui.inverted.attached.header {\n  background: @invertedAttachedBackground;\n  box-shadow: none;\n  border-color: transparent;\n}\n.ui.inverted.block.header {\n  background: @invertedBlockBackground;\n  box-shadow: none;\n}\n.ui.inverted.block.header {\n  border-bottom: none;\n}\n\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Red ---*/\n.ui.red.header {\n  color: @red !important;\n}\na.ui.red.header:hover {\n  color: @redHover !important;\n}\n.ui.red.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @red;\n}\n\n/* Inverted */\n.ui.inverted.red.header {\n  color: @lightRed !important;\n}\na.ui.inverted.red.header:hover {\n  color: @lightRedHover !important;\n}\n\n/*--- Orange ---*/\n.ui.orange.header {\n  color: @orange !important;\n}\na.ui.orange.header:hover {\n  color: @orangeHover !important;\n}\n.ui.orange.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @orange;\n}\n/* Inverted */\n.ui.inverted.orange.header {\n  color: @lightOrange !important;\n}\na.ui.inverted.orange.header:hover {\n  color: @lightOrangeHover !important;\n}\n\n/*--- Olive ---*/\n.ui.olive.header {\n  color: @olive !important;\n}\na.ui.olive.header:hover {\n  color: @oliveHover !important;\n}\n.ui.olive.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @olive;\n}\n/* Inverted */\n.ui.inverted.olive.header {\n  color: @lightOlive !important;\n}\na.ui.inverted.olive.header:hover {\n  color: @lightOliveHover !important;\n}\n\n/*--- Yellow ---*/\n.ui.yellow.header {\n  color: @yellow !important;\n}\na.ui.yellow.header:hover {\n  color: @yellowHover !important;\n}\n.ui.yellow.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @yellow;\n}\n/* Inverted */\n.ui.inverted.yellow.header {\n  color: @lightYellow !important;\n}\na.ui.inverted.yellow.header:hover {\n  color: @lightYellowHover !important;\n}\n\n/*--- Green ---*/\n.ui.green.header {\n  color: @green !important;\n}\na.ui.green.header:hover {\n  color: @greenHover !important;\n}\n.ui.green.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @green;\n}\n/* Inverted */\n.ui.inverted.green.header {\n  color: @lightGreen !important;\n}\na.ui.inverted.green.header:hover {\n  color: @lightGreenHover !important;\n}\n\n/*--- Teal ---*/\n.ui.teal.header {\n  color: @teal !important;\n}\na.ui.teal.header:hover {\n  color: @tealHover !important;\n}\n.ui.teal.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @teal;\n}\n/* Inverted */\n.ui.inverted.teal.header {\n  color: @lightTeal !important;\n}\na.ui.inverted.teal.header:hover {\n  color: @lightTealHover !important;\n}\n\n/*--- Blue ---*/\n.ui.blue.header {\n  color: @blue !important;\n}\na.ui.blue.header:hover {\n  color: @blueHover !important;\n}\n.ui.blue.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @blue;\n}\n/* Inverted */\n.ui.inverted.blue.header {\n  color: @lightBlue !important;\n}\na.ui.inverted.blue.header:hover {\n  color: @lightBlueHover !important;\n}\n\n/*--- Violet ---*/\n.ui.violet.header {\n  color: @violet !important;\n}\na.ui.violet.header:hover {\n  color: @violetHover !important;\n}\n.ui.violet.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @violet;\n}\n/* Inverted */\n.ui.inverted.violet.header {\n  color: @lightViolet !important;\n}\na.ui.inverted.violet.header:hover {\n  color: @lightVioletHover !important;\n}\n\n/*--- Purple ---*/\n.ui.purple.header {\n  color: @purple !important;\n}\na.ui.purple.header:hover {\n  color: @purpleHover !important;\n}\n.ui.purple.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @purple;\n}\n/* Inverted */\n.ui.inverted.purple.header {\n  color: @lightPurple !important;\n}\na.ui.inverted.purple.header:hover {\n  color: @lightPurpleHover !important;\n}\n\n/*--- Pink ---*/\n.ui.pink.header {\n  color: @pink !important;\n}\na.ui.pink.header:hover {\n  color: @pinkHover !important;\n}\n.ui.pink.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @pink;\n}\n/* Inverted */\n.ui.inverted.pink.header {\n  color: @lightPink !important;\n}\na.ui.inverted.pink.header:hover {\n  color: @lightPinkHover !important;\n}\n\n/*--- Brown ---*/\n.ui.brown.header {\n  color: @brown !important;\n}\na.ui.brown.header:hover {\n  color: @brownHover !important;\n}\n.ui.brown.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @brown;\n}\n/* Inverted */\n.ui.inverted.brown.header {\n  color: @lightBrown !important;\n}\na.ui.inverted.brown.header:hover {\n  color: @lightBrownHover !important;\n}\n\n/*--- Grey ---*/\n.ui.grey.header {\n  color: @grey !important;\n}\na.ui.grey.header:hover {\n  color: @greyHover !important;\n}\n.ui.grey.dividing.header {\n  border-bottom: @dividedColoredBorderWidth solid @grey;\n}\n/* Inverted */\n.ui.inverted.grey.header {\n  color: @lightGrey !important;\n}\na.ui.inverted.grey.header:hover {\n  color: @lightGreyHover !important;\n}\n\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.left.aligned.header {\n  text-align: left;\n}\n.ui.right.aligned.header {\n  text-align: right;\n}\n.ui.centered.header,\n.ui.center.aligned.header {\n  text-align: center;\n}\n.ui.justified.header {\n  text-align: justify;\n}\n.ui.justified.header:after {\n  display: inline-block;\n  content: '';\n  width: 100%;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.header,\n.ui[class*=\"left floated\"].header {\n  float: left;\n  margin-top: 0em;\n  margin-right: @floatedMargin;\n}\n.ui[class*=\"right floated\"].header {\n  float: right;\n  margin-top: 0em;\n  margin-left: @floatedMargin;\n}\n\n/*-------------------\n       Fitted\n--------------------*/\n\n.ui.fitted.header {\n  padding: 0em;\n}\n\n\n/*-------------------\n      Dividing\n--------------------*/\n\n.ui.dividing.header {\n  padding-bottom: @dividedBorderPadding;\n  border-bottom: @dividedBorder;\n}\n.ui.dividing.header .sub.header {\n  padding-bottom: @dividedSubHeaderPadding;\n}\n.ui.dividing.header .icon {\n  margin-bottom: @dividedIconPadding;\n}\n\n.ui.inverted.dividing.header {\n  border-bottom-color: @invertedDividedBorderColor;\n}\n\n\n/*-------------------\n        Block\n--------------------*/\n\n.ui.block.header {\n  background: @blockBackground;\n  padding: @blockVerticalPadding @blockHorizontalPadding;\n  box-shadow: @blockBoxShadow;\n  border: @blockBorder;\n  border-radius: @blockBorderRadius;\n}\n\n.ui.tiny.block.header {\n  font-size: @tinyBlock;\n}\n.ui.small.block.header {\n  font-size: @smallBlock;\n}\n.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: @mediumBlock;\n}\n.ui.large.block.header {\n  font-size: @largeBlock;\n}\n.ui.huge.block.header {\n  font-size: @hugeBlock;\n}\n\n/*-------------------\n       Attached\n--------------------*/\n\n.ui.attached.header {\n  background: @attachedBackground;\n  padding: @attachedVerticalPadding @attachedHorizontalPadding;\n  margin-left: @attachedOffset;\n  margin-right: @attachedOffset;\n  box-shadow: @attachedBoxShadow;\n  border: @attachedBorder;\n}\n.ui.attached.block.header {\n  background: @blockBackground;\n}\n\n.ui.attached:not(.top):not(.bottom).header {\n  margin-top: 0em;\n  margin-bottom: 0em;\n  border-top: none;\n  border-radius: 0em;\n}\n.ui.top.attached.header {\n  margin-bottom: 0em;\n  border-radius: @attachedBorderRadius @attachedBorderRadius 0em 0em;\n}\n.ui.bottom.attached.header {\n  margin-top: 0em;\n  border-top: none;\n  border-radius: 0em 0em @attachedBorderRadius @attachedBorderRadius;\n}\n\n/* Attached Sizes */\n.ui.tiny.attached.header {\n  font-size: @tinyAttachedSize;\n}\n.ui.small.attached.header {\n  font-size: @smallAttachedSize;\n}\n.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: @mediumAttachedSize;\n}\n.ui.large.attached.header {\n  font-size: @largeAttachedSize;\n}\n.ui.huge.attached.header {\n  font-size: @hugeAttachedSize;\n}\n\n/*-------------------\n        Sizing\n--------------------*/\n\n.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: @mediumFontSize;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'icon';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n             Icon\n*******************************/\n\n@font-face {\n  font-family: 'Icons';\n  src: @fallbackSRC;\n  src: @src;\n  font-style: normal;\n  font-weight: @normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\n\ni.icon {\n  display: inline-block;\n  opacity: @opacity;\n\n  margin: 0em @distanceFromText 0em 0em;\n\n  width: @width;\n  height: @height;\n\n  font-family: 'Icons';\n  font-style: normal;\n  font-weight: @normal;\n  text-decoration: inherit;\n  text-align: center;\n\n  speak: none;\n  font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  backface-visibility: hidden;\n}\n\ni.icon:before {\n  background: none !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n    Loading\n---------------*/\n\ni.icon.loading {\n  height: 1em;\n  line-height: 1;\n}\n\ni.icon.loading {\n  animation: icon-loading @loadingDuration linear infinite;\n}\n\n@keyframes icon-loading {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*******************************\n             States\n*******************************/\n\ni.icon.hover {\n  opacity: 1 !important;\n}\n\ni.icon.active {\n  opacity: 1 !important;\n}\n\ni.emphasized.icon {\n  opacity: 1 !important;\n}\n\ni.disabled.icon {\n  opacity: @disabledOpacity !important;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-------------------\n        Fitted\n--------------------*/\n\ni.fitted.icon {\n  width: auto;\n  margin: 0em !important;\n}\n\n/*-------------------\n         Link\n--------------------*/\n\ni.link.icon, i.link.icons {\n  cursor: pointer;\n  opacity: @linkOpacity;\n  transition: opacity @defaultDuration @defaultEasing;\n}\ni.link.icon:hover, i.link.icons:hover {\n  opacity: 1 !important;\n}\n\n/*-------------------\n      Circular\n--------------------*/\n\ni.circular.icon {\n  border-radius: 500em !important;\n  line-height: 1 !important;\n\n  padding: @circularPadding !important;\n  box-shadow: @circularShadow;\n\n  width: @circularSize !important;\n  height: @circularSize !important;\n}\ni.circular.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n\n/*-------------------\n      Flipped\n--------------------*/\n\ni.flipped.icon,\ni.horizontally.flipped.icon {\n  transform: scale(-1, 1);\n}\ni.vertically.flipped.icon {\n  transform: scale(1, -1);\n}\n\n/*-------------------\n      Rotated\n--------------------*/\n\ni.rotated.icon,\ni.right.rotated.icon,\ni.clockwise.rotated.icon {\n  transform: rotate(90deg);\n}\n\ni.left.rotated.icon,\ni.counterclockwise.rotated.icon {\n  transform: rotate(-90deg);\n}\n\n/*-------------------\n      Bordered\n--------------------*/\n\ni.bordered.icon {\n  line-height: 1;\n  vertical-align: baseline;\n\n  width: @borderedSize;\n  height: @borderedSize;\n  padding: @borderedVerticalPadding @borderedHorizontalPadding !important;\n  box-shadow: @borderedShadow;\n}\ni.bordered.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n\n/*-------------------\n      Inverted\n--------------------*/\n\n/* Inverted Shapes */\ni.inverted.bordered.icon,\ni.inverted.circular.icon {\n  background-color: @black !important;\n  color: @white !important;\n}\n\ni.inverted.icon {\n  color: @white;\n}\n\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\ni.red.icon {\n  color: @red !important;\n}\ni.inverted.red.icon {\n  color: @lightRed !important;\n}\ni.inverted.bordered.red.icon,\ni.inverted.circular.red.icon {\n  background-color: @red !important;\n  color: @white !important;\n}\n\n/* Orange */\ni.orange.icon {\n  color: @orange !important;\n}\ni.inverted.orange.icon {\n  color: @lightOrange !important;\n}\ni.inverted.bordered.orange.icon,\ni.inverted.circular.orange.icon {\n  background-color: @orange !important;\n  color: @white !important;\n}\n\n/* Yellow */\ni.yellow.icon {\n  color: @yellow !important;\n}\ni.inverted.yellow.icon {\n  color: @lightYellow !important;\n}\ni.inverted.bordered.yellow.icon,\ni.inverted.circular.yellow.icon {\n  background-color: @yellow !important;\n  color: @white !important;\n}\n\n/* Olive */\ni.olive.icon {\n  color: @olive !important;\n}\ni.inverted.olive.icon {\n  color: @lightOlive !important;\n}\ni.inverted.bordered.olive.icon,\ni.inverted.circular.olive.icon {\n  background-color: @olive !important;\n  color: @white !important;\n}\n\n/* Green */\ni.green.icon {\n  color: @green !important;\n}\ni.inverted.green.icon {\n  color: @lightGreen !important;\n}\ni.inverted.bordered.green.icon,\ni.inverted.circular.green.icon {\n  background-color: @green !important;\n  color: @white !important;\n}\n\n/* Teal */\ni.teal.icon {\n  color: @teal !important;\n}\ni.inverted.teal.icon {\n  color: @lightTeal !important;\n}\ni.inverted.bordered.teal.icon,\ni.inverted.circular.teal.icon {\n  background-color: @teal !important;\n  color: @white !important;\n}\n\n/* Blue */\ni.blue.icon {\n  color: @blue !important;\n}\ni.inverted.blue.icon {\n  color: @lightBlue !important;\n}\ni.inverted.bordered.blue.icon,\ni.inverted.circular.blue.icon {\n  background-color: @blue !important;\n  color: @white !important;\n}\n\n/* Violet */\ni.violet.icon {\n  color: @violet !important;\n}\ni.inverted.violet.icon {\n  color: @lightViolet !important;\n}\ni.inverted.bordered.violet.icon,\ni.inverted.circular.violet.icon {\n  background-color: @violet !important;\n  color: @white !important;\n}\n\n/* Purple */\ni.purple.icon {\n  color: @purple !important;\n}\ni.inverted.purple.icon {\n  color: @lightPurple !important;\n}\ni.inverted.bordered.purple.icon,\ni.inverted.circular.purple.icon {\n  background-color: @purple !important;\n  color: @white !important;\n}\n\n/* Pink */\ni.pink.icon {\n  color: @pink !important;\n}\ni.inverted.pink.icon {\n  color: @lightPink !important;\n}\ni.inverted.bordered.pink.icon,\ni.inverted.circular.pink.icon {\n  background-color: @pink !important;\n  color: @white !important;\n}\n\n/* Brown */\ni.brown.icon {\n  color: @brown !important;\n}\ni.inverted.brown.icon {\n  color: @lightBrown !important;\n}\ni.inverted.bordered.brown.icon,\ni.inverted.circular.brown.icon {\n  background-color: @brown !important;\n  color: @white !important;\n}\n\n/* Grey */\ni.grey.icon {\n  color: @grey !important;\n}\ni.inverted.grey.icon {\n  color: @lightGrey !important;\n}\ni.inverted.bordered.grey.icon,\ni.inverted.circular.grey.icon {\n  background-color: @grey !important;\n  color: @white !important;\n}\n\n/* Black */\ni.black.icon {\n  color: @black !important;\n}\ni.inverted.black.icon {\n  color: @lightBlack !important;\n}\ni.inverted.bordered.black.icon,\ni.inverted.circular.black.icon {\n  background-color: @black !important;\n  color: @white !important;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\ni.mini.icon,\ni.mini.icons {\n  line-height: 1;\n  font-size: @mini;\n}\ni.tiny.icon,\ni.tiny.icons {\n  line-height: 1;\n  font-size: @tiny;\n}\ni.small.icon,\ni.small.icons {\n  line-height: 1;\n  font-size: @small;\n}\ni.icon,\ni.icons {\n  font-size: @medium;\n}\ni.large.icon,\ni.large.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: @large;\n}\ni.big.icon,\ni.big.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: @big;\n}\ni.huge.icon,\ni.huge.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: @huge;\n}\ni.massive.icon,\ni.massive.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: @massive;\n}\n\n/*******************************\n            Groups\n*******************************/\n\ni.icons {\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n}\n\ni.icons .icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  margin: 0em;\n  margin: 0;\n}\n\ni.icons .icon:first-child {\n  position: static;\n  width: auto;\n  height: auto;\n  vertical-align: top;\n  transform: none;\n  margin-right: @distanceFromText;\n}\n\n/* Corner Icon */\ni.icons .corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  transform: none;\n  font-size: @cornerIconSize;\n  text-shadow: @cornerIconShadow;\n}\ni.icons .top.right.corner.icon {\n  top: 0;\n  left: auto;\n  right: 0;\n  bottom: auto;\n}\ni.icons .top.left.corner.icon {\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: auto;\n}\ni.icons .bottom.left.corner.icon {\n  top: auto;\n  left: 0;\n  right: auto;\n  bottom: 0;\n}\ni.icons .bottom.right.corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n}\n\ni.icons .inverted.corner.icon {\n  text-shadow: @cornerIconInvertedShadow;\n}\n\n.loadUIOverrides();\n","/*\n * Font Awesome 5.0.8 by @fontawesome - http://fontawesome.io - @fontawesome\n * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)\n */\n\n/*******************************\n\nSemantic-UI integration of font-awesome :\n\n///class names are separated\ni.icon.circle => i.icon.circle\ni.icon.circle-o => i.icon.circle.outline\n\n//abbreviation are replaced by full letters:\ni.icon.ellipsis-h => i.icon.ellipsis.horizontal\ni.icon.ellipsis-v => i.icon.ellipsis.vertical\n.alpha => .i.icon.alphabet\n.asc => .i.icon.ascending\n.desc => .i.icon.descending\n.alt =>.alternate\n\nASCII order is conserved for easier maintenance.\n\nIcons that only have one style 'outline', 'square' etc do not require this class\nfor instance `lemon icon` not `lemon outline icon` since there is only one lemon\n\n*******************************/\n\n\n/*******************************\n            Icons\n*******************************/\n\n/* Deprecated *In/Out Naming Conflict) */\ni.icon.linkedin.in:before { content: \"\\f0e1\"; }\ni.icon.zoom.in:before { content: \"\\f00e\"; }\ni.icon.zoom.out:before { content: \"\\f010\"; }\ni.icon.sign.in:before { content: \"\\f2f6\"; }\ni.icon.in.cart:before { content: \"\\f218\"; }\ni.icon.log.out:before { content: \"\\f2f5\"; }\ni.icon.sign.out:before { content: \"\\f2f5\"; }\n\n/* Icons */\ni.icon.\\35 00px:before { content: \"\\f26e\"; }\ni.icon.accessible.icon:before { content: \"\\f368\"; }\ni.icon.accusoft:before { content: \"\\f369\"; }\ni.icon.address.book:before { content: \"\\f2b9\"; }\ni.icon.address.card:before { content: \"\\f2bb\"; }\ni.icon.adjust:before { content: \"\\f042\"; }\ni.icon.adn:before { content: \"\\f170\"; }\ni.icon.adversal:before { content: \"\\f36a\"; }\ni.icon.affiliatetheme:before { content: \"\\f36b\"; }\ni.icon.algolia:before { content: \"\\f36c\"; }\ni.icon.align.center:before { content: \"\\f037\"; }\ni.icon.align.justify:before { content: \"\\f039\"; }\ni.icon.align.left:before { content: \"\\f036\"; }\ni.icon.align.right:before { content: \"\\f038\"; }\ni.icon.amazon:before { content: \"\\f270\"; }\ni.icon.amazon.pay:before { content: \"\\f42c\"; }\ni.icon.ambulance:before { content: \"\\f0f9\"; }\ni.icon.american.sign.language.interpreting:before { content: \"\\f2a3\"; }\ni.icon.amilia:before { content: \"\\f36d\"; }\ni.icon.anchor:before { content: \"\\f13d\"; }\ni.icon.android:before { content: \"\\f17b\"; }\ni.icon.angellist:before { content: \"\\f209\"; }\ni.icon.angle.double.down:before { content: \"\\f103\"; }\ni.icon.angle.double.left:before { content: \"\\f100\"; }\ni.icon.angle.double.right:before { content: \"\\f101\"; }\ni.icon.angle.double.up:before { content: \"\\f102\"; }\ni.icon.angle.down:before { content: \"\\f107\"; }\ni.icon.angle.left:before { content: \"\\f104\"; }\ni.icon.angle.right:before { content: \"\\f105\"; }\ni.icon.angle.up:before { content: \"\\f106\"; }\ni.icon.angrycreative:before { content: \"\\f36e\"; }\ni.icon.angular:before { content: \"\\f420\"; }\ni.icon.app.store:before { content: \"\\f36f\"; }\ni.icon.app.store.ios:before { content: \"\\f370\"; }\ni.icon.apper:before { content: \"\\f371\"; }\ni.icon.apple:before { content: \"\\f179\"; }\ni.icon.apple.pay:before { content: \"\\f415\"; }\ni.icon.archive:before { content: \"\\f187\"; }\ni.icon.arrow.alternate.circle.down:before { content: \"\\f358\"; }\ni.icon.arrow.alternate.circle.left:before { content: \"\\f359\"; }\ni.icon.arrow.alternate.circle.right:before { content: \"\\f35a\"; }\ni.icon.arrow.alternate.circle.up:before { content: \"\\f35b\"; }\ni.icon.arrow.circle.down:before { content: \"\\f0ab\"; }\ni.icon.arrow.circle.left:before { content: \"\\f0a8\"; }\ni.icon.arrow.circle.right:before { content: \"\\f0a9\"; }\ni.icon.arrow.circle.up:before { content: \"\\f0aa\"; }\ni.icon.arrow.down:before { content: \"\\f063\"; }\ni.icon.arrow.left:before { content: \"\\f060\"; }\ni.icon.arrow.right:before { content: \"\\f061\"; }\ni.icon.arrow.up:before { content: \"\\f062\"; }\ni.icon.arrows.alternate:before { content: \"\\f0b2\"; }\ni.icon.arrows.alternate.horizontal:before { content: \"\\f337\"; }\ni.icon.arrows.alternate.vertical:before { content: \"\\f338\"; }\ni.icon.assistive.listening.systems:before { content: \"\\f2a2\"; }\ni.icon.asterisk:before { content: \"\\f069\"; }\ni.icon.asymmetrik:before { content: \"\\f372\"; }\ni.icon.at:before { content: \"\\f1fa\"; }\ni.icon.audible:before { content: \"\\f373\"; }\ni.icon.audio.description:before { content: \"\\f29e\"; }\ni.icon.autoprefixer:before { content: \"\\f41c\"; }\ni.icon.avianex:before { content: \"\\f374\"; }\ni.icon.aviato:before { content: \"\\f421\"; }\ni.icon.aws:before { content: \"\\f375\"; }\ni.icon.backward:before { content: \"\\f04a\"; }\ni.icon.balance.scale:before { content: \"\\f24e\"; }\ni.icon.ban:before { content: \"\\f05e\"; }\ni.icon.band.aid:before { content: \"\\f462\"; }\ni.icon.bandcamp:before { content: \"\\f2d5\"; }\ni.icon.barcode:before { content: \"\\f02a\"; }\ni.icon.bars:before { content: \"\\f0c9\"; }\ni.icon.baseball.ball:before { content: \"\\f433\"; }\ni.icon.basketball.ball:before { content: \"\\f434\"; }\ni.icon.bath:before { content: \"\\f2cd\"; }\ni.icon.battery.empty:before { content: \"\\f244\"; }\ni.icon.battery.full:before { content: \"\\f240\"; }\ni.icon.battery.half:before { content: \"\\f242\"; }\ni.icon.battery.quarter:before { content: \"\\f243\"; }\ni.icon.battery.three.quarters:before { content: \"\\f241\"; }\ni.icon.bed:before { content: \"\\f236\"; }\ni.icon.beer:before { content: \"\\f0fc\"; }\ni.icon.behance:before { content: \"\\f1b4\"; }\ni.icon.behance.square:before { content: \"\\f1b5\"; }\ni.icon.bell:before { content: \"\\f0f3\"; }\ni.icon.bell.slash:before { content: \"\\f1f6\"; }\ni.icon.bicycle:before { content: \"\\f206\"; }\ni.icon.bimobject:before { content: \"\\f378\"; }\ni.icon.binoculars:before { content: \"\\f1e5\"; }\ni.icon.birthday.cake:before { content: \"\\f1fd\"; }\ni.icon.bitbucket:before { content: \"\\f171\"; }\ni.icon.bitcoin:before { content: \"\\f379\"; }\ni.icon.bity:before { content: \"\\f37a\"; }\ni.icon.black.tie:before { content: \"\\f27e\"; }\ni.icon.blackberry:before { content: \"\\f37b\"; }\ni.icon.blind:before { content: \"\\f29d\"; }\ni.icon.blogger:before { content: \"\\f37c\"; }\ni.icon.blogger.b:before { content: \"\\f37d\"; }\ni.icon.bluetooth:before { content: \"\\f293\"; }\ni.icon.bluetooth.b:before { content: \"\\f294\"; }\ni.icon.bold:before { content: \"\\f032\"; }\ni.icon.bolt:before { content: \"\\f0e7\"; }\ni.icon.bomb:before { content: \"\\f1e2\"; }\ni.icon.book:before { content: \"\\f02d\"; }\ni.icon.bookmark:before { content: \"\\f02e\"; }\ni.icon.bowling.ball:before { content: \"\\f436\"; }\ni.icon.box:before { content: \"\\f466\"; }\ni.icon.boxes:before { content: \"\\f468\"; }\ni.icon.braille:before { content: \"\\f2a1\"; }\ni.icon.briefcase:before { content: \"\\f0b1\"; }\ni.icon.btc:before { content: \"\\f15a\"; }\ni.icon.bug:before { content: \"\\f188\"; }\ni.icon.building:before { content: \"\\f1ad\"; }\ni.icon.bullhorn:before { content: \"\\f0a1\"; }\ni.icon.bullseye:before { content: \"\\f140\"; }\ni.icon.buromobelexperte:before { content: \"\\f37f\"; }\ni.icon.bus:before { content: \"\\f207\"; }\ni.icon.buysellads:before { content: \"\\f20d\"; }\ni.icon.calculator:before { content: \"\\f1ec\"; }\ni.icon.calendar:before { content: \"\\f133\"; }\ni.icon.calendar.alternate:before { content: \"\\f073\"; }\ni.icon.calendar.check:before { content: \"\\f274\"; }\ni.icon.calendar.minus:before { content: \"\\f272\"; }\ni.icon.calendar.plus:before { content: \"\\f271\"; }\ni.icon.calendar.times:before { content: \"\\f273\"; }\ni.icon.camera:before { content: \"\\f030\"; }\ni.icon.camera.retro:before { content: \"\\f083\"; }\ni.icon.car:before { content: \"\\f1b9\"; }\ni.icon.caret.down:before { content: \"\\f0d7\"; }\ni.icon.caret.left:before { content: \"\\f0d9\"; }\ni.icon.caret.right:before { content: \"\\f0da\"; }\ni.icon.caret.square.down:before { content: \"\\f150\"; }\ni.icon.caret.square.left:before { content: \"\\f191\"; }\ni.icon.caret.square.right:before { content: \"\\f152\"; }\ni.icon.caret.square.up:before { content: \"\\f151\"; }\ni.icon.caret.up:before { content: \"\\f0d8\"; }\ni.icon.cart.arrow.down:before { content: \"\\f218\"; }\ni.icon.cart.plus:before { content: \"\\f217\"; }\ni.icon.cc.amazon.pay:before { content: \"\\f42d\"; }\ni.icon.cc.amex:before { content: \"\\f1f3\"; }\ni.icon.cc.apple.pay:before { content: \"\\f416\"; }\ni.icon.cc.diners.club:before { content: \"\\f24c\"; }\ni.icon.cc.discover:before { content: \"\\f1f2\"; }\ni.icon.cc.jcb:before { content: \"\\f24b\"; }\ni.icon.cc.mastercard:before { content: \"\\f1f1\"; }\ni.icon.cc.paypal:before { content: \"\\f1f4\"; }\ni.icon.cc.stripe:before { content: \"\\f1f5\"; }\ni.icon.cc.visa:before { content: \"\\f1f0\"; }\ni.icon.centercode:before { content: \"\\f380\"; }\ni.icon.certificate:before { content: \"\\f0a3\"; }\ni.icon.chart.area:before { content: \"\\f1fe\"; }\ni.icon.chart.bar:before { content: \"\\f080\"; }\ni.icon.chart.line:before { content: \"\\f201\"; }\ni.icon.chart.pie:before { content: \"\\f200\"; }\ni.icon.check:before { content: \"\\f00c\"; }\ni.icon.check.circle:before { content: \"\\f058\"; }\ni.icon.check.square:before { content: \"\\f14a\"; }\ni.icon.chess:before { content: \"\\f439\"; }\ni.icon.chess.bishop:before { content: \"\\f43a\"; }\ni.icon.chess.board:before { content: \"\\f43c\"; }\ni.icon.chess.king:before { content: \"\\f43f\"; }\ni.icon.chess.knight:before { content: \"\\f441\"; }\ni.icon.chess.pawn:before { content: \"\\f443\"; }\ni.icon.chess.queen:before { content: \"\\f445\"; }\ni.icon.chess.rook:before { content: \"\\f447\"; }\ni.icon.chevron.circle.down:before { content: \"\\f13a\"; }\ni.icon.chevron.circle.left:before { content: \"\\f137\"; }\ni.icon.chevron.circle.right:before { content: \"\\f138\"; }\ni.icon.chevron.circle.up:before { content: \"\\f139\"; }\ni.icon.chevron.down:before { content: \"\\f078\"; }\ni.icon.chevron.left:before { content: \"\\f053\"; }\ni.icon.chevron.right:before { content: \"\\f054\"; }\ni.icon.chevron.up:before { content: \"\\f077\"; }\ni.icon.child:before { content: \"\\f1ae\"; }\ni.icon.chrome:before { content: \"\\f268\"; }\ni.icon.circle:before { content: \"\\f111\"; }\ni.icon.circle.notch:before { content: \"\\f1ce\"; }\ni.icon.clipboard:before { content: \"\\f328\"; }\ni.icon.clipboard.check:before { content: \"\\f46c\"; }\ni.icon.clipboard.list:before { content: \"\\f46d\"; }\ni.icon.clock:before { content: \"\\f017\"; }\ni.icon.clone:before { content: \"\\f24d\"; }\ni.icon.closed.captioning:before { content: \"\\f20a\"; }\ni.icon.cloud:before { content: \"\\f0c2\"; }\ni.icon.cloudscale:before { content: \"\\f383\"; }\ni.icon.cloudsmith:before { content: \"\\f384\"; }\ni.icon.cloudversify:before { content: \"\\f385\"; }\ni.icon.code:before { content: \"\\f121\"; }\ni.icon.code.branch:before { content: \"\\f126\"; }\ni.icon.codepen:before { content: \"\\f1cb\"; }\ni.icon.codiepie:before { content: \"\\f284\"; }\ni.icon.coffee:before { content: \"\\f0f4\"; }\ni.icon.cog:before { content: \"\\f013\"; }\ni.icon.cogs:before { content: \"\\f085\"; }\ni.icon.columns:before { content: \"\\f0db\"; }\ni.icon.comment:before { content: \"\\f075\"; }\ni.icon.comment.alternate:before { content: \"\\f27a\"; }\ni.icon.comments:before { content: \"\\f086\"; }\ni.icon.compass:before { content: \"\\f14e\"; }\ni.icon.compress:before { content: \"\\f066\"; }\ni.icon.connectdevelop:before { content: \"\\f20e\"; }\ni.icon.contao:before { content: \"\\f26d\"; }\ni.icon.copy:before { content: \"\\f0c5\"; }\ni.icon.copyright:before { content: \"\\f1f9\"; }\ni.icon.cpanel:before { content: \"\\f388\"; }\ni.icon.creative.commons:before { content: \"\\f25e\"; }\ni.icon.credit.card:before { content: \"\\f09d\"; }\ni.icon.crop:before { content: \"\\f125\"; }\ni.icon.crosshairs:before { content: \"\\f05b\"; }\ni.icon.css3:before { content: \"\\f13c\"; }\ni.icon.css3.alternate:before { content: \"\\f38b\"; }\ni.icon.cube:before { content: \"\\f1b2\"; }\ni.icon.cubes:before { content: \"\\f1b3\"; }\ni.icon.cut:before { content: \"\\f0c4\"; }\ni.icon.cuttlefish:before { content: \"\\f38c\"; }\ni.icon.d.and.d:before { content: \"\\f38d\"; }\ni.icon.dashcube:before { content: \"\\f210\"; }\ni.icon.database:before { content: \"\\f1c0\"; }\ni.icon.deaf:before { content: \"\\f2a4\"; }\ni.icon.delicious:before { content: \"\\f1a5\"; }\ni.icon.deploydog:before { content: \"\\f38e\"; }\ni.icon.deskpro:before { content: \"\\f38f\"; }\ni.icon.desktop:before { content: \"\\f108\"; }\ni.icon.deviantart:before { content: \"\\f1bd\"; }\ni.icon.digg:before { content: \"\\f1a6\"; }\ni.icon.digital.ocean:before { content: \"\\f391\"; }\ni.icon.discord:before { content: \"\\f392\"; }\ni.icon.discourse:before { content: \"\\f393\"; }\ni.icon.dna:before { content: \"\\f471\"; }\ni.icon.dochub:before { content: \"\\f394\"; }\ni.icon.docker:before { content: \"\\f395\"; }\ni.icon.dollar.sign:before { content: \"\\f155\"; }\ni.icon.dolly:before { content: \"\\f472\"; }\ni.icon.dolly.flatbed:before { content: \"\\f474\"; }\ni.icon.dot.circle:before { content: \"\\f192\"; }\ni.icon.download:before { content: \"\\f019\"; }\ni.icon.draft2digital:before { content: \"\\f396\"; }\ni.icon.dribbble:before { content: \"\\f17d\"; }\ni.icon.dribbble.square:before { content: \"\\f397\"; }\ni.icon.dropbox:before { content: \"\\f16b\"; }\ni.icon.drupal:before { content: \"\\f1a9\"; }\ni.icon.dyalog:before { content: \"\\f399\"; }\ni.icon.earlybirds:before { content: \"\\f39a\"; }\ni.icon.edge:before { content: \"\\f282\"; }\ni.icon.edit:before { content: \"\\f044\"; }\ni.icon.eject:before { content: \"\\f052\"; }\ni.icon.elementor:before { content: \"\\f430\"; }\ni.icon.ellipsis.horizontal:before { content: \"\\f141\"; }\ni.icon.ellipsis.vertical:before { content: \"\\f142\"; }\ni.icon.ember:before { content: \"\\f423\"; }\ni.icon.empire:before { content: \"\\f1d1\"; }\ni.icon.envelope:before { content: \"\\f0e0\"; }\ni.icon.envelope.open:before { content: \"\\f2b6\"; }\ni.icon.envelope.square:before { content: \"\\f199\"; }\ni.icon.envira:before { content: \"\\f299\"; }\ni.icon.eraser:before { content: \"\\f12d\"; }\ni.icon.erlang:before { content: \"\\f39d\"; }\ni.icon.ethereum:before { content: \"\\f42e\"; }\ni.icon.etsy:before { content: \"\\f2d7\"; }\ni.icon.euro.sign:before { content: \"\\f153\"; }\ni.icon.exchange.alternate:before { content: \"\\f362\"; }\ni.icon.exclamation:before { content: \"\\f12a\"; }\ni.icon.exclamation.circle:before { content: \"\\f06a\"; }\ni.icon.exclamation.triangle:before { content: \"\\f071\"; }\ni.icon.expand:before { content: \"\\f065\"; }\ni.icon.expand.arrows.alternate:before { content: \"\\f31e\"; }\ni.icon.expeditedssl:before { content: \"\\f23e\"; }\ni.icon.external.alternate:before { content: \"\\f35d\"; }\ni.icon.external.square.alternate:before { content: \"\\f360\"; }\ni.icon.eye:before { content: \"\\f06e\"; }\ni.icon.eye.dropper:before { content: \"\\f1fb\"; }\ni.icon.eye.slash:before { content: \"\\f070\"; }\ni.icon.facebook:before { content: \"\\f09a\"; }\ni.icon.facebook.f:before { content: \"\\f39e\"; }\ni.icon.facebook.messenger:before { content: \"\\f39f\"; }\ni.icon.facebook.square:before { content: \"\\f082\"; }\ni.icon.fast.backward:before { content: \"\\f049\"; }\ni.icon.fast.forward:before { content: \"\\f050\"; }\ni.icon.fax:before { content: \"\\f1ac\"; }\ni.icon.female:before { content: \"\\f182\"; }\ni.icon.fighter.jet:before { content: \"\\f0fb\"; }\ni.icon.file:before { content: \"\\f15b\"; }\ni.icon.file.alternate:before { content: \"\\f15c\"; }\ni.icon.file.archive:before { content: \"\\f1c6\"; }\ni.icon.file.audio:before { content: \"\\f1c7\"; }\ni.icon.file.code:before { content: \"\\f1c9\"; }\ni.icon.file.excel:before { content: \"\\f1c3\"; }\ni.icon.file.image:before { content: \"\\f1c5\"; }\ni.icon.file.pdf:before { content: \"\\f1c1\"; }\ni.icon.file.powerpoint:before { content: \"\\f1c4\"; }\ni.icon.file.video:before { content: \"\\f1c8\"; }\ni.icon.file.word:before { content: \"\\f1c2\"; }\ni.icon.film:before { content: \"\\f008\"; }\ni.icon.filter:before { content: \"\\f0b0\"; }\ni.icon.fire:before { content: \"\\f06d\"; }\ni.icon.fire.extinguisher:before { content: \"\\f134\"; }\ni.icon.firefox:before { content: \"\\f269\"; }\ni.icon.first.aid:before { content: \"\\f479\"; }\ni.icon.first.order:before { content: \"\\f2b0\"; }\ni.icon.firstdraft:before { content: \"\\f3a1\"; }\ni.icon.flag:before { content: \"\\f024\"; }\ni.icon.flag.checkered:before { content: \"\\f11e\"; }\ni.icon.flask:before { content: \"\\f0c3\"; }\ni.icon.flickr:before { content: \"\\f16e\"; }\ni.icon.flipboard:before { content: \"\\f44d\"; }\ni.icon.fly:before { content: \"\\f417\"; }\ni.icon.folder:before { content: \"\\f07b\"; }\ni.icon.folder.open:before { content: \"\\f07c\"; }\ni.icon.font:before { content: \"\\f031\"; }\ni.icon.font.awesome:before { content: \"\\f2b4\"; }\ni.icon.font.awesome.alternate:before { content: \"\\f35c\"; }\ni.icon.font.awesome.flag:before { content: \"\\f425\"; }\ni.icon.fonticons:before { content: \"\\f280\"; }\ni.icon.fonticons.fi:before { content: \"\\f3a2\"; }\ni.icon.football.ball:before { content: \"\\f44e\"; }\ni.icon.fort.awesome:before { content: \"\\f286\"; }\ni.icon.fort.awesome.alternate:before { content: \"\\f3a3\"; }\ni.icon.forumbee:before { content: \"\\f211\"; }\ni.icon.forward:before { content: \"\\f04e\"; }\ni.icon.foursquare:before { content: \"\\f180\"; }\ni.icon.free.code.camp:before { content: \"\\f2c5\"; }\ni.icon.freebsd:before { content: \"\\f3a4\"; }\ni.icon.frown:before { content: \"\\f119\"; }\ni.icon.futbol:before { content: \"\\f1e3\"; }\ni.icon.gamepad:before { content: \"\\f11b\"; }\ni.icon.gavel:before { content: \"\\f0e3\"; }\ni.icon.gem:before { content: \"\\f3a5\"; }\ni.icon.genderless:before { content: \"\\f22d\"; }\ni.icon.get.pocket:before { content: \"\\f265\"; }\ni.icon.gg:before { content: \"\\f260\"; }\ni.icon.gg.circle:before { content: \"\\f261\"; }\ni.icon.gift:before { content: \"\\f06b\"; }\ni.icon.git:before { content: \"\\f1d3\"; }\ni.icon.git.square:before { content: \"\\f1d2\"; }\ni.icon.github:before { content: \"\\f09b\"; }\ni.icon.github.alternate:before { content: \"\\f113\"; }\ni.icon.github.square:before { content: \"\\f092\"; }\ni.icon.gitkraken:before { content: \"\\f3a6\"; }\ni.icon.gitlab:before { content: \"\\f296\"; }\ni.icon.gitter:before { content: \"\\f426\"; }\ni.icon.glass.martini:before { content: \"\\f000\"; }\ni.icon.glide:before { content: \"\\f2a5\"; }\ni.icon.glide.g:before { content: \"\\f2a6\"; }\ni.icon.globe:before { content: \"\\f0ac\"; }\ni.icon.gofore:before { content: \"\\f3a7\"; }\ni.icon.golf.ball:before { content: \"\\f450\"; }\ni.icon.goodreads:before { content: \"\\f3a8\"; }\ni.icon.goodreads.g:before { content: \"\\f3a9\"; }\ni.icon.google:before { content: \"\\f1a0\"; }\ni.icon.google.drive:before { content: \"\\f3aa\"; }\ni.icon.google.play:before { content: \"\\f3ab\"; }\ni.icon.google.plus:before { content: \"\\f2b3\"; }\ni.icon.google.plus.g:before { content: \"\\f0d5\"; }\ni.icon.google.plus.square:before { content: \"\\f0d4\"; }\ni.icon.google.wallet:before { content: \"\\f1ee\"; }\ni.icon.graduation.cap:before { content: \"\\f19d\"; }\ni.icon.gratipay:before { content: \"\\f184\"; }\ni.icon.grav:before { content: \"\\f2d6\"; }\ni.icon.gripfire:before { content: \"\\f3ac\"; }\ni.icon.grunt:before { content: \"\\f3ad\"; }\ni.icon.gulp:before { content: \"\\f3ae\"; }\ni.icon.h.square:before { content: \"\\f0fd\"; }\ni.icon.hacker.news:before { content: \"\\f1d4\"; }\ni.icon.hacker.news.square:before { content: \"\\f3af\"; }\ni.icon.hand.lizard:before { content: \"\\f258\"; }\ni.icon.hand.paper:before { content: \"\\f256\"; }\ni.icon.hand.peace:before { content: \"\\f25b\"; }\ni.icon.hand.point.down:before { content: \"\\f0a7\"; }\ni.icon.hand.point.left:before { content: \"\\f0a5\"; }\ni.icon.hand.point.right:before { content: \"\\f0a4\"; }\ni.icon.hand.point.up:before { content: \"\\f0a6\"; }\ni.icon.hand.pointer:before { content: \"\\f25a\"; }\ni.icon.hand.rock:before { content: \"\\f255\"; }\ni.icon.hand.scissors:before { content: \"\\f257\"; }\ni.icon.hand.spock:before { content: \"\\f259\"; }\ni.icon.handshake:before { content: \"\\f2b5\"; }\ni.icon.hashtag:before { content: \"\\f292\"; }\ni.icon.hdd:before { content: \"\\f0a0\"; }\ni.icon.heading:before { content: \"\\f1dc\"; }\ni.icon.headphones:before { content: \"\\f025\"; }\ni.icon.heart:before { content: \"\\f004\"; }\ni.icon.heartbeat:before { content: \"\\f21e\"; }\ni.icon.hips:before { content: \"\\f452\"; }\ni.icon.hire.a.helper:before { content: \"\\f3b0\"; }\ni.icon.history:before { content: \"\\f1da\"; }\ni.icon.hockey.puck:before { content: \"\\f453\"; }\ni.icon.home:before { content: \"\\f015\"; }\ni.icon.hooli:before { content: \"\\f427\"; }\ni.icon.hospital:before { content: \"\\f0f8\"; }\ni.icon.hospital.symbol:before { content: \"\\f47e\"; }\ni.icon.hotjar:before { content: \"\\f3b1\"; }\ni.icon.hourglass:before { content: \"\\f254\"; }\ni.icon.hourglass.end:before { content: \"\\f253\"; }\ni.icon.hourglass.half:before { content: \"\\f252\"; }\ni.icon.hourglass.start:before { content: \"\\f251\"; }\ni.icon.houzz:before { content: \"\\f27c\"; }\ni.icon.html5:before { content: \"\\f13b\"; }\ni.icon.hubspot:before { content: \"\\f3b2\"; }\ni.icon.i.cursor:before { content: \"\\f246\"; }\ni.icon.id.badge:before { content: \"\\f2c1\"; }\ni.icon.id.card:before { content: \"\\f2c2\"; }\ni.icon.image:before { content: \"\\f03e\"; }\ni.icon.images:before { content: \"\\f302\"; }\ni.icon.imdb:before { content: \"\\f2d8\"; }\ni.icon.inbox:before { content: \"\\f01c\"; }\ni.icon.indent:before { content: \"\\f03c\"; }\ni.icon.industry:before { content: \"\\f275\"; }\ni.icon.info:before { content: \"\\f129\"; }\ni.icon.info.circle:before { content: \"\\f05a\"; }\ni.icon.instagram:before { content: \"\\f16d\"; }\ni.icon.internet.explorer:before { content: \"\\f26b\"; }\ni.icon.ioxhost:before { content: \"\\f208\"; }\ni.icon.italic:before { content: \"\\f033\"; }\ni.icon.itunes:before { content: \"\\f3b4\"; }\ni.icon.itunes.note:before { content: \"\\f3b5\"; }\ni.icon.jenkins:before { content: \"\\f3b6\"; }\ni.icon.joget:before { content: \"\\f3b7\"; }\ni.icon.joomla:before { content: \"\\f1aa\"; }\ni.icon.js:before { content: \"\\f3b8\"; }\ni.icon.js.square:before { content: \"\\f3b9\"; }\ni.icon.jsfiddle:before { content: \"\\f1cc\"; }\ni.icon.key:before { content: \"\\f084\"; }\ni.icon.keyboard:before { content: \"\\f11c\"; }\ni.icon.keycdn:before { content: \"\\f3ba\"; }\ni.icon.kickstarter:before { content: \"\\f3bb\"; }\ni.icon.kickstarter.k:before { content: \"\\f3bc\"; }\ni.icon.korvue:before { content: \"\\f42f\"; }\ni.icon.language:before { content: \"\\f1ab\"; }\ni.icon.laptop:before { content: \"\\f109\"; }\ni.icon.laravel:before { content: \"\\f3bd\"; }\ni.icon.lastfm:before { content: \"\\f202\"; }\ni.icon.lastfm.square:before { content: \"\\f203\"; }\ni.icon.leaf:before { content: \"\\f06c\"; }\ni.icon.leanpub:before { content: \"\\f212\"; }\ni.icon.lemon:before { content: \"\\f094\"; }\ni.icon.less:before { content: \"\\f41d\"; }\ni.icon.level.down.alternate:before { content: \"\\f3be\"; }\ni.icon.level.up.alternate:before { content: \"\\f3bf\"; }\ni.icon.life.ring:before { content: \"\\f1cd\"; }\ni.icon.lightbulb:before { content: \"\\f0eb\"; }\ni.icon.linechat:before { content: \"\\f3c0\"; }\ni.icon.linkify:before { content: \"\\f0c1\"; }\ni.icon.linkedin:before { content: \"\\f08c\"; }\ni.icon.linkedin.alt:before { content: \"\\f0e1\"; }\ni.icon.linode:before { content: \"\\f2b8\"; }\ni.icon.linux:before { content: \"\\f17c\"; }\ni.icon.lira.sign:before { content: \"\\f195\"; }\ni.icon.list:before { content: \"\\f03a\"; }\ni.icon.list.alternate:before { content: \"\\f022\"; }\ni.icon.list.ol:before { content: \"\\f0cb\"; }\ni.icon.list.ul:before { content: \"\\f0ca\"; }\ni.icon.location.arrow:before { content: \"\\f124\"; }\ni.icon.lock:before { content: \"\\f023\"; }\ni.icon.lock.open:before { content: \"\\f3c1\"; }\ni.icon.long.arrow.alternate.down:before { content: \"\\f309\"; }\ni.icon.long.arrow.alternate.left:before { content: \"\\f30a\"; }\ni.icon.long.arrow.alternate.right:before { content: \"\\f30b\"; }\ni.icon.long.arrow.alternate.up:before { content: \"\\f30c\"; }\ni.icon.low.vision:before { content: \"\\f2a8\"; }\ni.icon.lyft:before { content: \"\\f3c3\"; }\ni.icon.magento:before { content: \"\\f3c4\"; }\ni.icon.magic:before { content: \"\\f0d0\"; }\ni.icon.magnet:before { content: \"\\f076\"; }\ni.icon.male:before { content: \"\\f183\"; }\ni.icon.map:before { content: \"\\f279\"; }\ni.icon.map.marker:before { content: \"\\f041\"; }\ni.icon.map.marker.alternate:before { content: \"\\f3c5\"; }\ni.icon.map.pin:before { content: \"\\f276\"; }\ni.icon.map.signs:before { content: \"\\f277\"; }\ni.icon.mars:before { content: \"\\f222\"; }\ni.icon.mars.double:before { content: \"\\f227\"; }\ni.icon.mars.stroke:before { content: \"\\f229\"; }\ni.icon.mars.stroke.horizontal:before { content: \"\\f22b\"; }\ni.icon.mars.stroke.vertical:before { content: \"\\f22a\"; }\ni.icon.maxcdn:before { content: \"\\f136\"; }\ni.icon.medapps:before { content: \"\\f3c6\"; }\ni.icon.medium:before { content: \"\\f23a\"; }\ni.icon.medium.m:before { content: \"\\f3c7\"; }\ni.icon.medkit:before { content: \"\\f0fa\"; }\ni.icon.medrt:before { content: \"\\f3c8\"; }\ni.icon.meetup:before { content: \"\\f2e0\"; }\ni.icon.meh:before { content: \"\\f11a\"; }\ni.icon.mercury:before { content: \"\\f223\"; }\ni.icon.microchip:before { content: \"\\f2db\"; }\ni.icon.microphone:before { content: \"\\f130\"; }\ni.icon.microphone.slash:before { content: \"\\f131\"; }\ni.icon.microsoft:before { content: \"\\f3ca\"; }\ni.icon.minus:before { content: \"\\f068\"; }\ni.icon.minus.circle:before { content: \"\\f056\"; }\ni.icon.minus.square:before { content: \"\\f146\"; }\ni.icon.mix:before { content: \"\\f3cb\"; }\ni.icon.mixcloud:before { content: \"\\f289\"; }\ni.icon.mizuni:before { content: \"\\f3cc\"; }\ni.icon.mobile:before { content: \"\\f10b\"; }\ni.icon.mobile.alternate:before { content: \"\\f3cd\"; }\ni.icon.modx:before { content: \"\\f285\"; }\ni.icon.monero:before { content: \"\\f3d0\"; }\ni.icon.money.bill.alternate:before { content: \"\\f3d1\"; }\ni.icon.moon:before { content: \"\\f186\"; }\ni.icon.motorcycle:before { content: \"\\f21c\"; }\ni.icon.mouse.pointer:before { content: \"\\f245\"; }\ni.icon.music:before { content: \"\\f001\"; }\ni.icon.napster:before { content: \"\\f3d2\"; }\ni.icon.neuter:before { content: \"\\f22c\"; }\ni.icon.newspaper:before { content: \"\\f1ea\"; }\ni.icon.nintendo.switch:before { content: \"\\f418\"; }\ni.icon.node:before { content: \"\\f419\"; }\ni.icon.node.js:before { content: \"\\f3d3\"; }\ni.icon.npm:before { content: \"\\f3d4\"; }\ni.icon.ns8:before { content: \"\\f3d5\"; }\ni.icon.nutritionix:before { content: \"\\f3d6\"; }\ni.icon.object.group:before { content: \"\\f247\"; }\ni.icon.object.ungroup:before { content: \"\\f248\"; }\ni.icon.odnoklassniki:before { content: \"\\f263\"; }\ni.icon.odnoklassniki.square:before { content: \"\\f264\"; }\ni.icon.opencart:before { content: \"\\f23d\"; }\ni.icon.openid:before { content: \"\\f19b\"; }\ni.icon.opera:before { content: \"\\f26a\"; }\ni.icon.optin.monster:before { content: \"\\f23c\"; }\ni.icon.osi:before { content: \"\\f41a\"; }\ni.icon.outdent:before { content: \"\\f03b\"; }\ni.icon.page4:before { content: \"\\f3d7\"; }\ni.icon.pagelines:before { content: \"\\f18c\"; }\ni.icon.paint.brush:before { content: \"\\f1fc\"; }\ni.icon.palfed:before { content: \"\\f3d8\"; }\ni.icon.pallet:before { content: \"\\f482\"; }\ni.icon.paper.plane:before { content: \"\\f1d8\"; }\ni.icon.paperclip:before { content: \"\\f0c6\"; }\ni.icon.paragraph:before { content: \"\\f1dd\"; }\ni.icon.paste:before { content: \"\\f0ea\"; }\ni.icon.patreon:before { content: \"\\f3d9\"; }\ni.icon.pause:before { content: \"\\f04c\"; }\ni.icon.pause.circle:before { content: \"\\f28b\"; }\ni.icon.paw:before { content: \"\\f1b0\"; }\ni.icon.paypal:before { content: \"\\f1ed\"; }\ni.icon.pen.square:before { content: \"\\f14b\"; }\ni.icon.pencil.alternate:before { content: \"\\f303\"; }\ni.icon.percent:before { content: \"\\f295\"; }\ni.icon.periscope:before { content: \"\\f3da\"; }\ni.icon.phabricator:before { content: \"\\f3db\"; }\ni.icon.phoenix.framework:before { content: \"\\f3dc\"; }\ni.icon.phone:before { content: \"\\f095\"; }\ni.icon.phone.square:before { content: \"\\f098\"; }\ni.icon.phone.volume:before { content: \"\\f2a0\"; }\ni.icon.php:before { content: \"\\f457\"; }\ni.icon.pied.piper:before { content: \"\\f2ae\"; }\ni.icon.pied.piper.alternate:before { content: \"\\f1a8\"; }\ni.icon.pied.piper.pp:before { content: \"\\f1a7\"; }\ni.icon.pills:before { content: \"\\f484\"; }\ni.icon.pinterest:before { content: \"\\f0d2\"; }\ni.icon.pinterest.p:before { content: \"\\f231\"; }\ni.icon.pinterest.square:before { content: \"\\f0d3\"; }\ni.icon.plane:before { content: \"\\f072\"; }\ni.icon.play:before { content: \"\\f04b\"; }\ni.icon.play.circle:before { content: \"\\f144\"; }\ni.icon.playstation:before { content: \"\\f3df\"; }\ni.icon.plug:before { content: \"\\f1e6\"; }\ni.icon.plus:before { content: \"\\f067\"; }\ni.icon.plus.circle:before { content: \"\\f055\"; }\ni.icon.plus.square:before { content: \"\\f0fe\"; }\ni.icon.podcast:before { content: \"\\f2ce\"; }\ni.icon.pound.sign:before { content: \"\\f154\"; }\ni.icon.power.off:before { content: \"\\f011\"; }\ni.icon.print:before { content: \"\\f02f\"; }\ni.icon.product.hunt:before { content: \"\\f288\"; }\ni.icon.pushed:before { content: \"\\f3e1\"; }\ni.icon.puzzle.piece:before { content: \"\\f12e\"; }\ni.icon.python:before { content: \"\\f3e2\"; }\ni.icon.qq:before { content: \"\\f1d6\"; }\ni.icon.qrcode:before { content: \"\\f029\"; }\ni.icon.question:before { content: \"\\f128\"; }\ni.icon.question.circle:before { content: \"\\f059\"; }\ni.icon.quidditch:before { content: \"\\f458\"; }\ni.icon.quinscape:before { content: \"\\f459\"; }\ni.icon.quora:before { content: \"\\f2c4\"; }\ni.icon.quote.left:before { content: \"\\f10d\"; }\ni.icon.quote.right:before { content: \"\\f10e\"; }\ni.icon.random:before { content: \"\\f074\"; }\ni.icon.ravelry:before { content: \"\\f2d9\"; }\ni.icon.react:before { content: \"\\f41b\"; }\ni.icon.rebel:before { content: \"\\f1d0\"; }\ni.icon.recycle:before { content: \"\\f1b8\"; }\ni.icon.redriver:before { content: \"\\f3e3\"; }\ni.icon.reddit:before { content: \"\\f1a1\"; }\ni.icon.reddit.alien:before { content: \"\\f281\"; }\ni.icon.reddit.square:before { content: \"\\f1a2\"; }\ni.icon.redo:before { content: \"\\f01e\"; }\ni.icon.redo.alternate:before { content: \"\\f2f9\"; }\ni.icon.registered:before { content: \"\\f25d\"; }\ni.icon.rendact:before { content: \"\\f3e4\"; }\ni.icon.renren:before { content: \"\\f18b\"; }\ni.icon.reply:before { content: \"\\f3e5\"; }\ni.icon.reply.all:before { content: \"\\f122\"; }\ni.icon.replyd:before { content: \"\\f3e6\"; }\ni.icon.resolving:before { content: \"\\f3e7\"; }\ni.icon.retweet:before { content: \"\\f079\"; }\ni.icon.road:before { content: \"\\f018\"; }\ni.icon.rocket:before { content: \"\\f135\"; }\ni.icon.rocketchat:before { content: \"\\f3e8\"; }\ni.icon.rockrms:before { content: \"\\f3e9\"; }\ni.icon.rss:before { content: \"\\f09e\"; }\ni.icon.rss.square:before { content: \"\\f143\"; }\ni.icon.ruble.sign:before { content: \"\\f158\"; }\ni.icon.rupee.sign:before { content: \"\\f156\"; }\ni.icon.safari:before { content: \"\\f267\"; }\ni.icon.sass:before { content: \"\\f41e\"; }\ni.icon.save:before { content: \"\\f0c7\"; }\ni.icon.schlix:before { content: \"\\f3ea\"; }\ni.icon.scribd:before { content: \"\\f28a\"; }\ni.icon.search:before { content: \"\\f002\"; }\ni.icon.search.minus:before { content: \"\\f010\"; }\ni.icon.search.plus:before { content: \"\\f00e\"; }\ni.icon.searchengin:before { content: \"\\f3eb\"; }\ni.icon.sellcast:before { content: \"\\f2da\"; }\ni.icon.sellsy:before { content: \"\\f213\"; }\ni.icon.server:before { content: \"\\f233\"; }\ni.icon.servicestack:before { content: \"\\f3ec\"; }\ni.icon.share:before { content: \"\\f064\"; }\ni.icon.share.alternate:before { content: \"\\f1e0\"; }\ni.icon.share.alternate.square:before { content: \"\\f1e1\"; }\ni.icon.share.square:before { content: \"\\f14d\"; }\ni.icon.shekel.sign:before { content: \"\\f20b\"; }\ni.icon.shield.alternate:before { content: \"\\f3ed\"; }\ni.icon.ship:before { content: \"\\f21a\"; }\ni.icon.shipping.fast:before { content: \"\\f48b\"; }\ni.icon.shirtsinbulk:before { content: \"\\f214\"; }\ni.icon.shopping.bag:before { content: \"\\f290\"; }\ni.icon.shopping.basket:before { content: \"\\f291\"; }\ni.icon.shopping.cart:before { content: \"\\f07a\"; }\ni.icon.shower:before { content: \"\\f2cc\"; }\ni.icon.sign.language:before { content: \"\\f2a7\"; }\ni.icon.signal:before { content: \"\\f012\"; }\ni.icon.simplybuilt:before { content: \"\\f215\"; }\ni.icon.sistrix:before { content: \"\\f3ee\"; }\ni.icon.sitemap:before { content: \"\\f0e8\"; }\ni.icon.skyatlas:before { content: \"\\f216\"; }\ni.icon.skype:before { content: \"\\f17e\"; }\ni.icon.slack:before { content: \"\\f198\"; }\ni.icon.slack.hash:before { content: \"\\f3ef\"; }\ni.icon.sliders.horizontal:before { content: \"\\f1de\"; }\ni.icon.slideshare:before { content: \"\\f1e7\"; }\ni.icon.smile:before { content: \"\\f118\"; }\ni.icon.snapchat:before { content: \"\\f2ab\"; }\ni.icon.snapchat.ghost:before { content: \"\\f2ac\"; }\ni.icon.snapchat.square:before { content: \"\\f2ad\"; }\ni.icon.snowflake:before { content: \"\\f2dc\"; }\ni.icon.sort:before { content: \"\\f0dc\"; }\ni.icon.sort.alphabet.down:before { content: \"\\f15d\"; }\ni.icon.sort.alphabet.up:before { content: \"\\f15e\"; }\ni.icon.sort.amount.down:before { content: \"\\f160\"; }\ni.icon.sort.amount.up:before { content: \"\\f161\"; }\ni.icon.sort.down:before { content: \"\\f0dd\"; }\ni.icon.sort.numeric.down:before { content: \"\\f162\"; }\ni.icon.sort.numeric.up:before { content: \"\\f163\"; }\ni.icon.sort.up:before { content: \"\\f0de\"; }\ni.icon.soundcloud:before { content: \"\\f1be\"; }\ni.icon.space.shuttle:before { content: \"\\f197\"; }\ni.icon.speakap:before { content: \"\\f3f3\"; }\ni.icon.spinner:before { content: \"\\f110\"; }\ni.icon.spotify:before { content: \"\\f1bc\"; }\ni.icon.square:before { content: \"\\f0c8\"; }\ni.icon.square.full:before { content: \"\\f45c\"; }\ni.icon.stack.exchange:before { content: \"\\f18d\"; }\ni.icon.stack.overflow:before { content: \"\\f16c\"; }\ni.icon.star:before { content: \"\\f005\"; }\ni.icon.star.half:before { content: \"\\f089\"; }\ni.icon.staylinked:before { content: \"\\f3f5\"; }\ni.icon.steam:before { content: \"\\f1b6\"; }\ni.icon.steam.square:before { content: \"\\f1b7\"; }\ni.icon.steam.symbol:before { content: \"\\f3f6\"; }\ni.icon.step.backward:before { content: \"\\f048\"; }\ni.icon.step.forward:before { content: \"\\f051\"; }\ni.icon.stethoscope:before { content: \"\\f0f1\"; }\ni.icon.sticker.mule:before { content: \"\\f3f7\"; }\ni.icon.sticky.note:before { content: \"\\f249\"; }\ni.icon.stop:before { content: \"\\f04d\"; }\ni.icon.stop.circle:before { content: \"\\f28d\"; }\ni.icon.stopwatch:before { content: \"\\f2f2\"; }\ni.icon.strava:before { content: \"\\f428\"; }\ni.icon.street.view:before { content: \"\\f21d\"; }\ni.icon.strikethrough:before { content: \"\\f0cc\"; }\ni.icon.stripe:before { content: \"\\f429\"; }\ni.icon.stripe.s:before { content: \"\\f42a\"; }\ni.icon.studiovinari:before { content: \"\\f3f8\"; }\ni.icon.stumbleupon:before { content: \"\\f1a4\"; }\ni.icon.stumbleupon.circle:before { content: \"\\f1a3\"; }\ni.icon.subscript:before { content: \"\\f12c\"; }\ni.icon.subway:before { content: \"\\f239\"; }\ni.icon.suitcase:before { content: \"\\f0f2\"; }\ni.icon.sun:before { content: \"\\f185\"; }\ni.icon.superpowers:before { content: \"\\f2dd\"; }\ni.icon.superscript:before { content: \"\\f12b\"; }\ni.icon.supple:before { content: \"\\f3f9\"; }\ni.icon.sync:before { content: \"\\f021\"; }\ni.icon.sync.alternate:before { content: \"\\f2f1\"; }\ni.icon.syringe:before { content: \"\\f48e\"; }\ni.icon.table:before { content: \"\\f0ce\"; }\ni.icon.table.tennis:before { content: \"\\f45d\"; }\ni.icon.tablet:before { content: \"\\f10a\"; }\ni.icon.tablet.alternate:before { content: \"\\f3fa\"; }\ni.icon.tachometer.alternate:before { content: \"\\f3fd\"; }\ni.icon.tag:before { content: \"\\f02b\"; }\ni.icon.tags:before { content: \"\\f02c\"; }\ni.icon.tasks:before { content: \"\\f0ae\"; }\ni.icon.taxi:before { content: \"\\f1ba\"; }\ni.icon.telegram:before { content: \"\\f2c6\"; }\ni.icon.telegram.plane:before { content: \"\\f3fe\"; }\ni.icon.tencent.weibo:before { content: \"\\f1d5\"; }\ni.icon.terminal:before { content: \"\\f120\"; }\ni.icon.text.height:before { content: \"\\f034\"; }\ni.icon.text.width:before { content: \"\\f035\"; }\ni.icon.th:before { content: \"\\f00a\"; }\ni.icon.th.large:before { content: \"\\f009\"; }\ni.icon.th.list:before { content: \"\\f00b\"; }\ni.icon.themeisle:before { content: \"\\f2b2\"; }\ni.icon.thermometer:before { content: \"\\f491\"; }\ni.icon.thermometer.empty:before { content: \"\\f2cb\"; }\ni.icon.thermometer.full:before { content: \"\\f2c7\"; }\ni.icon.thermometer.half:before { content: \"\\f2c9\"; }\ni.icon.thermometer.quarter:before { content: \"\\f2ca\"; }\ni.icon.thermometer.three.quarters:before { content: \"\\f2c8\"; }\ni.icon.thumbs.down:before { content: \"\\f165\"; }\ni.icon.thumbs.up:before { content: \"\\f164\"; }\ni.icon.thumbtack:before { content: \"\\f08d\"; }\ni.icon.ticket.alternate:before { content: \"\\f3ff\"; }\ni.icon.times:before { content: \"\\f00d\"; }\ni.icon.times.circle:before { content: \"\\f057\"; }\ni.icon.tint:before { content: \"\\f043\"; }\ni.icon.toggle.off:before { content: \"\\f204\"; }\ni.icon.toggle.on:before { content: \"\\f205\"; }\ni.icon.trademark:before { content: \"\\f25c\"; }\ni.icon.train:before { content: \"\\f238\"; }\ni.icon.transgender:before { content: \"\\f224\"; }\ni.icon.transgender.alternate:before { content: \"\\f225\"; }\ni.icon.trash:before { content: \"\\f1f8\"; }\ni.icon.trash.alternate:before { content: \"\\f2ed\"; }\ni.icon.tree:before { content: \"\\f1bb\"; }\ni.icon.trello:before { content: \"\\f181\"; }\ni.icon.tripadvisor:before { content: \"\\f262\"; }\ni.icon.trophy:before { content: \"\\f091\"; }\ni.icon.truck:before { content: \"\\f0d1\"; }\ni.icon.tty:before { content: \"\\f1e4\"; }\ni.icon.tumblr:before { content: \"\\f173\"; }\ni.icon.tumblr.square:before { content: \"\\f174\"; }\ni.icon.tv:before { content: \"\\f26c\"; }\ni.icon.twitch:before { content: \"\\f1e8\"; }\ni.icon.twitter:before { content: \"\\f099\"; }\ni.icon.twitter.square:before { content: \"\\f081\"; }\ni.icon.typo3:before { content: \"\\f42b\"; }\ni.icon.uber:before { content: \"\\f402\"; }\ni.icon.uikit:before { content: \"\\f403\"; }\ni.icon.umbrella:before { content: \"\\f0e9\"; }\ni.icon.underline:before { content: \"\\f0cd\"; }\ni.icon.undo:before { content: \"\\f0e2\"; }\ni.icon.undo.alternate:before { content: \"\\f2ea\"; }\ni.icon.uniregistry:before { content: \"\\f404\"; }\ni.icon.universal.access:before { content: \"\\f29a\"; }\ni.icon.university:before { content: \"\\f19c\"; }\ni.icon.unlink:before { content: \"\\f127\"; }\ni.icon.unlock:before { content: \"\\f09c\"; }\ni.icon.unlock.alternate:before { content: \"\\f13e\"; }\ni.icon.untappd:before { content: \"\\f405\"; }\ni.icon.upload:before { content: \"\\f093\"; }\ni.icon.usb:before { content: \"\\f287\"; }\ni.icon.user:before { content: \"\\f007\"; }\ni.icon.user.circle:before { content: \"\\f2bd\"; }\ni.icon.user.md:before { content: \"\\f0f0\"; }\ni.icon.user.plus:before { content: \"\\f234\"; }\ni.icon.user.secret:before { content: \"\\f21b\"; }\ni.icon.user.times:before { content: \"\\f235\"; }\ni.icon.users:before { content: \"\\f0c0\"; }\ni.icon.ussunnah:before { content: \"\\f407\"; }\ni.icon.utensil.spoon:before { content: \"\\f2e5\"; }\ni.icon.utensils:before { content: \"\\f2e7\"; }\ni.icon.vaadin:before { content: \"\\f408\"; }\ni.icon.venus:before { content: \"\\f221\"; }\ni.icon.venus.double:before { content: \"\\f226\"; }\ni.icon.venus.mars:before { content: \"\\f228\"; }\ni.icon.viacoin:before { content: \"\\f237\"; }\ni.icon.viadeo:before { content: \"\\f2a9\"; }\ni.icon.viadeo.square:before { content: \"\\f2aa\"; }\ni.icon.viber:before { content: \"\\f409\"; }\ni.icon.video:before { content: \"\\f03d\"; }\ni.icon.vimeo:before { content: \"\\f40a\"; }\ni.icon.vimeo.square:before { content: \"\\f194\"; }\ni.icon.vimeo.v:before { content: \"\\f27d\"; }\ni.icon.vine:before { content: \"\\f1ca\"; }\ni.icon.vk:before { content: \"\\f189\"; }\ni.icon.vnv:before { content: \"\\f40b\"; }\ni.icon.volleyball.ball:before { content: \"\\f45f\"; }\ni.icon.volume.down:before { content: \"\\f027\"; }\ni.icon.volume.off:before { content: \"\\f026\"; }\ni.icon.volume.up:before { content: \"\\f028\"; }\ni.icon.vuejs:before { content: \"\\f41f\"; }\ni.icon.warehouse:before { content: \"\\f494\"; }\ni.icon.weibo:before { content: \"\\f18a\"; }\ni.icon.weight:before { content: \"\\f496\"; }\ni.icon.weixin:before { content: \"\\f1d7\"; }\ni.icon.whatsapp:before { content: \"\\f232\"; }\ni.icon.whatsapp.square:before { content: \"\\f40c\"; }\ni.icon.wheelchair:before { content: \"\\f193\"; }\ni.icon.whmcs:before { content: \"\\f40d\"; }\ni.icon.wifi:before { content: \"\\f1eb\"; }\ni.icon.wikipedia.w:before { content: \"\\f266\"; }\ni.icon.window.close:before { content: \"\\f410\"; }\ni.icon.window.maximize:before { content: \"\\f2d0\"; }\ni.icon.window.minimize:before { content: \"\\f2d1\"; }\ni.icon.window.restore:before { content: \"\\f2d2\"; }\ni.icon.windows:before { content: \"\\f17a\"; }\ni.icon.won.sign:before { content: \"\\f159\"; }\ni.icon.wordpress:before { content: \"\\f19a\"; }\ni.icon.wordpress.simple:before { content: \"\\f411\"; }\ni.icon.wpbeginner:before { content: \"\\f297\"; }\ni.icon.wpexplorer:before { content: \"\\f2de\"; }\ni.icon.wpforms:before { content: \"\\f298\"; }\ni.icon.wrench:before { content: \"\\f0ad\"; }\ni.icon.xbox:before { content: \"\\f412\"; }\ni.icon.xing:before { content: \"\\f168\"; }\ni.icon.xing.square:before { content: \"\\f169\"; }\ni.icon.y.combinator:before { content: \"\\f23b\"; }\ni.icon.yahoo:before { content: \"\\f19e\"; }\ni.icon.yandex:before { content: \"\\f413\"; }\ni.icon.yandex.international:before { content: \"\\f414\"; }\ni.icon.yelp:before { content: \"\\f1e9\"; }\ni.icon.yen.sign:before { content: \"\\f157\"; }\ni.icon.yoast:before { content: \"\\f2b1\"; }\ni.icon.youtube:before { content: \"\\f167\"; }\ni.icon.youtube.square:before { content: \"\\f431\"; }\n\n/* Aliases */\ni.icon.chess.rock:before { content: \"\\f447\"; }\ni.icon.ordered.list:before { content: \"\\f0cb\"; }\ni.icon.unordered.list:before { content: \"\\f0ca\"; }\ni.icon.user.doctor:before { content: \"\\f0f0\"; }\ni.icon.shield:before { content: \"\\f3ed\"; }\ni.icon.puzzle:before { content: \"\\f12e\"; }\ni.icon.credit.card.amazon.pay:before { content: \"\\f42d\"; }\ni.icon.credit.card.american.express:before { content: \"\\f1f3\"; }\ni.icon.credit.card.diners.club:before { content: \"\\f24c\"; }\ni.icon.credit.card.discover:before { content: \"\\f1f2\"; }\ni.icon.credit.card.jcb:before { content: \"\\f24b\"; }\ni.icon.credit.card.mastercard:before { content: \"\\f1f1\"; }\ni.icon.credit.card.paypal:before { content: \"\\f1f4\"; }\ni.icon.credit.card.stripe:before { content: \"\\f1f5\"; }\ni.icon.credit.card.visa:before { content: \"\\f1f0\"; }\ni.icon.add.circle:before { content: \"\\f055\"; }\ni.icon.add.square:before { content: \"\\f0fe\"; }\ni.icon.add.to.calendar:before { content: \"\\f271\"; }\ni.icon.add.to.cart:before { content: \"\\f217\"; }\ni.icon.add.user:before { content: \"\\f234\"; }\ni.icon.add:before { content: \"\\f067\"; }\ni.icon.alarm.mute:before { content: \"\\f1f6\"; }\ni.icon.alarm:before { content: \"\\f0f3\"; }\ni.icon.ald:before { content: \"\\f2a2\"; }\ni.icon.als:before { content: \"\\f2a2\"; }\ni.icon.american.express.card:before { content: \"\\f1f3\"; }\ni.icon.american.express:before { content: \"\\f1f3\"; }\ni.icon.amex:before { content: \"\\f1f3\"; }\ni.icon.announcement:before { content: \"\\f0a1\"; }\ni.icon.area.chart:before { content: \"\\f1fe\"; }\ni.icon.area.graph:before { content: \"\\f1fe\"; }\ni.icon.arrow.down.cart:before { content: \"\\f218\"; }\ni.icon.asexual:before { content: \"\\f22d\"; }\ni.icon.asl.interpreting:before { content: \"\\f2a3\"; }\ni.icon.asl:before { content: \"\\f2a3\"; }\ni.icon.assistive.listening.devices:before { content: \"\\f2a2\"; }\ni.icon.attach:before { content: \"\\f0c6\"; }\ni.icon.attention:before { content: \"\\f06a\"; }\ni.icon.balance:before { content: \"\\f24e\"; }\ni.icon.bar:before { content: \"\\f0fc\"; }\ni.icon.bathtub:before { content: \"\\f2cd\"; }\ni.icon.battery.four:before { content: \"\\f240\"; }\ni.icon.battery.high:before { content: \"\\f241\"; }\ni.icon.battery.low:before { content: \"\\f243\"; }\ni.icon.battery.medium:before { content: \"\\f242\"; }\ni.icon.battery.one:before { content: \"\\f243\"; }\ni.icon.battery.three:before { content: \"\\f241\"; }\ni.icon.battery.two:before { content: \"\\f242\"; }\ni.icon.battery.zero:before { content: \"\\f244\"; }\ni.icon.birthday:before { content: \"\\f1fd\"; }\ni.icon.block.layout:before { content: \"\\f009\"; }\ni.icon.bluetooth.alternative:before { content: \"\\f294\"; }\ni.icon.broken.chain:before { content: \"\\f127\"; }\ni.icon.browser:before { content: \"\\f022\"; }\ni.icon.call.square:before { content: \"\\f098\"; }\ni.icon.call:before { content: \"\\f095\"; }\ni.icon.cancel:before { content: \"\\f00d\"; }\ni.icon.cart:before { content: \"\\f07a\"; }\ni.icon.cc:before { content: \"\\f20a\"; }\ni.icon.chain:before { content: \"\\f0c1\"; }\ni.icon.chat:before { content: \"\\f075\"; }\ni.icon.checked.calendar:before { content: \"\\f274\"; }\ni.icon.checkmark:before { content: \"\\f00c\"; }\ni.icon.circle.notched:before { content: \"\\f1ce\"; }\ni.icon.close:before { content: \"\\f00d\"; }\ni.icon.cny:before { content: \"\\f157\"; }\ni.icon.cocktail:before { content: \"\\f000\"; }\ni.icon.commenting:before { content: \"\\f27a\"; }\ni.icon.computer:before { content: \"\\f108\"; }\ni.icon.configure:before { content: \"\\f0ad\"; }\ni.icon.content:before { content: \"\\f0c9\"; }\ni.icon.deafness:before { content: \"\\f2a4\"; }\ni.icon.delete.calendar:before { content: \"\\f273\"; }\ni.icon.delete:before { content: \"\\f00d\"; }\ni.icon.detective:before { content: \"\\f21b\"; }\ni.icon.diners.club.card:before { content: \"\\f24c\"; }\ni.icon.diners.club:before { content: \"\\f24c\"; }\ni.icon.discover.card:before { content: \"\\f1f2\"; }\ni.icon.discover:before { content: \"\\f1f2\"; }\ni.icon.discussions:before { content: \"\\f086\"; }\ni.icon.doctor:before { content: \"\\f0f0\"; }\ni.icon.dollar:before { content: \"\\f155\"; }\ni.icon.dont:before { content: \"\\f05e\"; }\ni.icon.dribble:before { content: \"\\f17d\"; }\ni.icon.drivers.license:before { content: \"\\f2c2\"; }\ni.icon.dropdown:before { content: \"\\f0d7\"; }\ni.icon.eercast:before { content: \"\\f2da\"; }\ni.icon.emergency:before { content: \"\\f0f9\"; }\ni.icon.envira.gallery:before { content: \"\\f299\"; }\ni.icon.erase:before { content: \"\\f12d\"; }\ni.icon.eur:before { content: \"\\f153\"; }\ni.icon.euro:before { content: \"\\f153\"; }\ni.icon.eyedropper:before { content: \"\\f1fb\"; }\ni.icon.fa:before { content: \"\\f2b4\"; }\ni.icon.factory:before { content: \"\\f275\"; }\ni.icon.favorite:before { content: \"\\f005\"; }\ni.icon.feed:before { content: \"\\f09e\"; }\ni.icon.female.homosexual:before { content: \"\\f226\"; }\ni.icon.file.text:before { content: \"\\f15c\"; }\ni.icon.find:before { content: \"\\f1e5\"; }\ni.icon.first.aid:before { content: \"\\f0fa\"; }\ni.icon.five.hundred.pixels:before { content: \"\\f26e\"; }\ni.icon.fork:before { content: \"\\f126\"; }\ni.icon.game:before { content: \"\\f11b\"; }\ni.icon.gay:before { content: \"\\f227\"; }\ni.icon.gbp:before { content: \"\\f154\"; }\ni.icon.gittip:before { content: \"\\f184\"; }\ni.icon.google.plus.circle:before { content: \"\\f2b3\"; }\ni.icon.google.plus.official:before { content: \"\\f2b3\"; }\ni.icon.grab:before { content: \"\\f255\"; }\ni.icon.graduation:before { content: \"\\f19d\"; }\ni.icon.grid.layout:before { content: \"\\f00a\"; }\ni.icon.group:before { content: \"\\f0c0\"; }\ni.icon.h:before { content: \"\\f0fd\"; }\ni.icon.hand.victory:before { content: \"\\f25b\"; }\ni.icon.handicap:before { content: \"\\f193\"; }\ni.icon.hard.of.hearing:before { content: \"\\f2a4\"; }\ni.icon.header:before { content: \"\\f1dc\"; }\ni.icon.help.circle:before { content: \"\\f059\"; }\ni.icon.help:before { content: \"\\f128\"; }\ni.icon.heterosexual:before { content: \"\\f228\"; }\ni.icon.hide:before { content: \"\\f070\"; }\ni.icon.hotel:before { content: \"\\f236\"; }\ni.icon.hourglass.four:before { content: \"\\f254\"; }\ni.icon.hourglass.full:before { content: \"\\f254\"; }\ni.icon.hourglass.one:before { content: \"\\f251\"; }\ni.icon.hourglass.three:before { content: \"\\f253\"; }\ni.icon.hourglass.two:before { content: \"\\f252\"; }\ni.icon.idea:before { content: \"\\f0eb\"; }\ni.icon.ils:before { content: \"\\f20b\"; }\ni.icon.in-cart:before { content: \"\\f218\"; }\ni.icon.inr:before { content: \"\\f156\"; }\ni.icon.intergender:before { content: \"\\f224\"; }\ni.icon.intersex:before { content: \"\\f224\"; }\ni.icon.japan.credit.bureau.card:before { content: \"\\f24b\"; }\ni.icon.japan.credit.bureau:before { content: \"\\f24b\"; }\ni.icon.jcb:before { content: \"\\f24b\"; }\ni.icon.jpy:before { content: \"\\f157\"; }\ni.icon.krw:before { content: \"\\f159\"; }\ni.icon.lab:before { content: \"\\f0c3\"; }\ni.icon.law:before { content: \"\\f24e\"; }\ni.icon.legal:before { content: \"\\f0e3\"; }\ni.icon.lesbian:before { content: \"\\f226\"; }\ni.icon.lightning:before { content: \"\\f0e7\"; }\ni.icon.like:before { content: \"\\f004\"; }\ni.icon.line.graph:before { content: \"\\f201\"; }\ni.icon.linkedin.square:before { content: \"\\f08c\"; }\ni.icon.linkify:before { content: \"\\f0c1\"; }\ni.icon.lira:before { content: \"\\f195\"; }\ni.icon.list.layout:before { content: \"\\f00b\"; }\ni.icon.magnify:before { content: \"\\f00e\"; }\ni.icon.mail.forward:before { content: \"\\f064\"; }\ni.icon.mail.square:before { content: \"\\f199\"; }\ni.icon.mail:before { content: \"\\f0e0\"; }\ni.icon.male.homosexual:before { content: \"\\f227\"; }\ni.icon.man:before { content: \"\\f222\"; }\ni.icon.marker:before { content: \"\\f041\"; }\ni.icon.mars.alternate:before { content: \"\\f229\"; }\ni.icon.mars.horizontal:before { content: \"\\f22b\"; }\ni.icon.mars.vertical:before { content: \"\\f22a\"; }\ni.icon.mastercard.card:before { content: \"\\f1f1\"; }\ni.icon.mastercard:before { content: \"\\f1f1\"; }\ni.icon.microsoft.edge:before { content: \"\\f282\"; }\ni.icon.military:before { content: \"\\f0fb\"; }\ni.icon.ms.edge:before { content: \"\\f282\"; }\ni.icon.mute:before { content: \"\\f131\"; }\ni.icon.new.pied.piper:before { content: \"\\f2ae\"; }\ni.icon.non.binary.transgender:before { content: \"\\f223\"; }\ni.icon.numbered.list:before { content: \"\\f0cb\"; }\ni.icon.optinmonster:before { content: \"\\f23c\"; }\ni.icon.options:before { content: \"\\f1de\"; }\ni.icon.other.gender.horizontal:before { content: \"\\f22b\"; }\ni.icon.other.gender.vertical:before { content: \"\\f22a\"; }\ni.icon.other.gender:before { content: \"\\f229\"; }\ni.icon.payment:before { content: \"\\f09d\"; }\ni.icon.paypal.card:before { content: \"\\f1f4\"; }\ni.icon.pencil.square:before { content: \"\\f14b\"; }\ni.icon.photo:before { content: \"\\f030\"; }\ni.icon.picture:before { content: \"\\f03e\"; }\ni.icon.pie.chart:before { content: \"\\f200\"; }\ni.icon.pie.graph:before { content: \"\\f200\"; }\ni.icon.pied.piper.hat:before { content: \"\\f2ae\"; }\ni.icon.pin:before { content: \"\\f08d\"; }\ni.icon.plus.cart:before { content: \"\\f217\"; }\ni.icon.pocket:before { content: \"\\f265\"; }\ni.icon.point:before { content: \"\\f041\"; }\ni.icon.pointing.down:before { content: \"\\f0a7\"; }\ni.icon.pointing.left:before { content: \"\\f0a5\"; }\ni.icon.pointing.right:before { content: \"\\f0a4\"; }\ni.icon.pointing.up:before { content: \"\\f0a6\"; }\ni.icon.pound:before { content: \"\\f154\"; }\ni.icon.power.cord:before { content: \"\\f1e6\"; }\ni.icon.power:before { content: \"\\f011\"; }\ni.icon.privacy:before { content: \"\\f084\"; }\ni.icon.r.circle:before { content: \"\\f25d\"; }\ni.icon.rain:before { content: \"\\f0e9\"; }\ni.icon.record:before { content: \"\\f03d\"; }\ni.icon.refresh:before { content: \"\\f021\"; }\ni.icon.remove.circle:before { content: \"\\f057\"; }\ni.icon.remove.from.calendar:before { content: \"\\f272\"; }\ni.icon.remove.user:before { content: \"\\f235\"; }\ni.icon.remove:before { content: \"\\f00d\"; }\ni.icon.repeat:before { content: \"\\f01e\"; }\ni.icon.rmb:before { content: \"\\f157\"; }\ni.icon.rouble:before { content: \"\\f158\"; }\ni.icon.rub:before { content: \"\\f158\"; }\ni.icon.ruble:before { content: \"\\f158\"; }\ni.icon.rupee:before { content: \"\\f156\"; }\ni.icon.s15:before { content: \"\\f2cd\"; }\ni.icon.selected.radio:before { content: \"\\f192\"; }\ni.icon.send:before { content: \"\\f1d8\"; }\ni.icon.setting:before { content: \"\\f013\"; }\ni.icon.settings:before { content: \"\\f085\"; }\ni.icon.shekel:before { content: \"\\f20b\"; }\ni.icon.sheqel:before { content: \"\\f20b\"; }\ni.icon.shipping:before { content: \"\\f0d1\"; }\ni.icon.shop:before { content: \"\\f07a\"; }\ni.icon.shuffle:before { content: \"\\f074\"; }\ni.icon.shutdown:before { content: \"\\f011\"; }\ni.icon.sidebar:before { content: \"\\f0c9\"; }\ni.icon.signing:before { content: \"\\f2a7\"; }\ni.icon.signup:before { content: \"\\f044\"; }\ni.icon.sliders:before { content: \"\\f1de\"; }\ni.icon.soccer:before { content: \"\\f1e3\"; }\ni.icon.sort.alphabet.ascending:before { content: \"\\f15d\"; }\ni.icon.sort.alphabet.descending:before { content: \"\\f15e\"; }\ni.icon.sort.ascending:before { content: \"\\f0de\"; }\ni.icon.sort.content.ascending:before { content: \"\\f160\"; }\ni.icon.sort.content.descending:before { content: \"\\f161\"; }\ni.icon.sort.descending:before { content: \"\\f0dd\"; }\ni.icon.sort.numeric.ascending:before { content: \"\\f162\"; }\ni.icon.sort.numeric.descending:before { content: \"\\f163\"; }\ni.icon.sound:before { content: \"\\f025\"; }\ni.icon.spy:before { content: \"\\f21b\"; }\ni.icon.stripe.card:before { content: \"\\f1f5\"; }\ni.icon.student:before { content: \"\\f19d\"; }\ni.icon.talk:before { content: \"\\f27a\"; }\ni.icon.target:before { content: \"\\f140\"; }\ni.icon.teletype:before { content: \"\\f1e4\"; }\ni.icon.television:before { content: \"\\f26c\"; }\ni.icon.text.cursor:before { content: \"\\f246\"; }\ni.icon.text.telephone:before { content: \"\\f1e4\"; }\ni.icon.theme.isle:before { content: \"\\f2b2\"; }\ni.icon.theme:before { content: \"\\f043\"; }\ni.icon.thermometer:before { content: \"\\f2c7\"; }\ni.icon.thumb.tack:before { content: \"\\f08d\"; }\ni.icon.time:before { content: \"\\f017\"; }\ni.icon.tm:before { content: \"\\f25c\"; }\ni.icon.toggle.down:before { content: \"\\f150\"; }\ni.icon.toggle.left:before { content: \"\\f191\"; }\ni.icon.toggle.right:before { content: \"\\f152\"; }\ni.icon.toggle.up:before { content: \"\\f151\"; }\ni.icon.translate:before { content: \"\\f1ab\"; }\ni.icon.travel:before { content: \"\\f0b1\"; }\ni.icon.treatment:before { content: \"\\f0f1\"; }\ni.icon.triangle.down:before { content: \"\\f0d7\"; }\ni.icon.triangle.left:before { content: \"\\f0d9\"; }\ni.icon.triangle.right:before { content: \"\\f0da\"; }\ni.icon.triangle.up:before { content: \"\\f0d8\"; }\ni.icon.try:before { content: \"\\f195\"; }\ni.icon.unhide:before { content: \"\\f06e\"; }\ni.icon.unlinkify:before { content: \"\\f127\"; }\ni.icon.unmute:before { content: \"\\f130\"; }\ni.icon.usd:before { content: \"\\f155\"; }\ni.icon.user.cancel:before { content: \"\\f235\"; }\ni.icon.user.close:before { content: \"\\f235\"; }\ni.icon.user.delete:before { content: \"\\f235\"; }\ni.icon.user.x:before { content: \"\\f235\"; }\ni.icon.vcard:before { content: \"\\f2bb\"; }\ni.icon.video.camera:before { content: \"\\f03d\"; }\ni.icon.video.play:before { content: \"\\f144\"; }\ni.icon.visa.card:before { content: \"\\f1f0\"; }\ni.icon.visa:before { content: \"\\f1f0\"; }\ni.icon.volume.control.phone:before { content: \"\\f2a0\"; }\ni.icon.wait:before { content: \"\\f017\"; }\ni.icon.warning.circle:before { content: \"\\f06a\"; }\ni.icon.warning.sign:before { content: \"\\f071\"; }\ni.icon.warning:before { content: \"\\f12a\"; }\ni.icon.wechat:before { content: \"\\f1d7\"; }\ni.icon.wi-fi:before { content: \"\\f1eb\"; }\ni.icon.wikipedia:before { content: \"\\f266\"; }\ni.icon.winner:before { content: \"\\f091\"; }\ni.icon.wizard:before { content: \"\\f0d0\"; }\ni.icon.woman:before { content: \"\\f221\"; }\ni.icon.won:before { content: \"\\f159\"; }\ni.icon.wordpress.beginner:before { content: \"\\f297\"; }\ni.icon.wordpress.forms:before { content: \"\\f298\"; }\ni.icon.world:before { content: \"\\f0ac\"; }\ni.icon.write.square:before { content: \"\\f14b\"; }\ni.icon.x:before { content: \"\\f00d\"; }\ni.icon.yc:before { content: \"\\f23b\"; }\ni.icon.ycombinator:before { content: \"\\f23b\"; }\ni.icon.yen:before { content: \"\\f157\"; }\ni.icon.zip:before { content: \"\\f187\"; }\ni.icon.zoom-in:before { content: \"\\f00e\"; }\ni.icon.zoom-out:before { content: \"\\f010\"; }\ni.icon.zoom:before { content: \"\\f00e\"; }\ni.icon.bitbucket.square:before { content: \"\\f171\"; }\ni.icon.checkmark.box:before { content: \"\\f14a\"; }\ni.icon.circle.thin:before { content: \"\\f111\"; }\ni.icon.cloud.download:before { content: \"\\f381\"; }\ni.icon.cloud.upload:before { content: \"\\f382\"; }\ni.icon.compose:before { content: \"\\f303\"; }\ni.icon.conversation:before { content: \"\\f086\"; }\ni.icon.credit.card.alternative:before { content: \"\\f09d\"; }\ni.icon.currency:before { content: \"\\f3d1\"; }\ni.icon.dashboard:before { content: \"\\f3fd\"; }\ni.icon.diamond:before { content: \"\\f3a5\"; }\ni.icon.disk:before { content: \"\\f0a0\"; }\ni.icon.exchange:before { content: \"\\f362\"; }\ni.icon.external.share:before { content: \"\\f14d\"; }\ni.icon.external.square:before { content: \"\\f360\"; }\ni.icon.external:before { content: \"\\f35d\"; }\ni.icon.facebook.official:before { content: \"\\f082\"; }\ni.icon.food:before { content: \"\\f2e7\"; }\ni.icon.hourglass.zero:before { content: \"\\f253\"; }\ni.icon.level.down:before { content: \"\\f3be\"; }\ni.icon.level.up:before { content: \"\\f3bf\"; }\ni.icon.logout:before { content: \"\\f2f5\"; }\ni.icon.meanpath:before { content: \"\\f0c8\"; }\ni.icon.money:before { content: \"\\f3d1\"; }\ni.icon.move:before { content: \"\\f0b2\"; }\ni.icon.pencil:before { content: \"\\f303\"; }\ni.icon.protect:before { content: \"\\f023\"; }\ni.icon.radio:before { content: \"\\f192\"; }\ni.icon.remove.bookmark:before { content: \"\\f02e\"; }\ni.icon.resize.horizontal:before { content: \"\\f337\"; }\ni.icon.resize.vertical:before { content: \"\\f338\"; }\ni.icon.sign-in:before { content: \"\\f2f6\"; }\ni.icon.sign-out:before { content: \"\\f2f5\"; }\ni.icon.spoon:before { content: \"\\f2e5\"; }\ni.icon.star.half.empty:before { content: \"\\f089\"; }\ni.icon.star.half.full:before { content: \"\\f089\"; }\ni.icon.ticket:before { content: \"\\f3ff\"; }\ni.icon.times.rectangle:before { content: \"\\f410\"; }\ni.icon.write:before { content: \"\\f303\"; }\ni.icon.youtube.play:before { content: \"\\f167\"; }\n\n\n\n/*******************************\n        Outline Icons\n*******************************/\n\n/* Outline Icon */\n.loadOutlineIcons() when (@importOutlineIcons) {\n  /* Load & Define Icon Font */\n  @font-face {\n    font-family: @outlineFontName;\n    src: @outlineFallbackSRC;\n    src: @outlineSrc;\n    font-style: normal;\n    font-weight: @normal;\n    font-variant: normal;\n    text-decoration: inherit;\n    text-transform: none;\n  }\n  i.icon.outline {\n    font-family: @outlineFontName;\n  }\n  /* Icon Definitions */\n  i.icon.address.book.outline:before { content: \"\\f2b9\"; }\n  i.icon.address.card.outline:before { content: \"\\f2bb\"; }\n  i.icon.arrow.alternate.circle.down.outline:before { content: \"\\f358\"; }\n  i.icon.arrow.alternate.circle.left.outline:before { content: \"\\f359\"; }\n  i.icon.arrow.alternate.circle.right.outline:before { content: \"\\f35a\"; }\n  i.icon.arrow.alternate.circle.up.outline:before { content: \"\\f35b\"; }\n  i.icon.bell.outline:before { content: \"\\f0f3\"; }\n  i.icon.bell.slash.outline:before { content: \"\\f1f6\"; }\n  i.icon.bookmark.outline:before { content: \"\\f02e\"; }\n  i.icon.building.outline:before { content: \"\\f1ad\"; }\n  i.icon.calendar.outline:before { content: \"\\f133\"; }\n  i.icon.calendar.alternate.outline:before { content: \"\\f073\"; }\n  i.icon.calendar.check.outline:before { content: \"\\f274\"; }\n  i.icon.calendar.minus.outline:before { content: \"\\f272\"; }\n  i.icon.calendar.plus.outline:before { content: \"\\f271\"; }\n  i.icon.calendar.times.outline:before { content: \"\\f273\"; }\n  i.icon.caret.square.down.outline:before { content: \"\\f150\"; }\n  i.icon.caret.square.left.outline:before { content: \"\\f191\"; }\n  i.icon.caret.square.right.outline:before { content: \"\\f152\"; }\n  i.icon.caret.square.up.outline:before { content: \"\\f151\"; }\n  i.icon.chart.bar.outline:before { content: \"\\f080\"; }\n  i.icon.check.circle.outline:before { content: \"\\f058\"; }\n  i.icon.check.square.outline:before { content: \"\\f14a\"; }\n  i.icon.circle.outline:before { content: \"\\f111\"; }\n  i.icon.clipboard.outline:before { content: \"\\f328\"; }\n  i.icon.clock.outline:before { content: \"\\f017\"; }\n  i.icon.clone.outline:before { content: \"\\f24d\"; }\n  i.icon.closed.captioning.outline:before { content: \"\\f20a\"; }\n  i.icon.comment.outline:before { content: \"\\f075\"; }\n  i.icon.comment.alternate.outline:before { content: \"\\f27a\"; }\n  i.icon.comments.outline:before { content: \"\\f086\"; }\n  i.icon.compass.outline:before { content: \"\\f14e\"; }\n  i.icon.copy.outline:before { content: \"\\f0c5\"; }\n  i.icon.copyright.outline:before { content: \"\\f1f9\"; }\n  i.icon.credit.card.outline:before { content: \"\\f09d\"; }\n  i.icon.dot.circle.outline:before { content: \"\\f192\"; }\n  i.icon.edit.outline:before { content: \"\\f044\"; }\n  i.icon.envelope.outline:before { content: \"\\f0e0\"; }\n  i.icon.envelope.open.outline:before { content: \"\\f2b6\"; }\n  i.icon.eye.slash.outline:before { content: \"\\f070\"; }\n  i.icon.file.outline:before { content: \"\\f15b\"; }\n  i.icon.file.alternate.outline:before { content: \"\\f15c\"; }\n  i.icon.file.archive.outline:before { content: \"\\f1c6\"; }\n  i.icon.file.audio.outline:before { content: \"\\f1c7\"; }\n  i.icon.file.code.outline:before { content: \"\\f1c9\"; }\n  i.icon.file.excel.outline:before { content: \"\\f1c3\"; }\n  i.icon.file.image.outline:before { content: \"\\f1c5\"; }\n  i.icon.file.pdf.outline:before { content: \"\\f1c1\"; }\n  i.icon.file.powerpoint.outline:before { content: \"\\f1c4\"; }\n  i.icon.file.video.outline:before { content: \"\\f1c8\"; }\n  i.icon.file.word.outline:before { content: \"\\f1c2\"; }\n  i.icon.flag.outline:before { content: \"\\f024\"; }\n  i.icon.folder.outline:before { content: \"\\f07b\"; }\n  i.icon.folder.open.outline:before { content: \"\\f07c\"; }\n  i.icon.frown.outline:before { content: \"\\f119\"; }\n  i.icon.futbol.outline:before { content: \"\\f1e3\"; }\n  i.icon.gem.outline:before { content: \"\\f3a5\"; }\n  i.icon.hand.lizard.outline:before { content: \"\\f258\"; }\n  i.icon.hand.paper.outline:before { content: \"\\f256\"; }\n  i.icon.hand.peace.outline:before { content: \"\\f25b\"; }\n  i.icon.hand.point.down.outline:before { content: \"\\f0a7\"; }\n  i.icon.hand.point.left.outline:before { content: \"\\f0a5\"; }\n  i.icon.hand.point.right.outline:before { content: \"\\f0a4\"; }\n  i.icon.hand.point.up.outline:before { content: \"\\f0a6\"; }\n  i.icon.hand.pointer.outline:before { content: \"\\f25a\"; }\n  i.icon.hand.rock.outline:before { content: \"\\f255\"; }\n  i.icon.hand.scissors.outline:before { content: \"\\f257\"; }\n  i.icon.hand.spock.outline:before { content: \"\\f259\"; }\n  i.icon.handshake.outline:before { content: \"\\f2b5\"; }\n  i.icon.hdd.outline:before { content: \"\\f0a0\"; }\n  i.icon.heart.outline:before { content: \"\\f004\"; }\n  i.icon.hospital.outline:before { content: \"\\f0f8\"; }\n  i.icon.hourglass.outline:before { content: \"\\f254\"; }\n  i.icon.id.badge.outline:before { content: \"\\f2c1\"; }\n  i.icon.id.card.outline:before { content: \"\\f2c2\"; }\n  i.icon.image.outline:before { content: \"\\f03e\"; }\n  i.icon.images.outline:before { content: \"\\f302\"; }\n  i.icon.keyboard.outline:before { content: \"\\f11c\"; }\n  i.icon.lemon.outline:before { content: \"\\f094\"; }\n  i.icon.life.ring.outline:before { content: \"\\f1cd\"; }\n  i.icon.lightbulb.outline:before { content: \"\\f0eb\"; }\n  i.icon.list.alternate.outline:before { content: \"\\f022\"; }\n  i.icon.map.outline:before { content: \"\\f279\"; }\n  i.icon.meh.outline:before { content: \"\\f11a\"; }\n  i.icon.minus.square.outline:before { content: \"\\f146\"; }\n  i.icon.money.bill.alternate.outline:before { content: \"\\f3d1\"; }\n  i.icon.moon.outline:before { content: \"\\f186\"; }\n  i.icon.newspaper.outline:before { content: \"\\f1ea\"; }\n  i.icon.object.group.outline:before { content: \"\\f247\"; }\n  i.icon.object.ungroup.outline:before { content: \"\\f248\"; }\n  i.icon.paper.plane.outline:before { content: \"\\f1d8\"; }\n  i.icon.pause.circle.outline:before { content: \"\\f28b\"; }\n  i.icon.play.circle.outline:before { content: \"\\f144\"; }\n  i.icon.plus.square.outline:before { content: \"\\f0fe\"; }\n  i.icon.question.circle.outline:before { content: \"\\f059\"; }\n  i.icon.registered.outline:before { content: \"\\f25d\"; }\n  i.icon.save.outline:before { content: \"\\f0c7\"; }\n  i.icon.share.square.outline:before { content: \"\\f14d\"; }\n  i.icon.smile.outline:before { content: \"\\f118\"; }\n  i.icon.snowflake.outline:before { content: \"\\f2dc\"; }\n  i.icon.square.outline:before { content: \"\\f0c8\"; }\n  i.icon.star.outline:before { content: \"\\f005\"; }\n  i.icon.star.half.outline:before { content: \"\\f089\"; }\n  i.icon.sticky.note.outline:before { content: \"\\f249\"; }\n  i.icon.stop.circle.outline:before { content: \"\\f28d\"; }\n  i.icon.sun.outline:before { content: \"\\f185\"; }\n  i.icon.thumbs.down.outline:before { content: \"\\f165\"; }\n  i.icon.thumbs.up.outline:before { content: \"\\f164\"; }\n  i.icon.times.circle.outline:before { content: \"\\f057\"; }\n  i.icon.trash.alternate.outline:before { content: \"\\f2ed\"; }\n  i.icon.user.outline:before { content: \"\\f007\"; }\n  i.icon.user.circle.outline:before { content: \"\\f2bd\"; }\n  i.icon.window.close.outline:before { content: \"\\f410\"; }\n  i.icon.window.maximize.outline:before { content: \"\\f2d0\"; }\n  i.icon.window.minimize.outline:before { content: \"\\f2d1\"; }\n  i.icon.window.restore.outline:before { content: \"\\f2d2\"; }\n\n  /* Outline Aliases */\n  i.icon.disk.outline:before { content: \"\\f0a0\"; }\n  i.icon.heart.empty,\n  i.icon.star.empty {\n    font-family: @outlineFontName;\n  }\n  i.icon.heart.empty:before { content: \"\\f004\"; }\n  i.icon.star.empty:before { content: \"\\f089\"; }\n\n}\n.loadOutlineIcons();\n\n/*******************************\n           Brand Icons\n*******************************/\n\n.loadBrandIcons() when (@importBrandIcons) {\n  /* Load & Define Brand Font */\n  @font-face {\n    font-family: @brandFontName;\n    src: @brandFallbackSRC;\n    src: @brandSrc;\n    font-style: normal;\n    font-weight: @normal;\n    font-variant: normal;\n    text-decoration: inherit;\n    text-transform: none;\n  }\n  /* Brand Icon Font Family */\n  i.icon.\\35 00px,\n  i.icon.accessible.icon,\n  i.icon.accusoft,\n  i.icon.adn,\n  i.icon.adversal,\n  i.icon.affiliatetheme,\n  i.icon.algolia,\n  i.icon.amazon,\n  i.icon.amazon.pay,\n  i.icon.amilia,\n  i.icon.android,\n  i.icon.angellist,\n  i.icon.angrycreative,\n  i.icon.angular,\n  i.icon.app.store,\n  i.icon.app.store.ios,\n  i.icon.apper,\n  i.icon.apple,\n  i.icon.apple.pay,\n  i.icon.asymmetrik,\n  i.icon.audible,\n  i.icon.autoprefixer,\n  i.icon.avianex,\n  i.icon.aviato,\n  i.icon.aws,\n  i.icon.bandcamp,\n  i.icon.behance,\n  i.icon.behance.square,\n  i.icon.bimobject,\n  i.icon.bitbucket,\n  i.icon.bitcoin,\n  i.icon.bity,\n  i.icon.black.tie,\n  i.icon.blackberry,\n  i.icon.blogger,\n  i.icon.blogger.b,\n  i.icon.bluetooth,\n  i.icon.bluetooth.b,\n  i.icon.btc,\n  i.icon.buromobelexperte,\n  i.icon.buysellads,\n  i.icon.cc.amazon.pay,\n  i.icon.cc.amex,\n  i.icon.cc.apple.pay,\n  i.icon.cc.diners.club,\n  i.icon.cc.discover,\n  i.icon.cc.jcb,\n  i.icon.cc.mastercard,\n  i.icon.cc.paypal,\n  i.icon.cc.stripe,\n  i.icon.cc.visa,\n  i.icon.centercode,\n  i.icon.chrome,\n  i.icon.cloudscale,\n  i.icon.cloudsmith,\n  i.icon.cloudversify,\n  i.icon.codepen,\n  i.icon.codiepie,\n  i.icon.connectdevelop,\n  i.icon.contao,\n  i.icon.cpanel,\n  i.icon.creative.commons,\n  i.icon.css3,\n  i.icon.css3.alternate,\n  i.icon.cuttlefish,\n  i.icon.d.and.d,\n  i.icon.dashcube,\n  i.icon.delicious,\n  i.icon.deploydog,\n  i.icon.deskpro,\n  i.icon.deviantart,\n  i.icon.digg,\n  i.icon.digital.ocean,\n  i.icon.discord,\n  i.icon.discourse,\n  i.icon.dochub,\n  i.icon.docker,\n  i.icon.draft2digital,\n  i.icon.dribbble,\n  i.icon.dribbble.square,\n  i.icon.dropbox,\n  i.icon.drupal,\n  i.icon.dyalog,\n  i.icon.earlybirds,\n  i.icon.edge,\n  i.icon.elementor,\n  i.icon.ember,\n  i.icon.empire,\n  i.icon.envira,\n  i.icon.erlang,\n  i.icon.ethereum,\n  i.icon.etsy,\n  i.icon.expeditedssl,\n  i.icon.facebook,\n  i.icon.facebook.f,\n  i.icon.facebook.messenger,\n  i.icon.facebook.square,\n  i.icon.firefox,\n  i.icon.first.order,\n  i.icon.firstdraft,\n  i.icon.flickr,\n  i.icon.flipboard,\n  i.icon.fly,\n  i.icon.font.awesome,\n  i.icon.font.awesome.alternate,\n  i.icon.font.awesome.flag,\n  i.icon.fonticons,\n  i.icon.fonticons.fi,\n  i.icon.fort.awesome,\n  i.icon.fort.awesome.alternate,\n  i.icon.forumbee,\n  i.icon.foursquare,\n  i.icon.free.code.camp,\n  i.icon.freebsd,\n  i.icon.get.pocket,\n  i.icon.gg,\n  i.icon.gg.circle,\n  i.icon.git,\n  i.icon.git.square,\n  i.icon.github,\n  i.icon.github.alternate,\n  i.icon.github.square,\n  i.icon.gitkraken,\n  i.icon.gitlab,\n  i.icon.gitter,\n  i.icon.glide,\n  i.icon.glide.g,\n  i.icon.gofore,\n  i.icon.goodreads,\n  i.icon.goodreads.g,\n  i.icon.google,\n  i.icon.google.drive,\n  i.icon.google.play,\n  i.icon.google.plus,\n  i.icon.google.plus.g,\n  i.icon.google.plus.square,\n  i.icon.google.wallet,\n  i.icon.gratipay,\n  i.icon.grav,\n  i.icon.gripfire,\n  i.icon.grunt,\n  i.icon.gulp,\n  i.icon.hacker.news,\n  i.icon.hacker.news.square,\n  i.icon.hips,\n  i.icon.hire.a.helper,\n  i.icon.hooli,\n  i.icon.hotjar,\n  i.icon.houzz,\n  i.icon.html5,\n  i.icon.hubspot,\n  i.icon.imdb,\n  i.icon.instagram,\n  i.icon.internet.explorer,\n  i.icon.ioxhost,\n  i.icon.itunes,\n  i.icon.itunes.note,\n  i.icon.jenkins,\n  i.icon.joget,\n  i.icon.joomla,\n  i.icon.js,\n  i.icon.js.square,\n  i.icon.jsfiddle,\n  i.icon.keycdn,\n  i.icon.kickstarter,\n  i.icon.kickstarter.k,\n  i.icon.korvue,\n  i.icon.laravel,\n  i.icon.lastfm,\n  i.icon.lastfm.square,\n  i.icon.leanpub,\n  i.icon.less,\n  i.icon.linechat,\n  i.icon.linkedin,\n  i.icon.linkedin.alternate,\n  i.icon.linkedin.in,\n  i.icon.linode,\n  i.icon.linux,\n  i.icon.lyft,\n  i.icon.magento,\n  i.icon.maxcdn,\n  i.icon.medapps,\n  i.icon.medium,\n  i.icon.medium.m,\n  i.icon.medrt,\n  i.icon.meetup,\n  i.icon.microsoft,\n  i.icon.mix,\n  i.icon.mixcloud,\n  i.icon.mizuni,\n  i.icon.modx,\n  i.icon.monero,\n  i.icon.napster,\n  i.icon.nintendo.switch,\n  i.icon.node,\n  i.icon.node.js,\n  i.icon.npm,\n  i.icon.ns8,\n  i.icon.nutritionix,\n  i.icon.odnoklassniki,\n  i.icon.odnoklassniki.square,\n  i.icon.opencart,\n  i.icon.openid,\n  i.icon.opera,\n  i.icon.optin.monster,\n  i.icon.osi,\n  i.icon.page4,\n  i.icon.pagelines,\n  i.icon.palfed,\n  i.icon.patreon,\n  i.icon.paypal,\n  i.icon.periscope,\n  i.icon.phabricator,\n  i.icon.phoenix.framework,\n  i.icon.php,\n  i.icon.pied.piper,\n  i.icon.pied.piper.alternate,\n  i.icon.pied.piper.pp,\n  i.icon.pinterest,\n  i.icon.pinterest.p,\n  i.icon.pinterest.square,\n  i.icon.playstation,\n  i.icon.product.hunt,\n  i.icon.pushed,\n  i.icon.python,\n  i.icon.qq,\n  i.icon.quinscape,\n  i.icon.quora,\n  i.icon.ravelry,\n  i.icon.react,\n  i.icon.rebel,\n  i.icon.redriver,\n  i.icon.reddit,\n  i.icon.reddit.alien,\n  i.icon.reddit.square,\n  i.icon.rendact,\n  i.icon.renren,\n  i.icon.replyd,\n  i.icon.resolving,\n  i.icon.rocketchat,\n  i.icon.rockrms,\n  i.icon.safari,\n  i.icon.sass,\n  i.icon.schlix,\n  i.icon.scribd,\n  i.icon.searchengin,\n  i.icon.sellcast,\n  i.icon.sellsy,\n  i.icon.servicestack,\n  i.icon.shirtsinbulk,\n  i.icon.simplybuilt,\n  i.icon.sistrix,\n  i.icon.skyatlas,\n  i.icon.skype,\n  i.icon.slack,\n  i.icon.slack.hash,\n  i.icon.slideshare,\n  i.icon.snapchat,\n  i.icon.snapchat.ghost,\n  i.icon.snapchat.square,\n  i.icon.soundcloud,\n  i.icon.speakap,\n  i.icon.spotify,\n  i.icon.stack.exchange,\n  i.icon.stack.overflow,\n  i.icon.staylinked,\n  i.icon.steam,\n  i.icon.steam.square,\n  i.icon.steam.symbol,\n  i.icon.sticker.mule,\n  i.icon.strava,\n  i.icon.stripe,\n  i.icon.stripe.s,\n  i.icon.studiovinari,\n  i.icon.stumbleupon,\n  i.icon.stumbleupon.circle,\n  i.icon.superpowers,\n  i.icon.supple,\n  i.icon.telegram,\n  i.icon.telegram.plane,\n  i.icon.tencent.weibo,\n  i.icon.themeisle,\n  i.icon.trello,\n  i.icon.tripadvisor,\n  i.icon.tumblr,\n  i.icon.tumblr.square,\n  i.icon.twitch,\n  i.icon.twitter,\n  i.icon.twitter.square,\n  i.icon.typo3,\n  i.icon.uber,\n  i.icon.uikit,\n  i.icon.uniregistry,\n  i.icon.untappd,\n  i.icon.usb,\n  i.icon.ussunnah,\n  i.icon.vaadin,\n  i.icon.viacoin,\n  i.icon.viadeo,\n  i.icon.viadeo.square,\n  i.icon.viber,\n  i.icon.vimeo,\n  i.icon.vimeo.square,\n  i.icon.vimeo.v,\n  i.icon.vine,\n  i.icon.vk,\n  i.icon.vnv,\n  i.icon.vuejs,\n  i.icon.wechat,\n  i.icon.weibo,\n  i.icon.weixin,\n  i.icon.whatsapp,\n  i.icon.whatsapp.square,\n  i.icon.whmcs,\n  i.icon.wikipedia.w,\n  i.icon.windows,\n  i.icon.wordpress,\n  i.icon.wordpress.simple,\n  i.icon.wpbeginner,\n  i.icon.wpexplorer,\n  i.icon.wpforms,\n  i.icon.xbox,\n  i.icon.xing,\n  i.icon.xing.square,\n  i.icon.y.combinator,\n  i.icon.yahoo,\n  i.icon.yandex,\n  i.icon.yandex.international,\n  i.icon.yelp,\n  i.icon.yoast,\n  i.icon.youtube,\n  i.icon.youtube.square {\n    font-family: 'brand-icons';\n  }\n  /* Brand Icons Ideally Would Be Defined Here */\n\n}\n.loadBrandIcons();\n","/*!\n * # Semantic UI - Image\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'image';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n             Image\n*******************************/\n\n.ui.image {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 100%;\n  background-color: @placeholderColor;\n}\n\nimg.ui.image {\n  display: block;\n}\n\n.ui.image svg,\n.ui.image img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n.ui.hidden.images,\n.ui.hidden.image {\n  display: none;\n}\n.ui.hidden.transition.images,\n.ui.hidden.transition.image {\n  display: block;\n  visibility: hidden;\n}\n.ui.images > .hidden.transition {\n  display: inline-block;\n  visibility: hidden;\n}\n\n\n.ui.disabled.images,\n.ui.disabled.image {\n  cursor: default;\n  opacity: @disabledOpacity;\n}\n\n\n/*******************************\n          Variations\n*******************************/\n\n\n/*--------------\n     Inline\n---------------*/\n\n.ui.inline.image,\n.ui.inline.image svg,\n.ui.inline.image img {\n  display: inline-block;\n}\n\n/*------------------\n  Vertical Aligned\n-------------------*/\n\n.ui.top.aligned.images .image,\n.ui.top.aligned.image,\n.ui.top.aligned.image svg,\n.ui.top.aligned.image img {\n  display: inline-block;\n  vertical-align: top;\n}\n.ui.middle.aligned.images .image,\n.ui.middle.aligned.image,\n.ui.middle.aligned.image svg,\n.ui.middle.aligned.image img {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ui.bottom.aligned.images .image,\n.ui.bottom.aligned.image,\n.ui.bottom.aligned.image svg,\n.ui.bottom.aligned.image img {\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n/*--------------\n     Rounded\n---------------*/\n\n.ui.rounded.images .image,\n.ui.rounded.image,\n.ui.rounded.images .image > *,\n.ui.rounded.image > * {\n  border-radius: @roundedBorderRadius;\n}\n\n/*--------------\n    Bordered\n---------------*/\n\n.ui.bordered.images .image,\n.ui.bordered.images img,\n.ui.bordered.images svg,\n.ui.bordered.image img,\n.ui.bordered.image svg,\nimg.ui.bordered.image {\n  border: @imageBorder;\n}\n\n/*--------------\n    Circular\n---------------*/\n\n.ui.circular.images,\n.ui.circular.image {\n  overflow: hidden;\n}\n\n.ui.circular.images .image,\n.ui.circular.image,\n.ui.circular.images .image > *,\n.ui.circular.image > * {\n  -webkit-border-radius: @circularRadius;\n  -moz-border-radius: @circularRadius;\n  border-radius: @circularRadius;\n}\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.images,\n.ui.fluid.image,\n.ui.fluid.images img,\n.ui.fluid.images svg,\n.ui.fluid.image svg,\n.ui.fluid.image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n\n/*--------------\n     Avatar\n---------------*/\n\n.ui.avatar.images .image,\n.ui.avatar.images img,\n.ui.avatar.images svg,\n.ui.avatar.image img,\n.ui.avatar.image svg,\n.ui.avatar.image {\n  margin-right: @avatarMargin;\n\n  display: inline-block;\n  width: @avatarSize;\n  height: @avatarSize;\n\n  -webkit-border-radius: @circularRadius;\n  -moz-border-radius: @circularRadius;\n  border-radius: @circularRadius;\n}\n\n/*-------------------\n       Spaced\n--------------------*/\n\n.ui.spaced.image {\n  display: inline-block !important;\n  margin-left: @spacedDistance;\n  margin-right: @spacedDistance;\n}\n\n.ui[class*=\"left spaced\"].image {\n  margin-left: @spacedDistance;\n  margin-right: 0em;\n}\n\n.ui[class*=\"right spaced\"].image {\n  margin-left: 0em;\n  margin-right: @spacedDistance;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.image,\n.ui.floated.images {\n  float: left;\n  margin-right: @floatedHorizontalMargin;\n  margin-bottom: @floatedVerticalMargin;\n}\n.ui.right.floated.images,\n.ui.right.floated.image {\n  float: right;\n  margin-right: 0em;\n  margin-bottom: @floatedVerticalMargin;\n  margin-left: @floatedHorizontalMargin;\n}\n\n.ui.floated.images:last-child,\n.ui.floated.image:last-child {\n  margin-bottom: 0em;\n}\n\n\n.ui.centered.images,\n.ui.centered.image {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.images .image,\n.ui.mini.images img,\n.ui.mini.images svg,\n.ui.mini.image {\n  width: @miniWidth;\n  height: auto;\n  font-size: @mini;\n}\n.ui.tiny.images .image,\n.ui.tiny.images img,\n.ui.tiny.images svg,\n.ui.tiny.image {\n  width: @tinyWidth;\n  height: auto;\n  font-size: @tiny;\n}\n.ui.small.images .image,\n.ui.small.images img,\n.ui.small.images svg,\n.ui.small.image {\n  width: @smallWidth;\n  height: auto;\n  font-size: @small;\n}\n.ui.medium.images .image,\n.ui.medium.images img,\n.ui.medium.images svg,\n.ui.medium.image {\n  width: @mediumWidth;\n  height: auto;\n  font-size: @medium;\n}\n.ui.large.images .image,\n.ui.large.images img,\n.ui.large.images svg,\n.ui.large.image {\n  width: @largeWidth;\n  height: auto;\n  font-size: @large;\n}\n.ui.big.images .image,\n.ui.big.images img,\n.ui.big.images svg,\n.ui.big.image {\n  width: @bigWidth;\n  height: auto;\n  font-size: @big;\n}\n.ui.huge.images .image,\n.ui.huge.images img,\n.ui.huge.images svg,\n.ui.huge.image {\n  width: @hugeWidth;\n  height: auto;\n  font-size: @huge;\n}\n.ui.massive.images .image,\n.ui.massive.images img,\n.ui.massive.images svg,\n.ui.massive.image {\n  width: @massiveWidth;\n  height: auto;\n  font-size: @massive;\n}\n\n\n/*******************************\n              Groups\n*******************************/\n\n.ui.images {\n  font-size: 0em;\n  margin: 0em -@imageHorizontalMargin 0rem;\n}\n\n.ui.images .image,\n.ui.images > img,\n.ui.images > svg {\n  display: inline-block;\n  margin: 0em @imageHorizontalMargin @imageVerticalMargin;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Input\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'input';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n           Standard\n*******************************/\n\n\n/*--------------------\n        Inputs\n---------------------*/\n\n.ui.input {\n  position: relative;\n  font-weight: @normal;\n  font-style: normal;\n  display: inline-flex;\n  color: @inputColor;\n}\n.ui.input > input {\n  margin: 0em;\n  max-width: 100%;\n  flex: 1 0 auto;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: @textAlign;\n  line-height: @lineHeight;\n\n  font-family: @inputFont;\n  padding: @padding;\n\n  background: @background;\n  border: @border;\n  color: @inputColor;\n  border-radius: @borderRadius;\n  transition: @transition;\n\n  box-shadow: @boxShadow;\n}\n\n\n/*--------------------\n      Placeholder\n---------------------*/\n\n/* browsers require these rules separate */\n\n.ui.input > input::-webkit-input-placeholder {\n  color: @placeholderColor;\n}\n.ui.input > input::-moz-placeholder {\n  color: @placeholderColor;\n}\n.ui.input > input:-ms-input-placeholder {\n  color: @placeholderColor;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n        Disabled\n---------------------*/\n\n.ui.disabled.input,\n.ui.input:not(.disabled) input[disabled] {\n  opacity: @disabledOpacity;\n}\n\n.ui.disabled.input > input,\n.ui.input:not(.disabled) input[disabled] {\n  pointer-events: none;\n}\n\n/*--------------------\n        Active\n---------------------*/\n\n.ui.input > input:active,\n.ui.input.down input {\n  border-color: @downBorderColor;\n  background: @downBackground;\n  color: @downColor;\n  box-shadow: @downBoxShadow;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.loading.input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @loaderFillColor;\n}\n.ui.loading.loading.input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: button-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor transparent transparent;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n\n/*--------------------\n        Focus\n---------------------*/\n\n.ui.input.focus > input,\n.ui.input > input:focus  {\n  border-color: @focusBorderColor;\n  background: @focusBackground;\n  color: @focusColor;\n  box-shadow: @focusBoxShadow;\n}\n.ui.input.focus > input::-webkit-input-placeholder,\n.ui.input > input:focus::-webkit-input-placeholder {\n  color: @placeholderFocusColor;\n}\n.ui.input.focus > input::-moz-placeholder,\n.ui.input > input:focus::-moz-placeholder {\n  color: @placeholderFocusColor;\n}\n.ui.input.focus > input:-ms-input-placeholder,\n.ui.input > input:focus:-ms-input-placeholder {\n  color: @placeholderFocusColor;\n}\n\n\n\n/*--------------------\n        Error\n---------------------*/\n\n.ui.input.error > input {\n  background-color: @errorBackground;\n  border-color: @errorBorder;\n  color: @errorColor;\n  box-shadow: @errorBoxShadow;\n}\n\n/* Error Placeholder */\n.ui.input.error > input::-webkit-input-placeholder {\n  color: @placeholderErrorColor;\n}\n.ui.input.error > input::-moz-placeholder {\n  color: @placeholderErrorColor;\n}\n.ui.input.error > input:-ms-input-placeholder {\n  color: @placeholderErrorColor !important;\n}\n\n/* Focused Error Placeholder */\n.ui.input.error > input:focus::-webkit-input-placeholder {\n  color: @placeholderErrorFocusColor;\n}\n.ui.input.error > input:focus::-moz-placeholder {\n  color: @placeholderErrorFocusColor;\n}\n.ui.input.error > input:focus:-ms-input-placeholder {\n  color: @placeholderErrorFocusColor !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------------\n      Transparent\n---------------------*/\n\n\n.ui.transparent.input > input {\n  border-color: transparent !important;\n  background-color: transparent !important;\n  padding: 0em !important;\n  box-shadow: none !important;\n  border-radius: 0px !important;\n}\n\n/* Transparent Icon */\n.ui.transparent.icon.input > i.icon {\n  width: @transparentIconWidth;\n}\n.ui.transparent.icon.input > input {\n  padding-left: 0em !important;\n  padding-right: @transparentIconMargin !important;\n}\n.ui.transparent[class*=\"left icon\"].input > input {\n  padding-left: @transparentIconMargin !important;\n  padding-right: 0em !important;\n}\n\n/* Transparent Inverted */\n.ui.transparent.inverted.input {\n  color: @transparentInvertedColor;\n}\n.ui.transparent.inverted.input > input {\n  color: inherit;\n}\n\n.ui.transparent.inverted.input > input::-webkit-input-placeholder {\n  color: @transparentInvertedPlaceholderColor;\n}\n.ui.transparent.inverted.input > input::-moz-placeholder {\n  color: @transparentInvertedPlaceholderColor;\n}\n.ui.transparent.inverted.input > input:-ms-input-placeholder {\n  color: @transparentInvertedPlaceholderColor;\n}\n\n\n/*--------------------\n         Icon\n---------------------*/\n\n.ui.icon.input > i.icon {\n  cursor: default;\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  top: 0px;\n  right: 0px;\n  margin: 0em;\n  height: 100%;\n\n  width: @iconWidth;\n  opacity: @iconOpacity;\n  border-radius: 0em @borderRadius @borderRadius 0em;\n  transition: @iconTransition;\n}\n.ui.icon.input > i.icon:not(.link) {\n  pointer-events: none;\n}\n.ui.icon.input > input {\n  padding-right: @iconMargin !important;\n}\n\n.ui.icon.input > i.icon:before,\n.ui.icon.input > i.icon:after {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 100%;\n  margin-top: @iconOffset;\n}\n.ui.icon.input > i.link.icon {\n  cursor: pointer;\n}\n.ui.icon.input > i.circular.icon {\n  top: @circularIconVerticalOffset;\n  right: @circularIconHorizontalOffset;\n}\n\n/* Left Icon Input */\n.ui[class*=\"left icon\"].input > i.icon {\n  right: auto;\n  left: @borderWidth;\n  border-radius: @borderRadius 0em 0em @borderRadius;\n}\n.ui[class*=\"left icon\"].input > i.circular.icon {\n  right: auto;\n  left: @circularIconHorizontalOffset;\n}\n.ui[class*=\"left icon\"].input > input {\n  padding-left: @iconMargin !important;\n  padding-right: @horizontalPadding !important;\n}\n\n/* Focus */\n.ui.icon.input > input:focus ~ i.icon {\n  opacity: 1;\n}\n\n/*--------------------\n        Labeled\n---------------------*/\n\n/* Adjacent Label */\n.ui.labeled.input > .label {\n  flex: 0 0 auto;\n  margin: 0;\n  font-size: @relativeMedium;\n}\n.ui.labeled.input > .label:not(.corner) {\n  padding-top: @verticalPadding;\n  padding-bottom: @verticalPadding;\n}\n\n/* Regular Label on Left */\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-left-color: transparent;\n}\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input:focus {\n  border-left-color: @focusBorderColor;\n}\n\n/* Regular Label on Right */\n.ui[class*=\"right labeled\"].input > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n.ui[class*=\"right labeled\"].input > input + .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.ui[class*=\"right labeled\"].input > input:focus {\n  border-right-color: @focusBorderColor !important;\n}\n\n/* Corner Label */\n.ui.labeled.input .corner.label {\n  top: @labelCornerTop;\n  right: @labelCornerRight;\n  font-size: @labelCornerSize;\n  border-radius: 0em @borderRadius 0em 0em;\n}\n\n/* Spacing with corner label */\n.ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input > input {\n  padding-right: @labeledMargin !important;\n}\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > input {\n  padding-right: @labeledIconInputMargin !important;\n}\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > .icon {\n  margin-right: @labeledIconMargin;\n}\n\n/* Left Labeled */\n.ui[class*=\"left corner labeled\"].labeled.input > input {\n  padding-left: @labeledMargin !important;\n}\n.ui[class*=\"left corner labeled\"].icon.input > input {\n  padding-left: @labeledIconInputMargin !important;\n}\n.ui[class*=\"left corner labeled\"].icon.input > .icon {\n  margin-left: @labeledIconMargin;\n}\n\n/* Corner Label Position  */\n.ui.input > .ui.corner.label {\n  top: @borderWidth;\n  right: @borderWidth;\n}\n.ui.input > .ui.left.corner.label {\n  right: auto;\n  left: @borderWidth;\n}\n\n\n/*--------------------\n        Action\n---------------------*/\n\n.ui.action.input > .button,\n.ui.action.input > .buttons {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n.ui.action.input > .button,\n.ui.action.input > .buttons > .button {\n  padding-top: @verticalPadding;\n  padding-bottom: @verticalPadding;\n  margin: 0;\n}\n\n/* Button on Right */\n.ui.action.input:not([class*=\"left action\"]) > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:not(:first-child),\n.ui.action.input:not([class*=\"left action\"]) > .button:not(:first-child),\n.ui.action.input:not([class*=\"left action\"]) > .buttons:not(:first-child) > .button {\n  border-radius: 0px;\n}\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:last-child,\n.ui.action.input:not([class*=\"left action\"]) > .button:last-child,\n.ui.action.input:not([class*=\"left action\"]) > .buttons:last-child > .button {\n  border-radius: 0px @borderRadius @borderRadius 0px;\n}\n\n/* Input Focus */\n.ui.action.input:not([class*=\"left action\"]) > input:focus {\n  border-right-color: @focusBorderColor !important;\n}\n\n/* Button on Left */\n.ui[class*=\"left action\"].input > input {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  border-left-color: transparent !important;\n}\n.ui[class*=\"left action\"].input > .dropdown,\n.ui[class*=\"left action\"].input > .button,\n.ui[class*=\"left action\"].input > .buttons > .button {\n  border-radius: 0px;\n}\n.ui[class*=\"left action\"].input > .dropdown:first-child,\n.ui[class*=\"left action\"].input > .button:first-child,\n.ui[class*=\"left action\"].input > .buttons:first-child > .button {\n  border-radius: @borderRadius 0px 0px @borderRadius;\n}\n/* Input Focus */\n.ui[class*=\"left action\"].input > input:focus {\n  border-left-color: @focusBorderColor !important;\n}\n\n/*--------------------\n       Inverted\n---------------------*/\n\n/* Standard */\n.ui.inverted.input > input {\n  border: none;\n}\n\n/*--------------------\n        Fluid\n---------------------*/\n\n.ui.fluid.input {\n  display: flex;\n}\n.ui.fluid.input > input {\n  width: 0px !important;\n}\n\n/*--------------------\n        Size\n---------------------*/\n\n.ui.mini.input {\n  font-size: @relativeMini;\n}\n.ui.small.input {\n  font-size: @relativeSmall;\n}\n.ui.input {\n  font-size: @relativeMedium;\n}\n.ui.large.input {\n  font-size: @relativeLarge;\n}\n.ui.big.input {\n  font-size: @relativeBig;\n}\n.ui.huge.input {\n  font-size: @relativeHuge;\n}\n.ui.massive.input {\n  font-size: @relativeMassive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Label\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'label';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Label\n*******************************/\n\n.ui.label {\n  display: inline-block;\n  line-height: 1;\n  vertical-align: @verticalAlign;\n\n  margin: @verticalMargin @horizontalMargin;\n\n  background-color: @backgroundColor;\n  background-image: @backgroundImage;\n  padding: @verticalPadding @horizontalPadding;\n  color: @color;\n\n  text-transform: @textTransform;\n  font-weight: @fontWeight;\n\n  border: @border;\n  border-radius: @borderRadius;\n  transition: @transition;\n}\n\n.ui.label:first-child {\n  margin-left: 0em;\n}\n.ui.label:last-child {\n  margin-right: 0em;\n}\n\n/* Link */\na.ui.label {\n  cursor: pointer;\n}\n\n/* Inside Link */\n.ui.label > a {\n  cursor: pointer;\n  color: inherit;\n  opacity: @linkOpacity;\n  transition: @linkTransition;\n}\n.ui.label > a:hover {\n  opacity: 1;\n}\n\n/* Image */\n.ui.label > img {\n  width: auto !important;\n  vertical-align: middle;\n  height: @imageHeight !important;\n}\n\n/* Icon */\n.ui.label > .icon {\n  width: auto;\n  margin: 0em @iconDistance 0em 0em;\n}\n\n/* Detail */\n.ui.label > .detail {\n  display: inline-block;\n  vertical-align: top;\n  font-weight: @detailFontWeight;\n  margin-left: @detailMargin;\n  opacity: @detailOpacity;\n}\n.ui.label > .detail .icon {\n  margin: 0em @detailIconDistance 0em 0em;\n}\n\n\n/* Removable label */\n.ui.label > .close.icon,\n.ui.label > .delete.icon {\n  cursor: pointer;\n  margin-right: 0em;\n  margin-left: @deleteMargin;\n  font-size: @deleteSize;\n  opacity: @deleteOpacity;\n  transition: @deleteTransition;\n}\n.ui.label > .delete.icon:hover {\n  opacity: 1;\n}\n\n/*-------------------\n       Group\n--------------------*/\n\n.ui.labels > .label {\n  margin: 0em @groupHorizontalMargin @groupVerticalMargin 0em;\n}\n\n\n/*-------------------\n       Coupling\n--------------------*/\n\n.ui.header > .ui.label {\n  margin-top: @lineHeightOffset;\n}\n\n\n/* Remove border radius on attached segment */\n.ui.attached.segment > .ui.top.left.attached.label,\n.ui.bottom.attached.segment > .ui.top.left.attached.label  {\n  border-top-left-radius: 0;\n}\n.ui.attached.segment > .ui.top.right.attached.label,\n.ui.bottom.attached.segment > .ui.top.right.attached.label  {\n  border-top-right-radius: 0;\n}\n.ui.top.attached.segment > .ui.bottom.left.attached.label  {\n  border-bottom-left-radius: 0;\n}\n.ui.top.attached.segment > .ui.bottom.right.attached.label  {\n  border-bottom-right-radius: 0;\n}\n\n/* Padding on next content after a label */\n.ui.top.attached.label:first-child + :not(.attached),\n.ui.top.attached.label + [class*=\"right floated\"] + * {\n  margin-top: @attachedSegmentPadding !important;\n}\n.ui.bottom.attached.label:first-child ~ :last-child:not(.attached) {\n  margin-top: 0em;\n  margin-bottom: @attachedSegmentPadding !important;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n.ui.image.label {\n  width: auto !important;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  max-width: 9999px;\n  vertical-align: baseline;\n  text-transform: none;\n\n  background: @imageLabelBackground;\n  padding: @imageLabelPadding;\n  border-radius: @imageLabelBorderRadius;\n  box-shadow: @imageLabelBoxShadow;\n}\n\n.ui.image.label img {\n  display: inline-block;\n  vertical-align: top;\n\n  height: @imageLabelImageHeight;\n  margin: @imageLabelImageMargin;\n  border-radius: @imageLabelImageBorderRadius;\n}\n\n.ui.image.label .detail {\n  background: @imageLabelDetailBackground;\n  margin: @imageLabelDetailMargin;\n  padding: @imageLabelDetailPadding;\n  border-radius: 0em @imageLabelBorderRadius @imageLabelBorderRadius 0em;\n}\n\n/*-------------------\n         Tag\n--------------------*/\n\n.ui.tag.labels .label,\n.ui.tag.label {\n  margin-left: 1em;\n  position: relative;\n  padding-left: @tagHorizontalPadding;\n  padding-right: @tagHorizontalPadding;\n\n  border-radius: 0em @borderRadius @borderRadius 0em;\n  transition: @tagTransition;\n}\n.ui.tag.labels .label:before,\n.ui.tag.label:before {\n    position: absolute;\n    transform: translateY(-50%) translateX(50%) rotate(-45deg);\n\n    top: @tagTriangleTopOffset;\n    right: @tagTriangleRightOffset;\n    content: '';\n\n    background-color: inherit;\n    background-image: @tagTriangleBackgroundImage;\n\n    width: @tagTriangleSize;\n    height: @tagTriangleSize;\n    transition: @tagTransition;\n}\n\n\n.ui.tag.labels .label:after,\n.ui.tag.label:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: -(@tagCircleSize / 2);\n\n  margin-top: -(@tagCircleSize / 2);\n  background-color: @tagCircleColor !important;\n  width: @tagCircleSize;\n  height: @tagCircleSize;\n\n  box-shadow: @tagCircleBoxShadow;\n  border-radius: @circularRadius;\n}\n\n\n/*-------------------\n    Corner Label\n--------------------*/\n\n.ui.corner.label {\n  position: absolute;\n  top: 0em;\n  right: 0em;\n  margin: 0em;\n  padding: 0em;\n  text-align: center;\n\n  border-color: @backgroundColor;\n\n  width: @cornerTriangleSize;\n  height: @cornerTriangleSize;\n  z-index: @cornerTriangleZIndex;\n  transition: @cornerTriangleTransition;\n}\n\n/* Icon Label */\n.ui.corner.label{\n  background-color: transparent !important;\n}\n.ui.corner.label:after {\n  position: absolute;\n  content: \"\";\n  right: 0em;\n  top: 0em;\n  z-index: -1;\n\n  width: 0em;\n  height: 0em;\n  background-color: transparent !important;\n\n  border-top: 0em solid transparent;\n  border-right: @cornerTriangleSize solid transparent;\n  border-bottom: @cornerTriangleSize solid transparent;\n  border-left: 0em solid transparent;\n\n  border-right-color: inherit;\n  transition: @cornerTriangleTransition;\n}\n\n.ui.corner.label .icon {\n  cursor: default;\n  position: relative;\n  top: @cornerIconTopOffset;\n  left: @cornerIconLeftOffset;\n  font-size: @cornerIconSize;\n  margin: 0em;\n}\n\n/* Left Corner */\n.ui.left.corner.label,\n.ui.left.corner.label:after {\n  right: auto;\n  left: 0em;\n}\n.ui.left.corner.label:after {\n  border-top: @cornerTriangleSize solid transparent;\n  border-right: @cornerTriangleSize solid transparent;\n  border-bottom: 0em solid transparent;\n  border-left: 0em solid transparent;\n\n  border-top-color: inherit;\n}\n.ui.left.corner.label .icon {\n  left: -@cornerIconLeftOffset;\n}\n\n/* Segment */\n.ui.segment > .ui.corner.label {\n  top: -1px;\n  right: -1px;\n}\n.ui.segment > .ui.left.corner.label {\n  right: auto;\n  left: -1px;\n}\n\n/*-------------------\n       Ribbon\n--------------------*/\n\n.ui.ribbon.label {\n  position: relative;\n  margin: 0em;\n  min-width: max-content;\n  border-radius: 0em @borderRadius @borderRadius 0em;\n  border-color: @ribbonShadowColor;\n}\n\n.ui.ribbon.label:after {\n  position: absolute;\n  content: '';\n\n  top: 100%;\n  left: 0%;\n  background-color: transparent !important;\n\n  border-style: solid;\n  border-width: 0em @ribbonTriangleSize @ribbonTriangleSize 0em;\n  border-color: transparent;\n  border-right-color: inherit;\n\n  width: 0em;\n  height: 0em;\n}\n/* Positioning */\n.ui.ribbon.label {\n  left: @ribbonOffset;\n  margin-right: -@ribbonTriangleSize;\n  padding-left: @ribbonDistance;\n  padding-right: @ribbonTriangleSize;\n}\n.ui[class*=\"right ribbon\"].label {\n  left: @rightRibbonOffset;\n  padding-left: @ribbonTriangleSize;\n  padding-right: @ribbonDistance;\n}\n\n/* Right Ribbon */\n.ui[class*=\"right ribbon\"].label {\n  text-align: left;\n  transform: translateX(-100%);\n  border-radius: @borderRadius 0em 0em @borderRadius;\n}\n.ui[class*=\"right ribbon\"].label:after {\n  left: auto;\n  right: 0%;\n\n  border-style: solid;\n  border-width: @ribbonTriangleSize @ribbonTriangleSize 0em 0em;\n  border-color: transparent;\n  border-top-color: inherit;\n}\n\n/* Inside Table */\n.ui.image > .ribbon.label,\n.ui.card .image > .ribbon.label {\n  position: absolute;\n  top: @ribbonImageTopDistance;\n}\n.ui.card .image > .ui.ribbon.label,\n.ui.image > .ui.ribbon.label {\n  left: @ribbonImageOffset;\n}\n.ui.card .image > .ui[class*=\"right ribbon\"].label,\n.ui.image > .ui[class*=\"right ribbon\"].label {\n  left: @rightRibbonImageOffset;\n  padding-left: @horizontalPadding;\n}\n\n/* Inside Table */\n.ui.table td > .ui.ribbon.label {\n  left: @ribbonTableOffset;\n}\n.ui.table td > .ui[class*=\"right ribbon\"].label {\n  left: @rightRibbonTableOffset;\n  padding-left: @horizontalPadding;\n}\n\n\n/*-------------------\n      Attached\n--------------------*/\n\n.ui[class*=\"top attached\"].label,\n.ui.attached.label {\n  width: 100%;\n  position: absolute;\n  margin: 0em;\n  top: 0em;\n  left: 0em;\n\n  padding: @attachedVerticalPadding @attachedHorizontalPadding;\n\n  border-radius: @attachedCornerBorderRadius @attachedCornerBorderRadius 0em 0em;\n}\n.ui[class*=\"bottom attached\"].label {\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em 0em @attachedCornerBorderRadius @attachedCornerBorderRadius;\n}\n\n.ui[class*=\"top left attached\"].label {\n  width: auto;\n  margin-top: 0em !important;\n  border-radius: @attachedCornerBorderRadius 0em @attachedBorderRadius 0em;\n}\n\n.ui[class*=\"top right attached\"].label {\n  width: auto;\n  left: auto;\n  right: 0em;\n  border-radius: 0em @attachedCornerBorderRadius 0em @attachedBorderRadius;\n}\n.ui[class*=\"bottom left attached\"].label {\n  width: auto;\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em @attachedBorderRadius 0em @attachedCornerBorderRadius;\n}\n.ui[class*=\"bottom right attached\"].label {\n  top: auto;\n  bottom: 0em;\n  left: auto;\n  right: 0em;\n  width: auto;\n  border-radius: @attachedBorderRadius 0em @attachedCornerBorderRadius 0em;\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n      Disabled\n--------------------*/\n\n.ui.label.disabled {\n  opacity: 0.5;\n}\n\n/*-------------------\n        Hover\n--------------------*/\n\na.ui.labels .label:hover,\na.ui.label:hover {\n  background-color: @labelHoverBackgroundColor;\n  border-color: @labelHoverBackgroundColor;\n\n  background-image: @labelHoverBackgroundImage;\n  color: @labelHoverTextColor;\n}\n.ui.labels a.label:hover:before,\na.ui.label:hover:before {\n  color: @labelHoverTextColor;\n}\n\n/*-------------------\n        Active\n--------------------*/\n\n.ui.active.label {\n  background-color: @labelActiveBackgroundColor;\n  border-color: @labelActiveBackgroundColor;\n\n  background-image: @labelActiveBackgroundImage;\n  color: @labelActiveTextColor;\n}\n.ui.active.label:before {\n  background-color: @labelActiveBackgroundColor;\n  background-image: @labelActiveBackgroundImage;\n  color: @labelActiveTextColor;\n}\n\n/*-------------------\n     Active Hover\n--------------------*/\n\na.ui.labels .active.label:hover,\na.ui.active.label:hover {\n  background-color: @labelActiveHoverBackgroundColor;\n  border-color: @labelActiveHoverBackgroundColor;\n\n  background-image: @labelActiveHoverBackgroundImage;\n  color: @labelActiveHoverTextColor;\n}\n.ui.labels a.active.label:ActiveHover:before,\na.ui.active.label:ActiveHover:before {\n  background-color: @labelActiveHoverBackgroundColor;\n  background-image: @labelActiveHoverBackgroundImage;\n  color: @labelActiveHoverTextColor;\n}\n\n\n/*-------------------\n      Visible\n--------------------*/\n\n.ui.labels.visible .label,\n.ui.label.visible:not(.dropdown) {\n  display: inline-block !important;\n}\n\n/*-------------------\n      Hidden\n--------------------*/\n\n.ui.labels.hidden .label,\n.ui.label.hidden {\n  display: none !important;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Red ---*/\n.ui.red.labels .label,\n.ui.red.label {\n  background-color: @red !important;\n  border-color: @red !important;\n  color: @redTextColor !important;\n}\n/* Link */\n.ui.red.labels .label:hover,\na.ui.red.label:hover{\n  background-color: @redHover !important;\n  border-color: @redHover !important;\n  color: @redHoverTextColor !important;\n}\n/* Corner */\n.ui.red.corner.label,\n.ui.red.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.red.ribbon.label {\n  border-color: @redRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.red.label {\n  background: @basicBackground !important;\n  color: @red !important;\n  border-color: @red !important;\n}\n.ui.basic.red.labels a.label:hover,\na.ui.basic.red.label:hover {\n  background-color: @white !important;\n  color: @redHover !important;\n  border-color: @redHover !important;\n}\n\n/*--- Orange ---*/\n.ui.orange.labels .label,\n.ui.orange.label {\n  background-color: @orange !important;\n  border-color: @orange !important;\n  color: @orangeTextColor !important;\n}\n/* Link */\n.ui.orange.labels .label:hover,\na.ui.orange.label:hover{\n  background-color: @orangeHover !important;\n  border-color: @orangeHover !important;\n  color: @orangeHoverTextColor !important;\n}\n/* Corner */\n.ui.orange.corner.label,\n.ui.orange.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.orange.ribbon.label {\n  border-color: @orangeRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.orange.label {\n  background: @basicBackground !important;\n  color: @orange !important;\n  border-color: @orange !important;\n}\n.ui.basic.orange.labels a.label:hover,\na.ui.basic.orange.label:hover {\n  background-color: @white !important;\n  color: @orangeHover !important;\n  border-color: @orangeHover !important;\n}\n\n/*--- Yellow ---*/\n.ui.yellow.labels .label,\n.ui.yellow.label {\n  background-color: @yellow !important;\n  border-color: @yellow !important;\n  color: @yellowTextColor !important;\n}\n/* Link */\n.ui.yellow.labels .label:hover,\na.ui.yellow.label:hover{\n  background-color: @yellowHover !important;\n  border-color: @yellowHover !important;\n  color: @yellowHoverTextColor !important;\n}\n/* Corner */\n.ui.yellow.corner.label,\n.ui.yellow.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.yellow.ribbon.label {\n  border-color: @yellowRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.yellow.label {\n  background: @basicBackground !important;\n  color: @yellow !important;\n  border-color: @yellow !important;\n}\n.ui.basic.yellow.labels a.label:hover,\na.ui.basic.yellow.label:hover {\n  background-color: @white !important;\n  color: @yellowHover !important;\n  border-color: @yellowHover !important;\n}\n\n/*--- Olive ---*/\n.ui.olive.labels .label,\n.ui.olive.label {\n  background-color: @olive !important;\n  border-color: @olive !important;\n  color: @oliveTextColor !important;\n}\n/* Link */\n.ui.olive.labels .label:hover,\na.ui.olive.label:hover{\n  background-color: @oliveHover !important;\n  border-color: @oliveHover !important;\n  color: @oliveHoverTextColor !important;\n}\n/* Corner */\n.ui.olive.corner.label,\n.ui.olive.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.olive.ribbon.label {\n  border-color: @greenRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.olive.label {\n  background: @basicBackground !important;\n  color: @olive !important;\n  border-color: @olive !important;\n}\n.ui.basic.olive.labels a.label:hover,\na.ui.basic.olive.label:hover {\n  background-color: @white !important;\n  color: @oliveHover !important;\n  border-color: @oliveHover !important;\n}\n\n/*--- Green ---*/\n.ui.green.labels .label,\n.ui.green.label {\n  background-color: @green !important;\n  border-color: @green !important;\n  color: @greenTextColor !important;\n}\n/* Link */\n.ui.green.labels .label:hover,\na.ui.green.label:hover{\n  background-color: @greenHover !important;\n  border-color: @greenHover !important;\n  color: @greenHoverTextColor !important;\n}\n/* Corner */\n.ui.green.corner.label,\n.ui.green.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.green.ribbon.label {\n  border-color: @greenRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.green.label {\n  background: @basicBackground !important;\n  color: @green !important;\n  border-color: @green !important;\n}\n.ui.basic.green.labels a.label:hover,\na.ui.basic.green.label:hover {\n  background-color: @white !important;\n  color: @greenHover !important;\n  border-color: @greenHover !important;\n}\n\n/*--- Teal ---*/\n.ui.teal.labels .label,\n.ui.teal.label {\n  background-color: @teal !important;\n  border-color: @teal !important;\n  color: @tealTextColor !important;\n}\n/* Link */\n.ui.teal.labels .label:hover,\na.ui.teal.label:hover{\n  background-color: @tealHover !important;\n  border-color: @tealHover !important;\n  color: @tealHoverTextColor !important;\n}\n/* Corner */\n.ui.teal.corner.label,\n.ui.teal.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.teal.ribbon.label {\n  border-color: @tealRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.teal.label {\n  background: @basicBackground !important;\n  color: @teal !important;\n  border-color: @teal !important;\n}\n.ui.basic.teal.labels a.label:hover,\na.ui.basic.teal.label:hover {\n  background-color: @white !important;\n  color: @tealHover !important;\n  border-color: @tealHover !important;\n}\n\n/*--- Blue ---*/\n.ui.blue.labels .label,\n.ui.blue.label {\n  background-color: @blue !important;\n  border-color: @blue !important;\n  color: @blueTextColor !important;\n}\n/* Link */\n.ui.blue.labels .label:hover,\na.ui.blue.label:hover{\n  background-color: @blueHover !important;\n  border-color: @blueHover !important;\n  color: @blueHoverTextColor !important;\n}\n/* Corner */\n.ui.blue.corner.label,\n.ui.blue.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.blue.ribbon.label {\n  border-color: @blueRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.blue.label {\n  background: @basicBackground !important;\n  color: @blue !important;\n  border-color: @blue !important;\n}\n.ui.basic.blue.labels a.label:hover,\na.ui.basic.blue.label:hover {\n  background-color: @white !important;\n  color: @blueHover !important;\n  border-color: @blueHover !important;\n}\n\n/*--- Violet ---*/\n.ui.violet.labels .label,\n.ui.violet.label {\n  background-color: @violet !important;\n  border-color: @violet !important;\n  color: @violetTextColor !important;\n}\n/* Link */\n.ui.violet.labels .label:hover,\na.ui.violet.label:hover{\n  background-color: @violetHover !important;\n  border-color: @violetHover !important;\n  color: @violetHoverTextColor !important;\n}\n/* Corner */\n.ui.violet.corner.label,\n.ui.violet.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.violet.ribbon.label {\n  border-color: @violetRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.violet.label {\n  background: @basicBackground !important;\n  color: @violet !important;\n  border-color: @violet !important;\n}\n.ui.basic.violet.labels a.label:hover,\na.ui.basic.violet.label:hover {\n  background-color: @white !important;\n  color: @violetHover !important;\n  border-color: @violetHover !important;\n}\n\n/*--- Purple ---*/\n.ui.purple.labels .label,\n.ui.purple.label {\n  background-color: @purple !important;\n  border-color: @purple !important;\n  color: @purpleTextColor !important;\n}\n/* Link */\n.ui.purple.labels .label:hover,\na.ui.purple.label:hover{\n  background-color: @purpleHover !important;\n  border-color: @purpleHover !important;\n  color: @purpleHoverTextColor !important;\n}\n/* Corner */\n.ui.purple.corner.label,\n.ui.purple.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.purple.ribbon.label {\n  border-color: @purpleRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.purple.label {\n  background: @basicBackground !important;\n  color: @purple !important;\n  border-color: @purple !important;\n}\n.ui.basic.purple.labels a.label:hover,\na.ui.basic.purple.label:hover {\n  background-color: @white !important;\n  color: @purpleHover !important;\n  border-color: @purpleHover !important;\n}\n\n/*--- Pink ---*/\n.ui.pink.labels .label,\n.ui.pink.label {\n  background-color: @pink !important;\n  border-color: @pink !important;\n  color: @pinkTextColor !important;\n}\n/* Link */\n.ui.pink.labels .label:hover,\na.ui.pink.label:hover{\n  background-color: @pinkHover !important;\n  border-color: @pinkHover !important;\n  color: @pinkHoverTextColor !important;\n}\n/* Corner */\n.ui.pink.corner.label,\n.ui.pink.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.pink.ribbon.label {\n  border-color: @pinkRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.pink.label {\n  background: @basicBackground !important;\n  color: @pink !important;\n  border-color: @pink !important;\n}\n.ui.basic.pink.labels a.label:hover,\na.ui.basic.pink.label:hover {\n  background-color: @white !important;\n  color: @pinkHover !important;\n  border-color: @pinkHover !important;\n}\n\n/*--- Brown ---*/\n.ui.brown.labels .label,\n.ui.brown.label {\n  background-color: @brown !important;\n  border-color: @brown !important;\n  color: @brownTextColor !important;\n}\n/* Link */\n.ui.brown.labels .label:hover,\na.ui.brown.label:hover{\n  background-color: @brownHover !important;\n  border-color: @brownHover !important;\n  color: @brownHoverTextColor !important;\n}\n/* Corner */\n.ui.brown.corner.label,\n.ui.brown.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.brown.ribbon.label {\n  border-color: @brownRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.brown.label {\n  background: @basicBackground !important;\n  color: @brown !important;\n  border-color: @brown !important;\n}\n.ui.basic.brown.labels a.label:hover,\na.ui.basic.brown.label:hover {\n  background-color: @white !important;\n  color: @brownHover !important;\n  border-color: @brownHover !important;\n}\n\n/*--- Grey ---*/\n.ui.grey.labels .label,\n.ui.grey.label {\n  background-color: @grey !important;\n  border-color: @grey !important;\n  color: @greyTextColor !important;\n}\n/* Link */\n.ui.grey.labels .label:hover,\na.ui.grey.label:hover{\n  background-color: @greyHover !important;\n  border-color: @greyHover !important;\n  color: @greyHoverTextColor !important;\n}\n/* Corner */\n.ui.grey.corner.label,\n.ui.grey.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.grey.ribbon.label {\n  border-color: @brownRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.grey.label {\n  background: @basicBackground !important;\n  color: @grey !important;\n  border-color: @grey !important;\n}\n.ui.basic.grey.labels a.label:hover,\na.ui.basic.grey.label:hover {\n  background-color: @white !important;\n  color: @greyHover !important;\n  border-color: @greyHover !important;\n}\n\n/*--- Black ---*/\n.ui.black.labels .label,\n.ui.black.label {\n  background-color: @black !important;\n  border-color: @black !important;\n  color: @blackTextColor !important;\n}\n/* Link */\n.ui.black.labels .label:hover,\na.ui.black.label:hover{\n  background-color: @blackHover !important;\n  border-color: @blackHover !important;\n  color: @blackHoverTextColor !important;\n}\n/* Corner */\n.ui.black.corner.label,\n.ui.black.corner.label:hover {\n  background-color: transparent !important;\n}\n/* Ribbon */\n.ui.black.ribbon.label {\n  border-color: @brownRibbonShadow !important;\n}\n/* Basic */\n.ui.basic.black.label {\n  background: @basicBackground !important;\n  color: @black !important;\n  border-color: @black !important;\n}\n.ui.basic.black.labels a.label:hover,\na.ui.basic.black.label:hover {\n  background-color: @white !important;\n  color: @blackHover !important;\n  border-color: @blackHover !important;\n}\n\n\n/*-------------------\n        Basic\n--------------------*/\n\n.ui.basic.label {\n  background: @basicBackground;\n  border: @basicBorder;\n  color: @basicColor;\n  box-shadow: @basicBoxShadow;\n}\n\n/* Link */\na.ui.basic.label:hover {\n  text-decoration: none;\n  background: @basicHoverBackground;\n  color: @basicHoverColor;\n  box-shadow: @basicHoverBorder;\n  box-shadow: @basicHoverBoxShadow;\n}\n\n/* Pointing */\n.ui.basic.pointing.label:before {\n  border-color: inherit;\n}\n\n\n/*-------------------\n       Fluid\n--------------------*/\n\n.ui.label.fluid,\n.ui.fluid.labels > .label {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.labels .label,\n.ui.inverted.label {\n  color: @invertedTextColor !important;\n}\n\n/*-------------------\n     Horizontal\n--------------------*/\n\n.ui.horizontal.labels .label,\n.ui.horizontal.label {\n  margin: 0em @horizontalLabelMargin 0em 0em;\n\n  padding: @horizontalLabelVerticalPadding @horizontalPadding;\n  min-width: @horizontalLabelMinWidth;\n  text-align: center;\n}\n\n\n/*-------------------\n       Circular\n--------------------*/\n\n.ui.circular.labels .label,\n.ui.circular.label {\n  min-width: @circularMinSize;\n  min-height: @circularMinSize;\n\n  padding: @circularPadding !important;\n\n  line-height: 1em;\n  text-align: center;\n  border-radius: @circularRadius;\n}\n.ui.empty.circular.labels .label,\n.ui.empty.circular.label {\n  min-width: 0em;\n  min-height: 0em;\n  overflow: hidden;\n  width: @emptyCircleSize;\n  height: @emptyCircleSize;\n  vertical-align: baseline;\n}\n\n/*-------------------\n       Pointing\n--------------------*/\n\n.ui.pointing.label {\n  position: relative;\n}\n\n.ui.attached.pointing.label {\n  position: absolute;\n}\n\n.ui.pointing.label:before {\n  background-color: inherit;\n  background-image: inherit;\n  border-width: none;\n  border-style: solid;\n  border-color: @pointingBorderColor;\n}\n/* Arrow */\n.ui.pointing.label:before {\n  position: absolute;\n  content: '';\n  transform: rotate(45deg);\n  background-image: none;\n\n  z-index: @pointingTriangleZIndex;\n  width: @pointingTriangleSize;\n  height: @pointingTriangleSize;\n  transition: @pointingTriangleTransition;\n}\n\n/*--- Above ---*/\n.ui.pointing.label,\n.ui[class*=\"pointing above\"].label {\n  margin-top: @pointingVerticalDistance;\n}\n.ui.pointing.label:before,\n.ui[class*=\"pointing above\"].label:before {\n  border-width: @borderWidth 0px 0px @borderWidth;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 0%;\n  left: 50%;\n}\n/*--- Below ---*/\n.ui[class*=\"bottom pointing\"].label,\n.ui[class*=\"pointing below\"].label {\n  margin-top: 0em;\n  margin-bottom: @pointingVerticalDistance;\n}\n.ui[class*=\"bottom pointing\"].label:before,\n.ui[class*=\"pointing below\"].label:before {\n  border-width: 0px @borderWidth @borderWidth 0px;\n  top: auto;\n  right: auto;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 100%;\n  left: 50%;\n}\n/*--- Left ---*/\n.ui[class*=\"left pointing\"].label {\n  margin-top: 0em;\n  margin-left: @pointingHorizontalDistance;\n}\n.ui[class*=\"left pointing\"].label:before {\n  border-width: 0px 0px @borderWidth @borderWidth;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n/*--- Right ---*/\n.ui[class*=\"right pointing\"].label {\n  margin-top: 0em;\n  margin-right: @pointingHorizontalDistance;\n}\n.ui[class*=\"right pointing\"].label:before {\n  border-width: @borderWidth @borderWidth 0px 0px;\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n}\n\n/* Basic Pointing */\n\n/*--- Above ---*/\n.ui.basic.pointing.label:before,\n.ui.basic[class*=\"pointing above\"].label:before {\n  margin-top: @basicPointingTriangleOffset;\n}\n/*--- Below ---*/\n.ui.basic[class*=\"bottom pointing\"].label:before,\n.ui.basic[class*=\"pointing below\"].label:before {\n  bottom: auto;\n  top: 100%;\n  margin-top: -@basicPointingTriangleOffset;\n}\n/*--- Left ---*/\n.ui.basic[class*=\"left pointing\"].label:before {\n  top: 50%;\n  left: @basicPointingTriangleOffset;\n}\n/*--- Right ---*/\n.ui.basic[class*=\"right pointing\"].label:before {\n  top: 50%;\n  right: @basicPointingTriangleOffset;\n}\n\n\n/*------------------\n   Floating Label\n-------------------*/\n\n.ui.floating.label {\n  position: absolute;\n  z-index: @floatingZIndex;\n  top: @floatingTopOffset;\n  left: 100%;\n  margin: 0em 0em 0em @floatingLeftOffset !important;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.labels .label,\n.ui.mini.label {\n  font-size: @mini;\n}\n.ui.tiny.labels .label,\n.ui.tiny.label {\n  font-size: @tiny;\n}\n.ui.small.labels .label,\n.ui.small.label {\n  font-size: @small;\n}\n.ui.labels .label,\n.ui.label {\n  font-size: @medium;\n}\n.ui.large.labels .label,\n.ui.large.label {\n  font-size: @large;\n}\n.ui.big.labels .label,\n.ui.big.label {\n  font-size: @big;\n}\n.ui.huge.labels .label,\n.ui.huge.label {\n  font-size: @huge;\n}\n.ui.massive.labels .label,\n.ui.massive.label {\n  font-size: @massive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - List\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'list';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            List\n*******************************/\n\nul.ui.list,\nol.ui.list,\n.ui.list {\n  list-style-type: @listStyleType;\n  margin: @margin;\n  padding: @verticalPadding @horizontalPadding;\n}\n\nul.ui.list:first-child,\nol.ui.list:first-child,\n.ui.list:first-child {\n  margin-top: 0em;\n  padding-top: 0em;\n}\n\nul.ui.list:last-child,\nol.ui.list:last-child,\n.ui.list:last-child {\n  margin-bottom: 0em;\n  padding-bottom: 0em;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* List Item */\nul.ui.list li,\nol.ui.list li,\n.ui.list > .item,\n.ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  list-style-type: @listStyleType;\n  list-style-position: @listStylePosition;\n\n  padding: @itemPadding;\n  line-height: @itemLineHeight;\n}\n\nul.ui.list > li:first-child:after,\nol.ui.list > li:first-child:after,\n.ui.list > .list > .item,\n.ui.list > .item:after {\n  content: '';\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\nul.ui.list li:first-child,\nol.ui.list li:first-child,\n.ui.list .list > .item:first-child,\n.ui.list > .item:first-child {\n  padding-top: 0em;\n}\nul.ui.list li:last-child,\nol.ui.list li:last-child,\n.ui.list .list > .item:last-child,\n.ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n\n/* Child List */\nul.ui.list ul,\nol.ui.list ol,\n.ui.list .list {\n  clear: both;\n  margin: 0em;\n  padding: @childListPadding;\n}\n\n/* Child Item */\nul.ui.list ul li,\nol.ui.list ol li,\n.ui.list .list > .item {\n  padding: @childItemPadding;\n  line-height: @childItemLineHeight;\n}\n\n\n/* Icon */\n.ui.list .list > .item > i.icon,\n.ui.list > .item > i.icon {\n  display: table-cell;\n  margin: 0em;\n  padding-top: @iconOffset;\n  padding-right: @iconDistance;\n  vertical-align: @iconContentVerticalAlign;\n  transition: @iconTransition;\n}\n.ui.list .list > .item > i.icon:only-child,\n.ui.list > .item > i.icon:only-child {\n  display: inline-block;\n  vertical-align: @iconVerticalAlign;\n}\n\n\n/* Image */\n.ui.list .list > .item > .image,\n.ui.list > .item > .image {\n  display: table-cell;\n  background-color: transparent;\n  margin: 0em;\n  vertical-align: @imageAlign;\n}\n.ui.list .list > .item > .image:not(:only-child):not(img),\n.ui.list > .item > .image:not(:only-child):not(img) {\n  padding-right: @imageDistance;\n}\n.ui.list .list > .item > .image img,\n.ui.list > .item > .image img {\n  vertical-align: @imageAlign;\n}\n\n.ui.list .list > .item > img.image,\n.ui.list .list > .item > .image:only-child,\n.ui.list > .item > img.image,\n.ui.list > .item > .image:only-child {\n  display: inline-block;\n}\n\n/* Content */\n.ui.list .list > .item > .content,\n.ui.list > .item > .content {\n  line-height: @contentLineHeight;\n}\n.ui.list .list > .item > .image + .content,\n.ui.list .list > .item > .icon + .content,\n.ui.list > .item > .image + .content,\n.ui.list > .item > .icon + .content {\n  display: table-cell;\n  width: 100%;\n  padding: 0em 0em 0em @contentDistance;\n  vertical-align: @contentVerticalAlign;\n}\n.ui.list .list > .item > img.image + .content,\n.ui.list > .item > img.image + .content {\n  display: inline-block;\n  width: auto;\n}\n.ui.list .list > .item > .content > .list,\n.ui.list > .item > .content > .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n\n/* Header */\n.ui.list .list > .item .header,\n.ui.list > .item .header {\n  display: block;\n  margin: 0em;\n  font-family: @itemHeaderFontFamily;\n  font-weight: @itemHeaderFontWeight;\n  color: @itemHeaderColor;\n}\n\n/* Description */\n.ui.list .list > .item .description,\n.ui.list > .item .description {\n  display: block;\n  color: @itemDescriptionColor;\n}\n\n/* Child Link */\n.ui.list > .item a,\n.ui.list .list > .item a {\n  cursor: pointer;\n}\n\n/* Linking Item */\n.ui.list .list > a.item,\n.ui.list > a.item {\n  cursor: pointer;\n  color: @itemLinkColor;\n}\n.ui.list .list > a.item:hover,\n.ui.list > a.item:hover {\n  color: @itemLinkHoverColor;\n}\n\n/* Linked Item Icons */\n.ui.list .list > a.item i.icon,\n.ui.list > a.item i.icon {\n  color: @itemLinkIconColor;\n}\n\n/* Header Link */\n.ui.list .list > .item a.header,\n.ui.list > .item a.header {\n  cursor: pointer;\n  color: @itemHeaderLinkColor !important;\n}\n.ui.list .list > .item a.header:hover,\n.ui.list > .item a.header:hover {\n  color: @itemHeaderLinkHoverColor !important;\n}\n\n/* Floated Content */\n.ui[class*=\"left floated\"].list {\n  float: left;\n}\n.ui[class*=\"right floated\"].list {\n  float: right;\n}\n\n.ui.list .list > .item [class*=\"left floated\"],\n.ui.list > .item [class*=\"left floated\"] {\n  float: left;\n  margin: @leftFloatMargin;\n}\n.ui.list .list > .item [class*=\"right floated\"],\n.ui.list > .item [class*=\"right floated\"] {\n  float: right;\n  margin: @rightFloatMargin;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n.ui.menu .ui.list > .item,\n.ui.menu .ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  background-color: transparent;\n\n  list-style-type: @listStyleType;\n  list-style-position: @listStylePosition;\n\n  padding: @itemVerticalPadding @itemHorizontalPadding;\n  line-height: @itemLineHeight;\n}\n.ui.menu .ui.list .list > .item:before,\n.ui.menu .ui.list > .item:before {\n  border: none;\n  background: none;\n}\n.ui.menu .ui.list .list > .item:first-child,\n.ui.menu .ui.list > .item:first-child {\n  padding-top: 0em;\n}\n.ui.menu .ui.list .list > .item:last-child,\n.ui.menu .ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n\n\n/*******************************\n            Types\n*******************************/\n\n/*-------------------\n      Horizontal\n--------------------*/\n\n.ui.horizontal.list {\n  display: inline-block;\n  font-size: 0em;\n}\n.ui.horizontal.list > .item {\n  display: inline-block;\n  margin-left: @horizontalSpacing;\n  font-size: 1rem;\n}\n.ui.horizontal.list:not(.celled) > .item:first-child {\n  margin-left: 0em !important;\n  padding-left: 0em !important;\n}\n.ui.horizontal.list .list {\n  padding-left: 0em;\n  padding-bottom: 0em;\n}\n\n.ui.horizontal.list > .item > .image,\n.ui.horizontal.list .list > .item > .image,\n.ui.horizontal.list > .item > .icon,\n.ui.horizontal.list .list > .item > .icon,\n.ui.horizontal.list > .item > .content,\n.ui.horizontal.list .list > .item > .content {\n  vertical-align: @horizontalVerticalAlign;\n}\n\n/* Padding on all elements */\n.ui.horizontal.list > .item:first-child,\n.ui.horizontal.list > .item:last-child {\n  padding-top: @itemVerticalPadding;\n  padding-bottom: @itemVerticalPadding;\n}\n\n/* Horizontal List */\n.ui.horizontal.list > .item > i.icon {\n  margin: 0em;\n  padding: 0em @horizontalIconDistance 0em 0em;\n}\n.ui.horizontal.list > .item > .icon,\n.ui.horizontal.list > .item > .icon + .content {\n  float: none;\n  display: inline-block;\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n       Disabled\n--------------------*/\n\n.ui.list .list > .disabled.item,\n.ui.list > .disabled.item {\n  pointer-events: none;\n  color: @disabledColor !important;\n}\n.ui.inverted.list .list > .disabled.item,\n.ui.inverted.list > .disabled.item {\n  color: @invertedDisabledColor !important;\n}\n\n/*-------------------\n        Hover\n--------------------*/\n\n.ui.list .list > a.item:hover .icon,\n.ui.list > a.item:hover .icon {\n  color: @itemLinkIconHoverColor;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.list .list > a.item > .icon,\n.ui.inverted.list > a.item > .icon {\n  color: @invertedIconLinkColor;\n}\n.ui.inverted.list .list > .item .header,\n.ui.inverted.list > .item .header {\n  color: @invertedHeaderColor;\n}\n.ui.inverted.list .list > .item .description,\n.ui.inverted.list > .item .description {\n  color: @invertedDescriptionColor;\n}\n\n/* Item Link */\n.ui.inverted.list .list > a.item,\n.ui.inverted.list > a.item {\n  cursor: pointer;\n  color: @invertedItemLinkColor;\n}\n.ui.inverted.list .list > a.item:hover,\n.ui.inverted.list > a.item:hover {\n  color: @invertedItemLinkHoverColor;\n}\n\n\n/* Linking Content */\n.ui.inverted.list .item a:not(.ui) {\n  color: @invertedItemLinkColor !important;\n}\n.ui.inverted.list .item a:not(.ui):hover {\n  color: @invertedItemLinkHoverColor !important;\n}\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.list[class*=\"top aligned\"] .image,\n.ui.list[class*=\"top aligned\"] .content,\n.ui.list [class*=\"top aligned\"] {\n  vertical-align: top !important;\n}\n.ui.list[class*=\"middle aligned\"] .image,\n.ui.list[class*=\"middle aligned\"] .content,\n.ui.list [class*=\"middle aligned\"] {\n  vertical-align: middle !important;\n}\n.ui.list[class*=\"bottom aligned\"] .image,\n.ui.list[class*=\"bottom aligned\"] .content,\n.ui.list [class*=\"bottom aligned\"] {\n  vertical-align: bottom !important;\n}\n\n/*-------------------\n       Link\n--------------------*/\n\n.ui.link.list .item,\n.ui.link.list a.item,\n.ui.link.list .item a:not(.ui) {\n  color: @linkListItemColor;\n  transition: @linkListTransition;\n}\n.ui.link.list.list a.item:hover,\n.ui.link.list.list .item a:not(.ui):hover {\n  color: @linkListItemHoverColor;\n}\n.ui.link.list.list a.item:active,\n.ui.link.list.list .item a:not(.ui):active {\n  color: @linkListItemDownColor;\n}\n.ui.link.list.list .active.item,\n.ui.link.list.list .active.item a:not(.ui) {\n  color: @linkListItemActiveColor;\n}\n\n/* Inverted */\n.ui.inverted.link.list .item,\n.ui.inverted.link.list a.item,\n.ui.inverted.link.list .item a:not(.ui) {\n  color: @invertedLinkListItemColor;\n}\n.ui.inverted.link.list.list a.item:hover,\n.ui.inverted.link.list.list .item a:not(.ui):hover {\n  color: @invertedLinkListItemHoverColor;\n}\n.ui.inverted.link.list.list a.item:active,\n.ui.inverted.link.list.list .item a:not(.ui):active {\n  color: @invertedLinkListItemDownColor;\n}\n.ui.inverted.link.list.list a.active.item,\n.ui.inverted.link.list.list .active.item a:not(.ui) {\n  color: @invertedLinkListItemActiveColor;\n}\n\n/*-------------------\n      Selection\n--------------------*/\n\n.ui.selection.list .list > .item,\n.ui.selection.list > .item {\n  cursor: pointer;\n  background: @selectionListBackground;\n  padding: @selectionListItemVerticalPadding @selectionListItemHorizontalPadding;\n  margin: @selectionListItemMargin;\n  color: @selectionListColor;\n  border-radius: @selectionListItemBorderRadius;\n  transition: @selectionListTransition;\n}\n.ui.selection.list .list > .item:last-child,\n.ui.selection.list > .item:last-child {\n  margin-bottom: 0em;\n}\n.ui.selection.list.list > .item:hover,\n.ui.selection.list > .item:hover {\n  background: @selectionListHoverBackground;\n  color: @selectionListHoverColor;\n}\n.ui.selection.list .list > .item:active,\n.ui.selection.list > .item:active {\n  background: @selectionListDownBackground;\n  color: @selectionListDownColor;\n}\n.ui.selection.list .list > .item.active,\n.ui.selection.list > .item.active {\n  background: @selectionListActiveBackground;\n  color: @selectionListActiveColor;\n}\n\n/* Inverted */\n.ui.inverted.selection.list > .item,\n.ui.inverted.selection.list > .item {\n  background: @invertedSelectionListBackground;\n  color: @invertedSelectionListColor;\n}\n.ui.inverted.selection.list > .item:hover,\n.ui.inverted.selection.list > .item:hover {\n  background: @invertedSelectionListHoverBackground;\n  color: @invertedSelectionListHoverColor;\n}\n.ui.inverted.selection.list > .item:active,\n.ui.inverted.selection.list > .item:active {\n  background: @invertedSelectionListDownBackground;\n  color: @invertedSelectionListDownColor;\n}\n.ui.inverted.selection.list > .item.active,\n.ui.inverted.selection.list > .item.active {\n  background: @invertedSelectionListActiveBackground;\n  color: @invertedSelectionListActiveColor;\n}\n\n/* Celled / Divided Selection List */\n.ui.celled.selection.list .list > .item,\n.ui.divided.selection.list .list > .item,\n.ui.celled.selection.list > .item,\n.ui.divided.selection.list > .item {\n  border-radius: 0em;\n}\n\n/*-------------------\n       Animated\n--------------------*/\n\n.ui.animated.list > .item {\n  transition: @animatedListTransition;\n}\n.ui.animated.list:not(.horizontal) > .item:hover {\n  padding-left: @animatedListIndent;\n}\n\n/*-------------------\n       Fitted\n--------------------*/\n.ui.fitted.list:not(.selection) .list > .item,\n.ui.fitted.list:not(.selection) > .item {\n  padding-left: 0em;\n  padding-right: 0em;\n}\n.ui.fitted.selection.list .list > .item,\n.ui.fitted.selection.list > .item {\n  margin-left: -@selectionListItemHorizontalPadding;\n  margin-right: -@selectionListItemHorizontalPadding;\n}\n\n/*-------------------\n      Bulleted\n--------------------*/\n\nul.ui.list,\n.ui.bulleted.list {\n  margin-left: @bulletDistance;\n}\nul.ui.list li,\n.ui.bulleted.list .list > .item,\n.ui.bulleted.list > .item {\n  position: relative;\n}\nul.ui.list li:before,\n.ui.bulleted.list .list > .item:before,\n.ui.bulleted.list > .item:before {\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  top: auto;\n  left: auto;\n  font-weight: @normal;\n  margin-left: @bulletOffset;\n  content: @bulletCharacter;\n  opacity: @bulletOpacity;\n  color: @bulletColor;\n  vertical-align: @bulletVerticalAlign;\n}\n\nul.ui.list li:before,\n.ui.bulleted.list .list > a.item:before,\n.ui.bulleted.list > a.item:before {\n  color: @bulletLinkColor;\n}\n\nul.ui.list ul,\n.ui.bulleted.list .list {\n  padding-left: @bulletChildDistance;\n}\n\n/* Horizontal Bulleted */\nul.ui.horizontal.bulleted.list,\n.ui.horizontal.bulleted.list {\n  margin-left: 0em;\n}\nul.ui.horizontal.bulleted.list li,\n.ui.horizontal.bulleted.list > .item {\n  margin-left: @horizontalBulletSpacing;\n}\nul.ui.horizontal.bulleted.list li:first-child,\n.ui.horizontal.bulleted.list > .item:first-child {\n  margin-left: 0em;\n}\nul.ui.horizontal.bulleted.list li::before,\n.ui.horizontal.bulleted.list > .item::before {\n  color: @horizontalBulletColor;\n}\nul.ui.horizontal.bulleted.list li:first-child::before,\n.ui.horizontal.bulleted.list > .item:first-child::before {\n  display: none;\n}\n\n/*-------------------\n       Ordered\n--------------------*/\n\nol.ui.list,\n.ui.ordered.list,\n.ui.ordered.list .list,\nol.ui.list ol {\n  counter-reset: ordered;\n  margin-left: @orderedCountDistance;\n  list-style-type: none;\n}\nol.ui.list li,\n.ui.ordered.list .list > .item,\n.ui.ordered.list > .item {\n  list-style-type: none;\n  position: relative;\n}\nol.ui.list li:before,\n.ui.ordered.list .list > .item:before,\n.ui.ordered.list > .item:before {\n  position: absolute;\n  top: auto;\n  left: auto;\n  user-select: none;\n  pointer-events: none;\n  margin-left: -(@orderedCountDistance);\n  counter-increment: @orderedCountName;\n  content: @orderedCountContent;\n  text-align: @orderedCountTextAlign;\n  color: @orderedCountColor;\n  vertical-align: @orderedCountVerticalAlign;\n  opacity: @orderedCountOpacity;\n}\n\nol.ui.inverted.list li:before,\n.ui.ordered.inverted.list .list > .item:before,\n.ui.ordered.inverted.list > .item:before {\n  color: @orderedInvertedCountColor;\n}\n\n/* Value */\n.ui.ordered.list > .list > .item[data-value],\n.ui.ordered.list > .item[data-value] {\n  content: attr(data-value);\n}\nol.ui.list li[value]:before {\n  content: attr(value);\n}\n\n/* Child Lists */\nol.ui.list ol,\n.ui.ordered.list .list {\n  margin-left: @orderedChildCountDistance;\n}\nol.ui.list ol li:before,\n.ui.ordered.list .list > .item:before {\n  margin-left: @orderedChildCountOffset;\n}\n\n/* Horizontal Ordered */\nol.ui.horizontal.list,\n.ui.ordered.horizontal.list {\n  margin-left: 0em;\n}\nol.ui.horizontal.list li:before,\n.ui.ordered.horizontal.list .list > .item:before,\n.ui.ordered.horizontal.list > .item:before {\n  position: static;\n  margin: 0em @horizontalOrderedCountDistance 0em 0em;\n}\n\n/*-------------------\n       Divided\n--------------------*/\n\n.ui.divided.list > .item {\n  border-top: @dividedBorder;\n}\n.ui.divided.list .list > .item {\n  border-top: @dividedChildListBorder;\n}\n.ui.divided.list .item .list > .item {\n  border-top: @dividedChildItemBorder;\n}\n.ui.divided.list .list > .item:first-child,\n.ui.divided.list > .item:first-child {\n  border-top: none;\n}\n\n/* Sub Menu */\n.ui.divided.list:not(.horizontal) .list > .item:first-child {\n  border-top-width: @dividedBorderWidth;\n}\n\n/* Divided bulleted */\n.ui.divided.bulleted.list:not(.horizontal),\n.ui.divided.bulleted.list .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n.ui.divided.bulleted.list > .item:not(.horizontal) {\n  padding-left: @bulletDistance;\n}\n\n/* Divided Ordered */\n.ui.divided.ordered.list {\n  margin-left: 0em;\n}\n.ui.divided.ordered.list .list > .item,\n.ui.divided.ordered.list > .item {\n  padding-left: @orderedCountDistance;\n}\n.ui.divided.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: @itemVerticalPadding;\n}\n.ui.divided.ordered.list .item .list > .item {\n  padding-left: @orderedChildCountDistance;\n}\n\n/* Divided Selection */\n.ui.divided.selection.list .list > .item,\n.ui.divided.selection.list > .item {\n  margin: 0em;\n  border-radius: 0em;\n}\n\n/* Divided horizontal */\n.ui.divided.horizontal.list {\n  margin-left: 0em;\n}\n.ui.divided.horizontal.list > .item:not(:first-child) {\n  padding-left: @horizontalDividedSpacing;\n}\n.ui.divided.horizontal.list > .item:not(:last-child) {\n  padding-right: @horizontalDividedSpacing;\n}\n.ui.divided.horizontal.list > .item {\n  border-top: none;\n  border-left: @dividedBorder;\n  margin: 0em;\n  line-height: @horizontalDividedLineHeight;\n}\n.ui.horizontal.divided.list > .item:first-child {\n  border-left: none;\n}\n/* Inverted */\n.ui.divided.inverted.list > .item,\n.ui.divided.inverted.list > .list,\n.ui.divided.inverted.horizontal.list > .item {\n  border-color: @dividedInvertedBorderColor;\n}\n\n\n/*-------------------\n        Celled\n--------------------*/\n\n.ui.celled.list > .item,\n.ui.celled.list > .list {\n  border-top: @celledBorder;\n  padding-left: @celledHorizontalPadding;\n  padding-right: @celledHorizontalPadding;\n}\n.ui.celled.list > .item:last-child {\n  border-bottom: @celledBorder;\n}\n\n/* Padding on all elements */\n.ui.celled.list > .item:first-child,\n.ui.celled.list > .item:last-child {\n  padding-top: @itemVerticalPadding;\n  padding-bottom: @itemVerticalPadding;\n}\n\n/* Sub Menu */\n.ui.celled.list .item .list > .item {\n  border-width: 0px;\n}\n.ui.celled.list .list > .item:first-child {\n  border-top-width: 0px;\n}\n\n/* Celled Bulleted */\n.ui.celled.bulleted.list {\n  margin-left: 0em;\n}\n.ui.celled.bulleted.list .list > .item,\n.ui.celled.bulleted.list > .item {\n  padding-left: (@bulletDistance);\n}\n.ui.celled.bulleted.list .item .list {\n  margin-left: -(@bulletDistance);\n  margin-right: -(@bulletDistance);\n  padding-bottom: @itemVerticalPadding;\n}\n\n/* Celled Ordered */\n.ui.celled.ordered.list {\n  margin-left: 0em;\n}\n.ui.celled.ordered.list .list > .item,\n.ui.celled.ordered.list > .item {\n  padding-left: @orderedCountDistance;\n}\n.ui.celled.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: @itemVerticalPadding;\n}\n.ui.celled.ordered.list .list > .item {\n  padding-left: @orderedChildCountDistance;\n}\n\n/* Celled Horizontal */\n.ui.horizontal.celled.list {\n  margin-left: 0em;\n}\n.ui.horizontal.celled.list .list > .item,\n.ui.horizontal.celled.list > .item {\n  border-top: none;\n  border-left: @celledBorder;\n  margin: 0em;\n  padding-left: @horizontalCelledSpacing;\n  padding-right: @horizontalCelledSpacing;\n\n  line-height: @horizontalCelledLineHeight;\n}\n.ui.horizontal.celled.list .list > .item:last-child,\n.ui.horizontal.celled.list > .item:last-child {\n  border-bottom: none;\n  border-right: @celledBorder;\n}\n\n/* Inverted */\n.ui.celled.inverted.list > .item,\n.ui.celled.inverted.list > .list {\n  border-color: @celledInvertedBorder;\n}\n.ui.celled.inverted.horizontal.list .list > .item,\n.ui.celled.inverted.horizontal.list > .item {\n  border-color: @celledInvertedBorder;\n}\n\n/*-------------------\n       Relaxed\n--------------------*/\n\n.ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: @relaxedItemVerticalPadding;\n}\n.ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: @relaxedItemVerticalPadding;\n}\n.ui.horizontal.relaxed.list .list > .item:not(:first-child),\n.ui.horizontal.relaxed.list > .item:not(:first-child) {\n  padding-left: @relaxedHorizontalPadding;\n}\n.ui.horizontal.relaxed.list .list > .item:not(:last-child),\n.ui.horizontal.relaxed.list > .item:not(:last-child) {\n  padding-right: @relaxedHorizontalPadding;\n}\n\n/* Very Relaxed */\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: @veryRelaxedItemVerticalPadding;\n}\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: @veryRelaxedItemVerticalPadding;\n}\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:first-child),\n.ui.horizontal[class*=\"very relaxed\"].list > .item:not(:first-child) {\n  padding-left: @veryRelaxedHorizontalPadding;\n}\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:last-child),\n.ui.horizontal[class*=\"very relaxed\"].list > .item:not(:last-child) {\n  padding-right: @veryRelaxedHorizontalPadding;\n}\n\n/*-------------------\n      Sizes\n--------------------*/\n\n.ui.mini.list {\n  font-size: @relativeMini;\n}\n.ui.tiny.list {\n  font-size: @relativeTiny;\n}\n.ui.small.list {\n  font-size: @relativeSmall;\n}\n.ui.list {\n  font-size: @relativeMedium;\n}\n.ui.large.list {\n  font-size: @relativeLarge;\n}\n.ui.big.list {\n  font-size: @relativeBig;\n}\n.ui.huge.list {\n  font-size: @relativeHuge;\n}\n.ui.massive.list {\n  font-size: @relativeMassive;\n}\n\n.ui.mini.horizontal.list .list > .item,\n.ui.mini.horizontal.list > .item {\n  font-size: @mini;\n}\n.ui.tiny.horizontal.list .list > .item,\n.ui.tiny.horizontal.list > .item {\n  font-size: @tiny;\n}\n.ui.small.horizontal.list .list > .item,\n.ui.small.horizontal.list > .item {\n  font-size: @small;\n}\n.ui.horizontal.list .list > .item,\n.ui.horizontal.list > .item {\n  font-size: @medium;\n}\n.ui.large.horizontal.list .list > .item,\n.ui.large.horizontal.list > .item {\n  font-size: @large;\n}\n.ui.big.horizontal.list .list > .item,\n.ui.big.horizontal.list > .item {\n  font-size: @big;\n}\n.ui.huge.horizontal.list .list > .item,\n.ui.huge.horizontal.list > .item {\n  font-size: @huge;\n}\n.ui.massive.horizontal.list .list > .item,\n.ui.massive.horizontal.list > .item {\n  font-size: @massive;\n}\n\n.loadUIOverrides();\n\n","/*!\n * # Semantic UI - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'loader';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Loader\n*******************************/\n\n\n/* Standard Size */\n.ui.loader {\n  display: none;\n  position: absolute;\n  top: @loaderTopOffset;\n  left: @loaderLeftOffset;\n  margin: 0px;\n  text-align: center;\n  z-index: 1000;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n/* Static Shape */\n.ui.loader:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @loaderFillColor;\n}\n\n/* Active Shape */\n.ui.loader:after {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n\n  animation: loader @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @shapeBorderColor;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n/* Active Animation */\n@keyframes loader {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Sizes */\n.ui.mini.loader:before,\n.ui.mini.loader:after {\n  width: @mini;\n  height: @mini;\n  margin: @miniOffset;\n}\n.ui.tiny.loader:before,\n.ui.tiny.loader:after {\n  width: @tiny;\n  height: @tiny;\n  margin: @tinyOffset;\n}\n.ui.small.loader:before,\n.ui.small.loader:after {\n  width: @small;\n  height: @small;\n  margin: @smallOffset;\n}\n.ui.loader:before,\n.ui.loader:after {\n  width: @medium;\n  height: @medium;\n  margin: @mediumOffset;\n}\n.ui.large.loader:before,\n.ui.large.loader:after {\n  width: @large;\n  height: @large;\n  margin: @largeOffset;\n}\n.ui.big.loader:before,\n.ui.big.loader:after {\n  width: @big;\n  height: @big;\n  margin: @bigOffset;\n}\n.ui.huge.loader:before,\n.ui.huge.loader:after {\n  width: @huge;\n  height: @huge;\n  margin: @hugeOffset;\n}\n.ui.massive.loader:before,\n.ui.massive.loader:after {\n  width: @massive;\n  height: @massive;\n  margin: @massiveOffset;\n}\n\n/*-------------------\n      Coupling\n--------------------*/\n\n/* Show inside active dimmer */\n.ui.dimmer .loader {\n  display: block;\n}\n\n/* Black Dimmer */\n.ui.dimmer .ui.loader {\n  color: @invertedLoaderTextColor;\n}\n.ui.dimmer .ui.loader:before {\n  border-color: @invertedLoaderFillColor;\n}\n.ui.dimmer .ui.loader:after {\n  border-color: @invertedShapeBorderColor;\n}\n\n/* White Dimmer (Inverted) */\n.ui.inverted.dimmer .ui.loader {\n  color: @loaderTextColor;\n}\n.ui.inverted.dimmer .ui.loader:before {\n  border-color: @loaderFillColor;\n}\n.ui.inverted.dimmer .ui.loader:after {\n  border-color: @shapeBorderColor;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n        Text\n--------------------*/\n\n.ui.text.loader {\n  width: auto !important;\n  height: auto !important;\n  text-align: center;\n  font-style: normal;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n.ui.indeterminate.loader:after {\n  animation-direction: @indeterminateDirection;\n  animation-duration: @indeterminateSpeed;\n}\n\n.ui.loader.active,\n.ui.loader.visible {\n  display: block;\n}\n.ui.loader.disabled,\n.ui.loader.hidden {\n  display: none;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n\n/*-------------------\n        Sizes\n--------------------*/\n\n\n/* Loader */\n.ui.inverted.dimmer .ui.mini.loader,\n.ui.mini.loader {\n  width: @mini;\n  height: @mini;\n  font-size: @miniFontSize;\n}\n.ui.inverted.dimmer .ui.tiny.loader,\n.ui.tiny.loader {\n  width: @tiny;\n  height: @tiny;\n  font-size: @tinyFontSize;\n}\n.ui.inverted.dimmer .ui.small.loader,\n.ui.small.loader {\n  width: @small;\n  height: @small;\n  font-size: @smallFontSize;\n}\n.ui.inverted.dimmer .ui.loader,\n.ui.loader {\n  width: @medium;\n  height: @medium;\n  font-size: @mediumFontSize;\n}\n.ui.inverted.dimmer .ui.large.loader,\n.ui.large.loader {\n  width: @large;\n  height: @large;\n  font-size: @largeFontSize;\n}\n.ui.inverted.dimmer .ui.big.loader,\n.ui.big.loader {\n  width: @big;\n  height: @big;\n  font-size: @bigFontSize;\n}\n.ui.inverted.dimmer .ui.huge.loader,\n.ui.huge.loader {\n  width: @huge;\n  height: @huge;\n  font-size: @hugeFontSize;\n}\n.ui.inverted.dimmer .ui.massive.loader,\n.ui.massive.loader {\n  width: @massive;\n  height: @massive;\n  font-size: @massiveFontSize;\n}\n\n/* Text Loader */\n.ui.mini.text.loader {\n  min-width: @mini;\n  padding-top: (@mini + @textDistance);\n}\n.ui.tiny.text.loader {\n  min-width: @tiny;\n  padding-top: (@tiny + @textDistance);\n}\n.ui.small.text.loader {\n  min-width: @small;\n  padding-top: (@small + @textDistance);\n}\n.ui.text.loader {\n  min-width: @medium;\n  padding-top: (@medium + @textDistance);\n}\n.ui.large.text.loader {\n  min-width: @large;\n  padding-top: (@large + @textDistance);\n}\n.ui.big.text.loader {\n  min-width: @big;\n  padding-top: (@big + @textDistance);\n}\n.ui.huge.text.loader {\n  min-width: @huge;\n  padding-top: (@huge + @textDistance);\n}\n.ui.massive.text.loader {\n  min-width: @massive;\n  padding-top: (@massive + @textDistance);\n}\n\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.loader {\n  color: @invertedLoaderTextColor\n}\n.ui.inverted.loader:before {\n  border-color: @invertedLoaderFillColor;\n}\n.ui.inverted.loader:after {\n  border-top-color: @invertedLoaderLineColor;\n}\n\n/*-------------------\n       Inline\n--------------------*/\n\n.ui.inline.loader {\n  position: relative;\n  vertical-align: @inlineVerticalAlign;\n  margin: @inlineMargin;\n  left: 0em;\n  top: 0em;\n  transform: none;\n}\n\n.ui.inline.loader.active,\n.ui.inline.loader.visible {\n  display: inline-block;\n}\n\n/* Centered Inline */\n.ui.centered.inline.loader.active,\n.ui.centered.inline.loader.visible {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'placeholder';\n\n@import (multiple) '../../theme.config';\n\n/*-------------------\n      Content\n--------------------*/\n\n.ui.placeholder {\n  position: static;\n  overflow: hidden;\n  animation: placeholderShimmer @placeholderLoadingAnimationDuration linear;\n  animation-iteration-count: infinite;\n  background-color: @white;\n  background-image: @placeholderLoadingGradient;\n  background-size: @placeholderLoadingGradientWidth 100%;\n  max-width: @placeholderMaxWidth;\n}\n\n@keyframes placeholderShimmer{\n  0% {\n    background-position: -@placeholderLoadingGradientWidth 0\n  }\n  100% {\n    background-position: @placeholderLoadingGradientWidth 0\n  }\n}\n\n.ui.placeholder + .ui.placeholder {\n  margin-top: @consecutivePlaceholderSpacing;\n}\n.ui.placeholder + .ui.placeholder {\n  animation-delay: @placeholderAnimationInterval;\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: (@placeholderAnimationInterval * 2);\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: (@placeholderAnimationInterval * 3);\n}\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  animation-delay: (@placeholderAnimationInterval * 4);\n}\n\n.ui.placeholder,\n.ui.placeholder > :before,\n.ui.placeholder .image.header:after,\n.ui.placeholder .line,\n.ui.placeholder .line:after {\n  background-color: @white;\n}\n\n/* Image */\n.ui.placeholder .image:not(.header):not(.ui) {\n  height: @placeholderImageHeight;\n}\n.ui.placeholder .square.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 1/1 aspect ratio */\n  padding-top: 100%;\n}\n.ui.placeholder .rectangular.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 4/3 aspect ratio */\n  padding-top: 75%;\n}\n\n\n/* Lines */\n.ui.placeholder .line {\n  position: relative;\n  height: @placeholderLineMargin;\n}\n.ui.placeholder .line:before,\n.ui.placeholder .line:after {\n  top: 100%;\n  position: absolute;\n  content: '';\n  background-color: inherit;\n}\n.ui.placeholder .line:before {\n  left: 0px;\n}\n.ui.placeholder .line:after {\n  right: 0px;\n}\n\n/* Any Lines */\n.ui.placeholder .line {\n  margin-bottom: @placeholderLineHeight;\n}\n.ui.placeholder .line:before,\n.ui.placeholder .line:after {\n  height: @placeholderLineHeight;\n}\n.ui.placeholder .line:not(:first-child) {\n  margin-top: @placeholderLineHeight;\n}\n\n/* Header Image + 2 Lines */\n.ui.placeholder .header {\n  position: relative;\n  overflow: hidden;\n}\n\n/* Line Outdent */\n.ui.placeholder .line:nth-child(1):after {\n  width: @placeholderLineOneOutdent;\n}\n.ui.placeholder .line:nth-child(2):after {\n  width: @placeholderLineTwoOutdent;\n}\n.ui.placeholder .line:nth-child(3):after {\n  width: @placeholderLineThreeOutdent;\n}\n.ui.placeholder .line:nth-child(4):after {\n  width: @placeholderLineFourOutdent;\n}\n.ui.placeholder .line:nth-child(5):after {\n  width: @placeholderLineFiveOutdent;\n}\n\n/* Header Line 1 & 2*/\n.ui.placeholder .header .line {\n  margin-bottom: @placeholderHeaderLineHeight;\n}\n.ui.placeholder .header .line:before,\n.ui.placeholder .header .line:after {\n  height: @placeholderHeaderLineHeight;\n}\n.ui.placeholder .header .line:not(:first-child) {\n  margin-top: @placeholderHeaderLineHeight;\n}\n.ui.placeholder .header .line:after {\n  width: @placeholderHeaderLineOneOutdent;\n}\n.ui.placeholder .header .line:nth-child(2):after {\n  width: @placeholderHeaderLineTwoOutdent;\n}\n\n/* Image Header */\n.ui.placeholder .image.header .line {\n  margin-left: @placeholderImageWidth;\n}\n.ui.placeholder .image.header .line:before {\n  width: @placeholderImageTextIndent;\n}\n.ui.placeholder .image.header:after {\n  display: block;\n  height: @placeholderLineMargin;\n  content: '';\n  margin-left: @placeholderImageWidth;\n}\n\n/* Spacing */\n.ui.placeholder .image .line:first-child,\n.ui.placeholder .paragraph .line:first-child,\n.ui.placeholder .header .line:first-child {\n  height: 0.01px;\n}\n.ui.placeholder .image:not(:first-child):before,\n.ui.placeholder .paragraph:not(:first-child):before,\n.ui.placeholder .header:not(:first-child):before {\n  height: @placeholderSpacing;\n  content: '';\n  display: block;\n}\n\n/* Inverted Content Loader */\n.ui.inverted.placeholder {\n  background-image: @placeholderInvertedLoadingGradient;\n}\n.ui.inverted.placeholder,\n.ui.inverted.placeholder > :before,\n.ui.inverted.placeholder .image.header:after,\n.ui.inverted.placeholder .line,\n.ui.inverted.placeholder .line:after {\n  background-color: @black;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.placeholder .full.line.line.line:after {\n  width: @placeholderFullLineOutdent;\n}\n.ui.placeholder .very.long.line.line.line:after {\n  width: @placeholderVeryLongLineOutdent;\n}\n.ui.placeholder .long.line.line.line:after {\n  width: @placeholderLongLineOutdent;\n}\n.ui.placeholder .medium.line.line.line:after {\n  width: @placeholderMediumLineOutdent;\n}\n.ui.placeholder .short.line.line.line:after {\n  width: @placeholderShortLineOutdent;\n}\n.ui.placeholder .very.short.line.line.line:after {\n  width: @placeholderVeryShortLineOutdent;\n}\n\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.placeholder {\n  max-width: none;\n}\n","/*!\n * # Semantic UI - Rail\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'rail';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Rails\n*******************************/\n\n.ui.rail {\n  position: absolute;\n  top: 0%;\n  width: @width;\n  height: @height;\n}\n\n.ui.left.rail {\n  left: auto;\n  right: 100%;\n  padding: 0em @splitDistance 0em 0em;\n  margin: 0em @splitDistance 0em 0em;\n}\n\n.ui.right.rail {\n  left: 100%;\n  right: auto;\n  padding: 0em 0em 0em @splitDistance;\n  margin: 0em 0em 0em @splitDistance;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Internal\n---------------*/\n\n.ui.left.internal.rail {\n  left: 0%;\n  right: auto;\n  padding: 0em 0em 0em @splitDistance;\n  margin: 0em 0em 0em @splitDistance;\n}\n\n.ui.right.internal.rail {\n  left: auto;\n  right: 0%;\n  padding: 0em @splitDistance 0em 0em;\n  margin: 0em @splitDistance 0em 0em;\n}\n\n\n/*--------------\n    Dividing\n---------------*/\n\n.ui.dividing.rail {\n  width: @dividingWidth;\n}\n.ui.left.dividing.rail {\n  padding: 0em @splitDividingDistance 0em 0em;\n  margin: 0em @splitDividingDistance 0em 0em;\n  border-right: @dividingBorder;\n}\n.ui.right.dividing.rail {\n  border-left: @dividingBorder;\n  padding: 0em 0em 0em @splitDividingDistance;\n  margin: 0em 0em 0em @splitDividingDistance;\n}\n\n/*--------------\n    Distance\n---------------*/\n\n.ui.close.rail {\n  width: @closeWidth;\n}\n.ui.close.left.rail {\n  padding: 0em @splitCloseDistance 0em 0em;\n  margin: 0em @splitCloseDistance 0em 0em;\n}\n.ui.close.right.rail {\n  padding: 0em 0em 0em @splitCloseDistance;\n  margin: 0em 0em 0em @splitCloseDistance;\n}\n\n.ui.very.close.rail {\n  width: @veryCloseWidth;\n}\n.ui.very.close.left.rail {\n  padding: 0em @splitVeryCloseDistance 0em 0em;\n  margin: 0em @splitVeryCloseDistance 0em 0em;\n}\n.ui.very.close.right.rail {\n  padding: 0em 0em 0em @splitVeryCloseDistance;\n  margin: 0em 0em 0em @splitVeryCloseDistance;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n.ui.attached.left.rail,\n.ui.attached.right.rail {\n  padding: 0em;\n  margin: 0em;\n}\n\n/*--------------\n     Sizing\n---------------*/\n\n.ui.mini.rail {\n  font-size: @mini;\n}\n.ui.tiny.rail {\n  font-size: @tiny;\n}\n.ui.small.rail {\n  font-size: @small;\n}\n.ui.rail {\n  font-size: @medium;\n}\n.ui.large.rail {\n  font-size: @large;\n}\n.ui.big.rail {\n  font-size: @big;\n}\n.ui.huge.rail {\n  font-size: @huge;\n}\n.ui.massive.rail {\n  font-size: @massive;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Reveal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'reveal';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Reveal\n*******************************/\n\n.ui.reveal  {\n  display: inherit;\n  position: relative !important;\n  font-size: 0em !important;\n}\n\n.ui.reveal > .visible.content {\n  position: absolute !important;\n  top: 0em !important;\n  left: 0em !important;\n  z-index: @topZIndex !important;\n  transition: @transition;\n}\n.ui.reveal > .hidden.content {\n  position: relative !important;\n  z-index: @bottomZIndex !important;\n}\n\n/* Make sure hovered element is on top of other reveal */\n.ui.active.reveal .visible.content,\n.ui.reveal:hover .visible.content {\n  z-index: @activeZIndex !important;\n}\n\n\n/*******************************\n              Types\n*******************************/\n\n\n/*--------------\n      Slide\n---------------*/\n\n.ui.slide.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n\n.ui.slide.reveal > .content {\n  display: block;\n  width: 100%;\n  white-space: normal;\n  float: left;\n\n  margin: 0em;\n  transition: @slideTransition;\n}\n\n.ui.slide.reveal > .visible.content {\n  position: relative !important;\n}\n.ui.slide.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n  transform: translateX(100%) !important;\n}\n.ui.slide.active.reveal > .visible.content,\n.ui.slide.reveal:hover > .visible.content {\n  transform: translateX(-100%) !important;\n}\n.ui.slide.active.reveal > .hidden.content,\n.ui.slide.reveal:hover > .hidden.content {\n  transform: translateX(0%) !important;\n}\n\n.ui.slide.right.reveal > .visible.content {\n  transform: translateX(0%) !important;\n}\n.ui.slide.right.reveal > .hidden.content {\n  transform: translateX(-100%) !important;\n}\n.ui.slide.right.active.reveal > .visible.content,\n.ui.slide.right.reveal:hover > .visible.content {\n  transform: translateX(100%) !important;\n}\n.ui.slide.right.active.reveal > .hidden.content,\n.ui.slide.right.reveal:hover > .hidden.content {\n  transform: translateX(0%) !important;\n}\n\n.ui.slide.up.reveal > .hidden.content {\n  transform: translateY(100%) !important;\n}\n.ui.slide.up.active.reveal > .visible.content,\n.ui.slide.up.reveal:hover > .visible.content {\n  transform: translateY(-100%) !important;\n}\n.ui.slide.up.active.reveal > .hidden.content,\n.ui.slide.up.reveal:hover > .hidden.content {\n  transform: translateY(0%) !important;\n}\n\n.ui.slide.down.reveal > .hidden.content {\n  transform: translateY(-100%) !important;\n}\n.ui.slide.down.active.reveal > .visible.content,\n.ui.slide.down.reveal:hover > .visible.content {\n  transform: translateY(100%) !important;\n}\n.ui.slide.down.active.reveal > .hidden.content,\n.ui.slide.down.reveal:hover > .hidden.content {\n  transform: translateY(0%) !important;\n}\n\n\n/*--------------\n      Fade\n---------------*/\n\n.ui.fade.reveal > .visible.content {\n  opacity: 1;\n}\n.ui.fade.active.reveal > .visible.content,\n.ui.fade.reveal:hover > .visible.content {\n  opacity: 0;\n}\n\n\n/*--------------\n      Move\n---------------*/\n\n.ui.move.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n\n.ui.move.reveal > .content {\n  display: block;\n  float: left;\n  white-space: normal;\n\n  margin: 0em;\n  transition: @moveTransition;\n}\n\n.ui.move.reveal > .visible.content {\n  position: relative !important;\n}\n.ui.move.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n}\n.ui.move.active.reveal > .visible.content,\n.ui.move.reveal:hover > .visible.content {\n  transform: translateX(-100%) !important;\n}\n.ui.move.right.active.reveal > .visible.content,\n.ui.move.right.reveal:hover > .visible.content {\n  transform: translateX(100%) !important;\n}\n.ui.move.up.active.reveal > .visible.content,\n.ui.move.up.reveal:hover > .visible.content {\n  transform: translateY(-100%) !important;\n}\n.ui.move.down.active.reveal > .visible.content,\n.ui.move.down.reveal:hover > .visible.content {\n  transform: translateY(100%) !important;\n}\n\n\n\n/*--------------\n     Rotate\n---------------*/\n\n.ui.rotate.reveal > .visible.content {\n  transition-duration: @transitionDuration;\n  transform: rotate(0deg);\n}\n\n.ui.rotate.reveal > .visible.content,\n.ui.rotate.right.reveal > .visible.content {\n  transform-origin: bottom right;\n}\n.ui.rotate.active.reveal > .visible.content,\n.ui.rotate.reveal:hover > .visible.content,\n.ui.rotate.right.active.reveal > .visible.content,\n.ui.rotate.right.reveal:hover > .visible.content {\n  transform: rotate(@rotateDegrees);\n}\n\n.ui.rotate.left.reveal > .visible.content {\n  transform-origin: bottom left;\n}\n.ui.rotate.left.active.reveal > .visible.content,\n.ui.rotate.left.reveal:hover > .visible.content {\n  transform: rotate(-@rotateDegrees);\n}\n\n/*******************************\n              States\n*******************************/\n\n.ui.disabled.reveal:hover > .visible.visible.content {\n  position: static !important;\n  display: block !important;\n  opacity: 1 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: none !important;\n}\n.ui.disabled.reveal:hover > .hidden.hidden.content {\n  display: none !important;\n}\n\n\n/*******************************\n           Coupling\n*******************************/\n\n.ui.reveal > .ui.ribbon.label {\n  z-index: @overlayZIndex;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Visible\n---------------*/\n\n.ui.visible.reveal {\n  overflow: visible;\n}\n\n/*--------------\n     Instant\n---------------*/\n\n.ui.instant.reveal > .content {\n  transition-delay: 0s !important;\n}\n\n\n/*--------------\n     Sizing\n---------------*/\n\n.ui.reveal > .content {\n  font-size: @medium !important;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Segment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'element';\n@element : 'segment';\n\n@import (multiple) '../../theme.config';\n\n@background: rgba(0, 0, 0, 0);\n\n/*******************************\n            Segment\n*******************************/\n\n.ui.segment {\n  position: relative;\n  background: @background;\n  box-shadow: @boxShadow;\n  margin: @margin;\n  padding: @padding;\n  border-radius: @borderRadius;\n  border: @border;\n}\n\n.ui.segment:first-child {\n  margin-top: 0em;\n}\n.ui.segment:last-child {\n  margin-bottom: 0em;\n}\n\n\n/* Vertical */\n.ui.vertical.segment {\n  margin: 0em;\n  padding-left: 0em;\n  padding-right: 0em;\n\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n  border-bottom: @borderWidth solid @borderColor;\n}\n.ui.vertical.segment:last-child {\n  border-bottom: none;\n}\n\n\n/*-------------------\n    Loose Coupling\n--------------------*/\n\n/* Header */\n.ui.inverted.segment > .ui.header {\n  color: @white;\n}\n\n/* Label */\n.ui[class*=\"bottom attached\"].segment > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n.ui[class*=\"top attached\"].segment > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n\n/* Grid */\n.ui.page.grid.segment,\n.ui.grid > .row > .ui.segment.column,\n.ui.grid > .ui.segment.column {\n  padding-top: @pageGridMargin;\n  padding-bottom: @pageGridMargin;\n}\n.ui.grid.segment {\n  margin: @margin;\n  border-radius: @borderRadius;\n}\n\n/* Table */\n.ui.basic.table.segment {\n  background: @background;\n  border: @border;\n  box-shadow: @boxShadow;\n}\n.ui[class*=\"very basic\"].table.segment {\n  padding: @padding;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n\n/*-------------------\n     Placeholder\n--------------------*/\n\n.ui.placeholder.segment {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  max-width: initial;\n  animation: none;\n  overflow: visible;\n  padding: @placeholderPadding;\n  min-height: @placeholderMinHeight;\n  background: @placeholderBackground;\n  border-color: @placeholderBorderColor;\n  box-shadow: @placeholderBoxShadow;\n}\n\n.ui.placeholder.segment .button,\n.ui.placeholder.segment textarea {\n  display: block;\n}\n.ui.placeholder.segment .field,\n.ui.placeholder.segment textarea,\n.ui.placeholder.segment > .ui.input,\n.ui.placeholder.segment .button {\n  max-width: @placeholderContentMaxWidth;\n  margin-left: auto;\n  margin-right: auto;\n}\n.ui.placeholder.segment .column .button,\n.ui.placeholder.segment .column .field,\n.ui.placeholder.segment .column textarea,\n.ui.placeholder.segment .column > .ui.input {\n  max-width: @placeholderContentMaxWidth;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ui.placeholder.segment > .inline  {\n  align-self: center;\n}\n.ui.placeholder.segment > .inline > .button {\n  display: inline-block;\n  width: auto;\n  margin: @placeholderContentInlineButtonMargin;\n}\n.ui.placeholder.segment > .inline > .button:last-child {\n  margin-right: 0px;\n}\n\n\n/*-------------------\n        Piled\n--------------------*/\n\n.ui.piled.segments,\n.ui.piled.segment {\n  margin: @piledMargin 0em;\n  box-shadow: @piledBoxShadow;\n  z-index: @piledZIndex;\n}\n.ui.piled.segment:first-child {\n  margin-top: 0em;\n}\n.ui.piled.segment:last-child {\n  margin-bottom: 0em;\n}\n.ui.piled.segments:after,\n.ui.piled.segments:before,\n.ui.piled.segment:after,\n.ui.piled.segment:before {\n  background-color: @highlightBackground;\n  visibility: visible;\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  width: 100%;\n  border: @piledBorder;\n  box-shadow: @piledBoxShadow;\n}\n.ui.piled.segments:before,\n.ui.piled.segment:before {\n  transform: rotate(-@piledDegrees);\n  top: 0;\n  z-index: -2;\n}\n.ui.piled.segments:after,\n.ui.piled.segment:after {\n  transform: rotate(@piledDegrees);\n  top: 0;\n  z-index: -1;\n}\n\n/* Piled Attached */\n.ui[class*=\"top attached\"].piled.segment {\n  margin-top: @piledMargin;\n  margin-bottom: 0em;\n}\n.ui.piled.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n.ui.piled.segment[class*=\"bottom attached\"] {\n  margin-top: 0em;\n  margin-bottom: @piledMargin;\n}\n.ui.piled.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n       Stacked\n--------------------*/\n\n.ui.stacked.segment {\n  padding-bottom: @stackedPadding;\n}\n.ui.stacked.segments:before,\n.ui.stacked.segments:after,\n.ui.stacked.segment:before,\n.ui.stacked.segment:after {\n  content: '';\n  position: absolute;\n  bottom: -(@stackedHeight / 2);\n  left: 0%;\n\n  border-top: 1px solid @borderColor;\n  background: @stackedPageBackground;\n\n  width: 100%;\n  height: @stackedHeight;\n  visibility: visible;\n}\n.ui.stacked.segments:before,\n.ui.stacked.segment:before {\n  display: none;\n}\n\n/* Add additional page */\n.ui.tall.stacked.segments:before,\n.ui.tall.stacked.segment:before {\n  display: block;\n  bottom: 0px;\n}\n\n/* Inverted */\n.ui.stacked.inverted.segments:before,\n.ui.stacked.inverted.segments:after,\n.ui.stacked.inverted.segment:before,\n.ui.stacked.inverted.segment:after {\n  background-color: @subtleTransparentBlack;\n  border-top: 1px solid @selectedBorderColor;\n}\n\n/*-------------------\n       Padded\n--------------------*/\n\n.ui.padded.segment {\n  padding: @paddedSegmentPadding;\n}\n\n.ui[class*=\"very padded\"].segment {\n  padding: @veryPaddedSegmentPadding;\n}\n\n/* Padded vertical */\n.ui.padded.segment.vertical.segment,\n.ui[class*=\"very padded\"].vertical.segment {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.segment {\n  display: table;\n}\n\n/* Compact Group */\n.ui.compact.segments {\n  display: inline-flex;\n}\n.ui.compact.segments .segment,\n.ui.segments .compact.segment {\n  display: block;\n  flex: 0 1 auto;\n}\n\n/*-------------------\n       Circular\n--------------------*/\n\n.ui.circular.segment {\n  display: table-cell;\n  padding: @circularPadding;\n  text-align: center;\n  vertical-align: middle;\n  border-radius: 500em;\n}\n\n/*-------------------\n       Raised\n--------------------*/\n\n.ui.raised.segments,\n.ui.raised.segment {\n  box-shadow: @raisedBoxShadow;\n}\n\n\n/*******************************\n            Groups\n*******************************/\n\n/* Group */\n.ui.segments {\n  flex-direction: column;\n  position: relative;\n  margin: @groupedMargin;\n  border: @groupedBorder;\n  box-shadow: @groupedBoxShadow;\n  border-radius: @groupedBorderRadius;\n}\n.ui.segments:first-child {\n  margin-top: 0em;\n}\n.ui.segments:last-child {\n  margin-bottom: 0em;\n}\n\n\n/* Nested Segment */\n.ui.segments > .segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: @groupedSegmentMargin;\n  width: @groupedSegmentWidth;\n  box-shadow: @groupedSegmentBoxShadow;\n  border: @groupedSegmentBorder;\n  border-top: @groupedSegmentDivider;\n}\n\n.ui.segments:not(.horizontal) > .segment:first-child {\n  top: @attachedTopOffset;\n  bottom: 0px;\n  border-top: none;\n  margin-top: 0em;\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: @attachedTopOffset;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n\n/* Bottom */\n.ui.segments:not(.horizontal) > .segment:last-child {\n  top: @attachedBottomOffset;\n  bottom: 0px;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  box-shadow: @attachedBottomBoxShadow;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n\n/* Only */\n.ui.segments:not(.horizontal) > .segment:only-child {\n  border-radius: @borderRadius;\n}\n\n\n/* Nested Group */\n.ui.segments > .ui.segments {\n  border-top: @groupedSegmentDivider;\n  margin: @nestedGroupMargin;\n}\n.ui.segments > .segments:first-child {\n  border-top: none;\n}\n.ui.segments > .segment + .segments:not(.horizontal) {\n  margin-top: 0em;\n}\n\n/* Horizontal Group */\n.ui.horizontal.segments {\n  display: flex;\n  flex-direction: row;\n  background-color: transparent;\n  border-radius: 0px;\n  padding: 0em;\n  background-color: @background;\n  box-shadow: @boxShadow;\n  margin: @margin;\n  border-radius: @borderRadius;\n  border: @border;\n}\n\n/* Nested Horizontal Group */\n.ui.segments > .horizontal.segments {\n  margin: 0em;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-top: @groupedSegmentDivider;\n}\n\n/* Horizontal Segment */\n.ui.horizontal.segments > .segment {\n  flex: 1 1 auto;\n  -ms-flex: 1 1 0px; /* Solves #2550 MS Flex */\n  margin: 0em;\n  min-width: 0px;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-left: @borderWidth solid @borderColor;\n}\n\n/* Border Fixes */\n.ui.segments > .horizontal.segments:first-child {\n  border-top: none;\n}\n.ui.horizontal.segments > .segment:first-child {\n  border-left: none;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n    Disabled\n---------------*/\n\n.ui.disabled.segment {\n  opacity: @disabledOpacity;\n  color: @disabledTextColor;\n}\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.segment {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n  text-shadow: none !important;\n  color: transparent !important;\n  transition: all 0s linear;\n}\n.ui.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: @loaderDimmerColor;\n  width: 100%;\n  height: 100%;\n  border-radius: @borderRadius;\n  z-index: @loaderDimmerZIndex;\n}\n.ui.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: segment-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor @loaderFillColor @loaderFillColor @loaderFillColor;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: @loaderLineZIndex;\n}\n\n@keyframes segment-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-------------------\n       Basic\n--------------------*/\n\n.ui.basic.segment {\n  background: @basicBackground;\n  box-shadow: @basicBoxShadow;\n  border: @basicBorder;\n  border-radius: @basicBorderRadius;\n}\n\n/*-------------------\n       Clearing\n--------------------*/\n\n.ui.clearing.segment:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n.ui.red.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @red !important;\n}\n.ui.inverted.red.segment {\n  background-color: @red !important;\n  color: @white !important;\n}\n\n/* Orange */\n.ui.orange.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @orange !important;\n}\n.ui.inverted.orange.segment {\n  background-color: @orange !important;\n  color: @white !important;\n}\n\n/* Yellow */\n.ui.yellow.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @yellow !important;\n}\n.ui.inverted.yellow.segment {\n  background-color: @yellow !important;\n  color: @white !important;\n}\n\n/* Olive */\n.ui.olive.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @olive !important;\n}\n.ui.inverted.olive.segment {\n  background-color: @olive !important;\n  color: @white !important;\n}\n\n/* Green */\n.ui.green.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @green !important;\n}\n.ui.inverted.green.segment {\n  background-color: @green !important;\n  color: @white !important;\n}\n\n/* Teal */\n.ui.teal.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @teal !important;\n}\n.ui.inverted.teal.segment {\n  background-color: @teal !important;\n  color: @white !important;\n}\n\n/* Blue */\n.ui.blue.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @blue !important;\n}\n.ui.inverted.blue.segment {\n  background-color: @blue !important;\n  color: @white !important;\n}\n\n/* Violet */\n.ui.violet.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @violet !important;\n}\n.ui.inverted.violet.segment {\n  background-color: @violet !important;\n  color: @white !important;\n}\n\n/* Purple */\n.ui.purple.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @purple !important;\n}\n.ui.inverted.purple.segment {\n  background-color: @purple !important;\n  color: @white !important;\n}\n\n/* Pink */\n.ui.pink.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @pink !important;\n}\n.ui.inverted.pink.segment {\n  background-color: @pink !important;\n  color: @white !important;\n}\n\n/* Brown */\n.ui.brown.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @brown !important;\n}\n.ui.inverted.brown.segment {\n  background-color: @brown !important;\n  color: @white !important;\n}\n\n/* Grey */\n.ui.grey.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @grey !important;\n}\n.ui.inverted.grey.segment {\n  background-color: @grey !important;\n  color: @white !important;\n}\n\n/* Black */\n.ui.black.segment:not(.inverted) {\n  border-top: @coloredBorderSize solid @black !important;\n}\n.ui.inverted.black.segment {\n  background-color: @black !important;\n  color: @white !important;\n}\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui[class*=\"left aligned\"].segment {\n  text-align: left;\n}\n.ui[class*=\"right aligned\"].segment {\n  text-align: right;\n}\n.ui[class*=\"center aligned\"].segment {\n  text-align: center;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.segment,\n.ui[class*=\"left floated\"].segment {\n  float: left;\n  margin-right: @floatedDistance;\n}\n.ui[class*=\"right floated\"].segment {\n  float: right;\n  margin-left: @floatedDistance;\n}\n\n\n/*-------------------\n      Inverted\n--------------------*/\n\n.ui.inverted.segment {\n  border: none;\n  box-shadow: none;\n}\n.ui.inverted.segment,\n.ui.primary.inverted.segment {\n  background: @invertedBackground;\n  color: @invertedTextColor;\n}\n\n/* Nested */\n.ui.inverted.segment .segment {\n  color: @textColor;\n}\n.ui.inverted.segment .inverted.segment {\n  color: @invertedTextColor;\n}\n\n/* Attached */\n.ui.inverted.attached.segment {\n  border-color: @solidWhiteBorderColor;\n}\n\n/*-------------------\n     Emphasis\n--------------------*/\n\n/* Secondary */\n.ui.secondary.segment {\n  background: @secondaryBackground;\n  color: @secondaryColor;\n}\n.ui.secondary.inverted.segment {\n  background: @secondaryInvertedBackground;\n  color: @secondaryInvertedColor;\n}\n\n/* Tertiary */\n.ui.tertiary.segment {\n  background: @tertiaryBackground;\n  color: @tertiaryColor;\n}\n.ui.tertiary.inverted.segment {\n  background: @tertiaryInvertedBackground;\n  color: @tertiaryInvertedColor;\n}\n\n\n/*-------------------\n      Attached\n--------------------*/\n\n/* Middle */\n.ui.attached.segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em @attachedHorizontalOffset;\n  width: @attachedWidth;\n  max-width: @attachedWidth;\n  box-shadow: @attachedBoxShadow;\n  border: @attachedBorder;\n}\n.ui.attached:not(.message) + .ui.attached.segment:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n.ui[class*=\"top attached\"].segment {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: @attachedTopOffset;\n  margin-top: @verticalMargin;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n.ui.segment[class*=\"bottom attached\"] {\n  bottom: 0px;\n  margin-top: 0em;\n  top: @attachedBottomOffset;\n  margin-bottom: @verticalMargin;\n  box-shadow: @attachedBottomBoxShadow;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n.ui.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n        Size\n--------------------*/\n\n.ui.mini.segments .segment,\n.ui.mini.segment {\n  font-size: @mini;\n}\n.ui.tiny.segments .segment,\n.ui.tiny.segment {\n  font-size: @tiny;\n}\n.ui.small.segments .segment,\n.ui.small.segment {\n  font-size: @small;\n}\n.ui.segments .segment,\n.ui.segment {\n  font-size: @medium;\n}\n.ui.large.segments .segment,\n.ui.large.segment {\n  font-size: @large;\n}\n.ui.big.segments .segment,\n.ui.big.segment {\n  font-size: @big;\n}\n.ui.huge.segments .segment,\n.ui.huge.segment {\n  font-size: @huge;\n}\n.ui.massive.segments .segment,\n.ui.massive.segment {\n  font-size: @massive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Step\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n             Step\n*******************************/\n\n/*--------------\n   Load Theme\n---------------*/\n\n@type    : 'element';\n@element : 'step';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Plural\n*******************************/\n\n.ui.steps {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: stretch;\n  margin: @stepMargin;\n  background: @stepsBackground;\n  box-shadow: @stepsBoxShadow;\n  line-height: @lineHeight;\n  border-radius: @stepsBorderRadius;\n  border: @stepsBorder;\n}\n\n/* First Steps */\n.ui.steps:first-child {\n  margin-top: 0em;\n}\n\n/* Last Steps */\n.ui.steps:last-child {\n  margin-bottom: 0em;\n}\n\n\n/*******************************\n           Singular\n*******************************/\n\n.ui.steps .step {\n  position: relative;\n  display: flex;\n  flex: 1 0 auto;\n  flex-wrap: wrap;\n  flex-direction: row;\n  vertical-align: middle;\n  align-items: center;\n  justify-content: @justifyContent;\n\n  margin: @verticalMargin @horizontalMargin;\n  padding: @verticalPadding @horizontalPadding;\n  background: @background;\n  color: @textColor;\n  box-shadow: @boxShadow;\n  border-radius: @borderRadius;\n  border: @border;\n  border-right: @divider;\n  transition: @transition;\n}\n\n/* Arrow */\n.ui.steps .step:after {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  content: '';\n  top: @arrowTopOffset;\n  right: @arrowRightOffset;\n  border: medium none;\n  background-color: @arrowBackgroundColor;\n  width: @arrowSize;\n  height: @arrowSize;\n\n  border-style: solid;\n  border-color: @borderColor;\n  border-width: @arrowBorderWidth;\n\n  transition: @transition;\n  transform: translateY(-50%) translateX(50%) rotate(-45deg);\n}\n\n/* First Step */\n.ui.steps .step:first-child {\n  padding-left: @horizontalPadding;\n  border-radius: @stepsBorderRadius 0em 0em @stepsBorderRadius;\n}\n\n/* Last Step */\n.ui.steps .step:last-child {\n  border-radius: 0em @stepsBorderRadius @stepsBorderRadius 0em;\n}\n.ui.steps .step:last-child {\n  border-right: none;\n  margin-right: 0em;\n}\n\n/* Only Step */\n.ui.steps .step:only-child {\n  border-radius: @stepsBorderRadius;\n}\n\n\n/*******************************\n            Content\n*******************************/\n\n/* Title */\n.ui.steps .step .title {\n  font-family: @titleFontFamily;\n  font-size: @titleFontSize;\n  font-weight: @titleFontWeight;\n}\n.ui.steps .step > .title {\n  width: 100%;\n}\n\n/* Description */\n.ui.steps .step .description {\n  font-weight: @descriptionFontWeight;\n  font-size: @descriptionFontSize;\n  color: @descriptionColor;\n}\n.ui.steps .step > .description {\n  width: 100%;\n}\n.ui.steps .step .title ~ .description {\n  margin-top: @descriptionDistance;\n}\n\n/* Icon */\n.ui.steps .step > .icon {\n  line-height: 1;\n  font-size: @iconSize;\n  margin: 0em @iconDistance 0em 0em;\n}\n.ui.steps .step > .icon,\n.ui.steps .step > .icon ~ .content {\n  display: block;\n  flex: 0 1 auto;\n  align-self: @iconAlign;\n}\n.ui.steps .step > .icon ~ .content {\n  flex-grow: 1 0 auto;\n}\n\n/* Horizontal Icon */\n.ui.steps:not(.vertical) .step > .icon {\n  width: auto;\n}\n\n/* Link */\n.ui.steps .link.step,\n.ui.steps a.step {\n  cursor: pointer;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n     Ordered\n---------------*/\n\n.ui.ordered.steps {\n  counter-reset: ordered;\n}\n.ui.ordered.steps .step:before {\n  display: block;\n  position: static;\n  text-align: center;\n  content: counters(ordered, \".\");\n  align-self: @iconAlign;\n  margin-right: @iconDistance;\n  font-size: @iconSize;\n  counter-increment: ordered;\n  font-family: @orderedFontFamily;\n  font-weight: @orderedFontWeight;\n}\n\n.ui.ordered.steps .step > * {\n  display: block;\n  align-self: @iconAlign;\n}\n\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.steps {\n  display: inline-flex;\n  flex-direction: column;\n  overflow: visible;\n}\n.ui.vertical.steps .step {\n  justify-content: flex-start;\n  border-radius: @borderRadius;\n  padding: @verticalPadding @horizontalPadding;\n  border-right: none;\n  border-bottom: @verticalDivider;\n}\n.ui.vertical.steps .step:first-child {\n  padding: @verticalPadding @horizontalPadding;\n  border-radius: @stepsBorderRadius @stepsBorderRadius 0em 0em;\n}\n.ui.vertical.steps .step:last-child {\n  border-bottom: none;\n  border-radius: 0em 0em @stepsBorderRadius @stepsBorderRadius;\n}\n.ui.vertical.steps .step:only-child {\n  border-radius: @stepsBorderRadius;\n}\n\n\n/* Arrow */\n.ui.vertical.steps .step:after {\n  display: none;\n}\n.ui.vertical.steps .step:after {\n  top: @verticalArrowTopOffset;\n  right: @verticalArrowRightOffset;\n  border-width: @verticalArrowBorderWidth;\n}\n\n.ui.vertical.steps .step:after {\n  display: @verticalArrowDisplay;\n}\n.ui.vertical.steps .active.step:after {\n  display: @verticalActiveArrowDisplay;\n}\n.ui.vertical.steps .step:last-child:after {\n  display: @verticalLastArrowDisplay;\n}\n.ui.vertical.steps .active.step:last-child:after {\n  display: @verticalActiveLastArrowDisplay;\n}\n\n\n/*---------------\n    Responsive\n----------------*/\n\n/* Mobile (Default) */\n@media only screen and (max-width: (@largestMobileScreen)) {\n\n  .ui.steps:not(.unstackable) {\n    display: inline-flex;\n    overflow: visible;\n    flex-direction: column;\n  }\n  .ui.steps:not(.unstackable) .step {\n    width: 100% !important;\n    flex-direction: column;\n    border-radius: @borderRadius;\n    padding: @verticalPadding @horizontalPadding;\n  }\n  .ui.steps:not(.unstackable) .step:first-child {\n    padding: @verticalPadding @horizontalPadding;\n    border-radius: @stepsBorderRadius @stepsBorderRadius 0em 0em;\n  }\n  .ui.steps:not(.unstackable) .step:last-child {\n    border-radius: 0em 0em @stepsBorderRadius @stepsBorderRadius;\n  }\n\n  /* Arrow */\n  .ui.steps:not(.unstackable) .step:after {\n    display: none !important;\n  }\n\n  /* Content */\n  .ui.steps:not(.unstackable) .step .content {\n    text-align: center;\n  }\n\n  /* Icon */\n  .ui.steps:not(.unstackable) .step > .icon,\n  .ui.ordered.steps:not(.unstackable) .step:before {\n    margin: 0em 0em @mobileIconDistance 0em;\n  }\n\n}\n\n/*******************************\n             States\n*******************************/\n\n/* Link Hover */\n.ui.steps .link.step:hover::after,\n.ui.steps .link.step:hover,\n.ui.steps a.step:hover::after,\n.ui.steps a.step:hover {\n  background: @hoverBackground;\n  color: @hoverColor;\n}\n\n/* Link Down */\n.ui.steps .link.step:active::after,\n.ui.steps .link.step:active,\n.ui.steps a.step:active::after,\n.ui.steps a.step:active {\n  background: @downBackground;\n  color: @downColor;\n}\n\n/* Active */\n.ui.steps .step.active {\n  cursor: auto;\n  background: @activeBackground;\n}\n.ui.steps .step.active:after {\n  background: @activeBackground;\n}\n.ui.steps .step.active .title {\n  color: @activeColor;\n}\n.ui.ordered.steps .step.active:before,\n.ui.steps .active.step .icon {\n  color: @activeIconColor;\n}\n\n/* Active Arrow */\n.ui.steps .step:after {\n  display: @arrowDisplay;\n}\n.ui.steps .active.step:after {\n  display: @activeArrowDisplay;\n}\n.ui.steps .step:last-child:after {\n  display: @lastArrowDisplay;\n}\n.ui.steps .active.step:last-child:after {\n  display: @activeLastArrowDisplay;\n}\n\n/* Active Hover */\n.ui.steps .link.active.step:hover::after,\n.ui.steps .link.active.step:hover,\n.ui.steps a.active.step:hover::after,\n.ui.steps a.active.step:hover {\n  cursor: pointer;\n  background: @activeHoverBackground;\n  color: @activeHoverColor;\n}\n\n/* Completed */\n.ui.steps .step.completed > .icon:before,\n.ui.ordered.steps .step.completed:before {\n  color: @completedColor;\n}\n\n/* Disabled */\n.ui.steps .disabled.step {\n  cursor: auto;\n  background: @disabledBackground;\n  pointer-events: none;\n}\n.ui.steps .disabled.step,\n.ui.steps .disabled.step .title,\n.ui.steps .disabled.step .description {\n  color: @disabledColor;\n}\n.ui.steps .disabled.step:after {\n  background: @disabledBackground;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*--------------\n   Stackable\n---------------*/\n\n/* Tablet Or Below */\n@media only screen and (max-width: @largestTabletScreen) {\n\n.ui[class*=\"tablet stackable\"].steps {\n  display: inline-flex;\n  overflow: visible;\n  flex-direction: column;\n}\n\n/* Steps */\n.ui[class*=\"tablet stackable\"].steps .step {\n  flex-direction: column;\n  border-radius: @borderRadius;\n  padding: @verticalPadding @horizontalPadding;\n}\n.ui[class*=\"tablet stackable\"].steps .step:first-child {\n  padding: @verticalPadding @horizontalPadding;\n  border-radius: @stepsBorderRadius @stepsBorderRadius 0em 0em;\n}\n.ui[class*=\"tablet stackable\"].steps .step:last-child {\n  border-radius: 0em 0em @stepsBorderRadius @stepsBorderRadius;\n}\n\n/* Arrow */\n.ui[class*=\"tablet stackable\"].steps .step:after {\n  display: none !important;\n}\n\n/* Content */\n.ui[class*=\"tablet stackable\"].steps .step .content {\n  text-align: center;\n}\n\n/* Icon */\n.ui[class*=\"tablet stackable\"].steps .step > .icon,\n.ui[class*=\"tablet stackable\"].ordered.steps .step:before {\n  margin: 0em 0em @mobileIconDistance 0em;\n}\n\n}\n\n/*--------------\n      Fluid\n---------------*/\n\n/* Fluid */\n.ui.fluid.steps {\n  display: flex;\n  width: 100%;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n/* Top */\n.ui.attached.steps {\n  width: @attachedWidth !important;\n  margin: 0em @attachedHorizontalOffset @attachedVerticalOffset;\n  max-width: @attachedWidth;\n  border-radius: @stepsBorderRadius @stepsBorderRadius 0em 0em;\n}\n.ui.attached.steps .step:first-child {\n  border-radius: @stepsBorderRadius 0em 0em 0em;\n}\n.ui.attached.steps .step:last-child {\n  border-radius: 0em @stepsBorderRadius 0em 0em;\n}\n\n/* Bottom */\n.ui.bottom.attached.steps {\n  margin: @attachedVerticalOffset @attachedHorizontalOffset 0em;\n  border-radius: 0em 0em @stepsBorderRadius @stepsBorderRadius;\n}\n.ui.bottom.attached.steps .step:first-child {\n  border-radius: 0em 0em 0em @stepsBorderRadius;\n}\n.ui.bottom.attached.steps .step:last-child {\n  border-radius: 0em 0em @stepsBorderRadius 0em;\n}\n\n/*-------------------\n    Evenly Divided\n--------------------*/\n\n.ui.one.steps,\n.ui.two.steps,\n.ui.three.steps,\n.ui.four.steps,\n.ui.five.steps,\n.ui.six.steps,\n.ui.seven.steps,\n.ui.eight.steps {\n  width: 100%;\n}\n.ui.one.steps > .step,\n.ui.two.steps > .step,\n.ui.three.steps > .step,\n.ui.four.steps > .step,\n.ui.five.steps > .step,\n.ui.six.steps > .step,\n.ui.seven.steps > .step,\n.ui.eight.steps > .step {\n  flex-wrap: nowrap;\n}\n.ui.one.steps > .step {\n  width: 100%;\n}\n.ui.two.steps > .step {\n  width: 50%;\n}\n.ui.three.steps > .step {\n  width: 33.333%;\n}\n.ui.four.steps > .step {\n  width: 25%;\n}\n.ui.five.steps > .step {\n  width: 20%;\n}\n.ui.six.steps > .step {\n  width: 16.666%;\n}\n.ui.seven.steps > .step {\n  width: 14.285%;\n}\n.ui.eight.steps > .step {\n  width: 12.500%;\n}\n\n/*-------------------\n       Sizes\n--------------------*/\n\n\n.ui.mini.steps .step,\n.ui.mini.step {\n  font-size: @mini;\n}\n.ui.tiny.steps .step,\n.ui.tiny.step {\n  font-size: @tiny;\n}\n.ui.small.steps .step,\n.ui.small.step {\n  font-size: @small;\n}\n.ui.steps .step,\n.ui.step {\n  font-size: @medium;\n}\n.ui.large.steps .step,\n.ui.large.step {\n  font-size: @large;\n}\n.ui.big.steps .step,\n.ui.big.step {\n  font-size: @big;\n}\n.ui.huge.steps .step,\n.ui.huge.step {\n  font-size: @huge;\n}\n.ui.massive.steps .step,\n.ui.massive.step {\n  font-size: @massive;\n}\n\n\n.loadUIOverrides();\n","/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Step';\n  src:\n    url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'),\n    url(data:application/font-woff;charset=utf-8;base64,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) format('woff')\n  ;\n}\n.ui.steps .step.completed > .icon:before,\n.ui.ordered.steps .step.completed:before {\n  font-family: 'Step';\n  content: '\\e800'; /* '' */\n}","/*!\n * # Semantic UI - Breadcrumb\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'breadcrumb';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n           Breadcrumb\n*******************************/\n\n.ui.breadcrumb {\n  line-height: 1;\n  display: @display;\n  margin: @verticalMargin 0em;\n  vertical-align: @verticalAlign;\n}\n.ui.breadcrumb:first-child {\n  margin-top: 0em;\n}\n.ui.breadcrumb:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n          Content\n*******************************/\n\n/* Divider */\n.ui.breadcrumb .divider {\n  display: inline-block;\n  opacity: @dividerOpacity;\n  margin: 0em @dividerSpacing 0em;\n\n  font-size: @dividerSize;\n  color: @dividerColor;\n  vertical-align: @dividerVerticalAlign;\n}\n\n/* Link */\n.ui.breadcrumb a {\n  color: @linkColor;\n}\n.ui.breadcrumb a:hover {\n  color: @linkHoverColor;\n}\n\n\n/* Icon Divider */\n.ui.breadcrumb .icon.divider {\n  font-size: @iconDividerSize;\n  vertical-align: @iconDividerVerticalAlign;\n}\n\n/* Section */\n.ui.breadcrumb a.section {\n  cursor: pointer;\n}\n.ui.breadcrumb .section {\n  display: inline-block;\n  margin: @sectionMargin;\n  padding: @sectionPadding;\n}\n\n/* Loose Coupling */\n.ui.breadcrumb.segment {\n  display: inline-block;\n  padding: @segmentPadding;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.breadcrumb .active.section {\n  font-weight: @activeFontWeight;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n.ui.mini.breadcrumb {\n  font-size: @mini;\n}\n.ui.tiny.breadcrumb {\n  font-size: @tiny;\n}\n.ui.small.breadcrumb {\n  font-size: @small;\n}\n.ui.breadcrumb {\n  font-size: @medium;\n}\n.ui.large.breadcrumb {\n  font-size: @large;\n}\n.ui.big.breadcrumb {\n  font-size: @big;\n}\n.ui.huge.breadcrumb {\n  font-size: @huge;\n}\n.ui.massive.breadcrumb {\n  font-size: @massive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Form\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'form';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Elements\n*******************************/\n\n/*--------------------\n        Form\n---------------------*/\n\n.ui.form {\n  position: relative;\n  max-width: 100%;\n}\n\n/*--------------------\n        Content\n---------------------*/\n\n.ui.form > p {\n  margin: @paragraphMargin;\n}\n\n/*--------------------\n        Field\n---------------------*/\n\n.ui.form .field {\n  clear: both;\n  margin: @fieldMargin;\n}\n\n.ui.form .field:last-child,\n.ui.form .fields:last-child .field {\n  margin-bottom: 0em;\n}\n\n.ui.form .fields .field {\n  clear: both;\n  margin: 0em;\n}\n\n\n/*--------------------\n        Labels\n---------------------*/\n\n.ui.form .field > label {\n  display: block;\n  margin: @labelMargin;\n  color: @labelColor;\n  font-size: @labelFontSize;\n  font-weight: @labelFontWeight;\n  text-transform: @labelTextTransform;\n}\n\n/*--------------------\n    Standard Inputs\n---------------------*/\n\n\n.ui.form textarea,\n.ui.form input:not([type]),\n.ui.form input[type=\"date\"],\n.ui.form input[type=\"datetime-local\"],\n.ui.form input[type=\"email\"],\n.ui.form input[type=\"number\"],\n.ui.form input[type=\"password\"],\n.ui.form input[type=\"search\"],\n.ui.form input[type=\"tel\"],\n.ui.form input[type=\"time\"],\n.ui.form input[type=\"text\"],\n.ui.form input[type=\"file\"],\n.ui.form input[type=\"url\"] {\n  width: @inputWidth;\n  vertical-align: top;\n}\n\n/* Set max height on unusual input */\n.ui.form ::-webkit-datetime-edit,\n.ui.form ::-webkit-inner-spin-button {\n  height: @inputLineHeight;\n}\n\n.ui.form input:not([type]),\n.ui.form input[type=\"date\"],\n.ui.form input[type=\"datetime-local\"],\n.ui.form input[type=\"email\"],\n.ui.form input[type=\"number\"],\n.ui.form input[type=\"password\"],\n.ui.form input[type=\"search\"],\n.ui.form input[type=\"tel\"],\n.ui.form input[type=\"time\"],\n.ui.form input[type=\"text\"],\n.ui.form input[type=\"file\"],\n.ui.form input[type=\"url\"] {\n  font-family: @inputFont;\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  tap-highlight-color:  rgba(255, 255, 255, 0);\n\n  line-height: @inputLineHeight;\n  padding: @inputPadding;\n  font-size: @inputFontSize;\n\n  background: @inputBackground;\n  border: @inputBorder;\n  color: @inputColor;\n  border-radius: @inputBorderRadius;\n  box-shadow: @inputBoxShadow;\n  transition: @inputTransition;\n}\n\n/* Text Area */\n.ui.form textarea {\n  margin: 0em;\n  -webkit-appearance: none;\n  tap-highlight-color:  rgba(255, 255, 255, 0);\n\n  padding: @textAreaPadding;\n  font-size: @textAreaFontSize;\n  background: @textAreaBackground;\n  border: @textAreaBorder;\n  outline: none;\n  color: @inputColor;\n  border-radius: @inputBorderRadius;\n  box-shadow: @inputBoxShadow;\n  transition: @textAreaTransition;\n  font-size: @textAreaFontSize;\n  line-height: @textAreaLineHeight;\n  resize: @textAreaResize;\n}\n.ui.form textarea:not([rows]) {\n  height: @textAreaHeight;\n  min-height: @textAreaMinHeight;\n  max-height: @textAreaMaxHeight;\n}\n\n.ui.form textarea,\n.ui.form input[type=\"checkbox\"] {\n  vertical-align: @checkboxVerticalAlign;\n}\n\n/*--------------------------\n  Input w/ attached Button\n---------------------------*/\n\n.ui.form input.attached {\n  width: auto;\n}\n\n\n/*--------------------\n     Basic Select\n---------------------*/\n\n.ui.form select {\n  display: block;\n  height: auto;\n  width: 100%;\n  background: @selectBackground;\n  border: @selectBorder;\n  border-radius: @selectBorderRadius;\n  box-shadow: @selectBoxShadow;\n  padding: @selectPadding;\n  color: @selectColor;\n  transition: @selectTransition;\n}\n\n/*--------------------\n       Dropdown\n---------------------*/\n\n/* Block */\n.ui.form .field > .selection.dropdown {\n  width: 100%;\n}\n.ui.form .field > .selection.dropdown > .dropdown.icon {\n  float: right;\n}\n\n/* Inline */\n.ui.form .inline.fields .field > .selection.dropdown,\n.ui.form .inline.field > .selection.dropdown {\n  width: auto;\n}\n.ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon,\n.ui.form .inline.field > .selection.dropdown > .dropdown.icon {\n  float: none;\n}\n\n/*--------------------\n       UI Input\n---------------------*/\n\n/* Block */\n.ui.form .field .ui.input,\n.ui.form .fields .field .ui.input,\n.ui.form .wide.field .ui.input {\n  width: 100%;\n}\n\n/* Inline  */\n.ui.form .inline.fields .field:not(.wide) .ui.input,\n.ui.form .inline.field:not(.wide) .ui.input {\n  width: auto;\n  vertical-align: middle;\n}\n\n/* Auto Input */\n.ui.form .fields .field .ui.input input,\n.ui.form .field .ui.input input {\n  width: auto;\n}\n\n/* Full Width Input */\n.ui.form .ten.fields .ui.input input,\n.ui.form .nine.fields .ui.input input,\n.ui.form .eight.fields .ui.input input,\n.ui.form .seven.fields .ui.input input,\n.ui.form .six.fields .ui.input input,\n.ui.form .five.fields .ui.input input,\n.ui.form .four.fields .ui.input input,\n.ui.form .three.fields .ui.input input,\n.ui.form .two.fields .ui.input input,\n.ui.form .wide.field .ui.input input {\n  flex: 1 0 auto;\n  width: 0px;\n}\n\n\n/*--------------------\n   Types of Messages\n---------------------*/\n\n.ui.form .success.message,\n.ui.form .warning.message,\n.ui.form .error.message {\n  display: none;\n}\n\n/* Assumptions */\n.ui.form .message:first-child {\n  margin-top: 0px;\n}\n\n/*--------------------\n   Validation Prompt\n---------------------*/\n\n.ui.form .field .prompt.label {\n  white-space: normal;\n  background: @promptBackground !important;\n  border: @promptBorder !important;\n  color: @promptTextColor !important;\n}\n.ui.form .inline.fields .field .prompt,\n.ui.form .inline.field .prompt {\n  vertical-align: top;\n  margin: @inlinePromptMargin;\n}\n.ui.form .inline.fields .field .prompt:before,\n.ui.form .inline.field .prompt:before {\n  border-width: 0px 0px @inlinePromptBorderWidth @inlinePromptBorderWidth;\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n      Autofilled\n---------------------*/\n\n.ui.form .field.field input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px @inputAutoFillBackground inset !important;\n  border-color: @inputAutoFillBorder !important;\n}\n\n/* Focus */\n.ui.form .field.field input:-webkit-autofill:focus {\n  box-shadow: 0px 0px 0px 100px @inputAutoFillFocusBackground inset !important;\n  border-color: @inputAutoFillFocusBorder !important;\n}\n\n/* Error */\n.ui.form .error.error input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px @inputAutoFillErrorBackground inset !important;\n  border-color: @inputAutoFillErrorBorder !important;\n}\n\n\n\n/*--------------------\n      Placeholder\n---------------------*/\n\n/* browsers require these rules separate */\n.ui.form ::-webkit-input-placeholder {\n  color: @inputPlaceholderColor;\n}\n.ui.form :-ms-input-placeholder {\n  color: @inputPlaceholderColor !important;\n}\n.ui.form ::-moz-placeholder {\n  color: @inputPlaceholderColor;\n}\n\n.ui.form :focus::-webkit-input-placeholder {\n  color: @inputPlaceholderFocusColor;\n}\n.ui.form :focus:-ms-input-placeholder {\n  color: @inputPlaceholderFocusColor !important;\n}\n.ui.form :focus::-moz-placeholder {\n  color: @inputPlaceholderFocusColor;\n}\n\n/* Error Placeholder */\n.ui.form .error ::-webkit-input-placeholder {\n  color: @inputErrorPlaceholderColor;\n}\n.ui.form .error :-ms-input-placeholder {\n  color: @inputErrorPlaceholderColor !important;\n}\n.ui.form .error ::-moz-placeholder {\n  color: @inputErrorPlaceholderColor;\n}\n\n.ui.form .error :focus::-webkit-input-placeholder {\n  color: @inputErrorPlaceholderFocusColor;\n}\n.ui.form .error :focus:-ms-input-placeholder {\n  color: @inputErrorPlaceholderFocusColor !important;\n}\n.ui.form .error :focus::-moz-placeholder {\n  color: @inputErrorPlaceholderFocusColor;\n}\n\n\n/*--------------------\n        Focus\n---------------------*/\n\n.ui.form input:not([type]):focus,\n.ui.form input[type=\"date\"]:focus,\n.ui.form input[type=\"datetime-local\"]:focus,\n.ui.form input[type=\"email\"]:focus,\n.ui.form input[type=\"number\"]:focus,\n.ui.form input[type=\"password\"]:focus,\n.ui.form input[type=\"search\"]:focus,\n.ui.form input[type=\"tel\"]:focus,\n.ui.form input[type=\"time\"]:focus,\n.ui.form input[type=\"text\"]:focus,\n.ui.form input[type=\"file\"]:focus,\n.ui.form input[type=\"url\"]:focus {\n  color: @inputFocusColor;\n  border-color: @inputFocusBorderColor;\n  border-radius: @inputFocusBorderRadius;\n  background: @inputFocusBackground;\n  box-shadow: @inputFocusBoxShadow;\n}\n.ui.form textarea:focus {\n  color: @textAreaFocusColor;\n  border-color: @textAreaFocusBorderColor;\n  border-radius: @textAreaFocusBorderRadius;\n  background: @textAreaFocusBackground;\n  box-shadow: @textAreaFocusBoxShadow;\n  -webkit-appearance: none;\n}\n\n\n/*--------------------\n        Success\n---------------------*/\n\n/* On Form */\n.ui.form.success .success.message:not(:empty) {\n  display: block;\n}\n.ui.form.success .compact.success.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.success .icon.success.message:not(:empty) {\n  display: flex;\n}\n\n/*--------------------\n        Warning\n---------------------*/\n\n/* On Form */\n.ui.form.warning .warning.message:not(:empty) {\n  display: block;\n}\n.ui.form.warning .compact.warning.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.warning .icon.warning.message:not(:empty) {\n  display: flex;\n}\n\n/*--------------------\n        Error\n---------------------*/\n\n/* On Form */\n.ui.form.error .error.message:not(:empty) {\n  display: block;\n}\n.ui.form.error .compact.error.message:not(:empty) {\n  display: inline-block;\n}\n.ui.form.error .icon.error.message:not(:empty) {\n  display: flex;\n}\n\n/* On Field(s) */\n.ui.form .fields.error .field label,\n.ui.form .field.error label,\n.ui.form .fields.error .field .input,\n.ui.form .field.error .input {\n  color: @formErrorColor;\n}\n\n.ui.form .fields.error .field .corner.label,\n.ui.form .field.error .corner.label {\n  border-color: @formErrorColor;\n  color: @white;\n}\n\n.ui.form .fields.error .field textarea,\n.ui.form .fields.error .field select,\n.ui.form .fields.error .field input:not([type]),\n.ui.form .fields.error .field input[type=\"date\"],\n.ui.form .fields.error .field input[type=\"datetime-local\"],\n.ui.form .fields.error .field input[type=\"email\"],\n.ui.form .fields.error .field input[type=\"number\"],\n.ui.form .fields.error .field input[type=\"password\"],\n.ui.form .fields.error .field input[type=\"search\"],\n.ui.form .fields.error .field input[type=\"tel\"],\n.ui.form .fields.error .field input[type=\"time\"],\n.ui.form .fields.error .field input[type=\"text\"],\n.ui.form .fields.error .field input[type=\"file\"],\n.ui.form .fields.error .field input[type=\"url\"],\n.ui.form .field.error textarea,\n.ui.form .field.error select,\n.ui.form .field.error input:not([type]),\n.ui.form .field.error input[type=\"date\"],\n.ui.form .field.error input[type=\"datetime-local\"],\n.ui.form .field.error input[type=\"email\"],\n.ui.form .field.error input[type=\"number\"],\n.ui.form .field.error input[type=\"password\"],\n.ui.form .field.error input[type=\"search\"],\n.ui.form .field.error input[type=\"tel\"],\n.ui.form .field.error input[type=\"time\"],\n.ui.form .field.error input[type=\"text\"],\n.ui.form .field.error input[type=\"file\"],\n.ui.form .field.error input[type=\"url\"] {\n  background: @formErrorBackground;\n  border-color: @formErrorBorder;\n  color: @formErrorColor;\n  border-radius: @inputErrorBorderRadius;\n  box-shadow: @inputErrorBoxShadow;\n}\n.ui.form .field.error textarea:focus,\n.ui.form .field.error select:focus,\n.ui.form .field.error input:not([type]):focus,\n.ui.form .field.error input[type=\"date\"]:focus,\n.ui.form .field.error input[type=\"datetime-local\"]:focus,\n.ui.form .field.error input[type=\"email\"]:focus,\n.ui.form .field.error input[type=\"number\"]:focus,\n.ui.form .field.error input[type=\"password\"]:focus,\n.ui.form .field.error input[type=\"search\"]:focus,\n.ui.form .field.error input[type=\"tel\"]:focus,\n.ui.form .field.error input[type=\"time\"]:focus,\n.ui.form .field.error input[type=\"text\"]:focus,\n.ui.form .field.error input[type=\"file\"]:focus,\n.ui.form .field.error input[type=\"url\"]:focus {\n  background: @inputErrorFocusBackground;\n  border-color: @inputErrorFocusBorder;\n  color: @inputErrorFocusColor;\n\n  -webkit-appearance: none;\n  box-shadow: @inputErrorFocusBoxShadow;\n}\n\n/* Preserve Native Select Stylings */\n.ui.form .field.error select {\n  -webkit-appearance: menulist-button;\n}\n\n/*------------------\n    Dropdown Error\n--------------------*/\n\n.ui.form .fields.error .field .ui.dropdown,\n.ui.form .fields.error .field .ui.dropdown .item,\n.ui.form .field.error .ui.dropdown,\n.ui.form .field.error .ui.dropdown .text,\n.ui.form .field.error .ui.dropdown .item {\n  background: @formErrorBackground;\n  color: @formErrorColor;\n}\n.ui.form .fields.error .field .ui.dropdown,\n.ui.form .field.error .ui.dropdown {\n  border-color: @formErrorBorder !important;\n}\n.ui.form .fields.error .field .ui.dropdown:hover,\n.ui.form .field.error .ui.dropdown:hover {\n  border-color: @formErrorBorder !important;\n}\n.ui.form .fields.error .field .ui.dropdown:hover .menu,\n.ui.form .field.error .ui.dropdown:hover .menu {\n  border-color: @formErrorBorder;\n}\n.ui.form .fields.error .field .ui.multiple.selection.dropdown > .label,\n.ui.form .field.error .ui.multiple.selection.dropdown > .label {\n  background-color: @dropdownErrorLabelBackground;\n  color: @dropdownErrorLabelColor;\n}\n\n/* Hover */\n.ui.form .fields.error .field .ui.dropdown .menu .item:hover,\n.ui.form .field.error .ui.dropdown .menu .item:hover {\n  background-color: @dropdownErrorHoverBackground;\n}\n\n/* Selected */\n.ui.form .fields.error .field .ui.dropdown .menu .selected.item,\n.ui.form .field.error .ui.dropdown .menu .selected.item {\n  background-color: @dropdownErrorSelectedBackground;\n}\n\n\n/* Active */\n.ui.form .fields.error .field .ui.dropdown .menu .active.item,\n.ui.form .field.error .ui.dropdown .menu .active.item {\n  background-color: @dropdownErrorActiveBackground !important;\n}\n\n/*--------------------\n    Checkbox Error\n---------------------*/\n\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) label,\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {\n  color: @formErrorColor;\n}\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before,\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before,\n.ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {\n  background: @formErrorBackground;\n  border-color: @formErrorBorder;\n}\n.ui.form .fields.error .field .checkbox label:after,\n.ui.form .field.error .checkbox label:after,\n.ui.form .fields.error .field .checkbox .box:after,\n.ui.form .field.error .checkbox .box:after {\n  color: @formErrorColor;\n}\n\n/*--------------------\n       Disabled\n---------------------*/\n\n.ui.form .disabled.fields .field,\n.ui.form .disabled.field,\n.ui.form .field :disabled {\n  pointer-events: none;\n  opacity: @disabledOpacity;\n}\n.ui.form .field.disabled > label,\n.ui.form .fields.disabled > label {\n  opacity: @disabledLabelOpacity;\n}\n.ui.form .field.disabled :disabled {\n  opacity: 1;\n}\n\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.form {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n}\n.ui.loading.form:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: @loaderDimmerColor;\n  width: 100%;\n  height: 100%;\n  z-index: @loaderDimmerZIndex;\n}\n.ui.loading.form:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: form-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor @loaderFillColor @loaderFillColor @loaderFillColor;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: @loaderLineZIndex;\n}\n\n@keyframes form-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*******************************\n         Element Types\n*******************************/\n\n/*--------------------\n     Required Field\n---------------------*/\n\n.ui.form .required.fields:not(.grouped) > .field > label:after,\n.ui.form .required.fields.grouped > label:after,\n.ui.form .required.field > label:after,\n.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n.ui.form .required.field > .checkbox:after {\n  margin: @requiredMargin;\n  content: @requiredContent;\n  color: @requiredColor;\n}\n\n.ui.form .required.fields:not(.grouped) > .field > label:after,\n.ui.form .required.fields.grouped > label:after,\n.ui.form .required.field > label:after {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n.ui.form .required.field > .checkbox:after {\n  position: absolute;\n  top: 0%;\n  left: 100%;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*--------------------\n    Inverted Colors\n---------------------*/\n\n.ui.inverted.form label,\n.ui.form .inverted.segment label,\n.ui.form .inverted.segment .ui.checkbox label,\n.ui.form .inverted.segment .ui.checkbox .box,\n.ui.inverted.form .ui.checkbox label,\n.ui.inverted.form .ui.checkbox .box,\n.ui.inverted.form .inline.fields > label,\n.ui.inverted.form .inline.fields .field > label,\n.ui.inverted.form .inline.fields .field > p,\n.ui.inverted.form .inline.field > label,\n.ui.inverted.form .inline.field > p {\n  color: @invertedLabelColor;\n}\n\n/* Inverted Field */\n.ui.inverted.form input:not([type]),\n.ui.inverted.form input[type=\"date\"],\n.ui.inverted.form input[type=\"datetime-local\"],\n.ui.inverted.form input[type=\"email\"],\n.ui.inverted.form input[type=\"number\"],\n.ui.inverted.form input[type=\"password\"],\n.ui.inverted.form input[type=\"search\"],\n.ui.inverted.form input[type=\"tel\"],\n.ui.inverted.form input[type=\"time\"],\n.ui.inverted.form input[type=\"text\"],\n.ui.inverted.form input[type=\"file\"],\n.ui.inverted.form input[type=\"url\"] {\n  background: @invertedInputBackground;\n  border-color: @invertedInputBorderColor;\n  color: @invertedInputColor;\n  box-shadow: @invertedInputBoxShadow;\n}\n\n\n/*--------------------\n     Field Groups\n---------------------*/\n\n/* Grouped Vertically */\n.ui.form .grouped.fields {\n  display: block;\n  margin: @groupedMargin;\n}\n.ui.form .grouped.fields:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.form .grouped.fields > label {\n  margin: @groupedLabelMargin;\n  color: @groupedLabelColor;\n  font-size: @groupedLabelFontSize;\n  font-weight: @groupedLabelFontWeight;\n  text-transform: @groupedLabelTextTransform;\n}\n\n.ui.form .grouped.fields .field,\n.ui.form .grouped.inline.fields .field {\n  display: block;\n  margin: @groupedFieldMargin;\n  padding: 0em;\n}\n\n/*--------------------\n        Fields\n---------------------*/\n\n/* Split fields */\n.ui.form .fields {\n  display: flex;\n  flex-direction: row;\n  margin: @fieldsMargin;\n}\n.ui.form .fields > .field {\n  flex: 0 1 auto;\n  padding-left: (@gutterWidth / 2);\n  padding-right: (@gutterWidth / 2);\n}\n.ui.form .fields > .field:first-child {\n  border-left: none;\n  box-shadow: none;\n}\n\n/* Other Combinations */\n.ui.form .two.fields > .fields,\n.ui.form .two.fields > .field {\n  width: @twoColumn;\n}\n.ui.form .three.fields > .fields,\n.ui.form .three.fields > .field {\n  width: @threeColumn;\n}\n.ui.form .four.fields > .fields,\n.ui.form .four.fields > .field {\n  width: @fourColumn;\n}\n.ui.form .five.fields > .fields,\n.ui.form .five.fields > .field {\n  width: @fiveColumn;\n}\n.ui.form .six.fields > .fields,\n.ui.form .six.fields > .field {\n  width: @sixColumn;\n}\n.ui.form .seven.fields > .fields,\n.ui.form .seven.fields > .field {\n  width: @sevenColumn;\n}\n.ui.form .eight.fields > .fields,\n.ui.form .eight.fields > .field {\n  width: @eightColumn;\n}\n.ui.form .nine.fields > .fields,\n.ui.form .nine.fields > .field {\n  width: @nineColumn;\n}\n.ui.form .ten.fields > .fields,\n.ui.form .ten.fields > .field {\n  width: @tenColumn;\n}\n\n/* Swap to full width on mobile */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.form .fields {\n    flex-wrap: wrap;\n  }\n\n  .ui[class*=\"equal width\"].form:not(.unstackable) .fields > .field,\n  .ui.form:not(.unstackable) [class*=\"equal width\"].fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {\n    width: @oneColumn !important;\n    margin: 0em 0em @rowDistance;\n  }\n}\n\n\n/* Sizing Combinations */\n.ui.form .fields .wide.field {\n  width: @oneWide;\n  padding-left: (@gutterWidth / 2);\n  padding-right: (@gutterWidth / 2);\n}\n\n.ui.form .one.wide.field {\n  width: @oneWide !important;\n}\n.ui.form .two.wide.field {\n  width: @twoWide !important;\n}\n.ui.form .three.wide.field {\n  width: @threeWide !important;\n}\n.ui.form .four.wide.field {\n  width: @fourWide !important;\n}\n.ui.form .five.wide.field {\n  width: @fiveWide !important;\n}\n.ui.form .six.wide.field {\n  width: @sixWide !important;\n}\n.ui.form .seven.wide.field {\n  width: @sevenWide !important;\n}\n.ui.form .eight.wide.field {\n  width: @eightWide !important;\n}\n.ui.form .nine.wide.field {\n  width: @nineWide !important;\n}\n.ui.form .ten.wide.field {\n  width: @tenWide !important;\n}\n.ui.form .eleven.wide.field {\n  width: @elevenWide !important;\n}\n.ui.form .twelve.wide.field {\n  width: @twelveWide !important;\n}\n.ui.form .thirteen.wide.field {\n  width: @thirteenWide !important;\n}\n.ui.form .fourteen.wide.field {\n  width: @fourteenWide !important;\n}\n.ui.form .fifteen.wide.field {\n  width: @fifteenWide !important;\n}\n.ui.form .sixteen.wide.field {\n  width: @sixteenWide !important;\n}\n\n/* Swap to full width on mobile */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n  .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field,\n  .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {\n    width: @oneColumn !important;\n  }\n  .ui.form .fields {\n    margin-bottom: 0em;\n  }\n}\n\n/*--------------------\n     Equal Width\n---------------------*/\n\n.ui[class*=\"equal width\"].form .fields > .field,\n.ui.form [class*=\"equal width\"].fields > .field {\n  width: 100%;\n  flex: 1 1 auto;\n}\n\n/*--------------------\n    Inline Fields\n---------------------*/\n\n.ui.form .inline.fields {\n  margin: @fieldMargin;\n  align-items: center;\n}\n.ui.form .inline.fields .field {\n  margin: 0em;\n  padding: @inlineFieldsMargin;\n}\n\n/* Inline Label */\n.ui.form .inline.fields > label,\n.ui.form .inline.fields .field > label,\n.ui.form .inline.fields .field > p,\n.ui.form .inline.field > label,\n.ui.form .inline.field > p {\n  display: inline-block;\n  width: auto;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  vertical-align: baseline;\n  font-size: @inlineLabelFontSize;\n  font-weight: @inlineLabelFontWeight;\n  color: @inlineLabelColor;\n  text-transform: @inlineLabelTextTransform;\n}\n\n/* Grouped Inline Label */\n.ui.form .inline.fields > label {\n  margin: @groupedInlineLabelMargin;\n}\n\n/* Inline Input */\n.ui.form .inline.fields .field > input,\n.ui.form .inline.fields .field > select,\n.ui.form .inline.field > input,\n.ui.form .inline.field > select {\n  display: inline-block;\n  width: auto;\n\n  margin-top: 0em;\n  margin-bottom: 0em;\n\n  vertical-align: middle;\n  font-size: @inlineInputSize;\n}\n\n/* Label */\n.ui.form .inline.fields .field > :first-child,\n.ui.form .inline.field > :first-child {\n  margin: 0em @inlineLabelDistance 0em 0em;\n}\n.ui.form .inline.fields .field > :only-child,\n.ui.form .inline.field > :only-child {\n  margin: 0em;\n}\n\n/* Wide */\n.ui.form .inline.fields .wide.field {\n  display: flex;\n  align-items: center;\n}\n.ui.form .inline.fields .wide.field > input,\n.ui.form .inline.fields .wide.field > select {\n  width: 100%;\n}\n\n\n/*--------------------\n        Sizes\n---------------------*/\n\n.ui.mini.form {\n  font-size: @mini;\n}\n.ui.tiny.form {\n  font-size: @tiny;\n}\n.ui.small.form {\n  font-size: @small;\n}\n.ui.form {\n  font-size: @medium;\n}\n.ui.large.form {\n  font-size: @large;\n}\n.ui.big.form {\n  font-size: @big;\n}\n.ui.huge.form {\n  font-size: @huge;\n}\n.ui.massive.form {\n  font-size: @massive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Grid\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'grid';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Standard\n*******************************/\n\n.ui.grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  padding: 0em;\n}\n\n/*----------------------\n      Remove Gutters\n-----------------------*/\n\n.ui.grid {\n  margin-top: -(@rowSpacing / 2);\n  margin-bottom: -(@rowSpacing / 2);\n  margin-left: -(@gutterWidth / 2);\n  margin-right: -(@gutterWidth / 2);\n}\n.ui.relaxed.grid  {\n  margin-left: -(@relaxedGutterWidth / 2);\n  margin-right: -(@relaxedGutterWidth / 2);\n}\n.ui[class*=\"very relaxed\"].grid  {\n  margin-left: -(@veryRelaxedGutterWidth / 2);\n  margin-right: -(@veryRelaxedGutterWidth / 2);\n}\n\n\n/* Preserve Rows Spacing on Consecutive Grids */\n.ui.grid + .grid {\n  margin-top: @consecutiveGridDistance;\n}\n\n/*-------------------\n       Columns\n--------------------*/\n\n/* Standard 16 column */\n.ui.grid > .column:not(.row),\n.ui.grid > .row > .column {\n  position: relative;\n  display: inline-block;\n\n  width: @oneWide;\n  padding-left: (@gutterWidth / 2);\n  padding-right: (@gutterWidth / 2);\n  vertical-align: top;\n}\n\n.ui.grid > * {\n  padding-left: (@gutterWidth / 2);\n  padding-right: (@gutterWidth / 2);\n}\n\n/*-------------------\n        Rows\n--------------------*/\n\n.ui.grid > .row {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: inherit;\n  align-items: stretch;\n  width: 100% !important;\n  padding: 0rem;\n  padding-top: (@rowSpacing / 2);\n  padding-bottom: (@rowSpacing / 2);\n}\n\n/*-------------------\n       Columns\n--------------------*/\n\n/* Vertical padding when no rows */\n.ui.grid > .column:not(.row) {\n  padding-top: (@rowSpacing / 2);\n  padding-bottom: (@rowSpacing / 2);\n}\n.ui.grid > .row > .column {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n\n/*-------------------\n      Content\n--------------------*/\n\n.ui.grid > .row > img,\n.ui.grid > .row > .column > img {\n  max-width: @columnMaxImageWidth;\n}\n\n/*-------------------\n    Loose Coupling\n--------------------*/\n\n/* Collapse Margin on Consecutive Grid */\n.ui.grid > .ui.grid:first-child {\n  margin-top: 0em;\n}\n.ui.grid > .ui.grid:last-child {\n  margin-bottom: 0em;\n}\n\n/* Segment inside Aligned Grid */\n.ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached),\n.ui.aligned.grid .column > .segment:not(.compact):not(.attached) {\n  width: 100%;\n}\n\n/* Align Dividers with Gutter */\n.ui.grid .row + .ui.divider {\n  flex-grow: 1;\n  margin: (@rowSpacing / 2) (@gutterWidth / 2);\n}\n.ui.grid .column + .ui.vertical.divider {\n  height: calc(50% - (@rowSpacing / 2));\n}\n\n/* Remove Border on Last Horizontal Segment */\n.ui.grid > .row > .column:last-child > .horizontal.segment,\n.ui.grid > .column:last-child > .horizontal.segment {\n  box-shadow: none;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-----------------------\n       Page Grid\n-------------------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.page.grid {\n    width: @mobileWidth;\n    padding-left: @mobileGutter;\n    padding-right: @mobileGutter;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n}\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui.page.grid {\n    width: @tabletWidth;\n    margin-left: @tabletMargin;\n    margin-right: @tabletMargin;\n    padding-left: @tabletGutter;\n    padding-right: @tabletGutter;\n  }\n}\n@media only screen and (min-width: @computerBreakpoint) and (max-width: @largestSmallMonitor) {\n  .ui.page.grid {\n    width: @computerWidth;\n    margin-left: @computerMargin;\n    margin-right: @computerMargin;\n    padding-left: @computerGutter;\n    padding-right: @computerGutter;\n  }\n}\n@media only screen and (min-width: @largeMonitorBreakpoint) and (max-width: @largestLargeMonitor) {\n  .ui.page.grid {\n    width: @largeMonitorWidth;\n    margin-left: @largeMonitorMargin;\n    margin-right: @largeMonitorMargin;\n    padding-left: @largeMonitorGutter;\n    padding-right: @largeMonitorGutter;\n  }\n}\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui.page.grid {\n    width: @widescreenMonitorWidth;\n    margin-left: @widescreenMargin;\n    margin-right: @widescreenMargin;\n    padding-left: @widescreenMonitorGutter;\n    padding-right: @widescreenMonitorGutter;\n  }\n}\n\n\n/*-------------------\n     Column Count\n--------------------*/\n\n/* Assume full width with one column */\n.ui.grid > .column:only-child,\n.ui.grid > .row > .column:only-child {\n  width: @oneColumn;\n}\n\n/* Grid Based */\n.ui[class*=\"one column\"].grid > .row > .column,\n.ui[class*=\"one column\"].grid > .column:not(.row) {\n  width: @oneColumn;\n}\n.ui[class*=\"two column\"].grid > .row > .column,\n.ui[class*=\"two column\"].grid > .column:not(.row) {\n  width: @twoColumn;\n}\n.ui[class*=\"three column\"].grid > .row > .column,\n.ui[class*=\"three column\"].grid > .column:not(.row) {\n  width: @threeColumn;\n}\n.ui[class*=\"four column\"].grid > .row > .column,\n.ui[class*=\"four column\"].grid > .column:not(.row) {\n  width: @fourColumn;\n}\n.ui[class*=\"five column\"].grid > .row > .column,\n.ui[class*=\"five column\"].grid > .column:not(.row) {\n  width: @fiveColumn;\n}\n.ui[class*=\"six column\"].grid > .row > .column,\n.ui[class*=\"six column\"].grid > .column:not(.row) {\n  width: @sixColumn;\n}\n.ui[class*=\"seven column\"].grid > .row > .column,\n.ui[class*=\"seven column\"].grid > .column:not(.row) {\n  width: @sevenColumn;\n}\n.ui[class*=\"eight column\"].grid > .row > .column,\n.ui[class*=\"eight column\"].grid > .column:not(.row) {\n  width: @eightColumn;\n}\n.ui[class*=\"nine column\"].grid > .row > .column,\n.ui[class*=\"nine column\"].grid > .column:not(.row) {\n  width: @nineColumn;\n}\n.ui[class*=\"ten column\"].grid > .row > .column,\n.ui[class*=\"ten column\"].grid > .column:not(.row) {\n  width: @tenColumn;\n}\n.ui[class*=\"eleven column\"].grid > .row > .column,\n.ui[class*=\"eleven column\"].grid > .column:not(.row) {\n  width: @elevenColumn;\n}\n.ui[class*=\"twelve column\"].grid > .row > .column,\n.ui[class*=\"twelve column\"].grid > .column:not(.row) {\n  width: @twelveColumn;\n}\n.ui[class*=\"thirteen column\"].grid > .row > .column,\n.ui[class*=\"thirteen column\"].grid > .column:not(.row) {\n  width: @thirteenColumn;\n}\n.ui[class*=\"fourteen column\"].grid > .row > .column,\n.ui[class*=\"fourteen column\"].grid > .column:not(.row) {\n  width: @fourteenColumn;\n}\n.ui[class*=\"fifteen column\"].grid > .row > .column,\n.ui[class*=\"fifteen column\"].grid > .column:not(.row) {\n  width: @fifteenColumn;\n}\n.ui[class*=\"sixteen column\"].grid > .row > .column,\n.ui[class*=\"sixteen column\"].grid > .column:not(.row) {\n  width: @sixteenColumn;\n}\n\n/* Row Based Overrides */\n.ui.grid > [class*=\"one column\"].row > .column {\n  width: @oneColumn !important;\n}\n.ui.grid > [class*=\"two column\"].row > .column {\n  width: @twoColumn !important;\n}\n.ui.grid > [class*=\"three column\"].row > .column {\n  width: @threeColumn !important;\n}\n.ui.grid > [class*=\"four column\"].row > .column {\n  width: @fourColumn !important;\n}\n.ui.grid > [class*=\"five column\"].row > .column {\n  width: @fiveColumn !important;\n}\n.ui.grid > [class*=\"six column\"].row > .column {\n  width: @sixColumn !important;\n}\n.ui.grid > [class*=\"seven column\"].row > .column {\n  width: @sevenColumn !important;\n}\n.ui.grid > [class*=\"eight column\"].row > .column {\n  width: @eightColumn !important;\n}\n.ui.grid > [class*=\"nine column\"].row > .column {\n  width: @nineColumn !important;\n}\n.ui.grid > [class*=\"ten column\"].row > .column {\n  width: @tenColumn !important;\n}\n.ui.grid > [class*=\"eleven column\"].row > .column {\n  width: @elevenColumn !important;\n}\n.ui.grid > [class*=\"twelve column\"].row > .column {\n  width: @twelveColumn !important;\n}\n.ui.grid > [class*=\"thirteen column\"].row > .column {\n  width: @thirteenColumn !important;\n}\n.ui.grid > [class*=\"fourteen column\"].row > .column {\n  width: @fourteenColumn !important;\n}\n.ui.grid > [class*=\"fifteen column\"].row > .column {\n  width: @fifteenColumn !important;\n}\n.ui.grid > [class*=\"sixteen column\"].row > .column {\n  width: @sixteenColumn !important;\n}\n\n/* Celled Page */\n.ui.celled.page.grid {\n  box-shadow: none;\n}\n\n/*-------------------\n    Column Width\n--------------------*/\n\n/* Sizing Combinations */\n.ui.grid > .row > [class*=\"one wide\"].column,\n.ui.grid > .column.row > [class*=\"one wide\"].column,\n.ui.grid > [class*=\"one wide\"].column,\n.ui.column.grid > [class*=\"one wide\"].column {\n  width: @oneWide !important;\n}\n.ui.grid > .row > [class*=\"two wide\"].column,\n.ui.grid > .column.row > [class*=\"two wide\"].column,\n.ui.grid > [class*=\"two wide\"].column,\n.ui.column.grid > [class*=\"two wide\"].column {\n  width: @twoWide !important;\n}\n.ui.grid > .row > [class*=\"three wide\"].column,\n.ui.grid > .column.row > [class*=\"three wide\"].column,\n.ui.grid > [class*=\"three wide\"].column,\n.ui.column.grid > [class*=\"three wide\"].column {\n  width: @threeWide !important;\n}\n.ui.grid > .row > [class*=\"four wide\"].column,\n.ui.grid > .column.row > [class*=\"four wide\"].column,\n.ui.grid > [class*=\"four wide\"].column,\n.ui.column.grid > [class*=\"four wide\"].column {\n  width: @fourWide !important;\n}\n.ui.grid > .row > [class*=\"five wide\"].column,\n.ui.grid > .column.row > [class*=\"five wide\"].column,\n.ui.grid > [class*=\"five wide\"].column,\n.ui.column.grid > [class*=\"five wide\"].column {\n  width: @fiveWide !important;\n}\n.ui.grid > .row > [class*=\"six wide\"].column,\n.ui.grid > .column.row > [class*=\"six wide\"].column,\n.ui.grid > [class*=\"six wide\"].column,\n.ui.column.grid > [class*=\"six wide\"].column {\n  width: @sixWide !important;\n}\n.ui.grid > .row > [class*=\"seven wide\"].column,\n.ui.grid > .column.row > [class*=\"seven wide\"].column,\n.ui.grid > [class*=\"seven wide\"].column,\n.ui.column.grid > [class*=\"seven wide\"].column {\n  width: @sevenWide !important;\n}\n.ui.grid > .row > [class*=\"eight wide\"].column,\n.ui.grid > .column.row > [class*=\"eight wide\"].column,\n.ui.grid > [class*=\"eight wide\"].column,\n.ui.column.grid > [class*=\"eight wide\"].column {\n  width: @eightWide !important;\n}\n.ui.grid > .row > [class*=\"nine wide\"].column,\n.ui.grid > .column.row > [class*=\"nine wide\"].column,\n.ui.grid > [class*=\"nine wide\"].column,\n.ui.column.grid > [class*=\"nine wide\"].column {\n  width: @nineWide !important;\n}\n.ui.grid > .row > [class*=\"ten wide\"].column,\n.ui.grid > .column.row > [class*=\"ten wide\"].column,\n.ui.grid > [class*=\"ten wide\"].column,\n.ui.column.grid > [class*=\"ten wide\"].column {\n  width: @tenWide !important;\n}\n.ui.grid > .row > [class*=\"eleven wide\"].column,\n.ui.grid > .column.row > [class*=\"eleven wide\"].column,\n.ui.grid > [class*=\"eleven wide\"].column,\n.ui.column.grid > [class*=\"eleven wide\"].column {\n  width: @elevenWide !important;\n}\n.ui.grid > .row > [class*=\"twelve wide\"].column,\n.ui.grid > .column.row > [class*=\"twelve wide\"].column,\n.ui.grid > [class*=\"twelve wide\"].column,\n.ui.column.grid > [class*=\"twelve wide\"].column {\n  width: @twelveWide !important;\n}\n.ui.grid > .row > [class*=\"thirteen wide\"].column,\n.ui.grid > .column.row > [class*=\"thirteen wide\"].column,\n.ui.grid > [class*=\"thirteen wide\"].column,\n.ui.column.grid > [class*=\"thirteen wide\"].column {\n  width: @thirteenWide !important;\n}\n.ui.grid > .row > [class*=\"fourteen wide\"].column,\n.ui.grid > .column.row > [class*=\"fourteen wide\"].column,\n.ui.grid > [class*=\"fourteen wide\"].column,\n.ui.column.grid > [class*=\"fourteen wide\"].column {\n  width: @fourteenWide !important;\n}\n.ui.grid > .row > [class*=\"fifteen wide\"].column,\n.ui.grid > .column.row > [class*=\"fifteen wide\"].column,\n.ui.grid > [class*=\"fifteen wide\"].column,\n.ui.column.grid > [class*=\"fifteen wide\"].column {\n  width: @fifteenWide !important;\n}\n.ui.grid > .row > [class*=\"sixteen wide\"].column,\n.ui.grid > .column.row > [class*=\"sixteen wide\"].column,\n.ui.grid > [class*=\"sixteen wide\"].column,\n.ui.column.grid > [class*=\"sixteen wide\"].column {\n  width: @sixteenWide !important;\n}\n\n/*----------------------\n    Width per Device\n-----------------------*/\n\n/* Mobile Sizing Combinations */\n@media only screen and (min-width: @mobileBreakpoint) and (max-width: @largestMobileScreen) {\n  .ui.grid > .row > [class*=\"one wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"one wide mobile\"].column,\n  .ui.grid > [class*=\"one wide mobile\"].column,\n  .ui.column.grid > [class*=\"one wide mobile\"].column {\n    width: @oneWide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"two wide mobile\"].column,\n  .ui.grid > [class*=\"two wide mobile\"].column,\n  .ui.column.grid > [class*=\"two wide mobile\"].column {\n    width: @twoWide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"three wide mobile\"].column,\n  .ui.grid > [class*=\"three wide mobile\"].column,\n  .ui.column.grid > [class*=\"three wide mobile\"].column {\n    width: @threeWide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"four wide mobile\"].column,\n  .ui.grid > [class*=\"four wide mobile\"].column,\n  .ui.column.grid > [class*=\"four wide mobile\"].column {\n    width: @fourWide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"five wide mobile\"].column,\n  .ui.grid > [class*=\"five wide mobile\"].column,\n  .ui.column.grid > [class*=\"five wide mobile\"].column {\n    width: @fiveWide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"six wide mobile\"].column,\n  .ui.grid > [class*=\"six wide mobile\"].column,\n  .ui.column.grid > [class*=\"six wide mobile\"].column {\n    width: @sixWide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide mobile\"].column,\n  .ui.grid > [class*=\"seven wide mobile\"].column,\n  .ui.column.grid > [class*=\"seven wide mobile\"].column {\n    width: @sevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide mobile\"].column,\n  .ui.grid > [class*=\"eight wide mobile\"].column,\n  .ui.column.grid > [class*=\"eight wide mobile\"].column {\n    width: @eightWide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide mobile\"].column,\n  .ui.grid > [class*=\"nine wide mobile\"].column,\n  .ui.column.grid > [class*=\"nine wide mobile\"].column {\n    width: @nineWide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide mobile\"].column,\n  .ui.grid > [class*=\"ten wide mobile\"].column,\n  .ui.column.grid > [class*=\"ten wide mobile\"].column {\n    width: @tenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide mobile\"].column,\n  .ui.grid > [class*=\"eleven wide mobile\"].column,\n  .ui.column.grid > [class*=\"eleven wide mobile\"].column {\n    width: @elevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide mobile\"].column,\n  .ui.grid > [class*=\"twelve wide mobile\"].column,\n  .ui.column.grid > [class*=\"twelve wide mobile\"].column {\n    width: @twelveWide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide mobile\"].column,\n  .ui.grid > [class*=\"thirteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"thirteen wide mobile\"].column {\n    width: @thirteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide mobile\"].column,\n  .ui.grid > [class*=\"fourteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"fourteen wide mobile\"].column {\n    width: @fourteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide mobile\"].column,\n  .ui.grid > [class*=\"fifteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"fifteen wide mobile\"].column {\n    width: @fifteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide mobile\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide mobile\"].column,\n  .ui.grid > [class*=\"sixteen wide mobile\"].column,\n  .ui.column.grid > [class*=\"sixteen wide mobile\"].column {\n    width: @sixteenWide !important;\n  }\n}\n\n/* Tablet Sizing Combinations */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui.grid > .row > [class*=\"one wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"one wide tablet\"].column,\n  .ui.grid > [class*=\"one wide tablet\"].column,\n  .ui.column.grid > [class*=\"one wide tablet\"].column {\n    width: @oneWide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"two wide tablet\"].column,\n  .ui.grid > [class*=\"two wide tablet\"].column,\n  .ui.column.grid > [class*=\"two wide tablet\"].column {\n    width: @twoWide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"three wide tablet\"].column,\n  .ui.grid > [class*=\"three wide tablet\"].column,\n  .ui.column.grid > [class*=\"three wide tablet\"].column {\n    width: @threeWide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"four wide tablet\"].column,\n  .ui.grid > [class*=\"four wide tablet\"].column,\n  .ui.column.grid > [class*=\"four wide tablet\"].column {\n    width: @fourWide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"five wide tablet\"].column,\n  .ui.grid > [class*=\"five wide tablet\"].column,\n  .ui.column.grid > [class*=\"five wide tablet\"].column {\n    width: @fiveWide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"six wide tablet\"].column,\n  .ui.grid > [class*=\"six wide tablet\"].column,\n  .ui.column.grid > [class*=\"six wide tablet\"].column {\n    width: @sixWide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide tablet\"].column,\n  .ui.grid > [class*=\"seven wide tablet\"].column,\n  .ui.column.grid > [class*=\"seven wide tablet\"].column {\n    width: @sevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide tablet\"].column,\n  .ui.grid > [class*=\"eight wide tablet\"].column,\n  .ui.column.grid > [class*=\"eight wide tablet\"].column {\n    width: @eightWide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide tablet\"].column,\n  .ui.grid > [class*=\"nine wide tablet\"].column,\n  .ui.column.grid > [class*=\"nine wide tablet\"].column {\n    width: @nineWide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide tablet\"].column,\n  .ui.grid > [class*=\"ten wide tablet\"].column,\n  .ui.column.grid > [class*=\"ten wide tablet\"].column {\n    width: @tenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide tablet\"].column,\n  .ui.grid > [class*=\"eleven wide tablet\"].column,\n  .ui.column.grid > [class*=\"eleven wide tablet\"].column {\n    width: @elevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide tablet\"].column,\n  .ui.grid > [class*=\"twelve wide tablet\"].column,\n  .ui.column.grid > [class*=\"twelve wide tablet\"].column {\n    width: @twelveWide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide tablet\"].column,\n  .ui.grid > [class*=\"thirteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"thirteen wide tablet\"].column {\n    width: @thirteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide tablet\"].column,\n  .ui.grid > [class*=\"fourteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"fourteen wide tablet\"].column {\n    width: @fourteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide tablet\"].column,\n  .ui.grid > [class*=\"fifteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"fifteen wide tablet\"].column {\n    width: @fifteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide tablet\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide tablet\"].column,\n  .ui.grid > [class*=\"sixteen wide tablet\"].column,\n  .ui.column.grid > [class*=\"sixteen wide tablet\"].column {\n    width: @sixteenWide !important;\n  }\n}\n\n/* Computer/Desktop Sizing Combinations */\n@media only screen and (min-width: @computerBreakpoint) {\n    .ui.grid > .row > [class*=\"one wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"one wide computer\"].column,\n  .ui.grid > [class*=\"one wide computer\"].column,\n  .ui.column.grid > [class*=\"one wide computer\"].column {\n    width: @oneWide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"two wide computer\"].column,\n  .ui.grid > [class*=\"two wide computer\"].column,\n  .ui.column.grid > [class*=\"two wide computer\"].column {\n    width: @twoWide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"three wide computer\"].column,\n  .ui.grid > [class*=\"three wide computer\"].column,\n  .ui.column.grid > [class*=\"three wide computer\"].column {\n    width: @threeWide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"four wide computer\"].column,\n  .ui.grid > [class*=\"four wide computer\"].column,\n  .ui.column.grid > [class*=\"four wide computer\"].column {\n    width: @fourWide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"five wide computer\"].column,\n  .ui.grid > [class*=\"five wide computer\"].column,\n  .ui.column.grid > [class*=\"five wide computer\"].column {\n    width: @fiveWide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"six wide computer\"].column,\n  .ui.grid > [class*=\"six wide computer\"].column,\n  .ui.column.grid > [class*=\"six wide computer\"].column {\n    width: @sixWide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide computer\"].column,\n  .ui.grid > [class*=\"seven wide computer\"].column,\n  .ui.column.grid > [class*=\"seven wide computer\"].column {\n    width: @sevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide computer\"].column,\n  .ui.grid > [class*=\"eight wide computer\"].column,\n  .ui.column.grid > [class*=\"eight wide computer\"].column {\n    width: @eightWide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide computer\"].column,\n  .ui.grid > [class*=\"nine wide computer\"].column,\n  .ui.column.grid > [class*=\"nine wide computer\"].column {\n    width: @nineWide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide computer\"].column,\n  .ui.grid > [class*=\"ten wide computer\"].column,\n  .ui.column.grid > [class*=\"ten wide computer\"].column {\n    width: @tenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide computer\"].column,\n  .ui.grid > [class*=\"eleven wide computer\"].column,\n  .ui.column.grid > [class*=\"eleven wide computer\"].column {\n    width: @elevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide computer\"].column,\n  .ui.grid > [class*=\"twelve wide computer\"].column,\n  .ui.column.grid > [class*=\"twelve wide computer\"].column {\n    width: @twelveWide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide computer\"].column,\n  .ui.grid > [class*=\"thirteen wide computer\"].column,\n  .ui.column.grid > [class*=\"thirteen wide computer\"].column {\n    width: @thirteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide computer\"].column,\n  .ui.grid > [class*=\"fourteen wide computer\"].column,\n  .ui.column.grid > [class*=\"fourteen wide computer\"].column {\n    width: @fourteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide computer\"].column,\n  .ui.grid > [class*=\"fifteen wide computer\"].column,\n  .ui.column.grid > [class*=\"fifteen wide computer\"].column {\n    width: @fifteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide computer\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide computer\"].column,\n  .ui.grid > [class*=\"sixteen wide computer\"].column,\n  .ui.column.grid > [class*=\"sixteen wide computer\"].column {\n    width: @sixteenWide !important;\n  }\n}\n\n/* Large Monitor Sizing Combinations */\n@media only screen and (min-width: @largeMonitorBreakpoint) and (max-width: @largestLargeMonitor){\n  .ui.grid > .row > [class*=\"one wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"one wide large screen\"].column,\n  .ui.grid > [class*=\"one wide large screen\"].column,\n  .ui.column.grid > [class*=\"one wide large screen\"].column {\n    width: @oneWide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"two wide large screen\"].column,\n  .ui.grid > [class*=\"two wide large screen\"].column,\n  .ui.column.grid > [class*=\"two wide large screen\"].column {\n    width: @twoWide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"three wide large screen\"].column,\n  .ui.grid > [class*=\"three wide large screen\"].column,\n  .ui.column.grid > [class*=\"three wide large screen\"].column {\n    width: @threeWide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"four wide large screen\"].column,\n  .ui.grid > [class*=\"four wide large screen\"].column,\n  .ui.column.grid > [class*=\"four wide large screen\"].column {\n    width: @fourWide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"five wide large screen\"].column,\n  .ui.grid > [class*=\"five wide large screen\"].column,\n  .ui.column.grid > [class*=\"five wide large screen\"].column {\n    width: @fiveWide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"six wide large screen\"].column,\n  .ui.grid > [class*=\"six wide large screen\"].column,\n  .ui.column.grid > [class*=\"six wide large screen\"].column {\n    width: @sixWide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide large screen\"].column,\n  .ui.grid > [class*=\"seven wide large screen\"].column,\n  .ui.column.grid > [class*=\"seven wide large screen\"].column {\n    width: @sevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide large screen\"].column,\n  .ui.grid > [class*=\"eight wide large screen\"].column,\n  .ui.column.grid > [class*=\"eight wide large screen\"].column {\n    width: @eightWide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide large screen\"].column,\n  .ui.grid > [class*=\"nine wide large screen\"].column,\n  .ui.column.grid > [class*=\"nine wide large screen\"].column {\n    width: @nineWide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide large screen\"].column,\n  .ui.grid > [class*=\"ten wide large screen\"].column,\n  .ui.column.grid > [class*=\"ten wide large screen\"].column {\n    width: @tenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide large screen\"].column,\n  .ui.grid > [class*=\"eleven wide large screen\"].column,\n  .ui.column.grid > [class*=\"eleven wide large screen\"].column {\n    width: @elevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide large screen\"].column,\n  .ui.grid > [class*=\"twelve wide large screen\"].column,\n  .ui.column.grid > [class*=\"twelve wide large screen\"].column {\n    width: @twelveWide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide large screen\"].column,\n  .ui.grid > [class*=\"thirteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"thirteen wide large screen\"].column {\n    width: @thirteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide large screen\"].column,\n  .ui.grid > [class*=\"fourteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"fourteen wide large screen\"].column {\n    width: @fourteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide large screen\"].column,\n  .ui.grid > [class*=\"fifteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"fifteen wide large screen\"].column {\n    width: @fifteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide large screen\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide large screen\"].column,\n  .ui.grid > [class*=\"sixteen wide large screen\"].column,\n  .ui.column.grid > [class*=\"sixteen wide large screen\"].column {\n    width: @sixteenWide !important;\n  }\n}\n\n/* Widescreen Sizing Combinations */\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui.grid > .row > [class*=\"one wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"one wide widescreen\"].column,\n  .ui.grid > [class*=\"one wide widescreen\"].column,\n  .ui.column.grid > [class*=\"one wide widescreen\"].column {\n    width: @oneWide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"two wide widescreen\"].column,\n  .ui.grid > [class*=\"two wide widescreen\"].column,\n  .ui.column.grid > [class*=\"two wide widescreen\"].column {\n    width: @twoWide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"three wide widescreen\"].column,\n  .ui.grid > [class*=\"three wide widescreen\"].column,\n  .ui.column.grid > [class*=\"three wide widescreen\"].column {\n    width: @threeWide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"four wide widescreen\"].column,\n  .ui.grid > [class*=\"four wide widescreen\"].column,\n  .ui.column.grid > [class*=\"four wide widescreen\"].column {\n    width: @fourWide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"five wide widescreen\"].column,\n  .ui.grid > [class*=\"five wide widescreen\"].column,\n  .ui.column.grid > [class*=\"five wide widescreen\"].column {\n    width: @fiveWide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"six wide widescreen\"].column,\n  .ui.grid > [class*=\"six wide widescreen\"].column,\n  .ui.column.grid > [class*=\"six wide widescreen\"].column {\n    width: @sixWide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide widescreen\"].column,\n  .ui.grid > [class*=\"seven wide widescreen\"].column,\n  .ui.column.grid > [class*=\"seven wide widescreen\"].column {\n    width: @sevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide widescreen\"].column,\n  .ui.grid > [class*=\"eight wide widescreen\"].column,\n  .ui.column.grid > [class*=\"eight wide widescreen\"].column {\n    width: @eightWide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide widescreen\"].column,\n  .ui.grid > [class*=\"nine wide widescreen\"].column,\n  .ui.column.grid > [class*=\"nine wide widescreen\"].column {\n    width: @nineWide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide widescreen\"].column,\n  .ui.grid > [class*=\"ten wide widescreen\"].column,\n  .ui.column.grid > [class*=\"ten wide widescreen\"].column {\n    width: @tenWide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide widescreen\"].column,\n  .ui.grid > [class*=\"eleven wide widescreen\"].column,\n  .ui.column.grid > [class*=\"eleven wide widescreen\"].column {\n    width: @elevenWide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide widescreen\"].column,\n  .ui.grid > [class*=\"twelve wide widescreen\"].column,\n  .ui.column.grid > [class*=\"twelve wide widescreen\"].column {\n    width: @twelveWide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide widescreen\"].column,\n  .ui.grid > [class*=\"thirteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"thirteen wide widescreen\"].column {\n    width: @thirteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide widescreen\"].column,\n  .ui.grid > [class*=\"fourteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"fourteen wide widescreen\"].column {\n    width: @fourteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide widescreen\"].column,\n  .ui.grid > [class*=\"fifteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"fifteen wide widescreen\"].column {\n    width: @fifteenWide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide widescreen\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide widescreen\"].column,\n  .ui.grid > [class*=\"sixteen wide widescreen\"].column,\n  .ui.column.grid > [class*=\"sixteen wide widescreen\"].column {\n    width: @sixteenWide !important;\n  }\n}\n\n/*----------------------\n        Centered\n-----------------------*/\n\n.ui.centered.grid,\n.ui.centered.grid > .row,\n.ui.grid > .centered.row {\n  text-align: center;\n  justify-content: center;\n}\n.ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),\n.ui.centered.grid > .row > .column:not(.aligned):not(.justified),\n.ui.grid .centered.row > .column:not(.aligned):not(.justified) {\n  text-align: left;\n}\n\n.ui.grid > .centered.column,\n.ui.grid > .row > .centered.column {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*----------------------\n        Relaxed\n-----------------------*/\n\n.ui.relaxed.grid > .column:not(.row),\n.ui.relaxed.grid > .row > .column,\n.ui.grid > .relaxed.row > .column {\n  padding-left: (@relaxedGutterWidth / 2);\n  padding-right: (@relaxedGutterWidth / 2);\n}\n\n.ui[class*=\"very relaxed\"].grid > .column:not(.row),\n.ui[class*=\"very relaxed\"].grid > .row > .column,\n.ui.grid > [class*=\"very relaxed\"].row > .column {\n  padding-left: (@veryRelaxedGutterWidth / 2);\n  padding-right: (@veryRelaxedGutterWidth / 2);\n}\n\n/* Coupling with UI Divider */\n.ui.relaxed.grid .row + .ui.divider,\n.ui.grid .relaxed.row + .ui.divider {\n  margin-left: (@relaxedGutterWidth / 2);\n  margin-right: (@relaxedGutterWidth / 2);\n}\n.ui[class*=\"very relaxed\"].grid .row + .ui.divider,\n.ui.grid [class*=\"very relaxed\"].row + .ui.divider {\n  margin-left: (@veryRelaxedGutterWidth / 2);\n  margin-right: (@veryRelaxedGutterWidth / 2);\n}\n\n\n/*----------------------\n        Padded\n-----------------------*/\n\n.ui.padded.grid:not(.vertically):not(.horizontally) {\n  margin: 0em !important;\n}\n[class*=\"horizontally padded\"].ui.grid {\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n}\n[class*=\"vertically padded\"].ui.grid {\n  margin-top: 0em !important;\n  margin-bottom: 0em !important;\n}\n\n/*----------------------\n       \"Floated\"\n-----------------------*/\n\n.ui.grid [class*=\"left floated\"].column {\n  margin-right: auto;\n}\n.ui.grid [class*=\"right floated\"].column {\n  margin-left: auto;\n}\n\n\n/*----------------------\n        Divided\n-----------------------*/\n\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: @dividedBorder;\n}\n\n/* Swap from padding to margin on columns to have dividers align */\n.ui[class*=\"vertically divided\"].grid > .column:not(.row),\n.ui[class*=\"vertically divided\"].grid > .row > .column {\n  margin-top: (@rowSpacing / 2);\n  margin-bottom: (@rowSpacing / 2);\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n.ui[class*=\"vertically divided\"].grid > .row {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n\n\n\n/* No divider on first column on row */\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n\n/* No space on top of first row */\n.ui[class*=\"vertically divided\"].grid > .row:first-child > .column {\n  margin-top: 0em;\n}\n\n\n/* Divided Row */\n.ui.grid > .divided.row > .column {\n  box-shadow: @dividedBorder;\n}\n.ui.grid > .divided.row > .column:first-child {\n  box-shadow: none;\n}\n\n/* Vertically Divided */\n.ui[class*=\"vertically divided\"].grid > .row {\n  position: relative;\n}\n.ui[class*=\"vertically divided\"].grid > .row:before {\n  position: absolute;\n  content: \"\";\n  top: 0em;\n  left: 0px;\n\n  width: calc(100% - @gutterWidth);\n  height: 1px;\n\n  margin: 0% (@gutterWidth / 2);\n  box-shadow: @verticallyDividedBorder;\n}\n\n/* Padded Horizontally Divided */\n[class*=\"horizontally padded\"].ui.divided.grid,\n.ui.padded.divided.grid:not(.vertically):not(.horizontally) {\n  width: 100%;\n}\n\n/* First Row Vertically Divided */\n.ui[class*=\"vertically divided\"].grid > .row:first-child:before {\n  box-shadow: none;\n}\n\n/* Inverted Divided */\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: @dividedInvertedBorder;\n}\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row):first-child,\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n.ui.inverted[class*=\"vertically divided\"].grid > .row:before {\n  box-shadow: @verticallyDividedInvertedBorder;\n}\n\n/* Relaxed */\n.ui.relaxed[class*=\"vertically divided\"].grid > .row:before {\n  margin-left: (@relaxedGutterWidth / 2);\n  margin-right: (@relaxedGutterWidth / 2);\n  width: calc(100% - @relaxedGutterWidth);\n}\n.ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid > .row:before {\n  margin-left: (@veryRelaxedGutterWidth / 2);\n  margin-right: (@veryRelaxedGutterWidth / 2);\n  width: calc(100% - @veryRelaxedGutterWidth);\n}\n\n/*----------------------\n         Celled\n-----------------------*/\n\n.ui.celled.grid {\n  width: 100%;\n  margin: @celledMargin;\n  box-shadow: @celledGridDivider;\n}\n\n.ui.celled.grid > .row {\n  width: 100% !important;\n  margin: 0em;\n  padding: 0em;\n  box-shadow: @celledRowDivider;\n}\n.ui.celled.grid > .column:not(.row),\n.ui.celled.grid > .row > .column {\n  box-shadow: @celledColumnDivider;\n}\n\n.ui.celled.grid > .column:first-child,\n.ui.celled.grid > .row > .column:first-child {\n  box-shadow: none;\n}\n\n.ui.celled.grid > .column:not(.row),\n.ui.celled.grid > .row > .column {\n  padding: @celledPadding;\n}\n.ui.relaxed.celled.grid > .column:not(.row),\n.ui.relaxed.celled.grid > .row > .column {\n  padding: @celledRelaxedPadding;\n}\n.ui[class*=\"very relaxed\"].celled.grid > .column:not(.row),\n.ui[class*=\"very relaxed\"].celled.grid > .row > .column {\n  padding: @celledVeryRelaxedPadding;\n}\n\n/* Internally Celled */\n.ui[class*=\"internally celled\"].grid {\n  box-shadow: none;\n  margin: 0em;\n}\n.ui[class*=\"internally celled\"].grid > .row:first-child {\n  box-shadow: none;\n}\n.ui[class*=\"internally celled\"].grid > .row > .column:first-child {\n  box-shadow: none;\n}\n\n/*----------------------\n   Vertically Aligned\n-----------------------*/\n\n/* Top Aligned */\n.ui[class*=\"top aligned\"].grid > .column:not(.row),\n.ui[class*=\"top aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"top aligned\"].row > .column,\n.ui.grid > [class*=\"top aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"top aligned\"].column {\n  flex-direction: column;\n  vertical-align: top;\n  align-self: flex-start !important;\n}\n\n/* Middle Aligned */\n.ui[class*=\"middle aligned\"].grid > .column:not(.row),\n.ui[class*=\"middle aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"middle aligned\"].row > .column,\n.ui.grid > [class*=\"middle aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"middle aligned\"].column {\n  flex-direction: column;\n  vertical-align: middle;\n  align-self: center !important;\n}\n\n/* Bottom Aligned */\n.ui[class*=\"bottom aligned\"].grid > .column:not(.row),\n.ui[class*=\"bottom aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"bottom aligned\"].row > .column,\n.ui.grid > [class*=\"bottom aligned\"].column:not(.row),\n.ui.grid > .row > [class*=\"bottom aligned\"].column {\n  flex-direction: column;\n  vertical-align: bottom;\n  align-self: flex-end !important;\n}\n\n/* Stretched */\n.ui.stretched.grid > .row > .column,\n.ui.stretched.grid > .column,\n.ui.grid > .stretched.row > .column,\n.ui.grid > .stretched.column:not(.row),\n.ui.grid > .row > .stretched.column {\n  display: inline-flex !important;\n  align-self: stretch;\n  flex-direction: column;\n}\n\n.ui.stretched.grid > .row > .column > *,\n.ui.stretched.grid > .column > *,\n.ui.grid > .stretched.row > .column > *,\n.ui.grid > .stretched.column:not(.row) > *,\n.ui.grid > .row > .stretched.column > * {\n  flex-grow: 1;\n}\n\n/*----------------------\n  Horizontally Centered\n-----------------------*/\n\n/* Left Aligned */\n.ui[class*=\"left aligned\"].grid > .column,\n.ui[class*=\"left aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"left aligned\"].row > .column,\n.ui.grid > [class*=\"left aligned\"].column.column,\n.ui.grid > .row > [class*=\"left aligned\"].column.column {\n  text-align: left;\n  align-self: inherit;\n}\n\n/* Center Aligned */\n.ui[class*=\"center aligned\"].grid > .column,\n.ui[class*=\"center aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"center aligned\"].row > .column,\n.ui.grid > [class*=\"center aligned\"].column.column,\n.ui.grid > .row > [class*=\"center aligned\"].column.column {\n  text-align: center;\n  align-self: inherit;\n}\n.ui[class*=\"center aligned\"].grid {\n  justify-content: center;\n}\n\n/* Right Aligned */\n.ui[class*=\"right aligned\"].grid > .column,\n.ui[class*=\"right aligned\"].grid > .row > .column,\n.ui.grid > [class*=\"right aligned\"].row > .column,\n.ui.grid > [class*=\"right aligned\"].column.column,\n.ui.grid > .row > [class*=\"right aligned\"].column.column {\n  text-align: right;\n  align-self: inherit;\n}\n\n/* Justified */\n.ui.justified.grid > .column,\n.ui.justified.grid > .row > .column,\n.ui.grid > .justified.row > .column,\n.ui.grid > .justified.column.column,\n.ui.grid > .row > .justified.column.column {\n  text-align: justify;\n  hyphens: auto;\n}\n\n/*----------------------\n         Colored\n-----------------------*/\n\n.ui.grid > .row > .red.column,\n.ui.grid > .row > .orange.column,\n.ui.grid > .row > .yellow.column,\n.ui.grid > .row > .olive.column,\n.ui.grid > .row > .green.column,\n.ui.grid > .row > .teal.column,\n.ui.grid > .row > .blue.column,\n.ui.grid > .row > .violet.column,\n.ui.grid > .row > .purple.column,\n.ui.grid > .row > .pink.column,\n.ui.grid > .row > .brown.column,\n.ui.grid > .row > .grey.column,\n.ui.grid > .row > .black.column {\n  margin-top: -(@rowSpacing / 2);\n  margin-bottom: -(@rowSpacing / 2);\n  padding-top: (@rowSpacing / 2);\n  padding-bottom: (@rowSpacing / 2);\n}\n\n/* Red */\n.ui.grid > .red.row,\n.ui.grid > .red.column,\n.ui.grid > .row > .red.column {\n  background-color: @red !important;\n  color: @white;\n}\n/* Orange */\n.ui.grid > .orange.row,\n.ui.grid > .orange.column,\n.ui.grid > .row > .orange.column {\n  background-color: @orange !important;\n  color: @white;\n}\n/* Yellow */\n.ui.grid > .yellow.row,\n.ui.grid > .yellow.column,\n.ui.grid > .row > .yellow.column {\n  background-color: @yellow !important;\n  color: @white;\n}\n/* Olive */\n.ui.grid > .olive.row,\n.ui.grid > .olive.column,\n.ui.grid > .row > .olive.column {\n  background-color: @olive !important;\n  color: @white;\n}\n/* Green */\n.ui.grid > .green.row,\n.ui.grid > .green.column,\n.ui.grid > .row > .green.column {\n  background-color: @green !important;\n  color: @white;\n}\n/* Teal */\n.ui.grid > .teal.row,\n.ui.grid > .teal.column,\n.ui.grid > .row > .teal.column {\n  background-color: @teal !important;\n  color: @white;\n}\n/* Blue */\n.ui.grid > .blue.row,\n.ui.grid > .blue.column,\n.ui.grid > .row > .blue.column {\n  background-color: @blue !important;\n  color: @white;\n}\n/* Violet */\n.ui.grid > .violet.row,\n.ui.grid > .violet.column,\n.ui.grid > .row > .violet.column {\n  background-color: @violet !important;\n  color: @white;\n}\n/* Purple */\n.ui.grid > .purple.row,\n.ui.grid > .purple.column,\n.ui.grid > .row > .purple.column {\n  background-color: @purple !important;\n  color: @white;\n}\n/* Pink */\n.ui.grid > .pink.row,\n.ui.grid > .pink.column,\n.ui.grid > .row > .pink.column {\n  background-color: @pink !important;\n  color: @white;\n}\n/* Brown */\n.ui.grid > .brown.row,\n.ui.grid > .brown.column,\n.ui.grid > .row > .brown.column {\n  background-color: @brown !important;\n  color: @white;\n}\n/* Grey */\n.ui.grid > .grey.row,\n.ui.grid > .grey.column,\n.ui.grid > .row > .grey.column {\n  background-color: @grey !important;\n  color: @white;\n}\n/* Black */\n.ui.grid > .black.row,\n.ui.grid > .black.column,\n.ui.grid > .row > .black.column {\n  background-color: @black !important;\n  color: @white;\n}\n\n\n/*----------------------\n      Equal Width\n-----------------------*/\n\n.ui[class*=\"equal width\"].grid > .column:not(.row),\n.ui[class*=\"equal width\"].grid > .row > .column,\n.ui.grid > [class*=\"equal width\"].row > .column {\n  display: inline-block;\n  flex-grow: 1;\n}\n.ui[class*=\"equal width\"].grid > .wide.column,\n.ui[class*=\"equal width\"].grid > .row > .wide.column,\n.ui.grid > [class*=\"equal width\"].row > .wide.column {\n  flex-grow: 0;\n}\n\n\n/*----------------------\n        Reverse\n-----------------------*/\n\n\n/* Mobile */\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui[class*=\"mobile reversed\"].grid,\n  .ui[class*=\"mobile reversed\"].grid > .row,\n  .ui.grid > [class*=\"mobile reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"mobile vertically reversed\"].grid,\n  .ui.stackable[class*=\"mobile reversed\"] {\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: @dividedBorder;\n  }\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:first-child:before {\n    box-shadow: @verticallyDividedBorder;\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: @celledColumnDivider;\n  }\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n/* Tablet */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui[class*=\"tablet reversed\"].grid,\n  .ui[class*=\"tablet reversed\"].grid > .row,\n  .ui.grid > [class*=\"tablet reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"tablet vertically reversed\"].grid {\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: @dividedBorder;\n  }\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:first-child:before {\n    box-shadow: @verticallyDividedBorder;\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: @celledColumnDivider;\n  }\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n/* Computer */\n@media only screen and (min-width: @computerBreakpoint) {\n  .ui[class*=\"computer reversed\"].grid,\n  .ui[class*=\"computer reversed\"].grid > .row,\n  .ui.grid > [class*=\"computer reversed\"].row {\n    flex-direction: row-reverse;\n  }\n  .ui[class*=\"computer vertically reversed\"].grid {\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: @dividedBorder;\n  }\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n  /* Vertically Divided Reversed */\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:first-child:before {\n    box-shadow: @verticallyDividedBorder;\n  }\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n  /* Celled Reversed */\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: @celledColumnDivider;\n  }\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n\n/*-------------------\n      Doubling\n--------------------*/\n\n/* Tablet Only */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui.doubling.grid {\n    width: auto;\n  }\n  .ui.grid > .doubling.row,\n  .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n  .ui.grid > .doubling.row > .column,\n  .ui.doubling.grid > .row > .column {\n    display: inline-block !important;\n    padding-top: (@rowSpacing / 2) !important;\n    padding-bottom: (@rowSpacing / 2) !important;\n    box-shadow: none !important;\n    margin: 0em;\n  }\n  .ui[class*=\"two column\"].doubling.grid > .row > .column,\n  .ui[class*=\"two column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"two column\"].doubling.row.row > .column {\n    width: @oneColumn !important;\n  }\n  .ui[class*=\"three column\"].doubling.grid > .row > .column,\n  .ui[class*=\"three column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"three column\"].doubling.row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"four column\"].doubling.grid > .row > .column,\n  .ui[class*=\"four column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"four column\"].doubling.row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"five column\"].doubling.grid > .row > .column,\n  .ui[class*=\"five column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"five column\"].doubling.row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"six column\"].doubling.grid > .row > .column,\n  .ui[class*=\"six column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"six column\"].doubling.row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"seven column\"].doubling.grid > .row > .column,\n  .ui[class*=\"seven column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"seven column\"].doubling.row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"eight column\"].doubling.grid > .row > .column,\n  .ui[class*=\"eight column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"eight column\"].doubling.row.row > .column {\n    width: @fourColumn !important;\n  }\n  .ui[class*=\"nine column\"].doubling.grid > .row > .column,\n  .ui[class*=\"nine column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"nine column\"].doubling.row.row > .column {\n    width: @fourColumn !important;\n  }\n  .ui[class*=\"ten column\"].doubling.grid > .row > .column,\n  .ui[class*=\"ten column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"ten column\"].doubling.row.row > .column {\n    width: @fiveColumn !important;\n  }\n  .ui[class*=\"eleven column\"].doubling.grid > .row > .column,\n  .ui[class*=\"eleven column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"eleven column\"].doubling.row.row > .column {\n    width: @fiveColumn !important;\n  }\n  .ui[class*=\"twelve column\"].doubling.grid > .row > .column,\n  .ui[class*=\"twelve column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"twelve column\"].doubling.row.row > .column {\n    width: @sixColumn !important;\n  }\n  .ui[class*=\"thirteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"thirteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"thirteen column\"].doubling.row.row > .column {\n    width: @sixColumn !important;\n  }\n  .ui[class*=\"fourteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"fourteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"fourteen column\"].doubling.row.row > .column {\n    width: @sevenColumn !important;\n  }\n  .ui[class*=\"fifteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"fifteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"fifteen column\"].doubling.row.row > .column {\n    width: @sevenColumn !important;\n  }\n  .ui[class*=\"sixteen column\"].doubling.grid > .row > .column,\n  .ui[class*=\"sixteen column\"].doubling.grid > .column:not(.row),\n  .ui.grid > [class*=\"sixteen column\"].doubling.row.row > .column {\n    width: @eightColumn !important;\n  }\n}\n\n/* Mobile Only */\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.grid > .doubling.row,\n  .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n  .ui.grid > .doubling.row > .column,\n  .ui.doubling.grid > .row > .column {\n    padding-top: (@rowSpacing / 2) !important;\n    padding-bottom: (@rowSpacing / 2) !important;\n    margin: 0em !important;\n    box-shadow: none !important;\n  }\n  .ui[class*=\"two column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"two column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"two column\"].doubling:not(.stackable).row.row > .column {\n    width: @oneColumn !important;\n  }\n  .ui[class*=\"three column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"three column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"three column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"four column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"four column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"four column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"five column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"five column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"five column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"six column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"six column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"six column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"seven column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"eight column\"].doubling:not(.stackable).row.row > .column {\n    width: @twoColumn !important;\n  }\n  .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"nine column\"].doubling:not(.stackable).row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"ten column\"].doubling:not(.stackable).row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"eleven column\"].doubling:not(.stackable).row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"twelve column\"].doubling:not(.stackable).row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"thirteen column\"].doubling:not(.stackable).row.row > .column {\n    width: @threeColumn !important;\n  }\n  .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"fourteen column\"].doubling:not(.stackable).row.row > .column {\n    width: @fourColumn !important;\n  }\n  .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"fifteen column\"].doubling:not(.stackable).row.row > .column {\n    width: @fourColumn !important;\n  }\n  .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .row > .column,\n  .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n  .ui.grid > [class*=\"sixteen column\"].doubling:not(.stackable).row.row > .column {\n    width: @fourColumn !important;\n  }\n}\n\n/*-------------------\n      Stackable\n--------------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.stackable.grid {\n    width: auto;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n  .ui.stackable.grid > .row > .wide.column,\n  .ui.stackable.grid > .wide.column,\n  .ui.stackable.grid > .column.grid > .column,\n  .ui.stackable.grid > .column.row > .column,\n  .ui.stackable.grid > .row > .column,\n  .ui.stackable.grid > .column:not(.row),\n  .ui.grid > .stackable.stackable.row > .column {\n    width: 100% !important;\n    margin: 0em 0em !important;\n    box-shadow: none !important;\n    padding: (@stackableRowSpacing / 2) (@stackableGutter / 2) !important;\n  }\n  .ui.stackable.grid:not(.vertically) > .row {\n    margin: 0em;\n    padding: 0em;\n  }\n\n  /* Coupling */\n  .ui.container > .ui.stackable.grid > .column,\n  .ui.container > .ui.stackable.grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n\n  /* Don't pad inside segment or nested grid */\n  .ui.grid .ui.stackable.grid,\n  .ui.segment:not(.vertical) .ui.stackable.page.grid {\n    margin-left: -(@stackableGutter / 2) !important;\n    margin-right: -(@stackableGutter / 2) !important;\n  }\n\n  /* Divided Stackable */\n  .ui.stackable.divided.grid > .row:first-child > .column:first-child,\n  .ui.stackable.celled.grid > .row:first-child > .column:first-child,\n  .ui.stackable.divided.grid > .column:not(.row):first-child,\n  .ui.stackable.celled.grid > .column:not(.row):first-child {\n    border-top: none !important;\n  }\n  .ui.inverted.stackable.celled.grid > .column:not(.row),\n  .ui.inverted.stackable.divided.grid > .column:not(.row),\n  .ui.inverted.stackable.celled.grid > .row > .column,\n  .ui.inverted.stackable.divided.grid > .row > .column {\n    border-top: @stackableInvertedMobileBorder;\n  }\n\n  .ui.stackable.celled.grid > .column:not(.row),\n  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n  .ui.stackable.celled.grid > .row > .column,\n  .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    border-top: @stackableMobileBorder;\n    box-shadow: none !important;\n    padding-top: @stackableRowSpacing !important;\n    padding-bottom: @stackableRowSpacing !important;\n  }\n\n  .ui.stackable.celled.grid > .row {\n    box-shadow: none !important;\n  }\n  .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n  .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n\n}\n\n/*----------------------\n     Only (Device)\n-----------------------*/\n\n\n/* These include arbitrary class repetitions for forced specificity */\n\n/* Mobile Only Hide */\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n/* Tablet Only Hide */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.tablet),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.tablet) {\n    display: none !important;\n  }\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.tablet),\n  .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.tablet),\n  .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.tablet) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Computer Only Hide */\n@media only screen and (min-width: @computerBreakpoint) and (max-width: @largestSmallMonitor) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Large Screen Only Hide */\n@media only screen and (min-width: @largeMonitorBreakpoint) and (max-width: @largestLargeMonitor) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n  .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n  .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Widescreen Only Hide */\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n  .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n  .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n}\n\n\n.loadUIOverrides();\n","/*\n * # Semantic - Menu\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2015 Contributor\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'menu';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Menu\n---------------*/\n\n.ui.menu {\n  display: flex;\n  margin: @margin;\n  font-family: @fontFamily;\n  background: @background;\n  font-weight: @fontWeight;\n  border: @border;\n  box-shadow: @boxShadow;\n  border-radius: @borderRadius;\n  min-height: @minHeight;\n}\n\n.ui.menu:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n\n.ui.menu:first-child {\n  margin-top: 0rem;\n}\n.ui.menu:last-child {\n  margin-bottom: 0rem;\n}\n\n\n/*--------------\n    Sub-Menu\n---------------*/\n\n.ui.menu .menu {\n  margin: 0em;\n}\n\n.ui.menu:not(.vertical) > .menu {\n  display: flex;\n}\n\n/*--------------\n      Item\n---------------*/\n\n.ui.menu:not(.vertical) .item {\n  display: flex;\n  align-items: center;\n}\n\n.ui.menu .item {\n  position: relative;\n  vertical-align: middle;\n  line-height: 1;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  flex: 0 0 auto;\n  user-select: none;\n\n  background: @itemBackground;\n  padding: @itemVerticalPadding @itemHorizontalPadding;\n  text-transform: @itemTextTransform;\n  color: @itemTextColor;\n  font-weight: @itemFontWeight;\n  transition: @itemTransition;\n}\n\n.ui.menu > .item:first-child {\n  border-radius: @borderRadius 0px 0px @borderRadius;\n}\n\n/* Border */\n.ui.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  right: 0px;\n  height: 100%;\n\n  width: @dividerSize;\n  background: @dividerBackground;\n}\n\n/*--------------\n  Text Content\n---------------*/\n\n.ui.menu .text.item > *,\n.ui.menu .item > a:not(.ui),\n.ui.menu .item > p:only-child {\n  user-select: text;\n  line-height: @textLineHeight;\n}\n.ui.menu .item > p:first-child {\n  margin-top: 0;\n}\n.ui.menu .item > p:last-child {\n  margin-bottom: 0;\n}\n\n/*--------------\n      Icons\n---------------*/\n\n.ui.menu .item > i.icon {\n  opacity: @iconOpacity;\n  float: @iconFloat;\n  margin: @iconMargin;\n}\n\n/*--------------\n     Button\n---------------*/\n\n.ui.menu:not(.vertical) .item > .button {\n  position: relative;\n  top: @buttonOffset;\n  margin: @buttonMargin;\n  padding-bottom: @buttonVerticalPadding;\n  padding-top: @buttonVerticalPadding;\n  font-size: @buttonSize;\n}\n\n/*----------------\n Grid / Container\n-----------------*/\n\n.ui.menu >  .grid,\n.ui.menu > .container {\n  display: flex;\n  align-items: inherit;\n  flex-direction: inherit;\n}\n\n/*--------------\n     Inputs\n---------------*/\n\n.ui.menu .item > .input {\n  width: 100%;\n}\n.ui.menu:not(.vertical) .item > .input {\n  position: relative;\n  top: @inputOffset;\n  margin: @inputVerticalMargin 0em;\n}\n.ui.menu .item > .input input {\n  font-size: @inputSize;\n  padding-top: @inputVerticalPadding;\n  padding-bottom: @inputVerticalPadding;\n}\n\n\n/*--------------\n     Header\n---------------*/\n\n.ui.menu .header.item,\n.ui.vertical.menu .header.item {\n  margin: 0em;\n  background: @headerBackground;\n  text-transform: @headerTextTransform;\n  font-weight: @headerWeight;\n}\n\n.ui.vertical.menu .item > .header:not(.ui) {\n  margin: @verticalHeaderMargin;\n  font-size: @verticalHeaderFontSize;\n  font-weight: @verticalHeaderFontWeight;\n}\n\n/*--------------\n    Dropdowns\n---------------*/\n\n\n/* Dropdown Icon */\n.ui.menu .item > i.dropdown.icon {\n  padding: 0em;\n  float: @dropdownIconFloat;\n  margin: 0em 0em 0em @dropdownIconDistance;\n}\n\n/* Menu */\n.ui.menu .dropdown.item .menu {\n  min-width: calc(100% - 1px);\n  border-radius: 0em 0em @dropdownMenuBorderRadius @dropdownMenuBorderRadius;\n  background: @dropdownBackground;\n  margin: @dropdownMenuDistance 0px 0px;\n  box-shadow: @dropdownMenuBoxShadow;\n  flex-direction: column !important;\n}\n\n\n/* Menu Items */\n.ui.menu .ui.dropdown .menu > .item {\n  margin: 0;\n  text-align: left;\n  font-size: @dropdownItemFontSize !important;\n  padding: @dropdownItemPadding !important;\n  background: @dropdownItemBackground !important;\n  color: @dropdownItemColor !important;\n  text-transform: @dropdownItemTextTransform !important;\n  font-weight: @dropdownItemFontWeight !important;\n  box-shadow: @dropdownItemBoxShadow !important;\n  transition: @dropdownItemTransition !important;\n}\n.ui.menu .ui.dropdown .menu > .item:hover {\n  background: @dropdownHoveredItemBackground !important;\n  color: @dropdownHoveredItemColor !important;\n}\n.ui.menu .ui.dropdown .menu > .selected.item {\n  background: @dropdownSelectedItemBackground !important;\n  color: @dropdownSelectedItemColor !important;\n}\n.ui.menu .ui.dropdown .menu > .active.item {\n  background: @dropdownActiveItemBackground !important;\n  font-weight: @dropdownActiveItemFontWeight !important;\n  color: @dropdownActiveItemColor !important;\n}\n\n.ui.menu .ui.dropdown.item .menu .item:not(.filtered) {\n  display: block;\n}\n.ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {\n  display: inline-block;\n  font-size: @dropdownItemIconFontSize !important;\n  float: @dropdownItemIconFloat;\n  margin: @dropdownItemIconMargin !important;\n}\n\n\n/* Secondary */\n.ui.secondary.menu .dropdown.item > .menu,\n.ui.text.menu .dropdown.item > .menu {\n  border-radius: @dropdownMenuBorderRadius;\n  margin-top: @secondaryDropdownMenuDistance;\n}\n\n/* Pointing */\n.ui.menu .pointing.dropdown.item .menu {\n  margin-top: @pointingDropdownMenuDistance;\n}\n\n/* Inverted */\n.ui.inverted.menu .search.dropdown.item > .search,\n.ui.inverted.menu .search.dropdown.item > .text {\n  color: @invertedSelectionDropdownColor;\n}\n\n/* Vertical */\n.ui.vertical.menu .dropdown.item > .icon {\n  float: right;\n  content: \"\\f0da\";\n  margin-left: 1em;\n}\n.ui.vertical.menu .dropdown.item .menu {\n  left: 100%;\n  min-width: 0;\n  margin: 0em 0em 0em @dropdownMenuDistance;\n  box-shadow: @dropdownVerticalMenuBoxShadow;\n  border-radius: 0em @dropdownMenuBorderRadius @dropdownMenuBorderRadius @dropdownMenuBorderRadius;\n}\n.ui.vertical.menu .dropdown.item.upward .menu {\n  bottom: 0;\n}\n.ui.vertical.menu .dropdown.item:not(.upward) .menu {\n  top: 0;\n}\n.ui.vertical.menu .active.dropdown.item {\n  border-top-right-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n.ui.vertical.menu .dropdown.active.item {\n  box-shadow: none;\n}\n\n/* Evenly Divided */\n.ui.item.menu .dropdown .menu .item {\n  width: 100%;\n}\n\n/*--------------\n     Labels\n---------------*/\n\n.ui.menu .item > .label {\n  background: @labelBackground;\n  color: @labelTextColor;\n  margin-left: @labelTextMargin;\n  padding: @labelVerticalPadding @labelHorizontalPadding;\n}\n.ui.vertical.menu .item > .label {\n  background: @labelBackground;\n  color: @labelTextColor;\n  margin-top: @labelOffset;\n  margin-bottom: @labelOffset;\n  padding: @labelVerticalPadding @labelHorizontalPadding;\n}\n.ui.menu .item > .floating.label {\n  padding: @labelVerticalPadding @labelHorizontalPadding;\n}\n\n/*--------------\n     Images\n---------------*/\n\n.ui.menu .item > img:not(.ui) {\n  display: inline-block;\n  vertical-align: middle;\n  margin: @imageMargin;\n  width: @imageWidth;\n}\n.ui.vertical.menu .item > img:not(.ui):only-child {\n  display: block;\n  max-width: 100%;\n  width: @verticalImageWidth;\n}\n\n/*******************************\n          Coupling\n*******************************/\n\n/*--------------\n     List\n---------------*/\n\n/* Menu divider shouldnt apply */\n.ui.menu .list .item:before {\n  background: none !important;\n}\n\n/*--------------\n     Sidebar\n---------------*/\n\n/* Show vertical dividers below last */\n\n.ui.vertical.sidebar.menu > .item:first-child:before {\n  display: block !important;\n}\n.ui.vertical.sidebar.menu > .item::before {\n  top: auto;\n  bottom: 0px;\n}\n\n/*--------------\n    Container\n---------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.menu > .ui.container {\n    width: 100% !important;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n}\n@media only screen and (min-width: @tabletBreakpoint) {\n  .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {\n    border-left: @dividerSize solid @dividerBackground;\n  }\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n      Hover\n---------------*/\n\n\n.ui.link.menu .item:hover,\n.ui.menu .dropdown.item:hover,\n.ui.menu .link.item:hover,\n.ui.menu a.item:hover {\n  cursor: pointer;\n  background: @hoverItemBackground;\n  color: @hoverItemTextColor;\n}\n\n\n/*--------------\n     Pressed\n---------------*/\n\n.ui.link.menu .item:active,\n.ui.menu .link.item:active,\n.ui.menu a.item:active {\n  background: @pressedItemBackground;\n  color: @pressedItemTextColor;\n}\n\n\n/*--------------\n     Active\n---------------*/\n\n.ui.menu .active.item  {\n  background: @activeItemBackground;\n  color: @activeItemTextColor;\n  font-weight: @activeItemFontWeight;\n  box-shadow: @activeItemBoxShadow;\n}\n.ui.menu .active.item > i.icon {\n  opacity: @activeIconOpacity;\n}\n\n/*--------------\n  Active Hover\n---------------*/\n\n.ui.menu .active.item:hover,\n.ui.vertical.menu .active.item:hover {\n  background-color: @activeHoverItemBackground;\n  color: @activeHoverItemColor;\n}\n\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.menu .item.disabled,\n.ui.menu .item.disabled:hover {\n  cursor: default !important;\n  background-color: transparent !important;\n  color: @disabledTextColor !important;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n/*------------------\nFloated Menu / Item\n-------------------*/\n\n/* Left Floated */\n.ui.menu:not(.vertical) .left.item,\n.ui.menu:not(.vertical) :not(.dropdown) > .left.menu {\n  display: flex;\n  margin-right: auto !important;\n}\n/* Right Floated */\n.ui.menu:not(.vertical) .right.item,\n.ui.menu:not(.vertical) .right.menu {\n  display: flex;\n  margin-left: auto !important;\n}\n\n/* Swapped Borders */\n.ui.menu .right.item::before,\n.ui.menu .right.menu > .item::before {\n  right: auto;\n  left: 0;\n}\n\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.menu {\n  display: block;\n  flex-direction: column;\n  background: @verticalBackground;\n  box-shadow: @verticalBoxShadow;\n}\n\n/*--- Item ---*/\n.ui.vertical.menu .item {\n  display: block;\n  background: @verticalItemBackground;\n  border-top: none;\n  border-right: none;\n}\n.ui.vertical.menu > .item:first-child {\n  border-radius: @borderRadius @borderRadius 0px 0px;\n}\n.ui.vertical.menu > .item:last-child {\n  border-radius: 0px 0px @borderRadius @borderRadius;\n}\n\n/*--- Label ---*/\n.ui.vertical.menu .item > .label {\n  float: right;\n  text-align: center;\n}\n\n/*--- Icon ---*/\n.ui.vertical.menu .item > i.icon {\n  width: @iconWidth;\n  float: @verticalIconFloat;\n  margin: @verticalIconMargin;\n}\n.ui.vertical.menu .item > .label + i.icon {\n  float: @labelAndIconFloat;\n  margin: @labelAndIconMargin;\n}\n\n\n/*--- Border ---*/\n.ui.vertical.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0px;\n  width: 100%;\n  height: @dividerSize;\n  background: @verticalDividerBackground;\n}\n\n.ui.vertical.menu .item:first-child:before {\n  display: none !important;\n}\n\n\n/*--- Sub Menu ---*/\n.ui.vertical.menu .item > .menu {\n  margin: @subMenuMargin;\n}\n.ui.vertical.menu .menu .item {\n  background: none;\n  padding: @subMenuVerticalPadding @subMenuHorizontalPadding;\n  font-size: @subMenuFontSize;\n  color: @subMenuTextColor;\n}\n.ui.vertical.menu .item .menu a.item:hover,\n.ui.vertical.menu .item .menu .link.item:hover {\n  color: @darkTextColor;\n}\n.ui.vertical.menu .menu .item:before {\n  display: none;\n}\n\n/* Vertical Active */\n.ui.vertical.menu .active.item {\n  background: @activeItemBackground;\n  border-radius: 0em;\n  box-shadow: @verticalActiveBoxShadow;\n}\n.ui.vertical.menu > .active.item:first-child {\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui.vertical.menu > .active.item:last-child {\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n.ui.vertical.menu > .active.item:only-child {\n  border-radius: @borderRadius;\n}\n.ui.vertical.menu .active.item .menu .active.item {\n  border-left: none;\n}\n.ui.vertical.menu .item .menu .active.item {\n  background-color: @subMenuActiveBackground;\n  font-weight: @subMenuActiveFontWeight;\n  color: @subMenuActiveTextColor;\n}\n\n\n/*--------------\n     Tabular\n---------------*/\n\n.ui.tabular.menu {\n  border-radius: 0em;\n  box-shadow: none !important;\n  border: none;\n  background: @tabularBackground;\n  border-bottom: @tabularBorderWidth solid @tabularBorderColor;\n}\n.ui.tabular.fluid.menu {\n  width: @tabularFluidWidth !important;\n}\n.ui.tabular.menu .item {\n  background: transparent;\n  border-bottom: none;\n\n  border-left: @tabularBorderWidth solid transparent;\n  border-right: @tabularBorderWidth solid transparent;\n  border-top: @tabularOppositeBorderWidth solid transparent;\n  padding: @tabularVerticalPadding @tabularHorizontalPadding;\n  color: @tabularTextColor;\n}\n.ui.tabular.menu .item:before {\n  display: none;\n}\n\n/* Hover */\n.ui.tabular.menu .item:hover {\n  background-color: transparent;\n  color: @tabularHoveredTextColor;\n}\n\n/* Active */\n.ui.tabular.menu .active.item {\n  background: @tabularActiveBackground;\n  color: @tabularActiveColor;\n  border-top-width: @tabularBorderWidth;\n  border-color: @tabularBorderColor;\n  font-weight: @tabularActiveWeight;\n  margin-bottom: -@tabularBorderWidth;\n  box-shadow: @tabularActiveBoxShadow;\n  border-radius: @tabularBorderRadius @tabularBorderRadius 0px 0px !important;\n}\n\n/* Coupling with segment for attachment */\n.ui.tabular.menu + .attached:not(.top).segment,\n.ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {\n  border-top: none;\n  margin-left: 0px;\n  margin-top: 0px;\n  margin-right: 0px;\n  width: 100%;\n}\n.top.attached.segment + .ui.bottom.tabular.menu {\n  position: relative;\n  width: @tabularFluidWidth;\n  left: -@tabularFluidOffset;\n}\n\n/* Bottom Vertical Tabular */\n.ui.bottom.tabular.menu {\n  background: @tabularBackground;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-top: @tabularBorderWidth solid @tabularBorderColor;\n}\n.ui.bottom.tabular.menu .item {\n  background: none;\n  border-left: @tabularBorderWidth solid transparent;\n  border-right: @tabularBorderWidth solid transparent;\n  border-bottom: @tabularBorderWidth solid transparent;\n  border-top: none;\n}\n.ui.bottom.tabular.menu .active.item {\n  background: @tabularActiveBackground;\n  color: @tabularActiveColor;\n  border-color: @tabularBorderColor;\n  margin: -@tabularBorderWidth 0px 0px 0px;\n  border-radius: 0px 0px @tabularBorderRadius @tabularBorderRadius !important;\n}\n\n/* Vertical Tabular (Left) */\n.ui.vertical.tabular.menu {\n  background: @tabularVerticalBackground;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: @tabularBorderWidth solid @tabularBorderColor;\n}\n.ui.vertical.tabular.menu .item {\n  background: none;\n  border-left: @tabularBorderWidth solid transparent;\n  border-bottom: @tabularBorderWidth solid transparent;\n  border-top: @tabularBorderWidth solid transparent;\n  border-right: none;\n}\n.ui.vertical.tabular.menu .active.item {\n  background: @tabularActiveBackground;\n  color: @tabularActiveColor;\n  border-color: @tabularBorderColor;\n  margin: 0px -@tabularBorderWidth 0px 0px;\n  border-radius: @tabularBorderRadius 0px 0px @tabularBorderRadius !important;\n}\n\n/* Vertical Right Tabular */\n.ui.vertical.right.tabular.menu {\n  background: @tabularVerticalBackground;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: none;\n  border-left: @tabularBorderWidth solid @tabularBorderColor;\n}\n.ui.vertical.right.tabular.menu .item {\n  background: none;\n  border-right: @tabularBorderWidth solid transparent;\n  border-bottom: @tabularBorderWidth solid transparent;\n  border-top: @tabularBorderWidth solid transparent;\n  border-left: none;\n}\n.ui.vertical.right.tabular.menu .active.item {\n  background: @tabularActiveBackground;\n  color: @tabularActiveColor;\n  border-color: @tabularBorderColor;\n  margin: 0px 0px 0px -@tabularBorderWidth;\n  border-radius: 0px @tabularBorderRadius @tabularBorderRadius 0px !important;\n}\n\n/* Dropdown */\n.ui.tabular.menu .active.dropdown.item {\n  margin-bottom: 0px;\n  border-left: @tabularBorderWidth solid transparent;\n  border-right: @tabularBorderWidth solid transparent;\n  border-top: @tabularOppositeBorderWidth solid transparent;\n  border-bottom: none;\n}\n\n\n\n/*--------------\n   Pagination\n---------------*/\n\n.ui.pagination.menu {\n  margin: 0em;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.ui.pagination.menu .item:last-child {\n  border-radius: 0em @borderRadius @borderRadius 0em;\n}\n.ui.compact.menu .item:last-child {\n  border-radius: 0em @borderRadius @borderRadius 0em;\n}\n.ui.pagination.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.pagination.menu .item {\n  min-width: @paginationMinWidth;\n  text-align: center;\n}\n.ui.pagination.menu .icon.item i.icon {\n  vertical-align: top;\n}\n\n/* Active */\n.ui.pagination.menu .active.item {\n  border-top: none;\n  padding-top: @itemVerticalPadding;\n  background-color: @paginationActiveBackground;\n  color: @paginationActiveTextColor;\n  box-shadow: none;\n}\n\n/*--------------\n   Secondary\n---------------*/\n\n.ui.secondary.menu {\n  background: @secondaryBackground;\n  margin-left: -@secondaryItemSpacing;\n  margin-right: -@secondaryItemSpacing;\n  border-radius: 0em;\n  border: none;\n  box-shadow: none;\n}\n\n/* Item */\n.ui.secondary.menu .item {\n  align-self: center;\n  box-shadow: none;\n  border: none;\n  padding: @secondaryItemPadding;\n  margin: @secondaryItemMargin;\n  background: @secondaryItemBackground;\n  transition: @secondaryItemTransition;\n  border-radius: @secondaryItemBorderRadius;\n}\n\n/* No Divider */\n.ui.secondary.menu .item:before {\n  display: none !important;\n}\n\n/* Header */\n.ui.secondary.menu .header.item {\n  border-radius: 0em;\n  border-right: @secondaryHeaderBorder;\n  background: @secondaryHeaderBackground;\n}\n\n/* Image */\n.ui.secondary.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n\n/* Hover */\n.ui.secondary.menu .dropdown.item:hover,\n.ui.secondary.menu .link.item:hover,\n.ui.secondary.menu a.item:hover {\n  background: @secondaryHoverItemBackground;\n  color: @secondaryHoverItemColor;\n}\n\n/* Active */\n.ui.secondary.menu .active.item {\n  box-shadow: none;\n  background: @secondaryActiveItemBackground;\n  color: @secondaryActiveItemColor;\n  border-radius: @secondaryItemBorderRadius;\n}\n\n/* Active Hover */\n.ui.secondary.menu .active.item:hover {\n  box-shadow: none;\n  background: @secondaryActiveHoverItemBackground;\n  color: @secondaryActiveHoverItemColor;\n}\n\n\n/* Inverted */\n.ui.secondary.inverted.menu .link.item,\n.ui.secondary.inverted.menu a.item {\n  color: @secondaryInvertedColor !important;\n}\n.ui.secondary.inverted.menu .dropdown.item:hover,\n.ui.secondary.inverted.menu .link.item:hover,\n.ui.secondary.inverted.menu a.item:hover {\n  background: @secondaryInvertedHoverBackground;\n  color: @secondaryInvertedHoverColor !important;\n}\n.ui.secondary.inverted.menu .active.item {\n  background: @secondaryInvertedActiveBackground;\n  color: @secondaryInvertedActiveColor !important;\n}\n\n/* Fix item margins */\n.ui.secondary.item.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n.ui.secondary.item.menu .item:last-child {\n  margin-right: 0em;\n}\n.ui.secondary.attached.menu {\n  box-shadow: none;\n}\n\n/* Sub Menu */\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu {\n  margin: @secondaryMenuSubMenuMargin;\n}\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {\n  margin: @secondaryMenuSubMenuItemMargin;\n  padding: @secondaryMenuSubMenuItemPadding;\n}\n\n\n/*---------------------\n   Secondary Vertical\n-----------------------*/\n\n.ui.secondary.vertical.menu > .item {\n  border: none;\n  margin: @secondaryVerticalItemMargin;\n  border-radius: @secondaryVerticalItemBorderRadius !important;\n}\n.ui.secondary.vertical.menu > .header.item {\n  border-radius: 0em;\n}\n\n/* Sub Menu */\n.ui.vertical.secondary.menu .item > .menu .item {\n  background-color: transparent;\n}\n\n/* Inverted */\n.ui.secondary.inverted.menu {\n  background-color: transparent;\n}\n\n/*---------------------\n   Secondary Pointing\n-----------------------*/\n\n.ui.secondary.pointing.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n  border-bottom: @secondaryPointingBorderWidth solid @secondaryPointingBorderColor;\n}\n\n.ui.secondary.pointing.menu .item {\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-radius: 0em;\n  align-self: flex-end;\n\n  margin: 0em 0em -@secondaryPointingBorderWidth;\n  padding: @secondaryPointingItemVerticalPadding @secondaryPointingItemHorizontalPadding;\n  border-bottom-width: @secondaryPointingBorderWidth;\n  transition: @secondaryItemTransition;\n}\n\n/* Item Types */\n.ui.secondary.pointing.menu .header.item {\n  color: @secondaryPointingHeaderColor !important;\n}\n.ui.secondary.pointing.menu .text.item {\n  box-shadow: none !important;\n}\n.ui.secondary.pointing.menu .item:after {\n  display: none;\n}\n\n/* Hover */\n.ui.secondary.pointing.menu .dropdown.item:hover,\n.ui.secondary.pointing.menu .link.item:hover,\n.ui.secondary.pointing.menu a.item:hover {\n  background-color: transparent;\n  color: @secondaryPointingHoverTextColor;\n}\n\n/* Pressed */\n.ui.secondary.pointing.menu .dropdown.item:active,\n.ui.secondary.pointing.menu .link.item:active,\n.ui.secondary.pointing.menu a.item:active {\n  background-color: transparent;\n  border-color: @secondaryPointingBorderColor;\n}\n\n/* Active */\n.ui.secondary.pointing.menu .active.item {\n  background-color: transparent;\n  box-shadow: none;\n  border-color: @secondaryPointingActiveBorderColor;\n  font-weight: @secondaryPointingActiveFontWeight;\n  color: @secondaryPointingActiveTextColor;\n}\n\n/* Active Hover */\n.ui.secondary.pointing.menu .active.item:hover {\n  border-color: @secondaryPointingActiveHoverBorderColor;\n  color: @secondaryPointingActiveHoverTextColor;\n}\n\n/* Active Dropdown */\n.ui.secondary.pointing.menu .active.dropdown.item {\n  border-color: @secondaryPointingActiveDropdownBorderColor;\n}\n\n/* Vertical Pointing */\n.ui.secondary.vertical.pointing.menu {\n  border-bottom-width: 0px;\n  border-right-width: @secondaryPointingBorderWidth;\n  border-right-style: solid;\n  border-right-color: @secondaryPointingBorderColor;\n}\n.ui.secondary.vertical.pointing.menu .item {\n  border-bottom: none;\n  border-right-style: solid;\n  border-right-color: transparent;\n  border-radius: 0em !important;\n  margin: @secondaryVerticalPointingItemMargin;\n  border-right-width: @secondaryPointingBorderWidth;\n}\n\n/* Vertical Active */\n.ui.secondary.vertical.pointing.menu .active.item {\n  border-color: @secondaryPointingActiveBorderColor;\n}\n\n/* Inverted */\n.ui.secondary.inverted.pointing.menu {\n  border-color: @secondaryPointingInvertedBorderColor;\n}\n\n.ui.secondary.inverted.pointing.menu {\n  border-width: @secondaryPointingBorderWidth;\n  border-color: @secondaryPointingBorderColor;\n}\n.ui.secondary.inverted.pointing.menu .item {\n  color: @secondaryPointingInvertedItemTextColor;\n}\n.ui.secondary.inverted.pointing.menu .header.item {\n  color: @secondaryPointingInvertedItemHeaderColor !important;\n}\n\n/* Hover */\n.ui.secondary.inverted.pointing.menu .link.item:hover,\n.ui.secondary.inverted.pointing.menu a.item:hover {\n  color: @secondaryPointingInvertedItemHoverTextColor;\n}\n\n\n/* Active */\n.ui.secondary.inverted.pointing.menu .active.item {\n  border-color: @secondaryPointingInvertedActiveBorderColor;\n  color: @secondaryPointingInvertedActiveColor;\n}\n\n/*--------------\n    Text Menu\n---------------*/\n\n.ui.text.menu {\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n\n  margin: @textMenuMargin;\n}\n.ui.text.menu .item {\n  border-radius: 0px;\n  box-shadow: none;\n  align-self: center;\n  margin: @textMenuItemMargin;\n  padding: @textMenuItemPadding;\n  font-weight: @textMenuItemFontWeight;\n  color: @textMenuItemColor;\n  transition: @textMenuItemTransition;\n}\n\n/* Border */\n.ui.text.menu .item:before,\n.ui.text.menu .menu .item:before {\n  display: none !important;\n}\n\n/* Header */\n.ui.text.menu .header.item {\n  background-color: transparent;\n  opacity: 1;\n  color: @textMenuHeaderColor;\n  font-size: @textMenuHeaderSize;\n  text-transform: @textMenuHeaderTextTransform;\n  font-weight: @textMenuHeaderFontWeight;\n}\n\n/* Image */\n.ui.text.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n\n/*--- fluid text ---*/\n.ui.text.item.menu .item {\n  margin: 0em;\n}\n\n/*--- vertical text ---*/\n.ui.vertical.text.menu {\n  margin: @textVerticalMenuMargin;\n}\n.ui.vertical.text.menu:first-child {\n  margin-top: 0rem;\n}\n.ui.vertical.text.menu:last-child {\n  margin-bottom: 0rem;\n}\n.ui.vertical.text.menu .item {\n  margin: @textVerticalMenuItemMargin;\n  padding-left: 0em;\n  padding-right: 0em;\n}\n.ui.vertical.text.menu .item > i.icon {\n  float: @textVerticalMenuIconFloat;\n  margin: @iconMargin;\n}\n.ui.vertical.text.menu .header.item {\n  margin: @textVerticalMenuHeaderMargin;\n}\n\n/* Vertical Sub Menu */\n.ui.vertical.text.menu .item:not(.dropdown) > .menu {\n  margin: @textMenuSubMenuMargin;\n}\n.ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {\n  margin: @textMenuSubMenuItemMargin;\n  padding: @textMenuSubMenuItemPadding;\n}\n\n/*--- hover ---*/\n.ui.text.menu .item:hover {\n  opacity: 1;\n  background-color: transparent;\n}\n\n/*--- active ---*/\n.ui.text.menu .active.item {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-weight: @textMenuActiveItemFontWeight;\n  color: @textMenuActiveItemColor;\n}\n\n/*--- active hover ---*/\n.ui.text.menu .active.item:hover {\n  background-color: transparent;\n}\n\n/* Disable Bariations */\n.ui.text.pointing.menu .active.item:after {\n  box-shadow: none;\n}\n.ui.text.attached.menu {\n  box-shadow: none;\n}\n\n/* Inverted */\n.ui.inverted.text.menu,\n.ui.inverted.text.menu .item,\n.ui.inverted.text.menu .item:hover,\n.ui.inverted.text.menu .active.item {\n  background-color: transparent !important;\n}\n\n/* Fluid */\n.ui.fluid.text.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n\n/*--------------\n    Icon Only\n---------------*/\n\n/* Vertical Menu */\n.ui.vertical.icon.menu {\n  display: inline-block;\n  width: auto;\n}\n\n/* Item */\n.ui.icon.menu .item {\n  height: auto;\n  text-align: @iconMenuTextAlign;\n  color: @iconMenuItemColor;\n}\n\n/* Icon */\n.ui.icon.menu .item > .icon:not(.dropdown) {\n  margin: 0;\n  opacity: 1;\n}\n\n/* Icon Gylph */\n.ui.icon.menu .icon:before {\n  opacity: 1;\n}\n\n/* (x) Item Icon */\n.ui.menu .icon.item > .icon {\n  width: auto;\n  margin: 0em auto;\n}\n\n/* Vertical Icon */\n.ui.vertical.icon.menu .item > .icon:not(.dropdown) {\n  display: block;\n  opacity: 1;\n  margin: 0em auto;\n  float: none;\n}\n\n/* Inverted */\n.ui.inverted.icon.menu .item {\n  color: @iconMenuInvertedItemColor;\n}\n\n/*--------------\n   Labeled Icon\n---------------*/\n\n/* Menu */\n.ui.labeled.icon.menu {\n  text-align: center;\n}\n\n/* Item */\n.ui.labeled.icon.menu .item {\n  min-width: @labeledIconMinWidth;\n  flex-direction: column;\n}\n\n/* Icon */\n.ui.labeled.icon.menu .item > .icon:not(.dropdown) {\n  height: 1em;\n  display: block;\n  font-size: @labeledIconSize !important;\n  margin: 0em auto @labeledIconTextMargin !important;\n}\n\n/* Fluid */\n.ui.fluid.labeled.icon.menu > .item {\n  min-width: 0em;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Stackable\n---------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.stackable.menu {\n    flex-direction: column;\n  }\n  .ui.stackable.menu .item {\n    width: 100% !important;\n  }\n  .ui.stackable.menu .item:before {\n    position: absolute;\n    content: '';\n    top: auto;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    height: @dividerSize;\n    background: @verticalDividerBackground;\n  }\n\n  .ui.stackable.menu .left.menu,\n  .ui.stackable.menu .left.item {\n    margin-right: 0 !important;\n  }\n  .ui.stackable.menu .right.menu,\n  .ui.stackable.menu .right.item {\n    margin-left: 0 !important;\n  }\n\n  .ui.stackable.menu .right.menu,\n  .ui.stackable.menu .left.menu {\n    flex-direction: column;\n  }\n}\n\n/*--------------\n     Colors\n---------------*/\n\n/*--- Standard Colors  ---*/\n.ui.menu .red.active.item,\n.ui.red.menu .active.item {\n  border-color: @red !important;\n  color: @red !important;\n}\n.ui.menu .orange.active.item,\n.ui.orange.menu .active.item {\n  border-color: @orange !important;\n  color: @orange !important;\n}\n.ui.menu .yellow.active.item,\n.ui.yellow.menu .active.item {\n  border-color: @yellow !important;\n  color: @yellow !important;\n}\n.ui.menu .olive.active.item,\n.ui.olive.menu .active.item {\n  border-color: @olive !important;\n  color: @olive !important;\n}\n.ui.menu .green.active.item,\n.ui.green.menu .active.item {\n  border-color: @green !important;\n  color: @green !important;\n}\n.ui.menu .teal.active.item,\n.ui.teal.menu .active.item {\n  border-color: @teal !important;\n  color: @teal !important;\n}\n.ui.menu .blue.active.item,\n.ui.blue.menu .active.item {\n  border-color: @blue !important;\n  color: @blue !important;\n}\n.ui.menu .violet.active.item,\n.ui.violet.menu .active.item {\n  border-color: @violet !important;\n  color: @violet !important;\n}\n.ui.menu .purple.active.item,\n.ui.purple.menu .active.item {\n  border-color: @purple !important;\n  color: @purple !important;\n}\n.ui.menu .pink.active.item,\n.ui.pink.menu .active.item {\n  border-color: @pink !important;\n  color: @pink !important;\n}\n.ui.menu .brown.active.item,\n.ui.brown.menu .active.item {\n  border-color: @brown !important;\n  color: @brown !important;\n}\n.ui.menu .grey.active.item,\n.ui.grey.menu .active.item {\n  border-color: @grey !important;\n  color: @grey !important;\n}\n\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.menu {\n  border: @invertedBorder;\n  background: @invertedBackground;\n  box-shadow: @invertedBoxShadow;\n}\n\n/* Menu Item */\n.ui.inverted.menu .item,\n.ui.inverted.menu .item > a:not(.ui) {\n  background: @invertedItemBackground;\n  color: @invertedItemTextColor;\n}\n.ui.inverted.menu .item.menu {\n  background: @invertedSubMenuBackground;\n}\n\n/*--- Border ---*/\n.ui.inverted.menu .item:before {\n  background: @invertedDividerBackground;\n}\n.ui.vertical.inverted.menu .item:before {\n  background: @invertedVerticalDividerBackground;\n}\n\n/* Sub Menu */\n.ui.vertical.inverted.menu .menu .item,\n.ui.vertical.inverted.menu .menu .item a:not(.ui) {\n  color: @invertedSubMenuColor;\n}\n\n/* Header */\n.ui.inverted.menu .header.item {\n  margin: 0em;\n  background: @invertedHeaderBackground;\n  box-shadow: none;\n}\n\n/* Disabled */\n.ui.inverted.menu .item.disabled,\n.ui.inverted.menu .item.disabled:hover {\n  color: @invertedDisabledTextColor;\n}\n\n/*--- Hover ---*/\n.ui.link.inverted.menu .item:hover,\n.ui.inverted.menu .dropdown.item:hover,\n.ui.inverted.menu .link.item:hover,\n.ui.inverted.menu a.item:hover {\n  background: @invertedHoverBackground;\n  color: @invertedHoverColor;\n}\n.ui.vertical.inverted.menu .item .menu a.item:hover,\n.ui.vertical.inverted.menu .item .menu .link.item:hover {\n  background: @invertedSubMenuBackground;\n  color: @invertedSubMenuHoverColor;\n}\n\n/*--- Pressed ---*/\n.ui.inverted.menu a.item:active,\n.ui.inverted.menu .link.item:active{\n  background: @invertedMenuPressedBackground;\n  color: @invertedMenuPressedColor;\n}\n\n/*--- Active ---*/\n.ui.inverted.menu .active.item {\n  background: @invertedActiveBackground;\n  color: @invertedActiveColor !important;\n}\n.ui.inverted.vertical.menu .item .menu .active.item {\n  background: @invertedSubMenuActiveBackground;\n  color: @invertedSubMenuActiveColor;\n}\n.ui.inverted.pointing.menu .active.item:after {\n  background: @invertedArrowActiveColor !important;\n  margin: 0em !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n/*--- Active Hover ---*/\n.ui.inverted.menu .active.item:hover {\n  background: @invertedActiveHoverBackground;\n  color: @invertedActiveHoverColor !important;\n}\n.ui.inverted.pointing.menu .active.item:hover:after {\n  background: @invertedArrowActiveHoverColor !important;\n}\n\n\n/*--------------\n     Floated\n---------------*/\n\n.ui.floated.menu {\n  float: left;\n  margin: 0rem @floatedDistance 0rem 0rem;\n}\n.ui.floated.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.right.floated.menu {\n  float: right;\n  margin: 0rem 0rem 0rem @floatedDistance;\n}\n\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Red */\n.ui.inverted.menu .red.active.item,\n.ui.inverted.red.menu {\n  background-color: @red;\n}\n.ui.inverted.red.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.red.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Orange */\n.ui.inverted.menu .orange.active.item,\n.ui.inverted.orange.menu {\n  background-color: @orange;\n}\n.ui.inverted.orange.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.orange.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Yellow */\n.ui.inverted.menu .yellow.active.item,\n.ui.inverted.yellow.menu {\n  background-color: @yellow;\n}\n.ui.inverted.yellow.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.yellow.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Olive */\n.ui.inverted.menu .olive.active.item,\n.ui.inverted.olive.menu {\n  background-color: @olive;\n}\n.ui.inverted.olive.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.olive.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Green */\n.ui.inverted.menu .green.active.item,\n.ui.inverted.green.menu {\n  background-color: @green;\n}\n.ui.inverted.green.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.green.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Teal */\n.ui.inverted.menu .teal.active.item,\n.ui.inverted.teal.menu {\n  background-color: @teal;\n}\n.ui.inverted.teal.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.teal.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Blue */\n.ui.inverted.menu .blue.active.item,\n.ui.inverted.blue.menu {\n  background-color: @blue;\n}\n.ui.inverted.blue.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.blue.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Violet */\n.ui.inverted.menu .violet.active.item,\n.ui.inverted.violet.menu {\n  background-color: @violet;\n}\n.ui.inverted.violet.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.violet.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Purple */\n.ui.inverted.menu .purple.active.item,\n.ui.inverted.purple.menu {\n  background-color: @purple;\n}\n.ui.inverted.purple.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.purple.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Pink */\n.ui.inverted.menu .pink.active.item,\n.ui.inverted.pink.menu {\n  background-color: @pink;\n}\n.ui.inverted.pink.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.pink.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Brown */\n.ui.inverted.menu .brown.active.item,\n.ui.inverted.brown.menu {\n  background-color: @brown;\n}\n.ui.inverted.brown.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.brown.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n/* Grey */\n.ui.inverted.menu .grey.active.item,\n.ui.inverted.grey.menu {\n  background-color: @grey;\n}\n.ui.inverted.grey.menu .item:before {\n  background-color: @invertedColoredDividerBackground;\n}\n.ui.inverted.grey.menu .active.item {\n  background-color: @invertedColoredActiveBackground !important;\n}\n\n\n/*--------------\n     Fitted\n---------------*/\n\n.ui.fitted.menu .item,\n.ui.fitted.menu .item .menu .item,\n.ui.menu .fitted.item {\n  padding: 0em;\n}\n.ui.horizontally.fitted.menu .item,\n.ui.horizontally.fitted.menu .item .menu .item,\n.ui.menu .horizontally.fitted.item {\n  padding-top: @itemVerticalPadding;\n  padding-bottom: @itemVerticalPadding;\n}\n.ui.vertically.fitted.menu .item,\n.ui.vertically.fitted.menu .item .menu .item,\n.ui.menu .vertically.fitted.item {\n  padding-left: @itemHorizontalPadding;\n  padding-right: @itemHorizontalPadding;\n}\n\n/*--------------\n   Borderless\n---------------*/\n\n.ui.borderless.menu .item:before,\n.ui.borderless.menu .item .menu .item:before,\n.ui.menu .borderless.item:before {\n  background: none !important;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.menu {\n  display: inline-flex;\n  margin: 0em;\n  vertical-align: middle;\n}\n.ui.compact.vertical.menu {\n  display: inline-block;\n}\n.ui.compact.menu .item:last-child {\n  border-radius: 0em @borderRadius @borderRadius 0em;\n}\n.ui.compact.menu .item:last-child:before {\n  display: none;\n}\n.ui.compact.vertical.menu {\n  width: auto !important;\n}\n.ui.compact.vertical.menu .item:last-child::before {\n  display: block;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.menu.fluid,\n.ui.vertical.menu.fluid {\n  width: 100% !important;\n}\n\n\n/*-------------------\n      Evenly Sized\n--------------------*/\n\n.ui.item.menu,\n.ui.item.menu .item {\n  width: 100%;\n  padding-left: 0em !important;\n  padding-right: 0em !important;\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n  text-align: center;\n  justify-content: center;\n}\n.ui.attached.item.menu {\n  margin: 0em @attachedHorizontalOffset !important;\n}\n\n.ui.item.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.menu.two.item .item {\n  width: 50%;\n}\n.ui.menu.three.item .item {\n  width: 33.333%;\n}\n.ui.menu.four.item .item {\n  width: 25%;\n}\n.ui.menu.five.item .item {\n  width: 20%;\n}\n.ui.menu.six.item .item {\n  width: 16.666%;\n}\n.ui.menu.seven.item .item {\n  width: 14.285%;\n}\n.ui.menu.eight.item .item {\n  width: 12.500%;\n}\n.ui.menu.nine.item .item {\n  width: 11.11%;\n}\n.ui.menu.ten.item .item {\n  width: 10.0%;\n}\n.ui.menu.eleven.item .item {\n  width: 9.09%;\n}\n.ui.menu.twelve.item .item {\n  width: 8.333%;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.menu.fixed {\n  position: fixed;\n  z-index: 101;\n  margin: 0em;\n  width: 100%;\n}\n.ui.menu.fixed,\n.ui.menu.fixed .item:first-child,\n.ui.menu.fixed .item:last-child {\n  border-radius: 0px !important;\n}\n\n.ui.fixed.menu,\n.ui[class*=\"top fixed\"].menu {\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n}\n.ui[class*=\"top fixed\"].menu {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n.ui[class*=\"right fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n  top: 0px;\n  right: 0px;\n  left: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n.ui[class*=\"bottom fixed\"].menu {\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  bottom: 0px;\n  left: 0px;\n  top: auto;\n  right: auto;\n}\n.ui[class*=\"left fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n\n/* Coupling with Grid */\n.ui.fixed.menu + .ui.grid {\n  padding-top: @fixedPrecedingGridMargin;\n}\n\n\n/*-------------------\n       Pointing\n--------------------*/\n\n.ui.pointing.menu .item:after {\n  visibility: hidden;\n  position: absolute;\n  content: '';\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  background: none;\n\n  margin: (@arrowBorderWidth / 2) 0em 0em;\n  width: @arrowSize;\n  height: @arrowSize;\n\n  border: none;\n  border-bottom: @arrowBorder;\n  border-right: @arrowBorder;\n\n  z-index: @arrowZIndex;\n  transition: @arrowTransition;\n}\n.ui.vertical.pointing.menu .item:after {\n  position: absolute;\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  margin: 0em -(@arrowBorderWidth / 2) 0em 0em;\n\n  border: none;\n  border-top: @arrowBorder;\n  border-right: @arrowBorder;\n}\n\n/* Active */\n.ui.pointing.menu .active.item:after {\n  visibility: visible;\n}\n.ui.pointing.menu .active.dropdown.item:after {\n  visibility: hidden;\n}\n\n/* Don't double up pointers */\n.ui.pointing.menu .dropdown.active.item:after,\n.ui.pointing.menu .active.item .menu .active.item:after {\n  display: none;\n}\n\n/* Colors */\n.ui.pointing.menu .active.item:hover:after {\n  background-color: @arrowHoverColor;\n}\n.ui.pointing.menu .active.item:after {\n  background-color: @arrowActiveColor;\n}\n.ui.pointing.menu .active.item:hover:after {\n  background-color: @arrowActiveHoverColor;\n}\n\n.ui.vertical.pointing.menu .active.item:hover:after {\n  background-color: @arrowVerticalHoverColor;\n}\n.ui.vertical.pointing.menu .active.item:after {\n  background-color: @arrowVerticalActiveColor;\n}\n.ui.vertical.pointing.menu .menu .active.item:after {\n  background-color: @arrowVerticalSubMenuColor;\n}\n\n\n\n/*--------------\n    Attached\n---------------*/\n\n/* Middle */\n.ui.attached.menu {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em @attachedHorizontalOffset;\n  width: @attachedWidth;\n  max-width: @attachedWidth;\n  box-shadow: @attachedBoxShadow;\n}\n.ui.attached + .ui.attached.menu:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n.ui[class*=\"top attached\"].menu {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: @attachedTopOffset;\n  margin-top: @verticalMargin;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui.menu[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n.ui[class*=\"bottom attached\"].menu {\n  bottom: 0px;\n  margin-top: 0em;\n  top: @attachedBottomOffset;\n  margin-bottom: @verticalMargin;\n  box-shadow: @attachedBottomBoxShadow;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n.ui[class*=\"bottom attached\"].menu:last-child {\n  margin-bottom: 0em;\n}\n\n/* Attached Menu Item */\n.ui.top.attached.menu > .item:first-child {\n  border-radius: @borderRadius 0em 0em 0em;\n}\n.ui.bottom.attached.menu > .item:first-child {\n  border-radius: 0em 0em 0em @borderRadius;\n}\n\n/* Tabular Attached */\n.ui.attached.menu:not(.tabular) {\n  border: @attachedBorder;\n}\n.ui.attached.inverted.menu {\n  border: none;\n}\n.ui.attached.tabular.menu {\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n/* Mini */\n.ui.mini.menu {\n  font-size: @mini;\n}\n.ui.mini.vertical.menu {\n  width: @miniWidth;\n}\n\n/* Tiny */\n.ui.tiny.menu {\n  font-size: @tiny;\n}\n.ui.tiny.vertical.menu {\n  width: @tinyWidth;\n}\n\n/* Small */\n.ui.small.menu {\n  font-size: @small;\n}\n.ui.small.vertical.menu {\n  width: @smallWidth;\n}\n\n/* Medium */\n.ui.menu {\n  font-size: @medium;\n}\n.ui.vertical.menu {\n  width: @mediumWidth;\n}\n\n/* Large */\n.ui.large.menu {\n  font-size: @large;\n}\n.ui.large.vertical.menu {\n  width: @largeWidth;\n}\n\n/* Huge */\n.ui.huge.menu {\n  font-size: @huge;\n}\n.ui.huge.vertical.menu {\n  width: @hugeWidth;\n}\n\n/* Big */\n.ui.big.menu {\n  font-size: @big;\n}\n.ui.big.vertical.menu {\n  width: @bigWidth;\n}\n\n/* Massive */\n.ui.massive.menu {\n  font-size: @massive;\n}\n.ui.massive.vertical.menu {\n  width: @massiveWidth;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Message\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'message';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Message\n*******************************/\n\n.ui.message {\n  position: relative;\n  min-height: 1em;\n  margin: @verticalMargin 0em;\n  background: @background;\n  padding: @padding;\n  line-height: @lineHeight;\n  color: @textColor;\n  transition: @transition;\n  border-radius: @borderRadius;\n  box-shadow: @boxShadow;\n}\n\n.ui.message:first-child {\n  margin-top: 0em;\n}\n.ui.message:last-child {\n  margin-bottom: 0em;\n}\n\n\n/*--------------\n     Content\n---------------*/\n\n/* Header */\n.ui.message .header {\n  display: @headerDisplay;\n  font-family: @headerFont;\n  font-weight: @headerFontWeight;\n  margin: @headerMargin;\n}\n\n/* Default font size */\n.ui.message .header:not(.ui) {\n  font-size: @headerFontSize;\n}\n\n/* Paragraph */\n.ui.message p {\n  opacity: @messageTextOpacity;\n  margin: @messageParagraphMargin 0em;\n}\n.ui.message p:first-child {\n  margin-top: 0em;\n}\n.ui.message p:last-child {\n  margin-bottom: 0em;\n}\n.ui.message .header + p {\n  margin-top: @headerParagraphDistance;\n}\n\n/* List */\n.ui.message .list:not(.ui) {\n  text-align: left;\n  padding: 0em;\n  opacity: @listOpacity;\n  list-style-position: @listStylePosition;\n  margin: @listMargin 0em 0em;\n}\n.ui.message .list:not(.ui):first-child {\n  margin-top: 0em;\n}\n.ui.message .list:not(.ui):last-child {\n  margin-bottom: 0em;\n}\n.ui.message .list:not(.ui) li {\n  position: relative;\n  list-style-type: none;\n  margin: 0em 0em @listItemMargin @listItemIndent;\n  padding: 0em;\n}\n.ui.message .list:not(.ui) li:before {\n  position: absolute;\n  content: '•';\n  left: -1em;\n  height: 100%;\n  vertical-align: baseline;\n}\n.ui.message .list:not(.ui) li:last-child {\n  margin-bottom: 0em;\n}\n\n\n/* Icon */\n.ui.message > .icon {\n  margin-right: @iconDistance;\n}\n\n/* Close Icon */\n.ui.message > .close.icon {\n  cursor: pointer;\n  position: absolute;\n  margin: 0em;\n  top: @closeTopDistance;\n  right: @closeRightDistance;\n  opacity: @closeOpacity;\n  transition: @closeTransition;\n}\n.ui.message > .close.icon:hover {\n  opacity: 1;\n}\n\n/* First / Last Element */\n.ui.message > :first-child {\n  margin-top: 0em;\n}\n.ui.message > :last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n.ui.dropdown .menu > .message {\n  margin: 0px -@borderWidth;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n    Visible\n---------------*/\n\n.ui.visible.visible.visible.visible.message {\n  display: block;\n}\n\n.ui.icon.visible.visible.visible.visible.message {\n  display: flex;\n}\n\n/*--------------\n     Hidden\n---------------*/\n\n.ui.hidden.hidden.hidden.hidden.message {\n  display: none;\n}\n\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n    Compact\n---------------*/\n\n.ui.compact.message {\n  display: inline-block;\n}\n.ui.compact.icon.message {\n  display: inline-flex;\n}\n\n\n/*--------------\n    Attached\n---------------*/\n\n.ui.attached.message {\n  margin-bottom: @attachedYOffset;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n  box-shadow: @attachedBoxShadow;\n  margin-left: @attachedXOffset;\n  margin-right: @attachedXOffset;\n}\n.ui.attached + .ui.attached.message:not(.top):not(.bottom) {\n  margin-top: @attachedYOffset;\n  border-radius: 0em;\n}\n.ui.bottom.attached.message {\n  margin-top: @attachedYOffset;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n  box-shadow: @attachedBottomBoxShadow;\n}\n.ui.bottom.attached.message:not(:last-child) {\n  margin-bottom: @verticalMargin;\n}\n.ui.attached.icon.message {\n  width: auto;\n}\n\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.icon.message {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.ui.icon.message > .icon:not(.close) {\n  display: block;\n  flex: 0 0 auto;\n  width: auto;\n  line-height: 1;\n  vertical-align: @iconVerticalAlign;\n  font-size: @iconSize;\n  opacity: @iconOpacity;\n}\n.ui.icon.message > .content {\n  display: block;\n  flex: 1 1 auto;\n  vertical-align: @iconVerticalAlign;\n}\n\n\n.ui.icon.message .icon:not(.close) + .content {\n  padding-left: @iconContentDistance;\n}\n.ui.icon.message .circular.icon {\n  width: 1em;\n}\n\n/*--------------\n    Floating\n---------------*/\n\n.ui.floating.message {\n  box-shadow: @floatingBoxShadow;\n}\n\n\n/*--------------\n     Colors\n---------------*/\n\n.ui.black.message {\n  background-color: @black;\n  color: @invertedTextColor;\n}\n\n/*--------------\n     Types\n---------------*/\n\n/* Positive */\n.ui.positive.message {\n  background-color: @positiveBackgroundColor;\n  color: @positiveTextColor;\n}\n.ui.positive.message,\n.ui.attached.positive.message {\n  box-shadow: @positiveBoxShadow;\n}\n.ui.positive.message .header {\n  color: @positiveHeaderColor;\n}\n\n/* Negative */\n.ui.negative.message {\n  background-color: @negativeBackgroundColor;\n  color: @negativeTextColor;\n}\n.ui.negative.message,\n.ui.attached.negative.message {\n  box-shadow: @negativeBoxShadow;\n}\n.ui.negative.message .header {\n  color: @negativeHeaderColor;\n}\n\n/* Info */\n.ui.info.message {\n  background-color: @infoBackgroundColor;\n  color: @infoTextColor;\n}\n.ui.info.message,\n.ui.attached.info.message {\n  box-shadow: @infoBoxShadow;\n}\n.ui.info.message .header {\n  color: @infoHeaderColor;\n}\n\n/* Warning */\n.ui.warning.message {\n  background-color: @warningBackgroundColor;\n  color: @warningTextColor;\n}\n.ui.warning.message,\n.ui.attached.warning.message {\n  box-shadow: @warningBoxShadow;\n}\n.ui.warning.message .header {\n  color: @warningHeaderColor;\n}\n\n/* Error */\n.ui.error.message {\n  background-color: @errorBackgroundColor;\n  color: @errorTextColor;\n}\n.ui.error.message,\n.ui.attached.error.message {\n  box-shadow: @errorBoxShadow;\n}\n.ui.error.message .header {\n  color: @errorHeaderColor;\n}\n\n/* Success */\n.ui.success.message {\n  background-color: @successBackgroundColor;\n  color: @successTextColor;\n}\n.ui.success.message,\n.ui.attached.success.message {\n  box-shadow: @successBoxShadow;\n}\n.ui.success.message .header {\n  color: @successHeaderColor;\n}\n\n\n/* Colors */\n.ui.inverted.message,\n.ui.black.message {\n  background-color: @black;\n  color: @invertedTextColor;\n}\n\n.ui.red.message {\n  background-color: @redBackground;\n  color: @redTextColor;\n  box-shadow: @redBoxShadow;\n}\n.ui.red.message .header {\n  color: @redHeaderColor;\n}\n\n.ui.orange.message {\n  background-color: @orangeBackground;\n  color: @orangeTextColor;\n  box-shadow: @orangeBoxShadow;\n}\n.ui.orange.message .header {\n  color: @orangeHeaderColor;\n}\n\n.ui.yellow.message {\n  background-color: @yellowBackground;\n  color: @yellowTextColor;\n  box-shadow: @yellowBoxShadow;\n}\n.ui.yellow.message .header {\n  color: @yellowHeaderColor;\n}\n\n.ui.olive.message {\n  background-color: @oliveBackground;\n  color: @oliveTextColor;\n  box-shadow: @oliveBoxShadow;\n}\n.ui.olive.message .header {\n  color: @oliveHeaderColor;\n}\n\n.ui.green.message {\n  background-color: @greenBackground;\n  color: @greenTextColor;\n  box-shadow: @greenBoxShadow;\n}\n.ui.green.message .header {\n  color: @greenHeaderColor;\n}\n\n.ui.teal.message {\n  background-color: @tealBackground;\n  color: @tealTextColor;\n  box-shadow: @tealBoxShadow;\n}\n.ui.teal.message .header {\n  color: @tealHeaderColor;\n}\n\n.ui.blue.message {\n  background-color: @blueBackground;\n  color: @blueTextColor;\n  box-shadow: @blueBoxShadow;\n}\n.ui.blue.message .header {\n  color: @blueHeaderColor;\n}\n\n.ui.violet.message {\n  background-color: @violetBackground;\n  color: @violetTextColor;\n  box-shadow: @violetBoxShadow;\n}\n.ui.violet.message .header {\n  color: @violetHeaderColor;\n}\n\n.ui.purple.message {\n  background-color: @purpleBackground;\n  color: @purpleTextColor;\n  box-shadow: @purpleBoxShadow;\n}\n.ui.purple.message .header {\n  color: @purpleHeaderColor;\n}\n\n.ui.pink.message {\n  background-color: @pinkBackground;\n  color: @pinkTextColor;\n  box-shadow: @pinkBoxShadow;\n}\n.ui.pink.message .header {\n  color: @pinkHeaderColor;\n}\n\n.ui.brown.message {\n  background-color: @brownBackground;\n  color: @brownTextColor;\n  box-shadow: @brownBoxShadow;\n}\n.ui.brown.message .header {\n  color: @brownHeaderColor;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.message {\n  font-size: @relativeMini;\n}\n.ui.tiny.message {\n  font-size: @relativeTiny;\n}\n.ui.small.message {\n  font-size: @relativeSmall;\n}\n.ui.message {\n  font-size: @relativeMedium;\n}\n.ui.large.message {\n  font-size: @relativeLarge;\n}\n.ui.big.message {\n  font-size: @relativeBig;\n}\n.ui.huge.message {\n  font-size: @relativeHuge;\n}\n.ui.massive.message {\n  font-size: @relativeMassive;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Table\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'collection';\n@element : 'table';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Table\n*******************************/\n\n/* Prototype */\n.ui.table {\n  width: 100%;\n  background: @background;\n  margin: @margin;\n  border: @border;\n  box-shadow: @boxShadow;\n  border-radius: @borderRadius;\n  text-align: @textAlign;\n  color: @color;\n  border-collapse: @borderCollapse;\n  border-spacing: @borderSpacing;\n}\n\n.ui.table:first-child {\n  margin-top: 0em;\n}\n.ui.table:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n             Parts\n*******************************/\n\n/* Table Content */\n.ui.table th,\n.ui.table td {\n  transition: @transition;\n}\n\n/* Headers */\n.ui.table thead {\n  box-shadow: @headerBoxShadow;\n}\n.ui.table thead th {\n  cursor: auto;\n  background: @headerBackground;\n  text-align: @headerAlign;\n  color: @headerColor;\n  padding: @headerVerticalPadding @headerHorizontalPadding;\n  vertical-align: @headerVerticalAlign;\n  font-style: @headerFontStyle;\n  font-weight: @headerFontWeight;\n  text-transform: @headerTextTransform;\n  border-bottom: @headerBorder;\n  border-left: @headerDivider;\n}\n\n.ui.table thead tr > th:first-child {\n  border-left: none;\n}\n\n.ui.table thead tr:first-child > th:first-child {\n  border-radius: @borderRadius 0em 0em 0em;\n}\n.ui.table thead tr:first-child > th:last-child {\n  border-radius: 0em @borderRadius 0em 0em;\n}\n.ui.table thead tr:first-child > th:only-child {\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n\n/* Footer */\n.ui.table tfoot {\n  box-shadow: @footerBoxShadow;\n}\n.ui.table tfoot th {\n  cursor: auto;\n  border-top: @footerBorder;\n  background: @footerBackground;\n  text-align: @footerAlign;\n  color: @footerColor;\n  padding: @footerVerticalPadding @footerHorizontalPadding;\n  vertical-align: @footerVerticalAlign;\n  font-style: @footerFontStyle;\n  font-weight: @footerFontWeight;\n  text-transform: @footerTextTransform;\n}\n.ui.table tfoot tr > th:first-child {\n  border-left: none;\n}\n.ui.table tfoot tr:first-child > th:first-child {\n  border-radius: 0em 0em 0em @borderRadius;\n}\n.ui.table tfoot tr:first-child > th:last-child {\n  border-radius: 0em 0em @borderRadius 0em;\n}\n.ui.table tfoot tr:first-child > th:only-child {\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n\n/* Table Row */\n.ui.table tr td {\n  border-top: @rowBorder;\n}\n.ui.table tr:first-child td {\n  border-top: none;\n}\n\n/* Repeated tbody */\n.ui.table tbody + tbody tr:first-child td {\n  border-top: @rowBorder;\n}\n\n/* Table Cells */\n.ui.table td {\n  padding: @cellVerticalPadding @cellHorizontalPadding;\n  text-align: @cellTextAlign;\n}\n\n/* Icons */\n.ui.table > .icon {\n  vertical-align: @iconVerticalAlign;\n}\n.ui.table > .icon:only-child {\n  margin: 0em;\n}\n\n/* Table Segment */\n.ui.table.segment {\n  padding: 0em;\n}\n.ui.table.segment:after {\n  display: none;\n}\n.ui.table.segment.stacked:after {\n  display: block;\n}\n\n\n/* Responsive */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.table:not(.unstackable) {\n    width: 100%;\n  }\n  .ui.table:not(.unstackable) tbody,\n  .ui.table:not(.unstackable) tr,\n  .ui.table:not(.unstackable) tr > th,\n  .ui.table:not(.unstackable) tr > td  {\n    display: block !important;\n    width: auto !important;\n    display: block !important;\n  }\n\n  .ui.table:not(.unstackable) {\n    padding: 0em;\n  }\n  .ui.table:not(.unstackable) thead {\n    display: @responsiveHeaderDisplay;\n  }\n  .ui.table:not(.unstackable) tfoot {\n    display: @responsiveFooterDisplay;\n  }\n  .ui.table:not(.unstackable) tr {\n    padding-top: @responsiveRowVerticalPadding;\n    padding-bottom: @responsiveRowVerticalPadding;\n    box-shadow: @responsiveRowBoxShadow;\n  }\n\n  .ui.table:not(.unstackable) tr > th,\n  .ui.table:not(.unstackable) tr > td {\n    background: none;\n    border: none !important;\n    padding: @responsiveCellVerticalPadding @responsiveCellHorizontalPadding !important;\n    box-shadow: @responsiveCellBoxShadow;\n  }\n  .ui.table:not(.unstackable) th:first-child,\n  .ui.table:not(.unstackable) td:first-child {\n    font-weight: @responsiveCellHeaderFontWeight;\n  }\n\n  /* Definition Table */\n  .ui.definition.table:not(.unstackable) thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n\n\n/*******************************\n            Coupling\n*******************************/\n\n/* UI Image */\n.ui.table th .image,\n.ui.table th .image img,\n.ui.table td .image,\n.ui.table td .image img {\n  max-width: none;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n    Complex\n---------------*/\n\n.ui.structured.table {\n  border-collapse: collapse;\n}\n.ui.structured.table thead th {\n  border-left: @headerDivider;\n  border-right: @headerDivider;\n}\n.ui.structured.sortable.table thead th {\n  border-left: @sortableBorder;\n  border-right: @sortableBorder;\n}\n.ui.structured.basic.table th {\n  border-left: @basicTableHeaderDivider;\n  border-right: @basicTableHeaderDivider;\n}\n.ui.structured.celled.table tr th,\n.ui.structured.celled.table tr td {\n  border-left: @cellBorder;\n  border-right: @cellBorder;\n}\n\n/*--------------\n   Definition\n---------------*/\n\n.ui.definition.table thead:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: @definitionHeaderBackground;\n  font-weight: @definitionHeaderFontWeight;\n  color: @definitionHeaderColor;\n  box-shadow: -@borderWidth -@borderWidth 0px @borderWidth @definitionPageBackground;\n}\n\n.ui.definition.table tfoot:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: @definitionFooterBackground;\n  font-weight: @definitionFooterColor;\n  color: @definitionFooterFontWeight;\n  box-shadow: @borderWidth @borderWidth 0px @borderWidth @definitionPageBackground;\n}\n\n/* Remove Border */\n.ui.celled.definition.table thead:not(.full-width) th:first-child {\n  box-shadow: 0px -@borderWidth 0px @borderWidth @definitionPageBackground;\n}\n.ui.celled.definition.table tfoot:not(.full-width) th:first-child {\n  box-shadow: 0px @borderWidth 0px @borderWidth @definitionPageBackground;\n}\n\n/* Highlight Defining Column */\n.ui.definition.table tr td:first-child:not(.ignored),\n.ui.definition.table tr td.definition {\n  background: @definitionColumnBackground;\n  font-weight: @definitionColumnFontWeight;\n  color: @definitionColumnColor;\n  text-transform: @definitionColumnTextTransform;\n  box-shadow: @definitionColumnBoxShadow;\n  text-align: @definitionColumnTextAlign;\n  font-size: @definitionColumnFontSize;\n  padding-left: @definitionColumnHorizontalPadding;\n  padding-right: @definitionColumnHorizontalPadding;\n}\n\n\n/* Fix 2nd Column */\n.ui.definition.table thead:not(.full-width) th:nth-child(2) {\n  border-left: @borderWidth solid @borderColor;\n}\n.ui.definition.table tfoot:not(.full-width) th:nth-child(2) {\n  border-left: @borderWidth solid @borderColor;\n}\n.ui.definition.table td:nth-child(2) {\n  border-left: @borderWidth solid @borderColor;\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n    Positive\n---------------*/\n\n.ui.table tr.positive,\n.ui.table td.positive {\n  box-shadow: @positiveBoxShadow;\n}\n.ui.table tr.positive,\n.ui.table td.positive {\n  background: @positiveBackgroundColor !important;\n  color: @positiveColor !important;\n}\n\n/*--------------\n     Negative\n---------------*/\n\n.ui.table tr.negative,\n.ui.table td.negative {\n  box-shadow: @negativeBoxShadow;\n}\n.ui.table tr.negative,\n.ui.table td.negative,\n.ui.table th.negative {\n  background: @negativeBackgroundColor !important;\n  color: @negativeColor !important;\n}\n\n/*--------------\n      Error\n---------------*/\n\n.ui.table tr.error,\n.ui.table td.error {\n  box-shadow: @errorBoxShadow;\n}\n.ui.table tr.error,\n.ui.table td.error {\n  background: @errorBackgroundColor !important;\n  color: @errorColor !important;\n}\n/*--------------\n     Warning\n---------------*/\n\n.ui.table tr.warning,\n.ui.table td.warning {\n  box-shadow: @warningBoxShadow;\n}\n.ui.table tr.warning,\n.ui.table td.warning {\n  background: @warningBackgroundColor !important;\n  color: @warningColor !important;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.table tr.active,\n.ui.table td.active {\n  box-shadow: @activeBoxShadow;\n}\n.ui.table tr.active,\n.ui.table td.active {\n  background: @activeBackgroundColor !important;\n  color: @activeColor !important;\n}\n\n\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.table tr.disabled td,\n.ui.table tr td.disabled,\n.ui.table tr.disabled:hover,\n.ui.table tr:hover td.disabled {\n  pointer-events: none;\n  color: @disabledTextColor;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n    Stackable\n---------------*/\n\n@media only screen and (max-width : @largestTabletScreen) {\n\n  .ui[class*=\"tablet stackable\"].table,\n  .ui[class*=\"tablet stackable\"].table tbody,\n  .ui[class*=\"tablet stackable\"].table tr,\n  .ui[class*=\"tablet stackable\"].table tr > th,\n  .ui[class*=\"tablet stackable\"].table tr > td  {\n    display: block !important;\n    width: 100% !important;\n    display: block !important;\n  }\n\n  .ui[class*=\"tablet stackable\"].table {\n    padding: 0em;\n  }\n  .ui[class*=\"tablet stackable\"].table thead {\n    display: @responsiveHeaderDisplay;\n  }\n  .ui[class*=\"tablet stackable\"].table tfoot {\n    display: @responsiveFooterDisplay;\n  }\n  .ui[class*=\"tablet stackable\"].table tr {\n    padding-top: @responsiveRowVerticalPadding;\n    padding-bottom: @responsiveRowVerticalPadding;\n    box-shadow: @responsiveRowBoxShadow;\n  }\n  .ui[class*=\"tablet stackable\"].table tr > th,\n  .ui[class*=\"tablet stackable\"].table tr > td {\n    background: none;\n    border: none !important;\n    padding: @responsiveCellVerticalPadding @responsiveCellHorizontalPadding;\n    box-shadow: @responsiveCellBoxShadow;\n  }\n\n  /* Definition Table */\n  .ui.definition[class*=\"tablet stackable\"].table thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n\n/*--------------\n Text Alignment\n---------------*/\n\n.ui.table[class*=\"left aligned\"],\n.ui.table [class*=\"left aligned\"] {\n  text-align: left;\n}\n.ui.table[class*=\"center aligned\"],\n.ui.table [class*=\"center aligned\"] {\n  text-align: center;\n}\n.ui.table[class*=\"right aligned\"],\n.ui.table [class*=\"right aligned\"] {\n  text-align: right;\n}\n\n/*------------------\n Vertical Alignment\n------------------*/\n\n.ui.table[class*=\"top aligned\"],\n.ui.table [class*=\"top aligned\"] {\n  vertical-align: top;\n}\n.ui.table[class*=\"middle aligned\"],\n.ui.table [class*=\"middle aligned\"] {\n  vertical-align: middle;\n}\n.ui.table[class*=\"bottom aligned\"],\n.ui.table [class*=\"bottom aligned\"] {\n  vertical-align: bottom;\n}\n\n/*--------------\n    Collapsing\n---------------*/\n\n.ui.table th.collapsing,\n.ui.table td.collapsing {\n  width: 1px;\n  white-space: nowrap;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.fixed.table {\n  table-layout: fixed;\n}\n\n.ui.fixed.table th,\n.ui.fixed.table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n/*--------------\n   Selectable\n---------------*/\n\n.ui.selectable.table tbody tr:hover,\n.ui.table tbody tr td.selectable:hover {\n  background: @selectableBackground !important;\n  color: @selectableTextColor !important;\n}\n.ui.selectable.inverted.table tbody tr:hover,\n.ui.inverted.table tbody tr td.selectable:hover {\n  background: @selectableInvertedBackground !important;\n  color: @selectableInvertedTextColor !important;\n}\n\n/* Selectable Cell Link */\n.ui.table tbody tr td.selectable {\n  padding: 0em;\n}\n.ui.table tbody tr td.selectable > a:not(.ui) {\n  display: block;\n  color: inherit;\n  padding: @cellVerticalPadding @cellHorizontalPadding;\n}\n\n/* Other States */\n.ui.selectable.table tr.error:hover,\n.ui.table tr td.selectable.error:hover,\n.ui.selectable.table tr:hover td.error {\n  background: @errorBackgroundHover !important;\n  color: @errorColorHover !important;\n}\n.ui.selectable.table tr.warning:hover,\n.ui.table tr td.selectable.warning:hover,\n.ui.selectable.table tr:hover td.warning {\n  background: @warningBackgroundHover !important;\n  color: @warningColorHover !important;\n}\n.ui.selectable.table tr.active:hover,\n.ui.table tr td.selectable.active:hover,\n.ui.selectable.table tr:hover td.active {\n  background: @activeBackgroundColor !important;\n  color: @activeColor !important;\n}\n.ui.selectable.table tr.positive:hover,\n.ui.table tr td.selectable.positive:hover,\n.ui.selectable.table tr:hover td.positive {\n  background: @positiveBackgroundHover !important;\n  color: @positiveColorHover !important;\n}\n.ui.selectable.table tr.negative:hover,\n.ui.table tr td.selectable.negative:hover,\n.ui.selectable.table tr:hover td.negative {\n  background: @negativeBackgroundHover !important;\n  color: @negativeColorHover !important;\n}\n\n\n\n/*-------------------\n      Attached\n--------------------*/\n\n/* Middle */\n.ui.attached.table {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em @attachedHorizontalOffset;\n  width: @attachedWidth;\n  max-width: @attachedWidth;\n  box-shadow: @attachedBoxShadow;\n  border: @attachedBorder;\n}\n.ui.attached + .ui.attached.table:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n.ui[class*=\"top attached\"].table {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: @attachedTopOffset;\n  margin-top: @verticalMargin;\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n.ui.table[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n.ui[class*=\"bottom attached\"].table {\n  bottom: 0px;\n  margin-top: 0em;\n  top: @attachedBottomOffset;\n  margin-bottom: @verticalMargin;\n  box-shadow: @attachedBottomBoxShadow;\n  border-radius: 0em 0em @borderRadius @borderRadius;\n}\n.ui[class*=\"bottom attached\"].table:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Striped\n---------------*/\n\n/* Table Striping */\n.ui.striped.table > tr:nth-child(2n),\n.ui.striped.table tbody tr:nth-child(2n) {\n  background-color: @stripedBackground;\n}\n\n/* Stripes */\n.ui.inverted.striped.table > tr:nth-child(2n),\n.ui.inverted.striped.table tbody tr:nth-child(2n) {\n  background-color: @invertedStripedBackground;\n}\n\n/* Allow striped active hover */\n.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {\n  background: @activeBackgroundHover !important;\n  color: @activeColorHover !important;\n}\n\n/*--------------\n   Single Line\n---------------*/\n\n.ui.table[class*=\"single line\"],\n.ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n.ui.table[class*=\"single line\"],\n.ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n.ui.red.table {\n  border-top: @coloredBorderSize solid @red;\n}\n.ui.inverted.red.table {\n  background-color: @red !important;\n  color: @white !important;\n}\n\n/* Orange */\n.ui.orange.table {\n  border-top: @coloredBorderSize solid @orange;\n}\n.ui.inverted.orange.table {\n  background-color: @orange !important;\n  color: @white !important;\n}\n\n/* Yellow */\n.ui.yellow.table {\n  border-top: @coloredBorderSize solid @yellow;\n}\n.ui.inverted.yellow.table {\n  background-color: @yellow !important;\n  color: @white !important;\n}\n\n/* Olive */\n.ui.olive.table {\n  border-top: @coloredBorderSize solid @olive;\n}\n.ui.inverted.olive.table {\n  background-color: @olive !important;\n  color: @white !important;\n}\n\n/* Green */\n.ui.green.table {\n  border-top: @coloredBorderSize solid @green;\n}\n.ui.inverted.green.table {\n  background-color: @green !important;\n  color: @white !important;\n}\n\n/* Teal */\n.ui.teal.table {\n  border-top: @coloredBorderSize solid @teal;\n}\n.ui.inverted.teal.table {\n  background-color: @teal !important;\n  color: @white !important;\n}\n\n/* Blue */\n.ui.blue.table {\n  border-top: @coloredBorderSize solid @blue;\n}\n.ui.inverted.blue.table {\n  background-color: @blue !important;\n  color: @white !important;\n}\n\n/* Violet */\n.ui.violet.table {\n  border-top: @coloredBorderSize solid @violet;\n}\n.ui.inverted.violet.table {\n  background-color: @violet !important;\n  color: @white !important;\n}\n\n/* Purple */\n.ui.purple.table {\n  border-top: @coloredBorderSize solid @purple;\n}\n.ui.inverted.purple.table {\n  background-color: @purple !important;\n  color: @white !important;\n}\n\n/* Pink */\n.ui.pink.table {\n  border-top: @coloredBorderSize solid @pink;\n}\n.ui.inverted.pink.table {\n  background-color: @pink !important;\n  color: @white !important;\n}\n\n/* Brown */\n.ui.brown.table {\n  border-top: @coloredBorderSize solid @brown;\n}\n.ui.inverted.brown.table {\n  background-color: @brown !important;\n  color: @white !important;\n}\n\n/* Grey */\n.ui.grey.table {\n  border-top: @coloredBorderSize solid @grey;\n}\n.ui.inverted.grey.table {\n  background-color: @grey !important;\n  color: @white !important;\n}\n\n/* Black */\n.ui.black.table {\n  border-top: @coloredBorderSize solid @black;\n}\n.ui.inverted.black.table {\n  background-color: @black !important;\n  color: @white !important;\n}\n\n\n/*--------------\n  Column Count\n---------------*/\n\n/* Grid Based */\n.ui.one.column.table td {\n  width: @oneColumn;\n}\n.ui.two.column.table td {\n  width: @twoColumn;\n}\n.ui.three.column.table td {\n  width: @threeColumn;\n}\n.ui.four.column.table td {\n  width: @fourColumn;\n}\n.ui.five.column.table td {\n  width: @fiveColumn;\n}\n.ui.six.column.table td {\n  width: @sixColumn;\n}\n.ui.seven.column.table td {\n  width: @sevenColumn;\n}\n.ui.eight.column.table td {\n  width: @eightColumn;\n}\n.ui.nine.column.table td {\n  width: @nineColumn;\n}\n.ui.ten.column.table td {\n  width: @tenColumn;\n}\n.ui.eleven.column.table td {\n  width: @elevenColumn;\n}\n.ui.twelve.column.table td {\n  width: @twelveColumn;\n}\n.ui.thirteen.column.table td {\n  width: @thirteenColumn;\n}\n.ui.fourteen.column.table td {\n  width: @fourteenColumn;\n}\n.ui.fifteen.column.table td {\n  width: @fifteenColumn;\n}\n.ui.sixteen.column.table td {\n  width: @sixteenColumn;\n}\n\n/* Column Width */\n.ui.table th.one.wide,\n.ui.table td.one.wide {\n  width: @oneWide;\n}\n.ui.table th.two.wide,\n.ui.table td.two.wide {\n  width: @twoWide;\n}\n.ui.table th.three.wide,\n.ui.table td.three.wide {\n  width: @threeWide;\n}\n.ui.table th.four.wide,\n.ui.table td.four.wide {\n  width: @fourWide;\n}\n.ui.table th.five.wide,\n.ui.table td.five.wide {\n  width: @fiveWide;\n}\n.ui.table th.six.wide,\n.ui.table td.six.wide {\n  width: @sixWide;\n}\n.ui.table th.seven.wide,\n.ui.table td.seven.wide {\n  width: @sevenWide;\n}\n.ui.table th.eight.wide,\n.ui.table td.eight.wide {\n  width: @eightWide;\n}\n.ui.table th.nine.wide,\n.ui.table td.nine.wide {\n  width: @nineWide;\n}\n.ui.table th.ten.wide,\n.ui.table td.ten.wide {\n  width: @tenWide;\n}\n.ui.table th.eleven.wide,\n.ui.table td.eleven.wide {\n  width: @elevenWide;\n}\n.ui.table th.twelve.wide,\n.ui.table td.twelve.wide {\n  width: @twelveWide;\n}\n.ui.table th.thirteen.wide,\n.ui.table td.thirteen.wide {\n  width: @thirteenWide;\n}\n.ui.table th.fourteen.wide,\n.ui.table td.fourteen.wide {\n  width: @fourteenWide;\n}\n.ui.table th.fifteen.wide,\n.ui.table td.fifteen.wide {\n  width: @fifteenWide;\n}\n.ui.table th.sixteen.wide,\n.ui.table td.sixteen.wide {\n  width: @sixteenWide;\n}\n\n/*--------------\n    Sortable\n---------------*/\n\n.ui.sortable.table thead th {\n  cursor: pointer;\n  white-space: nowrap;\n  border-left: @sortableBorder;\n  color: @sortableColor;\n}\n.ui.sortable.table thead th:first-child {\n  border-left: none;\n}\n.ui.sortable.table thead th.sorted,\n.ui.sortable.table thead th.sorted:hover {\n  user-select: none;\n}\n\n.ui.sortable.table thead th:after {\n  display: none;\n  font-style: normal;\n  font-weight: @normal;\n  text-decoration: inherit;\n  content: '';\n  height: 1em;\n  width: @sortableIconWidth;\n  opacity: @sortableIconOpacity;\n  margin: 0em 0em 0em @sortableIconDistance;\n  font-family: @sortableIconFont;\n}\n.ui.sortable.table thead th.ascending:after {\n  content: @sortableIconAscending;\n}\n.ui.sortable.table thead th.descending:after {\n  content: @sortableIconDescending;\n}\n\n/* Hover */\n.ui.sortable.table th.disabled:hover {\n  cursor: auto;\n  color: @sortableDisabledColor;\n}\n.ui.sortable.table thead th:hover {\n  background: @sortableHoverBackground;\n  color: @sortableHoverColor;\n}\n\n/* Sorted */\n.ui.sortable.table thead th.sorted {\n  background: @sortableActiveBackground;\n  color: @sortableActiveColor;\n}\n.ui.sortable.table thead th.sorted:after {\n  display: inline-block;\n}\n\n/* Sorted Hover */\n.ui.sortable.table thead th.sorted:hover {\n  background: @sortableActiveHoverBackground;\n  color: @sortableActiveHoverColor;\n}\n\n/* Inverted */\n.ui.inverted.sortable.table thead th.sorted {\n  background: @sortableInvertedActiveBackground;\n  color: @sortableInvertedActiveColor;\n}\n.ui.inverted.sortable.table thead th:hover {\n  background: @sortableInvertedHoverBackground;\n  color: @sortableInvertedHoverColor;\n}\n.ui.inverted.sortable.table thead th {\n  border-left-color: @sortableInvertedBorderColor;\n  border-right-color: @sortableInvertedBorderColor;\n}\n\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Text Color */\n.ui.inverted.table {\n  background: @invertedBackground;\n  color: @invertedCellColor;\n  border: @invertedBorder;\n}\n.ui.inverted.table th {\n  background-color: @invertedHeaderBackground;\n  border-color: @invertedHeaderBorderColor !important;\n  color: @invertedHeaderColor !important;\n}\n.ui.inverted.table tr td {\n  border-color: @invertedCellBorderColor !important;\n}\n\n.ui.inverted.table tr.disabled td,\n.ui.inverted.table tr td.disabled,\n.ui.inverted.table tr.disabled:hover td,\n.ui.inverted.table tr:hover td.disabled {\n  pointer-events: none;\n  color: @invertedDisabledTextColor;\n}\n\n/* Definition */\n.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,\n.ui.inverted.definition.table thead:not(.full-width) th:first-child {\n  background: @definitionPageBackground;\n}\n.ui.inverted.definition.table tr td:first-child {\n  background: @invertedDefinitionColumnBackground;\n  color: @invertedDefinitionColumnColor;\n}\n\n/*--------------\n   Collapsing\n---------------*/\n\n.ui.collapsing.table {\n  width: auto;\n}\n\n/*--------------\n      Basic\n---------------*/\n\n.ui.basic.table {\n  background: @basicTableBackground;\n  border: @basicTableBorder;\n  box-shadow: @basicBoxShadow;\n}\n.ui.basic.table thead,\n.ui.basic.table tfoot {\n  box-shadow: none;\n}\n.ui.basic.table th {\n  background: @basicTableHeaderBackground;\n  border-left: @basicTableHeaderDivider;\n}\n.ui.basic.table tbody tr {\n  border-bottom: @basicTableCellBorder;\n}\n.ui.basic.table td {\n  background: @basicTableCellBackground;\n}\n.ui.basic.striped.table tbody tr:nth-child(2n) {\n  background-color: @basicTableStripedBackground !important;\n}\n\n/* Very Basic */\n.ui[class*=\"very basic\"].table {\n  border: none;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td {\n  padding: @basicTableCellPadding;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:first-child,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:first-child {\n  padding-left: 0em;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:last-child,\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:last-child {\n  padding-right: 0em;\n}\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) thead tr:first-child th {\n  padding-top: 0em;\n}\n\n/*--------------\n     Celled\n---------------*/\n\n.ui.celled.table tr th,\n.ui.celled.table tr td {\n  border-left: @cellBorder;\n}\n.ui.celled.table tr th:first-child,\n.ui.celled.table tr td:first-child {\n  border-left: none;\n}\n\n/*--------------\n     Padded\n---------------*/\n\n.ui.padded.table th {\n  padding-left: @paddedHorizontalPadding;\n  padding-right: @paddedHorizontalPadding;\n}\n.ui.padded.table th,\n.ui.padded.table td {\n  padding: @paddedVerticalPadding @paddedHorizontalPadding;\n}\n\n/* Very */\n.ui[class*=\"very padded\"].table th {\n  padding-left: @veryPaddedHorizontalPadding;\n  padding-right: @veryPaddedHorizontalPadding;\n}\n.ui[class*=\"very padded\"].table td {\n  padding: @veryPaddedVerticalPadding @veryPaddedHorizontalPadding;\n}\n\n/*--------------\n     Compact\n---------------*/\n\n.ui.compact.table th {\n  padding-left: @compactHorizontalPadding;\n  padding-right: @compactHorizontalPadding;\n}\n.ui.compact.table td {\n  padding: @compactVerticalPadding @compactHorizontalPadding;\n}\n\n/* Very */\n.ui[class*=\"very compact\"].table th {\n  padding-left: @veryCompactHorizontalPadding;\n  padding-right: @veryCompactHorizontalPadding;\n}\n.ui[class*=\"very compact\"].table td {\n  padding: @veryCompactVerticalPadding @veryCompactHorizontalPadding;\n}\n\n/*--------------\n      Sizes\n---------------*/\n\n/* Small */\n.ui.small.table {\n  font-size: @small;\n}\n\n/* Standard */\n.ui.table {\n  font-size: @medium;\n}\n\n/* Large */\n.ui.large.table {\n  font-size: @large;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Ad\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2013 Contributors\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'ad';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n         Advertisement\n*******************************/\n\n.ui.ad {\n  display: block;\n  overflow: @overflow;\n  margin: @margin;\n}\n\n.ui.ad:first-child {\n  margin: 0em;\n}\n\n.ui.ad:last-child {\n  margin: 0em;\n}\n\n.ui.ad iframe {\n  margin: 0em;\n  padding: 0em;\n  border: none;\n  overflow: hidden;\n}\n\n/*--------------\n     Common\n---------------*/\n\n/* Leaderboard */\n.ui.leaderboard.ad {\n  width: 728px;\n  height: 90px;\n}\n\n/* Medium Rectangle */\n.ui[class*=\"medium rectangle\"].ad {\n  width: 300px;\n  height: 250px;\n}\n\n/* Large Rectangle */\n.ui[class*=\"large rectangle\"].ad {\n  width: 336px;\n  height: 280px;\n}\n/* Half Page */\n.ui[class*=\"half page\"].ad {\n  width: 300px;\n  height: 600px;\n}\n\n/*--------------\n     Square\n---------------*/\n\n/* Square */\n.ui.square.ad {\n  width: 250px;\n  height: 250px;\n}\n\n/* Small Square */\n.ui[class*=\"small square\"].ad {\n  width: 200px;\n  height: 200px;\n}\n\n/*--------------\n    Rectangle\n---------------*/\n\n/* Small Rectangle */\n.ui[class*=\"small rectangle\"].ad {\n  width: 180px;\n  height: 150px;\n}\n\n/* Vertical Rectangle */\n.ui[class*=\"vertical rectangle\"].ad {\n  width: 240px;\n  height: 400px;\n}\n\n/*--------------\n     Button\n---------------*/\n\n.ui.button.ad {\n  width: 120px;\n  height: 90px;\n}\n.ui[class*=\"square button\"].ad {\n  width: 125px;\n  height: 125px;\n}\n.ui[class*=\"small button\"].ad {\n  width: 120px;\n  height: 60px;\n}\n\n/*--------------\n   Skyscrapers\n---------------*/\n\n/* Skyscraper */\n.ui.skyscraper.ad {\n  width: 120px;\n  height: 600px;\n}\n\n/* Wide Skyscraper */\n.ui[class*=\"wide skyscraper\"].ad {\n  width: 160px;\n}\n\n/*--------------\n     Banners\n---------------*/\n\n/* Banner */\n.ui.banner.ad {\n  width: 468px;\n  height: 60px;\n}\n\n/* Vertical Banner */\n.ui[class*=\"vertical banner\"].ad {\n  width: 120px;\n  height: 240px;\n}\n\n/* Top Banner */\n.ui[class*=\"top banner\"].ad {\n  width: 930px;\n  height: 180px;\n}\n\n/* Half Banner */\n.ui[class*=\"half banner\"].ad {\n  width: 234px;\n  height: 60px;\n}\n\n/*--------------\n    Boards\n---------------*/\n\n/* Leaderboard */\n.ui[class*=\"large leaderboard\"].ad {\n  width: 970px;\n  height: 90px;\n}\n\n/* Billboard */\n.ui.billboard.ad {\n  width: 970px;\n  height: 250px;\n}\n\n/*--------------\n    Panorama\n---------------*/\n\n/* Panorama */\n.ui.panorama.ad {\n  width: 980px;\n  height: 120px;\n}\n\n/*--------------\n     Netboard\n---------------*/\n\n/* Netboard */\n.ui.netboard.ad {\n  width: 580px;\n  height: 400px;\n}\n\n\n\n/*--------------\n     Mobile\n---------------*/\n\n/* Large Mobile Banner */\n.ui[class*=\"large mobile banner\"].ad {\n  width: 320px;\n  height: 100px;\n}\n\n/* Mobile Leaderboard */\n.ui[class*=\"mobile leaderboard\"].ad {\n  width: 320px;\n  height: 50px;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/* Mobile Sizes */\n.ui.mobile.ad {\n  display: none;\n}\n\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.mobile.ad {\n    display: block;\n  }\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n.ui.centered.ad {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ui.test.ad {\n  position: relative;\n  background: @testBackground;\n}\n.ui.test.ad:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  text-align: center;\n  transform: translateX(-50%) translateY(-50%);\n\n  content: @testText;\n  color: @testColor;\n  font-size: @testFontSize;\n  font-weight: @testFontWeight;\n}\n.ui.mobile.test.ad:after {\n  font-size: @testMobileFontSize;\n}\n.ui.test.ad[data-text]:after {\n  content: attr(data-text);\n}\n\n.loadUIOverrides();","/*!\n * # Semantic UI - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'card';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Card\n---------------*/\n\n.ui.cards > .card,\n.ui.card {\n  max-width: 100%;\n  position: relative;\n  display: @display;\n  flex-direction: column;\n\n  width: @width;\n  min-height: @minHeight;\n  background: @background;\n  padding: @padding;\n\n  border: @border;\n  border-radius: @borderRadius;\n  box-shadow: @boxShadow;\n  transition: @transition;\n  z-index: @zIndex;\n}\n.ui.card {\n  margin: @margin;\n}\n\n.ui.cards > .card a,\n.ui.card a {\n  cursor: pointer;\n}\n\n.ui.card:first-child {\n  margin-top: 0em;\n}\n.ui.card:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Cards\n---------------*/\n\n.ui.cards {\n  display: @groupDisplay;\n  margin: @groupMargin;\n  flex-wrap: wrap;\n}\n\n.ui.cards > .card {\n  display: @groupCardDisplay;\n  margin: @groupCardMargin;\n  float: @groupCardFloat;\n}\n\n/* Clearing */\n.ui.cards:after,\n.ui.card:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n\n/* Consecutive Card Groups Preserve Row Spacing */\n.ui.cards ~ .ui.cards {\n  margin-top: @consecutiveGroupDistance;\n}\n\n\n/*--------------\n  Rounded Edges\n---------------*/\n\n.ui.cards > .card > :first-child,\n.ui.card > :first-child {\n  border-radius: @borderRadius @borderRadius 0em 0em !important;\n  border-top: none !important;\n}\n\n.ui.cards > .card > :last-child,\n.ui.card > :last-child {\n  border-radius: 0em 0em @borderRadius @borderRadius !important;\n}\n\n.ui.cards > .card > :only-child,\n.ui.card > :only-child {\n  border-radius: @borderRadius !important;\n}\n\n/*--------------\n     Images\n---------------*/\n\n.ui.cards > .card > .image,\n.ui.card > .image {\n  position: relative;\n  display: block;\n  flex: 0 0 auto;\n  padding: @imagePadding;\n  background: @imageBackground;\n}\n.ui.cards > .card > .image > img,\n.ui.card > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: inherit;\n}\n.ui.cards > .card > .image:not(.ui) > img,\n.ui.card > .image:not(.ui) > img {\n  border: @imageBorder;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.cards > .card > .content,\n.ui.card > .content {\n  flex-grow: 1;\n  border: @contentBorder;\n  border-top: @contentDivider;\n  background: @contentBackground;\n  margin: @contentMargin;\n  padding: @contentPadding;\n  box-shadow: @contentBoxShadow;\n  font-size: @contentFontSize;\n  border-radius: @contentBorderRadius;\n}\n\n.ui.cards > .card > .content:after,\n.ui.card > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.cards > .card > .content > .header,\n.ui.card > .content > .header {\n  display: block;\n  margin: @headerMargin;\n  font-family: @headerFont;\n  color: @headerColor;\n}\n\n/* Default Header Size */\n.ui.cards > .card > .content > .header:not(.ui),\n.ui.card > .content > .header:not(.ui) {\n  font-weight: @headerFontWeight;\n  font-size: @headerFontSize;\n  margin-top: @headerLineHeightOffset;\n  line-height: @headerLineHeight;\n}\n\n.ui.cards > .card > .content > .meta + .description,\n.ui.cards > .card > .content > .header + .description,\n.ui.card > .content > .meta + .description,\n.ui.card > .content > .header + .description  {\n  margin-top: @descriptionDistance;\n}\n\n/*----------------\n Floated Content\n-----------------*/\n\n.ui.cards > .card  [class*=\"left floated\"],\n.ui.card [class*=\"left floated\"] {\n  float: left;\n}\n.ui.cards > .card [class*=\"right floated\"],\n.ui.card [class*=\"right floated\"] {\n  float: right;\n}\n\n/*--------------\n     Aligned\n---------------*/\n\n.ui.cards > .card  [class*=\"left aligned\"],\n.ui.card [class*=\"left aligned\"] {\n  text-align: left;\n}\n.ui.cards > .card [class*=\"center aligned\"],\n.ui.card [class*=\"center aligned\"] {\n  text-align: center;\n}\n.ui.cards > .card [class*=\"right aligned\"],\n.ui.card [class*=\"right aligned\"] {\n  text-align: right;\n}\n\n\n/*--------------\n  Content Image\n---------------*/\n\n.ui.cards > .card .content img,\n.ui.card .content img {\n  display: inline-block;\n  vertical-align: @contentImageVerticalAlign;\n  width: @contentImageWidth;\n}\n.ui.cards > .card img.avatar,\n.ui.cards > .card .avatar img,\n.ui.card img.avatar,\n.ui.card .avatar img {\n  width: @avatarSize;\n  height: @avatarSize;\n  border-radius: @avatarBorderRadius;\n}\n\n\n/*--------------\n   Description\n---------------*/\n\n.ui.cards > .card > .content > .description,\n.ui.card > .content > .description {\n  clear: both;\n  color: @descriptionColor;\n}\n\n/*--------------\n    Paragraph\n---------------*/\n\n.ui.cards > .card > .content p,\n.ui.card > .content p {\n  margin: 0em 0em @paragraphDistance;\n}\n.ui.cards > .card > .content p:last-child,\n.ui.card > .content p:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.cards > .card .meta,\n.ui.card .meta {\n  font-size: @metaFontSize;\n  color: @metaColor;\n}\n.ui.cards > .card .meta *,\n.ui.card .meta * {\n  margin-right: @metaSpacing;\n}\n.ui.cards > .card .meta :last-child,\n.ui.card .meta :last-child {\n  margin-right: 0em;\n}\n\n.ui.cards > .card .meta [class*=\"right floated\"],\n.ui.card .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: @metaSpacing;\n}\n\n/*--------------\n      Links\n---------------*/\n\n/* Generic */\n.ui.cards > .card > .content a:not(.ui),\n.ui.card > .content a:not(.ui) {\n  color: @contentLinkColor;\n  transition: @contentLinkTransition;\n}\n.ui.cards > .card > .content a:not(.ui):hover,\n.ui.card > .content a:not(.ui):hover {\n  color: @contentLinkHoverColor;\n}\n\n/* Header */\n.ui.cards > .card > .content > a.header,\n.ui.card > .content > a.header {\n  color: @headerLinkColor;\n}\n.ui.cards > .card > .content > a.header:hover,\n.ui.card > .content > a.header:hover {\n  color: @headerLinkHoverColor;\n}\n\n/* Meta */\n.ui.cards > .card .meta > a:not(.ui),\n.ui.card .meta > a:not(.ui) {\n  color: @metaLinkColor;\n}\n.ui.cards > .card .meta > a:not(.ui):hover,\n.ui.card .meta > a:not(.ui):hover {\n  color: @metaLinkHoverColor;\n}\n\n/*--------------\n     Buttons\n---------------*/\n\n.ui.cards > .card > .buttons,\n.ui.card > .buttons,\n.ui.cards > .card > .button,\n.ui.card > .button {\n  margin: @buttonMargin;\n  width: @buttonWidth;\n}\n\n/*--------------\n      Dimmer\n---------------*/\n\n.ui.cards > .card .dimmer,\n.ui.card .dimmer {\n  background-color: @dimmerColor;\n  z-index: @dimmerZIndex;\n}\n\n/*--------------\n     Labels\n---------------*/\n\n/*-----Star----- */\n\n/* Icon */\n.ui.cards > .card > .content .star.icon,\n.ui.card > .content .star.icon {\n  cursor: pointer;\n  opacity: @actionOpacity;\n  transition: @actionTransition;\n}\n.ui.cards > .card > .content .star.icon:hover,\n.ui.card > .content .star.icon:hover {\n  opacity: @actionHoverOpacity;\n  color: @starColor;\n}\n.ui.cards > .card > .content .active.star.icon,\n.ui.card > .content .active.star.icon {\n  color: @starActiveColor;\n}\n\n/*-----Like----- */\n\n/* Icon */\n.ui.cards > .card > .content .like.icon,\n.ui.card > .content .like.icon {\n  cursor: pointer;\n  opacity: @actionOpacity;\n  transition: @actionTransition;\n}\n.ui.cards > .card > .content .like.icon:hover,\n.ui.card > .content .like.icon:hover {\n  opacity: @actionHoverOpacity;\n  color: @likeColor;\n}\n.ui.cards > .card > .content .active.like.icon,\n.ui.card > .content .active.like.icon {\n  color: @likeActiveColor;\n}\n\n/*----------------\n  Extra Content\n-----------------*/\n\n.ui.cards > .card > .extra,\n.ui.card > .extra {\n  max-width: 100%;\n  min-height: 0em !important;\n  flex-grow: 0;\n  border-top: @extraDivider !important;\n  position: @extraPosition;\n  background: @extraBackground;\n  width: @extraWidth;\n  margin: @extraMargin;\n  padding: @extraPadding;\n  top: @extraTop;\n  left: @extraLeft;\n  color: @extraColor;\n  box-shadow: @extraBoxShadow;\n  transition: @extraTransition;\n}\n.ui.cards > .card > .extra a:not(.ui),\n.ui.card > .extra a:not(.ui) {\n  color: @extraLinkColor;\n}\n.ui.cards > .card > .extra a:not(.ui):hover,\n.ui.card > .extra a:not(.ui):hover {\n  color: @extraLinkHoverColor;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Raised\n--------------------*/\n\n.ui.raised.cards > .card,\n.ui.raised.card {\n  box-shadow: @raisedShadow;\n}\n.ui.raised.cards a.card:hover,\n.ui.link.cards .raised.card:hover,\na.ui.raised.card:hover,\n.ui.link.raised.card:hover {\n  box-shadow: @raisedShadowHover;\n}\n\n.ui.raised.cards > .card,\n.ui.raised.card {\n  box-shadow: @raisedShadow;\n}\n/*-------------------\n       Centered\n--------------------*/\n\n.ui.centered.cards {\n  justify-content: center;\n}\n.ui.centered.card {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.card {\n  width: 100%;\n  max-width: 9999px;\n}\n\n/*-------------------\n        Link\n--------------------*/\n\n.ui.cards a.card,\n.ui.link.cards .card,\na.ui.card,\n.ui.link.card {\n  transform: none;\n}\n\n\n.ui.cards a.card:hover,\n.ui.link.cards .card:hover,\na.ui.card:hover,\n.ui.link.card:hover {\n  cursor: pointer;\n  z-index: @linkHoverZIndex;\n  background: @linkHoverBackground;\n  border: @linkHoverBorder;\n  box-shadow: @linkHoverBoxShadow;\n  transform: @linkHoverTransform;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n.ui.red.cards > .card,\n.ui.cards > .red.card,\n.ui.red.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @red,\n    @shadowBoxShadow\n  ;\n}\n.ui.red.cards > .card:hover,\n.ui.cards > .red.card:hover,\n.ui.red.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @redHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Orange */\n.ui.orange.cards > .card,\n.ui.cards > .orange.card,\n.ui.orange.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @orange,\n    @shadowBoxShadow\n  ;\n}\n.ui.orange.cards > .card:hover,\n.ui.cards > .orange.card:hover,\n.ui.orange.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @orangeHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Yellow */\n.ui.yellow.cards > .card,\n.ui.cards > .yellow.card,\n.ui.yellow.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @yellow,\n    @shadowBoxShadow\n  ;\n}\n.ui.yellow.cards > .card:hover,\n.ui.cards > .yellow.card:hover,\n.ui.yellow.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @yellowHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Olive */\n.ui.olive.cards > .card,\n.ui.cards > .olive.card,\n.ui.olive.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @olive,\n    @shadowBoxShadow\n  ;\n}\n.ui.olive.cards > .card:hover,\n.ui.cards > .olive.card:hover,\n.ui.olive.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @oliveHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Green */\n.ui.green.cards > .card,\n.ui.cards > .green.card,\n.ui.green.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @green,\n    @shadowBoxShadow\n  ;\n}\n.ui.green.cards > .card:hover,\n.ui.cards > .green.card:hover,\n.ui.green.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @greenHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Teal */\n.ui.teal.cards > .card,\n.ui.cards > .teal.card,\n.ui.teal.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @teal,\n    @shadowBoxShadow\n  ;\n}\n.ui.teal.cards > .card:hover,\n.ui.cards > .teal.card:hover,\n.ui.teal.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @tealHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Blue */\n.ui.blue.cards > .card,\n.ui.cards > .blue.card,\n.ui.blue.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @blue,\n    @shadowBoxShadow\n  ;\n}\n.ui.blue.cards > .card:hover,\n.ui.cards > .blue.card:hover,\n.ui.blue.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @blueHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Violet */\n.ui.violet.cards > .card,\n.ui.cards > .violet.card,\n.ui.violet.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @violet,\n    @shadowBoxShadow\n  ;\n}\n.ui.violet.cards > .card:hover,\n.ui.cards > .violet.card:hover,\n.ui.violet.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @violetHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Purple */\n.ui.purple.cards > .card,\n.ui.cards > .purple.card,\n.ui.purple.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @purple,\n    @shadowBoxShadow\n  ;\n}\n.ui.purple.cards > .card:hover,\n.ui.cards > .purple.card:hover,\n.ui.purple.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @purpleHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Pink */\n.ui.pink.cards > .card,\n.ui.cards > .pink.card,\n.ui.pink.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @pink,\n    @shadowBoxShadow\n  ;\n}\n.ui.pink.cards > .card:hover,\n.ui.cards > .pink.card:hover,\n.ui.pink.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @pinkHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Brown */\n.ui.brown.cards > .card,\n.ui.cards > .brown.card,\n.ui.brown.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @brown,\n    @shadowBoxShadow\n  ;\n}\n.ui.brown.cards > .card:hover,\n.ui.cards > .brown.card:hover,\n.ui.brown.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @brownHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Grey */\n.ui.grey.cards > .card,\n.ui.cards > .grey.card,\n.ui.grey.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @grey,\n    @shadowBoxShadow\n  ;\n}\n.ui.grey.cards > .card:hover,\n.ui.cards > .grey.card:hover,\n.ui.grey.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @greyHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/* Black */\n.ui.black.cards > .card,\n.ui.cards > .black.card,\n.ui.black.card {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @black,\n    @shadowBoxShadow\n  ;\n}\n.ui.black.cards > .card:hover,\n.ui.cards > .black.card:hover,\n.ui.black.card:hover {\n  box-shadow:\n    @borderShadow,\n    0px @coloredShadowDistance 0px 0px @blackHover,\n    @shadowHoverBoxShadow\n  ;\n}\n\n/*--------------\n   Card Count\n---------------*/\n\n.ui.one.cards {\n  margin-left: @oneCardOffset;\n  margin-right: @oneCardOffset;\n}\n.ui.one.cards > .card {\n  width: @oneCard;\n}\n\n.ui.two.cards {\n  margin-left: @twoCardOffset;\n  margin-right: @twoCardOffset;\n}\n.ui.two.cards > .card {\n  width: @twoCard;\n  margin-left: @twoCardSpacing;\n  margin-right: @twoCardSpacing;\n}\n\n.ui.three.cards {\n  margin-left: @threeCardOffset;\n  margin-right: @threeCardOffset;\n}\n.ui.three.cards > .card {\n  width: @threeCard;\n  margin-left: @threeCardSpacing;\n  margin-right: @threeCardSpacing;\n}\n\n.ui.four.cards {\n  margin-left: @fourCardOffset;\n  margin-right: @fourCardOffset;\n}\n.ui.four.cards > .card {\n  width: @fourCard;\n  margin-left: @fourCardSpacing;\n  margin-right: @fourCardSpacing;\n}\n\n.ui.five.cards {\n  margin-left: @fiveCardOffset;\n  margin-right: @fiveCardOffset;\n}\n.ui.five.cards > .card {\n  width: @fiveCard;\n  margin-left: @fiveCardSpacing;\n  margin-right: @fiveCardSpacing;\n}\n\n.ui.six.cards {\n  margin-left: @sixCardOffset;\n  margin-right: @sixCardOffset;\n}\n.ui.six.cards > .card {\n  width: @sixCard;\n  margin-left: @sixCardSpacing;\n  margin-right: @sixCardSpacing;\n}\n\n.ui.seven.cards {\n  margin-left: @sevenCardOffset;\n  margin-right: @sevenCardOffset;\n}\n.ui.seven.cards > .card {\n  width: @sevenCard;\n  margin-left: @sevenCardSpacing;\n  margin-right: @sevenCardSpacing;\n}\n\n.ui.eight.cards {\n  margin-left: @eightCardOffset;\n  margin-right: @eightCardOffset;\n}\n.ui.eight.cards > .card {\n  width: @eightCard;\n  margin-left: @eightCardSpacing;\n  margin-right: @eightCardSpacing;\n  font-size: 11px;\n}\n\n.ui.nine.cards {\n  margin-left: @nineCardOffset;\n  margin-right: @nineCardOffset;\n}\n.ui.nine.cards > .card {\n  width: @nineCard;\n  margin-left: @nineCardSpacing;\n  margin-right: @nineCardSpacing;\n  font-size: 10px;\n}\n\n.ui.ten.cards {\n  margin-left: @tenCardOffset;\n  margin-right: @tenCardOffset;\n}\n.ui.ten.cards > .card {\n  width: @tenCard;\n  margin-left: @tenCardSpacing;\n  margin-right: @tenCardSpacing;\n}\n\n\n/*-------------------\n      Doubling\n--------------------*/\n\n/* Mobile Only */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.two.doubling.cards {\n    margin-left: @oneCardOffset;\n    margin-right: @oneCardOffset;\n  }\n  .ui.two.doubling.cards > .card {\n    width: @oneCard;\n    margin-left: @oneCardSpacing;\n    margin-right: @oneCardSpacing;\n  }\n  .ui.three.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.three.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.four.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.four.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.five.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.five.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.six.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.six.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.seven.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.seven.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.nine.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.nine.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.ten.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.ten.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n}\n\n/* Tablet Only */\n@media only screen and (min-width : @tabletBreakpoint) and (max-width : @largestTabletScreen) {\n  .ui.two.doubling.cards {\n    margin-left: @oneCardOffset;\n    margin-right: @oneCardOffset;\n  }\n  .ui.two.doubling.cards > .card {\n    width: @oneCard;\n    margin-left: @oneCardSpacing;\n    margin-right: @oneCardSpacing;\n  }\n  .ui.three.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.three.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.four.doubling.cards {\n    margin-left: @twoCardOffset;\n    margin-right: @twoCardOffset;\n  }\n  .ui.four.doubling.cards > .card {\n    width: @twoCard;\n    margin-left: @twoCardSpacing;\n    margin-right: @twoCardSpacing;\n  }\n  .ui.five.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.five.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.six.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.six.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: @threeCardOffset;\n    margin-right: @threeCardOffset;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: @threeCard;\n    margin-left: @threeCardSpacing;\n    margin-right: @threeCardSpacing;\n  }\n  .ui.eight.doubling.cards {\n    margin-left: @fourCardOffset;\n    margin-right: @fourCardOffset;\n  }\n  .ui.eight.doubling.cards > .card {\n    width: @fourCard;\n    margin-left: @fourCardSpacing;\n    margin-right: @fourCardSpacing;\n  }\n  .ui.nine.doubling.cards {\n    margin-left: @fourCardOffset;\n    margin-right: @fourCardOffset;\n  }\n  .ui.nine.doubling.cards > .card {\n    width: @fourCard;\n    margin-left: @fourCardSpacing;\n    margin-right: @fourCardSpacing;\n  }\n  .ui.ten.doubling.cards {\n    margin-left: @fiveCardOffset;\n    margin-right: @fiveCardOffset;\n  }\n  .ui.ten.doubling.cards > .card {\n    width: @fiveCard;\n    margin-left: @fiveCardSpacing;\n    margin-right: @fiveCardSpacing;\n  }\n}\n\n/*-------------------\n      Stackable\n--------------------*/\n\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.stackable.cards {\n    display: block !important;\n  }\n  .ui.stackable.cards .card:first-child {\n    margin-top: 0em !important;\n  }\n  .ui.stackable.cards > .card {\n    display: block !important;\n    height: auto !important;\n    margin: @stackableRowSpacing @stackableCardSpacing;\n    padding: 0 !important;\n    width: @stackableMargin !important;\n  }\n}\n\n\n/*--------------\n      Size\n---------------*/\n\n.ui.cards > .card {\n  font-size: @medium;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Comment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'comment';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Standard\n*******************************/\n\n\n/*--------------\n    Comments\n---------------*/\n\n.ui.comments {\n  margin: @margin;\n  max-width: @maxWidth;\n}\n\n.ui.comments:first-child {\n  margin-top: 0em;\n}\n.ui.comments:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Comment\n---------------*/\n\n.ui.comments .comment {\n  position: relative;\n  background: @commentBackground;\n  margin: @commentMargin;\n  padding: @commentPadding;\n  border: @commentBorder;\n  border-top: @commentDivider;\n  line-height: @commentLineHeight;\n}\n.ui.comments .comment:first-child {\n  margin-top: @firstCommentMargin;\n  padding-top: @firstCommentPadding;\n}\n\n\n/*--------------------\n    Nested Comments\n---------------------*/\n\n.ui.comments .comment .comments {\n  margin: @nestedCommentsMargin;\n  padding: @nestedCommentsPadding;\n}\n.ui.comments .comment .comments:before{\n  position: absolute;\n  top: 0px;\n  left: 0px;\n}\n.ui.comments .comment .comments .comment {\n  border: @nestedCommentBorder;\n  border-top: @nestedCommentDivider;\n  background: @nestedCommentBackground;\n}\n\n/*--------------\n     Avatar\n---------------*/\n\n.ui.comments .comment .avatar {\n  display: @avatarDisplay;\n  width: @avatarWidth;\n  height: @avatarHeight;\n  float: @avatarFloat;\n  margin: @avatarMargin;\n}\n.ui.comments .comment img.avatar,\n.ui.comments .comment .avatar img {\n  display: block;\n  margin: 0em auto;\n  width: 100%;\n  height: 100%;\n  border-radius: @avatarBorderRadius;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.comments .comment > .content {\n  display: block;\n}\n/* If there is an avatar move content over */\n.ui.comments .comment > .avatar ~ .content {\n  margin-left: @contentMargin;\n}\n\n/*--------------\n     Author\n---------------*/\n\n.ui.comments .comment .author {\n  font-size: @authorFontSize;\n  color: @authorColor;\n  font-weight: @authorFontWeight;\n}\n.ui.comments .comment a.author {\n  cursor: pointer;\n}\n.ui.comments .comment a.author:hover {\n  color: @authorHoverColor;\n}\n\n/*--------------\n     Metadata\n---------------*/\n\n.ui.comments .comment .metadata {\n  display: @metadataDisplay;\n  margin-left: @metadataSpacing;\n  color: @metadataColor;\n  font-size: @metadataFontSize;\n}\n.ui.comments .comment .metadata > * {\n  display: inline-block;\n  margin: 0em @metadataContentSpacing 0em 0em;\n}\n.ui.comments .comment .metadata > :last-child {\n  margin-right: 0em;\n}\n\n/*--------------------\n     Comment Text\n---------------------*/\n\n.ui.comments .comment .text {\n  margin: @textMargin;\n  font-size: @textFontSize;\n  word-wrap: @textWordWrap;\n  color: @textColor;\n  line-height: @textLineHeight;\n}\n\n\n/*--------------------\n     User Actions\n---------------------*/\n\n.ui.comments .comment .actions {\n  font-size: @actionFontSize;\n}\n.ui.comments .comment .actions a {\n  cursor: pointer;\n  display: inline-block;\n  margin: 0em @actionContentDistance 0em 0em;\n  color: @actionLinkColor;\n}\n.ui.comments .comment .actions a:last-child {\n  margin-right: 0em;\n}\n.ui.comments .comment .actions a.active,\n.ui.comments .comment .actions a:hover {\n  color: @actionLinkHoverColor;\n}\n\n/*--------------------\n      Reply Form\n---------------------*/\n\n.ui.comments > .reply.form {\n  margin-top: @replyDistance;\n}\n.ui.comments .comment .reply.form {\n  width: 100%;\n  margin-top: @commentReplyDistance;\n}\n.ui.comments .reply.form textarea {\n  font-size: @replyFontSize;\n  height: @replyHeight;\n}\n\n/*******************************\n            State\n*******************************/\n\n.ui.collapsed.comments,\n.ui.comments .collapsed.comments,\n.ui.comments .collapsed.comment {\n  display: none;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------------\n        Threaded\n---------------------*/\n\n.ui.threaded.comments .comment .comments {\n  margin: @threadedCommentMargin;\n  padding: @threadedCommentPadding;\n  box-shadow: @threadedCommentBoxShadow;\n}\n\n/*--------------------\n        Minimal\n---------------------*/\n\n.ui.minimal.comments .comment .actions {\n  opacity: 0;\n  position: @minimalActionPosition;\n  top: @minimalActionTop;\n  right: @minimalActionRight;\n  left: @minimalActionLeft;\n  transition: @minimalTransition;\n  transition-delay: @minimalTransitionDelay;\n}\n.ui.minimal.comments .comment > .content:hover > .actions {\n  opacity: 1;\n}\n\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.comments {\n  font-size: @mini;\n}\n.ui.tiny.comments {\n  font-size: @tiny;\n}\n.ui.small.comments {\n  font-size: @small;\n}\n.ui.comments {\n  font-size: @medium;\n}\n.ui.large.comments {\n  font-size: @large;\n}\n.ui.big.comments {\n  font-size: @big;\n}\n.ui.huge.comments {\n  font-size: @huge;\n}\n.ui.massive.comments {\n  font-size: @massive;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Feed\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'feed';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n         Activity Feed\n*******************************/\n\n.ui.feed {\n  margin: @margin;\n}\n.ui.feed:first-child {\n  margin-top: 0em;\n}\n.ui.feed:last-child {\n  margin-bottom: 0em;\n}\n\n\n/*******************************\n            Content\n*******************************/\n\n/* Event */\n.ui.feed > .event {\n  display: flex;\n  flex-direction: row;\n  width: @eventWidth;\n  padding: @eventPadding;\n  margin: @eventMargin;\n  background: @eventBackground;\n  border-top: @eventDivider;\n}\n.ui.feed > .event:first-child {\n  border-top: 0px;\n  padding-top: 0em;\n}\n.ui.feed > .event:last-child {\n  padding-bottom: 0em;\n}\n\n/* Event Label */\n.ui.feed > .event > .label {\n  display: block;\n  flex: 0 0 auto;\n  width: @labelWidth;\n  height: @labelHeight;\n  align-self: @labelAlignSelf;\n  text-align: @labelTextAlign;\n}\n.ui.feed > .event > .label .icon {\n  opacity: @iconLabelOpacity;\n  font-size: @iconLabelSize;\n  width: @iconLabelWidth;\n  padding: @iconLabelPadding;\n  background: @iconLabelBackground;\n  border: @iconLabelBorder;\n  border-radius: @iconLabelBorderRadius;\n  color: @iconLabelColor;\n}\n.ui.feed > .event > .label img {\n  width: @imageLabelWidth;\n  height: @imageLabelHeight;\n  border-radius: @imageLabelBorderRadius;\n}\n.ui.feed > .event > .label + .content {\n  margin: @labeledContentMargin;\n}\n\n/*--------------\n     Content\n---------------*/\n\n/* Content */\n.ui.feed > .event > .content {\n  display: block;\n  flex: 1 1 auto;\n  align-self: @contentAlignSelf;\n  text-align: @contentTextAlign;\n  word-wrap: @contentWordWrap;\n}\n.ui.feed > .event:last-child > .content {\n  padding-bottom: @lastLabeledContentPadding;\n}\n\n/* Link */\n.ui.feed > .event > .content a {\n  cursor: pointer;\n}\n\n/*--------------\n      Date\n---------------*/\n\n.ui.feed > .event > .content .date {\n  margin: @dateMargin;\n  padding: @datePadding;\n  color: @dateColor;\n  font-weight: @dateFontWeight;\n  font-size: @dateFontSize;\n  font-style: @dateFontStyle;\n  color: @dateColor;\n}\n\n/*--------------\n     Summary\n---------------*/\n\n.ui.feed > .event > .content .summary {\n  margin: @summaryMargin;\n  font-size: @summaryFontSize;\n  font-weight: @summaryFontWeight;\n  color: @summaryColor;\n}\n\n/* Summary Image */\n.ui.feed > .event > .content .summary img {\n  display: inline-block;\n  width: @summaryImageWidth;\n  height: @summaryImageHeight;\n  margin: @summaryImageMargin;\n  border-radius: @summaryImageBorderRadius;\n  vertical-align: @summaryImageVerticalAlign;\n}\n/*--------------\n      User\n---------------*/\n\n.ui.feed > .event > .content .user {\n  display: inline-block;\n  font-weight: @userFontWeight;\n  margin-right: @userDistance;\n  vertical-align: baseline;\n}\n.ui.feed > .event > .content .user img {\n  margin: @userImageMargin;\n  width: @userImageWidth;\n  height: @userImageHeight;\n  vertical-align: @userImageVerticalAlign;\n}\n/*--------------\n   Inline Date\n---------------*/\n\n/* Date inside Summary */\n.ui.feed > .event > .content .summary > .date {\n  display: @summaryDateDisplay;\n  float: @summaryDateFloat;\n  font-weight: @summaryDateFontWeight;\n  font-size: @summaryDateFontSize;\n  font-style: @summaryDateFontStyle;\n  margin: @summaryDateMargin;\n  padding: @summaryDatePadding;\n  color: @summaryDateColor;\n}\n\n/*--------------\n  Extra Summary\n---------------*/\n\n.ui.feed > .event > .content .extra {\n  margin: @extraMargin;\n  background: @extraBackground;\n  padding: @extraPadding;\n  color: @extraColor;\n}\n\n/* Images */\n.ui.feed > .event > .content .extra.images img {\n  display: inline-block;\n  margin: @extraImageMargin;\n  width: @extraImageWidth;\n}\n\n/* Text */\n.ui.feed > .event > .content .extra.text {\n  padding: @extraTextPadding;\n  border-left: @extraTextPointer;\n  font-size: @extraTextFontSize;\n  max-width: @extraTextMaxWidth;\n  line-height: @extraTextLineHeight;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.feed > .event > .content .meta {\n  display: @metadataDisplay;\n  font-size: @metadataFontSize;\n  margin: @metadataMargin;\n  background: @metadataBackground;\n  border: @metadataBorder;\n  border-radius: @metadataBorderRadius;\n  box-shadow: @metadataBoxShadow;\n  padding: @metadataPadding;\n  color: @metadataColor;\n}\n\n.ui.feed > .event > .content .meta > * {\n  position: relative;\n  margin-left: @metadataElementSpacing;\n}\n.ui.feed > .event > .content .meta > *:after {\n  content: @metadataDivider;\n  color: @metadataDividerColor;\n  top: 0em;\n  left: @metadataDividerOffset;\n  opacity: 1;\n  position: absolute;\n  vertical-align: top;\n}\n\n.ui.feed > .event > .content .meta .like {\n  color: @likeColor;\n  transition: @likeTransition;\n}\n.ui.feed > .event > .content .meta .like:hover .icon {\n  color: @likeHoverColor;\n}\n.ui.feed > .event > .content .meta .active.like .icon {\n  color: @likeActiveColor;\n}\n\n/* First element */\n.ui.feed > .event > .content .meta > :first-child {\n  margin-left: 0em;\n}\n.ui.feed > .event > .content .meta > :first-child::after {\n  display: none;\n}\n\n/* Action */\n.ui.feed > .event > .content .meta a,\n.ui.feed > .event > .content .meta > .icon {\n  cursor: @metadataActionCursor;\n  opacity: @metadataActionOpacity;\n  color: @metadataActionColor;\n  transition: @metadataActionTransition;\n}\n.ui.feed > .event > .content .meta a:hover,\n.ui.feed > .event > .content .meta a:hover .icon,\n.ui.feed > .event > .content .meta > .icon:hover {\n  color: @metadataActionHoverColor;\n}\n\n\n\n/*******************************\n            Variations\n*******************************/\n\n.ui.small.feed {\n  font-size: @small;\n}\n.ui.feed {\n  font-size: @medium;\n}\n.ui.large.feed {\n  font-size: @large;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'item';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Item\n---------------*/\n\n.ui.items > .item {\n  display: @display;\n  margin: @itemSpacing 0em;\n  width: @width;\n  min-height: @minHeight;\n  background: @background;\n  padding: @padding;\n\n  border: @border;\n  border-radius: @borderRadius;\n  box-shadow: @boxShadow;\n  transition: @transition;\n  z-index: @zIndex;\n}\n.ui.items > .item a {\n  cursor: pointer;\n}\n\n/*--------------\n      Items\n---------------*/\n\n.ui.items {\n  margin: @groupMargin;\n}\n\n.ui.items:first-child {\n  margin-top: 0em !important;\n}\n.ui.items:last-child {\n  margin-bottom: 0em !important;\n}\n\n/*--------------\n      Item\n---------------*/\n\n.ui.items > .item:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ui.items > .item:first-child {\n  margin-top: 0em;\n}\n.ui.items > .item:last-child {\n  margin-bottom: 0em;\n}\n\n\n\n/*--------------\n     Images\n---------------*/\n\n.ui.items > .item > .image {\n  position: relative;\n  flex: 0 0 auto;\n  display: @imageDisplay;\n  float: @imageFloat;\n  margin: @imageMargin;\n  padding: @imagePadding;\n  max-height: @imageMaxHeight;\n  align-self: @imageVerticalAlign;\n}\n.ui.items > .item > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: @imageBorderRadius;\n  border: @imageBorder;\n}\n\n.ui.items > .item > .image:only-child > img {\n  border-radius: @borderRadius;\n}\n\n\n/*--------------\n     Content\n---------------*/\n\n.ui.items > .item > .content {\n  display: block;\n  flex: 1 1 auto;\n  background: @contentBackground;\n  margin: @contentMargin;\n  padding: @contentPadding;\n  box-shadow: @contentBoxShadow;\n  font-size: @contentFontSize;\n  border: @contentBorder;\n  border-radius: @contentBorderRadius;\n}\n.ui.items > .item > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.items > .item > .image + .content {\n  min-width: 0;\n  width: @contentWidth;\n  display: @contentDisplay;\n  margin-left: @contentOffset;\n  align-self: @contentVerticalAlign;\n  padding-left: @contentImageDistance;\n}\n\n.ui.items > .item > .content > .header {\n  display: inline-block;\n  margin: @headerMargin;\n  font-family: @headerFont;\n  font-weight: @headerFontWeight;\n  color: @headerColor;\n}\n/* Default Header Size */\n.ui.items > .item > .content > .header:not(.ui) {\n  font-size: @headerFontSize;\n}\n\n/*--------------\n     Floated\n---------------*/\n\n.ui.items > .item [class*=\"left floated\"] {\n  float: left;\n}\n.ui.items > .item [class*=\"right floated\"] {\n  float: right;\n}\n\n\n/*--------------\n  Content Image\n---------------*/\n\n.ui.items > .item .content img {\n  align-self: @contentImageVerticalAlign;\n  width: @contentImageWidth;\n}\n.ui.items > .item img.avatar,\n.ui.items > .item .avatar img {\n  width: @avatarSize;\n  height: @avatarSize;\n  border-radius: @avatarBorderRadius;\n}\n\n\n/*--------------\n   Description\n---------------*/\n\n.ui.items > .item > .content > .description {\n  margin-top: @descriptionDistance;\n  max-width: @descriptionMaxWidth;\n  font-size: @descriptionFontSize;\n  line-height: @descriptionLineHeight;\n  color: @descriptionColor;\n}\n\n/*--------------\n    Paragraph\n---------------*/\n\n.ui.items > .item > .content p {\n  margin: 0em 0em @paragraphDistance;\n}\n.ui.items > .item > .content p:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.items > .item .meta {\n  margin: @metaMargin;\n  font-size: @metaFontSize;\n  line-height: @metaLineHeight;\n  color: @metaColor;\n}\n.ui.items > .item .meta * {\n  margin-right: @metaSpacing;\n}\n.ui.items > .item .meta :last-child {\n  margin-right: 0em;\n}\n\n.ui.items > .item .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: @metaSpacing;\n}\n\n/*--------------\n      Links\n---------------*/\n\n/* Generic */\n.ui.items > .item > .content a:not(.ui) {\n  color: @contentLinkColor;\n  transition: @contentLinkTransition;\n}\n.ui.items > .item > .content a:not(.ui):hover {\n  color: @contentLinkHoverColor;\n}\n\n/* Header */\n.ui.items > .item > .content > a.header {\n  color: @headerLinkColor;\n}\n.ui.items > .item > .content > a.header:hover {\n  color: @headerLinkHoverColor;\n}\n\n/* Meta */\n.ui.items > .item .meta > a:not(.ui) {\n  color: @metaLinkColor;\n}\n.ui.items > .item .meta > a:not(.ui):hover {\n  color: @metaLinkHoverColor;\n}\n\n\n\n/*--------------\n     Labels\n---------------*/\n\n/*-----Star----- */\n\n/* Icon */\n.ui.items > .item > .content .favorite.icon {\n  cursor: pointer;\n  opacity: @actionOpacity;\n  transition: @actionTransition;\n}\n.ui.items > .item > .content .favorite.icon:hover {\n  opacity: @actionHoverOpacity;\n  color: @favoriteColor;\n}\n.ui.items > .item > .content .active.favorite.icon {\n  color: @favoriteActiveColor;\n}\n\n/*-----Like----- */\n\n/* Icon */\n.ui.items > .item > .content .like.icon {\n  cursor: pointer;\n  opacity: @actionOpacity;\n  transition: @actionTransition;\n}\n.ui.items > .item > .content .like.icon:hover {\n  opacity: @actionHoverOpacity;\n  color: @likeColor;\n}\n.ui.items > .item > .content .active.like.icon {\n  color: @likeActiveColor;\n}\n\n/*----------------\n  Extra Content\n-----------------*/\n\n.ui.items > .item .extra {\n  display: @extraDisplay;\n  position: @extraPosition;\n  background: @extraBackground;\n  margin: @extraMargin;\n  width: @extraWidth;\n  padding: @extraPadding;\n  top: @extraTop;\n  left: @extraLeft;\n  color: @extraColor;\n  box-shadow: @extraBoxShadow;\n  transition: @extraTransition;\n  border-top: @extraDivider;\n}\n.ui.items > .item .extra > * {\n  margin: (@extraRowSpacing / 2) @extraHorizontalSpacing (@extraRowSpacing / 2) 0em;\n}\n.ui.items > .item .extra > [class*=\"right floated\"] {\n  margin: (@extraRowSpacing / 2) 0em (@extraRowSpacing / 2) @extraHorizontalSpacing;\n}\n\n.ui.items > .item .extra:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n\n/*******************************\n          Responsive\n*******************************/\n\n/* Default Image Width */\n.ui.items > .item > .image:not(.ui) {\n  width: @imageWidth;\n}\n\n\n/* Tablet Only */\n@media only screen and (min-width: @tabletBreakpoint) and (max-width: @largestTabletScreen) {\n  .ui.items > .item {\n    margin: @tabletItemSpacing 0em;\n  }\n  .ui.items > .item > .image:not(.ui) {\n    width: @tabletImageWidth;\n  }\n  .ui.items > .item > .image + .content {\n    display: block;\n    padding: 0em 0em 0em @tabletContentImageDistance;\n  }\n\n}\n\n/* Mobile Only */\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.items:not(.unstackable) > .item {\n    flex-direction: column;\n    margin: @mobileItemSpacing 0em;\n  }\n  .ui.items:not(.unstackable) > .item > .image {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .ui.items:not(.unstackable) > .item > .image,\n  .ui.items:not(.unstackable) > .item > .image > img {\n    max-width: 100% !important;\n    width: @mobileImageWidth !important;\n    max-height: @mobileImageMaxHeight !important;\n  }\n  .ui.items:not(.unstackable) > .item > .image + .content {\n    display: block;\n    padding: @mobileContentImageDistance 0em 0em;\n  }\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.items > .item > .image + [class*=\"top aligned\"].content {\n  align-self: flex-start;\n}\n.ui.items > .item > .image + [class*=\"middle aligned\"].content {\n  align-self: center;\n}\n.ui.items > .item > .image + [class*=\"bottom aligned\"].content {\n  align-self: flex-end;\n}\n\n\n/*--------------\n     Relaxed\n---------------*/\n\n.ui.relaxed.items > .item {\n  margin: @relaxedItemSpacing 0em;\n}\n.ui[class*=\"very relaxed\"].items > .item {\n  margin: @veryRelaxedItemSpacing 0em;\n}\n\n\n/*-------------------\n      Divided\n--------------------*/\n\n.ui.divided.items > .item {\n  border-top: @dividedBorder;\n  margin: @dividedMargin;\n  padding: @dividedPadding;\n}\n.ui.divided.items > .item:first-child {\n  border-top: none;\n  margin-top: @dividedFirstLastMargin !important;\n  padding-top: @dividedFirstLastPadding !important;\n}\n.ui.divided.items > .item:last-child {\n  margin-bottom: @dividedFirstLastMargin !important;\n  padding-bottom: @dividedFirstLastPadding !important;\n}\n\n/* Relaxed Divided */\n.ui.relaxed.divided.items > .item {\n  margin: 0em;\n  padding: @relaxedItemSpacing 0em;\n}\n.ui[class*=\"very relaxed\"].divided.items > .item {\n  margin: 0em;\n  padding: @veryRelaxedItemSpacing 0em;\n}\n\n\n/*-------------------\n        Link\n--------------------*/\n\n.ui.items a.item:hover,\n.ui.link.items > .item:hover {\n  cursor: pointer;\n}\n\n.ui.items a.item:hover .content .header,\n.ui.link.items > .item:hover .content .header {\n  color: @headerLinkHoverColor;\n}\n\n\n/*--------------\n      Size\n---------------*/\n\n.ui.items > .item {\n  font-size: @relativeMedium;\n}\n\n/*---------------\n   Unstackable\n----------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.unstackable.items > .item > .image,\n  .ui.unstackable.items > .item > .image > img {\n    width: @unstackableMobileImageWidth !important;\n  }\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Statistic\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'view';\n@element : 'statistic';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n           Statistic\n*******************************/\n\n/* Standalone */\n.ui.statistic {\n  display: inline-flex;\n  flex-direction: column;\n  margin: @margin;\n  max-width: @maxWidth;\n}\n\n.ui.statistic + .ui.statistic {\n  margin: 0em 0em 0em @horizontalSpacing;\n}\n\n.ui.statistic:first-child {\n  margin-top: 0em;\n}\n.ui.statistic:last-child {\n  margin-bottom: 0em;\n}\n\n\n\n/*******************************\n            Group\n*******************************/\n\n/* Grouped */\n.ui.statistics {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.ui.statistics > .statistic {\n  display: inline-flex;\n  flex: 0 1 auto;\n  flex-direction: column;\n  margin: @elementMargin;\n  max-width: @elementMaxWidth;\n}\n.ui.statistics {\n  display: flex;\n  margin: @groupMargin;\n}\n\n/* Clearing */\n.ui.statistics:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.statistics:first-child {\n  margin-top: 0em;\n}\n\n\n/*******************************\n            Content\n*******************************/\n\n\n/*--------------\n      Value\n---------------*/\n\n.ui.statistics .statistic > .value,\n.ui.statistic > .value {\n  font-family: @valueFont;\n  font-size: @valueSize;\n  font-weight: @valueFontWeight;\n  line-height: @valueLineHeight;\n  color: @valueColor;\n  text-transform: @valueTextTransform;\n  text-align: @textAlign;\n}\n\n/*--------------\n     Label\n---------------*/\n\n.ui.statistics .statistic > .label,\n.ui.statistic > .label {\n  font-family: @labelFont;\n  font-size: @labelSize;\n  font-weight: @labelFontWeight;\n  color: @labelColor;\n  text-transform: @labelTextTransform;\n  text-align: @textAlign;\n}\n\n/* Top Label */\n.ui.statistics .statistic > .label ~ .value,\n.ui.statistic > .label ~ .value {\n  margin-top: @topLabelDistance;\n}\n\n/* Bottom Label */\n.ui.statistics .statistic > .value ~ .label,\n.ui.statistic > .value ~ .label {\n  margin-top: @bottomLabelDistance;\n}\n\n\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n   Icon Value\n---------------*/\n\n.ui.statistics .statistic > .value .icon,\n.ui.statistic > .value .icon {\n  opacity: 1;\n  width: auto;\n  margin: 0em;\n}\n\n/*--------------\n   Text Value\n---------------*/\n\n.ui.statistics .statistic > .text.value,\n.ui.statistic > .text.value {\n  line-height: @textValueLineHeight;\n  min-height: @textValueMinHeight;\n  font-weight: @textValueFontWeight;\n  text-align: center;\n}\n.ui.statistics .statistic > .text.value + .label,\n.ui.statistic > .text.value + .label {\n  text-align: center;\n}\n\n/*--------------\n   Image Value\n---------------*/\n\n.ui.statistics .statistic > .value img,\n.ui.statistic > .value img {\n  max-height: @imageHeight;\n  vertical-align: @imageVerticalAlign;\n}\n\n\n\n/*******************************\n            Variations\n*******************************/\n\n\n/*--------------\n      Count\n---------------*/\n\n\n.ui.ten.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.ten.statistics .statistic {\n  min-width: @tenColumn;\n  margin: @itemMargin;\n}\n\n.ui.nine.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.nine.statistics .statistic {\n  min-width: @nineColumn;\n  margin: @itemMargin;\n}\n\n.ui.eight.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.eight.statistics .statistic {\n  min-width: @eightColumn;\n  margin: @itemMargin;\n}\n\n.ui.seven.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.seven.statistics .statistic {\n  min-width: @sevenColumn;\n  margin: @itemMargin;\n}\n\n.ui.six.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.six.statistics .statistic {\n  min-width: @sixColumn;\n  margin: @itemMargin;\n}\n\n.ui.five.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.five.statistics .statistic {\n  min-width: @fiveColumn;\n  margin: @itemMargin;\n}\n\n.ui.four.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.four.statistics .statistic {\n  min-width: @fourColumn;\n  margin: @itemMargin;\n}\n\n.ui.three.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.three.statistics .statistic {\n  min-width: @threeColumn;\n  margin: @itemMargin;\n}\n\n.ui.two.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.two.statistics .statistic {\n  min-width: @twoColumn;\n  margin: @itemMargin;\n}\n\n.ui.one.statistics {\n  margin: @itemGroupMargin;\n}\n.ui.one.statistics .statistic {\n  min-width: @oneColumn;\n  margin: @itemMargin;\n}\n\n\n\n\n/*--------------\n   Horizontal\n---------------*/\n\n.ui.horizontal.statistic {\n  flex-direction: row;\n  align-items: center;\n}\n.ui.horizontal.statistics {\n  flex-direction: column;\n  margin: 0em;\n  max-width: none;\n}\n.ui.horizontal.statistics .statistic {\n  flex-direction: row;\n  align-items: center;\n  max-width: none;\n  margin: @horizontalGroupElementMargin;\n}\n\n.ui.horizontal.statistic > .text.value,\n.ui.horizontal.statistics > .statistic > .text.value {\n  min-height: 0em !important;\n}\n.ui.horizontal.statistics .statistic > .value .icon,\n.ui.horizontal.statistic > .value .icon {\n  width: @iconWidth;\n}\n\n.ui.horizontal.statistics .statistic > .value,\n.ui.horizontal.statistic > .value {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ui.horizontal.statistics .statistic > .label,\n.ui.horizontal.statistic > .label {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0em 0em 0em @horizontalLabelDistance;\n}\n\n/*--------------\n     Colors\n---------------*/\n\n.ui.red.statistics .statistic > .value,\n.ui.statistics .red.statistic > .value,\n.ui.red.statistic > .value {\n  color: @red;\n}\n.ui.orange.statistics .statistic > .value,\n.ui.statistics .orange.statistic > .value,\n.ui.orange.statistic > .value {\n  color: @orange;\n}\n.ui.yellow.statistics .statistic > .value,\n.ui.statistics .yellow.statistic > .value,\n.ui.yellow.statistic > .value {\n  color: @yellow;\n}\n.ui.olive.statistics .statistic > .value,\n.ui.statistics .olive.statistic > .value,\n.ui.olive.statistic > .value {\n  color: @olive;\n}\n.ui.green.statistics .statistic > .value,\n.ui.statistics .green.statistic > .value,\n.ui.green.statistic > .value {\n  color: @green;\n}\n.ui.teal.statistics .statistic > .value,\n.ui.statistics .teal.statistic > .value,\n.ui.teal.statistic > .value {\n  color: @teal;\n}\n.ui.blue.statistics .statistic > .value,\n.ui.statistics .blue.statistic > .value,\n.ui.blue.statistic > .value {\n  color: @blue;\n}\n.ui.violet.statistics .statistic > .value,\n.ui.statistics .violet.statistic > .value,\n.ui.violet.statistic > .value {\n  color: @violet;\n}\n.ui.purple.statistics .statistic > .value,\n.ui.statistics .purple.statistic > .value,\n.ui.purple.statistic > .value {\n  color: @purple;\n}\n.ui.pink.statistics .statistic > .value,\n.ui.statistics .pink.statistic > .value,\n.ui.pink.statistic > .value {\n  color: @pink;\n}\n.ui.brown.statistics .statistic > .value,\n.ui.statistics .brown.statistic > .value,\n.ui.brown.statistic > .value {\n  color: @brown;\n}\n.ui.grey.statistics .statistic > .value,\n.ui.statistics .grey.statistic > .value,\n.ui.grey.statistic > .value {\n  color: @grey;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.statistics .statistic > .value,\n.ui.inverted.statistic .value {\n  color: @invertedValueColor;\n}\n.ui.inverted.statistics .statistic > .label,\n.ui.inverted.statistic .label {\n  color: @invertedLabelColor;\n}\n\n.ui.inverted.red.statistics .statistic > .value,\n.ui.statistics .inverted.red.statistic > .value,\n.ui.inverted.red.statistic > .value {\n  color: @lightRed;\n}\n.ui.inverted.orange.statistics .statistic > .value,\n.ui.statistics .inverted.orange.statistic > .value,\n.ui.inverted.orange.statistic > .value {\n  color: @lightOrange;\n}\n.ui.inverted.yellow.statistics .statistic > .value,\n.ui.statistics .inverted.yellow.statistic > .value,\n.ui.inverted.yellow.statistic > .value {\n  color: @lightYellow;\n}\n.ui.inverted.olive.statistics .statistic > .value,\n.ui.statistics .inverted.olive.statistic > .value,\n.ui.inverted.olive.statistic > .value {\n  color: @lightOlive;\n}\n.ui.inverted.green.statistics .statistic > .value,\n.ui.statistics .inverted.green.statistic > .value,\n.ui.inverted.green.statistic > .value {\n  color: @lightGreen;\n}\n.ui.inverted.teal.statistics .statistic > .value,\n.ui.statistics .inverted.teal.statistic > .value,\n.ui.inverted.teal.statistic > .value {\n  color: @lightTeal;\n}\n.ui.inverted.blue.statistics .statistic > .value,\n.ui.statistics .inverted.blue.statistic > .value,\n.ui.inverted.blue.statistic > .value {\n  color: @lightBlue;\n}\n.ui.inverted.violet.statistics .statistic > .value,\n.ui.statistics .inverted.violet.statistic > .value,\n.ui.inverted.violet.statistic > .value {\n  color: @lightViolet;\n}\n.ui.inverted.purple.statistics .statistic > .value,\n.ui.statistics .inverted.purple.statistic > .value,\n.ui.inverted.purple.statistic > .value {\n  color: @lightPurple;\n}\n.ui.inverted.pink.statistics .statistic > .value,\n.ui.statistics .inverted.pink.statistic > .value,\n.ui.inverted.pink.statistic > .value {\n  color: @lightPink;\n}\n.ui.inverted.brown.statistics .statistic > .value,\n.ui.statistics .inverted.brown.statistic > .value,\n.ui.inverted.brown.statistic > .value {\n  color: @lightBrown;\n}\n.ui.inverted.grey.statistics .statistic > .value,\n.ui.statistics .inverted.grey.statistic > .value,\n.ui.inverted.grey.statistic > .value {\n  color: @lightGrey;\n}\n\n/*--------------\n    Floated\n---------------*/\n\n.ui[class*=\"left floated\"].statistic {\n  float: left;\n  margin: @leftFloatedMargin;\n}\n.ui[class*=\"right floated\"].statistic {\n  float: right;\n  margin: @rightFloatedMargin;\n}\n.ui.floated.statistic:last-child {\n  margin-bottom: 0em;\n}\n\n\n/*--------------\n     Sizes\n---------------*/\n\n\n/* Mini */\n.ui.mini.statistics .statistic > .value,\n.ui.mini.statistic > .value {\n  font-size: @miniValueSize !important;\n}\n.ui.mini.horizontal.statistics .statistic > .value,\n.ui.mini.horizontal.statistic > .value {\n  font-size: @miniHorizontalValueSize !important;\n}\n.ui.mini.statistics .statistic > .text.value,\n.ui.mini.statistic > .text.value {\n  font-size: @miniTextValueSize !important;\n}\n\n\n/* Tiny */\n.ui.tiny.statistics .statistic > .value,\n.ui.tiny.statistic > .value {\n  font-size: @tinyValueSize !important;\n}\n.ui.tiny.horizontal.statistics .statistic > .value,\n.ui.tiny.horizontal.statistic > .value {\n  font-size: @tinyHorizontalValueSize !important;\n}\n.ui.tiny.statistics .statistic > .text.value,\n.ui.tiny.statistic > .text.value {\n  font-size: @tinyTextValueSize !important;\n}\n\n/* Small */\n.ui.small.statistics .statistic > .value,\n.ui.small.statistic > .value {\n  font-size: @smallValueSize !important;\n}\n.ui.small.horizontal.statistics .statistic > .value,\n.ui.small.horizontal.statistic > .value {\n  font-size: @smallHorizontalValueSize !important;\n}\n.ui.small.statistics .statistic > .text.value,\n.ui.small.statistic > .text.value {\n  font-size: @smallTextValueSize !important;\n}\n\n/* Medium */\n.ui.statistics .statistic > .value,\n.ui.statistic > .value {\n  font-size: @valueSize !important;\n}\n.ui.horizontal.statistics .statistic > .value,\n.ui.horizontal.statistic > .value {\n  font-size: @horizontalValueSize !important;\n}\n.ui.statistics .statistic > .text.value,\n.ui.statistic > .text.value {\n  font-size: @textValueSize !important;\n}\n\n/* Large */\n.ui.large.statistics .statistic > .value,\n.ui.large.statistic > .value {\n  font-size: @largeValueSize !important;\n}\n.ui.large.horizontal.statistics .statistic > .value,\n.ui.large.horizontal.statistic > .value {\n  font-size: @largeHorizontalValueSize !important;\n}\n.ui.large.statistics .statistic > .text.value,\n.ui.large.statistic > .text.value {\n  font-size: @largeTextValueSize !important;\n}\n\n/* Huge */\n.ui.huge.statistics .statistic > .value,\n.ui.huge.statistic > .value {\n  font-size: @hugeValueSize !important;\n}\n.ui.huge.horizontal.statistics .statistic > .value,\n.ui.huge.horizontal.statistic > .value {\n  font-size: @hugeHorizontalValueSize !important;\n}\n.ui.huge.statistics .statistic > .text.value,\n.ui.huge.statistic > .text.value {\n  font-size: @hugeTextValueSize !important;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Accordion\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'accordion';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Accordion\n*******************************/\n\n.ui.accordion,\n.ui.accordion .accordion {\n  max-width: 100%;\n}\n.ui.accordion .accordion {\n  margin: @childAccordionMargin;\n  padding: @childAccordionPadding;\n}\n\n/* Title */\n.ui.accordion .title,\n.ui.accordion .accordion .title {\n  cursor: pointer;\n}\n\n/* Default Styling */\n.ui.accordion .title:not(.ui) {\n  padding: @titlePadding;\n  font-family: @titleFont;\n  font-size: @titleFontSize;\n  color: @titleColor;\n}\n\n/* Content */\n.ui.accordion .title ~ .content,\n.ui.accordion .accordion .title ~ .content {\n  display: none;\n}\n\n/* Default Styling */\n.ui.accordion:not(.styled) .title ~ .content:not(.ui),\n.ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {\n  margin: @contentMargin;\n  padding: @contentPadding;\n}\n.ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {\n  padding-bottom: 0em;\n}\n\n/* Arrow */\n.ui.accordion .title .dropdown.icon,\n.ui.accordion .accordion .title .dropdown.icon {\n  display: @iconDisplay;\n  float: @iconFloat;\n  opacity: @iconOpacity;\n  width: @iconWidth;\n  height: @iconHeight;\n  margin: @iconMargin;\n  padding: @iconPadding;\n  font-size: @iconFontSize;\n  transition: @iconTransition;\n  vertical-align: @iconVerticalAlign;\n  transform: @iconTransform;\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n/* Menu */\n.ui.accordion.menu .item .title {\n  display: block;\n  padding: @menuTitlePadding;\n}\n.ui.accordion.menu .item .title > .dropdown.icon {\n  float: @menuIconFloat;\n  margin: @menuIconMargin;\n  transform: @menuIconTransform;\n}\n\n/* Header */\n.ui.accordion .ui.header .dropdown.icon {\n  font-size: @iconFontSize;\n  margin: @iconMargin;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.accordion .active.title .dropdown.icon,\n.ui.accordion .accordion .active.title .dropdown.icon {\n  transform: @activeIconTransform;\n}\n\n.ui.accordion.menu .item .active.title > .dropdown.icon {\n  transform: @activeIconTransform;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n     Styled\n---------------*/\n\n.ui.styled.accordion {\n  width: @styledWidth;\n}\n\n.ui.styled.accordion,\n.ui.styled.accordion .accordion {\n  border-radius: @styledBorderRadius;\n  background: @styledBackground;\n  box-shadow: @styledBoxShadow;\n}\n.ui.styled.accordion .title,\n.ui.styled.accordion .accordion .title {\n  margin: @styledTitleMargin;\n  padding: @styledTitlePadding;\n  color: @styledTitleColor;\n  font-weight: @styledTitleFontWeight;\n  border-top: @styledTitleBorder;\n  transition: @styledTitleTransition;\n}\n.ui.styled.accordion > .title:first-child,\n.ui.styled.accordion .accordion .title:first-child {\n  border-top: none;\n}\n\n\n/* Content */\n.ui.styled.accordion .content,\n.ui.styled.accordion .accordion .content {\n  margin: @styledContentMargin;\n  padding: @styledContentPadding;\n}\n.ui.styled.accordion .accordion .content {\n  padding: @styledChildContentMargin;\n  padding: @styledChildContentPadding;\n}\n\n\n/* Hover */\n.ui.styled.accordion .title:hover,\n.ui.styled.accordion .active.title,\n.ui.styled.accordion .accordion .title:hover,\n.ui.styled.accordion .accordion .active.title {\n  background: @styledTitleHoverBackground;\n  color: @styledTitleHoverColor;\n}\n.ui.styled.accordion .accordion .title:hover,\n.ui.styled.accordion .accordion .active.title {\n  background: @styledHoverChildTitleBackground;\n  color: @styledHoverChildTitleColor;\n}\n\n\n/* Active */\n.ui.styled.accordion .active.title {\n  background: @styledActiveTitleBackground;\n  color: @styledActiveTitleColor;\n}\n.ui.styled.accordion .accordion .active.title {\n  background: @styledActiveChildTitleBackground;\n  color: @styledActiveChildTitleColor;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Active\n---------------*/\n\n.ui.accordion .active.content,\n.ui.accordion .accordion .active.content {\n  display: block;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.accordion,\n.ui.fluid.accordion .accordion {\n  width: 100%;\n}\n\n/*--------------\n     Inverted\n---------------*/\n\n.ui.inverted.accordion .title:not(.ui) {\n  color: @invertedTitleColor;\n}\n\n.loadUIOverrides();\n\n","/*******************************\n         Theme Overrides\n*******************************/\n@font-face {\n  font-family: 'Accordion';\n  src:\n    url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'),\n    url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff')\n  ;\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Dropdown Icon */\n.ui.accordion .title .dropdown.icon,\n.ui.accordion .accordion .title .dropdown.icon {\n  font-family: Accordion;\n  line-height: 1;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n.ui.accordion .title .dropdown.icon:before,\n.ui.accordion .accordion .title .dropdown.icon:before {\n  content: '\\f0da'/*rtl:'\\f0d9'*/;\n}\n","/*!\n * # Semantic UI - Checkbox\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'checkbox';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n           Checkbox\n*******************************/\n\n\n/*--------------\n    Content\n---------------*/\n\n.ui.checkbox {\n  position: relative;\n  display: inline-block;\n  backface-visibility: hidden;\n  outline: none;\n  vertical-align: baseline;\n  font-style: normal;\n\n  min-height: @checkboxSize;\n  font-size: @medium;\n  line-height: @checkboxLineHeight;\n  min-width: @checkboxSize;\n}\n\n/* HTML Checkbox */\n.ui.checkbox input[type=\"checkbox\"],\n.ui.checkbox input[type=\"radio\"] {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  opacity: 0 !important;\n  outline: none;\n  z-index: 3;\n  width: @checkboxSize;\n  height: @checkboxSize;\n}\n\n\n/*--------------\n      Box\n---------------*/\n\n\n.ui.checkbox .box,\n.ui.checkbox label {\n  cursor: auto;\n  position: relative;\n  display: block;\n  padding-left: @labelDistance;\n  outline: none;\n  font-size: @labelFontSize;\n}\n\n.ui.checkbox .box:before,\n.ui.checkbox label:before {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n\n  width: @checkboxSize;\n  height: @checkboxSize;\n  content: '';\n\n  background: @checkboxBackground;\n  border-radius: @checkboxBorderRadius;\n\n  transition: @checkboxTransition;\n  border: @checkboxBorder;\n}\n\n/*--------------\n    Checkmark\n---------------*/\n\n.ui.checkbox .box:after,\n.ui.checkbox label:after {\n  position: absolute;\n  font-size: @checkboxCheckFontSize;\n  top: @checkboxCheckTop;\n  left: @checkboxCheckLeft;\n  width: @checkboxCheckSize;\n  height: @checkboxCheckSize;\n  text-align: center;\n\n  opacity: 0;\n  color: @checkboxColor;\n  transition: @checkboxTransition;\n}\n\n/*--------------\n      Label\n---------------*/\n\n/* Inside */\n.ui.checkbox label,\n.ui.checkbox + label {\n  color: @labelColor;\n  transition: @labelTransition;\n}\n\n/* Outside */\n.ui.checkbox + label {\n  vertical-align: middle;\n}\n\n\n/*******************************\n           States\n*******************************/\n\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.checkbox .box:hover::before,\n.ui.checkbox label:hover::before {\n  background: @checkboxHoverBackground;\n  border-color: @checkboxHoverBorderColor;\n}\n.ui.checkbox label:hover,\n.ui.checkbox + label:hover {\n  color: @labelHoverColor;\n}\n\n/*--------------\n      Down\n---------------*/\n\n.ui.checkbox .box:active::before,\n.ui.checkbox label:active::before {\n  background: @checkboxPressedBackground;\n  border-color: @checkboxPressedBorderColor;\n}\n.ui.checkbox .box:active::after,\n.ui.checkbox label:active::after {\n  color: @checkboxPressedColor;\n}\n.ui.checkbox input:active ~ label {\n  color: @labelPressedColor;\n}\n\n/*--------------\n     Focus\n---------------*/\n\n.ui.checkbox input:focus ~ .box:before,\n.ui.checkbox input:focus ~ label:before {\n  background: @checkboxFocusBackground;\n  border-color: @checkboxFocusBorderColor;\n}\n.ui.checkbox input:focus ~ .box:after,\n.ui.checkbox input:focus ~ label:after {\n  color: @checkboxFocusCheckColor;\n}\n.ui.checkbox input:focus ~ label {\n  color: @labelFocusColor;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.checkbox input:checked ~ .box:before,\n.ui.checkbox input:checked ~ label:before {\n  background: @checkboxActiveBackground;\n  border-color: @checkboxActiveBorderColor;\n}\n.ui.checkbox input:checked ~ .box:after,\n.ui.checkbox input:checked ~ label:after {\n  opacity: @checkboxActiveCheckOpacity;\n  color: @checkboxActiveCheckColor;\n}\n\n/*--------------\n  Indeterminate\n---------------*/\n\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:before,\n.ui.checkbox input:not([type=radio]):indeterminate ~ label:before {\n  background: @checkboxIndeterminateBackground;\n  border-color: @checkboxIndeterminateBorderColor;\n}\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:after,\n.ui.checkbox input:not([type=radio]):indeterminate ~ label:after {\n  opacity: @checkboxIndeterminateCheckOpacity;\n  color: @checkboxIndeterminateCheckColor;\n}\n\n/*--------------\n  Active Focus\n---------------*/\n\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before,\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before,\n.ui.checkbox input:checked:focus ~ .box:before,\n.ui.checkbox input:checked:focus ~ label:before  {\n  background: @checkboxActiveFocusBackground;\n  border-color: @checkboxActiveFocusBorderColor;\n}\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after,\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after,\n.ui.checkbox input:checked:focus ~ .box:after,\n.ui.checkbox input:checked:focus ~ label:after {\n  color: @checkboxActiveFocusCheckColor;\n}\n\n\n/*--------------\n    Read-Only\n---------------*/\n\n.ui.read-only.checkbox,\n.ui.read-only.checkbox label {\n  cursor: default;\n}\n\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.disabled.checkbox .box:after,\n.ui.disabled.checkbox label,\n.ui.checkbox input[disabled] ~ .box:after,\n.ui.checkbox input[disabled] ~ label {\n  cursor: default !important;\n  opacity: @disabledCheckboxOpacity;\n  color: @disabledCheckboxLabelColor;\n}\n\n/*--------------\n     Hidden\n---------------*/\n\n/* Initialized checkbox moves input below element\n to prevent manually triggering */\n.ui.checkbox input.hidden {\n  z-index: -1;\n}\n\n/* Selectable Label */\n.ui.checkbox input.hidden + label {\n  cursor: pointer;\n  user-select: none;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n\n/*--------------\n     Radio\n---------------*/\n\n.ui.radio.checkbox {\n  min-height: @radioSize;\n}\n\n.ui.radio.checkbox .box,\n.ui.radio.checkbox label {\n  padding-left: @radioLabelDistance;\n}\n\n/* Box */\n.ui.radio.checkbox .box:before,\n.ui.radio.checkbox label:before {\n  content: '';\n  transform: none;\n\n  width: @radioSize;\n  height: @radioSize;\n  border-radius: @circularRadius;\n  top: @radioTop;\n  left: @radioLeft;\n}\n\n/* Bullet */\n.ui.radio.checkbox .box:after,\n.ui.radio.checkbox label:after {\n  border: none;\n  content: '' !important;\n  width: @radioSize;\n  height: @radioSize;\n  line-height: @radioSize;\n}\n\n/* Radio Checkbox */\n.ui.radio.checkbox .box:after,\n.ui.radio.checkbox label:after {\n  top: @bulletTop;\n  left: @bulletLeft;\n  width: @radioSize;\n  height: @radioSize;\n  border-radius: @bulletRadius;\n  transform: scale(@bulletScale);\n  background-color: @bulletColor;\n}\n\n/* Focus */\n.ui.radio.checkbox input:focus ~ .box:before,\n.ui.radio.checkbox input:focus ~ label:before {\n  background-color: @radioFocusBackground;\n}\n.ui.radio.checkbox input:focus ~ .box:after,\n.ui.radio.checkbox input:focus ~ label:after {\n  background-color: @radioFocusBulletColor;\n}\n\n/* Indeterminate */\n.ui.radio.checkbox input:indeterminate ~ .box:after,\n.ui.radio.checkbox input:indeterminate ~ label:after {\n  opacity: 0;\n}\n\n/* Active */\n.ui.radio.checkbox input:checked ~ .box:before,\n.ui.radio.checkbox input:checked ~ label:before {\n  background-color: @radioActiveBackground;\n}\n.ui.radio.checkbox input:checked ~ .box:after,\n.ui.radio.checkbox input:checked ~ label:after {\n  background-color: @radioActiveBulletColor;\n}\n\n/* Active Focus */\n.ui.radio.checkbox input:focus:checked ~ .box:before,\n.ui.radio.checkbox input:focus:checked ~ label:before {\n  background-color: @radioActiveFocusBackground;\n}\n.ui.radio.checkbox input:focus:checked ~ .box:after,\n.ui.radio.checkbox input:focus:checked ~ label:after {\n  background-color: @radioActiveFocusBulletColor;\n}\n\n/*--------------\n     Slider\n---------------*/\n\n.ui.slider.checkbox {\n  min-height: @sliderHeight;\n}\n\n/* Input */\n.ui.slider.checkbox input {\n  width: @sliderWidth;\n  height: @sliderHeight;\n}\n\n/* Label */\n.ui.slider.checkbox .box,\n.ui.slider.checkbox label {\n  padding-left: @sliderLabelDistance;\n  line-height: @sliderLabelLineHeight;\n  color: @sliderOffLabelColor;\n}\n\n/* Line */\n.ui.slider.checkbox .box:before,\n.ui.slider.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  transform: none;\n  border: none !important;\n  left: 0em;\n  z-index: 1;\n\n  top: @sliderLineVerticalOffset;\n\n  background-color: @sliderLineColor;\n  width: @sliderLineWidth;\n  height: @sliderLineHeight;\n\n  transform: none;\n  border-radius: @sliderLineRadius;\n  transition: @sliderLineTransition;\n\n}\n\n/* Handle */\n.ui.slider.checkbox .box:after,\n.ui.slider.checkbox label:after {\n  background: @handleBackground;\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n\n  border: none;\n  box-shadow: @handleBoxShadow;\n  width: @sliderHandleSize;\n  height: @sliderHandleSize;\n  top: @sliderHandleOffset;\n  left: 0em;\n  transform: none;\n\n  border-radius: @circularRadius;\n  transition: @sliderHandleTransition;\n}\n\n/* Focus */\n.ui.slider.checkbox input:focus ~ .box:before,\n.ui.slider.checkbox input:focus ~ label:before {\n  background-color: @toggleFocusColor;\n  border: none;\n}\n\n/* Hover */\n.ui.slider.checkbox .box:hover,\n.ui.slider.checkbox label:hover {\n  color: @sliderHoverLabelColor;\n}\n.ui.slider.checkbox .box:hover::before,\n.ui.slider.checkbox label:hover::before {\n  background: @sliderHoverLaneBackground;\n}\n\n/* Active */\n.ui.slider.checkbox input:checked ~ .box,\n.ui.slider.checkbox input:checked ~ label {\n  color: @sliderOnLabelColor !important;\n}\n.ui.slider.checkbox input:checked ~ .box:before,\n.ui.slider.checkbox input:checked ~ label:before {\n  background-color: @sliderOnLineColor !important;\n}\n.ui.slider.checkbox input:checked ~ .box:after,\n.ui.slider.checkbox input:checked ~ label:after {\n  left: @sliderTravelDistance;\n}\n\n/* Active Focus */\n.ui.slider.checkbox input:focus:checked ~ .box,\n.ui.slider.checkbox input:focus:checked ~ label {\n  color: @sliderOnFocusLabelColor !important;\n}\n.ui.slider.checkbox input:focus:checked ~ .box:before,\n.ui.slider.checkbox input:focus:checked ~ label:before {\n  background-color: @sliderOnFocusLineColor !important;\n}\n\n\n/*--------------\n     Toggle\n---------------*/\n\n.ui.toggle.checkbox {\n  min-height: @toggleHeight;\n}\n\n/* Input */\n.ui.toggle.checkbox input {\n  width: @toggleWidth;\n  height: @toggleHeight;\n}\n\n/* Label */\n.ui.toggle.checkbox .box,\n.ui.toggle.checkbox label {\n  min-height: @toggleHandleSize;\n  padding-left: @toggleLabelDistance;\n  color: @toggleOffLabelColor;\n}\n.ui.toggle.checkbox label {\n  padding-top: @toggleLabelOffset;\n}\n\n/* Switch */\n.ui.toggle.checkbox .box:before,\n.ui.toggle.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  z-index: 1;\n  transform: none;\n  border: none;\n\n  top: @toggleLaneVerticalOffset;\n\n  background: @toggleLaneBackground;\n  box-shadow: @toggleLaneBoxShadow;\n  width: @toggleLaneWidth;\n  height: @toggleLaneHeight;\n  border-radius: @toggleHandleRadius;\n}\n\n/* Handle */\n.ui.toggle.checkbox .box:after,\n.ui.toggle.checkbox label:after {\n  background: @handleBackground;\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n\n  border: none;\n  box-shadow: @handleBoxShadow;\n  width: @toggleHandleSize;\n  height: @toggleHandleSize;\n  top: @toggleHandleOffset;\n  left: 0em;\n\n  border-radius: @circularRadius;\n  transition: @toggleHandleTransition;\n}\n\n.ui.toggle.checkbox input ~ .box:after,\n.ui.toggle.checkbox input ~ label:after {\n  left: @toggleOffOffset;\n  box-shadow: @toggleOffHandleBoxShadow;\n}\n\n/* Focus */\n.ui.toggle.checkbox input:focus ~ .box:before,\n.ui.toggle.checkbox input:focus ~ label:before {\n  background-color: @toggleFocusColor;\n  border: none;\n}\n\n/* Hover */\n.ui.toggle.checkbox .box:hover::before,\n.ui.toggle.checkbox label:hover::before {\n  background-color: @toggleHoverColor;\n  border: none;\n}\n\n/* Active */\n.ui.toggle.checkbox input:checked ~ .box,\n.ui.toggle.checkbox input:checked ~ label {\n  color: @toggleOnLabelColor !important;\n}\n.ui.toggle.checkbox input:checked ~ .box:before,\n.ui.toggle.checkbox input:checked ~ label:before {\n  background-color: @toggleOnLaneColor !important;\n}\n.ui.toggle.checkbox input:checked ~ .box:after,\n.ui.toggle.checkbox input:checked ~ label:after {\n  left: @toggleOnOffset;\n  box-shadow: @toggleOnHandleBoxShadow;\n}\n\n\n/* Active Focus */\n.ui.toggle.checkbox input:focus:checked ~ .box,\n.ui.toggle.checkbox input:focus:checked ~ label {\n  color: @toggleOnFocusLabelColor !important;\n}\n.ui.toggle.checkbox input:focus:checked ~ .box:before,\n.ui.toggle.checkbox input:focus:checked ~ label:before {\n  background-color: @toggleOnFocusLaneColor !important;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n     Fitted\n---------------*/\n\n.ui.fitted.checkbox .box,\n.ui.fitted.checkbox label {\n  padding-left: 0em !important;\n}\n\n.ui.fitted.toggle.checkbox,\n.ui.fitted.toggle.checkbox {\n  width: @toggleWidth;\n}\n\n.ui.fitted.slider.checkbox,\n.ui.fitted.slider.checkbox {\n  width: @sliderWidth;\n}\n\n.loadUIOverrides();\n","/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Checkbox';\n  src:\n    url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype')\n  ;\n}\n\n/* Checkmark */\n.ui.checkbox label:after,\n.ui.checkbox .box:after {\n  font-family: 'Checkbox';\n}\n\n/* Checked */\n.ui.checkbox input:checked ~ .box:after,\n.ui.checkbox input:checked ~ label:after {\n  content: '\\e800';\n}\n\n/* Indeterminate */\n.ui.checkbox input:indeterminate ~ .box:after,\n.ui.checkbox input:indeterminate ~ label:after {\n  font-size: 12px;\n  content: '\\e801';\n}\n\n\n/*  UTF Reference\n.check:before { content: '\\e800'; }\n.dash:before  { content: '\\e801'; }\n.plus:before { content: '\\e802'; }\n*/\n","/*!\n * # Semantic UI - Dimmer\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'dimmer';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Dimmer\n*******************************/\n\n.dimmable:not(body) {\n  position: @dimmablePosition;\n}\n\n.ui.dimmer {\n  display: none;\n  position: @dimmerPosition;\n  top: 0em !important;\n  left: 0em !important;\n\n  width: 100%;\n  height: 100%;\n\n  text-align: @textAlign;\n  vertical-align: @verticalAlign;\n  padding: @padding;\n\n  background-color: @backgroundColor;\n  opacity: @hiddenOpacity;\n  line-height: @lineHeight;\n\n  animation-fill-mode: both;\n  animation-duration: @duration;\n  transition: @transition;\n\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  user-select: none;\n  will-change: opacity;\n  z-index: @zIndex;\n}\n\n/* Dimmer Content */\n.ui.dimmer > .content {\n  user-select: text;\n  color: @textColor;\n}\n\n\n/* Loose Coupling */\n.ui.segment > .ui.dimmer {\n  border-radius: inherit !important;\n}\n\n/* Scrollbars */\n.addScrollbars() when (@useCustomScrollbars) {\n  .ui.dimmer:not(.inverted)::-webkit-scrollbar-track {\n    background: @trackInvertedBackground;\n  }\n  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {\n    background: @thumbInvertedBackground;\n  }\n  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {\n    background: @thumbInvertedInactiveBackground;\n  }\n  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {\n    background: @thumbInvertedHoverBackground;\n  }\n}\n.addScrollbars();\n\n/*******************************\n            States\n*******************************/\n\n/* Animating */\n.animating.dimmable:not(body),\n.dimmed.dimmable:not(body) {\n  overflow: @overflow;\n}\n\n/* Animating / Active / Visible */\n.dimmed.dimmable > .ui.animating.dimmer,\n.dimmed.dimmable > .ui.visible.dimmer,\n.ui.active.dimmer {\n  display: flex;\n  opacity: @visibleOpacity;\n}\n\n/* Disabled */\n.ui.disabled.dimmer {\n  width: 0 !important;\n  height: 0 !important;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*--------------\n    Legacy\n---------------*/\n\n/* Animating / Active / Visible */\n.dimmed.dimmable > .ui.animating.legacy.dimmer,\n.dimmed.dimmable > .ui.visible.legacy.dimmer,\n.ui.active.legacy.dimmer {\n  display: block;\n}\n\n/*--------------\n    Alignment\n---------------*/\n\n.ui[class*=\"top aligned\"].dimmer {\n  justify-content: flex-start;\n}\n.ui[class*=\"bottom aligned\"].dimmer {\n  justify-content: flex-end;\n}\n\n/*--------------\n      Page\n---------------*/\n\n.ui.page.dimmer {\n  position: @pageDimmerPosition;\n  transform-style: @transformStyle;\n  perspective: @perspective;\n  transform-origin: center center;\n}\n\nbody.animating.in.dimmable,\nbody.dimmed.dimmable {\n  overflow: hidden;\n}\n\nbody.dimmable > .dimmer {\n  position: fixed;\n}\n\n/*--------------\n    Blurring\n---------------*/\n\n.blurring.dimmable > :not(.dimmer) {\n  filter: @blurredStartFilter;\n  transition: @blurredTransition;\n}\n.blurring.dimmed.dimmable > :not(.dimmer) {\n  filter: @blurredEndFilter;\n}\n\n/* Dimmer Color */\n.blurring.dimmable > .dimmer {\n  background-color: @blurredBackgroundColor;\n}\n.blurring.dimmable > .inverted.dimmer {\n  background-color: @blurredInvertedBackgroundColor;\n}\n\n/*--------------\n    Aligned\n---------------*/\n\n.ui.dimmer > .top.aligned.content > * {\n  vertical-align: top;\n}\n.ui.dimmer > .bottom.aligned.content > * {\n  vertical-align: bottom;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.dimmer {\n  background-color: @invertedBackgroundColor;\n}\n.ui.inverted.dimmer > .content > * {\n  color: @invertedTextColor;\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/* Displays without javascript */\n.ui.simple.dimmer {\n  display: block;\n  overflow: hidden;\n  opacity: 1;\n  width: 0%;\n  height: 0%;\n  z-index: -100;\n  background-color: @simpleStartBackgroundColor;\n}\n.dimmed.dimmable > .ui.simple.dimmer {\n  overflow: visible;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  background-color: @simpleEndBackgroundColor;\n  z-index: @simpleZIndex;\n}\n\n.ui.simple.inverted.dimmer {\n  background-color: @simpleInvertedStartBackgroundColor;\n}\n.dimmed.dimmable > .ui.simple.inverted.dimmer {\n  background-color: @simpleInvertedEndBackgroundColor;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Dropdown\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'dropdown';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Dropdown\n*******************************/\n\n.ui.dropdown {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  outline: none;\n  text-align: left;\n  transition: @transition;\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/*******************************\n            Content\n*******************************/\n\n/*--------------\n      Menu\n---------------*/\n\n.ui.dropdown .menu {\n  cursor: auto;\n  position: absolute;\n  display: none;\n  outline: none;\n  top: 100%;\n  min-width: max-content;\n  transition: @menuTransition;\n\n  margin: @menuMargin;\n  padding: @menuPadding;\n  background: @menuBackground;\n\n  font-size: @relativeMedium;\n  text-shadow: none;\n  text-align: @menuTextAlign;\n\n  box-shadow: @menuBoxShadow;\n  border: @menuBorder;\n  border-radius: @menuBorderRadius;\n  transition: @menuTransition;\n  z-index: @menuZIndex;\n  will-change: transform, opacity;\n}\n\n.ui.dropdown .menu > * {\n  white-space: nowrap;\n}\n\n\n/*--------------\n  Hidden Input\n---------------*/\n\n.ui.dropdown > input:not(.search):first-child,\n.ui.dropdown > select {\n  display: none !important;\n}\n\n/*--------------\n Dropdown Icon\n---------------*/\n\n.ui.dropdown > .dropdown.icon {\n  position: relative;\n  width: auto;\n  font-size: @dropdownIconSize;\n  margin: @dropdownIconMargin;\n}\n.ui.dropdown .menu > .item .dropdown.icon {\n  width: auto;\n  float: @itemDropdownIconFloat;\n  margin: @itemDropdownIconMargin;\n}\n.ui.dropdown .menu > .item .dropdown.icon + .text {\n  margin-right: @itemDropdownIconDistance;\n}\n\n\n/*--------------\n      Text\n---------------*/\n\n.ui.dropdown > .text {\n  display: inline-block;\n  transition: @textTransition;\n}\n\n/*--------------\n    Menu Item\n---------------*/\n\n.ui.dropdown .menu > .item {\n  position: relative;\n  cursor: pointer;\n  display: block;\n  border: @itemBorder;\n  height: @itemHeight;\n  text-align: @itemTextAlign;\n\n  border-top: @itemDivider;\n  line-height: @itemLineHeight;\n  font-size: @itemFontSize;\n  color: @itemColor;\n\n  padding: @itemPadding !important;\n  font-size: @itemFontSize;\n  text-transform: @itemTextTransform;\n  font-weight: @itemFontWeight;\n  box-shadow: @itemBoxShadow;\n  -webkit-touch-callout: none;\n}\n.ui.dropdown .menu > .item:first-child {\n  border-top-width: 0px;\n}\n\n/*--------------\n  Floated Content\n---------------*/\n\n.ui.dropdown > .text > [class*=\"right floated\"],\n.ui.dropdown .menu .item > [class*=\"right floated\"] {\n  float: right !important;\n  margin-right: 0em !important;\n  margin-left: @floatedDistance !important;\n}\n.ui.dropdown > .text > [class*=\"left floated\"],\n.ui.dropdown .menu .item > [class*=\"left floated\"] {\n  float: left !important;\n  margin-left: 0em !important;\n  margin-right: @floatedDistance !important;\n}\n\n.ui.dropdown .menu .item > .icon.floated,\n.ui.dropdown .menu .item > .flag.floated,\n.ui.dropdown .menu .item > .image.floated,\n.ui.dropdown .menu .item > img.floated {\n  margin-top: @itemLineHeightOffset;\n}\n\n\n/*--------------\n  Menu Divider\n---------------*/\n\n.ui.dropdown .menu > .header {\n  margin: @menuHeaderMargin;\n  padding: @menuHeaderPadding;\n  color: @menuHeaderColor;\n  font-size: @menuHeaderFontSize;\n  font-weight: @menuHeaderFontWeight;\n  text-transform: @menuHeaderTextTransform;\n}\n\n.ui.dropdown .menu > .divider {\n  border-top: @menuDividerBorder;\n  height: 0em;\n  margin: @menuDividerMargin;\n}\n\n.ui.dropdown.dropdown .menu > .input {\n  width: auto;\n  display: flex;\n  margin: @menuInputMargin;\n  min-width: @menuInputMinWidth;\n}\n.ui.dropdown .menu > .header + .input {\n  margin-top: 0em;\n}\n.ui.dropdown .menu > .input:not(.transparent) input {\n  padding: @menuInputPadding;\n}\n.ui.dropdown .menu > .input:not(.transparent) .button,\n.ui.dropdown .menu > .input:not(.transparent) .icon,\n.ui.dropdown .menu > .input:not(.transparent) .label {\n  padding-top: @menuInputVerticalPadding;\n  padding-bottom: @menuInputVerticalPadding;\n}\n\n/*-----------------\n  Item Description\n-------------------*/\n\n.ui.dropdown > .text > .description,\n.ui.dropdown .menu > .item > .description {\n  float: @itemDescriptionFloat;\n  margin: @itemDescriptionMargin;\n  color: @itemDescriptionColor;\n}\n\n/*-----------------\n       Message\n-------------------*/\n\n.ui.dropdown .menu > .message {\n  padding: @messagePadding;\n  font-weight: @messageFontWeight;\n}\n.ui.dropdown .menu > .message:not(.ui) {\n  color: @messageColor;\n}\n\n/*--------------\n    Sub Menu\n---------------*/\n\n.ui.dropdown .menu .menu {\n  top: @subMenuTop !important;\n  left: @subMenuLeft;\n  right: @subMenuRight;\n  margin: @subMenuMargin !important;\n  border-radius: @subMenuBorderRadius !important;\n  z-index: @subMenuZIndex !important;\n}\n\n/* Hide Arrow */\n.ui.dropdown .menu .menu:after {\n  display: none;\n}\n\n/*--------------\n   Sub Elements\n---------------*/\n\n/* Icons / Flags / Labels / Image */\n.ui.dropdown > .text > .icon,\n.ui.dropdown > .text > .label,\n.ui.dropdown > .text > .flag,\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image {\n  margin-top: @textLineHeightOffset;\n}\n.ui.dropdown .menu > .item > .icon,\n.ui.dropdown .menu > .item > .label,\n.ui.dropdown .menu > .item > .flag,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img  {\n  margin-top: @itemLineHeightOffset;\n}\n\n.ui.dropdown > .text > .icon,\n.ui.dropdown > .text > .label,\n.ui.dropdown > .text > .flag,\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image,\n.ui.dropdown .menu > .item > .icon,\n.ui.dropdown .menu > .item > .label,\n.ui.dropdown .menu > .item > .flag,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img  {\n  margin-left: 0em;\n  float: @itemElementFloat;\n  margin-right: @itemElementDistance;\n}\n\n/*--------------\n     Image\n---------------*/\n\n.ui.dropdown > .text > img,\n.ui.dropdown > .text > .image,\n.ui.dropdown .menu > .item > .image,\n.ui.dropdown .menu > .item > img {\n  display: inline-block;\n  vertical-align: top;\n  width: auto;\n  margin-top: @menuImageVerticalMargin;\n  margin-bottom: @menuImageVerticalMargin;\n  max-height: @menuImageMaxHeight;\n}\n\n\n/*******************************\n            Coupling\n*******************************/\n\n\n/*--------------\n      Menu\n---------------*/\n\n/* Remove Menu Item Divider */\n.ui.dropdown .ui.menu > .item:before,\n.ui.menu .ui.dropdown .menu > .item:before {\n  display: none;\n}\n\n/* Prevent Menu Item Border */\n.ui.menu .ui.dropdown .menu .active.item {\n  border-left: none;\n}\n\n/* Automatically float dropdown menu right on last menu item */\n.ui.menu .right.menu .dropdown:last-child > .menu,\n.ui.menu .right.dropdown.item > .menu,\n.ui.buttons > .ui.dropdown:last-child > .menu {\n  left: auto;\n  right: 0em;\n}\n\n/*--------------\n      Label\n---------------*/\n\n/* Dropdown Menu */\n.ui.label.dropdown .menu {\n  min-width: 100%;\n}\n\n/*--------------\n     Button\n---------------*/\n\n/* No Margin On Icon Button */\n.ui.dropdown.icon.button > .dropdown.icon {\n  margin: 0em;\n}\n.ui.button.dropdown .menu {\n  min-width: 100%;\n}\n\n\n\n/*******************************\n              Types\n*******************************/\n\n/*--------------\n    Selection\n---------------*/\n\n/* Displays like a select box */\n.ui.selection.dropdown {\n  cursor: pointer;\n  word-wrap: break-word;\n  line-height: 1em;\n  white-space: normal;\n  outline: 0;\n  transform: rotateZ(0deg);\n\n  min-width: @selectionMinWidth;\n  min-height: @selectionMinHeight;\n\n  background: @selectionBackground;\n  display: @selectionDisplay;\n  padding: @selectionPadding;\n  color: @selectionTextColor;\n  box-shadow: @selectionBoxShadow;\n  border: @selectionBorder;\n  border-radius: @selectionBorderRadius;\n  transition: @selectionTransition;\n}\n.ui.selection.dropdown.visible,\n.ui.selection.dropdown.active {\n  z-index: @selectionZIndex;\n}\n\nselect.ui.dropdown {\n  height: @selectHeight;\n  padding: @selectPadding;\n  border: @selectBorder;\n  visibility: @selectVisibility;\n}\n.ui.selection.dropdown > .search.icon,\n.ui.selection.dropdown > .delete.icon,\n.ui.selection.dropdown > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: @searchSelectionLineHeight;\n  top: @selectionVerticalPadding;\n  right: @selectionHorizontalPadding;\n  z-index: @selectionIconZIndex;\n  margin: @selectionIconMargin;\n  padding: @selectionIconPadding;\n  opacity: @selectionIconOpacity;\n  transition: @selectionIconTransition;\n}\n\n/* Compact */\n.ui.compact.selection.dropdown {\n  min-width:  0px;\n}\n\n/*  Selection Menu */\n.ui.selection.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  border-top-width: 0px !important;\n  width: auto;\n  outline: none;\n  margin: 0px -@menuBorderWidth;\n  min-width: @menuMinWidth;\n  width: @menuMinWidth;\n\n  border-radius: @selectionMenuBorderRadius;\n  box-shadow: @selectionMenuBoxShadow;\n  transition: @selectionMenuTransition;\n}\n.ui.selection.dropdown .menu:after,\n.ui.selection.dropdown .menu:before {\n  display: none;\n}\n\n/*--------------\n    Message\n---------------*/\n\n.ui.selection.dropdown .menu > .message {\n  padding: @selectionMessagePadding;\n}\n\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.selection.dropdown .menu {\n    max-height: @selectionMobileMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @tabletBreakpoint) {\n  .ui.selection.dropdown .menu {\n    max-height: @selectionTabletMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @computerBreakpoint) {\n  .ui.selection.dropdown .menu {\n    max-height: @selectionComputerMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui.selection.dropdown .menu {\n    max-height: @selectionWidescreenMaxMenuHeight;\n  }\n}\n\n/* Menu Item */\n.ui.selection.dropdown .menu > .item {\n  border-top: @selectionItemDivider;\n  padding: @selectionItemPadding !important;\n  white-space: normal;\n  word-wrap: normal;\n}\n\n/* User Item */\n.ui.selection.dropdown .menu > .hidden.addition.item {\n  display: none;\n}\n\n/* Hover */\n.ui.selection.dropdown:hover {\n  border-color: @selectionHoverBorderColor;\n  box-shadow: @selectionHoverBoxShadow;\n}\n\n/* Active */\n.ui.selection.active.dropdown {\n  border-color: @selectionVisibleBorderColor;\n  box-shadow: @selectionVisibleBoxShadow;\n}\n.ui.selection.active.dropdown .menu {\n  border-color: @selectionVisibleBorderColor;\n  box-shadow: @selectionVisibleMenuBoxShadow;\n}\n\n/* Focus */\n.ui.selection.dropdown:focus {\n  border-color: @selectionFocusBorderColor;\n  box-shadow: @selectionFocusBoxShadow;\n}\n.ui.selection.dropdown:focus .menu {\n  border-color: @selectionFocusBorderColor;\n  box-shadow: @selectionFocusMenuBoxShadow;\n}\n\n/* Visible */\n.ui.selection.visible.dropdown > .text:not(.default) {\n  font-weight: @selectionVisibleTextFontWeight;\n  color: @selectionVisibleTextColor;\n}\n\n/* Visible Hover */\n.ui.selection.active.dropdown:hover {\n  border-color: @selectionActiveHoverBorderColor;\n  box-shadow: @selectionActiveHoverBoxShadow;\n}\n.ui.selection.active.dropdown:hover .menu {\n  border-color: @selectionActiveHoverBorderColor;\n  box-shadow: @selectionActiveHoverMenuBoxShadow;\n}\n\n/* Dropdown Icon */\n.ui.active.selection.dropdown > .dropdown.icon,\n.ui.visible.selection.dropdown > .dropdown.icon {\n  opacity: @selectionVisibleIconOpacity;\n  z-index: 3;\n}\n\n/* Connecting Border */\n.ui.active.selection.dropdown {\n  border-bottom-left-radius: @selectionVisibleConnectingBorder !important;\n  border-bottom-right-radius: @selectionVisibleConnectingBorder !important;\n}\n\n/* Empty Connecting Border */\n.ui.active.empty.selection.dropdown {\n  border-radius: @selectionBorderRadius !important;\n  box-shadow: @selectionBoxShadow !important;\n}\n.ui.active.empty.selection.dropdown .menu {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/*--------------\n   Searchable\n---------------*/\n\n/* Search Selection */\n.ui.search.dropdown {\n  min-width: @searchMinWidth;\n}\n\n/* Search Dropdown */\n.ui.search.dropdown > input.search {\n  background: none transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  cursor: text;\n  top: 0em;\n  left: @textCursorSpacing;\n  width: 100%;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  padding: inherit;\n}\n\n/* Text Layering */\n.ui.search.dropdown > input.search {\n  position: absolute;\n  z-index: 2;\n}\n.ui.search.dropdown > .text {\n  cursor: text;\n  position: relative;\n  left: @textCursorSpacing;\n  z-index: 3;\n}\n\n/* Search Selection */\n.ui.search.selection.dropdown > input.search {\n  line-height: @searchSelectionLineHeight;\n  padding: @searchSelectionInputPadding;\n}\n\n/* Used to size multi select input to character width */\n.ui.search.selection.dropdown > span.sizer {\n  line-height: @searchSelectionLineHeight;\n  padding: @searchSelectionInputPadding;\n  display: none;\n  white-space: pre;\n}\n\n/* Active/Visible Search */\n.ui.search.dropdown.active > input.search,\n.ui.search.dropdown.visible > input.search {\n  cursor: auto;\n}\n.ui.search.dropdown.active > .text,\n.ui.search.dropdown.visible > .text {\n  pointer-events: none;\n}\n\n/* Filtered Text */\n.ui.active.search.dropdown input.search:focus + .text .icon,\n.ui.active.search.dropdown input.search:focus + .text .flag {\n  opacity: @selectionTextUnderlayIconOpacity;\n}\n.ui.active.search.dropdown input.search:focus + .text {\n  color: @selectionTextUnderlayColor !important;\n}\n\n/* Search Menu */\n.ui.search.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.search.dropdown .menu {\n    max-height: @searchMobileMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @tabletBreakpoint) {\n  .ui.search.dropdown .menu {\n    max-height: @searchTabletMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @computerBreakpoint) {\n  .ui.search.dropdown .menu {\n    max-height: @searchComputerMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui.search.dropdown .menu {\n    max-height: @searchWidescreenMaxMenuHeight;\n  }\n}\n\n/*--------------\n    Multiple\n---------------*/\n\n/* Multiple Selection */\n.ui.multiple.dropdown {\n  padding: @multipleSelectionPadding;\n}\n.ui.multiple.dropdown .menu {\n  cursor: auto;\n}\n\n/* Multiple Search Selection */\n.ui.multiple.search.dropdown,\n.ui.multiple.search.dropdown > input.search {\n  cursor: text;\n}\n\n/* Selection Label */\n.ui.multiple.dropdown > .label {\n  user-select: none;\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n  font-size: @labelSize;\n  padding: @labelPadding;\n  margin: @labelMargin;\n  box-shadow: @labelBoxShadow;\n}\n\n/* Dropdown Icon */\n.ui.multiple.dropdown .dropdown.icon {\n  margin: @multipleSelectionDropdownIconMargin;\n  padding: @multipleSelectionDropdownIconPadding;\n}\n\n/* Text */\n.ui.multiple.dropdown > .text {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: @multipleSelectionChildMargin;\n  line-height: @multipleSelectionChildLineHeight;\n}\n.ui.multiple.dropdown > .label ~ input.search {\n  margin-left: @multipleSelectionSearchAfterLabelDistance !important;\n}\n.ui.multiple.dropdown > .label ~ .text {\n  display: none;\n}\n\n/*-----------------\n  Multiple Search\n-----------------*/\n\n/* Prompt Text */\n.ui.multiple.search.dropdown > .text {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: inherit;\n  margin: @multipleSelectionChildMargin;\n  line-height: @multipleSelectionChildLineHeight;\n}\n\n.ui.multiple.search.dropdown > .label ~ .text {\n  display: none;\n}\n\n/* Search */\n.ui.multiple.search.dropdown > input.search {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: @multipleSelectionChildMargin;\n  width: @multipleSelectionSearchStartWidth;\n  line-height: @multipleSelectionChildLineHeight;\n}\n\n\n/*--------------\n     Inline\n---------------*/\n\n.ui.inline.dropdown {\n  cursor: pointer;\n  display: inline-block;\n  color: @inlineTextColor;\n}\n.ui.inline.dropdown .dropdown.icon {\n  margin: @inlineIconMargin;\n  vertical-align: baseline;\n}\n.ui.inline.dropdown > .text {\n  font-weight: @inlineTextFontWeight;\n}\n.ui.inline.dropdown .menu {\n  cursor: auto;\n  margin-top: @inlineMenuDistance;\n  border-radius: @inlineMenuBorderRadius;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n\n/*--------------------\n        Active\n----------------------*/\n\n/* Menu Item Active */\n.ui.dropdown .menu .active.item {\n  background: @activeItemBackground;\n  font-weight: @activeItemFontWeight;\n  color: @activeItemColor;\n  box-shadow: @activeItemBoxShadow;\n  z-index: @activeItemZIndex;\n}\n\n\n/*--------------------\n        Hover\n----------------------*/\n\n/* Menu Item Hover */\n.ui.dropdown .menu > .item:hover {\n  background: @hoveredItemBackground;\n  color: @hoveredItemColor;\n  z-index: @hoveredZIndex;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.dropdown > i.icon {\n  height: @relative14px !important;\n}\n.ui.loading.selection.dropdown > i.icon {\n  padding: @relative21px @relative18px !important;\n}\n.ui.loading.dropdown > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @loaderFillColor;\n}\n.ui.loading.dropdown > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  box-shadow: 0px 0px 0px 1px transparent;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: dropdown-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor transparent transparent;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n}\n\n/* Coupling */\n.ui.loading.dropdown.button > i.icon:before,\n.ui.loading.dropdown.button > i.icon:after {\n  display: none;\n}\n\n@keyframes dropdown-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*--------------------\n     Default Text\n----------------------*/\n\n.ui.dropdown:not(.button) > .default.text,\n.ui.default.dropdown:not(.button) > .text {\n  color: @defaultTextColor;\n}\n.ui.dropdown:not(.button) > input:focus ~ .default.text,\n.ui.default.dropdown:not(.button) > input:focus ~ .text {\n  color: @defaultTextFocusColor;\n}\n/*--------------------\n        Loading\n----------------------*/\n\n.ui.loading.dropdown > .text {\n  transition: none;\n}\n\n/* Used To Check Position */\n.ui.dropdown .loading.menu {\n  display: block;\n  visibility: hidden;\n  z-index: @loadingZIndex;\n}\n.ui.dropdown > .loading.menu {\n  left: 0px !important;\n  right: auto !important;\n}\n.ui.dropdown > .menu .loading.menu {\n  left: 100% !important;\n  right: auto !important;\n}\n\n/*--------------------\n    Keyboard Select\n----------------------*/\n\n/* Selected Item */\n.ui.dropdown.selected,\n.ui.dropdown .menu .selected.item {\n  background: @selectedBackground;\n  color: @selectedColor;\n}\n\n\n/*--------------------\n    Search Filtered\n----------------------*/\n\n/* Filtered Item */\n.ui.dropdown > .filtered.text {\n  visibility: hidden;\n}\n.ui.dropdown .filtered.item {\n  display: none !important;\n}\n\n\n/*--------------------\n        Error\n----------------------*/\n\n.ui.dropdown.error,\n.ui.dropdown.error > .text,\n.ui.dropdown.error > .default.text {\n  color: @errorTextColor;\n}\n\n.ui.selection.dropdown.error {\n  background: @errorBackgroundColor;\n  border-color: @errorBorderColor;\n}\n.ui.selection.dropdown.error:hover {\n  border-color: @errorBorderColor;\n}\n\n.ui.dropdown.error > .menu,\n.ui.dropdown.error > .menu .menu {\n  border-color: @errorBorderColor;\n}\n.ui.dropdown.error > .menu > .item {\n  color: @errorItemTextColor;\n}\n.ui.multiple.selection.error.dropdown > .label {\n  border-color: @errorBorderColor;\n}\n\n/* Item Hover */\n.ui.dropdown.error > .menu > .item:hover {\n  background-color: @errorItemHoverBackground;\n}\n\n/* Item Active */\n.ui.dropdown.error > .menu .active.item {\n  background-color: @errorItemActiveBackground;\n}\n\n\n/*--------------------\n        Clear\n----------------------*/\n\n.ui.dropdown > .clear.dropdown.icon {\n  opacity: @clearableIconOpacity;\n  transition: opacity @defaultDuration @defaultEasing;\n}\n.ui.dropdown > .clear.dropdown.icon:hover {\n  opacity: @clearableIconActiveOpacity;\n}\n\n\n/*--------------------\n        Disabled\n----------------------*/\n\n/* Disabled */\n.ui.disabled.dropdown,\n.ui.dropdown .menu > .disabled.item {\n  cursor: default;\n  pointer-events: none;\n  opacity: @disabledOpacity;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Direction\n---------------*/\n\n/* Flyout Direction */\n.ui.dropdown .menu {\n  left: 0px;\n}\n\n\n/* Default Side (Right) */\n.ui.dropdown .right.menu > .menu,\n.ui.dropdown .menu .right.menu {\n  left: 100% !important;\n  right: auto !important;\n  border-radius: @subMenuBorderRadius !important;\n}\n\n/* Leftward Opening Menu */\n.ui.dropdown > .left.menu {\n  left: auto !important;\n  right: 0px !important;\n}\n\n.ui.dropdown > .left.menu .menu,\n.ui.dropdown .menu .left.menu {\n  left: auto;\n  right: 100%;\n  margin: @leftSubMenuMargin !important;\n  border-radius: @leftSubMenuBorderRadius !important;\n}\n\n.ui.dropdown .item .left.dropdown.icon,\n.ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: @leftMenuDropdownIconFloat;\n  margin: @leftMenuDropdownIconMargin;\n}\n.ui.dropdown .item .left.dropdown.icon,\n.ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: @leftMenuDropdownIconFloat;\n  margin: @leftMenuDropdownIconMargin;\n}\n.ui.dropdown .item .left.dropdown.icon + .text,\n.ui.dropdown .left.menu .item .dropdown.icon + .text {\n  margin-left: @itemDropdownIconDistance;\n  margin-right: 0em;\n}\n\n\n/*--------------\n     Upward\n---------------*/\n\n/* Upward Main Menu */\n.ui.upward.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  box-shadow: @upwardMenuBoxShadow;\n  border-radius: @upwardMenuBorderRadius;\n}\n\n/* Upward Sub Menu */\n.ui.dropdown .upward.menu {\n  top: auto !important;\n  bottom: 0 !important;\n}\n\n/* Active Upward */\n.ui.simple.upward.active.dropdown,\n.ui.simple.upward.dropdown:hover {\n  border-radius: @borderRadius @borderRadius 0em 0em !important;\n}\n.ui.upward.dropdown.button:not(.pointing):not(.floating).active {\n  border-radius: @borderRadius @borderRadius 0em 0em;\n}\n\n/* Selection */\n.ui.upward.selection.dropdown .menu {\n  border-top-width: @menuBorderWidth !important;\n  border-bottom-width: 0px !important;\n  box-shadow: @upwardSelectionMenuBoxShadow;\n}\n.ui.upward.selection.dropdown:hover {\n  box-shadow: @upwardSelectionHoverBoxShadow;\n}\n\n/* Active Upward */\n.ui.active.upward.selection.dropdown {\n  border-radius: @upwardSelectionVisibleBorderRadius !important;\n}\n\n/* Visible Upward */\n.ui.upward.selection.dropdown.visible {\n  box-shadow: @upwardSelectionVisibleBoxShadow;\n  border-radius: @upwardSelectionVisibleBorderRadius !important;\n}\n\n/* Visible Hover Upward */\n.ui.upward.active.selection.dropdown:hover {\n  box-shadow: @upwardSelectionActiveHoverBoxShadow;\n}\n.ui.upward.active.selection.dropdown:hover .menu {\n  box-shadow: @upwardSelectionActiveHoverMenuBoxShadow;\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/*  Selection Menu */\n.ui.scrolling.dropdown .menu,\n.ui.dropdown .scrolling.menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ui.scrolling.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  min-width: 100% !important;\n  width: auto !important;\n}\n\n.ui.dropdown .scrolling.menu {\n  position: static;\n  overflow-y: auto;\n  border: none;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  min-width: 100% !important;\n  width: auto !important;\n  border-top: @menuBorder;\n}\n.ui.scrolling.dropdown .menu .item.item.item,\n.ui.dropdown .scrolling.menu > .item.item.item {\n  border-top: @scrollingMenuItemBorder;\n}\n.ui.scrolling.dropdown .menu .item:first-child,\n.ui.dropdown .scrolling.menu .item:first-child {\n  border-top: none;\n}\n.ui.dropdown > .animating.menu .scrolling.menu,\n.ui.dropdown > .visible.menu .scrolling.menu {\n  display: block;\n}\n\n/* Scrollbar in IE */\n@media all and (-ms-high-contrast:none) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    min-width: calc(100% - @scrollbarWidth);\n  }\n}\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: @scrollingMobileMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @tabletBreakpoint) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: @scrollingTabletMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @computerBreakpoint) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: @scrollingComputerMaxMenuHeight;\n  }\n}\n@media only screen and (min-width: @widescreenMonitorBreakpoint) {\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    max-height: @scrollingWidescreenMaxMenuHeight;\n  }\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/* Displays without javascript */\n\n.ui.simple.dropdown .menu:before,\n.ui.simple.dropdown .menu:after {\n  display: none;\n}\n.ui.simple.dropdown .menu {\n  position: absolute;\n  display: block;\n  overflow: hidden;\n  top: -9999px !important;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  transition: @simpleTransition;\n}\n\n.ui.simple.active.dropdown,\n.ui.simple.dropdown:hover {\n  border-bottom-left-radius: 0em !important;\n  border-bottom-right-radius: 0em !important;\n}\n\n.ui.simple.active.dropdown > .menu,\n.ui.simple.dropdown:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 100% !important;\n  opacity: 1;\n}\n.ui.simple.dropdown > .menu > .item:active > .menu,\n.ui.simple.dropdown:hover > .menu > .item:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 0% !important;\n  left: 100% !important;\n  opacity: 1;\n}\n.ui.simple.disabled.dropdown:hover .menu {\n  display: none;\n  height: 0px;\n  width: 0px;\n  overflow: hidden;\n}\n\n/* Visible */\n.ui.simple.visible.dropdown > .menu {\n  display: block;\n}\n\n/*--------------\n      Fluid\n---------------*/\n\n.ui.fluid.dropdown {\n  display: block;\n  width: 100%;\n  min-width: 0em;\n}\n.ui.fluid.dropdown > .dropdown.icon {\n  float: right;\n}\n\n\n/*--------------\n    Floating\n---------------*/\n\n.ui.floating.dropdown .menu {\n  left: 0;\n  right: auto;\n  box-shadow: @floatingMenuBoxShadow !important;\n  border-radius: @floatingMenuBorderRadius !important;\n}\n.ui.floating.dropdown > .menu {\n  margin-top: @floatingMenuDistance !important;\n  border-radius: @floatingMenuBorderRadius !important;\n}\n\n/*--------------\n     Pointing\n---------------*/\n\n.ui.pointing.dropdown > .menu {\n  top: 100%;\n  margin-top: @pointingMenuDistance;\n  border-radius: @pointingMenuBorderRadius;\n}\n\n.ui.pointing.dropdown > .menu:after {\n  display: block;\n  position: absolute;\n  pointer-events: none;\n  content: '';\n  visibility: visible;\n  transform: rotate(45deg);\n\n  width: @pointingArrowSize;\n  height: @pointingArrowSize;\n  box-shadow: @pointingArrowBoxShadow;\n  background: @pointingArrowBackground;\n  z-index: @pointingArrowZIndex;\n}\n\n.ui.pointing.dropdown > .menu:after {\n  top: @pointingArrowOffset;\n  left: 50%;\n  margin: 0em 0em 0em @pointingArrowOffset;\n}\n\n/* Top Left Pointing */\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.top.left.pointing.dropdown > .menu:after {\n  top: @pointingArrowOffset;\n  left: @pointingArrowDistanceFromEdge;\n  right: auto;\n  margin: 0em;\n  transform: rotate(45deg);\n}\n/* Top Right Pointing */\n.ui.top.right.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  right: 0%;\n  left: auto;\n  margin: @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.top.pointing.dropdown > .left.menu:after,\n.ui.top.right.pointing.dropdown > .menu:after {\n  top: @pointingArrowOffset;\n  left: auto !important;\n  right: @pointingArrowDistanceFromEdge !important;\n  margin: 0em;\n  transform: rotate(45deg);\n}\n\n/* Left Pointing */\n.ui.left.pointing.dropdown > .menu {\n  top: 0%;\n  left: 100%;\n  right: auto;\n  margin: 0em 0em 0em @pointingArrowDistanceFromEdge;\n}\n.ui.left.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: @pointingArrowOffset;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(-45deg);\n}\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {\n  left: auto !important;\n  right: 100% !important;\n  margin: 0em @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {\n  top: 1em;\n  left: auto;\n  right: @pointingArrowOffset;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(135deg);\n}\n\n\n/* Right Pointing */\n.ui.right.pointing.dropdown > .menu {\n  top: 0%;\n  left: auto;\n  right: 100%;\n  margin: 0em @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.right.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: auto;\n  right: @pointingArrowOffset;\n  margin: 0em 0em 0em 0em;\n  transform: rotate(135deg);\n}\n\n/* Bottom Pointing */\n.ui.bottom.pointing.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  left: 0%;\n  right: auto;\n  margin: 0em 0em @pointingArrowDistanceFromEdge ;\n}\n.ui.bottom.pointing.dropdown > .menu:after {\n  top: auto;\n  bottom: @pointingArrowOffset;\n  right: auto;\n  margin: 0em;\n  transform: rotate(-135deg);\n}\n/* Reverse Sub-Menu Direction */\n.ui.bottom.pointing.dropdown > .menu .menu {\n  top: auto !important;\n  bottom: 0px !important;\n}\n\n/* Bottom Left */\n.ui.bottom.left.pointing.dropdown > .menu {\n  left: 0%;\n  right: auto;\n}\n.ui.bottom.left.pointing.dropdown > .menu:after {\n  left: @pointingArrowDistanceFromEdge;\n  right: auto;\n}\n\n/* Bottom Right */\n.ui.bottom.right.pointing.dropdown > .menu {\n  right: 0%;\n  left: auto;\n}\n.ui.bottom.right.pointing.dropdown > .menu:after {\n  left: auto;\n  right: @pointingArrowDistanceFromEdge;\n}\n\n/* Upward pointing */\n.ui.pointing.upward.dropdown .menu,\n.ui.top.pointing.upward.dropdown .menu {\n  top: auto !important;\n  bottom: 100% !important;\n  margin: 0em 0em @pointingMenuDistance;\n  border-radius: @pointingUpwardMenuBorderRadius;\n}\n.ui.pointing.upward.dropdown .menu:after,\n.ui.top.pointing.upward.dropdown .menu:after {\n  top: 100% !important;\n  bottom: auto !important;\n  box-shadow: @pointingUpwardArrowBoxShadow;\n  margin: @pointingArrowOffset 0em 0em;\n}\n\n/* Right Pointing Upward */\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em @pointingArrowDistanceFromEdge 0em 0em;\n}\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em @pointingArrowDistanceFromEdge 0em;\n  box-shadow: @pointingArrowBoxShadow;\n}\n\n\n/* Left Pointing Upward */\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 0em @pointingArrowDistanceFromEdge;\n}\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em @pointingArrowDistanceFromEdge 0em;\n  box-shadow: @pointingArrowBoxShadow;\n}\n\n.loadUIOverrides();\n","/*******************************\n         Theme Overrides\n*******************************/\n\n/* Dropdown Carets */\n@font-face {\n  font-family: 'Dropdown';\n  src:\n    url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAVgAA8AAAAACFAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABWAAAABwAAAAchGgaq0dERUYAAAF0AAAAHAAAAB4AJwAPT1MvMgAAAZAAAABDAAAAVnW4TJdjbWFwAAAB1AAAAEsAAAFS8CcaqmN2dCAAAAIgAAAABAAAAAQAEQFEZ2FzcAAAAiQAAAAIAAAACP//AANnbHlmAAACLAAAAQoAAAGkrRHP9WhlYWQAAAM4AAAAMAAAADYPK8YyaGhlYQAAA2gAAAAdAAAAJANCAb1obXR4AAADiAAAACIAAAAiCBkAOGxvY2EAAAOsAAAAFAAAABQBnAIybWF4cAAAA8AAAAAfAAAAIAEVAF5uYW1lAAAD4AAAATAAAAKMFGlj5HBvc3QAAAUQAAAARgAAAHJoedjqd2ViZgAABVgAAAAGAAAABrO7W5UAAAABAAAAANXulPUAAAAA1r4hgAAAAADXu2Q1eNpjYGRgYOABYjEgZmJgBEIOIGYB8xgAA/YAN3jaY2BktGOcwMDKwMI4jTGNgYHBHUp/ZZBkaGFgYGJgZWbACgLSXFMYHFT/fLjFeOD/AQY9xjMMbkBhRpAcAN48DQYAeNpjYGBgZoBgGQZGBhDwAfIYwXwWBgMgzQGETAwMqn8+8H649f8/lHX9//9b7Pzf+fWgusCAkY0BzmUE6gHpQwGMDMMeAACbxg7SAAARAUQAAAAB//8AAnjadZBPSsNAGMXfS+yMqYgOhpSuSlKadmUhiVEhEMQzFF22m17BbbvzCh5BXCUn6EG8gjeQ4DepwYo4i+/ffL95j4EDA+CFC7jQuKyIeVHrI3wkleq9F7XrSInKteOeHdda8bOoaeepSc00NWPz/LRec9G8GabyGtEdF7h19z033GAMTK7zbM42xNEZpzYof0RtQ5CUHAQJ73OtVyutc+3b7Ou//b8XNlsPx3jgjUifABdhEohKJJL5iM5p39uqc7X1+sRQSqmGrUVhlsJ4lpmEUVwyT8SUYtg0P9DyNzPADDs+tjrGV6KRCRfsui3eHcL4/p8ZXvfMlcnEU+CLv7hDykOP+AKTPTxbAAB42mNgZGBgAGKuf5KP4vltvjLIMzGAwLV9ig0g+vruFFMQzdjACOJzMIClARh0CTJ42mNgZGBgPPD/AJD8wgAEjA0MjAyogAMAbOQEAQAAAAC7ABEAAAAAAKoAAAH0AAABgAAAAUAACAFAAAgAwAAXAAAAAAAAACoAKgAqADIAbACGAKAAugDSeNpjYGRgYOBkUGFgYgABEMkFhAwM/xn0QAIADdUBdAB42qWQvUoDQRSFv3GjaISUQaymSmGxJoGAsRC0iPYLsU50Y6IxrvlRtPCJJKUPIBb+PIHv4EN4djKuKAqCDHfmu+feOdwZoMCUAJNbAlYUMzaUlM14jjxbngOq7HnOia89z1Pk1vMCa9x7ztPkzfMyJbPj+ZGi6Xp+omxuPD+zaD7meaFg7mb8GrBqHmhwxoAxlm0uiRkpP9X5m26pKRoMxTGR1D49Dv/Yb/91o6l8qL6eu5n2hZQzn68utR9m3FU2cB4t9cdSLG2utI+44Eh/P9bqKO+oJ/WxmXssj77YkrjasZQD6SFddythk3Wtzrf+UF2p076Udla1VNzsERP3kkjVRKel7mp1udXYcHtZSlV7RfmJe1GiFWveluaeKD5/MuJcSk8Tpm/vvwPIbmJleNpjYGKAAFYG7ICTgYGRiZGZkYWRlZGNkZ2Rg5GTLT2nsiDDEEIZsZfmZRqZujmDaDcDAxcI7WIOpS2gtCWUdgQAZkcSmQAAAAFblbO6AAA=) format('woff')\n  ;\n  font-weight: normal;\n  font-style: normal;\n}\n\n.ui.dropdown > .dropdown.icon {\n  font-family: 'Dropdown';\n  line-height: 1;\n  height: 1em;\n  width: 1.23em;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n.ui.dropdown > .dropdown.icon {\n  width: auto;\n}\n.ui.dropdown > .dropdown.icon:before {\n  content: '\\f0d7';\n}\n\n/* Sub Menu */\n.ui.dropdown .menu .item .dropdown.icon:before {\n  content: '\\f0da'/*rtl:'\\f0d9'*/;\n}\n\n.ui.dropdown .item .left.dropdown.icon:before,\n.ui.dropdown .left.menu .item .dropdown.icon:before {\n  content: \"\\f0d9\"/*rtl:\"\\f0da\"*/;\n}\n\n/* Vertical Menu Dropdown */\n.ui.vertical.menu .dropdown.item > .dropdown.icon:before {\n  content: \"\\f0da\"/*rtl:\"\\f0d9\"*/;\n}\n\n.ui.dropdown > .clear.icon:before {\n  content: \"\\f00d\";\n}\n\n/* Icons for Reference (Subsetted in 2.4.0)\n  .dropdown.down:before { content: \"\\f0d7\"; }\n  .dropdown.up:before { content: \"\\f0d8\"; }\n  .dropdown.left:before { content: \"\\f0d9\"; }\n  .dropdown.right:before { content: \"\\f0da\"; }\n  .dropdown.close:before { content: \"\\f00d\"; }\n*/\n\n","/*!\n * # Semantic UI - Video\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'embed';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Types\n*******************************/\n\n.ui.embed {\n  position: relative;\n  position: relative;\n  max-width: 100%;\n  height: 0px;\n  overflow: hidden;\n  background: @background;\n  padding-bottom: @widescreenRatio;\n}\n\n/*-----------------\n  Embedded Content\n------------------*/\n\n.ui.embed iframe,\n.ui.embed embed,\n.ui.embed object {\n  position: absolute;\n  border: none;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  margin: 0em;\n  padding: 0em;\n}\n\n/*-----------------\n      Embed\n------------------*/\n\n.ui.embed > .embed {\n  display: none;\n}\n\n/*--------------\n   Placeholder\n---------------*/\n\n.ui.embed > .placeholder {\n  position: absolute;\n  cursor: pointer;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: @placeholderBackground;\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.embed > .icon {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.ui.embed > .icon:after {\n  position: absolute;\n  top: 0%;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  content: '';\n  background: @placeholderBackground;\n  opacity: @placeholderBackgroundOpacity;\n  transition: @placeholderBackgroundTransition;\n}\n.ui.embed > .icon:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 4;\n  transform: translateX(-50%) translateY(-50%);\n\n  color: @iconColor;\n  font-size: @iconSize;\n  text-shadow: @iconShadow;\n  transition: @iconTransition;\n  z-index: @iconZIndex;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Hover\n---------------*/\n\n.ui.embed .icon:hover:after {\n  background: @hoverPlaceholderBackground;\n  opacity: @hoverPlaceholderBackgroundOpacity;\n}\n.ui.embed .icon:hover:before {\n  color: @hoverIconColor;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.embed > .icon,\n.ui.active.embed > .placeholder {\n  display: none;\n}\n.ui.active.embed > .embed {\n  display: block;\n}\n\n.loadUIOverrides();\n\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.square.embed {\n  padding-bottom: @squareRatio;\n}\n.ui[class*=\"4:3\"].embed {\n  padding-bottom: @standardRatio;\n}\n.ui[class*=\"16:9\"].embed {\n  padding-bottom: @widescreenRatio;\n}\n.ui[class*=\"21:9\"].embed {\n  padding-bottom: @ultraWidescreenRatio;\n}\n\n\n\n","/*!\n * # Semantic UI - Modal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'modal';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Modal\n*******************************/\n\n.ui.modal {\n  position: absolute;\n  display: none;\n  z-index: @zIndex;\n  text-align: left;\n\n  background: @background;\n  border: @border;\n  box-shadow: @boxShadow;\n  transform-origin: @transformOrigin;\n\n  flex: 0 0 auto;\n\n  border-radius: @borderRadius;\n  user-select: text;\n  will-change: top, left, margin, transform, opacity;\n}\n\n.ui.modal > :first-child:not(.icon),\n.ui.modal > .icon:first-child + * {\n  border-top-left-radius: @borderRadius;\n  border-top-right-radius: @borderRadius;\n}\n\n.ui.modal > :last-child {\n  border-bottom-left-radius: @borderRadius;\n  border-bottom-right-radius: @borderRadius;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/*--------------\n     Close\n---------------*/\n\n.ui.modal > .close {\n  cursor: pointer;\n  position: absolute;\n  top: @closeTop;\n  right: @closeRight;\n  z-index: 1;\n\n  opacity: @closeOpacity;\n  font-size: @closeSize;\n  color: @closeColor;\n\n  width: @closeHitbox;\n  height: @closeHitbox;\n  padding: @closePadding;\n}\n.ui.modal > .close:hover {\n  opacity: 1;\n}\n\n/*--------------\n     Header\n---------------*/\n\n.ui.modal > .header {\n  display: block;\n  font-family: @headerFontFamily;\n  background: @headerBackground;\n  margin: @headerMargin;\n  padding: @headerPadding;\n  box-shadow: @headerBoxShadow;\n\n  color: @headerColor;\n  border-bottom: @headerBorder;\n}\n.ui.modal > .header:not(.ui) {\n  font-size: @headerFontSize;\n  line-height: @headerLineHeight;\n  font-weight: @headerFontWeight;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.modal > .content {\n  display: block;\n  width: 100%;\n  font-size: @contentFontSize;\n  line-height: @contentLineHeight;\n  padding: @contentPadding;\n  background: @contentBackground;\n}\n.ui.modal > .image.content {\n  display: flex;\n  flex-direction: row;\n}\n\n/* Image */\n.ui.modal > .content > .image {\n  display: block;\n  flex: 0 1 auto;\n  width: @imageWidth;\n  align-self: @imageVerticalAlign;\n}\n.ui.modal > [class*=\"top aligned\"] {\n  align-self: top;\n}\n.ui.modal > [class*=\"middle aligned\"] {\n  align-self: middle;\n}\n.ui.modal > [class*=\"stretched\"] {\n  align-self: stretch;\n}\n\n/* Description */\n.ui.modal > .content > .description {\n  display: block;\n  flex: 1 0 auto;\n  min-width: 0px;\n  align-self: @descriptionVerticalAlign;\n}\n\n.ui.modal > .content > .icon + .description,\n.ui.modal > .content > .image + .description {\n  flex: 0 1 auto;\n  min-width: @descriptionMinWidth;\n  width: @descriptionWidth;\n  padding-left: @descriptionDistance;\n}\n\n/*rtl:ignore*/\n.ui.modal > .content > .image > i.icon {\n  margin: 0em;\n  opacity: 1;\n  width: auto;\n  line-height: 1;\n  font-size: @imageIconSize;\n}\n\n/*--------------\n     Actions\n---------------*/\n\n.ui.modal > .actions {\n  background: @actionBackground;\n  padding: @actionPadding;\n  border-top: @actionBorder;\n  text-align: @actionAlign;\n}\n.ui.modal .actions > .button {\n  margin-left: @buttonDistance;\n}\n\n/*-------------------\n       Responsive\n--------------------*/\n\n/* Modal Width */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.modal {\n    width: @mobileWidth;\n    margin: @mobileMargin;\n  }\n}\n@media only screen and (min-width : @tabletBreakpoint) {\n  .ui.modal {\n    width: @tabletWidth;\n    margin: @tabletMargin;\n  }\n}\n@media only screen and (min-width : @computerBreakpoint) {\n  .ui.modal {\n    width: @computerWidth;\n    margin: @computerMargin;\n  }\n}\n@media only screen and (min-width : @largeMonitorBreakpoint) {\n  .ui.modal {\n    width: @largeMonitorWidth;\n    margin: @largeMonitorMargin;\n  }\n}\n@media only screen and (min-width : @widescreenMonitorBreakpoint) {\n  .ui.modal {\n    width: @widescreenMonitorWidth;\n    margin: @widescreenMonitorMargin;\n  }\n}\n\n/* Tablet and Mobile */\n@media only screen and (max-width : @largestTabletScreen) {\n  .ui.modal > .header {\n    padding-right: @closeHitbox;\n  }\n  .ui.modal > .close {\n    top: @innerCloseTop;\n    right: @innerCloseRight;\n    color: @innerCloseColor;\n  }\n}\n\n/* Mobile */\n@media only screen and (max-width : @largestMobileScreen) {\n\n  .ui.modal > .header {\n    padding: @mobileHeaderPadding !important;\n    padding-right: @closeHitbox !important;\n  }\n  .ui.modal > .content {\n    display: block;\n    padding: @mobileContentPadding !important;\n  }\n  .ui.modal > .close {\n    top: @mobileCloseTop !important;\n    right: @mobileCloseRight !important;\n  }\n\n  /*rtl:ignore*/\n  .ui.modal .image.content {\n    flex-direction: column;\n  }\n  .ui.modal .content > .image {\n    display: block;\n    max-width: 100%;\n    margin: 0em auto !important;\n    text-align: center;\n    padding: @mobileImagePadding !important;\n  }\n  .ui.modal > .content > .image > i.icon {\n    font-size: @mobileImageIconSize;\n    text-align: center;\n  }\n\n  /*rtl:ignore*/\n  .ui.modal .content > .description {\n    display: block;\n    width: 100% !important;\n    margin: 0em !important;\n    padding: @mobileDescriptionPadding !important;\n    box-shadow: none;\n  }\n\n  /* Let Buttons Stack */\n  .ui.modal > .actions {\n    padding: @mobileActionPadding !important;\n  }\n  .ui.modal .actions > .buttons,\n  .ui.modal .actions > .button {\n    margin-bottom: @mobileButtonDistance;\n  }\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n.ui.inverted.dimmer > .ui.modal {\n  box-shadow: @invertedBoxShadow;\n}\n\n/*******************************\n             Types\n*******************************/\n\n.ui.basic.modal {\n  background-color: transparent;\n  border: none;\n  border-radius: 0em;\n  box-shadow: none !important;\n  color: @basicModalColor;\n}\n.ui.basic.modal > .header,\n.ui.basic.modal > .content,\n.ui.basic.modal > .actions {\n  background-color: transparent;\n}\n.ui.basic.modal > .header {\n  color: @basicModalHeaderColor;\n}\n.ui.basic.modal > .close {\n  top: @basicModalCloseTop;\n  right: @basicModalCloseRight;\n}\n\n.ui.inverted.dimmer > .basic.modal {\n  color: @basicInvertedModalColor;\n}\n.ui.inverted.dimmer > .ui.basic.modal > .header {\n  color: @basicInvertedModalHeaderColor;\n}\n\n/* Resort to margin positioning if legacy */\n.ui.legacy.modal,\n.ui.legacy.page.dimmer > .ui.modal {\n  top: 50%;\n  left: 50%;\n}\n\n.ui.legacy.page.dimmer > .ui.scrolling.modal,\n.ui.page.dimmer > .ui.scrolling.legacy.modal,\n.ui.top.aligned.legacy.page.dimmer > .ui.modal,\n.ui.top.aligned.dimmer > .ui.legacy.modal {\n  top: auto;\n}\n\n/* Tablet and Mobile */\n@media only screen and (max-width : @largestTabletScreen) {\n  .ui.basic.modal > .close {\n    color: @basicInnerCloseColor;\n  }\n}\n\n\n/*******************************\n             States\n*******************************/\n\n.ui.loading.modal {\n  display: block;\n  visibility: hidden;\n  z-index: @loadingZIndex;\n}\n\n.ui.active.modal {\n  display: block;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n   Top Aligned\n---------------*/\n\n/* Top Aligned Modal */\n.modals.dimmer[class*=\"top aligned\"] .modal {\n  margin: @topAlignedMargin auto;\n}\n@media only screen and (max-width : @largestMobileScreen) {\n  .modals.dimmer[class*=\"top aligned\"] .modal {\n    margin: @mobileTopAlignedMargin auto;\n  }\n}\n/* Legacy Top Aligned */\n.legacy.modals.dimmer[class*=\"top aligned\"] {\n  padding-top: @topAlignedMargin;\n}\n@media only screen and (max-width : @largestMobileScreen) {\n  .legacy.modals.dimmer[class*=\"top aligned\"] {\n    padding-top: @mobileTopAlignedMargin;\n  }\n}\n\n/*--------------\n    Scrolling\n---------------*/\n\n/* Scrolling Dimmer */\n.scrolling.dimmable.dimmed {\n  overflow: hidden;\n}\n.scrolling.dimmable > .dimmer {\n  justify-content: flex-start;\n}\n.scrolling.dimmable.dimmed > .dimmer {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling.dimmable > .dimmer {\n  position: fixed;\n}\n.modals.dimmer .ui.scrolling.modal {\n  margin: @scrollingMargin auto;\n}\n\n/* Undetached Scrolling */\n.scrolling.undetached.dimmable.dimmed {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling.undetached.dimmable.dimmed > .dimmer {\n  overflow: hidden;\n}\n.scrolling.undetached.dimmable .ui.scrolling.modal {\n  position: absolute;\n  left: 50%;\n  margin-top: @scrollingMargin !important;\n}\n\n/* Scrolling Content */\n.ui.modal .scrolling.content {\n  max-height: @scrollingContentMaxHeight;\n  overflow: auto;\n}\n\n/*--------------\n   Full Screen\n---------------*/\n\n.ui.fullscreen.modal {\n  width: @fullScreenWidth !important;\n  margin: @fullScreenMargin;\n}\n.ui.fullscreen.modal > .header {\n  padding-right: @closeHitbox;\n}\n.ui.fullscreen.modal > .close {\n  top: @innerCloseTop;\n  right: @innerCloseRight;\n  color: @innerCloseColor;\n}\n\n\n/*--------------\n      Size\n---------------*/\n\n.ui.modal {\n  font-size: @medium;\n}\n\n/* Mini */\n.ui.mini.modal > .header:not(.ui) {\n  font-size: @miniHeaderSize;\n}\n\n/* Mini Modal Width */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.mini.modal {\n    width: @miniMobileWidth;\n    margin: @miniMobileMargin;\n  }\n}\n@media only screen and (min-width : @tabletBreakpoint) {\n  .ui.mini.modal {\n    width: @miniTabletWidth;\n    margin: @miniTabletMargin;\n  }\n}\n@media only screen and (min-width : @computerBreakpoint) {\n  .ui.mini.modal {\n    width: @miniComputerWidth;\n    margin: @miniComputerMargin;\n  }\n}\n@media only screen and (min-width : @largeMonitorBreakpoint) {\n  .ui.mini.modal {\n    width: @miniLargeMonitorWidth;\n    margin: @miniLargeMonitorMargin;\n  }\n}\n@media only screen and (min-width : @widescreenMonitorBreakpoint) {\n  .ui.mini.modal {\n    width: @miniWidescreenMonitorWidth;\n    margin: @miniWidescreenMonitorMargin;\n  }\n}\n\n/* mini */\n.ui.small.modal > .header:not(.ui) {\n  font-size: @miniHeaderSize;\n}\n\n/* Tiny Modal Width */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.tiny.modal {\n    width: @tinyMobileWidth;\n    margin: @tinyMobileMargin;\n  }\n}\n@media only screen and (min-width : @tabletBreakpoint) {\n  .ui.tiny.modal {\n    width: @tinyTabletWidth;\n    margin: @tinyTabletMargin;\n  }\n}\n@media only screen and (min-width : @computerBreakpoint) {\n  .ui.tiny.modal {\n    width: @tinyComputerWidth;\n    margin: @tinyComputerMargin;\n  }\n}\n@media only screen and (min-width : @largeMonitorBreakpoint) {\n  .ui.tiny.modal {\n    width: @tinyLargeMonitorWidth;\n    margin: @tinyLargeMonitorMargin;\n  }\n}\n@media only screen and (min-width : @widescreenMonitorBreakpoint) {\n  .ui.tiny.modal {\n    width: @tinyWidescreenMonitorWidth;\n    margin: @tinyWidescreenMonitorMargin;\n  }\n}\n\n/* Small */\n.ui.small.modal > .header:not(.ui) {\n  font-size: @smallHeaderSize;\n}\n\n/* Small Modal Width */\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.small.modal {\n    width: @smallMobileWidth;\n    margin: @smallMobileMargin;\n  }\n}\n@media only screen and (min-width : @tabletBreakpoint) {\n  .ui.small.modal {\n    width: @smallTabletWidth;\n    margin: @smallTabletMargin;\n  }\n}\n@media only screen and (min-width : @computerBreakpoint) {\n  .ui.small.modal {\n    width: @smallComputerWidth;\n    margin: @smallComputerMargin;\n  }\n}\n@media only screen and (min-width : @largeMonitorBreakpoint) {\n  .ui.small.modal {\n    width: @smallLargeMonitorWidth;\n    margin: @smallLargeMonitorMargin;\n  }\n}\n@media only screen and (min-width : @widescreenMonitorBreakpoint) {\n  .ui.small.modal {\n    width: @smallWidescreenMonitorWidth;\n    margin: @smallWidescreenMonitorMargin;\n  }\n}\n\n/* Large Modal Width */\n.ui.large.modal > .header {\n  font-size: @largeHeaderSize;\n}\n@media only screen and (max-width : @largestMobileScreen) {\n  .ui.large.modal {\n    width: @largeMobileWidth;\n    margin: @largeMobileMargin;\n  }\n}\n@media only screen and (min-width : @tabletBreakpoint) {\n  .ui.large.modal {\n    width: @largeTabletWidth;\n    margin: @largeTabletMargin;\n  }\n}\n@media only screen and (min-width : @computerBreakpoint) {\n  .ui.large.modal {\n    width: @largeComputerWidth;\n    margin: @largeComputerMargin;\n  }\n}\n@media only screen and (min-width : @largeMonitorBreakpoint) {\n  .ui.large.modal {\n    width: @largeLargeMonitorWidth;\n    margin: @largeLargeMonitorMargin;\n  }\n}\n@media only screen and (min-width : @widescreenMonitorBreakpoint) {\n  .ui.large.modal {\n    width: @largeWidescreenMonitorWidth;\n    margin: @largeWidescreenMonitorMargin;\n  }\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Nag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'nag';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Nag\n*******************************/\n\n.ui.nag {\n  display: none;\n  opacity: @opacity;\n  position: @position;\n\n  top: @top;\n  left: 0px;\n  z-index: @zIndex;\n\n  min-height: @minHeight;\n  width: @width;\n\n  margin: @margin;\n  padding: @padding;\n\n  background: @background;\n  box-shadow: @boxShadow;\n\n  font-size: @fontSize;\n  text-align: @textAlign;\n  color: @color;\n\n  border-radius: @topBorderRadius;\n  transition: @transition;\n}\n\na.ui.nag {\n  cursor: pointer;\n}\n\n.ui.nag > .title {\n  display: inline-block;\n  margin: @titleMargin;\n  color: @titleColor;\n}\n\n\n.ui.nag > .close.icon {\n  cursor: pointer;\n  opacity: @closeOpacity;\n\n  position: absolute;\n  top: @closeTop;\n  right: @closeRight;\n\n  font-size: @closeSize;\n\n  margin: @closeMargin;\n  color: @closeColor;\n  transition: @closeTransition;\n}\n\n\n\n/*******************************\n             States\n*******************************/\n\n/* Hover */\n.ui.nag:hover {\n  background: @nagHoverBackground;\n  opacity: @nagHoverOpacity;\n}\n\n.ui.nag .close:hover {\n  opacity: @closeHoverOpacity;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*--------------\n     Static\n---------------*/\n\n.ui.overlay.nag {\n  position: absolute;\n  display: block;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.fixed.nag {\n  position: fixed;\n}\n\n/*--------------\n     Bottom\n---------------*/\n\n.ui.bottom.nags,\n.ui.bottom.nag {\n  border-radius: @bottomBorderRadius;\n  top: auto;\n  bottom: @bottom;\n}\n\n/*--------------\n     White\n---------------*/\n\n.ui.inverted.nags .nag,\n.ui.inverted.nag {\n  background-color: @invertedBackground;\n  color: @darkTextColor;\n}\n.ui.inverted.nags .nag .close,\n.ui.inverted.nags .nag .title,\n.ui.inverted.nag .close,\n.ui.inverted.nag .title {\n  color: @lightTextColor;\n}\n\n\n/*******************************\n           Groups\n*******************************/\n\n.ui.nags .nag {\n  border-radius: @groupedBorderRadius !important;\n}\n.ui.nags .nag:last-child {\n  border-radius: @topBorderRadius;\n}\n.ui.bottom.nags .nag:last-child {\n  border-radius: @bottomBorderRadius;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Popup\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'popup';\n\n@import (multiple) '../../theme.config';\n\n\n/*******************************\n            Popup\n*******************************/\n\n.ui.popup {\n  display: none;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n\n  /* Fixes content being squished when inline (moz only) */\n  min-width: min-content;\n  z-index: @zIndex;\n\n  border: @border;\n  line-height: @lineHeight;\n  max-width: @maxWidth;\n  background: @background;\n\n  padding: @verticalPadding @horizontalPadding;\n  font-weight: @fontWeight;\n  font-style: @fontStyle;\n  color: @color;\n\n  border-radius: @borderRadius;\n  box-shadow: @boxShadow;\n}\n.ui.popup > .header {\n  padding: 0em;\n\n  font-family: @headerFont;\n  font-size: @headerFontSize;\n  line-height: @headerLineHeight;\n  font-weight: @headerFontWeight;\n}\n.ui.popup > .header + .content {\n  padding-top: @headerDistance;\n}\n\n.ui.popup:before {\n  position: absolute;\n  content: '';\n  width: @arrowSize;\n  height: @arrowSize;\n\n  background: @arrowBackground;\n  transform: rotate(45deg);\n\n  z-index: @arrowZIndex;\n  box-shadow: @arrowBoxShadow;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n    Tooltip\n---------------*/\n\n/* Content */\n[data-tooltip] {\n  position: relative;\n}\n\n/* Arrow */\n[data-tooltip]:before {\n  pointer-events: none;\n  position: absolute;\n  content: '';\n  font-size: @medium;\n  width: @arrowSize;\n  height: @arrowSize;\n\n  background: @tooltipArrowBackground;\n  transform: rotate(45deg);\n\n  z-index: @arrowZIndex;\n  box-shadow: @tooltipArrowBoxShadow;\n}\n\n/* Popup */\n[data-tooltip]:after {\n  pointer-events: none;\n  content: attr(data-tooltip);\n  position: absolute;\n  text-transform: none;\n  text-align: left;\n  white-space: nowrap;\n\n  font-size: @tooltipFontSize;\n\n  border: @tooltipBorder;\n  line-height: @tooltipLineHeight;\n  max-width: @tooltipMaxWidth;\n  background: @tooltipBackground;\n\n  padding: @tooltipPadding;\n  font-weight: @tooltipFontWeight;\n  font-style: @tooltipFontStyle;\n  color: @tooltipColor;\n\n  border-radius: @tooltipBorderRadius;\n  box-shadow: @tooltipBoxShadow;\n  z-index: @tooltipZIndex;\n}\n\n/* Default Position (Top Center) */\n[data-tooltip]:not([data-position]):before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: @tooltipArrowBottomBackground;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-bottom: -@tooltipArrowVerticalOffset;\n}\n[data-tooltip]:not([data-position]):after {\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 100%;\n  margin-bottom: @tooltipDistanceAway;\n}\n\n/* Animation */\n[data-tooltip]:before,\n[data-tooltip]:after {\n  pointer-events: none;\n  visibility: hidden;\n}\n[data-tooltip]:before {\n  opacity: 0;\n  transform: rotate(45deg) scale(0) !important;\n  transform-origin: center top;\n  transition:\n    all @tooltipDuration @tooltipEasing\n  ;\n}\n[data-tooltip]:after {\n  opacity: 1;\n  transform-origin: center bottom;\n  transition:\n    all @tooltipDuration @tooltipEasing\n  ;\n}\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after {\n  visibility: visible;\n  pointer-events: auto;\n}\n[data-tooltip]:hover:before {\n  transform: rotate(45deg) scale(1) !important;\n  opacity: 1;\n}\n\n/* Animation Position */\n[data-tooltip]:after,\n[data-tooltip][data-position=\"top center\"]:after,\n[data-tooltip][data-position=\"bottom center\"]:after {\n  transform: translateX(-50%) scale(0) !important;\n}\n[data-tooltip]:hover:after,\n[data-tooltip][data-position=\"bottom center\"]:hover:after {\n  transform: translateX(-50%) scale(1) !important;\n}\n[data-tooltip][data-position=\"left center\"]:after,\n[data-tooltip][data-position=\"right center\"]:after {\n  transform: translateY(-50%) scale(0) !important;\n}\n[data-tooltip][data-position=\"left center\"]:hover:after,\n[data-tooltip][data-position=\"right center\"]:hover:after {\n  transform: translateY(-50%) scale(1) !important;\n}\n[data-tooltip][data-position=\"top left\"]:after,\n[data-tooltip][data-position=\"top right\"]:after,\n[data-tooltip][data-position=\"bottom left\"]:after,\n[data-tooltip][data-position=\"bottom right\"]:after {\n  transform: scale(0) !important;\n}\n[data-tooltip][data-position=\"top left\"]:hover:after,\n[data-tooltip][data-position=\"top right\"]:hover:after,\n[data-tooltip][data-position=\"bottom left\"]:hover:after,\n[data-tooltip][data-position=\"bottom right\"]:hover:after {\n  transform: scale(1) !important;\n}\n\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Arrow */\n[data-tooltip][data-inverted]:before {\n  box-shadow: none !important;\n}\n\n/* Arrow Position */\n[data-tooltip][data-inverted]:before {\n  background: @invertedArrowBottomBackground;\n}\n\n/* Popup  */\n[data-tooltip][data-inverted]:after {\n  background: @tooltipInvertedBackground;\n  color: @tooltipInvertedColor;\n  border: @tooltipInvertedBorder;\n  box-shadow: @tooltipInvertedBoxShadow;\n}\n[data-tooltip][data-inverted]:after .header {\n  background-color: @tooltipInvertedHeaderBackground;\n  color: @tooltipInvertedHeaderColor;\n}\n\n/*--------------\n    Position\n---------------*/\n\n/* Top Center */\n[data-position=\"top center\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 50%;\n  bottom: 100%;\n  transform: translateX(-50%);\n  margin-bottom: @tooltipDistanceAway;\n}\n[data-position=\"top center\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: @tooltipArrowTopBackground;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-bottom: -@tooltipArrowVerticalOffset;\n}\n\n/* Top Left */\n[data-position=\"top left\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 0;\n  bottom: 100%;\n  margin-bottom: @tooltipDistanceAway;\n}\n[data-position=\"top left\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: @arrowDistanceFromEdge;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-bottom: -@tooltipArrowVerticalOffset;\n}\n\n/* Top Right */\n[data-position=\"top right\"][data-tooltip]:after {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 100%;\n  margin-bottom: @tooltipDistanceAway;\n}\n[data-position=\"top right\"][data-tooltip]:before {\n  top: auto;\n  left: auto;\n  bottom: 100%;\n  right: @arrowDistanceFromEdge;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-bottom: -@tooltipArrowVerticalOffset;\n}\n\n\n/* Bottom Center */\n[data-position=\"bottom center\"][data-tooltip]:after {\n  bottom: auto;\n  right: auto;\n  left: 50%;\n  top: 100%;\n  transform: translateX(-50%);\n  margin-top: @tooltipDistanceAway;\n}\n[data-position=\"bottom center\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: 50%;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-top: -@tooltipArrowVerticalOffset;\n}\n\n/* Bottom Left */\n[data-position=\"bottom left\"][data-tooltip]:after {\n  left: 0;\n  top: 100%;\n  margin-top: @tooltipDistanceAway;\n}\n[data-position=\"bottom left\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: @arrowDistanceFromEdge;\n  margin-left: @tooltipArrowHorizontalOffset;\n  margin-top: -@tooltipArrowVerticalOffset;\n}\n\n/* Bottom Right */\n[data-position=\"bottom right\"][data-tooltip]:after {\n  right: 0;\n  top: 100%;\n  margin-top: @tooltipDistanceAway;\n}\n[data-position=\"bottom right\"][data-tooltip]:before {\n  bottom: auto;\n  left: auto;\n  top: 100%;\n  right: @arrowDistanceFromEdge;\n  margin-left: @tooltipArrowVerticalOffset;\n  margin-top: -@tooltipArrowHorizontalOffset;\n}\n\n/* Left Center */\n[data-position=\"left center\"][data-tooltip]:after {\n  right: 100%;\n  top: 50%;\n  margin-right: @tooltipDistanceAway;\n  transform: translateY(-50%);\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  right: 100%;\n  top: 50%;\n  margin-top: @tooltipArrowVerticalOffset;\n  margin-right: @tooltipArrowHorizontalOffset;\n}\n\n/* Right Center */\n[data-position=\"right center\"][data-tooltip]:after {\n  left: 100%;\n  top: 50%;\n  margin-left: @tooltipDistanceAway;\n  transform: translateY(-50%);\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  left: 100%;\n  top: 50%;\n  margin-top: @tooltipArrowHorizontalOffset;\n  margin-left: -@tooltipArrowVerticalOffset;\n}\n\n/* Arrow */\n[data-position~=\"bottom\"][data-tooltip]:before {\n  background: @arrowTopBackground;\n  box-shadow: @bottomArrowBoxShadow;\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  background: @arrowCenterBackground;\n  box-shadow: @leftArrowBoxShadow;\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  background: @arrowCenterBackground;\n  box-shadow: @rightArrowBoxShadow;\n}\n[data-position~=\"top\"][data-tooltip]:before {\n  background: @arrowBottomBackground;\n}\n\n/* Inverted Arrow Color */\n[data-inverted][data-position~=\"bottom\"][data-tooltip]:before {\n  background: @invertedArrowTopBackground;\n  box-shadow: @bottomArrowBoxShadow;\n}\n[data-inverted][data-position=\"left center\"][data-tooltip]:before {\n  background: @invertedArrowCenterBackground;\n  box-shadow: @leftArrowBoxShadow;\n}\n[data-inverted][data-position=\"right center\"][data-tooltip]:before {\n  background: @invertedArrowCenterBackground;\n  box-shadow: @rightArrowBoxShadow;\n}\n[data-inverted][data-position~=\"top\"][data-tooltip]:before {\n  background: @invertedArrowBottomBackground;\n}\n\n[data-position~=\"bottom\"][data-tooltip]:before {\n  transform-origin: center bottom;\n}\n[data-position~=\"bottom\"][data-tooltip]:after {\n  transform-origin: center top;\n}\n[data-position=\"left center\"][data-tooltip]:before {\n  transform-origin: top center;\n}\n[data-position=\"left center\"][data-tooltip]:after {\n  transform-origin: right center;\n}\n[data-position=\"right center\"][data-tooltip]:before {\n  transform-origin: right center;\n}\n[data-position=\"right center\"][data-tooltip]:after {\n  transform-origin: left center;\n}\n\n/*--------------\n     Spacing\n---------------*/\n\n.ui.popup {\n  margin: 0em;\n}\n\n/* Extending from Top */\n.ui.top.popup {\n  margin: 0em 0em @popupDistanceAway;\n}\n.ui.top.left.popup {\n  transform-origin: left bottom;\n}\n.ui.top.center.popup {\n  transform-origin: center bottom;\n}\n.ui.top.right.popup {\n  transform-origin: right bottom;\n}\n\n/* Extending from Vertical Center */\n.ui.left.center.popup {\n  margin: 0em @popupDistanceAway 0em 0em;\n  transform-origin: right 50%;\n}\n.ui.right.center.popup {\n  margin: 0em 0em 0em @popupDistanceAway;\n  transform-origin: left 50%;\n}\n\n/* Extending from Bottom */\n.ui.bottom.popup {\n  margin: @popupDistanceAway 0em 0em;\n}\n.ui.bottom.left.popup {\n  transform-origin: left top;\n}\n.ui.bottom.center.popup {\n  transform-origin: center top;\n}\n.ui.bottom.right.popup {\n  transform-origin: right top;\n}\n\n/*--------------\n     Pointer\n---------------*/\n\n/*--- Below ---*/\n.ui.bottom.center.popup:before {\n  margin-left: @arrowOffset;\n  top: @arrowOffset;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  box-shadow: @bottomArrowBoxShadow;\n}\n\n.ui.bottom.left.popup {\n  margin-left: @boxArrowOffset;\n}\n/*rtl:rename*/\n.ui.bottom.left.popup:before {\n  top: @arrowOffset;\n  left: @arrowDistanceFromEdge;\n  right: auto;\n  bottom: auto;\n  margin-left: 0em;\n  box-shadow: @bottomArrowBoxShadow;\n}\n\n.ui.bottom.right.popup {\n  margin-right: @boxArrowOffset;\n}\n/*rtl:rename*/\n.ui.bottom.right.popup:before {\n  top: @arrowOffset;\n  right: @arrowDistanceFromEdge;\n  bottom: auto;\n  left: auto;\n  margin-left: 0em;\n  box-shadow: @bottomArrowBoxShadow;\n}\n\n/*--- Above ---*/\n.ui.top.center.popup:before {\n  top: auto;\n  right: auto;\n  bottom: @arrowOffset;\n  left: 50%;\n  margin-left: @arrowOffset;\n}\n.ui.top.left.popup {\n  margin-left: @boxArrowOffset;\n}\n/*rtl:rename*/\n.ui.top.left.popup:before {\n  bottom: @arrowOffset;\n  left: @arrowDistanceFromEdge;\n  top: auto;\n  right: auto;\n  margin-left: 0em;\n}\n.ui.top.right.popup {\n  margin-right: @boxArrowOffset;\n}\n/*rtl:rename*/\n.ui.top.right.popup:before {\n  bottom: @arrowOffset;\n  right: @arrowDistanceFromEdge;\n  top: auto;\n  left: auto;\n  margin-left: 0em;\n}\n\n/*--- Left Center ---*/\n/*rtl:rename*/\n.ui.left.center.popup:before {\n  top: 50%;\n  right: @arrowOffset;\n  bottom: auto;\n  left: auto;\n  margin-top: @arrowOffset;\n  box-shadow: @leftArrowBoxShadow;\n}\n\n/*--- Right Center  ---*/\n/*rtl:rename*/\n.ui.right.center.popup:before {\n  top: 50%;\n  left: @arrowOffset;\n  bottom: auto;\n  right: auto;\n  margin-top: @arrowOffset;\n  box-shadow: @rightArrowBoxShadow;\n}\n\n/* Arrow Color By Location */\n.ui.bottom.popup:before {\n  background: @arrowTopBackground;\n}\n.ui.right.center.popup:before,\n.ui.left.center.popup:before {\n  background: @arrowCenterBackground;\n}\n.ui.top.popup:before {\n  background: @arrowBottomBackground;\n}\n\n/* Inverted Arrow Color */\n.ui.inverted.bottom.popup:before {\n  background: @invertedArrowTopBackground;\n}\n.ui.inverted.right.center.popup:before,\n.ui.inverted.left.center.popup:before {\n  background: @invertedArrowCenterBackground;\n}\n.ui.inverted.top.popup:before {\n  background: @invertedArrowBottomBackground;\n}\n\n\n/*******************************\n            Coupling\n*******************************/\n\n/* Immediate Nested Grid */\n.ui.popup > .ui.grid:not(.padded) {\n  width: @nestedGridWidth;\n  margin: @nestedGridMargin;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.loading.popup {\n  display: block;\n  visibility: hidden;\n  z-index: @loadingZIndex;\n}\n\n.ui.animating.popup,\n.ui.visible.popup {\n  display: block;\n}\n\n.ui.visible.popup {\n  transform: translateZ(0px);\n  backface-visibility: hidden;\n}\n\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n     Basic\n---------------*/\n\n.ui.basic.popup:before {\n  display: none;\n}\n\n\n/*--------------\n     Wide\n---------------*/\n\n.ui.wide.popup {\n  max-width: @wideWidth;\n}\n.ui[class*=\"very wide\"].popup {\n  max-width: @veryWideWidth;\n}\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.wide.popup,\n  .ui[class*=\"very wide\"].popup {\n    max-width: @maxWidth;\n  }\n}\n\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.popup {\n  width: 100%;\n  max-width: none;\n}\n\n\n/*--------------\n     Colors\n---------------*/\n\n/* Inverted colors  */\n.ui.inverted.popup {\n  background: @invertedBackground;\n  color: @invertedColor;\n  border: @invertedBorder;\n  box-shadow: @invertedBoxShadow;\n}\n.ui.inverted.popup .header {\n  background-color: @invertedHeaderBackground;\n  color: @invertedHeaderColor;\n}\n.ui.inverted.popup:before {\n  background-color: @invertedArrowColor;\n  box-shadow: none !important;\n}\n\n/*--------------\n     Flowing\n---------------*/\n\n.ui.flowing.popup {\n  max-width: none;\n}\n\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.popup {\n  font-size: @mini;\n}\n.ui.tiny.popup {\n  font-size: @tiny;\n}\n.ui.small.popup {\n  font-size: @small;\n}\n.ui.popup {\n  font-size: @medium;\n}\n.ui.large.popup {\n  font-size: @large;\n}\n.ui.huge.popup {\n  font-size: @huge;\n}\n\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Progress Bar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'progress';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Progress\n*******************************/\n\n.ui.progress {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  border: @border;\n  margin: @margin;\n  box-shadow: @boxShadow;\n  background: @background;\n  padding: @padding;\n  border-radius: @borderRadius;\n}\n\n.ui.progress:first-child {\n  margin: @firstMargin;\n}\n.ui.progress:last-child {\n  margin: @lastMargin;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* Activity Bar */\n.ui.progress .bar {\n  display: block;\n  line-height: 1;\n  position: @barPosition;\n  width: @barInitialWidth;\n  min-width: @barMinWidth;\n  background: @barBackground;\n  border-radius: @barBorderRadius;\n  transition: @barTransition;\n}\n\n/* Percent Complete */\n.ui.progress .bar > .progress {\n  white-space: nowrap;\n  position: @progressPosition;\n  width: @progressWidth;\n  font-size: @progressSize;\n  top: @progressTop;\n  right: @progressRight;\n  left: @progressLeft;\n  bottom: @progressBottom;\n  color: @progressColor;\n  text-shadow: @progressTextShadow;\n  margin-top: @progressOffset;\n  font-weight: @progressFontWeight;\n  text-align: @progressTextAlign;\n}\n\n/* Label */\n.ui.progress > .label {\n  position: absolute;\n  width: @labelWidth;\n  font-size: @labelSize;\n  top: @labelTop;\n  right: @labelRight;\n  left: @labelLeft;\n  bottom: @labelBottom;\n  color: @labelColor;\n  font-weight: @labelFontWeight;\n  text-shadow: @labelTextShadow;\n  margin-top: @labelOffset;\n  text-align: @labelTextAlign;\n  transition: @labelTransition;\n}\n\n\n/*******************************\n            Types\n*******************************/\n\n\n/* Indicating */\n.ui.indicating.progress[data-percent^=\"1\"] .bar,\n.ui.indicating.progress[data-percent^=\"2\"] .bar {\n  background-color: @indicatingFirstColor;\n}\n.ui.indicating.progress[data-percent^=\"3\"] .bar {\n  background-color: @indicatingSecondColor;\n}\n.ui.indicating.progress[data-percent^=\"4\"] .bar,\n.ui.indicating.progress[data-percent^=\"5\"] .bar {\n  background-color: @indicatingThirdColor;\n}\n.ui.indicating.progress[data-percent^=\"6\"] .bar {\n  background-color: @indicatingFourthColor;\n}\n.ui.indicating.progress[data-percent^=\"7\"] .bar,\n.ui.indicating.progress[data-percent^=\"8\"] .bar {\n  background-color: @indicatingFifthColor;\n}\n.ui.indicating.progress[data-percent^=\"9\"] .bar,\n.ui.indicating.progress[data-percent^=\"100\"] .bar {\n  background-color: @indicatingSixthColor;\n}\n\n/* Indicating Label */\n.ui.indicating.progress[data-percent^=\"1\"] .label,\n.ui.indicating.progress[data-percent^=\"2\"] .label {\n  color: @indicatingFirstLabelColor;\n}\n.ui.indicating.progress[data-percent^=\"3\"] .label {\n  color: @indicatingSecondLabelColor;\n}\n.ui.indicating.progress[data-percent^=\"4\"] .label,\n.ui.indicating.progress[data-percent^=\"5\"] .label {\n  color: @indicatingThirdLabelColor;\n}\n.ui.indicating.progress[data-percent^=\"6\"] .label {\n  color: @indicatingFourthLabelColor;\n}\n.ui.indicating.progress[data-percent^=\"7\"] .label,\n.ui.indicating.progress[data-percent^=\"8\"] .label {\n  color: @indicatingFifthLabelColor;\n}\n.ui.indicating.progress[data-percent^=\"9\"] .label,\n.ui.indicating.progress[data-percent^=\"100\"] .label {\n  color: @indicatingSixthLabelColor;\n}\n\n/* Single Digits */\n.ui.indicating.progress[data-percent=\"1\"] .bar,\n.ui.indicating.progress[data-percent=\"2\"] .bar,\n.ui.indicating.progress[data-percent=\"3\"] .bar,\n.ui.indicating.progress[data-percent=\"4\"] .bar,\n.ui.indicating.progress[data-percent=\"5\"] .bar,\n.ui.indicating.progress[data-percent=\"6\"] .bar,\n.ui.indicating.progress[data-percent=\"7\"] .bar,\n.ui.indicating.progress[data-percent=\"8\"] .bar,\n.ui.indicating.progress[data-percent=\"9\"] .bar {\n  background-color: @indicatingFirstColor;\n}\n.ui.indicating.progress[data-percent=\"1\"] .label,\n.ui.indicating.progress[data-percent=\"2\"] .label,\n.ui.indicating.progress[data-percent=\"3\"] .label,\n.ui.indicating.progress[data-percent=\"4\"] .label,\n.ui.indicating.progress[data-percent=\"5\"] .label,\n.ui.indicating.progress[data-percent=\"6\"] .label,\n.ui.indicating.progress[data-percent=\"7\"] .label,\n.ui.indicating.progress[data-percent=\"8\"] .label,\n.ui.indicating.progress[data-percent=\"9\"] .label {\n  color: @indicatingFirstLabelColor;\n}\n\n/* Indicating Success */\n.ui.indicating.progress.success .label {\n  color: @successHeaderColor;\n}\n\n/*******************************\n             States\n*******************************/\n\n\n/*--------------\n     Success\n---------------*/\n\n.ui.progress.success .bar {\n  background-color: @successColor !important;\n}\n.ui.progress.success .bar,\n.ui.progress.success .bar::after {\n  animation: none !important;\n}\n.ui.progress.success > .label {\n  color: @successHeaderColor;\n}\n\n/*--------------\n     Warning\n---------------*/\n\n.ui.progress.warning .bar {\n  background-color: @warningColor !important;\n}\n.ui.progress.warning .bar,\n.ui.progress.warning .bar::after {\n  animation: none !important;\n}\n.ui.progress.warning > .label {\n  color: @warningHeaderColor;\n}\n\n/*--------------\n     Error\n---------------*/\n\n.ui.progress.error .bar {\n  background-color: @errorColor !important;\n}\n.ui.progress.error .bar,\n.ui.progress.error .bar::after {\n  animation: none !important;\n}\n.ui.progress.error > .label {\n  color: @errorHeaderColor;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.progress .bar {\n  position: relative;\n  min-width: @activeMinWidth;\n}\n.ui.active.progress .bar::after {\n  content: '';\n  opacity: 0;\n\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background: @activePulseColor;\n\n  border-radius: @barBorderRadius;\n\n  animation: progress-active @activePulseDuration @defaultEasing infinite;\n}\n@keyframes progress-active {\n  0% {\n    opacity: @activePulseMaxOpacity;\n    width: 0;\n  }\n  90% {\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n\n/*--------------\n    Disabled\n---------------*/\n\n.ui.disabled.progress {\n  opacity: 0.35;\n}\n.ui.disabled.progress .bar,\n.ui.disabled.progress .bar::after {\n  animation: none !important;\n}\n\n\n/*******************************\n           Variations\n*******************************/\n\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.progress {\n  background: @invertedBackground;\n  border: @invertedBorder;\n}\n.ui.inverted.progress .bar {\n  background: @invertedBarBackground;\n}\n.ui.inverted.progress .bar > .progress {\n  color: @invertedProgressColor;\n}\n.ui.inverted.progress > .label {\n  color: @invertedLabelColor;\n}\n.ui.inverted.progress.success > .label {\n  color: @successColor;\n}\n.ui.inverted.progress.warning > .label {\n  color: @warningColor;\n}\n.ui.inverted.progress.error > .label {\n  color: @errorColor;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n/* bottom attached */\n.ui.progress.attached {\n  background: @attachedBackground;\n  position: relative;\n  border: none;\n  margin: 0em;\n}\n.ui.progress.attached,\n.ui.progress.attached .bar {\n  display: block;\n  height: @attachedHeight;\n  padding: 0px;\n  overflow: hidden;\n  border-radius: 0em 0em @attachedBorderRadius @attachedBorderRadius;\n}\n.ui.progress.attached .bar {\n  border-radius: 0em;\n}\n\n/* top attached */\n.ui.progress.top.attached,\n.ui.progress.top.attached .bar {\n  top: 0px;\n  border-radius: @attachedBorderRadius @attachedBorderRadius 0em 0em;\n}\n.ui.progress.top.attached .bar {\n  border-radius: 0em;\n}\n\n/* Coupling */\n.ui.segment > .ui.attached.progress,\n.ui.card > .ui.attached.progress {\n  position: absolute;\n  top: auto;\n  left: 0;\n  bottom: 100%;\n  width: 100%;\n}\n.ui.segment > .ui.bottom.attached.progress,\n.ui.card > .ui.bottom.attached.progress {\n  top: 100%;\n  bottom: auto;\n}\n\n/*--------------\n     Colors\n---------------*/\n\n/* Red */\n.ui.red.progress .bar {\n  background-color: @red;\n}\n.ui.red.inverted.progress .bar {\n  background-color: @lightRed;\n}\n\n/* Orange */\n.ui.orange.progress .bar {\n  background-color: @orange;\n}\n.ui.orange.inverted.progress .bar {\n  background-color: @lightOrange;\n}\n\n/* Yellow */\n.ui.yellow.progress .bar {\n  background-color: @yellow;\n}\n.ui.yellow.inverted.progress .bar {\n  background-color: @lightYellow;\n}\n\n/* Olive */\n.ui.olive.progress .bar {\n  background-color: @olive;\n}\n.ui.olive.inverted.progress .bar {\n  background-color: @lightOlive;\n}\n\n/* Green */\n.ui.green.progress .bar {\n  background-color: @green;\n}\n.ui.green.inverted.progress .bar {\n  background-color: @lightGreen;\n}\n\n/* Teal */\n.ui.teal.progress .bar {\n  background-color: @teal;\n}\n.ui.teal.inverted.progress .bar {\n  background-color: @lightTeal;\n}\n\n/* Blue */\n.ui.blue.progress .bar {\n  background-color: @blue;\n}\n.ui.blue.inverted.progress .bar {\n  background-color: @lightBlue;\n}\n\n/* Violet */\n.ui.violet.progress .bar {\n  background-color: @violet;\n}\n.ui.violet.inverted.progress .bar {\n  background-color: @lightViolet;\n}\n\n/* Purple */\n.ui.purple.progress .bar {\n  background-color: @purple;\n}\n.ui.purple.inverted.progress .bar {\n  background-color: @lightPurple;\n}\n\n/* Pink */\n.ui.pink.progress .bar {\n  background-color: @pink;\n}\n.ui.pink.inverted.progress .bar {\n  background-color: @lightPink;\n}\n\n/* Brown */\n.ui.brown.progress .bar {\n  background-color: @brown;\n}\n.ui.brown.inverted.progress .bar {\n  background-color: @lightBrown;\n}\n\n/* Grey */\n.ui.grey.progress .bar {\n  background-color: @grey;\n}\n.ui.grey.inverted.progress .bar {\n  background-color: @lightGrey;\n}\n\n/* Black */\n.ui.black.progress .bar {\n  background-color: @black;\n}\n.ui.black.inverted.progress .bar {\n  background-color: @lightBlack;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.tiny.progress {\n  font-size: @tiny;\n}\n.ui.tiny.progress .bar {\n  height: @tinyBarHeight;\n}\n\n.ui.small.progress {\n  font-size: @small;\n}\n.ui.small.progress .bar {\n  height: @smallBarHeight;\n}\n\n.ui.progress {\n  font-size: @medium;\n}\n.ui.progress .bar {\n  height: @barHeight;\n}\n\n.ui.large.progress {\n  font-size: @large;\n}\n.ui.large.progress .bar {\n  height: @largeBarHeight;\n}\n\n.ui.big.progress {\n  font-size: @big;\n}\n.ui.big.progress .bar {\n  height: @bigBarHeight;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Rating\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'rating';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n           Rating\n*******************************/\n\n.ui.rating {\n  display: inline-flex;\n  white-space: @whiteSpace;\n  vertical-align: @verticalAlign;\n}\n.ui.rating:last-child {\n  margin-right: 0em;\n}\n\n/* Icon */\n.ui.rating .icon {\n  padding: 0em;\n  margin: 0em;\n  text-align: center;\n  font-weight: @normal;\n  font-style: normal;\n  flex: 1 0 auto;\n  cursor: @iconCursor;\n  width: @iconWidth;\n  height: @iconHeight;\n  transition: @iconTransition;\n}\n\n\n/*******************************\n             Types\n*******************************/\n\n\n/*-------------------\n      Standard\n--------------------*/\n\n/* Inactive Icon */\n.ui.rating .icon {\n  background: @inactiveBackground;\n  color: @inactiveColor;\n}\n\n/* Active Icon */\n.ui.rating .active.icon {\n  background: @activeBackground;\n  color: @activeColor;\n}\n\n/* Selected Icon */\n.ui.rating .icon.selected,\n.ui.rating .icon.selected.active {\n  background: @selectedBackground;\n  color: @selectedColor;\n}\n\n\n/*-------------------\n        Star\n--------------------*/\n\n/* Inactive */\n.ui.star.rating .icon {\n  width: @starIconWidth;\n  height: @starIconHeight;\n  background: @starInactiveBackground;\n  color: @starInactiveColor;\n  text-shadow: @starInactiveTextShadow;\n}\n\n/* Active Star */\n.ui.star.rating .active.icon {\n  background: @starActiveBackground !important;\n  color: @starActiveColor !important;\n  text-shadow: @starActiveTextShadow !important;\n}\n\n/* Selected Star */\n.ui.star.rating .icon.selected,\n.ui.star.rating .icon.selected.active {\n  background: @starSelectedBackground !important;\n  color: @starSelectedColor !important;\n  text-shadow: @starSelectedTextShadow !important;\n}\n\n\n/*-------------------\n        Heart\n--------------------*/\n\n.ui.heart.rating .icon {\n  width: @heartIconWidth;\n  height: @heartIconHeight;\n  background: @heartInactiveBackground;\n  color: @heartInactiveColor;\n  text-shadow: @heartInactiveTextShadow !important;\n}\n\n/* Active Heart */\n.ui.heart.rating .active.icon {\n  background: @heartActiveBackground !important;\n  color: @heartActiveColor !important;\n  text-shadow: @heartActiveTextShadow !important;\n}\n\n/* Selected Heart */\n.ui.heart.rating .icon.selected,\n.ui.heart.rating .icon.selected.active {\n  background: @heartSelectedBackground !important;\n  color: @heartSelectedColor !important;\n  text-shadow: @heartSelectedTextShadow !important;\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n       Disabled\n--------------------*/\n\n/* disabled rating */\n.ui.disabled.rating .icon {\n  cursor: default;\n}\n\n\n/*-------------------\n   User Interactive\n--------------------*/\n\n/* Selected Rating */\n.ui.rating.selected .active.icon {\n  opacity: @interactiveActiveIconOpacity;\n}\n.ui.rating.selected .icon.selected,\n.ui.rating .icon.selected {\n  opacity: @interactiveSelectedIconOpacity;\n}\n\n\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.mini.rating {\n  font-size: @mini;\n}\n.ui.tiny.rating {\n  font-size: @tiny;\n}\n.ui.small.rating {\n  font-size: @small;\n}\n.ui.rating {\n  font-size: @medium;\n}\n.ui.large.rating {\n  font-size: @large;\n}\n.ui.huge.rating {\n  font-size: @huge;\n}\n.ui.massive.rating {\n  font-size: @massive;\n}\n\n\n.loadUIOverrides();\n","/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Rating';\n  src:\n    url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'),\n    url(data:application/font-woff;charset=utf-8;base64,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) format('woff')\n  ;\n  font-weight: normal;\n  font-style: normal;\n}\n.ui.rating .icon {\n  font-family: 'Rating';\n  line-height: 1;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n/* Empty Star */\n.ui.rating .icon:before {\n  content: '\\f005';\n}\n/* Active Star */\n.ui.rating .active.icon:before {\n  content: '\\f005';\n}\n\n/*-------------------\n        Star\n--------------------*/\n\n/* Unfilled Star */\n.ui.star.rating .icon:before {\n  content: '\\f005';\n}\n/* Active Star */\n.ui.star.rating .active.icon:before {\n  content: '\\f005';\n}\n\n/* Partial */\n.ui.star.rating .partial.icon:before {\n  content: '\\f006';\n}\n.ui.star.rating .partial.icon {\n  content: '\\f005';\n}\n\n/*-------------------\n        Heart\n--------------------*/\n\n/* Empty Heart\n.ui.heart.rating .icon:before {\n  content: '\\f08a';\n}\n*/\n.ui.heart.rating .icon:before {\n  content: '\\f004';\n}\n/* Active */\n.ui.heart.rating .active.icon:before {\n  content: '\\f004';\n}\n","/*!\n * # Semantic UI - Search\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'search';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n             Search\n*******************************/\n\n.ui.search {\n  position: relative;\n}\n\n.ui.search > .prompt {\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);\n\n  text-shadow: none;\n  font-style: normal;\n  font-weight: @normal;\n\n  line-height: @promptLineHeight;\n  padding: @promptPadding;\n  font-size: @promptFontSize;\n\n  background: @promptBackground;\n  border: @promptBorder;\n  color: @promptColor;\n  box-shadow: @promptBoxShadow;\n  transition: @promptTransition;\n}\n\n.ui.search .prompt {\n  border-radius: @promptBorderRadius;\n}\n\n\n/*--------------\n     Icon\n---------------*/\n\n.ui.search .prompt ~ .search.icon {\n  cursor: pointer;\n}\n\n/*--------------\n    Results\n---------------*/\n\n.ui.search > .results {\n  display: none;\n\n  position: absolute;\n  top: 100%;\n  left: 0%;\n  transform-origin: center top;\n  white-space: normal;\n  text-align: left;\n  text-transform: none;\n\n  background: @resultsBackground;\n\n  margin-top: @resultsDistance;\n  width: @resultsWidth;\n\n  border-radius: @resultsBorderRadius;\n  box-shadow: @resultsBoxShadow;\n  border: @resultsBorder;\n  z-index: @resultsZIndex;\n}\n.ui.search > .results > :first-child {\n  border-radius: @resultsBorderRadius @resultsBorderRadius 0em 0em;\n}\n.ui.search > .results > :last-child {\n  border-radius: 0em 0em @resultsBorderRadius @resultsBorderRadius;\n}\n\n/*--------------\n    Result\n---------------*/\n\n.ui.search > .results .result {\n  cursor: pointer;\n  display: block;\n  overflow: hidden;\n  font-size: @resultFontSize;\n  padding: @resultPadding;\n  color: @resultTextColor;\n  line-height: @resultLineHeight;\n  border-bottom: @resultDivider;\n}\n.ui.search > .results .result:last-child {\n  border-bottom: @resultLastDivider !important;\n}\n\n/* Image */\n.ui.search > .results .result .image {\n  float: @resultImageFloat;\n  overflow: hidden;\n  background: @resultImageBackground;\n  width: @resultImageWidth;\n  height: @resultImageHeight;\n  border-radius: @resultImageBorderRadius;\n}\n.ui.search > .results .result .image img {\n  display: block;\n  width: auto;\n  height: 100%;\n}\n\n/*--------------\n      Info\n---------------*/\n\n.ui.search > .results .result .image + .content {\n  margin: @resultImageMargin;\n}\n\n.ui.search > .results .result .title {\n  margin: @resultTitleMargin;\n  font-family: @resultTitleFont;\n  font-weight: @resultTitleFontWeight;\n  font-size: @resultTitleFontSize;\n  color: @resultTitleColor;\n}\n.ui.search > .results .result .description {\n  margin-top: @resultDescriptionDistance;\n  font-size: @resultDescriptionFontSize;\n  color: @resultDescriptionColor;\n}\n.ui.search > .results .result .price {\n  float: @resultPriceFloat;\n  color: @resultPriceColor;\n}\n\n/*--------------\n    Message\n---------------*/\n\n.ui.search > .results > .message {\n  padding: @messageVerticalPadding @messageHorizontalPadding;\n}\n.ui.search > .results > .message .header {\n  font-family: @headerFont;\n  font-size: @messageHeaderFontSize;\n  font-weight: @messageHeaderFontWeight;\n  color: @messageHeaderColor;\n}\n.ui.search > .results > .message .description {\n  margin-top: @messageDescriptionDistance;\n  font-size: @messageDescriptionFontSize;\n  color: @messageDescriptionColor;\n}\n\n/* View All Results */\n.ui.search > .results > .action {\n  display: block;\n  border-top: @actionBorder;\n  background: @actionBackground;\n  padding: @actionPadding;\n  color: @actionColor;\n  font-weight: @actionFontWeight;\n  text-align: @actionAlign;\n}\n\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n       Focus\n---------------------*/\n\n.ui.search > .prompt:focus {\n  border-color: @promptFocusBorderColor;\n  background: @promptFocusBackground;\n  color: @promptFocusColor;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.search .input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @loaderFillColor;\n}\n.ui.loading.search .input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: button-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor transparent transparent;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.search > .results .result:hover,\n.ui.category.search > .results .category .result:hover {\n  background: @resultHoverBackground;\n}\n.ui.search .action:hover {\n  background: @actionHoverBackground;\n}\n\n/*--------------\n      Active\n---------------*/\n\n.ui.category.search > .results .category.active {\n  background: @categoryActiveBackground;\n}\n.ui.category.search > .results .category.active > .name {\n  color: @categoryNameActiveColor;\n}\n\n.ui.search > .results .result.active,\n.ui.category.search > .results .category .result.active {\n  position: relative;\n  border-left-color: @resultActiveBorderLeft;\n  background: @resultActiveBackground;\n  box-shadow: @resultActiveBoxShadow;\n}\n.ui.search > .results .result.active .title {\n  color: @resultActiveTitleColor;\n}\n.ui.search > .results .result.active .description {\n  color: @resultActiveDescriptionColor;\n}\n\n/*--------------------\n        Disabled\n----------------------*/\n\n/* Disabled */\n.ui.disabled.search {\n  cursor: default;\n  pointer-events: none;\n  opacity: @disabledOpacity;\n}\n\n\n/*******************************\n           Types\n*******************************/\n\n/*--------------\n    Selection\n---------------*/\n\n.ui.search.selection .prompt {\n  border-radius: @selectionPromptBorderRadius;\n}\n\n/* Remove input */\n.ui.search.selection > .icon.input > .remove.icon {\n  pointer-events: none;\n  position: absolute;\n  left: auto;\n  opacity: 0;\n  color: @selectionCloseIconColor;\n  top: @selectionCloseTop;\n  right: @selectionCloseRight;\n  transition: @selectionCloseTransition;\n}\n.ui.search.selection > .icon.input > .active.remove.icon {\n  cursor: pointer;\n  opacity: @selectionCloseIconOpacity;\n  pointer-events: auto;\n}\n.ui.search.selection > .icon.input:not([class*=\"left icon\"]) > .icon ~ .remove.icon {\n  right: @selectionCloseIconInputRight;\n}\n.ui.search.selection > .icon.input > .remove.icon:hover {\n  opacity: @selectionCloseIconHoverOpacity;\n  color: @selectionCloseIconHoverColor;\n}\n\n\n/*--------------\n    Category\n---------------*/\n\n.ui.category.search .results {\n  width: @categoryResultsWidth;\n}\n\n.ui.category.search .results.animating,\n.ui.category.search .results.visible {\n  display: table;\n}\n\n/* Category */\n.ui.category.search > .results .category {\n  display: table-row;\n  background: @categoryBackground;\n  box-shadow: @categoryBoxShadow;\n  transition: @categoryTransition;\n}\n\n/* Last Category */\n.ui.category.search > .results .category:last-child {\n  border-bottom: none;\n}\n\n/* First / Last */\n.ui.category.search > .results .category:first-child .name + .result {\n  border-radius: 0em @resultsBorderRadius 0em 0em;\n}\n.ui.category.search > .results .category:last-child .result:last-child {\n  border-radius: 0em 0em @resultsBorderRadius 0em;\n}\n\n/* Category Result Name */\n.ui.category.search > .results .category > .name {\n  display: table-cell;\n  text-overflow: ellipsis;\n  width: @categoryNameWidth;\n  white-space: @categoryNameWhitespace;\n  background: @categoryNameBackground;\n  font-family: @categoryNameFont;\n  font-size: @categoryNameFontSize;\n  padding: @categoryNamePadding;\n  font-weight: @categoryNameFontWeight;\n  color: @categoryNameColor;\n  border-bottom: @categoryDivider;\n}\n\n/* Category Result */\n.ui.category.search > .results .category .results {\n  display: table-cell;\n  background: @categoryResultBackground;\n  border-left: @categoryResultLeftBorder;\n  border-bottom: @categoryDivider;\n}\n.ui.category.search > .results .category .result {\n  border-bottom: @categoryResultDivider;\n  transition: @categoryResultTransition;\n  padding: @categoryResultPadding;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n     Left / Right\n--------------------*/\n\n.ui[class*=\"left aligned\"].search > .results {\n  right: auto;\n  left: 0%;\n}\n.ui[class*=\"right aligned\"].search > .results {\n  right: 0%;\n  left: auto;\n}\n\n/*--------------\n    Fluid\n---------------*/\n\n.ui.fluid.search .results {\n  width: 100%;\n}\n\n\n/*--------------\n      Sizes\n---------------*/\n\n.ui.mini.search {\n  font-size: @relativeMini;\n}\n.ui.small.search {\n  font-size: @relativeSmall;\n}\n.ui.search {\n  font-size: @relativeMedium;\n}\n.ui.large.search {\n  font-size: @relativeLarge;\n}\n.ui.big.search {\n  font-size: @relativeBig;\n}\n.ui.huge.search {\n  font-size: @relativeHuge;\n}\n.ui.massive.search {\n  font-size: @relativeMassive;\n}\n\n/*--------------\n      Mobile\n---------------*/\n\n@media only screen and (max-width: @largestMobileScreen) {\n  .ui.search .results {\n    max-width: @mobileMaxWidth;\n  }\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Shape\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'shape';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n              Shape\n*******************************/\n\n.ui.shape {\n  position: relative;\n  vertical-align: top;\n  display: @display;\n  perspective: @perspective;\n  transition: @transition;\n}\n\n.ui.shape .sides {\n  transform-style: preserve-3d;\n}\n\n.ui.shape .side {\n  opacity: 1;\n  width: 100%;\n\n  margin: @sideMargin !important;\n  backface-visibility: @backfaceVisibility;\n}\n\n.ui.shape .side {\n  display: none;\n}\n\n.ui.shape .side * {\n  backface-visibility: visible !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n.ui.cube.shape .side {\n  min-width: @cubeSize;\n  height: @cubeSize;\n\n  padding: @cubePadding;\n\n  background-color: @cubeBackground;\n  color: @cubeTextColor;\n  box-shadow: @cubeBoxShadow;\n}\n.ui.cube.shape .side > .content {\n  width: 100%;\n  height: 100%;\n  display: table;\n\n  text-align: @cubeTextAlign;\n  user-select: text;\n}\n.ui.cube.shape .side > .content > div {\n  display: table-cell;\n  vertical-align: middle;\n  font-size: @cubeFontSize;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.text.shape.animating .sides {\n  position: static;\n}\n.ui.text.shape .side {\n  white-space: nowrap;\n}\n.ui.text.shape .side > * {\n  white-space: normal;\n}\n\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.shape {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n}\n\n\n/*--------------\n    Animating\n---------------*/\n\n.ui.shape .animating.side {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: block;\n  z-index: @animatingZIndex;\n}\n.ui.shape .hidden.side {\n  opacity: @hiddenSideOpacity;\n}\n\n\n/*--------------\n      CSS\n---------------*/\n\n.ui.shape.animating .sides {\n  position: absolute;\n}\n.ui.shape.animating .sides {\n  transition: @transition;\n}\n.ui.shape.animating .side {\n  transition: @sideTransition;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.shape .active.side {\n  display: block;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Sidebar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'sidebar';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Sidebar\n*******************************/\n\n/* Sidebar Menu */\n.ui.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  backface-visibility: hidden;\n  transition: none;\n  will-change: transform;\n  transform: translate3d(0, 0, 0);\n  visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n\n  height: 100% !important;\n  max-height: 100%;\n  border-radius: 0em !important;\n  margin: 0em !important;\n  overflow-y: auto !important;\n  z-index: @topLayer;\n}\n\n/* GPU Layers for Child Elements */\n.ui.sidebar > * {\n  backface-visibility: hidden;\n}\n\n\n/*--------------\n   Direction\n---------------*/\n\n.ui.left.sidebar {\n  right: auto;\n  left: 0px;\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.sidebar {\n  right: 0px !important;\n  left: auto !important;\n  transform: translate3d(100%, 0%, 0);\n}\n\n.ui.top.sidebar,\n.ui.bottom.sidebar {\n  width: 100% !important;\n  height: auto !important;\n}\n.ui.top.sidebar {\n  top: 0px !important;\n  bottom: auto !important;\n  transform: translate3d(0, -100%, 0);\n}\n.ui.bottom.sidebar {\n  top: auto !important;\n  bottom: 0px !important;\n  transform: translate3d(0, 100%, 0);\n}\n\n\n/*--------------\n     Pushable\n---------------*/\n\n.pushable {\n  height: 100%;\n  overflow-x: hidden;\n  padding: 0em !important;\n}\n\n/* Whole Page */\nbody.pushable {\n  background: @canvasBackground !important;\n}\n\n/* Page Context */\n.pushable:not(body) {\n  transform: translate3d(0, 0, 0);\n}\n.pushable:not(body) > .ui.sidebar,\n.pushable:not(body) > .fixed,\n.pushable:not(body) > .pusher:after {\n  position: absolute;\n}\n\n\n/*--------------\n     Fixed\n---------------*/\n\n.pushable > .fixed {\n  position: fixed;\n  backface-visibility: hidden;\n\n  transition: transform @duration @easing;\n  will-change: transform;\n  z-index: @fixedLayer;\n}\n\n/*--------------\n     Page\n---------------*/\n\n.pushable > .pusher {\n  position: relative;\n  backface-visibility: hidden;\n  overflow: hidden;\n  min-height: 100%;\n  transition: transform @duration @easing;\n  z-index: @middleLayer;\n}\n\nbody.pushable > .pusher {\n  background: @pageBackground;\n}\n\n/* Pusher should inherit background from context */\n.pushable > .pusher {\n  background: inherit;\n}\n\n/*--------------\n     Dimmer\n---------------*/\n\n.pushable > .pusher:after {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  content: '';\n  background-color: @dimmerColor;\n  overflow: hidden;\n  opacity: 0;\n  transition: @dimmerTransition;\n  will-change: opacity;\n  z-index: @dimmerLayer;\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n.ui.sidebar.menu .item {\n  border-radius: 0em !important;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Dimmed\n---------------*/\n\n.pushable > .pusher.dimmed:after {\n  width: 100% !important;\n  height: 100% !important;\n  opacity: 1 !important;\n}\n\n/*--------------\n    Animating\n---------------*/\n\n.ui.animating.sidebar {\n  visibility: visible;\n}\n\n/*--------------\n     Visible\n---------------*/\n\n.ui.visible.sidebar {\n  visibility: visible;\n  transform: translate3d(0, 0, 0);\n}\n\n/* Shadow Direction */\n.ui.left.visible.sidebar,\n.ui.right.visible.sidebar {\n  box-shadow: @horizontalBoxShadow;\n}\n.ui.top.visible.sidebar,\n.ui.bottom.visible.sidebar {\n  box-shadow: @verticalBoxShadow;\n}\n\n/* Visible On Load */\n.ui.visible.left.sidebar ~ .fixed,\n.ui.visible.left.sidebar ~ .pusher {\n  transform: translate3d(@width, 0, 0);\n}\n.ui.visible.right.sidebar ~ .fixed,\n.ui.visible.right.sidebar ~ .pusher {\n  transform: translate3d(-@width, 0, 0);\n}\n.ui.visible.top.sidebar ~ .fixed,\n.ui.visible.top.sidebar ~ .pusher {\n  transform: translate3d(0, @height, 0);\n}\n.ui.visible.bottom.sidebar ~ .fixed,\n.ui.visible.bottom.sidebar ~ .pusher {\n  transform: translate3d(0, -@height, 0);\n}\n\n/* opposite sides visible forces content overlay */\n.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,\n.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,\n.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,\n.ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {\n  transform: translate3d(0, 0, 0);\n}\n\n/*--------------\n       iOS\n---------------*/\n\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n     Width\n---------------*/\n\n/* Left / Right */\n.ui.thin.left.sidebar,\n.ui.thin.right.sidebar {\n  width: @thinWidth;\n}\n.ui[class*=\"very thin\"].left.sidebar,\n.ui[class*=\"very thin\"].right.sidebar {\n  width: @veryThinWidth;\n}\n.ui.left.sidebar,\n.ui.right.sidebar {\n  width: @width;\n}\n.ui.wide.left.sidebar,\n.ui.wide.right.sidebar {\n  width: @wideWidth;\n}\n.ui[class*=\"very wide\"].left.sidebar,\n.ui[class*=\"very wide\"].right.sidebar {\n  width: @veryWideWidth;\n}\n\n/* Left Visible */\n.ui.visible.thin.left.sidebar ~ .fixed,\n.ui.visible.thin.left.sidebar ~ .pusher {\n  transform: translate3d(@thinWidth, 0, 0);\n}\n.ui.visible[class*=\"very thin\"].left.sidebar ~ .fixed,\n.ui.visible[class*=\"very thin\"].left.sidebar ~ .pusher {\n  transform: translate3d(@veryThinWidth, 0, 0);\n}\n.ui.visible.wide.left.sidebar ~ .fixed,\n.ui.visible.wide.left.sidebar ~ .pusher {\n  transform: translate3d(@wideWidth, 0, 0);\n}\n.ui.visible[class*=\"very wide\"].left.sidebar ~ .fixed,\n.ui.visible[class*=\"very wide\"].left.sidebar ~ .pusher {\n  transform: translate3d(@veryWideWidth, 0, 0);\n}\n\n/* Right Visible */\n.ui.visible.thin.right.sidebar ~ .fixed,\n.ui.visible.thin.right.sidebar ~ .pusher {\n  transform: translate3d(-@thinWidth, 0, 0);\n}\n.ui.visible[class*=\"very thin\"].right.sidebar ~ .fixed,\n.ui.visible[class*=\"very thin\"].right.sidebar ~ .pusher {\n  transform: translate3d(-@veryThinWidth, 0, 0);\n}\n.ui.visible.wide.right.sidebar ~ .fixed,\n.ui.visible.wide.right.sidebar ~ .pusher {\n  transform: translate3d(-@wideWidth, 0, 0);\n}\n.ui.visible[class*=\"very wide\"].right.sidebar ~ .fixed,\n.ui.visible[class*=\"very wide\"].right.sidebar ~ .pusher {\n  transform: translate3d(-@veryWideWidth, 0, 0);\n}\n\n\n\n/*******************************\n          Animations\n*******************************/\n\n/*--------------\n    Overlay\n---------------*/\n\n/* Set-up */\n.ui.overlay.sidebar {\n  z-index: @topLayer;\n}\n\n/* Initial */\n.ui.left.overlay.sidebar {\n  transform: translate3d(-100%, 0%, 0);\n}\n.ui.right.overlay.sidebar {\n  transform: translate3d(100%, 0%, 0);\n}\n.ui.top.overlay.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.overlay.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* Animation */\n.animating.ui.overlay.sidebar,\n.ui.visible.overlay.sidebar {\n  transition: transform @duration @easing;\n}\n\n/* End - Sidebar */\n.ui.visible.left.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.right.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.top.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n.ui.visible.bottom.overlay.sidebar {\n  transform: translate3d(0%, 0%, 0);\n}\n\n/* End - Pusher */\n.ui.visible.overlay.sidebar ~ .fixed,\n.ui.visible.overlay.sidebar ~ .pusher {\n  transform: none !important;\n}\n\n\n\n/*--------------\n      Push\n---------------*/\n\n/* Initial */\n.ui.push.sidebar {\n  transition: transform @duration @easing;\n  z-index: @topLayer;\n}\n\n/* Sidebar - Initial */\n.ui.left.push.sidebar {\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.push.sidebar {\n  transform: translate3d(100%, 0, 0);\n}\n.ui.top.push.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.push.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* End */\n.ui.visible.push.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n\n\n/*--------------\n    Uncover\n---------------*/\n\n/* Initial */\n.ui.uncover.sidebar {\n  transform: translate3d(0, 0, 0);\n  z-index: @bottomLayer;\n}\n\n/* End */\n.ui.visible.uncover.sidebar {\n  transform: translate3d(0, 0, 0);\n  transition: transform @duration @easing;\n}\n\n\n/*--------------\n   Slide Along\n---------------*/\n\n/* Initial */\n.ui.slide.along.sidebar {\n  z-index: @bottomLayer;\n}\n\n/* Sidebar - Initial */\n.ui.left.slide.along.sidebar {\n  transform: translate3d(-50%, 0, 0);\n}\n.ui.right.slide.along.sidebar {\n  transform: translate3d(50%, 0, 0);\n}\n.ui.top.slide.along.sidebar {\n  transform: translate3d(0, -50%, 0);\n}\n.ui.bottom.slide.along.sidebar {\n  transform: translate3d(0%, 50%, 0);\n}\n\n/* Animation */\n.ui.animating.slide.along.sidebar {\n  transition: transform @duration @easing;\n}\n\n/* End */\n.ui.visible.slide.along.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n\n\n/*--------------\n   Slide Out\n---------------*/\n\n/* Initial */\n.ui.slide.out.sidebar {\n  z-index: @bottomLayer;\n}\n\n/* Sidebar - Initial */\n.ui.left.slide.out.sidebar {\n  transform: translate3d(50%, 0, 0);\n}\n.ui.right.slide.out.sidebar {\n  transform: translate3d(-50%, 0, 0);\n}\n.ui.top.slide.out.sidebar {\n  transform: translate3d(0%, 50%, 0);\n}\n.ui.bottom.slide.out.sidebar {\n  transform: translate3d(0%, -50%, 0);\n}\n\n/* Animation */\n.ui.animating.slide.out.sidebar {\n  transition: transform @duration @easing;\n}\n\n/* End */\n.ui.visible.slide.out.sidebar {\n  transform: translate3d(0%, 0, 0);\n}\n\n/*--------------\n   Scale Down\n---------------*/\n\n/* Initial */\n.ui.scale.down.sidebar {\n  transition: transform @duration @easing;\n  z-index: @topLayer;\n}\n\n/* Sidebar - Initial  */\n.ui.left.scale.down.sidebar {\n  transform: translate3d(-100%, 0, 0);\n}\n.ui.right.scale.down.sidebar {\n  transform: translate3d(100%, 0, 0);\n}\n.ui.top.scale.down.sidebar {\n  transform: translate3d(0%, -100%, 0);\n}\n.ui.bottom.scale.down.sidebar {\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* Pusher - Initial */\n.ui.scale.down.left.sidebar ~ .pusher {\n  transform-origin: 75% 50%;\n}\n.ui.scale.down.right.sidebar ~ .pusher {\n  transform-origin: 25% 50%;\n}\n.ui.scale.down.top.sidebar ~ .pusher {\n  transform-origin: 50% 75%;\n}\n.ui.scale.down.bottom.sidebar ~ .pusher {\n  transform-origin: 50% 25%;\n}\n\n/* Animation */\n.ui.animating.scale.down > .visible.ui.sidebar {\n  transition: transform @duration @easing;\n}\n.ui.visible.scale.down.sidebar ~ .pusher,\n.ui.animating.scale.down.sidebar ~ .pusher {\n  display: block !important;\n  width: 100%;\n  height: 100%;\n  overflow: hidden !important;\n}\n\n/* End */\n.ui.visible.scale.down.sidebar {\n  transform: translate3d(0, 0, 0);\n}\n.ui.visible.scale.down.sidebar ~ .pusher {\n  transform: scale(0.75);\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Sticky\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'sticky';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n            Sticky\n*******************************/\n\n.ui.sticky {\n  position: static;\n  transition: @transition;\n  z-index: @zIndex;\n}\n\n/*******************************\n            States\n*******************************/\n\n/* Bound */\n.ui.sticky.bound {\n  position: absolute;\n  left: auto;\n  right: auto;\n}\n\n/* Fixed */\n.ui.sticky.fixed {\n  position: fixed;\n  left: auto;\n  right: auto;\n}\n\n/* Bound/Fixed Position */\n.ui.sticky.bound.top,\n.ui.sticky.fixed.top {\n  top: 0px;\n  bottom: auto;\n}\n.ui.sticky.bound.bottom,\n.ui.sticky.fixed.bottom {\n  top: auto;\n  bottom: 0px;\n}\n\n\n/*******************************\n            Types\n*******************************/\n\n.ui.native.sticky {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Tab\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'tab';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n           UI Tabs\n*******************************/\n\n.ui.tab {\n  display: none;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------------\n       Active\n---------------------*/\n\n.ui.tab.active,\n.ui.tab.open {\n  display: block;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.tab.loading {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  min-height: @loadingMinHeight;\n}\n.ui.tab.loading * {\n  position: @loadingContentPosition !important;\n  left: @loadingContentOffset !important;\n}\n\n.ui.tab.loading:before,\n.ui.tab.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: @loaderDistanceFromTop;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  border-radius: @circularRadius;\n  border: @loaderLineWidth solid @loaderFillColor;\n}\n.ui.tab.loading:after,\n.ui.tab.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: @loaderDistanceFromTop;\n  left: 50%;\n\n  margin: @loaderMargin;\n  width: @loaderSize;\n  height: @loaderSize;\n\n  animation: button-spin @loaderSpeed linear;\n  animation-iteration-count: infinite;\n\n  border-radius: @circularRadius;\n\n  border-color: @loaderLineColor transparent transparent;\n  border-style: solid;\n  border-width: @loaderLineWidth;\n\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n.loadUIOverrides();\n","/*!\n * # Semantic UI - Transition\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n\n/*******************************\n            Theme\n*******************************/\n\n@type    : 'module';\n@element : 'transition';\n\n@import (multiple) '../../theme.config';\n\n/*******************************\n          Transitions\n*******************************/\n\n.transition {\n  animation-iteration-count: 1;\n  animation-duration: @transitionDefaultDuration;\n  animation-timing-function: @transitionDefaultEasing;\n  animation-fill-mode: @transitionDefaultFill;\n}\n\n/*******************************\n            States\n*******************************/\n\n\n/* Animating */\n.animating.transition {\n  backface-visibility: @backfaceVisibility;\n  visibility: visible !important;\n}\n\n/* Loading */\n.loading.transition {\n  position: absolute;\n  top: -99999px;\n  left: -99999px;\n}\n\n/* Hidden */\n.hidden.transition {\n  display: none;\n  visibility: hidden;\n}\n\n/* Visible */\n.visible.transition {\n  display: block !important;\n  visibility: visible !important;\n/*  backface-visibility: @backfaceVisibility;\n  transform: @use3DAcceleration;*/\n}\n\n/* Disabled */\n.disabled.transition {\n  animation-play-state: paused;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n.looping.transition {\n  animation-iteration-count: infinite;\n}\n\n\n.loadUIOverrides();\n","/*******************************\n          Transitions\n*******************************/\n\n/*\n  Some transitions adapted from Animate CSS\n  https://github.com/daneden/animate.css\n\n  Additional transitions adapted from Glide\n  by Nick Pettit - https://github.com/nickpettit/glide\n*/\n\n/*--------------\n     Browse\n---------------*/\n\n.transition.browse {\n  animation-duration: 500ms;\n}\n.transition.browse.in {\n  animation-name: browseIn;\n}\n.transition.browse.out,\n.transition.browse.left.out {\n  animation-name: browseOutLeft;\n}\n.transition.browse.right.out {\n  animation-name: browseOutRight;\n}\n\n/* In */\n@keyframes browseIn {\n  0% {\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n  }\n  10% {\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1.05) translateZ(0px);\n    opacity: 1;\n    z-index: 999;\n  }\n  100% {\n    transform: scale(1) translateZ(0px);\n    z-index: 999;\n  }\n}\n\n/* Out */\n@keyframes browseOutLeft {\n  0% {\n    z-index: 999;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n  50% {\n    z-index: -1;\n    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    z-index: -1;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n@keyframes browseOutRight {\n  0% {\n    z-index: 999;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n  50% {\n    z-index: 1;\n    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    z-index: 1;\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n\n\n/*--------------\n     Drop\n---------------*/\n\n.drop.transition {\n  transform-origin: top center;\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);\n}\n.drop.transition.in {\n  animation-name: dropIn;\n}\n.drop.transition.out {\n  animation-name: dropOut;\n}\n\n/* Drop */\n@keyframes dropIn {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes dropOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0);\n  }\n}\n\n/*--------------\n      Fade\n---------------*/\n\n.transition.fade.in {\n  animation-name: fadeIn;\n}\n.transition[class*=\"fade up\"].in {\n  animation-name: fadeInUp;\n}\n.transition[class*=\"fade down\"].in {\n  animation-name: fadeInDown;\n}\n.transition[class*=\"fade left\"].in {\n  animation-name: fadeInLeft;\n}\n.transition[class*=\"fade right\"].in {\n  animation-name: fadeInRight;\n}\n\n.transition.fade.out {\n  animation-name: fadeOut;\n}\n.transition[class*=\"fade up\"].out {\n  animation-name: fadeOutUp;\n}\n.transition[class*=\"fade down\"].out {\n  animation-name: fadeOutDown;\n}\n.transition[class*=\"fade left\"].out {\n  animation-name: fadeOutLeft;\n}\n.transition[class*=\"fade right\"].out {\n  animation-name: fadeOutRight;\n}\n\n/* In */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translateX(-10%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n\n/* Out */\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(5%);\n  }\n}\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-5%);\n  }\n}\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(5%);\n  }\n}\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-5%);\n  }\n}\n\n/*--------------\n     Flips\n---------------*/\n\n.flip.transition.in,\n.flip.transition.out {\n  animation-duration: 600ms;\n}\n.horizontal.flip.transition.in {\n  animation-name: horizontalFlipIn;\n}\n.horizontal.flip.transition.out {\n  animation-name: horizontalFlipOut;\n}\n.vertical.flip.transition.in {\n  animation-name: verticalFlipIn;\n}\n.vertical.flip.transition.out {\n  animation-name: verticalFlipOut;\n}\n\n/* In */\n@keyframes horizontalFlipIn {\n  0% {\n    transform: perspective(2000px) rotateY(-90deg);\n    opacity: 0;\n  }\n  100% {\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n}\n@keyframes verticalFlipIn {\n  0% {\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n  100% {\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n/* Out */\n@keyframes horizontalFlipOut {\n  0% {\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(2000px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n@keyframes verticalFlipOut {\n  0% {\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n}\n\n/*--------------\n      Scale\n---------------*/\n\n.scale.transition.in {\n  animation-name: scaleIn;\n}\n.scale.transition.out {\n  animation-name: scaleOut;\n}\n\n@keyframes scaleIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Out */\n@keyframes scaleOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n}\n\n\n/*--------------\n      Fly\n---------------*/\n\n/* Inward */\n.transition.fly {\n  animation-duration: 0.6s;\n  transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n}\n.transition.fly.in {\n  animation-name: flyIn;\n}\n.transition[class*=\"fly up\"].in {\n  animation-name: flyInUp;\n}\n.transition[class*=\"fly down\"].in {\n  animation-name: flyInDown;\n}\n.transition[class*=\"fly left\"].in {\n  animation-name: flyInLeft;\n}\n.transition[class*=\"fly right\"].in {\n  animation-name: flyInRight;\n}\n\n/* Outward */\n.transition.fly.out {\n  animation-name: flyOut;\n}\n.transition[class*=\"fly up\"].out {\n  animation-name: flyOutUp;\n}\n.transition[class*=\"fly down\"].out {\n  animation-name: flyOutDown;\n}\n.transition[class*=\"fly left\"].out {\n  animation-name: flyOutLeft;\n}\n.transition[class*=\"fly right\"].out {\n  animation-name: flyOutRight;\n}\n\n/* In */\n@keyframes flyIn {\n  0% {\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  40% {\n    transform: scale3d(.9, .9, .9);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n  80% {\n    transform: scale3d(.97, .97, .97);\n  }\n  100% {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n}\n@keyframes flyInUp {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 1500px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes flyInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -1500px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n@keyframes flyInLeft {\n  0% {\n    opacity: 0;\n    transform: translate3d(1500px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n@keyframes flyInRight {\n  0% {\n    opacity: 0;\n    transform: translate3d(-1500px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n/* Out */\n@keyframes flyOut {\n  20% {\n    transform: scale3d(.9, .9, .9);\n  }\n  50%, 55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n}\n@keyframes flyOutUp {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n@keyframes flyOutDown {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes flyOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes flyOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n/*--------------\n     Slide\n---------------*/\n\n.transition.slide.in,\n.transition[class*=\"slide down\"].in {\n  animation-name: slideInY;\n  transform-origin: top center;\n}\n.transition[class*=\"slide up\"].in {\n  animation-name: slideInY;\n  transform-origin: bottom center;\n}\n.transition[class*=\"slide left\"].in {\n  animation-name: slideInX;\n  transform-origin: center right;\n}\n.transition[class*=\"slide right\"].in {\n  animation-name: slideInX;\n  transform-origin: center left;\n}\n\n.transition.slide.out,\n.transition[class*=\"slide down\"].out {\n  animation-name: slideOutY;\n  transform-origin: top center;\n}\n.transition[class*=\"slide up\"].out {\n  animation-name: slideOutY;\n  transform-origin: bottom center;\n}\n.transition[class*=\"slide left\"].out {\n  animation-name: slideOutX;\n  transform-origin: center right;\n}\n.transition[class*=\"slide right\"].out {\n  animation-name: slideOutX;\n  transform-origin: center left;\n}\n\n/* In */\n@keyframes slideInY {\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n@keyframes slideInX {\n  0% {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n/* Out */\n@keyframes slideOutY {\n  0% {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n}\n@keyframes slideOutX {\n  0% {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n}\n\n\n/*--------------\n     Swing\n---------------*/\n\n.transition.swing {\n  animation-duration: 800ms;\n}\n\n.transition[class*=\"swing down\"].in {\n  animation-name: swingInX;\n  transform-origin: top center;\n}\n.transition[class*=\"swing up\"].in {\n  animation-name: swingInX;\n  transform-origin: bottom center;\n}\n.transition[class*=\"swing left\"].in {\n  animation-name: swingInY;\n  transform-origin: center right;\n}\n.transition[class*=\"swing right\"].in {\n  animation-name: swingInY;\n  transform-origin: center left;\n}\n\n.transition.swing.out,\n.transition[class*=\"swing down\"].out {\n  animation-name: swingOutX;\n  transform-origin: top center;\n}\n.transition[class*=\"swing up\"].out {\n  animation-name: swingOutX;\n  transform-origin: bottom center;\n}\n.transition[class*=\"swing left\"].out {\n  animation-name: swingOutY;\n  transform-origin: center right;\n}\n.transition[class*=\"swing right\"].out {\n  animation-name: swingOutY;\n  transform-origin: center left;\n}\n\n/* In */\n@keyframes swingInX {\n  0% {\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n  60% {\n    transform: perspective(1000px) rotateX(15deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n  100% {\n    transform: perspective(1000px) rotateX(0deg);\n  }\n}\n@keyframes swingInY {\n  0% {\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n  60% {\n    transform: perspective(1000px) rotateY(-17.5deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n  100% {\n    transform: perspective(1000px) rotateY(0deg);\n  }\n}\n\n/* Out */\n@keyframes swingOutX {\n  0% {\n    transform: perspective(1000px) rotateX(0deg);\n  }\n  40% {\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n  60% {\n    transform: perspective(1000px) rotateX(17.5deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n@keyframes swingOutY {\n  0% {\n    transform: perspective(1000px) rotateY(0deg);\n  }\n  40% {\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n  60% {\n    transform: perspective(1000px) rotateY(-10deg);\n  }\n  80% {\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n  100% {\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n}\n\n\n/*--------------\n      Zoom\n---------------*/\n\n.transition.zoom.in {\n  animation-name: zoomIn;\n}\n.transition.zoom.out {\n  animation-name: zoomOut;\n}\n@keyframes zoomIn {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(0);\n  }\n}\n\n\n/*******************************\n       Static Animations\n*******************************/\n\n/*--------------\n    Emphasis\n---------------*/\n\n\n.flash.transition {\n  animation-duration: 750ms;\n  animation-name: flash;\n}\n.shake.transition {\n  animation-duration: 750ms;\n  animation-name: shake;\n}\n.bounce.transition {\n  animation-duration: 750ms;\n  animation-name: bounce;\n}\n.tada.transition {\n  animation-duration: 750ms;\n  animation-name: tada;\n}\n.pulse.transition {\n  animation-duration: 500ms;\n  animation-name: pulse;\n}\n.jiggle.transition {\n  animation-duration: 750ms;\n  animation-name: jiggle;\n}\n.transition.glow {\n  animation-duration: 2000ms;\n  animation-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\n}\n.transition.glow {\n  animation-name: glow;\n}\n\n\n/* Flash */\n@keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1;\n  }\n  25%, 75% {\n    opacity: 0;\n  }\n}\n\n/* Shake */\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateX(-10px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateX(10px);\n  }\n}\n\n/* Bounce */\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n}\n\n/* Tada */\n@keyframes tada {\n  0% {\n    transform: scale(1);\n  }\n  10%, 20% {\n    transform: scale(0.9) rotate(-3deg);\n  }\n  30%, 50%, 70%, 90% {\n    transform: scale(1.1) rotate(3deg);\n  }\n  40%, 60%, 80% {\n    transform: scale(1.1) rotate(-3deg);\n  }\n  100% {\n    transform: scale(1) rotate(0);\n  }\n}\n\n/* Pulse */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n}\n\n/* Jiggle */\n@keyframes jiggle {\n  0% {\n    transform: scale3d(1, 1, 1);\n  }\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n  65% {\n    transform: scale3d(.95, 1.05, 1);\n  }\n  75% {\n    transform: scale3d(1.05, .95, 1);\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n/* Glow */\n@keyframes glow {\n  0% {\n    background-color: #FCFCFD;\n  }\n  30% {\n    background-color: #FFF6CD;\n  }\n  100% {\n    background-color: #FCFCFD;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
